var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireefef"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireefef"] = parcelRequire;
}
parcelRequire.register("6THZ6", function(module, exports) {

$parcel$export(module.exports, "Application", () => II);

var $hPtJY = parcelRequire("hPtJY");

var $6ZWSX = parcelRequire("6ZWSX");
var $5059ff85b35ef8d7$require$Buffer = $6ZWSX.Buffer;
var FI = Object.create;
var Cv = Object.defineProperty;
var UI = Object.getOwnPropertyDescriptor;
var kI = Object.getOwnPropertyNames;
var zI = Object.getPrototypeOf, GI = Object.prototype.hasOwnProperty;
var ip = (r1, t)=>()=>(t || r1((t = {
            exports: {}
        }).exports, t), t.exports), VI = (r1, t)=>{
    for(var e in t)Cv(r1, e, {
        get: t[e],
        enumerable: !0
    });
}, HI = (r1, t, e, n)=>{
    if (t && typeof t == "object" || typeof t == "function") for (let i of kI(t))!GI.call(r1, i) && i !== e && Cv(r1, i, {
        get: ()=>t[i],
        enumerable: !(n = UI(t, i)) || n.enumerable
    });
    return r1;
};
var Jd = (r1, t, e)=>(e = r1 != null ? FI(zI(r1)) : {}, HI(t || !r1 || !r1.__esModule ? Cv(e, "default", {
        value: r1,
        enumerable: !0
    }) : e, r1));
var iC = ip((yb, rC)=>{
    (function(r1, t) {
        typeof yb == "object" ? rC.exports = t() : typeof define == "function" && define.amd ? define(t) : r1.Alea = t();
    })(yb, function() {
        "use strict";
        return r1.importState = function(e) {
            var n = new r1;
            return n.importState(e), n;
        }, r1;
        function r1() {
            return function(e) {
                var n = 0, i = 0, s = 0, o = 1;
                e.length == 0 && (e = [
                    +new Date
                ]);
                var a = t();
                n = a(" "), i = a(" "), s = a(" ");
                for(var l = 0; l < e.length; l++)n -= a(e[l]), n < 0 && (n += 1), i -= a(e[l]), i < 0 && (i += 1), s -= a(e[l]), s < 0 && (s += 1);
                a = null;
                var u = function() {
                    var c = 2091639 * n + o * 23283064365386963e-26;
                    return n = i, i = s, s = c - (o = c | 0);
                };
                return u.next = u, u.uint32 = function() {
                    return u() * 4294967296;
                }, u.fract53 = function() {
                    return u() + (u() * 2097152 | 0) * 11102230246251565e-32;
                }, u.version = "Alea 0.9", u.args = e, u.exportState = function() {
                    return [
                        n,
                        i,
                        s,
                        o
                    ];
                }, u.importState = function(c) {
                    n = +c[0] || 0, i = +c[1] || 0, s = +c[2] || 0, o = +c[3] || 0;
                }, u;
            }(Array.prototype.slice.call(arguments));
        }
        function t() {
            var e = 4022871197, n = function(i) {
                i = i.toString();
                for(var s = 0; s < i.length; s++){
                    e += i.charCodeAt(s);
                    var o = .02519603282416938 * e;
                    e = o >>> 0, o -= e, o *= e, e = o >>> 0, o -= e, e += o * 4294967296;
                }
                return (e >>> 0) * 23283064365386963e-26;
            };
            return n.version = "Mash 0.9", n;
        }
    });
});
var xb = ip((Ig, lC)=>{
    (function(r1, t) {
        typeof Ig == "object" && typeof lC < "u" ? t(Ig) : typeof define == "function" && define.amd ? define([
            "exports"
        ], t) : t((r1 = typeof globalThis < "u" ? globalThis : r1 || self).SVDJS = {});
    })(Ig, function(r1) {
        "use strict";
        r1.SVD = function(t, e, n, i, s) {
            if (e = e === void 0 || e, n = n === void 0 || n, s = 1e-64 / (i = i || Math.pow(2, -52)), !t) throw new TypeError("Matrix a is not defined");
            var o, a, l, u, c, d, h, f, m, p, g, y, v = t[0].length, x = t.length;
            if (x < v) throw new TypeError("Invalid matrix: m < n");
            for(var w = [], S = [], _ = [], M = e === "f" ? x : v, b = p = h = 0; b < x; b++)S[b] = new Array(M).fill(0);
            for(b = 0; b < v; b++)_[b] = new Array(v).fill(0);
            var T, E = new Array(v).fill(0);
            for(b = 0; b < x; b++)for(o = 0; o < v; o++)S[b][o] = t[b][o];
            for(b = 0; b < v; b++){
                for(w[b] = h, m = 0, l = b + 1, o = b; o < x; o++)m += Math.pow(S[o][b], 2);
                if (m < s) h = 0;
                else for(f = (d = S[b][b]) * (h = d < 0 ? Math.sqrt(m) : -Math.sqrt(m)) - m, S[b][b] = d - h, o = l; o < v; o++){
                    for(m = 0, a = b; a < x; a++)m += S[a][b] * S[a][o];
                    for(d = m / f, a = b; a < x; a++)S[a][o] = S[a][o] + d * S[a][b];
                }
                for(E[b] = h, m = 0, o = l; o < v; o++)m += Math.pow(S[b][o], 2);
                if (m < s) h = 0;
                else {
                    for(f = (d = S[b][b + 1]) * (h = d < 0 ? Math.sqrt(m) : -Math.sqrt(m)) - m, S[b][b + 1] = d - h, o = l; o < v; o++)w[o] = S[b][o] / f;
                    for(o = l; o < x; o++){
                        for(m = 0, a = l; a < v; a++)m += S[o][a] * S[b][a];
                        for(a = l; a < v; a++)S[o][a] = S[o][a] + m * w[a];
                    }
                }
                p < (g = Math.abs(E[b]) + Math.abs(w[b])) && (p = g);
            }
            if (n) for(b = v - 1; 0 <= b; b--){
                if (h !== 0) {
                    for(f = S[b][b + 1] * h, o = l; o < v; o++)_[o][b] = S[b][o] / f;
                    for(o = l; o < v; o++){
                        for(m = 0, a = l; a < v; a++)m += S[b][a] * _[a][o];
                        for(a = l; a < v; a++)_[a][o] = _[a][o] + m * _[a][b];
                    }
                }
                for(o = l; o < v; o++)_[b][o] = 0, _[o][b] = 0;
                _[b][b] = 1, h = w[b], l = b;
            }
            if (e) {
                if (e === "f") for(b = v; b < x; b++){
                    for(o = v; o < x; o++)S[b][o] = 0;
                    S[b][b] = 1;
                }
                for(b = v - 1; 0 <= b; b--){
                    for(l = b + 1, h = E[b], o = l; o < M; o++)S[b][o] = 0;
                    if (h !== 0) {
                        for(f = S[b][b] * h, o = l; o < M; o++){
                            for(m = 0, a = l; a < x; a++)m += S[a][b] * S[a][o];
                            for(d = m / f, a = b; a < x; a++)S[a][o] = S[a][o] + d * S[a][b];
                        }
                        for(o = b; o < x; o++)S[o][b] = S[o][b] / h;
                    } else for(o = b; o < x; o++)S[o][b] = 0;
                    S[b][b] = S[b][b] + 1;
                }
            }
            for(i *= p, a = v - 1; 0 <= a; a--)for(var P = 0; P < 50; P++){
                for(T = !1, l = a; 0 <= l; l--){
                    if (Math.abs(w[l]) <= i) {
                        T = !0;
                        break;
                    }
                    if (Math.abs(E[l - 1]) <= i) break;
                }
                if (!T) {
                    for(c = 0, u = l - (m = 1), b = l; b < a + 1 && (d = m * w[b], w[b] = c * w[b], !(Math.abs(d) <= i)); b++)if (h = E[b], E[b] = Math.sqrt(d * d + h * h), c = h / (f = E[b]), m = -d / f, e) for(o = 0; o < x; o++)g = S[o][u], y = S[o][b], S[o][u] = g * c + y * m, S[o][b] = -g * m + y * c;
                }
                if (y = E[a], l === a) {
                    if (y < 0 && (E[a] = -y, n)) for(o = 0; o < v; o++)_[o][a] = -_[o][a];
                    break;
                }
                for(p = E[l], d = (((g = E[a - 1]) - y) * (g + y) + ((h = w[a - 1]) - (f = w[a])) * (h + f)) / (2 * f * g), h = Math.sqrt(d * d + 1), d = ((p - y) * (p + y) + f * (g / (d < 0 ? d - h : d + h) - f)) / p, b = l + (m = c = 1); b < a + 1; b++){
                    if (h = w[b], g = E[b], f = m * h, h *= c, y = Math.sqrt(d * d + f * f), d = p * (c = d / (w[b - 1] = y)) + h * (m = f / y), h = -p * m + h * c, f = g * m, g *= c, n) for(o = 0; o < v; o++)p = _[o][b - 1], y = _[o][b], _[o][b - 1] = p * c + y * m, _[o][b] = -p * m + y * c;
                    if (y = Math.sqrt(d * d + f * f), d = (c = d / (E[b - 1] = y)) * h + (m = f / y) * g, p = -m * h + c * g, e) for(o = 0; o < x; o++)g = S[o][b - 1], y = S[o][b], S[o][b - 1] = g * c + y * m, S[o][b] = -g * m + y * c;
                }
                w[l] = 0, w[a] = d, E[a] = p;
            }
            for(b = 0; b < v; b++)E[b] < i && (E[b] = 0);
            return {
                u: S,
                q: E,
                v: _
            };
        }, r1.VERSION = "1.1.1", Object.defineProperty(r1, "__esModule", {
            value: !0
        });
    });
});
var EP = ip((sy)=>{
    (function() {
        "use strict";
        var r1 = function() {
            this.init();
        };
        r1.prototype = {
            init: function() {
                var c = this || t;
                return c._counter = 1e3, c._html5AudioPool = [], c.html5PoolSize = 10, c._codecs = {}, c._howls = [], c._muted = !1, c._volume = 1, c._canPlayEvent = "canplaythrough", c._navigator = typeof window < "u" && window.navigator ? window.navigator : null, c.masterGain = null, c.noAudio = !1, c.usingWebAudio = !0, c.autoSuspend = !0, c.ctx = null, c.autoUnlock = !0, c._setup(), c;
            },
            volume: function(c) {
                var d = this || t;
                if (c = parseFloat(c), d.ctx || u(), typeof c < "u" && c >= 0 && c <= 1) {
                    if (d._volume = c, d._muted) return d;
                    d.usingWebAudio && d.masterGain.gain.setValueAtTime(c, t.ctx.currentTime);
                    for(var h = 0; h < d._howls.length; h++)if (!d._howls[h]._webAudio) for(var f = d._howls[h]._getSoundIds(), m = 0; m < f.length; m++){
                        var p = d._howls[h]._soundById(f[m]);
                        p && p._node && (p._node.volume = p._volume * c);
                    }
                    return d;
                }
                return d._volume;
            },
            mute: function(c) {
                var d = this || t;
                d.ctx || u(), d._muted = c, d.usingWebAudio && d.masterGain.gain.setValueAtTime(c ? 0 : d._volume, t.ctx.currentTime);
                for(var h = 0; h < d._howls.length; h++)if (!d._howls[h]._webAudio) for(var f = d._howls[h]._getSoundIds(), m = 0; m < f.length; m++){
                    var p = d._howls[h]._soundById(f[m]);
                    p && p._node && (p._node.muted = c ? !0 : p._muted);
                }
                return d;
            },
            stop: function() {
                for(var c = this || t, d = 0; d < c._howls.length; d++)c._howls[d].stop();
                return c;
            },
            unload: function() {
                for(var c = this || t, d = c._howls.length - 1; d >= 0; d--)c._howls[d].unload();
                return c.usingWebAudio && c.ctx && typeof c.ctx.close < "u" && (c.ctx.close(), c.ctx = null, u()), c;
            },
            codecs: function(c) {
                return (this || t)._codecs[c.replace(/^x-/, "")];
            },
            _setup: function() {
                var c = this || t;
                if (c.state = c.ctx && c.ctx.state || "suspended", c._autoSuspend(), !c.usingWebAudio) {
                    if (typeof Audio < "u") try {
                        var d = new Audio;
                        typeof d.oncanplaythrough > "u" && (c._canPlayEvent = "canplay");
                    } catch  {
                        c.noAudio = !0;
                    }
                    else c.noAudio = !0;
                }
                try {
                    var d = new Audio;
                    d.muted && (c.noAudio = !0);
                } catch  {}
                return c.noAudio || c._setupCodecs(), c;
            },
            _setupCodecs: function() {
                var c = this || t, d = null;
                try {
                    d = typeof Audio < "u" ? new Audio : null;
                } catch  {
                    return c;
                }
                if (!d || typeof d.canPlayType != "function") return c;
                var h = d.canPlayType("audio/mpeg;").replace(/^no$/, ""), f = c._navigator ? c._navigator.userAgent : "", m = f.match(/OPR\/([0-6].)/g), p = m && parseInt(m[0].split("/")[1], 10) < 33, g = f.indexOf("Safari") !== -1 && f.indexOf("Chrome") === -1, y = f.match(/Version\/(.*?) /), v = g && y && parseInt(y[1], 10) < 15;
                return c._codecs = {
                    mp3: !!(!p && (h || d.canPlayType("audio/mp3;").replace(/^no$/, ""))),
                    mpeg: !!h,
                    opus: !!d.canPlayType('audio/ogg; codecs="opus"').replace(/^no$/, ""),
                    ogg: !!d.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/, ""),
                    oga: !!d.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/, ""),
                    wav: !!(d.canPlayType('audio/wav; codecs="1"') || d.canPlayType("audio/wav")).replace(/^no$/, ""),
                    aac: !!d.canPlayType("audio/aac;").replace(/^no$/, ""),
                    caf: !!d.canPlayType("audio/x-caf;").replace(/^no$/, ""),
                    m4a: !!(d.canPlayType("audio/x-m4a;") || d.canPlayType("audio/m4a;") || d.canPlayType("audio/aac;")).replace(/^no$/, ""),
                    m4b: !!(d.canPlayType("audio/x-m4b;") || d.canPlayType("audio/m4b;") || d.canPlayType("audio/aac;")).replace(/^no$/, ""),
                    mp4: !!(d.canPlayType("audio/x-mp4;") || d.canPlayType("audio/mp4;") || d.canPlayType("audio/aac;")).replace(/^no$/, ""),
                    weba: !!(!v && d.canPlayType('audio/webm; codecs="vorbis"').replace(/^no$/, "")),
                    webm: !!(!v && d.canPlayType('audio/webm; codecs="vorbis"').replace(/^no$/, "")),
                    dolby: !!d.canPlayType('audio/mp4; codecs="ec-3"').replace(/^no$/, ""),
                    flac: !!(d.canPlayType("audio/x-flac;") || d.canPlayType("audio/flac;")).replace(/^no$/, "")
                }, c;
            },
            _unlockAudio: function() {
                var c = this || t;
                if (!(c._audioUnlocked || !c.ctx)) {
                    c._audioUnlocked = !1, c.autoUnlock = !1, !c._mobileUnloaded && c.ctx.sampleRate !== 44100 && (c._mobileUnloaded = !0, c.unload()), c._scratchBuffer = c.ctx.createBuffer(1, 1, 22050);
                    var d = function(h) {
                        for(; c._html5AudioPool.length < c.html5PoolSize;)try {
                            var f = new Audio;
                            f._unlocked = !0, c._releaseHtml5Audio(f);
                        } catch  {
                            c.noAudio = !0;
                            break;
                        }
                        for(var m = 0; m < c._howls.length; m++)if (!c._howls[m]._webAudio) for(var p = c._howls[m]._getSoundIds(), g = 0; g < p.length; g++){
                            var y = c._howls[m]._soundById(p[g]);
                            y && y._node && !y._node._unlocked && (y._node._unlocked = !0, y._node.load());
                        }
                        c._autoResume();
                        var v = c.ctx.createBufferSource();
                        v.buffer = c._scratchBuffer, v.connect(c.ctx.destination), typeof v.start > "u" ? v.noteOn(0) : v.start(0), typeof c.ctx.resume == "function" && c.ctx.resume(), v.onended = function() {
                            v.disconnect(0), c._audioUnlocked = !0, document.removeEventListener("touchstart", d, !0), document.removeEventListener("touchend", d, !0), document.removeEventListener("click", d, !0), document.removeEventListener("keydown", d, !0);
                            for(var x = 0; x < c._howls.length; x++)c._howls[x]._emit("unlock");
                        };
                    };
                    return document.addEventListener("touchstart", d, !0), document.addEventListener("touchend", d, !0), document.addEventListener("click", d, !0), document.addEventListener("keydown", d, !0), c;
                }
            },
            _obtainHtml5Audio: function() {
                var c = this || t;
                if (c._html5AudioPool.length) return c._html5AudioPool.pop();
                var d = new Audio().play();
                return d && typeof Promise < "u" && (d instanceof Promise || typeof d.then == "function") && d.catch(function() {
                    console.warn("HTML5 Audio pool exhausted, returning potentially locked audio object.");
                }), new Audio;
            },
            _releaseHtml5Audio: function(c) {
                var d = this || t;
                return c._unlocked && d._html5AudioPool.push(c), d;
            },
            _autoSuspend: function() {
                var c = this;
                if (!(!c.autoSuspend || !c.ctx || typeof c.ctx.suspend > "u" || !t.usingWebAudio)) {
                    for(var d = 0; d < c._howls.length; d++)if (c._howls[d]._webAudio) {
                        for(var h = 0; h < c._howls[d]._sounds.length; h++)if (!c._howls[d]._sounds[h]._paused) return c;
                    }
                    return c._suspendTimer && clearTimeout(c._suspendTimer), c._suspendTimer = setTimeout(function() {
                        if (!!c.autoSuspend) {
                            c._suspendTimer = null, c.state = "suspending";
                            var f = function() {
                                c.state = "suspended", c._resumeAfterSuspend && (delete c._resumeAfterSuspend, c._autoResume());
                            };
                            c.ctx.suspend().then(f, f);
                        }
                    }, 3e4), c;
                }
            },
            _autoResume: function() {
                var c = this;
                if (!(!c.ctx || typeof c.ctx.resume > "u" || !t.usingWebAudio)) return c.state === "running" && c.ctx.state !== "interrupted" && c._suspendTimer ? (clearTimeout(c._suspendTimer), c._suspendTimer = null) : c.state === "suspended" || c.state === "running" && c.ctx.state === "interrupted" ? (c.ctx.resume().then(function() {
                    c.state = "running";
                    for(var d = 0; d < c._howls.length; d++)c._howls[d]._emit("resume");
                }), c._suspendTimer && (clearTimeout(c._suspendTimer), c._suspendTimer = null)) : c.state === "suspending" && (c._resumeAfterSuspend = !0), c;
            }
        };
        var t = new r1, e = function(c) {
            var d = this;
            if (!c.src || c.src.length === 0) {
                console.error("An array of source files must be passed with any new Howl.");
                return;
            }
            d.init(c);
        };
        e.prototype = {
            init: function(c) {
                var d = this;
                return t.ctx || u(), d._autoplay = c.autoplay || !1, d._format = typeof c.format != "string" ? c.format : [
                    c.format
                ], d._html5 = c.html5 || !1, d._muted = c.mute || !1, d._loop = c.loop || !1, d._pool = c.pool || 5, d._preload = typeof c.preload == "boolean" || c.preload === "metadata" ? c.preload : !0, d._rate = c.rate || 1, d._sprite = c.sprite || {}, d._src = typeof c.src != "string" ? c.src : [
                    c.src
                ], d._volume = c.volume !== void 0 ? c.volume : 1, d._xhr = {
                    method: c.xhr && c.xhr.method ? c.xhr.method : "GET",
                    headers: c.xhr && c.xhr.headers ? c.xhr.headers : null,
                    withCredentials: c.xhr && c.xhr.withCredentials ? c.xhr.withCredentials : !1
                }, d._duration = 0, d._state = "unloaded", d._sounds = [], d._endTimers = {}, d._queue = [], d._playLock = !1, d._onend = c.onend ? [
                    {
                        fn: c.onend
                    }
                ] : [], d._onfade = c.onfade ? [
                    {
                        fn: c.onfade
                    }
                ] : [], d._onload = c.onload ? [
                    {
                        fn: c.onload
                    }
                ] : [], d._onloaderror = c.onloaderror ? [
                    {
                        fn: c.onloaderror
                    }
                ] : [], d._onplayerror = c.onplayerror ? [
                    {
                        fn: c.onplayerror
                    }
                ] : [], d._onpause = c.onpause ? [
                    {
                        fn: c.onpause
                    }
                ] : [], d._onplay = c.onplay ? [
                    {
                        fn: c.onplay
                    }
                ] : [], d._onstop = c.onstop ? [
                    {
                        fn: c.onstop
                    }
                ] : [], d._onmute = c.onmute ? [
                    {
                        fn: c.onmute
                    }
                ] : [], d._onvolume = c.onvolume ? [
                    {
                        fn: c.onvolume
                    }
                ] : [], d._onrate = c.onrate ? [
                    {
                        fn: c.onrate
                    }
                ] : [], d._onseek = c.onseek ? [
                    {
                        fn: c.onseek
                    }
                ] : [], d._onunlock = c.onunlock ? [
                    {
                        fn: c.onunlock
                    }
                ] : [], d._onresume = [], d._webAudio = t.usingWebAudio && !d._html5, typeof t.ctx < "u" && t.ctx && t.autoUnlock && t._unlockAudio(), t._howls.push(d), d._autoplay && d._queue.push({
                    event: "play",
                    action: function() {
                        d.play();
                    }
                }), d._preload && d._preload !== "none" && d.load(), d;
            },
            load: function() {
                var c = this, d = null;
                if (t.noAudio) {
                    c._emit("loaderror", null, "No audio support.");
                    return;
                }
                typeof c._src == "string" && (c._src = [
                    c._src
                ]);
                for(var h = 0; h < c._src.length; h++){
                    var f, m;
                    if (c._format && c._format[h]) f = c._format[h];
                    else {
                        if (m = c._src[h], typeof m != "string") {
                            c._emit("loaderror", null, "Non-string found in selected audio sources - ignoring.");
                            continue;
                        }
                        f = /^data:audio\/([^;,]+);/i.exec(m), f || (f = /\.([^.]+)$/.exec(m.split("?", 1)[0])), f && (f = f[1].toLowerCase());
                    }
                    if (f || console.warn('No file extension was found. Consider using the "format" property or specify an extension.'), f && t.codecs(f)) {
                        d = c._src[h];
                        break;
                    }
                }
                if (!d) {
                    c._emit("loaderror", null, "No codec support for selected audio sources.");
                    return;
                }
                return c._src = d, c._state = "loading", window.location.protocol === "https:" && d.slice(0, 5) === "http:" && (c._html5 = !0, c._webAudio = !1), new n(c), c._webAudio && s(c), c;
            },
            play: function(c, d) {
                var h = this, f = null;
                if (typeof c == "number") f = c, c = null;
                else {
                    if (typeof c == "string" && h._state === "loaded" && !h._sprite[c]) return null;
                    if (typeof c > "u" && (c = "__default", !h._playLock)) {
                        for(var m = 0, p = 0; p < h._sounds.length; p++)h._sounds[p]._paused && !h._sounds[p]._ended && (m++, f = h._sounds[p]._id);
                        m === 1 ? c = null : f = null;
                    }
                }
                var g = f ? h._soundById(f) : h._inactiveSound();
                if (!g) return null;
                if (f && !c && (c = g._sprite || "__default"), h._state !== "loaded") {
                    g._sprite = c, g._ended = !1;
                    var y = g._id;
                    return h._queue.push({
                        event: "play",
                        action: function() {
                            h.play(y);
                        }
                    }), y;
                }
                if (f && !g._paused) return d || h._loadQueue("play"), g._id;
                h._webAudio && t._autoResume();
                var v = Math.max(0, g._seek > 0 ? g._seek : h._sprite[c][0] / 1e3), x = Math.max(0, (h._sprite[c][0] + h._sprite[c][1]) / 1e3 - v), w = x * 1e3 / Math.abs(g._rate), S = h._sprite[c][0] / 1e3, _ = (h._sprite[c][0] + h._sprite[c][1]) / 1e3;
                g._sprite = c, g._ended = !1;
                var M = function() {
                    g._paused = !1, g._seek = v, g._start = S, g._stop = _, g._loop = !!(g._loop || h._sprite[c][2]);
                };
                if (v >= _) {
                    h._ended(g);
                    return;
                }
                var b = g._node;
                if (h._webAudio) {
                    var T = function() {
                        h._playLock = !1, M(), h._refreshBuffer(g);
                        var C = g._muted || h._muted ? 0 : g._volume;
                        b.gain.setValueAtTime(C, t.ctx.currentTime), g._playStart = t.ctx.currentTime, typeof b.bufferSource.start > "u" ? g._loop ? b.bufferSource.noteGrainOn(0, v, 86400) : b.bufferSource.noteGrainOn(0, v, x) : g._loop ? b.bufferSource.start(0, v, 86400) : b.bufferSource.start(0, v, x), w !== 1 / 0 && (h._endTimers[g._id] = setTimeout(h._ended.bind(h, g), w)), d || setTimeout(function() {
                            h._emit("play", g._id), h._loadQueue();
                        }, 0);
                    };
                    t.state === "running" && t.ctx.state !== "interrupted" ? T() : (h._playLock = !0, h.once("resume", T), h._clearTimer(g._id));
                } else {
                    var E = function() {
                        b.currentTime = v, b.muted = g._muted || h._muted || t._muted || b.muted, b.volume = g._volume * t.volume(), b.playbackRate = g._rate;
                        try {
                            var C = b.play();
                            if (C && typeof Promise < "u" && (C instanceof Promise || typeof C.then == "function") ? (h._playLock = !0, M(), C.then(function() {
                                h._playLock = !1, b._unlocked = !0, d ? h._loadQueue() : h._emit("play", g._id);
                            }).catch(function() {
                                h._playLock = !1, h._emit("playerror", g._id, "Playback was unable to start. This is most commonly an issue on mobile devices and Chrome where playback was not within a user interaction."), g._ended = !0, g._paused = !0;
                            })) : d || (h._playLock = !1, M(), h._emit("play", g._id)), b.playbackRate = g._rate, b.paused) {
                                h._emit("playerror", g._id, "Playback was unable to start. This is most commonly an issue on mobile devices and Chrome where playback was not within a user interaction.");
                                return;
                            }
                            c !== "__default" || g._loop ? h._endTimers[g._id] = setTimeout(h._ended.bind(h, g), w) : (h._endTimers[g._id] = function() {
                                h._ended(g), b.removeEventListener("ended", h._endTimers[g._id], !1);
                            }, b.addEventListener("ended", h._endTimers[g._id], !1));
                        } catch (O) {
                            h._emit("playerror", g._id, O);
                        }
                    };
                    b.src === "data:audio/wav;base64,UklGRigAAABXQVZFZm10IBIAAAABAAEARKwAAIhYAQACABAAAABkYXRhAgAAAAEA" && (b.src = h._src, b.load());
                    var P = window && window.ejecta || !b.readyState && t._navigator.isCocoonJS;
                    if (b.readyState >= 3 || P) E();
                    else {
                        h._playLock = !0, h._state = "loading";
                        var D = function() {
                            h._state = "loaded", E(), b.removeEventListener(t._canPlayEvent, D, !1);
                        };
                        b.addEventListener(t._canPlayEvent, D, !1), h._clearTimer(g._id);
                    }
                }
                return g._id;
            },
            pause: function(c) {
                var d = this;
                if (d._state !== "loaded" || d._playLock) return d._queue.push({
                    event: "pause",
                    action: function() {
                        d.pause(c);
                    }
                }), d;
                for(var h = d._getSoundIds(c), f = 0; f < h.length; f++){
                    d._clearTimer(h[f]);
                    var m = d._soundById(h[f]);
                    if (m && !m._paused && (m._seek = d.seek(h[f]), m._rateSeek = 0, m._paused = !0, d._stopFade(h[f]), m._node)) {
                        if (d._webAudio) {
                            if (!m._node.bufferSource) continue;
                            typeof m._node.bufferSource.stop > "u" ? m._node.bufferSource.noteOff(0) : m._node.bufferSource.stop(0), d._cleanBuffer(m._node);
                        } else (!isNaN(m._node.duration) || m._node.duration === 1 / 0) && m._node.pause();
                    }
                    arguments[1] || d._emit("pause", m ? m._id : null);
                }
                return d;
            },
            stop: function(c, d) {
                var h = this;
                if (h._state !== "loaded" || h._playLock) return h._queue.push({
                    event: "stop",
                    action: function() {
                        h.stop(c);
                    }
                }), h;
                for(var f = h._getSoundIds(c), m = 0; m < f.length; m++){
                    h._clearTimer(f[m]);
                    var p = h._soundById(f[m]);
                    p && (p._seek = p._start || 0, p._rateSeek = 0, p._paused = !0, p._ended = !0, h._stopFade(f[m]), p._node && (h._webAudio ? p._node.bufferSource && (typeof p._node.bufferSource.stop > "u" ? p._node.bufferSource.noteOff(0) : p._node.bufferSource.stop(0), h._cleanBuffer(p._node)) : (!isNaN(p._node.duration) || p._node.duration === 1 / 0) && (p._node.currentTime = p._start || 0, p._node.pause(), p._node.duration === 1 / 0 && h._clearSound(p._node))), d || h._emit("stop", p._id));
                }
                return h;
            },
            mute: function(c, d) {
                var h = this;
                if (h._state !== "loaded" || h._playLock) return h._queue.push({
                    event: "mute",
                    action: function() {
                        h.mute(c, d);
                    }
                }), h;
                if (typeof d > "u") {
                    if (typeof c == "boolean") h._muted = c;
                    else return h._muted;
                }
                for(var f = h._getSoundIds(d), m = 0; m < f.length; m++){
                    var p = h._soundById(f[m]);
                    p && (p._muted = c, p._interval && h._stopFade(p._id), h._webAudio && p._node ? p._node.gain.setValueAtTime(c ? 0 : p._volume, t.ctx.currentTime) : p._node && (p._node.muted = t._muted ? !0 : c), h._emit("mute", p._id));
                }
                return h;
            },
            volume: function() {
                var c = this, d = arguments, h, f;
                if (d.length === 0) return c._volume;
                if (d.length === 1 || d.length === 2 && typeof d[1] > "u") {
                    var m = c._getSoundIds(), p = m.indexOf(d[0]);
                    p >= 0 ? f = parseInt(d[0], 10) : h = parseFloat(d[0]);
                } else d.length >= 2 && (h = parseFloat(d[0]), f = parseInt(d[1], 10));
                var g;
                if (typeof h < "u" && h >= 0 && h <= 1) {
                    if (c._state !== "loaded" || c._playLock) return c._queue.push({
                        event: "volume",
                        action: function() {
                            c.volume.apply(c, d);
                        }
                    }), c;
                    typeof f > "u" && (c._volume = h), f = c._getSoundIds(f);
                    for(var y = 0; y < f.length; y++)g = c._soundById(f[y]), g && (g._volume = h, d[2] || c._stopFade(f[y]), c._webAudio && g._node && !g._muted ? g._node.gain.setValueAtTime(h, t.ctx.currentTime) : g._node && !g._muted && (g._node.volume = h * t.volume()), c._emit("volume", g._id));
                } else return g = f ? c._soundById(f) : c._sounds[0], g ? g._volume : 0;
                return c;
            },
            fade: function(c, d, h, f) {
                var m = this;
                if (m._state !== "loaded" || m._playLock) return m._queue.push({
                    event: "fade",
                    action: function() {
                        m.fade(c, d, h, f);
                    }
                }), m;
                c = Math.min(Math.max(0, parseFloat(c)), 1), d = Math.min(Math.max(0, parseFloat(d)), 1), h = parseFloat(h), m.volume(c, f);
                for(var p = m._getSoundIds(f), g = 0; g < p.length; g++){
                    var y = m._soundById(p[g]);
                    if (y) {
                        if (f || m._stopFade(p[g]), m._webAudio && !y._muted) {
                            var v = t.ctx.currentTime, x = v + h / 1e3;
                            y._volume = c, y._node.gain.setValueAtTime(c, v), y._node.gain.linearRampToValueAtTime(d, x);
                        }
                        m._startFadeInterval(y, c, d, h, p[g], typeof f > "u");
                    }
                }
                return m;
            },
            _startFadeInterval: function(c, d, h, f, m, p) {
                var g = this, y = d, v = h - d, x = Math.abs(v / .01), w = Math.max(4, x > 0 ? f / x : f), S = Date.now();
                c._fadeTo = h, c._interval = setInterval(function() {
                    var _ = (Date.now() - S) / f;
                    S = Date.now(), y += v * _, y = Math.round(y * 100) / 100, v < 0 ? y = Math.max(h, y) : y = Math.min(h, y), g._webAudio ? c._volume = y : g.volume(y, c._id, !0), p && (g._volume = y), (h < d && y <= h || h > d && y >= h) && (clearInterval(c._interval), c._interval = null, c._fadeTo = null, g.volume(h, c._id), g._emit("fade", c._id));
                }, w);
            },
            _stopFade: function(c) {
                var d = this, h = d._soundById(c);
                return h && h._interval && (d._webAudio && h._node.gain.cancelScheduledValues(t.ctx.currentTime), clearInterval(h._interval), h._interval = null, d.volume(h._fadeTo, c), h._fadeTo = null, d._emit("fade", c)), d;
            },
            loop: function() {
                var c = this, d = arguments, h, f, m;
                if (d.length === 0) return c._loop;
                if (d.length === 1) {
                    if (typeof d[0] == "boolean") h = d[0], c._loop = h;
                    else return m = c._soundById(parseInt(d[0], 10)), m ? m._loop : !1;
                } else d.length === 2 && (h = d[0], f = parseInt(d[1], 10));
                for(var p = c._getSoundIds(f), g = 0; g < p.length; g++)m = c._soundById(p[g]), m && (m._loop = h, c._webAudio && m._node && m._node.bufferSource && (m._node.bufferSource.loop = h, h && (m._node.bufferSource.loopStart = m._start || 0, m._node.bufferSource.loopEnd = m._stop, c.playing(p[g]) && (c.pause(p[g], !0), c.play(p[g], !0)))));
                return c;
            },
            rate: function() {
                var c = this, d = arguments, h, f;
                if (d.length === 0) f = c._sounds[0]._id;
                else if (d.length === 1) {
                    var m = c._getSoundIds(), p = m.indexOf(d[0]);
                    p >= 0 ? f = parseInt(d[0], 10) : h = parseFloat(d[0]);
                } else d.length === 2 && (h = parseFloat(d[0]), f = parseInt(d[1], 10));
                var g;
                if (typeof h == "number") {
                    if (c._state !== "loaded" || c._playLock) return c._queue.push({
                        event: "rate",
                        action: function() {
                            c.rate.apply(c, d);
                        }
                    }), c;
                    typeof f > "u" && (c._rate = h), f = c._getSoundIds(f);
                    for(var y = 0; y < f.length; y++)if (g = c._soundById(f[y]), g) {
                        c.playing(f[y]) && (g._rateSeek = c.seek(f[y]), g._playStart = c._webAudio ? t.ctx.currentTime : g._playStart), g._rate = h, c._webAudio && g._node && g._node.bufferSource ? g._node.bufferSource.playbackRate.setValueAtTime(h, t.ctx.currentTime) : g._node && (g._node.playbackRate = h);
                        var v = c.seek(f[y]), x = (c._sprite[g._sprite][0] + c._sprite[g._sprite][1]) / 1e3 - v, w = x * 1e3 / Math.abs(g._rate);
                        (c._endTimers[f[y]] || !g._paused) && (c._clearTimer(f[y]), c._endTimers[f[y]] = setTimeout(c._ended.bind(c, g), w)), c._emit("rate", g._id);
                    }
                } else return g = c._soundById(f), g ? g._rate : c._rate;
                return c;
            },
            seek: function() {
                var c = this, d = arguments, h, f;
                if (d.length === 0) c._sounds.length && (f = c._sounds[0]._id);
                else if (d.length === 1) {
                    var m = c._getSoundIds(), p = m.indexOf(d[0]);
                    p >= 0 ? f = parseInt(d[0], 10) : c._sounds.length && (f = c._sounds[0]._id, h = parseFloat(d[0]));
                } else d.length === 2 && (h = parseFloat(d[0]), f = parseInt(d[1], 10));
                if (typeof f > "u") return 0;
                if (typeof h == "number" && (c._state !== "loaded" || c._playLock)) return c._queue.push({
                    event: "seek",
                    action: function() {
                        c.seek.apply(c, d);
                    }
                }), c;
                var g = c._soundById(f);
                if (g) {
                    if (typeof h == "number" && h >= 0) {
                        var y = c.playing(f);
                        y && c.pause(f, !0), g._seek = h, g._ended = !1, c._clearTimer(f), !c._webAudio && g._node && !isNaN(g._node.duration) && (g._node.currentTime = h);
                        var v = function() {
                            y && c.play(f, !0), c._emit("seek", f);
                        };
                        if (y && !c._webAudio) {
                            var x = function() {
                                c._playLock ? setTimeout(x, 0) : v();
                            };
                            setTimeout(x, 0);
                        } else v();
                    } else if (c._webAudio) {
                        var w = c.playing(f) ? t.ctx.currentTime - g._playStart : 0, S = g._rateSeek ? g._rateSeek - g._seek : 0;
                        return g._seek + (S + w * Math.abs(g._rate));
                    } else return g._node.currentTime;
                }
                return c;
            },
            playing: function(c) {
                var d = this;
                if (typeof c == "number") {
                    var h = d._soundById(c);
                    return h ? !h._paused : !1;
                }
                for(var f = 0; f < d._sounds.length; f++)if (!d._sounds[f]._paused) return !0;
                return !1;
            },
            duration: function(c) {
                var d = this, h = d._duration, f = d._soundById(c);
                return f && (h = d._sprite[f._sprite][1] / 1e3), h;
            },
            state: function() {
                return this._state;
            },
            unload: function() {
                for(var c = this, d = c._sounds, h = 0; h < d.length; h++)d[h]._paused || c.stop(d[h]._id), c._webAudio || (c._clearSound(d[h]._node), d[h]._node.removeEventListener("error", d[h]._errorFn, !1), d[h]._node.removeEventListener(t._canPlayEvent, d[h]._loadFn, !1), d[h]._node.removeEventListener("ended", d[h]._endFn, !1), t._releaseHtml5Audio(d[h]._node)), delete d[h]._node, c._clearTimer(d[h]._id);
                var f = t._howls.indexOf(c);
                f >= 0 && t._howls.splice(f, 1);
                var m = !0;
                for(h = 0; h < t._howls.length; h++)if (t._howls[h]._src === c._src || c._src.indexOf(t._howls[h]._src) >= 0) {
                    m = !1;
                    break;
                }
                return i && m && delete i[c._src], t.noAudio = !1, c._state = "unloaded", c._sounds = [], c = null, null;
            },
            on: function(c, d, h, f) {
                var m = this, p = m["_on" + c];
                return typeof d == "function" && p.push(f ? {
                    id: h,
                    fn: d,
                    once: f
                } : {
                    id: h,
                    fn: d
                }), m;
            },
            off: function(c, d, h) {
                var f = this, m = f["_on" + c], p = 0;
                if (typeof d == "number" && (h = d, d = null), d || h) for(p = 0; p < m.length; p++){
                    var g = h === m[p].id;
                    if (d === m[p].fn && g || !d && g) {
                        m.splice(p, 1);
                        break;
                    }
                }
                else if (c) f["_on" + c] = [];
                else {
                    var y = Object.keys(f);
                    for(p = 0; p < y.length; p++)y[p].indexOf("_on") === 0 && Array.isArray(f[y[p]]) && (f[y[p]] = []);
                }
                return f;
            },
            once: function(c, d, h) {
                var f = this;
                return f.on(c, d, h, 1), f;
            },
            _emit: function(c, d, h) {
                for(var f = this, m = f["_on" + c], p = m.length - 1; p >= 0; p--)(!m[p].id || m[p].id === d || c === "load") && (setTimeout((function(g) {
                    g.call(this, d, h);
                }).bind(f, m[p].fn), 0), m[p].once && f.off(c, m[p].fn, m[p].id));
                return f._loadQueue(c), f;
            },
            _loadQueue: function(c) {
                var d = this;
                if (d._queue.length > 0) {
                    var h = d._queue[0];
                    h.event === c && (d._queue.shift(), d._loadQueue()), c || h.action();
                }
                return d;
            },
            _ended: function(c) {
                var d = this, h = c._sprite;
                if (!d._webAudio && c._node && !c._node.paused && !c._node.ended && c._node.currentTime < c._stop) return setTimeout(d._ended.bind(d, c), 100), d;
                var f = !!(c._loop || d._sprite[h][2]);
                if (d._emit("end", c._id), !d._webAudio && f && d.stop(c._id, !0).play(c._id), d._webAudio && f) {
                    d._emit("play", c._id), c._seek = c._start || 0, c._rateSeek = 0, c._playStart = t.ctx.currentTime;
                    var m = (c._stop - c._start) * 1e3 / Math.abs(c._rate);
                    d._endTimers[c._id] = setTimeout(d._ended.bind(d, c), m);
                }
                return d._webAudio && !f && (c._paused = !0, c._ended = !0, c._seek = c._start || 0, c._rateSeek = 0, d._clearTimer(c._id), d._cleanBuffer(c._node), t._autoSuspend()), !d._webAudio && !f && d.stop(c._id, !0), d;
            },
            _clearTimer: function(c) {
                var d = this;
                if (d._endTimers[c]) {
                    if (typeof d._endTimers[c] != "function") clearTimeout(d._endTimers[c]);
                    else {
                        var h = d._soundById(c);
                        h && h._node && h._node.removeEventListener("ended", d._endTimers[c], !1);
                    }
                    delete d._endTimers[c];
                }
                return d;
            },
            _soundById: function(c) {
                for(var d = this, h = 0; h < d._sounds.length; h++)if (c === d._sounds[h]._id) return d._sounds[h];
                return null;
            },
            _inactiveSound: function() {
                var c = this;
                c._drain();
                for(var d = 0; d < c._sounds.length; d++)if (c._sounds[d]._ended) return c._sounds[d].reset();
                return new n(c);
            },
            _drain: function() {
                var c = this, d = c._pool, h = 0, f = 0;
                if (!(c._sounds.length < d)) {
                    for(f = 0; f < c._sounds.length; f++)c._sounds[f]._ended && h++;
                    for(f = c._sounds.length - 1; f >= 0; f--){
                        if (h <= d) return;
                        c._sounds[f]._ended && (c._webAudio && c._sounds[f]._node && c._sounds[f]._node.disconnect(0), c._sounds.splice(f, 1), h--);
                    }
                }
            },
            _getSoundIds: function(c) {
                var d = this;
                if (typeof c > "u") {
                    for(var h = [], f = 0; f < d._sounds.length; f++)h.push(d._sounds[f]._id);
                    return h;
                } else return [
                    c
                ];
            },
            _refreshBuffer: function(c) {
                var d = this;
                return c._node.bufferSource = t.ctx.createBufferSource(), c._node.bufferSource.buffer = i[d._src], c._panner ? c._node.bufferSource.connect(c._panner) : c._node.bufferSource.connect(c._node), c._node.bufferSource.loop = c._loop, c._loop && (c._node.bufferSource.loopStart = c._start || 0, c._node.bufferSource.loopEnd = c._stop || 0), c._node.bufferSource.playbackRate.setValueAtTime(c._rate, t.ctx.currentTime), d;
            },
            _cleanBuffer: function(c) {
                var d = this, h = t._navigator && t._navigator.vendor.indexOf("Apple") >= 0;
                if (t._scratchBuffer && c.bufferSource && (c.bufferSource.onended = null, c.bufferSource.disconnect(0), h)) try {
                    c.bufferSource.buffer = t._scratchBuffer;
                } catch  {}
                return c.bufferSource = null, d;
            },
            _clearSound: function(c) {
                var d = /MSIE |Trident\//.test(t._navigator && t._navigator.userAgent);
                d || (c.src = "data:audio/wav;base64,UklGRigAAABXQVZFZm10IBIAAAABAAEARKwAAIhYAQACABAAAABkYXRhAgAAAAEA");
            }
        };
        var n = function(c) {
            this._parent = c, this.init();
        };
        n.prototype = {
            init: function() {
                var c = this, d = c._parent;
                return c._muted = d._muted, c._loop = d._loop, c._volume = d._volume, c._rate = d._rate, c._seek = 0, c._paused = !0, c._ended = !0, c._sprite = "__default", c._id = ++t._counter, d._sounds.push(c), c.create(), c;
            },
            create: function() {
                var c = this, d = c._parent, h = t._muted || c._muted || c._parent._muted ? 0 : c._volume;
                return d._webAudio ? (c._node = typeof t.ctx.createGain > "u" ? t.ctx.createGainNode() : t.ctx.createGain(), c._node.gain.setValueAtTime(h, t.ctx.currentTime), c._node.paused = !0, c._node.connect(t.masterGain)) : t.noAudio || (c._node = t._obtainHtml5Audio(), c._errorFn = c._errorListener.bind(c), c._node.addEventListener("error", c._errorFn, !1), c._loadFn = c._loadListener.bind(c), c._node.addEventListener(t._canPlayEvent, c._loadFn, !1), c._endFn = c._endListener.bind(c), c._node.addEventListener("ended", c._endFn, !1), c._node.src = d._src, c._node.preload = d._preload === !0 ? "auto" : d._preload, c._node.volume = h * t.volume(), c._node.load()), c;
            },
            reset: function() {
                var c = this, d = c._parent;
                return c._muted = d._muted, c._loop = d._loop, c._volume = d._volume, c._rate = d._rate, c._seek = 0, c._rateSeek = 0, c._paused = !0, c._ended = !0, c._sprite = "__default", c._id = ++t._counter, c;
            },
            _errorListener: function() {
                var c = this;
                c._parent._emit("loaderror", c._id, c._node.error ? c._node.error.code : 0), c._node.removeEventListener("error", c._errorFn, !1);
            },
            _loadListener: function() {
                var c = this, d = c._parent;
                d._duration = Math.ceil(c._node.duration * 10) / 10, Object.keys(d._sprite).length === 0 && (d._sprite = {
                    __default: [
                        0,
                        d._duration * 1e3
                    ]
                }), d._state !== "loaded" && (d._state = "loaded", d._emit("load"), d._loadQueue()), c._node.removeEventListener(t._canPlayEvent, c._loadFn, !1);
            },
            _endListener: function() {
                var c = this, d = c._parent;
                d._duration === 1 / 0 && (d._duration = Math.ceil(c._node.duration * 10) / 10, d._sprite.__default[1] === 1 / 0 && (d._sprite.__default[1] = d._duration * 1e3), d._ended(c)), c._node.removeEventListener("ended", c._endFn, !1);
            }
        };
        var i = {}, s = function(c) {
            var d = c._src;
            if (i[d]) {
                c._duration = i[d].duration, l(c);
                return;
            }
            if (/^data:[^;]+;base64,/.test(d)) {
                for(var h = atob(d.split(",")[1]), f = new Uint8Array(h.length), m = 0; m < h.length; ++m)f[m] = h.charCodeAt(m);
                a(f.buffer, c);
            } else {
                var p = new XMLHttpRequest;
                p.open(c._xhr.method, d, !0), p.withCredentials = c._xhr.withCredentials, p.responseType = "arraybuffer", c._xhr.headers && Object.keys(c._xhr.headers).forEach(function(g) {
                    p.setRequestHeader(g, c._xhr.headers[g]);
                }), p.onload = function() {
                    var g = (p.status + "")[0];
                    if (g !== "0" && g !== "2" && g !== "3") {
                        c._emit("loaderror", null, "Failed loading audio file with status: " + p.status + ".");
                        return;
                    }
                    a(p.response, c);
                }, p.onerror = function() {
                    c._webAudio && (c._html5 = !0, c._webAudio = !1, c._sounds = [], delete i[d], c.load());
                }, o(p);
            }
        }, o = function(c) {
            try {
                c.send();
            } catch  {
                c.onerror();
            }
        }, a = function(c, d) {
            var h = function() {
                d._emit("loaderror", null, "Decoding audio data failed.");
            }, f = function(m) {
                m && d._sounds.length > 0 ? (i[d._src] = m, l(d, m)) : h();
            };
            typeof Promise < "u" && t.ctx.decodeAudioData.length === 1 ? t.ctx.decodeAudioData(c).then(f).catch(h) : t.ctx.decodeAudioData(c, f, h);
        }, l = function(c, d) {
            d && !c._duration && (c._duration = d.duration), Object.keys(c._sprite).length === 0 && (c._sprite = {
                __default: [
                    0,
                    c._duration * 1e3
                ]
            }), c._state !== "loaded" && (c._state = "loaded", c._emit("load"), c._loadQueue());
        }, u = function() {
            if (!!t.usingWebAudio) {
                try {
                    typeof AudioContext < "u" ? t.ctx = new AudioContext : typeof webkitAudioContext < "u" ? t.ctx = new webkitAudioContext : t.usingWebAudio = !1;
                } catch  {
                    t.usingWebAudio = !1;
                }
                t.ctx || (t.usingWebAudio = !1);
                var c = /iP(hone|od|ad)/.test(t._navigator && t._navigator.platform), d = t._navigator && t._navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/), h = d ? parseInt(d[1], 10) : null;
                if (c && h && h < 9) {
                    var f = /safari/.test(t._navigator && t._navigator.userAgent.toLowerCase());
                    t._navigator && !f && (t.usingWebAudio = !1);
                }
                t.usingWebAudio && (t.masterGain = typeof t.ctx.createGain > "u" ? t.ctx.createGainNode() : t.ctx.createGain(), t.masterGain.gain.setValueAtTime(t._muted ? 0 : t._volume, t.ctx.currentTime), t.masterGain.connect(t.ctx.destination)), t._setup();
            }
        };
        typeof define == "function" && define.amd && define([], function() {
            return {
                Howler: t,
                Howl: e
            };
        }), typeof sy < "u" && (sy.Howler = t, sy.Howl = e), typeof $parcel$global < "u" ? ($parcel$global.HowlerGlobal = r1, $parcel$global.Howler = t, $parcel$global.Howl = e, $parcel$global.Sound = n) : typeof window < "u" && (window.HowlerGlobal = r1, window.Howler = t, window.Howl = e, window.Sound = n);
    })();
    (function() {
        "use strict";
        HowlerGlobal.prototype._pos = [
            0,
            0,
            0
        ], HowlerGlobal.prototype._orientation = [
            0,
            0,
            -1,
            0,
            1,
            0
        ], HowlerGlobal.prototype.stereo = function(t) {
            var e = this;
            if (!e.ctx || !e.ctx.listener) return e;
            for(var n = e._howls.length - 1; n >= 0; n--)e._howls[n].stereo(t);
            return e;
        }, HowlerGlobal.prototype.pos = function(t, e, n) {
            var i = this;
            if (!i.ctx || !i.ctx.listener) return i;
            if (e = typeof e != "number" ? i._pos[1] : e, n = typeof n != "number" ? i._pos[2] : n, typeof t == "number") i._pos = [
                t,
                e,
                n
            ], typeof i.ctx.listener.positionX < "u" ? (i.ctx.listener.positionX.setTargetAtTime(i._pos[0], Howler.ctx.currentTime, .1), i.ctx.listener.positionY.setTargetAtTime(i._pos[1], Howler.ctx.currentTime, .1), i.ctx.listener.positionZ.setTargetAtTime(i._pos[2], Howler.ctx.currentTime, .1)) : i.ctx.listener.setPosition(i._pos[0], i._pos[1], i._pos[2]);
            else return i._pos;
            return i;
        }, HowlerGlobal.prototype.orientation = function(t, e, n, i, s, o) {
            var a = this;
            if (!a.ctx || !a.ctx.listener) return a;
            var l = a._orientation;
            if (e = typeof e != "number" ? l[1] : e, n = typeof n != "number" ? l[2] : n, i = typeof i != "number" ? l[3] : i, s = typeof s != "number" ? l[4] : s, o = typeof o != "number" ? l[5] : o, typeof t == "number") a._orientation = [
                t,
                e,
                n,
                i,
                s,
                o
            ], typeof a.ctx.listener.forwardX < "u" ? (a.ctx.listener.forwardX.setTargetAtTime(t, Howler.ctx.currentTime, .1), a.ctx.listener.forwardY.setTargetAtTime(e, Howler.ctx.currentTime, .1), a.ctx.listener.forwardZ.setTargetAtTime(n, Howler.ctx.currentTime, .1), a.ctx.listener.upX.setTargetAtTime(i, Howler.ctx.currentTime, .1), a.ctx.listener.upY.setTargetAtTime(s, Howler.ctx.currentTime, .1), a.ctx.listener.upZ.setTargetAtTime(o, Howler.ctx.currentTime, .1)) : a.ctx.listener.setOrientation(t, e, n, i, s, o);
            else return l;
            return a;
        }, Howl.prototype.init = function(t) {
            return function(e) {
                var n = this;
                return n._orientation = e.orientation || [
                    1,
                    0,
                    0
                ], n._stereo = e.stereo || null, n._pos = e.pos || null, n._pannerAttr = {
                    coneInnerAngle: typeof e.coneInnerAngle < "u" ? e.coneInnerAngle : 360,
                    coneOuterAngle: typeof e.coneOuterAngle < "u" ? e.coneOuterAngle : 360,
                    coneOuterGain: typeof e.coneOuterGain < "u" ? e.coneOuterGain : 0,
                    distanceModel: typeof e.distanceModel < "u" ? e.distanceModel : "inverse",
                    maxDistance: typeof e.maxDistance < "u" ? e.maxDistance : 1e4,
                    panningModel: typeof e.panningModel < "u" ? e.panningModel : "HRTF",
                    refDistance: typeof e.refDistance < "u" ? e.refDistance : 1,
                    rolloffFactor: typeof e.rolloffFactor < "u" ? e.rolloffFactor : 1
                }, n._onstereo = e.onstereo ? [
                    {
                        fn: e.onstereo
                    }
                ] : [], n._onpos = e.onpos ? [
                    {
                        fn: e.onpos
                    }
                ] : [], n._onorientation = e.onorientation ? [
                    {
                        fn: e.onorientation
                    }
                ] : [], t.call(this, e);
            };
        }(Howl.prototype.init), Howl.prototype.stereo = function(t, e) {
            var n = this;
            if (!n._webAudio) return n;
            if (n._state !== "loaded") return n._queue.push({
                event: "stereo",
                action: function() {
                    n.stereo(t, e);
                }
            }), n;
            var i = typeof Howler.ctx.createStereoPanner > "u" ? "spatial" : "stereo";
            if (typeof e > "u") {
                if (typeof t == "number") n._stereo = t, n._pos = [
                    t,
                    0,
                    0
                ];
                else return n._stereo;
            }
            for(var s = n._getSoundIds(e), o = 0; o < s.length; o++){
                var a = n._soundById(s[o]);
                if (a) {
                    if (typeof t == "number") a._stereo = t, a._pos = [
                        t,
                        0,
                        0
                    ], a._node && (a._pannerAttr.panningModel = "equalpower", (!a._panner || !a._panner.pan) && r1(a, i), i === "spatial" ? typeof a._panner.positionX < "u" ? (a._panner.positionX.setValueAtTime(t, Howler.ctx.currentTime), a._panner.positionY.setValueAtTime(0, Howler.ctx.currentTime), a._panner.positionZ.setValueAtTime(0, Howler.ctx.currentTime)) : a._panner.setPosition(t, 0, 0) : a._panner.pan.setValueAtTime(t, Howler.ctx.currentTime)), n._emit("stereo", a._id);
                    else return a._stereo;
                }
            }
            return n;
        }, Howl.prototype.pos = function(t, e, n, i) {
            var s = this;
            if (!s._webAudio) return s;
            if (s._state !== "loaded") return s._queue.push({
                event: "pos",
                action: function() {
                    s.pos(t, e, n, i);
                }
            }), s;
            if (e = typeof e != "number" ? 0 : e, n = typeof n != "number" ? -0.5 : n, typeof i > "u") {
                if (typeof t == "number") s._pos = [
                    t,
                    e,
                    n
                ];
                else return s._pos;
            }
            for(var o = s._getSoundIds(i), a = 0; a < o.length; a++){
                var l = s._soundById(o[a]);
                if (l) {
                    if (typeof t == "number") l._pos = [
                        t,
                        e,
                        n
                    ], l._node && ((!l._panner || l._panner.pan) && r1(l, "spatial"), typeof l._panner.positionX < "u" ? (l._panner.positionX.setValueAtTime(t, Howler.ctx.currentTime), l._panner.positionY.setValueAtTime(e, Howler.ctx.currentTime), l._panner.positionZ.setValueAtTime(n, Howler.ctx.currentTime)) : l._panner.setPosition(t, e, n)), s._emit("pos", l._id);
                    else return l._pos;
                }
            }
            return s;
        }, Howl.prototype.orientation = function(t, e, n, i) {
            var s = this;
            if (!s._webAudio) return s;
            if (s._state !== "loaded") return s._queue.push({
                event: "orientation",
                action: function() {
                    s.orientation(t, e, n, i);
                }
            }), s;
            if (e = typeof e != "number" ? s._orientation[1] : e, n = typeof n != "number" ? s._orientation[2] : n, typeof i > "u") {
                if (typeof t == "number") s._orientation = [
                    t,
                    e,
                    n
                ];
                else return s._orientation;
            }
            for(var o = s._getSoundIds(i), a = 0; a < o.length; a++){
                var l = s._soundById(o[a]);
                if (l) {
                    if (typeof t == "number") l._orientation = [
                        t,
                        e,
                        n
                    ], l._node && (l._panner || (l._pos || (l._pos = s._pos || [
                        0,
                        0,
                        -0.5
                    ]), r1(l, "spatial")), typeof l._panner.orientationX < "u" ? (l._panner.orientationX.setValueAtTime(t, Howler.ctx.currentTime), l._panner.orientationY.setValueAtTime(e, Howler.ctx.currentTime), l._panner.orientationZ.setValueAtTime(n, Howler.ctx.currentTime)) : l._panner.setOrientation(t, e, n)), s._emit("orientation", l._id);
                    else return l._orientation;
                }
            }
            return s;
        }, Howl.prototype.pannerAttr = function() {
            var t = this, e = arguments, n, i, s;
            if (!t._webAudio) return t;
            if (e.length === 0) return t._pannerAttr;
            if (e.length === 1) {
                if (typeof e[0] == "object") n = e[0], typeof i > "u" && (n.pannerAttr || (n.pannerAttr = {
                    coneInnerAngle: n.coneInnerAngle,
                    coneOuterAngle: n.coneOuterAngle,
                    coneOuterGain: n.coneOuterGain,
                    distanceModel: n.distanceModel,
                    maxDistance: n.maxDistance,
                    refDistance: n.refDistance,
                    rolloffFactor: n.rolloffFactor,
                    panningModel: n.panningModel
                }), t._pannerAttr = {
                    coneInnerAngle: typeof n.pannerAttr.coneInnerAngle < "u" ? n.pannerAttr.coneInnerAngle : t._coneInnerAngle,
                    coneOuterAngle: typeof n.pannerAttr.coneOuterAngle < "u" ? n.pannerAttr.coneOuterAngle : t._coneOuterAngle,
                    coneOuterGain: typeof n.pannerAttr.coneOuterGain < "u" ? n.pannerAttr.coneOuterGain : t._coneOuterGain,
                    distanceModel: typeof n.pannerAttr.distanceModel < "u" ? n.pannerAttr.distanceModel : t._distanceModel,
                    maxDistance: typeof n.pannerAttr.maxDistance < "u" ? n.pannerAttr.maxDistance : t._maxDistance,
                    refDistance: typeof n.pannerAttr.refDistance < "u" ? n.pannerAttr.refDistance : t._refDistance,
                    rolloffFactor: typeof n.pannerAttr.rolloffFactor < "u" ? n.pannerAttr.rolloffFactor : t._rolloffFactor,
                    panningModel: typeof n.pannerAttr.panningModel < "u" ? n.pannerAttr.panningModel : t._panningModel
                });
                else return s = t._soundById(parseInt(e[0], 10)), s ? s._pannerAttr : t._pannerAttr;
            } else e.length === 2 && (n = e[0], i = parseInt(e[1], 10));
            for(var o = t._getSoundIds(i), a = 0; a < o.length; a++)if (s = t._soundById(o[a]), s) {
                var l = s._pannerAttr;
                l = {
                    coneInnerAngle: typeof n.coneInnerAngle < "u" ? n.coneInnerAngle : l.coneInnerAngle,
                    coneOuterAngle: typeof n.coneOuterAngle < "u" ? n.coneOuterAngle : l.coneOuterAngle,
                    coneOuterGain: typeof n.coneOuterGain < "u" ? n.coneOuterGain : l.coneOuterGain,
                    distanceModel: typeof n.distanceModel < "u" ? n.distanceModel : l.distanceModel,
                    maxDistance: typeof n.maxDistance < "u" ? n.maxDistance : l.maxDistance,
                    refDistance: typeof n.refDistance < "u" ? n.refDistance : l.refDistance,
                    rolloffFactor: typeof n.rolloffFactor < "u" ? n.rolloffFactor : l.rolloffFactor,
                    panningModel: typeof n.panningModel < "u" ? n.panningModel : l.panningModel
                };
                var u = s._panner;
                u ? (u.coneInnerAngle = l.coneInnerAngle, u.coneOuterAngle = l.coneOuterAngle, u.coneOuterGain = l.coneOuterGain, u.distanceModel = l.distanceModel, u.maxDistance = l.maxDistance, u.refDistance = l.refDistance, u.rolloffFactor = l.rolloffFactor, u.panningModel = l.panningModel) : (s._pos || (s._pos = t._pos || [
                    0,
                    0,
                    -0.5
                ]), r1(s, "spatial"));
            }
            return t;
        }, Sound.prototype.init = function(t) {
            return function() {
                var e = this, n = e._parent;
                e._orientation = n._orientation, e._stereo = n._stereo, e._pos = n._pos, e._pannerAttr = n._pannerAttr, t.call(this), e._stereo ? n.stereo(e._stereo) : e._pos && n.pos(e._pos[0], e._pos[1], e._pos[2], e._id);
            };
        }(Sound.prototype.init), Sound.prototype.reset = function(t) {
            return function() {
                var e = this, n = e._parent;
                return e._orientation = n._orientation, e._stereo = n._stereo, e._pos = n._pos, e._pannerAttr = n._pannerAttr, e._stereo ? n.stereo(e._stereo) : e._pos ? n.pos(e._pos[0], e._pos[1], e._pos[2], e._id) : e._panner && (e._panner.disconnect(0), e._panner = void 0, n._refreshBuffer(e)), t.call(this);
            };
        }(Sound.prototype.reset);
        var r1 = function(t, e) {
            e = e || "spatial", e === "spatial" ? (t._panner = Howler.ctx.createPanner(), t._panner.coneInnerAngle = t._pannerAttr.coneInnerAngle, t._panner.coneOuterAngle = t._pannerAttr.coneOuterAngle, t._panner.coneOuterGain = t._pannerAttr.coneOuterGain, t._panner.distanceModel = t._pannerAttr.distanceModel, t._panner.maxDistance = t._pannerAttr.maxDistance, t._panner.refDistance = t._pannerAttr.refDistance, t._panner.rolloffFactor = t._pannerAttr.rolloffFactor, t._panner.panningModel = t._pannerAttr.panningModel, typeof t._panner.positionX < "u" ? (t._panner.positionX.setValueAtTime(t._pos[0], Howler.ctx.currentTime), t._panner.positionY.setValueAtTime(t._pos[1], Howler.ctx.currentTime), t._panner.positionZ.setValueAtTime(t._pos[2], Howler.ctx.currentTime)) : t._panner.setPosition(t._pos[0], t._pos[1], t._pos[2]), typeof t._panner.orientationX < "u" ? (t._panner.orientationX.setValueAtTime(t._orientation[0], Howler.ctx.currentTime), t._panner.orientationY.setValueAtTime(t._orientation[1], Howler.ctx.currentTime), t._panner.orientationZ.setValueAtTime(t._orientation[2], Howler.ctx.currentTime)) : t._panner.setOrientation(t._orientation[0], t._orientation[1], t._orientation[2])) : (t._panner = Howler.ctx.createStereoPanner(), t._panner.pan.setValueAtTime(t._stereo, Howler.ctx.currentTime)), t._panner.connect(t._node), t._paused || t._parent.pause(t._id, !0).play(t._id, !0);
        };
    })();
});
var DI = ip((tIe, PI)=>{
    PI.exports = function(t, e) {
        for(var n = t.split("."), i = e.split("."), s = 0; s < 3; s++){
            var o = Number(n[s]), a = Number(i[s]);
            if (o > a) return 1;
            if (a > o) return -1;
            if (!isNaN(o) && isNaN(a)) return 1;
            if (isNaN(o) && !isNaN(a)) return -1;
        }
        return 0;
    };
});
var ao = "149";
var li = {
    ROTATE: 0,
    PAN: 1,
    DOLLY_PAN: 2,
    DOLLY_ROTATE: 3
}, WI = 0, WS = 1, jI = 2;
var rm = 1, K0 = 2, ah = 3, si = 0, On = 1, Ir = 2;
var Dt = 0, sc = 1, jS = 2, qS = 3, XS = 4, qI = 5, nc = 100, XI = 101, YI = 102, YS = 103, QS = 104, QI = 200, KI = 201, ZI = 202, JI = 203, SA = 204, AA = 205, $I = 206, eO = 207, tO = 208, nO = 209, rO = 210, iO = 0, sO = 1, oO = 2, h0 = 3, aO = 4, lO = 5, cO = 6, uO = 7, _A = 0, dO = 1, hO = 2, io = 0, fO = 1, pO = 2, mO = 3, gO = 4, yO = 5, MA = 300, Vo = 301, Ho = 302, f0 = 303, p0 = 304, Ac = 306, Bi = 1e3, Gt = 1001, m0 = 1002, _t = 1003, KS = 1004;
var Pv = 1005;
var Qe = 1006, vO = 1007;
var Va = 1008;
var qt = 1009, xO = 1010, bO = 1011, TA = 1012, wO = 1013, no = 1014, wr = 1015, Ha = 1016, SO = 1017, AO = 1018, Go = 1020, _O = 1021, gi = 1023, MO = 1024, TO = 1025, za = 1026, Wo = 1027, EO = 1028, CO = 1029, Z0 = 1030, PO = 1031, DO = 1033, Dv = 33776, Iv = 33777, Ov = 33778, Rv = 33779, ZS = 35840, JS = 35841, $S = 35842, e1 = 35843, IO = 36196, t1 = 37492, n1 = 37496, r1 = 37808, i1 = 37809, s1 = 37810, o1 = 37811, a1 = 37812, l1 = 37813, c1 = 37814, u1 = 37815, d1 = 37816, h1 = 37817, f1 = 37818, p1 = 37819, m1 = 37820, g1 = 37821, Lv = 36492, OO = 36283, y1 = 36284, v1 = 36285, x1 = 36286;
var Rp = 2300, Lp = 2301, Nv = 2302, b1 = 2400, w1 = 2401, S1 = 2402;
var oi = 3e3, Ye = 3001, tr = 3200, J0 = 3201, RO = 0, LO = 1;
var fs = "srgb", ph = "srgb-linear";
var Bv = 7680;
var NO = 519, g0 = 35044;
var A1 = "300 es", y0 = 1035, Ht = class {
    addEventListener(t, e) {
        this._listeners === void 0 && (this._listeners = {});
        let n = this._listeners;
        n[t] === void 0 && (n[t] = []), n[t].indexOf(e) === -1 && n[t].push(e);
    }
    hasEventListener(t, e) {
        if (this._listeners === void 0) return !1;
        let n = this._listeners;
        return n[t] !== void 0 && n[t].indexOf(e) !== -1;
    }
    removeEventListener(t, e) {
        if (this._listeners === void 0) return;
        let i = this._listeners[t];
        if (i !== void 0) {
            let s = i.indexOf(e);
            s !== -1 && i.splice(s, 1);
        }
    }
    dispatchEvent(t) {
        if (this._listeners === void 0) return;
        let n = this._listeners[t.type];
        if (n !== void 0) {
            t.target = this;
            let i = n.slice(0);
            for(let s = 0, o = i.length; s < o; s++)i[s].call(this, t);
            t.target = null;
        }
    }
}, br = [
    "00",
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "0a",
    "0b",
    "0c",
    "0d",
    "0e",
    "0f",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "1a",
    "1b",
    "1c",
    "1d",
    "1e",
    "1f",
    "20",
    "21",
    "22",
    "23",
    "24",
    "25",
    "26",
    "27",
    "28",
    "29",
    "2a",
    "2b",
    "2c",
    "2d",
    "2e",
    "2f",
    "30",
    "31",
    "32",
    "33",
    "34",
    "35",
    "36",
    "37",
    "38",
    "39",
    "3a",
    "3b",
    "3c",
    "3d",
    "3e",
    "3f",
    "40",
    "41",
    "42",
    "43",
    "44",
    "45",
    "46",
    "47",
    "48",
    "49",
    "4a",
    "4b",
    "4c",
    "4d",
    "4e",
    "4f",
    "50",
    "51",
    "52",
    "53",
    "54",
    "55",
    "56",
    "57",
    "58",
    "59",
    "5a",
    "5b",
    "5c",
    "5d",
    "5e",
    "5f",
    "60",
    "61",
    "62",
    "63",
    "64",
    "65",
    "66",
    "67",
    "68",
    "69",
    "6a",
    "6b",
    "6c",
    "6d",
    "6e",
    "6f",
    "70",
    "71",
    "72",
    "73",
    "74",
    "75",
    "76",
    "77",
    "78",
    "79",
    "7a",
    "7b",
    "7c",
    "7d",
    "7e",
    "7f",
    "80",
    "81",
    "82",
    "83",
    "84",
    "85",
    "86",
    "87",
    "88",
    "89",
    "8a",
    "8b",
    "8c",
    "8d",
    "8e",
    "8f",
    "90",
    "91",
    "92",
    "93",
    "94",
    "95",
    "96",
    "97",
    "98",
    "99",
    "9a",
    "9b",
    "9c",
    "9d",
    "9e",
    "9f",
    "a0",
    "a1",
    "a2",
    "a3",
    "a4",
    "a5",
    "a6",
    "a7",
    "a8",
    "a9",
    "aa",
    "ab",
    "ac",
    "ad",
    "ae",
    "af",
    "b0",
    "b1",
    "b2",
    "b3",
    "b4",
    "b5",
    "b6",
    "b7",
    "b8",
    "b9",
    "ba",
    "bb",
    "bc",
    "bd",
    "be",
    "bf",
    "c0",
    "c1",
    "c2",
    "c3",
    "c4",
    "c5",
    "c6",
    "c7",
    "c8",
    "c9",
    "ca",
    "cb",
    "cc",
    "cd",
    "ce",
    "cf",
    "d0",
    "d1",
    "d2",
    "d3",
    "d4",
    "d5",
    "d6",
    "d7",
    "d8",
    "d9",
    "da",
    "db",
    "dc",
    "dd",
    "de",
    "df",
    "e0",
    "e1",
    "e2",
    "e3",
    "e4",
    "e5",
    "e6",
    "e7",
    "e8",
    "e9",
    "ea",
    "eb",
    "ec",
    "ed",
    "ee",
    "ef",
    "f0",
    "f1",
    "f2",
    "f3",
    "f4",
    "f5",
    "f6",
    "f7",
    "f8",
    "f9",
    "fa",
    "fb",
    "fc",
    "fd",
    "fe",
    "ff"
], _1 = 1234567, ch = Math.PI / 180, mh = 180 / Math.PI;
function gs() {
    let r1 = Math.random() * 4294967295 | 0, t = Math.random() * 4294967295 | 0, e = Math.random() * 4294967295 | 0, n = Math.random() * 4294967295 | 0;
    return (br[r1 & 255] + br[r1 >> 8 & 255] + br[r1 >> 16 & 255] + br[r1 >> 24 & 255] + "-" + br[t & 255] + br[t >> 8 & 255] + "-" + br[t >> 16 & 15 | 64] + br[t >> 24 & 255] + "-" + br[e & 63 | 128] + br[e >> 8 & 255] + "-" + br[e >> 16 & 255] + br[e >> 24 & 255] + br[n & 255] + br[n >> 8 & 255] + br[n >> 16 & 255] + br[n >> 24 & 255]).toLowerCase();
}
function zn(r1, t, e) {
    return Math.max(t, Math.min(e, r1));
}
function $0(r1, t) {
    return (r1 % t + t) % t;
}
function BO(r1, t, e, n, i) {
    return n + (r1 - t) * (i - n) / (e - t);
}
function FO(r1, t, e) {
    return r1 !== t ? (e - r1) / (t - r1) : 0;
}
function uh(r1, t, e) {
    return (1 - e) * r1 + e * t;
}
function UO(r1, t, e, n) {
    return uh(r1, t, 1 - Math.exp(-e * n));
}
function kO(r1, t = 1) {
    return t - Math.abs($0(r1, t * 2) - t);
}
function zO(r1, t, e) {
    return r1 <= t ? 0 : r1 >= e ? 1 : (r1 = (r1 - t) / (e - t), r1 * r1 * (3 - 2 * r1));
}
function GO(r1, t, e) {
    return r1 <= t ? 0 : r1 >= e ? 1 : (r1 = (r1 - t) / (e - t), r1 * r1 * r1 * (r1 * (r1 * 6 - 15) + 10));
}
function VO(r1, t) {
    return r1 + Math.floor(Math.random() * (t - r1 + 1));
}
function HO(r1, t) {
    return r1 + Math.random() * (t - r1);
}
function WO(r1) {
    return r1 * (.5 - Math.random());
}
function jO(r1) {
    r1 !== void 0 && (_1 = r1);
    let t = _1 += 1831565813;
    return t = Math.imul(t ^ t >>> 15, t | 1), t ^= t + Math.imul(t ^ t >>> 7, t | 61), ((t ^ t >>> 14) >>> 0) / 4294967296;
}
function qO(r1) {
    return r1 * ch;
}
function XO(r1) {
    return r1 * mh;
}
function v0(r1) {
    return (r1 & r1 - 1) === 0 && r1 !== 0;
}
function YO(r1) {
    return Math.pow(2, Math.ceil(Math.log(r1) / Math.LN2));
}
function Np(r1) {
    return Math.pow(2, Math.floor(Math.log(r1) / Math.LN2));
}
function QO(r1, t, e, n, i) {
    let s = Math.cos, o = Math.sin, a = s(e / 2), l = o(e / 2), u = s((t + n) / 2), c = o((t + n) / 2), d = s((t - n) / 2), h = o((t - n) / 2), f = s((n - t) / 2), m = o((n - t) / 2);
    switch(i){
        case "XYX":
            r1.set(a * c, l * d, l * h, a * u);
            break;
        case "YZY":
            r1.set(l * h, a * c, l * d, a * u);
            break;
        case "ZXZ":
            r1.set(l * d, l * h, a * c, a * u);
            break;
        case "XZX":
            r1.set(a * c, l * m, l * f, a * u);
            break;
        case "YXY":
            r1.set(l * f, a * c, l * m, a * u);
            break;
        case "ZYZ":
            r1.set(l * m, l * f, a * c, a * u);
            break;
        default:
            console.warn("THREE.MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: " + i);
    }
}
function ro(r1, t) {
    switch(t.constructor){
        case Float32Array:
            return r1;
        case Uint16Array:
            return r1 / 65535;
        case Uint8Array:
            return r1 / 255;
        case Int16Array:
            return Math.max(r1 / 32767, -1);
        case Int8Array:
            return Math.max(r1 / 127, -1);
        default:
            throw new Error("Invalid component type.");
    }
}
function Ut(r1, t) {
    switch(t.constructor){
        case Float32Array:
            return r1;
        case Uint16Array:
            return Math.round(r1 * 65535);
        case Uint8Array:
            return Math.round(r1 * 255);
        case Int16Array:
            return Math.round(r1 * 32767);
        case Int8Array:
            return Math.round(r1 * 127);
        default:
            throw new Error("Invalid component type.");
    }
}
var He = Object.freeze({
    __proto__: null,
    DEG2RAD: ch,
    RAD2DEG: mh,
    ceilPowerOfTwo: YO,
    clamp: zn,
    damp: UO,
    degToRad: qO,
    denormalize: ro,
    euclideanModulo: $0,
    floorPowerOfTwo: Np,
    generateUUID: gs,
    inverseLerp: FO,
    isPowerOfTwo: v0,
    lerp: uh,
    mapLinear: BO,
    normalize: Ut,
    pingpong: kO,
    radToDeg: XO,
    randFloat: HO,
    randFloatSpread: WO,
    randInt: VO,
    seededRandom: jO,
    setQuaternionFromProperEuler: QO,
    smootherstep: GO,
    smoothstep: zO
}), F = class {
    constructor(t = 0, e = 0){
        F.prototype.isVector2 = !0, this.x = t, this.y = e;
    }
    get width() {
        return this.x;
    }
    set width(t) {
        this.x = t;
    }
    get height() {
        return this.y;
    }
    set height(t) {
        this.y = t;
    }
    set(t, e) {
        return this.x = t, this.y = e, this;
    }
    setScalar(t) {
        return this.x = t, this.y = t, this;
    }
    setX(t) {
        return this.x = t, this;
    }
    setY(t) {
        return this.y = t, this;
    }
    setComponent(t, e) {
        switch(t){
            case 0:
                this.x = e;
                break;
            case 1:
                this.y = e;
                break;
            default:
                throw new Error("index is out of range: " + t);
        }
        return this;
    }
    getComponent(t) {
        switch(t){
            case 0:
                return this.x;
            case 1:
                return this.y;
            default:
                throw new Error("index is out of range: " + t);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y);
    }
    copy(t) {
        return this.x = t.x, this.y = t.y, this;
    }
    add(t) {
        return this.x += t.x, this.y += t.y, this;
    }
    addScalar(t) {
        return this.x += t, this.y += t, this;
    }
    addVectors(t, e) {
        return this.x = t.x + e.x, this.y = t.y + e.y, this;
    }
    addScaledVector(t, e) {
        return this.x += t.x * e, this.y += t.y * e, this;
    }
    sub(t) {
        return this.x -= t.x, this.y -= t.y, this;
    }
    subScalar(t) {
        return this.x -= t, this.y -= t, this;
    }
    subVectors(t, e) {
        return this.x = t.x - e.x, this.y = t.y - e.y, this;
    }
    multiply(t) {
        return this.x *= t.x, this.y *= t.y, this;
    }
    multiplyScalar(t) {
        return this.x *= t, this.y *= t, this;
    }
    divide(t) {
        return this.x /= t.x, this.y /= t.y, this;
    }
    divideScalar(t) {
        return this.multiplyScalar(1 / t);
    }
    applyMatrix3(t) {
        let e = this.x, n = this.y, i = t.elements;
        return this.x = i[0] * e + i[3] * n + i[6], this.y = i[1] * e + i[4] * n + i[7], this;
    }
    min(t) {
        return this.x = Math.min(this.x, t.x), this.y = Math.min(this.y, t.y), this;
    }
    max(t) {
        return this.x = Math.max(this.x, t.x), this.y = Math.max(this.y, t.y), this;
    }
    clamp(t, e) {
        return this.x = Math.max(t.x, Math.min(e.x, this.x)), this.y = Math.max(t.y, Math.min(e.y, this.y)), this;
    }
    clampScalar(t, e) {
        return this.x = Math.max(t, Math.min(e, this.x)), this.y = Math.max(t, Math.min(e, this.y)), this;
    }
    clampLength(t, e) {
        let n = this.length();
        return this.divideScalar(n || 1).multiplyScalar(Math.max(t, Math.min(e, n)));
    }
    floor() {
        return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this;
    }
    ceil() {
        return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this;
    }
    round() {
        return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
    }
    roundToZero() {
        return this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x), this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y), this;
    }
    negate() {
        return this.x = -this.x, this.y = -this.y, this;
    }
    dot(t) {
        return this.x * t.x + this.y * t.y;
    }
    cross(t) {
        return this.x * t.y - this.y * t.x;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    angle() {
        return Math.atan2(-this.y, -this.x) + Math.PI;
    }
    distanceTo(t) {
        return Math.sqrt(this.distanceToSquared(t));
    }
    distanceToSquared(t) {
        let e = this.x - t.x, n = this.y - t.y;
        return e * e + n * n;
    }
    manhattanDistanceTo(t) {
        return Math.abs(this.x - t.x) + Math.abs(this.y - t.y);
    }
    setLength(t) {
        return this.normalize().multiplyScalar(t);
    }
    lerp(t, e) {
        return this.x += (t.x - this.x) * e, this.y += (t.y - this.y) * e, this;
    }
    lerpVectors(t, e, n) {
        return this.x = t.x + (e.x - t.x) * n, this.y = t.y + (e.y - t.y) * n, this;
    }
    equals(t) {
        return t.x === this.x && t.y === this.y;
    }
    fromArray(t, e = 0) {
        return this.x = t[e], this.y = t[e + 1], this;
    }
    toArray(t = [], e = 0) {
        return t[e] = this.x, t[e + 1] = this.y, t;
    }
    fromBufferAttribute(t, e) {
        return this.x = t.getX(e), this.y = t.getY(e), this;
    }
    rotateAround(t, e) {
        let n = Math.cos(e), i = Math.sin(e), s = this.x - t.x, o = this.y - t.y;
        return this.x = s * n - o * i + t.x, this.y = s * i + o * n + t.y, this;
    }
    random() {
        return this.x = Math.random(), this.y = Math.random(), this;
    }
    *[Symbol.iterator]() {
        yield this.x, yield this.y;
    }
}, Kt = class {
    constructor(){
        Kt.prototype.isMatrix3 = !0, this.elements = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
    }
    set(t, e, n, i, s, o, a, l, u) {
        let c = this.elements;
        return c[0] = t, c[1] = i, c[2] = a, c[3] = e, c[4] = s, c[5] = l, c[6] = n, c[7] = o, c[8] = u, this;
    }
    identity() {
        return this.set(1, 0, 0, 0, 1, 0, 0, 0, 1), this;
    }
    copy(t) {
        let e = this.elements, n = t.elements;
        return e[0] = n[0], e[1] = n[1], e[2] = n[2], e[3] = n[3], e[4] = n[4], e[5] = n[5], e[6] = n[6], e[7] = n[7], e[8] = n[8], this;
    }
    extractBasis(t, e, n) {
        return t.setFromMatrix3Column(this, 0), e.setFromMatrix3Column(this, 1), n.setFromMatrix3Column(this, 2), this;
    }
    setFromMatrix4(t) {
        let e = t.elements;
        return this.set(e[0], e[4], e[8], e[1], e[5], e[9], e[2], e[6], e[10]), this;
    }
    multiply(t) {
        return this.multiplyMatrices(this, t);
    }
    premultiply(t) {
        return this.multiplyMatrices(t, this);
    }
    multiplyMatrices(t, e) {
        let n = t.elements, i = e.elements, s = this.elements, o = n[0], a = n[3], l = n[6], u = n[1], c = n[4], d = n[7], h = n[2], f = n[5], m = n[8], p = i[0], g = i[3], y = i[6], v = i[1], x = i[4], w = i[7], S = i[2], _ = i[5], M = i[8];
        return s[0] = o * p + a * v + l * S, s[3] = o * g + a * x + l * _, s[6] = o * y + a * w + l * M, s[1] = u * p + c * v + d * S, s[4] = u * g + c * x + d * _, s[7] = u * y + c * w + d * M, s[2] = h * p + f * v + m * S, s[5] = h * g + f * x + m * _, s[8] = h * y + f * w + m * M, this;
    }
    multiplyScalar(t) {
        let e = this.elements;
        return e[0] *= t, e[3] *= t, e[6] *= t, e[1] *= t, e[4] *= t, e[7] *= t, e[2] *= t, e[5] *= t, e[8] *= t, this;
    }
    determinant() {
        let t = this.elements, e = t[0], n = t[1], i = t[2], s = t[3], o = t[4], a = t[5], l = t[6], u = t[7], c = t[8];
        return e * o * c - e * a * u - n * s * c + n * a * l + i * s * u - i * o * l;
    }
    invert() {
        let t = this.elements, e = t[0], n = t[1], i = t[2], s = t[3], o = t[4], a = t[5], l = t[6], u = t[7], c = t[8], d = c * o - a * u, h = a * l - c * s, f = u * s - o * l, m = e * d + n * h + i * f;
        if (m === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
        let p = 1 / m;
        return t[0] = d * p, t[1] = (i * u - c * n) * p, t[2] = (a * n - i * o) * p, t[3] = h * p, t[4] = (c * e - i * l) * p, t[5] = (i * s - a * e) * p, t[6] = f * p, t[7] = (n * l - u * e) * p, t[8] = (o * e - n * s) * p, this;
    }
    transpose() {
        let t, e = this.elements;
        return t = e[1], e[1] = e[3], e[3] = t, t = e[2], e[2] = e[6], e[6] = t, t = e[5], e[5] = e[7], e[7] = t, this;
    }
    getNormalMatrix(t) {
        return this.setFromMatrix4(t).invert().transpose();
    }
    transposeIntoArray(t) {
        let e = this.elements;
        return t[0] = e[0], t[1] = e[3], t[2] = e[6], t[3] = e[1], t[4] = e[4], t[5] = e[7], t[6] = e[2], t[7] = e[5], t[8] = e[8], this;
    }
    setUvTransform(t, e, n, i, s, o, a) {
        let l = Math.cos(s), u = Math.sin(s);
        return this.set(n * l, n * u, -n * (l * o + u * a) + o + t, -i * u, i * l, -i * (-u * o + l * a) + a + e, 0, 0, 1), this;
    }
    scale(t, e) {
        return this.premultiply(Fv.makeScale(t, e)), this;
    }
    rotate(t) {
        return this.premultiply(Fv.makeRotation(-t)), this;
    }
    translate(t, e) {
        return this.premultiply(Fv.makeTranslation(t, e)), this;
    }
    makeTranslation(t, e) {
        return this.set(1, 0, t, 0, 1, e, 0, 0, 1), this;
    }
    makeRotation(t) {
        let e = Math.cos(t), n = Math.sin(t);
        return this.set(e, -n, 0, n, e, 0, 0, 0, 1), this;
    }
    makeScale(t, e) {
        return this.set(t, 0, 0, 0, e, 0, 0, 0, 1), this;
    }
    equals(t) {
        let e = this.elements, n = t.elements;
        for(let i = 0; i < 9; i++)if (e[i] !== n[i]) return !1;
        return !0;
    }
    fromArray(t, e = 0) {
        for(let n = 0; n < 9; n++)this.elements[n] = t[n + e];
        return this;
    }
    toArray(t = [], e = 0) {
        let n = this.elements;
        return t[e] = n[0], t[e + 1] = n[1], t[e + 2] = n[2], t[e + 3] = n[3], t[e + 4] = n[4], t[e + 5] = n[5], t[e + 6] = n[6], t[e + 7] = n[7], t[e + 8] = n[8], t;
    }
    clone() {
        return new this.constructor().fromArray(this.elements);
    }
}, Fv = new Kt;
function EA(r1) {
    for(let t = r1.length - 1; t >= 0; --t)if (r1[t] >= 65535) return !0;
    return !1;
}
var KO = {
    Int8Array: Int8Array,
    Uint8Array: Uint8Array,
    Uint8ClampedArray: Uint8ClampedArray,
    Int16Array: Int16Array,
    Uint16Array: Uint16Array,
    Int32Array: Int32Array,
    Uint32Array: Uint32Array,
    Float32Array: Float32Array,
    Float64Array: Float64Array
};
function sp(r1, t) {
    return new KO[r1](t);
}
function Bp(r1) {
    return document.createElementNS("http://www.w3.org/1999/xhtml", r1);
}
function Ga(r1) {
    return r1 < .04045 ? r1 * .0773993808 : Math.pow(r1 * .9478672986 + .0521327014, 2.4);
}
function Op(r1) {
    return r1 < .0031308 ? r1 * 12.92 : 1.055 * Math.pow(r1, .41666) - .055;
}
var Uv = {
    [fs]: {
        [ph]: Ga
    },
    [ph]: {
        [fs]: Op
    }
}, Cr = {
    legacyMode: !0,
    get workingColorSpace () {
        return ph;
    },
    set workingColorSpace (r){
        console.warn("THREE.ColorManagement: .workingColorSpace is readonly.");
    },
    convert: function(r1, t, e) {
        if (this.legacyMode || t === e || !t || !e) return r1;
        if (Uv[t] && Uv[t][e] !== void 0) {
            let n = Uv[t][e];
            return r1.r = n(r1.r), r1.g = n(r1.g), r1.b = n(r1.b), r1;
        }
        throw new Error("Unsupported color space conversion.");
    },
    fromWorkingColorSpace: function(r1, t) {
        return this.convert(r1, this.workingColorSpace, t);
    },
    toWorkingColorSpace: function(r1, t) {
        return this.convert(r1, t, this.workingColorSpace);
    }
}, CA = {
    aliceblue: 15792383,
    antiquewhite: 16444375,
    aqua: 65535,
    aquamarine: 8388564,
    azure: 15794175,
    beige: 16119260,
    bisque: 16770244,
    black: 0,
    blanchedalmond: 16772045,
    blue: 255,
    blueviolet: 9055202,
    brown: 10824234,
    burlywood: 14596231,
    cadetblue: 6266528,
    chartreuse: 8388352,
    chocolate: 13789470,
    coral: 16744272,
    cornflowerblue: 6591981,
    cornsilk: 16775388,
    crimson: 14423100,
    cyan: 65535,
    darkblue: 139,
    darkcyan: 35723,
    darkgoldenrod: 12092939,
    darkgray: 11119017,
    darkgreen: 25600,
    darkgrey: 11119017,
    darkkhaki: 12433259,
    darkmagenta: 9109643,
    darkolivegreen: 5597999,
    darkorange: 16747520,
    darkorchid: 10040012,
    darkred: 9109504,
    darksalmon: 15308410,
    darkseagreen: 9419919,
    darkslateblue: 4734347,
    darkslategray: 3100495,
    darkslategrey: 3100495,
    darkturquoise: 52945,
    darkviolet: 9699539,
    deeppink: 16716947,
    deepskyblue: 49151,
    dimgray: 6908265,
    dimgrey: 6908265,
    dodgerblue: 2003199,
    firebrick: 11674146,
    floralwhite: 16775920,
    forestgreen: 2263842,
    fuchsia: 16711935,
    gainsboro: 14474460,
    ghostwhite: 16316671,
    gold: 16766720,
    goldenrod: 14329120,
    gray: 8421504,
    green: 32768,
    greenyellow: 11403055,
    grey: 8421504,
    honeydew: 15794160,
    hotpink: 16738740,
    indianred: 13458524,
    indigo: 4915330,
    ivory: 16777200,
    khaki: 15787660,
    lavender: 15132410,
    lavenderblush: 16773365,
    lawngreen: 8190976,
    lemonchiffon: 16775885,
    lightblue: 11393254,
    lightcoral: 15761536,
    lightcyan: 14745599,
    lightgoldenrodyellow: 16448210,
    lightgray: 13882323,
    lightgreen: 9498256,
    lightgrey: 13882323,
    lightpink: 16758465,
    lightsalmon: 16752762,
    lightseagreen: 2142890,
    lightskyblue: 8900346,
    lightslategray: 7833753,
    lightslategrey: 7833753,
    lightsteelblue: 11584734,
    lightyellow: 16777184,
    lime: 65280,
    limegreen: 3329330,
    linen: 16445670,
    magenta: 16711935,
    maroon: 8388608,
    mediumaquamarine: 6737322,
    mediumblue: 205,
    mediumorchid: 12211667,
    mediumpurple: 9662683,
    mediumseagreen: 3978097,
    mediumslateblue: 8087790,
    mediumspringgreen: 64154,
    mediumturquoise: 4772300,
    mediumvioletred: 13047173,
    midnightblue: 1644912,
    mintcream: 16121850,
    mistyrose: 16770273,
    moccasin: 16770229,
    navajowhite: 16768685,
    navy: 128,
    oldlace: 16643558,
    olive: 8421376,
    olivedrab: 7048739,
    orange: 16753920,
    orangered: 16729344,
    orchid: 14315734,
    palegoldenrod: 15657130,
    palegreen: 10025880,
    paleturquoise: 11529966,
    palevioletred: 14381203,
    papayawhip: 16773077,
    peachpuff: 16767673,
    peru: 13468991,
    pink: 16761035,
    plum: 14524637,
    powderblue: 11591910,
    purple: 8388736,
    rebeccapurple: 6697881,
    red: 16711680,
    rosybrown: 12357519,
    royalblue: 4286945,
    saddlebrown: 9127187,
    salmon: 16416882,
    sandybrown: 16032864,
    seagreen: 3050327,
    seashell: 16774638,
    sienna: 10506797,
    silver: 12632256,
    skyblue: 8900331,
    slateblue: 6970061,
    slategray: 7372944,
    slategrey: 7372944,
    snow: 16775930,
    springgreen: 65407,
    steelblue: 4620980,
    tan: 13808780,
    teal: 32896,
    thistle: 14204888,
    tomato: 16737095,
    turquoise: 4251856,
    violet: 15631086,
    wheat: 16113331,
    white: 16777215,
    whitesmoke: 16119285,
    yellow: 16776960,
    yellowgreen: 10145074
}, kn = {
    r: 0,
    g: 0,
    b: 0
}, Ri = {
    h: 0,
    s: 0,
    l: 0
}, op = {
    h: 0,
    s: 0,
    l: 0
};
function kv(r1, t, e) {
    return e < 0 && (e += 1), e > 1 && (e -= 1), e < 1 / 6 ? r1 + (t - r1) * 6 * e : e < 0.5 ? t : e < 2 / 3 ? r1 + (t - r1) * 6 * (2 / 3 - e) : r1;
}
function ap(r1, t) {
    return t.r = r1.r, t.g = r1.g, t.b = r1.b, t;
}
var Ne = class {
    constructor(t, e, n){
        return this.isColor = !0, this.r = 1, this.g = 1, this.b = 1, e === void 0 && n === void 0 ? this.set(t) : this.setRGB(t, e, n);
    }
    set(t) {
        return t && t.isColor ? this.copy(t) : typeof t == "number" ? this.setHex(t) : typeof t == "string" && this.setStyle(t), this;
    }
    setScalar(t) {
        return this.r = t, this.g = t, this.b = t, this;
    }
    setHex(t, e = fs) {
        return t = Math.floor(t), this.r = (t >> 16 & 255) / 255, this.g = (t >> 8 & 255) / 255, this.b = (t & 255) / 255, Cr.toWorkingColorSpace(this, e), this;
    }
    setRGB(t, e, n, i = Cr.workingColorSpace) {
        return this.r = t, this.g = e, this.b = n, Cr.toWorkingColorSpace(this, i), this;
    }
    setHSL(t, e, n, i = Cr.workingColorSpace) {
        if (t = $0(t, 1), e = zn(e, 0, 1), n = zn(n, 0, 1), e === 0) this.r = this.g = this.b = n;
        else {
            let s = n <= .5 ? n * (1 + e) : n + e - n * e, o = 2 * n - s;
            this.r = kv(o, s, t + 1 / 3), this.g = kv(o, s, t), this.b = kv(o, s, t - 1 / 3);
        }
        return Cr.toWorkingColorSpace(this, i), this;
    }
    setStyle(t, e = fs) {
        function n(s) {
            s !== void 0 && parseFloat(s) < 1 && console.warn("THREE.Color: Alpha component of " + t + " will be ignored.");
        }
        let i;
        if (i = /^((?:rgb|hsl)a?)\(([^\)]*)\)/.exec(t)) {
            let s, o = i[1], a = i[2];
            switch(o){
                case "rgb":
                case "rgba":
                    if (s = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(a)) return this.r = Math.min(255, parseInt(s[1], 10)) / 255, this.g = Math.min(255, parseInt(s[2], 10)) / 255, this.b = Math.min(255, parseInt(s[3], 10)) / 255, Cr.toWorkingColorSpace(this, e), n(s[4]), this;
                    if (s = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(a)) return this.r = Math.min(100, parseInt(s[1], 10)) / 100, this.g = Math.min(100, parseInt(s[2], 10)) / 100, this.b = Math.min(100, parseInt(s[3], 10)) / 100, Cr.toWorkingColorSpace(this, e), n(s[4]), this;
                    break;
                case "hsl":
                case "hsla":
                    if (s = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(a)) {
                        let l = parseFloat(s[1]) / 360, u = parseFloat(s[2]) / 100, c = parseFloat(s[3]) / 100;
                        return n(s[4]), this.setHSL(l, u, c, e);
                    }
                    break;
            }
        } else if (i = /^\#([A-Fa-f\d]+)$/.exec(t)) {
            let s = i[1], o = s.length;
            if (o === 3) return this.r = parseInt(s.charAt(0) + s.charAt(0), 16) / 255, this.g = parseInt(s.charAt(1) + s.charAt(1), 16) / 255, this.b = parseInt(s.charAt(2) + s.charAt(2), 16) / 255, Cr.toWorkingColorSpace(this, e), this;
            if (o === 6) return this.r = parseInt(s.charAt(0) + s.charAt(1), 16) / 255, this.g = parseInt(s.charAt(2) + s.charAt(3), 16) / 255, this.b = parseInt(s.charAt(4) + s.charAt(5), 16) / 255, Cr.toWorkingColorSpace(this, e), this;
        }
        return t && t.length > 0 ? this.setColorName(t, e) : this;
    }
    setColorName(t, e = fs) {
        let n = CA[t.toLowerCase()];
        return n !== void 0 ? this.setHex(n, e) : console.warn("THREE.Color: Unknown color " + t), this;
    }
    clone() {
        return new this.constructor(this.r, this.g, this.b);
    }
    copy(t) {
        return this.r = t.r, this.g = t.g, this.b = t.b, this;
    }
    copySRGBToLinear(t) {
        return this.r = Ga(t.r), this.g = Ga(t.g), this.b = Ga(t.b), this;
    }
    copyLinearToSRGB(t) {
        return this.r = Op(t.r), this.g = Op(t.g), this.b = Op(t.b), this;
    }
    convertSRGBToLinear() {
        return this.copySRGBToLinear(this), this;
    }
    convertLinearToSRGB() {
        return this.copyLinearToSRGB(this), this;
    }
    getHex(t = fs) {
        return Cr.fromWorkingColorSpace(ap(this, kn), t), zn(kn.r * 255, 0, 255) << 16 ^ zn(kn.g * 255, 0, 255) << 8 ^ zn(kn.b * 255, 0, 255) << 0;
    }
    getHexString(t = fs) {
        return ("000000" + this.getHex(t).toString(16)).slice(-6);
    }
    getHSL(t, e = Cr.workingColorSpace) {
        Cr.fromWorkingColorSpace(ap(this, kn), e);
        let n = kn.r, i = kn.g, s = kn.b, o = Math.max(n, i, s), a = Math.min(n, i, s), l, u, c = (a + o) / 2;
        if (a === o) l = 0, u = 0;
        else {
            let d = o - a;
            switch(u = c <= .5 ? d / (o + a) : d / (2 - o - a), o){
                case n:
                    l = (i - s) / d + (i < s ? 6 : 0);
                    break;
                case i:
                    l = (s - n) / d + 2;
                    break;
                case s:
                    l = (n - i) / d + 4;
                    break;
            }
            l /= 6;
        }
        return t.h = l, t.s = u, t.l = c, t;
    }
    getRGB(t, e = Cr.workingColorSpace) {
        return Cr.fromWorkingColorSpace(ap(this, kn), e), t.r = kn.r, t.g = kn.g, t.b = kn.b, t;
    }
    getStyle(t = fs) {
        return Cr.fromWorkingColorSpace(ap(this, kn), t), t !== fs ? `color(${t} ${kn.r} ${kn.g} ${kn.b})` : `rgb(${kn.r * 255 | 0},${kn.g * 255 | 0},${kn.b * 255 | 0})`;
    }
    offsetHSL(t, e, n) {
        return this.getHSL(Ri), Ri.h += t, Ri.s += e, Ri.l += n, this.setHSL(Ri.h, Ri.s, Ri.l), this;
    }
    add(t) {
        return this.r += t.r, this.g += t.g, this.b += t.b, this;
    }
    addColors(t, e) {
        return this.r = t.r + e.r, this.g = t.g + e.g, this.b = t.b + e.b, this;
    }
    addScalar(t) {
        return this.r += t, this.g += t, this.b += t, this;
    }
    sub(t) {
        return this.r = Math.max(0, this.r - t.r), this.g = Math.max(0, this.g - t.g), this.b = Math.max(0, this.b - t.b), this;
    }
    multiply(t) {
        return this.r *= t.r, this.g *= t.g, this.b *= t.b, this;
    }
    multiplyScalar(t) {
        return this.r *= t, this.g *= t, this.b *= t, this;
    }
    lerp(t, e) {
        return this.r += (t.r - this.r) * e, this.g += (t.g - this.g) * e, this.b += (t.b - this.b) * e, this;
    }
    lerpColors(t, e, n) {
        return this.r = t.r + (e.r - t.r) * n, this.g = t.g + (e.g - t.g) * n, this.b = t.b + (e.b - t.b) * n, this;
    }
    lerpHSL(t, e) {
        this.getHSL(Ri), t.getHSL(op);
        let n = uh(Ri.h, op.h, e), i = uh(Ri.s, op.s, e), s = uh(Ri.l, op.l, e);
        return this.setHSL(n, i, s), this;
    }
    equals(t) {
        return t.r === this.r && t.g === this.g && t.b === this.b;
    }
    fromArray(t, e = 0) {
        return this.r = t[e], this.g = t[e + 1], this.b = t[e + 2], this;
    }
    toArray(t = [], e = 0) {
        return t[e] = this.r, t[e + 1] = this.g, t[e + 2] = this.b, t;
    }
    fromBufferAttribute(t, e) {
        return this.r = t.getX(e), this.g = t.getY(e), this.b = t.getZ(e), this;
    }
    toJSON() {
        return this.getHex();
    }
    *[Symbol.iterator]() {
        yield this.r, yield this.g, yield this.b;
    }
};
Ne.NAMES = CA;
var Vl, Fp = class {
    static getDataURL(t) {
        if (/^data:/i.test(t.src) || typeof HTMLCanvasElement > "u") return t.src;
        let e;
        if (t instanceof HTMLCanvasElement) e = t;
        else {
            Vl === void 0 && (Vl = Bp("canvas")), Vl.width = t.width, Vl.height = t.height;
            let n = Vl.getContext("2d");
            t instanceof ImageData ? n.putImageData(t, 0, 0) : n.drawImage(t, 0, 0, t.width, t.height), e = Vl;
        }
        return e.width > 2048 || e.height > 2048 ? (console.warn("THREE.ImageUtils.getDataURL: Image converted to jpg for performance reasons", t), e.toDataURL("image/jpeg", .6)) : e.toDataURL("image/png");
    }
    static sRGBToLinear(t) {
        if (typeof HTMLImageElement < "u" && t instanceof HTMLImageElement || typeof HTMLCanvasElement < "u" && t instanceof HTMLCanvasElement || typeof ImageBitmap < "u" && t instanceof ImageBitmap) {
            let e = Bp("canvas");
            e.width = t.width, e.height = t.height;
            let n = e.getContext("2d");
            n.drawImage(t, 0, 0, t.width, t.height);
            let i = n.getImageData(0, 0, t.width, t.height), s = i.data;
            for(let o = 0; o < s.length; o++)s[o] = Ga(s[o] / 255) * 255;
            return n.putImageData(i, 0, 0), e;
        } else if (t.data) {
            let e = t.data.slice(0);
            for(let n = 0; n < e.length; n++)e instanceof Uint8Array || e instanceof Uint8ClampedArray ? e[n] = Math.floor(Ga(e[n] / 255) * 255) : e[n] = Ga(e[n]);
            return {
                data: e,
                width: t.width,
                height: t.height
            };
        } else return console.warn("THREE.ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied."), t;
    }
}, Up = class {
    constructor(t = null){
        this.isSource = !0, this.uuid = gs(), this.data = t, this.version = 0;
    }
    set needsUpdate(t) {
        t === !0 && this.version++;
    }
    toJSON(t) {
        let e = t === void 0 || typeof t == "string";
        if (!e && t.images[this.uuid] !== void 0) return t.images[this.uuid];
        let n = {
            uuid: this.uuid,
            url: ""
        }, i = this.data;
        if (i !== null) {
            let s;
            if (Array.isArray(i)) {
                s = [];
                for(let o = 0, a = i.length; o < a; o++)i[o].isDataTexture ? s.push(zv(i[o].image)) : s.push(zv(i[o]));
            } else s = zv(i);
            n.url = s;
        }
        return e || (t.images[this.uuid] = n), n;
    }
};
function zv(r1) {
    return typeof HTMLImageElement < "u" && r1 instanceof HTMLImageElement || typeof HTMLCanvasElement < "u" && r1 instanceof HTMLCanvasElement || typeof ImageBitmap < "u" && r1 instanceof ImageBitmap ? Fp.getDataURL(r1) : r1.data ? {
        data: Array.from(r1.data),
        width: r1.width,
        height: r1.height,
        type: r1.data.constructor.name
    } : (console.warn("THREE.Texture: Unable to serialize Texture."), {});
}
var ZO = 0, Vt = class extends Ht {
    constructor(t = Vt.DEFAULT_IMAGE, e = Vt.DEFAULT_MAPPING, n = Gt, i = Gt, s = Qe, o = Va, a = gi, l = qt, u = Vt.DEFAULT_ANISOTROPY, c = oi){
        super(), this.isTexture = !0, Object.defineProperty(this, "id", {
            value: ZO++
        }), this.uuid = gs(), this.name = "", this.source = new Up(t), this.mipmaps = [], this.mapping = e, this.wrapS = n, this.wrapT = i, this.magFilter = s, this.minFilter = o, this.anisotropy = u, this.format = a, this.internalFormat = null, this.type = l, this.offset = new F(0, 0), this.repeat = new F(1, 1), this.center = new F(0, 0), this.rotation = 0, this.matrixAutoUpdate = !0, this.matrix = new Kt, this.generateMipmaps = !0, this.premultiplyAlpha = !1, this.flipY = !0, this.unpackAlignment = 4, this.encoding = c, this.userData = {}, this.version = 0, this.onUpdate = null, this.isRenderTargetTexture = !1, this.needsPMREMUpdate = !1;
    }
    get image() {
        return this.source.data;
    }
    set image(t) {
        this.source.data = t;
    }
    updateMatrix() {
        this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(t) {
        return this.name = t.name, this.source = t.source, this.mipmaps = t.mipmaps.slice(0), this.mapping = t.mapping, this.wrapS = t.wrapS, this.wrapT = t.wrapT, this.magFilter = t.magFilter, this.minFilter = t.minFilter, this.anisotropy = t.anisotropy, this.format = t.format, this.internalFormat = t.internalFormat, this.type = t.type, this.offset.copy(t.offset), this.repeat.copy(t.repeat), this.center.copy(t.center), this.rotation = t.rotation, this.matrixAutoUpdate = t.matrixAutoUpdate, this.matrix.copy(t.matrix), this.generateMipmaps = t.generateMipmaps, this.premultiplyAlpha = t.premultiplyAlpha, this.flipY = t.flipY, this.unpackAlignment = t.unpackAlignment, this.encoding = t.encoding, this.userData = JSON.parse(JSON.stringify(t.userData)), this.needsUpdate = !0, this;
    }
    toJSON(t) {
        let e = t === void 0 || typeof t == "string";
        if (!e && t.textures[this.uuid] !== void 0) return t.textures[this.uuid];
        let n = {
            metadata: {
                version: 4.5,
                type: "Texture",
                generator: "Texture.toJSON"
            },
            uuid: this.uuid,
            name: this.name,
            image: this.source.toJSON(t).uuid,
            mapping: this.mapping,
            repeat: [
                this.repeat.x,
                this.repeat.y
            ],
            offset: [
                this.offset.x,
                this.offset.y
            ],
            center: [
                this.center.x,
                this.center.y
            ],
            rotation: this.rotation,
            wrap: [
                this.wrapS,
                this.wrapT
            ],
            format: this.format,
            type: this.type,
            encoding: this.encoding,
            minFilter: this.minFilter,
            magFilter: this.magFilter,
            anisotropy: this.anisotropy,
            flipY: this.flipY,
            generateMipmaps: this.generateMipmaps,
            premultiplyAlpha: this.premultiplyAlpha,
            unpackAlignment: this.unpackAlignment
        };
        return Object.keys(this.userData).length > 0 && (n.userData = this.userData), e || (t.textures[this.uuid] = n), n;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
    transformUv(t) {
        if (this.mapping !== MA) return t;
        if (t.applyMatrix3(this.matrix), t.x < 0 || t.x > 1) switch(this.wrapS){
            case Bi:
                t.x = t.x - Math.floor(t.x);
                break;
            case Gt:
                t.x = t.x < 0 ? 0 : 1;
                break;
            case m0:
                Math.abs(Math.floor(t.x) % 2) === 1 ? t.x = Math.ceil(t.x) - t.x : t.x = t.x - Math.floor(t.x);
                break;
        }
        if (t.y < 0 || t.y > 1) switch(this.wrapT){
            case Bi:
                t.y = t.y - Math.floor(t.y);
                break;
            case Gt:
                t.y = t.y < 0 ? 0 : 1;
                break;
            case m0:
                Math.abs(Math.floor(t.y) % 2) === 1 ? t.y = Math.ceil(t.y) - t.y : t.y = t.y - Math.floor(t.y);
                break;
        }
        return this.flipY && (t.y = 1 - t.y), t;
    }
    set needsUpdate(t) {
        t === !0 && (this.version++, this.source.needsUpdate = !0);
    }
};
Vt.DEFAULT_IMAGE = null;
Vt.DEFAULT_MAPPING = MA;
Vt.DEFAULT_ANISOTROPY = 1;
var Ze = class {
    constructor(t = 0, e = 0, n = 0, i = 1){
        Ze.prototype.isVector4 = !0, this.x = t, this.y = e, this.z = n, this.w = i;
    }
    get width() {
        return this.z;
    }
    set width(t) {
        this.z = t;
    }
    get height() {
        return this.w;
    }
    set height(t) {
        this.w = t;
    }
    set(t, e, n, i) {
        return this.x = t, this.y = e, this.z = n, this.w = i, this;
    }
    setScalar(t) {
        return this.x = t, this.y = t, this.z = t, this.w = t, this;
    }
    setX(t) {
        return this.x = t, this;
    }
    setY(t) {
        return this.y = t, this;
    }
    setZ(t) {
        return this.z = t, this;
    }
    setW(t) {
        return this.w = t, this;
    }
    setComponent(t, e) {
        switch(t){
            case 0:
                this.x = e;
                break;
            case 1:
                this.y = e;
                break;
            case 2:
                this.z = e;
                break;
            case 3:
                this.w = e;
                break;
            default:
                throw new Error("index is out of range: " + t);
        }
        return this;
    }
    getComponent(t) {
        switch(t){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            case 3:
                return this.w;
            default:
                throw new Error("index is out of range: " + t);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y, this.z, this.w);
    }
    copy(t) {
        return this.x = t.x, this.y = t.y, this.z = t.z, this.w = t.w !== void 0 ? t.w : 1, this;
    }
    add(t) {
        return this.x += t.x, this.y += t.y, this.z += t.z, this.w += t.w, this;
    }
    addScalar(t) {
        return this.x += t, this.y += t, this.z += t, this.w += t, this;
    }
    addVectors(t, e) {
        return this.x = t.x + e.x, this.y = t.y + e.y, this.z = t.z + e.z, this.w = t.w + e.w, this;
    }
    addScaledVector(t, e) {
        return this.x += t.x * e, this.y += t.y * e, this.z += t.z * e, this.w += t.w * e, this;
    }
    sub(t) {
        return this.x -= t.x, this.y -= t.y, this.z -= t.z, this.w -= t.w, this;
    }
    subScalar(t) {
        return this.x -= t, this.y -= t, this.z -= t, this.w -= t, this;
    }
    subVectors(t, e) {
        return this.x = t.x - e.x, this.y = t.y - e.y, this.z = t.z - e.z, this.w = t.w - e.w, this;
    }
    multiply(t) {
        return this.x *= t.x, this.y *= t.y, this.z *= t.z, this.w *= t.w, this;
    }
    multiplyScalar(t) {
        return this.x *= t, this.y *= t, this.z *= t, this.w *= t, this;
    }
    applyMatrix4(t) {
        let e = this.x, n = this.y, i = this.z, s = this.w, o = t.elements;
        return this.x = o[0] * e + o[4] * n + o[8] * i + o[12] * s, this.y = o[1] * e + o[5] * n + o[9] * i + o[13] * s, this.z = o[2] * e + o[6] * n + o[10] * i + o[14] * s, this.w = o[3] * e + o[7] * n + o[11] * i + o[15] * s, this;
    }
    divideScalar(t) {
        return this.multiplyScalar(1 / t);
    }
    setAxisAngleFromQuaternion(t) {
        this.w = 2 * Math.acos(t.w);
        let e = Math.sqrt(1 - t.w * t.w);
        return e < 1e-4 ? (this.x = 1, this.y = 0, this.z = 0) : (this.x = t.x / e, this.y = t.y / e, this.z = t.z / e), this;
    }
    setAxisAngleFromRotationMatrix(t) {
        let e, n, i, s, l = t.elements, u = l[0], c = l[4], d = l[8], h = l[1], f = l[5], m = l[9], p = l[2], g = l[6], y = l[10];
        if (Math.abs(c - h) < .01 && Math.abs(d - p) < .01 && Math.abs(m - g) < .01) {
            if (Math.abs(c + h) < .1 && Math.abs(d + p) < .1 && Math.abs(m + g) < .1 && Math.abs(u + f + y - 3) < .1) return this.set(1, 0, 0, 0), this;
            e = Math.PI;
            let x = (u + 1) / 2, w = (f + 1) / 2, S = (y + 1) / 2, _ = (c + h) / 4, M = (d + p) / 4, b = (m + g) / 4;
            return x > w && x > S ? x < .01 ? (n = 0, i = .707106781, s = .707106781) : (n = Math.sqrt(x), i = _ / n, s = M / n) : w > S ? w < .01 ? (n = .707106781, i = 0, s = .707106781) : (i = Math.sqrt(w), n = _ / i, s = b / i) : S < .01 ? (n = .707106781, i = .707106781, s = 0) : (s = Math.sqrt(S), n = M / s, i = b / s), this.set(n, i, s, e), this;
        }
        let v = Math.sqrt((g - m) * (g - m) + (d - p) * (d - p) + (h - c) * (h - c));
        return Math.abs(v) < .001 && (v = 1), this.x = (g - m) / v, this.y = (d - p) / v, this.z = (h - c) / v, this.w = Math.acos((u + f + y - 1) / 2), this;
    }
    min(t) {
        return this.x = Math.min(this.x, t.x), this.y = Math.min(this.y, t.y), this.z = Math.min(this.z, t.z), this.w = Math.min(this.w, t.w), this;
    }
    max(t) {
        return this.x = Math.max(this.x, t.x), this.y = Math.max(this.y, t.y), this.z = Math.max(this.z, t.z), this.w = Math.max(this.w, t.w), this;
    }
    clamp(t, e) {
        return this.x = Math.max(t.x, Math.min(e.x, this.x)), this.y = Math.max(t.y, Math.min(e.y, this.y)), this.z = Math.max(t.z, Math.min(e.z, this.z)), this.w = Math.max(t.w, Math.min(e.w, this.w)), this;
    }
    clampScalar(t, e) {
        return this.x = Math.max(t, Math.min(e, this.x)), this.y = Math.max(t, Math.min(e, this.y)), this.z = Math.max(t, Math.min(e, this.z)), this.w = Math.max(t, Math.min(e, this.w)), this;
    }
    clampLength(t, e) {
        let n = this.length();
        return this.divideScalar(n || 1).multiplyScalar(Math.max(t, Math.min(e, n)));
    }
    floor() {
        return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this.w = Math.floor(this.w), this;
    }
    ceil() {
        return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this.w = Math.ceil(this.w), this;
    }
    round() {
        return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this.w = Math.round(this.w), this;
    }
    roundToZero() {
        return this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x), this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y), this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z), this.w = this.w < 0 ? Math.ceil(this.w) : Math.floor(this.w), this;
    }
    negate() {
        return this.x = -this.x, this.y = -this.y, this.z = -this.z, this.w = -this.w, this;
    }
    dot(t) {
        return this.x * t.x + this.y * t.y + this.z * t.z + this.w * t.w;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    setLength(t) {
        return this.normalize().multiplyScalar(t);
    }
    lerp(t, e) {
        return this.x += (t.x - this.x) * e, this.y += (t.y - this.y) * e, this.z += (t.z - this.z) * e, this.w += (t.w - this.w) * e, this;
    }
    lerpVectors(t, e, n) {
        return this.x = t.x + (e.x - t.x) * n, this.y = t.y + (e.y - t.y) * n, this.z = t.z + (e.z - t.z) * n, this.w = t.w + (e.w - t.w) * n, this;
    }
    equals(t) {
        return t.x === this.x && t.y === this.y && t.z === this.z && t.w === this.w;
    }
    fromArray(t, e = 0) {
        return this.x = t[e], this.y = t[e + 1], this.z = t[e + 2], this.w = t[e + 3], this;
    }
    toArray(t = [], e = 0) {
        return t[e] = this.x, t[e + 1] = this.y, t[e + 2] = this.z, t[e + 3] = this.w, t;
    }
    fromBufferAttribute(t, e) {
        return this.x = t.getX(e), this.y = t.getY(e), this.z = t.getZ(e), this.w = t.getW(e), this;
    }
    random() {
        return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this.w = Math.random(), this;
    }
    *[Symbol.iterator]() {
        yield this.x, yield this.y, yield this.z, yield this.w;
    }
}, st = class extends Ht {
    constructor(t = 1, e = 1, n = {}){
        super(), this.isWebGLRenderTarget = !0, this.width = t, this.height = e, this.depth = 1, this.scissor = new Ze(0, 0, t, e), this.scissorTest = !1, this.viewport = new Ze(0, 0, t, e);
        let i = {
            width: t,
            height: e,
            depth: 1
        };
        this.texture = new Vt(i, n.mapping, n.wrapS, n.wrapT, n.magFilter, n.minFilter, n.format, n.type, n.anisotropy, n.encoding), this.texture.isRenderTargetTexture = !0, this.texture.flipY = !1, this.texture.generateMipmaps = n.generateMipmaps !== void 0 ? n.generateMipmaps : !1, this.texture.internalFormat = n.internalFormat !== void 0 ? n.internalFormat : null, this.texture.minFilter = n.minFilter !== void 0 ? n.minFilter : Qe, this.depthBuffer = n.depthBuffer !== void 0 ? n.depthBuffer : !0, this.stencilBuffer = n.stencilBuffer !== void 0 ? n.stencilBuffer : !1, this.depthTexture = n.depthTexture !== void 0 ? n.depthTexture : null, this.samples = n.samples !== void 0 ? n.samples : 0;
    }
    setSize(t, e, n = 1) {
        (this.width !== t || this.height !== e || this.depth !== n) && (this.width = t, this.height = e, this.depth = n, this.texture.image.width = t, this.texture.image.height = e, this.texture.image.depth = n, this.dispose()), this.viewport.set(0, 0, t, e), this.scissor.set(0, 0, t, e);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(t) {
        this.width = t.width, this.height = t.height, this.depth = t.depth, this.viewport.copy(t.viewport), this.texture = t.texture.clone(), this.texture.isRenderTargetTexture = !0;
        let e = Object.assign({}, t.texture.image);
        return this.texture.source = new Up(e), this.depthBuffer = t.depthBuffer, this.stencilBuffer = t.stencilBuffer, t.depthTexture !== null && (this.depthTexture = t.depthTexture.clone()), this.samples = t.samples, this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
}, kp = class extends Vt {
    constructor(t = null, e = 1, n = 1, i = 1){
        super(null), this.isDataArrayTexture = !0, this.image = {
            data: t,
            width: e,
            height: n,
            depth: i
        }, this.magFilter = _t, this.minFilter = _t, this.wrapR = Gt, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
    }
};
var zp = class extends Vt {
    constructor(t = null, e = 1, n = 1, i = 1){
        super(null), this.isData3DTexture = !0, this.image = {
            data: t,
            width: e,
            height: n,
            depth: i
        }, this.magFilter = _t, this.minFilter = _t, this.wrapR = Gt, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
    }
};
var Gp = class extends st {
    constructor(t = 1, e = 1, n = 1, i = {}){
        super(t, e, i), this.isWebGLMultipleRenderTargets = !0;
        let s = this.texture;
        this.texture = [];
        for(let o = 0; o < n; o++)this.texture[o] = s.clone(), this.texture[o].isRenderTargetTexture = !0;
    }
    setSize(t, e, n = 1) {
        if (this.width !== t || this.height !== e || this.depth !== n) {
            this.width = t, this.height = e, this.depth = n;
            for(let i = 0, s = this.texture.length; i < s; i++)this.texture[i].image.width = t, this.texture[i].image.height = e, this.texture[i].image.depth = n;
            this.dispose();
        }
        return this.viewport.set(0, 0, t, e), this.scissor.set(0, 0, t, e), this;
    }
    copy(t) {
        this.dispose(), this.width = t.width, this.height = t.height, this.depth = t.depth, this.viewport.set(0, 0, this.width, this.height), this.scissor.set(0, 0, this.width, this.height), this.depthBuffer = t.depthBuffer, this.stencilBuffer = t.stencilBuffer, t.depthTexture !== null && (this.depthTexture = t.depthTexture.clone()), this.texture.length = 0;
        for(let e = 0, n = t.texture.length; e < n; e++)this.texture[e] = t.texture[e].clone(), this.texture[e].isRenderTargetTexture = !0;
        return this;
    }
}, Je = class {
    constructor(t = 0, e = 0, n = 0, i = 1){
        this.isQuaternion = !0, this._x = t, this._y = e, this._z = n, this._w = i;
    }
    static slerpFlat(t, e, n, i, s, o, a) {
        let l = n[i + 0], u = n[i + 1], c = n[i + 2], d = n[i + 3], h = s[o + 0], f = s[o + 1], m = s[o + 2], p = s[o + 3];
        if (a === 0) {
            t[e + 0] = l, t[e + 1] = u, t[e + 2] = c, t[e + 3] = d;
            return;
        }
        if (a === 1) {
            t[e + 0] = h, t[e + 1] = f, t[e + 2] = m, t[e + 3] = p;
            return;
        }
        if (d !== p || l !== h || u !== f || c !== m) {
            let g = 1 - a, y = l * h + u * f + c * m + d * p, v = y >= 0 ? 1 : -1, x = 1 - y * y;
            if (x > Number.EPSILON) {
                let S = Math.sqrt(x), _ = Math.atan2(S, y * v);
                g = Math.sin(g * _) / S, a = Math.sin(a * _) / S;
            }
            let w = a * v;
            if (l = l * g + h * w, u = u * g + f * w, c = c * g + m * w, d = d * g + p * w, g === 1 - a) {
                let S = 1 / Math.sqrt(l * l + u * u + c * c + d * d);
                l *= S, u *= S, c *= S, d *= S;
            }
        }
        t[e] = l, t[e + 1] = u, t[e + 2] = c, t[e + 3] = d;
    }
    static multiplyQuaternionsFlat(t, e, n, i, s, o) {
        let a = n[i], l = n[i + 1], u = n[i + 2], c = n[i + 3], d = s[o], h = s[o + 1], f = s[o + 2], m = s[o + 3];
        return t[e] = a * m + c * d + l * f - u * h, t[e + 1] = l * m + c * h + u * d - a * f, t[e + 2] = u * m + c * f + a * h - l * d, t[e + 3] = c * m - a * d - l * h - u * f, t;
    }
    get x() {
        return this._x;
    }
    set x(t) {
        this._x = t, this._onChangeCallback();
    }
    get y() {
        return this._y;
    }
    set y(t) {
        this._y = t, this._onChangeCallback();
    }
    get z() {
        return this._z;
    }
    set z(t) {
        this._z = t, this._onChangeCallback();
    }
    get w() {
        return this._w;
    }
    set w(t) {
        this._w = t, this._onChangeCallback();
    }
    set(t, e, n, i) {
        return this._x = t, this._y = e, this._z = n, this._w = i, this._onChangeCallback(), this;
    }
    clone() {
        return new this.constructor(this._x, this._y, this._z, this._w);
    }
    copy(t) {
        return this._x = t.x, this._y = t.y, this._z = t.z, this._w = t.w, this._onChangeCallback(), this;
    }
    setFromEuler(t, e) {
        let n = t._x, i = t._y, s = t._z, o = t._order, a = Math.cos, l = Math.sin, u = a(n / 2), c = a(i / 2), d = a(s / 2), h = l(n / 2), f = l(i / 2), m = l(s / 2);
        switch(o){
            case "XYZ":
                this._x = h * c * d + u * f * m, this._y = u * f * d - h * c * m, this._z = u * c * m + h * f * d, this._w = u * c * d - h * f * m;
                break;
            case "YXZ":
                this._x = h * c * d + u * f * m, this._y = u * f * d - h * c * m, this._z = u * c * m - h * f * d, this._w = u * c * d + h * f * m;
                break;
            case "ZXY":
                this._x = h * c * d - u * f * m, this._y = u * f * d + h * c * m, this._z = u * c * m + h * f * d, this._w = u * c * d - h * f * m;
                break;
            case "ZYX":
                this._x = h * c * d - u * f * m, this._y = u * f * d + h * c * m, this._z = u * c * m - h * f * d, this._w = u * c * d + h * f * m;
                break;
            case "YZX":
                this._x = h * c * d + u * f * m, this._y = u * f * d + h * c * m, this._z = u * c * m - h * f * d, this._w = u * c * d - h * f * m;
                break;
            case "XZY":
                this._x = h * c * d - u * f * m, this._y = u * f * d - h * c * m, this._z = u * c * m + h * f * d, this._w = u * c * d + h * f * m;
                break;
            default:
                console.warn("THREE.Quaternion: .setFromEuler() encountered an unknown order: " + o);
        }
        return e !== !1 && this._onChangeCallback(), this;
    }
    setFromAxisAngle(t, e) {
        let n = e / 2, i = Math.sin(n);
        return this._x = t.x * i, this._y = t.y * i, this._z = t.z * i, this._w = Math.cos(n), this._onChangeCallback(), this;
    }
    setFromRotationMatrix(t) {
        let e = t.elements, n = e[0], i = e[4], s = e[8], o = e[1], a = e[5], l = e[9], u = e[2], c = e[6], d = e[10], h = n + a + d;
        if (h > 0) {
            let f = .5 / Math.sqrt(h + 1);
            this._w = .25 / f, this._x = (c - l) * f, this._y = (s - u) * f, this._z = (o - i) * f;
        } else if (n > a && n > d) {
            let f = 2 * Math.sqrt(1 + n - a - d);
            this._w = (c - l) / f, this._x = .25 * f, this._y = (i + o) / f, this._z = (s + u) / f;
        } else if (a > d) {
            let f = 2 * Math.sqrt(1 + a - n - d);
            this._w = (s - u) / f, this._x = (i + o) / f, this._y = .25 * f, this._z = (l + c) / f;
        } else {
            let f = 2 * Math.sqrt(1 + d - n - a);
            this._w = (o - i) / f, this._x = (s + u) / f, this._y = (l + c) / f, this._z = .25 * f;
        }
        return this._onChangeCallback(), this;
    }
    setFromUnitVectors(t, e) {
        let n = t.dot(e) + 1;
        return n < Number.EPSILON ? (n = 0, Math.abs(t.x) > Math.abs(t.z) ? (this._x = -t.y, this._y = t.x, this._z = 0, this._w = n) : (this._x = 0, this._y = -t.z, this._z = t.y, this._w = n)) : (this._x = t.y * e.z - t.z * e.y, this._y = t.z * e.x - t.x * e.z, this._z = t.x * e.y - t.y * e.x, this._w = n), this.normalize();
    }
    angleTo(t) {
        return 2 * Math.acos(Math.abs(zn(this.dot(t), -1, 1)));
    }
    rotateTowards(t, e) {
        let n = this.angleTo(t);
        if (n === 0) return this;
        let i = Math.min(1, e / n);
        return this.slerp(t, i), this;
    }
    identity() {
        return this.set(0, 0, 0, 1);
    }
    invert() {
        return this.conjugate();
    }
    conjugate() {
        return this._x *= -1, this._y *= -1, this._z *= -1, this._onChangeCallback(), this;
    }
    dot(t) {
        return this._x * t._x + this._y * t._y + this._z * t._z + this._w * t._w;
    }
    lengthSq() {
        return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
    }
    length() {
        return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
    }
    normalize() {
        let t = this.length();
        return t === 0 ? (this._x = 0, this._y = 0, this._z = 0, this._w = 1) : (t = 1 / t, this._x = this._x * t, this._y = this._y * t, this._z = this._z * t, this._w = this._w * t), this._onChangeCallback(), this;
    }
    multiply(t) {
        return this.multiplyQuaternions(this, t);
    }
    premultiply(t) {
        return this.multiplyQuaternions(t, this);
    }
    multiplyQuaternions(t, e) {
        let n = t._x, i = t._y, s = t._z, o = t._w, a = e._x, l = e._y, u = e._z, c = e._w;
        return this._x = n * c + o * a + i * u - s * l, this._y = i * c + o * l + s * a - n * u, this._z = s * c + o * u + n * l - i * a, this._w = o * c - n * a - i * l - s * u, this._onChangeCallback(), this;
    }
    slerp(t, e) {
        if (e === 0) return this;
        if (e === 1) return this.copy(t);
        let n = this._x, i = this._y, s = this._z, o = this._w, a = o * t._w + n * t._x + i * t._y + s * t._z;
        if (a < 0 ? (this._w = -t._w, this._x = -t._x, this._y = -t._y, this._z = -t._z, a = -a) : this.copy(t), a >= 1) return this._w = o, this._x = n, this._y = i, this._z = s, this;
        let l = 1 - a * a;
        if (l <= Number.EPSILON) {
            let f = 1 - e;
            return this._w = f * o + e * this._w, this._x = f * n + e * this._x, this._y = f * i + e * this._y, this._z = f * s + e * this._z, this.normalize(), this._onChangeCallback(), this;
        }
        let u = Math.sqrt(l), c = Math.atan2(u, a), d = Math.sin((1 - e) * c) / u, h = Math.sin(e * c) / u;
        return this._w = o * d + this._w * h, this._x = n * d + this._x * h, this._y = i * d + this._y * h, this._z = s * d + this._z * h, this._onChangeCallback(), this;
    }
    slerpQuaternions(t, e, n) {
        return this.copy(t).slerp(e, n);
    }
    random() {
        let t = Math.random(), e = Math.sqrt(1 - t), n = Math.sqrt(t), i = 2 * Math.PI * Math.random(), s = 2 * Math.PI * Math.random();
        return this.set(e * Math.cos(i), n * Math.sin(s), n * Math.cos(s), e * Math.sin(i));
    }
    equals(t) {
        return t._x === this._x && t._y === this._y && t._z === this._z && t._w === this._w;
    }
    fromArray(t, e = 0) {
        return this._x = t[e], this._y = t[e + 1], this._z = t[e + 2], this._w = t[e + 3], this._onChangeCallback(), this;
    }
    toArray(t = [], e = 0) {
        return t[e] = this._x, t[e + 1] = this._y, t[e + 2] = this._z, t[e + 3] = this._w, t;
    }
    fromBufferAttribute(t, e) {
        return this._x = t.getX(e), this._y = t.getY(e), this._z = t.getZ(e), this._w = t.getW(e), this;
    }
    _onChange(t) {
        return this._onChangeCallback = t, this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
        yield this._x, yield this._y, yield this._z, yield this._w;
    }
}, A = class {
    constructor(t = 0, e = 0, n = 0){
        A.prototype.isVector3 = !0, this.x = t, this.y = e, this.z = n;
    }
    set(t, e, n) {
        return n === void 0 && (n = this.z), this.x = t, this.y = e, this.z = n, this;
    }
    setScalar(t) {
        return this.x = t, this.y = t, this.z = t, this;
    }
    setX(t) {
        return this.x = t, this;
    }
    setY(t) {
        return this.y = t, this;
    }
    setZ(t) {
        return this.z = t, this;
    }
    setComponent(t, e) {
        switch(t){
            case 0:
                this.x = e;
                break;
            case 1:
                this.y = e;
                break;
            case 2:
                this.z = e;
                break;
            default:
                throw new Error("index is out of range: " + t);
        }
        return this;
    }
    getComponent(t) {
        switch(t){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            default:
                throw new Error("index is out of range: " + t);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y, this.z);
    }
    copy(t) {
        return this.x = t.x, this.y = t.y, this.z = t.z, this;
    }
    add(t) {
        return this.x += t.x, this.y += t.y, this.z += t.z, this;
    }
    addScalar(t) {
        return this.x += t, this.y += t, this.z += t, this;
    }
    addVectors(t, e) {
        return this.x = t.x + e.x, this.y = t.y + e.y, this.z = t.z + e.z, this;
    }
    addScaledVector(t, e) {
        return this.x += t.x * e, this.y += t.y * e, this.z += t.z * e, this;
    }
    sub(t) {
        return this.x -= t.x, this.y -= t.y, this.z -= t.z, this;
    }
    subScalar(t) {
        return this.x -= t, this.y -= t, this.z -= t, this;
    }
    subVectors(t, e) {
        return this.x = t.x - e.x, this.y = t.y - e.y, this.z = t.z - e.z, this;
    }
    multiply(t) {
        return this.x *= t.x, this.y *= t.y, this.z *= t.z, this;
    }
    multiplyScalar(t) {
        return this.x *= t, this.y *= t, this.z *= t, this;
    }
    multiplyVectors(t, e) {
        return this.x = t.x * e.x, this.y = t.y * e.y, this.z = t.z * e.z, this;
    }
    applyEuler(t) {
        return this.applyQuaternion(M1.setFromEuler(t));
    }
    applyAxisAngle(t, e) {
        return this.applyQuaternion(M1.setFromAxisAngle(t, e));
    }
    applyMatrix3(t) {
        let e = this.x, n = this.y, i = this.z, s = t.elements;
        return this.x = s[0] * e + s[3] * n + s[6] * i, this.y = s[1] * e + s[4] * n + s[7] * i, this.z = s[2] * e + s[5] * n + s[8] * i, this;
    }
    applyNormalMatrix(t) {
        return this.applyMatrix3(t).normalize();
    }
    applyMatrix4(t) {
        let e = this.x, n = this.y, i = this.z, s = t.elements, o = 1 / (s[3] * e + s[7] * n + s[11] * i + s[15]);
        return this.x = (s[0] * e + s[4] * n + s[8] * i + s[12]) * o, this.y = (s[1] * e + s[5] * n + s[9] * i + s[13]) * o, this.z = (s[2] * e + s[6] * n + s[10] * i + s[14]) * o, this;
    }
    applyQuaternion(t) {
        let e = this.x, n = this.y, i = this.z, s = t.x, o = t.y, a = t.z, l = t.w, u = l * e + o * i - a * n, c = l * n + a * e - s * i, d = l * i + s * n - o * e, h = -s * e - o * n - a * i;
        return this.x = u * l + h * -s + c * -a - d * -o, this.y = c * l + h * -o + d * -s - u * -a, this.z = d * l + h * -a + u * -o - c * -s, this;
    }
    project(t) {
        return this.applyMatrix4(t.matrixWorldInverse).applyMatrix4(t.projectionMatrix);
    }
    unproject(t) {
        return this.applyMatrix4(t.projectionMatrixInverse).applyMatrix4(t.matrixWorld);
    }
    transformDirection(t) {
        let e = this.x, n = this.y, i = this.z, s = t.elements;
        return this.x = s[0] * e + s[4] * n + s[8] * i, this.y = s[1] * e + s[5] * n + s[9] * i, this.z = s[2] * e + s[6] * n + s[10] * i, this.normalize();
    }
    divide(t) {
        return this.x /= t.x, this.y /= t.y, this.z /= t.z, this;
    }
    divideScalar(t) {
        return this.multiplyScalar(1 / t);
    }
    min(t) {
        return this.x = Math.min(this.x, t.x), this.y = Math.min(this.y, t.y), this.z = Math.min(this.z, t.z), this;
    }
    max(t) {
        return this.x = Math.max(this.x, t.x), this.y = Math.max(this.y, t.y), this.z = Math.max(this.z, t.z), this;
    }
    clamp(t, e) {
        return this.x = Math.max(t.x, Math.min(e.x, this.x)), this.y = Math.max(t.y, Math.min(e.y, this.y)), this.z = Math.max(t.z, Math.min(e.z, this.z)), this;
    }
    clampScalar(t, e) {
        return this.x = Math.max(t, Math.min(e, this.x)), this.y = Math.max(t, Math.min(e, this.y)), this.z = Math.max(t, Math.min(e, this.z)), this;
    }
    clampLength(t, e) {
        let n = this.length();
        return this.divideScalar(n || 1).multiplyScalar(Math.max(t, Math.min(e, n)));
    }
    floor() {
        return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this;
    }
    ceil() {
        return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this;
    }
    round() {
        return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this;
    }
    roundToZero() {
        return this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x), this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y), this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z), this;
    }
    negate() {
        return this.x = -this.x, this.y = -this.y, this.z = -this.z, this;
    }
    dot(t) {
        return this.x * t.x + this.y * t.y + this.z * t.z;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    setLength(t) {
        return this.normalize().multiplyScalar(t);
    }
    lerp(t, e) {
        return this.x += (t.x - this.x) * e, this.y += (t.y - this.y) * e, this.z += (t.z - this.z) * e, this;
    }
    lerpVectors(t, e, n) {
        return this.x = t.x + (e.x - t.x) * n, this.y = t.y + (e.y - t.y) * n, this.z = t.z + (e.z - t.z) * n, this;
    }
    cross(t) {
        return this.crossVectors(this, t);
    }
    crossVectors(t, e) {
        let n = t.x, i = t.y, s = t.z, o = e.x, a = e.y, l = e.z;
        return this.x = i * l - s * a, this.y = s * o - n * l, this.z = n * a - i * o, this;
    }
    projectOnVector(t) {
        let e = t.lengthSq();
        if (e === 0) return this.set(0, 0, 0);
        let n = t.dot(this) / e;
        return this.copy(t).multiplyScalar(n);
    }
    projectOnPlane(t) {
        return Gv.copy(this).projectOnVector(t), this.sub(Gv);
    }
    reflect(t) {
        return this.sub(Gv.copy(t).multiplyScalar(2 * this.dot(t)));
    }
    angleTo(t) {
        let e = Math.sqrt(this.lengthSq() * t.lengthSq());
        if (e === 0) return Math.PI / 2;
        let n = this.dot(t) / e;
        return Math.acos(zn(n, -1, 1));
    }
    distanceTo(t) {
        return Math.sqrt(this.distanceToSquared(t));
    }
    distanceToSquared(t) {
        let e = this.x - t.x, n = this.y - t.y, i = this.z - t.z;
        return e * e + n * n + i * i;
    }
    manhattanDistanceTo(t) {
        return Math.abs(this.x - t.x) + Math.abs(this.y - t.y) + Math.abs(this.z - t.z);
    }
    setFromSpherical(t) {
        return this.setFromSphericalCoords(t.radius, t.phi, t.theta);
    }
    setFromSphericalCoords(t, e, n) {
        let i = Math.sin(e) * t;
        return this.x = i * Math.sin(n), this.y = Math.cos(e) * t, this.z = i * Math.cos(n), this;
    }
    setFromCylindrical(t) {
        return this.setFromCylindricalCoords(t.radius, t.theta, t.y);
    }
    setFromCylindricalCoords(t, e, n) {
        return this.x = t * Math.sin(e), this.y = n, this.z = t * Math.cos(e), this;
    }
    setFromMatrixPosition(t) {
        let e = t.elements;
        return this.x = e[12], this.y = e[13], this.z = e[14], this;
    }
    setFromMatrixScale(t) {
        let e = this.setFromMatrixColumn(t, 0).length(), n = this.setFromMatrixColumn(t, 1).length(), i = this.setFromMatrixColumn(t, 2).length();
        return this.x = e, this.y = n, this.z = i, this;
    }
    setFromMatrixColumn(t, e) {
        return this.fromArray(t.elements, e * 4);
    }
    setFromMatrix3Column(t, e) {
        return this.fromArray(t.elements, e * 3);
    }
    setFromEuler(t) {
        return this.x = t._x, this.y = t._y, this.z = t._z, this;
    }
    equals(t) {
        return t.x === this.x && t.y === this.y && t.z === this.z;
    }
    fromArray(t, e = 0) {
        return this.x = t[e], this.y = t[e + 1], this.z = t[e + 2], this;
    }
    toArray(t = [], e = 0) {
        return t[e] = this.x, t[e + 1] = this.y, t[e + 2] = this.z, t;
    }
    fromBufferAttribute(t, e) {
        return this.x = t.getX(e), this.y = t.getY(e), this.z = t.getZ(e), this;
    }
    random() {
        return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this;
    }
    randomDirection() {
        let t = (Math.random() - .5) * 2, e = Math.random() * Math.PI * 2, n = Math.sqrt(1 - t ** 2);
        return this.x = n * Math.cos(e), this.y = n * Math.sin(e), this.z = t, this;
    }
    *[Symbol.iterator]() {
        yield this.x, yield this.y, yield this.z;
    }
}, Gv = new A, M1 = new Je, Mt = class {
    constructor(t = new A(1 / 0, 1 / 0, 1 / 0), e = new A(-1 / 0, -1 / 0, -1 / 0)){
        this.isBox3 = !0, this.min = t, this.max = e;
    }
    set(t, e) {
        return this.min.copy(t), this.max.copy(e), this;
    }
    setFromArray(t) {
        let e = 1 / 0, n = 1 / 0, i = 1 / 0, s = -1 / 0, o = -1 / 0, a = -1 / 0;
        for(let l = 0, u = t.length; l < u; l += 3){
            let c = t[l], d = t[l + 1], h = t[l + 2];
            c < e && (e = c), d < n && (n = d), h < i && (i = h), c > s && (s = c), d > o && (o = d), h > a && (a = h);
        }
        return this.min.set(e, n, i), this.max.set(s, o, a), this;
    }
    setFromBufferAttribute(t) {
        let e = 1 / 0, n = 1 / 0, i = 1 / 0, s = -1 / 0, o = -1 / 0, a = -1 / 0;
        for(let l = 0, u = t.count; l < u; l++){
            let c = t.getX(l), d = t.getY(l), h = t.getZ(l);
            c < e && (e = c), d < n && (n = d), h < i && (i = h), c > s && (s = c), d > o && (o = d), h > a && (a = h);
        }
        return this.min.set(e, n, i), this.max.set(s, o, a), this;
    }
    setFromPoints(t) {
        this.makeEmpty();
        for(let e = 0, n = t.length; e < n; e++)this.expandByPoint(t[e]);
        return this;
    }
    setFromCenterAndSize(t, e) {
        let n = Na.copy(e).multiplyScalar(.5);
        return this.min.copy(t).sub(n), this.max.copy(t).add(n), this;
    }
    setFromObject(t, e = !1) {
        return this.makeEmpty(), this.expandByObject(t, e);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(t) {
        return this.min.copy(t.min), this.max.copy(t.max), this;
    }
    makeEmpty() {
        return this.min.x = this.min.y = this.min.z = 1 / 0, this.max.x = this.max.y = this.max.z = -1 / 0, this;
    }
    isEmpty() {
        return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
    }
    getCenter(t) {
        return this.isEmpty() ? t.set(0, 0, 0) : t.addVectors(this.min, this.max).multiplyScalar(.5);
    }
    getSize(t) {
        return this.isEmpty() ? t.set(0, 0, 0) : t.subVectors(this.max, this.min);
    }
    expandByPoint(t) {
        return this.min.min(t), this.max.max(t), this;
    }
    expandByVector(t) {
        return this.min.sub(t), this.max.add(t), this;
    }
    expandByScalar(t) {
        return this.min.addScalar(-t), this.max.addScalar(t), this;
    }
    expandByObject(t, e = !1) {
        t.updateWorldMatrix(!1, !1);
        let n = t.geometry;
        if (n !== void 0) {
            if (e && n.attributes != null && n.attributes.position !== void 0) {
                let s = n.attributes.position;
                for(let o = 0, a = s.count; o < a; o++)Na.fromBufferAttribute(s, o).applyMatrix4(t.matrixWorld), this.expandByPoint(Na);
            } else n.boundingBox === null && n.computeBoundingBox(), Vv.copy(n.boundingBox), Vv.applyMatrix4(t.matrixWorld), this.union(Vv);
        }
        let i = t.children;
        for(let s = 0, o = i.length; s < o; s++)this.expandByObject(i[s], e);
        return this;
    }
    containsPoint(t) {
        return !(t.x < this.min.x || t.x > this.max.x || t.y < this.min.y || t.y > this.max.y || t.z < this.min.z || t.z > this.max.z);
    }
    containsBox(t) {
        return this.min.x <= t.min.x && t.max.x <= this.max.x && this.min.y <= t.min.y && t.max.y <= this.max.y && this.min.z <= t.min.z && t.max.z <= this.max.z;
    }
    getParameter(t, e) {
        return e.set((t.x - this.min.x) / (this.max.x - this.min.x), (t.y - this.min.y) / (this.max.y - this.min.y), (t.z - this.min.z) / (this.max.z - this.min.z));
    }
    intersectsBox(t) {
        return !(t.max.x < this.min.x || t.min.x > this.max.x || t.max.y < this.min.y || t.min.y > this.max.y || t.max.z < this.min.z || t.min.z > this.max.z);
    }
    intersectsSphere(t) {
        return this.clampPoint(t.center, Na), Na.distanceToSquared(t.center) <= t.radius * t.radius;
    }
    intersectsPlane(t) {
        let e, n;
        return t.normal.x > 0 ? (e = t.normal.x * this.min.x, n = t.normal.x * this.max.x) : (e = t.normal.x * this.max.x, n = t.normal.x * this.min.x), t.normal.y > 0 ? (e += t.normal.y * this.min.y, n += t.normal.y * this.max.y) : (e += t.normal.y * this.max.y, n += t.normal.y * this.min.y), t.normal.z > 0 ? (e += t.normal.z * this.min.z, n += t.normal.z * this.max.z) : (e += t.normal.z * this.max.z, n += t.normal.z * this.min.z), e <= -t.constant && n >= -t.constant;
    }
    intersectsTriangle(t) {
        if (this.isEmpty()) return !1;
        this.getCenter($d), lp.subVectors(this.max, $d), Hl.subVectors(t.a, $d), Wl.subVectors(t.b, $d), jl.subVectors(t.c, $d), Bo.subVectors(Wl, Hl), Fo.subVectors(jl, Wl), Ba.subVectors(Hl, jl);
        let e = [
            0,
            -Bo.z,
            Bo.y,
            0,
            -Fo.z,
            Fo.y,
            0,
            -Ba.z,
            Ba.y,
            Bo.z,
            0,
            -Bo.x,
            Fo.z,
            0,
            -Fo.x,
            Ba.z,
            0,
            -Ba.x,
            -Bo.y,
            Bo.x,
            0,
            -Fo.y,
            Fo.x,
            0,
            -Ba.y,
            Ba.x,
            0
        ];
        return !Hv(e, Hl, Wl, jl, lp) || (e = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ], !Hv(e, Hl, Wl, jl, lp)) ? !1 : (cp.crossVectors(Bo, Fo), e = [
            cp.x,
            cp.y,
            cp.z
        ], Hv(e, Hl, Wl, jl, lp));
    }
    clampPoint(t, e) {
        return e.copy(t).clamp(this.min, this.max);
    }
    distanceToPoint(t) {
        return Na.copy(t).clamp(this.min, this.max).sub(t).length();
    }
    getBoundingSphere(t) {
        return this.getCenter(t.center), t.radius = this.getSize(Na).length() * .5, t;
    }
    intersect(t) {
        return this.min.max(t.min), this.max.min(t.max), this.isEmpty() && this.makeEmpty(), this;
    }
    union(t) {
        return this.min.min(t.min), this.max.max(t.max), this;
    }
    applyMatrix4(t) {
        return this.isEmpty() ? this : (Ks[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(t), Ks[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(t), Ks[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(t), Ks[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(t), Ks[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(t), Ks[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(t), Ks[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(t), Ks[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(t), this.setFromPoints(Ks), this);
    }
    translate(t) {
        return this.min.add(t), this.max.add(t), this;
    }
    equals(t) {
        return t.min.equals(this.min) && t.max.equals(this.max);
    }
}, Ks = [
    new A,
    new A,
    new A,
    new A,
    new A,
    new A,
    new A,
    new A
], Na = new A, Vv = new Mt, Hl = new A, Wl = new A, jl = new A, Bo = new A, Fo = new A, Ba = new A, $d = new A, lp = new A, cp = new A, Fa = new A;
function Hv(r1, t, e, n, i) {
    for(let s = 0, o = r1.length - 3; s <= o; s += 3){
        Fa.fromArray(r1, s);
        let a = i.x * Math.abs(Fa.x) + i.y * Math.abs(Fa.y) + i.z * Math.abs(Fa.z), l = t.dot(Fa), u = e.dot(Fa), c = n.dot(Fa);
        if (Math.max(-Math.max(l, u, c), Math.min(l, u, c)) > a) return !1;
    }
    return !0;
}
var JO = new Mt, eh = new A, Wv = new A, Rn = class {
    constructor(t = new A, e = -1){
        this.center = t, this.radius = e;
    }
    set(t, e) {
        return this.center.copy(t), this.radius = e, this;
    }
    setFromPoints(t, e) {
        let n = this.center;
        e !== void 0 ? n.copy(e) : JO.setFromPoints(t).getCenter(n);
        let i = 0;
        for(let s = 0, o = t.length; s < o; s++)i = Math.max(i, n.distanceToSquared(t[s]));
        return this.radius = Math.sqrt(i), this;
    }
    copy(t) {
        return this.center.copy(t.center), this.radius = t.radius, this;
    }
    isEmpty() {
        return this.radius < 0;
    }
    makeEmpty() {
        return this.center.set(0, 0, 0), this.radius = -1, this;
    }
    containsPoint(t) {
        return t.distanceToSquared(this.center) <= this.radius * this.radius;
    }
    distanceToPoint(t) {
        return t.distanceTo(this.center) - this.radius;
    }
    intersectsSphere(t) {
        let e = this.radius + t.radius;
        return t.center.distanceToSquared(this.center) <= e * e;
    }
    intersectsBox(t) {
        return t.intersectsSphere(this);
    }
    intersectsPlane(t) {
        return Math.abs(t.distanceToPoint(this.center)) <= this.radius;
    }
    clampPoint(t, e) {
        let n = this.center.distanceToSquared(t);
        return e.copy(t), n > this.radius * this.radius && (e.sub(this.center).normalize(), e.multiplyScalar(this.radius).add(this.center)), e;
    }
    getBoundingBox(t) {
        return this.isEmpty() ? (t.makeEmpty(), t) : (t.set(this.center, this.center), t.expandByScalar(this.radius), t);
    }
    applyMatrix4(t) {
        return this.center.applyMatrix4(t), this.radius = this.radius * t.getMaxScaleOnAxis(), this;
    }
    translate(t) {
        return this.center.add(t), this;
    }
    expandByPoint(t) {
        if (this.isEmpty()) return this.center.copy(t), this.radius = 0, this;
        eh.subVectors(t, this.center);
        let e = eh.lengthSq();
        if (e > this.radius * this.radius) {
            let n = Math.sqrt(e), i = (n - this.radius) * .5;
            this.center.addScaledVector(eh, i / n), this.radius += i;
        }
        return this;
    }
    union(t) {
        return t.isEmpty() ? this : this.isEmpty() ? (this.copy(t), this) : (this.center.equals(t.center) === !0 ? this.radius = Math.max(this.radius, t.radius) : (Wv.subVectors(t.center, this.center).setLength(t.radius), this.expandByPoint(eh.copy(t.center).add(Wv)), this.expandByPoint(eh.copy(t.center).sub(Wv))), this);
    }
    equals(t) {
        return t.center.equals(this.center) && t.radius === this.radius;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}, Zs = new A, jv = new A, up = new A, Uo = new A, qv = new A, dp = new A, Xv = new A, Fi = class {
    constructor(t = new A, e = new A(0, 0, -1)){
        this.origin = t, this.direction = e;
    }
    set(t, e) {
        return this.origin.copy(t), this.direction.copy(e), this;
    }
    copy(t) {
        return this.origin.copy(t.origin), this.direction.copy(t.direction), this;
    }
    at(t, e) {
        return e.copy(this.direction).multiplyScalar(t).add(this.origin);
    }
    lookAt(t) {
        return this.direction.copy(t).sub(this.origin).normalize(), this;
    }
    recast(t) {
        return this.origin.copy(this.at(t, Zs)), this;
    }
    closestPointToPoint(t, e) {
        e.subVectors(t, this.origin);
        let n = e.dot(this.direction);
        return n < 0 ? e.copy(this.origin) : e.copy(this.direction).multiplyScalar(n).add(this.origin);
    }
    distanceToPoint(t) {
        return Math.sqrt(this.distanceSqToPoint(t));
    }
    distanceSqToPoint(t) {
        let e = Zs.subVectors(t, this.origin).dot(this.direction);
        return e < 0 ? this.origin.distanceToSquared(t) : (Zs.copy(this.direction).multiplyScalar(e).add(this.origin), Zs.distanceToSquared(t));
    }
    distanceSqToSegment(t, e, n, i) {
        jv.copy(t).add(e).multiplyScalar(.5), up.copy(e).sub(t).normalize(), Uo.copy(this.origin).sub(jv);
        let s = t.distanceTo(e) * .5, o = -this.direction.dot(up), a = Uo.dot(this.direction), l = -Uo.dot(up), u = Uo.lengthSq(), c = Math.abs(1 - o * o), d, h, f, m;
        if (c > 0) {
            if (d = o * l - a, h = o * a - l, m = s * c, d >= 0) {
                if (h >= -m) {
                    if (h <= m) {
                        let p = 1 / c;
                        d *= p, h *= p, f = d * (d + o * h + 2 * a) + h * (o * d + h + 2 * l) + u;
                    } else h = s, d = Math.max(0, -(o * h + a)), f = -d * d + h * (h + 2 * l) + u;
                } else h = -s, d = Math.max(0, -(o * h + a)), f = -d * d + h * (h + 2 * l) + u;
            } else h <= -m ? (d = Math.max(0, -(-o * s + a)), h = d > 0 ? -s : Math.min(Math.max(-s, -l), s), f = -d * d + h * (h + 2 * l) + u) : h <= m ? (d = 0, h = Math.min(Math.max(-s, -l), s), f = h * (h + 2 * l) + u) : (d = Math.max(0, -(o * s + a)), h = d > 0 ? s : Math.min(Math.max(-s, -l), s), f = -d * d + h * (h + 2 * l) + u);
        } else h = o > 0 ? -s : s, d = Math.max(0, -(o * h + a)), f = -d * d + h * (h + 2 * l) + u;
        return n && n.copy(this.direction).multiplyScalar(d).add(this.origin), i && i.copy(up).multiplyScalar(h).add(jv), f;
    }
    intersectSphere(t, e) {
        Zs.subVectors(t.center, this.origin);
        let n = Zs.dot(this.direction), i = Zs.dot(Zs) - n * n, s = t.radius * t.radius;
        if (i > s) return null;
        let o = Math.sqrt(s - i), a = n - o, l = n + o;
        return a < 0 && l < 0 ? null : a < 0 ? this.at(l, e) : this.at(a, e);
    }
    intersectsSphere(t) {
        return this.distanceSqToPoint(t.center) <= t.radius * t.radius;
    }
    distanceToPlane(t) {
        let e = t.normal.dot(this.direction);
        if (e === 0) return t.distanceToPoint(this.origin) === 0 ? 0 : null;
        let n = -(this.origin.dot(t.normal) + t.constant) / e;
        return n >= 0 ? n : null;
    }
    intersectPlane(t, e) {
        let n = this.distanceToPlane(t);
        return n === null ? null : this.at(n, e);
    }
    intersectsPlane(t) {
        let e = t.distanceToPoint(this.origin);
        return e === 0 || t.normal.dot(this.direction) * e < 0;
    }
    intersectBox(t, e) {
        let n, i, s, o, a, l, u = 1 / this.direction.x, c = 1 / this.direction.y, d = 1 / this.direction.z, h = this.origin;
        return u >= 0 ? (n = (t.min.x - h.x) * u, i = (t.max.x - h.x) * u) : (n = (t.max.x - h.x) * u, i = (t.min.x - h.x) * u), c >= 0 ? (s = (t.min.y - h.y) * c, o = (t.max.y - h.y) * c) : (s = (t.max.y - h.y) * c, o = (t.min.y - h.y) * c), n > o || s > i || ((s > n || isNaN(n)) && (n = s), (o < i || isNaN(i)) && (i = o), d >= 0 ? (a = (t.min.z - h.z) * d, l = (t.max.z - h.z) * d) : (a = (t.max.z - h.z) * d, l = (t.min.z - h.z) * d), n > l || a > i) || ((a > n || n !== n) && (n = a), (l < i || i !== i) && (i = l), i < 0) ? null : this.at(n >= 0 ? n : i, e);
    }
    intersectsBox(t) {
        return this.intersectBox(t, Zs) !== null;
    }
    intersectTriangle(t, e, n, i, s) {
        qv.subVectors(e, t), dp.subVectors(n, t), Xv.crossVectors(qv, dp);
        let o = this.direction.dot(Xv), a;
        if (o > 0) {
            if (i) return null;
            a = 1;
        } else if (o < 0) a = -1, o = -o;
        else return null;
        Uo.subVectors(this.origin, t);
        let l = a * this.direction.dot(dp.crossVectors(Uo, dp));
        if (l < 0) return null;
        let u = a * this.direction.dot(qv.cross(Uo));
        if (u < 0 || l + u > o) return null;
        let c = -a * Uo.dot(Xv);
        return c < 0 ? null : this.at(c / o, s);
    }
    applyMatrix4(t) {
        return this.origin.applyMatrix4(t), this.direction.transformDirection(t), this;
    }
    equals(t) {
        return t.origin.equals(this.origin) && t.direction.equals(this.direction);
    }
    clone() {
        return new this.constructor().copy(this);
    }
}, ae = class {
    constructor(){
        ae.prototype.isMatrix4 = !0, this.elements = [
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1
        ];
    }
    set(t, e, n, i, s, o, a, l, u, c, d, h, f, m, p, g) {
        let y = this.elements;
        return y[0] = t, y[4] = e, y[8] = n, y[12] = i, y[1] = s, y[5] = o, y[9] = a, y[13] = l, y[2] = u, y[6] = c, y[10] = d, y[14] = h, y[3] = f, y[7] = m, y[11] = p, y[15] = g, this;
    }
    identity() {
        return this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this;
    }
    clone() {
        return new ae().fromArray(this.elements);
    }
    copy(t) {
        let e = this.elements, n = t.elements;
        return e[0] = n[0], e[1] = n[1], e[2] = n[2], e[3] = n[3], e[4] = n[4], e[5] = n[5], e[6] = n[6], e[7] = n[7], e[8] = n[8], e[9] = n[9], e[10] = n[10], e[11] = n[11], e[12] = n[12], e[13] = n[13], e[14] = n[14], e[15] = n[15], this;
    }
    copyPosition(t) {
        let e = this.elements, n = t.elements;
        return e[12] = n[12], e[13] = n[13], e[14] = n[14], this;
    }
    setFromMatrix3(t) {
        let e = t.elements;
        return this.set(e[0], e[3], e[6], 0, e[1], e[4], e[7], 0, e[2], e[5], e[8], 0, 0, 0, 0, 1), this;
    }
    extractBasis(t, e, n) {
        return t.setFromMatrixColumn(this, 0), e.setFromMatrixColumn(this, 1), n.setFromMatrixColumn(this, 2), this;
    }
    makeBasis(t, e, n) {
        return this.set(t.x, e.x, n.x, 0, t.y, e.y, n.y, 0, t.z, e.z, n.z, 0, 0, 0, 0, 1), this;
    }
    extractRotation(t) {
        let e = this.elements, n = t.elements, i = 1 / ql.setFromMatrixColumn(t, 0).length(), s = 1 / ql.setFromMatrixColumn(t, 1).length(), o = 1 / ql.setFromMatrixColumn(t, 2).length();
        return e[0] = n[0] * i, e[1] = n[1] * i, e[2] = n[2] * i, e[3] = 0, e[4] = n[4] * s, e[5] = n[5] * s, e[6] = n[6] * s, e[7] = 0, e[8] = n[8] * o, e[9] = n[9] * o, e[10] = n[10] * o, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, this;
    }
    makeRotationFromEuler(t) {
        let e = this.elements, n = t.x, i = t.y, s = t.z, o = Math.cos(n), a = Math.sin(n), l = Math.cos(i), u = Math.sin(i), c = Math.cos(s), d = Math.sin(s);
        if (t.order === "XYZ") {
            let h = o * c, f = o * d, m = a * c, p = a * d;
            e[0] = l * c, e[4] = -l * d, e[8] = u, e[1] = f + m * u, e[5] = h - p * u, e[9] = -a * l, e[2] = p - h * u, e[6] = m + f * u, e[10] = o * l;
        } else if (t.order === "YXZ") {
            let h = l * c, f = l * d, m = u * c, p = u * d;
            e[0] = h + p * a, e[4] = m * a - f, e[8] = o * u, e[1] = o * d, e[5] = o * c, e[9] = -a, e[2] = f * a - m, e[6] = p + h * a, e[10] = o * l;
        } else if (t.order === "ZXY") {
            let h = l * c, f = l * d, m = u * c, p = u * d;
            e[0] = h - p * a, e[4] = -o * d, e[8] = m + f * a, e[1] = f + m * a, e[5] = o * c, e[9] = p - h * a, e[2] = -o * u, e[6] = a, e[10] = o * l;
        } else if (t.order === "ZYX") {
            let h = o * c, f = o * d, m = a * c, p = a * d;
            e[0] = l * c, e[4] = m * u - f, e[8] = h * u + p, e[1] = l * d, e[5] = p * u + h, e[9] = f * u - m, e[2] = -u, e[6] = a * l, e[10] = o * l;
        } else if (t.order === "YZX") {
            let h = o * l, f = o * u, m = a * l, p = a * u;
            e[0] = l * c, e[4] = p - h * d, e[8] = m * d + f, e[1] = d, e[5] = o * c, e[9] = -a * c, e[2] = -u * c, e[6] = f * d + m, e[10] = h - p * d;
        } else if (t.order === "XZY") {
            let h = o * l, f = o * u, m = a * l, p = a * u;
            e[0] = l * c, e[4] = -d, e[8] = u * c, e[1] = h * d + p, e[5] = o * c, e[9] = f * d - m, e[2] = m * d - f, e[6] = a * c, e[10] = p * d + h;
        }
        return e[3] = 0, e[7] = 0, e[11] = 0, e[12] = 0, e[13] = 0, e[14] = 0, e[15] = 1, this;
    }
    makeRotationFromQuaternion(t) {
        return this.compose($O, t, eR);
    }
    lookAt(t, e, n) {
        let i = this.elements;
        return ri.subVectors(t, e), ri.lengthSq() === 0 && (ri.z = 1), ri.normalize(), ko.crossVectors(n, ri), ko.lengthSq() === 0 && (Math.abs(n.z) === 1 ? ri.x += 1e-4 : ri.z += 1e-4, ri.normalize(), ko.crossVectors(n, ri)), ko.normalize(), hp.crossVectors(ri, ko), i[0] = ko.x, i[4] = hp.x, i[8] = ri.x, i[1] = ko.y, i[5] = hp.y, i[9] = ri.y, i[2] = ko.z, i[6] = hp.z, i[10] = ri.z, this;
    }
    multiply(t) {
        return this.multiplyMatrices(this, t);
    }
    premultiply(t) {
        return this.multiplyMatrices(t, this);
    }
    multiplyMatrices(t, e) {
        let n = t.elements, i = e.elements, s = this.elements, o = n[0], a = n[4], l = n[8], u = n[12], c = n[1], d = n[5], h = n[9], f = n[13], m = n[2], p = n[6], g = n[10], y = n[14], v = n[3], x = n[7], w = n[11], S = n[15], _ = i[0], M = i[4], b = i[8], T = i[12], E = i[1], P = i[5], D = i[9], C = i[13], O = i[2], B = i[6], V = i[10], Y = i[14], W = i[3], q = i[7], j = i[11], X = i[15];
        return s[0] = o * _ + a * E + l * O + u * W, s[4] = o * M + a * P + l * B + u * q, s[8] = o * b + a * D + l * V + u * j, s[12] = o * T + a * C + l * Y + u * X, s[1] = c * _ + d * E + h * O + f * W, s[5] = c * M + d * P + h * B + f * q, s[9] = c * b + d * D + h * V + f * j, s[13] = c * T + d * C + h * Y + f * X, s[2] = m * _ + p * E + g * O + y * W, s[6] = m * M + p * P + g * B + y * q, s[10] = m * b + p * D + g * V + y * j, s[14] = m * T + p * C + g * Y + y * X, s[3] = v * _ + x * E + w * O + S * W, s[7] = v * M + x * P + w * B + S * q, s[11] = v * b + x * D + w * V + S * j, s[15] = v * T + x * C + w * Y + S * X, this;
    }
    multiplyScalar(t) {
        let e = this.elements;
        return e[0] *= t, e[4] *= t, e[8] *= t, e[12] *= t, e[1] *= t, e[5] *= t, e[9] *= t, e[13] *= t, e[2] *= t, e[6] *= t, e[10] *= t, e[14] *= t, e[3] *= t, e[7] *= t, e[11] *= t, e[15] *= t, this;
    }
    determinant() {
        let t = this.elements, e = t[0], n = t[4], i = t[8], s = t[12], o = t[1], a = t[5], l = t[9], u = t[13], c = t[2], d = t[6], h = t[10], f = t[14], m = t[3], p = t[7], g = t[11], y = t[15];
        return m * (+s * l * d - i * u * d - s * a * h + n * u * h + i * a * f - n * l * f) + p * (+e * l * f - e * u * h + s * o * h - i * o * f + i * u * c - s * l * c) + g * (+e * u * d - e * a * f - s * o * d + n * o * f + s * a * c - n * u * c) + y * (-i * a * c - e * l * d + e * a * h + i * o * d - n * o * h + n * l * c);
    }
    transpose() {
        let t = this.elements, e;
        return e = t[1], t[1] = t[4], t[4] = e, e = t[2], t[2] = t[8], t[8] = e, e = t[6], t[6] = t[9], t[9] = e, e = t[3], t[3] = t[12], t[12] = e, e = t[7], t[7] = t[13], t[13] = e, e = t[11], t[11] = t[14], t[14] = e, this;
    }
    setPosition(t, e, n) {
        let i = this.elements;
        return t.isVector3 ? (i[12] = t.x, i[13] = t.y, i[14] = t.z) : (i[12] = t, i[13] = e, i[14] = n), this;
    }
    invert() {
        let t = this.elements, e = t[0], n = t[1], i = t[2], s = t[3], o = t[4], a = t[5], l = t[6], u = t[7], c = t[8], d = t[9], h = t[10], f = t[11], m = t[12], p = t[13], g = t[14], y = t[15], v = d * g * u - p * h * u + p * l * f - a * g * f - d * l * y + a * h * y, x = m * h * u - c * g * u - m * l * f + o * g * f + c * l * y - o * h * y, w = c * p * u - m * d * u + m * a * f - o * p * f - c * a * y + o * d * y, S = m * d * l - c * p * l - m * a * h + o * p * h + c * a * g - o * d * g, _ = e * v + n * x + i * w + s * S;
        if (_ === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
        let M = 1 / _;
        return t[0] = v * M, t[1] = (p * h * s - d * g * s - p * i * f + n * g * f + d * i * y - n * h * y) * M, t[2] = (a * g * s - p * l * s + p * i * u - n * g * u - a * i * y + n * l * y) * M, t[3] = (d * l * s - a * h * s - d * i * u + n * h * u + a * i * f - n * l * f) * M, t[4] = x * M, t[5] = (c * g * s - m * h * s + m * i * f - e * g * f - c * i * y + e * h * y) * M, t[6] = (m * l * s - o * g * s - m * i * u + e * g * u + o * i * y - e * l * y) * M, t[7] = (o * h * s - c * l * s + c * i * u - e * h * u - o * i * f + e * l * f) * M, t[8] = w * M, t[9] = (m * d * s - c * p * s - m * n * f + e * p * f + c * n * y - e * d * y) * M, t[10] = (o * p * s - m * a * s + m * n * u - e * p * u - o * n * y + e * a * y) * M, t[11] = (c * a * s - o * d * s - c * n * u + e * d * u + o * n * f - e * a * f) * M, t[12] = S * M, t[13] = (c * p * i - m * d * i + m * n * h - e * p * h - c * n * g + e * d * g) * M, t[14] = (m * a * i - o * p * i - m * n * l + e * p * l + o * n * g - e * a * g) * M, t[15] = (o * d * i - c * a * i + c * n * l - e * d * l - o * n * h + e * a * h) * M, this;
    }
    scale(t) {
        let e = this.elements, n = t.x, i = t.y, s = t.z;
        return e[0] *= n, e[4] *= i, e[8] *= s, e[1] *= n, e[5] *= i, e[9] *= s, e[2] *= n, e[6] *= i, e[10] *= s, e[3] *= n, e[7] *= i, e[11] *= s, this;
    }
    getMaxScaleOnAxis() {
        let t = this.elements, e = t[0] * t[0] + t[1] * t[1] + t[2] * t[2], n = t[4] * t[4] + t[5] * t[5] + t[6] * t[6], i = t[8] * t[8] + t[9] * t[9] + t[10] * t[10];
        return Math.sqrt(Math.max(e, n, i));
    }
    makeTranslation(t, e, n) {
        return this.set(1, 0, 0, t, 0, 1, 0, e, 0, 0, 1, n, 0, 0, 0, 1), this;
    }
    makeRotationX(t) {
        let e = Math.cos(t), n = Math.sin(t);
        return this.set(1, 0, 0, 0, 0, e, -n, 0, 0, n, e, 0, 0, 0, 0, 1), this;
    }
    makeRotationY(t) {
        let e = Math.cos(t), n = Math.sin(t);
        return this.set(e, 0, n, 0, 0, 1, 0, 0, -n, 0, e, 0, 0, 0, 0, 1), this;
    }
    makeRotationZ(t) {
        let e = Math.cos(t), n = Math.sin(t);
        return this.set(e, -n, 0, 0, n, e, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this;
    }
    makeRotationAxis(t, e) {
        let n = Math.cos(e), i = Math.sin(e), s = 1 - n, o = t.x, a = t.y, l = t.z, u = s * o, c = s * a;
        return this.set(u * o + n, u * a - i * l, u * l + i * a, 0, u * a + i * l, c * a + n, c * l - i * o, 0, u * l - i * a, c * l + i * o, s * l * l + n, 0, 0, 0, 0, 1), this;
    }
    makeScale(t, e, n) {
        return this.set(t, 0, 0, 0, 0, e, 0, 0, 0, 0, n, 0, 0, 0, 0, 1), this;
    }
    makeShear(t, e, n, i, s, o) {
        return this.set(1, n, s, 0, t, 1, o, 0, e, i, 1, 0, 0, 0, 0, 1), this;
    }
    compose(t, e, n) {
        let i = this.elements, s = e._x, o = e._y, a = e._z, l = e._w, u = s + s, c = o + o, d = a + a, h = s * u, f = s * c, m = s * d, p = o * c, g = o * d, y = a * d, v = l * u, x = l * c, w = l * d, S = n.x, _ = n.y, M = n.z;
        return i[0] = (1 - (p + y)) * S, i[1] = (f + w) * S, i[2] = (m - x) * S, i[3] = 0, i[4] = (f - w) * _, i[5] = (1 - (h + y)) * _, i[6] = (g + v) * _, i[7] = 0, i[8] = (m + x) * M, i[9] = (g - v) * M, i[10] = (1 - (h + p)) * M, i[11] = 0, i[12] = t.x, i[13] = t.y, i[14] = t.z, i[15] = 1, this;
    }
    decompose(t, e, n) {
        let i = this.elements, s = ql.set(i[0], i[1], i[2]).length(), o = ql.set(i[4], i[5], i[6]).length(), a = ql.set(i[8], i[9], i[10]).length();
        this.determinant() < 0 && (s = -s), t.x = i[12], t.y = i[13], t.z = i[14], Li.copy(this);
        let u = 1 / s, c = 1 / o, d = 1 / a;
        return Li.elements[0] *= u, Li.elements[1] *= u, Li.elements[2] *= u, Li.elements[4] *= c, Li.elements[5] *= c, Li.elements[6] *= c, Li.elements[8] *= d, Li.elements[9] *= d, Li.elements[10] *= d, e.setFromRotationMatrix(Li), n.x = s, n.y = o, n.z = a, this;
    }
    makePerspective(t, e, n, i, s, o) {
        let a = this.elements, l = 2 * s / (e - t), u = 2 * s / (n - i), c = (e + t) / (e - t), d = (n + i) / (n - i), h = -(o + s) / (o - s), f = -2 * o * s / (o - s);
        return a[0] = l, a[4] = 0, a[8] = c, a[12] = 0, a[1] = 0, a[5] = u, a[9] = d, a[13] = 0, a[2] = 0, a[6] = 0, a[10] = h, a[14] = f, a[3] = 0, a[7] = 0, a[11] = -1, a[15] = 0, this;
    }
    makeOrthographic(t, e, n, i, s, o) {
        let a = this.elements, l = 1 / (e - t), u = 1 / (n - i), c = 1 / (o - s), d = (e + t) * l, h = (n + i) * u, f = (o + s) * c;
        return a[0] = 2 * l, a[4] = 0, a[8] = 0, a[12] = -d, a[1] = 0, a[5] = 2 * u, a[9] = 0, a[13] = -h, a[2] = 0, a[6] = 0, a[10] = -2 * c, a[14] = -f, a[3] = 0, a[7] = 0, a[11] = 0, a[15] = 1, this;
    }
    equals(t) {
        let e = this.elements, n = t.elements;
        for(let i = 0; i < 16; i++)if (e[i] !== n[i]) return !1;
        return !0;
    }
    fromArray(t, e = 0) {
        for(let n = 0; n < 16; n++)this.elements[n] = t[n + e];
        return this;
    }
    toArray(t = [], e = 0) {
        let n = this.elements;
        return t[e] = n[0], t[e + 1] = n[1], t[e + 2] = n[2], t[e + 3] = n[3], t[e + 4] = n[4], t[e + 5] = n[5], t[e + 6] = n[6], t[e + 7] = n[7], t[e + 8] = n[8], t[e + 9] = n[9], t[e + 10] = n[10], t[e + 11] = n[11], t[e + 12] = n[12], t[e + 13] = n[13], t[e + 14] = n[14], t[e + 15] = n[15], t;
    }
}, ql = new A, Li = new ae, $O = new A(0, 0, 0), eR = new A(1, 1, 1), ko = new A, hp = new A, ri = new A, T1 = new ae, E1 = new Je, Wt = class {
    constructor(t = 0, e = 0, n = 0, i = Wt.DEFAULT_ORDER){
        this.isEuler = !0, this._x = t, this._y = e, this._z = n, this._order = i;
    }
    get x() {
        return this._x;
    }
    set x(t) {
        this._x = t, this._onChangeCallback();
    }
    get y() {
        return this._y;
    }
    set y(t) {
        this._y = t, this._onChangeCallback();
    }
    get z() {
        return this._z;
    }
    set z(t) {
        this._z = t, this._onChangeCallback();
    }
    get order() {
        return this._order;
    }
    set order(t) {
        this._order = t, this._onChangeCallback();
    }
    set(t, e, n, i = this._order) {
        return this._x = t, this._y = e, this._z = n, this._order = i, this._onChangeCallback(), this;
    }
    clone() {
        return new this.constructor(this._x, this._y, this._z, this._order);
    }
    copy(t) {
        return this._x = t._x, this._y = t._y, this._z = t._z, this._order = t._order, this._onChangeCallback(), this;
    }
    setFromRotationMatrix(t, e = this._order, n = !0) {
        let i = t.elements, s = i[0], o = i[4], a = i[8], l = i[1], u = i[5], c = i[9], d = i[2], h = i[6], f = i[10];
        switch(e){
            case "XYZ":
                this._y = Math.asin(zn(a, -1, 1)), Math.abs(a) < .9999999 ? (this._x = Math.atan2(-c, f), this._z = Math.atan2(-o, s)) : (this._x = Math.atan2(h, u), this._z = 0);
                break;
            case "YXZ":
                this._x = Math.asin(-zn(c, -1, 1)), Math.abs(c) < .9999999 ? (this._y = Math.atan2(a, f), this._z = Math.atan2(l, u)) : (this._y = Math.atan2(-d, s), this._z = 0);
                break;
            case "ZXY":
                this._x = Math.asin(zn(h, -1, 1)), Math.abs(h) < .9999999 ? (this._y = Math.atan2(-d, f), this._z = Math.atan2(-o, u)) : (this._y = 0, this._z = Math.atan2(l, s));
                break;
            case "ZYX":
                this._y = Math.asin(-zn(d, -1, 1)), Math.abs(d) < .9999999 ? (this._x = Math.atan2(h, f), this._z = Math.atan2(l, s)) : (this._x = 0, this._z = Math.atan2(-o, u));
                break;
            case "YZX":
                this._z = Math.asin(zn(l, -1, 1)), Math.abs(l) < .9999999 ? (this._x = Math.atan2(-c, u), this._y = Math.atan2(-d, s)) : (this._x = 0, this._y = Math.atan2(a, f));
                break;
            case "XZY":
                this._z = Math.asin(-zn(o, -1, 1)), Math.abs(o) < .9999999 ? (this._x = Math.atan2(h, u), this._y = Math.atan2(a, s)) : (this._x = Math.atan2(-c, f), this._y = 0);
                break;
            default:
                console.warn("THREE.Euler: .setFromRotationMatrix() encountered an unknown order: " + e);
        }
        return this._order = e, n === !0 && this._onChangeCallback(), this;
    }
    setFromQuaternion(t, e, n) {
        return T1.makeRotationFromQuaternion(t), this.setFromRotationMatrix(T1, e, n);
    }
    setFromVector3(t, e = this._order) {
        return this.set(t.x, t.y, t.z, e);
    }
    reorder(t) {
        return E1.setFromEuler(this), this.setFromQuaternion(E1, t);
    }
    equals(t) {
        return t._x === this._x && t._y === this._y && t._z === this._z && t._order === this._order;
    }
    fromArray(t) {
        return this._x = t[0], this._y = t[1], this._z = t[2], t[3] !== void 0 && (this._order = t[3]), this._onChangeCallback(), this;
    }
    toArray(t = [], e = 0) {
        return t[e] = this._x, t[e + 1] = this._y, t[e + 2] = this._z, t[e + 3] = this._order, t;
    }
    _onChange(t) {
        return this._onChangeCallback = t, this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
        yield this._x, yield this._y, yield this._z, yield this._order;
    }
};
Wt.DEFAULT_ORDER = "XYZ";
var gh = class {
    constructor(){
        this.mask = 1;
    }
    set(t) {
        this.mask = (1 << t | 0) >>> 0;
    }
    enable(t) {
        this.mask |= 1 << t | 0;
    }
    enableAll() {
        this.mask = -1;
    }
    toggle(t) {
        this.mask ^= 1 << t | 0;
    }
    disable(t) {
        this.mask &= ~(1 << t | 0);
    }
    disableAll() {
        this.mask = 0;
    }
    test(t) {
        return (this.mask & t.mask) !== 0;
    }
    isEnabled(t) {
        return (this.mask & (1 << t | 0)) !== 0;
    }
}, tR = 0, C1 = new A, Xl = new Je, Js = new ae, fp = new A, th = new A, nR = new A, rR = new Je, P1 = new A(1, 0, 0), D1 = new A(0, 1, 0), I1 = new A(0, 0, 1), iR = {
    type: "added"
}, O1 = {
    type: "removed"
}, pt = class extends Ht {
    constructor(){
        super(), this.isObject3D = !0, Object.defineProperty(this, "id", {
            value: tR++
        }), this.uuid = gs(), this.name = "", this.type = "Object3D", this.parent = null, this.children = [], this.up = pt.DEFAULT_UP.clone();
        let t = new A, e = new Wt, n = new Je, i = new A(1, 1, 1);
        function s() {
            n.setFromEuler(e, !1);
        }
        function o() {
            e.setFromQuaternion(n, void 0, !1);
        }
        e._onChange(s), n._onChange(o), Object.defineProperties(this, {
            position: {
                configurable: !0,
                enumerable: !0,
                value: t
            },
            rotation: {
                configurable: !0,
                enumerable: !0,
                value: e
            },
            quaternion: {
                configurable: !0,
                enumerable: !0,
                value: n
            },
            scale: {
                configurable: !0,
                enumerable: !0,
                value: i
            },
            modelViewMatrix: {
                value: new ae
            },
            normalMatrix: {
                value: new Kt
            }
        }), this.matrix = new ae, this.matrixWorld = new ae, this.matrixAutoUpdate = pt.DEFAULT_MATRIX_AUTO_UPDATE, this.matrixWorldNeedsUpdate = !1, this.matrixWorldAutoUpdate = pt.DEFAULT_MATRIX_WORLD_AUTO_UPDATE, this.layers = new gh, this.visible = !0, this.castShadow = !1, this.receiveShadow = !1, this.frustumCulled = !0, this.renderOrder = 0, this.animations = [], this.userData = {};
    }
    onBeforeRender() {}
    onAfterRender() {}
    applyMatrix4(t) {
        this.matrixAutoUpdate && this.updateMatrix(), this.matrix.premultiply(t), this.matrix.decompose(this.position, this.quaternion, this.scale);
    }
    applyQuaternion(t) {
        return this.quaternion.premultiply(t), this;
    }
    setRotationFromAxisAngle(t, e) {
        this.quaternion.setFromAxisAngle(t, e);
    }
    setRotationFromEuler(t) {
        this.quaternion.setFromEuler(t, !0);
    }
    setRotationFromMatrix(t) {
        this.quaternion.setFromRotationMatrix(t);
    }
    setRotationFromQuaternion(t) {
        this.quaternion.copy(t);
    }
    rotateOnAxis(t, e) {
        return Xl.setFromAxisAngle(t, e), this.quaternion.multiply(Xl), this;
    }
    rotateOnWorldAxis(t, e) {
        return Xl.setFromAxisAngle(t, e), this.quaternion.premultiply(Xl), this;
    }
    rotateX(t) {
        return this.rotateOnAxis(P1, t);
    }
    rotateY(t) {
        return this.rotateOnAxis(D1, t);
    }
    rotateZ(t) {
        return this.rotateOnAxis(I1, t);
    }
    translateOnAxis(t, e) {
        return C1.copy(t).applyQuaternion(this.quaternion), this.position.add(C1.multiplyScalar(e)), this;
    }
    translateX(t) {
        return this.translateOnAxis(P1, t);
    }
    translateY(t) {
        return this.translateOnAxis(D1, t);
    }
    translateZ(t) {
        return this.translateOnAxis(I1, t);
    }
    localToWorld(t) {
        return this.updateWorldMatrix(!0, !1), t.applyMatrix4(this.matrixWorld);
    }
    worldToLocal(t) {
        return this.updateWorldMatrix(!0, !1), t.applyMatrix4(Js.copy(this.matrixWorld).invert());
    }
    lookAt(t, e, n) {
        t.isVector3 ? fp.copy(t) : fp.set(t, e, n);
        let i = this.parent;
        this.updateWorldMatrix(!0, !1), th.setFromMatrixPosition(this.matrixWorld), this.isCamera || this.isLight ? Js.lookAt(th, fp, this.up) : Js.lookAt(fp, th, this.up), this.quaternion.setFromRotationMatrix(Js), i && (Js.extractRotation(i.matrixWorld), Xl.setFromRotationMatrix(Js), this.quaternion.premultiply(Xl.invert()));
    }
    add(t) {
        if (arguments.length > 1) {
            for(let e = 0; e < arguments.length; e++)this.add(arguments[e]);
            return this;
        }
        return t === this ? (console.error("THREE.Object3D.add: object can't be added as a child of itself.", t), this) : (t && t.isObject3D ? (t.parent !== null && t.parent.remove(t), t.parent = this, this.children.push(t), t.dispatchEvent(iR)) : console.error("THREE.Object3D.add: object not an instance of THREE.Object3D.", t), this);
    }
    remove(t) {
        if (arguments.length > 1) {
            for(let n = 0; n < arguments.length; n++)this.remove(arguments[n]);
            return this;
        }
        let e = this.children.indexOf(t);
        return e !== -1 && (t.parent = null, this.children.splice(e, 1), t.dispatchEvent(O1)), this;
    }
    removeFromParent() {
        let t = this.parent;
        return t !== null && t.remove(this), this;
    }
    clear() {
        for(let t = 0; t < this.children.length; t++){
            let e = this.children[t];
            e.parent = null, e.dispatchEvent(O1);
        }
        return this.children.length = 0, this;
    }
    attach(t) {
        return this.updateWorldMatrix(!0, !1), Js.copy(this.matrixWorld).invert(), t.parent !== null && (t.parent.updateWorldMatrix(!0, !1), Js.multiply(t.parent.matrixWorld)), t.applyMatrix4(Js), this.add(t), t.updateWorldMatrix(!1, !0), this;
    }
    getObjectById(t) {
        return this.getObjectByProperty("id", t);
    }
    getObjectByName(t) {
        return this.getObjectByProperty("name", t);
    }
    getObjectByProperty(t, e) {
        if (this[t] === e) return this;
        for(let n = 0, i = this.children.length; n < i; n++){
            let o = this.children[n].getObjectByProperty(t, e);
            if (o !== void 0) return o;
        }
    }
    getObjectsByProperty(t, e) {
        let n = [];
        this[t] === e && n.push(this);
        for(let i = 0, s = this.children.length; i < s; i++){
            let o = this.children[i].getObjectsByProperty(t, e);
            o.length > 0 && (n = n.concat(o));
        }
        return n;
    }
    getWorldPosition(t) {
        return this.updateWorldMatrix(!0, !1), t.setFromMatrixPosition(this.matrixWorld);
    }
    getWorldQuaternion(t) {
        return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose(th, t, nR), t;
    }
    getWorldScale(t) {
        return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose(th, rR, t), t;
    }
    getWorldDirection(t) {
        this.updateWorldMatrix(!0, !1);
        let e = this.matrixWorld.elements;
        return t.set(e[8], e[9], e[10]).normalize();
    }
    raycast() {}
    traverse(t) {
        t(this);
        let e = this.children;
        for(let n = 0, i = e.length; n < i; n++)e[n].traverse(t);
    }
    traverseVisible(t) {
        if (this.visible === !1) return;
        t(this);
        let e = this.children;
        for(let n = 0, i = e.length; n < i; n++)e[n].traverseVisible(t);
    }
    traverseAncestors(t) {
        let e = this.parent;
        e !== null && (t(e), e.traverseAncestors(t));
    }
    updateMatrix() {
        this.matrix.compose(this.position, this.quaternion, this.scale), this.matrixWorldNeedsUpdate = !0;
    }
    updateMatrixWorld(t) {
        this.matrixAutoUpdate && this.updateMatrix(), (this.matrixWorldNeedsUpdate || t) && (this.parent === null ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix), this.matrixWorldNeedsUpdate = !1, t = !0);
        let e = this.children;
        for(let n = 0, i = e.length; n < i; n++){
            let s = e[n];
            (s.matrixWorldAutoUpdate === !0 || t === !0) && s.updateMatrixWorld(t);
        }
    }
    updateWorldMatrix(t, e) {
        let n = this.parent;
        if (t === !0 && n !== null && n.matrixWorldAutoUpdate === !0 && n.updateWorldMatrix(!0, !1), this.matrixAutoUpdate && this.updateMatrix(), this.parent === null ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix), e === !0) {
            let i = this.children;
            for(let s = 0, o = i.length; s < o; s++){
                let a = i[s];
                a.matrixWorldAutoUpdate === !0 && a.updateWorldMatrix(!1, !0);
            }
        }
    }
    toJSON(t) {
        let e = t === void 0 || typeof t == "string", n = {};
        e && (t = {
            geometries: {},
            materials: {},
            textures: {},
            images: {},
            shapes: {},
            skeletons: {},
            animations: {},
            nodes: {}
        }, n.metadata = {
            version: 4.5,
            type: "Object",
            generator: "Object3D.toJSON"
        });
        let i = {};
        i.uuid = this.uuid, i.type = this.type, this.name !== "" && (i.name = this.name), this.castShadow === !0 && (i.castShadow = !0), this.receiveShadow === !0 && (i.receiveShadow = !0), this.visible === !1 && (i.visible = !1), this.frustumCulled === !1 && (i.frustumCulled = !1), this.renderOrder !== 0 && (i.renderOrder = this.renderOrder), Object.keys(this.userData).length > 0 && (i.userData = this.userData), i.layers = this.layers.mask, i.matrix = this.matrix.toArray(), this.matrixAutoUpdate === !1 && (i.matrixAutoUpdate = !1), this.isInstancedMesh && (i.type = "InstancedMesh", i.count = this.count, i.instanceMatrix = this.instanceMatrix.toJSON(), this.instanceColor !== null && (i.instanceColor = this.instanceColor.toJSON()));
        function s(a, l) {
            return a[l.uuid] === void 0 && (a[l.uuid] = l.toJSON(t)), l.uuid;
        }
        if (this.isScene) this.background && (this.background.isColor ? i.background = this.background.toJSON() : this.background.isTexture && (i.background = this.background.toJSON(t).uuid)), this.environment && this.environment.isTexture && this.environment.isRenderTargetTexture !== !0 && (i.environment = this.environment.toJSON(t).uuid);
        else if (this.isMesh || this.isLine || this.isPoints) {
            i.geometry = s(t.geometries, this.geometry);
            let a = this.geometry.parameters;
            if (a !== void 0 && a.shapes !== void 0) {
                let l = a.shapes;
                if (Array.isArray(l)) for(let u = 0, c = l.length; u < c; u++){
                    let d = l[u];
                    s(t.shapes, d);
                }
                else s(t.shapes, l);
            }
        }
        if (this.isSkinnedMesh && (i.bindMode = this.bindMode, i.bindMatrix = this.bindMatrix.toArray(), this.skeleton !== void 0 && (s(t.skeletons, this.skeleton), i.skeleton = this.skeleton.uuid)), this.material !== void 0) {
            if (Array.isArray(this.material)) {
                let a = [];
                for(let l = 0, u = this.material.length; l < u; l++)a.push(s(t.materials, this.material[l]));
                i.material = a;
            } else i.material = s(t.materials, this.material);
        }
        if (this.children.length > 0) {
            i.children = [];
            for(let a = 0; a < this.children.length; a++)i.children.push(this.children[a].toJSON(t).object);
        }
        if (this.animations.length > 0) {
            i.animations = [];
            for(let a = 0; a < this.animations.length; a++){
                let l = this.animations[a];
                i.animations.push(s(t.animations, l));
            }
        }
        if (e) {
            let a = o(t.geometries), l = o(t.materials), u = o(t.textures), c = o(t.images), d = o(t.shapes), h = o(t.skeletons), f = o(t.animations), m = o(t.nodes);
            a.length > 0 && (n.geometries = a), l.length > 0 && (n.materials = l), u.length > 0 && (n.textures = u), c.length > 0 && (n.images = c), d.length > 0 && (n.shapes = d), h.length > 0 && (n.skeletons = h), f.length > 0 && (n.animations = f), m.length > 0 && (n.nodes = m);
        }
        return n.object = i, n;
        function o(a) {
            let l = [];
            for(let u in a){
                let c = a[u];
                delete c.metadata, l.push(c);
            }
            return l;
        }
    }
    clone(t) {
        return new this.constructor().copy(this, t);
    }
    copy(t, e = !0) {
        if (this.name = t.name, this.up.copy(t.up), this.position.copy(t.position), this.rotation.order = t.rotation.order, this.quaternion.copy(t.quaternion), this.scale.copy(t.scale), this.matrix.copy(t.matrix), this.matrixWorld.copy(t.matrixWorld), this.matrixAutoUpdate = t.matrixAutoUpdate, this.matrixWorldNeedsUpdate = t.matrixWorldNeedsUpdate, this.matrixWorldAutoUpdate = t.matrixWorldAutoUpdate, this.layers.mask = t.layers.mask, this.visible = t.visible, this.castShadow = t.castShadow, this.receiveShadow = t.receiveShadow, this.frustumCulled = t.frustumCulled, this.renderOrder = t.renderOrder, this.userData = JSON.parse(JSON.stringify(t.userData)), e === !0) for(let n = 0; n < t.children.length; n++){
            let i = t.children[n];
            this.add(i.clone());
        }
        return this;
    }
};
pt.DEFAULT_UP = new A(0, 1, 0);
pt.DEFAULT_MATRIX_AUTO_UPDATE = !0;
pt.DEFAULT_MATRIX_WORLD_AUTO_UPDATE = !0;
var Ni = new A, $s = new A, Yv = new A, eo = new A, Yl = new A, Ql = new A, R1 = new A, Qv = new A, Kv = new A, Zv = new A, an = class {
    constructor(t = new A, e = new A, n = new A){
        this.a = t, this.b = e, this.c = n;
    }
    static getNormal(t, e, n, i) {
        i.subVectors(n, e), Ni.subVectors(t, e), i.cross(Ni);
        let s = i.lengthSq();
        return s > 0 ? i.multiplyScalar(1 / Math.sqrt(s)) : i.set(0, 0, 0);
    }
    static getBarycoord(t, e, n, i, s) {
        Ni.subVectors(i, e), $s.subVectors(n, e), Yv.subVectors(t, e);
        let o = Ni.dot(Ni), a = Ni.dot($s), l = Ni.dot(Yv), u = $s.dot($s), c = $s.dot(Yv), d = o * u - a * a;
        if (d === 0) return s.set(-2, -1, -1);
        let h = 1 / d, f = (u * l - a * c) * h, m = (o * c - a * l) * h;
        return s.set(1 - f - m, m, f);
    }
    static containsPoint(t, e, n, i) {
        return this.getBarycoord(t, e, n, i, eo), eo.x >= 0 && eo.y >= 0 && eo.x + eo.y <= 1;
    }
    static getUV(t, e, n, i, s, o, a, l) {
        return this.getBarycoord(t, e, n, i, eo), l.set(0, 0), l.addScaledVector(s, eo.x), l.addScaledVector(o, eo.y), l.addScaledVector(a, eo.z), l;
    }
    static isFrontFacing(t, e, n, i) {
        return Ni.subVectors(n, e), $s.subVectors(t, e), Ni.cross($s).dot(i) < 0;
    }
    set(t, e, n) {
        return this.a.copy(t), this.b.copy(e), this.c.copy(n), this;
    }
    setFromPointsAndIndices(t, e, n, i) {
        return this.a.copy(t[e]), this.b.copy(t[n]), this.c.copy(t[i]), this;
    }
    setFromAttributeAndIndices(t, e, n, i) {
        return this.a.fromBufferAttribute(t, e), this.b.fromBufferAttribute(t, n), this.c.fromBufferAttribute(t, i), this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(t) {
        return this.a.copy(t.a), this.b.copy(t.b), this.c.copy(t.c), this;
    }
    getArea() {
        return Ni.subVectors(this.c, this.b), $s.subVectors(this.a, this.b), Ni.cross($s).length() * .5;
    }
    getMidpoint(t) {
        return t.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
    }
    getNormal(t) {
        return an.getNormal(this.a, this.b, this.c, t);
    }
    getPlane(t) {
        return t.setFromCoplanarPoints(this.a, this.b, this.c);
    }
    getBarycoord(t, e) {
        return an.getBarycoord(t, this.a, this.b, this.c, e);
    }
    getUV(t, e, n, i, s) {
        return an.getUV(t, this.a, this.b, this.c, e, n, i, s);
    }
    containsPoint(t) {
        return an.containsPoint(t, this.a, this.b, this.c);
    }
    isFrontFacing(t) {
        return an.isFrontFacing(this.a, this.b, this.c, t);
    }
    intersectsBox(t) {
        return t.intersectsTriangle(this);
    }
    closestPointToPoint(t, e) {
        let n = this.a, i = this.b, s = this.c, o, a;
        Yl.subVectors(i, n), Ql.subVectors(s, n), Qv.subVectors(t, n);
        let l = Yl.dot(Qv), u = Ql.dot(Qv);
        if (l <= 0 && u <= 0) return e.copy(n);
        Kv.subVectors(t, i);
        let c = Yl.dot(Kv), d = Ql.dot(Kv);
        if (c >= 0 && d <= c) return e.copy(i);
        let h = l * d - c * u;
        if (h <= 0 && l >= 0 && c <= 0) return o = l / (l - c), e.copy(n).addScaledVector(Yl, o);
        Zv.subVectors(t, s);
        let f = Yl.dot(Zv), m = Ql.dot(Zv);
        if (m >= 0 && f <= m) return e.copy(s);
        let p = f * u - l * m;
        if (p <= 0 && u >= 0 && m <= 0) return a = u / (u - m), e.copy(n).addScaledVector(Ql, a);
        let g = c * m - f * d;
        if (g <= 0 && d - c >= 0 && f - m >= 0) return R1.subVectors(s, i), a = (d - c) / (d - c + (f - m)), e.copy(i).addScaledVector(R1, a);
        let y = 1 / (g + p + h);
        return o = p * y, a = h * y, e.copy(n).addScaledVector(Yl, o).addScaledVector(Ql, a);
    }
    equals(t) {
        return t.a.equals(this.a) && t.b.equals(this.b) && t.c.equals(this.c);
    }
}, sR = 0, Wa = class extends Ht {
    constructor(){
        super(), this.isMaterial = !0, Object.defineProperty(this, "id", {
            value: sR++
        }), this.uuid = gs(), this.name = "", this.type = "Material", this.blending = sc, this.side = si, this.vertexColors = !1, this.opacity = 1, this.transparent = !1, this.blendSrc = SA, this.blendDst = AA, this.blendEquation = nc, this.blendSrcAlpha = null, this.blendDstAlpha = null, this.blendEquationAlpha = null, this.depthFunc = h0, this.depthTest = !0, this.depthWrite = !0, this.stencilWriteMask = 255, this.stencilFunc = NO, this.stencilRef = 0, this.stencilFuncMask = 255, this.stencilFail = Bv, this.stencilZFail = Bv, this.stencilZPass = Bv, this.stencilWrite = !1, this.clippingPlanes = null, this.clipIntersection = !1, this.clipShadows = !1, this.shadowSide = null, this.colorWrite = !0, this.precision = null, this.polygonOffset = !1, this.polygonOffsetFactor = 0, this.polygonOffsetUnits = 0, this.dithering = !1, this.alphaToCoverage = !1, this.premultipliedAlpha = !1, this.forceSinglePass = !1, this.visible = !0, this.toneMapped = !0, this.userData = {}, this.version = 0, this._alphaTest = 0;
    }
    get alphaTest() {
        return this._alphaTest;
    }
    set alphaTest(t) {
        this._alphaTest > 0 != t > 0 && this.version++, this._alphaTest = t;
    }
    onBuild() {}
    onBeforeRender() {}
    onBeforeCompile() {}
    customProgramCacheKey() {
        return this.onBeforeCompile.toString();
    }
    setValues(t) {
        if (t !== void 0) for(let e in t){
            let n = t[e];
            if (n === void 0) {
                console.warn("THREE.Material: '" + e + "' parameter is undefined.");
                continue;
            }
            let i = this[e];
            if (i === void 0) {
                console.warn("THREE." + this.type + ": '" + e + "' is not a property of this material.");
                continue;
            }
            i && i.isColor ? i.set(n) : i && i.isVector3 && n && n.isVector3 ? i.copy(n) : this[e] = n;
        }
    }
    toJSON(t) {
        let e = t === void 0 || typeof t == "string";
        e && (t = {
            textures: {},
            images: {}
        });
        let n = {
            metadata: {
                version: 4.5,
                type: "Material",
                generator: "Material.toJSON"
            }
        };
        n.uuid = this.uuid, n.type = this.type, this.name !== "" && (n.name = this.name), this.color && this.color.isColor && (n.color = this.color.getHex()), this.roughness !== void 0 && (n.roughness = this.roughness), this.metalness !== void 0 && (n.metalness = this.metalness), this.sheen !== void 0 && (n.sheen = this.sheen), this.sheenColor && this.sheenColor.isColor && (n.sheenColor = this.sheenColor.getHex()), this.sheenRoughness !== void 0 && (n.sheenRoughness = this.sheenRoughness), this.emissive && this.emissive.isColor && (n.emissive = this.emissive.getHex()), this.emissiveIntensity && this.emissiveIntensity !== 1 && (n.emissiveIntensity = this.emissiveIntensity), this.specular && this.specular.isColor && (n.specular = this.specular.getHex()), this.specularIntensity !== void 0 && (n.specularIntensity = this.specularIntensity), this.specularColor && this.specularColor.isColor && (n.specularColor = this.specularColor.getHex()), this.shininess !== void 0 && (n.shininess = this.shininess), this.clearcoat !== void 0 && (n.clearcoat = this.clearcoat), this.clearcoatRoughness !== void 0 && (n.clearcoatRoughness = this.clearcoatRoughness), this.clearcoatMap && this.clearcoatMap.isTexture && (n.clearcoatMap = this.clearcoatMap.toJSON(t).uuid), this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture && (n.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(t).uuid), this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture && (n.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(t).uuid, n.clearcoatNormalScale = this.clearcoatNormalScale.toArray()), this.iridescence !== void 0 && (n.iridescence = this.iridescence), this.iridescenceIOR !== void 0 && (n.iridescenceIOR = this.iridescenceIOR), this.iridescenceThicknessRange !== void 0 && (n.iridescenceThicknessRange = this.iridescenceThicknessRange), this.iridescenceMap && this.iridescenceMap.isTexture && (n.iridescenceMap = this.iridescenceMap.toJSON(t).uuid), this.iridescenceThicknessMap && this.iridescenceThicknessMap.isTexture && (n.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON(t).uuid), this.map && this.map.isTexture && (n.map = this.map.toJSON(t).uuid), this.matcap && this.matcap.isTexture && (n.matcap = this.matcap.toJSON(t).uuid), this.alphaMap && this.alphaMap.isTexture && (n.alphaMap = this.alphaMap.toJSON(t).uuid), this.lightMap && this.lightMap.isTexture && (n.lightMap = this.lightMap.toJSON(t).uuid, n.lightMapIntensity = this.lightMapIntensity), this.aoMap && this.aoMap.isTexture && (n.aoMap = this.aoMap.toJSON(t).uuid, n.aoMapIntensity = this.aoMapIntensity), this.bumpMap && this.bumpMap.isTexture && (n.bumpMap = this.bumpMap.toJSON(t).uuid, n.bumpScale = this.bumpScale), this.normalMap && this.normalMap.isTexture && (n.normalMap = this.normalMap.toJSON(t).uuid, n.normalMapType = this.normalMapType, n.normalScale = this.normalScale.toArray()), this.displacementMap && this.displacementMap.isTexture && (n.displacementMap = this.displacementMap.toJSON(t).uuid, n.displacementScale = this.displacementScale, n.displacementBias = this.displacementBias), this.roughnessMap && this.roughnessMap.isTexture && (n.roughnessMap = this.roughnessMap.toJSON(t).uuid), this.metalnessMap && this.metalnessMap.isTexture && (n.metalnessMap = this.metalnessMap.toJSON(t).uuid), this.emissiveMap && this.emissiveMap.isTexture && (n.emissiveMap = this.emissiveMap.toJSON(t).uuid), this.specularMap && this.specularMap.isTexture && (n.specularMap = this.specularMap.toJSON(t).uuid), this.specularIntensityMap && this.specularIntensityMap.isTexture && (n.specularIntensityMap = this.specularIntensityMap.toJSON(t).uuid), this.specularColorMap && this.specularColorMap.isTexture && (n.specularColorMap = this.specularColorMap.toJSON(t).uuid), this.envMap && this.envMap.isTexture && (n.envMap = this.envMap.toJSON(t).uuid, this.combine !== void 0 && (n.combine = this.combine)), this.envMapIntensity !== void 0 && (n.envMapIntensity = this.envMapIntensity), this.reflectivity !== void 0 && (n.reflectivity = this.reflectivity), this.refractionRatio !== void 0 && (n.refractionRatio = this.refractionRatio), this.gradientMap && this.gradientMap.isTexture && (n.gradientMap = this.gradientMap.toJSON(t).uuid), this.transmission !== void 0 && (n.transmission = this.transmission), this.transmissionMap && this.transmissionMap.isTexture && (n.transmissionMap = this.transmissionMap.toJSON(t).uuid), this.thickness !== void 0 && (n.thickness = this.thickness), this.thicknessMap && this.thicknessMap.isTexture && (n.thicknessMap = this.thicknessMap.toJSON(t).uuid), this.attenuationDistance !== void 0 && this.attenuationDistance !== 1 / 0 && (n.attenuationDistance = this.attenuationDistance), this.attenuationColor !== void 0 && (n.attenuationColor = this.attenuationColor.getHex()), this.size !== void 0 && (n.size = this.size), this.shadowSide !== null && (n.shadowSide = this.shadowSide), this.sizeAttenuation !== void 0 && (n.sizeAttenuation = this.sizeAttenuation), this.blending !== sc && (n.blending = this.blending), this.side !== si && (n.side = this.side), this.vertexColors && (n.vertexColors = !0), this.opacity < 1 && (n.opacity = this.opacity), this.transparent === !0 && (n.transparent = this.transparent), n.depthFunc = this.depthFunc, n.depthTest = this.depthTest, n.depthWrite = this.depthWrite, n.colorWrite = this.colorWrite, n.stencilWrite = this.stencilWrite, n.stencilWriteMask = this.stencilWriteMask, n.stencilFunc = this.stencilFunc, n.stencilRef = this.stencilRef, n.stencilFuncMask = this.stencilFuncMask, n.stencilFail = this.stencilFail, n.stencilZFail = this.stencilZFail, n.stencilZPass = this.stencilZPass, this.rotation !== void 0 && this.rotation !== 0 && (n.rotation = this.rotation), this.polygonOffset === !0 && (n.polygonOffset = !0), this.polygonOffsetFactor !== 0 && (n.polygonOffsetFactor = this.polygonOffsetFactor), this.polygonOffsetUnits !== 0 && (n.polygonOffsetUnits = this.polygonOffsetUnits), this.linewidth !== void 0 && this.linewidth !== 1 && (n.linewidth = this.linewidth), this.dashSize !== void 0 && (n.dashSize = this.dashSize), this.gapSize !== void 0 && (n.gapSize = this.gapSize), this.scale !== void 0 && (n.scale = this.scale), this.dithering === !0 && (n.dithering = !0), this.alphaTest > 0 && (n.alphaTest = this.alphaTest), this.alphaToCoverage === !0 && (n.alphaToCoverage = this.alphaToCoverage), this.premultipliedAlpha === !0 && (n.premultipliedAlpha = this.premultipliedAlpha), this.forceSinglePass === !0 && (n.forceSinglePass = this.forceSinglePass), this.wireframe === !0 && (n.wireframe = this.wireframe), this.wireframeLinewidth > 1 && (n.wireframeLinewidth = this.wireframeLinewidth), this.wireframeLinecap !== "round" && (n.wireframeLinecap = this.wireframeLinecap), this.wireframeLinejoin !== "round" && (n.wireframeLinejoin = this.wireframeLinejoin), this.flatShading === !0 && (n.flatShading = this.flatShading), this.visible === !1 && (n.visible = !1), this.toneMapped === !1 && (n.toneMapped = !1), this.fog === !1 && (n.fog = !1), Object.keys(this.userData).length > 0 && (n.userData = this.userData);
        function i(s) {
            let o = [];
            for(let a in s){
                let l = s[a];
                delete l.metadata, o.push(l);
            }
            return o;
        }
        if (e) {
            let s = i(t.textures), o = i(t.images);
            s.length > 0 && (n.textures = s), o.length > 0 && (n.images = o);
        }
        return n;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(t) {
        this.name = t.name, this.blending = t.blending, this.side = t.side, this.vertexColors = t.vertexColors, this.opacity = t.opacity, this.transparent = t.transparent, this.blendSrc = t.blendSrc, this.blendDst = t.blendDst, this.blendEquation = t.blendEquation, this.blendSrcAlpha = t.blendSrcAlpha, this.blendDstAlpha = t.blendDstAlpha, this.blendEquationAlpha = t.blendEquationAlpha, this.depthFunc = t.depthFunc, this.depthTest = t.depthTest, this.depthWrite = t.depthWrite, this.stencilWriteMask = t.stencilWriteMask, this.stencilFunc = t.stencilFunc, this.stencilRef = t.stencilRef, this.stencilFuncMask = t.stencilFuncMask, this.stencilFail = t.stencilFail, this.stencilZFail = t.stencilZFail, this.stencilZPass = t.stencilZPass, this.stencilWrite = t.stencilWrite;
        let e = t.clippingPlanes, n = null;
        if (e !== null) {
            let i = e.length;
            n = new Array(i);
            for(let s = 0; s !== i; ++s)n[s] = e[s].clone();
        }
        return this.clippingPlanes = n, this.clipIntersection = t.clipIntersection, this.clipShadows = t.clipShadows, this.shadowSide = t.shadowSide, this.colorWrite = t.colorWrite, this.precision = t.precision, this.polygonOffset = t.polygonOffset, this.polygonOffsetFactor = t.polygonOffsetFactor, this.polygonOffsetUnits = t.polygonOffsetUnits, this.dithering = t.dithering, this.alphaTest = t.alphaTest, this.alphaToCoverage = t.alphaToCoverage, this.premultipliedAlpha = t.premultipliedAlpha, this.forceSinglePass = t.forceSinglePass, this.visible = t.visible, this.toneMapped = t.toneMapped, this.userData = JSON.parse(JSON.stringify(t.userData)), this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
    set needsUpdate(t) {
        t === !0 && this.version++;
    }
}, Ui = class extends Wa {
    constructor(t){
        super(), this.isMeshBasicMaterial = !0, this.type = "MeshBasicMaterial", this.color = new Ne(16777215), this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.specularMap = null, this.alphaMap = null, this.envMap = null, this.combine = _A, this.reflectivity = 1, this.refractionRatio = .98, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.fog = !0, this.setValues(t);
    }
    copy(t) {
        return super.copy(t), this.color.copy(t.color), this.map = t.map, this.lightMap = t.lightMap, this.lightMapIntensity = t.lightMapIntensity, this.aoMap = t.aoMap, this.aoMapIntensity = t.aoMapIntensity, this.specularMap = t.specularMap, this.alphaMap = t.alphaMap, this.envMap = t.envMap, this.combine = t.combine, this.reflectivity = t.reflectivity, this.refractionRatio = t.refractionRatio, this.wireframe = t.wireframe, this.wireframeLinewidth = t.wireframeLinewidth, this.wireframeLinecap = t.wireframeLinecap, this.wireframeLinejoin = t.wireframeLinejoin, this.fog = t.fog, this;
    }
}, Dn = new A, pp = new F, Be = class {
    constructor(t, e, n = !1){
        if (Array.isArray(t)) throw new TypeError("THREE.BufferAttribute: array should be a Typed Array.");
        this.isBufferAttribute = !0, this.name = "", this.array = t, this.itemSize = e, this.count = t !== void 0 ? t.length / e : 0, this.normalized = n, this.usage = g0, this.updateRange = {
            offset: 0,
            count: -1
        }, this.version = 0;
    }
    onUploadCallback() {}
    set needsUpdate(t) {
        t === !0 && this.version++;
    }
    setUsage(t) {
        return this.usage = t, this;
    }
    copy(t) {
        return this.name = t.name, this.array = new t.array.constructor(t.array), this.itemSize = t.itemSize, this.count = t.count, this.normalized = t.normalized, this.usage = t.usage, this;
    }
    copyAt(t, e, n) {
        t *= this.itemSize, n *= e.itemSize;
        for(let i = 0, s = this.itemSize; i < s; i++)this.array[t + i] = e.array[n + i];
        return this;
    }
    copyArray(t) {
        return this.array.set(t), this;
    }
    applyMatrix3(t) {
        if (this.itemSize === 2) for(let e = 0, n = this.count; e < n; e++)pp.fromBufferAttribute(this, e), pp.applyMatrix3(t), this.setXY(e, pp.x, pp.y);
        else if (this.itemSize === 3) for(let e = 0, n = this.count; e < n; e++)Dn.fromBufferAttribute(this, e), Dn.applyMatrix3(t), this.setXYZ(e, Dn.x, Dn.y, Dn.z);
        return this;
    }
    applyMatrix4(t) {
        for(let e = 0, n = this.count; e < n; e++)Dn.fromBufferAttribute(this, e), Dn.applyMatrix4(t), this.setXYZ(e, Dn.x, Dn.y, Dn.z);
        return this;
    }
    applyNormalMatrix(t) {
        for(let e = 0, n = this.count; e < n; e++)Dn.fromBufferAttribute(this, e), Dn.applyNormalMatrix(t), this.setXYZ(e, Dn.x, Dn.y, Dn.z);
        return this;
    }
    transformDirection(t) {
        for(let e = 0, n = this.count; e < n; e++)Dn.fromBufferAttribute(this, e), Dn.transformDirection(t), this.setXYZ(e, Dn.x, Dn.y, Dn.z);
        return this;
    }
    set(t, e = 0) {
        return this.array.set(t, e), this;
    }
    getX(t) {
        let e = this.array[t * this.itemSize];
        return this.normalized && (e = ro(e, this.array)), e;
    }
    setX(t, e) {
        return this.normalized && (e = Ut(e, this.array)), this.array[t * this.itemSize] = e, this;
    }
    getY(t) {
        let e = this.array[t * this.itemSize + 1];
        return this.normalized && (e = ro(e, this.array)), e;
    }
    setY(t, e) {
        return this.normalized && (e = Ut(e, this.array)), this.array[t * this.itemSize + 1] = e, this;
    }
    getZ(t) {
        let e = this.array[t * this.itemSize + 2];
        return this.normalized && (e = ro(e, this.array)), e;
    }
    setZ(t, e) {
        return this.normalized && (e = Ut(e, this.array)), this.array[t * this.itemSize + 2] = e, this;
    }
    getW(t) {
        let e = this.array[t * this.itemSize + 3];
        return this.normalized && (e = ro(e, this.array)), e;
    }
    setW(t, e) {
        return this.normalized && (e = Ut(e, this.array)), this.array[t * this.itemSize + 3] = e, this;
    }
    setXY(t, e, n) {
        return t *= this.itemSize, this.normalized && (e = Ut(e, this.array), n = Ut(n, this.array)), this.array[t + 0] = e, this.array[t + 1] = n, this;
    }
    setXYZ(t, e, n, i) {
        return t *= this.itemSize, this.normalized && (e = Ut(e, this.array), n = Ut(n, this.array), i = Ut(i, this.array)), this.array[t + 0] = e, this.array[t + 1] = n, this.array[t + 2] = i, this;
    }
    setXYZW(t, e, n, i, s) {
        return t *= this.itemSize, this.normalized && (e = Ut(e, this.array), n = Ut(n, this.array), i = Ut(i, this.array), s = Ut(s, this.array)), this.array[t + 0] = e, this.array[t + 1] = n, this.array[t + 2] = i, this.array[t + 3] = s, this;
    }
    onUpload(t) {
        return this.onUploadCallback = t, this;
    }
    clone() {
        return new this.constructor(this.array, this.itemSize).copy(this);
    }
    toJSON() {
        let t = {
            itemSize: this.itemSize,
            type: this.array.constructor.name,
            array: Array.from(this.array),
            normalized: this.normalized
        };
        return this.name !== "" && (t.name = this.name), this.usage !== g0 && (t.usage = this.usage), (this.updateRange.offset !== 0 || this.updateRange.count !== -1) && (t.updateRange = this.updateRange), t;
    }
    copyColorsArray() {
        console.error("THREE.BufferAttribute: copyColorsArray() was removed in r144.");
    }
    copyVector2sArray() {
        console.error("THREE.BufferAttribute: copyVector2sArray() was removed in r144.");
    }
    copyVector3sArray() {
        console.error("THREE.BufferAttribute: copyVector3sArray() was removed in r144.");
    }
    copyVector4sArray() {
        console.error("THREE.BufferAttribute: copyVector4sArray() was removed in r144.");
    }
};
var Vp = class extends Be {
    constructor(t, e, n){
        super(new Uint16Array(t), e, n);
    }
};
var ys = class extends Be {
    constructor(t, e, n){
        super(new Uint32Array(t), e, n);
    }
};
var Ae = class extends Be {
    constructor(t, e, n){
        super(new Float32Array(t), e, n);
    }
};
var oR = 0, mi = new ae, Jv = new pt, Kl = new A, ii = new Mt, nh = new Mt, $n = new A, Me = class extends Ht {
    constructor(){
        super(), this.isBufferGeometry = !0, Object.defineProperty(this, "id", {
            value: oR++
        }), this.uuid = gs(), this.name = "", this.type = "BufferGeometry", this.index = null, this.attributes = {}, this.morphAttributes = {}, this.morphTargetsRelative = !1, this.groups = [], this.boundingBox = null, this.boundingSphere = null, this.drawRange = {
            start: 0,
            count: 1 / 0
        }, this.userData = {};
    }
    getIndex() {
        return this.index;
    }
    setIndex(t) {
        return Array.isArray(t) ? this.index = new (EA(t) ? ys : Vp)(t, 1) : this.index = t, this;
    }
    getAttribute(t) {
        return this.attributes[t];
    }
    setAttribute(t, e) {
        return this.attributes[t] = e, this;
    }
    deleteAttribute(t) {
        return delete this.attributes[t], this;
    }
    hasAttribute(t) {
        return this.attributes[t] !== void 0;
    }
    addGroup(t, e, n = 0) {
        this.groups.push({
            start: t,
            count: e,
            materialIndex: n
        });
    }
    clearGroups() {
        this.groups = [];
    }
    setDrawRange(t, e) {
        this.drawRange.start = t, this.drawRange.count = e;
    }
    applyMatrix4(t) {
        let e = this.attributes.position;
        e !== void 0 && (e.applyMatrix4(t), e.needsUpdate = !0);
        let n = this.attributes.normal;
        if (n !== void 0) {
            let s = new Kt().getNormalMatrix(t);
            n.applyNormalMatrix(s), n.needsUpdate = !0;
        }
        let i = this.attributes.tangent;
        return i !== void 0 && (i.transformDirection(t), i.needsUpdate = !0), this.boundingBox !== null && this.computeBoundingBox(), this.boundingSphere !== null && this.computeBoundingSphere(), this;
    }
    applyQuaternion(t) {
        return mi.makeRotationFromQuaternion(t), this.applyMatrix4(mi), this;
    }
    rotateX(t) {
        return mi.makeRotationX(t), this.applyMatrix4(mi), this;
    }
    rotateY(t) {
        return mi.makeRotationY(t), this.applyMatrix4(mi), this;
    }
    rotateZ(t) {
        return mi.makeRotationZ(t), this.applyMatrix4(mi), this;
    }
    translate(t, e, n) {
        return mi.makeTranslation(t, e, n), this.applyMatrix4(mi), this;
    }
    scale(t, e, n) {
        return mi.makeScale(t, e, n), this.applyMatrix4(mi), this;
    }
    lookAt(t) {
        return Jv.lookAt(t), Jv.updateMatrix(), this.applyMatrix4(Jv.matrix), this;
    }
    center() {
        return this.computeBoundingBox(), this.boundingBox.getCenter(Kl).negate(), this.translate(Kl.x, Kl.y, Kl.z), this;
    }
    setFromPoints(t) {
        let e = [];
        for(let n = 0, i = t.length; n < i; n++){
            let s = t[n];
            e.push(s.x, s.y, s.z || 0);
        }
        return this.setAttribute("position", new Ae(e, 3)), this;
    }
    computeBoundingBox() {
        this.boundingBox === null && (this.boundingBox = new Mt);
        let t = this.attributes.position, e = this.morphAttributes.position;
        if (t && t.isGLBufferAttribute) {
            console.error('THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box. Alternatively set "mesh.frustumCulled" to "false".', this), this.boundingBox.set(new A(-1 / 0, -1 / 0, -1 / 0), new A(1 / 0, 1 / 0, 1 / 0));
            return;
        }
        if (t !== void 0) {
            if (this.boundingBox.setFromBufferAttribute(t), e) for(let n = 0, i = e.length; n < i; n++){
                let s = e[n];
                ii.setFromBufferAttribute(s), this.morphTargetsRelative ? ($n.addVectors(this.boundingBox.min, ii.min), this.boundingBox.expandByPoint($n), $n.addVectors(this.boundingBox.max, ii.max), this.boundingBox.expandByPoint($n)) : (this.boundingBox.expandByPoint(ii.min), this.boundingBox.expandByPoint(ii.max));
            }
        } else this.boundingBox.makeEmpty();
        (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) && console.error('THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
    }
    computeBoundingSphere() {
        this.boundingSphere === null && (this.boundingSphere = new Rn);
        let t = this.attributes.position, e = this.morphAttributes.position;
        if (t && t.isGLBufferAttribute) {
            console.error('THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere. Alternatively set "mesh.frustumCulled" to "false".', this), this.boundingSphere.set(new A, 1 / 0);
            return;
        }
        if (t) {
            let n = this.boundingSphere.center;
            if (ii.setFromBufferAttribute(t), e) for(let s = 0, o = e.length; s < o; s++){
                let a = e[s];
                nh.setFromBufferAttribute(a), this.morphTargetsRelative ? ($n.addVectors(ii.min, nh.min), ii.expandByPoint($n), $n.addVectors(ii.max, nh.max), ii.expandByPoint($n)) : (ii.expandByPoint(nh.min), ii.expandByPoint(nh.max));
            }
            ii.getCenter(n);
            let i = 0;
            for(let s = 0, o = t.count; s < o; s++)$n.fromBufferAttribute(t, s), i = Math.max(i, n.distanceToSquared($n));
            if (e) for(let s = 0, o = e.length; s < o; s++){
                let a = e[s], l = this.morphTargetsRelative;
                for(let u = 0, c = a.count; u < c; u++)$n.fromBufferAttribute(a, u), l && (Kl.fromBufferAttribute(t, u), $n.add(Kl)), i = Math.max(i, n.distanceToSquared($n));
            }
            this.boundingSphere.radius = Math.sqrt(i), isNaN(this.boundingSphere.radius) && console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
        }
    }
    computeTangents() {
        let t = this.index, e = this.attributes;
        if (t === null || e.position === void 0 || e.normal === void 0 || e.uv === void 0) {
            console.error("THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)");
            return;
        }
        let n = t.array, i = e.position.array, s = e.normal.array, o = e.uv.array, a = i.length / 3;
        this.hasAttribute("tangent") === !1 && this.setAttribute("tangent", new Be(new Float32Array(4 * a), 4));
        let l = this.getAttribute("tangent").array, u = [], c = [];
        for(let E = 0; E < a; E++)u[E] = new A, c[E] = new A;
        let d = new A, h = new A, f = new A, m = new F, p = new F, g = new F, y = new A, v = new A;
        function x(E, P, D) {
            d.fromArray(i, E * 3), h.fromArray(i, P * 3), f.fromArray(i, D * 3), m.fromArray(o, E * 2), p.fromArray(o, P * 2), g.fromArray(o, D * 2), h.sub(d), f.sub(d), p.sub(m), g.sub(m);
            let C = 1 / (p.x * g.y - g.x * p.y);
            !isFinite(C) || (y.copy(h).multiplyScalar(g.y).addScaledVector(f, -p.y).multiplyScalar(C), v.copy(f).multiplyScalar(p.x).addScaledVector(h, -g.x).multiplyScalar(C), u[E].add(y), u[P].add(y), u[D].add(y), c[E].add(v), c[P].add(v), c[D].add(v));
        }
        let w = this.groups;
        w.length === 0 && (w = [
            {
                start: 0,
                count: n.length
            }
        ]);
        for(let E = 0, P = w.length; E < P; ++E){
            let D = w[E], C = D.start, O = D.count;
            for(let B = C, V = C + O; B < V; B += 3)x(n[B + 0], n[B + 1], n[B + 2]);
        }
        let S = new A, _ = new A, M = new A, b = new A;
        function T(E) {
            M.fromArray(s, E * 3), b.copy(M);
            let P = u[E];
            S.copy(P), S.sub(M.multiplyScalar(M.dot(P))).normalize(), _.crossVectors(b, P);
            let C = _.dot(c[E]) < 0 ? -1 : 1;
            l[E * 4] = S.x, l[E * 4 + 1] = S.y, l[E * 4 + 2] = S.z, l[E * 4 + 3] = C;
        }
        for(let E = 0, P = w.length; E < P; ++E){
            let D = w[E], C = D.start, O = D.count;
            for(let B = C, V = C + O; B < V; B += 3)T(n[B + 0]), T(n[B + 1]), T(n[B + 2]);
        }
    }
    computeVertexNormals() {
        let t = this.index, e = this.getAttribute("position");
        if (e !== void 0) {
            let n = this.getAttribute("normal");
            if (n === void 0) n = new Be(new Float32Array(e.count * 3), 3), this.setAttribute("normal", n);
            else for(let h = 0, f = n.count; h < f; h++)n.setXYZ(h, 0, 0, 0);
            let i = new A, s = new A, o = new A, a = new A, l = new A, u = new A, c = new A, d = new A;
            if (t) for(let h = 0, f = t.count; h < f; h += 3){
                let m = t.getX(h + 0), p = t.getX(h + 1), g = t.getX(h + 2);
                i.fromBufferAttribute(e, m), s.fromBufferAttribute(e, p), o.fromBufferAttribute(e, g), c.subVectors(o, s), d.subVectors(i, s), c.cross(d), a.fromBufferAttribute(n, m), l.fromBufferAttribute(n, p), u.fromBufferAttribute(n, g), a.add(c), l.add(c), u.add(c), n.setXYZ(m, a.x, a.y, a.z), n.setXYZ(p, l.x, l.y, l.z), n.setXYZ(g, u.x, u.y, u.z);
            }
            else for(let h = 0, f = e.count; h < f; h += 3)i.fromBufferAttribute(e, h + 0), s.fromBufferAttribute(e, h + 1), o.fromBufferAttribute(e, h + 2), c.subVectors(o, s), d.subVectors(i, s), c.cross(d), n.setXYZ(h + 0, c.x, c.y, c.z), n.setXYZ(h + 1, c.x, c.y, c.z), n.setXYZ(h + 2, c.x, c.y, c.z);
            this.normalizeNormals(), n.needsUpdate = !0;
        }
    }
    merge() {
        return console.error("THREE.BufferGeometry.merge() has been removed. Use THREE.BufferGeometryUtils.mergeBufferGeometries() instead."), this;
    }
    normalizeNormals() {
        let t = this.attributes.normal;
        for(let e = 0, n = t.count; e < n; e++)$n.fromBufferAttribute(t, e), $n.normalize(), t.setXYZ(e, $n.x, $n.y, $n.z);
    }
    toNonIndexed() {
        function t(a, l) {
            let u = a.array, c = a.itemSize, d = a.normalized, h = new u.constructor(l.length * c), f = 0, m = 0;
            for(let p = 0, g = l.length; p < g; p++){
                a.isInterleavedBufferAttribute ? f = l[p] * a.data.stride + a.offset : f = l[p] * c;
                for(let y = 0; y < c; y++)h[m++] = u[f++];
            }
            return new Be(h, c, d);
        }
        if (this.index === null) return console.warn("THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed."), this;
        let e = new Me, n = this.index.array, i = this.attributes;
        for(let a in i){
            let l = i[a], u = t(l, n);
            e.setAttribute(a, u);
        }
        let s = this.morphAttributes;
        for(let a in s){
            let l = [], u = s[a];
            for(let c = 0, d = u.length; c < d; c++){
                let h = u[c], f = t(h, n);
                l.push(f);
            }
            e.morphAttributes[a] = l;
        }
        e.morphTargetsRelative = this.morphTargetsRelative;
        let o = this.groups;
        for(let a = 0, l = o.length; a < l; a++){
            let u = o[a];
            e.addGroup(u.start, u.count, u.materialIndex);
        }
        return e;
    }
    toJSON() {
        let t = {
            metadata: {
                version: 4.5,
                type: "BufferGeometry",
                generator: "BufferGeometry.toJSON"
            }
        };
        if (t.uuid = this.uuid, t.type = this.type, this.name !== "" && (t.name = this.name), Object.keys(this.userData).length > 0 && (t.userData = this.userData), this.parameters !== void 0) {
            let l = this.parameters;
            for(let u in l)l[u] !== void 0 && (t[u] = l[u]);
            return t;
        }
        t.data = {
            attributes: {}
        };
        let e = this.index;
        e !== null && (t.data.index = {
            type: e.array.constructor.name,
            array: Array.prototype.slice.call(e.array)
        });
        let n = this.attributes;
        for(let l in n){
            let u = n[l];
            t.data.attributes[l] = u.toJSON(t.data);
        }
        let i = {}, s = !1;
        for(let l in this.morphAttributes){
            let u = this.morphAttributes[l], c = [];
            for(let d = 0, h = u.length; d < h; d++){
                let f = u[d];
                c.push(f.toJSON(t.data));
            }
            c.length > 0 && (i[l] = c, s = !0);
        }
        s && (t.data.morphAttributes = i, t.data.morphTargetsRelative = this.morphTargetsRelative);
        let o = this.groups;
        o.length > 0 && (t.data.groups = JSON.parse(JSON.stringify(o)));
        let a = this.boundingSphere;
        return a !== null && (t.data.boundingSphere = {
            center: a.center.toArray(),
            radius: a.radius
        }), t;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(t) {
        this.index = null, this.attributes = {}, this.morphAttributes = {}, this.groups = [], this.boundingBox = null, this.boundingSphere = null;
        let e = {};
        this.name = t.name;
        let n = t.index;
        n !== null && this.setIndex(n.clone(e));
        let i = t.attributes;
        for(let u in i){
            let c = i[u];
            this.setAttribute(u, c.clone(e));
        }
        let s = t.morphAttributes;
        for(let u in s){
            let c = [], d = s[u];
            for(let h = 0, f = d.length; h < f; h++)c.push(d[h].clone(e));
            this.morphAttributes[u] = c;
        }
        this.morphTargetsRelative = t.morphTargetsRelative;
        let o = t.groups;
        for(let u = 0, c = o.length; u < c; u++){
            let d = o[u];
            this.addGroup(d.start, d.count, d.materialIndex);
        }
        let a = t.boundingBox;
        a !== null && (this.boundingBox = a.clone());
        let l = t.boundingSphere;
        return l !== null && (this.boundingSphere = l.clone()), this.drawRange.start = t.drawRange.start, this.drawRange.count = t.drawRange.count, this.userData = t.userData, t.parameters !== void 0 && (this.parameters = Object.assign({}, t.parameters)), this;
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
}, L1 = new ae, Zl = new Fi, $v = new Rn, rh = new A, ih = new A, sh = new A, e0 = new A, mp = new A, gp = new F, yp = new F, vp = new F, t0 = new A, xp = new A, In = class extends pt {
    constructor(t = new Me, e = new Ui){
        super(), this.isMesh = !0, this.type = "Mesh", this.geometry = t, this.material = e, this.updateMorphTargets();
    }
    copy(t, e) {
        return super.copy(t, e), t.morphTargetInfluences !== void 0 && (this.morphTargetInfluences = t.morphTargetInfluences.slice()), t.morphTargetDictionary !== void 0 && (this.morphTargetDictionary = Object.assign({}, t.morphTargetDictionary)), this.material = t.material, this.geometry = t.geometry, this;
    }
    updateMorphTargets() {
        let e = this.geometry.morphAttributes, n = Object.keys(e);
        if (n.length > 0) {
            let i = e[n[0]];
            if (i !== void 0) {
                this.morphTargetInfluences = [], this.morphTargetDictionary = {};
                for(let s = 0, o = i.length; s < o; s++){
                    let a = i[s].name || String(s);
                    this.morphTargetInfluences.push(0), this.morphTargetDictionary[a] = s;
                }
            }
        }
    }
    getVertexPosition(t, e) {
        let n = this.geometry, i = n.attributes.position, s = n.morphAttributes.position, o = n.morphTargetsRelative;
        e.fromBufferAttribute(i, t);
        let a = this.morphTargetInfluences;
        if (s && a) {
            mp.set(0, 0, 0);
            for(let l = 0, u = s.length; l < u; l++){
                let c = a[l], d = s[l];
                c !== 0 && (e0.fromBufferAttribute(d, t), o ? mp.addScaledVector(e0, c) : mp.addScaledVector(e0.sub(e), c));
            }
            e.add(mp);
        }
        return this.isSkinnedMesh && this.boneTransform(t, e), e;
    }
    raycast(t, e) {
        let n = this.geometry, i = this.material, s = this.matrixWorld;
        if (i === void 0 || (n.boundingSphere === null && n.computeBoundingSphere(), $v.copy(n.boundingSphere), $v.applyMatrix4(s), t.ray.intersectsSphere($v) === !1) || (L1.copy(s).invert(), Zl.copy(t.ray).applyMatrix4(L1), n.boundingBox !== null && Zl.intersectsBox(n.boundingBox) === !1)) return;
        let o, a = n.index, l = n.attributes.position, u = n.attributes.uv, c = n.attributes.uv2, d = n.groups, h = n.drawRange;
        if (a !== null) {
            if (Array.isArray(i)) for(let f = 0, m = d.length; f < m; f++){
                let p = d[f], g = i[p.materialIndex], y = Math.max(p.start, h.start), v = Math.min(a.count, Math.min(p.start + p.count, h.start + h.count));
                for(let x = y, w = v; x < w; x += 3){
                    let S = a.getX(x), _ = a.getX(x + 1), M = a.getX(x + 2);
                    o = bp(this, g, t, Zl, u, c, S, _, M), o && (o.faceIndex = Math.floor(x / 3), o.face.materialIndex = p.materialIndex, e.push(o));
                }
            }
            else {
                let f = Math.max(0, h.start), m = Math.min(a.count, h.start + h.count);
                for(let p = f, g = m; p < g; p += 3){
                    let y = a.getX(p), v = a.getX(p + 1), x = a.getX(p + 2);
                    o = bp(this, i, t, Zl, u, c, y, v, x), o && (o.faceIndex = Math.floor(p / 3), e.push(o));
                }
            }
        } else if (l !== void 0) {
            if (Array.isArray(i)) for(let f = 0, m = d.length; f < m; f++){
                let p = d[f], g = i[p.materialIndex], y = Math.max(p.start, h.start), v = Math.min(l.count, Math.min(p.start + p.count, h.start + h.count));
                for(let x = y, w = v; x < w; x += 3){
                    let S = x, _ = x + 1, M = x + 2;
                    o = bp(this, g, t, Zl, u, c, S, _, M), o && (o.faceIndex = Math.floor(x / 3), o.face.materialIndex = p.materialIndex, e.push(o));
                }
            }
            else {
                let f = Math.max(0, h.start), m = Math.min(l.count, h.start + h.count);
                for(let p = f, g = m; p < g; p += 3){
                    let y = p, v = p + 1, x = p + 2;
                    o = bp(this, i, t, Zl, u, c, y, v, x), o && (o.faceIndex = Math.floor(p / 3), e.push(o));
                }
            }
        }
    }
};
function aR(r1, t, e, n, i, s, o, a) {
    let l;
    if (t.side === On ? l = n.intersectTriangle(o, s, i, !0, a) : l = n.intersectTriangle(i, s, o, t.side === si, a), l === null) return null;
    xp.copy(a), xp.applyMatrix4(r1.matrixWorld);
    let u = e.ray.origin.distanceTo(xp);
    return u < e.near || u > e.far ? null : {
        distance: u,
        point: xp.clone(),
        object: r1
    };
}
function bp(r1, t, e, n, i, s, o, a, l) {
    r1.getVertexPosition(o, rh), r1.getVertexPosition(a, ih), r1.getVertexPosition(l, sh);
    let u = aR(r1, t, e, n, rh, ih, sh, t0);
    if (u) {
        i && (gp.fromBufferAttribute(i, o), yp.fromBufferAttribute(i, a), vp.fromBufferAttribute(i, l), u.uv = an.getUV(t0, rh, ih, sh, gp, yp, vp, new F)), s && (gp.fromBufferAttribute(s, o), yp.fromBufferAttribute(s, a), vp.fromBufferAttribute(s, l), u.uv2 = an.getUV(t0, rh, ih, sh, gp, yp, vp, new F));
        let c = {
            a: o,
            b: a,
            c: l,
            normal: new A,
            materialIndex: 0
        };
        an.getNormal(rh, ih, sh, c.normal), u.face = c;
    }
    return u;
}
var er = class extends Me {
    constructor(t = 1, e = 1, n = 1, i = 1, s = 1, o = 1){
        super(), this.type = "BoxGeometry", this.parameters = {
            width: t,
            height: e,
            depth: n,
            widthSegments: i,
            heightSegments: s,
            depthSegments: o
        };
        let a = this;
        i = Math.floor(i), s = Math.floor(s), o = Math.floor(o);
        let l = [], u = [], c = [], d = [], h = 0, f = 0;
        m("z", "y", "x", -1, -1, n, e, t, o, s, 0), m("z", "y", "x", 1, -1, n, e, -t, o, s, 1), m("x", "z", "y", 1, 1, t, n, e, i, o, 2), m("x", "z", "y", 1, -1, t, n, -e, i, o, 3), m("x", "y", "z", 1, -1, t, e, n, i, s, 4), m("x", "y", "z", -1, -1, t, e, -n, i, s, 5), this.setIndex(l), this.setAttribute("position", new Ae(u, 3)), this.setAttribute("normal", new Ae(c, 3)), this.setAttribute("uv", new Ae(d, 2));
        function m(p, g, y, v, x, w, S, _, M, b, T) {
            let E = w / M, P = S / b, D = w / 2, C = S / 2, O = _ / 2, B = M + 1, V = b + 1, Y = 0, W = 0, q = new A;
            for(let j = 0; j < V; j++){
                let X = j * P - C;
                for(let L = 0; L < B; L++){
                    let U = L * E - D;
                    q[p] = U * v, q[g] = X * x, q[y] = O, u.push(q.x, q.y, q.z), q[p] = 0, q[g] = 0, q[y] = _ > 0 ? 1 : -1, c.push(q.x, q.y, q.z), d.push(L / M), d.push(1 - j / b), Y += 1;
                }
            }
            for(let j = 0; j < b; j++)for(let X = 0; X < M; X++){
                let L = h + X + B * j, U = h + X + B * (j + 1), G = h + (X + 1) + B * (j + 1), H = h + (X + 1) + B * j;
                l.push(L, U, H), l.push(U, G, H), W += 6;
            }
            a.addGroup(f, W, T), f += W, h += Y;
        }
    }
    static fromJSON(t) {
        return new er(t.width, t.height, t.depth, t.widthSegments, t.heightSegments, t.depthSegments);
    }
};
function ac(r1) {
    let t = {};
    for(let e in r1){
        t[e] = {};
        for(let n in r1[e]){
            let i = r1[e][n];
            i && (i.isColor || i.isMatrix3 || i.isMatrix4 || i.isVector2 || i.isVector3 || i.isVector4 || i.isTexture || i.isQuaternion) ? t[e][n] = i.clone() : Array.isArray(i) ? t[e][n] = i.slice() : t[e][n] = i;
        }
    }
    return t;
}
function Dr(r1) {
    let t = {};
    for(let e = 0; e < r1.length; e++){
        let n = ac(r1[e]);
        for(let i in n)t[i] = n[i];
    }
    return t;
}
function lR(r1) {
    let t = [];
    for(let e = 0; e < r1.length; e++)t.push(r1[e].clone());
    return t;
}
function PA(r1) {
    return r1.getRenderTarget() === null && r1.outputEncoding === Ye ? fs : ph;
}
var Gi = {
    clone: ac,
    merge: Dr
}, cR = `void main() {
	gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
}`, uR = `void main() {
	gl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );
}`, ot = class extends Wa {
    constructor(t){
        super(), this.isShaderMaterial = !0, this.type = "ShaderMaterial", this.defines = {}, this.uniforms = {}, this.uniformsGroups = [], this.vertexShader = cR, this.fragmentShader = uR, this.linewidth = 1, this.wireframe = !1, this.wireframeLinewidth = 1, this.fog = !1, this.lights = !1, this.clipping = !1, this.extensions = {
            derivatives: !1,
            fragDepth: !1,
            drawBuffers: !1,
            shaderTextureLOD: !1
        }, this.defaultAttributeValues = {
            color: [
                1,
                1,
                1
            ],
            uv: [
                0,
                0
            ],
            uv2: [
                0,
                0
            ]
        }, this.index0AttributeName = void 0, this.uniformsNeedUpdate = !1, this.glslVersion = null, t !== void 0 && this.setValues(t);
    }
    copy(t) {
        return super.copy(t), this.fragmentShader = t.fragmentShader, this.vertexShader = t.vertexShader, this.uniforms = ac(t.uniforms), this.uniformsGroups = lR(t.uniformsGroups), this.defines = Object.assign({}, t.defines), this.wireframe = t.wireframe, this.wireframeLinewidth = t.wireframeLinewidth, this.fog = t.fog, this.lights = t.lights, this.clipping = t.clipping, this.extensions = Object.assign({}, t.extensions), this.glslVersion = t.glslVersion, this;
    }
    toJSON(t) {
        let e = super.toJSON(t);
        e.glslVersion = this.glslVersion, e.uniforms = {};
        for(let i in this.uniforms){
            let o = this.uniforms[i].value;
            o && o.isTexture ? e.uniforms[i] = {
                type: "t",
                value: o.toJSON(t).uuid
            } : o && o.isColor ? e.uniforms[i] = {
                type: "c",
                value: o.getHex()
            } : o && o.isVector2 ? e.uniforms[i] = {
                type: "v2",
                value: o.toArray()
            } : o && o.isVector3 ? e.uniforms[i] = {
                type: "v3",
                value: o.toArray()
            } : o && o.isVector4 ? e.uniforms[i] = {
                type: "v4",
                value: o.toArray()
            } : o && o.isMatrix3 ? e.uniforms[i] = {
                type: "m3",
                value: o.toArray()
            } : o && o.isMatrix4 ? e.uniforms[i] = {
                type: "m4",
                value: o.toArray()
            } : e.uniforms[i] = {
                value: o
            };
        }
        Object.keys(this.defines).length > 0 && (e.defines = this.defines), e.vertexShader = this.vertexShader, e.fragmentShader = this.fragmentShader;
        let n = {};
        for(let i in this.extensions)this.extensions[i] === !0 && (n[i] = !0);
        return Object.keys(n).length > 0 && (e.extensions = n), e;
    }
}, ki = class extends pt {
    constructor(){
        super(), this.isCamera = !0, this.type = "Camera", this.matrixWorldInverse = new ae, this.projectionMatrix = new ae, this.projectionMatrixInverse = new ae;
    }
    copy(t, e) {
        return super.copy(t, e), this.matrixWorldInverse.copy(t.matrixWorldInverse), this.projectionMatrix.copy(t.projectionMatrix), this.projectionMatrixInverse.copy(t.projectionMatrixInverse), this;
    }
    getWorldDirection(t) {
        this.updateWorldMatrix(!0, !1);
        let e = this.matrixWorld.elements;
        return t.set(-e[8], -e[9], -e[10]).normalize();
    }
    updateMatrixWorld(t) {
        super.updateMatrixWorld(t), this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    updateWorldMatrix(t, e) {
        super.updateWorldMatrix(t, e), this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    clone() {
        return new this.constructor().copy(this);
    }
}, gn = class extends ki {
    constructor(t = 50, e = 1, n = .1, i = 2e3){
        super(), this.isPerspectiveCamera = !0, this.type = "PerspectiveCamera", this.fov = t, this.zoom = 1, this.near = n, this.far = i, this.focus = 10, this.aspect = e, this.view = null, this.filmGauge = 35, this.filmOffset = 0, this.updateProjectionMatrix();
    }
    copy(t, e) {
        return super.copy(t, e), this.fov = t.fov, this.zoom = t.zoom, this.near = t.near, this.far = t.far, this.focus = t.focus, this.aspect = t.aspect, this.view = t.view === null ? null : Object.assign({}, t.view), this.filmGauge = t.filmGauge, this.filmOffset = t.filmOffset, this;
    }
    setFocalLength(t) {
        let e = .5 * this.getFilmHeight() / t;
        this.fov = mh * 2 * Math.atan(e), this.updateProjectionMatrix();
    }
    getFocalLength() {
        let t = Math.tan(ch * .5 * this.fov);
        return .5 * this.getFilmHeight() / t;
    }
    getEffectiveFOV() {
        return mh * 2 * Math.atan(Math.tan(ch * .5 * this.fov) / this.zoom);
    }
    getFilmWidth() {
        return this.filmGauge * Math.min(this.aspect, 1);
    }
    getFilmHeight() {
        return this.filmGauge / Math.max(this.aspect, 1);
    }
    setViewOffset(t, e, n, i, s, o) {
        this.aspect = t / e, this.view === null && (this.view = {
            enabled: !0,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        }), this.view.enabled = !0, this.view.fullWidth = t, this.view.fullHeight = e, this.view.offsetX = n, this.view.offsetY = i, this.view.width = s, this.view.height = o, this.updateProjectionMatrix();
    }
    clearViewOffset() {
        this.view !== null && (this.view.enabled = !1), this.updateProjectionMatrix();
    }
    updateProjectionMatrix() {
        let t = this.near, e = t * Math.tan(ch * .5 * this.fov) / this.zoom, n = 2 * e, i = this.aspect * n, s = -0.5 * i, o = this.view;
        if (this.view !== null && this.view.enabled) {
            let l = o.fullWidth, u = o.fullHeight;
            s += o.offsetX * i / l, e -= o.offsetY * n / u, i *= o.width / l, n *= o.height / u;
        }
        let a = this.filmOffset;
        a !== 0 && (s += t * a / this.getFilmWidth()), this.projectionMatrix.makePerspective(s, s + i, e, e - n, t, this.far), this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(t) {
        let e = super.toJSON(t);
        return e.object.fov = this.fov, e.object.zoom = this.zoom, e.object.near = this.near, e.object.far = this.far, e.object.focus = this.focus, e.object.aspect = this.aspect, this.view !== null && (e.object.view = Object.assign({}, this.view)), e.object.filmGauge = this.filmGauge, e.object.filmOffset = this.filmOffset, e;
    }
}, Jl = -90, $l = 1, x0 = class extends pt {
    constructor(t, e, n){
        super(), this.type = "CubeCamera", this.renderTarget = n;
        let i = new gn(Jl, $l, t, e);
        i.layers = this.layers, i.up.set(0, 1, 0), i.lookAt(1, 0, 0), this.add(i);
        let s = new gn(Jl, $l, t, e);
        s.layers = this.layers, s.up.set(0, 1, 0), s.lookAt(-1, 0, 0), this.add(s);
        let o = new gn(Jl, $l, t, e);
        o.layers = this.layers, o.up.set(0, 0, -1), o.lookAt(0, 1, 0), this.add(o);
        let a = new gn(Jl, $l, t, e);
        a.layers = this.layers, a.up.set(0, 0, 1), a.lookAt(0, -1, 0), this.add(a);
        let l = new gn(Jl, $l, t, e);
        l.layers = this.layers, l.up.set(0, 1, 0), l.lookAt(0, 0, 1), this.add(l);
        let u = new gn(Jl, $l, t, e);
        u.layers = this.layers, u.up.set(0, 1, 0), u.lookAt(0, 0, -1), this.add(u);
    }
    update(t, e) {
        this.parent === null && this.updateMatrixWorld();
        let n = this.renderTarget, [i, s, o, a, l, u] = this.children, c = t.getRenderTarget(), d = t.toneMapping, h = t.xr.enabled;
        t.toneMapping = io, t.xr.enabled = !1;
        let f = n.texture.generateMipmaps;
        n.texture.generateMipmaps = !1, t.setRenderTarget(n, 0), t.render(e, i), t.setRenderTarget(n, 1), t.render(e, s), t.setRenderTarget(n, 2), t.render(e, o), t.setRenderTarget(n, 3), t.render(e, a), t.setRenderTarget(n, 4), t.render(e, l), n.texture.generateMipmaps = f, t.setRenderTarget(n, 5), t.render(e, u), t.setRenderTarget(c), t.toneMapping = d, t.xr.enabled = h, n.texture.needsPMREMUpdate = !0;
    }
}, lc = class extends Vt {
    constructor(t, e, n, i, s, o, a, l, u, c){
        t = t !== void 0 ? t : [], e = e !== void 0 ? e : Vo, super(t, e, n, i, s, o, a, l, u, c), this.isCubeTexture = !0, this.flipY = !1;
    }
    get images() {
        return this.image;
    }
    set images(t) {
        this.image = t;
    }
}, b0 = class extends st {
    constructor(t = 1, e = {}){
        super(t, t, e), this.isWebGLCubeRenderTarget = !0;
        let n = {
            width: t,
            height: t,
            depth: 1
        }, i = [
            n,
            n,
            n,
            n,
            n,
            n
        ];
        this.texture = new lc(i, e.mapping, e.wrapS, e.wrapT, e.magFilter, e.minFilter, e.format, e.type, e.anisotropy, e.encoding), this.texture.isRenderTargetTexture = !0, this.texture.generateMipmaps = e.generateMipmaps !== void 0 ? e.generateMipmaps : !1, this.texture.minFilter = e.minFilter !== void 0 ? e.minFilter : Qe;
    }
    fromEquirectangularTexture(t, e) {
        this.texture.type = e.type, this.texture.encoding = e.encoding, this.texture.generateMipmaps = e.generateMipmaps, this.texture.minFilter = e.minFilter, this.texture.magFilter = e.magFilter;
        let n = {
            uniforms: {
                tEquirect: {
                    value: null
                }
            },
            vertexShader: `

				varying vec3 vWorldDirection;

				vec3 transformDirection( in vec3 dir, in mat4 matrix ) {

					return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );

				}

				void main() {

					vWorldDirection = transformDirection( position, modelMatrix );

					#include <begin_vertex>
					#include <project_vertex>

				}
			`,
            fragmentShader: `

				uniform sampler2D tEquirect;

				varying vec3 vWorldDirection;

				#include <common>

				void main() {

					vec3 direction = normalize( vWorldDirection );

					vec2 sampleUV = equirectUv( direction );

					gl_FragColor = texture2D( tEquirect, sampleUV );

				}
			`
        }, i = new er(5, 5, 5), s = new ot({
            name: "CubemapFromEquirect",
            uniforms: ac(n.uniforms),
            vertexShader: n.vertexShader,
            fragmentShader: n.fragmentShader,
            side: On,
            blending: Dt
        });
        s.uniforms.tEquirect.value = e;
        let o = new In(i, s), a = e.minFilter;
        return e.minFilter === Va && (e.minFilter = Qe), new x0(1, 10, this).update(t, o), e.minFilter = a, o.geometry.dispose(), o.material.dispose(), this;
    }
    clear(t, e, n, i) {
        let s = t.getRenderTarget();
        for(let o = 0; o < 6; o++)t.setRenderTarget(this, o), t.clear(e, n, i);
        t.setRenderTarget(s);
    }
}, n0 = new A, dR = new A, hR = new Kt, yn = class {
    constructor(t = new A(1, 0, 0), e = 0){
        this.isPlane = !0, this.normal = t, this.constant = e;
    }
    set(t, e) {
        return this.normal.copy(t), this.constant = e, this;
    }
    setComponents(t, e, n, i) {
        return this.normal.set(t, e, n), this.constant = i, this;
    }
    setFromNormalAndCoplanarPoint(t, e) {
        return this.normal.copy(t), this.constant = -e.dot(this.normal), this;
    }
    setFromCoplanarPoints(t, e, n) {
        let i = n0.subVectors(n, e).cross(dR.subVectors(t, e)).normalize();
        return this.setFromNormalAndCoplanarPoint(i, t), this;
    }
    copy(t) {
        return this.normal.copy(t.normal), this.constant = t.constant, this;
    }
    normalize() {
        let t = 1 / this.normal.length();
        return this.normal.multiplyScalar(t), this.constant *= t, this;
    }
    negate() {
        return this.constant *= -1, this.normal.negate(), this;
    }
    distanceToPoint(t) {
        return this.normal.dot(t) + this.constant;
    }
    distanceToSphere(t) {
        return this.distanceToPoint(t.center) - t.radius;
    }
    projectPoint(t, e) {
        return e.copy(this.normal).multiplyScalar(-this.distanceToPoint(t)).add(t);
    }
    intersectLine(t, e) {
        let n = t.delta(n0), i = this.normal.dot(n);
        if (i === 0) return this.distanceToPoint(t.start) === 0 ? e.copy(t.start) : null;
        let s = -(t.start.dot(this.normal) + this.constant) / i;
        return s < 0 || s > 1 ? null : e.copy(n).multiplyScalar(s).add(t.start);
    }
    intersectsLine(t) {
        let e = this.distanceToPoint(t.start), n = this.distanceToPoint(t.end);
        return e < 0 && n > 0 || n < 0 && e > 0;
    }
    intersectsBox(t) {
        return t.intersectsPlane(this);
    }
    intersectsSphere(t) {
        return t.intersectsPlane(this);
    }
    coplanarPoint(t) {
        return t.copy(this.normal).multiplyScalar(-this.constant);
    }
    applyMatrix4(t, e) {
        let n = e || hR.getNormalMatrix(t), i = this.coplanarPoint(n0).applyMatrix4(t), s = this.normal.applyMatrix3(n).normalize();
        return this.constant = -i.dot(s), this;
    }
    translate(t) {
        return this.constant -= t.dot(this.normal), this;
    }
    equals(t) {
        return t.normal.equals(this.normal) && t.constant === this.constant;
    }
    clone() {
        return new this.constructor().copy(this);
    }
}, ec = new Rn, wp = new A, yh = class {
    constructor(t = new yn, e = new yn, n = new yn, i = new yn, s = new yn, o = new yn){
        this.planes = [
            t,
            e,
            n,
            i,
            s,
            o
        ];
    }
    set(t, e, n, i, s, o) {
        let a = this.planes;
        return a[0].copy(t), a[1].copy(e), a[2].copy(n), a[3].copy(i), a[4].copy(s), a[5].copy(o), this;
    }
    copy(t) {
        let e = this.planes;
        for(let n = 0; n < 6; n++)e[n].copy(t.planes[n]);
        return this;
    }
    setFromProjectionMatrix(t) {
        let e = this.planes, n = t.elements, i = n[0], s = n[1], o = n[2], a = n[3], l = n[4], u = n[5], c = n[6], d = n[7], h = n[8], f = n[9], m = n[10], p = n[11], g = n[12], y = n[13], v = n[14], x = n[15];
        return e[0].setComponents(a - i, d - l, p - h, x - g).normalize(), e[1].setComponents(a + i, d + l, p + h, x + g).normalize(), e[2].setComponents(a + s, d + u, p + f, x + y).normalize(), e[3].setComponents(a - s, d - u, p - f, x - y).normalize(), e[4].setComponents(a - o, d - c, p - m, x - v).normalize(), e[5].setComponents(a + o, d + c, p + m, x + v).normalize(), this;
    }
    intersectsObject(t) {
        let e = t.geometry;
        return e.boundingSphere === null && e.computeBoundingSphere(), ec.copy(e.boundingSphere).applyMatrix4(t.matrixWorld), this.intersectsSphere(ec);
    }
    intersectsSprite(t) {
        return ec.center.set(0, 0, 0), ec.radius = .7071067811865476, ec.applyMatrix4(t.matrixWorld), this.intersectsSphere(ec);
    }
    intersectsSphere(t) {
        let e = this.planes, n = t.center, i = -t.radius;
        for(let s = 0; s < 6; s++)if (e[s].distanceToPoint(n) < i) return !1;
        return !0;
    }
    intersectsBox(t) {
        let e = this.planes;
        for(let n = 0; n < 6; n++){
            let i = e[n];
            if (wp.x = i.normal.x > 0 ? t.max.x : t.min.x, wp.y = i.normal.y > 0 ? t.max.y : t.min.y, wp.z = i.normal.z > 0 ? t.max.z : t.min.z, i.distanceToPoint(wp) < 0) return !1;
        }
        return !0;
    }
    containsPoint(t) {
        let e = this.planes;
        for(let n = 0; n < 6; n++)if (e[n].distanceToPoint(t) < 0) return !1;
        return !0;
    }
    clone() {
        return new this.constructor().copy(this);
    }
};
function DA() {
    let r1 = null, t = !1, e = null, n = null;
    function i(s, o) {
        e(s, o), n = r1.requestAnimationFrame(i);
    }
    return {
        start: function() {
            t !== !0 && e !== null && (n = r1.requestAnimationFrame(i), t = !0);
        },
        stop: function() {
            r1.cancelAnimationFrame(n), t = !1;
        },
        setAnimationLoop: function(s) {
            e = s;
        },
        setContext: function(s) {
            r1 = s;
        }
    };
}
function fR(r1, t) {
    let e = t.isWebGL2, n = new WeakMap;
    function i(u, c) {
        let d = u.array, h = u.usage, f = r1.createBuffer();
        r1.bindBuffer(c, f), r1.bufferData(c, d, h), u.onUploadCallback();
        let m;
        if (d instanceof Float32Array) m = 5126;
        else if (d instanceof Uint16Array) {
            if (u.isFloat16BufferAttribute) {
                if (e) m = 5131;
                else throw new Error("THREE.WebGLAttributes: Usage of Float16BufferAttribute requires WebGL2.");
            } else m = 5123;
        } else if (d instanceof Int16Array) m = 5122;
        else if (d instanceof Uint32Array) m = 5125;
        else if (d instanceof Int32Array) m = 5124;
        else if (d instanceof Int8Array) m = 5120;
        else if (d instanceof Uint8Array) m = 5121;
        else if (d instanceof Uint8ClampedArray) m = 5121;
        else throw new Error("THREE.WebGLAttributes: Unsupported buffer data format: " + d);
        return {
            buffer: f,
            type: m,
            bytesPerElement: d.BYTES_PER_ELEMENT,
            version: u.version
        };
    }
    function s(u, c, d) {
        let h = c.array, f = c.updateRange;
        r1.bindBuffer(d, u), f.count === -1 ? r1.bufferSubData(d, 0, h) : (e ? r1.bufferSubData(d, f.offset * h.BYTES_PER_ELEMENT, h, f.offset, f.count) : r1.bufferSubData(d, f.offset * h.BYTES_PER_ELEMENT, h.subarray(f.offset, f.offset + f.count)), f.count = -1), c.onUploadCallback();
    }
    function o(u) {
        return u.isInterleavedBufferAttribute && (u = u.data), n.get(u);
    }
    function a(u) {
        u.isInterleavedBufferAttribute && (u = u.data);
        let c = n.get(u);
        c && (r1.deleteBuffer(c.buffer), n.delete(u));
    }
    function l(u, c) {
        if (u.isGLBufferAttribute) {
            let h = n.get(u);
            (!h || h.version < u.version) && n.set(u, {
                buffer: u.buffer,
                type: u.type,
                bytesPerElement: u.elementSize,
                version: u.version
            });
            return;
        }
        u.isInterleavedBufferAttribute && (u = u.data);
        let d = n.get(u);
        d === void 0 ? n.set(u, i(u, c)) : d.version < u.version && (s(d.buffer, u, c), d.version = u.version);
    }
    return {
        get: o,
        remove: a,
        update: l
    };
}
var so = class extends Me {
    constructor(t = 1, e = 1, n = 1, i = 1){
        super(), this.type = "PlaneGeometry", this.parameters = {
            width: t,
            height: e,
            widthSegments: n,
            heightSegments: i
        };
        let s = t / 2, o = e / 2, a = Math.floor(n), l = Math.floor(i), u = a + 1, c = l + 1, d = t / a, h = e / l, f = [], m = [], p = [], g = [];
        for(let y = 0; y < c; y++){
            let v = y * h - o;
            for(let x = 0; x < u; x++){
                let w = x * d - s;
                m.push(w, -v, 0), p.push(0, 0, 1), g.push(x / a), g.push(1 - y / l);
            }
        }
        for(let y = 0; y < l; y++)for(let v = 0; v < a; v++){
            let x = v + u * y, w = v + u * (y + 1), S = v + 1 + u * (y + 1), _ = v + 1 + u * y;
            f.push(x, w, _), f.push(w, S, _);
        }
        this.setIndex(f), this.setAttribute("position", new Ae(m, 3)), this.setAttribute("normal", new Ae(p, 3)), this.setAttribute("uv", new Ae(g, 2));
    }
    static fromJSON(t) {
        return new so(t.width, t.height, t.widthSegments, t.heightSegments);
    }
}, pR = `#ifdef USE_ALPHAMAP
	diffuseColor.a *= texture2D( alphaMap, vUv ).g;
#endif`, mR = `#ifdef USE_ALPHAMAP
	uniform sampler2D alphaMap;
#endif`, gR = `#ifdef USE_ALPHATEST
	if ( diffuseColor.a < alphaTest ) discard;
#endif`, yR = `#ifdef USE_ALPHATEST
	uniform float alphaTest;
#endif`, vR = `#ifdef USE_AOMAP
	float ambientOcclusion = ( texture2D( aoMap, vUv2 ).r - 1.0 ) * aoMapIntensity + 1.0;
	reflectedLight.indirectDiffuse *= ambientOcclusion;
	#if defined( USE_ENVMAP ) && defined( STANDARD )
		float dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );
		reflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );
	#endif
#endif`, xR = `#ifdef USE_AOMAP
	uniform sampler2D aoMap;
	uniform float aoMapIntensity;
#endif`, bR = "vec3 transformed = vec3( position );", wR = `vec3 objectNormal = vec3( normal );
#ifdef USE_TANGENT
	vec3 objectTangent = vec3( tangent.xyz );
#endif`, SR = `vec3 BRDF_Lambert( const in vec3 diffuseColor ) {
	return RECIPROCAL_PI * diffuseColor;
}
vec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {
	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );
	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );
}
float F_Schlick( const in float f0, const in float f90, const in float dotVH ) {
	float fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );
	return f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );
}
vec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {
    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );
    float x2 = x * x;
    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );
    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );
}
float V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {
	float a2 = pow2( alpha );
	float gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );
	float gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );
	return 0.5 / max( gv + gl, EPSILON );
}
float D_GGX( const in float alpha, const in float dotNH ) {
	float a2 = pow2( alpha );
	float denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;
	return RECIPROCAL_PI * a2 / pow2( denom );
}
vec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 f0, const in float f90, const in float roughness ) {
	float alpha = pow2( roughness );
	vec3 halfDir = normalize( lightDir + viewDir );
	float dotNL = saturate( dot( normal, lightDir ) );
	float dotNV = saturate( dot( normal, viewDir ) );
	float dotNH = saturate( dot( normal, halfDir ) );
	float dotVH = saturate( dot( viewDir, halfDir ) );
	vec3 F = F_Schlick( f0, f90, dotVH );
	float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );
	float D = D_GGX( alpha, dotNH );
	return F * ( V * D );
}
#ifdef USE_IRIDESCENCE
	vec3 BRDF_GGX_Iridescence( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 f0, const in float f90, const in float iridescence, const in vec3 iridescenceFresnel, const in float roughness ) {
		float alpha = pow2( roughness );
		vec3 halfDir = normalize( lightDir + viewDir );
		float dotNL = saturate( dot( normal, lightDir ) );
		float dotNV = saturate( dot( normal, viewDir ) );
		float dotNH = saturate( dot( normal, halfDir ) );
		float dotVH = saturate( dot( viewDir, halfDir ) );
		vec3 F = mix( F_Schlick( f0, f90, dotVH ), iridescenceFresnel, iridescence );
		float V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );
		float D = D_GGX( alpha, dotNH );
		return F * ( V * D );
	}
#endif
vec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {
	const float LUT_SIZE = 64.0;
	const float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;
	const float LUT_BIAS = 0.5 / LUT_SIZE;
	float dotNV = saturate( dot( N, V ) );
	vec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );
	uv = uv * LUT_SCALE + LUT_BIAS;
	return uv;
}
float LTC_ClippedSphereFormFactor( const in vec3 f ) {
	float l = length( f );
	return max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );
}
vec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {
	float x = dot( v1, v2 );
	float y = abs( x );
	float a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;
	float b = 3.4175940 + ( 4.1616724 + y ) * y;
	float v = a / b;
	float theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;
	return cross( v1, v2 ) * theta_sintheta;
}
vec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {
	vec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];
	vec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];
	vec3 lightNormal = cross( v1, v2 );
	if( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );
	vec3 T1, T2;
	T1 = normalize( V - N * dot( V, N ) );
	T2 = - cross( N, T1 );
	mat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );
	vec3 coords[ 4 ];
	coords[ 0 ] = mat * ( rectCoords[ 0 ] - P );
	coords[ 1 ] = mat * ( rectCoords[ 1 ] - P );
	coords[ 2 ] = mat * ( rectCoords[ 2 ] - P );
	coords[ 3 ] = mat * ( rectCoords[ 3 ] - P );
	coords[ 0 ] = normalize( coords[ 0 ] );
	coords[ 1 ] = normalize( coords[ 1 ] );
	coords[ 2 ] = normalize( coords[ 2 ] );
	coords[ 3 ] = normalize( coords[ 3 ] );
	vec3 vectorFormFactor = vec3( 0.0 );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );
	vectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );
	float result = LTC_ClippedSphereFormFactor( vectorFormFactor );
	return vec3( result );
}
float G_BlinnPhong_Implicit( ) {
	return 0.25;
}
float D_BlinnPhong( const in float shininess, const in float dotNH ) {
	return RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );
}
vec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {
	vec3 halfDir = normalize( lightDir + viewDir );
	float dotNH = saturate( dot( normal, halfDir ) );
	float dotVH = saturate( dot( viewDir, halfDir ) );
	vec3 F = F_Schlick( specularColor, 1.0, dotVH );
	float G = G_BlinnPhong_Implicit( );
	float D = D_BlinnPhong( shininess, dotNH );
	return F * ( G * D );
}
#if defined( USE_SHEEN )
float D_Charlie( float roughness, float dotNH ) {
	float alpha = pow2( roughness );
	float invAlpha = 1.0 / alpha;
	float cos2h = dotNH * dotNH;
	float sin2h = max( 1.0 - cos2h, 0.0078125 );
	return ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );
}
float V_Neubelt( float dotNV, float dotNL ) {
	return saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );
}
vec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {
	vec3 halfDir = normalize( lightDir + viewDir );
	float dotNL = saturate( dot( normal, lightDir ) );
	float dotNV = saturate( dot( normal, viewDir ) );
	float dotNH = saturate( dot( normal, halfDir ) );
	float D = D_Charlie( sheenRoughness, dotNH );
	float V = V_Neubelt( dotNV, dotNL );
	return sheenColor * ( D * V );
}
#endif`, AR = `#ifdef USE_IRIDESCENCE
	const mat3 XYZ_TO_REC709 = mat3(
		 3.2404542, -0.9692660,  0.0556434,
		-1.5371385,  1.8760108, -0.2040259,
		-0.4985314,  0.0415560,  1.0572252
	);
	vec3 Fresnel0ToIor( vec3 fresnel0 ) {
		vec3 sqrtF0 = sqrt( fresnel0 );
		return ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );
	}
	vec3 IorToFresnel0( vec3 transmittedIor, float incidentIor ) {
		return pow2( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );
	}
	float IorToFresnel0( float transmittedIor, float incidentIor ) {
		return pow2( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ));
	}
	vec3 evalSensitivity( float OPD, vec3 shift ) {
		float phase = 2.0 * PI * OPD * 1.0e-9;
		vec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );
		vec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );
		vec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );
		vec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( - pow2( phase ) * var );
		xyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[ 0 ] ) * exp( - 4.5282e+09 * pow2( phase ) );
		xyz /= 1.0685e-7;
		vec3 rgb = XYZ_TO_REC709 * xyz;
		return rgb;
	}
	vec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {
		vec3 I;
		float iridescenceIOR = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );
		float sinTheta2Sq = pow2( outsideIOR / iridescenceIOR ) * ( 1.0 - pow2( cosTheta1 ) );
		float cosTheta2Sq = 1.0 - sinTheta2Sq;
		if ( cosTheta2Sq < 0.0 ) {
			 return vec3( 1.0 );
		}
		float cosTheta2 = sqrt( cosTheta2Sq );
		float R0 = IorToFresnel0( iridescenceIOR, outsideIOR );
		float R12 = F_Schlick( R0, 1.0, cosTheta1 );
		float R21 = R12;
		float T121 = 1.0 - R12;
		float phi12 = 0.0;
		if ( iridescenceIOR < outsideIOR ) phi12 = PI;
		float phi21 = PI - phi12;
		vec3 baseIOR = Fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) );		vec3 R1 = IorToFresnel0( baseIOR, iridescenceIOR );
		vec3 R23 = F_Schlick( R1, 1.0, cosTheta2 );
		vec3 phi23 = vec3( 0.0 );
		if ( baseIOR[ 0 ] < iridescenceIOR ) phi23[ 0 ] = PI;
		if ( baseIOR[ 1 ] < iridescenceIOR ) phi23[ 1 ] = PI;
		if ( baseIOR[ 2 ] < iridescenceIOR ) phi23[ 2 ] = PI;
		float OPD = 2.0 * iridescenceIOR * thinFilmThickness * cosTheta2;
		vec3 phi = vec3( phi21 ) + phi23;
		vec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );
		vec3 r123 = sqrt( R123 );
		vec3 Rs = pow2( T121 ) * R23 / ( vec3( 1.0 ) - R123 );
		vec3 C0 = R12 + Rs;
		I = C0;
		vec3 Cm = Rs - T121;
		for ( int m = 1; m <= 2; ++ m ) {
			Cm *= r123;
			vec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );
			I += Cm * Sm;
		}
		return max( I, vec3( 0.0 ) );
	}
#endif`, _R = `#ifdef USE_BUMPMAP
	uniform sampler2D bumpMap;
	uniform float bumpScale;
	vec2 dHdxy_fwd() {
		vec2 dSTdx = dFdx( vUv );
		vec2 dSTdy = dFdy( vUv );
		float Hll = bumpScale * texture2D( bumpMap, vUv ).x;
		float dBx = bumpScale * texture2D( bumpMap, vUv + dSTdx ).x - Hll;
		float dBy = bumpScale * texture2D( bumpMap, vUv + dSTdy ).x - Hll;
		return vec2( dBx, dBy );
	}
	vec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {
		vec3 vSigmaX = dFdx( surf_pos.xyz );
		vec3 vSigmaY = dFdy( surf_pos.xyz );
		vec3 vN = surf_norm;
		vec3 R1 = cross( vSigmaY, vN );
		vec3 R2 = cross( vN, vSigmaX );
		float fDet = dot( vSigmaX, R1 ) * faceDirection;
		vec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );
		return normalize( abs( fDet ) * surf_norm - vGrad );
	}
#endif`, MR = `#if NUM_CLIPPING_PLANES > 0
	vec4 plane;
	#pragma unroll_loop_start
	for ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {
		plane = clippingPlanes[ i ];
		if ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;
	}
	#pragma unroll_loop_end
	#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES
		bool clipped = true;
		#pragma unroll_loop_start
		for ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {
			plane = clippingPlanes[ i ];
			clipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;
		}
		#pragma unroll_loop_end
		if ( clipped ) discard;
	#endif
#endif`, TR = `#if NUM_CLIPPING_PLANES > 0
	varying vec3 vClipPosition;
	uniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];
#endif`, ER = `#if NUM_CLIPPING_PLANES > 0
	varying vec3 vClipPosition;
#endif`, CR = `#if NUM_CLIPPING_PLANES > 0
	vClipPosition = - mvPosition.xyz;
#endif`, PR = `#if defined( USE_COLOR_ALPHA )
	diffuseColor *= vColor;
#elif defined( USE_COLOR )
	diffuseColor.rgb *= vColor;
#endif`, DR = `#if defined( USE_COLOR_ALPHA )
	varying vec4 vColor;
#elif defined( USE_COLOR )
	varying vec3 vColor;
#endif`, IR = `#if defined( USE_COLOR_ALPHA )
	varying vec4 vColor;
#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )
	varying vec3 vColor;
#endif`, OR = `#if defined( USE_COLOR_ALPHA )
	vColor = vec4( 1.0 );
#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )
	vColor = vec3( 1.0 );
#endif
#ifdef USE_COLOR
	vColor *= color;
#endif
#ifdef USE_INSTANCING_COLOR
	vColor.xyz *= instanceColor.xyz;
#endif`, RR = `#define PI 3.141592653589793
#define PI2 6.283185307179586
#define PI_HALF 1.5707963267948966
#define RECIPROCAL_PI 0.3183098861837907
#define RECIPROCAL_PI2 0.15915494309189535
#define EPSILON 1e-6
#ifndef saturate
#define saturate( a ) clamp( a, 0.0, 1.0 )
#endif
#define whiteComplement( a ) ( 1.0 - saturate( a ) )
float pow2( const in float x ) { return x*x; }
vec3 pow2( const in vec3 x ) { return x*x; }
float pow3( const in float x ) { return x*x*x; }
float pow4( const in float x ) { float x2 = x*x; return x2*x2; }
float max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }
float average( const in vec3 v ) { return dot( v, vec3( 0.3333333 ) ); }
highp float rand( const in vec2 uv ) {
	const highp float a = 12.9898, b = 78.233, c = 43758.5453;
	highp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );
	return fract( sin( sn ) * c );
}
#ifdef HIGH_PRECISION
	float precisionSafeLength( vec3 v ) { return length( v ); }
#else
	float precisionSafeLength( vec3 v ) {
		float maxComponent = max3( abs( v ) );
		return length( v / maxComponent ) * maxComponent;
	}
#endif
struct IncidentLight {
	vec3 color;
	vec3 direction;
	bool visible;
};
struct ReflectedLight {
	vec3 directDiffuse;
	vec3 directSpecular;
	vec3 indirectDiffuse;
	vec3 indirectSpecular;
};
struct GeometricContext {
	vec3 position;
	vec3 normal;
	vec3 viewDir;
#ifdef USE_CLEARCOAT
	vec3 clearcoatNormal;
#endif
};
vec3 transformDirection( in vec3 dir, in mat4 matrix ) {
	return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );
}
vec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {
	return normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );
}
mat3 transposeMat3( const in mat3 m ) {
	mat3 tmp;
	tmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );
	tmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );
	tmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );
	return tmp;
}
float luminance( const in vec3 rgb ) {
	const vec3 weights = vec3( 0.2126729, 0.7151522, 0.0721750 );
	return dot( weights, rgb );
}
bool isPerspectiveMatrix( mat4 m ) {
	return m[ 2 ][ 3 ] == - 1.0;
}
vec2 equirectUv( in vec3 dir ) {
	float u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;
	float v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;
	return vec2( u, v );
}`, LR = `#ifdef ENVMAP_TYPE_CUBE_UV
	#define cubeUV_minMipLevel 4.0
	#define cubeUV_minTileSize 16.0
	float getFace( vec3 direction ) {
		vec3 absDirection = abs( direction );
		float face = - 1.0;
		if ( absDirection.x > absDirection.z ) {
			if ( absDirection.x > absDirection.y )
				face = direction.x > 0.0 ? 0.0 : 3.0;
			else
				face = direction.y > 0.0 ? 1.0 : 4.0;
		} else {
			if ( absDirection.z > absDirection.y )
				face = direction.z > 0.0 ? 2.0 : 5.0;
			else
				face = direction.y > 0.0 ? 1.0 : 4.0;
		}
		return face;
	}
	vec2 getUV( vec3 direction, float face ) {
		vec2 uv;
		if ( face == 0.0 ) {
			uv = vec2( direction.z, direction.y ) / abs( direction.x );
		} else if ( face == 1.0 ) {
			uv = vec2( - direction.x, - direction.z ) / abs( direction.y );
		} else if ( face == 2.0 ) {
			uv = vec2( - direction.x, direction.y ) / abs( direction.z );
		} else if ( face == 3.0 ) {
			uv = vec2( - direction.z, direction.y ) / abs( direction.x );
		} else if ( face == 4.0 ) {
			uv = vec2( - direction.x, direction.z ) / abs( direction.y );
		} else {
			uv = vec2( direction.x, direction.y ) / abs( direction.z );
		}
		return 0.5 * ( uv + 1.0 );
	}
	vec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {
		float face = getFace( direction );
		float filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );
		mipInt = max( mipInt, cubeUV_minMipLevel );
		float faceSize = exp2( mipInt );
		highp vec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0;
		if ( face > 2.0 ) {
			uv.y += faceSize;
			face -= 3.0;
		}
		uv.x += face * faceSize;
		uv.x += filterInt * 3.0 * cubeUV_minTileSize;
		uv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );
		uv.x *= CUBEUV_TEXEL_WIDTH;
		uv.y *= CUBEUV_TEXEL_HEIGHT;
		#ifdef texture2DGradEXT
			return texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;
		#else
			return texture2D( envMap, uv ).rgb;
		#endif
	}
	#define cubeUV_r0 1.0
	#define cubeUV_v0 0.339
	#define cubeUV_m0 - 2.0
	#define cubeUV_r1 0.8
	#define cubeUV_v1 0.276
	#define cubeUV_m1 - 1.0
	#define cubeUV_r4 0.4
	#define cubeUV_v4 0.046
	#define cubeUV_m4 2.0
	#define cubeUV_r5 0.305
	#define cubeUV_v5 0.016
	#define cubeUV_m5 3.0
	#define cubeUV_r6 0.21
	#define cubeUV_v6 0.0038
	#define cubeUV_m6 4.0
	float roughnessToMip( float roughness ) {
		float mip = 0.0;
		if ( roughness >= cubeUV_r1 ) {
			mip = ( cubeUV_r0 - roughness ) * ( cubeUV_m1 - cubeUV_m0 ) / ( cubeUV_r0 - cubeUV_r1 ) + cubeUV_m0;
		} else if ( roughness >= cubeUV_r4 ) {
			mip = ( cubeUV_r1 - roughness ) * ( cubeUV_m4 - cubeUV_m1 ) / ( cubeUV_r1 - cubeUV_r4 ) + cubeUV_m1;
		} else if ( roughness >= cubeUV_r5 ) {
			mip = ( cubeUV_r4 - roughness ) * ( cubeUV_m5 - cubeUV_m4 ) / ( cubeUV_r4 - cubeUV_r5 ) + cubeUV_m4;
		} else if ( roughness >= cubeUV_r6 ) {
			mip = ( cubeUV_r5 - roughness ) * ( cubeUV_m6 - cubeUV_m5 ) / ( cubeUV_r5 - cubeUV_r6 ) + cubeUV_m5;
		} else {
			mip = - 2.0 * log2( 1.16 * roughness );		}
		return mip;
	}
	vec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {
		float mip = clamp( roughnessToMip( roughness ), cubeUV_m0, CUBEUV_MAX_MIP );
		float mipF = fract( mip );
		float mipInt = floor( mip );
		vec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );
		if ( mipF == 0.0 ) {
			return vec4( color0, 1.0 );
		} else {
			vec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );
			return vec4( mix( color0, color1, mipF ), 1.0 );
		}
	}
#endif`, NR = `vec3 transformedNormal = objectNormal;
#ifdef USE_INSTANCING
	mat3 m = mat3( instanceMatrix );
	transformedNormal /= vec3( dot( m[ 0 ], m[ 0 ] ), dot( m[ 1 ], m[ 1 ] ), dot( m[ 2 ], m[ 2 ] ) );
	transformedNormal = m * transformedNormal;
#endif
transformedNormal = normalMatrix * transformedNormal;
#ifdef FLIP_SIDED
	transformedNormal = - transformedNormal;
#endif
#ifdef USE_TANGENT
	vec3 transformedTangent = ( modelViewMatrix * vec4( objectTangent, 0.0 ) ).xyz;
	#ifdef FLIP_SIDED
		transformedTangent = - transformedTangent;
	#endif
#endif`, BR = `#ifdef USE_DISPLACEMENTMAP
	uniform sampler2D displacementMap;
	uniform float displacementScale;
	uniform float displacementBias;
#endif`, FR = `#ifdef USE_DISPLACEMENTMAP
	transformed += normalize( objectNormal ) * ( texture2D( displacementMap, vUv ).x * displacementScale + displacementBias );
#endif`, UR = `#ifdef USE_EMISSIVEMAP
	vec4 emissiveColor = texture2D( emissiveMap, vUv );
	totalEmissiveRadiance *= emissiveColor.rgb;
#endif`, kR = `#ifdef USE_EMISSIVEMAP
	uniform sampler2D emissiveMap;
#endif`, zR = "gl_FragColor = linearToOutputTexel( gl_FragColor );", GR = `vec4 LinearToLinear( in vec4 value ) {
	return value;
}
vec4 LinearTosRGB( in vec4 value ) {
	return vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );
}`, VR = `#ifdef USE_ENVMAP
	#ifdef ENV_WORLDPOS
		vec3 cameraToFrag;
		if ( isOrthographic ) {
			cameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );
		} else {
			cameraToFrag = normalize( vWorldPosition - cameraPosition );
		}
		vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );
		#ifdef ENVMAP_MODE_REFLECTION
			vec3 reflectVec = reflect( cameraToFrag, worldNormal );
		#else
			vec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );
		#endif
	#else
		vec3 reflectVec = vReflect;
	#endif
	#ifdef ENVMAP_TYPE_CUBE
		vec4 envColor = textureCube( envMap, vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );
	#else
		vec4 envColor = vec4( 0.0 );
	#endif
	#ifdef ENVMAP_BLENDING_MULTIPLY
		outgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );
	#elif defined( ENVMAP_BLENDING_MIX )
		outgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );
	#elif defined( ENVMAP_BLENDING_ADD )
		outgoingLight += envColor.xyz * specularStrength * reflectivity;
	#endif
#endif`, HR = `#ifdef USE_ENVMAP
	uniform float envMapIntensity;
	uniform float flipEnvMap;
	#ifdef ENVMAP_TYPE_CUBE
		uniform samplerCube envMap;
	#else
		uniform sampler2D envMap;
	#endif
	
#endif`, WR = `#ifdef USE_ENVMAP
	uniform float reflectivity;
	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )
		#define ENV_WORLDPOS
	#endif
	#ifdef ENV_WORLDPOS
		varying vec3 vWorldPosition;
		uniform float refractionRatio;
	#else
		varying vec3 vReflect;
	#endif
#endif`, jR = `#ifdef USE_ENVMAP
	#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )
		#define ENV_WORLDPOS
	#endif
	#ifdef ENV_WORLDPOS
		
		varying vec3 vWorldPosition;
	#else
		varying vec3 vReflect;
		uniform float refractionRatio;
	#endif
#endif`, qR = `#ifdef USE_ENVMAP
	#ifdef ENV_WORLDPOS
		vWorldPosition = worldPosition.xyz;
	#else
		vec3 cameraToVertex;
		if ( isOrthographic ) {
			cameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );
		} else {
			cameraToVertex = normalize( worldPosition.xyz - cameraPosition );
		}
		vec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );
		#ifdef ENVMAP_MODE_REFLECTION
			vReflect = reflect( cameraToVertex, worldNormal );
		#else
			vReflect = refract( cameraToVertex, worldNormal, refractionRatio );
		#endif
	#endif
#endif`, XR = `#ifdef USE_FOG
	vFogDepth = - mvPosition.z;
#endif`, YR = `#ifdef USE_FOG
	varying float vFogDepth;
#endif`, QR = `#ifdef USE_FOG
	#ifdef FOG_EXP2
		float fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );
	#else
		float fogFactor = smoothstep( fogNear, fogFar, vFogDepth );
	#endif
	gl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );
#endif`, KR = `#ifdef USE_FOG
	uniform vec3 fogColor;
	varying float vFogDepth;
	#ifdef FOG_EXP2
		uniform float fogDensity;
	#else
		uniform float fogNear;
		uniform float fogFar;
	#endif
#endif`, ZR = `#ifdef USE_GRADIENTMAP
	uniform sampler2D gradientMap;
#endif
vec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {
	float dotNL = dot( normal, lightDirection );
	vec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );
	#ifdef USE_GRADIENTMAP
		return vec3( texture2D( gradientMap, coord ).r );
	#else
		vec2 fw = fwidth( coord ) * 0.5;
		return mix( vec3( 0.7 ), vec3( 1.0 ), smoothstep( 0.7 - fw.x, 0.7 + fw.x, coord.x ) );
	#endif
}`, JR = `#ifdef USE_LIGHTMAP
	vec4 lightMapTexel = texture2D( lightMap, vUv2 );
	vec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;
	reflectedLight.indirectDiffuse += lightMapIrradiance;
#endif`, $R = `#ifdef USE_LIGHTMAP
	uniform sampler2D lightMap;
	uniform float lightMapIntensity;
#endif`, eL = `LambertMaterial material;
material.diffuseColor = diffuseColor.rgb;
material.specularStrength = specularStrength;`, tL = `varying vec3 vViewPosition;
struct LambertMaterial {
	vec3 diffuseColor;
	float specularStrength;
};
void RE_Direct_Lambert( const in IncidentLight directLight, const in GeometricContext geometry, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {
	float dotNL = saturate( dot( geometry.normal, directLight.direction ) );
	vec3 irradiance = dotNL * directLight.color;
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
void RE_IndirectDiffuse_Lambert( const in vec3 irradiance, const in GeometricContext geometry, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {
	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
#define RE_Direct				RE_Direct_Lambert
#define RE_IndirectDiffuse		RE_IndirectDiffuse_Lambert`, nL = `uniform bool receiveShadow;
uniform vec3 ambientLightColor;
uniform vec3 lightProbe[ 9 ];
vec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {
	float x = normal.x, y = normal.y, z = normal.z;
	vec3 result = shCoefficients[ 0 ] * 0.886227;
	result += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;
	result += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;
	result += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;
	result += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;
	result += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;
	result += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );
	result += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;
	result += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );
	return result;
}
vec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {
	vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );
	vec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );
	return irradiance;
}
vec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {
	vec3 irradiance = ambientLightColor;
	return irradiance;
}
float getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {
	#if defined ( PHYSICALLY_CORRECT_LIGHTS )
		float distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );
		if ( cutoffDistance > 0.0 ) {
			distanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );
		}
		return distanceFalloff;
	#else
		if ( cutoffDistance > 0.0 && decayExponent > 0.0 ) {
			return pow( saturate( - lightDistance / cutoffDistance + 1.0 ), decayExponent );
		}
		return 1.0;
	#endif
}
float getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {
	return smoothstep( coneCosine, penumbraCosine, angleCosine );
}
#if NUM_DIR_LIGHTS > 0
	struct DirectionalLight {
		vec3 direction;
		vec3 color;
	};
	uniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];
	void getDirectionalLightInfo( const in DirectionalLight directionalLight, const in GeometricContext geometry, out IncidentLight light ) {
		light.color = directionalLight.color;
		light.direction = directionalLight.direction;
		light.visible = true;
	}
#endif
#if NUM_POINT_LIGHTS > 0
	struct PointLight {
		vec3 position;
		vec3 color;
		float distance;
		float decay;
	};
	uniform PointLight pointLights[ NUM_POINT_LIGHTS ];
	void getPointLightInfo( const in PointLight pointLight, const in GeometricContext geometry, out IncidentLight light ) {
		vec3 lVector = pointLight.position - geometry.position;
		light.direction = normalize( lVector );
		float lightDistance = length( lVector );
		light.color = pointLight.color;
		light.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );
		light.visible = ( light.color != vec3( 0.0 ) );
	}
#endif
#if NUM_SPOT_LIGHTS > 0
	struct SpotLight {
		vec3 position;
		vec3 direction;
		vec3 color;
		float distance;
		float decay;
		float coneCos;
		float penumbraCos;
	};
	uniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];
	void getSpotLightInfo( const in SpotLight spotLight, const in GeometricContext geometry, out IncidentLight light ) {
		vec3 lVector = spotLight.position - geometry.position;
		light.direction = normalize( lVector );
		float angleCos = dot( light.direction, spotLight.direction );
		float spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );
		if ( spotAttenuation > 0.0 ) {
			float lightDistance = length( lVector );
			light.color = spotLight.color * spotAttenuation;
			light.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );
			light.visible = ( light.color != vec3( 0.0 ) );
		} else {
			light.color = vec3( 0.0 );
			light.visible = false;
		}
	}
#endif
#if NUM_RECT_AREA_LIGHTS > 0
	struct RectAreaLight {
		vec3 color;
		vec3 position;
		vec3 halfWidth;
		vec3 halfHeight;
	};
	uniform sampler2D ltc_1;	uniform sampler2D ltc_2;
	uniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];
#endif
#if NUM_HEMI_LIGHTS > 0
	struct HemisphereLight {
		vec3 direction;
		vec3 skyColor;
		vec3 groundColor;
	};
	uniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];
	vec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {
		float dotNL = dot( normal, hemiLight.direction );
		float hemiDiffuseWeight = 0.5 * dotNL + 0.5;
		vec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );
		return irradiance;
	}
#endif`, rL = `#if defined( USE_ENVMAP )
	vec3 getIBLIrradiance( const in vec3 normal ) {
		#if defined( ENVMAP_TYPE_CUBE_UV )
			vec3 worldNormal = inverseTransformDirection( normal, viewMatrix );
			vec4 envMapColor = textureCubeUV( envMap, worldNormal, 1.0 );
			return PI * envMapColor.rgb * envMapIntensity;
		#else
			return vec3( 0.0 );
		#endif
	}
	vec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {
		#if defined( ENVMAP_TYPE_CUBE_UV )
			vec3 reflectVec = reflect( - viewDir, normal );
			reflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );
			reflectVec = inverseTransformDirection( reflectVec, viewMatrix );
			vec4 envMapColor = textureCubeUV( envMap, reflectVec, roughness );
			return envMapColor.rgb * envMapIntensity;
		#else
			return vec3( 0.0 );
		#endif
	}
#endif`, iL = `ToonMaterial material;
material.diffuseColor = diffuseColor.rgb;`, sL = `varying vec3 vViewPosition;
struct ToonMaterial {
	vec3 diffuseColor;
};
void RE_Direct_Toon( const in IncidentLight directLight, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {
	vec3 irradiance = getGradientIrradiance( geometry.normal, directLight.direction ) * directLight.color;
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
void RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {
	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
#define RE_Direct				RE_Direct_Toon
#define RE_IndirectDiffuse		RE_IndirectDiffuse_Toon`, oL = `BlinnPhongMaterial material;
material.diffuseColor = diffuseColor.rgb;
material.specularColor = specular;
material.specularShininess = shininess;
material.specularStrength = specularStrength;`, aL = `varying vec3 vViewPosition;
struct BlinnPhongMaterial {
	vec3 diffuseColor;
	vec3 specularColor;
	float specularShininess;
	float specularStrength;
};
void RE_Direct_BlinnPhong( const in IncidentLight directLight, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {
	float dotNL = saturate( dot( geometry.normal, directLight.direction ) );
	vec3 irradiance = dotNL * directLight.color;
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
	reflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometry.viewDir, geometry.normal, material.specularColor, material.specularShininess ) * material.specularStrength;
}
void RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {
	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
#define RE_Direct				RE_Direct_BlinnPhong
#define RE_IndirectDiffuse		RE_IndirectDiffuse_BlinnPhong`, lL = `PhysicalMaterial material;
material.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );
vec3 dxy = max( abs( dFdx( geometryNormal ) ), abs( dFdy( geometryNormal ) ) );
float geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );
material.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;
material.roughness = min( material.roughness, 1.0 );
#ifdef IOR
	material.ior = ior;
	#ifdef SPECULAR
		float specularIntensityFactor = specularIntensity;
		vec3 specularColorFactor = specularColor;
		#ifdef USE_SPECULARINTENSITYMAP
			specularIntensityFactor *= texture2D( specularIntensityMap, vUv ).a;
		#endif
		#ifdef USE_SPECULARCOLORMAP
			specularColorFactor *= texture2D( specularColorMap, vUv ).rgb;
		#endif
		material.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );
	#else
		float specularIntensityFactor = 1.0;
		vec3 specularColorFactor = vec3( 1.0 );
		material.specularF90 = 1.0;
	#endif
	material.specularColor = mix( min( pow2( ( material.ior - 1.0 ) / ( material.ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor, diffuseColor.rgb, metalnessFactor );
#else
	material.specularColor = mix( vec3( 0.04 ), diffuseColor.rgb, metalnessFactor );
	material.specularF90 = 1.0;
#endif
#ifdef USE_CLEARCOAT
	material.clearcoat = clearcoat;
	material.clearcoatRoughness = clearcoatRoughness;
	material.clearcoatF0 = vec3( 0.04 );
	material.clearcoatF90 = 1.0;
	#ifdef USE_CLEARCOATMAP
		material.clearcoat *= texture2D( clearcoatMap, vUv ).x;
	#endif
	#ifdef USE_CLEARCOAT_ROUGHNESSMAP
		material.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vUv ).y;
	#endif
	material.clearcoat = saturate( material.clearcoat );	material.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );
	material.clearcoatRoughness += geometryRoughness;
	material.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );
#endif
#ifdef USE_IRIDESCENCE
	material.iridescence = iridescence;
	material.iridescenceIOR = iridescenceIOR;
	#ifdef USE_IRIDESCENCEMAP
		material.iridescence *= texture2D( iridescenceMap, vUv ).r;
	#endif
	#ifdef USE_IRIDESCENCE_THICKNESSMAP
		material.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vUv ).g + iridescenceThicknessMinimum;
	#else
		material.iridescenceThickness = iridescenceThicknessMaximum;
	#endif
#endif
#ifdef USE_SHEEN
	material.sheenColor = sheenColor;
	#ifdef USE_SHEENCOLORMAP
		material.sheenColor *= texture2D( sheenColorMap, vUv ).rgb;
	#endif
	material.sheenRoughness = clamp( sheenRoughness, 0.07, 1.0 );
	#ifdef USE_SHEENROUGHNESSMAP
		material.sheenRoughness *= texture2D( sheenRoughnessMap, vUv ).a;
	#endif
#endif`, cL = `struct PhysicalMaterial {
	vec3 diffuseColor;
	float roughness;
	vec3 specularColor;
	float specularF90;
	#ifdef USE_CLEARCOAT
		float clearcoat;
		float clearcoatRoughness;
		vec3 clearcoatF0;
		float clearcoatF90;
	#endif
	#ifdef USE_IRIDESCENCE
		float iridescence;
		float iridescenceIOR;
		float iridescenceThickness;
		vec3 iridescenceFresnel;
		vec3 iridescenceF0;
	#endif
	#ifdef USE_SHEEN
		vec3 sheenColor;
		float sheenRoughness;
	#endif
	#ifdef IOR
		float ior;
	#endif
	#ifdef USE_TRANSMISSION
		float transmission;
		float transmissionAlpha;
		float thickness;
		float attenuationDistance;
		vec3 attenuationColor;
	#endif
};
vec3 clearcoatSpecular = vec3( 0.0 );
vec3 sheenSpecular = vec3( 0.0 );
float IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {
	float dotNV = saturate( dot( normal, viewDir ) );
	float r2 = roughness * roughness;
	float a = roughness < 0.25 ? -339.2 * r2 + 161.4 * roughness - 25.9 : -8.48 * r2 + 14.3 * roughness - 9.95;
	float b = roughness < 0.25 ? 44.0 * r2 - 23.7 * roughness + 3.26 : 1.97 * r2 - 3.27 * roughness + 0.72;
	float DG = exp( a * dotNV + b ) + ( roughness < 0.25 ? 0.0 : 0.1 * ( roughness - 0.25 ) );
	return saturate( DG * RECIPROCAL_PI );
}
vec2 DFGApprox( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {
	float dotNV = saturate( dot( normal, viewDir ) );
	const vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );
	const vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );
	vec4 r = roughness * c0 + c1;
	float a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;
	vec2 fab = vec2( - 1.04, 1.04 ) * a004 + r.zw;
	return fab;
}
vec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {
	vec2 fab = DFGApprox( normal, viewDir, roughness );
	return specularColor * fab.x + specularF90 * fab.y;
}
#ifdef USE_IRIDESCENCE
void computeMultiscatteringIridescence( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {
#else
void computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {
#endif
	vec2 fab = DFGApprox( normal, viewDir, roughness );
	#ifdef USE_IRIDESCENCE
		vec3 Fr = mix( specularColor, iridescenceF0, iridescence );
	#else
		vec3 Fr = specularColor;
	#endif
	vec3 FssEss = Fr * fab.x + specularF90 * fab.y;
	float Ess = fab.x + fab.y;
	float Ems = 1.0 - Ess;
	vec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619;	vec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );
	singleScatter += FssEss;
	multiScatter += Fms * Ems;
}
#if NUM_RECT_AREA_LIGHTS > 0
	void RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {
		vec3 normal = geometry.normal;
		vec3 viewDir = geometry.viewDir;
		vec3 position = geometry.position;
		vec3 lightPos = rectAreaLight.position;
		vec3 halfWidth = rectAreaLight.halfWidth;
		vec3 halfHeight = rectAreaLight.halfHeight;
		vec3 lightColor = rectAreaLight.color;
		float roughness = material.roughness;
		vec3 rectCoords[ 4 ];
		rectCoords[ 0 ] = lightPos + halfWidth - halfHeight;		rectCoords[ 1 ] = lightPos - halfWidth - halfHeight;
		rectCoords[ 2 ] = lightPos - halfWidth + halfHeight;
		rectCoords[ 3 ] = lightPos + halfWidth + halfHeight;
		vec2 uv = LTC_Uv( normal, viewDir, roughness );
		vec4 t1 = texture2D( ltc_1, uv );
		vec4 t2 = texture2D( ltc_2, uv );
		mat3 mInv = mat3(
			vec3( t1.x, 0, t1.y ),
			vec3(    0, 1,    0 ),
			vec3( t1.z, 0, t1.w )
		);
		vec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );
		reflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );
		reflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );
	}
#endif
void RE_Direct_Physical( const in IncidentLight directLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {
	float dotNL = saturate( dot( geometry.normal, directLight.direction ) );
	vec3 irradiance = dotNL * directLight.color;
	#ifdef USE_CLEARCOAT
		float dotNLcc = saturate( dot( geometry.clearcoatNormal, directLight.direction ) );
		vec3 ccIrradiance = dotNLcc * directLight.color;
		clearcoatSpecular += ccIrradiance * BRDF_GGX( directLight.direction, geometry.viewDir, geometry.clearcoatNormal, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );
	#endif
	#ifdef USE_SHEEN
		sheenSpecular += irradiance * BRDF_Sheen( directLight.direction, geometry.viewDir, geometry.normal, material.sheenColor, material.sheenRoughness );
	#endif
	#ifdef USE_IRIDESCENCE
		reflectedLight.directSpecular += irradiance * BRDF_GGX_Iridescence( directLight.direction, geometry.viewDir, geometry.normal, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnel, material.roughness );
	#else
		reflectedLight.directSpecular += irradiance * BRDF_GGX( directLight.direction, geometry.viewDir, geometry.normal, material.specularColor, material.specularF90, material.roughness );
	#endif
	reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
void RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {
	reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
}
void RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {
	#ifdef USE_CLEARCOAT
		clearcoatSpecular += clearcoatRadiance * EnvironmentBRDF( geometry.clearcoatNormal, geometry.viewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );
	#endif
	#ifdef USE_SHEEN
		sheenSpecular += irradiance * material.sheenColor * IBLSheenBRDF( geometry.normal, geometry.viewDir, material.sheenRoughness );
	#endif
	vec3 singleScattering = vec3( 0.0 );
	vec3 multiScattering = vec3( 0.0 );
	vec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;
	#ifdef USE_IRIDESCENCE
		computeMultiscatteringIridescence( geometry.normal, geometry.viewDir, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnel, material.roughness, singleScattering, multiScattering );
	#else
		computeMultiscattering( geometry.normal, geometry.viewDir, material.specularColor, material.specularF90, material.roughness, singleScattering, multiScattering );
	#endif
	vec3 totalScattering = singleScattering + multiScattering;
	vec3 diffuse = material.diffuseColor * ( 1.0 - max( max( totalScattering.r, totalScattering.g ), totalScattering.b ) );
	reflectedLight.indirectSpecular += radiance * singleScattering;
	reflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;
	reflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;
}
#define RE_Direct				RE_Direct_Physical
#define RE_Direct_RectArea		RE_Direct_RectArea_Physical
#define RE_IndirectDiffuse		RE_IndirectDiffuse_Physical
#define RE_IndirectSpecular		RE_IndirectSpecular_Physical
float computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {
	return saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );
}`, uL = `
GeometricContext geometry;
geometry.position = - vViewPosition;
geometry.normal = normal;
geometry.viewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );
#ifdef USE_CLEARCOAT
	geometry.clearcoatNormal = clearcoatNormal;
#endif
#ifdef USE_IRIDESCENCE
	float dotNVi = saturate( dot( normal, geometry.viewDir ) );
	if ( material.iridescenceThickness == 0.0 ) {
		material.iridescence = 0.0;
	} else {
		material.iridescence = saturate( material.iridescence );
	}
	if ( material.iridescence > 0.0 ) {
		material.iridescenceFresnel = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.specularColor );
		material.iridescenceF0 = Schlick_to_F0( material.iridescenceFresnel, 1.0, dotNVi );
	}
#endif
IncidentLight directLight;
#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )
	PointLight pointLight;
	#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0
	PointLightShadow pointLightShadow;
	#endif
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {
		pointLight = pointLights[ i ];
		getPointLightInfo( pointLight, geometry, directLight );
		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )
		pointLightShadow = pointLightShadows[ i ];
		directLight.color *= ( directLight.visible && receiveShadow ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;
		#endif
		RE_Direct( directLight, geometry, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )
	SpotLight spotLight;
	vec4 spotColor;
	vec3 spotLightCoord;
	bool inSpotLightMap;
	#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0
	SpotLightShadow spotLightShadow;
	#endif
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {
		spotLight = spotLights[ i ];
		getSpotLightInfo( spotLight, geometry, directLight );
		#if ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )
		#define SPOT_LIGHT_MAP_INDEX UNROLLED_LOOP_INDEX
		#elif ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )
		#define SPOT_LIGHT_MAP_INDEX NUM_SPOT_LIGHT_MAPS
		#else
		#define SPOT_LIGHT_MAP_INDEX ( UNROLLED_LOOP_INDEX - NUM_SPOT_LIGHT_SHADOWS + NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )
		#endif
		#if ( SPOT_LIGHT_MAP_INDEX < NUM_SPOT_LIGHT_MAPS )
			spotLightCoord = vSpotLightCoord[ i ].xyz / vSpotLightCoord[ i ].w;
			inSpotLightMap = all( lessThan( abs( spotLightCoord * 2. - 1. ), vec3( 1.0 ) ) );
			spotColor = texture2D( spotLightMap[ SPOT_LIGHT_MAP_INDEX ], spotLightCoord.xy );
			directLight.color = inSpotLightMap ? directLight.color * spotColor.rgb : directLight.color;
		#endif
		#undef SPOT_LIGHT_MAP_INDEX
		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )
		spotLightShadow = spotLightShadows[ i ];
		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;
		#endif
		RE_Direct( directLight, geometry, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )
	DirectionalLight directionalLight;
	#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0
	DirectionalLightShadow directionalLightShadow;
	#endif
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {
		directionalLight = directionalLights[ i ];
		getDirectionalLightInfo( directionalLight, geometry, directLight );
		#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )
		directionalLightShadow = directionalLightShadows[ i ];
		directLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;
		#endif
		RE_Direct( directLight, geometry, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )
	RectAreaLight rectAreaLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {
		rectAreaLight = rectAreaLights[ i ];
		RE_Direct_RectArea( rectAreaLight, geometry, material, reflectedLight );
	}
	#pragma unroll_loop_end
#endif
#if defined( RE_IndirectDiffuse )
	vec3 iblIrradiance = vec3( 0.0 );
	vec3 irradiance = getAmbientLightIrradiance( ambientLightColor );
	irradiance += getLightProbeIrradiance( lightProbe, geometry.normal );
	#if ( NUM_HEMI_LIGHTS > 0 )
		#pragma unroll_loop_start
		for ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {
			irradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry.normal );
		}
		#pragma unroll_loop_end
	#endif
#endif
#if defined( RE_IndirectSpecular )
	vec3 radiance = vec3( 0.0 );
	vec3 clearcoatRadiance = vec3( 0.0 );
#endif`, dL = `#if defined( RE_IndirectDiffuse )
	#ifdef USE_LIGHTMAP
		vec4 lightMapTexel = texture2D( lightMap, vUv2 );
		vec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;
		irradiance += lightMapIrradiance;
	#endif
	#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )
		iblIrradiance += getIBLIrradiance( geometry.normal );
	#endif
#endif
#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )
	radiance += getIBLRadiance( geometry.viewDir, geometry.normal, material.roughness );
	#ifdef USE_CLEARCOAT
		clearcoatRadiance += getIBLRadiance( geometry.viewDir, geometry.clearcoatNormal, material.clearcoatRoughness );
	#endif
#endif`, hL = `#if defined( RE_IndirectDiffuse )
	RE_IndirectDiffuse( irradiance, geometry, material, reflectedLight );
#endif
#if defined( RE_IndirectSpecular )
	RE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometry, material, reflectedLight );
#endif`, fL = `#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )
	gl_FragDepthEXT = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;
#endif`, pL = `#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )
	uniform float logDepthBufFC;
	varying float vFragDepth;
	varying float vIsPerspective;
#endif`, mL = `#ifdef USE_LOGDEPTHBUF
	#ifdef USE_LOGDEPTHBUF_EXT
		varying float vFragDepth;
		varying float vIsPerspective;
	#else
		uniform float logDepthBufFC;
	#endif
#endif`, gL = `#ifdef USE_LOGDEPTHBUF
	#ifdef USE_LOGDEPTHBUF_EXT
		vFragDepth = 1.0 + gl_Position.w;
		vIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );
	#else
		if ( isPerspectiveMatrix( projectionMatrix ) ) {
			gl_Position.z = log2( max( EPSILON, gl_Position.w + 1.0 ) ) * logDepthBufFC - 1.0;
			gl_Position.z *= gl_Position.w;
		}
	#endif
#endif`, yL = `#ifdef USE_MAP
	vec4 sampledDiffuseColor = texture2D( map, vUv );
	#ifdef DECODE_VIDEO_TEXTURE
		sampledDiffuseColor = vec4( mix( pow( sampledDiffuseColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), sampledDiffuseColor.rgb * 0.0773993808, vec3( lessThanEqual( sampledDiffuseColor.rgb, vec3( 0.04045 ) ) ) ), sampledDiffuseColor.w );
	#endif
	diffuseColor *= sampledDiffuseColor;
#endif`, vL = `#ifdef USE_MAP
	uniform sampler2D map;
#endif`, xL = `#if defined( USE_MAP ) || defined( USE_ALPHAMAP )
	vec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;
#endif
#ifdef USE_MAP
	diffuseColor *= texture2D( map, uv );
#endif
#ifdef USE_ALPHAMAP
	diffuseColor.a *= texture2D( alphaMap, uv ).g;
#endif`, bL = `#if defined( USE_MAP ) || defined( USE_ALPHAMAP )
	uniform mat3 uvTransform;
#endif
#ifdef USE_MAP
	uniform sampler2D map;
#endif
#ifdef USE_ALPHAMAP
	uniform sampler2D alphaMap;
#endif`, wL = `float metalnessFactor = metalness;
#ifdef USE_METALNESSMAP
	vec4 texelMetalness = texture2D( metalnessMap, vUv );
	metalnessFactor *= texelMetalness.b;
#endif`, SL = `#ifdef USE_METALNESSMAP
	uniform sampler2D metalnessMap;
#endif`, AL = `#if defined( USE_MORPHCOLORS ) && defined( MORPHTARGETS_TEXTURE )
	vColor *= morphTargetBaseInfluence;
	for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {
		#if defined( USE_COLOR_ALPHA )
			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];
		#elif defined( USE_COLOR )
			if ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];
		#endif
	}
#endif`, _L = `#ifdef USE_MORPHNORMALS
	objectNormal *= morphTargetBaseInfluence;
	#ifdef MORPHTARGETS_TEXTURE
		for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {
			if ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];
		}
	#else
		objectNormal += morphNormal0 * morphTargetInfluences[ 0 ];
		objectNormal += morphNormal1 * morphTargetInfluences[ 1 ];
		objectNormal += morphNormal2 * morphTargetInfluences[ 2 ];
		objectNormal += morphNormal3 * morphTargetInfluences[ 3 ];
	#endif
#endif`, ML = `#ifdef USE_MORPHTARGETS
	uniform float morphTargetBaseInfluence;
	#ifdef MORPHTARGETS_TEXTURE
		uniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];
		uniform sampler2DArray morphTargetsTexture;
		uniform ivec2 morphTargetsTextureSize;
		vec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {
			int texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;
			int y = texelIndex / morphTargetsTextureSize.x;
			int x = texelIndex - y * morphTargetsTextureSize.x;
			ivec3 morphUV = ivec3( x, y, morphTargetIndex );
			return texelFetch( morphTargetsTexture, morphUV, 0 );
		}
	#else
		#ifndef USE_MORPHNORMALS
			uniform float morphTargetInfluences[ 8 ];
		#else
			uniform float morphTargetInfluences[ 4 ];
		#endif
	#endif
#endif`, TL = `#ifdef USE_MORPHTARGETS
	transformed *= morphTargetBaseInfluence;
	#ifdef MORPHTARGETS_TEXTURE
		for ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {
			if ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];
		}
	#else
		transformed += morphTarget0 * morphTargetInfluences[ 0 ];
		transformed += morphTarget1 * morphTargetInfluences[ 1 ];
		transformed += morphTarget2 * morphTargetInfluences[ 2 ];
		transformed += morphTarget3 * morphTargetInfluences[ 3 ];
		#ifndef USE_MORPHNORMALS
			transformed += morphTarget4 * morphTargetInfluences[ 4 ];
			transformed += morphTarget5 * morphTargetInfluences[ 5 ];
			transformed += morphTarget6 * morphTargetInfluences[ 6 ];
			transformed += morphTarget7 * morphTargetInfluences[ 7 ];
		#endif
	#endif
#endif`, EL = `float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;
#ifdef FLAT_SHADED
	vec3 fdx = dFdx( vViewPosition );
	vec3 fdy = dFdy( vViewPosition );
	vec3 normal = normalize( cross( fdx, fdy ) );
#else
	vec3 normal = normalize( vNormal );
	#ifdef DOUBLE_SIDED
		normal = normal * faceDirection;
	#endif
	#ifdef USE_TANGENT
		vec3 tangent = normalize( vTangent );
		vec3 bitangent = normalize( vBitangent );
		#ifdef DOUBLE_SIDED
			tangent = tangent * faceDirection;
			bitangent = bitangent * faceDirection;
		#endif
		#if defined( TANGENTSPACE_NORMALMAP ) || defined( USE_CLEARCOAT_NORMALMAP )
			mat3 vTBN = mat3( tangent, bitangent, normal );
		#endif
	#endif
#endif
vec3 geometryNormal = normal;`, CL = `#ifdef OBJECTSPACE_NORMALMAP
	normal = texture2D( normalMap, vUv ).xyz * 2.0 - 1.0;
	#ifdef FLIP_SIDED
		normal = - normal;
	#endif
	#ifdef DOUBLE_SIDED
		normal = normal * faceDirection;
	#endif
	normal = normalize( normalMatrix * normal );
#elif defined( TANGENTSPACE_NORMALMAP )
	vec3 mapN = texture2D( normalMap, vUv ).xyz * 2.0 - 1.0;
	mapN.xy *= normalScale;
	#ifdef USE_TANGENT
		normal = normalize( vTBN * mapN );
	#else
		normal = perturbNormal2Arb( - vViewPosition, normal, mapN, faceDirection );
	#endif
#elif defined( USE_BUMPMAP )
	normal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );
#endif`, PL = `#ifndef FLAT_SHADED
	varying vec3 vNormal;
	#ifdef USE_TANGENT
		varying vec3 vTangent;
		varying vec3 vBitangent;
	#endif
#endif`, DL = `#ifndef FLAT_SHADED
	varying vec3 vNormal;
	#ifdef USE_TANGENT
		varying vec3 vTangent;
		varying vec3 vBitangent;
	#endif
#endif`, IL = `#ifndef FLAT_SHADED
	vNormal = normalize( transformedNormal );
	#ifdef USE_TANGENT
		vTangent = normalize( transformedTangent );
		vBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );
	#endif
#endif`, OL = `#ifdef USE_NORMALMAP
	uniform sampler2D normalMap;
	uniform vec2 normalScale;
#endif
#ifdef OBJECTSPACE_NORMALMAP
	uniform mat3 normalMatrix;
#endif
#if ! defined ( USE_TANGENT ) && ( defined ( TANGENTSPACE_NORMALMAP ) || defined ( USE_CLEARCOAT_NORMALMAP ) )
	vec3 perturbNormal2Arb( vec3 eye_pos, vec3 surf_norm, vec3 mapN, float faceDirection ) {
		vec3 q0 = dFdx( eye_pos.xyz );
		vec3 q1 = dFdy( eye_pos.xyz );
		vec2 st0 = dFdx( vUv.st );
		vec2 st1 = dFdy( vUv.st );
		vec3 N = surf_norm;
		vec3 q1perp = cross( q1, N );
		vec3 q0perp = cross( N, q0 );
		vec3 T = q1perp * st0.x + q0perp * st1.x;
		vec3 B = q1perp * st0.y + q0perp * st1.y;
		float det = max( dot( T, T ), dot( B, B ) );
		float scale = ( det == 0.0 ) ? 0.0 : faceDirection * inversesqrt( det );
		return normalize( T * ( mapN.x * scale ) + B * ( mapN.y * scale ) + N * mapN.z );
	}
#endif`, RL = `#ifdef USE_CLEARCOAT
	vec3 clearcoatNormal = geometryNormal;
#endif`, LL = `#ifdef USE_CLEARCOAT_NORMALMAP
	vec3 clearcoatMapN = texture2D( clearcoatNormalMap, vUv ).xyz * 2.0 - 1.0;
	clearcoatMapN.xy *= clearcoatNormalScale;
	#ifdef USE_TANGENT
		clearcoatNormal = normalize( vTBN * clearcoatMapN );
	#else
		clearcoatNormal = perturbNormal2Arb( - vViewPosition, clearcoatNormal, clearcoatMapN, faceDirection );
	#endif
#endif`, NL = `#ifdef USE_CLEARCOATMAP
	uniform sampler2D clearcoatMap;
#endif
#ifdef USE_CLEARCOAT_ROUGHNESSMAP
	uniform sampler2D clearcoatRoughnessMap;
#endif
#ifdef USE_CLEARCOAT_NORMALMAP
	uniform sampler2D clearcoatNormalMap;
	uniform vec2 clearcoatNormalScale;
#endif`, BL = `#ifdef USE_IRIDESCENCEMAP
	uniform sampler2D iridescenceMap;
#endif
#ifdef USE_IRIDESCENCE_THICKNESSMAP
	uniform sampler2D iridescenceThicknessMap;
#endif`, FL = `#ifdef OPAQUE
diffuseColor.a = 1.0;
#endif
#ifdef USE_TRANSMISSION
diffuseColor.a *= material.transmissionAlpha + 0.1;
#endif
gl_FragColor = vec4( outgoingLight, diffuseColor.a );`, UL = `vec3 packNormalToRGB( const in vec3 normal ) {
	return normalize( normal ) * 0.5 + 0.5;
}
vec3 unpackRGBToNormal( const in vec3 rgb ) {
	return 2.0 * rgb.xyz - 1.0;
}
const float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;
const vec3 PackFactors = vec3( 256. * 256. * 256., 256. * 256., 256. );
const vec4 UnpackFactors = UnpackDownscale / vec4( PackFactors, 1. );
const float ShiftRight8 = 1. / 256.;
vec4 packDepthToRGBA( const in float v ) {
	vec4 r = vec4( fract( v * PackFactors ), v );
	r.yzw -= r.xyz * ShiftRight8;	return r * PackUpscale;
}
float unpackRGBAToDepth( const in vec4 v ) {
	return dot( v, UnpackFactors );
}
vec2 packDepthToRG( in highp float v ) {
	return packDepthToRGBA( v ).yx;
}
float unpackRGToDepth( const in highp vec2 v ) {
	return unpackRGBAToDepth( vec4( v.xy, 0.0, 0.0 ) );
}
vec4 pack2HalfToRGBA( vec2 v ) {
	vec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );
	return vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );
}
vec2 unpackRGBATo2Half( vec4 v ) {
	return vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );
}
float viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {
	return ( viewZ + near ) / ( near - far );
}
float orthographicDepthToViewZ( const in float linearClipZ, const in float near, const in float far ) {
	return linearClipZ * ( near - far ) - near;
}
float viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {
	return ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );
}
float perspectiveDepthToViewZ( const in float invClipZ, const in float near, const in float far ) {
	return ( near * far ) / ( ( far - near ) * invClipZ - far );
}`, kL = `#ifdef PREMULTIPLIED_ALPHA
	gl_FragColor.rgb *= gl_FragColor.a;
#endif`, zL = `vec4 mvPosition = vec4( transformed, 1.0 );
#ifdef USE_INSTANCING
	mvPosition = instanceMatrix * mvPosition;
#endif
mvPosition = modelViewMatrix * mvPosition;
gl_Position = projectionMatrix * mvPosition;`, GL = `#ifdef DITHERING
	gl_FragColor.rgb = dithering( gl_FragColor.rgb );
#endif`, VL = `#ifdef DITHERING
	vec3 dithering( vec3 color ) {
		float grid_position = rand( gl_FragCoord.xy );
		vec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );
		dither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );
		return color + dither_shift_RGB;
	}
#endif`, HL = `float roughnessFactor = roughness;
#ifdef USE_ROUGHNESSMAP
	vec4 texelRoughness = texture2D( roughnessMap, vUv );
	roughnessFactor *= texelRoughness.g;
#endif`, WL = `#ifdef USE_ROUGHNESSMAP
	uniform sampler2D roughnessMap;
#endif`, jL = `#if NUM_SPOT_LIGHT_COORDS > 0
  varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];
#endif
#if NUM_SPOT_LIGHT_MAPS > 0
  uniform sampler2D spotLightMap[ NUM_SPOT_LIGHT_MAPS ];
#endif
#ifdef USE_SHADOWMAP
	#if NUM_DIR_LIGHT_SHADOWS > 0
		uniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];
		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];
		struct DirectionalLightShadow {
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];
	#endif
	#if NUM_SPOT_LIGHT_SHADOWS > 0
		uniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];
		struct SpotLightShadow {
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
		uniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];
		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];
		struct PointLightShadow {
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
			float shadowCameraNear;
			float shadowCameraFar;
		};
		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];
	#endif
	float texture2DCompare( sampler2D depths, vec2 uv, float compare ) {
		return step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );
	}
	vec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {
		return unpackRGBATo2Half( texture2D( shadow, uv ) );
	}
	float VSMShadow (sampler2D shadow, vec2 uv, float compare ){
		float occlusion = 1.0;
		vec2 distribution = texture2DDistribution( shadow, uv );
		float hard_shadow = step( compare , distribution.x );
		if (hard_shadow != 1.0 ) {
			float distance = compare - distribution.x ;
			float variance = max( 0.00000, distribution.y * distribution.y );
			float softness_probability = variance / (variance + distance * distance );			softness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );			occlusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );
		}
		return occlusion;
	}
	float getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord ) {
		float shadow = 1.0;
		shadowCoord.xyz /= shadowCoord.w;
		shadowCoord.z += shadowBias;
		bool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;
		bool frustumTest = inFrustum && shadowCoord.z <= 1.0;
		if ( frustumTest ) {
		#if defined( SHADOWMAP_TYPE_PCF )
			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;
			float dx0 = - texelSize.x * shadowRadius;
			float dy0 = - texelSize.y * shadowRadius;
			float dx1 = + texelSize.x * shadowRadius;
			float dy1 = + texelSize.y * shadowRadius;
			float dx2 = dx0 / 2.0;
			float dy2 = dy0 / 2.0;
			float dx3 = dx1 / 2.0;
			float dy3 = dy1 / 2.0;
			shadow = (
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )
			) * ( 1.0 / 17.0 );
		#elif defined( SHADOWMAP_TYPE_PCF_SOFT )
			vec2 texelSize = vec2( 1.0 ) / shadowMapSize;
			float dx = texelSize.x;
			float dy = texelSize.y;
			vec2 uv = shadowCoord.xy;
			vec2 f = fract( uv * shadowMapSize + 0.5 );
			uv -= f * texelSize;
			shadow = (
				texture2DCompare( shadowMap, uv, shadowCoord.z ) +
				texture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +
				texture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +
				texture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +
				mix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ),
					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),
					 f.x ) +
				mix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ),
					 texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),
					 f.x ) +
				mix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ),
					 texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),
					 f.y ) +
				mix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ),
					 texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),
					 f.y ) +
				mix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ),
						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),
						  f.x ),
					 mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ),
						  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),
						  f.x ),
					 f.y )
			) * ( 1.0 / 9.0 );
		#elif defined( SHADOWMAP_TYPE_VSM )
			shadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );
		#else
			shadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );
		#endif
		}
		return shadow;
	}
	vec2 cubeToUV( vec3 v, float texelSizeY ) {
		vec3 absV = abs( v );
		float scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );
		absV *= scaleToCube;
		v *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );
		vec2 planar = v.xy;
		float almostATexel = 1.5 * texelSizeY;
		float almostOne = 1.0 - almostATexel;
		if ( absV.z >= almostOne ) {
			if ( v.z > 0.0 )
				planar.x = 4.0 - v.x;
		} else if ( absV.x >= almostOne ) {
			float signX = sign( v.x );
			planar.x = v.z * signX + 2.0 * signX;
		} else if ( absV.y >= almostOne ) {
			float signY = sign( v.y );
			planar.x = v.x + 2.0 * signY + 2.0;
			planar.y = v.z * signY - 2.0;
		}
		return vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );
	}
	float getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {
		vec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );
		vec3 lightToPosition = shadowCoord.xyz;
		float dp = ( length( lightToPosition ) - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );		dp += shadowBias;
		vec3 bd3D = normalize( lightToPosition );
		#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )
			vec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;
			return (
				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +
				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +
				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +
				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +
				texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +
				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +
				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +
				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +
				texture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )
			) * ( 1.0 / 9.0 );
		#else
			return texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );
		#endif
	}
#endif`, qL = `#if NUM_SPOT_LIGHT_COORDS > 0
  uniform mat4 spotLightMatrix[ NUM_SPOT_LIGHT_COORDS ];
  varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];
#endif
#ifdef USE_SHADOWMAP
	#if NUM_DIR_LIGHT_SHADOWS > 0
		uniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];
		varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];
		struct DirectionalLightShadow {
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];
	#endif
	#if NUM_SPOT_LIGHT_SHADOWS > 0
		struct SpotLightShadow {
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
		};
		uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
		uniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];
		varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];
		struct PointLightShadow {
			float shadowBias;
			float shadowNormalBias;
			float shadowRadius;
			vec2 shadowMapSize;
			float shadowCameraNear;
			float shadowCameraFar;
		};
		uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];
	#endif
#endif`, XL = `#if ( defined( USE_SHADOWMAP ) && ( NUM_DIR_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0 ) ) || ( NUM_SPOT_LIGHT_COORDS > 0 )
	vec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );
	vec4 shadowWorldPosition;
#endif
#if defined( USE_SHADOWMAP )
	#if NUM_DIR_LIGHT_SHADOWS > 0
		#pragma unroll_loop_start
		for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {
			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );
			vDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;
		}
		#pragma unroll_loop_end
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
		#pragma unroll_loop_start
		for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {
			shadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );
			vPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;
		}
		#pragma unroll_loop_end
	#endif
#endif
#if NUM_SPOT_LIGHT_COORDS > 0
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_SPOT_LIGHT_COORDS; i ++ ) {
		shadowWorldPosition = worldPosition;
		#if ( defined( USE_SHADOWMAP ) && UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )
			shadowWorldPosition.xyz += shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias;
		#endif
		vSpotLightCoord[ i ] = spotLightMatrix[ i ] * shadowWorldPosition;
	}
	#pragma unroll_loop_end
#endif`, YL = `float getShadowMask() {
	float shadow = 1.0;
	#ifdef USE_SHADOWMAP
	#if NUM_DIR_LIGHT_SHADOWS > 0
	DirectionalLightShadow directionalLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {
		directionalLight = directionalLightShadows[ i ];
		shadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;
	}
	#pragma unroll_loop_end
	#endif
	#if NUM_SPOT_LIGHT_SHADOWS > 0
	SpotLightShadow spotLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {
		spotLight = spotLightShadows[ i ];
		shadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowBias, spotLight.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;
	}
	#pragma unroll_loop_end
	#endif
	#if NUM_POINT_LIGHT_SHADOWS > 0
	PointLightShadow pointLight;
	#pragma unroll_loop_start
	for ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {
		pointLight = pointLightShadows[ i ];
		shadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;
	}
	#pragma unroll_loop_end
	#endif
	#endif
	return shadow;
}`, QL = `#ifdef USE_SKINNING
	mat4 boneMatX = getBoneMatrix( skinIndex.x );
	mat4 boneMatY = getBoneMatrix( skinIndex.y );
	mat4 boneMatZ = getBoneMatrix( skinIndex.z );
	mat4 boneMatW = getBoneMatrix( skinIndex.w );
#endif`, KL = `#ifdef USE_SKINNING
	uniform mat4 bindMatrix;
	uniform mat4 bindMatrixInverse;
	uniform highp sampler2D boneTexture;
	uniform int boneTextureSize;
	mat4 getBoneMatrix( const in float i ) {
		float j = i * 4.0;
		float x = mod( j, float( boneTextureSize ) );
		float y = floor( j / float( boneTextureSize ) );
		float dx = 1.0 / float( boneTextureSize );
		float dy = 1.0 / float( boneTextureSize );
		y = dy * ( y + 0.5 );
		vec4 v1 = texture2D( boneTexture, vec2( dx * ( x + 0.5 ), y ) );
		vec4 v2 = texture2D( boneTexture, vec2( dx * ( x + 1.5 ), y ) );
		vec4 v3 = texture2D( boneTexture, vec2( dx * ( x + 2.5 ), y ) );
		vec4 v4 = texture2D( boneTexture, vec2( dx * ( x + 3.5 ), y ) );
		mat4 bone = mat4( v1, v2, v3, v4 );
		return bone;
	}
#endif`, ZL = `#ifdef USE_SKINNING
	vec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );
	vec4 skinned = vec4( 0.0 );
	skinned += boneMatX * skinVertex * skinWeight.x;
	skinned += boneMatY * skinVertex * skinWeight.y;
	skinned += boneMatZ * skinVertex * skinWeight.z;
	skinned += boneMatW * skinVertex * skinWeight.w;
	transformed = ( bindMatrixInverse * skinned ).xyz;
#endif`, JL = `#ifdef USE_SKINNING
	mat4 skinMatrix = mat4( 0.0 );
	skinMatrix += skinWeight.x * boneMatX;
	skinMatrix += skinWeight.y * boneMatY;
	skinMatrix += skinWeight.z * boneMatZ;
	skinMatrix += skinWeight.w * boneMatW;
	skinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;
	objectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;
	#ifdef USE_TANGENT
		objectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;
	#endif
#endif`, $L = `float specularStrength;
#ifdef USE_SPECULARMAP
	vec4 texelSpecular = texture2D( specularMap, vUv );
	specularStrength = texelSpecular.r;
#else
	specularStrength = 1.0;
#endif`, e3 = `#ifdef USE_SPECULARMAP
	uniform sampler2D specularMap;
#endif`, t3 = `#if defined( TONE_MAPPING )
	gl_FragColor.rgb = toneMapping( gl_FragColor.rgb );
#endif`, n3 = `#ifndef saturate
#define saturate( a ) clamp( a, 0.0, 1.0 )
#endif
uniform float toneMappingExposure;
vec3 LinearToneMapping( vec3 color ) {
	return toneMappingExposure * color;
}
vec3 ReinhardToneMapping( vec3 color ) {
	color *= toneMappingExposure;
	return saturate( color / ( vec3( 1.0 ) + color ) );
}
vec3 OptimizedCineonToneMapping( vec3 color ) {
	color *= toneMappingExposure;
	color = max( vec3( 0.0 ), color - 0.004 );
	return pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );
}
vec3 RRTAndODTFit( vec3 v ) {
	vec3 a = v * ( v + 0.0245786 ) - 0.000090537;
	vec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;
	return a / b;
}
vec3 ACESFilmicToneMapping( vec3 color ) {
	const mat3 ACESInputMat = mat3(
		vec3( 0.59719, 0.07600, 0.02840 ),		vec3( 0.35458, 0.90834, 0.13383 ),
		vec3( 0.04823, 0.01566, 0.83777 )
	);
	const mat3 ACESOutputMat = mat3(
		vec3(  1.60475, -0.10208, -0.00327 ),		vec3( -0.53108,  1.10813, -0.07276 ),
		vec3( -0.07367, -0.00605,  1.07602 )
	);
	color *= toneMappingExposure / 0.6;
	color = ACESInputMat * color;
	color = RRTAndODTFit( color );
	color = ACESOutputMat * color;
	return saturate( color );
}
vec3 CustomToneMapping( vec3 color ) { return color; }`, r3 = `#ifdef USE_TRANSMISSION
	material.transmission = transmission;
	material.transmissionAlpha = 1.0;
	material.thickness = thickness;
	material.attenuationDistance = attenuationDistance;
	material.attenuationColor = attenuationColor;
	#ifdef USE_TRANSMISSIONMAP
		material.transmission *= texture2D( transmissionMap, vUv ).r;
	#endif
	#ifdef USE_THICKNESSMAP
		material.thickness *= texture2D( thicknessMap, vUv ).g;
	#endif
	vec3 pos = vWorldPosition;
	vec3 v = normalize( cameraPosition - pos );
	vec3 n = inverseTransformDirection( normal, viewMatrix );
	vec4 transmission = getIBLVolumeRefraction(
		n, v, material.roughness, material.diffuseColor, material.specularColor, material.specularF90,
		pos, modelMatrix, viewMatrix, projectionMatrix, material.ior, material.thickness,
		material.attenuationColor, material.attenuationDistance );
	material.transmissionAlpha = mix( material.transmissionAlpha, transmission.a, material.transmission );
	totalDiffuse = mix( totalDiffuse, transmission.rgb, material.transmission );
#endif`, i3 = `#ifdef USE_TRANSMISSION
	uniform float transmission;
	uniform float thickness;
	uniform float attenuationDistance;
	uniform vec3 attenuationColor;
	#ifdef USE_TRANSMISSIONMAP
		uniform sampler2D transmissionMap;
	#endif
	#ifdef USE_THICKNESSMAP
		uniform sampler2D thicknessMap;
	#endif
	uniform vec2 transmissionSamplerSize;
	uniform sampler2D transmissionSamplerMap;
	uniform mat4 modelMatrix;
	uniform mat4 projectionMatrix;
	varying vec3 vWorldPosition;
	vec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {
		vec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );
		vec3 modelScale;
		modelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );
		modelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );
		modelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );
		return normalize( refractionVector ) * thickness * modelScale;
	}
	float applyIorToRoughness( const in float roughness, const in float ior ) {
		return roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );
	}
	vec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {
		float framebufferLod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );
		#ifdef texture2DLodEXT
			return texture2DLodEXT( transmissionSamplerMap, fragCoord.xy, framebufferLod );
		#else
			return texture2D( transmissionSamplerMap, fragCoord.xy, framebufferLod );
		#endif
	}
	vec3 applyVolumeAttenuation( const in vec3 radiance, const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {
		if ( isinf( attenuationDistance ) ) {
			return radiance;
		} else {
			vec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;
			vec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );			return transmittance * radiance;
		}
	}
	vec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,
		const in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,
		const in mat4 viewMatrix, const in mat4 projMatrix, const in float ior, const in float thickness,
		const in vec3 attenuationColor, const in float attenuationDistance ) {
		vec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );
		vec3 refractedRayExit = position + transmissionRay;
		vec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );
		vec2 refractionCoords = ndcPos.xy / ndcPos.w;
		refractionCoords += 1.0;
		refractionCoords /= 2.0;
		vec4 transmittedLight = getTransmissionSample( refractionCoords, roughness, ior );
		vec3 attenuatedColor = applyVolumeAttenuation( transmittedLight.rgb, length( transmissionRay ), attenuationColor, attenuationDistance );
		vec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );
		return vec4( ( 1.0 - F ) * attenuatedColor * diffuseColor, transmittedLight.a );
	}
#endif`, s3 = `#if ( defined( USE_UV ) && ! defined( UVS_VERTEX_ONLY ) )
	varying vec2 vUv;
#endif`, o3 = `#ifdef USE_UV
	#ifdef UVS_VERTEX_ONLY
		vec2 vUv;
	#else
		varying vec2 vUv;
	#endif
	uniform mat3 uvTransform;
#endif`, a3 = `#ifdef USE_UV
	vUv = ( uvTransform * vec3( uv, 1 ) ).xy;
#endif`, l3 = `#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )
	varying vec2 vUv2;
#endif`, c3 = `#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )
	attribute vec2 uv2;
	varying vec2 vUv2;
	uniform mat3 uv2Transform;
#endif`, u3 = `#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )
	vUv2 = ( uv2Transform * vec3( uv2, 1 ) ).xy;
#endif`, d3 = `#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION ) || NUM_SPOT_LIGHT_COORDS > 0
	vec4 worldPosition = vec4( transformed, 1.0 );
	#ifdef USE_INSTANCING
		worldPosition = instanceMatrix * worldPosition;
	#endif
	worldPosition = modelMatrix * worldPosition;
#endif`, h3 = `varying vec2 vUv;
uniform mat3 uvTransform;
void main() {
	vUv = ( uvTransform * vec3( uv, 1 ) ).xy;
	gl_Position = vec4( position.xy, 1.0, 1.0 );
}`, f3 = `uniform sampler2D t2D;
uniform float backgroundIntensity;
varying vec2 vUv;
void main() {
	vec4 texColor = texture2D( t2D, vUv );
	#ifdef DECODE_VIDEO_TEXTURE
		texColor = vec4( mix( pow( texColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), texColor.rgb * 0.0773993808, vec3( lessThanEqual( texColor.rgb, vec3( 0.04045 ) ) ) ), texColor.w );
	#endif
	texColor.rgb *= backgroundIntensity;
	gl_FragColor = texColor;
	#include <tonemapping_fragment>
	#include <encodings_fragment>
}`, p3 = `varying vec3 vWorldDirection;
#include <common>
void main() {
	vWorldDirection = transformDirection( position, modelMatrix );
	#include <begin_vertex>
	#include <project_vertex>
	gl_Position.z = gl_Position.w;
}`, m3 = `#ifdef ENVMAP_TYPE_CUBE
	uniform samplerCube envMap;
#elif defined( ENVMAP_TYPE_CUBE_UV )
	uniform sampler2D envMap;
#endif
uniform float flipEnvMap;
uniform float backgroundBlurriness;
uniform float backgroundIntensity;
varying vec3 vWorldDirection;
#include <cube_uv_reflection_fragment>
void main() {
	#ifdef ENVMAP_TYPE_CUBE
		vec4 texColor = textureCube( envMap, vec3( flipEnvMap * vWorldDirection.x, vWorldDirection.yz ) );
	#elif defined( ENVMAP_TYPE_CUBE_UV )
		vec4 texColor = textureCubeUV( envMap, vWorldDirection, backgroundBlurriness );
	#else
		vec4 texColor = vec4( 0.0, 0.0, 0.0, 1.0 );
	#endif
	texColor.rgb *= backgroundIntensity;
	gl_FragColor = texColor;
	#include <tonemapping_fragment>
	#include <encodings_fragment>
}`, g3 = `varying vec3 vWorldDirection;
#include <common>
void main() {
	vWorldDirection = transformDirection( position, modelMatrix );
	#include <begin_vertex>
	#include <project_vertex>
	gl_Position.z = gl_Position.w;
}`, y3 = `uniform samplerCube tCube;
uniform float tFlip;
uniform float opacity;
varying vec3 vWorldDirection;
void main() {
	vec4 texColor = textureCube( tCube, vec3( tFlip * vWorldDirection.x, vWorldDirection.yz ) );
	gl_FragColor = texColor;
	gl_FragColor.a *= opacity;
	#include <tonemapping_fragment>
	#include <encodings_fragment>
}`, v3 = `#include <common>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
varying vec2 vHighPrecisionZW;
void main() {
	#include <uv_vertex>
	#include <skinbase_vertex>
	#ifdef USE_DISPLACEMENTMAP
		#include <beginnormal_vertex>
		#include <morphnormal_vertex>
		#include <skinnormal_vertex>
	#endif
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vHighPrecisionZW = gl_Position.zw;
}`, x3 = `#if DEPTH_PACKING == 3200
	uniform float opacity;
#endif
#include <common>
#include <packing>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
varying vec2 vHighPrecisionZW;
void main() {
	#include <clipping_planes_fragment>
	vec4 diffuseColor = vec4( 1.0 );
	#if DEPTH_PACKING == 3200
		diffuseColor.a = opacity;
	#endif
	#include <map_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <logdepthbuf_fragment>
	float fragCoordZ = 0.5 * vHighPrecisionZW[0] / vHighPrecisionZW[1] + 0.5;
	#if DEPTH_PACKING == 3200
		gl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );
	#elif DEPTH_PACKING == 3201
		gl_FragColor = packDepthToRGBA( fragCoordZ );
	#endif
}`, b3 = `#define DISTANCE
varying vec3 vWorldPosition;
#include <common>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <skinbase_vertex>
	#ifdef USE_DISPLACEMENTMAP
		#include <beginnormal_vertex>
		#include <morphnormal_vertex>
		#include <skinnormal_vertex>
	#endif
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <worldpos_vertex>
	#include <clipping_planes_vertex>
	vWorldPosition = worldPosition.xyz;
}`, w3 = `#define DISTANCE
uniform vec3 referencePosition;
uniform float nearDistance;
uniform float farDistance;
varying vec3 vWorldPosition;
#include <common>
#include <packing>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <clipping_planes_pars_fragment>
void main () {
	#include <clipping_planes_fragment>
	vec4 diffuseColor = vec4( 1.0 );
	#include <map_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	float dist = length( vWorldPosition - referencePosition );
	dist = ( dist - nearDistance ) / ( farDistance - nearDistance );
	dist = saturate( dist );
	gl_FragColor = packDepthToRGBA( dist );
}`, S3 = `varying vec3 vWorldDirection;
#include <common>
void main() {
	vWorldDirection = transformDirection( position, modelMatrix );
	#include <begin_vertex>
	#include <project_vertex>
}`, A3 = `uniform sampler2D tEquirect;
varying vec3 vWorldDirection;
#include <common>
void main() {
	vec3 direction = normalize( vWorldDirection );
	vec2 sampleUV = equirectUv( direction );
	gl_FragColor = texture2D( tEquirect, sampleUV );
	#include <tonemapping_fragment>
	#include <encodings_fragment>
}`, _3 = `uniform float scale;
attribute float lineDistance;
varying float vLineDistance;
#include <common>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	vLineDistance = scale * lineDistance;
	#include <color_vertex>
	#include <morphcolor_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <fog_vertex>
}`, M3 = `uniform vec3 diffuse;
uniform float opacity;
uniform float dashSize;
uniform float totalSize;
varying float vLineDistance;
#include <common>
#include <color_pars_fragment>
#include <fog_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	if ( mod( vLineDistance, totalSize ) > dashSize ) {
		discard;
	}
	vec3 outgoingLight = vec3( 0.0 );
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <logdepthbuf_fragment>
	#include <color_fragment>
	outgoingLight = diffuseColor.rgb;
	#include <output_fragment>
	#include <tonemapping_fragment>
	#include <encodings_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
}`, T3 = `#include <common>
#include <uv_pars_vertex>
#include <uv2_pars_vertex>
#include <envmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <uv2_vertex>
	#include <color_vertex>
	#include <morphcolor_vertex>
	#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )
		#include <beginnormal_vertex>
		#include <morphnormal_vertex>
		#include <skinbase_vertex>
		#include <skinnormal_vertex>
		#include <defaultnormal_vertex>
	#endif
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <worldpos_vertex>
	#include <envmap_vertex>
	#include <fog_vertex>
}`, E3 = `uniform vec3 diffuse;
uniform float opacity;
#ifndef FLAT_SHADED
	varying vec3 vNormal;
#endif
#include <common>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <uv2_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_pars_fragment>
#include <fog_pars_fragment>
#include <specularmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <specularmap_fragment>
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	#ifdef USE_LIGHTMAP
		vec4 lightMapTexel = texture2D( lightMap, vUv2 );
		reflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;
	#else
		reflectedLight.indirectDiffuse += vec3( 1.0 );
	#endif
	#include <aomap_fragment>
	reflectedLight.indirectDiffuse *= diffuseColor.rgb;
	vec3 outgoingLight = reflectedLight.indirectDiffuse;
	#include <envmap_fragment>
	#include <output_fragment>
	#include <tonemapping_fragment>
	#include <encodings_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, C3 = `#define LAMBERT
varying vec3 vViewPosition;
#include <common>
#include <uv_pars_vertex>
#include <uv2_pars_vertex>
#include <displacementmap_pars_vertex>
#include <envmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <uv2_vertex>
	#include <color_vertex>
	#include <morphcolor_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <envmap_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`, P3 = `#define LAMBERT
uniform vec3 diffuse;
uniform vec3 emissive;
uniform float opacity;
#include <common>
#include <packing>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <uv2_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_pars_fragment>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_lambert_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <specularmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	vec4 diffuseColor = vec4( diffuse, opacity );
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <specularmap_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_lambert_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;
	#include <envmap_fragment>
	#include <output_fragment>
	#include <tonemapping_fragment>
	#include <encodings_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, D3 = `#define MATCAP
varying vec3 vViewPosition;
#include <common>
#include <uv_pars_vertex>
#include <color_pars_vertex>
#include <displacementmap_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <color_vertex>
	#include <morphcolor_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <fog_vertex>
	vViewPosition = - mvPosition.xyz;
}`, I3 = `#define MATCAP
uniform vec3 diffuse;
uniform float opacity;
uniform sampler2D matcap;
varying vec3 vViewPosition;
#include <common>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <fog_pars_fragment>
#include <normal_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	vec3 viewDir = normalize( vViewPosition );
	vec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );
	vec3 y = cross( viewDir, x );
	vec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;
	#ifdef USE_MATCAP
		vec4 matcapColor = texture2D( matcap, uv );
	#else
		vec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );
	#endif
	vec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;
	#include <output_fragment>
	#include <tonemapping_fragment>
	#include <encodings_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, O3 = `#define NORMAL
#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )
	varying vec3 vViewPosition;
#endif
#include <common>
#include <uv_pars_vertex>
#include <displacementmap_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )
	vViewPosition = - mvPosition.xyz;
#endif
}`, R3 = `#define NORMAL
uniform float opacity;
#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )
	varying vec3 vViewPosition;
#endif
#include <packing>
#include <uv_pars_fragment>
#include <normal_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	#include <logdepthbuf_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	gl_FragColor = vec4( packNormalToRGB( normal ), opacity );
	#ifdef OPAQUE
		gl_FragColor.a = 1.0;
	#endif
}`, L3 = `#define PHONG
varying vec3 vViewPosition;
#include <common>
#include <uv_pars_vertex>
#include <uv2_pars_vertex>
#include <displacementmap_pars_vertex>
#include <envmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <uv2_vertex>
	#include <color_vertex>
	#include <morphcolor_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <envmap_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`, N3 = `#define PHONG
uniform vec3 diffuse;
uniform vec3 emissive;
uniform vec3 specular;
uniform float shininess;
uniform float opacity;
#include <common>
#include <packing>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <uv2_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_pars_fragment>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_phong_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <specularmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	vec4 diffuseColor = vec4( diffuse, opacity );
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <specularmap_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_phong_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;
	#include <envmap_fragment>
	#include <output_fragment>
	#include <tonemapping_fragment>
	#include <encodings_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, B3 = `#define STANDARD
varying vec3 vViewPosition;
#ifdef USE_TRANSMISSION
	varying vec3 vWorldPosition;
#endif
#include <common>
#include <uv_pars_vertex>
#include <uv2_pars_vertex>
#include <displacementmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <uv2_vertex>
	#include <color_vertex>
	#include <morphcolor_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
#ifdef USE_TRANSMISSION
	vWorldPosition = worldPosition.xyz;
#endif
}`, F3 = `#define STANDARD
#ifdef PHYSICAL
	#define IOR
	#define SPECULAR
#endif
uniform vec3 diffuse;
uniform vec3 emissive;
uniform float roughness;
uniform float metalness;
uniform float opacity;
#ifdef IOR
	uniform float ior;
#endif
#ifdef SPECULAR
	uniform float specularIntensity;
	uniform vec3 specularColor;
	#ifdef USE_SPECULARINTENSITYMAP
		uniform sampler2D specularIntensityMap;
	#endif
	#ifdef USE_SPECULARCOLORMAP
		uniform sampler2D specularColorMap;
	#endif
#endif
#ifdef USE_CLEARCOAT
	uniform float clearcoat;
	uniform float clearcoatRoughness;
#endif
#ifdef USE_IRIDESCENCE
	uniform float iridescence;
	uniform float iridescenceIOR;
	uniform float iridescenceThicknessMinimum;
	uniform float iridescenceThicknessMaximum;
#endif
#ifdef USE_SHEEN
	uniform vec3 sheenColor;
	uniform float sheenRoughness;
	#ifdef USE_SHEENCOLORMAP
		uniform sampler2D sheenColorMap;
	#endif
	#ifdef USE_SHEENROUGHNESSMAP
		uniform sampler2D sheenRoughnessMap;
	#endif
#endif
varying vec3 vViewPosition;
#include <common>
#include <packing>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <uv2_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <bsdfs>
#include <iridescence_fragment>
#include <cube_uv_reflection_fragment>
#include <envmap_common_pars_fragment>
#include <envmap_physical_pars_fragment>
#include <fog_pars_fragment>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_physical_pars_fragment>
#include <transmission_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <clearcoat_pars_fragment>
#include <iridescence_pars_fragment>
#include <roughnessmap_pars_fragment>
#include <metalnessmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	vec4 diffuseColor = vec4( diffuse, opacity );
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <roughnessmap_fragment>
	#include <metalnessmap_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <clearcoat_normal_fragment_begin>
	#include <clearcoat_normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_physical_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;
	vec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;
	#include <transmission_fragment>
	vec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;
	#ifdef USE_SHEEN
		float sheenEnergyComp = 1.0 - 0.157 * max3( material.sheenColor );
		outgoingLight = outgoingLight * sheenEnergyComp + sheenSpecular;
	#endif
	#ifdef USE_CLEARCOAT
		float dotNVcc = saturate( dot( geometry.clearcoatNormal, geometry.viewDir ) );
		vec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );
		outgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + clearcoatSpecular * material.clearcoat;
	#endif
	#include <output_fragment>
	#include <tonemapping_fragment>
	#include <encodings_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, U3 = `#define TOON
varying vec3 vViewPosition;
#include <common>
#include <uv_pars_vertex>
#include <uv2_pars_vertex>
#include <displacementmap_pars_vertex>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <normal_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	#include <uv2_vertex>
	#include <color_vertex>
	#include <morphcolor_vertex>
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <normal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <displacementmap_vertex>
	#include <project_vertex>
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	vViewPosition = - mvPosition.xyz;
	#include <worldpos_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`, k3 = `#define TOON
uniform vec3 diffuse;
uniform vec3 emissive;
uniform float opacity;
#include <common>
#include <packing>
#include <dithering_pars_fragment>
#include <color_pars_fragment>
#include <uv_pars_fragment>
#include <uv2_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <aomap_pars_fragment>
#include <lightmap_pars_fragment>
#include <emissivemap_pars_fragment>
#include <gradientmap_pars_fragment>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <normal_pars_fragment>
#include <lights_toon_pars_fragment>
#include <shadowmap_pars_fragment>
#include <bumpmap_pars_fragment>
#include <normalmap_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	vec4 diffuseColor = vec4( diffuse, opacity );
	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );
	vec3 totalEmissiveRadiance = emissive;
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <color_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	#include <normal_fragment_begin>
	#include <normal_fragment_maps>
	#include <emissivemap_fragment>
	#include <lights_toon_fragment>
	#include <lights_fragment_begin>
	#include <lights_fragment_maps>
	#include <lights_fragment_end>
	#include <aomap_fragment>
	vec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;
	#include <output_fragment>
	#include <tonemapping_fragment>
	#include <encodings_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
	#include <dithering_fragment>
}`, z3 = `uniform float size;
uniform float scale;
#include <common>
#include <color_pars_vertex>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <color_vertex>
	#include <morphcolor_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <project_vertex>
	gl_PointSize = size;
	#ifdef USE_SIZEATTENUATION
		bool isPerspective = isPerspectiveMatrix( projectionMatrix );
		if ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );
	#endif
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <worldpos_vertex>
	#include <fog_vertex>
}`, G3 = `uniform vec3 diffuse;
uniform float opacity;
#include <common>
#include <color_pars_fragment>
#include <map_particle_pars_fragment>
#include <alphatest_pars_fragment>
#include <fog_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	vec3 outgoingLight = vec3( 0.0 );
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <logdepthbuf_fragment>
	#include <map_particle_fragment>
	#include <color_fragment>
	#include <alphatest_fragment>
	outgoingLight = diffuseColor.rgb;
	#include <output_fragment>
	#include <tonemapping_fragment>
	#include <encodings_fragment>
	#include <fog_fragment>
	#include <premultiplied_alpha_fragment>
}`, V3 = `#include <common>
#include <fog_pars_vertex>
#include <morphtarget_pars_vertex>
#include <skinning_pars_vertex>
#include <shadowmap_pars_vertex>
void main() {
	#include <beginnormal_vertex>
	#include <morphnormal_vertex>
	#include <skinbase_vertex>
	#include <skinnormal_vertex>
	#include <defaultnormal_vertex>
	#include <begin_vertex>
	#include <morphtarget_vertex>
	#include <skinning_vertex>
	#include <project_vertex>
	#include <worldpos_vertex>
	#include <shadowmap_vertex>
	#include <fog_vertex>
}`, H3 = `uniform vec3 color;
uniform float opacity;
#include <common>
#include <packing>
#include <fog_pars_fragment>
#include <bsdfs>
#include <lights_pars_begin>
#include <shadowmap_pars_fragment>
#include <shadowmask_pars_fragment>
void main() {
	gl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );
	#include <tonemapping_fragment>
	#include <encodings_fragment>
	#include <fog_fragment>
}`, W3 = `uniform float rotation;
uniform vec2 center;
#include <common>
#include <uv_pars_vertex>
#include <fog_pars_vertex>
#include <logdepthbuf_pars_vertex>
#include <clipping_planes_pars_vertex>
void main() {
	#include <uv_vertex>
	vec4 mvPosition = modelViewMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );
	vec2 scale;
	scale.x = length( vec3( modelMatrix[ 0 ].x, modelMatrix[ 0 ].y, modelMatrix[ 0 ].z ) );
	scale.y = length( vec3( modelMatrix[ 1 ].x, modelMatrix[ 1 ].y, modelMatrix[ 1 ].z ) );
	#ifndef USE_SIZEATTENUATION
		bool isPerspective = isPerspectiveMatrix( projectionMatrix );
		if ( isPerspective ) scale *= - mvPosition.z;
	#endif
	vec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;
	vec2 rotatedPosition;
	rotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;
	rotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;
	mvPosition.xy += rotatedPosition;
	gl_Position = projectionMatrix * mvPosition;
	#include <logdepthbuf_vertex>
	#include <clipping_planes_vertex>
	#include <fog_vertex>
}`, j3 = `uniform vec3 diffuse;
uniform float opacity;
#include <common>
#include <uv_pars_fragment>
#include <map_pars_fragment>
#include <alphamap_pars_fragment>
#include <alphatest_pars_fragment>
#include <fog_pars_fragment>
#include <logdepthbuf_pars_fragment>
#include <clipping_planes_pars_fragment>
void main() {
	#include <clipping_planes_fragment>
	vec3 outgoingLight = vec3( 0.0 );
	vec4 diffuseColor = vec4( diffuse, opacity );
	#include <logdepthbuf_fragment>
	#include <map_fragment>
	#include <alphamap_fragment>
	#include <alphatest_fragment>
	outgoingLight = diffuseColor.rgb;
	#include <output_fragment>
	#include <tonemapping_fragment>
	#include <encodings_fragment>
	#include <fog_fragment>
}`, it = {
    alphamap_fragment: pR,
    alphamap_pars_fragment: mR,
    alphatest_fragment: gR,
    alphatest_pars_fragment: yR,
    aomap_fragment: vR,
    aomap_pars_fragment: xR,
    begin_vertex: bR,
    beginnormal_vertex: wR,
    bsdfs: SR,
    iridescence_fragment: AR,
    bumpmap_pars_fragment: _R,
    clipping_planes_fragment: MR,
    clipping_planes_pars_fragment: TR,
    clipping_planes_pars_vertex: ER,
    clipping_planes_vertex: CR,
    color_fragment: PR,
    color_pars_fragment: DR,
    color_pars_vertex: IR,
    color_vertex: OR,
    common: RR,
    cube_uv_reflection_fragment: LR,
    defaultnormal_vertex: NR,
    displacementmap_pars_vertex: BR,
    displacementmap_vertex: FR,
    emissivemap_fragment: UR,
    emissivemap_pars_fragment: kR,
    encodings_fragment: zR,
    encodings_pars_fragment: GR,
    envmap_fragment: VR,
    envmap_common_pars_fragment: HR,
    envmap_pars_fragment: WR,
    envmap_pars_vertex: jR,
    envmap_physical_pars_fragment: rL,
    envmap_vertex: qR,
    fog_vertex: XR,
    fog_pars_vertex: YR,
    fog_fragment: QR,
    fog_pars_fragment: KR,
    gradientmap_pars_fragment: ZR,
    lightmap_fragment: JR,
    lightmap_pars_fragment: $R,
    lights_lambert_fragment: eL,
    lights_lambert_pars_fragment: tL,
    lights_pars_begin: nL,
    lights_toon_fragment: iL,
    lights_toon_pars_fragment: sL,
    lights_phong_fragment: oL,
    lights_phong_pars_fragment: aL,
    lights_physical_fragment: lL,
    lights_physical_pars_fragment: cL,
    lights_fragment_begin: uL,
    lights_fragment_maps: dL,
    lights_fragment_end: hL,
    logdepthbuf_fragment: fL,
    logdepthbuf_pars_fragment: pL,
    logdepthbuf_pars_vertex: mL,
    logdepthbuf_vertex: gL,
    map_fragment: yL,
    map_pars_fragment: vL,
    map_particle_fragment: xL,
    map_particle_pars_fragment: bL,
    metalnessmap_fragment: wL,
    metalnessmap_pars_fragment: SL,
    morphcolor_vertex: AL,
    morphnormal_vertex: _L,
    morphtarget_pars_vertex: ML,
    morphtarget_vertex: TL,
    normal_fragment_begin: EL,
    normal_fragment_maps: CL,
    normal_pars_fragment: PL,
    normal_pars_vertex: DL,
    normal_vertex: IL,
    normalmap_pars_fragment: OL,
    clearcoat_normal_fragment_begin: RL,
    clearcoat_normal_fragment_maps: LL,
    clearcoat_pars_fragment: NL,
    iridescence_pars_fragment: BL,
    output_fragment: FL,
    packing: UL,
    premultiplied_alpha_fragment: kL,
    project_vertex: zL,
    dithering_fragment: GL,
    dithering_pars_fragment: VL,
    roughnessmap_fragment: HL,
    roughnessmap_pars_fragment: WL,
    shadowmap_pars_fragment: jL,
    shadowmap_pars_vertex: qL,
    shadowmap_vertex: XL,
    shadowmask_pars_fragment: YL,
    skinbase_vertex: QL,
    skinning_pars_vertex: KL,
    skinning_vertex: ZL,
    skinnormal_vertex: JL,
    specularmap_fragment: $L,
    specularmap_pars_fragment: e3,
    tonemapping_fragment: t3,
    tonemapping_pars_fragment: n3,
    transmission_fragment: r3,
    transmission_pars_fragment: i3,
    uv_pars_fragment: s3,
    uv_pars_vertex: o3,
    uv_vertex: a3,
    uv2_pars_fragment: l3,
    uv2_pars_vertex: c3,
    uv2_vertex: u3,
    worldpos_vertex: d3,
    background_vert: h3,
    background_frag: f3,
    backgroundCube_vert: p3,
    backgroundCube_frag: m3,
    cube_vert: g3,
    cube_frag: y3,
    depth_vert: v3,
    depth_frag: x3,
    distanceRGBA_vert: b3,
    distanceRGBA_frag: w3,
    equirect_vert: S3,
    equirect_frag: A3,
    linedashed_vert: _3,
    linedashed_frag: M3,
    meshbasic_vert: T3,
    meshbasic_frag: E3,
    meshlambert_vert: C3,
    meshlambert_frag: P3,
    meshmatcap_vert: D3,
    meshmatcap_frag: I3,
    meshnormal_vert: O3,
    meshnormal_frag: R3,
    meshphong_vert: L3,
    meshphong_frag: N3,
    meshphysical_vert: B3,
    meshphysical_frag: F3,
    meshtoon_vert: U3,
    meshtoon_frag: k3,
    points_vert: z3,
    points_frag: G3,
    shadow_vert: V3,
    shadow_frag: H3,
    sprite_vert: W3,
    sprite_frag: j3
}, be = {
    common: {
        diffuse: {
            value: new Ne(16777215)
        },
        opacity: {
            value: 1
        },
        map: {
            value: null
        },
        uvTransform: {
            value: new Kt
        },
        uv2Transform: {
            value: new Kt
        },
        alphaMap: {
            value: null
        },
        alphaTest: {
            value: 0
        }
    },
    specularmap: {
        specularMap: {
            value: null
        }
    },
    envmap: {
        envMap: {
            value: null
        },
        flipEnvMap: {
            value: -1
        },
        reflectivity: {
            value: 1
        },
        ior: {
            value: 1.5
        },
        refractionRatio: {
            value: .98
        }
    },
    aomap: {
        aoMap: {
            value: null
        },
        aoMapIntensity: {
            value: 1
        }
    },
    lightmap: {
        lightMap: {
            value: null
        },
        lightMapIntensity: {
            value: 1
        }
    },
    emissivemap: {
        emissiveMap: {
            value: null
        }
    },
    bumpmap: {
        bumpMap: {
            value: null
        },
        bumpScale: {
            value: 1
        }
    },
    normalmap: {
        normalMap: {
            value: null
        },
        normalScale: {
            value: new F(1, 1)
        }
    },
    displacementmap: {
        displacementMap: {
            value: null
        },
        displacementScale: {
            value: 1
        },
        displacementBias: {
            value: 0
        }
    },
    roughnessmap: {
        roughnessMap: {
            value: null
        }
    },
    metalnessmap: {
        metalnessMap: {
            value: null
        }
    },
    gradientmap: {
        gradientMap: {
            value: null
        }
    },
    fog: {
        fogDensity: {
            value: 25e-5
        },
        fogNear: {
            value: 1
        },
        fogFar: {
            value: 2e3
        },
        fogColor: {
            value: new Ne(16777215)
        }
    },
    lights: {
        ambientLightColor: {
            value: []
        },
        lightProbe: {
            value: []
        },
        directionalLights: {
            value: [],
            properties: {
                direction: {},
                color: {}
            }
        },
        directionalLightShadows: {
            value: [],
            properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        directionalShadowMap: {
            value: []
        },
        directionalShadowMatrix: {
            value: []
        },
        spotLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                direction: {},
                distance: {},
                coneCos: {},
                penumbraCos: {},
                decay: {}
            }
        },
        spotLightShadows: {
            value: [],
            properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        spotLightMap: {
            value: []
        },
        spotShadowMap: {
            value: []
        },
        spotLightMatrix: {
            value: []
        },
        pointLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                decay: {},
                distance: {}
            }
        },
        pointLightShadows: {
            value: [],
            properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {},
                shadowCameraNear: {},
                shadowCameraFar: {}
            }
        },
        pointShadowMap: {
            value: []
        },
        pointShadowMatrix: {
            value: []
        },
        hemisphereLights: {
            value: [],
            properties: {
                direction: {},
                skyColor: {},
                groundColor: {}
            }
        },
        rectAreaLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                width: {},
                height: {}
            }
        },
        ltc_1: {
            value: null
        },
        ltc_2: {
            value: null
        }
    },
    points: {
        diffuse: {
            value: new Ne(16777215)
        },
        opacity: {
            value: 1
        },
        size: {
            value: 1
        },
        scale: {
            value: 1
        },
        map: {
            value: null
        },
        alphaMap: {
            value: null
        },
        alphaTest: {
            value: 0
        },
        uvTransform: {
            value: new Kt
        }
    },
    sprite: {
        diffuse: {
            value: new Ne(16777215)
        },
        opacity: {
            value: 1
        },
        center: {
            value: new F(.5, .5)
        },
        rotation: {
            value: 0
        },
        map: {
            value: null
        },
        alphaMap: {
            value: null
        },
        alphaTest: {
            value: 0
        },
        uvTransform: {
            value: new Kt
        }
    }
}, ps = {
    basic: {
        uniforms: Dr([
            be.common,
            be.specularmap,
            be.envmap,
            be.aomap,
            be.lightmap,
            be.fog
        ]),
        vertexShader: it.meshbasic_vert,
        fragmentShader: it.meshbasic_frag
    },
    lambert: {
        uniforms: Dr([
            be.common,
            be.specularmap,
            be.envmap,
            be.aomap,
            be.lightmap,
            be.emissivemap,
            be.bumpmap,
            be.normalmap,
            be.displacementmap,
            be.fog,
            be.lights,
            {
                emissive: {
                    value: new Ne(0)
                }
            }
        ]),
        vertexShader: it.meshlambert_vert,
        fragmentShader: it.meshlambert_frag
    },
    phong: {
        uniforms: Dr([
            be.common,
            be.specularmap,
            be.envmap,
            be.aomap,
            be.lightmap,
            be.emissivemap,
            be.bumpmap,
            be.normalmap,
            be.displacementmap,
            be.fog,
            be.lights,
            {
                emissive: {
                    value: new Ne(0)
                },
                specular: {
                    value: new Ne(1118481)
                },
                shininess: {
                    value: 30
                }
            }
        ]),
        vertexShader: it.meshphong_vert,
        fragmentShader: it.meshphong_frag
    },
    standard: {
        uniforms: Dr([
            be.common,
            be.envmap,
            be.aomap,
            be.lightmap,
            be.emissivemap,
            be.bumpmap,
            be.normalmap,
            be.displacementmap,
            be.roughnessmap,
            be.metalnessmap,
            be.fog,
            be.lights,
            {
                emissive: {
                    value: new Ne(0)
                },
                roughness: {
                    value: 1
                },
                metalness: {
                    value: 0
                },
                envMapIntensity: {
                    value: 1
                }
            }
        ]),
        vertexShader: it.meshphysical_vert,
        fragmentShader: it.meshphysical_frag
    },
    toon: {
        uniforms: Dr([
            be.common,
            be.aomap,
            be.lightmap,
            be.emissivemap,
            be.bumpmap,
            be.normalmap,
            be.displacementmap,
            be.gradientmap,
            be.fog,
            be.lights,
            {
                emissive: {
                    value: new Ne(0)
                }
            }
        ]),
        vertexShader: it.meshtoon_vert,
        fragmentShader: it.meshtoon_frag
    },
    matcap: {
        uniforms: Dr([
            be.common,
            be.bumpmap,
            be.normalmap,
            be.displacementmap,
            be.fog,
            {
                matcap: {
                    value: null
                }
            }
        ]),
        vertexShader: it.meshmatcap_vert,
        fragmentShader: it.meshmatcap_frag
    },
    points: {
        uniforms: Dr([
            be.points,
            be.fog
        ]),
        vertexShader: it.points_vert,
        fragmentShader: it.points_frag
    },
    dashed: {
        uniforms: Dr([
            be.common,
            be.fog,
            {
                scale: {
                    value: 1
                },
                dashSize: {
                    value: 1
                },
                totalSize: {
                    value: 2
                }
            }
        ]),
        vertexShader: it.linedashed_vert,
        fragmentShader: it.linedashed_frag
    },
    depth: {
        uniforms: Dr([
            be.common,
            be.displacementmap
        ]),
        vertexShader: it.depth_vert,
        fragmentShader: it.depth_frag
    },
    normal: {
        uniforms: Dr([
            be.common,
            be.bumpmap,
            be.normalmap,
            be.displacementmap,
            {
                opacity: {
                    value: 1
                }
            }
        ]),
        vertexShader: it.meshnormal_vert,
        fragmentShader: it.meshnormal_frag
    },
    sprite: {
        uniforms: Dr([
            be.sprite,
            be.fog
        ]),
        vertexShader: it.sprite_vert,
        fragmentShader: it.sprite_frag
    },
    background: {
        uniforms: {
            uvTransform: {
                value: new Kt
            },
            t2D: {
                value: null
            },
            backgroundIntensity: {
                value: 1
            }
        },
        vertexShader: it.background_vert,
        fragmentShader: it.background_frag
    },
    backgroundCube: {
        uniforms: {
            envMap: {
                value: null
            },
            flipEnvMap: {
                value: -1
            },
            backgroundBlurriness: {
                value: 0
            },
            backgroundIntensity: {
                value: 1
            }
        },
        vertexShader: it.backgroundCube_vert,
        fragmentShader: it.backgroundCube_frag
    },
    cube: {
        uniforms: {
            tCube: {
                value: null
            },
            tFlip: {
                value: -1
            },
            opacity: {
                value: 1
            }
        },
        vertexShader: it.cube_vert,
        fragmentShader: it.cube_frag
    },
    equirect: {
        uniforms: {
            tEquirect: {
                value: null
            }
        },
        vertexShader: it.equirect_vert,
        fragmentShader: it.equirect_frag
    },
    distanceRGBA: {
        uniforms: Dr([
            be.common,
            be.displacementmap,
            {
                referencePosition: {
                    value: new A
                },
                nearDistance: {
                    value: 1
                },
                farDistance: {
                    value: 1e3
                }
            }
        ]),
        vertexShader: it.distanceRGBA_vert,
        fragmentShader: it.distanceRGBA_frag
    },
    shadow: {
        uniforms: Dr([
            be.lights,
            be.fog,
            {
                color: {
                    value: new Ne(0)
                },
                opacity: {
                    value: 1
                }
            }
        ]),
        vertexShader: it.shadow_vert,
        fragmentShader: it.shadow_frag
    }
};
ps.physical = {
    uniforms: Dr([
        ps.standard.uniforms,
        {
            clearcoat: {
                value: 0
            },
            clearcoatMap: {
                value: null
            },
            clearcoatRoughness: {
                value: 0
            },
            clearcoatRoughnessMap: {
                value: null
            },
            clearcoatNormalScale: {
                value: new F(1, 1)
            },
            clearcoatNormalMap: {
                value: null
            },
            iridescence: {
                value: 0
            },
            iridescenceMap: {
                value: null
            },
            iridescenceIOR: {
                value: 1.3
            },
            iridescenceThicknessMinimum: {
                value: 100
            },
            iridescenceThicknessMaximum: {
                value: 400
            },
            iridescenceThicknessMap: {
                value: null
            },
            sheen: {
                value: 0
            },
            sheenColor: {
                value: new Ne(0)
            },
            sheenColorMap: {
                value: null
            },
            sheenRoughness: {
                value: 1
            },
            sheenRoughnessMap: {
                value: null
            },
            transmission: {
                value: 0
            },
            transmissionMap: {
                value: null
            },
            transmissionSamplerSize: {
                value: new F
            },
            transmissionSamplerMap: {
                value: null
            },
            thickness: {
                value: 0
            },
            thicknessMap: {
                value: null
            },
            attenuationDistance: {
                value: 0
            },
            attenuationColor: {
                value: new Ne(0)
            },
            specularIntensity: {
                value: 1
            },
            specularIntensityMap: {
                value: null
            },
            specularColor: {
                value: new Ne(1, 1, 1)
            },
            specularColorMap: {
                value: null
            }
        }
    ]),
    vertexShader: it.meshphysical_vert,
    fragmentShader: it.meshphysical_frag
};
var Sp = {
    r: 0,
    b: 0,
    g: 0
};
function q3(r1, t, e, n, i, s, o) {
    let a = new Ne(0), l = s === !0 ? 0 : 1, u, c, d = null, h = 0, f = null;
    function m(g, y) {
        let v = !1, x = y.isScene === !0 ? y.background : null;
        x && x.isTexture && (x = (y.backgroundBlurriness > 0 ? e : t).get(x));
        let w = r1.xr, S = w.getSession && w.getSession();
        S && S.environmentBlendMode === "additive" && (x = null), x === null ? p(a, l) : x && x.isColor && (p(x, 1), v = !0), (r1.autoClear || v) && r1.clear(r1.autoClearColor, r1.autoClearDepth, r1.autoClearStencil), x && (x.isCubeTexture || x.mapping === Ac) ? (c === void 0 && (c = new In(new er(1, 1, 1), new ot({
            name: "BackgroundCubeMaterial",
            uniforms: ac(ps.backgroundCube.uniforms),
            vertexShader: ps.backgroundCube.vertexShader,
            fragmentShader: ps.backgroundCube.fragmentShader,
            side: On,
            depthTest: !1,
            depthWrite: !1,
            fog: !1
        })), c.geometry.deleteAttribute("normal"), c.geometry.deleteAttribute("uv"), c.onBeforeRender = function(_, M, b) {
            this.matrixWorld.copyPosition(b.matrixWorld);
        }, Object.defineProperty(c.material, "envMap", {
            get: function() {
                return this.uniforms.envMap.value;
            }
        }), i.update(c)), c.material.uniforms.envMap.value = x, c.material.uniforms.flipEnvMap.value = x.isCubeTexture && x.isRenderTargetTexture === !1 ? -1 : 1, c.material.uniforms.backgroundBlurriness.value = y.backgroundBlurriness, c.material.uniforms.backgroundIntensity.value = y.backgroundIntensity, c.material.toneMapped = x.encoding !== Ye, (d !== x || h !== x.version || f !== r1.toneMapping) && (c.material.needsUpdate = !0, d = x, h = x.version, f = r1.toneMapping), c.layers.enableAll(), g.unshift(c, c.geometry, c.material, 0, 0, null)) : x && x.isTexture && (u === void 0 && (u = new In(new so(2, 2), new ot({
            name: "BackgroundMaterial",
            uniforms: ac(ps.background.uniforms),
            vertexShader: ps.background.vertexShader,
            fragmentShader: ps.background.fragmentShader,
            side: si,
            depthTest: !1,
            depthWrite: !1,
            fog: !1
        })), u.geometry.deleteAttribute("normal"), Object.defineProperty(u.material, "map", {
            get: function() {
                return this.uniforms.t2D.value;
            }
        }), i.update(u)), u.material.uniforms.t2D.value = x, u.material.uniforms.backgroundIntensity.value = y.backgroundIntensity, u.material.toneMapped = x.encoding !== Ye, x.matrixAutoUpdate === !0 && x.updateMatrix(), u.material.uniforms.uvTransform.value.copy(x.matrix), (d !== x || h !== x.version || f !== r1.toneMapping) && (u.material.needsUpdate = !0, d = x, h = x.version, f = r1.toneMapping), u.layers.enableAll(), g.unshift(u, u.geometry, u.material, 0, 0, null));
    }
    function p(g, y) {
        g.getRGB(Sp, PA(r1)), n.buffers.color.setClear(Sp.r, Sp.g, Sp.b, y, o);
    }
    return {
        getClearColor: function() {
            return a;
        },
        setClearColor: function(g, y = 1) {
            a.set(g), l = y, p(a, l);
        },
        getClearAlpha: function() {
            return l;
        },
        setClearAlpha: function(g) {
            l = g, p(a, l);
        },
        render: m
    };
}
function X3(r1, t, e, n) {
    let i = r1.getParameter(34921), s = n.isWebGL2 ? null : t.get("OES_vertex_array_object"), o = n.isWebGL2 || s !== null, a = {}, l = g(null), u = l, c = !1;
    function d(O, B, V, Y, W) {
        let q = !1;
        if (o) {
            let j = p(Y, V, B);
            u !== j && (u = j, f(u.object)), q = y(O, Y, V, W), q && v(O, Y, V, W);
        } else {
            let j = B.wireframe === !0;
            (u.geometry !== Y.id || u.program !== V.id || u.wireframe !== j) && (u.geometry = Y.id, u.program = V.id, u.wireframe = j, q = !0);
        }
        W !== null && e.update(W, 34963), (q || c) && (c = !1, b(O, B, V, Y), W !== null && r1.bindBuffer(34963, e.get(W).buffer));
    }
    function h() {
        return n.isWebGL2 ? r1.createVertexArray() : s.createVertexArrayOES();
    }
    function f(O) {
        return n.isWebGL2 ? r1.bindVertexArray(O) : s.bindVertexArrayOES(O);
    }
    function m(O) {
        return n.isWebGL2 ? r1.deleteVertexArray(O) : s.deleteVertexArrayOES(O);
    }
    function p(O, B, V) {
        let Y = V.wireframe === !0, W = a[O.id];
        W === void 0 && (W = {}, a[O.id] = W);
        let q = W[B.id];
        q === void 0 && (q = {}, W[B.id] = q);
        let j = q[Y];
        return j === void 0 && (j = g(h()), q[Y] = j), j;
    }
    function g(O) {
        let B = [], V = [], Y = [];
        for(let W = 0; W < i; W++)B[W] = 0, V[W] = 0, Y[W] = 0;
        return {
            geometry: null,
            program: null,
            wireframe: !1,
            newAttributes: B,
            enabledAttributes: V,
            attributeDivisors: Y,
            object: O,
            attributes: {},
            index: null
        };
    }
    function y(O, B, V, Y) {
        let W = u.attributes, q = B.attributes, j = 0, X = V.getAttributes();
        for(let L in X)if (X[L].location >= 0) {
            let G = W[L], H = q[L];
            if (H === void 0 && (L === "instanceMatrix" && O.instanceMatrix && (H = O.instanceMatrix), L === "instanceColor" && O.instanceColor && (H = O.instanceColor)), G === void 0 || G.attribute !== H || H && G.data !== H.data) return !0;
            j++;
        }
        return u.attributesNum !== j || u.index !== Y;
    }
    function v(O, B, V, Y) {
        let W = {}, q = B.attributes, j = 0, X = V.getAttributes();
        for(let L in X)if (X[L].location >= 0) {
            let G = q[L];
            G === void 0 && (L === "instanceMatrix" && O.instanceMatrix && (G = O.instanceMatrix), L === "instanceColor" && O.instanceColor && (G = O.instanceColor));
            let H = {};
            H.attribute = G, G && G.data && (H.data = G.data), W[L] = H, j++;
        }
        u.attributes = W, u.attributesNum = j, u.index = Y;
    }
    function x() {
        let O = u.newAttributes;
        for(let B = 0, V = O.length; B < V; B++)O[B] = 0;
    }
    function w(O) {
        S(O, 0);
    }
    function S(O, B) {
        let V = u.newAttributes, Y = u.enabledAttributes, W = u.attributeDivisors;
        V[O] = 1, Y[O] === 0 && (r1.enableVertexAttribArray(O), Y[O] = 1), W[O] !== B && ((n.isWebGL2 ? r1 : t.get("ANGLE_instanced_arrays"))[n.isWebGL2 ? "vertexAttribDivisor" : "vertexAttribDivisorANGLE"](O, B), W[O] = B);
    }
    function _() {
        let O = u.newAttributes, B = u.enabledAttributes;
        for(let V = 0, Y = B.length; V < Y; V++)B[V] !== O[V] && (r1.disableVertexAttribArray(V), B[V] = 0);
    }
    function M(O, B, V, Y, W, q) {
        n.isWebGL2 === !0 && (V === 5124 || V === 5125) ? r1.vertexAttribIPointer(O, B, V, W, q) : r1.vertexAttribPointer(O, B, V, Y, W, q);
    }
    function b(O, B, V, Y) {
        if (n.isWebGL2 === !1 && (O.isInstancedMesh || Y.isInstancedBufferGeometry) && t.get("ANGLE_instanced_arrays") === null) return;
        x();
        let W = Y.attributes, q = V.getAttributes(), j = B.defaultAttributeValues;
        for(let X in q){
            let L = q[X];
            if (L.location >= 0) {
                let U = W[X];
                if (U === void 0 && (X === "instanceMatrix" && O.instanceMatrix && (U = O.instanceMatrix), X === "instanceColor" && O.instanceColor && (U = O.instanceColor)), U !== void 0) {
                    let G = U.normalized, H = U.itemSize, z = e.get(U);
                    if (z === void 0) continue;
                    let re = z.buffer, K = z.type, Z = z.bytesPerElement;
                    if (U.isInterleavedBufferAttribute) {
                        let k = U.data, he = k.stride, fe = U.offset;
                        if (k.isInstancedInterleavedBuffer) {
                            for(let ce = 0; ce < L.locationSize; ce++)S(L.location + ce, k.meshPerAttribute);
                            O.isInstancedMesh !== !0 && Y._maxInstanceCount === void 0 && (Y._maxInstanceCount = k.meshPerAttribute * k.count);
                        } else for(let ce = 0; ce < L.locationSize; ce++)w(L.location + ce);
                        r1.bindBuffer(34962, re);
                        for(let ce = 0; ce < L.locationSize; ce++)M(L.location + ce, H / L.locationSize, K, G, he * Z, (fe + H / L.locationSize * ce) * Z);
                    } else {
                        if (U.isInstancedBufferAttribute) {
                            for(let k = 0; k < L.locationSize; k++)S(L.location + k, U.meshPerAttribute);
                            O.isInstancedMesh !== !0 && Y._maxInstanceCount === void 0 && (Y._maxInstanceCount = U.meshPerAttribute * U.count);
                        } else for(let k = 0; k < L.locationSize; k++)w(L.location + k);
                        r1.bindBuffer(34962, re);
                        for(let k = 0; k < L.locationSize; k++)M(L.location + k, H / L.locationSize, K, G, H * Z, H / L.locationSize * k * Z);
                    }
                } else if (j !== void 0) {
                    let G = j[X];
                    if (G !== void 0) switch(G.length){
                        case 2:
                            r1.vertexAttrib2fv(L.location, G);
                            break;
                        case 3:
                            r1.vertexAttrib3fv(L.location, G);
                            break;
                        case 4:
                            r1.vertexAttrib4fv(L.location, G);
                            break;
                        default:
                            r1.vertexAttrib1fv(L.location, G);
                    }
                }
            }
        }
        _();
    }
    function T() {
        D();
        for(let O in a){
            let B = a[O];
            for(let V in B){
                let Y = B[V];
                for(let W in Y)m(Y[W].object), delete Y[W];
                delete B[V];
            }
            delete a[O];
        }
    }
    function E(O) {
        if (a[O.id] === void 0) return;
        let B = a[O.id];
        for(let V in B){
            let Y = B[V];
            for(let W in Y)m(Y[W].object), delete Y[W];
            delete B[V];
        }
        delete a[O.id];
    }
    function P(O) {
        for(let B in a){
            let V = a[B];
            if (V[O.id] === void 0) continue;
            let Y = V[O.id];
            for(let W in Y)m(Y[W].object), delete Y[W];
            delete V[O.id];
        }
    }
    function D() {
        C(), c = !0, u !== l && (u = l, f(u.object));
    }
    function C() {
        l.geometry = null, l.program = null, l.wireframe = !1;
    }
    return {
        setup: d,
        reset: D,
        resetDefaultState: C,
        dispose: T,
        releaseStatesOfGeometry: E,
        releaseStatesOfProgram: P,
        initAttributes: x,
        enableAttribute: w,
        disableUnusedAttributes: _
    };
}
function Y3(r1, t, e, n) {
    let i = n.isWebGL2, s;
    function o(u) {
        s = u;
    }
    function a(u, c) {
        r1.drawArrays(s, u, c), e.update(c, s, 1);
    }
    function l(u, c, d) {
        if (d === 0) return;
        let h, f;
        if (i) h = r1, f = "drawArraysInstanced";
        else if (h = t.get("ANGLE_instanced_arrays"), f = "drawArraysInstancedANGLE", h === null) {
            console.error("THREE.WebGLBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");
            return;
        }
        h[f](s, u, c, d), e.update(c, s, d);
    }
    this.setMode = o, this.render = a, this.renderInstances = l;
}
function Q3(r1, t, e) {
    let n;
    function i() {
        if (n !== void 0) return n;
        if (t.has("EXT_texture_filter_anisotropic") === !0) {
            let M = t.get("EXT_texture_filter_anisotropic");
            n = r1.getParameter(M.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
        } else n = 0;
        return n;
    }
    function s(M) {
        if (M === "highp") {
            if (r1.getShaderPrecisionFormat(35633, 36338).precision > 0 && r1.getShaderPrecisionFormat(35632, 36338).precision > 0) return "highp";
            M = "mediump";
        }
        return M === "mediump" && r1.getShaderPrecisionFormat(35633, 36337).precision > 0 && r1.getShaderPrecisionFormat(35632, 36337).precision > 0 ? "mediump" : "lowp";
    }
    let o = typeof WebGL2RenderingContext < "u" && r1 instanceof WebGL2RenderingContext, a = e.precision !== void 0 ? e.precision : "highp", l = s(a);
    l !== a && (console.warn("THREE.WebGLRenderer:", a, "not supported, using", l, "instead."), a = l);
    let u = o || t.has("WEBGL_draw_buffers"), c = e.logarithmicDepthBuffer === !0, d = r1.getParameter(34930), h = r1.getParameter(35660), f = r1.getParameter(3379), m = r1.getParameter(34076), p = r1.getParameter(34921), g = r1.getParameter(36347), y = r1.getParameter(36348), v = r1.getParameter(36349), x = h > 0, w = o || t.has("OES_texture_float"), S = x && w, _ = o ? r1.getParameter(36183) : 0;
    return {
        isWebGL2: o,
        drawBuffers: u,
        getMaxAnisotropy: i,
        getMaxPrecision: s,
        precision: a,
        logarithmicDepthBuffer: c,
        maxTextures: d,
        maxVertexTextures: h,
        maxTextureSize: f,
        maxCubemapSize: m,
        maxAttributes: p,
        maxVertexUniforms: g,
        maxVaryings: y,
        maxFragmentUniforms: v,
        vertexTextures: x,
        floatFragmentTextures: w,
        floatVertexTextures: S,
        maxSamples: _
    };
}
function K3(r1) {
    let t = this, e = null, n = 0, i = !1, s = !1, o = new yn, a = new Kt, l = {
        value: null,
        needsUpdate: !1
    };
    this.uniform = l, this.numPlanes = 0, this.numIntersection = 0, this.init = function(d, h) {
        let f = d.length !== 0 || h || n !== 0 || i;
        return i = h, n = d.length, f;
    }, this.beginShadows = function() {
        s = !0, c(null);
    }, this.endShadows = function() {
        s = !1;
    }, this.setGlobalState = function(d, h) {
        e = c(d, h, 0);
    }, this.setState = function(d, h, f) {
        let m = d.clippingPlanes, p = d.clipIntersection, g = d.clipShadows, y = r1.get(d);
        if (!i || m === null || m.length === 0 || s && !g) s ? c(null) : u();
        else {
            let v = s ? 0 : n, x = v * 4, w = y.clippingState || null;
            l.value = w, w = c(m, h, x, f);
            for(let S = 0; S !== x; ++S)w[S] = e[S];
            y.clippingState = w, this.numIntersection = p ? this.numPlanes : 0, this.numPlanes += v;
        }
    };
    function u() {
        l.value !== e && (l.value = e, l.needsUpdate = n > 0), t.numPlanes = n, t.numIntersection = 0;
    }
    function c(d, h, f, m) {
        let p = d !== null ? d.length : 0, g = null;
        if (p !== 0) {
            if (g = l.value, m !== !0 || g === null) {
                let y = f + p * 4, v = h.matrixWorldInverse;
                a.getNormalMatrix(v), (g === null || g.length < y) && (g = new Float32Array(y));
                for(let x = 0, w = f; x !== p; ++x, w += 4)o.copy(d[x]).applyMatrix4(v, a), o.normal.toArray(g, w), g[w + 3] = o.constant;
            }
            l.value = g, l.needsUpdate = !0;
        }
        return t.numPlanes = p, t.numIntersection = 0, g;
    }
}
function Z3(r1) {
    let t = new WeakMap;
    function e(o, a) {
        return a === f0 ? o.mapping = Vo : a === p0 && (o.mapping = Ho), o;
    }
    function n(o) {
        if (o && o.isTexture && o.isRenderTargetTexture === !1) {
            let a = o.mapping;
            if (a === f0 || a === p0) {
                if (t.has(o)) {
                    let l = t.get(o).texture;
                    return e(l, o.mapping);
                } else {
                    let l = o.image;
                    if (l && l.height > 0) {
                        let u = new b0(l.height / 2);
                        return u.fromEquirectangularTexture(r1, o), t.set(o, u), o.addEventListener("dispose", i), e(u.texture, o.mapping);
                    } else return null;
                }
            }
        }
        return o;
    }
    function i(o) {
        let a = o.target;
        a.removeEventListener("dispose", i);
        let l = t.get(a);
        l !== void 0 && (t.delete(a), l.dispose());
    }
    function s() {
        t = new WeakMap;
    }
    return {
        get: n,
        dispose: s
    };
}
var ja = class extends ki {
    constructor(t = -1, e = 1, n = 1, i = -1, s = .1, o = 2e3){
        super(), this.isOrthographicCamera = !0, this.type = "OrthographicCamera", this.zoom = 1, this.view = null, this.left = t, this.right = e, this.top = n, this.bottom = i, this.near = s, this.far = o, this.updateProjectionMatrix();
    }
    copy(t, e) {
        return super.copy(t, e), this.left = t.left, this.right = t.right, this.top = t.top, this.bottom = t.bottom, this.near = t.near, this.far = t.far, this.zoom = t.zoom, this.view = t.view === null ? null : Object.assign({}, t.view), this;
    }
    setViewOffset(t, e, n, i, s, o) {
        this.view === null && (this.view = {
            enabled: !0,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        }), this.view.enabled = !0, this.view.fullWidth = t, this.view.fullHeight = e, this.view.offsetX = n, this.view.offsetY = i, this.view.width = s, this.view.height = o, this.updateProjectionMatrix();
    }
    clearViewOffset() {
        this.view !== null && (this.view.enabled = !1), this.updateProjectionMatrix();
    }
    updateProjectionMatrix() {
        let t = (this.right - this.left) / (2 * this.zoom), e = (this.top - this.bottom) / (2 * this.zoom), n = (this.right + this.left) / 2, i = (this.top + this.bottom) / 2, s = n - t, o = n + t, a = i + e, l = i - e;
        if (this.view !== null && this.view.enabled) {
            let u = (this.right - this.left) / this.view.fullWidth / this.zoom, c = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
            s += u * this.view.offsetX, o = s + u * this.view.width, a -= c * this.view.offsetY, l = a - c * this.view.height;
        }
        this.projectionMatrix.makeOrthographic(s, o, a, l, this.near, this.far), this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(t) {
        let e = super.toJSON(t);
        return e.object.zoom = this.zoom, e.object.left = this.left, e.object.right = this.right, e.object.top = this.top, e.object.bottom = this.bottom, e.object.near = this.near, e.object.far = this.far, this.view !== null && (e.object.view = Object.assign({}, this.view)), e;
    }
}, rc = 4, N1 = [
    .125,
    .215,
    .35,
    .446,
    .526,
    .582
], ka = 20, r0 = new ja, B1 = new Ne, i0 = null, Ua = (1 + Math.sqrt(5)) / 2, tc = 1 / Ua, F1 = [
    new A(1, 1, 1),
    new A(-1, 1, 1),
    new A(1, 1, -1),
    new A(-1, 1, -1),
    new A(0, Ua, tc),
    new A(0, Ua, -tc),
    new A(tc, 0, Ua),
    new A(-tc, 0, Ua),
    new A(Ua, tc, 0),
    new A(-Ua, tc, 0)
], Hp = class {
    constructor(t){
        this._renderer = t, this._pingPongRenderTarget = null, this._lodMax = 0, this._cubeSize = 0, this._lodPlanes = [], this._sizeLods = [], this._sigmas = [], this._blurMaterial = null, this._cubemapMaterial = null, this._equirectMaterial = null, this._compileMaterial(this._blurMaterial);
    }
    fromScene(t, e = 0, n = .1, i = 100) {
        i0 = this._renderer.getRenderTarget(), this._setSize(256);
        let s = this._allocateTargets();
        return s.depthBuffer = !0, this._sceneToCubeUV(t, n, i, s), e > 0 && this._blur(s, 0, 0, e), this._applyPMREM(s), this._cleanup(s), s;
    }
    fromEquirectangular(t, e = null) {
        return this._fromTexture(t, e);
    }
    fromCubemap(t, e = null) {
        return this._fromTexture(t, e);
    }
    compileCubemapShader() {
        this._cubemapMaterial === null && (this._cubemapMaterial = z1(), this._compileMaterial(this._cubemapMaterial));
    }
    compileEquirectangularShader() {
        this._equirectMaterial === null && (this._equirectMaterial = k1(), this._compileMaterial(this._equirectMaterial));
    }
    dispose() {
        this._dispose(), this._cubemapMaterial !== null && this._cubemapMaterial.dispose(), this._equirectMaterial !== null && this._equirectMaterial.dispose();
    }
    _setSize(t) {
        this._lodMax = Math.floor(Math.log2(t)), this._cubeSize = Math.pow(2, this._lodMax);
    }
    _dispose() {
        this._blurMaterial !== null && this._blurMaterial.dispose(), this._pingPongRenderTarget !== null && this._pingPongRenderTarget.dispose();
        for(let t = 0; t < this._lodPlanes.length; t++)this._lodPlanes[t].dispose();
    }
    _cleanup(t) {
        this._renderer.setRenderTarget(i0), t.scissorTest = !1, Ap(t, 0, 0, t.width, t.height);
    }
    _fromTexture(t, e) {
        t.mapping === Vo || t.mapping === Ho ? this._setSize(t.image.length === 0 ? 16 : t.image[0].width || t.image[0].image.width) : this._setSize(t.image.width / 4), i0 = this._renderer.getRenderTarget();
        let n = e || this._allocateTargets();
        return this._textureToCubeUV(t, n), this._applyPMREM(n), this._cleanup(n), n;
    }
    _allocateTargets() {
        let t = 3 * Math.max(this._cubeSize, 112), e = 4 * this._cubeSize, n = {
            magFilter: Qe,
            minFilter: Qe,
            generateMipmaps: !1,
            type: Ha,
            format: gi,
            encoding: oi,
            depthBuffer: !1
        }, i = U1(t, e, n);
        if (this._pingPongRenderTarget === null || this._pingPongRenderTarget.width !== t || this._pingPongRenderTarget.height !== e) {
            this._pingPongRenderTarget !== null && this._dispose(), this._pingPongRenderTarget = U1(t, e, n);
            let { _lodMax: s  } = this;
            ({ sizeLods: this._sizeLods , lodPlanes: this._lodPlanes , sigmas: this._sigmas  } = J3(s)), this._blurMaterial = $3(s, t, e);
        }
        return i;
    }
    _compileMaterial(t) {
        let e = new In(this._lodPlanes[0], t);
        this._renderer.compile(e, r0);
    }
    _sceneToCubeUV(t, e, n, i) {
        let a = new gn(90, 1, e, n), l = [
            1,
            -1,
            1,
            1,
            1,
            1
        ], u = [
            1,
            1,
            1,
            -1,
            -1,
            -1
        ], c = this._renderer, d = c.autoClear, h = c.toneMapping;
        c.getClearColor(B1), c.toneMapping = io, c.autoClear = !1;
        let f = new Ui({
            name: "PMREM.Background",
            side: On,
            depthWrite: !1,
            depthTest: !1
        }), m = new In(new er, f), p = !1, g = t.background;
        g ? g.isColor && (f.color.copy(g), t.background = null, p = !0) : (f.color.copy(B1), p = !0);
        for(let y = 0; y < 6; y++){
            let v = y % 3;
            v === 0 ? (a.up.set(0, l[y], 0), a.lookAt(u[y], 0, 0)) : v === 1 ? (a.up.set(0, 0, l[y]), a.lookAt(0, u[y], 0)) : (a.up.set(0, l[y], 0), a.lookAt(0, 0, u[y]));
            let x = this._cubeSize;
            Ap(i, v * x, y > 2 ? x : 0, x, x), c.setRenderTarget(i), p && c.render(m, a), c.render(t, a);
        }
        m.geometry.dispose(), m.material.dispose(), c.toneMapping = h, c.autoClear = d, t.background = g;
    }
    _textureToCubeUV(t, e) {
        let n = this._renderer, i = t.mapping === Vo || t.mapping === Ho;
        i ? (this._cubemapMaterial === null && (this._cubemapMaterial = z1()), this._cubemapMaterial.uniforms.flipEnvMap.value = t.isRenderTargetTexture === !1 ? -1 : 1) : this._equirectMaterial === null && (this._equirectMaterial = k1());
        let s = i ? this._cubemapMaterial : this._equirectMaterial, o = new In(this._lodPlanes[0], s), a = s.uniforms;
        a.envMap.value = t;
        let l = this._cubeSize;
        Ap(e, 0, 0, 3 * l, 2 * l), n.setRenderTarget(e), n.render(o, r0);
    }
    _applyPMREM(t) {
        let e = this._renderer, n = e.autoClear;
        e.autoClear = !1;
        for(let i = 1; i < this._lodPlanes.length; i++){
            let s = Math.sqrt(this._sigmas[i] * this._sigmas[i] - this._sigmas[i - 1] * this._sigmas[i - 1]), o = F1[(i - 1) % F1.length];
            this._blur(t, i - 1, i, s, o);
        }
        e.autoClear = n;
    }
    _blur(t, e, n, i, s) {
        let o = this._pingPongRenderTarget;
        this._halfBlur(t, o, e, n, i, "latitudinal", s), this._halfBlur(o, t, n, n, i, "longitudinal", s);
    }
    _halfBlur(t, e, n, i, s, o, a) {
        let l = this._renderer, u = this._blurMaterial;
        o !== "latitudinal" && o !== "longitudinal" && console.error("blur direction must be either latitudinal or longitudinal!");
        let c = 3, d = new In(this._lodPlanes[i], u), h = u.uniforms, f = this._sizeLods[n] - 1, m = isFinite(s) ? Math.PI / (2 * f) : 2 * Math.PI / (2 * ka - 1), p = s / m, g = isFinite(s) ? 1 + Math.floor(c * p) : ka;
        g > ka && console.warn(`sigmaRadians, ${s}, is too large and will clip, as it requested ${g} samples when the maximum is set to ${ka}`);
        let y = [], v = 0;
        for(let M = 0; M < ka; ++M){
            let b = M / p, T = Math.exp(-b * b / 2);
            y.push(T), M === 0 ? v += T : M < g && (v += 2 * T);
        }
        for(let M = 0; M < y.length; M++)y[M] = y[M] / v;
        h.envMap.value = t.texture, h.samples.value = g, h.weights.value = y, h.latitudinal.value = o === "latitudinal", a && (h.poleAxis.value = a);
        let { _lodMax: x  } = this;
        h.dTheta.value = m, h.mipInt.value = x - n;
        let w = this._sizeLods[i], S = 3 * w * (i > x - rc ? i - x + rc : 0), _ = 4 * (this._cubeSize - w);
        Ap(e, S, _, 3 * w, 2 * w), l.setRenderTarget(e), l.render(d, r0);
    }
};
function J3(r1) {
    let t = [], e = [], n = [], i = r1, s = r1 - rc + 1 + N1.length;
    for(let o = 0; o < s; o++){
        let a = Math.pow(2, i);
        e.push(a);
        let l = 1 / a;
        o > r1 - rc ? l = N1[o - r1 + rc - 1] : o === 0 && (l = 0), n.push(l);
        let u = 1 / (a - 2), c = -u, d = 1 + u, h = [
            c,
            c,
            d,
            c,
            d,
            d,
            c,
            c,
            d,
            d,
            c,
            d
        ], f = 6, m = 6, p = 3, g = 2, y = 1, v = new Float32Array(p * m * f), x = new Float32Array(g * m * f), w = new Float32Array(y * m * f);
        for(let _ = 0; _ < f; _++){
            let M = _ % 3 * 2 / 3 - 1, b = _ > 2 ? 0 : -1, T = [
                M,
                b,
                0,
                M + 2 / 3,
                b,
                0,
                M + 2 / 3,
                b + 1,
                0,
                M,
                b,
                0,
                M + 2 / 3,
                b + 1,
                0,
                M,
                b + 1,
                0
            ];
            v.set(T, p * m * _), x.set(h, g * m * _);
            let E = [
                _,
                _,
                _,
                _,
                _,
                _
            ];
            w.set(E, y * m * _);
        }
        let S = new Me;
        S.setAttribute("position", new Be(v, p)), S.setAttribute("uv", new Be(x, g)), S.setAttribute("faceIndex", new Be(w, y)), t.push(S), i > rc && i--;
    }
    return {
        lodPlanes: t,
        sizeLods: e,
        sigmas: n
    };
}
function U1(r1, t, e) {
    let n = new st(r1, t, e);
    return n.texture.mapping = Ac, n.texture.name = "PMREM.cubeUv", n.scissorTest = !0, n;
}
function Ap(r1, t, e, n, i) {
    r1.viewport.set(t, e, n, i), r1.scissor.set(t, e, n, i);
}
function $3(r1, t, e) {
    let n = new Float32Array(ka), i = new A(0, 1, 0);
    return new ot({
        name: "SphericalGaussianBlur",
        defines: {
            n: ka,
            CUBEUV_TEXEL_WIDTH: 1 / t,
            CUBEUV_TEXEL_HEIGHT: 1 / e,
            CUBEUV_MAX_MIP: `${r1}.0`
        },
        uniforms: {
            envMap: {
                value: null
            },
            samples: {
                value: 1
            },
            weights: {
                value: n
            },
            latitudinal: {
                value: !1
            },
            dTheta: {
                value: 0
            },
            mipInt: {
                value: 0
            },
            poleAxis: {
                value: i
            }
        },
        vertexShader: ex(),
        fragmentShader: `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform int samples;
			uniform float weights[ n ];
			uniform bool latitudinal;
			uniform float dTheta;
			uniform float mipInt;
			uniform vec3 poleAxis;

			#define ENVMAP_TYPE_CUBE_UV
			#include <cube_uv_reflection_fragment>

			vec3 getSample( float theta, vec3 axis ) {

				float cosTheta = cos( theta );
				// Rodrigues' axis-angle rotation
				vec3 sampleDirection = vOutputDirection * cosTheta
					+ cross( axis, vOutputDirection ) * sin( theta )
					+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );

				return bilinearCubeUV( envMap, sampleDirection, mipInt );

			}

			void main() {

				vec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );

				if ( all( equal( axis, vec3( 0.0 ) ) ) ) {

					axis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );

				}

				axis = normalize( axis );

				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );
				gl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );

				for ( int i = 1; i < n; i++ ) {

					if ( i >= samples ) {

						break;

					}

					float theta = dTheta * float( i );
					gl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );
					gl_FragColor.rgb += weights[ i ] * getSample( theta, axis );

				}

			}
		`,
        blending: Dt,
        depthTest: !1,
        depthWrite: !1
    });
}
function k1() {
    return new ot({
        name: "EquirectangularToCubeUV",
        uniforms: {
            envMap: {
                value: null
            }
        },
        vertexShader: ex(),
        fragmentShader: `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;

			#include <common>

			void main() {

				vec3 outputDirection = normalize( vOutputDirection );
				vec2 uv = equirectUv( outputDirection );

				gl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );

			}
		`,
        blending: Dt,
        depthTest: !1,
        depthWrite: !1
    });
}
function z1() {
    return new ot({
        name: "CubemapToCubeUV",
        uniforms: {
            envMap: {
                value: null
            },
            flipEnvMap: {
                value: -1
            }
        },
        vertexShader: ex(),
        fragmentShader: `

			precision mediump float;
			precision mediump int;

			uniform float flipEnvMap;

			varying vec3 vOutputDirection;

			uniform samplerCube envMap;

			void main() {

				gl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );

			}
		`,
        blending: Dt,
        depthTest: !1,
        depthWrite: !1
    });
}
function ex() {
    return `

		precision mediump float;
		precision mediump int;

		attribute float faceIndex;

		varying vec3 vOutputDirection;

		// RH coordinate system; PMREM face-indexing convention
		vec3 getDirection( vec2 uv, float face ) {

			uv = 2.0 * uv - 1.0;

			vec3 direction = vec3( uv, 1.0 );

			if ( face == 0.0 ) {

				direction = direction.zyx; // ( 1, v, u ) pos x

			} else if ( face == 1.0 ) {

				direction = direction.xzy;
				direction.xz *= -1.0; // ( -u, 1, -v ) pos y

			} else if ( face == 2.0 ) {

				direction.x *= -1.0; // ( -u, v, 1 ) pos z

			} else if ( face == 3.0 ) {

				direction = direction.zyx;
				direction.xz *= -1.0; // ( -1, v, -u ) neg x

			} else if ( face == 4.0 ) {

				direction = direction.xzy;
				direction.xy *= -1.0; // ( -u, -1, v ) neg y

			} else if ( face == 5.0 ) {

				direction.z *= -1.0; // ( u, v, -1 ) neg z

			}

			return direction;

		}

		void main() {

			vOutputDirection = getDirection( uv, faceIndex );
			gl_Position = vec4( position, 1.0 );

		}
	`;
}
function eN(r1) {
    let t = new WeakMap, e = null;
    function n(a) {
        if (a && a.isTexture) {
            let l = a.mapping, u = l === f0 || l === p0, c = l === Vo || l === Ho;
            if (u || c) {
                if (a.isRenderTargetTexture && a.needsPMREMUpdate === !0) {
                    a.needsPMREMUpdate = !1;
                    let d = t.get(a);
                    return e === null && (e = new Hp(r1)), d = u ? e.fromEquirectangular(a, d) : e.fromCubemap(a, d), t.set(a, d), d.texture;
                } else {
                    if (t.has(a)) return t.get(a).texture;
                    {
                        let d = a.image;
                        if (u && d && d.height > 0 || c && d && i(d)) {
                            e === null && (e = new Hp(r1));
                            let h = u ? e.fromEquirectangular(a) : e.fromCubemap(a);
                            return t.set(a, h), a.addEventListener("dispose", s), h.texture;
                        } else return null;
                    }
                }
            }
        }
        return a;
    }
    function i(a) {
        let l = 0, u = 6;
        for(let c = 0; c < u; c++)a[c] !== void 0 && l++;
        return l === u;
    }
    function s(a) {
        let l = a.target;
        l.removeEventListener("dispose", s);
        let u = t.get(l);
        u !== void 0 && (t.delete(l), u.dispose());
    }
    function o() {
        t = new WeakMap, e !== null && (e.dispose(), e = null);
    }
    return {
        get: n,
        dispose: o
    };
}
function tN(r1) {
    let t = {};
    function e(n) {
        if (t[n] !== void 0) return t[n];
        let i;
        switch(n){
            case "WEBGL_depth_texture":
                i = r1.getExtension("WEBGL_depth_texture") || r1.getExtension("MOZ_WEBGL_depth_texture") || r1.getExtension("WEBKIT_WEBGL_depth_texture");
                break;
            case "EXT_texture_filter_anisotropic":
                i = r1.getExtension("EXT_texture_filter_anisotropic") || r1.getExtension("MOZ_EXT_texture_filter_anisotropic") || r1.getExtension("WEBKIT_EXT_texture_filter_anisotropic");
                break;
            case "WEBGL_compressed_texture_s3tc":
                i = r1.getExtension("WEBGL_compressed_texture_s3tc") || r1.getExtension("MOZ_WEBGL_compressed_texture_s3tc") || r1.getExtension("WEBKIT_WEBGL_compressed_texture_s3tc");
                break;
            case "WEBGL_compressed_texture_pvrtc":
                i = r1.getExtension("WEBGL_compressed_texture_pvrtc") || r1.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc");
                break;
            default:
                i = r1.getExtension(n);
        }
        return t[n] = i, i;
    }
    return {
        has: function(n) {
            return e(n) !== null;
        },
        init: function(n) {
            n.isWebGL2 ? e("EXT_color_buffer_float") : (e("WEBGL_depth_texture"), e("OES_texture_float"), e("OES_texture_half_float"), e("OES_texture_half_float_linear"), e("OES_standard_derivatives"), e("OES_element_index_uint"), e("OES_vertex_array_object"), e("ANGLE_instanced_arrays")), e("OES_texture_float_linear"), e("EXT_color_buffer_half_float"), e("WEBGL_multisampled_render_to_texture");
        },
        get: function(n) {
            let i = e(n);
            return i === null && console.warn("THREE.WebGLRenderer: " + n + " extension not supported."), i;
        }
    };
}
function nN(r1, t, e, n) {
    let i = {}, s = new WeakMap;
    function o(d) {
        let h = d.target;
        h.index !== null && t.remove(h.index);
        for(let m in h.attributes)t.remove(h.attributes[m]);
        h.removeEventListener("dispose", o), delete i[h.id];
        let f = s.get(h);
        f && (t.remove(f), s.delete(h)), n.releaseStatesOfGeometry(h), h.isInstancedBufferGeometry === !0 && delete h._maxInstanceCount, e.memory.geometries--;
    }
    function a(d, h) {
        return i[h.id] === !0 || (h.addEventListener("dispose", o), i[h.id] = !0, e.memory.geometries++), h;
    }
    function l(d) {
        let h = d.attributes;
        for(let m in h)t.update(h[m], 34962);
        let f = d.morphAttributes;
        for(let m in f){
            let p = f[m];
            for(let g = 0, y = p.length; g < y; g++)t.update(p[g], 34962);
        }
    }
    function u(d) {
        let h = [], f = d.index, m = d.attributes.position, p = 0;
        if (f !== null) {
            let v = f.array;
            p = f.version;
            for(let x = 0, w = v.length; x < w; x += 3){
                let S = v[x + 0], _ = v[x + 1], M = v[x + 2];
                h.push(S, _, _, M, M, S);
            }
        } else {
            let v = m.array;
            p = m.version;
            for(let x = 0, w = v.length / 3 - 1; x < w; x += 3){
                let S = x + 0, _ = x + 1, M = x + 2;
                h.push(S, _, _, M, M, S);
            }
        }
        let g = new (EA(h) ? ys : Vp)(h, 1);
        g.version = p;
        let y = s.get(d);
        y && t.remove(y), s.set(d, g);
    }
    function c(d) {
        let h = s.get(d);
        if (h) {
            let f = d.index;
            f !== null && h.version < f.version && u(d);
        } else u(d);
        return s.get(d);
    }
    return {
        get: a,
        update: l,
        getWireframeAttribute: c
    };
}
function rN(r1, t, e, n) {
    let i = n.isWebGL2, s;
    function o(h) {
        s = h;
    }
    let a, l;
    function u(h) {
        a = h.type, l = h.bytesPerElement;
    }
    function c(h, f) {
        r1.drawElements(s, f, a, h * l), e.update(f, s, 1);
    }
    function d(h, f, m) {
        if (m === 0) return;
        let p, g;
        if (i) p = r1, g = "drawElementsInstanced";
        else if (p = t.get("ANGLE_instanced_arrays"), g = "drawElementsInstancedANGLE", p === null) {
            console.error("THREE.WebGLIndexedBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.");
            return;
        }
        p[g](s, f, a, h * l, m), e.update(f, s, m);
    }
    this.setMode = o, this.setIndex = u, this.render = c, this.renderInstances = d;
}
function iN(r1) {
    let t = {
        geometries: 0,
        textures: 0
    }, e = {
        frame: 0,
        calls: 0,
        triangles: 0,
        points: 0,
        lines: 0
    };
    function n(s, o, a) {
        switch(e.calls++, o){
            case 4:
                e.triangles += a * (s / 3);
                break;
            case 1:
                e.lines += a * (s / 2);
                break;
            case 3:
                e.lines += a * (s - 1);
                break;
            case 2:
                e.lines += a * s;
                break;
            case 0:
                e.points += a * s;
                break;
            default:
                console.error("THREE.WebGLInfo: Unknown draw mode:", o);
                break;
        }
    }
    function i() {
        e.frame++, e.calls = 0, e.triangles = 0, e.points = 0, e.lines = 0;
    }
    return {
        memory: t,
        render: e,
        programs: null,
        autoReset: !0,
        reset: i,
        update: n
    };
}
function sN(r1, t) {
    return r1[0] - t[0];
}
function oN(r1, t) {
    return Math.abs(t[1]) - Math.abs(r1[1]);
}
function aN(r1, t, e) {
    let n = {}, i = new Float32Array(8), s = new WeakMap, o = new Ze, a = [];
    for(let u = 0; u < 8; u++)a[u] = [
        u,
        0
    ];
    function l(u, c, d, h) {
        let f = u.morphTargetInfluences;
        if (t.isWebGL2 === !0) {
            let m = c.morphAttributes.position || c.morphAttributes.normal || c.morphAttributes.color, p = m !== void 0 ? m.length : 0, g = s.get(c);
            if (g === void 0 || g.count !== p) {
                let B = function() {
                    C.dispose(), s.delete(c), c.removeEventListener("dispose", B);
                };
                g !== void 0 && g.texture.dispose();
                let x = c.morphAttributes.position !== void 0, w = c.morphAttributes.normal !== void 0, S = c.morphAttributes.color !== void 0, _ = c.morphAttributes.position || [], M = c.morphAttributes.normal || [], b = c.morphAttributes.color || [], T = 0;
                x === !0 && (T = 1), w === !0 && (T = 2), S === !0 && (T = 3);
                let E = c.attributes.position.count * T, P = 1;
                E > t.maxTextureSize && (P = Math.ceil(E / t.maxTextureSize), E = t.maxTextureSize);
                let D = new Float32Array(E * P * 4 * p), C = new kp(D, E, P, p);
                C.type = wr, C.needsUpdate = !0;
                let O = T * 4;
                for(let V = 0; V < p; V++){
                    let Y = _[V], W = M[V], q = b[V], j = E * P * 4 * V;
                    for(let X = 0; X < Y.count; X++){
                        let L = X * O;
                        x === !0 && (o.fromBufferAttribute(Y, X), D[j + L + 0] = o.x, D[j + L + 1] = o.y, D[j + L + 2] = o.z, D[j + L + 3] = 0), w === !0 && (o.fromBufferAttribute(W, X), D[j + L + 4] = o.x, D[j + L + 5] = o.y, D[j + L + 6] = o.z, D[j + L + 7] = 0), S === !0 && (o.fromBufferAttribute(q, X), D[j + L + 8] = o.x, D[j + L + 9] = o.y, D[j + L + 10] = o.z, D[j + L + 11] = q.itemSize === 4 ? o.w : 1);
                    }
                }
                g = {
                    count: p,
                    texture: C,
                    size: new F(E, P)
                }, s.set(c, g), c.addEventListener("dispose", B);
            }
            let y = 0;
            for(let x = 0; x < f.length; x++)y += f[x];
            let v = c.morphTargetsRelative ? 1 : 1 - y;
            h.getUniforms().setValue(r1, "morphTargetBaseInfluence", v), h.getUniforms().setValue(r1, "morphTargetInfluences", f), h.getUniforms().setValue(r1, "morphTargetsTexture", g.texture, e), h.getUniforms().setValue(r1, "morphTargetsTextureSize", g.size);
        } else {
            let m = f === void 0 ? 0 : f.length, p = n[c.id];
            if (p === void 0 || p.length !== m) {
                p = [];
                for(let w = 0; w < m; w++)p[w] = [
                    w,
                    0
                ];
                n[c.id] = p;
            }
            for(let w = 0; w < m; w++){
                let S = p[w];
                S[0] = w, S[1] = f[w];
            }
            p.sort(oN);
            for(let w = 0; w < 8; w++)w < m && p[w][1] ? (a[w][0] = p[w][0], a[w][1] = p[w][1]) : (a[w][0] = Number.MAX_SAFE_INTEGER, a[w][1] = 0);
            a.sort(sN);
            let g = c.morphAttributes.position, y = c.morphAttributes.normal, v = 0;
            for(let w = 0; w < 8; w++){
                let S = a[w], _ = S[0], M = S[1];
                _ !== Number.MAX_SAFE_INTEGER && M ? (g && c.getAttribute("morphTarget" + w) !== g[_] && c.setAttribute("morphTarget" + w, g[_]), y && c.getAttribute("morphNormal" + w) !== y[_] && c.setAttribute("morphNormal" + w, y[_]), i[w] = M, v += M) : (g && c.hasAttribute("morphTarget" + w) === !0 && c.deleteAttribute("morphTarget" + w), y && c.hasAttribute("morphNormal" + w) === !0 && c.deleteAttribute("morphNormal" + w), i[w] = 0);
            }
            let x = c.morphTargetsRelative ? 1 : 1 - v;
            h.getUniforms().setValue(r1, "morphTargetBaseInfluence", x), h.getUniforms().setValue(r1, "morphTargetInfluences", i);
        }
    }
    return {
        update: l
    };
}
function lN(r1, t, e, n) {
    let i = new WeakMap;
    function s(l) {
        let u = n.render.frame, c = l.geometry, d = t.get(l, c);
        return i.get(d) !== u && (t.update(d), i.set(d, u)), l.isInstancedMesh && (l.hasEventListener("dispose", a) === !1 && l.addEventListener("dispose", a), e.update(l.instanceMatrix, 34962), l.instanceColor !== null && e.update(l.instanceColor, 34962)), d;
    }
    function o() {
        i = new WeakMap;
    }
    function a(l) {
        let u = l.target;
        u.removeEventListener("dispose", a), e.remove(u.instanceMatrix), u.instanceColor !== null && e.remove(u.instanceColor);
    }
    return {
        update: s,
        dispose: o
    };
}
var IA = new Vt, OA = new kp, RA = new zp, LA = new lc, G1 = [], V1 = [], H1 = new Float32Array(16), W1 = new Float32Array(9), j1 = new Float32Array(4);
function _c(r1, t, e) {
    let n = r1[0];
    if (n <= 0 || n > 0) return r1;
    let i = t * e, s = G1[i];
    if (s === void 0 && (s = new Float32Array(i), G1[i] = s), t !== 0) {
        n.toArray(s, 0);
        for(let o = 1, a = 0; o !== t; ++o)a += e, r1[o].toArray(s, a);
    }
    return s;
}
function Gn(r1, t) {
    if (r1.length !== t.length) return !1;
    for(let e = 0, n = r1.length; e < n; e++)if (r1[e] !== t[e]) return !1;
    return !0;
}
function Vn(r1, t) {
    for(let e = 0, n = t.length; e < n; e++)r1[e] = t[e];
}
function im(r1, t) {
    let e = V1[t];
    e === void 0 && (e = new Int32Array(t), V1[t] = e);
    for(let n = 0; n !== t; ++n)e[n] = r1.allocateTextureUnit();
    return e;
}
function cN(r1, t) {
    let e = this.cache;
    e[0] !== t && (r1.uniform1f(this.addr, t), e[0] = t);
}
function uN(r1, t) {
    let e = this.cache;
    if (t.x !== void 0) (e[0] !== t.x || e[1] !== t.y) && (r1.uniform2f(this.addr, t.x, t.y), e[0] = t.x, e[1] = t.y);
    else {
        if (Gn(e, t)) return;
        r1.uniform2fv(this.addr, t), Vn(e, t);
    }
}
function dN(r1, t) {
    let e = this.cache;
    if (t.x !== void 0) (e[0] !== t.x || e[1] !== t.y || e[2] !== t.z) && (r1.uniform3f(this.addr, t.x, t.y, t.z), e[0] = t.x, e[1] = t.y, e[2] = t.z);
    else if (t.r !== void 0) (e[0] !== t.r || e[1] !== t.g || e[2] !== t.b) && (r1.uniform3f(this.addr, t.r, t.g, t.b), e[0] = t.r, e[1] = t.g, e[2] = t.b);
    else {
        if (Gn(e, t)) return;
        r1.uniform3fv(this.addr, t), Vn(e, t);
    }
}
function hN(r1, t) {
    let e = this.cache;
    if (t.x !== void 0) (e[0] !== t.x || e[1] !== t.y || e[2] !== t.z || e[3] !== t.w) && (r1.uniform4f(this.addr, t.x, t.y, t.z, t.w), e[0] = t.x, e[1] = t.y, e[2] = t.z, e[3] = t.w);
    else {
        if (Gn(e, t)) return;
        r1.uniform4fv(this.addr, t), Vn(e, t);
    }
}
function fN(r1, t) {
    let e = this.cache, n = t.elements;
    if (n === void 0) {
        if (Gn(e, t)) return;
        r1.uniformMatrix2fv(this.addr, !1, t), Vn(e, t);
    } else {
        if (Gn(e, n)) return;
        j1.set(n), r1.uniformMatrix2fv(this.addr, !1, j1), Vn(e, n);
    }
}
function pN(r1, t) {
    let e = this.cache, n = t.elements;
    if (n === void 0) {
        if (Gn(e, t)) return;
        r1.uniformMatrix3fv(this.addr, !1, t), Vn(e, t);
    } else {
        if (Gn(e, n)) return;
        W1.set(n), r1.uniformMatrix3fv(this.addr, !1, W1), Vn(e, n);
    }
}
function mN(r1, t) {
    let e = this.cache, n = t.elements;
    if (n === void 0) {
        if (Gn(e, t)) return;
        r1.uniformMatrix4fv(this.addr, !1, t), Vn(e, t);
    } else {
        if (Gn(e, n)) return;
        H1.set(n), r1.uniformMatrix4fv(this.addr, !1, H1), Vn(e, n);
    }
}
function gN(r1, t) {
    let e = this.cache;
    e[0] !== t && (r1.uniform1i(this.addr, t), e[0] = t);
}
function yN(r1, t) {
    let e = this.cache;
    if (t.x !== void 0) (e[0] !== t.x || e[1] !== t.y) && (r1.uniform2i(this.addr, t.x, t.y), e[0] = t.x, e[1] = t.y);
    else {
        if (Gn(e, t)) return;
        r1.uniform2iv(this.addr, t), Vn(e, t);
    }
}
function vN(r1, t) {
    let e = this.cache;
    if (t.x !== void 0) (e[0] !== t.x || e[1] !== t.y || e[2] !== t.z) && (r1.uniform3i(this.addr, t.x, t.y, t.z), e[0] = t.x, e[1] = t.y, e[2] = t.z);
    else {
        if (Gn(e, t)) return;
        r1.uniform3iv(this.addr, t), Vn(e, t);
    }
}
function xN(r1, t) {
    let e = this.cache;
    if (t.x !== void 0) (e[0] !== t.x || e[1] !== t.y || e[2] !== t.z || e[3] !== t.w) && (r1.uniform4i(this.addr, t.x, t.y, t.z, t.w), e[0] = t.x, e[1] = t.y, e[2] = t.z, e[3] = t.w);
    else {
        if (Gn(e, t)) return;
        r1.uniform4iv(this.addr, t), Vn(e, t);
    }
}
function bN(r1, t) {
    let e = this.cache;
    e[0] !== t && (r1.uniform1ui(this.addr, t), e[0] = t);
}
function wN(r1, t) {
    let e = this.cache;
    if (t.x !== void 0) (e[0] !== t.x || e[1] !== t.y) && (r1.uniform2ui(this.addr, t.x, t.y), e[0] = t.x, e[1] = t.y);
    else {
        if (Gn(e, t)) return;
        r1.uniform2uiv(this.addr, t), Vn(e, t);
    }
}
function SN(r1, t) {
    let e = this.cache;
    if (t.x !== void 0) (e[0] !== t.x || e[1] !== t.y || e[2] !== t.z) && (r1.uniform3ui(this.addr, t.x, t.y, t.z), e[0] = t.x, e[1] = t.y, e[2] = t.z);
    else {
        if (Gn(e, t)) return;
        r1.uniform3uiv(this.addr, t), Vn(e, t);
    }
}
function AN(r1, t) {
    let e = this.cache;
    if (t.x !== void 0) (e[0] !== t.x || e[1] !== t.y || e[2] !== t.z || e[3] !== t.w) && (r1.uniform4ui(this.addr, t.x, t.y, t.z, t.w), e[0] = t.x, e[1] = t.y, e[2] = t.z, e[3] = t.w);
    else {
        if (Gn(e, t)) return;
        r1.uniform4uiv(this.addr, t), Vn(e, t);
    }
}
function _N(r1, t, e) {
    let n = this.cache, i = e.allocateTextureUnit();
    n[0] !== i && (r1.uniform1i(this.addr, i), n[0] = i), e.setTexture2D(t || IA, i);
}
function MN(r1, t, e) {
    let n = this.cache, i = e.allocateTextureUnit();
    n[0] !== i && (r1.uniform1i(this.addr, i), n[0] = i), e.setTexture3D(t || RA, i);
}
function TN(r1, t, e) {
    let n = this.cache, i = e.allocateTextureUnit();
    n[0] !== i && (r1.uniform1i(this.addr, i), n[0] = i), e.setTextureCube(t || LA, i);
}
function EN(r1, t, e) {
    let n = this.cache, i = e.allocateTextureUnit();
    n[0] !== i && (r1.uniform1i(this.addr, i), n[0] = i), e.setTexture2DArray(t || OA, i);
}
function CN(r1) {
    switch(r1){
        case 5126:
            return cN;
        case 35664:
            return uN;
        case 35665:
            return dN;
        case 35666:
            return hN;
        case 35674:
            return fN;
        case 35675:
            return pN;
        case 35676:
            return mN;
        case 5124:
        case 35670:
            return gN;
        case 35667:
        case 35671:
            return yN;
        case 35668:
        case 35672:
            return vN;
        case 35669:
        case 35673:
            return xN;
        case 5125:
            return bN;
        case 36294:
            return wN;
        case 36295:
            return SN;
        case 36296:
            return AN;
        case 35678:
        case 36198:
        case 36298:
        case 36306:
        case 35682:
            return _N;
        case 35679:
        case 36299:
        case 36307:
            return MN;
        case 35680:
        case 36300:
        case 36308:
        case 36293:
            return TN;
        case 36289:
        case 36303:
        case 36311:
        case 36292:
            return EN;
    }
}
function PN(r1, t) {
    r1.uniform1fv(this.addr, t);
}
function DN(r1, t) {
    let e = _c(t, this.size, 2);
    r1.uniform2fv(this.addr, e);
}
function IN(r1, t) {
    let e = _c(t, this.size, 3);
    r1.uniform3fv(this.addr, e);
}
function ON(r1, t) {
    let e = _c(t, this.size, 4);
    r1.uniform4fv(this.addr, e);
}
function RN(r1, t) {
    let e = _c(t, this.size, 4);
    r1.uniformMatrix2fv(this.addr, !1, e);
}
function LN(r1, t) {
    let e = _c(t, this.size, 9);
    r1.uniformMatrix3fv(this.addr, !1, e);
}
function NN(r1, t) {
    let e = _c(t, this.size, 16);
    r1.uniformMatrix4fv(this.addr, !1, e);
}
function BN(r1, t) {
    r1.uniform1iv(this.addr, t);
}
function FN(r1, t) {
    r1.uniform2iv(this.addr, t);
}
function UN(r1, t) {
    r1.uniform3iv(this.addr, t);
}
function kN(r1, t) {
    r1.uniform4iv(this.addr, t);
}
function zN(r1, t) {
    r1.uniform1uiv(this.addr, t);
}
function GN(r1, t) {
    r1.uniform2uiv(this.addr, t);
}
function VN(r1, t) {
    r1.uniform3uiv(this.addr, t);
}
function HN(r1, t) {
    r1.uniform4uiv(this.addr, t);
}
function WN(r1, t, e) {
    let n = this.cache, i = t.length, s = im(e, i);
    Gn(n, s) || (r1.uniform1iv(this.addr, s), Vn(n, s));
    for(let o = 0; o !== i; ++o)e.setTexture2D(t[o] || IA, s[o]);
}
function jN(r1, t, e) {
    let n = this.cache, i = t.length, s = im(e, i);
    Gn(n, s) || (r1.uniform1iv(this.addr, s), Vn(n, s));
    for(let o = 0; o !== i; ++o)e.setTexture3D(t[o] || RA, s[o]);
}
function qN(r1, t, e) {
    let n = this.cache, i = t.length, s = im(e, i);
    Gn(n, s) || (r1.uniform1iv(this.addr, s), Vn(n, s));
    for(let o = 0; o !== i; ++o)e.setTextureCube(t[o] || LA, s[o]);
}
function XN(r1, t, e) {
    let n = this.cache, i = t.length, s = im(e, i);
    Gn(n, s) || (r1.uniform1iv(this.addr, s), Vn(n, s));
    for(let o = 0; o !== i; ++o)e.setTexture2DArray(t[o] || OA, s[o]);
}
function YN(r1) {
    switch(r1){
        case 5126:
            return PN;
        case 35664:
            return DN;
        case 35665:
            return IN;
        case 35666:
            return ON;
        case 35674:
            return RN;
        case 35675:
            return LN;
        case 35676:
            return NN;
        case 5124:
        case 35670:
            return BN;
        case 35667:
        case 35671:
            return FN;
        case 35668:
        case 35672:
            return UN;
        case 35669:
        case 35673:
            return kN;
        case 5125:
            return zN;
        case 36294:
            return GN;
        case 36295:
            return VN;
        case 36296:
            return HN;
        case 35678:
        case 36198:
        case 36298:
        case 36306:
        case 35682:
            return WN;
        case 35679:
        case 36299:
        case 36307:
            return jN;
        case 35680:
        case 36300:
        case 36308:
        case 36293:
            return qN;
        case 36289:
        case 36303:
        case 36311:
        case 36292:
            return XN;
    }
}
var w0 = class {
    constructor(t, e, n){
        this.id = t, this.addr = n, this.cache = [], this.setValue = CN(e.type);
    }
}, S0 = class {
    constructor(t, e, n){
        this.id = t, this.addr = n, this.cache = [], this.size = e.size, this.setValue = YN(e.type);
    }
}, A0 = class {
    constructor(t){
        this.id = t, this.seq = [], this.map = {};
    }
    setValue(t, e, n) {
        let i = this.seq;
        for(let s = 0, o = i.length; s !== o; ++s){
            let a = i[s];
            a.setValue(t, e[a.id], n);
        }
    }
}, s0 = /(\w+)(\])?(\[|\.)?/g;
function q1(r1, t) {
    r1.seq.push(t), r1.map[t.id] = t;
}
function QN(r1, t, e) {
    let n = r1.name, i = n.length;
    for(s0.lastIndex = 0;;){
        let s = s0.exec(n), o = s0.lastIndex, a = s[1], l = s[2] === "]", u = s[3];
        if (l && (a = a | 0), u === void 0 || u === "[" && o + 2 === i) {
            q1(e, u === void 0 ? new w0(a, r1, t) : new S0(a, r1, t));
            break;
        } else {
            let d = e.map[a];
            d === void 0 && (d = new A0(a), q1(e, d)), e = d;
        }
    }
}
var oc = class {
    constructor(t, e){
        this.seq = [], this.map = {};
        let n = t.getProgramParameter(e, 35718);
        for(let i = 0; i < n; ++i){
            let s = t.getActiveUniform(e, i), o = t.getUniformLocation(e, s.name);
            QN(s, o, this);
        }
    }
    setValue(t, e, n, i) {
        let s = this.map[e];
        s !== void 0 && s.setValue(t, n, i);
    }
    setOptional(t, e, n) {
        let i = e[n];
        i !== void 0 && this.setValue(t, n, i);
    }
    static upload(t, e, n, i) {
        for(let s = 0, o = e.length; s !== o; ++s){
            let a = e[s], l = n[a.id];
            l.needsUpdate !== !1 && a.setValue(t, l.value, i);
        }
    }
    static seqWithValue(t, e) {
        let n = [];
        for(let i = 0, s = t.length; i !== s; ++i){
            let o = t[i];
            o.id in e && n.push(o);
        }
        return n;
    }
};
function X1(r1, t, e) {
    let n = r1.createShader(t);
    return r1.shaderSource(n, e), r1.compileShader(n), n;
}
var KN = 0;
function ZN(r1, t) {
    let e = r1.split(`
`), n = [], i = Math.max(t - 6, 0), s = Math.min(t + 6, e.length);
    for(let o = i; o < s; o++){
        let a = o + 1;
        n.push(`${a === t ? ">" : " "} ${a}: ${e[o]}`);
    }
    return n.join(`
`);
}
function JN(r1) {
    switch(r1){
        case oi:
            return [
                "Linear",
                "( value )"
            ];
        case Ye:
            return [
                "sRGB",
                "( value )"
            ];
        default:
            return console.warn("THREE.WebGLProgram: Unsupported encoding:", r1), [
                "Linear",
                "( value )"
            ];
    }
}
function Y1(r1, t, e) {
    let n = r1.getShaderParameter(t, 35713), i = r1.getShaderInfoLog(t).trim();
    if (n && i === "") return "";
    let s = /ERROR: 0:(\d+)/.exec(i);
    if (s) {
        let o = parseInt(s[1]);
        return e.toUpperCase() + `

` + i + `

` + ZN(r1.getShaderSource(t), o);
    } else return i;
}
function $N(r1, t) {
    let e = JN(t);
    return "vec4 " + r1 + "( vec4 value ) { return LinearTo" + e[0] + e[1] + "; }";
}
function eB(r1, t) {
    let e;
    switch(t){
        case fO:
            e = "Linear";
            break;
        case pO:
            e = "Reinhard";
            break;
        case mO:
            e = "OptimizedCineon";
            break;
        case gO:
            e = "ACESFilmic";
            break;
        case yO:
            e = "Custom";
            break;
        default:
            console.warn("THREE.WebGLProgram: Unsupported toneMapping:", t), e = "Linear";
    }
    return "vec3 " + r1 + "( vec3 color ) { return " + e + "ToneMapping( color ); }";
}
function tB(r1) {
    return [
        r1.extensionDerivatives || !!r1.envMapCubeUVHeight || r1.bumpMap || r1.tangentSpaceNormalMap || r1.clearcoatNormalMap || r1.flatShading || r1.shaderID === "physical" ? "#extension GL_OES_standard_derivatives : enable" : "",
        (r1.extensionFragDepth || r1.logarithmicDepthBuffer) && r1.rendererExtensionFragDepth ? "#extension GL_EXT_frag_depth : enable" : "",
        r1.extensionDrawBuffers && r1.rendererExtensionDrawBuffers ? "#extension GL_EXT_draw_buffers : require" : "",
        (r1.extensionShaderTextureLOD || r1.envMap || r1.transmission) && r1.rendererExtensionShaderTextureLod ? "#extension GL_EXT_shader_texture_lod : enable" : ""
    ].filter(lh).join(`
`);
}
function nB(r1) {
    let t = [];
    for(let e in r1){
        let n = r1[e];
        n !== !1 && t.push("#define " + e + " " + n);
    }
    return t.join(`
`);
}
function rB(r1, t) {
    let e = {}, n = r1.getProgramParameter(t, 35721);
    for(let i = 0; i < n; i++){
        let s = r1.getActiveAttrib(t, i), o = s.name, a = 1;
        s.type === 35674 && (a = 2), s.type === 35675 && (a = 3), s.type === 35676 && (a = 4), e[o] = {
            type: s.type,
            location: r1.getAttribLocation(t, o),
            locationSize: a
        };
    }
    return e;
}
function lh(r1) {
    return r1 !== "";
}
function Q1(r1, t) {
    let e = t.numSpotLightShadows + t.numSpotLightMaps - t.numSpotLightShadowsWithMaps;
    return r1.replace(/NUM_DIR_LIGHTS/g, t.numDirLights).replace(/NUM_SPOT_LIGHTS/g, t.numSpotLights).replace(/NUM_SPOT_LIGHT_MAPS/g, t.numSpotLightMaps).replace(/NUM_SPOT_LIGHT_COORDS/g, e).replace(/NUM_RECT_AREA_LIGHTS/g, t.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, t.numPointLights).replace(/NUM_HEMI_LIGHTS/g, t.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, t.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS/g, t.numSpotLightShadowsWithMaps).replace(/NUM_SPOT_LIGHT_SHADOWS/g, t.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, t.numPointLightShadows);
}
function K1(r1, t) {
    return r1.replace(/NUM_CLIPPING_PLANES/g, t.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, t.numClippingPlanes - t.numClipIntersection);
}
var iB = /^[ \t]*#include +<([\w\d./]+)>/gm;
function _0(r1) {
    return r1.replace(iB, sB);
}
function sB(r1, t) {
    let e = it[t];
    if (e === void 0) throw new Error("Can not resolve #include <" + t + ">");
    return _0(e);
}
var oB = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
function Z1(r1) {
    return r1.replace(oB, aB);
}
function aB(r1, t, e, n) {
    let i = "";
    for(let s = parseInt(t); s < parseInt(e); s++)i += n.replace(/\[\s*i\s*\]/g, "[ " + s + " ]").replace(/UNROLLED_LOOP_INDEX/g, s);
    return i;
}
function J1(r1) {
    let t = "precision " + r1.precision + ` float;
precision ` + r1.precision + " int;";
    return r1.precision === "highp" ? t += `
#define HIGH_PRECISION` : r1.precision === "mediump" ? t += `
#define MEDIUM_PRECISION` : r1.precision === "lowp" && (t += `
#define LOW_PRECISION`), t;
}
function lB(r1) {
    let t = "SHADOWMAP_TYPE_BASIC";
    return r1.shadowMapType === rm ? t = "SHADOWMAP_TYPE_PCF" : r1.shadowMapType === K0 ? t = "SHADOWMAP_TYPE_PCF_SOFT" : r1.shadowMapType === ah && (t = "SHADOWMAP_TYPE_VSM"), t;
}
function cB(r1) {
    let t = "ENVMAP_TYPE_CUBE";
    if (r1.envMap) switch(r1.envMapMode){
        case Vo:
        case Ho:
            t = "ENVMAP_TYPE_CUBE";
            break;
        case Ac:
            t = "ENVMAP_TYPE_CUBE_UV";
            break;
    }
    return t;
}
function uB(r1) {
    let t = "ENVMAP_MODE_REFLECTION";
    if (r1.envMap) switch(r1.envMapMode){
        case Ho:
            t = "ENVMAP_MODE_REFRACTION";
            break;
    }
    return t;
}
function dB(r1) {
    let t = "ENVMAP_BLENDING_NONE";
    if (r1.envMap) switch(r1.combine){
        case _A:
            t = "ENVMAP_BLENDING_MULTIPLY";
            break;
        case dO:
            t = "ENVMAP_BLENDING_MIX";
            break;
        case hO:
            t = "ENVMAP_BLENDING_ADD";
            break;
    }
    return t;
}
function hB(r1) {
    let t = r1.envMapCubeUVHeight;
    if (t === null) return null;
    let e = Math.log2(t) - 2, n = 1 / t;
    return {
        texelWidth: 1 / (3 * Math.max(Math.pow(2, e), 112)),
        texelHeight: n,
        maxMip: e
    };
}
function fB(r1, t, e, n) {
    let i = r1.getContext(), s = e.defines, o = e.vertexShader, a = e.fragmentShader, l = lB(e), u = cB(e), c = uB(e), d = dB(e), h = hB(e), f = e.isWebGL2 ? "" : tB(e), m = nB(s), p = i.createProgram(), g, y, v = e.glslVersion ? "#version " + e.glslVersion + `
` : "";
    e.isRawShaderMaterial ? (g = [
        m
    ].filter(lh).join(`
`), g.length > 0 && (g += `
`), y = [
        f,
        m
    ].filter(lh).join(`
`), y.length > 0 && (y += `
`)) : (g = [
        J1(e),
        "#define SHADER_NAME " + e.shaderName,
        m,
        e.instancing ? "#define USE_INSTANCING" : "",
        e.instancingColor ? "#define USE_INSTANCING_COLOR" : "",
        e.supportsVertexTextures ? "#define VERTEX_TEXTURES" : "",
        e.useFog && e.fog ? "#define USE_FOG" : "",
        e.useFog && e.fogExp2 ? "#define FOG_EXP2" : "",
        e.map ? "#define USE_MAP" : "",
        e.envMap ? "#define USE_ENVMAP" : "",
        e.envMap ? "#define " + c : "",
        e.lightMap ? "#define USE_LIGHTMAP" : "",
        e.aoMap ? "#define USE_AOMAP" : "",
        e.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
        e.bumpMap ? "#define USE_BUMPMAP" : "",
        e.normalMap ? "#define USE_NORMALMAP" : "",
        e.normalMap && e.objectSpaceNormalMap ? "#define OBJECTSPACE_NORMALMAP" : "",
        e.normalMap && e.tangentSpaceNormalMap ? "#define TANGENTSPACE_NORMALMAP" : "",
        e.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
        e.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
        e.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
        e.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
        e.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
        e.displacementMap && e.supportsVertexTextures ? "#define USE_DISPLACEMENTMAP" : "",
        e.specularMap ? "#define USE_SPECULARMAP" : "",
        e.specularIntensityMap ? "#define USE_SPECULARINTENSITYMAP" : "",
        e.specularColorMap ? "#define USE_SPECULARCOLORMAP" : "",
        e.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
        e.metalnessMap ? "#define USE_METALNESSMAP" : "",
        e.alphaMap ? "#define USE_ALPHAMAP" : "",
        e.transmission ? "#define USE_TRANSMISSION" : "",
        e.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
        e.thicknessMap ? "#define USE_THICKNESSMAP" : "",
        e.sheenColorMap ? "#define USE_SHEENCOLORMAP" : "",
        e.sheenRoughnessMap ? "#define USE_SHEENROUGHNESSMAP" : "",
        e.vertexTangents ? "#define USE_TANGENT" : "",
        e.vertexColors ? "#define USE_COLOR" : "",
        e.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
        e.vertexUvs ? "#define USE_UV" : "",
        e.uvsVertexOnly ? "#define UVS_VERTEX_ONLY" : "",
        e.flatShading ? "#define FLAT_SHADED" : "",
        e.skinning ? "#define USE_SKINNING" : "",
        e.morphTargets ? "#define USE_MORPHTARGETS" : "",
        e.morphNormals && e.flatShading === !1 ? "#define USE_MORPHNORMALS" : "",
        e.morphColors && e.isWebGL2 ? "#define USE_MORPHCOLORS" : "",
        e.morphTargetsCount > 0 && e.isWebGL2 ? "#define MORPHTARGETS_TEXTURE" : "",
        e.morphTargetsCount > 0 && e.isWebGL2 ? "#define MORPHTARGETS_TEXTURE_STRIDE " + e.morphTextureStride : "",
        e.morphTargetsCount > 0 && e.isWebGL2 ? "#define MORPHTARGETS_COUNT " + e.morphTargetsCount : "",
        e.doubleSided ? "#define DOUBLE_SIDED" : "",
        e.flipSided ? "#define FLIP_SIDED" : "",
        e.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
        e.shadowMapEnabled ? "#define " + l : "",
        e.sizeAttenuation ? "#define USE_SIZEATTENUATION" : "",
        e.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
        e.logarithmicDepthBuffer && e.rendererExtensionFragDepth ? "#define USE_LOGDEPTHBUF_EXT" : "",
        "uniform mat4 modelMatrix;",
        "uniform mat4 modelViewMatrix;",
        "uniform mat4 projectionMatrix;",
        "uniform mat4 viewMatrix;",
        "uniform mat3 normalMatrix;",
        "uniform vec3 cameraPosition;",
        "uniform bool isOrthographic;",
        "#ifdef USE_INSTANCING",
        "	attribute mat4 instanceMatrix;",
        "#endif",
        "#ifdef USE_INSTANCING_COLOR",
        "	attribute vec3 instanceColor;",
        "#endif",
        "attribute vec3 position;",
        "attribute vec3 normal;",
        "attribute vec2 uv;",
        "#ifdef USE_TANGENT",
        "	attribute vec4 tangent;",
        "#endif",
        "#if defined( USE_COLOR_ALPHA )",
        "	attribute vec4 color;",
        "#elif defined( USE_COLOR )",
        "	attribute vec3 color;",
        "#endif",
        "#if ( defined( USE_MORPHTARGETS ) && ! defined( MORPHTARGETS_TEXTURE ) )",
        "	attribute vec3 morphTarget0;",
        "	attribute vec3 morphTarget1;",
        "	attribute vec3 morphTarget2;",
        "	attribute vec3 morphTarget3;",
        "	#ifdef USE_MORPHNORMALS",
        "		attribute vec3 morphNormal0;",
        "		attribute vec3 morphNormal1;",
        "		attribute vec3 morphNormal2;",
        "		attribute vec3 morphNormal3;",
        "	#else",
        "		attribute vec3 morphTarget4;",
        "		attribute vec3 morphTarget5;",
        "		attribute vec3 morphTarget6;",
        "		attribute vec3 morphTarget7;",
        "	#endif",
        "#endif",
        "#ifdef USE_SKINNING",
        "	attribute vec4 skinIndex;",
        "	attribute vec4 skinWeight;",
        "#endif",
        `
`
    ].filter(lh).join(`
`), y = [
        f,
        J1(e),
        "#define SHADER_NAME " + e.shaderName,
        m,
        e.useFog && e.fog ? "#define USE_FOG" : "",
        e.useFog && e.fogExp2 ? "#define FOG_EXP2" : "",
        e.map ? "#define USE_MAP" : "",
        e.matcap ? "#define USE_MATCAP" : "",
        e.envMap ? "#define USE_ENVMAP" : "",
        e.envMap ? "#define " + u : "",
        e.envMap ? "#define " + c : "",
        e.envMap ? "#define " + d : "",
        h ? "#define CUBEUV_TEXEL_WIDTH " + h.texelWidth : "",
        h ? "#define CUBEUV_TEXEL_HEIGHT " + h.texelHeight : "",
        h ? "#define CUBEUV_MAX_MIP " + h.maxMip + ".0" : "",
        e.lightMap ? "#define USE_LIGHTMAP" : "",
        e.aoMap ? "#define USE_AOMAP" : "",
        e.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
        e.bumpMap ? "#define USE_BUMPMAP" : "",
        e.normalMap ? "#define USE_NORMALMAP" : "",
        e.normalMap && e.objectSpaceNormalMap ? "#define OBJECTSPACE_NORMALMAP" : "",
        e.normalMap && e.tangentSpaceNormalMap ? "#define TANGENTSPACE_NORMALMAP" : "",
        e.clearcoat ? "#define USE_CLEARCOAT" : "",
        e.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
        e.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
        e.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
        e.iridescence ? "#define USE_IRIDESCENCE" : "",
        e.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
        e.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
        e.specularMap ? "#define USE_SPECULARMAP" : "",
        e.specularIntensityMap ? "#define USE_SPECULARINTENSITYMAP" : "",
        e.specularColorMap ? "#define USE_SPECULARCOLORMAP" : "",
        e.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
        e.metalnessMap ? "#define USE_METALNESSMAP" : "",
        e.alphaMap ? "#define USE_ALPHAMAP" : "",
        e.alphaTest ? "#define USE_ALPHATEST" : "",
        e.sheen ? "#define USE_SHEEN" : "",
        e.sheenColorMap ? "#define USE_SHEENCOLORMAP" : "",
        e.sheenRoughnessMap ? "#define USE_SHEENROUGHNESSMAP" : "",
        e.transmission ? "#define USE_TRANSMISSION" : "",
        e.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
        e.thicknessMap ? "#define USE_THICKNESSMAP" : "",
        e.decodeVideoTexture ? "#define DECODE_VIDEO_TEXTURE" : "",
        e.vertexTangents ? "#define USE_TANGENT" : "",
        e.vertexColors || e.instancingColor ? "#define USE_COLOR" : "",
        e.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
        e.vertexUvs ? "#define USE_UV" : "",
        e.uvsVertexOnly ? "#define UVS_VERTEX_ONLY" : "",
        e.gradientMap ? "#define USE_GRADIENTMAP" : "",
        e.flatShading ? "#define FLAT_SHADED" : "",
        e.doubleSided ? "#define DOUBLE_SIDED" : "",
        e.flipSided ? "#define FLIP_SIDED" : "",
        e.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
        e.shadowMapEnabled ? "#define " + l : "",
        e.premultipliedAlpha ? "#define PREMULTIPLIED_ALPHA" : "",
        e.physicallyCorrectLights ? "#define PHYSICALLY_CORRECT_LIGHTS" : "",
        e.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
        e.logarithmicDepthBuffer && e.rendererExtensionFragDepth ? "#define USE_LOGDEPTHBUF_EXT" : "",
        "uniform mat4 viewMatrix;",
        "uniform vec3 cameraPosition;",
        "uniform bool isOrthographic;",
        e.toneMapping !== io ? "#define TONE_MAPPING" : "",
        e.toneMapping !== io ? it.tonemapping_pars_fragment : "",
        e.toneMapping !== io ? eB("toneMapping", e.toneMapping) : "",
        e.dithering ? "#define DITHERING" : "",
        e.opaque ? "#define OPAQUE" : "",
        it.encodings_pars_fragment,
        $N("linearToOutputTexel", e.outputEncoding),
        e.useDepthPacking ? "#define DEPTH_PACKING " + e.depthPacking : "",
        `
`
    ].filter(lh).join(`
`)), o = _0(o), o = Q1(o, e), o = K1(o, e), a = _0(a), a = Q1(a, e), a = K1(a, e), o = Z1(o), a = Z1(a), e.isWebGL2 && e.isRawShaderMaterial !== !0 && (v = `#version 300 es
`, g = [
        "precision mediump sampler2DArray;",
        "#define attribute in",
        "#define varying out",
        "#define texture2D texture"
    ].join(`
`) + `
` + g, y = [
        "#define varying in",
        e.glslVersion === A1 ? "" : "layout(location = 0) out highp vec4 pc_fragColor;",
        e.glslVersion === A1 ? "" : "#define gl_FragColor pc_fragColor",
        "#define gl_FragDepthEXT gl_FragDepth",
        "#define texture2D texture",
        "#define textureCube texture",
        "#define texture2DProj textureProj",
        "#define texture2DLodEXT textureLod",
        "#define texture2DProjLodEXT textureProjLod",
        "#define textureCubeLodEXT textureLod",
        "#define texture2DGradEXT textureGrad",
        "#define texture2DProjGradEXT textureProjGrad",
        "#define textureCubeGradEXT textureGrad"
    ].join(`
`) + `
` + y);
    let x = v + g + o, w = v + y + a, S = X1(i, 35633, x), _ = X1(i, 35632, w);
    if (i.attachShader(p, S), i.attachShader(p, _), e.index0AttributeName !== void 0 ? i.bindAttribLocation(p, 0, e.index0AttributeName) : e.morphTargets === !0 && i.bindAttribLocation(p, 0, "position"), i.linkProgram(p), r1.debug.checkShaderErrors) {
        let T = i.getProgramInfoLog(p).trim(), E = i.getShaderInfoLog(S).trim(), P = i.getShaderInfoLog(_).trim(), D = !0, C = !0;
        if (i.getProgramParameter(p, 35714) === !1) {
            D = !1;
            let O = Y1(i, S, "vertex"), B = Y1(i, _, "fragment");
            console.error("THREE.WebGLProgram: Shader Error " + i.getError() + " - VALIDATE_STATUS " + i.getProgramParameter(p, 35715) + `

Program Info Log: ` + T + `
` + O + `
` + B);
        } else T !== "" ? console.warn("THREE.WebGLProgram: Program Info Log:", T) : (E === "" || P === "") && (C = !1);
        C && (this.diagnostics = {
            runnable: D,
            programLog: T,
            vertexShader: {
                log: E,
                prefix: g
            },
            fragmentShader: {
                log: P,
                prefix: y
            }
        });
    }
    i.deleteShader(S), i.deleteShader(_);
    let M;
    this.getUniforms = function() {
        return M === void 0 && (M = new oc(i, p)), M;
    };
    let b;
    return this.getAttributes = function() {
        return b === void 0 && (b = rB(i, p)), b;
    }, this.destroy = function() {
        n.releaseStatesOfProgram(this), i.deleteProgram(p), this.program = void 0;
    }, this.name = e.shaderName, this.id = KN++, this.cacheKey = t, this.usedTimes = 1, this.program = p, this.vertexShader = S, this.fragmentShader = _, this;
}
var pB = 0, M0 = class {
    constructor(){
        this.shaderCache = new Map, this.materialCache = new Map;
    }
    update(t) {
        let e = t.vertexShader, n = t.fragmentShader, i = this._getShaderStage(e), s = this._getShaderStage(n), o = this._getShaderCacheForMaterial(t);
        return o.has(i) === !1 && (o.add(i), i.usedTimes++), o.has(s) === !1 && (o.add(s), s.usedTimes++), this;
    }
    remove(t) {
        let e = this.materialCache.get(t);
        for (let n of e)n.usedTimes--, n.usedTimes === 0 && this.shaderCache.delete(n.code);
        return this.materialCache.delete(t), this;
    }
    getVertexShaderID(t) {
        return this._getShaderStage(t.vertexShader).id;
    }
    getFragmentShaderID(t) {
        return this._getShaderStage(t.fragmentShader).id;
    }
    dispose() {
        this.shaderCache.clear(), this.materialCache.clear();
    }
    _getShaderCacheForMaterial(t) {
        let e = this.materialCache, n = e.get(t);
        return n === void 0 && (n = new Set, e.set(t, n)), n;
    }
    _getShaderStage(t) {
        let e = this.shaderCache, n = e.get(t);
        return n === void 0 && (n = new T0(t), e.set(t, n)), n;
    }
}, T0 = class {
    constructor(t){
        this.id = pB++, this.code = t, this.usedTimes = 0;
    }
};
function mB(r1, t, e, n, i, s, o) {
    let a = new gh, l = new M0, u = [], c = i.isWebGL2, d = i.logarithmicDepthBuffer, h = i.vertexTextures, f = i.precision, m = {
        MeshDepthMaterial: "depth",
        MeshDistanceMaterial: "distanceRGBA",
        MeshNormalMaterial: "normal",
        MeshBasicMaterial: "basic",
        MeshLambertMaterial: "lambert",
        MeshPhongMaterial: "phong",
        MeshToonMaterial: "toon",
        MeshStandardMaterial: "physical",
        MeshPhysicalMaterial: "physical",
        MeshMatcapMaterial: "matcap",
        LineBasicMaterial: "basic",
        LineDashedMaterial: "dashed",
        PointsMaterial: "points",
        ShadowMaterial: "shadow",
        SpriteMaterial: "sprite"
    };
    function p(b, T, E, P, D) {
        let C = P.fog, O = D.geometry, B = b.isMeshStandardMaterial ? P.environment : null, V = (b.isMeshStandardMaterial ? e : t).get(b.envMap || B), Y = !!V && V.mapping === Ac ? V.image.height : null, W = m[b.type];
        b.precision !== null && (f = i.getMaxPrecision(b.precision), f !== b.precision && console.warn("THREE.WebGLProgram.getParameters:", b.precision, "not supported, using", f, "instead."));
        let q = O.morphAttributes.position || O.morphAttributes.normal || O.morphAttributes.color, j = q !== void 0 ? q.length : 0, X = 0;
        O.morphAttributes.position !== void 0 && (X = 1), O.morphAttributes.normal !== void 0 && (X = 2), O.morphAttributes.color !== void 0 && (X = 3);
        let L, U, G, H;
        if (W) {
            let he = ps[W];
            L = he.vertexShader, U = he.fragmentShader;
        } else L = b.vertexShader, U = b.fragmentShader, l.update(b), G = l.getVertexShaderID(b), H = l.getFragmentShaderID(b);
        let z = r1.getRenderTarget(), re = b.alphaTest > 0, K = b.clearcoat > 0, Z = b.iridescence > 0;
        return {
            isWebGL2: c,
            shaderID: W,
            shaderName: b.type,
            vertexShader: L,
            fragmentShader: U,
            defines: b.defines,
            customVertexShaderID: G,
            customFragmentShaderID: H,
            isRawShaderMaterial: b.isRawShaderMaterial === !0,
            glslVersion: b.glslVersion,
            precision: f,
            instancing: D.isInstancedMesh === !0,
            instancingColor: D.isInstancedMesh === !0 && D.instanceColor !== null,
            supportsVertexTextures: h,
            outputEncoding: z === null ? r1.outputEncoding : z.isXRRenderTarget === !0 ? z.texture.encoding : oi,
            map: !!b.map,
            matcap: !!b.matcap,
            envMap: !!V,
            envMapMode: V && V.mapping,
            envMapCubeUVHeight: Y,
            lightMap: !!b.lightMap,
            aoMap: !!b.aoMap,
            emissiveMap: !!b.emissiveMap,
            bumpMap: !!b.bumpMap,
            normalMap: !!b.normalMap,
            objectSpaceNormalMap: b.normalMapType === LO,
            tangentSpaceNormalMap: b.normalMapType === RO,
            decodeVideoTexture: !!b.map && b.map.isVideoTexture === !0 && b.map.encoding === Ye,
            clearcoat: K,
            clearcoatMap: K && !!b.clearcoatMap,
            clearcoatRoughnessMap: K && !!b.clearcoatRoughnessMap,
            clearcoatNormalMap: K && !!b.clearcoatNormalMap,
            iridescence: Z,
            iridescenceMap: Z && !!b.iridescenceMap,
            iridescenceThicknessMap: Z && !!b.iridescenceThicknessMap,
            displacementMap: !!b.displacementMap,
            roughnessMap: !!b.roughnessMap,
            metalnessMap: !!b.metalnessMap,
            specularMap: !!b.specularMap,
            specularIntensityMap: !!b.specularIntensityMap,
            specularColorMap: !!b.specularColorMap,
            opaque: b.transparent === !1 && b.blending === sc,
            alphaMap: !!b.alphaMap,
            alphaTest: re,
            gradientMap: !!b.gradientMap,
            sheen: b.sheen > 0,
            sheenColorMap: !!b.sheenColorMap,
            sheenRoughnessMap: !!b.sheenRoughnessMap,
            transmission: b.transmission > 0,
            transmissionMap: !!b.transmissionMap,
            thicknessMap: !!b.thicknessMap,
            combine: b.combine,
            vertexTangents: !!b.normalMap && !!O.attributes.tangent,
            vertexColors: b.vertexColors,
            vertexAlphas: b.vertexColors === !0 && !!O.attributes.color && O.attributes.color.itemSize === 4,
            vertexUvs: !!b.map || !!b.bumpMap || !!b.normalMap || !!b.specularMap || !!b.alphaMap || !!b.emissiveMap || !!b.roughnessMap || !!b.metalnessMap || !!b.clearcoatMap || !!b.clearcoatRoughnessMap || !!b.clearcoatNormalMap || !!b.iridescenceMap || !!b.iridescenceThicknessMap || !!b.displacementMap || !!b.transmissionMap || !!b.thicknessMap || !!b.specularIntensityMap || !!b.specularColorMap || !!b.sheenColorMap || !!b.sheenRoughnessMap,
            uvsVertexOnly: !(!!b.map || !!b.bumpMap || !!b.normalMap || !!b.specularMap || !!b.alphaMap || !!b.emissiveMap || !!b.roughnessMap || !!b.metalnessMap || !!b.clearcoatNormalMap || !!b.iridescenceMap || !!b.iridescenceThicknessMap || b.transmission > 0 || !!b.transmissionMap || !!b.thicknessMap || !!b.specularIntensityMap || !!b.specularColorMap || b.sheen > 0 || !!b.sheenColorMap || !!b.sheenRoughnessMap) && !!b.displacementMap,
            fog: !!C,
            useFog: b.fog === !0,
            fogExp2: C && C.isFogExp2,
            flatShading: !!b.flatShading,
            sizeAttenuation: b.sizeAttenuation,
            logarithmicDepthBuffer: d,
            skinning: D.isSkinnedMesh === !0,
            morphTargets: O.morphAttributes.position !== void 0,
            morphNormals: O.morphAttributes.normal !== void 0,
            morphColors: O.morphAttributes.color !== void 0,
            morphTargetsCount: j,
            morphTextureStride: X,
            numDirLights: T.directional.length,
            numPointLights: T.point.length,
            numSpotLights: T.spot.length,
            numSpotLightMaps: T.spotLightMap.length,
            numRectAreaLights: T.rectArea.length,
            numHemiLights: T.hemi.length,
            numDirLightShadows: T.directionalShadowMap.length,
            numPointLightShadows: T.pointShadowMap.length,
            numSpotLightShadows: T.spotShadowMap.length,
            numSpotLightShadowsWithMaps: T.numSpotLightShadowsWithMaps,
            numClippingPlanes: o.numPlanes,
            numClipIntersection: o.numIntersection,
            dithering: b.dithering,
            shadowMapEnabled: r1.shadowMap.enabled && E.length > 0,
            shadowMapType: r1.shadowMap.type,
            toneMapping: b.toneMapped ? r1.toneMapping : io,
            physicallyCorrectLights: r1.physicallyCorrectLights,
            premultipliedAlpha: b.premultipliedAlpha,
            doubleSided: b.side === Ir,
            flipSided: b.side === On,
            useDepthPacking: !!b.depthPacking,
            depthPacking: b.depthPacking || 0,
            index0AttributeName: b.index0AttributeName,
            extensionDerivatives: b.extensions && b.extensions.derivatives,
            extensionFragDepth: b.extensions && b.extensions.fragDepth,
            extensionDrawBuffers: b.extensions && b.extensions.drawBuffers,
            extensionShaderTextureLOD: b.extensions && b.extensions.shaderTextureLOD,
            rendererExtensionFragDepth: c || n.has("EXT_frag_depth"),
            rendererExtensionDrawBuffers: c || n.has("WEBGL_draw_buffers"),
            rendererExtensionShaderTextureLod: c || n.has("EXT_shader_texture_lod"),
            customProgramCacheKey: b.customProgramCacheKey()
        };
    }
    function g(b) {
        let T = [];
        if (b.shaderID ? T.push(b.shaderID) : (T.push(b.customVertexShaderID), T.push(b.customFragmentShaderID)), b.defines !== void 0) for(let E in b.defines)T.push(E), T.push(b.defines[E]);
        return b.isRawShaderMaterial === !1 && (y(T, b), v(T, b), T.push(r1.outputEncoding)), T.push(b.customProgramCacheKey), T.join();
    }
    function y(b, T) {
        b.push(T.precision), b.push(T.outputEncoding), b.push(T.envMapMode), b.push(T.envMapCubeUVHeight), b.push(T.combine), b.push(T.vertexUvs), b.push(T.fogExp2), b.push(T.sizeAttenuation), b.push(T.morphTargetsCount), b.push(T.morphAttributeCount), b.push(T.numDirLights), b.push(T.numPointLights), b.push(T.numSpotLights), b.push(T.numSpotLightMaps), b.push(T.numHemiLights), b.push(T.numRectAreaLights), b.push(T.numDirLightShadows), b.push(T.numPointLightShadows), b.push(T.numSpotLightShadows), b.push(T.numSpotLightShadowsWithMaps), b.push(T.shadowMapType), b.push(T.toneMapping), b.push(T.numClippingPlanes), b.push(T.numClipIntersection), b.push(T.depthPacking);
    }
    function v(b, T) {
        a.disableAll(), T.isWebGL2 && a.enable(0), T.supportsVertexTextures && a.enable(1), T.instancing && a.enable(2), T.instancingColor && a.enable(3), T.map && a.enable(4), T.matcap && a.enable(5), T.envMap && a.enable(6), T.lightMap && a.enable(7), T.aoMap && a.enable(8), T.emissiveMap && a.enable(9), T.bumpMap && a.enable(10), T.normalMap && a.enable(11), T.objectSpaceNormalMap && a.enable(12), T.tangentSpaceNormalMap && a.enable(13), T.clearcoat && a.enable(14), T.clearcoatMap && a.enable(15), T.clearcoatRoughnessMap && a.enable(16), T.clearcoatNormalMap && a.enable(17), T.iridescence && a.enable(18), T.iridescenceMap && a.enable(19), T.iridescenceThicknessMap && a.enable(20), T.displacementMap && a.enable(21), T.specularMap && a.enable(22), T.roughnessMap && a.enable(23), T.metalnessMap && a.enable(24), T.gradientMap && a.enable(25), T.alphaMap && a.enable(26), T.alphaTest && a.enable(27), T.vertexColors && a.enable(28), T.vertexAlphas && a.enable(29), T.vertexUvs && a.enable(30), T.vertexTangents && a.enable(31), T.uvsVertexOnly && a.enable(32), b.push(a.mask), a.disableAll(), T.fog && a.enable(0), T.useFog && a.enable(1), T.flatShading && a.enable(2), T.logarithmicDepthBuffer && a.enable(3), T.skinning && a.enable(4), T.morphTargets && a.enable(5), T.morphNormals && a.enable(6), T.morphColors && a.enable(7), T.premultipliedAlpha && a.enable(8), T.shadowMapEnabled && a.enable(9), T.physicallyCorrectLights && a.enable(10), T.doubleSided && a.enable(11), T.flipSided && a.enable(12), T.useDepthPacking && a.enable(13), T.dithering && a.enable(14), T.specularIntensityMap && a.enable(15), T.specularColorMap && a.enable(16), T.transmission && a.enable(17), T.transmissionMap && a.enable(18), T.thicknessMap && a.enable(19), T.sheen && a.enable(20), T.sheenColorMap && a.enable(21), T.sheenRoughnessMap && a.enable(22), T.decodeVideoTexture && a.enable(23), T.opaque && a.enable(24), b.push(a.mask);
    }
    function x(b) {
        let T = m[b.type], E;
        if (T) {
            let P = ps[T];
            E = Gi.clone(P.uniforms);
        } else E = b.uniforms;
        return E;
    }
    function w(b, T) {
        let E;
        for(let P = 0, D = u.length; P < D; P++){
            let C = u[P];
            if (C.cacheKey === T) {
                E = C, ++E.usedTimes;
                break;
            }
        }
        return E === void 0 && (E = new fB(r1, T, b, s), u.push(E)), E;
    }
    function S(b) {
        if (--b.usedTimes === 0) {
            let T = u.indexOf(b);
            u[T] = u[u.length - 1], u.pop(), b.destroy();
        }
    }
    function _(b) {
        l.remove(b);
    }
    function M() {
        l.dispose();
    }
    return {
        getParameters: p,
        getProgramCacheKey: g,
        getUniforms: x,
        acquireProgram: w,
        releaseProgram: S,
        releaseShaderCache: _,
        programs: u,
        dispose: M
    };
}
function gB() {
    let r1 = new WeakMap;
    function t(s) {
        let o = r1.get(s);
        return o === void 0 && (o = {}, r1.set(s, o)), o;
    }
    function e(s) {
        r1.delete(s);
    }
    function n(s, o, a) {
        r1.get(s)[o] = a;
    }
    function i() {
        r1 = new WeakMap;
    }
    return {
        get: t,
        remove: e,
        update: n,
        dispose: i
    };
}
function yB(r1, t) {
    return r1.groupOrder !== t.groupOrder ? r1.groupOrder - t.groupOrder : r1.renderOrder !== t.renderOrder ? r1.renderOrder - t.renderOrder : r1.material.id !== t.material.id ? r1.material.id - t.material.id : r1.z !== t.z ? r1.z - t.z : r1.id - t.id;
}
function $1(r1, t) {
    return r1.groupOrder !== t.groupOrder ? r1.groupOrder - t.groupOrder : r1.renderOrder !== t.renderOrder ? r1.renderOrder - t.renderOrder : r1.z !== t.z ? t.z - r1.z : r1.id - t.id;
}
function eA() {
    let r1 = [], t = 0, e = [], n = [], i = [];
    function s() {
        t = 0, e.length = 0, n.length = 0, i.length = 0;
    }
    function o(d, h, f, m, p, g) {
        let y = r1[t];
        return y === void 0 ? (y = {
            id: d.id,
            object: d,
            geometry: h,
            material: f,
            groupOrder: m,
            renderOrder: d.renderOrder,
            z: p,
            group: g
        }, r1[t] = y) : (y.id = d.id, y.object = d, y.geometry = h, y.material = f, y.groupOrder = m, y.renderOrder = d.renderOrder, y.z = p, y.group = g), t++, y;
    }
    function a(d, h, f, m, p, g) {
        let y = o(d, h, f, m, p, g);
        f.transmission > 0 ? n.push(y) : f.transparent === !0 ? i.push(y) : e.push(y);
    }
    function l(d, h, f, m, p, g) {
        let y = o(d, h, f, m, p, g);
        f.transmission > 0 ? n.unshift(y) : f.transparent === !0 ? i.unshift(y) : e.unshift(y);
    }
    function u(d, h) {
        e.length > 1 && e.sort(d || yB), n.length > 1 && n.sort(h || $1), i.length > 1 && i.sort(h || $1);
    }
    function c() {
        for(let d = t, h = r1.length; d < h; d++){
            let f = r1[d];
            if (f.id === null) break;
            f.id = null, f.object = null, f.geometry = null, f.material = null, f.group = null;
        }
    }
    return {
        opaque: e,
        transmissive: n,
        transparent: i,
        init: s,
        push: a,
        unshift: l,
        finish: c,
        sort: u
    };
}
function vB() {
    let r1 = new WeakMap;
    function t(n, i) {
        let s = r1.get(n), o;
        return s === void 0 ? (o = new eA, r1.set(n, [
            o
        ])) : i >= s.length ? (o = new eA, s.push(o)) : o = s[i], o;
    }
    function e() {
        r1 = new WeakMap;
    }
    return {
        get: t,
        dispose: e
    };
}
function xB() {
    let r1 = {};
    return {
        get: function(t) {
            if (r1[t.id] !== void 0) return r1[t.id];
            let e;
            switch(t.type){
                case "DirectionalLight":
                    e = {
                        direction: new A,
                        color: new Ne
                    };
                    break;
                case "SpotLight":
                    e = {
                        position: new A,
                        direction: new A,
                        color: new Ne,
                        distance: 0,
                        coneCos: 0,
                        penumbraCos: 0,
                        decay: 0
                    };
                    break;
                case "PointLight":
                    e = {
                        position: new A,
                        color: new Ne,
                        distance: 0,
                        decay: 0
                    };
                    break;
                case "HemisphereLight":
                    e = {
                        direction: new A,
                        skyColor: new Ne,
                        groundColor: new Ne
                    };
                    break;
                case "RectAreaLight":
                    e = {
                        color: new Ne,
                        position: new A,
                        halfWidth: new A,
                        halfHeight: new A
                    };
                    break;
            }
            return r1[t.id] = e, e;
        }
    };
}
function bB() {
    let r1 = {};
    return {
        get: function(t) {
            if (r1[t.id] !== void 0) return r1[t.id];
            let e;
            switch(t.type){
                case "DirectionalLight":
                    e = {
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new F
                    };
                    break;
                case "SpotLight":
                    e = {
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new F
                    };
                    break;
                case "PointLight":
                    e = {
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new F,
                        shadowCameraNear: 1,
                        shadowCameraFar: 1e3
                    };
                    break;
            }
            return r1[t.id] = e, e;
        }
    };
}
var wB = 0;
function SB(r1, t) {
    return (t.castShadow ? 2 : 0) - (r1.castShadow ? 2 : 0) + (t.map ? 1 : 0) - (r1.map ? 1 : 0);
}
function AB(r1, t) {
    let e = new xB, n = bB(), i = {
        version: 0,
        hash: {
            directionalLength: -1,
            pointLength: -1,
            spotLength: -1,
            rectAreaLength: -1,
            hemiLength: -1,
            numDirectionalShadows: -1,
            numPointShadows: -1,
            numSpotShadows: -1,
            numSpotMaps: -1
        },
        ambient: [
            0,
            0,
            0
        ],
        probe: [],
        directional: [],
        directionalShadow: [],
        directionalShadowMap: [],
        directionalShadowMatrix: [],
        spot: [],
        spotLightMap: [],
        spotShadow: [],
        spotShadowMap: [],
        spotLightMatrix: [],
        rectArea: [],
        rectAreaLTC1: null,
        rectAreaLTC2: null,
        point: [],
        pointShadow: [],
        pointShadowMap: [],
        pointShadowMatrix: [],
        hemi: [],
        numSpotLightShadowsWithMaps: 0
    };
    for(let c = 0; c < 9; c++)i.probe.push(new A);
    let s = new A, o = new ae, a = new ae;
    function l(c, d) {
        let h = 0, f = 0, m = 0;
        for(let P = 0; P < 9; P++)i.probe[P].set(0, 0, 0);
        let p = 0, g = 0, y = 0, v = 0, x = 0, w = 0, S = 0, _ = 0, M = 0, b = 0;
        c.sort(SB);
        let T = d !== !0 ? Math.PI : 1;
        for(let P = 0, D = c.length; P < D; P++){
            let C = c[P], O = C.color, B = C.intensity, V = C.distance, Y = C.shadow && C.shadow.map ? C.shadow.map.texture : null;
            if (C.isAmbientLight) h += O.r * B * T, f += O.g * B * T, m += O.b * B * T;
            else if (C.isLightProbe) for(let W = 0; W < 9; W++)i.probe[W].addScaledVector(C.sh.coefficients[W], B);
            else if (C.isDirectionalLight) {
                let W = e.get(C);
                if (W.color.copy(C.color).multiplyScalar(C.intensity * T), C.castShadow) {
                    let q = C.shadow, j = n.get(C);
                    j.shadowBias = q.bias, j.shadowNormalBias = q.normalBias, j.shadowRadius = q.radius, j.shadowMapSize = q.mapSize, i.directionalShadow[p] = j, i.directionalShadowMap[p] = Y, i.directionalShadowMatrix[p] = C.shadow.matrix, w++;
                }
                i.directional[p] = W, p++;
            } else if (C.isSpotLight) {
                let W = e.get(C);
                W.position.setFromMatrixPosition(C.matrixWorld), W.color.copy(O).multiplyScalar(B * T), W.distance = V, W.coneCos = Math.cos(C.angle), W.penumbraCos = Math.cos(C.angle * (1 - C.penumbra)), W.decay = C.decay, i.spot[y] = W;
                let q = C.shadow;
                if (C.map && (i.spotLightMap[M] = C.map, M++, q.updateMatrices(C), C.castShadow && b++), i.spotLightMatrix[y] = q.matrix, C.castShadow) {
                    let j = n.get(C);
                    j.shadowBias = q.bias, j.shadowNormalBias = q.normalBias, j.shadowRadius = q.radius, j.shadowMapSize = q.mapSize, i.spotShadow[y] = j, i.spotShadowMap[y] = Y, _++;
                }
                y++;
            } else if (C.isRectAreaLight) {
                let W = e.get(C);
                W.color.copy(O).multiplyScalar(B), W.halfWidth.set(C.width * .5, 0, 0), W.halfHeight.set(0, C.height * .5, 0), i.rectArea[v] = W, v++;
            } else if (C.isPointLight) {
                let W = e.get(C);
                if (W.color.copy(C.color).multiplyScalar(C.intensity * T), W.distance = C.distance, W.decay = C.decay, C.castShadow) {
                    let q = C.shadow, j = n.get(C);
                    j.shadowBias = q.bias, j.shadowNormalBias = q.normalBias, j.shadowRadius = q.radius, j.shadowMapSize = q.mapSize, j.shadowCameraNear = q.camera.near, j.shadowCameraFar = q.camera.far, i.pointShadow[g] = j, i.pointShadowMap[g] = Y, i.pointShadowMatrix[g] = C.shadow.matrix, S++;
                }
                i.point[g] = W, g++;
            } else if (C.isHemisphereLight) {
                let W = e.get(C);
                W.skyColor.copy(C.color).multiplyScalar(B * T), W.groundColor.copy(C.groundColor).multiplyScalar(B * T), i.hemi[x] = W, x++;
            }
        }
        v > 0 && (t.isWebGL2 || r1.has("OES_texture_float_linear") === !0 ? (i.rectAreaLTC1 = be.LTC_FLOAT_1, i.rectAreaLTC2 = be.LTC_FLOAT_2) : r1.has("OES_texture_half_float_linear") === !0 ? (i.rectAreaLTC1 = be.LTC_HALF_1, i.rectAreaLTC2 = be.LTC_HALF_2) : console.error("THREE.WebGLRenderer: Unable to use RectAreaLight. Missing WebGL extensions.")), i.ambient[0] = h, i.ambient[1] = f, i.ambient[2] = m;
        let E = i.hash;
        (E.directionalLength !== p || E.pointLength !== g || E.spotLength !== y || E.rectAreaLength !== v || E.hemiLength !== x || E.numDirectionalShadows !== w || E.numPointShadows !== S || E.numSpotShadows !== _ || E.numSpotMaps !== M) && (i.directional.length = p, i.spot.length = y, i.rectArea.length = v, i.point.length = g, i.hemi.length = x, i.directionalShadow.length = w, i.directionalShadowMap.length = w, i.pointShadow.length = S, i.pointShadowMap.length = S, i.spotShadow.length = _, i.spotShadowMap.length = _, i.directionalShadowMatrix.length = w, i.pointShadowMatrix.length = S, i.spotLightMatrix.length = _ + M - b, i.spotLightMap.length = M, i.numSpotLightShadowsWithMaps = b, E.directionalLength = p, E.pointLength = g, E.spotLength = y, E.rectAreaLength = v, E.hemiLength = x, E.numDirectionalShadows = w, E.numPointShadows = S, E.numSpotShadows = _, E.numSpotMaps = M, i.version = wB++);
    }
    function u(c, d) {
        let h = 0, f = 0, m = 0, p = 0, g = 0, y = d.matrixWorldInverse;
        for(let v = 0, x = c.length; v < x; v++){
            let w = c[v];
            if (w.isDirectionalLight) {
                let S = i.directional[h];
                S.direction.setFromMatrixPosition(w.matrixWorld), s.setFromMatrixPosition(w.target.matrixWorld), S.direction.sub(s), S.direction.transformDirection(y), h++;
            } else if (w.isSpotLight) {
                let S = i.spot[m];
                S.position.setFromMatrixPosition(w.matrixWorld), S.position.applyMatrix4(y), S.direction.setFromMatrixPosition(w.matrixWorld), s.setFromMatrixPosition(w.target.matrixWorld), S.direction.sub(s), S.direction.transformDirection(y), m++;
            } else if (w.isRectAreaLight) {
                let S = i.rectArea[p];
                S.position.setFromMatrixPosition(w.matrixWorld), S.position.applyMatrix4(y), a.identity(), o.copy(w.matrixWorld), o.premultiply(y), a.extractRotation(o), S.halfWidth.set(w.width * .5, 0, 0), S.halfHeight.set(0, w.height * .5, 0), S.halfWidth.applyMatrix4(a), S.halfHeight.applyMatrix4(a), p++;
            } else if (w.isPointLight) {
                let S = i.point[f];
                S.position.setFromMatrixPosition(w.matrixWorld), S.position.applyMatrix4(y), f++;
            } else if (w.isHemisphereLight) {
                let S = i.hemi[g];
                S.direction.setFromMatrixPosition(w.matrixWorld), S.direction.transformDirection(y), g++;
            }
        }
    }
    return {
        setup: l,
        setupView: u,
        state: i
    };
}
function tA(r1, t) {
    let e = new AB(r1, t), n = [], i = [];
    function s() {
        n.length = 0, i.length = 0;
    }
    function o(d) {
        n.push(d);
    }
    function a(d) {
        i.push(d);
    }
    function l(d) {
        e.setup(n, d);
    }
    function u(d) {
        e.setupView(n, d);
    }
    return {
        init: s,
        state: {
            lightsArray: n,
            shadowsArray: i,
            lights: e
        },
        setupLights: l,
        setupLightsView: u,
        pushLight: o,
        pushShadow: a
    };
}
function _B(r1, t) {
    let e = new WeakMap;
    function n(s, o = 0) {
        let a = e.get(s), l;
        return a === void 0 ? (l = new tA(r1, t), e.set(s, [
            l
        ])) : o >= a.length ? (l = new tA(r1, t), a.push(l)) : l = a[o], l;
    }
    function i() {
        e = new WeakMap;
    }
    return {
        get: n,
        dispose: i
    };
}
var vh = class extends Wa {
    constructor(t){
        super(), this.isMeshDepthMaterial = !0, this.type = "MeshDepthMaterial", this.depthPacking = tr, this.map = null, this.alphaMap = null, this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.wireframe = !1, this.wireframeLinewidth = 1, this.setValues(t);
    }
    copy(t) {
        return super.copy(t), this.depthPacking = t.depthPacking, this.map = t.map, this.alphaMap = t.alphaMap, this.displacementMap = t.displacementMap, this.displacementScale = t.displacementScale, this.displacementBias = t.displacementBias, this.wireframe = t.wireframe, this.wireframeLinewidth = t.wireframeLinewidth, this;
    }
}, E0 = class extends Wa {
    constructor(t){
        super(), this.isMeshDistanceMaterial = !0, this.type = "MeshDistanceMaterial", this.referencePosition = new A, this.nearDistance = 1, this.farDistance = 1e3, this.map = null, this.alphaMap = null, this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.setValues(t);
    }
    copy(t) {
        return super.copy(t), this.referencePosition.copy(t.referencePosition), this.nearDistance = t.nearDistance, this.farDistance = t.farDistance, this.map = t.map, this.alphaMap = t.alphaMap, this.displacementMap = t.displacementMap, this.displacementScale = t.displacementScale, this.displacementBias = t.displacementBias, this;
    }
}, MB = `void main() {
	gl_Position = vec4( position, 1.0 );
}`, TB = `uniform sampler2D shadow_pass;
uniform vec2 resolution;
uniform float radius;
#include <packing>
void main() {
	const float samples = float( VSM_SAMPLES );
	float mean = 0.0;
	float squared_mean = 0.0;
	float uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );
	float uvStart = samples <= 1.0 ? 0.0 : - 1.0;
	for ( float i = 0.0; i < samples; i ++ ) {
		float uvOffset = uvStart + i * uvStride;
		#ifdef HORIZONTAL_PASS
			vec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ) );
			mean += distribution.x;
			squared_mean += distribution.y * distribution.y + distribution.x * distribution.x;
		#else
			float depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ) );
			mean += depth;
			squared_mean += depth * depth;
		#endif
	}
	mean = mean / samples;
	squared_mean = squared_mean / samples;
	float std_dev = sqrt( squared_mean - mean * mean );
	gl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );
}`;
function EB(r1, t, e) {
    let n = new yh, i = new F, s = new F, o = new Ze, a = new vh({
        depthPacking: J0
    }), l = new E0, u = {}, c = e.maxTextureSize, d = {
        [si]: On,
        [On]: si,
        [Ir]: Ir
    }, h = new ot({
        defines: {
            VSM_SAMPLES: 8
        },
        uniforms: {
            shadow_pass: {
                value: null
            },
            resolution: {
                value: new F
            },
            radius: {
                value: 4
            }
        },
        vertexShader: MB,
        fragmentShader: TB
    }), f = h.clone();
    f.defines.HORIZONTAL_PASS = 1;
    let m = new Me;
    m.setAttribute("position", new Be(new Float32Array([
        -1,
        -1,
        .5,
        3,
        -1,
        .5,
        -1,
        3,
        .5
    ]), 3));
    let p = new In(m, h), g = this;
    this.enabled = !1, this.autoUpdate = !0, this.needsUpdate = !1, this.type = rm, this.render = function(w, S, _) {
        if (g.enabled === !1 || g.autoUpdate === !1 && g.needsUpdate === !1 || w.length === 0) return;
        let M = r1.getRenderTarget(), b = r1.getActiveCubeFace(), T = r1.getActiveMipmapLevel(), E = r1.state;
        E.setBlending(Dt), E.buffers.color.setClear(1, 1, 1, 1), E.buffers.depth.setTest(!0), E.setScissorTest(!1);
        for(let P = 0, D = w.length; P < D; P++){
            let C = w[P], O = C.shadow;
            if (O === void 0) {
                console.warn("THREE.WebGLShadowMap:", C, "has no shadow.");
                continue;
            }
            if (O.autoUpdate === !1 && O.needsUpdate === !1) continue;
            i.copy(O.mapSize);
            let B = O.getFrameExtents();
            if (i.multiply(B), s.copy(O.mapSize), (i.x > c || i.y > c) && (i.x > c && (s.x = Math.floor(c / B.x), i.x = s.x * B.x, O.mapSize.x = s.x), i.y > c && (s.y = Math.floor(c / B.y), i.y = s.y * B.y, O.mapSize.y = s.y)), O.map === null) {
                let Y = this.type !== ah ? {
                    minFilter: _t,
                    magFilter: _t
                } : {};
                O.map = new st(i.x, i.y, Y), O.map.texture.name = C.name + ".shadowMap", O.camera.updateProjectionMatrix();
            }
            r1.setRenderTarget(O.map), r1.clear();
            let V = O.getViewportCount();
            for(let Y = 0; Y < V; Y++){
                let W = O.getViewport(Y);
                o.set(s.x * W.x, s.y * W.y, s.x * W.z, s.y * W.w), E.viewport(o), O.updateMatrices(C, Y), n = O.getFrustum(), x(S, _, O.camera, C, this.type);
            }
            O.isPointLightShadow !== !0 && this.type === ah && y(O, _), O.needsUpdate = !1;
        }
        g.needsUpdate = !1, r1.setRenderTarget(M, b, T);
    };
    function y(w, S) {
        let _ = t.update(p);
        h.defines.VSM_SAMPLES !== w.blurSamples && (h.defines.VSM_SAMPLES = w.blurSamples, f.defines.VSM_SAMPLES = w.blurSamples, h.needsUpdate = !0, f.needsUpdate = !0), w.mapPass === null && (w.mapPass = new st(i.x, i.y)), h.uniforms.shadow_pass.value = w.map.texture, h.uniforms.resolution.value = w.mapSize, h.uniforms.radius.value = w.radius, r1.setRenderTarget(w.mapPass), r1.clear(), r1.renderBufferDirect(S, null, _, h, p, null), f.uniforms.shadow_pass.value = w.mapPass.texture, f.uniforms.resolution.value = w.mapSize, f.uniforms.radius.value = w.radius, r1.setRenderTarget(w.map), r1.clear(), r1.renderBufferDirect(S, null, _, f, p, null);
    }
    function v(w, S, _, M, b, T) {
        let E = null, P = _.isPointLight === !0 ? w.customDistanceMaterial : w.customDepthMaterial;
        if (P !== void 0) E = P;
        else if (E = _.isPointLight === !0 ? l : a, r1.localClippingEnabled && S.clipShadows === !0 && Array.isArray(S.clippingPlanes) && S.clippingPlanes.length !== 0 || S.displacementMap && S.displacementScale !== 0 || S.alphaMap && S.alphaTest > 0 || S.map && S.alphaTest > 0) {
            let D = E.uuid, C = S.uuid, O = u[D];
            O === void 0 && (O = {}, u[D] = O);
            let B = O[C];
            B === void 0 && (B = E.clone(), O[C] = B), E = B;
        }
        return E.visible = S.visible, E.wireframe = S.wireframe, T === ah ? E.side = S.shadowSide !== null ? S.shadowSide : S.side : E.side = S.shadowSide !== null ? S.shadowSide : d[S.side], E.alphaMap = S.alphaMap, E.alphaTest = S.alphaTest, E.map = S.map, E.clipShadows = S.clipShadows, E.clippingPlanes = S.clippingPlanes, E.clipIntersection = S.clipIntersection, E.displacementMap = S.displacementMap, E.displacementScale = S.displacementScale, E.displacementBias = S.displacementBias, E.wireframeLinewidth = S.wireframeLinewidth, E.linewidth = S.linewidth, _.isPointLight === !0 && E.isMeshDistanceMaterial === !0 && (E.referencePosition.setFromMatrixPosition(_.matrixWorld), E.nearDistance = M, E.farDistance = b), E;
    }
    function x(w, S, _, M, b) {
        if (w.visible === !1) return;
        if (w.layers.test(S.layers) && (w.isMesh || w.isLine || w.isPoints) && (w.castShadow || w.receiveShadow && b === ah) && (!w.frustumCulled || n.intersectsObject(w))) {
            w.modelViewMatrix.multiplyMatrices(_.matrixWorldInverse, w.matrixWorld);
            let P = t.update(w), D = w.material;
            if (Array.isArray(D)) {
                let C = P.groups;
                for(let O = 0, B = C.length; O < B; O++){
                    let V = C[O], Y = D[V.materialIndex];
                    if (Y && Y.visible) {
                        let W = v(w, Y, M, _.near, _.far, b);
                        r1.renderBufferDirect(_, null, P, W, w, V);
                    }
                }
            } else if (D.visible) {
                let C = v(w, D, M, _.near, _.far, b);
                r1.renderBufferDirect(_, null, P, C, w, null);
            }
        }
        let E = w.children;
        for(let P = 0, D = E.length; P < D; P++)x(E[P], S, _, M, b);
    }
}
function CB(r1, t, e) {
    let n = e.isWebGL2;
    function i() {
        let Q = !1, se = new Ze, ge = null, Le = new Ze(0, 0, 0, 0);
        return {
            setMask: function(Oe) {
                ge !== Oe && !Q && (r1.colorMask(Oe, Oe, Oe, Oe), ge = Oe);
            },
            setLocked: function(Oe) {
                Q = Oe;
            },
            setClear: function(Oe, vt, En, pn, Ia) {
                Ia === !0 && (Oe *= pn, vt *= pn, En *= pn), se.set(Oe, vt, En, pn), Le.equals(se) === !1 && (r1.clearColor(Oe, vt, En, pn), Le.copy(se));
            },
            reset: function() {
                Q = !1, ge = null, Le.set(-1, 0, 0, 0);
            }
        };
    }
    function s() {
        let Q = !1, se = null, ge = null, Le = null;
        return {
            setTest: function(Oe) {
                Oe ? re(2929) : K(2929);
            },
            setMask: function(Oe) {
                se !== Oe && !Q && (r1.depthMask(Oe), se = Oe);
            },
            setFunc: function(Oe) {
                if (ge !== Oe) {
                    switch(Oe){
                        case iO:
                            r1.depthFunc(512);
                            break;
                        case sO:
                            r1.depthFunc(519);
                            break;
                        case oO:
                            r1.depthFunc(513);
                            break;
                        case h0:
                            r1.depthFunc(515);
                            break;
                        case aO:
                            r1.depthFunc(514);
                            break;
                        case lO:
                            r1.depthFunc(518);
                            break;
                        case cO:
                            r1.depthFunc(516);
                            break;
                        case uO:
                            r1.depthFunc(517);
                            break;
                        default:
                            r1.depthFunc(515);
                    }
                    ge = Oe;
                }
            },
            setLocked: function(Oe) {
                Q = Oe;
            },
            setClear: function(Oe) {
                Le !== Oe && (r1.clearDepth(Oe), Le = Oe);
            },
            reset: function() {
                Q = !1, se = null, ge = null, Le = null;
            }
        };
    }
    function o() {
        let Q = !1, se = null, ge = null, Le = null, Oe = null, vt = null, En = null, pn = null, Ia = null;
        return {
            setTest: function(Qt) {
                Q || (Qt ? re(2960) : K(2960));
            },
            setMask: function(Qt) {
                se !== Qt && !Q && (r1.stencilMask(Qt), se = Qt);
            },
            setFunc: function(Qt, Ys, pi) {
                (ge !== Qt || Le !== Ys || Oe !== pi) && (r1.stencilFunc(Qt, Ys, pi), ge = Qt, Le = Ys, Oe = pi);
            },
            setOp: function(Qt, Ys, pi) {
                (vt !== Qt || En !== Ys || pn !== pi) && (r1.stencilOp(Qt, Ys, pi), vt = Qt, En = Ys, pn = pi);
            },
            setLocked: function(Qt) {
                Q = Qt;
            },
            setClear: function(Qt) {
                Ia !== Qt && (r1.clearStencil(Qt), Ia = Qt);
            },
            reset: function() {
                Q = !1, se = null, ge = null, Le = null, Oe = null, vt = null, En = null, pn = null, Ia = null;
            }
        };
    }
    let a = new i, l = new s, u = new o, c = new WeakMap, d = new WeakMap, h = {}, f = {}, m = new WeakMap, p = [], g = null, y = !1, v = null, x = null, w = null, S = null, _ = null, M = null, b = null, T = !1, E = null, P = null, D = null, C = null, O = null, B = r1.getParameter(35661), V = !1, Y = 0, W = r1.getParameter(7938);
    W.indexOf("WebGL") !== -1 ? (Y = parseFloat(/^WebGL (\d)/.exec(W)[1]), V = Y >= 1) : W.indexOf("OpenGL ES") !== -1 && (Y = parseFloat(/^OpenGL ES (\d)/.exec(W)[1]), V = Y >= 2);
    let q = null, j = {}, X = r1.getParameter(3088), L = r1.getParameter(2978), U = new Ze().fromArray(X), G = new Ze().fromArray(L);
    function H(Q, se, ge) {
        let Le = new Uint8Array(4), Oe = r1.createTexture();
        r1.bindTexture(Q, Oe), r1.texParameteri(Q, 10241, 9728), r1.texParameteri(Q, 10240, 9728);
        for(let vt = 0; vt < ge; vt++)r1.texImage2D(se + vt, 0, 6408, 1, 1, 0, 6408, 5121, Le);
        return Oe;
    }
    let z = {};
    z[3553] = H(3553, 3553, 1), z[34067] = H(34067, 34069, 6), a.setClear(0, 0, 0, 1), l.setClear(1), u.setClear(0), re(2929), l.setFunc(h0), ve(!1), Te(WS), re(2884), ye(Dt);
    function re(Q) {
        h[Q] !== !0 && (r1.enable(Q), h[Q] = !0);
    }
    function K(Q) {
        h[Q] !== !1 && (r1.disable(Q), h[Q] = !1);
    }
    function Z(Q, se) {
        return f[Q] !== se ? (r1.bindFramebuffer(Q, se), f[Q] = se, n && (Q === 36009 && (f[36160] = se), Q === 36160 && (f[36009] = se)), !0) : !1;
    }
    function k(Q, se) {
        let ge = p, Le = !1;
        if (Q) {
            if (ge = m.get(se), ge === void 0 && (ge = [], m.set(se, ge)), Q.isWebGLMultipleRenderTargets) {
                let Oe = Q.texture;
                if (ge.length !== Oe.length || ge[0] !== 36064) {
                    for(let vt = 0, En = Oe.length; vt < En; vt++)ge[vt] = 36064 + vt;
                    ge.length = Oe.length, Le = !0;
                }
            } else ge[0] !== 36064 && (ge[0] = 36064, Le = !0);
        } else ge[0] !== 1029 && (ge[0] = 1029, Le = !0);
        Le && (e.isWebGL2 ? r1.drawBuffers(ge) : t.get("WEBGL_draw_buffers").drawBuffersWEBGL(ge));
    }
    function he(Q) {
        return g !== Q ? (r1.useProgram(Q), g = Q, !0) : !1;
    }
    let fe = {
        [nc]: 32774,
        [XI]: 32778,
        [YI]: 32779
    };
    if (n) fe[YS] = 32775, fe[QS] = 32776;
    else {
        let Q = t.get("EXT_blend_minmax");
        Q !== null && (fe[YS] = Q.MIN_EXT, fe[QS] = Q.MAX_EXT);
    }
    let ce = {
        [QI]: 0,
        [KI]: 1,
        [ZI]: 768,
        [SA]: 770,
        [rO]: 776,
        [tO]: 774,
        [$I]: 772,
        [JI]: 769,
        [AA]: 771,
        [nO]: 775,
        [eO]: 773
    };
    function ye(Q, se, ge, Le, Oe, vt, En, pn) {
        if (Q === Dt) {
            y === !0 && (K(3042), y = !1);
            return;
        }
        if (y === !1 && (re(3042), y = !0), Q !== qI) {
            if (Q !== v || pn !== T) {
                if ((x !== nc || _ !== nc) && (r1.blendEquation(32774), x = nc, _ = nc), pn) switch(Q){
                    case sc:
                        r1.blendFuncSeparate(1, 771, 1, 771);
                        break;
                    case jS:
                        r1.blendFunc(1, 1);
                        break;
                    case qS:
                        r1.blendFuncSeparate(0, 769, 0, 1);
                        break;
                    case XS:
                        r1.blendFuncSeparate(0, 768, 0, 770);
                        break;
                    default:
                        console.error("THREE.WebGLState: Invalid blending: ", Q);
                        break;
                }
                else switch(Q){
                    case sc:
                        r1.blendFuncSeparate(770, 771, 1, 771);
                        break;
                    case jS:
                        r1.blendFunc(770, 1);
                        break;
                    case qS:
                        r1.blendFuncSeparate(0, 769, 0, 1);
                        break;
                    case XS:
                        r1.blendFunc(0, 768);
                        break;
                    default:
                        console.error("THREE.WebGLState: Invalid blending: ", Q);
                        break;
                }
                w = null, S = null, M = null, b = null, v = Q, T = pn;
            }
            return;
        }
        Oe = Oe || se, vt = vt || ge, En = En || Le, (se !== x || Oe !== _) && (r1.blendEquationSeparate(fe[se], fe[Oe]), x = se, _ = Oe), (ge !== w || Le !== S || vt !== M || En !== b) && (r1.blendFuncSeparate(ce[ge], ce[Le], ce[vt], ce[En]), w = ge, S = Le, M = vt, b = En), v = Q, T = !1;
    }
    function Se(Q, se) {
        Q.side === Ir ? K(2884) : re(2884);
        let ge = Q.side === On;
        se && (ge = !ge), ve(ge), Q.blending === sc && Q.transparent === !1 ? ye(Dt) : ye(Q.blending, Q.blendEquation, Q.blendSrc, Q.blendDst, Q.blendEquationAlpha, Q.blendSrcAlpha, Q.blendDstAlpha, Q.premultipliedAlpha), l.setFunc(Q.depthFunc), l.setTest(Q.depthTest), l.setMask(Q.depthWrite), a.setMask(Q.colorWrite);
        let Le = Q.stencilWrite;
        u.setTest(Le), Le && (u.setMask(Q.stencilWriteMask), u.setFunc(Q.stencilFunc, Q.stencilRef, Q.stencilFuncMask), u.setOp(Q.stencilFail, Q.stencilZFail, Q.stencilZPass)), we(Q.polygonOffset, Q.polygonOffsetFactor, Q.polygonOffsetUnits), Q.alphaToCoverage === !0 ? re(32926) : K(32926);
    }
    function ve(Q) {
        E !== Q && (Q ? r1.frontFace(2304) : r1.frontFace(2305), E = Q);
    }
    function Te(Q) {
        Q !== WI ? (re(2884), Q !== P && (Q === WS ? r1.cullFace(1029) : Q === jI ? r1.cullFace(1028) : r1.cullFace(1032))) : K(2884), P = Q;
    }
    function Ee(Q) {
        Q !== D && (V && r1.lineWidth(Q), D = Q);
    }
    function we(Q, se, ge) {
        Q ? (re(32823), (C !== se || O !== ge) && (r1.polygonOffset(se, ge), C = se, O = ge)) : K(32823);
    }
    function Ge(Q) {
        Q ? re(3089) : K(3089);
    }
    function gt(Q) {
        Q === void 0 && (Q = 33984 + B - 1), q !== Q && (r1.activeTexture(Q), q = Q);
    }
    function R(Q, se, ge) {
        ge === void 0 && (q === null ? ge = 33984 + B - 1 : ge = q);
        let Le = j[ge];
        Le === void 0 && (Le = {
            type: void 0,
            texture: void 0
        }, j[ge] = Le), (Le.type !== Q || Le.texture !== se) && (q !== ge && (r1.activeTexture(ge), q = ge), r1.bindTexture(Q, se || z[Q]), Le.type = Q, Le.texture = se);
    }
    function I() {
        let Q = j[q];
        Q !== void 0 && Q.type !== void 0 && (r1.bindTexture(Q.type, null), Q.type = void 0, Q.texture = void 0);
    }
    function ee() {
        try {
            r1.compressedTexImage2D.apply(r1, arguments);
        } catch (Q) {
            console.error("THREE.WebGLState:", Q);
        }
    }
    function pe() {
        try {
            r1.compressedTexImage3D.apply(r1, arguments);
        } catch (Q) {
            console.error("THREE.WebGLState:", Q);
        }
    }
    function xe() {
        try {
            r1.texSubImage2D.apply(r1, arguments);
        } catch (Q) {
            console.error("THREE.WebGLState:", Q);
        }
    }
    function Ce() {
        try {
            r1.texSubImage3D.apply(r1, arguments);
        } catch (Q) {
            console.error("THREE.WebGLState:", Q);
        }
    }
    function Ve() {
        try {
            r1.compressedTexSubImage2D.apply(r1, arguments);
        } catch (Q) {
            console.error("THREE.WebGLState:", Q);
        }
    }
    function Pe() {
        try {
            r1.compressedTexSubImage3D.apply(r1, arguments);
        } catch (Q) {
            console.error("THREE.WebGLState:", Q);
        }
    }
    function de() {
        try {
            r1.texStorage2D.apply(r1, arguments);
        } catch (Q) {
            console.error("THREE.WebGLState:", Q);
        }
    }
    function qe() {
        try {
            r1.texStorage3D.apply(r1, arguments);
        } catch (Q) {
            console.error("THREE.WebGLState:", Q);
        }
    }
    function Re() {
        try {
            r1.texImage2D.apply(r1, arguments);
        } catch (Q) {
            console.error("THREE.WebGLState:", Q);
        }
    }
    function De() {
        try {
            r1.texImage3D.apply(r1, arguments);
        } catch (Q) {
            console.error("THREE.WebGLState:", Q);
        }
    }
    function Ue(Q) {
        U.equals(Q) === !1 && (r1.scissor(Q.x, Q.y, Q.z, Q.w), U.copy(Q));
    }
    function Xe(Q) {
        G.equals(Q) === !1 && (r1.viewport(Q.x, Q.y, Q.z, Q.w), G.copy(Q));
    }
    function yt(Q, se) {
        let ge = d.get(se);
        ge === void 0 && (ge = new WeakMap, d.set(se, ge));
        let Le = ge.get(Q);
        Le === void 0 && (Le = r1.getUniformBlockIndex(se, Q.name), ge.set(Q, Le));
    }
    function zt(Q, se) {
        let Le = d.get(se).get(Q);
        c.get(se) !== Le && (r1.uniformBlockBinding(se, Le, Q.__bindingPointIndex), c.set(se, Le));
    }
    function Tn() {
        r1.disable(3042), r1.disable(2884), r1.disable(2929), r1.disable(32823), r1.disable(3089), r1.disable(2960), r1.disable(32926), r1.blendEquation(32774), r1.blendFunc(1, 0), r1.blendFuncSeparate(1, 0, 1, 0), r1.colorMask(!0, !0, !0, !0), r1.clearColor(0, 0, 0, 0), r1.depthMask(!0), r1.depthFunc(513), r1.clearDepth(1), r1.stencilMask(4294967295), r1.stencilFunc(519, 0, 4294967295), r1.stencilOp(7680, 7680, 7680), r1.clearStencil(0), r1.cullFace(1029), r1.frontFace(2305), r1.polygonOffset(0, 0), r1.activeTexture(33984), r1.bindFramebuffer(36160, null), n === !0 && (r1.bindFramebuffer(36009, null), r1.bindFramebuffer(36008, null)), r1.useProgram(null), r1.lineWidth(1), r1.scissor(0, 0, r1.canvas.width, r1.canvas.height), r1.viewport(0, 0, r1.canvas.width, r1.canvas.height), h = {}, q = null, j = {}, f = {}, m = new WeakMap, p = [], g = null, y = !1, v = null, x = null, w = null, S = null, _ = null, M = null, b = null, T = !1, E = null, P = null, D = null, C = null, O = null, U.set(0, 0, r1.canvas.width, r1.canvas.height), G.set(0, 0, r1.canvas.width, r1.canvas.height), a.reset(), l.reset(), u.reset();
    }
    return {
        buffers: {
            color: a,
            depth: l,
            stencil: u
        },
        enable: re,
        disable: K,
        bindFramebuffer: Z,
        drawBuffers: k,
        useProgram: he,
        setBlending: ye,
        setMaterial: Se,
        setFlipSided: ve,
        setCullFace: Te,
        setLineWidth: Ee,
        setPolygonOffset: we,
        setScissorTest: Ge,
        activeTexture: gt,
        bindTexture: R,
        unbindTexture: I,
        compressedTexImage2D: ee,
        compressedTexImage3D: pe,
        texImage2D: Re,
        texImage3D: De,
        updateUBOMapping: yt,
        uniformBlockBinding: zt,
        texStorage2D: de,
        texStorage3D: qe,
        texSubImage2D: xe,
        texSubImage3D: Ce,
        compressedTexSubImage2D: Ve,
        compressedTexSubImage3D: Pe,
        scissor: Ue,
        viewport: Xe,
        reset: Tn
    };
}
function PB(r1, t, e, n, i, s, o) {
    let a = i.isWebGL2, l = i.maxTextures, u = i.maxCubemapSize, c = i.maxTextureSize, d = i.maxSamples, h = t.has("WEBGL_multisampled_render_to_texture") ? t.get("WEBGL_multisampled_render_to_texture") : null, f = typeof navigator > "u" ? !1 : /OculusBrowser/g.test(navigator.userAgent), m = new WeakMap, p, g = new WeakMap, y = !1;
    try {
        y = typeof OffscreenCanvas < "u" && new OffscreenCanvas(1, 1).getContext("2d") !== null;
    } catch  {}
    function v(R, I) {
        return y ? new OffscreenCanvas(R, I) : Bp("canvas");
    }
    function x(R, I, ee, pe) {
        let xe = 1;
        if ((R.width > pe || R.height > pe) && (xe = pe / Math.max(R.width, R.height)), xe < 1 || I === !0) {
            if (typeof HTMLImageElement < "u" && R instanceof HTMLImageElement || typeof HTMLCanvasElement < "u" && R instanceof HTMLCanvasElement || typeof ImageBitmap < "u" && R instanceof ImageBitmap) {
                let Ce = I ? Np : Math.floor, Ve = Ce(xe * R.width), Pe = Ce(xe * R.height);
                p === void 0 && (p = v(Ve, Pe));
                let de = ee ? v(Ve, Pe) : p;
                return de.width = Ve, de.height = Pe, de.getContext("2d").drawImage(R, 0, 0, Ve, Pe), console.warn("THREE.WebGLRenderer: Texture has been resized from (" + R.width + "x" + R.height + ") to (" + Ve + "x" + Pe + ")."), de;
            } else return "data" in R && console.warn("THREE.WebGLRenderer: Image in DataTexture is too big (" + R.width + "x" + R.height + ")."), R;
        }
        return R;
    }
    function w(R) {
        return v0(R.width) && v0(R.height);
    }
    function S(R) {
        return a ? !1 : R.wrapS !== Gt || R.wrapT !== Gt || R.minFilter !== _t && R.minFilter !== Qe;
    }
    function _(R, I) {
        return R.generateMipmaps && I && R.minFilter !== _t && R.minFilter !== Qe;
    }
    function M(R) {
        r1.generateMipmap(R);
    }
    function b(R, I, ee, pe, xe = !1) {
        if (a === !1) return I;
        if (R !== null) {
            if (r1[R] !== void 0) return r1[R];
            console.warn("THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format '" + R + "'");
        }
        let Ce = I;
        return I === 6403 && (ee === 5126 && (Ce = 33326), ee === 5131 && (Ce = 33325), ee === 5121 && (Ce = 33321)), I === 33319 && (ee === 5126 && (Ce = 33328), ee === 5131 && (Ce = 33327), ee === 5121 && (Ce = 33323)), I === 6408 && (ee === 5126 && (Ce = 34836), ee === 5131 && (Ce = 34842), ee === 5121 && (Ce = pe === Ye && xe === !1 ? 35907 : 32856), ee === 32819 && (Ce = 32854), ee === 32820 && (Ce = 32855)), (Ce === 33325 || Ce === 33326 || Ce === 33327 || Ce === 33328 || Ce === 34842 || Ce === 34836) && t.get("EXT_color_buffer_float"), Ce;
    }
    function T(R, I, ee) {
        return _(R, ee) === !0 || R.isFramebufferTexture && R.minFilter !== _t && R.minFilter !== Qe ? Math.log2(Math.max(I.width, I.height)) + 1 : R.mipmaps !== void 0 && R.mipmaps.length > 0 ? R.mipmaps.length : R.isCompressedTexture && Array.isArray(R.image) ? I.mipmaps.length : 1;
    }
    function E(R) {
        return R === _t || R === KS || R === Pv ? 9728 : 9729;
    }
    function P(R) {
        let I = R.target;
        I.removeEventListener("dispose", P), C(I), I.isVideoTexture && m.delete(I);
    }
    function D(R) {
        let I = R.target;
        I.removeEventListener("dispose", D), B(I);
    }
    function C(R) {
        let I = n.get(R);
        if (I.__webglInit === void 0) return;
        let ee = R.source, pe = g.get(ee);
        if (pe) {
            let xe = pe[I.__cacheKey];
            xe.usedTimes--, xe.usedTimes === 0 && O(R), Object.keys(pe).length === 0 && g.delete(ee);
        }
        n.remove(R);
    }
    function O(R) {
        let I = n.get(R);
        r1.deleteTexture(I.__webglTexture);
        let ee = R.source, pe = g.get(ee);
        delete pe[I.__cacheKey], o.memory.textures--;
    }
    function B(R) {
        let I = R.texture, ee = n.get(R), pe = n.get(I);
        if (pe.__webglTexture !== void 0 && (r1.deleteTexture(pe.__webglTexture), o.memory.textures--), R.depthTexture && R.depthTexture.dispose(), R.isWebGLCubeRenderTarget) for(let xe = 0; xe < 6; xe++)r1.deleteFramebuffer(ee.__webglFramebuffer[xe]), ee.__webglDepthbuffer && r1.deleteRenderbuffer(ee.__webglDepthbuffer[xe]);
        else {
            if (r1.deleteFramebuffer(ee.__webglFramebuffer), ee.__webglDepthbuffer && r1.deleteRenderbuffer(ee.__webglDepthbuffer), ee.__webglMultisampledFramebuffer && r1.deleteFramebuffer(ee.__webglMultisampledFramebuffer), ee.__webglColorRenderbuffer) for(let xe = 0; xe < ee.__webglColorRenderbuffer.length; xe++)ee.__webglColorRenderbuffer[xe] && r1.deleteRenderbuffer(ee.__webglColorRenderbuffer[xe]);
            ee.__webglDepthRenderbuffer && r1.deleteRenderbuffer(ee.__webglDepthRenderbuffer);
        }
        if (R.isWebGLMultipleRenderTargets) for(let xe = 0, Ce = I.length; xe < Ce; xe++){
            let Ve = n.get(I[xe]);
            Ve.__webglTexture && (r1.deleteTexture(Ve.__webglTexture), o.memory.textures--), n.remove(I[xe]);
        }
        n.remove(I), n.remove(R);
    }
    let V = 0;
    function Y() {
        V = 0;
    }
    function W() {
        let R = V;
        return R >= l && console.warn("THREE.WebGLTextures: Trying to use " + R + " texture units while this GPU supports only " + l), V += 1, R;
    }
    function q(R) {
        let I = [];
        return I.push(R.wrapS), I.push(R.wrapT), I.push(R.wrapR || 0), I.push(R.magFilter), I.push(R.minFilter), I.push(R.anisotropy), I.push(R.internalFormat), I.push(R.format), I.push(R.type), I.push(R.generateMipmaps), I.push(R.premultiplyAlpha), I.push(R.flipY), I.push(R.unpackAlignment), I.push(R.encoding), I.join();
    }
    function j(R, I) {
        let ee = n.get(R);
        if (R.isVideoTexture && Ge(R), R.isRenderTargetTexture === !1 && R.version > 0 && ee.__version !== R.version) {
            let pe = R.image;
            if (pe === null) console.warn("THREE.WebGLRenderer: Texture marked for update but no image data found.");
            else if (pe.complete === !1) console.warn("THREE.WebGLRenderer: Texture marked for update but image is incomplete");
            else {
                K(ee, R, I);
                return;
            }
        }
        e.bindTexture(3553, ee.__webglTexture, 33984 + I);
    }
    function X(R, I) {
        let ee = n.get(R);
        if (R.version > 0 && ee.__version !== R.version) {
            K(ee, R, I);
            return;
        }
        e.bindTexture(35866, ee.__webglTexture, 33984 + I);
    }
    function L(R, I) {
        let ee = n.get(R);
        if (R.version > 0 && ee.__version !== R.version) {
            K(ee, R, I);
            return;
        }
        e.bindTexture(32879, ee.__webglTexture, 33984 + I);
    }
    function U(R, I) {
        let ee = n.get(R);
        if (R.version > 0 && ee.__version !== R.version) {
            Z(ee, R, I);
            return;
        }
        e.bindTexture(34067, ee.__webglTexture, 33984 + I);
    }
    let G = {
        [Bi]: 10497,
        [Gt]: 33071,
        [m0]: 33648
    }, H = {
        [_t]: 9728,
        [KS]: 9984,
        [Pv]: 9986,
        [Qe]: 9729,
        [vO]: 9985,
        [Va]: 9987
    };
    function z(R, I, ee) {
        if (ee ? (r1.texParameteri(R, 10242, G[I.wrapS]), r1.texParameteri(R, 10243, G[I.wrapT]), (R === 32879 || R === 35866) && r1.texParameteri(R, 32882, G[I.wrapR]), r1.texParameteri(R, 10240, H[I.magFilter]), r1.texParameteri(R, 10241, H[I.minFilter])) : (r1.texParameteri(R, 10242, 33071), r1.texParameteri(R, 10243, 33071), (R === 32879 || R === 35866) && r1.texParameteri(R, 32882, 33071), (I.wrapS !== Gt || I.wrapT !== Gt) && console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.wrapS and Texture.wrapT should be set to THREE.ClampToEdgeWrapping."), r1.texParameteri(R, 10240, E(I.magFilter)), r1.texParameteri(R, 10241, E(I.minFilter)), I.minFilter !== _t && I.minFilter !== Qe && console.warn("THREE.WebGLRenderer: Texture is not power of two. Texture.minFilter should be set to THREE.NearestFilter or THREE.LinearFilter.")), t.has("EXT_texture_filter_anisotropic") === !0) {
            let pe = t.get("EXT_texture_filter_anisotropic");
            if (I.magFilter === _t || I.minFilter !== Pv && I.minFilter !== Va || I.type === wr && t.has("OES_texture_float_linear") === !1 || a === !1 && I.type === Ha && t.has("OES_texture_half_float_linear") === !1) return;
            (I.anisotropy > 1 || n.get(I).__currentAnisotropy) && (r1.texParameterf(R, pe.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(I.anisotropy, i.getMaxAnisotropy())), n.get(I).__currentAnisotropy = I.anisotropy);
        }
    }
    function re(R, I) {
        let ee = !1;
        R.__webglInit === void 0 && (R.__webglInit = !0, I.addEventListener("dispose", P));
        let pe = I.source, xe = g.get(pe);
        xe === void 0 && (xe = {}, g.set(pe, xe));
        let Ce = q(I);
        if (Ce !== R.__cacheKey) {
            xe[Ce] === void 0 && (xe[Ce] = {
                texture: r1.createTexture(),
                usedTimes: 0
            }, o.memory.textures++, ee = !0), xe[Ce].usedTimes++;
            let Ve = xe[R.__cacheKey];
            Ve !== void 0 && (xe[R.__cacheKey].usedTimes--, Ve.usedTimes === 0 && O(I)), R.__cacheKey = Ce, R.__webglTexture = xe[Ce].texture;
        }
        return ee;
    }
    function K(R, I, ee) {
        let pe = 3553;
        (I.isDataArrayTexture || I.isCompressedArrayTexture) && (pe = 35866), I.isData3DTexture && (pe = 32879);
        let xe = re(R, I), Ce = I.source;
        e.bindTexture(pe, R.__webglTexture, 33984 + ee);
        let Ve = n.get(Ce);
        if (Ce.version !== Ve.__version || xe === !0) {
            e.activeTexture(33984 + ee), r1.pixelStorei(37440, I.flipY), r1.pixelStorei(37441, I.premultiplyAlpha), r1.pixelStorei(3317, I.unpackAlignment), r1.pixelStorei(37443, 0);
            let Pe = S(I) && w(I.image) === !1, de = x(I.image, Pe, !1, c);
            de = gt(I, de);
            let qe = w(de) || a, Re = s.convert(I.format, I.encoding), De = s.convert(I.type), Ue = b(I.internalFormat, Re, De, I.encoding, I.isVideoTexture);
            z(pe, I, qe);
            let Xe, yt = I.mipmaps, zt = a && I.isVideoTexture !== !0, Tn = Ve.__version === void 0 || xe === !0, Q = T(I, de, qe);
            if (I.isDepthTexture) Ue = 6402, a ? I.type === wr ? Ue = 36012 : I.type === no ? Ue = 33190 : I.type === Go ? Ue = 35056 : Ue = 33189 : I.type === wr && console.error("WebGLRenderer: Floating point depth texture requires WebGL2."), I.format === za && Ue === 6402 && I.type !== TA && I.type !== no && (console.warn("THREE.WebGLRenderer: Use UnsignedShortType or UnsignedIntType for DepthFormat DepthTexture."), I.type = no, De = s.convert(I.type)), I.format === Wo && Ue === 6402 && (Ue = 34041, I.type !== Go && (console.warn("THREE.WebGLRenderer: Use UnsignedInt248Type for DepthStencilFormat DepthTexture."), I.type = Go, De = s.convert(I.type))), Tn && (zt ? e.texStorage2D(3553, 1, Ue, de.width, de.height) : e.texImage2D(3553, 0, Ue, de.width, de.height, 0, Re, De, null));
            else if (I.isDataTexture) {
                if (yt.length > 0 && qe) {
                    zt && Tn && e.texStorage2D(3553, Q, Ue, yt[0].width, yt[0].height);
                    for(let se = 0, ge = yt.length; se < ge; se++)Xe = yt[se], zt ? e.texSubImage2D(3553, se, 0, 0, Xe.width, Xe.height, Re, De, Xe.data) : e.texImage2D(3553, se, Ue, Xe.width, Xe.height, 0, Re, De, Xe.data);
                    I.generateMipmaps = !1;
                } else zt ? (Tn && e.texStorage2D(3553, Q, Ue, de.width, de.height), e.texSubImage2D(3553, 0, 0, 0, de.width, de.height, Re, De, de.data)) : e.texImage2D(3553, 0, Ue, de.width, de.height, 0, Re, De, de.data);
            } else if (I.isCompressedTexture) {
                if (I.isCompressedArrayTexture) {
                    zt && Tn && e.texStorage3D(35866, Q, Ue, yt[0].width, yt[0].height, de.depth);
                    for(let se = 0, ge = yt.length; se < ge; se++)Xe = yt[se], I.format !== gi ? Re !== null ? zt ? e.compressedTexSubImage3D(35866, se, 0, 0, 0, Xe.width, Xe.height, de.depth, Re, Xe.data, 0, 0) : e.compressedTexImage3D(35866, se, Ue, Xe.width, Xe.height, de.depth, 0, Xe.data, 0, 0) : console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()") : zt ? e.texSubImage3D(35866, se, 0, 0, 0, Xe.width, Xe.height, de.depth, Re, De, Xe.data) : e.texImage3D(35866, se, Ue, Xe.width, Xe.height, de.depth, 0, Re, De, Xe.data);
                } else {
                    zt && Tn && e.texStorage2D(3553, Q, Ue, yt[0].width, yt[0].height);
                    for(let se = 0, ge = yt.length; se < ge; se++)Xe = yt[se], I.format !== gi ? Re !== null ? zt ? e.compressedTexSubImage2D(3553, se, 0, 0, Xe.width, Xe.height, Re, Xe.data) : e.compressedTexImage2D(3553, se, Ue, Xe.width, Xe.height, 0, Xe.data) : console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()") : zt ? e.texSubImage2D(3553, se, 0, 0, Xe.width, Xe.height, Re, De, Xe.data) : e.texImage2D(3553, se, Ue, Xe.width, Xe.height, 0, Re, De, Xe.data);
                }
            } else if (I.isDataArrayTexture) zt ? (Tn && e.texStorage3D(35866, Q, Ue, de.width, de.height, de.depth), e.texSubImage3D(35866, 0, 0, 0, 0, de.width, de.height, de.depth, Re, De, de.data)) : e.texImage3D(35866, 0, Ue, de.width, de.height, de.depth, 0, Re, De, de.data);
            else if (I.isData3DTexture) zt ? (Tn && e.texStorage3D(32879, Q, Ue, de.width, de.height, de.depth), e.texSubImage3D(32879, 0, 0, 0, 0, de.width, de.height, de.depth, Re, De, de.data)) : e.texImage3D(32879, 0, Ue, de.width, de.height, de.depth, 0, Re, De, de.data);
            else if (I.isFramebufferTexture) {
                if (Tn) {
                    if (zt) e.texStorage2D(3553, Q, Ue, de.width, de.height);
                    else {
                        let se = de.width, ge = de.height;
                        for(let Le = 0; Le < Q; Le++)e.texImage2D(3553, Le, Ue, se, ge, 0, Re, De, null), se >>= 1, ge >>= 1;
                    }
                }
            } else if (yt.length > 0 && qe) {
                zt && Tn && e.texStorage2D(3553, Q, Ue, yt[0].width, yt[0].height);
                for(let se = 0, ge = yt.length; se < ge; se++)Xe = yt[se], zt ? e.texSubImage2D(3553, se, 0, 0, Re, De, Xe) : e.texImage2D(3553, se, Ue, Re, De, Xe);
                I.generateMipmaps = !1;
            } else zt ? (Tn && e.texStorage2D(3553, Q, Ue, de.width, de.height), e.texSubImage2D(3553, 0, 0, 0, Re, De, de)) : e.texImage2D(3553, 0, Ue, Re, De, de);
            _(I, qe) && M(pe), Ve.__version = Ce.version, I.onUpdate && I.onUpdate(I);
        }
        R.__version = I.version;
    }
    function Z(R, I, ee) {
        if (I.image.length !== 6) return;
        let pe = re(R, I), xe = I.source;
        e.bindTexture(34067, R.__webglTexture, 33984 + ee);
        let Ce = n.get(xe);
        if (xe.version !== Ce.__version || pe === !0) {
            e.activeTexture(33984 + ee), r1.pixelStorei(37440, I.flipY), r1.pixelStorei(37441, I.premultiplyAlpha), r1.pixelStorei(3317, I.unpackAlignment), r1.pixelStorei(37443, 0);
            let Ve = I.isCompressedTexture || I.image[0].isCompressedTexture, Pe = I.image[0] && I.image[0].isDataTexture, de = [];
            for(let se = 0; se < 6; se++)!Ve && !Pe ? de[se] = x(I.image[se], !1, !0, u) : de[se] = Pe ? I.image[se].image : I.image[se], de[se] = gt(I, de[se]);
            let qe = de[0], Re = w(qe) || a, De = s.convert(I.format, I.encoding), Ue = s.convert(I.type), Xe = b(I.internalFormat, De, Ue, I.encoding), yt = a && I.isVideoTexture !== !0, zt = Ce.__version === void 0 || pe === !0, Tn = T(I, qe, Re);
            z(34067, I, Re);
            let Q;
            if (Ve) {
                yt && zt && e.texStorage2D(34067, Tn, Xe, qe.width, qe.height);
                for(let se = 0; se < 6; se++){
                    Q = de[se].mipmaps;
                    for(let ge = 0; ge < Q.length; ge++){
                        let Le = Q[ge];
                        I.format !== gi ? De !== null ? yt ? e.compressedTexSubImage2D(34069 + se, ge, 0, 0, Le.width, Le.height, De, Le.data) : e.compressedTexImage2D(34069 + se, ge, Xe, Le.width, Le.height, 0, Le.data) : console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()") : yt ? e.texSubImage2D(34069 + se, ge, 0, 0, Le.width, Le.height, De, Ue, Le.data) : e.texImage2D(34069 + se, ge, Xe, Le.width, Le.height, 0, De, Ue, Le.data);
                    }
                }
            } else {
                Q = I.mipmaps, yt && zt && (Q.length > 0 && Tn++, e.texStorage2D(34067, Tn, Xe, de[0].width, de[0].height));
                for(let se = 0; se < 6; se++)if (Pe) {
                    yt ? e.texSubImage2D(34069 + se, 0, 0, 0, de[se].width, de[se].height, De, Ue, de[se].data) : e.texImage2D(34069 + se, 0, Xe, de[se].width, de[se].height, 0, De, Ue, de[se].data);
                    for(let ge = 0; ge < Q.length; ge++){
                        let Oe = Q[ge].image[se].image;
                        yt ? e.texSubImage2D(34069 + se, ge + 1, 0, 0, Oe.width, Oe.height, De, Ue, Oe.data) : e.texImage2D(34069 + se, ge + 1, Xe, Oe.width, Oe.height, 0, De, Ue, Oe.data);
                    }
                } else {
                    yt ? e.texSubImage2D(34069 + se, 0, 0, 0, De, Ue, de[se]) : e.texImage2D(34069 + se, 0, Xe, De, Ue, de[se]);
                    for(let ge = 0; ge < Q.length; ge++){
                        let Le = Q[ge];
                        yt ? e.texSubImage2D(34069 + se, ge + 1, 0, 0, De, Ue, Le.image[se]) : e.texImage2D(34069 + se, ge + 1, Xe, De, Ue, Le.image[se]);
                    }
                }
            }
            _(I, Re) && M(34067), Ce.__version = xe.version, I.onUpdate && I.onUpdate(I);
        }
        R.__version = I.version;
    }
    function k(R, I, ee, pe, xe) {
        let Ce = s.convert(ee.format, ee.encoding), Ve = s.convert(ee.type), Pe = b(ee.internalFormat, Ce, Ve, ee.encoding);
        n.get(I).__hasExternalTextures || (xe === 32879 || xe === 35866 ? e.texImage3D(xe, 0, Pe, I.width, I.height, I.depth, 0, Ce, Ve, null) : e.texImage2D(xe, 0, Pe, I.width, I.height, 0, Ce, Ve, null)), e.bindFramebuffer(36160, R), we(I) ? h.framebufferTexture2DMultisampleEXT(36160, pe, xe, n.get(ee).__webglTexture, 0, Ee(I)) : (xe === 3553 || xe >= 34069 && xe <= 34074) && r1.framebufferTexture2D(36160, pe, xe, n.get(ee).__webglTexture, 0), e.bindFramebuffer(36160, null);
    }
    function he(R, I, ee) {
        if (r1.bindRenderbuffer(36161, R), I.depthBuffer && !I.stencilBuffer) {
            let pe = 33189;
            if (ee || we(I)) {
                let xe = I.depthTexture;
                xe && xe.isDepthTexture && (xe.type === wr ? pe = 36012 : xe.type === no && (pe = 33190));
                let Ce = Ee(I);
                we(I) ? h.renderbufferStorageMultisampleEXT(36161, Ce, pe, I.width, I.height) : r1.renderbufferStorageMultisample(36161, Ce, pe, I.width, I.height);
            } else r1.renderbufferStorage(36161, pe, I.width, I.height);
            r1.framebufferRenderbuffer(36160, 36096, 36161, R);
        } else if (I.depthBuffer && I.stencilBuffer) {
            let pe = Ee(I);
            ee && we(I) === !1 ? r1.renderbufferStorageMultisample(36161, pe, 35056, I.width, I.height) : we(I) ? h.renderbufferStorageMultisampleEXT(36161, pe, 35056, I.width, I.height) : r1.renderbufferStorage(36161, 34041, I.width, I.height), r1.framebufferRenderbuffer(36160, 33306, 36161, R);
        } else {
            let pe = I.isWebGLMultipleRenderTargets === !0 ? I.texture : [
                I.texture
            ];
            for(let xe = 0; xe < pe.length; xe++){
                let Ce = pe[xe], Ve = s.convert(Ce.format, Ce.encoding), Pe = s.convert(Ce.type), de = b(Ce.internalFormat, Ve, Pe, Ce.encoding), qe = Ee(I);
                ee && we(I) === !1 ? r1.renderbufferStorageMultisample(36161, qe, de, I.width, I.height) : we(I) ? h.renderbufferStorageMultisampleEXT(36161, qe, de, I.width, I.height) : r1.renderbufferStorage(36161, de, I.width, I.height);
            }
        }
        r1.bindRenderbuffer(36161, null);
    }
    function fe(R, I) {
        if (I && I.isWebGLCubeRenderTarget) throw new Error("Depth Texture with cube render targets is not supported");
        if (e.bindFramebuffer(36160, R), !(I.depthTexture && I.depthTexture.isDepthTexture)) throw new Error("renderTarget.depthTexture must be an instance of THREE.DepthTexture");
        (!n.get(I.depthTexture).__webglTexture || I.depthTexture.image.width !== I.width || I.depthTexture.image.height !== I.height) && (I.depthTexture.image.width = I.width, I.depthTexture.image.height = I.height, I.depthTexture.needsUpdate = !0), j(I.depthTexture, 0);
        let pe = n.get(I.depthTexture).__webglTexture, xe = Ee(I);
        if (I.depthTexture.format === za) we(I) ? h.framebufferTexture2DMultisampleEXT(36160, 36096, 3553, pe, 0, xe) : r1.framebufferTexture2D(36160, 36096, 3553, pe, 0);
        else if (I.depthTexture.format === Wo) we(I) ? h.framebufferTexture2DMultisampleEXT(36160, 33306, 3553, pe, 0, xe) : r1.framebufferTexture2D(36160, 33306, 3553, pe, 0);
        else throw new Error("Unknown depthTexture format");
    }
    function ce(R) {
        let I = n.get(R), ee = R.isWebGLCubeRenderTarget === !0;
        if (R.depthTexture && !I.__autoAllocateDepthBuffer) {
            if (ee) throw new Error("target.depthTexture not supported in Cube render targets");
            fe(I.__webglFramebuffer, R);
        } else if (ee) {
            I.__webglDepthbuffer = [];
            for(let pe = 0; pe < 6; pe++)e.bindFramebuffer(36160, I.__webglFramebuffer[pe]), I.__webglDepthbuffer[pe] = r1.createRenderbuffer(), he(I.__webglDepthbuffer[pe], R, !1);
        } else e.bindFramebuffer(36160, I.__webglFramebuffer), I.__webglDepthbuffer = r1.createRenderbuffer(), he(I.__webglDepthbuffer, R, !1);
        e.bindFramebuffer(36160, null);
    }
    function ye(R, I, ee) {
        let pe = n.get(R);
        I !== void 0 && k(pe.__webglFramebuffer, R, R.texture, 36064, 3553), ee !== void 0 && ce(R);
    }
    function Se(R) {
        let I = R.texture, ee = n.get(R), pe = n.get(I);
        R.addEventListener("dispose", D), R.isWebGLMultipleRenderTargets !== !0 && (pe.__webglTexture === void 0 && (pe.__webglTexture = r1.createTexture()), pe.__version = I.version, o.memory.textures++);
        let xe = R.isWebGLCubeRenderTarget === !0, Ce = R.isWebGLMultipleRenderTargets === !0, Ve = w(R) || a;
        if (xe) {
            ee.__webglFramebuffer = [];
            for(let Pe = 0; Pe < 6; Pe++)ee.__webglFramebuffer[Pe] = r1.createFramebuffer();
        } else {
            if (ee.__webglFramebuffer = r1.createFramebuffer(), Ce) {
                if (i.drawBuffers) {
                    let Pe = R.texture;
                    for(let de = 0, qe = Pe.length; de < qe; de++){
                        let Re = n.get(Pe[de]);
                        Re.__webglTexture === void 0 && (Re.__webglTexture = r1.createTexture(), o.memory.textures++);
                    }
                } else console.warn("THREE.WebGLRenderer: WebGLMultipleRenderTargets can only be used with WebGL2 or WEBGL_draw_buffers extension.");
            }
            if (a && R.samples > 0 && we(R) === !1) {
                let Pe = Ce ? I : [
                    I
                ];
                ee.__webglMultisampledFramebuffer = r1.createFramebuffer(), ee.__webglColorRenderbuffer = [], e.bindFramebuffer(36160, ee.__webglMultisampledFramebuffer);
                for(let de = 0; de < Pe.length; de++){
                    let qe = Pe[de];
                    ee.__webglColorRenderbuffer[de] = r1.createRenderbuffer(), r1.bindRenderbuffer(36161, ee.__webglColorRenderbuffer[de]);
                    let Re = s.convert(qe.format, qe.encoding), De = s.convert(qe.type), Ue = b(qe.internalFormat, Re, De, qe.encoding, R.isXRRenderTarget === !0), Xe = Ee(R);
                    r1.renderbufferStorageMultisample(36161, Xe, Ue, R.width, R.height), r1.framebufferRenderbuffer(36160, 36064 + de, 36161, ee.__webglColorRenderbuffer[de]);
                }
                r1.bindRenderbuffer(36161, null), R.depthBuffer && (ee.__webglDepthRenderbuffer = r1.createRenderbuffer(), he(ee.__webglDepthRenderbuffer, R, !0)), e.bindFramebuffer(36160, null);
            }
        }
        if (xe) {
            e.bindTexture(34067, pe.__webglTexture), z(34067, I, Ve);
            for(let Pe = 0; Pe < 6; Pe++)k(ee.__webglFramebuffer[Pe], R, I, 36064, 34069 + Pe);
            _(I, Ve) && M(34067), e.unbindTexture();
        } else if (Ce) {
            let Pe = R.texture;
            for(let de = 0, qe = Pe.length; de < qe; de++){
                let Re = Pe[de], De = n.get(Re);
                e.bindTexture(3553, De.__webglTexture), z(3553, Re, Ve), k(ee.__webglFramebuffer, R, Re, 36064 + de, 3553), _(Re, Ve) && M(3553);
            }
            e.unbindTexture();
        } else {
            let Pe = 3553;
            (R.isWebGL3DRenderTarget || R.isWebGLArrayRenderTarget) && (a ? Pe = R.isWebGL3DRenderTarget ? 32879 : 35866 : console.error("THREE.WebGLTextures: THREE.Data3DTexture and THREE.DataArrayTexture only supported with WebGL2.")), e.bindTexture(Pe, pe.__webglTexture), z(Pe, I, Ve), k(ee.__webglFramebuffer, R, I, 36064, Pe), _(I, Ve) && M(Pe), e.unbindTexture();
        }
        R.depthBuffer && ce(R);
    }
    function ve(R) {
        let I = w(R) || a, ee = R.isWebGLMultipleRenderTargets === !0 ? R.texture : [
            R.texture
        ];
        for(let pe = 0, xe = ee.length; pe < xe; pe++){
            let Ce = ee[pe];
            if (_(Ce, I)) {
                let Ve = R.isWebGLCubeRenderTarget ? 34067 : 3553, Pe = n.get(Ce).__webglTexture;
                e.bindTexture(Ve, Pe), M(Ve), e.unbindTexture();
            }
        }
    }
    function Te(R) {
        if (a && R.samples > 0 && we(R) === !1) {
            let I = R.isWebGLMultipleRenderTargets ? R.texture : [
                R.texture
            ], ee = R.width, pe = R.height, xe = 16384, Ce = [], Ve = R.stencilBuffer ? 33306 : 36096, Pe = n.get(R), de = R.isWebGLMultipleRenderTargets === !0;
            if (de) for(let qe = 0; qe < I.length; qe++)e.bindFramebuffer(36160, Pe.__webglMultisampledFramebuffer), r1.framebufferRenderbuffer(36160, 36064 + qe, 36161, null), e.bindFramebuffer(36160, Pe.__webglFramebuffer), r1.framebufferTexture2D(36009, 36064 + qe, 3553, null, 0);
            e.bindFramebuffer(36008, Pe.__webglMultisampledFramebuffer), e.bindFramebuffer(36009, Pe.__webglFramebuffer);
            for(let qe = 0; qe < I.length; qe++){
                Ce.push(36064 + qe), R.depthBuffer && Ce.push(Ve);
                let Re = Pe.__ignoreDepthValues !== void 0 ? Pe.__ignoreDepthValues : !1;
                if (Re === !1 && (R.depthBuffer && (xe |= 256), R.stencilBuffer && (xe |= 1024)), de && r1.framebufferRenderbuffer(36008, 36064, 36161, Pe.__webglColorRenderbuffer[qe]), Re === !0 && (r1.invalidateFramebuffer(36008, [
                    Ve
                ]), r1.invalidateFramebuffer(36009, [
                    Ve
                ])), de) {
                    let De = n.get(I[qe]).__webglTexture;
                    r1.framebufferTexture2D(36009, 36064, 3553, De, 0);
                }
                r1.blitFramebuffer(0, 0, ee, pe, 0, 0, ee, pe, xe, 9728), f && r1.invalidateFramebuffer(36008, Ce);
            }
            if (e.bindFramebuffer(36008, null), e.bindFramebuffer(36009, null), de) for(let qe = 0; qe < I.length; qe++){
                e.bindFramebuffer(36160, Pe.__webglMultisampledFramebuffer), r1.framebufferRenderbuffer(36160, 36064 + qe, 36161, Pe.__webglColorRenderbuffer[qe]);
                let Re = n.get(I[qe]).__webglTexture;
                e.bindFramebuffer(36160, Pe.__webglFramebuffer), r1.framebufferTexture2D(36009, 36064 + qe, 3553, Re, 0);
            }
            e.bindFramebuffer(36009, Pe.__webglMultisampledFramebuffer);
        }
    }
    function Ee(R) {
        return Math.min(d, R.samples);
    }
    function we(R) {
        let I = n.get(R);
        return a && R.samples > 0 && t.has("WEBGL_multisampled_render_to_texture") === !0 && I.__useRenderToTexture !== !1;
    }
    function Ge(R) {
        let I = o.render.frame;
        m.get(R) !== I && (m.set(R, I), R.update());
    }
    function gt(R, I) {
        let ee = R.encoding, pe = R.format, xe = R.type;
        return R.isCompressedTexture === !0 || R.isVideoTexture === !0 || R.format === y0 || ee !== oi && (ee === Ye ? a === !1 ? t.has("EXT_sRGB") === !0 && pe === gi ? (R.format = y0, R.minFilter = Qe, R.generateMipmaps = !1) : I = Fp.sRGBToLinear(I) : (pe !== gi || xe !== qt) && console.warn("THREE.WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.") : console.error("THREE.WebGLTextures: Unsupported texture encoding:", ee)), I;
    }
    this.allocateTextureUnit = W, this.resetTextureUnits = Y, this.setTexture2D = j, this.setTexture2DArray = X, this.setTexture3D = L, this.setTextureCube = U, this.rebindTextures = ye, this.setupRenderTarget = Se, this.updateRenderTargetMipmap = ve, this.updateMultisampleRenderTarget = Te, this.setupDepthRenderbuffer = ce, this.setupFrameBufferTexture = k, this.useMultisampledRTT = we;
}
function DB(r2, t, e) {
    let n = e.isWebGL2;
    function i(s, o = null) {
        let a;
        if (s === qt) return 5121;
        if (s === SO) return 32819;
        if (s === AO) return 32820;
        if (s === xO) return 5120;
        if (s === bO) return 5122;
        if (s === TA) return 5123;
        if (s === wO) return 5124;
        if (s === no) return 5125;
        if (s === wr) return 5126;
        if (s === Ha) return n ? 5131 : (a = t.get("OES_texture_half_float"), a !== null ? a.HALF_FLOAT_OES : null);
        if (s === _O) return 6406;
        if (s === gi) return 6408;
        if (s === MO) return 6409;
        if (s === TO) return 6410;
        if (s === za) return 6402;
        if (s === Wo) return 34041;
        if (s === y0) return a = t.get("EXT_sRGB"), a !== null ? a.SRGB_ALPHA_EXT : null;
        if (s === EO) return 6403;
        if (s === CO) return 36244;
        if (s === Z0) return 33319;
        if (s === PO) return 33320;
        if (s === DO) return 36249;
        if (s === Dv || s === Iv || s === Ov || s === Rv) {
            if (o === Ye) {
                if (a = t.get("WEBGL_compressed_texture_s3tc_srgb"), a !== null) {
                    if (s === Dv) return a.COMPRESSED_SRGB_S3TC_DXT1_EXT;
                    if (s === Iv) return a.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
                    if (s === Ov) return a.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
                    if (s === Rv) return a.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
                } else return null;
            } else if (a = t.get("WEBGL_compressed_texture_s3tc"), a !== null) {
                if (s === Dv) return a.COMPRESSED_RGB_S3TC_DXT1_EXT;
                if (s === Iv) return a.COMPRESSED_RGBA_S3TC_DXT1_EXT;
                if (s === Ov) return a.COMPRESSED_RGBA_S3TC_DXT3_EXT;
                if (s === Rv) return a.COMPRESSED_RGBA_S3TC_DXT5_EXT;
            } else return null;
        }
        if (s === ZS || s === JS || s === $S || s === e1) {
            if (a = t.get("WEBGL_compressed_texture_pvrtc"), a !== null) {
                if (s === ZS) return a.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
                if (s === JS) return a.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
                if (s === $S) return a.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
                if (s === e1) return a.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
            } else return null;
        }
        if (s === IO) return a = t.get("WEBGL_compressed_texture_etc1"), a !== null ? a.COMPRESSED_RGB_ETC1_WEBGL : null;
        if (s === t1 || s === n1) {
            if (a = t.get("WEBGL_compressed_texture_etc"), a !== null) {
                if (s === t1) return o === Ye ? a.COMPRESSED_SRGB8_ETC2 : a.COMPRESSED_RGB8_ETC2;
                if (s === n1) return o === Ye ? a.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : a.COMPRESSED_RGBA8_ETC2_EAC;
            } else return null;
        }
        if (s === r1 || s === i1 || s === s1 || s === o1 || s === a1 || s === l1 || s === c1 || s === u1 || s === d1 || s === h1 || s === f1 || s === p1 || s === m1 || s === g1) {
            if (a = t.get("WEBGL_compressed_texture_astc"), a !== null) {
                if (s === r1) return o === Ye ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : a.COMPRESSED_RGBA_ASTC_4x4_KHR;
                if (s === i1) return o === Ye ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : a.COMPRESSED_RGBA_ASTC_5x4_KHR;
                if (s === s1) return o === Ye ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : a.COMPRESSED_RGBA_ASTC_5x5_KHR;
                if (s === o1) return o === Ye ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : a.COMPRESSED_RGBA_ASTC_6x5_KHR;
                if (s === a1) return o === Ye ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : a.COMPRESSED_RGBA_ASTC_6x6_KHR;
                if (s === l1) return o === Ye ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : a.COMPRESSED_RGBA_ASTC_8x5_KHR;
                if (s === c1) return o === Ye ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : a.COMPRESSED_RGBA_ASTC_8x6_KHR;
                if (s === u1) return o === Ye ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : a.COMPRESSED_RGBA_ASTC_8x8_KHR;
                if (s === d1) return o === Ye ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : a.COMPRESSED_RGBA_ASTC_10x5_KHR;
                if (s === h1) return o === Ye ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : a.COMPRESSED_RGBA_ASTC_10x6_KHR;
                if (s === f1) return o === Ye ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : a.COMPRESSED_RGBA_ASTC_10x8_KHR;
                if (s === p1) return o === Ye ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : a.COMPRESSED_RGBA_ASTC_10x10_KHR;
                if (s === m1) return o === Ye ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : a.COMPRESSED_RGBA_ASTC_12x10_KHR;
                if (s === g1) return o === Ye ? a.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : a.COMPRESSED_RGBA_ASTC_12x12_KHR;
            } else return null;
        }
        if (s === Lv) {
            if (a = t.get("EXT_texture_compression_bptc"), a !== null) {
                if (s === Lv) return o === Ye ? a.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : a.COMPRESSED_RGBA_BPTC_UNORM_EXT;
            } else return null;
        }
        if (s === OO || s === y1 || s === v1 || s === x1) {
            if (a = t.get("EXT_texture_compression_rgtc"), a !== null) {
                if (s === Lv) return a.COMPRESSED_RED_RGTC1_EXT;
                if (s === y1) return a.COMPRESSED_SIGNED_RED_RGTC1_EXT;
                if (s === v1) return a.COMPRESSED_RED_GREEN_RGTC2_EXT;
                if (s === x1) return a.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT;
            } else return null;
        }
        return s === Go ? n ? 34042 : (a = t.get("WEBGL_depth_texture"), a !== null ? a.UNSIGNED_INT_24_8_WEBGL : null) : r2[s] !== void 0 ? r2[s] : null;
    }
    return {
        convert: i
    };
}
var C0 = class extends gn {
    constructor(t = []){
        super(), this.isArrayCamera = !0, this.cameras = t;
    }
}, ms = class extends pt {
    constructor(){
        super(), this.isGroup = !0, this.type = "Group";
    }
}, IB = {
    type: "move"
}, dh = class {
    constructor(){
        this._targetRay = null, this._grip = null, this._hand = null;
    }
    getHandSpace() {
        return this._hand === null && (this._hand = new ms, this._hand.matrixAutoUpdate = !1, this._hand.visible = !1, this._hand.joints = {}, this._hand.inputState = {
            pinching: !1
        }), this._hand;
    }
    getTargetRaySpace() {
        return this._targetRay === null && (this._targetRay = new ms, this._targetRay.matrixAutoUpdate = !1, this._targetRay.visible = !1, this._targetRay.hasLinearVelocity = !1, this._targetRay.linearVelocity = new A, this._targetRay.hasAngularVelocity = !1, this._targetRay.angularVelocity = new A), this._targetRay;
    }
    getGripSpace() {
        return this._grip === null && (this._grip = new ms, this._grip.matrixAutoUpdate = !1, this._grip.visible = !1, this._grip.hasLinearVelocity = !1, this._grip.linearVelocity = new A, this._grip.hasAngularVelocity = !1, this._grip.angularVelocity = new A), this._grip;
    }
    dispatchEvent(t) {
        return this._targetRay !== null && this._targetRay.dispatchEvent(t), this._grip !== null && this._grip.dispatchEvent(t), this._hand !== null && this._hand.dispatchEvent(t), this;
    }
    connect(t) {
        if (t && t.hand) {
            let e = this._hand;
            if (e) for (let n of t.hand.values())this._getHandJoint(e, n);
        }
        return this.dispatchEvent({
            type: "connected",
            data: t
        }), this;
    }
    disconnect(t) {
        return this.dispatchEvent({
            type: "disconnected",
            data: t
        }), this._targetRay !== null && (this._targetRay.visible = !1), this._grip !== null && (this._grip.visible = !1), this._hand !== null && (this._hand.visible = !1), this;
    }
    update(t, e, n) {
        let i = null, s = null, o = null, a = this._targetRay, l = this._grip, u = this._hand;
        if (t && e.session.visibilityState !== "visible-blurred") {
            if (u && t.hand) {
                o = !0;
                for (let p of t.hand.values()){
                    let g = e.getJointPose(p, n), y = this._getHandJoint(u, p);
                    g !== null && (y.matrix.fromArray(g.transform.matrix), y.matrix.decompose(y.position, y.rotation, y.scale), y.jointRadius = g.radius), y.visible = g !== null;
                }
                let c = u.joints["index-finger-tip"], d = u.joints["thumb-tip"], h = c.position.distanceTo(d.position), f = .02, m = .005;
                u.inputState.pinching && h > f + m ? (u.inputState.pinching = !1, this.dispatchEvent({
                    type: "pinchend",
                    handedness: t.handedness,
                    target: this
                })) : !u.inputState.pinching && h <= f - m && (u.inputState.pinching = !0, this.dispatchEvent({
                    type: "pinchstart",
                    handedness: t.handedness,
                    target: this
                }));
            } else l !== null && t.gripSpace && (s = e.getPose(t.gripSpace, n), s !== null && (l.matrix.fromArray(s.transform.matrix), l.matrix.decompose(l.position, l.rotation, l.scale), s.linearVelocity ? (l.hasLinearVelocity = !0, l.linearVelocity.copy(s.linearVelocity)) : l.hasLinearVelocity = !1, s.angularVelocity ? (l.hasAngularVelocity = !0, l.angularVelocity.copy(s.angularVelocity)) : l.hasAngularVelocity = !1));
            a !== null && (i = e.getPose(t.targetRaySpace, n), i === null && s !== null && (i = s), i !== null && (a.matrix.fromArray(i.transform.matrix), a.matrix.decompose(a.position, a.rotation, a.scale), i.linearVelocity ? (a.hasLinearVelocity = !0, a.linearVelocity.copy(i.linearVelocity)) : a.hasLinearVelocity = !1, i.angularVelocity ? (a.hasAngularVelocity = !0, a.angularVelocity.copy(i.angularVelocity)) : a.hasAngularVelocity = !1, this.dispatchEvent(IB)));
        }
        return a !== null && (a.visible = i !== null), l !== null && (l.visible = s !== null), u !== null && (u.visible = o !== null), this;
    }
    _getHandJoint(t, e) {
        if (t.joints[e.jointName] === void 0) {
            let n = new ms;
            n.matrixAutoUpdate = !1, n.visible = !1, t.joints[e.jointName] = n, t.add(n);
        }
        return t.joints[e.jointName];
    }
}, yi = class extends Vt {
    constructor(t, e, n, i, s, o, a, l, u, c){
        if (c = c !== void 0 ? c : za, c !== za && c !== Wo) throw new Error("DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat");
        n === void 0 && c === za && (n = no), n === void 0 && c === Wo && (n = Go), super(null, i, s, o, a, l, c, n, u), this.isDepthTexture = !0, this.image = {
            width: t,
            height: e
        }, this.magFilter = a !== void 0 ? a : _t, this.minFilter = l !== void 0 ? l : _t, this.flipY = !1, this.generateMipmaps = !1;
    }
}, P0 = class extends Ht {
    constructor(t, e){
        super();
        let n = this, i = null, s = 1, o = null, a = "local-floor", l = 1, u = null, c = null, d = null, h = null, f = null, m = null, p = e.getContextAttributes(), g = null, y = null, v = [], x = [], w = new Set, S = new Map, _ = new gn;
        _.layers.enable(1), _.viewport = new Ze;
        let M = new gn;
        M.layers.enable(2), M.viewport = new Ze;
        let b = [
            _,
            M
        ], T = new C0;
        T.layers.enable(1), T.layers.enable(2);
        let E = null, P = null;
        this.cameraAutoUpdate = !0, this.enabled = !1, this.isPresenting = !1, this.getController = function(L) {
            let U = v[L];
            return U === void 0 && (U = new dh, v[L] = U), U.getTargetRaySpace();
        }, this.getControllerGrip = function(L) {
            let U = v[L];
            return U === void 0 && (U = new dh, v[L] = U), U.getGripSpace();
        }, this.getHand = function(L) {
            let U = v[L];
            return U === void 0 && (U = new dh, v[L] = U), U.getHandSpace();
        };
        function D(L) {
            let U = x.indexOf(L.inputSource);
            if (U === -1) return;
            let G = v[U];
            G !== void 0 && G.dispatchEvent({
                type: L.type,
                data: L.inputSource
            });
        }
        function C() {
            i.removeEventListener("select", D), i.removeEventListener("selectstart", D), i.removeEventListener("selectend", D), i.removeEventListener("squeeze", D), i.removeEventListener("squeezestart", D), i.removeEventListener("squeezeend", D), i.removeEventListener("end", C), i.removeEventListener("inputsourceschange", O);
            for(let L = 0; L < v.length; L++){
                let U = x[L];
                U !== null && (x[L] = null, v[L].disconnect(U));
            }
            E = null, P = null, t.setRenderTarget(g), f = null, h = null, d = null, i = null, y = null, X.stop(), n.isPresenting = !1, n.dispatchEvent({
                type: "sessionend"
            });
        }
        this.setFramebufferScaleFactor = function(L) {
            s = L, n.isPresenting === !0 && console.warn("THREE.WebXRManager: Cannot change framebuffer scale while presenting.");
        }, this.setReferenceSpaceType = function(L) {
            a = L, n.isPresenting === !0 && console.warn("THREE.WebXRManager: Cannot change reference space type while presenting.");
        }, this.getReferenceSpace = function() {
            return u || o;
        }, this.setReferenceSpace = function(L) {
            u = L;
        }, this.getBaseLayer = function() {
            return h !== null ? h : f;
        }, this.getBinding = function() {
            return d;
        }, this.getFrame = function() {
            return m;
        }, this.getSession = function() {
            return i;
        }, this.setSession = async function(L) {
            if (i = L, i !== null) {
                if (g = t.getRenderTarget(), i.addEventListener("select", D), i.addEventListener("selectstart", D), i.addEventListener("selectend", D), i.addEventListener("squeeze", D), i.addEventListener("squeezestart", D), i.addEventListener("squeezeend", D), i.addEventListener("end", C), i.addEventListener("inputsourceschange", O), p.xrCompatible !== !0 && await e.makeXRCompatible(), i.renderState.layers === void 0 || t.capabilities.isWebGL2 === !1) {
                    let U = {
                        antialias: i.renderState.layers === void 0 ? p.antialias : !0,
                        alpha: p.alpha,
                        depth: p.depth,
                        stencil: p.stencil,
                        framebufferScaleFactor: s
                    };
                    f = new XRWebGLLayer(i, e, U), i.updateRenderState({
                        baseLayer: f
                    }), y = new st(f.framebufferWidth, f.framebufferHeight, {
                        format: gi,
                        type: qt,
                        encoding: t.outputEncoding,
                        stencilBuffer: p.stencil
                    });
                } else {
                    let U = null, G = null, H = null;
                    p.depth && (H = p.stencil ? 35056 : 33190, U = p.stencil ? Wo : za, G = p.stencil ? Go : no);
                    let z = {
                        colorFormat: 32856,
                        depthFormat: H,
                        scaleFactor: s
                    };
                    d = new XRWebGLBinding(i, e), h = d.createProjectionLayer(z), i.updateRenderState({
                        layers: [
                            h
                        ]
                    }), y = new st(h.textureWidth, h.textureHeight, {
                        format: gi,
                        type: qt,
                        depthTexture: new yi(h.textureWidth, h.textureHeight, G, void 0, void 0, void 0, void 0, void 0, void 0, U),
                        stencilBuffer: p.stencil,
                        encoding: t.outputEncoding,
                        samples: p.antialias ? 4 : 0
                    });
                    let re = t.properties.get(y);
                    re.__ignoreDepthValues = h.ignoreDepthValues;
                }
                y.isXRRenderTarget = !0, this.setFoveation(l), u = null, o = await i.requestReferenceSpace(a), X.setContext(i), X.start(), n.isPresenting = !0, n.dispatchEvent({
                    type: "sessionstart"
                });
            }
        };
        function O(L) {
            for(let U = 0; U < L.removed.length; U++){
                let G = L.removed[U], H = x.indexOf(G);
                H >= 0 && (x[H] = null, v[H].disconnect(G));
            }
            for(let U = 0; U < L.added.length; U++){
                let G = L.added[U], H = x.indexOf(G);
                if (H === -1) {
                    for(let re = 0; re < v.length; re++)if (re >= x.length) {
                        x.push(G), H = re;
                        break;
                    } else if (x[re] === null) {
                        x[re] = G, H = re;
                        break;
                    }
                    if (H === -1) break;
                }
                let z = v[H];
                z && z.connect(G);
            }
        }
        let B = new A, V = new A;
        function Y(L, U, G) {
            B.setFromMatrixPosition(U.matrixWorld), V.setFromMatrixPosition(G.matrixWorld);
            let H = B.distanceTo(V), z = U.projectionMatrix.elements, re = G.projectionMatrix.elements, K = z[14] / (z[10] - 1), Z = z[14] / (z[10] + 1), k = (z[9] + 1) / z[5], he = (z[9] - 1) / z[5], fe = (z[8] - 1) / z[0], ce = (re[8] + 1) / re[0], ye = K * fe, Se = K * ce, ve = H / (-fe + ce), Te = ve * -fe;
            U.matrixWorld.decompose(L.position, L.quaternion, L.scale), L.translateX(Te), L.translateZ(ve), L.matrixWorld.compose(L.position, L.quaternion, L.scale), L.matrixWorldInverse.copy(L.matrixWorld).invert();
            let Ee = K + ve, we = Z + ve, Ge = ye - Te, gt = Se + (H - Te), R = k * Z / we * Ee, I = he * Z / we * Ee;
            L.projectionMatrix.makePerspective(Ge, gt, R, I, Ee, we);
        }
        function W(L, U) {
            U === null ? L.matrixWorld.copy(L.matrix) : L.matrixWorld.multiplyMatrices(U.matrixWorld, L.matrix), L.matrixWorldInverse.copy(L.matrixWorld).invert();
        }
        this.updateCamera = function(L) {
            if (i === null) return;
            T.near = M.near = _.near = L.near, T.far = M.far = _.far = L.far, (E !== T.near || P !== T.far) && (i.updateRenderState({
                depthNear: T.near,
                depthFar: T.far
            }), E = T.near, P = T.far);
            let U = L.parent, G = T.cameras;
            W(T, U);
            for(let z = 0; z < G.length; z++)W(G[z], U);
            T.matrixWorld.decompose(T.position, T.quaternion, T.scale), L.matrix.copy(T.matrix), L.matrix.decompose(L.position, L.quaternion, L.scale);
            let H = L.children;
            for(let z = 0, re = H.length; z < re; z++)H[z].updateMatrixWorld(!0);
            G.length === 2 ? Y(T, _, M) : T.projectionMatrix.copy(_.projectionMatrix);
        }, this.getCamera = function() {
            return T;
        }, this.getFoveation = function() {
            if (!(h === null && f === null)) return l;
        }, this.setFoveation = function(L) {
            l = L, h !== null && (h.fixedFoveation = L), f !== null && f.fixedFoveation !== void 0 && (f.fixedFoveation = L);
        }, this.getPlanes = function() {
            return w;
        };
        let q = null;
        function j(L, U) {
            if (c = U.getViewerPose(u || o), m = U, c !== null) {
                let G = c.views;
                f !== null && (t.setRenderTargetFramebuffer(y, f.framebuffer), t.setRenderTarget(y));
                let H = !1;
                G.length !== T.cameras.length && (T.cameras.length = 0, H = !0);
                for(let z = 0; z < G.length; z++){
                    let re = G[z], K = null;
                    if (f !== null) K = f.getViewport(re);
                    else {
                        let k = d.getViewSubImage(h, re);
                        K = k.viewport, z === 0 && (t.setRenderTargetTextures(y, k.colorTexture, h.ignoreDepthValues ? void 0 : k.depthStencilTexture), t.setRenderTarget(y));
                    }
                    let Z = b[z];
                    Z === void 0 && (Z = new gn, Z.layers.enable(z), Z.viewport = new Ze, b[z] = Z), Z.matrix.fromArray(re.transform.matrix), Z.projectionMatrix.fromArray(re.projectionMatrix), Z.viewport.set(K.x, K.y, K.width, K.height), z === 0 && T.matrix.copy(Z.matrix), H === !0 && T.cameras.push(Z);
                }
            }
            for(let G = 0; G < v.length; G++){
                let H = x[G], z = v[G];
                H !== null && z !== void 0 && z.update(H, U, u || o);
            }
            if (q && q(L, U), U.detectedPlanes) {
                n.dispatchEvent({
                    type: "planesdetected",
                    data: U.detectedPlanes
                });
                let G = null;
                for (let H of w)U.detectedPlanes.has(H) || (G === null && (G = []), G.push(H));
                if (G !== null) for (let H of G)w.delete(H), S.delete(H), n.dispatchEvent({
                    type: "planeremoved",
                    data: H
                });
                for (let H of U.detectedPlanes)if (!w.has(H)) w.add(H), S.set(H, U.lastChangedTime), n.dispatchEvent({
                    type: "planeadded",
                    data: H
                });
                else {
                    let z = S.get(H);
                    H.lastChangedTime > z && (S.set(H, H.lastChangedTime), n.dispatchEvent({
                        type: "planechanged",
                        data: H
                    }));
                }
            }
            m = null;
        }
        let X = new DA;
        X.setAnimationLoop(j), this.setAnimationLoop = function(L) {
            q = L;
        }, this.dispose = function() {};
    }
};
function OB(r1, t) {
    function e(p, g) {
        g.color.getRGB(p.fogColor.value, PA(r1)), g.isFog ? (p.fogNear.value = g.near, p.fogFar.value = g.far) : g.isFogExp2 && (p.fogDensity.value = g.density);
    }
    function n(p, g, y, v, x) {
        g.isMeshBasicMaterial || g.isMeshLambertMaterial ? i(p, g) : g.isMeshToonMaterial ? (i(p, g), c(p, g)) : g.isMeshPhongMaterial ? (i(p, g), u(p, g)) : g.isMeshStandardMaterial ? (i(p, g), d(p, g), g.isMeshPhysicalMaterial && h(p, g, x)) : g.isMeshMatcapMaterial ? (i(p, g), f(p, g)) : g.isMeshDepthMaterial ? i(p, g) : g.isMeshDistanceMaterial ? (i(p, g), m(p, g)) : g.isMeshNormalMaterial ? i(p, g) : g.isLineBasicMaterial ? (s(p, g), g.isLineDashedMaterial && o(p, g)) : g.isPointsMaterial ? a(p, g, y, v) : g.isSpriteMaterial ? l(p, g) : g.isShadowMaterial ? (p.color.value.copy(g.color), p.opacity.value = g.opacity) : g.isShaderMaterial && (g.uniformsNeedUpdate = !1);
    }
    function i(p, g) {
        p.opacity.value = g.opacity, g.color && p.diffuse.value.copy(g.color), g.emissive && p.emissive.value.copy(g.emissive).multiplyScalar(g.emissiveIntensity), g.map && (p.map.value = g.map), g.alphaMap && (p.alphaMap.value = g.alphaMap), g.bumpMap && (p.bumpMap.value = g.bumpMap, p.bumpScale.value = g.bumpScale, g.side === On && (p.bumpScale.value *= -1)), g.displacementMap && (p.displacementMap.value = g.displacementMap, p.displacementScale.value = g.displacementScale, p.displacementBias.value = g.displacementBias), g.emissiveMap && (p.emissiveMap.value = g.emissiveMap), g.normalMap && (p.normalMap.value = g.normalMap, p.normalScale.value.copy(g.normalScale), g.side === On && p.normalScale.value.negate()), g.specularMap && (p.specularMap.value = g.specularMap), g.alphaTest > 0 && (p.alphaTest.value = g.alphaTest);
        let y = t.get(g).envMap;
        if (y && (p.envMap.value = y, p.flipEnvMap.value = y.isCubeTexture && y.isRenderTargetTexture === !1 ? -1 : 1, p.reflectivity.value = g.reflectivity, p.ior.value = g.ior, p.refractionRatio.value = g.refractionRatio), g.lightMap) {
            p.lightMap.value = g.lightMap;
            let w = r1.physicallyCorrectLights !== !0 ? Math.PI : 1;
            p.lightMapIntensity.value = g.lightMapIntensity * w;
        }
        g.aoMap && (p.aoMap.value = g.aoMap, p.aoMapIntensity.value = g.aoMapIntensity);
        let v;
        g.map ? v = g.map : g.specularMap ? v = g.specularMap : g.displacementMap ? v = g.displacementMap : g.normalMap ? v = g.normalMap : g.bumpMap ? v = g.bumpMap : g.roughnessMap ? v = g.roughnessMap : g.metalnessMap ? v = g.metalnessMap : g.alphaMap ? v = g.alphaMap : g.emissiveMap ? v = g.emissiveMap : g.clearcoatMap ? v = g.clearcoatMap : g.clearcoatNormalMap ? v = g.clearcoatNormalMap : g.clearcoatRoughnessMap ? v = g.clearcoatRoughnessMap : g.iridescenceMap ? v = g.iridescenceMap : g.iridescenceThicknessMap ? v = g.iridescenceThicknessMap : g.specularIntensityMap ? v = g.specularIntensityMap : g.specularColorMap ? v = g.specularColorMap : g.transmissionMap ? v = g.transmissionMap : g.thicknessMap ? v = g.thicknessMap : g.sheenColorMap ? v = g.sheenColorMap : g.sheenRoughnessMap && (v = g.sheenRoughnessMap), v !== void 0 && (v.isWebGLRenderTarget && (v = v.texture), v.matrixAutoUpdate === !0 && v.updateMatrix(), p.uvTransform.value.copy(v.matrix));
        let x;
        g.aoMap ? x = g.aoMap : g.lightMap && (x = g.lightMap), x !== void 0 && (x.isWebGLRenderTarget && (x = x.texture), x.matrixAutoUpdate === !0 && x.updateMatrix(), p.uv2Transform.value.copy(x.matrix));
    }
    function s(p, g) {
        p.diffuse.value.copy(g.color), p.opacity.value = g.opacity;
    }
    function o(p, g) {
        p.dashSize.value = g.dashSize, p.totalSize.value = g.dashSize + g.gapSize, p.scale.value = g.scale;
    }
    function a(p, g, y, v) {
        p.diffuse.value.copy(g.color), p.opacity.value = g.opacity, p.size.value = g.size * y, p.scale.value = v * .5, g.map && (p.map.value = g.map), g.alphaMap && (p.alphaMap.value = g.alphaMap), g.alphaTest > 0 && (p.alphaTest.value = g.alphaTest);
        let x;
        g.map ? x = g.map : g.alphaMap && (x = g.alphaMap), x !== void 0 && (x.matrixAutoUpdate === !0 && x.updateMatrix(), p.uvTransform.value.copy(x.matrix));
    }
    function l(p, g) {
        p.diffuse.value.copy(g.color), p.opacity.value = g.opacity, p.rotation.value = g.rotation, g.map && (p.map.value = g.map), g.alphaMap && (p.alphaMap.value = g.alphaMap), g.alphaTest > 0 && (p.alphaTest.value = g.alphaTest);
        let y;
        g.map ? y = g.map : g.alphaMap && (y = g.alphaMap), y !== void 0 && (y.matrixAutoUpdate === !0 && y.updateMatrix(), p.uvTransform.value.copy(y.matrix));
    }
    function u(p, g) {
        p.specular.value.copy(g.specular), p.shininess.value = Math.max(g.shininess, 1e-4);
    }
    function c(p, g) {
        g.gradientMap && (p.gradientMap.value = g.gradientMap);
    }
    function d(p, g) {
        p.roughness.value = g.roughness, p.metalness.value = g.metalness, g.roughnessMap && (p.roughnessMap.value = g.roughnessMap), g.metalnessMap && (p.metalnessMap.value = g.metalnessMap), t.get(g).envMap && (p.envMapIntensity.value = g.envMapIntensity);
    }
    function h(p, g, y) {
        p.ior.value = g.ior, g.sheen > 0 && (p.sheenColor.value.copy(g.sheenColor).multiplyScalar(g.sheen), p.sheenRoughness.value = g.sheenRoughness, g.sheenColorMap && (p.sheenColorMap.value = g.sheenColorMap), g.sheenRoughnessMap && (p.sheenRoughnessMap.value = g.sheenRoughnessMap)), g.clearcoat > 0 && (p.clearcoat.value = g.clearcoat, p.clearcoatRoughness.value = g.clearcoatRoughness, g.clearcoatMap && (p.clearcoatMap.value = g.clearcoatMap), g.clearcoatRoughnessMap && (p.clearcoatRoughnessMap.value = g.clearcoatRoughnessMap), g.clearcoatNormalMap && (p.clearcoatNormalScale.value.copy(g.clearcoatNormalScale), p.clearcoatNormalMap.value = g.clearcoatNormalMap, g.side === On && p.clearcoatNormalScale.value.negate())), g.iridescence > 0 && (p.iridescence.value = g.iridescence, p.iridescenceIOR.value = g.iridescenceIOR, p.iridescenceThicknessMinimum.value = g.iridescenceThicknessRange[0], p.iridescenceThicknessMaximum.value = g.iridescenceThicknessRange[1], g.iridescenceMap && (p.iridescenceMap.value = g.iridescenceMap), g.iridescenceThicknessMap && (p.iridescenceThicknessMap.value = g.iridescenceThicknessMap)), g.transmission > 0 && (p.transmission.value = g.transmission, p.transmissionSamplerMap.value = y.texture, p.transmissionSamplerSize.value.set(y.width, y.height), g.transmissionMap && (p.transmissionMap.value = g.transmissionMap), p.thickness.value = g.thickness, g.thicknessMap && (p.thicknessMap.value = g.thicknessMap), p.attenuationDistance.value = g.attenuationDistance, p.attenuationColor.value.copy(g.attenuationColor)), p.specularIntensity.value = g.specularIntensity, p.specularColor.value.copy(g.specularColor), g.specularIntensityMap && (p.specularIntensityMap.value = g.specularIntensityMap), g.specularColorMap && (p.specularColorMap.value = g.specularColorMap);
    }
    function f(p, g) {
        g.matcap && (p.matcap.value = g.matcap);
    }
    function m(p, g) {
        p.referencePosition.value.copy(g.referencePosition), p.nearDistance.value = g.nearDistance, p.farDistance.value = g.farDistance;
    }
    return {
        refreshFogUniforms: e,
        refreshMaterialUniforms: n
    };
}
function RB(r1, t, e, n) {
    let i = {}, s = {}, o = [], a = e.isWebGL2 ? r1.getParameter(35375) : 0;
    function l(v, x) {
        let w = x.program;
        n.uniformBlockBinding(v, w);
    }
    function u(v, x) {
        let w = i[v.id];
        w === void 0 && (m(v), w = c(v), i[v.id] = w, v.addEventListener("dispose", g));
        let S = x.program;
        n.updateUBOMapping(v, S);
        let _ = t.render.frame;
        s[v.id] !== _ && (h(v), s[v.id] = _);
    }
    function c(v) {
        let x = d();
        v.__bindingPointIndex = x;
        let w = r1.createBuffer(), S = v.__size, _ = v.usage;
        return r1.bindBuffer(35345, w), r1.bufferData(35345, S, _), r1.bindBuffer(35345, null), r1.bindBufferBase(35345, x, w), w;
    }
    function d() {
        for(let v = 0; v < a; v++)if (o.indexOf(v) === -1) return o.push(v), v;
        return console.error("THREE.WebGLRenderer: Maximum number of simultaneously usable uniforms groups reached."), 0;
    }
    function h(v) {
        let x = i[v.id], w = v.uniforms, S = v.__cache;
        r1.bindBuffer(35345, x);
        for(let _ = 0, M = w.length; _ < M; _++){
            let b = w[_];
            if (f(b, _, S) === !0) {
                let T = b.__offset, E = Array.isArray(b.value) ? b.value : [
                    b.value
                ], P = 0;
                for(let D = 0; D < E.length; D++){
                    let C = E[D], O = p(C);
                    typeof C == "number" ? (b.__data[0] = C, r1.bufferSubData(35345, T + P, b.__data)) : C.isMatrix3 ? (b.__data[0] = C.elements[0], b.__data[1] = C.elements[1], b.__data[2] = C.elements[2], b.__data[3] = C.elements[0], b.__data[4] = C.elements[3], b.__data[5] = C.elements[4], b.__data[6] = C.elements[5], b.__data[7] = C.elements[0], b.__data[8] = C.elements[6], b.__data[9] = C.elements[7], b.__data[10] = C.elements[8], b.__data[11] = C.elements[0]) : (C.toArray(b.__data, P), P += O.storage / Float32Array.BYTES_PER_ELEMENT);
                }
                r1.bufferSubData(35345, T, b.__data);
            }
        }
        r1.bindBuffer(35345, null);
    }
    function f(v, x, w) {
        let S = v.value;
        if (w[x] === void 0) {
            if (typeof S == "number") w[x] = S;
            else {
                let _ = Array.isArray(S) ? S : [
                    S
                ], M = [];
                for(let b = 0; b < _.length; b++)M.push(_[b].clone());
                w[x] = M;
            }
            return !0;
        } else if (typeof S == "number") {
            if (w[x] !== S) return w[x] = S, !0;
        } else {
            let _ = Array.isArray(w[x]) ? w[x] : [
                w[x]
            ], M = Array.isArray(S) ? S : [
                S
            ];
            for(let b = 0; b < _.length; b++){
                let T = _[b];
                if (T.equals(M[b]) === !1) return T.copy(M[b]), !0;
            }
        }
        return !1;
    }
    function m(v) {
        let x = v.uniforms, w = 0, S = 16, _ = 0;
        for(let M = 0, b = x.length; M < b; M++){
            let T = x[M], E = {
                boundary: 0,
                storage: 0
            }, P = Array.isArray(T.value) ? T.value : [
                T.value
            ];
            for(let D = 0, C = P.length; D < C; D++){
                let O = P[D], B = p(O);
                E.boundary += B.boundary, E.storage += B.storage;
            }
            if (T.__data = new Float32Array(E.storage / Float32Array.BYTES_PER_ELEMENT), T.__offset = w, M > 0) {
                _ = w % S;
                let D = S - _;
                _ !== 0 && D - E.boundary < 0 && (w += S - _, T.__offset = w);
            }
            w += E.storage;
        }
        return _ = w % S, _ > 0 && (w += S - _), v.__size = w, v.__cache = {}, this;
    }
    function p(v) {
        let x = {
            boundary: 0,
            storage: 0
        };
        return typeof v == "number" ? (x.boundary = 4, x.storage = 4) : v.isVector2 ? (x.boundary = 8, x.storage = 8) : v.isVector3 || v.isColor ? (x.boundary = 16, x.storage = 12) : v.isVector4 ? (x.boundary = 16, x.storage = 16) : v.isMatrix3 ? (x.boundary = 48, x.storage = 48) : v.isMatrix4 ? (x.boundary = 64, x.storage = 64) : v.isTexture ? console.warn("THREE.WebGLRenderer: Texture samplers can not be part of an uniforms group.") : console.warn("THREE.WebGLRenderer: Unsupported uniform value type.", v), x;
    }
    function g(v) {
        let x = v.target;
        x.removeEventListener("dispose", g);
        let w = o.indexOf(x.__bindingPointIndex);
        o.splice(w, 1), r1.deleteBuffer(i[x.id]), delete i[x.id], delete s[x.id];
    }
    function y() {
        for(let v in i)r1.deleteBuffer(i[v]);
        o = [], i = {}, s = {};
    }
    return {
        bind: l,
        update: u,
        dispose: y
    };
}
function LB() {
    let r1 = Bp("canvas");
    return r1.style.display = "block", r1;
}
function tx(r1 = {}) {
    this.isWebGLRenderer = !0;
    let t = r1.canvas !== void 0 ? r1.canvas : LB(), e = r1.context !== void 0 ? r1.context : null, n = r1.depth !== void 0 ? r1.depth : !0, i = r1.stencil !== void 0 ? r1.stencil : !0, s = r1.antialias !== void 0 ? r1.antialias : !1, o = r1.premultipliedAlpha !== void 0 ? r1.premultipliedAlpha : !0, a = r1.preserveDrawingBuffer !== void 0 ? r1.preserveDrawingBuffer : !1, l = r1.powerPreference !== void 0 ? r1.powerPreference : "default", u = r1.failIfMajorPerformanceCaveat !== void 0 ? r1.failIfMajorPerformanceCaveat : !1, c;
    e !== null ? c = e.getContextAttributes().alpha : c = r1.alpha !== void 0 ? r1.alpha : !1;
    let d = null, h = null, f = [], m = [];
    this.domElement = t, this.debug = {
        checkShaderErrors: !0
    }, this.autoClear = !0, this.autoClearColor = !0, this.autoClearDepth = !0, this.autoClearStencil = !0, this.sortObjects = !0, this.clippingPlanes = [], this.localClippingEnabled = !1, this.outputEncoding = oi, this.physicallyCorrectLights = !1, this.toneMapping = io, this.toneMappingExposure = 1;
    let p = this, g = !1, y = 0, v = 0, x = null, w = -1, S = null, _ = new Ze, M = new Ze, b = null, T = t.width, E = t.height, P = 1, D = null, C = null, O = new Ze(0, 0, T, E), B = new Ze(0, 0, T, E), V = !1, Y = new yh, W = !1, q = !1, j = null, X = new ae, L = new F, U = new A, G = {
        background: null,
        fog: null,
        environment: null,
        overrideMaterial: null,
        isScene: !0
    };
    function H() {
        return x === null ? P : 1;
    }
    let z = e;
    function re(N, te) {
        for(let oe = 0; oe < N.length; oe++){
            let $ = N[oe], ue = t.getContext($, te);
            if (ue !== null) return ue;
        }
        return null;
    }
    try {
        let N = {
            alpha: !0,
            depth: n,
            stencil: i,
            antialias: s,
            premultipliedAlpha: o,
            preserveDrawingBuffer: a,
            powerPreference: l,
            failIfMajorPerformanceCaveat: u
        };
        if ("setAttribute" in t && t.setAttribute("data-engine", `three.js r${ao}`), t.addEventListener("webglcontextlost", Ue, !1), t.addEventListener("webglcontextrestored", Xe, !1), t.addEventListener("webglcontextcreationerror", yt, !1), z === null) {
            let te = [
                "webgl2",
                "webgl",
                "experimental-webgl"
            ];
            if (p.isWebGL1Renderer === !0 && te.shift(), z = re(te, N), z === null) throw re(te) ? new Error("Error creating WebGL context with your selected attributes.") : new Error("Error creating WebGL context.");
        }
        z.getShaderPrecisionFormat === void 0 && (z.getShaderPrecisionFormat = function() {
            return {
                rangeMin: 1,
                rangeMax: 1,
                precision: 1
            };
        });
    } catch (N) {
        throw console.error("THREE.WebGLRenderer: " + N.message), N;
    }
    let K, Z, k, he, fe, ce, ye, Se, ve, Te, Ee, we, Ge, gt, R, I, ee, pe, xe, Ce, Ve, Pe, de, qe;
    function Re() {
        K = new tN(z), Z = new Q3(z, K, r1), K.init(Z), Pe = new DB(z, K, Z), k = new CB(z, K, Z), he = new iN, fe = new gB, ce = new PB(z, K, k, fe, Z, Pe, he), ye = new Z3(p), Se = new eN(p), ve = new fR(z, Z), de = new X3(z, K, ve, Z), Te = new nN(z, ve, he, de), Ee = new lN(z, Te, ve, he), xe = new aN(z, Z, ce), I = new K3(fe), we = new mB(p, ye, Se, K, Z, de, I), Ge = new OB(p, fe), gt = new vB, R = new _B(K, Z), pe = new q3(p, ye, Se, k, Ee, c, o), ee = new EB(p, Ee, Z), qe = new RB(z, he, Z, k), Ce = new Y3(z, K, he, Z), Ve = new rN(z, K, he, Z), he.programs = we.programs, p.capabilities = Z, p.extensions = K, p.properties = fe, p.renderLists = gt, p.shadowMap = ee, p.state = k, p.info = he;
    }
    Re();
    let De = new P0(p, z);
    this.xr = De, this.getContext = function() {
        return z;
    }, this.getContextAttributes = function() {
        return z.getContextAttributes();
    }, this.forceContextLoss = function() {
        let N = K.get("WEBGL_lose_context");
        N && N.loseContext();
    }, this.forceContextRestore = function() {
        let N = K.get("WEBGL_lose_context");
        N && N.restoreContext();
    }, this.getPixelRatio = function() {
        return P;
    }, this.setPixelRatio = function(N) {
        N !== void 0 && (P = N, this.setSize(T, E, !1));
    }, this.getSize = function(N) {
        return N.set(T, E);
    }, this.setSize = function(N, te, oe) {
        if (De.isPresenting) {
            console.warn("THREE.WebGLRenderer: Can't change size while VR device is presenting.");
            return;
        }
        T = N, E = te, t.width = Math.floor(N * P), t.height = Math.floor(te * P), oe !== !1 && (t.style.width = N + "px", t.style.height = te + "px"), this.setViewport(0, 0, N, te);
    }, this.getDrawingBufferSize = function(N) {
        return N.set(T * P, E * P).floor();
    }, this.setDrawingBufferSize = function(N, te, oe) {
        T = N, E = te, P = oe, t.width = Math.floor(N * oe), t.height = Math.floor(te * oe), this.setViewport(0, 0, N, te);
    }, this.getCurrentViewport = function(N) {
        return N.copy(_);
    }, this.getViewport = function(N) {
        return N.copy(O);
    }, this.setViewport = function(N, te, oe, $) {
        N.isVector4 ? O.set(N.x, N.y, N.z, N.w) : O.set(N, te, oe, $), k.viewport(_.copy(O).multiplyScalar(P).floor());
    }, this.getScissor = function(N) {
        return N.copy(B);
    }, this.setScissor = function(N, te, oe, $) {
        N.isVector4 ? B.set(N.x, N.y, N.z, N.w) : B.set(N, te, oe, $), k.scissor(M.copy(B).multiplyScalar(P).floor());
    }, this.getScissorTest = function() {
        return V;
    }, this.setScissorTest = function(N) {
        k.setScissorTest(V = N);
    }, this.setOpaqueSort = function(N) {
        D = N;
    }, this.setTransparentSort = function(N) {
        C = N;
    }, this.getClearColor = function(N) {
        return N.copy(pe.getClearColor());
    }, this.setClearColor = function() {
        pe.setClearColor.apply(pe, arguments);
    }, this.getClearAlpha = function() {
        return pe.getClearAlpha();
    }, this.setClearAlpha = function() {
        pe.setClearAlpha.apply(pe, arguments);
    }, this.clear = function(N = !0, te = !0, oe = !0) {
        let $ = 0;
        N && ($ |= 16384), te && ($ |= 256), oe && ($ |= 1024), z.clear($);
    }, this.clearColor = function() {
        this.clear(!0, !1, !1);
    }, this.clearDepth = function() {
        this.clear(!1, !0, !1);
    }, this.clearStencil = function() {
        this.clear(!1, !1, !0);
    }, this.dispose = function() {
        t.removeEventListener("webglcontextlost", Ue, !1), t.removeEventListener("webglcontextrestored", Xe, !1), t.removeEventListener("webglcontextcreationerror", yt, !1), gt.dispose(), R.dispose(), fe.dispose(), ye.dispose(), Se.dispose(), Ee.dispose(), de.dispose(), qe.dispose(), we.dispose(), De.dispose(), De.removeEventListener("sessionstart", Le), De.removeEventListener("sessionend", Oe), j && (j.dispose(), j = null), vt.stop();
    };
    function Ue(N) {
        N.preventDefault(), console.log("THREE.WebGLRenderer: Context Lost."), g = !0;
    }
    function Xe() {
        console.log("THREE.WebGLRenderer: Context Restored."), g = !1;
        let N = he.autoReset, te = ee.enabled, oe = ee.autoUpdate, $ = ee.needsUpdate, ue = ee.type;
        Re(), he.autoReset = N, ee.enabled = te, ee.autoUpdate = oe, ee.needsUpdate = $, ee.type = ue;
    }
    function yt(N) {
        console.error("THREE.WebGLRenderer: A WebGL context could not be created. Reason: ", N.statusMessage);
    }
    function zt(N) {
        let te = N.target;
        te.removeEventListener("dispose", zt), Tn(te);
    }
    function Tn(N) {
        Q(N), fe.remove(N);
    }
    function Q(N) {
        let te = fe.get(N).programs;
        te !== void 0 && (te.forEach(function(oe) {
            we.releaseProgram(oe);
        }), N.isShaderMaterial && we.releaseShaderCache(N));
    }
    this.renderBufferDirect = function(N, te, oe, $, ue, tt) {
        te === null && (te = G);
        let at = ue.isMesh && ue.matrixWorld.determinant() < 0, ct = RI(N, te, oe, $, ue);
        k.setMaterial($, at);
        let ft = oe.index, Ct = 1;
        $.wireframe === !0 && (ft = Te.getWireframeAttribute(oe), Ct = 2);
        let xt = oe.drawRange, bt = oe.attributes.position, Cn = xt.start * Ct, ti = (xt.start + xt.count) * Ct;
        tt !== null && (Cn = Math.max(Cn, tt.start * Ct), ti = Math.min(ti, (tt.start + tt.count) * Ct)), ft !== null ? (Cn = Math.max(Cn, 0), ti = Math.min(ti, ft.count)) : bt != null && (Cn = Math.max(Cn, 0), ti = Math.min(ti, bt.count));
        let Qs = ti - Cn;
        if (Qs < 0 || Qs === 1 / 0) return;
        de.setup(ue, $, ct, oe, ft);
        let Oa, Pn = Ce;
        if (ft !== null && (Oa = ve.get(ft), Pn = Ve, Pn.setIndex(Oa)), ue.isMesh) $.wireframe === !0 ? (k.setLineWidth($.wireframeLinewidth * H()), Pn.setMode(1)) : Pn.setMode(4);
        else if (ue.isLine) {
            let wt = $.linewidth;
            wt === void 0 && (wt = 1), k.setLineWidth(wt * H()), ue.isLineSegments ? Pn.setMode(1) : ue.isLineLoop ? Pn.setMode(2) : Pn.setMode(3);
        } else ue.isPoints ? Pn.setMode(0) : ue.isSprite && Pn.setMode(4);
        if (ue.isInstancedMesh) Pn.renderInstances(Cn, Qs, ue.count);
        else if (oe.isInstancedBufferGeometry) {
            let wt = oe._maxInstanceCount !== void 0 ? oe._maxInstanceCount : 1 / 0, _v = Math.min(oe.instanceCount, wt);
            Pn.renderInstances(Cn, Qs, _v);
        } else Pn.render(Cn, Qs);
    }, this.compile = function(N, te) {
        function oe($, ue, tt) {
            $.transparent === !0 && $.side === Ir && $.forceSinglePass === !1 ? ($.side = On, $.needsUpdate = !0, pi($, ue, tt), $.side = si, $.needsUpdate = !0, pi($, ue, tt), $.side = Ir) : pi($, ue, tt);
        }
        h = R.get(N), h.init(), m.push(h), N.traverseVisible(function($) {
            $.isLight && $.layers.test(te.layers) && (h.pushLight($), $.castShadow && h.pushShadow($));
        }), h.setupLights(p.physicallyCorrectLights), N.traverse(function($) {
            let ue = $.material;
            if (ue) {
                if (Array.isArray(ue)) for(let tt = 0; tt < ue.length; tt++){
                    let at = ue[tt];
                    oe(at, N, $);
                }
                else oe(ue, N, $);
            }
        }), m.pop(), h = null;
    };
    let se = null;
    function ge(N) {
        se && se(N);
    }
    function Le() {
        vt.stop();
    }
    function Oe() {
        vt.start();
    }
    let vt = new DA;
    vt.setAnimationLoop(ge), typeof self < "u" && vt.setContext(self), this.setAnimationLoop = function(N) {
        se = N, De.setAnimationLoop(N), N === null ? vt.stop() : vt.start();
    }, De.addEventListener("sessionstart", Le), De.addEventListener("sessionend", Oe), this.render = function(N, te) {
        if (te !== void 0 && te.isCamera !== !0) {
            console.error("THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.");
            return;
        }
        if (g === !0) return;
        N.matrixWorldAutoUpdate === !0 && N.updateMatrixWorld(), te.parent === null && te.matrixWorldAutoUpdate === !0 && te.updateMatrixWorld(), De.enabled === !0 && De.isPresenting === !0 && (De.cameraAutoUpdate === !0 && De.updateCamera(te), te = De.getCamera()), N.isScene === !0 && N.onBeforeRender(p, N, te, x), h = R.get(N, m.length), h.init(), m.push(h), X.multiplyMatrices(te.projectionMatrix, te.matrixWorldInverse), Y.setFromProjectionMatrix(X), q = this.localClippingEnabled, W = I.init(this.clippingPlanes, q), d = gt.get(N, f.length), d.init(), f.push(d), En(N, te, 0, p.sortObjects), d.finish(), p.sortObjects === !0 && d.sort(D, C), W === !0 && I.beginShadows();
        let oe = h.state.shadowsArray;
        if (ee.render(oe, N, te), W === !0 && I.endShadows(), this.info.autoReset === !0 && this.info.reset(), pe.render(d, N), h.setupLights(p.physicallyCorrectLights), te.isArrayCamera) {
            let $ = te.cameras;
            for(let ue = 0, tt = $.length; ue < tt; ue++){
                let at = $[ue];
                pn(d, N, at, at.viewport);
            }
        } else pn(d, N, te);
        x !== null && (ce.updateMultisampleRenderTarget(x), ce.updateRenderTargetMipmap(x)), N.isScene === !0 && N.onAfterRender(p, N, te), de.resetDefaultState(), w = -1, S = null, m.pop(), m.length > 0 ? h = m[m.length - 1] : h = null, f.pop(), f.length > 0 ? d = f[f.length - 1] : d = null;
    };
    function En(N, te, oe, $) {
        if (N.visible === !1) return;
        if (N.layers.test(te.layers)) {
            if (N.isGroup) oe = N.renderOrder;
            else if (N.isLOD) N.autoUpdate === !0 && N.update(te);
            else if (N.isLight) h.pushLight(N), N.castShadow && h.pushShadow(N);
            else if (N.isSprite) {
                if (!N.frustumCulled || Y.intersectsSprite(N)) {
                    $ && U.setFromMatrixPosition(N.matrixWorld).applyMatrix4(X);
                    let at = Ee.update(N), ct = N.material;
                    ct.visible && d.push(N, at, ct, oe, U.z, null);
                }
            } else if ((N.isMesh || N.isLine || N.isPoints) && (N.isSkinnedMesh && N.skeleton.frame !== he.render.frame && (N.skeleton.update(), N.skeleton.frame = he.render.frame), !N.frustumCulled || Y.intersectsObject(N))) {
                $ && U.setFromMatrixPosition(N.matrixWorld).applyMatrix4(X);
                let at = Ee.update(N), ct = N.material;
                if (Array.isArray(ct)) {
                    let ft = at.groups;
                    for(let Ct = 0, xt = ft.length; Ct < xt; Ct++){
                        let bt = ft[Ct], Cn = ct[bt.materialIndex];
                        Cn && Cn.visible && d.push(N, at, Cn, oe, U.z, bt);
                    }
                } else ct.visible && d.push(N, at, ct, oe, U.z, null);
            }
        }
        let tt = N.children;
        for(let at = 0, ct = tt.length; at < ct; at++)En(tt[at], te, oe, $);
    }
    function pn(N, te, oe, $) {
        let ue = N.opaque, tt = N.transmissive, at = N.transparent;
        h.setupLightsView(oe), W === !0 && I.setGlobalState(p.clippingPlanes, oe), tt.length > 0 && Ia(ue, te, oe), $ && k.viewport(_.copy($)), ue.length > 0 && Qt(ue, te, oe), tt.length > 0 && Qt(tt, te, oe), at.length > 0 && Qt(at, te, oe), k.buffers.depth.setTest(!0), k.buffers.depth.setMask(!0), k.buffers.color.setMask(!0), k.setPolygonOffset(!1);
    }
    function Ia(N, te, oe) {
        let $ = Z.isWebGL2;
        j === null && (j = new st(1, 1, {
            generateMipmaps: !0,
            type: K.has("EXT_color_buffer_half_float") ? Ha : qt,
            minFilter: Va,
            samples: $ && s === !0 ? 4 : 0
        })), p.getDrawingBufferSize(L), $ ? j.setSize(L.x, L.y) : j.setSize(Np(L.x), Np(L.y));
        let ue = p.getRenderTarget();
        p.setRenderTarget(j), p.clear();
        let tt = p.toneMapping;
        p.toneMapping = io, Qt(N, te, oe), p.toneMapping = tt, ce.updateMultisampleRenderTarget(j), ce.updateRenderTargetMipmap(j), p.setRenderTarget(ue);
    }
    function Qt(N, te, oe) {
        let $ = te.isScene === !0 ? te.overrideMaterial : null;
        for(let ue = 0, tt = N.length; ue < tt; ue++){
            let at = N[ue], ct = at.object, ft = at.geometry, Ct = $ === null ? at.material : $, xt = at.group;
            ct.layers.test(oe.layers) && Ys(ct, te, oe, ft, Ct, xt);
        }
    }
    function Ys(N, te, oe, $, ue, tt) {
        N.onBeforeRender(p, te, oe, $, ue, tt), N.modelViewMatrix.multiplyMatrices(oe.matrixWorldInverse, N.matrixWorld), N.normalMatrix.getNormalMatrix(N.modelViewMatrix), ue.onBeforeRender(p, te, oe, $, N, tt), ue.transparent === !0 && ue.side === Ir && ue.forceSinglePass === !1 ? (ue.side = On, ue.needsUpdate = !0, p.renderBufferDirect(oe, te, $, ue, N, tt), ue.side = si, ue.needsUpdate = !0, p.renderBufferDirect(oe, te, $, ue, N, tt), ue.side = Ir) : p.renderBufferDirect(oe, te, $, ue, N, tt), N.onAfterRender(p, te, oe, $, ue, tt);
    }
    function pi(N, te, oe) {
        te.isScene !== !0 && (te = G);
        let $ = fe.get(N), ue = h.state.lights, tt = h.state.shadowsArray, at = ue.state.version, ct = we.getParameters(N, ue.state, tt, te, oe), ft = we.getProgramCacheKey(ct), Ct = $.programs;
        $.environment = N.isMeshStandardMaterial ? te.environment : null, $.fog = te.fog, $.envMap = (N.isMeshStandardMaterial ? Se : ye).get(N.envMap || $.environment), Ct === void 0 && (N.addEventListener("dispose", zt), Ct = new Map, $.programs = Ct);
        let xt = Ct.get(ft);
        if (xt !== void 0) {
            if ($.currentProgram === xt && $.lightsStateVersion === at) return GS(N, ct), xt;
        } else ct.uniforms = we.getUniforms(N), N.onBuild(oe, ct, p), N.onBeforeCompile(ct, p), xt = we.acquireProgram(ct, ft), Ct.set(ft, xt), $.uniforms = ct.uniforms;
        let bt = $.uniforms;
        (!N.isShaderMaterial && !N.isRawShaderMaterial || N.clipping === !0) && (bt.clippingPlanes = I.uniform), GS(N, ct), $.needsLights = NI(N), $.lightsStateVersion = at, $.needsLights && (bt.ambientLightColor.value = ue.state.ambient, bt.lightProbe.value = ue.state.probe, bt.directionalLights.value = ue.state.directional, bt.directionalLightShadows.value = ue.state.directionalShadow, bt.spotLights.value = ue.state.spot, bt.spotLightShadows.value = ue.state.spotShadow, bt.rectAreaLights.value = ue.state.rectArea, bt.ltc_1.value = ue.state.rectAreaLTC1, bt.ltc_2.value = ue.state.rectAreaLTC2, bt.pointLights.value = ue.state.point, bt.pointLightShadows.value = ue.state.pointShadow, bt.hemisphereLights.value = ue.state.hemi, bt.directionalShadowMap.value = ue.state.directionalShadowMap, bt.directionalShadowMatrix.value = ue.state.directionalShadowMatrix, bt.spotShadowMap.value = ue.state.spotShadowMap, bt.spotLightMatrix.value = ue.state.spotLightMatrix, bt.spotLightMap.value = ue.state.spotLightMap, bt.pointShadowMap.value = ue.state.pointShadowMap, bt.pointShadowMatrix.value = ue.state.pointShadowMatrix);
        let Cn = xt.getUniforms(), ti = oc.seqWithValue(Cn.seq, bt);
        return $.currentProgram = xt, $.uniformsList = ti, xt;
    }
    function GS(N, te) {
        let oe = fe.get(N);
        oe.outputEncoding = te.outputEncoding, oe.instancing = te.instancing, oe.skinning = te.skinning, oe.morphTargets = te.morphTargets, oe.morphNormals = te.morphNormals, oe.morphColors = te.morphColors, oe.morphTargetsCount = te.morphTargetsCount, oe.numClippingPlanes = te.numClippingPlanes, oe.numIntersection = te.numClipIntersection, oe.vertexAlphas = te.vertexAlphas, oe.vertexTangents = te.vertexTangents, oe.toneMapping = te.toneMapping;
    }
    function RI(N, te, oe, $, ue) {
        te.isScene !== !0 && (te = G), ce.resetTextureUnits();
        let tt = te.fog, at = $.isMeshStandardMaterial ? te.environment : null, ct = x === null ? p.outputEncoding : x.isXRRenderTarget === !0 ? x.texture.encoding : oi, ft = ($.isMeshStandardMaterial ? Se : ye).get($.envMap || at), Ct = $.vertexColors === !0 && !!oe.attributes.color && oe.attributes.color.itemSize === 4, xt = !!$.normalMap && !!oe.attributes.tangent, bt = !!oe.morphAttributes.position, Cn = !!oe.morphAttributes.normal, ti = !!oe.morphAttributes.color, Qs = $.toneMapped ? p.toneMapping : io, Oa = oe.morphAttributes.position || oe.morphAttributes.normal || oe.morphAttributes.color, Pn = Oa !== void 0 ? Oa.length : 0, wt = fe.get($), _v = h.state.lights;
        if (W === !0 && (q === !0 || N !== S)) {
            let ni = N === S && $.id === w;
            I.setState($, N, ni);
        }
        let Jn = !1;
        $.version === wt.__version ? (wt.needsLights && wt.lightsStateVersion !== _v.state.version || wt.outputEncoding !== ct || ue.isInstancedMesh && wt.instancing === !1 || !ue.isInstancedMesh && wt.instancing === !0 || ue.isSkinnedMesh && wt.skinning === !1 || !ue.isSkinnedMesh && wt.skinning === !0 || wt.envMap !== ft || $.fog === !0 && wt.fog !== tt || wt.numClippingPlanes !== void 0 && (wt.numClippingPlanes !== I.numPlanes || wt.numIntersection !== I.numIntersection) || wt.vertexAlphas !== Ct || wt.vertexTangents !== xt || wt.morphTargets !== bt || wt.morphNormals !== Cn || wt.morphColors !== ti || wt.toneMapping !== Qs || Z.isWebGL2 === !0 && wt.morphTargetsCount !== Pn) && (Jn = !0) : (Jn = !0, wt.__version = $.version);
        let Ra = wt.currentProgram;
        Jn === !0 && (Ra = pi($, te, ue));
        let VS = !1, Zd = !1, Mv = !1, pr = Ra.getUniforms(), La = wt.uniforms;
        if (k.useProgram(Ra.program) && (VS = !0, Zd = !0, Mv = !0), $.id !== w && (w = $.id, Zd = !0), VS || S !== N) {
            if (pr.setValue(z, "projectionMatrix", N.projectionMatrix), Z.logarithmicDepthBuffer && pr.setValue(z, "logDepthBufFC", 2 / (Math.log(N.far + 1) / Math.LN2)), S !== N && (S = N, Zd = !0, Mv = !0), $.isShaderMaterial || $.isMeshPhongMaterial || $.isMeshToonMaterial || $.isMeshStandardMaterial || $.envMap) {
                let ni = pr.map.cameraPosition;
                ni !== void 0 && ni.setValue(z, U.setFromMatrixPosition(N.matrixWorld));
            }
            ($.isMeshPhongMaterial || $.isMeshToonMaterial || $.isMeshLambertMaterial || $.isMeshBasicMaterial || $.isMeshStandardMaterial || $.isShaderMaterial) && pr.setValue(z, "isOrthographic", N.isOrthographicCamera === !0), ($.isMeshPhongMaterial || $.isMeshToonMaterial || $.isMeshLambertMaterial || $.isMeshBasicMaterial || $.isMeshStandardMaterial || $.isShaderMaterial || $.isShadowMaterial || ue.isSkinnedMesh) && pr.setValue(z, "viewMatrix", N.matrixWorldInverse);
        }
        if (ue.isSkinnedMesh) {
            pr.setOptional(z, ue, "bindMatrix"), pr.setOptional(z, ue, "bindMatrixInverse");
            let ni = ue.skeleton;
            ni && (Z.floatVertexTextures ? (ni.boneTexture === null && ni.computeBoneTexture(), pr.setValue(z, "boneTexture", ni.boneTexture, ce), pr.setValue(z, "boneTextureSize", ni.boneTextureSize)) : console.warn("THREE.WebGLRenderer: SkinnedMesh can only be used with WebGL 2. With WebGL 1 OES_texture_float and vertex textures support is required."));
        }
        let Tv = oe.morphAttributes;
        if ((Tv.position !== void 0 || Tv.normal !== void 0 || Tv.color !== void 0 && Z.isWebGL2 === !0) && xe.update(ue, oe, $, Ra), (Zd || wt.receiveShadow !== ue.receiveShadow) && (wt.receiveShadow = ue.receiveShadow, pr.setValue(z, "receiveShadow", ue.receiveShadow)), $.isMeshGouraudMaterial && $.envMap !== null && (La.envMap.value = ft, La.flipEnvMap.value = ft.isCubeTexture && ft.isRenderTargetTexture === !1 ? -1 : 1), Zd && (pr.setValue(z, "toneMappingExposure", p.toneMappingExposure), wt.needsLights && LI(La, Mv), tt && $.fog === !0 && Ge.refreshFogUniforms(La, tt), Ge.refreshMaterialUniforms(La, $, P, E, j), oc.upload(z, wt.uniformsList, La, ce)), $.isShaderMaterial && $.uniformsNeedUpdate === !0 && (oc.upload(z, wt.uniformsList, La, ce), $.uniformsNeedUpdate = !1), $.isSpriteMaterial && pr.setValue(z, "center", ue.center), pr.setValue(z, "modelViewMatrix", ue.modelViewMatrix), pr.setValue(z, "normalMatrix", ue.normalMatrix), pr.setValue(z, "modelMatrix", ue.matrixWorld), ue.previousModelViewMatrix && pr.setValue(z, "previousModelViewMatrix", ue.previousModelViewMatrix), N.previousProjectionMatrix && pr.setValue(z, "previousProjectionMatrix", N.previousProjectionMatrix), $.isShaderMaterial || $.isRawShaderMaterial) {
            let ni = $.uniformsGroups;
            for(let Ev = 0, BI = ni.length; Ev < BI; Ev++)if (Z.isWebGL2) {
                let HS = ni[Ev];
                qe.update(HS, Ra), qe.bind(HS, Ra);
            } else console.warn("THREE.WebGLRenderer: Uniform Buffer Objects can only be used with WebGL 2.");
        }
        return Ra;
    }
    function LI(N, te) {
        N.ambientLightColor.needsUpdate = te, N.lightProbe.needsUpdate = te, N.directionalLights.needsUpdate = te, N.directionalLightShadows.needsUpdate = te, N.pointLights.needsUpdate = te, N.pointLightShadows.needsUpdate = te, N.spotLights.needsUpdate = te, N.spotLightShadows.needsUpdate = te, N.rectAreaLights.needsUpdate = te, N.hemisphereLights.needsUpdate = te;
    }
    function NI(N) {
        return N.isMeshLambertMaterial || N.isMeshToonMaterial || N.isMeshPhongMaterial || N.isMeshStandardMaterial || N.isShadowMaterial || N.isShaderMaterial && N.lights === !0;
    }
    this.getActiveCubeFace = function() {
        return y;
    }, this.getActiveMipmapLevel = function() {
        return v;
    }, this.getRenderTarget = function() {
        return x;
    }, this.setRenderTargetTextures = function(N, te, oe) {
        fe.get(N.texture).__webglTexture = te, fe.get(N.depthTexture).__webglTexture = oe;
        let $ = fe.get(N);
        $.__hasExternalTextures = !0, $.__hasExternalTextures && ($.__autoAllocateDepthBuffer = oe === void 0, $.__autoAllocateDepthBuffer || K.has("WEBGL_multisampled_render_to_texture") === !0 && (console.warn("THREE.WebGLRenderer: Render-to-texture extension was disabled because an external texture was provided"), $.__useRenderToTexture = !1));
    }, this.setRenderTargetFramebuffer = function(N, te) {
        let oe = fe.get(N);
        oe.__webglFramebuffer = te, oe.__useDefaultFramebuffer = te === void 0;
    }, this.setRenderTarget = function(N, te = 0, oe = 0) {
        x = N, y = te, v = oe;
        let $ = !0, ue = null, tt = !1, at = !1;
        if (N) {
            let ft = fe.get(N);
            ft.__useDefaultFramebuffer !== void 0 ? (k.bindFramebuffer(36160, null), $ = !1) : ft.__webglFramebuffer === void 0 ? ce.setupRenderTarget(N) : ft.__hasExternalTextures && ce.rebindTextures(N, fe.get(N.texture).__webglTexture, fe.get(N.depthTexture).__webglTexture);
            let Ct = N.texture;
            (Ct.isData3DTexture || Ct.isDataArrayTexture || Ct.isCompressedArrayTexture) && (at = !0);
            let xt = fe.get(N).__webglFramebuffer;
            N.isWebGLCubeRenderTarget ? (ue = xt[te], tt = !0) : Z.isWebGL2 && N.samples > 0 && ce.useMultisampledRTT(N) === !1 ? ue = fe.get(N).__webglMultisampledFramebuffer : ue = xt, _.copy(N.viewport), M.copy(N.scissor), b = N.scissorTest;
        } else _.copy(O).multiplyScalar(P).floor(), M.copy(B).multiplyScalar(P).floor(), b = V;
        if (k.bindFramebuffer(36160, ue) && Z.drawBuffers && $ && k.drawBuffers(N, ue), k.viewport(_), k.scissor(M), k.setScissorTest(b), tt) {
            let ft = fe.get(N.texture);
            z.framebufferTexture2D(36160, 36064, 34069 + te, ft.__webglTexture, oe);
        } else if (at) {
            let ft = fe.get(N.texture), Ct = te || 0;
            z.framebufferTextureLayer(36160, 36064, ft.__webglTexture, oe || 0, Ct);
        }
        w = -1;
    }, this.readRenderTargetPixels = function(N, te, oe, $, ue, tt, at) {
        if (!(N && N.isWebGLRenderTarget)) {
            console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");
            return;
        }
        let ct = fe.get(N).__webglFramebuffer;
        if (N.isWebGLCubeRenderTarget && at !== void 0 && (ct = ct[at]), ct) {
            k.bindFramebuffer(36160, ct);
            try {
                let ft = N.texture, Ct = ft.format, xt = ft.type;
                if (Ct !== gi && Pe.convert(Ct) !== z.getParameter(35739)) {
                    console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.");
                    return;
                }
                let bt = xt === Ha && (K.has("EXT_color_buffer_half_float") || Z.isWebGL2 && K.has("EXT_color_buffer_float"));
                if (xt !== qt && Pe.convert(xt) !== z.getParameter(35738) && !(xt === wr && (Z.isWebGL2 || K.has("OES_texture_float") || K.has("WEBGL_color_buffer_float"))) && !bt) {
                    console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.");
                    return;
                }
                te >= 0 && te <= N.width - $ && oe >= 0 && oe <= N.height - ue && z.readPixels(te, oe, $, ue, Pe.convert(Ct), Pe.convert(xt), tt);
            } finally{
                let ft = x !== null ? fe.get(x).__webglFramebuffer : null;
                k.bindFramebuffer(36160, ft);
            }
        }
    }, this.copyFramebufferToTexture = function(N, te, oe = 0) {
        let $ = Math.pow(2, -oe), ue = Math.floor(te.image.width * $), tt = Math.floor(te.image.height * $);
        ce.setTexture2D(te, 0), z.copyTexSubImage2D(3553, oe, 0, 0, N.x, N.y, ue, tt), k.unbindTexture();
    }, this.copyTextureToTexture = function(N, te, oe, $ = 0) {
        let ue = te.image.width, tt = te.image.height, at = Pe.convert(oe.format), ct = Pe.convert(oe.type);
        ce.setTexture2D(oe, 0), z.pixelStorei(37440, oe.flipY), z.pixelStorei(37441, oe.premultiplyAlpha), z.pixelStorei(3317, oe.unpackAlignment), te.isDataTexture ? z.texSubImage2D(3553, $, N.x, N.y, ue, tt, at, ct, te.image.data) : te.isCompressedTexture ? z.compressedTexSubImage2D(3553, $, N.x, N.y, te.mipmaps[0].width, te.mipmaps[0].height, at, te.mipmaps[0].data) : z.texSubImage2D(3553, $, N.x, N.y, at, ct, te.image), $ === 0 && oe.generateMipmaps && z.generateMipmap(3553), k.unbindTexture();
    }, this.copyTextureToTexture3D = function(N, te, oe, $, ue = 0) {
        if (p.isWebGL1Renderer) {
            console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: can only be used with WebGL2.");
            return;
        }
        let tt = N.max.x - N.min.x + 1, at = N.max.y - N.min.y + 1, ct = N.max.z - N.min.z + 1, ft = Pe.convert($.format), Ct = Pe.convert($.type), xt;
        if ($.isData3DTexture) ce.setTexture3D($, 0), xt = 32879;
        else if ($.isDataArrayTexture) ce.setTexture2DArray($, 0), xt = 35866;
        else {
            console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: only supports THREE.DataTexture3D and THREE.DataTexture2DArray.");
            return;
        }
        z.pixelStorei(37440, $.flipY), z.pixelStorei(37441, $.premultiplyAlpha), z.pixelStorei(3317, $.unpackAlignment);
        let bt = z.getParameter(3314), Cn = z.getParameter(32878), ti = z.getParameter(3316), Qs = z.getParameter(3315), Oa = z.getParameter(32877), Pn = oe.isCompressedTexture ? oe.mipmaps[0] : oe.image;
        z.pixelStorei(3314, Pn.width), z.pixelStorei(32878, Pn.height), z.pixelStorei(3316, N.min.x), z.pixelStorei(3315, N.min.y), z.pixelStorei(32877, N.min.z), oe.isDataTexture || oe.isData3DTexture ? z.texSubImage3D(xt, ue, te.x, te.y, te.z, tt, at, ct, ft, Ct, Pn.data) : oe.isCompressedArrayTexture ? (console.warn("THREE.WebGLRenderer.copyTextureToTexture3D: untested support for compressed srcTexture."), z.compressedTexSubImage3D(xt, ue, te.x, te.y, te.z, tt, at, ct, ft, Pn.data)) : z.texSubImage3D(xt, ue, te.x, te.y, te.z, tt, at, ct, ft, Ct, Pn), z.pixelStorei(3314, bt), z.pixelStorei(32878, Cn), z.pixelStorei(3316, ti), z.pixelStorei(3315, Qs), z.pixelStorei(32877, Oa), ue === 0 && $.generateMipmaps && z.generateMipmap(xt), k.unbindTexture();
    }, this.initTexture = function(N) {
        N.isCubeTexture ? ce.setTextureCube(N, 0) : N.isData3DTexture ? ce.setTexture3D(N, 0) : N.isDataArrayTexture || N.isCompressedArrayTexture ? ce.setTexture2DArray(N, 0) : ce.setTexture2D(N, 0), k.unbindTexture();
    }, this.resetState = function() {
        y = 0, v = 0, x = null, k.reset(), de.reset();
    }, typeof __THREE_DEVTOOLS__ < "u" && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", {
        detail: this
    }));
}
var D0 = class extends tx {
};
D0.prototype.isWebGL1Renderer = !0;
var cc = class {
    constructor(t, e = 1, n = 1e3){
        this.isFog = !0, this.name = "", this.color = new Ne(t), this.near = e, this.far = n;
    }
    clone() {
        return new cc(this.color, this.near, this.far);
    }
    toJSON() {
        return {
            type: "Fog",
            color: this.color.getHex(),
            near: this.near,
            far: this.far
        };
    }
}, Or = class extends pt {
    constructor(){
        super(), this.isScene = !0, this.type = "Scene", this.background = null, this.environment = null, this.fog = null, this.backgroundBlurriness = 0, this.backgroundIntensity = 1, this.overrideMaterial = null, typeof __THREE_DEVTOOLS__ < "u" && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", {
            detail: this
        }));
    }
    copy(t, e) {
        return super.copy(t, e), t.background !== null && (this.background = t.background.clone()), t.environment !== null && (this.environment = t.environment.clone()), t.fog !== null && (this.fog = t.fog.clone()), this.backgroundBlurriness = t.backgroundBlurriness, this.backgroundIntensity = t.backgroundIntensity, t.overrideMaterial !== null && (this.overrideMaterial = t.overrideMaterial.clone()), this.matrixAutoUpdate = t.matrixAutoUpdate, this;
    }
    toJSON(t) {
        let e = super.toJSON(t);
        return this.fog !== null && (e.object.fog = this.fog.toJSON()), this.backgroundBlurriness > 0 && (e.object.backgroundBlurriness = this.backgroundBlurriness), this.backgroundIntensity !== 1 && (e.object.backgroundIntensity = this.backgroundIntensity), e;
    }
    get autoUpdate() {
        return console.warn("THREE.Scene: autoUpdate was renamed to matrixWorldAutoUpdate in r144."), this.matrixWorldAutoUpdate;
    }
    set autoUpdate(t) {
        console.warn("THREE.Scene: autoUpdate was renamed to matrixWorldAutoUpdate in r144."), this.matrixWorldAutoUpdate = t;
    }
}, Wp = class {
    constructor(t, e){
        this.isInterleavedBuffer = !0, this.array = t, this.stride = e, this.count = t !== void 0 ? t.length / e : 0, this.usage = g0, this.updateRange = {
            offset: 0,
            count: -1
        }, this.version = 0, this.uuid = gs();
    }
    onUploadCallback() {}
    set needsUpdate(t) {
        t === !0 && this.version++;
    }
    setUsage(t) {
        return this.usage = t, this;
    }
    copy(t) {
        return this.array = new t.array.constructor(t.array), this.count = t.count, this.stride = t.stride, this.usage = t.usage, this;
    }
    copyAt(t, e, n) {
        t *= this.stride, n *= e.stride;
        for(let i = 0, s = this.stride; i < s; i++)this.array[t + i] = e.array[n + i];
        return this;
    }
    set(t, e = 0) {
        return this.array.set(t, e), this;
    }
    clone(t) {
        t.arrayBuffers === void 0 && (t.arrayBuffers = {}), this.array.buffer._uuid === void 0 && (this.array.buffer._uuid = gs()), t.arrayBuffers[this.array.buffer._uuid] === void 0 && (t.arrayBuffers[this.array.buffer._uuid] = this.array.slice(0).buffer);
        let e = new this.array.constructor(t.arrayBuffers[this.array.buffer._uuid]), n = new this.constructor(e, this.stride);
        return n.setUsage(this.usage), n;
    }
    onUpload(t) {
        return this.onUploadCallback = t, this;
    }
    toJSON(t) {
        return t.arrayBuffers === void 0 && (t.arrayBuffers = {}), this.array.buffer._uuid === void 0 && (this.array.buffer._uuid = gs()), t.arrayBuffers[this.array.buffer._uuid] === void 0 && (t.arrayBuffers[this.array.buffer._uuid] = Array.from(new Uint32Array(this.array.buffer))), {
            uuid: this.uuid,
            buffer: this.array.buffer._uuid,
            type: this.array.constructor.name,
            stride: this.stride
        };
    }
}, Pr = new A, qa = class {
    constructor(t, e, n, i = !1){
        this.isInterleavedBufferAttribute = !0, this.name = "", this.data = t, this.itemSize = e, this.offset = n, this.normalized = i;
    }
    get count() {
        return this.data.count;
    }
    get array() {
        return this.data.array;
    }
    set needsUpdate(t) {
        this.data.needsUpdate = t;
    }
    applyMatrix4(t) {
        for(let e = 0, n = this.data.count; e < n; e++)Pr.fromBufferAttribute(this, e), Pr.applyMatrix4(t), this.setXYZ(e, Pr.x, Pr.y, Pr.z);
        return this;
    }
    applyNormalMatrix(t) {
        for(let e = 0, n = this.count; e < n; e++)Pr.fromBufferAttribute(this, e), Pr.applyNormalMatrix(t), this.setXYZ(e, Pr.x, Pr.y, Pr.z);
        return this;
    }
    transformDirection(t) {
        for(let e = 0, n = this.count; e < n; e++)Pr.fromBufferAttribute(this, e), Pr.transformDirection(t), this.setXYZ(e, Pr.x, Pr.y, Pr.z);
        return this;
    }
    setX(t, e) {
        return this.normalized && (e = Ut(e, this.array)), this.data.array[t * this.data.stride + this.offset] = e, this;
    }
    setY(t, e) {
        return this.normalized && (e = Ut(e, this.array)), this.data.array[t * this.data.stride + this.offset + 1] = e, this;
    }
    setZ(t, e) {
        return this.normalized && (e = Ut(e, this.array)), this.data.array[t * this.data.stride + this.offset + 2] = e, this;
    }
    setW(t, e) {
        return this.normalized && (e = Ut(e, this.array)), this.data.array[t * this.data.stride + this.offset + 3] = e, this;
    }
    getX(t) {
        let e = this.data.array[t * this.data.stride + this.offset];
        return this.normalized && (e = ro(e, this.array)), e;
    }
    getY(t) {
        let e = this.data.array[t * this.data.stride + this.offset + 1];
        return this.normalized && (e = ro(e, this.array)), e;
    }
    getZ(t) {
        let e = this.data.array[t * this.data.stride + this.offset + 2];
        return this.normalized && (e = ro(e, this.array)), e;
    }
    getW(t) {
        let e = this.data.array[t * this.data.stride + this.offset + 3];
        return this.normalized && (e = ro(e, this.array)), e;
    }
    setXY(t, e, n) {
        return t = t * this.data.stride + this.offset, this.normalized && (e = Ut(e, this.array), n = Ut(n, this.array)), this.data.array[t + 0] = e, this.data.array[t + 1] = n, this;
    }
    setXYZ(t, e, n, i) {
        return t = t * this.data.stride + this.offset, this.normalized && (e = Ut(e, this.array), n = Ut(n, this.array), i = Ut(i, this.array)), this.data.array[t + 0] = e, this.data.array[t + 1] = n, this.data.array[t + 2] = i, this;
    }
    setXYZW(t, e, n, i, s) {
        return t = t * this.data.stride + this.offset, this.normalized && (e = Ut(e, this.array), n = Ut(n, this.array), i = Ut(i, this.array), s = Ut(s, this.array)), this.data.array[t + 0] = e, this.data.array[t + 1] = n, this.data.array[t + 2] = i, this.data.array[t + 3] = s, this;
    }
    clone(t) {
        if (t === void 0) {
            console.log("THREE.InterleavedBufferAttribute.clone(): Cloning an interleaved buffer attribute will de-interleave buffer data.");
            let e = [];
            for(let n = 0; n < this.count; n++){
                let i = n * this.data.stride + this.offset;
                for(let s = 0; s < this.itemSize; s++)e.push(this.data.array[i + s]);
            }
            return new Be(new this.array.constructor(e), this.itemSize, this.normalized);
        } else return t.interleavedBuffers === void 0 && (t.interleavedBuffers = {}), t.interleavedBuffers[this.data.uuid] === void 0 && (t.interleavedBuffers[this.data.uuid] = this.data.clone(t)), new qa(t.interleavedBuffers[this.data.uuid], this.itemSize, this.offset, this.normalized);
    }
    toJSON(t) {
        if (t === void 0) {
            console.log("THREE.InterleavedBufferAttribute.toJSON(): Serializing an interleaved buffer attribute will de-interleave buffer data.");
            let e = [];
            for(let n = 0; n < this.count; n++){
                let i = n * this.data.stride + this.offset;
                for(let s = 0; s < this.itemSize; s++)e.push(this.data.array[i + s]);
            }
            return {
                itemSize: this.itemSize,
                type: this.array.constructor.name,
                array: e,
                normalized: this.normalized
            };
        } else return t.interleavedBuffers === void 0 && (t.interleavedBuffers = {}), t.interleavedBuffers[this.data.uuid] === void 0 && (t.interleavedBuffers[this.data.uuid] = this.data.toJSON(t)), {
            isInterleavedBufferAttribute: !0,
            itemSize: this.itemSize,
            data: this.data.uuid,
            offset: this.offset,
            normalized: this.normalized
        };
    }
};
var jo = class extends Vt {
    constructor(t = null, e = 1, n = 1, i, s, o, a, l, u = _t, c = _t, d, h){
        super(null, o, a, l, u, c, i, s, d, h), this.isDataTexture = !0, this.image = {
            data: t,
            width: e,
            height: n
        }, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
    }
};
var jp = class extends Be {
    constructor(t, e, n, i = 1){
        super(t, e, n), this.isInstancedBufferAttribute = !0, this.meshPerAttribute = i;
    }
    copy(t) {
        return super.copy(t), this.meshPerAttribute = t.meshPerAttribute, this;
    }
    toJSON() {
        let t = super.toJSON();
        return t.meshPerAttribute = this.meshPerAttribute, t.isInstancedBufferAttribute = !0, t;
    }
};
var vi = class extends Wa {
    constructor(t){
        super(), this.isLineBasicMaterial = !0, this.type = "LineBasicMaterial", this.color = new Ne(16777215), this.linewidth = 1, this.linecap = "round", this.linejoin = "round", this.fog = !0, this.setValues(t);
    }
    copy(t) {
        return super.copy(t), this.color.copy(t.color), this.linewidth = t.linewidth, this.linecap = t.linecap, this.linejoin = t.linejoin, this.fog = t.fog, this;
    }
}, nA = new A, rA = new A, iA = new ae, o0 = new Fi, _p = new Rn, Xa = class extends pt {
    constructor(t = new Me, e = new vi){
        super(), this.isLine = !0, this.type = "Line", this.geometry = t, this.material = e, this.updateMorphTargets();
    }
    copy(t, e) {
        return super.copy(t, e), this.material = t.material, this.geometry = t.geometry, this;
    }
    computeLineDistances() {
        let t = this.geometry;
        if (t.index === null) {
            let e = t.attributes.position, n = [
                0
            ];
            for(let i = 1, s = e.count; i < s; i++)nA.fromBufferAttribute(e, i - 1), rA.fromBufferAttribute(e, i), n[i] = n[i - 1], n[i] += nA.distanceTo(rA);
            t.setAttribute("lineDistance", new Ae(n, 1));
        } else console.warn("THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
        return this;
    }
    raycast(t, e) {
        let n = this.geometry, i = this.matrixWorld, s = t.params.Line.threshold, o = n.drawRange;
        if (n.boundingSphere === null && n.computeBoundingSphere(), _p.copy(n.boundingSphere), _p.applyMatrix4(i), _p.radius += s, t.ray.intersectsSphere(_p) === !1) return;
        iA.copy(i).invert(), o0.copy(t.ray).applyMatrix4(iA);
        let a = s / ((this.scale.x + this.scale.y + this.scale.z) / 3), l = a * a, u = new A, c = new A, d = new A, h = new A, f = this.isLineSegments ? 2 : 1, m = n.index, g = n.attributes.position;
        if (m !== null) {
            let y = Math.max(0, o.start), v = Math.min(m.count, o.start + o.count);
            for(let x = y, w = v - 1; x < w; x += f){
                let S = m.getX(x), _ = m.getX(x + 1);
                if (u.fromBufferAttribute(g, S), c.fromBufferAttribute(g, _), o0.distanceSqToSegment(u, c, h, d) > l) continue;
                h.applyMatrix4(this.matrixWorld);
                let b = t.ray.origin.distanceTo(h);
                b < t.near || b > t.far || e.push({
                    distance: b,
                    point: d.clone().applyMatrix4(this.matrixWorld),
                    index: x,
                    face: null,
                    faceIndex: null,
                    object: this
                });
            }
        } else {
            let y = Math.max(0, o.start), v = Math.min(g.count, o.start + o.count);
            for(let x = y, w = v - 1; x < w; x += f){
                if (u.fromBufferAttribute(g, x), c.fromBufferAttribute(g, x + 1), o0.distanceSqToSegment(u, c, h, d) > l) continue;
                h.applyMatrix4(this.matrixWorld);
                let _ = t.ray.origin.distanceTo(h);
                _ < t.near || _ > t.far || e.push({
                    distance: _,
                    point: d.clone().applyMatrix4(this.matrixWorld),
                    index: x,
                    face: null,
                    faceIndex: null,
                    object: this
                });
            }
        }
    }
    updateMorphTargets() {
        let e = this.geometry.morphAttributes, n = Object.keys(e);
        if (n.length > 0) {
            let i = e[n[0]];
            if (i !== void 0) {
                this.morphTargetInfluences = [], this.morphTargetDictionary = {};
                for(let s = 0, o = i.length; s < o; s++){
                    let a = i[s].name || String(s);
                    this.morphTargetInfluences.push(0), this.morphTargetDictionary[a] = s;
                }
            }
        }
    }
}, sA = new A, oA = new A, qo = class extends Xa {
    constructor(t, e){
        super(t, e), this.isLineSegments = !0, this.type = "LineSegments";
    }
    computeLineDistances() {
        let t = this.geometry;
        if (t.index === null) {
            let e = t.attributes.position, n = [];
            for(let i = 0, s = e.count; i < s; i += 2)sA.fromBufferAttribute(e, i), oA.fromBufferAttribute(e, i + 1), n[i] = i === 0 ? 0 : n[i - 1], n[i + 1] = n[i] + sA.distanceTo(oA);
            t.setAttribute("lineDistance", new Ae(n, 1));
        } else console.warn("THREE.LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
        return this;
    }
};
var qp = class extends Vt {
    constructor(t, e, n, i, s, o, a, l, u){
        super(t, e, n, i, s, o, a, l, u), this.isVideoTexture = !0, this.minFilter = o !== void 0 ? o : Qe, this.magFilter = s !== void 0 ? s : Qe, this.generateMipmaps = !1;
        let c = this;
        function d() {
            c.needsUpdate = !0, t.requestVideoFrameCallback(d);
        }
        "requestVideoFrameCallback" in t && t.requestVideoFrameCallback(d);
    }
    clone() {
        return new this.constructor(this.image).copy(this);
    }
    update() {
        let t = this.image;
        "requestVideoFrameCallback" in t === !1 && t.readyState >= t.HAVE_CURRENT_DATA && (this.needsUpdate = !0);
    }
};
var xi = class {
    constructor(){
        this.type = "Curve", this.arcLengthDivisions = 200;
    }
    getPoint() {
        return console.warn("THREE.Curve: .getPoint() not implemented."), null;
    }
    getPointAt(t, e) {
        let n = this.getUtoTmapping(t);
        return this.getPoint(n, e);
    }
    getPoints(t = 5) {
        let e = [];
        for(let n = 0; n <= t; n++)e.push(this.getPoint(n / t));
        return e;
    }
    getSpacedPoints(t = 5) {
        let e = [];
        for(let n = 0; n <= t; n++)e.push(this.getPointAt(n / t));
        return e;
    }
    getLength() {
        let t = this.getLengths();
        return t[t.length - 1];
    }
    getLengths(t = this.arcLengthDivisions) {
        if (this.cacheArcLengths && this.cacheArcLengths.length === t + 1 && !this.needsUpdate) return this.cacheArcLengths;
        this.needsUpdate = !1;
        let e = [], n, i = this.getPoint(0), s = 0;
        e.push(0);
        for(let o = 1; o <= t; o++)n = this.getPoint(o / t), s += n.distanceTo(i), e.push(s), i = n;
        return this.cacheArcLengths = e, e;
    }
    updateArcLengths() {
        this.needsUpdate = !0, this.getLengths();
    }
    getUtoTmapping(t, e) {
        let n = this.getLengths(), i = 0, s = n.length, o;
        e ? o = e : o = t * n[s - 1];
        let a = 0, l = s - 1, u;
        for(; a <= l;)if (i = Math.floor(a + (l - a) / 2), u = n[i] - o, u < 0) a = i + 1;
        else if (u > 0) l = i - 1;
        else {
            l = i;
            break;
        }
        if (i = l, n[i] === o) return i / (s - 1);
        let c = n[i], h = n[i + 1] - c, f = (o - c) / h;
        return (i + f) / (s - 1);
    }
    getTangent(t, e) {
        let i = t - 1e-4, s = t + 1e-4;
        i < 0 && (i = 0), s > 1 && (s = 1);
        let o = this.getPoint(i), a = this.getPoint(s), l = e || (o.isVector2 ? new F : new A);
        return l.copy(a).sub(o).normalize(), l;
    }
    getTangentAt(t, e) {
        let n = this.getUtoTmapping(t);
        return this.getTangent(n, e);
    }
    computeFrenetFrames(t, e) {
        let n = new A, i = [], s = [], o = [], a = new A, l = new ae;
        for(let f = 0; f <= t; f++){
            let m = f / t;
            i[f] = this.getTangentAt(m, new A);
        }
        s[0] = new A, o[0] = new A;
        let u = Number.MAX_VALUE, c = Math.abs(i[0].x), d = Math.abs(i[0].y), h = Math.abs(i[0].z);
        c <= u && (u = c, n.set(1, 0, 0)), d <= u && (u = d, n.set(0, 1, 0)), h <= u && n.set(0, 0, 1), a.crossVectors(i[0], n).normalize(), s[0].crossVectors(i[0], a), o[0].crossVectors(i[0], s[0]);
        for(let f = 1; f <= t; f++){
            if (s[f] = s[f - 1].clone(), o[f] = o[f - 1].clone(), a.crossVectors(i[f - 1], i[f]), a.length() > Number.EPSILON) {
                a.normalize();
                let m = Math.acos(zn(i[f - 1].dot(i[f]), -1, 1));
                s[f].applyMatrix4(l.makeRotationAxis(a, m));
            }
            o[f].crossVectors(i[f], s[f]);
        }
        if (e === !0) {
            let f = Math.acos(zn(s[0].dot(s[t]), -1, 1));
            f /= t, i[0].dot(a.crossVectors(s[0], s[t])) > 0 && (f = -f);
            for(let m = 1; m <= t; m++)s[m].applyMatrix4(l.makeRotationAxis(i[m], f * m)), o[m].crossVectors(i[m], s[m]);
        }
        return {
            tangents: i,
            normals: s,
            binormals: o
        };
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(t) {
        return this.arcLengthDivisions = t.arcLengthDivisions, this;
    }
    toJSON() {
        let t = {
            metadata: {
                version: 4.5,
                type: "Curve",
                generator: "Curve.toJSON"
            }
        };
        return t.arcLengthDivisions = this.arcLengthDivisions, t.type = this.type, t;
    }
    fromJSON(t) {
        return this.arcLengthDivisions = t.arcLengthDivisions, this;
    }
}, Ya = class extends xi {
    constructor(t = 0, e = 0, n = 1, i = 1, s = 0, o = Math.PI * 2, a = !1, l = 0){
        super(), this.isEllipseCurve = !0, this.type = "EllipseCurve", this.aX = t, this.aY = e, this.xRadius = n, this.yRadius = i, this.aStartAngle = s, this.aEndAngle = o, this.aClockwise = a, this.aRotation = l;
    }
    getPoint(t, e) {
        let n = e || new F, i = Math.PI * 2, s = this.aEndAngle - this.aStartAngle, o = Math.abs(s) < Number.EPSILON;
        for(; s < 0;)s += i;
        for(; s > i;)s -= i;
        s < Number.EPSILON && (o ? s = 0 : s = i), this.aClockwise === !0 && !o && (s === i ? s = -i : s = s - i);
        let a = this.aStartAngle + t * s, l = this.aX + this.xRadius * Math.cos(a), u = this.aY + this.yRadius * Math.sin(a);
        if (this.aRotation !== 0) {
            let c = Math.cos(this.aRotation), d = Math.sin(this.aRotation), h = l - this.aX, f = u - this.aY;
            l = h * c - f * d + this.aX, u = h * d + f * c + this.aY;
        }
        return n.set(l, u);
    }
    copy(t) {
        return super.copy(t), this.aX = t.aX, this.aY = t.aY, this.xRadius = t.xRadius, this.yRadius = t.yRadius, this.aStartAngle = t.aStartAngle, this.aEndAngle = t.aEndAngle, this.aClockwise = t.aClockwise, this.aRotation = t.aRotation, this;
    }
    toJSON() {
        let t = super.toJSON();
        return t.aX = this.aX, t.aY = this.aY, t.xRadius = this.xRadius, t.yRadius = this.yRadius, t.aStartAngle = this.aStartAngle, t.aEndAngle = this.aEndAngle, t.aClockwise = this.aClockwise, t.aRotation = this.aRotation, t;
    }
    fromJSON(t) {
        return super.fromJSON(t), this.aX = t.aX, this.aY = t.aY, this.xRadius = t.xRadius, this.yRadius = t.yRadius, this.aStartAngle = t.aStartAngle, this.aEndAngle = t.aEndAngle, this.aClockwise = t.aClockwise, this.aRotation = t.aRotation, this;
    }
}, I0 = class extends Ya {
    constructor(t, e, n, i, s, o){
        super(t, e, n, n, i, s, o), this.isArcCurve = !0, this.type = "ArcCurve";
    }
};
function nx() {
    let r1 = 0, t = 0, e = 0, n = 0;
    function i(s, o, a, l) {
        r1 = s, t = a, e = -3 * s + 3 * o - 2 * a - l, n = 2 * s - 2 * o + a + l;
    }
    return {
        initCatmullRom: function(s, o, a, l, u) {
            i(o, a, u * (a - s), u * (l - o));
        },
        initNonuniformCatmullRom: function(s, o, a, l, u, c, d) {
            let h = (o - s) / u - (a - s) / (u + c) + (a - o) / c, f = (a - o) / c - (l - o) / (c + d) + (l - a) / d;
            h *= c, f *= c, i(o, a, h, f);
        },
        calc: function(s) {
            let o = s * s, a = o * s;
            return r1 + t * s + e * o + n * a;
        }
    };
}
var Mp = new A, a0 = new nx, l0 = new nx, c0 = new nx, O0 = class extends xi {
    constructor(t = [], e = !1, n = "centripetal", i = .5){
        super(), this.isCatmullRomCurve3 = !0, this.type = "CatmullRomCurve3", this.points = t, this.closed = e, this.curveType = n, this.tension = i;
    }
    getPoint(t, e = new A) {
        let n = e, i = this.points, s = i.length, o = (s - (this.closed ? 0 : 1)) * t, a = Math.floor(o), l = o - a;
        this.closed ? a += a > 0 ? 0 : (Math.floor(Math.abs(a) / s) + 1) * s : l === 0 && a === s - 1 && (a = s - 2, l = 1);
        let u, c;
        this.closed || a > 0 ? u = i[(a - 1) % s] : (Mp.subVectors(i[0], i[1]).add(i[0]), u = Mp);
        let d = i[a % s], h = i[(a + 1) % s];
        if (this.closed || a + 2 < s ? c = i[(a + 2) % s] : (Mp.subVectors(i[s - 1], i[s - 2]).add(i[s - 1]), c = Mp), this.curveType === "centripetal" || this.curveType === "chordal") {
            let f = this.curveType === "chordal" ? .5 : .25, m = Math.pow(u.distanceToSquared(d), f), p = Math.pow(d.distanceToSquared(h), f), g = Math.pow(h.distanceToSquared(c), f);
            p < 1e-4 && (p = 1), m < 1e-4 && (m = p), g < 1e-4 && (g = p), a0.initNonuniformCatmullRom(u.x, d.x, h.x, c.x, m, p, g), l0.initNonuniformCatmullRom(u.y, d.y, h.y, c.y, m, p, g), c0.initNonuniformCatmullRom(u.z, d.z, h.z, c.z, m, p, g);
        } else this.curveType === "catmullrom" && (a0.initCatmullRom(u.x, d.x, h.x, c.x, this.tension), l0.initCatmullRom(u.y, d.y, h.y, c.y, this.tension), c0.initCatmullRom(u.z, d.z, h.z, c.z, this.tension));
        return n.set(a0.calc(l), l0.calc(l), c0.calc(l)), n;
    }
    copy(t) {
        super.copy(t), this.points = [];
        for(let e = 0, n = t.points.length; e < n; e++){
            let i = t.points[e];
            this.points.push(i.clone());
        }
        return this.closed = t.closed, this.curveType = t.curveType, this.tension = t.tension, this;
    }
    toJSON() {
        let t = super.toJSON();
        t.points = [];
        for(let e = 0, n = this.points.length; e < n; e++){
            let i = this.points[e];
            t.points.push(i.toArray());
        }
        return t.closed = this.closed, t.curveType = this.curveType, t.tension = this.tension, t;
    }
    fromJSON(t) {
        super.fromJSON(t), this.points = [];
        for(let e = 0, n = t.points.length; e < n; e++){
            let i = t.points[e];
            this.points.push(new A().fromArray(i));
        }
        return this.closed = t.closed, this.curveType = t.curveType, this.tension = t.tension, this;
    }
};
function aA(r1, t, e, n, i) {
    let s = (n - t) * .5, o = (i - e) * .5, a = r1 * r1, l = r1 * a;
    return (2 * e - 2 * n + s + o) * l + (-3 * e + 3 * n - 2 * s - o) * a + s * r1 + e;
}
function NB(r1, t) {
    let e = 1 - r1;
    return e * e * t;
}
function BB(r1, t) {
    return 2 * (1 - r1) * r1 * t;
}
function FB(r1, t) {
    return r1 * r1 * t;
}
function hh(r1, t, e, n) {
    return NB(r1, t) + BB(r1, e) + FB(r1, n);
}
function UB(r1, t) {
    let e = 1 - r1;
    return e * e * e * t;
}
function kB(r1, t) {
    let e = 1 - r1;
    return 3 * e * e * r1 * t;
}
function zB(r1, t) {
    return 3 * (1 - r1) * r1 * r1 * t;
}
function GB(r1, t) {
    return r1 * r1 * r1 * t;
}
function fh(r1, t, e, n, i) {
    return UB(r1, t) + kB(r1, e) + zB(r1, n) + GB(r1, i);
}
var Sr = class extends xi {
    constructor(t = new F, e = new F, n = new F, i = new F){
        super(), this.isCubicBezierCurve = !0, this.type = "CubicBezierCurve", this.v0 = t, this.v1 = e, this.v2 = n, this.v3 = i;
    }
    getPoint(t, e = new F) {
        let n = e, i = this.v0, s = this.v1, o = this.v2, a = this.v3;
        return n.set(fh(t, i.x, s.x, o.x, a.x), fh(t, i.y, s.y, o.y, a.y)), n;
    }
    copy(t) {
        return super.copy(t), this.v0.copy(t.v0), this.v1.copy(t.v1), this.v2.copy(t.v2), this.v3.copy(t.v3), this;
    }
    toJSON() {
        let t = super.toJSON();
        return t.v0 = this.v0.toArray(), t.v1 = this.v1.toArray(), t.v2 = this.v2.toArray(), t.v3 = this.v3.toArray(), t;
    }
    fromJSON(t) {
        return super.fromJSON(t), this.v0.fromArray(t.v0), this.v1.fromArray(t.v1), this.v2.fromArray(t.v2), this.v3.fromArray(t.v3), this;
    }
}, Qa = class extends xi {
    constructor(t = new A, e = new A, n = new A, i = new A){
        super(), this.isCubicBezierCurve3 = !0, this.type = "CubicBezierCurve3", this.v0 = t, this.v1 = e, this.v2 = n, this.v3 = i;
    }
    getPoint(t, e = new A) {
        let n = e, i = this.v0, s = this.v1, o = this.v2, a = this.v3;
        return n.set(fh(t, i.x, s.x, o.x, a.x), fh(t, i.y, s.y, o.y, a.y), fh(t, i.z, s.z, o.z, a.z)), n;
    }
    copy(t) {
        return super.copy(t), this.v0.copy(t.v0), this.v1.copy(t.v1), this.v2.copy(t.v2), this.v3.copy(t.v3), this;
    }
    toJSON() {
        let t = super.toJSON();
        return t.v0 = this.v0.toArray(), t.v1 = this.v1.toArray(), t.v2 = this.v2.toArray(), t.v3 = this.v3.toArray(), t;
    }
    fromJSON(t) {
        return super.fromJSON(t), this.v0.fromArray(t.v0), this.v1.fromArray(t.v1), this.v2.fromArray(t.v2), this.v3.fromArray(t.v3), this;
    }
}, Ar = class extends xi {
    constructor(t = new F, e = new F){
        super(), this.isLineCurve = !0, this.type = "LineCurve", this.v1 = t, this.v2 = e;
    }
    getPoint(t, e = new F) {
        let n = e;
        return t === 1 ? n.copy(this.v2) : (n.copy(this.v2).sub(this.v1), n.multiplyScalar(t).add(this.v1)), n;
    }
    getPointAt(t, e) {
        return this.getPoint(t, e);
    }
    getTangent(t, e) {
        let n = e || new F;
        return n.copy(this.v2).sub(this.v1).normalize(), n;
    }
    copy(t) {
        return super.copy(t), this.v1.copy(t.v1), this.v2.copy(t.v2), this;
    }
    toJSON() {
        let t = super.toJSON();
        return t.v1 = this.v1.toArray(), t.v2 = this.v2.toArray(), t;
    }
    fromJSON(t) {
        return super.fromJSON(t), this.v1.fromArray(t.v1), this.v2.fromArray(t.v2), this;
    }
}, xh = class extends xi {
    constructor(t = new A, e = new A){
        super(), this.isLineCurve3 = !0, this.type = "LineCurve3", this.v1 = t, this.v2 = e;
    }
    getPoint(t, e = new A) {
        let n = e;
        return t === 1 ? n.copy(this.v2) : (n.copy(this.v2).sub(this.v1), n.multiplyScalar(t).add(this.v1)), n;
    }
    getPointAt(t, e) {
        return this.getPoint(t, e);
    }
    copy(t) {
        return super.copy(t), this.v1.copy(t.v1), this.v2.copy(t.v2), this;
    }
    toJSON() {
        let t = super.toJSON();
        return t.v1 = this.v1.toArray(), t.v2 = this.v2.toArray(), t;
    }
    fromJSON(t) {
        return super.fromJSON(t), this.v1.fromArray(t.v1), this.v2.fromArray(t.v2), this;
    }
}, ai = class extends xi {
    constructor(t = new F, e = new F, n = new F){
        super(), this.isQuadraticBezierCurve = !0, this.type = "QuadraticBezierCurve", this.v0 = t, this.v1 = e, this.v2 = n;
    }
    getPoint(t, e = new F) {
        let n = e, i = this.v0, s = this.v1, o = this.v2;
        return n.set(hh(t, i.x, s.x, o.x), hh(t, i.y, s.y, o.y)), n;
    }
    copy(t) {
        return super.copy(t), this.v0.copy(t.v0), this.v1.copy(t.v1), this.v2.copy(t.v2), this;
    }
    toJSON() {
        let t = super.toJSON();
        return t.v0 = this.v0.toArray(), t.v1 = this.v1.toArray(), t.v2 = this.v2.toArray(), t;
    }
    fromJSON(t) {
        return super.fromJSON(t), this.v0.fromArray(t.v0), this.v1.fromArray(t.v1), this.v2.fromArray(t.v2), this;
    }
}, R0 = class extends xi {
    constructor(t = new A, e = new A, n = new A){
        super(), this.isQuadraticBezierCurve3 = !0, this.type = "QuadraticBezierCurve3", this.v0 = t, this.v1 = e, this.v2 = n;
    }
    getPoint(t, e = new A) {
        let n = e, i = this.v0, s = this.v1, o = this.v2;
        return n.set(hh(t, i.x, s.x, o.x), hh(t, i.y, s.y, o.y), hh(t, i.z, s.z, o.z)), n;
    }
    copy(t) {
        return super.copy(t), this.v0.copy(t.v0), this.v1.copy(t.v1), this.v2.copy(t.v2), this;
    }
    toJSON() {
        let t = super.toJSON();
        return t.v0 = this.v0.toArray(), t.v1 = this.v1.toArray(), t.v2 = this.v2.toArray(), t;
    }
    fromJSON(t) {
        return super.fromJSON(t), this.v0.fromArray(t.v0), this.v1.fromArray(t.v1), this.v2.fromArray(t.v2), this;
    }
}, uc = class extends xi {
    constructor(t = []){
        super(), this.isSplineCurve = !0, this.type = "SplineCurve", this.points = t;
    }
    getPoint(t, e = new F) {
        let n = e, i = this.points, s = (i.length - 1) * t, o = Math.floor(s), a = s - o, l = i[o === 0 ? o : o - 1], u = i[o], c = i[o > i.length - 2 ? i.length - 1 : o + 1], d = i[o > i.length - 3 ? i.length - 1 : o + 2];
        return n.set(aA(a, l.x, u.x, c.x, d.x), aA(a, l.y, u.y, c.y, d.y)), n;
    }
    copy(t) {
        super.copy(t), this.points = [];
        for(let e = 0, n = t.points.length; e < n; e++){
            let i = t.points[e];
            this.points.push(i.clone());
        }
        return this;
    }
    toJSON() {
        let t = super.toJSON();
        t.points = [];
        for(let e = 0, n = this.points.length; e < n; e++){
            let i = this.points[e];
            t.points.push(i.toArray());
        }
        return t;
    }
    fromJSON(t) {
        super.fromJSON(t), this.points = [];
        for(let e = 0, n = t.points.length; e < n; e++){
            let i = t.points[e];
            this.points.push(new F().fromArray(i));
        }
        return this;
    }
}, VB = Object.freeze({
    __proto__: null,
    ArcCurve: I0,
    CatmullRomCurve3: O0,
    CubicBezierCurve: Sr,
    CubicBezierCurve3: Qa,
    EllipseCurve: Ya,
    LineCurve: Ar,
    LineCurve3: xh,
    QuadraticBezierCurve: ai,
    QuadraticBezierCurve3: R0,
    SplineCurve: uc
}), bh = class extends xi {
    constructor(){
        super(), this.type = "CurvePath", this.curves = [], this.autoClose = !1;
    }
    add(t) {
        this.curves.push(t);
    }
    closePath() {
        let t = this.curves[0].getPoint(0), e = this.curves[this.curves.length - 1].getPoint(1);
        t.equals(e) || this.curves.push(new Ar(e, t));
    }
    getPoint(t, e) {
        let n = t * this.getLength(), i = this.getCurveLengths(), s = 0;
        for(; s < i.length;){
            if (i[s] >= n) {
                let o = i[s] - n, a = this.curves[s], l = a.getLength(), u = l === 0 ? 0 : 1 - o / l;
                return a.getPointAt(u, e);
            }
            s++;
        }
        return null;
    }
    getLength() {
        let t = this.getCurveLengths();
        return t[t.length - 1];
    }
    updateArcLengths() {
        this.needsUpdate = !0, this.cacheLengths = null, this.getCurveLengths();
    }
    getCurveLengths() {
        if (this.cacheLengths && this.cacheLengths.length === this.curves.length) return this.cacheLengths;
        let t = [], e = 0;
        for(let n = 0, i = this.curves.length; n < i; n++)e += this.curves[n].getLength(), t.push(e);
        return this.cacheLengths = t, t;
    }
    getSpacedPoints(t = 40) {
        let e = [];
        for(let n = 0; n <= t; n++)e.push(this.getPoint(n / t));
        return this.autoClose && e.push(e[0]), e;
    }
    getPoints(t = 12) {
        let e = [], n;
        for(let i = 0, s = this.curves; i < s.length; i++){
            let o = s[i], a = o.isEllipseCurve ? t * 2 : o.isLineCurve || o.isLineCurve3 ? 1 : o.isSplineCurve ? t * o.points.length : t, l = o.getPoints(a);
            for(let u = 0; u < l.length; u++){
                let c = l[u];
                n && n.equals(c) || (e.push(c), n = c);
            }
        }
        return this.autoClose && e.length > 1 && !e[e.length - 1].equals(e[0]) && e.push(e[0]), e;
    }
    copy(t) {
        super.copy(t), this.curves = [];
        for(let e = 0, n = t.curves.length; e < n; e++){
            let i = t.curves[e];
            this.curves.push(i.clone());
        }
        return this.autoClose = t.autoClose, this;
    }
    toJSON() {
        let t = super.toJSON();
        t.autoClose = this.autoClose, t.curves = [];
        for(let e = 0, n = this.curves.length; e < n; e++){
            let i = this.curves[e];
            t.curves.push(i.toJSON());
        }
        return t;
    }
    fromJSON(t) {
        super.fromJSON(t), this.autoClose = t.autoClose, this.curves = [];
        for(let e = 0, n = t.curves.length; e < n; e++){
            let i = t.curves[e];
            this.curves.push(new VB[i.type]().fromJSON(i));
        }
        return this;
    }
}, Ka = class extends bh {
    constructor(t){
        super(), this.type = "Path", this.currentPoint = new F, t && this.setFromPoints(t);
    }
    setFromPoints(t) {
        this.moveTo(t[0].x, t[0].y);
        for(let e = 1, n = t.length; e < n; e++)this.lineTo(t[e].x, t[e].y);
        return this;
    }
    moveTo(t, e) {
        return this.currentPoint.set(t, e), this;
    }
    lineTo(t, e) {
        let n = new Ar(this.currentPoint.clone(), new F(t, e));
        return this.curves.push(n), this.currentPoint.set(t, e), this;
    }
    quadraticCurveTo(t, e, n, i) {
        let s = new ai(this.currentPoint.clone(), new F(t, e), new F(n, i));
        return this.curves.push(s), this.currentPoint.set(n, i), this;
    }
    bezierCurveTo(t, e, n, i, s, o) {
        let a = new Sr(this.currentPoint.clone(), new F(t, e), new F(n, i), new F(s, o));
        return this.curves.push(a), this.currentPoint.set(s, o), this;
    }
    splineThru(t) {
        let e = [
            this.currentPoint.clone()
        ].concat(t), n = new uc(e);
        return this.curves.push(n), this.currentPoint.copy(t[t.length - 1]), this;
    }
    arc(t, e, n, i, s, o) {
        let a = this.currentPoint.x, l = this.currentPoint.y;
        return this.absarc(t + a, e + l, n, i, s, o), this;
    }
    absarc(t, e, n, i, s, o) {
        return this.absellipse(t, e, n, n, i, s, o), this;
    }
    ellipse(t, e, n, i, s, o, a, l) {
        let u = this.currentPoint.x, c = this.currentPoint.y;
        return this.absellipse(t + u, e + c, n, i, s, o, a, l), this;
    }
    absellipse(t, e, n, i, s, o, a, l) {
        let u = new Ya(t, e, n, i, s, o, a, l);
        if (this.curves.length > 0) {
            let d = u.getPoint(0);
            d.equals(this.currentPoint) || this.lineTo(d.x, d.y);
        }
        this.curves.push(u);
        let c = u.getPoint(1);
        return this.currentPoint.copy(c), this;
    }
    copy(t) {
        return super.copy(t), this.currentPoint.copy(t.currentPoint), this;
    }
    toJSON() {
        let t = super.toJSON();
        return t.currentPoint = this.currentPoint.toArray(), t;
    }
    fromJSON(t) {
        return super.fromJSON(t), this.currentPoint.fromArray(t.currentPoint), this;
    }
}, dc = class extends Me {
    constructor(t = [
        new F(0, -0.5),
        new F(.5, 0),
        new F(0, .5)
    ], e = 12, n = 0, i = Math.PI * 2){
        super(), this.type = "LatheGeometry", this.parameters = {
            points: t,
            segments: e,
            phiStart: n,
            phiLength: i
        }, e = Math.floor(e), i = zn(i, 0, Math.PI * 2);
        let s = [], o = [], a = [], l = [], u = [], c = 1 / e, d = new A, h = new F, f = new A, m = new A, p = new A, g = 0, y = 0;
        for(let v = 0; v <= t.length - 1; v++)switch(v){
            case 0:
                g = t[v + 1].x - t[v].x, y = t[v + 1].y - t[v].y, f.x = y * 1, f.y = -g, f.z = y * 0, p.copy(f), f.normalize(), l.push(f.x, f.y, f.z);
                break;
            case t.length - 1:
                l.push(p.x, p.y, p.z);
                break;
            default:
                g = t[v + 1].x - t[v].x, y = t[v + 1].y - t[v].y, f.x = y * 1, f.y = -g, f.z = y * 0, m.copy(f), f.x += p.x, f.y += p.y, f.z += p.z, f.normalize(), l.push(f.x, f.y, f.z), p.copy(m);
        }
        for(let v = 0; v <= e; v++){
            let x = n + v * c * i, w = Math.sin(x), S = Math.cos(x);
            for(let _ = 0; _ <= t.length - 1; _++){
                d.x = t[_].x * w, d.y = t[_].y, d.z = t[_].x * S, o.push(d.x, d.y, d.z), h.x = v / e, h.y = _ / (t.length - 1), a.push(h.x, h.y);
                let M = l[3 * _ + 0] * w, b = l[3 * _ + 1], T = l[3 * _ + 0] * S;
                u.push(M, b, T);
            }
        }
        for(let v = 0; v < e; v++)for(let x = 0; x < t.length - 1; x++){
            let w = x + v * t.length, S = w, _ = w + t.length, M = w + t.length + 1, b = w + 1;
            s.push(S, _, b), s.push(M, b, _);
        }
        this.setIndex(s), this.setAttribute("position", new Ae(o, 3)), this.setAttribute("uv", new Ae(a, 2)), this.setAttribute("normal", new Ae(u, 3));
    }
    static fromJSON(t) {
        return new dc(t.points, t.segments, t.phiStart, t.phiLength);
    }
};
var Za = class extends Me {
    constructor(t = 1, e = 1, n = 1, i = 32, s = 1, o = !1, a = 0, l = Math.PI * 2){
        super(), this.type = "CylinderGeometry", this.parameters = {
            radiusTop: t,
            radiusBottom: e,
            height: n,
            radialSegments: i,
            heightSegments: s,
            openEnded: o,
            thetaStart: a,
            thetaLength: l
        };
        let u = this;
        i = Math.floor(i), s = Math.floor(s);
        let c = [], d = [], h = [], f = [], m = 0, p = [], g = n / 2, y = 0;
        v(), o === !1 && (t > 0 && x(!0), e > 0 && x(!1)), this.setIndex(c), this.setAttribute("position", new Ae(d, 3)), this.setAttribute("normal", new Ae(h, 3)), this.setAttribute("uv", new Ae(f, 2));
        function v() {
            let w = new A, S = new A, _ = 0, M = (e - t) / n;
            for(let b = 0; b <= s; b++){
                let T = [], E = b / s, P = E * (e - t) + t;
                for(let D = 0; D <= i; D++){
                    let C = D / i, O = C * l + a, B = Math.sin(O), V = Math.cos(O);
                    S.x = P * B, S.y = -E * n + g, S.z = P * V, d.push(S.x, S.y, S.z), w.set(B, M, V).normalize(), h.push(w.x, w.y, w.z), f.push(C, 1 - E), T.push(m++);
                }
                p.push(T);
            }
            for(let b = 0; b < i; b++)for(let T = 0; T < s; T++){
                let E = p[T][b], P = p[T + 1][b], D = p[T + 1][b + 1], C = p[T][b + 1];
                c.push(E, P, C), c.push(P, D, C), _ += 6;
            }
            u.addGroup(y, _, 0), y += _;
        }
        function x(w) {
            let S = m, _ = new F, M = new A, b = 0, T = w === !0 ? t : e, E = w === !0 ? 1 : -1;
            for(let D = 1; D <= i; D++)d.push(0, g * E, 0), h.push(0, E, 0), f.push(.5, .5), m++;
            let P = m;
            for(let D = 0; D <= i; D++){
                let O = D / i * l + a, B = Math.cos(O), V = Math.sin(O);
                M.x = T * V, M.y = g * E, M.z = T * B, d.push(M.x, M.y, M.z), h.push(0, E, 0), _.x = B * .5 + .5, _.y = V * .5 * E + .5, f.push(_.x, _.y), m++;
            }
            for(let D = 0; D < i; D++){
                let C = S + D, O = P + D;
                w === !0 ? c.push(O, O + 1, C) : c.push(O + 1, O, C), b += 3;
            }
            u.addGroup(y, b, w === !0 ? 1 : 2), y += b;
        }
    }
    static fromJSON(t) {
        return new Za(t.radiusTop, t.radiusBottom, t.height, t.radialSegments, t.heightSegments, t.openEnded, t.thetaStart, t.thetaLength);
    }
}, hc = class extends Za {
    constructor(t = 1, e = 1, n = 32, i = 1, s = !1, o = 0, a = Math.PI * 2){
        super(0, t, e, n, i, s, o, a), this.type = "ConeGeometry", this.parameters = {
            radius: t,
            height: e,
            radialSegments: n,
            heightSegments: i,
            openEnded: s,
            thetaStart: o,
            thetaLength: a
        };
    }
    static fromJSON(t) {
        return new hc(t.radius, t.height, t.radialSegments, t.heightSegments, t.openEnded, t.thetaStart, t.thetaLength);
    }
}, fc = class extends Me {
    constructor(t = [], e = [], n = 1, i = 0){
        super(), this.type = "PolyhedronGeometry", this.parameters = {
            vertices: t,
            indices: e,
            radius: n,
            detail: i
        };
        let s = [], o = [];
        a(i), u(n), c(), this.setAttribute("position", new Ae(s, 3)), this.setAttribute("normal", new Ae(s.slice(), 3)), this.setAttribute("uv", new Ae(o, 2)), i === 0 ? this.computeVertexNormals() : this.normalizeNormals();
        function a(v) {
            let x = new A, w = new A, S = new A;
            for(let _ = 0; _ < e.length; _ += 3)f(e[_ + 0], x), f(e[_ + 1], w), f(e[_ + 2], S), l(x, w, S, v);
        }
        function l(v, x, w, S) {
            let _ = S + 1, M = [];
            for(let b = 0; b <= _; b++){
                M[b] = [];
                let T = v.clone().lerp(w, b / _), E = x.clone().lerp(w, b / _), P = _ - b;
                for(let D = 0; D <= P; D++)D === 0 && b === _ ? M[b][D] = T : M[b][D] = T.clone().lerp(E, D / P);
            }
            for(let b = 0; b < _; b++)for(let T = 0; T < 2 * (_ - b) - 1; T++){
                let E = Math.floor(T / 2);
                T % 2 === 0 ? (h(M[b][E + 1]), h(M[b + 1][E]), h(M[b][E])) : (h(M[b][E + 1]), h(M[b + 1][E + 1]), h(M[b + 1][E]));
            }
        }
        function u(v) {
            let x = new A;
            for(let w = 0; w < s.length; w += 3)x.x = s[w + 0], x.y = s[w + 1], x.z = s[w + 2], x.normalize().multiplyScalar(v), s[w + 0] = x.x, s[w + 1] = x.y, s[w + 2] = x.z;
        }
        function c() {
            let v = new A;
            for(let x = 0; x < s.length; x += 3){
                v.x = s[x + 0], v.y = s[x + 1], v.z = s[x + 2];
                let w = g(v) / 2 / Math.PI + .5, S = y(v) / Math.PI + .5;
                o.push(w, 1 - S);
            }
            m(), d();
        }
        function d() {
            for(let v = 0; v < o.length; v += 6){
                let x = o[v + 0], w = o[v + 2], S = o[v + 4], _ = Math.max(x, w, S), M = Math.min(x, w, S);
                _ > .9 && M < .1 && (x < .2 && (o[v + 0] += 1), w < .2 && (o[v + 2] += 1), S < .2 && (o[v + 4] += 1));
            }
        }
        function h(v) {
            s.push(v.x, v.y, v.z);
        }
        function f(v, x) {
            let w = v * 3;
            x.x = t[w + 0], x.y = t[w + 1], x.z = t[w + 2];
        }
        function m() {
            let v = new A, x = new A, w = new A, S = new A, _ = new F, M = new F, b = new F;
            for(let T = 0, E = 0; T < s.length; T += 9, E += 6){
                v.set(s[T + 0], s[T + 1], s[T + 2]), x.set(s[T + 3], s[T + 4], s[T + 5]), w.set(s[T + 6], s[T + 7], s[T + 8]), _.set(o[E + 0], o[E + 1]), M.set(o[E + 2], o[E + 3]), b.set(o[E + 4], o[E + 5]), S.copy(v).add(x).add(w).divideScalar(3);
                let P = g(S);
                p(_, E + 0, v, P), p(M, E + 2, x, P), p(b, E + 4, w, P);
            }
        }
        function p(v, x, w, S) {
            S < 0 && v.x === 1 && (o[x] = v.x - 1), w.x === 0 && w.z === 0 && (o[x] = S / 2 / Math.PI + .5);
        }
        function g(v) {
            return Math.atan2(v.z, -v.x);
        }
        function y(v) {
            return Math.atan2(-v.y, Math.sqrt(v.x * v.x + v.z * v.z));
        }
    }
    static fromJSON(t) {
        return new fc(t.vertices, t.indices, t.radius, t.details);
    }
}, pc = class extends fc {
    constructor(t = 1, e = 0){
        let n = (1 + Math.sqrt(5)) / 2, i = 1 / n, s = [
            -1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            1,
            1,
            1,
            0,
            -i,
            -n,
            0,
            -i,
            n,
            0,
            i,
            -n,
            0,
            i,
            n,
            -i,
            -n,
            0,
            -i,
            n,
            0,
            i,
            -n,
            0,
            i,
            n,
            0,
            -n,
            0,
            -i,
            n,
            0,
            -i,
            -n,
            0,
            i,
            n,
            0,
            i
        ], o = [
            3,
            11,
            7,
            3,
            7,
            15,
            3,
            15,
            13,
            7,
            19,
            17,
            7,
            17,
            6,
            7,
            6,
            15,
            17,
            4,
            8,
            17,
            8,
            10,
            17,
            10,
            6,
            8,
            0,
            16,
            8,
            16,
            2,
            8,
            2,
            10,
            0,
            12,
            1,
            0,
            1,
            18,
            0,
            18,
            16,
            6,
            10,
            2,
            6,
            2,
            13,
            6,
            13,
            15,
            2,
            16,
            18,
            2,
            18,
            3,
            2,
            3,
            13,
            18,
            1,
            9,
            18,
            9,
            11,
            18,
            11,
            3,
            4,
            14,
            12,
            4,
            12,
            0,
            4,
            0,
            8,
            11,
            9,
            5,
            11,
            5,
            19,
            11,
            19,
            7,
            19,
            5,
            14,
            19,
            14,
            4,
            19,
            4,
            17,
            1,
            12,
            14,
            1,
            14,
            5,
            1,
            5,
            9
        ];
        super(s, o, t, e), this.type = "DodecahedronGeometry", this.parameters = {
            radius: t,
            detail: e
        };
    }
    static fromJSON(t) {
        return new pc(t.radius, t.detail);
    }
};
var oo = class extends Ka {
    constructor(t){
        super(t), this.uuid = gs(), this.type = "Shape", this.holes = [];
    }
    getPointsHoles(t) {
        let e = [];
        for(let n = 0, i = this.holes.length; n < i; n++)e[n] = this.holes[n].getPoints(t);
        return e;
    }
    extractPoints(t) {
        return {
            shape: this.getPoints(t),
            holes: this.getPointsHoles(t)
        };
    }
    copy(t) {
        super.copy(t), this.holes = [];
        for(let e = 0, n = t.holes.length; e < n; e++){
            let i = t.holes[e];
            this.holes.push(i.clone());
        }
        return this;
    }
    toJSON() {
        let t = super.toJSON();
        t.uuid = this.uuid, t.holes = [];
        for(let e = 0, n = this.holes.length; e < n; e++){
            let i = this.holes[e];
            t.holes.push(i.toJSON());
        }
        return t;
    }
    fromJSON(t) {
        super.fromJSON(t), this.uuid = t.uuid, this.holes = [];
        for(let e = 0, n = t.holes.length; e < n; e++){
            let i = t.holes[e];
            this.holes.push(new Ka().fromJSON(i));
        }
        return this;
    }
}, HB = {
    triangulate: function(r1, t, e = 2) {
        let n = t && t.length, i = n ? t[0] * e : r1.length, s = NA(r1, 0, i, e, !0), o = [];
        if (!s || s.next === s.prev) return o;
        let a, l, u, c, d, h, f;
        if (n && (s = YB(r1, t, s, e)), r1.length > 80 * e) {
            a = u = r1[0], l = c = r1[1];
            for(let m = e; m < i; m += e)d = r1[m], h = r1[m + 1], d < a && (a = d), h < l && (l = h), d > u && (u = d), h > c && (c = h);
            f = Math.max(u - a, c - l), f = f !== 0 ? 32767 / f : 0;
        }
        return wh(s, o, e, a, l, f, 0), o;
    }
};
function NA(r1, t, e, n, i) {
    let s, o;
    if (i === sF(r1, t, e, n) > 0) for(s = t; s < e; s += n)o = lA(s, r1[s], r1[s + 1], o);
    else for(s = e - n; s >= t; s -= n)o = lA(s, r1[s], r1[s + 1], o);
    return o && sm(o, o.next) && (Ah(o), o = o.next), o;
}
function Ja(r1, t) {
    if (!r1) return r1;
    t || (t = r1);
    let e = r1, n;
    do if (n = !1, !e.steiner && (sm(e, e.next) || rn(e.prev, e, e.next) === 0)) {
        if (Ah(e), e = t = e.prev, e === e.next) break;
        n = !0;
    } else e = e.next;
    while (n || e !== t);
    return t;
}
function wh(r1, t, e, n, i, s, o) {
    if (!r1) return;
    !o && s && $B(r1, n, i, s);
    let a = r1, l, u;
    for(; r1.prev !== r1.next;){
        if (l = r1.prev, u = r1.next, s ? jB(r1, n, i, s) : WB(r1)) {
            t.push(l.i / e | 0), t.push(r1.i / e | 0), t.push(u.i / e | 0), Ah(r1), r1 = u.next, a = u.next;
            continue;
        }
        if (r1 = u, r1 === a) {
            o ? o === 1 ? (r1 = qB(Ja(r1), t, e), wh(r1, t, e, n, i, s, 2)) : o === 2 && XB(r1, t, e, n, i, s) : wh(Ja(r1), t, e, n, i, s, 1);
            break;
        }
    }
}
function WB(r1) {
    let t = r1.prev, e = r1, n = r1.next;
    if (rn(t, e, n) >= 0) return !1;
    let i = t.x, s = e.x, o = n.x, a = t.y, l = e.y, u = n.y, c = i < s ? i < o ? i : o : s < o ? s : o, d = a < l ? a < u ? a : u : l < u ? l : u, h = i > s ? i > o ? i : o : s > o ? s : o, f = a > l ? a > u ? a : u : l > u ? l : u, m = n.next;
    for(; m !== t;){
        if (m.x >= c && m.x <= h && m.y >= d && m.y <= f && ic(i, a, s, l, o, u, m.x, m.y) && rn(m.prev, m, m.next) >= 0) return !1;
        m = m.next;
    }
    return !0;
}
function jB(r1, t, e, n) {
    let i = r1.prev, s = r1, o = r1.next;
    if (rn(i, s, o) >= 0) return !1;
    let a = i.x, l = s.x, u = o.x, c = i.y, d = s.y, h = o.y, f = a < l ? a < u ? a : u : l < u ? l : u, m = c < d ? c < h ? c : h : d < h ? d : h, p = a > l ? a > u ? a : u : l > u ? l : u, g = c > d ? c > h ? c : h : d > h ? d : h, y = L0(f, m, t, e, n), v = L0(p, g, t, e, n), x = r1.prevZ, w = r1.nextZ;
    for(; x && x.z >= y && w && w.z <= v;){
        if (x.x >= f && x.x <= p && x.y >= m && x.y <= g && x !== i && x !== o && ic(a, c, l, d, u, h, x.x, x.y) && rn(x.prev, x, x.next) >= 0 || (x = x.prevZ, w.x >= f && w.x <= p && w.y >= m && w.y <= g && w !== i && w !== o && ic(a, c, l, d, u, h, w.x, w.y) && rn(w.prev, w, w.next) >= 0)) return !1;
        w = w.nextZ;
    }
    for(; x && x.z >= y;){
        if (x.x >= f && x.x <= p && x.y >= m && x.y <= g && x !== i && x !== o && ic(a, c, l, d, u, h, x.x, x.y) && rn(x.prev, x, x.next) >= 0) return !1;
        x = x.prevZ;
    }
    for(; w && w.z <= v;){
        if (w.x >= f && w.x <= p && w.y >= m && w.y <= g && w !== i && w !== o && ic(a, c, l, d, u, h, w.x, w.y) && rn(w.prev, w, w.next) >= 0) return !1;
        w = w.nextZ;
    }
    return !0;
}
function qB(r1, t, e) {
    let n = r1;
    do {
        let i = n.prev, s = n.next.next;
        !sm(i, s) && BA(i, n, n.next, s) && Sh(i, s) && Sh(s, i) && (t.push(i.i / e | 0), t.push(n.i / e | 0), t.push(s.i / e | 0), Ah(n), Ah(n.next), n = r1 = s), n = n.next;
    }while (n !== r1);
    return Ja(n);
}
function XB(r1, t, e, n, i, s) {
    let o = r1;
    do {
        let a = o.next.next;
        for(; a !== o.prev;){
            if (o.i !== a.i && nF(o, a)) {
                let l = FA(o, a);
                o = Ja(o, o.next), l = Ja(l, l.next), wh(o, t, e, n, i, s, 0), wh(l, t, e, n, i, s, 0);
                return;
            }
            a = a.next;
        }
        o = o.next;
    }while (o !== r1);
}
function YB(r1, t, e, n) {
    let i = [], s, o, a, l, u;
    for(s = 0, o = t.length; s < o; s++)a = t[s] * n, l = s < o - 1 ? t[s + 1] * n : r1.length, u = NA(r1, a, l, n, !1), u === u.next && (u.steiner = !0), i.push(tF(u));
    for(i.sort(QB), s = 0; s < i.length; s++)e = KB(i[s], e);
    return e;
}
function QB(r1, t) {
    return r1.x - t.x;
}
function KB(r1, t) {
    let e = ZB(r1, t);
    if (!e) return t;
    let n = FA(e, r1);
    return Ja(n, n.next), Ja(e, e.next);
}
function ZB(r1, t) {
    let e = t, n = -1 / 0, i, s = r1.x, o = r1.y;
    do {
        if (o <= e.y && o >= e.next.y && e.next.y !== e.y) {
            let h = e.x + (o - e.y) * (e.next.x - e.x) / (e.next.y - e.y);
            if (h <= s && h > n && (n = h, i = e.x < e.next.x ? e : e.next, h === s)) return i;
        }
        e = e.next;
    }while (e !== t);
    if (!i) return null;
    let a = i, l = i.x, u = i.y, c = 1 / 0, d;
    e = i;
    do s >= e.x && e.x >= l && s !== e.x && ic(o < u ? s : n, o, l, u, o < u ? n : s, o, e.x, e.y) && (d = Math.abs(o - e.y) / (s - e.x), Sh(e, r1) && (d < c || d === c && (e.x > i.x || e.x === i.x && JB(i, e))) && (i = e, c = d)), e = e.next;
    while (e !== a);
    return i;
}
function JB(r1, t) {
    return rn(r1.prev, r1, t.prev) < 0 && rn(t.next, r1, r1.next) < 0;
}
function $B(r1, t, e, n) {
    let i = r1;
    do i.z === 0 && (i.z = L0(i.x, i.y, t, e, n)), i.prevZ = i.prev, i.nextZ = i.next, i = i.next;
    while (i !== r1);
    i.prevZ.nextZ = null, i.prevZ = null, eF(i);
}
function eF(r1) {
    let t, e, n, i, s, o, a, l, u = 1;
    do {
        for(e = r1, r1 = null, s = null, o = 0; e;){
            for(o++, n = e, a = 0, t = 0; t < u && (a++, n = n.nextZ, !!n); t++);
            for(l = u; a > 0 || l > 0 && n;)a !== 0 && (l === 0 || !n || e.z <= n.z) ? (i = e, e = e.nextZ, a--) : (i = n, n = n.nextZ, l--), s ? s.nextZ = i : r1 = i, i.prevZ = s, s = i;
            e = n;
        }
        s.nextZ = null, u *= 2;
    }while (o > 1);
    return r1;
}
function L0(r1, t, e, n, i) {
    return r1 = (r1 - e) * i | 0, t = (t - n) * i | 0, r1 = (r1 | r1 << 8) & 16711935, r1 = (r1 | r1 << 4) & 252645135, r1 = (r1 | r1 << 2) & 858993459, r1 = (r1 | r1 << 1) & 1431655765, t = (t | t << 8) & 16711935, t = (t | t << 4) & 252645135, t = (t | t << 2) & 858993459, t = (t | t << 1) & 1431655765, r1 | t << 1;
}
function tF(r1) {
    let t = r1, e = r1;
    do (t.x < e.x || t.x === e.x && t.y < e.y) && (e = t), t = t.next;
    while (t !== r1);
    return e;
}
function ic(r1, t, e, n, i, s, o, a) {
    return (i - o) * (t - a) >= (r1 - o) * (s - a) && (r1 - o) * (n - a) >= (e - o) * (t - a) && (e - o) * (s - a) >= (i - o) * (n - a);
}
function nF(r1, t) {
    return r1.next.i !== t.i && r1.prev.i !== t.i && !rF(r1, t) && (Sh(r1, t) && Sh(t, r1) && iF(r1, t) && (rn(r1.prev, r1, t.prev) || rn(r1, t.prev, t)) || sm(r1, t) && rn(r1.prev, r1, r1.next) > 0 && rn(t.prev, t, t.next) > 0);
}
function rn(r1, t, e) {
    return (t.y - r1.y) * (e.x - t.x) - (t.x - r1.x) * (e.y - t.y);
}
function sm(r1, t) {
    return r1.x === t.x && r1.y === t.y;
}
function BA(r1, t, e, n) {
    let i = Ep(rn(r1, t, e)), s = Ep(rn(r1, t, n)), o = Ep(rn(e, n, r1)), a = Ep(rn(e, n, t));
    return !!(i !== s && o !== a || i === 0 && Tp(r1, e, t) || s === 0 && Tp(r1, n, t) || o === 0 && Tp(e, r1, n) || a === 0 && Tp(e, t, n));
}
function Tp(r1, t, e) {
    return t.x <= Math.max(r1.x, e.x) && t.x >= Math.min(r1.x, e.x) && t.y <= Math.max(r1.y, e.y) && t.y >= Math.min(r1.y, e.y);
}
function Ep(r1) {
    return r1 > 0 ? 1 : r1 < 0 ? -1 : 0;
}
function rF(r1, t) {
    let e = r1;
    do {
        if (e.i !== r1.i && e.next.i !== r1.i && e.i !== t.i && e.next.i !== t.i && BA(e, e.next, r1, t)) return !0;
        e = e.next;
    }while (e !== r1);
    return !1;
}
function Sh(r1, t) {
    return rn(r1.prev, r1, r1.next) < 0 ? rn(r1, t, r1.next) >= 0 && rn(r1, r1.prev, t) >= 0 : rn(r1, t, r1.prev) < 0 || rn(r1, r1.next, t) < 0;
}
function iF(r1, t) {
    let e = r1, n = !1, i = (r1.x + t.x) / 2, s = (r1.y + t.y) / 2;
    do e.y > s != e.next.y > s && e.next.y !== e.y && i < (e.next.x - e.x) * (s - e.y) / (e.next.y - e.y) + e.x && (n = !n), e = e.next;
    while (e !== r1);
    return n;
}
function FA(r1, t) {
    let e = new N0(r1.i, r1.x, r1.y), n = new N0(t.i, t.x, t.y), i = r1.next, s = t.prev;
    return r1.next = t, t.prev = r1, e.next = i, i.prev = e, n.next = e, e.prev = n, s.next = n, n.prev = s, n;
}
function lA(r1, t, e, n) {
    let i = new N0(r1, t, e);
    return n ? (i.next = n.next, i.prev = n, n.next.prev = i, n.next = i) : (i.prev = i, i.next = i), i;
}
function Ah(r1) {
    r1.next.prev = r1.prev, r1.prev.next = r1.next, r1.prevZ && (r1.prevZ.nextZ = r1.nextZ), r1.nextZ && (r1.nextZ.prevZ = r1.prevZ);
}
function N0(r1, t, e) {
    this.i = r1, this.x = t, this.y = e, this.prev = null, this.next = null, this.z = 0, this.prevZ = null, this.nextZ = null, this.steiner = !1;
}
function sF(r1, t, e, n) {
    let i = 0;
    for(let s = t, o = e - n; s < e; s += n)i += (r1[o] - r1[s]) * (r1[s + 1] + r1[o + 1]), o = s;
    return i;
}
var mc = class {
    static area(t) {
        let e = t.length, n = 0;
        for(let i = e - 1, s = 0; s < e; i = s++)n += t[i].x * t[s].y - t[s].x * t[i].y;
        return n * .5;
    }
    static isClockWise(t) {
        return mc.area(t) < 0;
    }
    static triangulateShape(t, e) {
        let n = [], i = [], s = [];
        cA(t), uA(n, t);
        let o = t.length;
        e.forEach(cA);
        for(let l = 0; l < e.length; l++)i.push(o), o += e[l].length, uA(n, e[l]);
        let a = HB.triangulate(n, i);
        for(let l = 0; l < a.length; l += 3)s.push(a.slice(l, l + 3));
        return s;
    }
};
function cA(r1) {
    let t = r1.length;
    t > 2 && r1[t - 1].equals(r1[0]) && r1.pop();
}
function uA(r1, t) {
    for(let e = 0; e < t.length; e++)r1.push(t[e].x), r1.push(t[e].y);
}
var gc = class extends fc {
    constructor(t = 1, e = 0){
        let n = (1 + Math.sqrt(5)) / 2, i = [
            -1,
            n,
            0,
            1,
            n,
            0,
            -1,
            -n,
            0,
            1,
            -n,
            0,
            0,
            -1,
            n,
            0,
            1,
            n,
            0,
            -1,
            -n,
            0,
            1,
            -n,
            n,
            0,
            -1,
            n,
            0,
            1,
            -n,
            0,
            -1,
            -n,
            0,
            1
        ], s = [
            0,
            11,
            5,
            0,
            5,
            1,
            0,
            1,
            7,
            0,
            7,
            10,
            0,
            10,
            11,
            1,
            5,
            9,
            5,
            11,
            4,
            11,
            10,
            2,
            10,
            7,
            6,
            7,
            1,
            8,
            3,
            9,
            4,
            3,
            4,
            2,
            3,
            2,
            6,
            3,
            6,
            8,
            3,
            8,
            9,
            4,
            9,
            5,
            2,
            4,
            11,
            6,
            2,
            10,
            8,
            6,
            7,
            9,
            8,
            1
        ];
        super(i, s, t, e), this.type = "IcosahedronGeometry", this.parameters = {
            radius: t,
            detail: e
        };
    }
    static fromJSON(t) {
        return new gc(t.radius, t.detail);
    }
};
var $a = class extends Me {
    constructor(t = 1, e = 32, n = 16, i = 0, s = Math.PI * 2, o = 0, a = Math.PI){
        super(), this.type = "SphereGeometry", this.parameters = {
            radius: t,
            widthSegments: e,
            heightSegments: n,
            phiStart: i,
            phiLength: s,
            thetaStart: o,
            thetaLength: a
        }, e = Math.max(3, Math.floor(e)), n = Math.max(2, Math.floor(n));
        let l = Math.min(o + a, Math.PI), u = 0, c = [], d = new A, h = new A, f = [], m = [], p = [], g = [];
        for(let y = 0; y <= n; y++){
            let v = [], x = y / n, w = 0;
            y == 0 && o == 0 ? w = .5 / e : y == n && l == Math.PI && (w = -0.5 / e);
            for(let S = 0; S <= e; S++){
                let _ = S / e;
                d.x = -t * Math.cos(i + _ * s) * Math.sin(o + x * a), d.y = t * Math.cos(o + x * a), d.z = t * Math.sin(i + _ * s) * Math.sin(o + x * a), m.push(d.x, d.y, d.z), h.copy(d).normalize(), p.push(h.x, h.y, h.z), g.push(_ + w, 1 - x), v.push(u++);
            }
            c.push(v);
        }
        for(let y = 0; y < n; y++)for(let v = 0; v < e; v++){
            let x = c[y][v + 1], w = c[y][v], S = c[y + 1][v], _ = c[y + 1][v + 1];
            (y !== 0 || o > 0) && f.push(x, w, _), (y !== n - 1 || l < Math.PI) && f.push(w, S, _);
        }
        this.setIndex(f), this.setAttribute("position", new Ae(m, 3)), this.setAttribute("normal", new Ae(p, 3)), this.setAttribute("uv", new Ae(g, 2));
    }
    static fromJSON(t) {
        return new $a(t.radius, t.widthSegments, t.heightSegments, t.phiStart, t.phiLength, t.thetaStart, t.thetaLength);
    }
};
var yc = class extends Me {
    constructor(t = 1, e = .4, n = 64, i = 8, s = 2, o = 3){
        super(), this.type = "TorusKnotGeometry", this.parameters = {
            radius: t,
            tube: e,
            tubularSegments: n,
            radialSegments: i,
            p: s,
            q: o
        }, n = Math.floor(n), i = Math.floor(i);
        let a = [], l = [], u = [], c = [], d = new A, h = new A, f = new A, m = new A, p = new A, g = new A, y = new A;
        for(let x = 0; x <= n; ++x){
            let w = x / n * s * Math.PI * 2;
            v(w, s, o, t, f), v(w + .01, s, o, t, m), g.subVectors(m, f), y.addVectors(m, f), p.crossVectors(g, y), y.crossVectors(p, g), p.normalize(), y.normalize();
            for(let S = 0; S <= i; ++S){
                let _ = S / i * Math.PI * 2, M = -e * Math.cos(_), b = e * Math.sin(_);
                d.x = f.x + (M * y.x + b * p.x), d.y = f.y + (M * y.y + b * p.y), d.z = f.z + (M * y.z + b * p.z), l.push(d.x, d.y, d.z), h.subVectors(d, f).normalize(), u.push(h.x, h.y, h.z), c.push(x / n), c.push(S / i);
            }
        }
        for(let x = 1; x <= n; x++)for(let w = 1; w <= i; w++){
            let S = (i + 1) * (x - 1) + (w - 1), _ = (i + 1) * x + (w - 1), M = (i + 1) * x + w, b = (i + 1) * (x - 1) + w;
            a.push(S, _, b), a.push(_, M, b);
        }
        this.setIndex(a), this.setAttribute("position", new Ae(l, 3)), this.setAttribute("normal", new Ae(u, 3)), this.setAttribute("uv", new Ae(c, 2));
        function v(x, w, S, _, M) {
            let b = Math.cos(x), T = Math.sin(x), E = S / w * x, P = Math.cos(E);
            M.x = _ * (2 + P) * .5 * b, M.y = _ * (2 + P) * T * .5, M.z = _ * Math.sin(E) * .5;
        }
    }
    static fromJSON(t) {
        return new yc(t.radius, t.tube, t.tubularSegments, t.radialSegments, t.p, t.q);
    }
};
function zo(r1, t, e) {
    return UA(r1) ? new r1.constructor(r1.subarray(t, e !== void 0 ? e : r1.length)) : r1.slice(t, e);
}
function Cp(r1, t, e) {
    return !r1 || !e && r1.constructor === t ? r1 : typeof t.BYTES_PER_ELEMENT == "number" ? new t(r1) : Array.prototype.slice.call(r1);
}
function UA(r1) {
    return ArrayBuffer.isView(r1) && !(r1 instanceof DataView);
}
var vc = class {
    constructor(t, e, n, i){
        this.parameterPositions = t, this._cachedIndex = 0, this.resultBuffer = i !== void 0 ? i : new e.constructor(n), this.sampleValues = e, this.valueSize = n, this.settings = null, this.DefaultSettings_ = {};
    }
    evaluate(t) {
        let e = this.parameterPositions, n = this._cachedIndex, i = e[n], s = e[n - 1];
        n: {
            e: {
                let o;
                t: {
                    r: if (!(t < i)) {
                        for(let a = n + 2;;){
                            if (i === void 0) {
                                if (t < s) break r;
                                return n = e.length, this._cachedIndex = n, this.copySampleValue_(n - 1);
                            }
                            if (n === a) break;
                            if (s = i, i = e[++n], t < i) break e;
                        }
                        o = e.length;
                        break t;
                    }
                    if (!(t >= s)) {
                        let a = e[1];
                        t < a && (n = 2, s = a);
                        for(let l = n - 2;;){
                            if (s === void 0) return this._cachedIndex = 0, this.copySampleValue_(0);
                            if (n === l) break;
                            if (i = s, s = e[--n - 1], t >= s) break e;
                        }
                        o = n, n = 0;
                        break t;
                    }
                    break n;
                }
                for(; n < o;){
                    let a = n + o >>> 1;
                    t < e[a] ? o = a : n = a + 1;
                }
                if (i = e[n], s = e[n - 1], s === void 0) return this._cachedIndex = 0, this.copySampleValue_(0);
                if (i === void 0) return n = e.length, this._cachedIndex = n, this.copySampleValue_(n - 1);
            }
            this._cachedIndex = n, this.intervalChanged_(n, s, i);
        }
        return this.interpolate_(n, s, t, i);
    }
    getSettings_() {
        return this.settings || this.DefaultSettings_;
    }
    copySampleValue_(t) {
        let e = this.resultBuffer, n = this.sampleValues, i = this.valueSize, s = t * i;
        for(let o = 0; o !== i; ++o)e[o] = n[s + o];
        return e;
    }
    interpolate_() {
        throw new Error("call to abstract method");
    }
    intervalChanged_() {}
}, B0 = class extends vc {
    constructor(t, e, n, i){
        super(t, e, n, i), this._weightPrev = -0, this._offsetPrev = -0, this._weightNext = -0, this._offsetNext = -0, this.DefaultSettings_ = {
            endingStart: b1,
            endingEnd: b1
        };
    }
    intervalChanged_(t, e, n) {
        let i = this.parameterPositions, s = t - 2, o = t + 1, a = i[s], l = i[o];
        if (a === void 0) switch(this.getSettings_().endingStart){
            case w1:
                s = t, a = 2 * e - n;
                break;
            case S1:
                s = i.length - 2, a = e + i[s] - i[s + 1];
                break;
            default:
                s = t, a = n;
        }
        if (l === void 0) switch(this.getSettings_().endingEnd){
            case w1:
                o = t, l = 2 * n - e;
                break;
            case S1:
                o = 1, l = n + i[1] - i[0];
                break;
            default:
                o = t - 1, l = e;
        }
        let u = (n - e) * .5, c = this.valueSize;
        this._weightPrev = u / (e - a), this._weightNext = u / (l - n), this._offsetPrev = s * c, this._offsetNext = o * c;
    }
    interpolate_(t, e, n, i) {
        let s = this.resultBuffer, o = this.sampleValues, a = this.valueSize, l = t * a, u = l - a, c = this._offsetPrev, d = this._offsetNext, h = this._weightPrev, f = this._weightNext, m = (n - e) / (i - e), p = m * m, g = p * m, y = -h * g + 2 * h * p - h * m, v = (1 + h) * g + (-1.5 - 2 * h) * p + (-0.5 + h) * m + 1, x = (-1 - f) * g + (1.5 + f) * p + .5 * m, w = f * g - f * p;
        for(let S = 0; S !== a; ++S)s[S] = y * o[c + S] + v * o[u + S] + x * o[l + S] + w * o[d + S];
        return s;
    }
}, F0 = class extends vc {
    constructor(t, e, n, i){
        super(t, e, n, i);
    }
    interpolate_(t, e, n, i) {
        let s = this.resultBuffer, o = this.sampleValues, a = this.valueSize, l = t * a, u = l - a, c = (n - e) / (i - e), d = 1 - c;
        for(let h = 0; h !== a; ++h)s[h] = o[u + h] * d + o[l + h] * c;
        return s;
    }
}, U0 = class extends vc {
    constructor(t, e, n, i){
        super(t, e, n, i);
    }
    interpolate_(t) {
        return this.copySampleValue_(t - 1);
    }
}, zi = class {
    constructor(t, e, n, i){
        if (t === void 0) throw new Error("THREE.KeyframeTrack: track name is undefined");
        if (e === void 0 || e.length === 0) throw new Error("THREE.KeyframeTrack: no keyframes in track named " + t);
        this.name = t, this.times = Cp(e, this.TimeBufferType), this.values = Cp(n, this.ValueBufferType), this.setInterpolation(i || this.DefaultInterpolation);
    }
    static toJSON(t) {
        let e = t.constructor, n;
        if (e.toJSON !== this.toJSON) n = e.toJSON(t);
        else {
            n = {
                name: t.name,
                times: Cp(t.times, Array),
                values: Cp(t.values, Array)
            };
            let i = t.getInterpolation();
            i !== t.DefaultInterpolation && (n.interpolation = i);
        }
        return n.type = t.ValueTypeName, n;
    }
    InterpolantFactoryMethodDiscrete(t) {
        return new U0(this.times, this.values, this.getValueSize(), t);
    }
    InterpolantFactoryMethodLinear(t) {
        return new F0(this.times, this.values, this.getValueSize(), t);
    }
    InterpolantFactoryMethodSmooth(t) {
        return new B0(this.times, this.values, this.getValueSize(), t);
    }
    setInterpolation(t) {
        let e;
        switch(t){
            case Rp:
                e = this.InterpolantFactoryMethodDiscrete;
                break;
            case Lp:
                e = this.InterpolantFactoryMethodLinear;
                break;
            case Nv:
                e = this.InterpolantFactoryMethodSmooth;
                break;
        }
        if (e === void 0) {
            let n = "unsupported interpolation for " + this.ValueTypeName + " keyframe track named " + this.name;
            if (this.createInterpolant === void 0) {
                if (t !== this.DefaultInterpolation) this.setInterpolation(this.DefaultInterpolation);
                else throw new Error(n);
            }
            return console.warn("THREE.KeyframeTrack:", n), this;
        }
        return this.createInterpolant = e, this;
    }
    getInterpolation() {
        switch(this.createInterpolant){
            case this.InterpolantFactoryMethodDiscrete:
                return Rp;
            case this.InterpolantFactoryMethodLinear:
                return Lp;
            case this.InterpolantFactoryMethodSmooth:
                return Nv;
        }
    }
    getValueSize() {
        return this.values.length / this.times.length;
    }
    shift(t) {
        if (t !== 0) {
            let e = this.times;
            for(let n = 0, i = e.length; n !== i; ++n)e[n] += t;
        }
        return this;
    }
    scale(t) {
        if (t !== 1) {
            let e = this.times;
            for(let n = 0, i = e.length; n !== i; ++n)e[n] *= t;
        }
        return this;
    }
    trim(t, e) {
        let n = this.times, i = n.length, s = 0, o = i - 1;
        for(; s !== i && n[s] < t;)++s;
        for(; o !== -1 && n[o] > e;)--o;
        if (++o, s !== 0 || o !== i) {
            s >= o && (o = Math.max(o, 1), s = o - 1);
            let a = this.getValueSize();
            this.times = zo(n, s, o), this.values = zo(this.values, s * a, o * a);
        }
        return this;
    }
    validate() {
        let t = !0, e = this.getValueSize();
        e - Math.floor(e) !== 0 && (console.error("THREE.KeyframeTrack: Invalid value size in track.", this), t = !1);
        let n = this.times, i = this.values, s = n.length;
        s === 0 && (console.error("THREE.KeyframeTrack: Track is empty.", this), t = !1);
        let o = null;
        for(let a = 0; a !== s; a++){
            let l = n[a];
            if (typeof l == "number" && isNaN(l)) {
                console.error("THREE.KeyframeTrack: Time is not a valid number.", this, a, l), t = !1;
                break;
            }
            if (o !== null && o > l) {
                console.error("THREE.KeyframeTrack: Out of order keys.", this, a, l, o), t = !1;
                break;
            }
            o = l;
        }
        if (i !== void 0 && UA(i)) for(let a = 0, l = i.length; a !== l; ++a){
            let u = i[a];
            if (isNaN(u)) {
                console.error("THREE.KeyframeTrack: Value is not a valid number.", this, a, u), t = !1;
                break;
            }
        }
        return t;
    }
    optimize() {
        let t = zo(this.times), e = zo(this.values), n = this.getValueSize(), i = this.getInterpolation() === Nv, s = t.length - 1, o = 1;
        for(let a = 1; a < s; ++a){
            let l = !1, u = t[a], c = t[a + 1];
            if (u !== c && (a !== 1 || u !== t[0])) {
                if (i) l = !0;
                else {
                    let d = a * n, h = d - n, f = d + n;
                    for(let m = 0; m !== n; ++m){
                        let p = e[d + m];
                        if (p !== e[h + m] || p !== e[f + m]) {
                            l = !0;
                            break;
                        }
                    }
                }
            }
            if (l) {
                if (a !== o) {
                    t[o] = t[a];
                    let d = a * n, h = o * n;
                    for(let f = 0; f !== n; ++f)e[h + f] = e[d + f];
                }
                ++o;
            }
        }
        if (s > 0) {
            t[o] = t[s];
            for(let a = s * n, l = o * n, u = 0; u !== n; ++u)e[l + u] = e[a + u];
            ++o;
        }
        return o !== t.length ? (this.times = zo(t, 0, o), this.values = zo(e, 0, o * n)) : (this.times = t, this.values = e), this;
    }
    clone() {
        let t = zo(this.times, 0), e = zo(this.values, 0), n = this.constructor, i = new n(this.name, t, e);
        return i.createInterpolant = this.createInterpolant, i;
    }
};
zi.prototype.TimeBufferType = Float32Array;
zi.prototype.ValueBufferType = Float32Array;
zi.prototype.DefaultInterpolation = Lp;
var el = class extends zi {
};
el.prototype.ValueTypeName = "bool";
el.prototype.ValueBufferType = Array;
el.prototype.DefaultInterpolation = Rp;
el.prototype.InterpolantFactoryMethodLinear = void 0;
el.prototype.InterpolantFactoryMethodSmooth = void 0;
var k0 = class extends zi {
};
k0.prototype.ValueTypeName = "color";
var z0 = class extends zi {
};
z0.prototype.ValueTypeName = "number";
var G0 = class extends vc {
    constructor(t, e, n, i){
        super(t, e, n, i);
    }
    interpolate_(t, e, n, i) {
        let s = this.resultBuffer, o = this.sampleValues, a = this.valueSize, l = (n - e) / (i - e), u = t * a;
        for(let c = u + a; u !== c; u += 4)Je.slerpFlat(s, 0, o, u - a, o, u, l);
        return s;
    }
}, _h = class extends zi {
    InterpolantFactoryMethodLinear(t) {
        return new G0(this.times, this.values, this.getValueSize(), t);
    }
};
_h.prototype.ValueTypeName = "quaternion";
_h.prototype.DefaultInterpolation = Lp;
_h.prototype.InterpolantFactoryMethodSmooth = void 0;
var tl = class extends zi {
};
tl.prototype.ValueTypeName = "string";
tl.prototype.ValueBufferType = Array;
tl.prototype.DefaultInterpolation = Rp;
tl.prototype.InterpolantFactoryMethodLinear = void 0;
tl.prototype.InterpolantFactoryMethodSmooth = void 0;
var V0 = class extends zi {
};
V0.prototype.ValueTypeName = "vector";
var dA = {
    enabled: !1,
    files: {},
    add: function(r1, t) {
        this.enabled !== !1 && (this.files[r1] = t);
    },
    get: function(r1) {
        if (this.enabled !== !1) return this.files[r1];
    },
    remove: function(r1) {
        delete this.files[r1];
    },
    clear: function() {
        this.files = {};
    }
}, Mh = class {
    constructor(t, e, n){
        let i = this, s = !1, o = 0, a = 0, l, u = [];
        this.onStart = void 0, this.onLoad = t, this.onProgress = e, this.onError = n, this.itemStart = function(c) {
            a++, s === !1 && i.onStart !== void 0 && i.onStart(c, o, a), s = !0;
        }, this.itemEnd = function(c) {
            o++, i.onProgress !== void 0 && i.onProgress(c, o, a), o === a && (s = !1, i.onLoad !== void 0 && i.onLoad());
        }, this.itemError = function(c) {
            i.onError !== void 0 && i.onError(c);
        }, this.resolveURL = function(c) {
            return l ? l(c) : c;
        }, this.setURLModifier = function(c) {
            return l = c, this;
        }, this.addHandler = function(c, d) {
            return u.push(c, d), this;
        }, this.removeHandler = function(c) {
            let d = u.indexOf(c);
            return d !== -1 && u.splice(d, 2), this;
        }, this.getHandler = function(c) {
            for(let d = 0, h = u.length; d < h; d += 2){
                let f = u[d], m = u[d + 1];
                if (f.global && (f.lastIndex = 0), f.test(c)) return m;
            }
            return null;
        };
    }
}, oF = new Mh, xc = class {
    constructor(t){
        this.manager = t !== void 0 ? t : oF, this.crossOrigin = "anonymous", this.withCredentials = !1, this.path = "", this.resourcePath = "", this.requestHeader = {};
    }
    load() {}
    loadAsync(t, e) {
        let n = this;
        return new Promise(function(i, s) {
            n.load(t, i, e, s);
        });
    }
    parse() {}
    setCrossOrigin(t) {
        return this.crossOrigin = t, this;
    }
    setWithCredentials(t) {
        return this.withCredentials = t, this;
    }
    setPath(t) {
        return this.path = t, this;
    }
    setResourcePath(t) {
        return this.resourcePath = t, this;
    }
    setRequestHeader(t) {
        return this.requestHeader = t, this;
    }
}, to = {}, H0 = class extends Error {
    constructor(t, e){
        super(t), this.response = e;
    }
}, bc = class extends xc {
    constructor(t){
        super(t);
    }
    load(t, e, n, i) {
        t === void 0 && (t = ""), this.path !== void 0 && (t = this.path + t), t = this.manager.resolveURL(t);
        let s = dA.get(t);
        if (s !== void 0) return this.manager.itemStart(t), setTimeout(()=>{
            e && e(s), this.manager.itemEnd(t);
        }, 0), s;
        if (to[t] !== void 0) {
            to[t].push({
                onLoad: e,
                onProgress: n,
                onError: i
            });
            return;
        }
        to[t] = [], to[t].push({
            onLoad: e,
            onProgress: n,
            onError: i
        });
        let o = new Request(t, {
            headers: new Headers(this.requestHeader),
            credentials: this.withCredentials ? "include" : "same-origin"
        }), a = this.mimeType, l = this.responseType;
        fetch(o).then((u)=>{
            if (u.status === 200 || u.status === 0) {
                if (u.status === 0 && console.warn("THREE.FileLoader: HTTP Status 0 received."), typeof ReadableStream > "u" || u.body === void 0 || u.body.getReader === void 0) return u;
                let c = to[t], d = u.body.getReader(), h = u.headers.get("Content-Length") || u.headers.get("X-File-Size"), f = h ? parseInt(h) : 0, m = f !== 0, p = 0, g = new ReadableStream({
                    start (y) {
                        v();
                        function v() {
                            d.read().then(({ done: x , value: w  })=>{
                                if (x) y.close();
                                else {
                                    p += w.byteLength;
                                    let S = new ProgressEvent("progress", {
                                        lengthComputable: m,
                                        loaded: p,
                                        total: f
                                    });
                                    for(let _ = 0, M = c.length; _ < M; _++){
                                        let b = c[_];
                                        b.onProgress && b.onProgress(S);
                                    }
                                    y.enqueue(w), v();
                                }
                            });
                        }
                    }
                });
                return new Response(g);
            } else throw new H0(`fetch for "${u.url}" responded with ${u.status}: ${u.statusText}`, u);
        }).then((u)=>{
            switch(l){
                case "arraybuffer":
                    return u.arrayBuffer();
                case "blob":
                    return u.blob();
                case "document":
                    return u.text().then((c)=>new DOMParser().parseFromString(c, a));
                case "json":
                    return u.json();
                default:
                    if (a === void 0) return u.text();
                    {
                        let d = /charset="?([^;"\s]*)"?/i.exec(a), h = d && d[1] ? d[1].toLowerCase() : void 0, f = new TextDecoder(h);
                        return u.arrayBuffer().then((m)=>f.decode(m));
                    }
            }
        }).then((u)=>{
            dA.add(t, u);
            let c = to[t];
            delete to[t];
            for(let d = 0, h = c.length; d < h; d++){
                let f = c[d];
                f.onLoad && f.onLoad(u);
            }
        }).catch((u)=>{
            let c = to[t];
            if (c === void 0) throw this.manager.itemError(t), u;
            delete to[t];
            for(let d = 0, h = c.length; d < h; d++){
                let f = c[d];
                f.onError && f.onError(u);
            }
            this.manager.itemError(t);
        }).finally(()=>{
            this.manager.itemEnd(t);
        }), this.manager.itemStart(t);
    }
    setResponseType(t) {
        return this.responseType = t, this;
    }
    setMimeType(t) {
        return this.mimeType = t, this;
    }
};
var Xo = class extends pt {
    constructor(t, e = 1){
        super(), this.isLight = !0, this.type = "Light", this.color = new Ne(t), this.intensity = e;
    }
    dispose() {}
    copy(t, e) {
        return super.copy(t, e), this.color.copy(t.color), this.intensity = t.intensity, this;
    }
    toJSON(t) {
        let e = super.toJSON(t);
        return e.object.color = this.color.getHex(), e.object.intensity = this.intensity, this.groundColor !== void 0 && (e.object.groundColor = this.groundColor.getHex()), this.distance !== void 0 && (e.object.distance = this.distance), this.angle !== void 0 && (e.object.angle = this.angle), this.decay !== void 0 && (e.object.decay = this.decay), this.penumbra !== void 0 && (e.object.penumbra = this.penumbra), this.shadow !== void 0 && (e.object.shadow = this.shadow.toJSON()), e;
    }
}, Xp = class extends Xo {
    constructor(t, e, n){
        super(t, n), this.isHemisphereLight = !0, this.type = "HemisphereLight", this.position.copy(pt.DEFAULT_UP), this.updateMatrix(), this.groundColor = new Ne(e);
    }
    copy(t, e) {
        return super.copy(t, e), this.groundColor.copy(t.groundColor), this;
    }
}, u0 = new ae, hA = new A, fA = new A, Th = class {
    constructor(t){
        this.camera = t, this.bias = 0, this.normalBias = 0, this.radius = 1, this.blurSamples = 8, this.mapSize = new F(512, 512), this.map = null, this.mapPass = null, this.matrix = new ae, this.autoUpdate = !0, this.needsUpdate = !1, this._frustum = new yh, this._frameExtents = new F(1, 1), this._viewportCount = 1, this._viewports = [
            new Ze(0, 0, 1, 1)
        ];
    }
    getViewportCount() {
        return this._viewportCount;
    }
    getFrustum() {
        return this._frustum;
    }
    updateMatrices(t) {
        let e = this.camera, n = this.matrix;
        hA.setFromMatrixPosition(t.matrixWorld), e.position.copy(hA), fA.setFromMatrixPosition(t.target.matrixWorld), e.lookAt(fA), e.updateMatrixWorld(), u0.multiplyMatrices(e.projectionMatrix, e.matrixWorldInverse), this._frustum.setFromProjectionMatrix(u0), n.set(.5, 0, 0, .5, 0, .5, 0, .5, 0, 0, .5, .5, 0, 0, 0, 1), n.multiply(u0);
    }
    getViewport(t) {
        return this._viewports[t];
    }
    getFrameExtents() {
        return this._frameExtents;
    }
    dispose() {
        this.map && this.map.dispose(), this.mapPass && this.mapPass.dispose();
    }
    copy(t) {
        return this.camera = t.camera.clone(), this.bias = t.bias, this.radius = t.radius, this.mapSize.copy(t.mapSize), this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    toJSON() {
        let t = {};
        return this.bias !== 0 && (t.bias = this.bias), this.normalBias !== 0 && (t.normalBias = this.normalBias), this.radius !== 1 && (t.radius = this.radius), (this.mapSize.x !== 512 || this.mapSize.y !== 512) && (t.mapSize = this.mapSize.toArray()), t.camera = this.camera.toJSON(!1).object, delete t.camera.matrix, t;
    }
}, W0 = class extends Th {
    constructor(){
        super(new gn(50, 1, .5, 500)), this.isSpotLightShadow = !0, this.focus = 1;
    }
    updateMatrices(t) {
        let e = this.camera, n = mh * 2 * t.angle * this.focus, i = this.mapSize.width / this.mapSize.height, s = t.distance || e.far;
        (n !== e.fov || i !== e.aspect || s !== e.far) && (e.fov = n, e.aspect = i, e.far = s, e.updateProjectionMatrix()), super.updateMatrices(t);
    }
    copy(t) {
        return super.copy(t), this.focus = t.focus, this;
    }
}, Yp = class extends Xo {
    constructor(t, e, n = 0, i = Math.PI / 3, s = 0, o = 2){
        super(t, e), this.isSpotLight = !0, this.type = "SpotLight", this.position.copy(pt.DEFAULT_UP), this.updateMatrix(), this.target = new pt, this.distance = n, this.angle = i, this.penumbra = s, this.decay = o, this.map = null, this.shadow = new W0;
    }
    get power() {
        return this.intensity * Math.PI;
    }
    set power(t) {
        this.intensity = t / Math.PI;
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(t, e) {
        return super.copy(t, e), this.distance = t.distance, this.angle = t.angle, this.penumbra = t.penumbra, this.decay = t.decay, this.target = t.target.clone(), this.shadow = t.shadow.clone(), this;
    }
}, pA = new ae, oh = new A, d0 = new A, j0 = class extends Th {
    constructor(){
        super(new gn(90, 1, .5, 500)), this.isPointLightShadow = !0, this._frameExtents = new F(4, 2), this._viewportCount = 6, this._viewports = [
            new Ze(2, 1, 1, 1),
            new Ze(0, 1, 1, 1),
            new Ze(3, 1, 1, 1),
            new Ze(1, 1, 1, 1),
            new Ze(3, 0, 1, 1),
            new Ze(1, 0, 1, 1)
        ], this._cubeDirections = [
            new A(1, 0, 0),
            new A(-1, 0, 0),
            new A(0, 0, 1),
            new A(0, 0, -1),
            new A(0, 1, 0),
            new A(0, -1, 0)
        ], this._cubeUps = [
            new A(0, 1, 0),
            new A(0, 1, 0),
            new A(0, 1, 0),
            new A(0, 1, 0),
            new A(0, 0, 1),
            new A(0, 0, -1)
        ];
    }
    updateMatrices(t, e = 0) {
        let n = this.camera, i = this.matrix, s = t.distance || n.far;
        s !== n.far && (n.far = s, n.updateProjectionMatrix()), oh.setFromMatrixPosition(t.matrixWorld), n.position.copy(oh), d0.copy(n.position), d0.add(this._cubeDirections[e]), n.up.copy(this._cubeUps[e]), n.lookAt(d0), n.updateMatrixWorld(), i.makeTranslation(-oh.x, -oh.y, -oh.z), pA.multiplyMatrices(n.projectionMatrix, n.matrixWorldInverse), this._frustum.setFromProjectionMatrix(pA);
    }
}, Qp = class extends Xo {
    constructor(t, e, n = 0, i = 2){
        super(t, e), this.isPointLight = !0, this.type = "PointLight", this.distance = n, this.decay = i, this.shadow = new j0;
    }
    get power() {
        return this.intensity * 4 * Math.PI;
    }
    set power(t) {
        this.intensity = t / (4 * Math.PI);
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(t, e) {
        return super.copy(t, e), this.distance = t.distance, this.decay = t.decay, this.shadow = t.shadow.clone(), this;
    }
}, q0 = class extends Th {
    constructor(){
        super(new ja(-5, 5, 5, -5, .5, 500)), this.isDirectionalLightShadow = !0;
    }
}, Kp = class extends Xo {
    constructor(t, e){
        super(t, e), this.isDirectionalLight = !0, this.type = "DirectionalLight", this.position.copy(pt.DEFAULT_UP), this.updateMatrix(), this.target = new pt, this.shadow = new q0;
    }
    dispose() {
        this.shadow.dispose();
    }
    copy(t) {
        return super.copy(t), this.target = t.target.clone(), this.shadow = t.shadow.clone(), this;
    }
};
var X0 = class extends Me {
    constructor(){
        super(), this.isInstancedBufferGeometry = !0, this.type = "InstancedBufferGeometry", this.instanceCount = 1 / 0;
    }
    copy(t) {
        return super.copy(t), this.instanceCount = t.instanceCount, this;
    }
    toJSON() {
        let t = super.toJSON();
        return t.instanceCount = this.instanceCount, t.isInstancedBufferGeometry = !0, t;
    }
}, wc = class extends xc {
    constructor(t){
        super(t);
    }
    load(t, e, n, i) {
        let s = this, o = new bc(s.manager);
        o.setPath(s.path), o.setRequestHeader(s.requestHeader), o.setWithCredentials(s.withCredentials), o.load(t, function(a) {
            try {
                e(s.parse(JSON.parse(a)));
            } catch (l) {
                i ? i(l) : console.error(l), s.manager.itemError(t);
            }
        }, n, i);
    }
    parse(t) {
        let e = {}, n = {};
        function i(f, m) {
            if (e[m] !== void 0) return e[m];
            let g = f.interleavedBuffers[m], y = s(f, g.buffer), v = sp(g.type, y), x = new Wp(v, g.stride);
            return x.uuid = g.uuid, e[m] = x, x;
        }
        function s(f, m) {
            if (n[m] !== void 0) return n[m];
            let g = f.arrayBuffers[m], y = new Uint32Array(g).buffer;
            return n[m] = y, y;
        }
        let o = t.isInstancedBufferGeometry ? new X0 : new Me, a = t.data.index;
        if (a !== void 0) {
            let f = sp(a.type, a.array);
            o.setIndex(new Be(f, 1));
        }
        let l = t.data.attributes;
        for(let f in l){
            let m = l[f], p;
            if (m.isInterleavedBufferAttribute) {
                let g = i(t.data, m.data);
                p = new qa(g, m.itemSize, m.offset, m.normalized);
            } else {
                let g = sp(m.type, m.array), y = m.isInstancedBufferAttribute ? jp : Be;
                p = new y(g, m.itemSize, m.normalized);
            }
            m.name !== void 0 && (p.name = m.name), m.usage !== void 0 && p.setUsage(m.usage), m.updateRange !== void 0 && (p.updateRange.offset = m.updateRange.offset, p.updateRange.count = m.updateRange.count), o.setAttribute(f, p);
        }
        let u = t.data.morphAttributes;
        if (u) for(let f in u){
            let m = u[f], p = [];
            for(let g = 0, y = m.length; g < y; g++){
                let v = m[g], x;
                if (v.isInterleavedBufferAttribute) {
                    let w = i(t.data, v.data);
                    x = new qa(w, v.itemSize, v.offset, v.normalized);
                } else {
                    let w = sp(v.type, v.array);
                    x = new Be(w, v.itemSize, v.normalized);
                }
                v.name !== void 0 && (x.name = v.name), p.push(x);
            }
            o.morphAttributes[f] = p;
        }
        t.data.morphTargetsRelative && (o.morphTargetsRelative = !0);
        let d = t.data.groups || t.data.drawcalls || t.data.offsets;
        if (d !== void 0) for(let f = 0, m = d.length; f !== m; ++f){
            let p = d[f];
            o.addGroup(p.start, p.count, p.materialIndex);
        }
        let h = t.data.boundingSphere;
        if (h !== void 0) {
            let f = new A;
            h.center !== void 0 && f.fromArray(h.center), o.boundingSphere = new Rn(f, h.radius);
        }
        return t.name && (o.name = t.name), t.userData && (o.userData = t.userData), o;
    }
};
var Zp = class {
    constructor(t = !0){
        this.autoStart = t, this.startTime = 0, this.oldTime = 0, this.elapsedTime = 0, this.running = !1;
    }
    start() {
        this.startTime = mA(), this.oldTime = this.startTime, this.elapsedTime = 0, this.running = !0;
    }
    stop() {
        this.getElapsedTime(), this.running = !1, this.autoStart = !1;
    }
    getElapsedTime() {
        return this.getDelta(), this.elapsedTime;
    }
    getDelta() {
        let t = 0;
        if (this.autoStart && !this.running) return this.start(), 0;
        if (this.running) {
            let e = mA();
            t = (e - this.oldTime) / 1e3, this.oldTime = e, this.elapsedTime += t;
        }
        return t;
    }
};
function mA() {
    return (typeof performance > "u" ? Date : performance).now();
}
var rx = "\\[\\]\\.:\\/", aF = new RegExp("[" + rx + "]", "g"), ix = "[^" + rx + "]", lF = "[^" + rx.replace("\\.", "") + "]", cF = /((?:WC+[\/:])*)/.source.replace("WC", ix), uF = /(WCOD+)?/.source.replace("WCOD", lF), dF = /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace("WC", ix), hF = /\.(WC+)(?:\[(.+)\])?/.source.replace("WC", ix), fF = new RegExp("^" + cF + uF + dF + hF + "$"), pF = [
    "material",
    "materials",
    "bones",
    "map"
], Y0 = class {
    constructor(t, e, n){
        let i = n || Rt.parseTrackName(e);
        this._targetGroup = t, this._bindings = t.subscribe_(e, i);
    }
    getValue(t, e) {
        this.bind();
        let n = this._targetGroup.nCachedObjects_, i = this._bindings[n];
        i !== void 0 && i.getValue(t, e);
    }
    setValue(t, e) {
        let n = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, s = n.length; i !== s; ++i)n[i].setValue(t, e);
    }
    bind() {
        let t = this._bindings;
        for(let e = this._targetGroup.nCachedObjects_, n = t.length; e !== n; ++e)t[e].bind();
    }
    unbind() {
        let t = this._bindings;
        for(let e = this._targetGroup.nCachedObjects_, n = t.length; e !== n; ++e)t[e].unbind();
    }
}, Rt = class {
    constructor(t, e, n){
        this.path = e, this.parsedPath = n || Rt.parseTrackName(e), this.node = Rt.findNode(t, this.parsedPath.nodeName) || t, this.rootNode = t, this.getValue = this._getValue_unbound, this.setValue = this._setValue_unbound;
    }
    static create(t, e, n) {
        return t && t.isAnimationObjectGroup ? new Rt.Composite(t, e, n) : new Rt(t, e, n);
    }
    static sanitizeNodeName(t) {
        return t.replace(/\s/g, "_").replace(aF, "");
    }
    static parseTrackName(t) {
        let e = fF.exec(t);
        if (e === null) throw new Error("PropertyBinding: Cannot parse trackName: " + t);
        let n = {
            nodeName: e[2],
            objectName: e[3],
            objectIndex: e[4],
            propertyName: e[5],
            propertyIndex: e[6]
        }, i = n.nodeName && n.nodeName.lastIndexOf(".");
        if (i !== void 0 && i !== -1) {
            let s = n.nodeName.substring(i + 1);
            pF.indexOf(s) !== -1 && (n.nodeName = n.nodeName.substring(0, i), n.objectName = s);
        }
        if (n.propertyName === null || n.propertyName.length === 0) throw new Error("PropertyBinding: can not parse propertyName from trackName: " + t);
        return n;
    }
    static findNode(t, e) {
        if (e === void 0 || e === "" || e === "." || e === -1 || e === t.name || e === t.uuid) return t;
        if (t.skeleton) {
            let n = t.skeleton.getBoneByName(e);
            if (n !== void 0) return n;
        }
        if (t.children) {
            let n = function(s) {
                for(let o = 0; o < s.length; o++){
                    let a = s[o];
                    if (a.name === e || a.uuid === e) return a;
                    let l = n(a.children);
                    if (l) return l;
                }
                return null;
            }, i = n(t.children);
            if (i) return i;
        }
        return null;
    }
    _getValue_unavailable() {}
    _setValue_unavailable() {}
    _getValue_direct(t, e) {
        t[e] = this.targetObject[this.propertyName];
    }
    _getValue_array(t, e) {
        let n = this.resolvedProperty;
        for(let i = 0, s = n.length; i !== s; ++i)t[e++] = n[i];
    }
    _getValue_arrayElement(t, e) {
        t[e] = this.resolvedProperty[this.propertyIndex];
    }
    _getValue_toArray(t, e) {
        this.resolvedProperty.toArray(t, e);
    }
    _setValue_direct(t, e) {
        this.targetObject[this.propertyName] = t[e];
    }
    _setValue_direct_setNeedsUpdate(t, e) {
        this.targetObject[this.propertyName] = t[e], this.targetObject.needsUpdate = !0;
    }
    _setValue_direct_setMatrixWorldNeedsUpdate(t, e) {
        this.targetObject[this.propertyName] = t[e], this.targetObject.matrixWorldNeedsUpdate = !0;
    }
    _setValue_array(t, e) {
        let n = this.resolvedProperty;
        for(let i = 0, s = n.length; i !== s; ++i)n[i] = t[e++];
    }
    _setValue_array_setNeedsUpdate(t, e) {
        let n = this.resolvedProperty;
        for(let i = 0, s = n.length; i !== s; ++i)n[i] = t[e++];
        this.targetObject.needsUpdate = !0;
    }
    _setValue_array_setMatrixWorldNeedsUpdate(t, e) {
        let n = this.resolvedProperty;
        for(let i = 0, s = n.length; i !== s; ++i)n[i] = t[e++];
        this.targetObject.matrixWorldNeedsUpdate = !0;
    }
    _setValue_arrayElement(t, e) {
        this.resolvedProperty[this.propertyIndex] = t[e];
    }
    _setValue_arrayElement_setNeedsUpdate(t, e) {
        this.resolvedProperty[this.propertyIndex] = t[e], this.targetObject.needsUpdate = !0;
    }
    _setValue_arrayElement_setMatrixWorldNeedsUpdate(t, e) {
        this.resolvedProperty[this.propertyIndex] = t[e], this.targetObject.matrixWorldNeedsUpdate = !0;
    }
    _setValue_fromArray(t, e) {
        this.resolvedProperty.fromArray(t, e);
    }
    _setValue_fromArray_setNeedsUpdate(t, e) {
        this.resolvedProperty.fromArray(t, e), this.targetObject.needsUpdate = !0;
    }
    _setValue_fromArray_setMatrixWorldNeedsUpdate(t, e) {
        this.resolvedProperty.fromArray(t, e), this.targetObject.matrixWorldNeedsUpdate = !0;
    }
    _getValue_unbound(t, e) {
        this.bind(), this.getValue(t, e);
    }
    _setValue_unbound(t, e) {
        this.bind(), this.setValue(t, e);
    }
    bind() {
        let t = this.node, e = this.parsedPath, n = e.objectName, i = e.propertyName, s = e.propertyIndex;
        if (t || (t = Rt.findNode(this.rootNode, e.nodeName) || this.rootNode, this.node = t), this.getValue = this._getValue_unavailable, this.setValue = this._setValue_unavailable, !t) {
            console.error("THREE.PropertyBinding: Trying to update node for track: " + this.path + " but it wasn't found.");
            return;
        }
        if (n) {
            let u = e.objectIndex;
            switch(n){
                case "materials":
                    if (!t.material) {
                        console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.", this);
                        return;
                    }
                    if (!t.material.materials) {
                        console.error("THREE.PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.", this);
                        return;
                    }
                    t = t.material.materials;
                    break;
                case "bones":
                    if (!t.skeleton) {
                        console.error("THREE.PropertyBinding: Can not bind to bones as node does not have a skeleton.", this);
                        return;
                    }
                    t = t.skeleton.bones;
                    for(let c = 0; c < t.length; c++)if (t[c].name === u) {
                        u = c;
                        break;
                    }
                    break;
                case "map":
                    if ("map" in t) {
                        t = t.map;
                        break;
                    }
                    if (!t.material) {
                        console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.", this);
                        return;
                    }
                    if (!t.material.map) {
                        console.error("THREE.PropertyBinding: Can not bind to material.map as node.material does not have a map.", this);
                        return;
                    }
                    t = t.material.map;
                    break;
                default:
                    if (t[n] === void 0) {
                        console.error("THREE.PropertyBinding: Can not bind to objectName of node undefined.", this);
                        return;
                    }
                    t = t[n];
            }
            if (u !== void 0) {
                if (t[u] === void 0) {
                    console.error("THREE.PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.", this, t);
                    return;
                }
                t = t[u];
            }
        }
        let o = t[i];
        if (o === void 0) {
            let u = e.nodeName;
            console.error("THREE.PropertyBinding: Trying to update property for track: " + u + "." + i + " but it wasn't found.", t);
            return;
        }
        let a = this.Versioning.None;
        this.targetObject = t, t.needsUpdate !== void 0 ? a = this.Versioning.NeedsUpdate : t.matrixWorldNeedsUpdate !== void 0 && (a = this.Versioning.MatrixWorldNeedsUpdate);
        let l = this.BindingType.Direct;
        if (s !== void 0) {
            if (i === "morphTargetInfluences") {
                if (!t.geometry) {
                    console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.", this);
                    return;
                }
                if (!t.geometry.morphAttributes) {
                    console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.", this);
                    return;
                }
                t.morphTargetDictionary[s] !== void 0 && (s = t.morphTargetDictionary[s]);
            }
            l = this.BindingType.ArrayElement, this.resolvedProperty = o, this.propertyIndex = s;
        } else o.fromArray !== void 0 && o.toArray !== void 0 ? (l = this.BindingType.HasFromToArray, this.resolvedProperty = o) : Array.isArray(o) ? (l = this.BindingType.EntireArray, this.resolvedProperty = o) : this.propertyName = i;
        this.getValue = this.GetterByBindingType[l], this.setValue = this.SetterByBindingTypeAndVersioning[l][a];
    }
    unbind() {
        this.node = null, this.getValue = this._getValue_unbound, this.setValue = this._setValue_unbound;
    }
};
Rt.Composite = Y0;
Rt.prototype.BindingType = {
    Direct: 0,
    EntireArray: 1,
    ArrayElement: 2,
    HasFromToArray: 3
};
Rt.prototype.Versioning = {
    None: 0,
    NeedsUpdate: 1,
    MatrixWorldNeedsUpdate: 2
};
Rt.prototype.GetterByBindingType = [
    Rt.prototype._getValue_direct,
    Rt.prototype._getValue_array,
    Rt.prototype._getValue_arrayElement,
    Rt.prototype._getValue_toArray
];
Rt.prototype.SetterByBindingTypeAndVersioning = [
    [
        Rt.prototype._setValue_direct,
        Rt.prototype._setValue_direct_setNeedsUpdate,
        Rt.prototype._setValue_direct_setMatrixWorldNeedsUpdate
    ],
    [
        Rt.prototype._setValue_array,
        Rt.prototype._setValue_array_setNeedsUpdate,
        Rt.prototype._setValue_array_setMatrixWorldNeedsUpdate
    ],
    [
        Rt.prototype._setValue_arrayElement,
        Rt.prototype._setValue_arrayElement_setNeedsUpdate,
        Rt.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate
    ],
    [
        Rt.prototype._setValue_fromArray,
        Rt.prototype._setValue_fromArray_setNeedsUpdate,
        Rt.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate
    ]
];
var Pq = new Float32Array(1);
var ie = class {
    constructor(t){
        this.value = t;
    }
    clone() {
        return new ie(this.value.clone === void 0 ? this.value : this.value.clone());
    }
};
var Sc = class {
    constructor(t, e, n = 0, i = 1 / 0){
        this.ray = new Fi(t, e), this.near = n, this.far = i, this.camera = null, this.layers = new gh, this.params = {
            Mesh: {},
            Line: {
                threshold: 1
            },
            LOD: {},
            Points: {
                threshold: 1
            },
            Sprite: {}
        };
    }
    set(t, e) {
        this.ray.set(t, e);
    }
    setFromCamera(t, e) {
        e.isPerspectiveCamera ? (this.ray.origin.setFromMatrixPosition(e.matrixWorld), this.ray.direction.set(t.x, t.y, .5).unproject(e).sub(this.ray.origin).normalize(), this.camera = e) : e.isOrthographicCamera ? (this.ray.origin.set(t.x, t.y, (e.near + e.far) / (e.near - e.far)).unproject(e), this.ray.direction.set(0, 0, -1).transformDirection(e.matrixWorld), this.camera = e) : console.error("THREE.Raycaster: Unsupported camera type: " + e.type);
    }
    intersectObject(t, e = !0, n = []) {
        return Q0(t, this, n, e), n.sort(gA), n;
    }
    intersectObjects(t, e = !0, n = []) {
        for(let i = 0, s = t.length; i < s; i++)Q0(t[i], this, n, e);
        return n.sort(gA), n;
    }
};
function gA(r1, t) {
    return r1.distance - t.distance;
}
function Q0(r1, t, e, n) {
    if (r1.layers.test(t.layers) && r1.raycast(t, e), n === !0) {
        let i = r1.children;
        for(let s = 0, o = i.length; s < o; s++)Q0(i[s], t, e, !0);
    }
}
var Eh = class {
    constructor(t = 1, e = 0, n = 0){
        return this.radius = t, this.phi = e, this.theta = n, this;
    }
    set(t, e, n) {
        return this.radius = t, this.phi = e, this.theta = n, this;
    }
    copy(t) {
        return this.radius = t.radius, this.phi = t.phi, this.theta = t.theta, this;
    }
    makeSafe() {
        return this.phi = Math.max(1e-6, Math.min(Math.PI - 1e-6, this.phi)), this;
    }
    setFromVector3(t) {
        return this.setFromCartesianCoords(t.x, t.y, t.z);
    }
    setFromCartesianCoords(t, e, n) {
        return this.radius = Math.sqrt(t * t + e * e + n * n), this.radius === 0 ? (this.theta = 0, this.phi = 0) : (this.theta = Math.atan2(t, n), this.phi = Math.acos(zn(e / this.radius, -1, 1))), this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
};
var yA = new F, Jp = class {
    constructor(t = new F(1 / 0, 1 / 0), e = new F(-1 / 0, -1 / 0)){
        this.isBox2 = !0, this.min = t, this.max = e;
    }
    set(t, e) {
        return this.min.copy(t), this.max.copy(e), this;
    }
    setFromPoints(t) {
        this.makeEmpty();
        for(let e = 0, n = t.length; e < n; e++)this.expandByPoint(t[e]);
        return this;
    }
    setFromCenterAndSize(t, e) {
        let n = yA.copy(e).multiplyScalar(.5);
        return this.min.copy(t).sub(n), this.max.copy(t).add(n), this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(t) {
        return this.min.copy(t.min), this.max.copy(t.max), this;
    }
    makeEmpty() {
        return this.min.x = this.min.y = 1 / 0, this.max.x = this.max.y = -1 / 0, this;
    }
    isEmpty() {
        return this.max.x < this.min.x || this.max.y < this.min.y;
    }
    getCenter(t) {
        return this.isEmpty() ? t.set(0, 0) : t.addVectors(this.min, this.max).multiplyScalar(.5);
    }
    getSize(t) {
        return this.isEmpty() ? t.set(0, 0) : t.subVectors(this.max, this.min);
    }
    expandByPoint(t) {
        return this.min.min(t), this.max.max(t), this;
    }
    expandByVector(t) {
        return this.min.sub(t), this.max.add(t), this;
    }
    expandByScalar(t) {
        return this.min.addScalar(-t), this.max.addScalar(t), this;
    }
    containsPoint(t) {
        return !(t.x < this.min.x || t.x > this.max.x || t.y < this.min.y || t.y > this.max.y);
    }
    containsBox(t) {
        return this.min.x <= t.min.x && t.max.x <= this.max.x && this.min.y <= t.min.y && t.max.y <= this.max.y;
    }
    getParameter(t, e) {
        return e.set((t.x - this.min.x) / (this.max.x - this.min.x), (t.y - this.min.y) / (this.max.y - this.min.y));
    }
    intersectsBox(t) {
        return !(t.max.x < this.min.x || t.min.x > this.max.x || t.max.y < this.min.y || t.min.y > this.max.y);
    }
    clampPoint(t, e) {
        return e.copy(t).clamp(this.min, this.max);
    }
    distanceToPoint(t) {
        return yA.copy(t).clamp(this.min, this.max).sub(t).length();
    }
    intersect(t) {
        return this.min.max(t.min), this.max.min(t.max), this;
    }
    union(t) {
        return this.min.min(t.min), this.max.max(t.max), this;
    }
    translate(t) {
        return this.min.add(t), this.max.add(t), this;
    }
    equals(t) {
        return t.min.equals(this.min) && t.max.equals(this.max);
    }
}, vA = new A, Pp = new A, Hn = class {
    constructor(t = new A, e = new A){
        this.start = t, this.end = e;
    }
    set(t, e) {
        return this.start.copy(t), this.end.copy(e), this;
    }
    copy(t) {
        return this.start.copy(t.start), this.end.copy(t.end), this;
    }
    getCenter(t) {
        return t.addVectors(this.start, this.end).multiplyScalar(.5);
    }
    delta(t) {
        return t.subVectors(this.end, this.start);
    }
    distanceSq() {
        return this.start.distanceToSquared(this.end);
    }
    distance() {
        return this.start.distanceTo(this.end);
    }
    at(t, e) {
        return this.delta(e).multiplyScalar(t).add(this.start);
    }
    closestPointToPointParameter(t, e) {
        vA.subVectors(t, this.start), Pp.subVectors(this.end, this.start);
        let n = Pp.dot(Pp), s = Pp.dot(vA) / n;
        return e && (s = zn(s, 0, 1)), s;
    }
    closestPointToPoint(t, e, n) {
        let i = this.closestPointToPointParameter(t, e);
        return this.delta(n).multiplyScalar(i).add(this.start);
    }
    applyMatrix4(t) {
        return this.start.applyMatrix4(t), this.end.applyMatrix4(t), this;
    }
    equals(t) {
        return t.start.equals(this.start) && t.end.equals(this.end);
    }
    clone() {
        return new this.constructor().copy(this);
    }
}, xA = new A, $p = class extends pt {
    constructor(t, e){
        super(), this.light = t, this.matrix = t.matrixWorld, this.matrixAutoUpdate = !1, this.color = e, this.type = "SpotLightHelper";
        let n = new Me, i = [
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1,
            0,
            1,
            0,
            0,
            0,
            -1,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            1,
            0,
            0,
            0,
            0,
            -1,
            1
        ];
        for(let o = 0, a = 1, l = 32; o < l; o++, a++){
            let u = o / l * Math.PI * 2, c = a / l * Math.PI * 2;
            i.push(Math.cos(u), Math.sin(u), 1, Math.cos(c), Math.sin(c), 1);
        }
        n.setAttribute("position", new Ae(i, 3));
        let s = new vi({
            fog: !1,
            toneMapped: !1
        });
        this.cone = new qo(n, s), this.add(this.cone), this.update();
    }
    dispose() {
        this.cone.geometry.dispose(), this.cone.material.dispose();
    }
    update() {
        this.light.updateWorldMatrix(!0, !1), this.light.target.updateWorldMatrix(!0, !1);
        let t = this.light.distance ? this.light.distance : 1e3, e = t * Math.tan(this.light.angle);
        this.cone.scale.set(e, e, t), xA.setFromMatrixPosition(this.light.target.matrixWorld), this.cone.lookAt(xA), this.color !== void 0 ? this.cone.material.color.set(this.color) : this.cone.material.color.copy(this.light.color);
    }
};
var em = class extends In {
    constructor(t, e, n){
        let i = new $a(e, 4, 2), s = new Ui({
            wireframe: !0,
            fog: !1,
            toneMapped: !1
        });
        super(i, s), this.light = t, this.color = n, this.type = "PointLightHelper", this.matrix = this.light.matrixWorld, this.matrixAutoUpdate = !1, this.update();
    }
    dispose() {
        this.geometry.dispose(), this.material.dispose();
    }
    update() {
        this.light.updateWorldMatrix(!0, !1), this.color !== void 0 ? this.material.color.set(this.color) : this.material.color.copy(this.light.color);
    }
};
var bA = new A, Dp = new A, wA = new A, tm = class extends pt {
    constructor(t, e, n){
        super(), this.light = t, this.matrix = t.matrixWorld, this.matrixAutoUpdate = !1, this.color = n, this.type = "DirectionalLightHelper", e === void 0 && (e = 1);
        let i = new Me;
        i.setAttribute("position", new Ae([
            -e,
            e,
            0,
            e,
            e,
            0,
            e,
            -e,
            0,
            -e,
            -e,
            0,
            -e,
            e,
            0
        ], 3));
        let s = new vi({
            fog: !1,
            toneMapped: !1
        });
        this.lightPlane = new Xa(i, s), this.add(this.lightPlane), i = new Me, i.setAttribute("position", new Ae([
            0,
            0,
            0,
            0,
            0,
            1
        ], 3)), this.targetLine = new Xa(i, s), this.add(this.targetLine), this.update();
    }
    dispose() {
        this.lightPlane.geometry.dispose(), this.lightPlane.material.dispose(), this.targetLine.geometry.dispose(), this.targetLine.material.dispose();
    }
    update() {
        this.light.updateWorldMatrix(!0, !1), this.light.target.updateWorldMatrix(!0, !1), bA.setFromMatrixPosition(this.light.matrixWorld), Dp.setFromMatrixPosition(this.light.target.matrixWorld), wA.subVectors(Dp, bA), this.lightPlane.lookAt(Dp), this.color !== void 0 ? (this.lightPlane.material.color.set(this.color), this.targetLine.material.color.set(this.color)) : (this.lightPlane.material.color.copy(this.light.color), this.targetLine.material.color.copy(this.light.color)), this.targetLine.lookAt(Dp), this.targetLine.scale.z = wA.length();
    }
}, Ip = new A, on = new ki, Yo = class extends qo {
    constructor(t){
        let e = new Me, n = new vi({
            color: 16777215,
            vertexColors: !0,
            toneMapped: !1
        }), i = [], s = [], o = {};
        a("n1", "n2"), a("n2", "n4"), a("n4", "n3"), a("n3", "n1"), a("f1", "f2"), a("f2", "f4"), a("f4", "f3"), a("f3", "f1"), a("n1", "f1"), a("n2", "f2"), a("n3", "f3"), a("n4", "f4"), a("p", "n1"), a("p", "n2"), a("p", "n3"), a("p", "n4"), a("u1", "u2"), a("u2", "u3"), a("u3", "u1"), a("c", "t"), a("p", "c"), a("cn1", "cn2"), a("cn3", "cn4"), a("cf1", "cf2"), a("cf3", "cf4");
        function a(m, p) {
            l(m), l(p);
        }
        function l(m) {
            i.push(0, 0, 0), s.push(0, 0, 0), o[m] === void 0 && (o[m] = []), o[m].push(i.length / 3 - 1);
        }
        e.setAttribute("position", new Ae(i, 3)), e.setAttribute("color", new Ae(s, 3)), super(e, n), this.type = "CameraHelper", this.camera = t, this.camera.updateProjectionMatrix && this.camera.updateProjectionMatrix(), this.matrix = t.matrixWorld, this.matrixAutoUpdate = !1, this.pointMap = o, this.update();
        let u = new Ne(16755200), c = new Ne(16711680), d = new Ne(43775), h = new Ne(16777215), f = new Ne(3355443);
        this.setColors(u, c, d, h, f);
    }
    setColors(t, e, n, i, s) {
        let a = this.geometry.getAttribute("color");
        a.setXYZ(0, t.r, t.g, t.b), a.setXYZ(1, t.r, t.g, t.b), a.setXYZ(2, t.r, t.g, t.b), a.setXYZ(3, t.r, t.g, t.b), a.setXYZ(4, t.r, t.g, t.b), a.setXYZ(5, t.r, t.g, t.b), a.setXYZ(6, t.r, t.g, t.b), a.setXYZ(7, t.r, t.g, t.b), a.setXYZ(8, t.r, t.g, t.b), a.setXYZ(9, t.r, t.g, t.b), a.setXYZ(10, t.r, t.g, t.b), a.setXYZ(11, t.r, t.g, t.b), a.setXYZ(12, t.r, t.g, t.b), a.setXYZ(13, t.r, t.g, t.b), a.setXYZ(14, t.r, t.g, t.b), a.setXYZ(15, t.r, t.g, t.b), a.setXYZ(16, t.r, t.g, t.b), a.setXYZ(17, t.r, t.g, t.b), a.setXYZ(18, t.r, t.g, t.b), a.setXYZ(19, t.r, t.g, t.b), a.setXYZ(20, t.r, t.g, t.b), a.setXYZ(21, t.r, t.g, t.b), a.setXYZ(22, t.r, t.g, t.b), a.setXYZ(23, t.r, t.g, t.b), a.setXYZ(24, e.r, e.g, e.b), a.setXYZ(25, e.r, e.g, e.b), a.setXYZ(26, e.r, e.g, e.b), a.setXYZ(27, e.r, e.g, e.b), a.setXYZ(28, e.r, e.g, e.b), a.setXYZ(29, e.r, e.g, e.b), a.setXYZ(30, e.r, e.g, e.b), a.setXYZ(31, e.r, e.g, e.b), a.setXYZ(32, n.r, n.g, n.b), a.setXYZ(33, n.r, n.g, n.b), a.setXYZ(34, n.r, n.g, n.b), a.setXYZ(35, n.r, n.g, n.b), a.setXYZ(36, n.r, n.g, n.b), a.setXYZ(37, n.r, n.g, n.b), a.setXYZ(38, i.r, i.g, i.b), a.setXYZ(39, i.r, i.g, i.b), a.setXYZ(40, s.r, s.g, s.b), a.setXYZ(41, s.r, s.g, s.b), a.setXYZ(42, s.r, s.g, s.b), a.setXYZ(43, s.r, s.g, s.b), a.setXYZ(44, s.r, s.g, s.b), a.setXYZ(45, s.r, s.g, s.b), a.setXYZ(46, s.r, s.g, s.b), a.setXYZ(47, s.r, s.g, s.b), a.setXYZ(48, s.r, s.g, s.b), a.setXYZ(49, s.r, s.g, s.b), a.needsUpdate = !0;
    }
    update() {
        let t = this.geometry, e = this.pointMap, n = 1, i = 1;
        on.projectionMatrixInverse.copy(this.camera.projectionMatrixInverse), mn("c", e, t, on, 0, 0, -1), mn("t", e, t, on, 0, 0, 1), mn("n1", e, t, on, -n, -i, -1), mn("n2", e, t, on, n, -i, -1), mn("n3", e, t, on, -n, i, -1), mn("n4", e, t, on, n, i, -1), mn("f1", e, t, on, -n, -i, 1), mn("f2", e, t, on, n, -i, 1), mn("f3", e, t, on, -n, i, 1), mn("f4", e, t, on, n, i, 1), mn("u1", e, t, on, n * .7, i * 1.1, -1), mn("u2", e, t, on, -n * .7, i * 1.1, -1), mn("u3", e, t, on, 0, i * 2, -1), mn("cf1", e, t, on, -n, 0, 1), mn("cf2", e, t, on, n, 0, 1), mn("cf3", e, t, on, 0, -i, 1), mn("cf4", e, t, on, 0, i, 1), mn("cn1", e, t, on, -n, 0, -1), mn("cn2", e, t, on, n, 0, -1), mn("cn3", e, t, on, 0, -i, -1), mn("cn4", e, t, on, 0, i, -1), t.getAttribute("position").needsUpdate = !0;
    }
    dispose() {
        this.geometry.dispose(), this.material.dispose();
    }
};
function mn(r1, t, e, n, i, s, o) {
    Ip.set(i, s, o).unproject(n);
    let a = t[r1];
    if (a !== void 0) {
        let l = e.getAttribute("position");
        for(let u = 0, c = a.length; u < c; u++)l.setXYZ(a[u], Ip.x, Ip.y, Ip.z);
    }
}
var Qo = class extends qo {
    constructor(t, e = 16776960){
        let n = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]), i = [
            1,
            1,
            1,
            -1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            -1
        ], s = new Me;
        s.setIndex(new Be(n, 1)), s.setAttribute("position", new Ae(i, 3)), super(s, new vi({
            color: e,
            toneMapped: !1
        })), this.box = t, this.type = "Box3Helper", this.geometry.computeBoundingSphere();
    }
    updateMatrixWorld(t) {
        let e = this.box;
        e.isEmpty() || (e.getCenter(this.position), e.getSize(this.scale), this.scale.multiplyScalar(.5), super.updateMatrixWorld(t));
    }
    dispose() {
        this.geometry.dispose(), this.material.dispose();
    }
};
var nm = class extends qo {
    constructor(t = 1){
        let e = [
            0,
            0,
            0,
            t,
            0,
            0,
            0,
            0,
            0,
            0,
            t,
            0,
            0,
            0,
            0,
            0,
            0,
            t
        ], n = [
            1,
            0,
            0,
            1,
            .6,
            0,
            0,
            1,
            0,
            .6,
            1,
            0,
            0,
            0,
            1,
            0,
            .6,
            1
        ], i = new Me;
        i.setAttribute("position", new Ae(e, 3)), i.setAttribute("color", new Ae(n, 3));
        let s = new vi({
            vertexColors: !0,
            toneMapped: !1
        });
        super(i, s), this.type = "AxesHelper";
    }
    setColors(t, e, n) {
        let i = new Ne, s = this.geometry.attributes.color.array;
        return i.set(t), i.toArray(s, 0), i.toArray(s, 3), i.set(e), i.toArray(s, 6), i.toArray(s, 9), i.set(n), i.toArray(s, 12), i.toArray(s, 15), this.geometry.attributes.color.needsUpdate = !0, this;
    }
    dispose() {
        this.geometry.dispose(), this.material.dispose();
    }
};
typeof __THREE_DEVTOOLS__ < "u" && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("register", {
    detail: {
        revision: ao
    }
}));
typeof window < "u" && (window.__THREE__ ? console.warn("WARNING: Multiple instances of Three.js being imported.") : window.__THREE__ = ao);
var Mc = ".", Ch = Symbol("target"), sx = Symbol("unsubscribe");
function Ph(r1) {
    return r1 instanceof Date || r1 instanceof Set || r1 instanceof Map || r1 instanceof WeakSet || r1 instanceof WeakMap || ArrayBuffer.isView(r1);
}
function kA(r1) {
    return (typeof r1 == "object" ? r1 === null : typeof r1 != "function") || r1 instanceof RegExp;
}
var ci = Array.isArray;
function nl(r1) {
    return typeof r1 == "symbol";
}
var mF = {
    after: (r1, t)=>ci(r1) ? r1.slice(t.length) : t === "" ? r1 : r1.slice(t.length + 1),
    concat: (r1, t)=>ci(r1) ? (r1 = [
            ...r1
        ], t && r1.push(t), r1) : t && t.toString !== void 0 ? (r1 !== "" && (r1 += Mc), nl(t) ? r1 + t.toString() : r1 + t) : r1,
    initial: (r1)=>{
        if (ci(r1)) return r1.slice(0, -1);
        if (r1 === "") return r1;
        let t = r1.lastIndexOf(Mc);
        return t === -1 ? "" : r1.slice(0, t);
    },
    last: (r1)=>{
        if (ci(r1)) return r1[r1.length - 1] || "";
        if (r1 === "") return r1;
        let t = r1.lastIndexOf(Mc);
        return t === -1 ? r1 : r1.slice(t + 1);
    },
    walk: (r1, t)=>{
        if (ci(r1)) for (let e of r1)t(e);
        else if (r1 !== "") {
            let e = 0, n = r1.indexOf(Mc);
            if (n === -1) t(r1);
            else for(; e < r1.length;)n === -1 && (n = r1.length), t(r1.slice(e, n)), e = n + 1, n = r1.indexOf(Mc, e);
        }
    },
    get (r1, t) {
        return this.walk(t, (e)=>{
            r1 && (r1 = r1[e]);
        }), r1;
    }
}, Rr = mF;
function ox(r1) {
    return typeof r1 == "object" && typeof r1.next == "function";
}
function ax(r1, t, e, n, i) {
    let s = r1.next;
    if (t.name === "entries") r1.next = function() {
        let o = s.call(this);
        return o.done === !1 && (o.value[0] = i(o.value[0], t, o.value[0], n), o.value[1] = i(o.value[1], t, o.value[0], n)), o;
    };
    else if (t.name === "values") {
        let o = e[Ch].keys();
        r1.next = function() {
            let a = s.call(this);
            return a.done === !1 && (a.value = i(a.value, t, o.next().value, n)), a;
        };
    } else r1.next = function() {
        let o = s.call(this);
        return o.done === !1 && (o.value = i(o.value, t, o.value, n)), o;
    };
    return r1;
}
function om(r1, t, e) {
    return r1.isUnsubscribed || t.ignoreSymbols && nl(e) || t.ignoreUnderscores && e.charAt(0) === "_" || "ignoreKeys" in t && t.ignoreKeys.includes(e);
}
var Dh = class {
    constructor(t){
        this._equals = t, this._proxyCache = new WeakMap, this._pathCache = new WeakMap, this.isUnsubscribed = !1;
    }
    _getDescriptorCache() {
        return this._descriptorCache === void 0 && (this._descriptorCache = new WeakMap), this._descriptorCache;
    }
    _getProperties(t) {
        let e = this._getDescriptorCache(), n = e.get(t);
        return n === void 0 && (n = {}, e.set(t, n)), n;
    }
    _getOwnPropertyDescriptor(t, e) {
        if (this.isUnsubscribed) return Reflect.getOwnPropertyDescriptor(t, e);
        let n = this._getProperties(t), i = n[e];
        return i === void 0 && (i = Reflect.getOwnPropertyDescriptor(t, e), n[e] = i), i;
    }
    getProxy(t, e, n, i) {
        if (this.isUnsubscribed) return t;
        let s = t[i], o = s || t;
        this._pathCache.set(o, e);
        let a = this._proxyCache.get(o);
        return a === void 0 && (a = s === void 0 ? new Proxy(t, n) : t, this._proxyCache.set(o, a)), a;
    }
    getPath(t) {
        return this.isUnsubscribed ? void 0 : this._pathCache.get(t);
    }
    isDetached(t, e) {
        return !Object.is(t, Rr.get(e, this.getPath(t)));
    }
    defineProperty(t, e, n) {
        return Reflect.defineProperty(t, e, n) ? (this.isUnsubscribed || (this._getProperties(t)[e] = n), !0) : !1;
    }
    setProperty(t, e, n, i, s) {
        if (!this._equals(s, n) || !(e in t)) {
            let o = this._getOwnPropertyDescriptor(t, e);
            return o !== void 0 && "set" in o ? Reflect.set(t, e, n, i) : Reflect.set(t, e, n);
        }
        return !0;
    }
    deleteProperty(t, e, n) {
        if (Reflect.deleteProperty(t, e)) {
            if (!this.isUnsubscribed) {
                let i = this._getDescriptorCache().get(t);
                i && (delete i[e], this._pathCache.delete(n));
            }
            return !0;
        }
        return !1;
    }
    isSameDescriptor(t, e, n) {
        let i = this._getOwnPropertyDescriptor(e, n);
        return t !== void 0 && i !== void 0 && Object.is(t.value, i.value) && (t.writable || !1) === (i.writable || !1) && (t.enumerable || !1) === (i.enumerable || !1) && (t.configurable || !1) === (i.configurable || !1) && t.get === i.get && t.set === i.set;
    }
    isGetInvariant(t, e) {
        let n = this._getOwnPropertyDescriptor(t, e);
        return n !== void 0 && n.configurable !== !0 && n.writable !== !0;
    }
    unsubscribe() {
        this._descriptorCache = null, this._pathCache = null, this._proxyCache = null, this.isUnsubscribed = !0;
    }
};
function Tc(r1) {
    return toString.call(r1) === "[object Object]";
}
function Ec() {
    return !0;
}
function Ko(r1, t) {
    return r1.length !== t.length || r1.some((e, n)=>t[n] !== e);
}
var am = new Set([
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
]);
var gF = new Set([
    "concat",
    "includes",
    "indexOf",
    "join",
    "keys",
    "lastIndexOf"
]), lx = {
    push: Ec,
    pop: Ec,
    shift: Ec,
    unshift: Ec,
    copyWithin: Ko,
    reverse: Ko,
    sort: Ko,
    splice: Ko,
    flat: Ko,
    fill: Ko
}, zA = new Set([
    ...am,
    ...gF,
    ...Object.keys(lx)
]);
function Cc(r1, t) {
    if (r1.size !== t.size) return !0;
    for (let e of r1)if (!t.has(e)) return !0;
    return !1;
}
var cx = [
    "keys",
    "values",
    "entries"
], ux = new Set([
    "has",
    "toString"
]), dx = {
    add: Cc,
    clear: Cc,
    delete: Cc,
    forEach: Cc
}, GA = new Set([
    ...ux,
    ...Object.keys(dx),
    ...cx
]);
function Pc(r1, t) {
    if (r1.size !== t.size) return !0;
    let e;
    for (let [n, i] of r1)if (e = t.get(n), e !== i || e === void 0 && !t.has(n)) return !0;
    return !1;
}
var yF = new Set([
    ...ux,
    "get"
]), hx = {
    set: Pc,
    clear: Pc,
    delete: Pc,
    forEach: Pc
}, VA = new Set([
    ...yF,
    ...Object.keys(hx),
    ...cx
]);
var nr = class {
    constructor(t, e, n, i){
        this._path = e, this._isChanged = !1, this._clonedCache = new Set, this._hasOnValidate = i, this._changes = i ? [] : null, this.clone = e === void 0 ? t : this._shallowClone(t);
    }
    static isHandledMethod(t) {
        return am.has(t);
    }
    _shallowClone(t) {
        let e = t;
        if (Tc(t)) e = {
            ...t
        };
        else if (ci(t)) e = [
            ...t
        ];
        else if (t instanceof Date) e = new Date(t);
        else if (t instanceof Set) e = new Set([
            ...t
        ].map((n)=>this._shallowClone(n)));
        else if (t instanceof Map) {
            e = new Map;
            for (let [n, i] of t.entries())e.set(n, this._shallowClone(i));
        }
        return this._clonedCache.add(e), e;
    }
    preferredThisArg(t, e, n, i) {
        return t ? (ci(i) ? this._onIsChanged = lx[e] : i instanceof Set ? this._onIsChanged = dx[e] : i instanceof Map && (this._onIsChanged = hx[e]), i) : n;
    }
    update(t, e, n) {
        let i = Rr.after(t, this._path);
        if (e !== "length") {
            let s = this.clone;
            Rr.walk(i, (o)=>{
                s && s[o] && (this._clonedCache.has(s[o]) || (s[o] = this._shallowClone(s[o])), s = s[o]);
            }), this._hasOnValidate && this._changes.push({
                path: i,
                property: e,
                previous: n
            }), s && s[e] && (s[e] = n);
        }
        this._isChanged = !0;
    }
    undo(t) {
        let e;
        for(let n = this._changes.length - 1; n !== -1; n--)e = this._changes[n], Rr.get(t, e.path)[e.property] = e.previous;
    }
    isChanged(t) {
        return this._onIsChanged === void 0 ? this._isChanged : this._onIsChanged(this.clone, t);
    }
};
var Dc = class extends nr {
    static isHandledMethod(t) {
        return zA.has(t);
    }
};
var Ih = class extends nr {
    undo(t) {
        t.setTime(this.clone.getTime());
    }
    isChanged(t, e) {
        return !e(this.clone.valueOf(), t.valueOf());
    }
};
var Ic = class extends nr {
    static isHandledMethod(t) {
        return GA.has(t);
    }
    undo(t) {
        for (let e of this.clone)t.add(e);
        for (let e of t)this.clone.has(e) || t.delete(e);
    }
};
var Oc = class extends nr {
    static isHandledMethod(t) {
        return VA.has(t);
    }
    undo(t) {
        for (let [e, n] of this.clone.entries())t.set(e, n);
        for (let e of t.keys())this.clone.has(e) || t.delete(e);
    }
};
var Oh = class extends nr {
    constructor(t, e, n, i){
        super(void 0, e, n, i), this._arg1 = n[0], this._weakValue = t.has(this._arg1);
    }
    isChanged(t) {
        return this._weakValue !== t.has(this._arg1);
    }
    undo(t) {
        this._weakValue && !t.has(this._arg1) ? t.add(this._arg1) : t.delete(this._arg1);
    }
};
var Rh = class extends nr {
    constructor(t, e, n, i){
        super(void 0, e, n, i), this._weakKey = n[0], this._weakHas = t.has(this._weakKey), this._weakValue = t.get(this._weakKey);
    }
    isChanged(t) {
        return this._weakValue !== t.get(this._weakKey);
    }
    undo(t) {
        let e = t.has(this._weakKey);
        this._weakHas && !e ? t.set(this._weakKey, this._weakValue) : !this._weakHas && e ? t.delete(this._weakKey) : this._weakValue !== t.get(this._weakKey) && t.set(this._weakKey, this._weakValue);
    }
};
var Vi = class {
    constructor(t){
        this._stack = [], this._hasOnValidate = t;
    }
    static isHandledType(t) {
        return Tc(t) || ci(t) || Ph(t);
    }
    static isHandledMethod(t, e) {
        return Tc(t) ? nr.isHandledMethod(e) : ci(t) ? Dc.isHandledMethod(e) : t instanceof Set ? Ic.isHandledMethod(e) : t instanceof Map ? Oc.isHandledMethod(e) : Ph(t);
    }
    get isCloning() {
        return this._stack.length > 0;
    }
    start(t, e, n) {
        let i = nr;
        ci(t) ? i = Dc : t instanceof Date ? i = Ih : t instanceof Set ? i = Ic : t instanceof Map ? i = Oc : t instanceof WeakSet ? i = Oh : t instanceof WeakMap && (i = Rh), this._stack.push(new i(t, e, n, this._hasOnValidate));
    }
    update(t, e, n) {
        this._stack[this._stack.length - 1].update(t, e, n);
    }
    preferredThisArg(t, e, n) {
        let { name: i  } = t, s = Vi.isHandledMethod(n, i);
        return this._stack[this._stack.length - 1].preferredThisArg(s, i, e, n);
    }
    isChanged(t, e, n) {
        return this._stack[this._stack.length - 1].isChanged(t, e, n);
    }
    undo(t) {
        this._previousClone !== void 0 && this._previousClone.undo(t);
    }
    stop() {
        return this._previousClone = this._stack.pop(), this._previousClone.clone;
    }
};
var vF = {
    equals: Object.is,
    isShallow: !1,
    pathAsArray: !1,
    ignoreSymbols: !1,
    ignoreUnderscores: !1,
    ignoreDetached: !1,
    details: !1
}, fx = (r1, t, e = {})=>{
    e = {
        ...vF,
        ...e
    };
    let n = Symbol("ProxyTarget"), { equals: i , isShallow: s , ignoreDetached: o , details: a  } = e, l = new Dh(i), u = typeof e.onValidate == "function", c = new Vi(u), d = (v, x, w, S, _)=>!u || c.isCloning || e.onValidate(Rr.concat(l.getPath(v), x), w, S, _) === !0, h = (v, x, w, S)=>{
        !om(l, e, x) && !(o && l.isDetached(v, r1)) && f(l.getPath(v), x, w, S);
    }, f = (v, x, w, S, _)=>{
        c.isCloning ? c.update(v, x, S) : t(Rr.concat(v, x), w, S, _);
    }, m = (v)=>v && (v[n] || v), p = (v, x, w, S)=>kA(v) || w === "constructor" || s && !Vi.isHandledMethod(x, w) || om(l, e, w) || l.isGetInvariant(x, w) || o && l.isDetached(x, r1) ? v : (S === void 0 && (S = l.getPath(x)), l.getProxy(v, Rr.concat(S, w), g, n)), g = {
        get (v, x, w) {
            if (nl(x)) {
                if (x === n || x === Ch) return v;
                if (x === sx && !l.isUnsubscribed && l.getPath(v).length === 0) return l.unsubscribe(), v;
            }
            let S = Ph(v) ? Reflect.get(v, x) : Reflect.get(v, x, w);
            return p(S, v, x);
        },
        set (v, x, w, S) {
            w = m(w);
            let _ = v[n] || v, M = _[x];
            if (i(M, w) && x in v) return !0;
            let b = d(v, x, w, M);
            return b && l.setProperty(_, x, w, S, M) ? (h(v, x, v[x], M), !0) : !b;
        },
        defineProperty (v, x, w) {
            if (!l.isSameDescriptor(w, v, x)) {
                let S = v[x];
                d(v, x, w.value, S) && l.defineProperty(v, x, w, S) && h(v, x, w.value, S);
            }
            return !0;
        },
        deleteProperty (v, x) {
            if (!Reflect.has(v, x)) return !0;
            let w = Reflect.get(v, x), S = d(v, x, void 0, w);
            return S && l.deleteProperty(v, x, w) ? (h(v, x, void 0, w), !0) : !S;
        },
        apply (v, x, w) {
            let S = x[n] || x;
            if (l.isUnsubscribed) return Reflect.apply(v, S, w);
            if ((a === !1 || a !== !0 && !a.includes(v.name)) && Vi.isHandledType(S)) {
                let _ = Rr.initial(l.getPath(v)), M = Vi.isHandledMethod(S, v.name);
                c.start(S, _, w);
                let b = Reflect.apply(v, c.preferredThisArg(v, x, S), M ? w.map((P)=>m(P)) : w), T = c.isChanged(S, i), E = c.stop();
                if (Vi.isHandledType(b) && M && (x instanceof Map && v.name === "get" && (_ = Rr.concat(_, w[0])), b = l.getProxy(b, _, g)), T) {
                    let P = {
                        name: v.name,
                        args: w,
                        result: b
                    }, D = c.isCloning ? Rr.initial(_) : _, C = c.isCloning ? Rr.last(_) : "";
                    d(Rr.get(r1, D), C, S, E, P) ? f(D, C, S, E, P) : c.undo(S);
                }
                return (x instanceof Map || x instanceof Set) && ox(b) ? ax(b, v, x, _, p) : b;
            }
            return Reflect.apply(v, x, w);
        }
    }, y = l.getProxy(r1, e.pathAsArray ? [] : "", g);
    return t = t.bind(y), u && (e.onValidate = e.onValidate.bind(y)), y;
};
fx.target = (r1)=>r1 && r1[Ch] || r1;
fx.unsubscribe = (r1)=>r1[sx] || r1;
var px = fx;
var xF = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global, lm = xF;
var bF = typeof self == "object" && self && self.Object === Object && self, wF = lm || bF || Function("return this")(), ln = wF;
var SF = ln.Symbol, rr = SF;
var HA = Object.prototype, AF = HA.hasOwnProperty, _F = HA.toString, Lh = rr ? rr.toStringTag : void 0;
function MF(r1) {
    var t = AF.call(r1, Lh), e = r1[Lh];
    try {
        r1[Lh] = void 0;
        var n = !0;
    } catch  {}
    var i = _F.call(r1);
    return n && (t ? r1[Lh] = e : delete r1[Lh]), i;
}
var WA = MF;
var TF = Object.prototype, EF = TF.toString;
function CF(r1) {
    return EF.call(r1);
}
var jA = CF;
var PF = "[object Null]", DF = "[object Undefined]", qA = rr ? rr.toStringTag : void 0;
function IF(r1) {
    return r1 == null ? r1 === void 0 ? DF : PF : qA && qA in Object(r1) ? WA(r1) : jA(r1);
}
var ui = IF;
function OF(r1) {
    return r1 != null && typeof r1 == "object";
}
var mr = OF;
var RF = "[object Symbol]";
function LF(r1) {
    return typeof r1 == "symbol" || mr(r1) && ui(r1) == RF;
}
var Zo = LF;
function NF(r1, t) {
    for(var e = -1, n = r1 == null ? 0 : r1.length, i = Array(n); ++e < n;)i[e] = t(r1[e], e, r1);
    return i;
}
var cm = NF;
var BF = Array.isArray, Wn = BF;
var FF = 1 / 0, XA = rr ? rr.prototype : void 0, YA = XA ? XA.toString : void 0;
function QA(r1) {
    if (typeof r1 == "string") return r1;
    if (Wn(r1)) return cm(r1, QA) + "";
    if (Zo(r1)) return YA ? YA.call(r1) : "";
    var t = r1 + "";
    return t == "0" && 1 / r1 == -FF ? "-0" : t;
}
var KA = QA;
var UF = /\s/;
function kF(r1) {
    for(var t = r1.length; t-- && UF.test(r1.charAt(t)););
    return t;
}
var ZA = kF;
var zF = /^\s+/;
function GF(r1) {
    return r1 && r1.slice(0, ZA(r1) + 1).replace(zF, "");
}
var JA = GF;
function VF(r1) {
    var t = typeof r1;
    return r1 != null && (t == "object" || t == "function");
}
var Ln = VF;
var $A = 0 / 0, HF = /^[-+]0x[0-9a-f]+$/i, WF = /^0b[01]+$/i, jF = /^0o[0-7]+$/i, qF = parseInt;
function XF(r1) {
    if (typeof r1 == "number") return r1;
    if (Zo(r1)) return $A;
    if (Ln(r1)) {
        var t = typeof r1.valueOf == "function" ? r1.valueOf() : r1;
        r1 = Ln(t) ? t + "" : t;
    }
    if (typeof r1 != "string") return r1 === 0 ? r1 : +r1;
    r1 = JA(r1);
    var e = WF.test(r1);
    return e || jF.test(r1) ? qF(r1.slice(2), e ? 2 : 8) : HF.test(r1) ? $A : +r1;
}
var mx = XF;
function YF(r1) {
    return r1;
}
var e_ = YF;
var QF = "[object AsyncFunction]", KF = "[object Function]", ZF = "[object GeneratorFunction]", JF = "[object Proxy]";
function $F(r1) {
    if (!Ln(r1)) return !1;
    var t = ui(r1);
    return t == KF || t == ZF || t == QF || t == JF;
}
var um = $F;
var eU = ln["__core-js_shared__"], dm = eU;
var t_ = function() {
    var r1 = /[^.]+$/.exec(dm && dm.keys && dm.keys.IE_PROTO || "");
    return r1 ? "Symbol(src)_1." + r1 : "";
}();
function tU(r1) {
    return !!t_ && t_ in r1;
}
var n_ = tU;
var nU = Function.prototype, rU = nU.toString;
function iU(r1) {
    if (r1 != null) {
        try {
            return rU.call(r1);
        } catch  {}
        try {
            return r1 + "";
        } catch  {}
    }
    return "";
}
var lo = iU;
var sU = /[\\^$.*+?()[\]{}|]/g, oU = /^\[object .+?Constructor\]$/, aU = Function.prototype, lU = Object.prototype, cU = aU.toString, uU = lU.hasOwnProperty, dU = RegExp("^" + cU.call(uU).replace(sU, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
function hU(r1) {
    if (!Ln(r1) || n_(r1)) return !1;
    var t = um(r1) ? dU : oU;
    return t.test(lo(r1));
}
var r_ = hU;
function fU(r1, t) {
    return r1?.[t];
}
var i_ = fU;
function pU(r1, t) {
    var e = i_(r1, t);
    return r_(e) ? e : void 0;
}
var Vr = pU;
var mU = Vr(ln, "WeakMap"), hm = mU;
var s_ = Object.create, gU = function() {
    function r1() {}
    return function(t) {
        if (!Ln(t)) return {};
        if (s_) return s_(t);
        r1.prototype = t;
        var e = new r1;
        return r1.prototype = void 0, e;
    };
}(), o_ = gU;
function yU(r1, t, e) {
    switch(e.length){
        case 0:
            return r1.call(t);
        case 1:
            return r1.call(t, e[0]);
        case 2:
            return r1.call(t, e[0], e[1]);
        case 3:
            return r1.call(t, e[0], e[1], e[2]);
    }
    return r1.apply(t, e);
}
var a_ = yU;
function vU(r1, t) {
    var e = -1, n = r1.length;
    for(t || (t = Array(n)); ++e < n;)t[e] = r1[e];
    return t;
}
var l_ = vU;
var xU = 800, bU = 16, wU = Date.now;
function SU(r1) {
    var t = 0, e = 0;
    return function() {
        var n = wU(), i = bU - (n - e);
        if (e = n, i > 0) {
            if (++t >= xU) return arguments[0];
        } else t = 0;
        return r1.apply(void 0, arguments);
    };
}
var c_ = SU;
function AU(r1) {
    return function() {
        return r1;
    };
}
var u_ = AU;
var _U = function() {
    try {
        var r1 = Vr(Object, "defineProperty");
        return r1({}, "", {}), r1;
    } catch  {}
}(), Rc = _U;
var MU = Rc ? function(r1, t) {
    return Rc(r1, "toString", {
        configurable: !0,
        enumerable: !1,
        value: u_(t),
        writable: !0
    });
} : e_, d_ = MU;
var TU = c_(d_), h_ = TU;
function EU(r1, t) {
    for(var e = -1, n = r1 == null ? 0 : r1.length; ++e < n && t(r1[e], e, r1) !== !1;);
    return r1;
}
var f_ = EU;
var CU = 9007199254740991, PU = /^(?:0|[1-9]\d*)$/;
function DU(r1, t) {
    var e = typeof r1;
    return t = t ?? CU, !!t && (e == "number" || e != "symbol" && PU.test(r1)) && r1 > -1 && r1 % 1 == 0 && r1 < t;
}
var Lc = DU;
function IU(r1, t, e) {
    t == "__proto__" && Rc ? Rc(r1, t, {
        configurable: !0,
        enumerable: !0,
        value: e,
        writable: !0
    }) : r1[t] = e;
}
var fm = IU;
function OU(r1, t) {
    return r1 === t || r1 !== r1 && t !== t;
}
var Nc = OU;
var RU = Object.prototype, LU = RU.hasOwnProperty;
function NU(r1, t, e) {
    var n = r1[t];
    (!(LU.call(r1, t) && Nc(n, e)) || e === void 0 && !(t in r1)) && fm(r1, t, e);
}
var Bc = NU;
function BU(r1, t, e, n) {
    var i = !e;
    e || (e = {});
    for(var s = -1, o = t.length; ++s < o;){
        var a = t[s], l = n ? n(e[a], r1[a], a, e, r1) : void 0;
        l === void 0 && (l = r1[a]), i ? fm(e, a, l) : Bc(e, a, l);
    }
    return e;
}
var vs = BU;
var p_ = Math.max;
function FU(r1, t, e) {
    return t = p_(t === void 0 ? r1.length - 1 : t, 0), function() {
        for(var n = arguments, i = -1, s = p_(n.length - t, 0), o = Array(s); ++i < s;)o[i] = n[t + i];
        i = -1;
        for(var a = Array(t + 1); ++i < t;)a[i] = n[i];
        return a[t] = e(o), a_(r1, this, a);
    };
}
var m_ = FU;
var UU = 9007199254740991;
function kU(r1) {
    return typeof r1 == "number" && r1 > -1 && r1 % 1 == 0 && r1 <= UU;
}
var Fc = kU;
function zU(r1) {
    return r1 != null && Fc(r1.length) && !um(r1);
}
var pm = zU;
var GU = Object.prototype;
function VU(r1) {
    var t = r1 && r1.constructor, e = typeof t == "function" && t.prototype || GU;
    return r1 === e;
}
var Uc = VU;
function HU(r1, t) {
    for(var e = -1, n = Array(r1); ++e < r1;)n[e] = t(e);
    return n;
}
var g_ = HU;
var WU = "[object Arguments]";
function jU(r1) {
    return mr(r1) && ui(r1) == WU;
}
var gx = jU;
var y_ = Object.prototype, qU = y_.hasOwnProperty, XU = y_.propertyIsEnumerable, YU = gx(function() {
    return arguments;
}()) ? gx : function(r1) {
    return mr(r1) && qU.call(r1, "callee") && !XU.call(r1, "callee");
}, kc = YU;
function QU() {
    return !1;
}
var v_ = QU;
var w_ = exports && !exports.nodeType && exports, x_ = w_ && true && module && !module.nodeType && module, KU = x_ && x_.exports === w_, b_ = KU ? ln.Buffer : void 0, ZU = b_ ? b_.isBuffer : void 0, JU = ZU || v_, rl = JU;
var $U = "[object Arguments]", ek = "[object Array]", tk = "[object Boolean]", nk = "[object Date]", rk = "[object Error]", ik = "[object Function]", sk = "[object Map]", ok = "[object Number]", ak = "[object Object]", lk = "[object RegExp]", ck = "[object Set]", uk = "[object String]", dk = "[object WeakMap]", hk = "[object ArrayBuffer]", fk = "[object DataView]", pk = "[object Float32Array]", mk = "[object Float64Array]", gk = "[object Int8Array]", yk = "[object Int16Array]", vk = "[object Int32Array]", xk = "[object Uint8Array]", bk = "[object Uint8ClampedArray]", wk = "[object Uint16Array]", Sk = "[object Uint32Array]", Xt = {};
Xt[pk] = Xt[mk] = Xt[gk] = Xt[yk] = Xt[vk] = Xt[xk] = Xt[bk] = Xt[wk] = Xt[Sk] = !0;
Xt[$U] = Xt[ek] = Xt[hk] = Xt[tk] = Xt[fk] = Xt[nk] = Xt[rk] = Xt[ik] = Xt[sk] = Xt[ok] = Xt[ak] = Xt[lk] = Xt[ck] = Xt[uk] = Xt[dk] = !1;
function Ak(r1) {
    return mr(r1) && Fc(r1.length) && !!Xt[ui(r1)];
}
var S_ = Ak;
function _k(r1) {
    return function(t) {
        return r1(t);
    };
}
var zc = _k;
var A_ = exports && !exports.nodeType && exports, Nh = A_ && true && module && !module.nodeType && module, Mk = Nh && Nh.exports === A_, yx = Mk && lm.process, Tk = function() {
    try {
        var r1 = Nh && Nh.require && Nh.require("util").types;
        return r1 || yx && yx.binding && yx.binding("util");
    } catch  {}
}(), co = Tk;
var __ = co && co.isTypedArray, Ek = __ ? zc(__) : S_, mm = Ek;
var Ck = Object.prototype, Pk = Ck.hasOwnProperty;
function Dk(r1, t) {
    var e = Wn(r1), n = !e && kc(r1), i = !e && !n && rl(r1), s = !e && !n && !i && mm(r1), o = e || n || i || s, a = o ? g_(r1.length, String) : [], l = a.length;
    for(var u in r1)(t || Pk.call(r1, u)) && !(o && (u == "length" || i && (u == "offset" || u == "parent") || s && (u == "buffer" || u == "byteLength" || u == "byteOffset") || Lc(u, l))) && a.push(u);
    return a;
}
var gm = Dk;
function Ik(r1, t) {
    return function(e) {
        return r1(t(e));
    };
}
var ym = Ik;
var Ok = ym(Object.keys, Object), M_ = Ok;
var Rk = Object.prototype, Lk = Rk.hasOwnProperty;
function Nk(r1) {
    if (!Uc(r1)) return M_(r1);
    var t = [];
    for(var e in Object(r1))Lk.call(r1, e) && e != "constructor" && t.push(e);
    return t;
}
var T_ = Nk;
function Bk(r1) {
    return pm(r1) ? gm(r1) : T_(r1);
}
var Gc = Bk;
function Fk(r1) {
    var t = [];
    if (r1 != null) for(var e in Object(r1))t.push(e);
    return t;
}
var E_ = Fk;
var Uk = Object.prototype, kk = Uk.hasOwnProperty;
function zk(r1) {
    if (!Ln(r1)) return E_(r1);
    var t = Uc(r1), e = [];
    for(var n in r1)n == "constructor" && (t || !kk.call(r1, n)) || e.push(n);
    return e;
}
var C_ = zk;
function Gk(r1) {
    return pm(r1) ? gm(r1, !0) : C_(r1);
}
var Vc = Gk;
var Vk = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Hk = /^\w*$/;
function Wk(r1, t) {
    if (Wn(r1)) return !1;
    var e = typeof r1;
    return e == "number" || e == "symbol" || e == "boolean" || r1 == null || Zo(r1) ? !0 : Hk.test(r1) || !Vk.test(r1) || t != null && r1 in Object(t);
}
var P_ = Wk;
var jk = Vr(Object, "create"), uo = jk;
function qk() {
    this.__data__ = uo ? uo(null) : {}, this.size = 0;
}
var D_ = qk;
function Xk(r1) {
    var t = this.has(r1) && delete this.__data__[r1];
    return this.size -= t ? 1 : 0, t;
}
var I_ = Xk;
var Yk = "__lodash_hash_undefined__", Qk = Object.prototype, Kk = Qk.hasOwnProperty;
function Zk(r1) {
    var t = this.__data__;
    if (uo) {
        var e = t[r1];
        return e === Yk ? void 0 : e;
    }
    return Kk.call(t, r1) ? t[r1] : void 0;
}
var O_ = Zk;
var Jk = Object.prototype, $k = Jk.hasOwnProperty;
function ez(r1) {
    var t = this.__data__;
    return uo ? t[r1] !== void 0 : $k.call(t, r1);
}
var R_ = ez;
var tz = "__lodash_hash_undefined__";
function nz(r1, t) {
    var e = this.__data__;
    return this.size += this.has(r1) ? 0 : 1, e[r1] = uo && t === void 0 ? tz : t, this;
}
var L_ = nz;
function Hc(r1) {
    var t = -1, e = r1 == null ? 0 : r1.length;
    for(this.clear(); ++t < e;){
        var n = r1[t];
        this.set(n[0], n[1]);
    }
}
Hc.prototype.clear = D_;
Hc.prototype.delete = I_;
Hc.prototype.get = O_;
Hc.prototype.has = R_;
Hc.prototype.set = L_;
var vx = Hc;
function rz() {
    this.__data__ = [], this.size = 0;
}
var N_ = rz;
function iz(r1, t) {
    for(var e = r1.length; e--;)if (Nc(r1[e][0], t)) return e;
    return -1;
}
var Jo = iz;
var sz = Array.prototype, oz = sz.splice;
function az(r1) {
    var t = this.__data__, e = Jo(t, r1);
    if (e < 0) return !1;
    var n = t.length - 1;
    return e == n ? t.pop() : oz.call(t, e, 1), --this.size, !0;
}
var B_ = az;
function lz(r1) {
    var t = this.__data__, e = Jo(t, r1);
    return e < 0 ? void 0 : t[e][1];
}
var F_ = lz;
function cz(r1) {
    return Jo(this.__data__, r1) > -1;
}
var U_ = cz;
function uz(r1, t) {
    var e = this.__data__, n = Jo(e, r1);
    return n < 0 ? (++this.size, e.push([
        r1,
        t
    ])) : e[n][1] = t, this;
}
var k_ = uz;
function Wc(r1) {
    var t = -1, e = r1 == null ? 0 : r1.length;
    for(this.clear(); ++t < e;){
        var n = r1[t];
        this.set(n[0], n[1]);
    }
}
Wc.prototype.clear = N_;
Wc.prototype.delete = B_;
Wc.prototype.get = F_;
Wc.prototype.has = U_;
Wc.prototype.set = k_;
var $o = Wc;
var dz = Vr(ln, "Map"), ea = dz;
function hz() {
    this.size = 0, this.__data__ = {
        hash: new vx,
        map: new (ea || $o),
        string: new vx
    };
}
var z_ = hz;
function fz(r1) {
    var t = typeof r1;
    return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? r1 !== "__proto__" : r1 === null;
}
var G_ = fz;
function pz(r1, t) {
    var e = r1.__data__;
    return G_(t) ? e[typeof t == "string" ? "string" : "hash"] : e.map;
}
var ta = pz;
function mz(r1) {
    var t = ta(this, r1).delete(r1);
    return this.size -= t ? 1 : 0, t;
}
var V_ = mz;
function gz(r1) {
    return ta(this, r1).get(r1);
}
var H_ = gz;
function yz(r1) {
    return ta(this, r1).has(r1);
}
var W_ = yz;
function vz(r1, t) {
    var e = ta(this, r1), n = e.size;
    return e.set(r1, t), this.size += e.size == n ? 0 : 1, this;
}
var j_ = vz;
function jc(r1) {
    var t = -1, e = r1 == null ? 0 : r1.length;
    for(this.clear(); ++t < e;){
        var n = r1[t];
        this.set(n[0], n[1]);
    }
}
jc.prototype.clear = z_;
jc.prototype.delete = V_;
jc.prototype.get = H_;
jc.prototype.has = W_;
jc.prototype.set = j_;
var il = jc;
var xz = "Expected a function";
function xx(r1, t) {
    if (typeof r1 != "function" || t != null && typeof t != "function") throw new TypeError(xz);
    var e = function() {
        var n = arguments, i = t ? t.apply(this, n) : n[0], s = e.cache;
        if (s.has(i)) return s.get(i);
        var o = r1.apply(this, n);
        return e.cache = s.set(i, o) || s, o;
    };
    return e.cache = new (xx.Cache || il), e;
}
xx.Cache = il;
var q_ = xx;
var bz = 500;
function wz(r1) {
    var t = q_(r1, function(n) {
        return e.size === bz && e.clear(), n;
    }), e = t.cache;
    return t;
}
var X_ = wz;
var Sz = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Az = /\\(\\)?/g, _z = X_(function(r1) {
    var t = [];
    return r1.charCodeAt(0) === 46 && t.push(""), r1.replace(Sz, function(e, n, i, s) {
        t.push(i ? s.replace(Az, "$1") : n || e);
    }), t;
}), Y_ = _z;
function Mz(r1) {
    return r1 == null ? "" : KA(r1);
}
var Q_ = Mz;
function Tz(r1, t) {
    return Wn(r1) ? r1 : P_(r1, t) ? [
        r1
    ] : Y_(Q_(r1));
}
var bi = Tz;
var Ez = 1 / 0;
function Cz(r1) {
    if (typeof r1 == "string" || Zo(r1)) return r1;
    var t = r1 + "";
    return t == "0" && 1 / r1 == -Ez ? "-0" : t;
}
var na = Cz;
function Pz(r1, t) {
    t = bi(t, r1);
    for(var e = 0, n = t.length; r1 != null && e < n;)r1 = r1[na(t[e++])];
    return e && e == n ? r1 : void 0;
}
var vm = Pz;
function Dz(r1, t) {
    for(var e = -1, n = t.length, i = r1.length; ++e < n;)r1[i + e] = t[e];
    return r1;
}
var qc = Dz;
var K_ = rr ? rr.isConcatSpreadable : void 0;
function Iz(r1) {
    return Wn(r1) || kc(r1) || !!(K_ && r1 && r1[K_]);
}
var Z_ = Iz;
function J_(r1, t, e, n, i) {
    var s = -1, o = r1.length;
    for(e || (e = Z_), i || (i = []); ++s < o;){
        var a = r1[s];
        t > 0 && e(a) ? t > 1 ? J_(a, t - 1, e, n, i) : qc(i, a) : n || (i[i.length] = a);
    }
    return i;
}
var $_ = J_;
function Oz(r1) {
    var t = r1 == null ? 0 : r1.length;
    return t ? $_(r1, 1) : [];
}
var eM = Oz;
function Rz(r1) {
    return h_(m_(r1, void 0, eM), r1 + "");
}
var xm = Rz;
var Lz = ym(Object.getPrototypeOf, Object), Xc = Lz;
var Nz = "[object Object]", Bz = Function.prototype, Fz = Object.prototype, tM = Bz.toString, Uz = Fz.hasOwnProperty, kz = tM.call(Object);
function zz(r1) {
    if (!mr(r1) || ui(r1) != Nz) return !1;
    var t = Xc(r1);
    if (t === null) return !0;
    var e = Uz.call(t, "constructor") && t.constructor;
    return typeof e == "function" && e instanceof e && tM.call(e) == kz;
}
var nM = zz;
function Gz(r1, t, e) {
    var n = -1, i = r1.length;
    t < 0 && (t = -t > i ? 0 : i + t), e = e > i ? i : e, e < 0 && (e += i), i = t > e ? 0 : e - t >>> 0, t >>>= 0;
    for(var s = Array(i); ++n < i;)s[n] = r1[n + t];
    return s;
}
var rM = Gz;
function Vz() {
    this.__data__ = new $o, this.size = 0;
}
var iM = Vz;
function Hz(r1) {
    var t = this.__data__, e = t.delete(r1);
    return this.size = t.size, e;
}
var sM = Hz;
function Wz(r1) {
    return this.__data__.get(r1);
}
var oM = Wz;
function jz(r1) {
    return this.__data__.has(r1);
}
var aM = jz;
var qz = 200;
function Xz(r1, t) {
    var e = this.__data__;
    if (e instanceof $o) {
        var n = e.__data__;
        if (!ea || n.length < qz - 1) return n.push([
            r1,
            t
        ]), this.size = ++e.size, this;
        e = this.__data__ = new il(n);
    }
    return e.set(r1, t), this.size = e.size, this;
}
var lM = Xz;
function Yc(r1) {
    var t = this.__data__ = new $o(r1);
    this.size = t.size;
}
Yc.prototype.clear = iM;
Yc.prototype.delete = sM;
Yc.prototype.get = oM;
Yc.prototype.has = aM;
Yc.prototype.set = lM;
var Qc = Yc;
function Yz(r1, t) {
    return r1 && vs(t, Gc(t), r1);
}
var cM = Yz;
function Qz(r1, t) {
    return r1 && vs(t, Vc(t), r1);
}
var uM = Qz;
var pM = exports && !exports.nodeType && exports, dM = pM && true && module && !module.nodeType && module, Kz = dM && dM.exports === pM, hM = Kz ? ln.Buffer : void 0, fM = hM ? hM.allocUnsafe : void 0;
function Zz(r1, t) {
    if (t) return r1.slice();
    var e = r1.length, n = fM ? fM(e) : new r1.constructor(e);
    return r1.copy(n), n;
}
var mM = Zz;
function Jz(r1, t) {
    for(var e = -1, n = r1 == null ? 0 : r1.length, i = 0, s = []; ++e < n;){
        var o = r1[e];
        t(o, e, r1) && (s[i++] = o);
    }
    return s;
}
var gM = Jz;
function $z() {
    return [];
}
var bm = $z;
var eG = Object.prototype, tG = eG.propertyIsEnumerable, yM = Object.getOwnPropertySymbols, nG = yM ? function(r1) {
    return r1 == null ? [] : (r1 = Object(r1), gM(yM(r1), function(t) {
        return tG.call(r1, t);
    }));
} : bm, Kc = nG;
function rG(r1, t) {
    return vs(r1, Kc(r1), t);
}
var vM = rG;
var iG = Object.getOwnPropertySymbols, sG = iG ? function(r1) {
    for(var t = []; r1;)qc(t, Kc(r1)), r1 = Xc(r1);
    return t;
} : bm, wm = sG;
function oG(r1, t) {
    return vs(r1, wm(r1), t);
}
var xM = oG;
function aG(r1, t, e) {
    var n = t(r1);
    return Wn(r1) ? n : qc(n, e(r1));
}
var Sm = aG;
function lG(r1) {
    return Sm(r1, Gc, Kc);
}
var Bh = lG;
function cG(r1) {
    return Sm(r1, Vc, wm);
}
var Am = cG;
var uG = Vr(ln, "DataView"), _m = uG;
var dG = Vr(ln, "Promise"), Mm = dG;
var hG = Vr(ln, "Set"), Tm = hG;
var bM = "[object Map]", fG = "[object Object]", wM = "[object Promise]", SM = "[object Set]", AM = "[object WeakMap]", _M = "[object DataView]", pG = lo(_m), mG = lo(ea), gG = lo(Mm), yG = lo(Tm), vG = lo(hm), sl = ui;
(_m && sl(new _m(new ArrayBuffer(1))) != _M || ea && sl(new ea) != bM || Mm && sl(Mm.resolve()) != wM || Tm && sl(new Tm) != SM || hm && sl(new hm) != AM) && (sl = function(r1) {
    var t = ui(r1), e = t == fG ? r1.constructor : void 0, n = e ? lo(e) : "";
    if (n) switch(n){
        case pG:
            return _M;
        case mG:
            return bM;
        case gG:
            return wM;
        case yG:
            return SM;
        case vG:
            return AM;
    }
    return t;
});
var ho = sl;
var xG = Object.prototype, bG = xG.hasOwnProperty;
function wG(r1) {
    var t = r1.length, e = new r1.constructor(t);
    return t && typeof r1[0] == "string" && bG.call(r1, "index") && (e.index = r1.index, e.input = r1.input), e;
}
var MM = wG;
var SG = ln.Uint8Array, Zc = SG;
function AG(r1) {
    var t = new r1.constructor(r1.byteLength);
    return new Zc(t).set(new Zc(r1)), t;
}
var Jc = AG;
function _G(r1, t) {
    var e = t ? Jc(r1.buffer) : r1.buffer;
    return new r1.constructor(e, r1.byteOffset, r1.byteLength);
}
var TM = _G;
var MG = /\w*$/;
function TG(r1) {
    var t = new r1.constructor(r1.source, MG.exec(r1));
    return t.lastIndex = r1.lastIndex, t;
}
var EM = TG;
var CM = rr ? rr.prototype : void 0, PM = CM ? CM.valueOf : void 0;
function EG(r1) {
    return PM ? Object(PM.call(r1)) : {};
}
var DM = EG;
function CG(r1, t) {
    var e = t ? Jc(r1.buffer) : r1.buffer;
    return new r1.constructor(e, r1.byteOffset, r1.length);
}
var IM = CG;
var PG = "[object Boolean]", DG = "[object Date]", IG = "[object Map]", OG = "[object Number]", RG = "[object RegExp]", LG = "[object Set]", NG = "[object String]", BG = "[object Symbol]", FG = "[object ArrayBuffer]", UG = "[object DataView]", kG = "[object Float32Array]", zG = "[object Float64Array]", GG = "[object Int8Array]", VG = "[object Int16Array]", HG = "[object Int32Array]", WG = "[object Uint8Array]", jG = "[object Uint8ClampedArray]", qG = "[object Uint16Array]", XG = "[object Uint32Array]";
function YG(r1, t, e) {
    var n = r1.constructor;
    switch(t){
        case FG:
            return Jc(r1);
        case PG:
        case DG:
            return new n(+r1);
        case UG:
            return TM(r1, e);
        case kG:
        case zG:
        case GG:
        case VG:
        case HG:
        case WG:
        case jG:
        case qG:
        case XG:
            return IM(r1, e);
        case IG:
            return new n;
        case OG:
        case NG:
            return new n(r1);
        case RG:
            return EM(r1);
        case LG:
            return new n;
        case BG:
            return DM(r1);
    }
}
var OM = YG;
function QG(r1) {
    return typeof r1.constructor == "function" && !Uc(r1) ? o_(Xc(r1)) : {};
}
var RM = QG;
var KG = "[object Map]";
function ZG(r1) {
    return mr(r1) && ho(r1) == KG;
}
var LM = ZG;
var NM = co && co.isMap, JG = NM ? zc(NM) : LM, BM = JG;
var $G = "[object Set]";
function eV(r1) {
    return mr(r1) && ho(r1) == $G;
}
var FM = eV;
var UM = co && co.isSet, tV = UM ? zc(UM) : FM, kM = tV;
var nV = 1, rV = 2, iV = 4, zM = "[object Arguments]", sV = "[object Array]", oV = "[object Boolean]", aV = "[object Date]", lV = "[object Error]", GM = "[object Function]", cV = "[object GeneratorFunction]", uV = "[object Map]", dV = "[object Number]", VM = "[object Object]", hV = "[object RegExp]", fV = "[object Set]", pV = "[object String]", mV = "[object Symbol]", gV = "[object WeakMap]", yV = "[object ArrayBuffer]", vV = "[object DataView]", xV = "[object Float32Array]", bV = "[object Float64Array]", wV = "[object Int8Array]", SV = "[object Int16Array]", AV = "[object Int32Array]", _V = "[object Uint8Array]", MV = "[object Uint8ClampedArray]", TV = "[object Uint16Array]", EV = "[object Uint32Array]", jt = {};
jt[zM] = jt[sV] = jt[yV] = jt[vV] = jt[oV] = jt[aV] = jt[xV] = jt[bV] = jt[wV] = jt[SV] = jt[AV] = jt[uV] = jt[dV] = jt[VM] = jt[hV] = jt[fV] = jt[pV] = jt[mV] = jt[_V] = jt[MV] = jt[TV] = jt[EV] = !0;
jt[lV] = jt[GM] = jt[gV] = !1;
function Em(r1, t, e, n, i, s) {
    var o, a = t & nV, l = t & rV, u = t & iV;
    if (e && (o = i ? e(r1, n, i, s) : e(r1)), o !== void 0) return o;
    if (!Ln(r1)) return r1;
    var c = Wn(r1);
    if (c) {
        if (o = MM(r1), !a) return l_(r1, o);
    } else {
        var d = ho(r1), h = d == GM || d == cV;
        if (rl(r1)) return mM(r1, a);
        if (d == VM || d == zM || h && !i) {
            if (o = l || h ? {} : RM(r1), !a) return l ? xM(r1, uM(o, r1)) : vM(r1, cM(o, r1));
        } else {
            if (!jt[d]) return i ? r1 : {};
            o = OM(r1, d, a);
        }
    }
    s || (s = new Qc);
    var f = s.get(r1);
    if (f) return f;
    s.set(r1, o), kM(r1) ? r1.forEach(function(g) {
        o.add(Em(g, t, e, g, r1, s));
    }) : BM(r1) && r1.forEach(function(g, y) {
        o.set(y, Em(g, t, e, y, r1, s));
    });
    var m = u ? l ? Am : Bh : l ? Vc : Gc, p = c ? void 0 : m(r1);
    return f_(p || r1, function(g, y) {
        p && (y = g, g = r1[y]), Bc(o, y, Em(g, t, e, y, r1, s));
    }), o;
}
var Cm = Em;
var CV = 1, PV = 4;
function DV(r1) {
    return Cm(r1, CV | PV);
}
var fo = DV;
var IV = "__lodash_hash_undefined__";
function OV(r1) {
    return this.__data__.set(r1, IV), this;
}
var HM = OV;
function RV(r1) {
    return this.__data__.has(r1);
}
var WM = RV;
function Pm(r1) {
    var t = -1, e = r1 == null ? 0 : r1.length;
    for(this.__data__ = new il; ++t < e;)this.add(r1[t]);
}
Pm.prototype.add = Pm.prototype.push = HM;
Pm.prototype.has = WM;
var jM = Pm;
function LV(r1, t) {
    for(var e = -1, n = r1 == null ? 0 : r1.length; ++e < n;)if (t(r1[e], e, r1)) return !0;
    return !1;
}
var qM = LV;
function NV(r1, t) {
    return r1.has(t);
}
var XM = NV;
var BV = 1, FV = 2;
function UV(r1, t, e, n, i, s) {
    var o = e & BV, a = r1.length, l = t.length;
    if (a != l && !(o && l > a)) return !1;
    var u = s.get(r1), c = s.get(t);
    if (u && c) return u == t && c == r1;
    var d = -1, h = !0, f = e & FV ? new jM : void 0;
    for(s.set(r1, t), s.set(t, r1); ++d < a;){
        var m = r1[d], p = t[d];
        if (n) var g = o ? n(p, m, d, t, r1, s) : n(m, p, d, r1, t, s);
        if (g !== void 0) {
            if (g) continue;
            h = !1;
            break;
        }
        if (f) {
            if (!qM(t, function(y, v) {
                if (!XM(f, v) && (m === y || i(m, y, e, n, s))) return f.push(v);
            })) {
                h = !1;
                break;
            }
        } else if (!(m === p || i(m, p, e, n, s))) {
            h = !1;
            break;
        }
    }
    return s.delete(r1), s.delete(t), h;
}
var Dm = UV;
function kV(r1) {
    var t = -1, e = Array(r1.size);
    return r1.forEach(function(n, i) {
        e[++t] = [
            i,
            n
        ];
    }), e;
}
var YM = kV;
function zV(r1) {
    var t = -1, e = Array(r1.size);
    return r1.forEach(function(n) {
        e[++t] = n;
    }), e;
}
var QM = zV;
var GV = 1, VV = 2, HV = "[object Boolean]", WV = "[object Date]", jV = "[object Error]", qV = "[object Map]", XV = "[object Number]", YV = "[object RegExp]", QV = "[object Set]", KV = "[object String]", ZV = "[object Symbol]", JV = "[object ArrayBuffer]", $V = "[object DataView]", KM = rr ? rr.prototype : void 0, bx = KM ? KM.valueOf : void 0;
function e4(r1, t, e, n, i, s, o) {
    switch(e){
        case $V:
            if (r1.byteLength != t.byteLength || r1.byteOffset != t.byteOffset) return !1;
            r1 = r1.buffer, t = t.buffer;
        case JV:
            return !(r1.byteLength != t.byteLength || !s(new Zc(r1), new Zc(t)));
        case HV:
        case WV:
        case XV:
            return Nc(+r1, +t);
        case jV:
            return r1.name == t.name && r1.message == t.message;
        case YV:
        case KV:
            return r1 == t + "";
        case qV:
            var a = YM;
        case QV:
            var l = n & GV;
            if (a || (a = QM), r1.size != t.size && !l) return !1;
            var u = o.get(r1);
            if (u) return u == t;
            n |= VV, o.set(r1, t);
            var c = Dm(a(r1), a(t), n, i, s, o);
            return o.delete(r1), c;
        case ZV:
            if (bx) return bx.call(r1) == bx.call(t);
    }
    return !1;
}
var ZM = e4;
var t4 = 1, n4 = Object.prototype, r4 = n4.hasOwnProperty;
function i4(r1, t, e, n, i, s) {
    var o = e & t4, a = Bh(r1), l = a.length, u = Bh(t), c = u.length;
    if (l != c && !o) return !1;
    for(var d = l; d--;){
        var h = a[d];
        if (!(o ? h in t : r4.call(t, h))) return !1;
    }
    var f = s.get(r1), m = s.get(t);
    if (f && m) return f == t && m == r1;
    var p = !0;
    s.set(r1, t), s.set(t, r1);
    for(var g = o; ++d < l;){
        h = a[d];
        var y = r1[h], v = t[h];
        if (n) var x = o ? n(v, y, h, t, r1, s) : n(y, v, h, r1, t, s);
        if (!(x === void 0 ? y === v || i(y, v, e, n, s) : x)) {
            p = !1;
            break;
        }
        g || (g = h == "constructor");
    }
    if (p && !g) {
        var w = r1.constructor, S = t.constructor;
        w != S && "constructor" in r1 && "constructor" in t && !(typeof w == "function" && w instanceof w && typeof S == "function" && S instanceof S) && (p = !1);
    }
    return s.delete(r1), s.delete(t), p;
}
var JM = i4;
var s4 = 1, $M = "[object Arguments]", eT = "[object Array]", Im = "[object Object]", o4 = Object.prototype, tT = o4.hasOwnProperty;
function a4(r1, t, e, n, i, s) {
    var o = Wn(r1), a = Wn(t), l = o ? eT : ho(r1), u = a ? eT : ho(t);
    l = l == $M ? Im : l, u = u == $M ? Im : u;
    var c = l == Im, d = u == Im, h = l == u;
    if (h && rl(r1)) {
        if (!rl(t)) return !1;
        o = !0, c = !1;
    }
    if (h && !c) return s || (s = new Qc), o || mm(r1) ? Dm(r1, t, e, n, i, s) : ZM(r1, t, l, e, n, i, s);
    if (!(e & s4)) {
        var f = c && tT.call(r1, "__wrapped__"), m = d && tT.call(t, "__wrapped__");
        if (f || m) {
            var p = f ? r1.value() : r1, g = m ? t.value() : t;
            return s || (s = new Qc), i(p, g, e, n, s);
        }
    }
    return h ? (s || (s = new Qc), JM(r1, t, e, n, i, s)) : !1;
}
var nT = a4;
function rT(r1, t, e, n, i) {
    return r1 === t ? !0 : r1 == null || t == null || !mr(r1) && !mr(t) ? r1 !== r1 && t !== t : nT(r1, t, e, n, rT, i);
}
var iT = rT;
function l4(r1, t) {
    return r1 != null && t in Object(r1);
}
var sT = l4;
function c4(r1, t, e) {
    t = bi(t, r1);
    for(var n = -1, i = t.length, s = !1; ++n < i;){
        var o = na(t[n]);
        if (!(s = r1 != null && e(r1, o))) break;
        r1 = r1[o];
    }
    return s || ++n != i ? s : (i = r1 == null ? 0 : r1.length, !!i && Fc(i) && Lc(o, i) && (Wn(r1) || kc(r1)));
}
var oT = c4;
function u4(r1, t) {
    return r1 != null && oT(r1, t, sT);
}
var aT = u4;
var d4 = function() {
    return ln.Date.now();
}, Om = d4;
var h4 = "Expected a function", f4 = Math.max, p4 = Math.min;
function m4(r1, t, e) {
    var n, i, s, o, a, l, u = 0, c = !1, d = !1, h = !0;
    if (typeof r1 != "function") throw new TypeError(h4);
    t = mx(t) || 0, Ln(e) && (c = !!e.leading, d = "maxWait" in e, s = d ? f4(mx(e.maxWait) || 0, t) : s, h = "trailing" in e ? !!e.trailing : h);
    function f(_) {
        var M = n, b = i;
        return n = i = void 0, u = _, o = r1.apply(b, M), o;
    }
    function m(_) {
        return u = _, a = setTimeout(y, t), c ? f(_) : o;
    }
    function p(_) {
        var M = _ - l, b = _ - u, T = t - M;
        return d ? p4(T, s - b) : T;
    }
    function g(_) {
        var M = _ - l, b = _ - u;
        return l === void 0 || M >= t || M < 0 || d && b >= s;
    }
    function y() {
        var _ = Om();
        if (g(_)) return v(_);
        a = setTimeout(y, p(_));
    }
    function v(_) {
        return a = void 0, h && n ? f(_) : (n = i = void 0, o);
    }
    function x() {
        a !== void 0 && clearTimeout(a), u = 0, n = l = i = a = void 0;
    }
    function w() {
        return a === void 0 ? o : v(Om());
    }
    function S() {
        var _ = Om(), M = g(_);
        if (n = arguments, i = this, l = _, M) {
            if (a === void 0) return m(l);
            if (d) return clearTimeout(a), a = setTimeout(y, t), f(l);
        }
        return a === void 0 && (a = setTimeout(y, t)), o;
    }
    return S.cancel = x, S.flush = w, S;
}
var ol = m4;
function g4(r1) {
    var t = r1 == null ? 0 : r1.length;
    return t ? r1[t - 1] : void 0;
}
var lT = g4;
function y4(r1, t) {
    return t.length < 2 ? r1 : vm(r1, rM(t, 0, -1));
}
var cT = y4;
function v4(r1, t) {
    return iT(r1, t);
}
var al = v4;
function x4(r1, t) {
    return t = bi(t, r1), r1 = cT(r1, t), r1 == null || delete r1[na(lT(t))];
}
var uT = x4;
function b4(r1) {
    return nM(r1) ? void 0 : r1;
}
var dT = b4;
var w4 = 1, S4 = 2, A4 = 4, _4 = xm(function(r1, t) {
    var e = {};
    if (r1 == null) return e;
    var n = !1;
    t = cm(t, function(s) {
        return s = bi(s, r1), n || (n = s.length > 1), s;
    }), vs(r1, Am(r1), e), n && (e = Cm(e, w4 | S4 | A4, dT));
    for(var i = t.length; i--;)uT(e, t[i]);
    return e;
}), $c = _4;
function M4(r1, t, e, n) {
    if (!Ln(r1)) return r1;
    t = bi(t, r1);
    for(var i = -1, s = t.length, o = s - 1, a = r1; a != null && ++i < s;){
        var l = na(t[i]), u = e;
        if (l === "__proto__" || l === "constructor" || l === "prototype") return r1;
        if (i != o) {
            var c = a[l];
            u = n ? n(c, l, a) : void 0, u === void 0 && (u = Ln(c) ? c : Lc(t[i + 1]) ? [] : {});
        }
        Bc(a, l, u), a = a[l];
    }
    return r1;
}
var hT = M4;
function T4(r1, t, e) {
    for(var n = -1, i = t.length, s = {}; ++n < i;){
        var o = t[n], a = vm(r1, o);
        e(a, o) && hT(s, bi(o, r1), a);
    }
    return s;
}
var fT = T4;
function E4(r1, t) {
    return fT(r1, t, function(e, n) {
        return aT(r1, n);
    });
}
var pT = E4;
var C4 = xm(function(r1, t) {
    return r1 == null ? {} : pT(r1, t);
}), ra = C4;
var P4 = "Expected a function";
function D4(r1, t, e) {
    var n = !0, i = !0;
    if (typeof r1 != "function") throw new TypeError(P4);
    return Ln(e) && (n = "leading" in e ? !!e.leading : n, i = "trailing" in e ? !!e.trailing : i), ol(r1, t, {
        leading: n,
        maxWait: t,
        trailing: i
    });
}
var wx = D4;
function mT(r1) {
    for (let t of Object.keys(r1))r1[t] === void 0 && delete r1[t];
    return r1;
}
function Hi(r1, t) {
    return Object.setPrototypeOf(r1, t), r1;
}
var I4 = ()=>typeof window > "u" ? !1 : window.navigator.userAgent.toLowerCase().includes(" electron/"), O4 = ()=>typeof window > "u" ? !1 : window.navigator.platform.toUpperCase().includes("MAC"), R4 = ()=>typeof window > "u" ? !1 : /iPad|iPhone|iPod/.test(window.navigator.userAgent) || ll && "ontouchend" in document, L4 = ()=>typeof window > "u" ? !1 : window.navigator.userAgent.toLowerCase().indexOf("firefox") > -1, N4 = ()=>typeof window > "u" ? !1 : "ontouchstart" in window || navigator.maxTouchPoints > 0, B4 = ()=>{
    if (typeof window > "u") return !1;
    let r1 = navigator.userAgent, t = navigator.vendor;
    return /Safari/i.test(r1) && /Apple Computer/.test(t);
}, F4 = ()=>{
    if (typeof window > "u") return null;
    let t = navigator.userAgent.match(/Version\/(\d+\.\d)/);
    return t && t[1];
}, Cee = I4(), ll = O4(), Rm = R4(), gT = L4(), jn = N4(), Sx = B4(), Ax = Number(F4());
function Lm(r1) {
    return Array.isArray(r1) ? r1 : [
        r1
    ];
}
function yT(r1, t) {
    let e = 0;
    for(; e < r1.length && e < t.length;){
        if (r1[e] < t[e]) return -1;
        if (r1[e] > t[e]) return 1;
        e += 1;
    }
    return e !== t.length ? -1 : e !== r1.length ? 1 : 0;
}
function Fh(r1) {
    return ll ? r1.metaKey : r1.ctrlKey;
}
var ke = [], Bm = {}, Uh = {}, Nm = {};
function vT(r1) {
    ke.includes(r1) || ke.push(r1);
}
function eu(r1) {
    delete Bm[r1.pointerId];
    for(let t = 0; t < ke.length; t++)if (ke[t].pointerId === r1.pointerId) {
        ke.splice(t, 1);
        break;
    }
}
function xT() {
    ke.splice(0, ke.length);
}
function Fm(r1) {
    if (r1.pointerType !== "touch") return;
    let t = Bm[r1.pointerId];
    t === void 0 && (t = {
        x: 0,
        y: 0
    }, Bm[r1.pointerId] = t), t.x = r1.pageX, t.y = r1.pageY;
}
function Um(r1) {
    let t = r1.pointerId === ke[0].pointerId ? ke[1] : ke[0];
    return Bm[t.pointerId];
}
function bT(r1) {
    Uh[r1.key] = !0, Nm[r1.key] = Nm[r1.key] === void 0 ? 1 : Nm[r1.key] + 1;
}
function wT(r1) {
    if (ll && Uh.Meta) for(let t in Uh)Uh[t] = !1;
    else Uh[r1.key] = !1;
    Nm = {};
}
function ST(r1) {
    r1.addEventListener("pointerdown", vT, !0), r1.addEventListener("pointerdown", Fm, !0), r1.addEventListener("pointermove", Fm, !0), r1.addEventListener("pointerup", eu, !0), r1.addEventListener("pointercancel", eu, !0), r1.addEventListener("pointerleave", eu, !0), window.addEventListener("keydown", bT, !0), window.addEventListener("keyup", wT, !0);
}
function AT(r1) {
    r1.removeEventListener("pointerdown", vT, !0), r1.removeEventListener("pointerdown", Fm, !0), r1.removeEventListener("pointermove", Fm, !0), r1.removeEventListener("pointerup", eu, !0), r1.removeEventListener("pointercancel", eu, !0), r1.removeEventListener("pointerleave", eu, !0), window.removeEventListener("keydown", bT, !0), window.removeEventListener("keyup", wT, !0);
}
var MT, TT = new Promise((r1)=>{
    MT = r1;
}), _T = !1;

async function ET() {
    if (_T) return;
    let t = "https://unpkg.com/@splinetool/navmesh-wasm@0.9.369/build", [e, n] = await Promise.all([
        (parcelRequire("ghxkD")),
        fetch(`${t}/navmesh.wasm`).then((o)=>o.arrayBuffer())
    ]), i = e.default, s = await i({
        wasmBinary: n
    });
    MT(s), _T = !0;
}
var PT, DT = new Promise((r1)=>{
    PT = r1;
}), CT = !1;

async function IT() {
    if (CT) return;
    let r1 = await (parcelRequire("kB53x"));
    await r1.init(), PT(r1), CT = !0;
}
var Ft = class {
    modifyById(t, e) {
        let n = this;
        if (n[t] === void 0) throw new Error("not expected");
        {
            let s = {
                ...n,
                [t]: e
            };
            return Object.setPrototypeOf(s, Ft.prototype), s;
        }
    }
    add(t, e) {
        return this.runOp({
            type: 1,
            id: t,
            data: e
        })?.data ?? this;
    }
    runOp(t) {
        let e = this;
        if (t.type === 1) {
            let n = e[t.id], i;
            n === void 0 ? i = {
                type: 2,
                id: t.id
            } : i = {
                type: 1,
                id: t.id,
                data: n
            };
            let { id: s , data: o  } = t, a = {
                ...e,
                [s]: o
            };
            return Object.setPrototypeOf(a, Ft.prototype), {
                data: a,
                actual: t,
                reverse: i
            };
        } else if (t.type === 2) {
            let { id: n  } = t, i = e[n];
            if (i === void 0) return null;
            {
                let s = {
                    ...e
                };
                return Object.setPrototypeOf(s, Ft.prototype), delete s[n], {
                    data: s,
                    actual: t,
                    reverse: {
                        type: 1,
                        id: n,
                        data: i
                    }
                };
            }
        }
        return null;
    }
};
function kh(r1) {
    if (r1.deepFreeze !== void 0) {
        r1.deepFreeze(r1);
        return;
    }
    let t = Object.getOwnPropertyNames(r1);
    for (let e of t){
        let n = r1[e];
        n && typeof n == "object" && kh(n);
    }
    return Object.freeze(r1);
}
function OT(r1, t) {
    let e = 0;
    for(; e < r1.length && e < t.length;){
        if (r1[e] < t[e]) return -1;
        if (r1[e] > t[e]) return 1;
        e += 1;
    }
    return e !== t.length ? -1 : e !== r1.length ? 1 : 0;
}
var tu = class extends Error {
};
function km(r1) {
    let t = {
        ...r1
    };
    return Object.setPrototypeOf(t, Object.getPrototypeOf(r1)), t;
}
function xs(r1, t, e) {
    if (r1 === void 0 ? t === void 0 ? (r1 = 0, t = 10) : r1 = t - 10 : t === void 0 && (t = r1 + 10), r1 > t) {
        let s = r1;
        r1 = t, t = s;
    }
    let n = [], i = 1 / (e + 1);
    for(let s = 0; s < e; s++){
        let o = r1 + (t - r1) * (s + .75 + Math.random() * .5) * i;
        n.push(o);
    }
    return n;
}
function nu(r1) {
    return r1 instanceof Uint8Array || r1 instanceof Uint16Array || r1 instanceof Uint32Array || r1 instanceof Int8Array || r1 instanceof Int16Array || r1 instanceof Int32Array || r1 instanceof Float32Array || r1 instanceof Float64Array;
}
function RT() {
    return typeof $hPtJY < "u";
}
function LT(r1, t) {
    for (let e of r1)t(e.id, e.data) !== !0 && LT(e.children, t);
}
function NT(r1, t) {
    if (t(r1.id, r1.data) !== !0) for (let e of r1.children)NT(e, t);
}
var Zt = class extends Array {
    constructor(...e){
        super(...e);
        Object.setPrototypeOf(this, Zt.prototype);
    }
    deepFreeze() {
        let e = 0;
        for(; e < this.length;)kh(this[e]), e++;
    }
    fillCaches0(e, n) {
        this.objCaches.set(e.id, e), this.parentCaches.set(e.id, n);
        for (let i of e.children)this.fillCaches0(i, e.id);
    }
    fillCaches() {
        if (this.objCaches === void 0) {
            this.objCaches = new Map, this.parentCaches = new Map;
            for (let e of this)this.fillCaches0(e, null);
        }
    }
    randomId() {
        this.fillCaches();
        let e = Array.from(this.objCaches.keys());
        if (e.length !== 0) return e[Math.max(0, Math.floor(Math.random() * e.length) - 1)];
    }
    nonExistOrDescendantOf(e, n) {
        if (!this.has(e)) return !0;
        for(; e;){
            let i = this.parent(e);
            if (i === n) return !0;
            e = i;
        }
        return !1;
    }
    isDescendantOf(e, n) {
        for(; e;){
            let i = this.parent(e);
            if (i === n) return !0;
            e = i;
        }
        return !1;
    }
    data(e) {
        return this.get(e)?.data;
    }
    has(e) {
        return this.childrenOf(e) !== void 0;
    }
    get(e) {
        return this.fillCaches(), this.objCaches.get(e);
    }
    childrenOf(e) {
        return e === null ? this : this.get(e)?.children;
    }
    traverseFrom(e, n) {
        if (e === null) this.traverse(n);
        else {
            let i = this.get(e);
            i && NT(i, n);
        }
    }
    traverse(e) {
        LT(this, e);
    }
    totalSize() {
        return this.fillCaches(), this.objCaches.size;
    }
    parent(e) {
        return this.fillCaches(), this.parentCaches.get(e);
    }
    childrenArray(e) {
        return e === null ? this : this.get(e).children;
    }
    modifyById(e, n) {
        if (this.get(e) === void 0) throw new Error("not expected");
        {
            let s = this.parent(e), o = this.childrenArray(s), a = o.findIndex((c)=>c.id === e);
            if (a < 0) throw new Error("not expected");
            let l = o[a];
            return o = [
                ...o
            ], o[a] = {
                ...l,
                data: n
            }, this.modifyArrayBy(s, o);
        }
    }
    modifyArrayBy(e, n) {
        let i = e, s = n;
        for(; i !== null;){
            let a = s, l = i;
            if (i = this.parent(i), i === void 0) throw new Error;
            s = this.childrenArray(i);
            let u = s.findIndex((c)=>c.id === l);
            if (u < 0) throw new Error;
            s = [
                ...s
            ], s[u] = {
                ...s[u],
                children: a
            };
        }
        Object.setPrototypeOf(s, Zt.prototype);
        let o = s;
        return o.fillCaches(), o;
    }
    runOp(e) {
        switch(e.type){
            case 7:
                return this.addOp(e);
            case 8:
                return this.deleteOp(e);
            case 9:
                return this.moveOp(e);
        }
        return null;
    }
    checkDuplicatedIdRec({ id: e , children: n  }) {
        if (this.get(e) !== void 0) return !0;
        for (let i of n)if (this.checkDuplicatedIdRec(i)) return !0;
        return !1;
    }
    addOp(e) {
        let { parent: n , fi: i , id: s , data: o , children: a  } = e;
        if (n !== null && this.get(n) === void 0) return null;
        if (this.checkDuplicatedIdRec(e)) return null;
        {
            let l = n, u = this.childrenArray(l), c = {
                fi: i,
                id: s,
                data: o,
                children: a
            };
            return u = [
                ...u,
                c
            ], u.sort((h, f)=>h.fi - f.fi), e.localIndex = u.indexOf(c), {
                data: this.modifyArrayBy(l, u),
                actual: e,
                reverse: {
                    type: 8,
                    id: s
                }
            };
        }
    }
    deleteOp(e) {
        let { id: n  } = e;
        if (this.get(n) === null) return null;
        {
            let i = this.parent(n);
            if (i === void 0) return null;
            let s = this.childrenArray(i), o = s.findIndex((u)=>u.id === n);
            e.localIndex = o, s = [
                ...s
            ];
            let a = s.splice(o, 1)[0];
            return {
                data: this.modifyArrayBy(i, s),
                actual: e,
                reverse: {
                    type: 7,
                    ...a,
                    parent: i
                }
            };
        }
    }
    moveOp(e) {
        let { parent: n , fi: i , id: s  } = e;
        if (n !== null && this.get(n) === void 0) return this.deleteOp({
            type: 8,
            id: s
        });
        if (n !== null) {
            let f = n;
            for(; f !== null;){
                if (f === void 0) throw new Error;
                if (f === s) throw new tu("cyclic tree");
                f = this.parent(f);
            }
        }
        let o = this.parent(s);
        if (o === void 0) return null;
        let a = o, l = this.childrenArray(o), u = l.findIndex((f)=>f.id === s);
        l = [
            ...l
        ];
        let c = l.splice(u, 1)[0], d = this.modifyArrayBy(o, l);
        o = n, l = d.childrenArray(o);
        let h = c.fi;
        return c = {
            ...c,
            fi: i
        }, l = [
            ...l,
            c
        ], l.sort((f, m)=>f.fi - m.fi), e.localIndex = l.indexOf(c), d = d.modifyArrayBy(o, l), {
            data: d,
            actual: e,
            reverse: {
                type: 9,
                parent: a,
                fi: h,
                id: s
            }
        };
    }
    previous(e, n) {
        if (n === null) {
            let s = this.childrenArray(e);
            return s.length === 0 ? null : s[s.length - 1].id;
        }
        let i = null;
        for (let s of this.childrenArray(e)){
            if (s.id === n) return i;
            i = s.id;
        }
        return null;
    }
    traverseSortNext(e) {
        let n = this.parent(e);
        if (n !== void 0) {
            let i = this.childrenArray(n), s = i.findIndex((o)=>o.id === e) + 1;
            if (s < i.length) return i[s].id;
            if (n) return this.traverseSortNext(n);
        }
    }
    sortNext(e) {
        let n = this.childrenArray(e);
        return n.length > 0 ? n[0].id : this.traverseSortNext(e);
    }
    traverseSortPrevious(e) {
        let n = this.childrenArray(e);
        return n.length > 0 ? this.traverseSortPrevious(n[n.length - 1].id) : e;
    }
    sortPrevious(e) {
        let n = this.parent(e);
        if (n !== void 0) {
            let i = this.childrenArray(n), s = i.findIndex((o)=>o.id === e) - 1;
            return s >= 0 ? this.traverseSortPrevious(i[s].id) : n;
        }
    }
    getAllSorted(e) {
        let n = [];
        for (let i of e){
            let s = this.getWithSortKey(i.id);
            s !== void 0 && n.push({
                ...i,
                ...s
            });
        }
        n.sort((i, s)=>OT(i.sortKey, s.sortKey));
        for (let i of n)delete i.sortKey;
        return n;
    }
    getWithSortKey(e) {
        var n = e;
        let i = [], s = this.get(n), o = s;
        if (s !== void 0) {
            for(; n;)i.splice(0, 0, s.fi), n = this.parent(n), n !== null && (s = this.get(n));
            return {
                ...o,
                sortKey: i
            };
        }
    }
    insertBeforeHelper(e, n, i) {
        return this.insertAfterHelper(e, this.previous(e, n), i);
    }
    insertAfterHelper(e, n, i) {
        let s = this.childrenArray(e);
        if (n === null) {
            if (s.length === 0) return xs(0, i, i);
            {
                let o = s[0].fi;
                return xs(o - i, o, i);
            }
        } else {
            let o = this.get(n);
            if (o === void 0 || this.parent(n) !== e) throw new Error("illegal args");
            let a = s.find((l)=>l.fi > o.fi);
            if (a === void 0) {
                let l = s[s.length - 1].fi;
                return xs(l, l + i, i);
            } else return xs(o.fi, a.fi, i);
        }
    }
};
var ru;
((t)=>{
    function r1(e, n) {
        if (n.type !== 0) return null;
        if (Array.isArray(e)) {
            let i = n.props, s = {}, o = [
                ...e
            ], a = !1;
            if (i) for (let l of Object.keys(i)){
                let u = parseInt(l);
                if (isNaN(u)) throw new Error("wrong index");
                s[l] = o[u], o[u] = i[l], a = !0;
            }
            return a ? {
                data: o,
                actual: n,
                reverse: {
                    type: 0,
                    props: s
                }
            } : null;
        } else {
            let i = n.props, s = {}, o = {
                ...e
            }, a = !1;
            if (i) for (let l of Object.keys(i)){
                s[l] = o[l];
                let u = i[l];
                u === void 0 ? delete o[l] : o[l] = u, a = !0;
            }
            return a ? {
                data: o,
                actual: n,
                reverse: {
                    type: 0,
                    props: s
                }
            } : null;
        }
    }
    t.runOp = r1;
})(ru || (ru = {}));
var We = class extends Array {
    constructor(...e){
        super(...e);
        Object.setPrototypeOf(this, We.prototype);
    }
    deepFreeze() {
        let e = 0;
        for(; e < this.length;)kh(this[e]), e++;
    }
    fillCaches0(e) {
        this.objCaches.set(e.id, e);
    }
    fillCaches() {
        if (this.objCaches === void 0) {
            this.objCaches = new Map, Object.getOwnPropertyDescriptor(this, "objCaches").enumerable = !1;
            for (let e of this)this.fillCaches0(e);
        }
    }
    randomId() {
        this.fillCaches();
        let e = Array.from(this.objCaches.keys());
        if (e.length !== 0) return e[Math.max(0, Math.floor(Math.random() * e.length) - 1)];
    }
    data(e) {
        return this.get(e)?.data;
    }
    get(e) {
        return this.fillCaches(), this.objCaches.get(e);
    }
    modifyById(e, n) {
        if (this.get(e) === void 0) throw new Error("not expected");
        {
            let s = this, o = s.findIndex((u)=>u.id === e);
            if (o < 0) throw new Error("not expected");
            let a = s[o];
            return s = [
                ...s
            ], s[o] = {
                ...a,
                data: n
            }, this.modifyArrayBy(s);
        }
    }
    modifyArrayBy(e) {
        Object.setPrototypeOf(e, We.prototype);
        let n = e;
        return RT() || n.fillCaches(), n;
    }
    runOp(e) {
        switch(e.type){
            case 4:
                return this.addOp(e);
            case 5:
                return this.deleteOp(e);
            case 6:
                return this.moveOp(e);
        }
        return null;
    }
    addOp(e) {
        let { fi: n , id: i , data: s  } = e, o = this, a = {
            fi: n,
            id: i,
            data: s
        };
        return o = [
            ...o,
            a
        ], o.sort((u, c)=>u.fi - c.fi), e.localIndex = o.indexOf(a), {
            data: this.modifyArrayBy(o),
            actual: e,
            reverse: {
                type: 5,
                id: i
            }
        };
    }
    deleteOp(e) {
        let { id: n  } = e, i = this, s = i.findIndex((l)=>l.id === n);
        if (s === -1) return null;
        e.localIndex = s, i = [
            ...i
        ];
        let o = i.splice(s, 1)[0];
        return {
            data: this.modifyArrayBy(i),
            actual: e,
            reverse: {
                type: 4,
                ...o
            }
        };
    }
    moveOp(e) {
        let { fi: n , id: i  } = e, s = this;
        s = [
            ...s
        ];
        let o = s.findIndex((c)=>c.id === i);
        if (o === -1) return null;
        let a = s[o].fi, l = {
            ...s[o],
            fi: n
        };
        return s[o] = l, s.sort((c, d)=>c.fi - d.fi), e.localIndex = s.indexOf(l), {
            data: this.modifyArrayBy(s),
            actual: e,
            reverse: {
                type: 6,
                fi: a,
                id: i
            }
        };
    }
    previous(e) {
        if (e === null) return this.length === 0 ? null : this[this.length - 1].id;
        let n = null;
        for (let i of this){
            if (i.id === e) return n;
            n = i.id;
        }
        return null;
    }
    insertBeforeHelper(e, n) {
        return this.insertAfterHelper(this.previous(e), n);
    }
    insertAfterHelper(e, n) {
        let i = this;
        if (e === null) {
            if (i.length === 0) return xs(0, n, n);
            {
                let s = i[0].fi;
                return xs(s - n, s, n);
            }
        } else {
            let s = this.get(e);
            if (s === void 0) throw new Error("illegal args");
            let o = i.find((a)=>a.fi > s.fi);
            if (o === void 0) {
                let a = i[i.length - 1].fi;
                return xs(a, a + n, n);
            } else return xs(s.fi, o.fi, n);
        }
    }
};
function iu(r1) {
    return r1 && typeof r1 == "object" && r1 instanceof Jt;
}
var Jt = class {
    unusedFunOverridesTable(t) {}
    runOp(t) {
        let e = [], n = this, i = 0, s = {};
        for(; i < t.path.length;){
            if (e.push(n), n = n === void 0 ? void 0 : n[t.path[i]], n !== void 0 && !iu(n)) return null;
            i += 1;
        }
        n = n ? km(n) : new Jt;
        for (let [l, u] of Object.entries(t.props)){
            let c = n[l];
            s[l] = c, u === void 0 ? delete n[l] : n[l] = u;
        }
        for(; i > 0;){
            if (Object.keys(n).length === 0) {
                let l = e[i - 1];
                l && (n = km(l), delete n[t.path[i - 1]]);
            } else {
                let l = e[i - 1];
                if (l) {
                    let u = km(l);
                    u[t.path[i - 1]] = n, n = u;
                } else {
                    let u = new Jt;
                    u[t.path[i - 1]] = n, n = u;
                }
            }
            i -= 1;
        }
        let o = Object.setPrototypeOf(n, Jt.prototype), a = {
            ...t,
            props: s
        };
        return {
            data: o,
            actual: t,
            reverse: a
        };
    }
}, po;
((n)=>{
    function r1(i, s) {
        return zh(i, s) ?? i;
    }
    n.apply = r1;
    function t(i, s) {
        return Mx(i, s);
    }
    n.merge = t;
    function e(i, s) {
        let o = 0, a = s.path, l = i;
        for(; o < a.length && l !== void 0;){
            if (l = Lr.zoomOnce(l, a[o]), l === void 0) return s;
            if (!iu(l)) return;
            o += 1;
        }
        if (l === void 0) return s;
        if (!!iu(l)) {
            if (s.type === 0) {
                let u = {
                    ...s.props
                };
                for (let c of Object.keys(l))delete u[c];
                return {
                    ...s,
                    props: u
                };
            } else if (s.type === 1 || s.type === 4 || s.type === 7) {
                let u = _x([
                    s
                ], l);
                return u ? (console.log(u), u) : s;
            } else return s;
        }
    }
    n.filterOp = e;
})(po || (po = {}));
function _x(r1, t) {
    if (t === void 0) return;
    let e = !1, n = r1.map((i)=>{
        let s = i.id, o = zh(i.data, t[s]);
        if (e = e || o !== void 0, o === void 0 && (o = i.data), i.children) {
            let a = _x(i.children, t);
            return a !== void 0 ? e = !0 : a = i.children, {
                ...i,
                id: s,
                data: o,
                children: a
            };
        } else return {
            ...i,
            id: s,
            data: o
        };
    });
    if (e) return n;
}
function U4(r1, t) {
    if (t === void 0) return;
    let e = !1, n = r1.map((i)=>{
        let s = i.id, o = zh(i.data, t[s]);
        return e = e || o !== void 0, o === void 0 && (o = i.data), {
            ...i,
            id: s,
            data: o
        };
    });
    if (e) return Object.setPrototypeOf(n, Object.getPrototypeOf(r1)), n;
}
function zh(r1, t) {
    if (!iu(t)) return t;
    if (r1 instanceof Zt) {
        let e = _x(r1, t);
        return e !== void 0 && Object.setPrototypeOf(e, Object.getPrototypeOf(r1)), e;
    } else {
        if (r1 instanceof We) return U4(r1, t);
        if (Array.isArray(r1)) {
            let e = !1, n = r1.map((i, s)=>{
                let o = zh(i, t[s]);
                return e = e || o !== void 0, o === void 0 && (o = i), o;
            });
            return e ? (Object.setPrototypeOf(n, Object.getPrototypeOf(r1)), n) : void 0;
        } else {
            if (r1 instanceof Jt) return Mx(r1, t);
            if (r1 && typeof r1 == "object") {
                let e = {}, n = !1;
                for (let [i, s] of Object.entries(r1)){
                    let o = zh(s, t[i]);
                    n = n || o !== void 0, o === void 0 && (o = s), e[i] = o;
                }
                return n ? (Object.setPrototypeOf(e, Object.getPrototypeOf(r1)), e) : void 0;
            }
        }
    }
}
function Mx(r1, t) {
    if (r1 === void 0) return t;
    if (t === void 0) return r1;
    if (!iu(t)) return t;
    if (!iu(r1)) return po.apply(r1, t);
    let e = new Set;
    for (let i of Object.keys(r1))e.add(i);
    for (let i of Object.keys(t))e.add(i);
    let n = new Jt;
    for (let i of e){
        let s = Mx(r1 === void 0 ? void 0 : r1[i], t === void 0 ? void 0 : t[i]);
        n[i] = s;
    }
    return n;
}
function BT(r1, t) {
    let e = {
        cur: [],
        result: [],
        len: 0
    };
    return r1 = Gh(r1, t, e) ?? r1, [
        r1,
        e.result
    ];
}
function zm(r1, t) {
    return r1 === null ? null : (r1.cur[r1.len] = t, r1.len += 1, r1);
}
function Gm(r1) {
    r1 && (r1.len -= 1);
}
function k4(r1) {
    if (r1 === null) return null;
    r1.result.push(r1.cur.slice(0, r1.len));
}
function FT(r1, t, e) {
    let n = !1, i = r1.map((s)=>{
        let o = s.id, a = t[o];
        if (a !== void 0 && typeof a == "string" && (n = !0, o = a, e !== null)) throw new Error("not supported");
        let l = Gh(s.data, t, zm(e, o));
        Gm(e), n = n || l !== void 0, l === void 0 && (l = s.data);
        let u = FT(s.children, t, e);
        return u !== void 0 ? n = !0 : u = s.children, {
            ...s,
            id: o,
            data: l,
            children: u
        };
    });
    if (n) return i;
}
function z4(r1, t, e) {
    let n = !1, i = r1.map((s)=>{
        let o = s.id, a = t[o];
        if (a !== void 0 && typeof a == "string" && (n = !0, o = a, e !== null)) throw new Error("not supported");
        let l = Gh(s.data, t, zm(e, o));
        return Gm(e), n = n || l !== void 0, l === void 0 && (l = s.data), {
            ...s,
            id: o,
            data: l
        };
    });
    if (n) return Object.setPrototypeOf(i, Object.getPrototypeOf(r1)), i;
}
function Gh(r1, t, e) {
    if (r1 instanceof Zt) {
        let n = FT(r1, t, e);
        return n !== void 0 && Object.setPrototypeOf(n, Object.getPrototypeOf(r1)), n;
    } else {
        if (r1 instanceof We) return z4(r1, t, e);
        if (Array.isArray(r1)) {
            let n = !1, i = r1.map((s, o)=>{
                let a = Gh(s, t, zm(e, o));
                return Gm(e), n = n || a !== void 0, a === void 0 && (a = s), a;
            });
            return n ? (Object.setPrototypeOf(i, Object.getPrototypeOf(r1)), i) : void 0;
        } else if (r1 && typeof r1 == "object" && !nu(r1)) {
            let n = {}, i = !1;
            for (let [s, o] of Object.entries(r1))if (s !== "name" && s !== "text") {
                let a = t[s];
                if (typeof a == "string") {
                    if (e !== null) throw new Error("not supported");
                    i = !0, s = a;
                }
                let l = Gh(o, t, zm(e, s));
                Gm(e), i = i || l !== void 0, l === void 0 && (l = o), n[s] = l;
            } else n[s] = o;
            return i ? (Object.setPrototypeOf(n, Object.getPrototypeOf(r1)), n) : void 0;
        } else if (typeof r1 == "string") {
            let n = t[r1];
            if (n !== void 0) {
                if (r1.length !== 36) throw new Error("for now you should only call this method when the key is a uuid");
                k4(e);
            }
            return n;
        } else return;
    }
}
var Vm;
((t)=>{
    function r1(e, n) {
        let i = Lr.zoom(n, e.path);
        if (typeof i == "object") {
            let s = {};
            for (let o of Object.keys(e.props))s[o] = i[o];
            return {
                ...e,
                props: s
            };
        } else return {
            ...e,
            props: {}
        };
    }
    t.replaceProps = r1;
})(Vm || (Vm = {}));
var gr;
((a)=>{
    function r1(l, u) {
        return {
            ...l,
            path: l.path.slice(u)
        };
    }
    a.drop = r1;
    function t(l, u) {
        return e(l, u)?.data ?? l;
    }
    a.applySimple = t;
    function e(l, u) {
        let c = u.path;
        for(var d = [];;){
            let h;
            if (l instanceof Jt && u.type === 0 && (h = l.runOp({
                ...u,
                path: c.slice(d.length)
            }), h === null && (h = void 0)), h === void 0 && d.length === c.length && (l instanceof Zt || l instanceof We || l instanceof Ft ? h = l.runOp(u) : h = ru.runOp(l, u)), h !== void 0) {
                if (h !== null) {
                    let p = h.data;
                    for(let g = d.length - 1; g >= 0; g--){
                        let y = c[g], v = d[g];
                        if (v instanceof Zt) {
                            if (typeof y == "number") throw new Error("illegal arg");
                            p = v.modifyById(y, p);
                        } else if (v instanceof We) {
                            if (typeof y == "number") throw new Error("illegal arg");
                            p = v.modifyById(y, p);
                        } else if (v instanceof Ft) {
                            if (typeof y == "number") throw new Error("illegal arg");
                            p = v.modifyById(y, p);
                        } else if (v instanceof Jt) {
                            let x = {
                                ...v,
                                [y]: p
                            };
                            p = Object.setPrototypeOf(x, Jt.prototype);
                        } else if (typeof v == "object") {
                            if (Array.isArray(v)) {
                                if (typeof y == "string" && (y = parseInt(y), isNaN(y))) throw new Error("Invalid path");
                                let x = p;
                                p = [
                                    ...v
                                ], p[y] = x;
                            } else p = {
                                ...v,
                                [y]: p
                            };
                        } else return null;
                    }
                    return {
                        data: p,
                        actual: {
                            ...h.actual,
                            path: c
                        },
                        reverse: {
                            ...h.reverse,
                            path: c
                        }
                    };
                } else return null;
            }
            let f = c[d.length], m;
            if (l instanceof Zt) {
                if (typeof f == "number") throw new Error("");
                m = l.get(f)?.data;
            } else if (l instanceof We) {
                if (typeof f == "number") throw new Error("");
                m = l.get(f)?.data;
            } else l !== null && (m = l[f]);
            if (m !== void 0) d.push(l), l = m;
            else return null;
        }
    }
    a.apply = e;
    function n(l, u) {
        for(let c = 0; c < l.length && c < u.length; c++)if (l[c] !== u[c]) return !0;
        return !1;
    }
    a.pathDisjoint = n;
    function i(l, u) {
        if (l.length !== u.length) return !1;
        for(let c = 0; c < l.length; c++)if (l[c] !== u[c]) return !1;
        return !0;
    }
    a.pathEq = i;
    function s(l, u) {
        return n(l.path, u.path);
    }
    a.commutative = s;
    function o(l, u) {
        return l.type === 0 && u.type === 0 && i(l.path, u.path) ? Object.keys(l.props).every((c)=>u.props[c] !== void 0) : !1;
    }
    a.subsumed = o;
})(gr || (gr = {}));
var Tx;
((l)=>{
    function r1() {
        return [];
    }
    l.empty = r1;
    function t(u, c) {
        let d = [];
        for (let h of u){
            let [f, ...m] = h.path;
            f === c && d.push({
                ...h,
                path: m
            });
        }
        return d;
    }
    l.removePrefix = t;
    function e(u, c) {
        return u.map((d)=>({
                ...d,
                path: [
                    c,
                    ...d.path
                ]
            }));
    }
    l.addPrefix = e;
    function n(u, c) {
        return [
            ...u,
            ...c
        ];
    }
    l.concat = n;
    function i(u, c) {
        return [
            ...u.filter((h)=>!c.some((f)=>gr.subsumed(h, f))),
            ...c
        ];
    }
    l.compress = i;
    function s(u, c) {
        return u.every((d)=>c.every((h)=>gr.commutative(d, h)));
    }
    l.commutative = s;
    function o(u, c) {
        for (let d of c){
            let h = a(u, d);
            h !== null && (u = h.data);
        }
        return u;
    }
    l.applyAll = o;
    function a(u, c) {
        var d = u;
        let h = [], f = [];
        for (let m of c)try {
            if (m.type === 3) {
                let p = Lr.zoom(d, [
                    ...m.path,
                    m.id
                ]), g = gr.apply(d, {
                    ...m,
                    type: 2
                });
                if (g !== null) {
                    d = g.data;
                    let [y, v] = BT(d, {
                        [m.id]: p
                    });
                    d = y;
                    for (let x of v){
                        let w = x[x.length - 1];
                        x.splice(x.length - 1, 1), h.push({
                            type: 0,
                            path: x,
                            props: {
                                [w]: p
                            }
                        }), f.push({
                            type: 0,
                            path: x,
                            props: {
                                [w]: m.id
                            }
                        });
                    }
                    f.push(g.reverse), h.push(g.actual);
                }
            } else {
                let p = gr.apply(d, m);
                p !== null && (h.push(p.actual), d = p.data, f.push(p.reverse));
            }
        } catch (p) {
            if (p instanceof tu) return null;
            throw p;
        }
        return {
            data: d,
            actual: h,
            reverse: f.reverse()
        };
    }
    l.apply = a;
})(Tx || (Tx = {}));
var UT = Symbol(), G4 = Symbol(), Wm = Symbol(), cl = class {
    reportOp(t, e, n = []) {
        let i = this;
        if (e === null) return;
        i._current = e.data;
        let s = n;
        for(; !(i instanceof Hm);){
            let o = i._path, a = i._current;
            if (o !== "" && s.splice(0, 0, o), i = i._parent, i === null) return;
            i.update(o, a);
        }
        i.push(s, t, e.actual, e.reverse);
    }
    deleteChildren(t) {
        if (this._children) {
            let e = this._children[t];
            if (e) {
                let n = e[Wm];
                n && n(), delete this._children[t];
            }
        }
    }
}, Cx = class extends cl {
    constructor(t, e, n){
        super(), this._parent = t, this._path = e, this._current = n;
    }
    update(t, e) {
        if (Array.isArray(this._current)) {
            if (typeof t == "string" && (t = parseInt(t), isNaN(t))) throw new Error("Invalid path");
            this._current = [
                ...this._current
            ], this._current[t] = e;
        } else this._current = {
            ...this._current,
            [t]: e
        };
    }
    runOp(t) {
        this.reportOp(t, ru.runOp(this._current, t), t.path);
    }
}, Px = class extends cl {
    constructor(t, e, n){
        super(), this._parent = t, this._path = e, this._current = n;
    }
    update(t, e) {
        this._current = {
            ...this._current,
            [t]: e
        }, Object.setPrototypeOf(this._current, Ft.prototype);
    }
    runOp(t) {
        this.reportOp(t, this._current.runOp(t));
    }
}, kT = {
    get (r1, t) {
        if (t === Wm) return ()=>{
            r1._parent = null;
        };
        if (t === UT) return r1._current;
        if (t === G4) return r1;
        let { _current: e , _children: n  } = r1;
        if (t === "push" && Array.isArray(e)) throw new Error("not supported to expand array");
        let i = n === void 0 ? void 0 : n[t];
        if (i !== void 0) return i;
        let s = e[t], o = jm(r1, t, s);
        return o !== s ? (n === void 0 && (n = {}, r1._children = n), n[t] = o, o) : s;
    },
    has (r1, t) {
        return t in r1._current;
    },
    ownKeys (r1) {
        return Reflect.ownKeys(r1._current);
    },
    defineProperty () {
        throw Error("not supported");
    },
    getPrototypeOf (r1) {
        return Object.getPrototypeOf(r1._current);
    },
    setPrototypeOf () {
        throw Error("not supported");
    },
    getOwnPropertyDescriptor (r1, t) {
        let e = r1._current, n = Reflect.getOwnPropertyDescriptor(e, t);
        return n && {
            writable: !0,
            configurable: !0,
            enumerable: n.enumerable,
            value: e[t]
        };
    }
}, V4 = {
    ...kT,
    set (r1, t, e) {
        let n = {
            type: 0,
            props: {
                [t]: ir(e) ?? e
            }
        };
        return r1.deleteChildren(t), r1.runOp(n), !0;
    },
    deleteProperty (r1, t) {
        let e = {
            type: 0,
            props: {
                [t]: void 0
            }
        };
        return r1.deleteChildren(t), r1.runOp(e), !0;
    }
}, H4 = {
    ...kT,
    set (r1, t, e) {
        return e === void 0 ? this.deleteProperty(r1, t) : (r1.deleteChildren(t), r1.runOp({
            type: 1,
            id: t,
            data: e
        })), !0;
    },
    deleteProperty (r1, t) {
        return r1.runOp({
            type: 2,
            id: t
        }), !0;
    }
}, su = class extends cl {
    constructor(t, e, n){
        super(), this._children = {}, this._parent = t, this._path = e, this._current = n, this[Wm] = ()=>{
            this._parent = null;
        };
    }
    unproxy() {
        return this._current;
    }
    update(t, e) {
        this._current = this._current.modifyById(t, e);
    }
    runOp(t) {
        this.reportOp(t, this._current.runOp(t));
    }
    randomId() {
        return this._current.randomId();
    }
    isDescendantOf(t, e) {
        return this._current.isDescendantOf(t, e);
    }
    childrenOf(t) {
        return this._current.childrenOf(t);
    }
    traverse(t) {
        return this._current.traverse(t);
    }
    get(t) {
        return this._current.get(t);
    }
    parent(t) {
        return this._current.parent(t);
    }
    traverse(t) {
        this._current.traverse((e, n)=>{
            t(e, this.data(e));
        });
    }
    data(t) {
        let { _current: e , _children: n  } = this, i = n === void 0 ? void 0 : n[t];
        if (i !== void 0) return i;
        let s = e.get(t)?.data, o = jm(this, t, s);
        return o !== s ? (n === void 0 && (n = {}, this._children = n), n[t] = o, o) : s;
    }
    add(t, e, n, i, s) {
        this.runOp({
            type: 7,
            parent: t,
            fi: e,
            id: n,
            data: i,
            children: s
        });
    }
    move(t, e, n) {
        this.runOp({
            type: 9,
            parent: t,
            fi: e,
            id: n
        });
    }
    insertAfter(t, e, n) {
        let i = this._current.insertAfterHelper(t, e, n.length);
        for(let s = 0; s < n.length; s++){
            let o = n[s];
            this.add(t, i[s], o.id, o.data, o.children);
        }
    }
    insertBefore(t, e, n) {
        let i = this._current.insertBeforeHelper(t, e, n.length);
        for(let s = 0; s < n.length; s++){
            let o = n[s];
            this.add(t, i[s], o.id, o.data, o.children);
        }
    }
    moveAfter(t, e, n) {
        let i = this._current.insertAfterHelper(t, e, n.length);
        for(let s = 0; s < n.length; s++){
            let o = n[s];
            this.move(t, i[s], o);
        }
    }
    moveBefore(t, e, n) {
        let i = this._current.insertBeforeHelper(t, e, n.length);
        for(let s = 0; s < n.length; s++){
            let o = n[s];
            this.move(t, i[s], o);
        }
    }
    delete(t) {
        this.deleteChildren(t), this.runOp({
            type: 8,
            id: t
        });
    }
    sortNext(t) {
        return this._current.sortNext(t);
    }
    sortPrevious(t) {
        return this._current.sortPrevious(t);
    }
    getAllSorted(t) {
        return this._current.getAllSorted(t);
    }
}, ou = class extends cl {
    constructor(t, e, n){
        super(), this._children = {}, this._parent = t, this._path = e, this._current = n, this[Wm] = ()=>{
            this._parent = null;
        };
    }
    unproxy() {
        return this._current;
    }
    get length() {
        return this._current.length;
    }
    forEach(t) {
        let e = this.length;
        for(let n = 0; n < e; n++){
            let i = this._current[n].id, s = this._current[n].fi;
            t(this.data(this._current[n].id), i, s);
        }
    }
    find(t) {
        let e = this.length;
        for(let n = 0; n < e; n++){
            let i = this._current[n].id;
            if (t(this.data(i), i)) return this.get(i);
        }
    }
    update(t, e) {
        this._current = this._current.modifyById(t, e);
    }
    randomId() {
        return this._current.randomId();
    }
    get(t) {
        return {
            ...this._current.get(t),
            data: this.data(t)
        };
    }
    data(t) {
        let { _current: e , _children: n  } = this, i = n === void 0 ? void 0 : n[t];
        if (i !== void 0) return i;
        let s = e.get(t)?.data, o = jm(this, t, s);
        return o !== s ? (n === void 0 && (n = {}, this._children = n), n[t] = o, o) : s;
    }
    runOp(t) {
        this.reportOp(t, this._current.runOp(t));
    }
    add(t, e, n) {
        this.runOp({
            type: 4,
            fi: t,
            id: e,
            data: n
        });
    }
    move(t, e) {
        this.runOp({
            type: 6,
            fi: t,
            id: e
        });
    }
    insertAfter(t, e) {
        let n = this._current.insertAfterHelper(t, e.length);
        for(let i = 0; i < e.length; i++){
            let s = e[i];
            this.add(n[i], s.id, s.data);
        }
    }
    insertBefore(t, e) {
        let n = this._current.insertBeforeHelper(t, e.length);
        for(let i = 0; i < e.length; i++){
            let s = e[i];
            this.add(n[i], s.id, s.data);
        }
    }
    moveAfter(t, e) {
        let n = this._current.insertAfterHelper(t, e.length);
        for(let i = 0; i < e.length; i++){
            let s = e[i];
            this.move(n[i], s);
        }
    }
    moveBefore(t, e) {
        let n = this._current.insertBeforeHelper(t, e.length);
        for(let i = 0; i < e.length; i++){
            let s = e[i];
            this.move(n[i], s);
        }
    }
    delete(t) {
        this.deleteChildren(t), this.runOp({
            type: 5,
            id: t
        });
    }
};
function Ex(r1, t, e) {
    if (r1.length > 0) {
        let n = r1[r1.length - 1];
        if (n.type === 0 && t.type === 0 && Lr.equal(n.path, e)) {
            Object.assign(n.props, t.props);
            return;
        }
    }
    r1.push({
        ...t,
        path: e
    });
}
var Hm = class extends cl {
    constructor(t){
        super(), this.ts = [], this.actual = [], this.reverse = [], this._current = t;
    }
    update(t, e) {
        if (t !== "") throw new Error("");
        this._current = e;
    }
    push(t, e, n, i) {
        Ex(this.ts, e, t), Ex(this.actual, n, t), Ex(this.reverse, i, t);
    }
    result() {
        return {
            data: this._current,
            ts: this.ts,
            actual: this.actual,
            reverse: this.reverse.reverse()
        };
    }
};
function jm(r1, t, e) {
    return e instanceof Zt ? new su(r1, t, e) : e instanceof We ? new ou(r1, t, e) : e instanceof Ft ? new Proxy(new Px(r1, t, e), H4) : e !== null && typeof e == "object" ? nu(e) ? e : new Proxy(new Cx(r1, t, e), V4) : e;
}
function Dx(r1) {
    let t = new Hm(r1);
    return [
        jm(t, "", r1),
        t
    ];
}
function au(r1, t) {
    let [e, n] = Dx(r1);
    return t(e), n.result();
}
function ir(r1) {
    return r1 instanceof su || r1 instanceof ou ? r1._current : r1 !== null && typeof r1 == "object" ? r1[UT] : r1;
}
var Lr;
((i)=>{
    function r1(s, o) {
        if (o.length === s.length) for(var a = 0; a < s.length;){
            if (s[a] !== o[a]) return !1;
            a += 1;
        }
        else return !1;
        return !0;
    }
    i.equal = r1;
    function t(s, o, a) {
        let l = n(a, s);
        if (l !== void 0 && typeof l == "object" && l !== null) {
            let u = {
                ...o
            };
            return Object.keys(l).forEach((c)=>{
                delete u[c];
            }), u;
        } else return o;
    }
    i.removeOverridden = t;
    function e(s, o) {
        if ((s instanceof Zt || s instanceof su) && typeof o == "string") return s.data(o);
        if ((s instanceof We || s instanceof ou) && typeof o == "string") return s.data(o);
        if (typeof o == "number" && Array.isArray(s)) return s[o];
        if (typeof o == "string" && typeof s == "object" && s !== null) return s[o];
    }
    i.zoomOnce = e;
    function n(s, o, a = 0) {
        for(; a < o.length && s !== void 0;)s = e(s, o[a]), a += 1;
        return s;
    }
    i.zoom = n;
})(Lr || (Lr = {}));
function zT(r1, t) {
    let e = [];
    if (t.length === r1.length) for(var n = 0; n < r1.length;){
        if (t[n] === "*") e.push(r1[n]);
        else if (r1[n] !== t[n]) return null;
        n += 1;
    }
    else return null;
    return e;
}
function Wi(r1, t) {
    let e = [];
    if (t.length <= r1.length) for(var n = 0; n < t.length;){
        if (t[n] === "*") e.push(r1[n]);
        else if (r1[n] !== t[n]) return null;
        n += 1;
    }
    else return null;
    return e;
}
var qm = class {
}, Vh = class extends qm {
    constructor(e){
        super();
        this.id = e;
    }
}, Hh = class extends qm {
    constructor(e){
        super();
        this.data = e;
    }
};
var Ox;
try {
    Ox = new TextDecoder;
} catch  {}
var Ie, sa, J = 0;
var YT = [], Rx = YT, Lx = 0, Hr = {}, Pt, ia, wi = 0, bs = 0, di, mo, Nr = [], Lt, GT = {
    useRecords: !1,
    mapsAsObjects: !0
}, Wh = class {
}, Bx = new Wh;
Bx.name = "MessagePack 0xC1";
var lu = !1, ws = class {
    constructor(t){
        t && (t.useRecords === !1 && t.mapsAsObjects === void 0 && (t.mapsAsObjects = !0), t.structures ? t.structures.sharedLength = t.structures.length : t.getStructures && ((t.structures = []).uninitialized = !0, t.structures.sharedLength = 0)), Object.assign(this, t);
    }
    unpack(t, e) {
        if (Ie) return $T(()=>(Ym(), this ? this.unpack(t, e) : ws.prototype.unpack.call(GT, t, e)));
        sa = e > -1 ? e : t.length, J = 0, Lx = 0, bs = 0, ia = null, Rx = YT, di = null, Ie = t;
        try {
            Lt = t.dataView || (t.dataView = new DataView(t.buffer, t.byteOffset, t.byteLength));
        } catch (n) {
            throw Ie = null, t instanceof Uint8Array ? n : new Error("Source must be a Uint8Array or Buffer but was a " + (t && typeof t == "object" ? t.constructor.name : typeof t));
        }
        if (this instanceof ws) {
            if (Hr = this, this.structures) return Pt = this.structures, Xm();
            (!Pt || Pt.length > 0) && (Pt = []);
        } else Hr = GT, (!Pt || Pt.length > 0) && (Pt = []);
        return Xm();
    }
    unpackMultiple(t, e) {
        let n, i = 0;
        try {
            lu = !0;
            let s = t.length, o = this ? this.unpack(t, s) : Zm.unpack(t, s);
            if (e) {
                for(e(o); J < s;)if (i = J, e(Xm()) === !1) return;
            } else {
                for(n = [
                    o
                ]; J < s;)i = J, n.push(Xm());
                return n;
            }
        } catch (s) {
            throw s.lastPosition = i, s.values = n, s;
        } finally{
            lu = !1, Ym();
        }
    }
    _mergeStructures(t, e) {
        t = t || [];
        for(let n = 0, i = t.length; n < i; n++){
            let s = t[n];
            s && (s.isShared = !0, n >= 32 && (s.highByte = n - 32 >> 5));
        }
        t.sharedLength = t.length;
        for(let n in e || [])if (n >= 0) {
            let i = t[n], s = e[n];
            s && (i && ((t.restoreStructures || (t.restoreStructures = []))[n] = i), t[n] = s);
        }
        return this.structures = t;
    }
    decode(t, e) {
        return this.unpack(t, e);
    }
};
function Xm() {
    try {
        if (!Hr.trusted && !lu) {
            let t = Pt.sharedLength || 0;
            t < Pt.length && (Pt.length = t);
        }
        let r1 = cn();
        if (J == sa) Pt.restoreStructures && VT(), Pt = null, Ie = null, mo && (mo = null);
        else if (J > sa) {
            let t = new Error("Unexpected end of MessagePack data");
            throw t.incomplete = !0, t;
        } else if (!lu) throw new Error("Data read, but end of buffer not reached");
        return r1;
    } catch (r1) {
        throw Pt.restoreStructures && VT(), Ym(), (r1 instanceof RangeError || r1.message.startsWith("Unexpected end of buffer")) && (r1.incomplete = !0), r1;
    }
}
function VT() {
    for(let r1 in Pt.restoreStructures)Pt[r1] = Pt.restoreStructures[r1];
    Pt.restoreStructures = null;
}
function cn() {
    let r1 = Ie[J++];
    if (r1 < 160) {
        if (r1 < 128) {
            if (r1 < 64) return r1;
            {
                let t = Pt[r1 & 63] || Hr.getStructures && QT()[r1 & 63];
                return t ? (t.read || (t.read = Fx(t, r1 & 63)), t.read()) : r1;
            }
        } else if (r1 < 144) {
            if (r1 -= 128, Hr.mapsAsObjects) {
                let t = {};
                for(let e = 0; e < r1; e++)t[ZT()] = cn();
                return t;
            } else {
                let t = new Map;
                for(let e = 0; e < r1; e++)t.set(cn(), cn());
                return t;
            }
        } else {
            r1 -= 144;
            let t = new Array(r1);
            for(let e = 0; e < r1; e++)t[e] = cn();
            return t;
        }
    } else if (r1 < 192) {
        let t = r1 - 160;
        if (bs >= J) return ia.slice(J - wi, (J += t) - wi);
        if (bs == 0 && sa < 140) {
            let e = t < 16 ? Ux(t) : KT(t);
            if (e != null) return e;
        }
        return Nx(t);
    } else {
        let t;
        switch(r1){
            case 192:
                return null;
            case 193:
                return di ? (t = cn(), t > 0 ? di[1].slice(di.position1, di.position1 += t) : di[0].slice(di.position0, di.position0 -= t)) : Bx;
            case 194:
                return !1;
            case 195:
                return !0;
            case 196:
                return Ix(Ie[J++]);
            case 197:
                return t = Lt.getUint16(J), J += 2, Ix(t);
            case 198:
                return t = Lt.getUint32(J), J += 4, Ix(t);
            case 199:
                return ul(Ie[J++]);
            case 200:
                return t = Lt.getUint16(J), J += 2, ul(t);
            case 201:
                return t = Lt.getUint32(J), J += 4, ul(t);
            case 202:
                if (t = Lt.getFloat32(J), Hr.useFloat32 > 2) {
                    let e = Km[(Ie[J] & 127) << 1 | Ie[J + 1] >> 7];
                    return J += 4, (e * t + (t > 0 ? .5 : -0.5) >> 0) / e;
                }
                return J += 4, t;
            case 203:
                return t = Lt.getFloat64(J), J += 8, t;
            case 204:
                return Ie[J++];
            case 205:
                return t = Lt.getUint16(J), J += 2, t;
            case 206:
                return t = Lt.getUint32(J), J += 4, t;
            case 207:
                return Hr.int64AsNumber ? (t = Lt.getUint32(J) * 4294967296, t += Lt.getUint32(J + 4)) : t = Lt.getBigUint64(J), J += 8, t;
            case 208:
                return Lt.getInt8(J++);
            case 209:
                return t = Lt.getInt16(J), J += 2, t;
            case 210:
                return t = Lt.getInt32(J), J += 4, t;
            case 211:
                return Hr.int64AsNumber ? (t = Lt.getInt32(J) * 4294967296, t += Lt.getUint32(J + 4)) : t = Lt.getBigInt64(J), J += 8, t;
            case 212:
                if (t = Ie[J++], t == 114) return XT(Ie[J++] & 63);
                {
                    let e = Nr[t];
                    if (e) return e.read ? (J++, e.read(cn())) : e.noBuffer ? (J++, e()) : e(Ie.subarray(J, ++J));
                    throw new Error("Unknown extension " + t);
                }
            case 213:
                return t = Ie[J], t == 114 ? (J++, XT(Ie[J++] & 63, Ie[J++])) : ul(2);
            case 214:
                return ul(4);
            case 215:
                return ul(8);
            case 216:
                return ul(16);
            case 217:
                return t = Ie[J++], bs >= J ? ia.slice(J - wi, (J += t) - wi) : j4(t);
            case 218:
                return t = Lt.getUint16(J), J += 2, bs >= J ? ia.slice(J - wi, (J += t) - wi) : q4(t);
            case 219:
                return t = Lt.getUint32(J), J += 4, bs >= J ? ia.slice(J - wi, (J += t) - wi) : X4(t);
            case 220:
                return t = Lt.getUint16(J), J += 2, WT(t);
            case 221:
                return t = Lt.getUint32(J), J += 4, WT(t);
            case 222:
                return t = Lt.getUint16(J), J += 2, jT(t);
            case 223:
                return t = Lt.getUint32(J), J += 4, jT(t);
            default:
                if (r1 >= 224) return r1 - 256;
                if (r1 === void 0) {
                    let e = new Error("Unexpected end of MessagePack data");
                    throw e.incomplete = !0, e;
                }
                throw new Error("Unknown MessagePack token " + r1);
        }
    }
}
var W4 = /^[a-zA-Z_$][a-zA-Z\d_$]*$/;
function Fx(r1, t) {
    function e() {
        if (e.count++ > 2) {
            let i = r1.read = new Function("r", "return function(){return {" + r1.map((s)=>W4.test(s) ? s + ":r()" : "[" + JSON.stringify(s) + "]:r()").join(",") + "}}")(cn);
            return r1.highByte === 0 && (r1.read = HT(t, r1.read)), i();
        }
        let n = {};
        for(let i = 0, s = r1.length; i < s; i++){
            let o = r1[i];
            n[o] = cn();
        }
        return n;
    }
    return e.count = 0, r1.highByte === 0 ? HT(t, e) : e;
}
var HT = (r1, t)=>function() {
        let e = Ie[J++];
        if (e === 0) return t();
        let n = r1 < 32 ? -(r1 + (e << 5)) : r1 + (e << 5), i = Pt[n] || QT()[n];
        if (!i) throw new Error("Record id is not defined for " + n);
        return i.read || (i.read = Fx(i, r1)), i.read();
    };
function QT() {
    let r1 = $T(()=>(Ie = null, Hr.getStructures()));
    return Pt = Hr._mergeStructures(r1, Pt);
}
var Nx = Qm, j4 = Qm, q4 = Qm, X4 = Qm;
function Qm(r1) {
    let t;
    if (r1 < 16 && (t = Ux(r1))) return t;
    if (r1 > 64 && Ox) return Ox.decode(Ie.subarray(J, J += r1));
    let e = J + r1, n = [];
    for(t = ""; J < e;){
        let i = Ie[J++];
        if ((i & 128) === 0) n.push(i);
        else if ((i & 224) === 192) {
            let s = Ie[J++] & 63;
            n.push((i & 31) << 6 | s);
        } else if ((i & 240) === 224) {
            let s = Ie[J++] & 63, o = Ie[J++] & 63;
            n.push((i & 31) << 12 | s << 6 | o);
        } else if ((i & 248) === 240) {
            let s = Ie[J++] & 63, o = Ie[J++] & 63, a = Ie[J++] & 63, l = (i & 7) << 18 | s << 12 | o << 6 | a;
            l > 65535 && (l -= 65536, n.push(l >>> 10 & 1023 | 55296), l = 56320 | l & 1023), n.push(l);
        } else n.push(i);
        n.length >= 4096 && (t += sr.apply(String, n), n.length = 0);
    }
    return n.length > 0 && (t += sr.apply(String, n)), t;
}
function WT(r1) {
    let t = new Array(r1);
    for(let e = 0; e < r1; e++)t[e] = cn();
    return t;
}
function jT(r1) {
    if (Hr.mapsAsObjects) {
        let t = {};
        for(let e = 0; e < r1; e++)t[ZT()] = cn();
        return t;
    } else {
        let t = new Map;
        for(let e = 0; e < r1; e++)t.set(cn(), cn());
        return t;
    }
}
var sr = String.fromCharCode;
function KT(r1) {
    let t = J, e = new Array(r1);
    for(let n = 0; n < r1; n++){
        let i = Ie[J++];
        if ((i & 128) > 0) {
            J = t;
            return;
        }
        e[n] = i;
    }
    return sr.apply(String, e);
}
function Ux(r1) {
    if (r1 < 4) {
        if (r1 < 2) {
            if (r1 === 0) return "";
            {
                let t = Ie[J++];
                if ((t & 128) > 1) {
                    J -= 1;
                    return;
                }
                return sr(t);
            }
        } else {
            let t = Ie[J++], e = Ie[J++];
            if ((t & 128) > 0 || (e & 128) > 0) {
                J -= 2;
                return;
            }
            if (r1 < 3) return sr(t, e);
            let n = Ie[J++];
            if ((n & 128) > 0) {
                J -= 3;
                return;
            }
            return sr(t, e, n);
        }
    } else {
        let t = Ie[J++], e = Ie[J++], n = Ie[J++], i = Ie[J++];
        if ((t & 128) > 0 || (e & 128) > 0 || (n & 128) > 0 || (i & 128) > 0) {
            J -= 4;
            return;
        }
        if (r1 < 6) {
            if (r1 === 4) return sr(t, e, n, i);
            {
                let s = Ie[J++];
                if ((s & 128) > 0) {
                    J -= 5;
                    return;
                }
                return sr(t, e, n, i, s);
            }
        } else if (r1 < 8) {
            let s = Ie[J++], o = Ie[J++];
            if ((s & 128) > 0 || (o & 128) > 0) {
                J -= 6;
                return;
            }
            if (r1 < 7) return sr(t, e, n, i, s, o);
            let a = Ie[J++];
            if ((a & 128) > 0) {
                J -= 7;
                return;
            }
            return sr(t, e, n, i, s, o, a);
        } else {
            let s = Ie[J++], o = Ie[J++], a = Ie[J++], l = Ie[J++];
            if ((s & 128) > 0 || (o & 128) > 0 || (a & 128) > 0 || (l & 128) > 0) {
                J -= 8;
                return;
            }
            if (r1 < 10) {
                if (r1 === 8) return sr(t, e, n, i, s, o, a, l);
                {
                    let u = Ie[J++];
                    if ((u & 128) > 0) {
                        J -= 9;
                        return;
                    }
                    return sr(t, e, n, i, s, o, a, l, u);
                }
            } else if (r1 < 12) {
                let u = Ie[J++], c = Ie[J++];
                if ((u & 128) > 0 || (c & 128) > 0) {
                    J -= 10;
                    return;
                }
                if (r1 < 11) return sr(t, e, n, i, s, o, a, l, u, c);
                let d = Ie[J++];
                if ((d & 128) > 0) {
                    J -= 11;
                    return;
                }
                return sr(t, e, n, i, s, o, a, l, u, c, d);
            } else {
                let u = Ie[J++], c = Ie[J++], d = Ie[J++], h = Ie[J++];
                if ((u & 128) > 0 || (c & 128) > 0 || (d & 128) > 0 || (h & 128) > 0) {
                    J -= 12;
                    return;
                }
                if (r1 < 14) {
                    if (r1 === 12) return sr(t, e, n, i, s, o, a, l, u, c, d, h);
                    {
                        let f = Ie[J++];
                        if ((f & 128) > 0) {
                            J -= 13;
                            return;
                        }
                        return sr(t, e, n, i, s, o, a, l, u, c, d, h, f);
                    }
                } else {
                    let f = Ie[J++], m = Ie[J++];
                    if ((f & 128) > 0 || (m & 128) > 0) {
                        J -= 14;
                        return;
                    }
                    if (r1 < 15) return sr(t, e, n, i, s, o, a, l, u, c, d, h, f, m);
                    let p = Ie[J++];
                    if ((p & 128) > 0) {
                        J -= 15;
                        return;
                    }
                    return sr(t, e, n, i, s, o, a, l, u, c, d, h, f, m, p);
                }
            }
        }
    }
}
function Ix(r1) {
    return Hr.copyBuffers ? Uint8Array.prototype.slice.call(Ie, J, J += r1) : Ie.subarray(J, J += r1);
}
function ul(r1) {
    let t = Ie[J++];
    if (Nr[t]) return Nr[t](Ie.subarray(J, J += r1));
    throw new Error("Unknown extension type " + t);
}
var qT = new Array(4096);
function ZT() {
    let r1 = Ie[J++];
    if (r1 >= 160 && r1 < 192) {
        if (r1 = r1 - 160, bs >= J) return ia.slice(J - wi, (J += r1) - wi);
        if (!(bs == 0 && sa < 180)) return Nx(r1);
    } else return J--, cn();
    let t = (r1 << 5 ^ (r1 > 1 ? Lt.getUint16(J) : r1 > 0 ? Ie[J] : 0)) & 4095, e = qT[t], n = J, i = J + r1 - 3, s, o = 0;
    if (e && e.bytes == r1) {
        for(; n < i;){
            if (s = Lt.getUint32(n), s != e[o++]) {
                n = 1879048192;
                break;
            }
            n += 4;
        }
        for(i += 3; n < i;)if (s = Ie[n++], s != e[o++]) {
            n = 1879048192;
            break;
        }
        if (n === i) return J = n, e.string;
        i -= 3, n = J;
    }
    for(e = [], qT[t] = e, e.bytes = r1; n < i;)s = Lt.getUint32(n), e.push(s), n += 4;
    for(i += 3; n < i;)s = Ie[n++], e.push(s);
    let a = r1 < 16 ? Ux(r1) : KT(r1);
    return a != null ? e.string = a : e.string = Nx(r1);
}
var XT = (r1, t)=>{
    var e = cn();
    let n = r1;
    t !== void 0 && (r1 = r1 < 32 ? -((t << 5) + r1) : (t << 5) + r1, e.highByte = t);
    let i = Pt[r1];
    return i && i.isShared && ((Pt.restoreStructures || (Pt.restoreStructures = []))[r1] = i), Pt[r1] = e, e.read = Fx(e, n), e.read();
}, JT = typeof self == "object" ? self : $parcel$global;
Nr[0] = ()=>{};
Nr[0].noBuffer = !0;
Nr[101] = ()=>{
    let r1 = cn();
    return (JT[r1[0]] || Error)(r1[1]);
};
Nr[105] = (r1)=>{
    let t = Lt.getUint32(J - 4);
    mo || (mo = new Map);
    let e = Ie[J], n;
    e >= 144 && e < 160 || e == 220 || e == 221 ? n = [] : n = {};
    let i = {
        target: n
    };
    mo.set(t, i);
    let s = cn();
    return i.used ? Object.assign(n, s) : (i.target = s, s);
};
Nr[112] = (r1)=>{
    let t = Lt.getUint32(J - 4), e = mo.get(t);
    return e.used = !0, e.target;
};
Nr[115] = ()=>new Set(cn());
var kx = [
    "Int8",
    "Uint8",
    "Uint8Clamped",
    "Int16",
    "Uint16",
    "Int32",
    "Uint32",
    "Float32",
    "Float64",
    "BigInt64",
    "BigUint64"
].map((r1)=>r1 + "Array");
Nr[116] = (r1)=>{
    let t = r1[0], e = kx[t];
    if (!e) throw new Error("Could not find typed array for code " + t);
    return new JT[e](Uint8Array.prototype.slice.call(r1, 1).buffer);
};
Nr[120] = ()=>{
    let r1 = cn();
    return new RegExp(r1[0], r1[1]);
};
Nr[98] = (r1)=>{
    let t = (r1[0] << 24) + (r1[1] << 16) + (r1[2] << 8) + r1[3], e = J;
    J += t - 4, di = [
        cn(),
        cn()
    ], di.position0 = 0, di.position1 = 0;
    let n = J;
    J = e;
    try {
        return cn();
    } finally{
        J = n;
    }
};
Nr[255] = (r1)=>r1.length == 4 ? new Date((r1[0] * 16777216 + (r1[1] << 16) + (r1[2] << 8) + r1[3]) * 1e3) : r1.length == 8 ? new Date(((r1[0] << 22) + (r1[1] << 14) + (r1[2] << 6) + (r1[3] >> 2)) / 1e6 + ((r1[3] & 3) * 4294967296 + r1[4] * 16777216 + (r1[5] << 16) + (r1[6] << 8) + r1[7]) * 1e3) : r1.length == 12 ? new Date(((r1[0] << 24) + (r1[1] << 16) + (r1[2] << 8) + r1[3]) / 1e6 + ((r1[4] & 128 ? -281474976710656 : 0) + r1[6] * 1099511627776 + r1[7] * 4294967296 + r1[8] * 16777216 + (r1[9] << 16) + (r1[10] << 8) + r1[11]) * 1e3) : new Date("invalid");
function $T(r1) {
    let t = sa, e = J, n = Lx, i = wi, s = bs, o = ia, a = Rx, l = mo, u = di, c = new Uint8Array(Ie.slice(0, sa)), d = Pt, h = Pt.slice(0, Pt.length), f = Hr, m = lu, p = r1();
    return sa = t, J = e, Lx = n, wi = i, bs = s, ia = o, Rx = a, mo = l, di = u, Ie = c, lu = m, Pt = d, Pt.splice(0, Pt.length, ...h), Hr = f, Lt = new DataView(Ie.buffer, Ie.byteOffset, Ie.byteLength), p;
}
function Ym() {
    Ie = null, mo = null, Pt = null;
}
function eE(r1) {
    r1.unpack ? Nr[r1.type] = r1.unpack : Nr[r1.type] = r1;
}
var Km = new Array(147);
for(let r1 = 0; r1 < 256; r1++)Km[r1] = +("1e" + Math.floor(45.15 - r1 * .30103));
var Zm = new ws({
    useRecords: !1
}), Y4 = Zm.unpack, Q4 = Zm.unpackMultiple, K4 = Zm.unpack, Jm = {
    NEVER: 0,
    ALWAYS: 1,
    DECIMAL_ROUND: 3,
    DECIMAL_FIT: 4
}, Z4 = new Float32Array(1), kte = new Uint8Array(Z4.buffer, 0, 4);
var $m;
try {
    $m = new TextEncoder;
} catch  {}
var eg, Gx, tg = typeof $5059ff85b35ef8d7$require$Buffer < "u", zx = tg ? $5059ff85b35ef8d7$require$Buffer.allocUnsafeSlow : Uint8Array, iE = tg ? $5059ff85b35ef8d7$require$Buffer : Uint8Array, tE = tg ? 4294967296 : 2144337920, le, vn, ne = 0, Ss, As = null, J4 = /[\u0080-\uFFFF]/, jh = Symbol("record-id"), dl = class extends ws {
    constructor(t){
        super(t), this.offset = 0;
        let e, n, i, s, o, a, l = 0, u = iE.prototype.utf8Write ? function(b, T, E) {
            return le.utf8Write(b, T, E);
        } : $m && $m.encodeInto ? function(b, T) {
            return $m.encodeInto(b, le.subarray(T)).written;
        } : !1, c = this;
        t || (t = {});
        let d = t && t.sequential, h = t.structures || t.saveStructures, f = t.maxSharedStructures;
        if (f == null && (f = h ? 32 : 0), f > 8160) throw new Error("Maximum maxSharedStructure is 8160");
        let m = t.maxOwnStructures;
        m == null && (m = h ? 32 : 64), d && !t.saveStructures && (this.structures = []);
        let p = f > 32 || m + f > 64, g = f + 64, y = f + m + 64;
        if (y > 8256) throw new Error("Maximum maxSharedStructure + maxOwnStructure is 8192");
        let v = [], x = 0, w = 0;
        this.pack = this.encode = function(b, T) {
            if (le || (le = new zx(8192), vn = new DataView(le.buffer, 0, 8192), ne = 0), Ss = le.length - 10, Ss - ne < 2048 ? (le = new zx(le.length), vn = new DataView(le.buffer, 0, le.length), Ss = le.length - 10, ne = 0) : ne = ne + 7 & 2147483640, n = ne, a = c.structuredClone ? new Map : null, c.bundleStrings ? (As = [
                "",
                ""
            ], le[ne++] = 214, le[ne++] = 98, As.position = ne - n, ne += 4) : As = null, i = c.structures, i) {
                i.uninitialized && (i = c._mergeStructures(c.getStructures()));
                let E = i.sharedLength || 0;
                if (E > f) throw new Error("Shared structures is larger than maximum shared structures, try increasing maxSharedStructures to " + i.sharedLength);
                if (!i.transitions) {
                    i.transitions = Object.create(null);
                    for(let P = 0; P < E; P++){
                        let D = i[P];
                        if (!D) continue;
                        let C, O = i.transitions;
                        for(let B = 0, V = D.length; B < V; B++){
                            let Y = D[B];
                            C = O[Y], C || (C = O[Y] = Object.create(null)), O = C;
                        }
                        O[jh] = P + 64;
                    }
                    l = E;
                }
                d || (i.nextId = E + 64);
            }
            s && (s = !1), o = i || [];
            try {
                if (S(b), As) {
                    vn.setUint32(As.position + n, ne - As.position - n);
                    let E = As;
                    As = null, S(E[0]), S(E[1]);
                }
                if (c.offset = ne, a && a.idsToInsert) {
                    ne += a.idsToInsert.length * 6, ne > Ss && M(ne), c.offset = ne;
                    let E = eH(le.subarray(n, ne), a.idsToInsert);
                    return a = null, E;
                }
                return T & oE ? (le.start = n, le.end = ne, le) : le.subarray(n, ne);
            } finally{
                if (i) {
                    if (w < 10 && w++, x > 1e4) i.transitions = null, w = 0, x = 0, v.length > 0 && (v = []);
                    else if (v.length > 0 && !d) {
                        for(let E = 0, P = v.length; E < P; E++)v[E][jh] = 0;
                        v = [];
                    }
                    if (s && c.saveStructures) {
                        let E = i.sharedLength || f;
                        i.length > E && (i = i.slice(0, E));
                        let P = le.subarray(n, ne);
                        return c.saveStructures(i, l) === !1 ? (c._mergeStructures(c.getStructures()), c.pack(b)) : (l = E, P);
                    }
                }
                T & aH && (ne = n);
            }
        };
        let S = (b)=>{
            ne > Ss && (le = M(ne));
            var T = typeof b, E;
            if (T === "string") {
                let P = b.length;
                if (As && P >= 8 && P < 4096) {
                    let O = J4.test(b);
                    As[O ? 0 : 1] += b, le[ne++] = 193, S(O ? -P : P);
                    return;
                }
                let D;
                P < 32 ? D = 1 : P < 256 ? D = 2 : P < 65536 ? D = 3 : D = 5;
                let C = P * 3;
                if (ne + C > Ss && (le = M(ne + C)), P < 64 || !u) {
                    let O, B, V, Y = ne + D;
                    for(O = 0; O < P; O++)B = b.charCodeAt(O), B < 128 ? le[Y++] = B : B < 2048 ? (le[Y++] = B >> 6 | 192, le[Y++] = B & 63 | 128) : (B & 64512) === 55296 && ((V = b.charCodeAt(O + 1)) & 64512) === 56320 ? (B = 65536 + ((B & 1023) << 10) + (V & 1023), O++, le[Y++] = B >> 18 | 240, le[Y++] = B >> 12 & 63 | 128, le[Y++] = B >> 6 & 63 | 128, le[Y++] = B & 63 | 128) : (le[Y++] = B >> 12 | 224, le[Y++] = B >> 6 & 63 | 128, le[Y++] = B & 63 | 128);
                    E = Y - ne - D;
                } else E = u(b, ne + D, C);
                E < 32 ? le[ne++] = 160 | E : E < 256 ? (D < 2 && le.copyWithin(ne + 2, ne + 1, ne + 1 + E), le[ne++] = 217, le[ne++] = E) : E < 65536 ? (D < 3 && le.copyWithin(ne + 3, ne + 2, ne + 2 + E), le[ne++] = 218, le[ne++] = E >> 8, le[ne++] = E & 255) : (D < 5 && le.copyWithin(ne + 5, ne + 3, ne + 3 + E), le[ne++] = 219, vn.setUint32(ne, E), ne += 4), ne += E;
            } else if (T === "number") {
                if (b >>> 0 === b) b < 64 ? le[ne++] = b : b < 256 ? (le[ne++] = 204, le[ne++] = b) : b < 65536 ? (le[ne++] = 205, le[ne++] = b >> 8, le[ne++] = b & 255) : (le[ne++] = 206, vn.setUint32(ne, b), ne += 4);
                else if (b >> 0 === b) b >= -32 ? le[ne++] = 256 + b : b >= -128 ? (le[ne++] = 208, le[ne++] = b + 256) : b >= -32768 ? (le[ne++] = 209, vn.setInt16(ne, b), ne += 2) : (le[ne++] = 210, vn.setInt32(ne, b), ne += 4);
                else {
                    let P;
                    if ((P = this.useFloat32) > 0 && b < 4294967296 && b >= -2147483648) {
                        le[ne++] = 202, vn.setFloat32(ne, b);
                        let D;
                        if (P < 4 || (D = b * Km[(le[ne] & 127) << 1 | le[ne + 1] >> 7]) >> 0 === D) {
                            ne += 4;
                            return;
                        } else ne--;
                    }
                    le[ne++] = 203, vn.setFloat64(ne, b), ne += 8;
                }
            } else if (T === "object") {
                if (!b) le[ne++] = 192;
                else {
                    if (a) {
                        let D = a.get(b);
                        if (D) {
                            if (!D.id) {
                                let C = a.idsToInsert || (a.idsToInsert = []);
                                D.id = C.push(D);
                            }
                            le[ne++] = 214, le[ne++] = 112, vn.setUint32(ne, D.id), ne += 4;
                            return;
                        } else a.set(b, {
                            offset: ne - n
                        });
                    }
                    let P = b.constructor;
                    if (P === Object) _(b, !0);
                    else if (P === Array) {
                        E = b.length, E < 16 ? le[ne++] = 144 | E : E < 65536 ? (le[ne++] = 220, le[ne++] = E >> 8, le[ne++] = E & 255) : (le[ne++] = 221, vn.setUint32(ne, E), ne += 4);
                        for(let D = 0; D < E; D++)S(b[D]);
                    } else if (P === Map) {
                        E = b.size, E < 16 ? le[ne++] = 128 | E : E < 65536 ? (le[ne++] = 222, le[ne++] = E >> 8, le[ne++] = E & 255) : (le[ne++] = 223, vn.setUint32(ne, E), ne += 4);
                        for (let [D, C] of b)S(D), S(C);
                    } else {
                        for(let D = 0, C = eg.length; D < C; D++){
                            let O = Gx[D];
                            if (b instanceof O) {
                                let B = eg[D];
                                if (B.write) {
                                    B.type && (le[ne++] = 212, le[ne++] = B.type, le[ne++] = 0), S(B.write.call(this, b));
                                    return;
                                }
                                let V = le, Y = vn, W = ne;
                                le = null;
                                let q;
                                try {
                                    q = B.pack.call(this, b, (j)=>(le = V, V = null, ne += j, ne > Ss && M(ne), {
                                            target: le,
                                            targetView: vn,
                                            position: ne - j
                                        }), S);
                                } finally{
                                    V && (le = V, vn = Y, ne = W, Ss = le.length - 10);
                                }
                                q && (q.length + ne > Ss && M(q.length + ne), ne = $4(q, le, ne, B.type));
                                return;
                            }
                        }
                        _(b, !b.hasOwnProperty);
                    }
                }
            } else if (T === "boolean") le[ne++] = b ? 195 : 194;
            else if (T === "bigint") {
                if (b < BigInt(1) << BigInt(63) && b >= -(BigInt(1) << BigInt(63))) le[ne++] = 211, vn.setBigInt64(ne, b);
                else if (b < BigInt(1) << BigInt(64) && b > 0) le[ne++] = 207, vn.setBigUint64(ne, b);
                else if (this.largeBigIntToFloat) le[ne++] = 203, vn.setFloat64(ne, Number(b));
                else throw new RangeError(b + " was too large to fit in MessagePack 64-bit integer format, set largeBigIntToFloat to convert to float-64");
                ne += 8;
            } else if (T === "undefined") this.encodeUndefinedAsNil ? le[ne++] = 192 : (le[ne++] = 212, le[ne++] = 0, le[ne++] = 0);
            else if (T === "function") S(this.writeFunction && this.writeFunction());
            else throw new Error("Unknown type: " + T);
        }, _ = this.useRecords === !1 ? this.variableMapSize ? (b)=>{
            let T = Object.keys(b), E = T.length;
            E < 16 ? le[ne++] = 128 | E : E < 65536 ? (le[ne++] = 222, le[ne++] = E >> 8, le[ne++] = E & 255) : (le[ne++] = 223, vn.setUint32(ne, E), ne += 4);
            let P;
            for(let D = 0; D < E; D++)S(P = T[D]), S(b[P]);
        } : (b, T)=>{
            le[ne++] = 222;
            let E = ne - n;
            ne += 2;
            let P = 0;
            for(let D in b)(T || b.hasOwnProperty(D)) && (S(D), S(b[D]), P++);
            le[E++ + n] = P >> 8, le[E + n] = P & 255;
        } : (b)=>{
            let T = Object.keys(b), E, P = o.transitions || (o.transitions = Object.create(null)), D = 0;
            for(let O = 0, B = T.length; O < B; O++){
                let V = T[O];
                E = P[V], E || (E = P[V] = Object.create(null), D++), P = E;
            }
            let C = P[jh];
            if (C) C >= 96 && p ? (le[ne++] = ((C -= 96) & 31) + 96, le[ne++] = C >> 5) : le[ne++] = C;
            else {
                C = o.nextId, C || (C = 64), C < g && this.shouldShareStructure && !this.shouldShareStructure(T) ? (C = o.nextOwnId, C < y || (C = g), o.nextOwnId = C + 1) : (C >= y && (C = g), o.nextId = C + 1);
                let O = T.highByte = C >= 96 && p ? C - 96 >> 5 : -1;
                P[jh] = C, o[C - 64] = T, C < g ? (T.isShared = !0, o.sharedLength = C - 63, s = !0, O >= 0 ? (le[ne++] = (C & 31) + 96, le[ne++] = O) : le[ne++] = C) : (O >= 0 ? (le[ne++] = 213, le[ne++] = 114, le[ne++] = (C & 31) + 96, le[ne++] = O) : (le[ne++] = 212, le[ne++] = 114, le[ne++] = C), D && (x += w * D), v.length >= m && (v.shift()[jh] = 0), v.push(P), S(T));
            }
            for(let O = 0, B = T.length; O < B; O++)S(b[T[O]]);
        }, M = (b)=>{
            let T;
            if (b > 16777216) {
                if (b - n > tE) throw new Error("Packed buffer would be larger than maximum buffer size");
                T = Math.min(tE, Math.round(Math.max((b - n) * (b > 67108864 ? 1.25 : 2), 4194304) / 4096) * 4096);
            } else T = (Math.max(b - n << 2, le.length - 1) >> 12) + 1 << 12;
            let E = new zx(T);
            return vn = new DataView(E.buffer, 0, T), le.copy ? le.copy(E, 0, n, b) : E.set(le.slice(n, b)), ne -= n, n = 0, Ss = E.length - 10, le = E;
        };
    }
    useBuffer(t) {
        le = t, vn = new DataView(le.buffer, le.byteOffset, le.byteLength), ne = 0;
    }
};
Gx = [
    Date,
    Set,
    Error,
    RegExp,
    ArrayBuffer,
    Object.getPrototypeOf(Uint8Array.prototype).constructor,
    Wh
];
eg = [
    {
        pack (r1, t, e) {
            let n = r1.getTime() / 1e3;
            if ((this.useTimestamp32 || r1.getMilliseconds() === 0) && n >= 0 && n < 4294967296) {
                let { target: i , targetView: s , position: o  } = t(6);
                i[o++] = 214, i[o++] = 255, s.setUint32(o, n);
            } else if (n > 0 && n < 17179869184) {
                let { target: i , targetView: s , position: o  } = t(10);
                i[o++] = 215, i[o++] = 255, s.setUint32(o, r1.getMilliseconds() * 4e6 + (n / 1e3 / 4294967296 >> 0)), s.setUint32(o + 4, n);
            } else if (isNaN(n)) {
                if (this.onInvalidDate) return t(0), e(this.onInvalidDate());
                let { target: i , targetView: s , position: o  } = t(3);
                i[o++] = 212, i[o++] = 255, i[o++] = 255;
            } else {
                let { target: i , targetView: s , position: o  } = t(15);
                i[o++] = 199, i[o++] = 12, i[o++] = 255, s.setUint32(o, r1.getMilliseconds() * 1e6), s.setBigInt64(o + 4, BigInt(Math.floor(n)));
            }
        }
    },
    {
        pack (r1, t, e) {
            let n = Array.from(r1), { target: i , position: s  } = t(this.structuredClone ? 3 : 0);
            this.structuredClone && (i[s++] = 212, i[s++] = 115, i[s++] = 0), e(n);
        }
    },
    {
        pack (r1, t, e) {
            let { target: n , position: i  } = t(this.structuredClone ? 3 : 0);
            this.structuredClone && (n[i++] = 212, n[i++] = 101, n[i++] = 0), e([
                r1.name,
                r1.message
            ]);
        }
    },
    {
        pack (r1, t, e) {
            let { target: n , position: i  } = t(this.structuredClone ? 3 : 0);
            this.structuredClone && (n[i++] = 212, n[i++] = 120, n[i++] = 0), e([
                r1.source,
                r1.flags
            ]);
        }
    },
    {
        pack (r1, t) {
            this.structuredClone ? nE(r1, 16, t) : rE(tg ? $5059ff85b35ef8d7$require$Buffer.from(r1) : new Uint8Array(r1), t);
        }
    },
    {
        pack (r1, t) {
            let e = r1.constructor;
            e !== iE && this.structuredClone ? nE(r1, kx.indexOf(e.name), t) : rE(r1, t);
        }
    },
    {
        pack (r1, t) {
            let { target: e , position: n  } = t(1);
            e[n] = 193;
        }
    }
];
function nE(r1, t, e, n) {
    let i = r1.byteLength;
    if (i + 1 < 256) {
        var { target: s , position: o  } = e(4 + i);
        s[o++] = 199, s[o++] = i + 1;
    } else if (i + 1 < 65536) {
        var { target: s , position: o  } = e(5 + i);
        s[o++] = 200, s[o++] = i + 1 >> 8, s[o++] = i + 1 & 255;
    } else {
        var { target: s , position: o , targetView: a  } = e(7 + i);
        s[o++] = 201, a.setUint32(o, i + 1), o += 4;
    }
    s[o++] = 116, s[o++] = t, s.set(new Uint8Array(r1.buffer, r1.byteOffset, r1.byteLength), o);
}
function rE(r1, t) {
    let e = r1.byteLength;
    var n, i;
    if (e < 256) {
        var { target: n , position: i  } = t(e + 2);
        n[i++] = 196, n[i++] = e;
    } else if (e < 65536) {
        var { target: n , position: i  } = t(e + 3);
        n[i++] = 197, n[i++] = e >> 8, n[i++] = e & 255;
    } else {
        var { target: n , position: i , targetView: s  } = t(e + 5);
        n[i++] = 198, s.setUint32(i, e), i += 4;
    }
    n.set(r1, i);
}
function $4(r1, t, e, n) {
    let i = r1.length;
    switch(i){
        case 1:
            t[e++] = 212;
            break;
        case 2:
            t[e++] = 213;
            break;
        case 4:
            t[e++] = 214;
            break;
        case 8:
            t[e++] = 215;
            break;
        case 16:
            t[e++] = 216;
            break;
        default:
            i < 256 ? (t[e++] = 199, t[e++] = i) : i < 65536 ? (t[e++] = 200, t[e++] = i >> 8, t[e++] = i & 255) : (t[e++] = 201, t[e++] = i >> 24, t[e++] = i >> 16 & 255, t[e++] = i >> 8 & 255, t[e++] = i & 255);
    }
    return t[e++] = n, t.set(r1, e), e += i, e;
}
function eH(r1, t) {
    let e, n = t.length * 6, i = r1.length - n;
    for(t.sort((s, o)=>s.offset > o.offset ? 1 : -1); e = t.pop();){
        let s = e.offset, o = e.id;
        r1.copyWithin(s + n, s, i), n -= 6;
        let a = s + n;
        r1[a++] = 214, r1[a++] = 105, r1[a++] = o >> 24, r1[a++] = o >> 16 & 255, r1[a++] = o >> 8 & 255, r1[a++] = o & 255, i = s;
    }
    return r1;
}
function oa(r1) {
    if (r1.Class) {
        if (!r1.pack && !r1.write) throw new Error("Extension has no pack or write function");
        if (r1.pack && !r1.type) throw new Error("Extension has no type (numeric code to identify the extension)");
        Gx.unshift(r1.Class), eg.unshift(r1);
    }
    eE(r1);
}
var sE = new dl({
    useRecords: !1
}), tH = sE.pack, nH = sE.pack;
var { NEVER: rH , ALWAYS: iH , DECIMAL_ROUND: sH , DECIMAL_FIT: oH  } = Jm, oE = 512, aH = 1024;
var aE = new dl({
    structuredClone: !0
});
oa({
    Class: Ft.prototype.constructor,
    type: 1,
    write (r1) {
        return {
            ...r1
        };
    },
    read (r1) {
        return Object.setPrototypeOf(r1, Ft.prototype), r1;
    }
});
oa({
    Class: We.prototype.constructor,
    type: 2,
    write (r1) {
        return [
            ...r1
        ];
    },
    read (r1) {
        return Object.setPrototypeOf(r1, We.prototype), r1;
    }
});
oa({
    Class: Zt.prototype.constructor,
    type: 3,
    write (r1) {
        return [
            ...r1
        ];
    },
    read (r1) {
        return Object.setPrototypeOf(r1, Zt.prototype), r1;
    }
});
oa({
    Class: Vh.prototype.constructor,
    type: 4,
    write (r1) {
        return r1.id;
    },
    read (r1) {
        return new Vh(r1);
    }
});
oa({
    Class: Hh.prototype.constructor,
    type: 5,
    write (r1) {
        return r1.data;
    },
    read (r1) {
        return new Hh(r1);
    }
});
oa({
    Class: Jt.prototype.constructor,
    type: 6,
    write (r1) {
        return {
            ...r1
        };
    },
    read (r1) {
        return Object.setPrototypeOf(r1, Jt.prototype), r1;
    }
});
function lH(r1) {
    var t = 0;
    if (r1.length === 0) return t;
    for(let e = 0; e < r1.length; e++){
        let n = r1[e];
        t = (t << 5) - t + n, t = t & t;
    }
    return t;
}
function Vx(r1) {
    if (nu(r1)) return r1;
    if (Array.isArray(r1)) return r1.map(Vx);
    if (typeof r1 == "object" && r1 !== null) {
        let t = {};
        for (let e of Object.keys(r1).sort())t[e] = Vx(r1[e]);
        return Object.setPrototypeOf(t, Object.getPrototypeOf(r1)), t;
    } else return r1;
}
var ng;
((n)=>{
    function r1(i) {
        return aE.pack(i);
    }
    n.serialize = r1;
    function t(i) {
        return aE.unpack(i);
    }
    n.deserialize = t;
    function e(i) {
        return lH(r1(Vx(i))).toString();
    }
    n.checksum = e;
})(ng || (ng = {}));
var go = {
    ["LookAt"]: [],
    ["Follow"]: [
        "Create"
    ],
    ["DragDrop"]: [
        "Transition",
        "Audio",
        "Create"
    ],
    ["MouseHover"]: [
        "Transition",
        "Create",
        "Destroy",
        "SwitchCamera"
    ],
    ["Scroll"]: [
        "Transition",
        "Create"
    ],
    ["Start"]: [
        "Transition",
        "Audio",
        "Video",
        "Create",
        "Destroy",
        "SwitchCamera"
    ],
    ["Conditional"]: [
        "Transition",
        "Audio",
        "Video",
        "Create",
        "Destroy",
        "SwitchCamera",
        "Reset"
    ],
    ["MouseDown"]: [
        "Transition",
        "SwitchCamera",
        "Audio",
        "Video",
        "Link",
        "Create",
        "Destroy",
        "Reset"
    ],
    ["MouseUp"]: [
        "Transition",
        "SwitchCamera",
        "Audio",
        "Video",
        "Link",
        "Create",
        "Destroy",
        "Reset"
    ],
    ["MousePress"]: [
        "Transition",
        "SwitchCamera",
        "Audio",
        "Video",
        "Link",
        "Create",
        "Reset"
    ],
    ["KeyDown"]: [
        "Transition",
        "SwitchCamera",
        "Audio",
        "Video",
        "Link",
        "Create",
        "Destroy",
        "Reset"
    ],
    ["KeyUp"]: [
        "Transition",
        "SwitchCamera",
        "Audio",
        "Video",
        "Link",
        "Create",
        "Destroy",
        "Reset"
    ],
    ["KeyPress"]: [
        "Transition",
        "SwitchCamera",
        "Audio",
        "Video",
        "Link",
        "Create",
        "Reset"
    ],
    ["GameControl"]: [
        "Transition",
        "Audio",
        "Video",
        "Create"
    ],
    ["Collision"]: [
        "Transition",
        "Audio",
        "Video",
        "Create",
        "Destroy",
        "Reset"
    ]
}, lE;
((e)=>{
    function r1(n) {
        return n.type === "MouseDown" || n.type === "MouseUp" || n.type === "MousePress" || n.type === "KeyDown" || n.type === "KeyUp" || n.type === "KeyPress";
    }
    e.is = r1;
    function t(n) {
        return n === "MouseDown" || n === "MouseUp" || n === "MousePress" ? {
            type: n,
            mode: "Object",
            disabled: !1,
            toggle: !1,
            actions: new We
        } : {
            type: n,
            disabled: !1,
            key: void 0,
            toggle: !1,
            actions: new We
        };
    }
    e.defaultData = t;
})(lE || (lE = {}));
var rg;
((e)=>{
    function r1(n) {
        return {
            type: "Property",
            value: [
                n ?? null,
                "position",
                "x"
            ]
        };
    }
    e.propertyDefaultData = r1, e.valueDefaultData = {
        type: "Literal",
        value: 0
    };
})(rg || (rg = {}));
var Hx;
((n)=>{
    function r1(i) {
        return {
            type: "Comparison",
            operator: "==",
            lOperand: rg.propertyDefaultData(i),
            rOperand: {
                ...rg.valueDefaultData
            }
        };
    }
    n.comparisonDefaultData = r1;
    function t(i) {
        return {
            type: "Distance",
            toObject: i ?? null,
            fromObject: i ?? null,
            distance: 200
        };
    }
    n.distanceDefaultData = t;
    function e(i, s) {
        return {
            type: "State",
            object: i ?? null,
            state: s ?? null
        };
    }
    n.stateDefaultData = e;
})(Hx || (Hx = {}));
var cE;
((e)=>{
    function r1(n) {
        return n.type === "Conditional";
    }
    e.is = r1;
    function t(n) {
        return {
            type: "Conditional",
            disabled: !1,
            inActions: new We,
            outActions: new We,
            condition: Hx.distanceDefaultData(n)
        };
    }
    e.defaultData = t;
})(cE || (cE = {}));
var uE;
((t)=>t.defaultData = {
        type: "DragDrop",
        cursor: "hand",
        disabled: !1,
        dampingFactor: 1,
        objects: [],
        snapTo: "center",
        snapSurfaceMode: "bbox",
        snapSurfaceOffset: 0,
        dropOn: "all",
        autoOrient: !0,
        dropDestinations: [],
        plane: "adaptive",
        planeMode: "locked",
        referenceFrame: "global",
        limits: [
            -1 / 0,
            1 / 0,
            -1 / 0,
            1 / 0,
            -1 / 0,
            1 / 0
        ],
        drop: !1,
        resetOnSnapFail: !1,
        snapSpeed: 20,
        resetSpeed: 20,
        dragDropActions: {
            drag: new We,
            drop: new We
        }
    })(uE || (uE = {}));
var ig;
((t)=>t.defaultData = {
        type: "Follow",
        disabled: !1,
        maxDelta: 0,
        dampingFactor: 1,
        target: "cursor",
        plane: "custom",
        resetOnPointerLeave: !0,
        resetAfterDistanceLimit: !0,
        enabledTranslation: [
            !0,
            !0,
            !0
        ],
        limitDistanceEnabled: !1,
        limitDistance: 1e3,
        snapDelay: 0,
        resetSpeed: 5,
        actions: new We
    })(ig || (ig = {}));
var sg;
((t)=>t.defaultData = {
        type: "LookAt",
        disabled: !1,
        distance: 1e3,
        dampingFactor: 1,
        target: "cursor",
        tilt: "up",
        axis: "z",
        plane: "custom",
        resetOnPointerLeave: !0,
        resetAfterDistanceLimit: !0,
        enabledRotation: [
            !0,
            !0,
            !0
        ],
        limitDistanceEnabled: !1,
        limitDistance: 1e3,
        snapDelay: 0,
        resetSpeed: 5
    })(sg || (sg = {}));
var dE;
((e)=>{
    function r1(n) {
        return n.type === "MouseHover";
    }
    e.is = r1;
    function t() {
        return {
            type: "MouseHover",
            disabled: !1,
            actions: new We
        };
    }
    e.defaultData = t;
})(dE || (dE = {}));
var hE;
((e)=>{
    function r1(n) {
        return n.type === "Scroll";
    }
    e.is = r1;
    function t() {
        return {
            type: "Scroll",
            disabled: !1,
            steps: 100,
            trigger: "load",
            startFrom: "enter",
            enterAnchor: "top",
            startOffset: 0,
            endAfter: 400,
            actions: new We
        };
    }
    e.defaultData = t;
})(hE || (hE = {}));
var fE;
((e)=>{
    function r1(n) {
        return n.type === "Start";
    }
    e.is = r1;
    function t() {
        return {
            type: "Start",
            disabled: !1,
            actions: new We
        };
    }
    e.defaultData = t;
})(fE || (fE = {}));
var pE;
((e)=>{
    function r1(n) {
        return n.type === "Collision";
    }
    e.is = r1;
    function t() {
        return {
            type: "Collision",
            disabled: !1,
            toggle: !1,
            target: "character",
            actions: new We
        };
    }
    e.defaultData = t;
})(pE || (pE = {}));
var hl;
((e)=>{
    function r1(n, i) {
        return n[0] === i[0] && n[1] === i[1];
    }
    e.isEqual = r1;
    function t(n, i, s) {
        return [
            n[0] + (i[0] - n[0]) * s,
            n[1] + (i[1] - n[1]) * s
        ];
    }
    e.lerp = t;
})(hl || (hl = {}));
var _s;
((a)=>{
    function r1(l, u) {
        return l[0] === u[0] && l[1] === u[1] && l[2] === u[2];
    }
    a.isEqual = r1;
    function t(l, u) {
        return [
            l[0] + u[0],
            l[1] + u[1],
            l[2] + u[2]
        ];
    }
    a.add = t;
    function e(l, u) {
        return [
            l[0] - u[0],
            l[1] - u[1],
            l[2] - u[2]
        ];
    }
    a.sub = e;
    function n(l, u) {
        return [
            l[0] / u[0],
            l[1] / u[1],
            l[2] / u[2]
        ];
    }
    a.div = n;
    function i(l, u) {
        return [
            l[0] * u[0],
            l[1] * u[1],
            l[2] * u[2]
        ];
    }
    a.mul = i;
    function s(l, u) {
        return Math.hypot(l[0] - u[0], l[1] - u[1], l[2] - u[2]);
    }
    a.dist = s;
    function o(l, u, c) {
        return [
            l[0] + (u[0] - l[0]) * c,
            l[1] + (u[1] - l[1]) * c,
            l[2] + (u[2] - l[2]) * c
        ];
    }
    a.lerp = o;
})(_s || (_s = {}));
var qh;
((e)=>{
    function r1(n, i) {
        return n[0] === i[0] && n[1] === i[1] && n[2] === i[2] && n[3] === i[3];
    }
    e.isEqual = r1;
    function t(n, i, s) {
        return [
            n[0] + (i[0] - n[0]) * s,
            n[1] + (i[1] - n[1]) * s,
            n[2] + (i[2] - n[2]) * s,
            n[3] + (i[3] - n[3]) * s
        ];
    }
    e.lerp = t;
})(qh || (qh = {}));
var aa;
((i)=>{
    i.identity = [
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        1
    ];
    function t(s, o) {
        for(let a = 0; a < 16; a++)if (s[a] !== o[a]) return !1;
        return !0;
    }
    i.isEqual = t;
    function e(s) {
        return s ?? i.identity;
    }
    i.simplify = e;
    function n(s, o) {
        let a = o.slice(0);
        for(var l = 0, u = o.length; l < u; l += 3){
            let c = s[3] * o[l] + s[7] * o[l + 1] + s[11] * o[l + 2] + s[15];
            a[l] = (s[0] * o[l] + s[4] * o[l + 1] + s[8] * o[l + 2] + s[12]) / c, a[l + 1] = (s[1] * o[l] + s[5] * o[l + 1] + s[9] * o[l + 2] + s[13]) / c, a[l + 2] = (s[2] * o[l] + s[6] * o[l + 1] + s[10] * o[l + 2] + s[14]) / c;
        }
        return a;
    }
    i.applyMatrix4 = n;
})(aa || (aa = {}));
var Nn;
((c)=>{
    function r1(d) {
        return typeof d == "object" && typeof d.r == "number" && typeof d.g == "number" && typeof d.b == "number";
    }
    c.isRGB = r1, c.white = {
        r: 1,
        g: 1,
        b: 1
    }, c.red = {
        r: 1,
        g: 0,
        b: 0
    }, c.black = {
        r: 0,
        g: 0,
        b: 0
    };
    function i(d) {
        return {
            r: Math.round(d.r * 255),
            g: Math.round(d.g * 255),
            b: Math.round(d.b * 255),
            a: 1
        };
    }
    c.toRgb255a1 = i;
    function s(d) {
        return {
            r: d.r,
            g: d.g,
            b: d.b
        };
    }
    c.clone = s;
    function o(d) {
        return d = Math.floor(d), {
            r: (d >> 16 & 255) / 255,
            g: (d >> 8 & 255) / 255,
            b: (d & 255) / 255
        };
    }
    c.fromHex = o;
    function a(d) {
        return Math.round(d.r * 255) * 65536 + Math.round(d.g * 255) * 256 + Math.round(d.b * 255);
    }
    c.toHex = a;
    function l(d, h) {
        return d.r === h.r && d.g === h.g && d.b === h.b;
    }
    c.equals = l;
    function u(d, h, f) {
        return {
            r: d.r + (h.r - d.r) * f,
            g: d.g + (h.g - d.g) * f,
            b: d.b + (h.b - d.b) * f
        };
    }
    c.lerp = u;
})(Nn || (Nn = {}));
var Mr;
((a)=>{
    a.white = {
        ...Nn.white,
        a: 1
    }, a.transparent = {
        ...Nn.white,
        a: 0
    };
    function e(l) {
        return {
            r: l[0],
            g: l[1],
            b: l[2],
            a: l[3]
        };
    }
    a.from0to1 = e;
    function n(l, u) {
        return {
            ...Nn.fromHex(l),
            a: u
        };
    }
    a.fromHexAndA = n;
    function i(l) {
        return {
            r: Math.round(l.r * 255),
            g: Math.round(l.g * 255),
            b: Math.round(l.b * 255),
            a: l.a
        };
    }
    a.toRgb255a1 = i;
    function s(l, u) {
        return Nn.equals(l, u) && l.a === u.a;
    }
    a.equals = s;
    function o(l, u, c) {
        return {
            r: l.r + (u.r - l.r) * c,
            g: l.g + (u.g - l.g) * c,
            b: l.b + (u.b - l.b) * c,
            a: l.a + (u.a - l.a) * c
        };
    }
    a.lerp = o;
})(Mr || (Mr = {}));
var og;
((t)=>t.identity = {
        position: [
            0,
            0,
            0
        ],
        rotation: [
            0,
            0,
            0
        ],
        scale: [
            1,
            1,
            1
        ]
    })(og || (og = {}));
var mE;
((t)=>t.defaultData = {
        mass: 1,
        stiffness: 80,
        damping: 10,
        velocity: 0
    })(mE || (mE = {}));
var gE;
((t)=>t.defaultData = {
        control1: [
            .5,
            0
        ],
        control2: [
            .5,
            1
        ]
    })(gE || (gE = {}));
var yo;
((s)=>(s.linear = [
        0,
        0,
        1,
        1
    ], s.ease = [
        .25,
        .1,
        .25,
        1
    ], s.easeIn = [
        .42,
        0,
        1,
        1
    ], s.easeOut = [
        0,
        0,
        .58,
        1
    ], s.easeInOut = [
        .42,
        0,
        .58,
        1
    ]))(yo || (yo = {}));
var ji;
((e)=>{
    e.all = [
        "PerspectiveCamera",
        "OrthographicCamera"
    ];
    function t(n) {
        return e.all.includes(n);
    }
    e.is = t;
})(ji || (ji = {}));
var fl;
((i)=>{
    i.DefaultUp = [
        0,
        1,
        0
    ], i.DefaultTargetOffset = 1e3, i.defaultData = {
        far: 1e5,
        type: "OrthographicCamera",
        perspective: {
            near: 70,
            fov: 45,
            zoom: 1
        },
        orthographic: {
            near: -100000,
            zoom: 1,
            autoZoom: !1,
            autoZoomFrustumSize: 790
        },
        up: i.DefaultUp,
        isUpVectorFlipped: !1,
        targetOffset: i.DefaultTargetOffset
    };
    function n(s) {
        return s.type === "PerspectiveCamera" ? s.perspective.zoom : s.orthographic.zoom;
    }
    i.getZoom = n;
})(fl || (fl = {}));
var Ms;
((e)=>{
    function r1(n, i = .1) {
        return {
            disabled: !1,
            type: "linear",
            hideBase: !1,
            count: 3,
            radial: {
                radius: Math.max(n[0], n[1]) * 2,
                start: 0,
                end: 360,
                alignment: !1,
                axis: "y",
                scale: [
                    1,
                    1,
                    1
                ],
                rotation: [
                    0,
                    0,
                    0
                ],
                position: [
                    0,
                    0,
                    0
                ]
            },
            toObject: {
                object: "",
                spreadType: "random",
                scale: [
                    0,
                    0,
                    0
                ],
                rotation: [
                    0,
                    0,
                    0
                ],
                position: [
                    0,
                    0,
                    0
                ],
                axis: "x",
                seed: 0,
                count: 99,
                align: "normal"
            },
            linear: {
                scale: [
                    1,
                    1,
                    1
                ],
                rotation: [
                    0,
                    0,
                    0
                ],
                position: [
                    n[0] + n[0] * i,
                    0,
                    0
                ]
            },
            grid: {
                count: [
                    2,
                    2,
                    2
                ],
                size: n.map((s)=>s * (1 + i)),
                useCenter: !0
            },
            randomness: !1,
            randomnessObject: {
                strength: 100,
                scale: [
                    0,
                    0,
                    0
                ],
                rotation: [
                    0,
                    0,
                    0
                ],
                position: [
                    0,
                    0,
                    0
                ],
                movement: 1,
                seed: 0,
                freqScale: 10,
                noiseType: "perlin"
            }
        };
    }
    e.defaultData = r1;
    function t(n, i) {
        let s = {
            ...n
        };
        if (Wx.forEach((o)=>{
            Object.assign(s, {
                [o]: i[o] ?? n[o]
            });
        }), s.radial = {
            ...n.radial
        }, i.radial) {
            let o = n.radial, a = i.radial;
            jx.forEach((l)=>{
                Object.assign(s.radial, {
                    [l]: a[l] ?? o[l]
                });
            });
        }
        if (s.linear = {
            ...n.linear
        }, i.linear) {
            let o = n.linear, a = i.linear;
            qx.forEach((l)=>{
                Object.assign(s.linear, {
                    [l]: a[l] ?? o[l]
                });
            });
        }
        if (s.grid = {
            ...n.grid
        }, i.grid) {
            let o = n.grid, a = i.grid;
            Xx.forEach((l)=>{
                Object.assign(s.grid, {
                    [l]: a[l] ?? o[l]
                });
            });
        }
        if (s.toObject = {
            ...n.toObject
        }, i.toObject) {
            let o = n.toObject, a = i.toObject;
            Yx.forEach((l)=>{
                Object.assign(s.toObject, {
                    [l]: a[l] ?? o[l]
                });
            });
        }
        if (s.randomnessObject = {
            ...n.randomnessObject
        }, i.randomnessObject) {
            let o = n.randomnessObject, a = i.randomnessObject;
            Qx.forEach((l)=>{
                Object.assign(s.randomnessObject, {
                    [l]: a[l] ?? o[l]
                });
            });
        }
        return s;
    }
    e.merge = t;
})(Ms || (Ms = {}));
var ag;
((n)=>{
    n.defaultData = {
        radial: {},
        linear: {},
        grid: {},
        toObject: {},
        randomnessObject: {}
    };
    let t = [
        "radial",
        "linear",
        "grid",
        "toObject",
        "randomnessObject"
    ];
    function e(i, s) {
        let o = [];
        i.count !== void 0 && o.push({
            type: 0,
            path: s,
            props: {
                count: i.count
            }
        });
        for (let a of t){
            let l = i[a];
            l && Object.keys(l).length > 0 && o.push({
                type: 0,
                path: [
                    ...s,
                    a
                ],
                props: l
            });
        }
        return o;
    }
    n.toOps = e;
})(ag || (ag = {}));
var Wx = [
    "count"
], jx = [
    "radius",
    "start",
    "end",
    "position",
    "scale",
    "rotation"
], qx = [
    "position",
    "scale",
    "rotation"
], Xx = [
    "count",
    "size"
], Yx = [
    "count",
    "position",
    "scale",
    "rotation"
], Qx = [
    "strength",
    "scale",
    "rotation",
    "position",
    "movement",
    "seed",
    "freqScale"
];
var pl;
((e)=>{
    let r1 = {
        opacity: 1,
        blendFunction: 13,
        enabled: !1
    };
    e.defaultData = {
        enabled: !1,
        pixelation: {
            ...r1,
            blendFunction: 16,
            granularity: 15
        },
        bloom: {
            ...r1,
            blendFunction: 16,
            intensity: 1,
            blurScale: 1,
            luminanceThreshold: .25,
            luminanceSmoothing: .025,
            kernelSize: 3
        },
        chromaticAberration: {
            ...r1,
            offset: [
                2,
                2
            ]
        },
        vignette: {
            ...r1,
            darkness: 1,
            offset: 0
        },
        hueSaturation: {
            ...r1,
            hue: 3,
            saturation: 0
        },
        brightnessContrast: {
            ...r1,
            brightness: .25,
            contrast: 0
        },
        depthOfField: {
            ...r1,
            focalLength: 2,
            focusDistance: 2,
            bokehScale: 2
        },
        noise: {
            ...r1,
            blendFunction: 16
        }
    };
})(pl || (pl = {}));
var lg;
((e)=>{
    e.all = [
        "PointLight",
        "SpotLight",
        "DirectionalLight",
        "HemisphereLight"
    ];
    function t(n) {
        return e.all.includes(n);
    }
    e.is = t;
})(lg || (lg = {}));
var cg;
((e)=>{
    function r1(n) {
        return t(n);
    }
    e.defaultData = r1;
    function t(n) {
        if (n === "PointLight") return {
            type: n,
            color: Mr.white,
            intensity: 1,
            distance: 2e3,
            decay: 1,
            shadows: !0,
            shadowResolution: 1024,
            shadowRadius: 1,
            depth: 1e5
        };
        if (n === "SpotLight") return {
            type: n,
            color: Mr.white,
            intensity: 1,
            distance: 2e3,
            decay: 1,
            shadows: !0,
            penumbra: 0,
            angle: 30 / 180 * Math.PI,
            depth: 1e5,
            shadowResolution: 1024,
            shadowRadius: 1
        };
        if (n === "DirectionalLight") return {
            type: n,
            color: Mr.white,
            intensity: 1,
            shadows: !0,
            size: 2e3,
            depth: 1e5,
            shadowResolution: 1024,
            shadowRadius: 1
        };
        throw new Error("not implemented");
    }
})(cg || (cg = {}));
var Kx;
((e)=>{
    e.defaultData = {
        castShadow: !0,
        receiveShadow: !0
    };
    function t(n, i) {
        return n.castShadow === i.castShadow && n.receiveShadow === i.receiveShadow;
    }
    e.equals = t;
})(Kx || (Kx = {}));
var Zx;
((e)=>{
    e.defaultData = {
        flatShading: !1,
        wireframe: !1,
        side: 0
    };
    function t(n, i) {
        return n.flatShading === i.flatShading && n.side === i.side && n.wireframe === i.wireframe;
    }
    e.equals = t;
})(Zx || (Zx = {}));
var ug;
((t)=>t.defaultData = {
        ...Zx.defaultData,
        ...Kx.defaultData
    })(ug || (ug = {}));
var cu;
((e)=>(e.defaultVideo = {
        data: "",
        thumb: "/_assets/_videos/catThumb.png",
        type: "video",
        name: "Cat video"
    }, e.maxSize = 3e7))(cu || (cu = {}));
var yE;
((t)=>{
    function r1(e) {
        return e === "texture" || e === "video" || e === "color" || e === "depth" || e === "normal" || e === "gradient" || e === "noise" || e === "fresnel" || e === "rainbow" || e === "toon" || e === "outline" || e === "transmission" || e === "matcap" || e === "displace" || e === "pattern" || e === "light";
    }
    t.is = r1;
})(yE || (yE = {}));
function xE(r1) {
    return r1.type !== "displace";
}
var vE;
((t)=>{
    function r1(e) {
        return e === "phong" || e === "toon" || e === "lambert" || e === "physical";
    }
    t.is = r1;
})(vE || (vE = {}));
var dg = [
    "mode",
    "gradientType",
    "noiseType",
    "displacementType",
    "projection",
    "cnormal",
    "crop",
    "axis",
    "side"
], bE = [
    "wrapping",
    "image",
    "video"
], Br;
((i)=>{
    function r1(s, o) {
        let { texture: a , ...l } = o;
        if (Object.assign(s, l), a) {
            let u = s.texture;
            u && Object.assign(u, a);
        }
    }
    i.patch = r1;
    function t(s, o) {
        return s === "light" && o ? e(o) : n(s);
    }
    i.defaultData = t;
    function e(s) {
        let o = {
            mode: 0,
            isMask: !1,
            visible: !0
        };
        switch(s){
            case "phong":
                return {
                    ...o,
                    category: "phong",
                    specular: {
                        r: .2,
                        g: .2,
                        b: .2
                    },
                    shininess: 5,
                    type: "light",
                    visible: !0,
                    mode: 0,
                    occlusion: !0,
                    alpha: .6
                };
            case "toon":
                return {
                    ...o,
                    category: "toon",
                    specular: {
                        r: .2,
                        g: .2,
                        b: .2
                    },
                    shininess: 10,
                    type: "light",
                    alpha: 1
                };
            case "lambert":
                return {
                    ...o,
                    category: "lambert",
                    emissive: {
                        r: 0,
                        g: 0,
                        b: 0
                    },
                    type: "light",
                    alpha: 1,
                    visible: !0,
                    mode: 0,
                    occlusion: !0
                };
            case "physical":
                return {
                    ...o,
                    category: "physical",
                    roughness: .2,
                    metalness: .2,
                    reflectivity: .2,
                    type: "light",
                    alpha: 1,
                    visible: !0,
                    mode: 0,
                    occlusion: !0
                };
        }
    }
    function n(s) {
        let o = {
            alpha: 1,
            mode: 0,
            isMask: !1,
            visible: !0
        };
        switch(s){
            case "texture":
                return {
                    ...o,
                    type: "texture",
                    size: [
                        128,
                        128
                    ],
                    blending: 0,
                    axis: "x",
                    side: 2,
                    projection: 0,
                    texture: {
                        image: "image_0",
                        wrapping: 1e3,
                        repeat: [
                            1,
                            1
                        ],
                        offset: [
                            0,
                            0
                        ]
                    },
                    crop: !1
                };
            case "video":
                return {
                    ...o,
                    type: "video",
                    size: [
                        128,
                        128
                    ],
                    blending: 0,
                    axis: "x",
                    side: 2,
                    projection: 0,
                    texture: {
                        video: cu.defaultVideo,
                        wrapping: 1001,
                        repeat: [
                            1,
                            1
                        ],
                        offset: [
                            0,
                            0
                        ]
                    },
                    crop: !1
                };
            case "color":
                return {
                    ...o,
                    type: "color",
                    color: Nn.fromHex(5526619)
                };
            case "depth":
                return {
                    ...o,
                    type: "depth",
                    gradientType: 1,
                    smooth: !1,
                    isVector: !0,
                    isWorldSpace: !1,
                    origin: [
                        0,
                        0,
                        0
                    ],
                    direction: [
                        1,
                        0,
                        0
                    ],
                    colors: [
                        [
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            0,
                            0,
                            0,
                            1
                        ]
                    ],
                    steps: [
                        0,
                        1
                    ],
                    near: 50,
                    far: 200
                };
            case "normal":
                return {
                    ...o,
                    type: "normal",
                    cnormal: [
                        1,
                        1,
                        1
                    ]
                };
            case "gradient":
                return {
                    ...o,
                    type: "gradient",
                    gradientType: 0,
                    smooth: !1,
                    colors: [
                        [
                            0,
                            0,
                            0,
                            1
                        ],
                        [
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            1,
                            1,
                            1,
                            1
                        ]
                    ],
                    steps: [
                        0,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1
                    ],
                    num: 2,
                    angle: 0,
                    offset: [
                        0,
                        0
                    ],
                    morph: [
                        0,
                        0
                    ]
                };
            case "noise":
                return {
                    ...o,
                    type: "noise",
                    size: [
                        100,
                        100,
                        100
                    ],
                    noiseType: 0,
                    scale: 1,
                    move: 1,
                    colorA: {
                        ...Nn.fromHex(6710886),
                        a: 1
                    },
                    colorB: {
                        ...Nn.fromHex(6710886),
                        a: 1
                    },
                    colorC: {
                        ...Nn.fromHex(16777215),
                        a: 1
                    },
                    colorD: {
                        ...Nn.fromHex(16777215),
                        a: 1
                    },
                    distortion: [
                        1,
                        1
                    ],
                    fA: [
                        1.7,
                        9.2
                    ],
                    fB: [
                        8.3,
                        2.8
                    ],
                    voronoiStyle: 0,
                    highCut: 1,
                    lowCut: 0,
                    smoothness: .3,
                    seed: 0,
                    quality: 1
                };
            case "fresnel":
                return {
                    ...o,
                    type: "fresnel",
                    color: Mr.fromHexAndA(16777215, 1),
                    bias: .1,
                    scale: 1,
                    intensity: 2,
                    factor: 1
                };
            case "rainbow":
                return {
                    ...o,
                    type: "rainbow",
                    filmThickness: 30,
                    movement: 0,
                    wavelengths: [
                        0,
                        0,
                        0
                    ],
                    noiseStrength: 0,
                    noiseScale: 1,
                    offset: [
                        0,
                        0,
                        0
                    ]
                };
            case "toon":
                return {
                    ...o,
                    type: "toon",
                    positioning: 2,
                    colors: [
                        [
                            0,
                            0,
                            0,
                            1
                        ],
                        [
                            .5,
                            .5,
                            .5,
                            1
                        ],
                        [
                            .5,
                            .5,
                            .5,
                            1
                        ],
                        [
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            1,
                            1,
                            1,
                            1
                        ],
                        [
                            1,
                            1,
                            1,
                            1
                        ]
                    ],
                    steps: [
                        0,
                        .475,
                        .525,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1,
                        1
                    ],
                    num: 4,
                    source: [
                        0,
                        1e3,
                        0
                    ],
                    isWorldSpace: !0,
                    noiseStrength: 0,
                    noiseScale: 1,
                    shadowColor: Mr.fromHexAndA(0, 0),
                    offset: [
                        0,
                        0,
                        0
                    ]
                };
            case "outline":
                return {
                    ...o,
                    type: "outline",
                    outlineColor: Mr.fromHexAndA(0, 1),
                    contourColor: Mr.fromHexAndA(0, 1),
                    outlineWidth: 2,
                    contourWidth: 5,
                    outlineThreshold: .4,
                    contourThreshold: 0,
                    outlineSmoothing: 0,
                    contourFrequency: 10,
                    contourDirection: [
                        0,
                        1,
                        0
                    ],
                    positionalLines: !1,
                    compensation: !0
                };
            case "matcap":
                return {
                    ...o,
                    type: "matcap",
                    texture: {
                        image: "matcap_0",
                        wrapping: 1001,
                        repeat: [
                            1,
                            1
                        ],
                        offset: [
                            0,
                            0
                        ]
                    }
                };
            case "transmission":
                return {
                    ...o,
                    type: "transmission",
                    thickness: 10,
                    ior: 1.5,
                    roughness: 1
                };
            case "displace":
                return {
                    visible: !0,
                    type: "displace",
                    displacementType: "noise",
                    noiseType: 0,
                    scale: 10,
                    movement: 1,
                    offset: [
                        0,
                        0,
                        0
                    ],
                    intensity: 8,
                    voronoiStyle: 0,
                    smoothness: .3,
                    seed: 0,
                    highCut: 1,
                    lowCut: 0,
                    quality: 1
                };
            case "pattern":
                return {
                    ...o,
                    type: "pattern",
                    style: 0,
                    projection: 0,
                    axis: "y",
                    blending: 0,
                    offset: [
                        0,
                        0
                    ],
                    colorA: {
                        ...Nn.fromHex(0),
                        a: 1
                    },
                    colorB: {
                        ...Nn.fromHex(16777215),
                        a: 1
                    },
                    frequency: [
                        10,
                        10
                    ],
                    size: .5,
                    variation: 0,
                    smoothness: .5,
                    zigzag: 0,
                    rotation: 0,
                    vertical: [
                        0,
                        1
                    ],
                    horizontal: [
                        0,
                        1
                    ],
                    sides: 6
                };
        }
    }
})(Br || (Br = {}));
var or;
((l)=>{
    function r1(u) {
        return !u.layers.some((d)=>d.data.type === "texture" && d.data.projection !== 0 || d.data.type === "depth" && !d.data.isWorldSpace || d.data.type === "noise" || d.data.type === "displace");
    }
    l.isMergable = r1;
    function t(u) {
        let c = "";
        return u.layers.forEach((d)=>{
            Object.entries(d.data).forEach(([h, f])=>{
                c += `${h}${f}`, Array.isArray(f) ? f.forEach((m)=>c += `${m}`) : typeof f == "object" ? Object.values(f).forEach((m)=>{
                    typeof m == "number" ? c += `${m.toFixed(4)}` : c += `${m}`;
                }) : c += `${f}`;
            });
        }), c;
    }
    l.getHash = t;
    function e() {
        return {
            layers: new We
        };
    }
    l.defaultEmptyData = e;
    function n(u = "layer1", c = "layer2") {
        return s("phong", u, c);
    }
    l.defaultData = n;
    function i(u, c) {
        return {
            ...u,
            name: c
        };
    }
    l.withName = i;
    function s(u, c = "layer1", d = "layer2") {
        let h = new We;
        return h.push({
            fi: 0,
            data: Br.defaultData("light", u),
            id: c
        }), h.push({
            fi: 1,
            data: Br.defaultData("color"),
            id: d
        }), {
            layers: h
        };
    }
    l.defaultTwoLayerData = s;
    function o(u, c = "phong", d = "layer1", h = "layer2") {
        let f = Br.defaultData("texture");
        Object.assign(f.texture, {
            image: u
        });
        let m = new We;
        return m.push({
            fi: 0,
            data: f,
            id: d
        }), m.push({
            fi: 1,
            data: Br.defaultData("light", c),
            id: h
        }), {
            layers: m
        };
    }
    l.defaultTwoLayerTextureData = o;
    function a(u, c = "phong", d = "layer1", h = "layer2") {
        let f = Br.defaultData("video");
        Object.assign(f.texture, {
            video: u
        });
        let m = new We;
        return m.push({
            fi: 0,
            data: f,
            id: d
        }), m.push({
            fi: 1,
            data: Br.defaultData("light", c),
            id: h
        }), {
            layers: m
        };
    }
    l.defaultTwoLayerVideoTextureData = a;
})(or || (or = {}));
var uu;
((t)=>{
    function r1() {
        return {
            points: new We,
            roundness: 0,
            shapeHoles: [],
            isClosed: !1
        };
    }
    t.defaultData = r1;
})(uu || (uu = {}));
var du;
((t)=>{
    function r1() {
        return {
            points: new We,
            lastInsertionPlane: null,
            subdivisions: 12,
            isClosed: !1
        };
    }
    t.defaultData = r1;
})(du || (du = {}));
var Jx = {
    type: "Ellipse",
    width: 100,
    height: 100,
    spikes: 64,
    angle: 360,
    innerRadius: 0
};
var hg;
((t)=>{
    function r1(e, n) {
        let i = {
            ...e
        };
        return $x.forEach((s)=>{
            Object.assign(i, {
                [s]: n[s] ?? e[s]
            });
        }), i;
    }
    t.merge = r1;
})(hg || (hg = {}));
var fg = {
    shape: Jx,
    depth: 1,
    offset: 0,
    bevel: 0,
    bevelSides: 1,
    angle: 0,
    twist: 0,
    startScale: 1,
    endScale: 1
}, $x = [
    "depth",
    "offset",
    "angle",
    "twist",
    "startScale",
    "endScale"
];
var Xh;
((e)=>{
    function r1(n) {
        return n === "PolygonGeometry" || n === "RectangleGeometry" || n === "StarGeometry" || n === "TriangleGeometry" || n === "EllipseGeometry";
    }
    e.is2DParametricMesh = r1;
    function t(n) {
        return n === "PolygonGeometry" || n === "PolygonGeometry" || n === "RectangleGeometry" || n === "StarGeometry" || n === "TriangleGeometry" || n === "EllipseGeometry" || n === "PathGeometry" || n === "VectorGeometry" || n === "ConeGeometry" || n === "CubeGeometry" || n === "CylinderGeometry" || n === "DodecahedronGeometry" || n === "HelixGeometry" || n === "IcosahedronGeometry" || n === "LatheGeometry" || n === "PyramidGeometry" || n === "SphereGeometry" || n === "PlaneGeometry" || n === "BackdropGeometry" || n === "TorusGeometry" || n === "TorusKnotGeometry" || n === "BooleanGeometry" || n === "TextGeometry";
    }
    e.isParametricMesh = t;
})(Xh || (Xh = {}));
var pg;
((t)=>{
    function r1(e, n) {
        let i = {
            ...e
        };
        return Object.assign(i, n), i.type === "PathGeometry" && "extrusion" in n && n.extrusion && (i.extrusion = {
            ...e.extrusion
        }, Object.assign(i.extrusion, hg.merge(i.extrusion, n.extrusion))), i;
    }
    t.merge = r1;
})(pg || (pg = {}));
var la;
((t)=>{
    function r1(e) {
        if (e === "RectangleGeometry") return {
            width: 320,
            height: 320,
            type: e,
            cornerRadius: [
                0,
                0,
                0,
                0
            ],
            cornerType: 0,
            depth: 0,
            extrudeBevelSize: 0,
            extrudeBevelSegments: 1
        };
        if (e === "PathGeometry") return {
            type: e,
            width: 1,
            height: 1,
            depth: 1,
            path: du.defaultData(),
            extrusion: fg
        };
        if (e === "VectorGeometry") return {
            width: 1,
            height: 1,
            type: e,
            subdivisions: 12,
            shape: uu.defaultData(),
            depth: 0,
            extrudeBevelSize: 0,
            extrudeBevelSegments: 1
        };
        if (e === "BooleanGeometry") return {
            type: e,
            operation: 2,
            width: 0,
            height: 0,
            depth: 0,
            phongAngle: 35
        };
        if (e === "TextGeometry") return {
            type: e,
            width: 100,
            height: 100,
            depth: 0,
            horizontalAlign: 1,
            verticalAlign: 1,
            fontSize: 16,
            lineHeight: 1.2,
            letterSpacing: 0,
            text: "",
            textTransform: 1,
            font: "Roboto_regular",
            extrudeBevelSize: 0,
            extrudeBevelSegments: 1
        };
        if (e === "SphereGeometry") return {
            type: "SphereGeometry",
            width: 100,
            height: 100,
            depth: 100,
            widthSegments: 64,
            heightSegments: 64,
            phiStart: 0,
            phiLength: 2 * Math.PI,
            thetaStart: 0,
            thetaLength: Math.PI
        };
        throw new Error("not implemented");
    }
    t.defaultData = r1;
})(la || (la = {}));
var eb = [
    "width",
    "height",
    "depth"
];
var wE;
((e)=>{
    function r1(n) {
        return n === "Component" || n === "Instance";
    }
    e.isComponentRelated = r1;
    function t(n) {
        return n === "Empty" || n === "Instance";
    }
    e.isEmptyOrComponent = t;
})(wE || (wE = {}));
var hu;
((i)=>{
    i.identity = {
        ...og.identity,
        hiddenMatrix: aa.identity
    };
    function t(s) {
        return {
            position: s.position,
            rotation: s.rotation,
            scale: s.scale,
            hiddenMatrix: s.hiddenMatrix
        };
    }
    i.fromObject = t;
    function e(s, o) {
        return {
            position: o?.position || s.position,
            rotation: o?.rotation || s.rotation,
            scale: o?.scale || s.scale,
            hiddenMatrix: o?.hiddenMatrix || s.hiddenMatrix
        };
    }
    i.merge = e;
    function n(s, o) {
        return mT({
            position: _s.isEqual(s.position, o.position) ? void 0 : o.position,
            rotation: _s.isEqual(s.rotation, o.rotation) ? void 0 : o.rotation,
            scale: _s.isEqual(s.scale, o.scale) ? null : o.scale,
            hiddenMatrix: aa.isEqual(s.hiddenMatrix, o.hiddenMatrix) ? void 0 : o.hiddenMatrix
        });
    }
    i.diff = n;
})(hu || (hu = {}));
var SE;
((t)=>t.defaultData = {
        fusedBody: !0,
        rigidBody: "positioned",
        density: 1,
        pointMass: 0,
        gravityScale: 1,
        friction: .5,
        damping: 0,
        restitution: .2,
        colliderType: "convex",
        enabledRotation: [
            !0,
            !0,
            !0
        ],
        enabledTranslation: [
            !0,
            !0,
            !0
        ]
    })(SE || (SE = {}));
var hi;
((t)=>t.defaultData = {
        states: new We,
        events: new We,
        visible: !0,
        raycastLock: !1,
        collision: "visibility",
        physics: null,
        pathSnapping: {
            pathId: null,
            slide: 0,
            offset: 0,
            orientation: "tangential"
        },
        ...hu.identity,
        cloner: null
    })(hi || (hi = {}));
var AE;
((t)=>t.defaultData = {
        type: "Empty",
        ...hi.defaultData
    })(AE || (AE = {}));
var _E;
((t)=>t.defaultData = {
        type: "Component",
        ...hi.defaultData
    })(_E || (_E = {}));
var ml;
((t)=>t.defaultData = {
        type: "Mesh",
        ...hi.defaultData,
        ...ug.defaultData
    })(ml || (ml = {}));
var fu;
((t)=>t.defaultData = {
        ...hi.defaultData,
        ...hu.identity,
        ...fl.defaultData
    })(fu || (fu = {}));
var mg;
((t)=>{
    function r1(e) {
        return {
            ...hi.defaultData,
            ...cg.defaultData(e)
        };
    }
    t.defaultData = r1;
})(mg || (mg = {}));
var pu;
((e)=>{
    function r1(n, i, s = 0) {
        for(; s < i.length;){
            let o = n ? n[i[s]] : void 0;
            if (i.length === s + 1) return o;
            if (o) n = o.descendants, s += 1;
            else return;
        }
    }
    e.resolveWithDes = r1;
    function t(n, i, s = 0) {
        let o = r1(n, i, s);
        if (o) {
            let a = Object.keys(o);
            if (a.length === 1 && a[0] === "descendants") return;
        }
        return o;
    }
    e.resolve = t;
})(pu || (pu = {}));
var ca;
((s)=>{
    s.rootOverrideProps = [
        "physics"
    ], s.compositeNonOptionalOverrideProps = [
        "geometry"
    ], s.compositeEntireOverrideOverrideProps = [
        "material"
    ];
    function n(o, a) {
        return {
            ...hi.defaultData,
            ...a,
            component: o,
            overrides: new Jt,
            physics: void 0,
            type: "Instance"
        };
    }
    s.ofComponent = n;
    function i(o) {
        let a = hu.fromObject(o.data);
        return n(o.id, a);
    }
    s.fromComponentData = i;
})(ca || (ca = {}));
var gg;
((s)=>(s.defaultCamera = {
        position: [
            0,
            0,
            1e3
        ],
        scale: [
            1,
            1,
            1
        ],
        rotation: [
            0,
            0,
            0
        ],
        hiddenMatrix: aa.identity,
        name: "Play Camera",
        visible: !0,
        raycastLock: !1,
        collision: "visibility",
        physics: null,
        states: new We,
        events: new We,
        cloner: null,
        pathSnapping: {
            pathId: null,
            orientation: "tangential",
            slide: 0,
            offset: 0
        },
        ...fl.defaultData
    }, s.KeysByResetCategory = {
        States: [
            "states"
        ],
        Events: [
            "events"
        ],
        Material: [
            "material",
            "materials"
        ],
        Geometry: [
            "geometry"
        ],
        Position: [
            "position"
        ],
        Rotation: [
            "rotation"
        ],
        Scale: [
            "scale"
        ],
        Transform: [
            "position",
            "scale",
            "rotation",
            "hiddenMatrix"
        ],
        Name: [
            "name"
        ],
        Visibility: [
            "visible",
            "raycastLock",
            "flatShading",
            "wireframe",
            "side"
        ],
        Shadows: [
            "castShadow",
            "receiveShadow"
        ],
        Cloner: [
            "cloner"
        ],
        Physics: [
            "physics"
        ]
    }, s.defaultMeshObject = {
        name: "Rectangle",
        ...hi.defaultData,
        ...ml.defaultData,
        geometry: la.defaultData("RectangleGeometry"),
        material: or.defaultTwoLayerData("phong", "layer1", "layer2")
    }, s.defaultBooleanObject = {
        name: "Boolean",
        ...hi.defaultData,
        ...ml.defaultData,
        geometry: la.defaultData("BooleanGeometry"),
        material: or.defaultTwoLayerData("phong", "layer1", "layer2")
    }, s.defaultTextObject = {
        name: "Text",
        ...hi.defaultData,
        ...ml.defaultData,
        geometry: la.defaultData("TextGeometry"),
        material: or.defaultTwoLayerData("phong", "layer1", "layer2")
    }))(gg || (gg = {}));
var vo;
((i)=>{
    function r1(s, o) {
        let a = {
            name: o
        };
        return s.type === "Mesh" ? (a.geometry = {}, "material" in s && (a.material = {
            layers: new Jt
        }), "materials" in s && (a.materials = s.materials.map((l)=>({
                layers: new Jt
            })))) : ji.is(s.type) && (a.perspective = {}, a.orthographic = {}), a;
    }
    i.newEmpty = r1;
    function t(s, o) {
        if (o === void 0) return s;
        let a = {
            ...s
        };
        return "material" in a && "material" in o && o.material && (a.material = au(a.material, (l)=>{
            if (typeof l != "string") for (let [u, c] of Object.entries(o.material.layers)){
                let d = l.layers.data(u);
                d && Br.patch(d, c);
            }
        }).data), a.materials && o.materials && (a.materials = au(a.materials, (l)=>{
            for(let u = 0; u < a.materials.length; u++){
                let c = o.materials[u];
                if (typeof c != "string") for (let [d, h] of Object.entries(c.layers)){
                    let f = l[u]?.layers?.data(d);
                    f && Br.patch(f, h);
                }
            }
        }).data), a;
    }
    function e(s, o) {
        let a, l = [], u = {
            orthographic: 0,
            perspective: 0,
            geometry: 0
        };
        function c(d, h) {
            for (let [f, m] of Object.entries(h.layers)){
                let { texture: p , ...g } = m;
                if (p !== void 0 && Object.keys(p).length > 0) {
                    let y = {
                        path: [
                            ...d,
                            "layers",
                            f,
                            "texture"
                        ],
                        props: p,
                        type: 0
                    };
                    l.push(y);
                }
                if (Object.keys(g).length > 0) {
                    let y = {
                        path: [
                            ...d,
                            "layers",
                            f
                        ],
                        props: g,
                        type: 0
                    };
                    l.push(y);
                }
            }
        }
        for (let [d, h] of Object.entries(o))if (d !== "name") {
            if (d === "cloner") l.push(...ag.toOps(h, [
                "cloner"
            ]));
            else if (d === "pathSnapping") l.push({
                path: [
                    d
                ],
                props: {
                    slide: h.slide,
                    offset: h.offset
                },
                type: 0
            });
            else if (d === "material") c([
                "material"
            ], h);
            else if (d === "materials") for (let [f, m] of Object.entries(h))c([
                "materials",
                f
            ], m);
            else if (u[d] === 0) {
                if (d === "geometry" && h.extrusion !== void 0) {
                    let f = {
                        path: [
                            d,
                            "extrusion"
                        ],
                        props: h.extrusion,
                        type: 0
                    };
                    l.push(f), h = {
                        ...h
                    }, delete h.extrusion;
                }
                if (Object.keys(h).length > 0) {
                    let f = {
                        path: [
                            d
                        ],
                        props: h,
                        type: 0
                    };
                    l.push(f);
                }
            } else a === void 0 && (a = {
                path: [],
                props: {},
                type: 0
            }, l.push(a)), a.props[d] = h;
        }
        return l;
    }
    i.toOps = e;
    function n(s, o) {
        if (o === void 0) return s;
        let a = {
            ...s
        };
        if (Object.assign(a, hu.merge(a, o)), Object.assign(a, {
            pathSnapping: Object.assign({}, a.pathSnapping, {
                slide: o.pathSnapping?.slide ?? a.pathSnapping?.slide ?? 0,
                offset: o.pathSnapping?.offset ?? a.pathSnapping?.offset ?? 0
            })
        }), ji.is(s.type)) {
            a.orthographic = {
                ...a.orthographic
            }, a.perspective = {
                ...a.perspective
            };
            let l = o;
            l.orthographic?.zoom !== void 0 && (a.orthographic.zoom = l.orthographic.zoom), l.perspective?.zoom !== void 0 && (a.perspective.zoom = l.perspective.zoom), l.isUpVectorFlipped !== void 0 && (a.isUpVectorFlipped = l.isUpVectorFlipped), l.targetOffset !== void 0 && (a.targetOffset = l.targetOffset);
        } else if (s.type === "Mesh") "geometry" in o && Object.assign(a, {
            geometry: pg.merge(a.geometry, o.geometry)
        }), (o.material || o.materials) && (a = t(a, o)), a.cloner && "cloner" in o && Object.assign(a, {
            cloner: Ms.merge(a.cloner, o.cloner)
        });
        else if (s.type === "Empty") a.cloner && "cloner" in o && Object.assign(a, {
            cloner: Ms.merge(a.cloner, o.cloner)
        });
        else if (lg.is(s.type)) {
            let l = o;
            l.intensity !== void 0 && (a.intensity = l.intensity), l.color !== void 0 && (typeof l.color == "string" ? a.color = l.color : a.color = Nn.clone(l.color));
        }
        return a;
    }
    i.patch = n;
})(vo || (vo = {}));
var Qh;
((t)=>t.defaultData = {
        enabled: !1,
        useBackgroundColor: !1,
        color: Nn.white,
        near: .1,
        far: 2e3
    })(Qh || (Qh = {}));
var mu;
((t)=>t.defaultData = {
        enablePan: !0,
        enableZoom: !0,
        enableRotate: !0,
        enableDamping: !0,
        rotationLimitsMode: 0,
        rotationVerticalOffset: {
            min: Math.PI / 4,
            max: Math.PI / 4
        },
        rotationHorizontalOffset: {
            min: Math.PI / 4,
            max: Math.PI / 4
        },
        rotationSoftLimit: 2,
        panLimitsMode: 0,
        panVerticalOffset: {
            min: 250,
            max: 250
        },
        panHorizontalOffset: {
            min: 250,
            max: 250
        },
        panSoftLimit: 2,
        zoomLimitsEnabled: !1,
        zoomLimits: {
            min: .1,
            max: 2
        },
        autoRotate: !1,
        autoRotateSpeed: 2,
        autoRotateClockwise: !0,
        hoverRotatePanMode: 0,
        hoverRotatePanStrength: 20,
        isTouchZoom: !0,
        orbitTouches: 2,
        panTouches: 3,
        resetHoverEffectOnPointerLeave: !0,
        autoZoom: !1
    })(mu || (mu = {}));
var xo;
((t)=>t.defaultData = {
        orbitControls: mu.defaultData,
        playCamera: null,
        withBackground: !0,
        preventScroll: !1,
        preventTouchScroll: !1,
        hideCursor: !1,
        mouseEventTarget: "canvas",
        settings: {
            image: {
                format: "jpg",
                ratio: 1
            },
            video: {
                format: "mp4",
                imageFormat: "jpg",
                fps: 30,
                mbps: 80,
                ratio: Math.max(1, typeof window < "u" ? Math.floor(window.devicePixelRatio) : 1),
                stopMode: "manual",
                duration: 5e3
            },
            web: {
                logo: !0,
                compress: !0,
                preset: 1,
                preload: !0,
                hint: !1
            }
        },
        stopRaycast: !0,
        joystickSizeAndXYOffset: Array(12).fill(0).map((e, n)=>{
            let i = 0, s = 0;
            return n < 5 ? s = -30 : n < 10 && (s = 30), n === 0 || n === 10 || n === 5 ? i = 30 : (n === 4 || n === 11 || n === 9) && (i = -30), [
                120,
                [
                    i,
                    s
                ],
                "show"
            ];
        }),
        gameControlObject: null,
        hdTransmission: !1
    })(xo || (xo = {}));
var tb;
((t)=>t.defaultData = {
        id: "basic",
        label: "Basic",
        style: "None",
        prompt: ""
    })(tb || (tb = {}));
var nb;
((t)=>t.defaultData = {
        weather: 0,
        shadows: 0,
        lightOrigin: 0,
        temperature: 0,
        sun: 0,
        camera: 0,
        environment: 0,
        particles: 0,
        nature: 0,
        floor: 0
    })(nb || (nb = {}));
var gl;
((e)=>(e.defaultData = ()=>({
            mode: "line-art-both",
            prompt: "",
            negativePrompt: "",
            style: {
                ...tb.defaultData
            },
            isRandomSeed: !0,
            seed: e.generateSeed(),
            guessMode: !1,
            advanced: !1,
            steps: 20,
            guidanceScale: 7.5,
            controlNetScale: 1,
            modifiers: nb.defaultData
        }), e.generateSeed = ()=>Math.round(Math.random() * 1e5)))(gl || (gl = {}));
var Fr;
((t)=>t.defaultData = {
        ambientLight: {
            enabled: !0,
            color: {
                r: .8274509803921568,
                g: .8274509803921568,
                b: .8274509803921568
            },
            intensity: .75,
            depth: 100,
            groundColor: {
                r: .5098039215686274,
                g: .5098039215686274,
                b: .5098039215686274
            },
            softShadows: !0,
            softShadowQuality: "low",
            occlusion: !1,
            aoFullRes: !1,
            radius: 256,
            bias: .5,
            aoColor: {
                r: .19607843137254902,
                g: .19607843137254902,
                b: .19607843137254902
            }
        },
        usePhysics: !1,
        gravity: -10,
        pixelsPerMeter: 200,
        skinWidthRelative: .02,
        stepThreshRelative: .3,
        slopeThresh: 65
    })(Fr || (Fr = {}));
var ME;
((o)=>{
    o.TRASH_CAN_ID = "830a2708-8ed9-49cf-a68e-085299892222";
    function t(a = {
        withLight: !0,
        withSquare: !0
    }) {
        let l = new Zt, u = gg.defaultMeshObject;
        return a.withLight === !0 && l.push({
            fi: -1,
            data: {
                ...mg.defaultData("DirectionalLight"),
                position: [
                    200,
                    300,
                    300
                ],
                name: "Directional Light",
                intensity: .7
            },
            id: "830a2708-8ed9-49cf-a68e-085299899103",
            children: []
        }), a.withSquare === !0 && l.push({
            fi: 1,
            id: "7ba78968-2a55-48f2-b14c-5191da3e075e",
            data: u,
            children: []
        }), l;
    }
    o.defaultData = {
        backgroundColor: Mr.fromHexAndA(2960946, 1),
        postprocessing: pl.defaultData,
        fog: Qh.defaultData,
        objects: t(),
        environment: Fr.defaultData,
        publish: xo.defaultData,
        styles: gl.defaultData()
    }, o.emptyData = function(a) {
        return {
            backgroundColor: Mr.fromHexAndA(2960946, 1),
            postprocessing: pl.defaultData,
            fog: Qh.defaultData,
            objects: a ? t(a) : new Zt,
            environment: Fr.defaultData,
            publish: xo.defaultData,
            styles: gl.defaultData()
        };
    };
    function i(a) {
        return {
            ...o.defaultData,
            objects: Hi(a, Zt.prototype)
        };
    }
    o.withObjs = i;
    function s(a, l) {
        return i([
            {
                id: a,
                data: l,
                children: [],
                fi: 0
            }
        ]);
    }
    o.withObj = s;
})(ME || (ME = {}));
var gu;
((t)=>t.emptyImage = {
        data: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVQYV2NgYAAAAAMAAWgmWQ0AAAAASUVORK5CYII="
    })(gu || (gu = {}));
var yg;
((n)=>{
    function r1() {
        let i = {};
        return i["89b10010-844c-11ec-a8a3-0242ac120002"] = {
            r: .5,
            g: .5,
            b: .5,
            a: 1,
            name: "Default Color"
        }, Hi(i, Ft.prototype);
    }
    n.defaultColors = r1;
    function t(i) {
        let s = {};
        return i?.withAITexture && (s["a1b10010-844c-a8a3-11ec-0242ac2011ec"] = {
            ...gu.emptyImage,
            name: "AI generated image"
        }), Hi(s, Ft.prototype);
    }
    n.defaultImages = t;
    function e() {
        return {
            materials: new Ft,
            images: new Ft,
            videos: new Ft,
            colors: new Ft,
            audios: new Ft,
            fonts: new Ft,
            penumbraSize: [
                2,
                2,
                2
            ]
        };
    }
    n.emptyData = e;
})(yg || (yg = {}));
var yu;
((e)=>(e.defaultColliderData = {
        type: "capsule",
        height: 200,
        radius: 50,
        position: [
            0,
            0,
            0
        ],
        rotation: [
            0,
            0,
            0
        ]
    }, e.defaultDataThirdPerson = {
        moveMode: "walk",
        speedTranslate: 1e3,
        speedRotate: 100,
        rotationMode: "normal",
        rotBy: "keys",
        rotByTouch: "drag",
        delayPos: [
            .3,
            .3
        ],
        delayRot: [
            .3,
            .3
        ],
        keyAssignments: [
            [
                "moveNegZ",
                "W"
            ],
            [
                "moveNegX",
                "A"
            ],
            [
                "movePosZ",
                "S"
            ],
            [
                "movePosX",
                "D"
            ],
            [
                "rotPosX",
                "▲"
            ],
            [
                "rotPosY",
                "◀"
            ],
            [
                "rotNegX",
                "▼"
            ],
            [
                "rotNegY",
                "▶"
            ],
            [
                "jump",
                "Space"
            ]
        ],
        touchControl: !0,
        joystickPosLoc: 5,
        joystickRotLoc: 11,
        jumpTouchButtonLoc: 9,
        collider: e.defaultColliderData,
        colliderHelperVisible: !0,
        collisionEnabled: !0,
        jumpPower: 100,
        resetYPosition: 3e3,
        alignToGround: !1,
        autoOrientMove: !0,
        orientWith: "camera",
        orientMode: "radial",
        delayPosCamera: .3,
        delayRotCamera: .3,
        camera: "",
        cameraXAxis: "Limit",
        cameraYAxis: "Free",
        cameraRotXLimits: [
            0,
            Math.PI / 2
        ],
        cameraRotYLimits: [
            -Math.PI / 2,
            Math.PI / 2
        ],
        gameActions: {
            idle: new We,
            move: new We,
            jump: new We
        },
        navmesh: {
            enabled: !1,
            ch: 6,
            cs: 6,
            walkableClimb: 5,
            walkableHeight: 1,
            walkableRadius: 0,
            zones: "all",
            objects: [],
            helperVisible: !0,
            destinationHelperRadius: 0,
            destinationHelperColor: Mr.fromHexAndA(3728051, 1)
        }
    }))(yu || (yu = {}));
function TE(r1) {
    r1.layers.forEach((t)=>{
        if (t.type === "depth" && t.colorA !== void 0) {
            let e = t.colorA, n = t.colorB, i = [
                [
                    e.r,
                    e.g,
                    e.b,
                    e.a
                ],
                [
                    n.r,
                    n.g,
                    n.b,
                    n.a
                ]
            ], s = [
                0,
                1
            ];
            for(let a = 2; a < 10; a++)i.push(i[1]), s.push(1);
            let o = {
                ...ra(ir(t), "type", "visible", "isVector", "isWorldSpace", "origin", "alpha", "mode"),
                near: Math.max(0, t.near),
                far: Math.max(0, t.far),
                colors: i,
                steps: s,
                num: 2,
                direction: [
                    1,
                    0,
                    0
                ],
                smooth: !1,
                gradientType: 1
            };
            Object.assign(t, o);
        } else if (t.type === "depth" && t.gradientType === 1 && (t.near < 0 || t.far < 0)) {
            let e = {
                ...ir(t),
                near: Math.max(t.near, 0),
                far: Math.max(t.far, 0)
            };
            Object.assign(t, e);
        }
    });
}
function vu(r1, t) {
    Object.values(r1.shared.materials).forEach((e)=>t(e));
}
function xu(r1, t) {
    r1.scene.objects.traverse((e, n)=>{
        "materials" in n ? n.materials.forEach((i)=>{
            typeof i != "string" && t(i);
        }) : "material" in n && typeof n.material != "string" && t(n.material);
    });
}
function uH(r1) {
    Object.assign(r1.scene.publish, {
        orbitControls: {
            ...mu.defaultData,
            ...ir(r1.scene.publish.orbitControls)
        }
    });
}
function dH(r1) {
    Object.assign(r1.scene.publish.settings, {
        video: {
            ...xo.defaultData.settings.video,
            ...ir(r1.scene.publish.settings.video)
        }
    });
}
function hH(r1) {
    function t(e) {
        if (e.layers) {
            for (let n of Object.values(e.layers))if (n) {
                for (let [i, s] of Object.entries(n))if ((dg.includes(i) || typeof s == "boolean") && delete n[i], i === "texture") for (let [o, a] of Object.entries(s))(bE.includes(o) || typeof a == "boolean") && delete s[o];
            }
        }
    }
    r1.scene.objects.traverse((e, n)=>{
        n.states.forEach((i)=>{
            let s = i;
            s.material ? t(s.material) : s.materials && s.materials.forEach((o)=>{
                t(o);
            });
        });
    });
}
function fH(r1) {
    r1.scene.publish.withBackground = !0;
}
function pH(r1) {
    r1.scene.publish.settings.web = {
        compress: !0,
        preload: !0,
        preset: 1,
        logo: !0,
        hint: !1
    };
}
function mH(r1) {
    r1.scene.objects.traverse((t, e)=>{
        let n = e.cloner;
        n && (n.radial.scale = n.radial.scale.map((i)=>i + 1), n.linear.scale = n.linear.scale.map((i)=>i + 1));
    });
}
function gH(r1) {
    r1.scene.objects.traverse((t, e)=>{
        let n = e.geometry;
        n && (n.type === "DodecahedronGeometry" || n.type === "IcosahedronGeometry") && (n.detail = Math.round(n.detail));
    });
}
function yH(r1) {
    r1.scene.objects.traverse((t, e)=>{
        let n = r1.scene.objects.unproxy().parent(t);
        if (n) {
            let i = ir(r1.scene.objects.data(n));
            i && i.type === "Mesh" && i.geometry.type === "BooleanGeometry" && e.type === "Mesh" && (e.visible = ir(e).booleanExclude !== !0);
        }
    });
}
function vH(r1) {
    r1.scene.objects.traverse((t, e)=>{
        if (e.type === "Mesh") {
            let n = e;
            e.geometry.type === "NonParametricGeometry" ? n.material !== void 0 && delete n.material : n.materials !== void 0 && delete n.materials;
        }
    });
}
function xH(r1) {
    function t(n) {
        Object.setPrototypeOf(n, Jt.prototype), n.texture && Object.setPrototypeOf(n.texture, Jt.prototype);
    }
    function e(n) {
        Object.setPrototypeOf(n, Jt.prototype);
        for(let i in n)t(n[i]);
    }
    r1.scene.objects.traverse((n, i)=>{
        i.states.forEach((s)=>{
            let o = s;
            if (o.material) {
                let a = ir(o.material).layers;
                e(a), o.material.layers = a;
            }
            if (o.materials) for(let a = 0; a < o.materials.length; a++){
                let l = o.materials[a], u = ir(l).layers;
                e(u), l.layers = u;
            }
        });
    });
}
function EE(r1) {
    r1.layers === void 0 && Object.assign(r1, or.defaultTwoLayerData("lambert"));
}
function rb(r1) {
    !r1.layers || r1.layers.forEach((t)=>{
        if (t.type === "depth" && t.colors.length === 10) {
            let e = [
                ...t.colors
            ];
            e.push(t.colors[9]);
            let n = [
                ...t.steps
            ];
            n.push(t.steps[9]);
            let i = {
                ...ir(t),
                colors: e,
                steps: n
            };
            Object.assign(t, i);
        }
    });
}
function bH(r1) {
    r1.scene.objects.traverse((t, e)=>{
        e.type === "Mesh" && (e.geometry.type === "BooleanGeometry" || e.geometry.type === "SubdivGeometry") && (e.geometry.phongAngle = 35);
    });
}
function CE(r1) {
    r1.scene.objects.traverse((t, e)=>{
        "materials" in e ? e.materials.forEach((n)=>{
            typeof n != "string" && rb(n);
        }) : "material" in e && typeof e.material != "string" && rb(e.material);
    }), Object.values(r1.shared.materials).forEach((t)=>rb(t));
}
function wH(r1) {
    r1.scene.environment.ambientLight.softShadows = !1, r1.scene.environment.ambientLight.softShadowQuality = "low", r1.scene.objects.traverse((t, e)=>{
        (e.type === "DirectionalLight" || e.type === "SpotLight") && (e.shadowResolution = 1024, e.shadowRadius = 1, e.depth = 1e5);
    }), r1.shared.penumbraSize = new Array(5).fill(.5);
}
function SH(r1) {
    r1.shared.audios = Hi({}, Ft.prototype);
}
function AH(r1) {
    r1.shared.videos = Hi({}, Ft.prototype);
}
function _H(r1) {
    let t = r1.shared.materials;
    Object.entries(t).forEach(([e, n])=>{
        if (!n.layers) {
            let i = {
                name: "Untitled Material",
                layers: [
                    {
                        fi: 0,
                        data: {
                            type: "light",
                            category: "phong",
                            alpha: .6,
                            visible: !0,
                            mode: 0,
                            specular: {
                                r: .2,
                                g: .2,
                                b: .2
                            },
                            shininess: 5
                        },
                        id: "layer1"
                    },
                    {
                        fi: 1,
                        data: {
                            type: "color",
                            alpha: 1,
                            visible: !0,
                            mode: 0,
                            color: {
                                r: .2823529411764706,
                                g: .2823529411764706,
                                b: .30196078431372547
                            }
                        },
                        id: "layer2"
                    }
                ]
            };
            Object.assign(t, {
                [e]: i
            });
        }
    });
}
function MH(r1) {
    Object.entries(ir(r1.shared.images)).filter((n)=>n[1].asset === !1).map((n)=>n[0]).forEach((n)=>{
        delete r1.shared.images[n];
    }), Object.entries(ir(r1.shared.audios)).filter((n)=>n[1].asset === !1).map((n)=>n[0]).forEach((n)=>{
        delete r1.shared.audios[n];
    });
}
function TH(r1) {
    r1.scene.publish.settings.web.preload = !1;
}
function PE(r1) {
    r1.layers && r1.layers.forEach((t)=>{
        t.type === "depth" && t.num !== void 0 && (t.colors = t.colors.slice(0, t.num), t.steps = t.steps.slice(0, t.num), delete t.num);
    });
}
function DE(r1) {
    r1.layers && r1.layers.forEach((t)=>{
        xE(t) && t.isMask === void 0 && (t.isMask = !1), (t.type === "texture" || t.type === "video") && t.blending === void 0 && (t.blending = 0), (t.type === "noise" || t.type === "displace" && t.displacementType === "noise") && (t.voronoiStyle === void 0 && (t.voronoiStyle = 0), t.highCut === void 0 && (t.highCut = 1), t.lowCut === void 0 && (t.lowCut = 0), t.smoothness === void 0 && (t.smoothness = .3), t.seed === void 0 && (t.seed = 0), t.quality === void 0 && (t.quality = 1));
    });
}
function EH(r1) {
    r1.shared.fonts = Hi({}, Ft.prototype);
}
function CH(r1) {
    return r1.replace(".typeface", "").replace(/optimer/gi, "open sans").replace("space_mono", "space mono").replace(/alma_mono/gi, "varela round").replace(/droid_sans_mono/gi, "noto sans mono").replace(/droid_sans|gentilis|gnomon_(simple|foreground)|helvetiker/gi, "roboto").replace(/droid_serif/gi, "roboto slab").replace("_sans", " sans").replace("crimson_text", "crimson text").replace("medium_medium", "medium").replace("fatface_fatface", "fatface").replace("100hairline", "thin").replace("200thin", "extralight").replace("300light", "light").replace("500medium", "medium").replace("600semi", "semibold").replace("800heavy", "extrabold").replace("900black", "black").replace(/bodoni_(11|16|24|36|48|72|96)([^_])/gi, "bodoni_$1_$2").replace(/bodoni_(11|16|24|36|48|72|96)/gi, "bodoni moda").replace(/(thin|hairline)(_regular)?/gi, "100").replace(/(extra|ultra)light(_regular)?/gi, "200").replace(/light(_regular)?/gi, "300").replace(/_book|_normal|_roman/gi, "_regular").replace(/medium(_regular)?/gi, "500").replace(/(semi|demi)bold(_regular)?/gi, "600").replace(/(extra|ultra)bold(_regular)?/gi, "800").replace(/bold(_regular)?/gi, "700").replace(/(black|heavy|fatface)(_regular)?/gi, "900").replace(/([1-9]00)_italic/gi, "$1italic").replace(/regularitalic/gi, "italic").replace(/regularitalic/gi, "italic").split(" ").map((e)=>e.charAt(0).toUpperCase() + e.slice(1)).join(" ");
}
function PH(r1) {
    let t = [];
    r1.scene.objects.traverse((e, n)=>{
        let i = n;
        if (i.type === "TextFrame") {
            let s = or.defaultTwoLayerData("phong"), o = typeof i.color == "string" ? r1.shared.colors[i.color] : i.color;
            s.layers[1].data.color = {
                r: o.r,
                g: o.g,
                b: o.b
            }, s.layers[1].data.alpha = i.alpha;
            let a = CH(i.font);
            r1.shared.fonts[a] === void 0 && (r1.shared.fonts[a] = {
                name: a
            });
            let l = {
                name: i.name,
                ...hi.defaultData,
                ...ml.defaultData,
                flatShading: !1,
                wireframe: !1,
                geometry: {
                    ...la.defaultData("TextGeometry"),
                    width: i.width,
                    height: i.height,
                    font: a,
                    depth: 0,
                    horizontalAlign: i.horizontalAlign,
                    verticalAlign: i.verticalAlign,
                    fontSize: i.fontSize * 1.40625,
                    lineHeight: i.lineHeight / 1.40625,
                    letterSpacing: i.letterSpacing - 1,
                    text: i.text,
                    textTransform: i.textTransform,
                    extrudeBevelSize: 0,
                    extrudeBevelSegments: 1
                },
                material: s,
                states: ir(i.states),
                events: ir(i.events),
                visible: i.visible,
                raycastLock: i.raycastLock,
                position: i.position,
                rotation: i.rotation,
                scale: i.scale,
                hiddenMatrix: i.hiddenMatrix
            }, u = ir(r1.scene.objects).parent(e);
            r1.scene.objects.insertAfter(u ?? null, e, [
                {
                    id: e + "new",
                    data: l,
                    children: []
                }
            ]), t.push(e);
        }
    }), t.forEach((e)=>{
        r1.scene.objects.delete(e);
    });
}
function DH(r1) {
    let t = {
        0: "MouseDown",
        1: "MouseUp",
        2: "MouseHover",
        5: "KeyDown",
        6: "KeyUp",
        7: "Start",
        9: "LookAt",
        10: "Follow",
        11: "Scroll",
        12: "Audio",
        13: "GameControl"
    };
    r1.scene.objects.traverse((e, n)=>{
        n.events.forEach((i)=>{
            if (!!t[Number(i.type)]) {
                if (Object.assign(i, {
                    type: t[Number(i.type)]
                }), i.type === "Audio" && "audioEvent" in i && (Object.assign(i, {
                    playAudio: i.audioEvent
                }), delete i.audioEvent), i.type === "GameControl") Object.assign(i, {
                    gameActions: {
                        idle: new We,
                        move: new We,
                        jump: new We
                    }
                });
                else {
                    let s = new We;
                    Object.assign(i, {
                        actions: s
                    }), (i.type === "MouseDown" || i.type === "MouseUp" || i.type === "KeyDown" || i.type === "KeyUp") && "url" in i && s.push({
                        fi: 0,
                        id: He.generateUUID(),
                        data: {
                            type: "Link",
                            url: i.url,
                            delay: 0
                        }
                    }), "targets" in i && (i.targets.forEach((o, a, l)=>{
                        let u = {
                            state: void 0,
                            repeat: 0,
                            delay: 0,
                            delayDirection: void 0,
                            direction: "normal",
                            duration: 0,
                            easing: 4
                        }, c = {
                            easing: o.easing,
                            duration: o.duration
                        };
                        o.easing === 6 ? Object.assign(c, ra(o, "mass", "stiffness", "damping", "velocity")) : o.easing === 5 && Object.assign(c, {
                            control1: {
                                ...o.control1
                            },
                            control2: {
                                ...o.control2
                            }
                        });
                        let d = {
                            repeat: o.repeat ? -1 : 0,
                            delay: o.delay,
                            delayDirection: o.delayDirection,
                            direction: o.cycle && o.rewind ? "pingpong-rewind" : o.cycle ? "pingpong" : "normal"
                        }, h = {
                            state: o.state,
                            ...d,
                            ...c
                        }, f = {
                            allowSlerp: !0,
                            type: "Transition",
                            object: o.object,
                            repeat: 0,
                            delay: 0,
                            delayDirection: void 0,
                            direction: "normal",
                            tweens: new We({
                                fi: 0,
                                id: He.generateUUID(),
                                data: u
                            }, {
                                fi: 1,
                                id: He.generateUUID(),
                                data: h
                            })
                        };
                        s.push({
                            fi: l,
                            id: a,
                            data: f
                        });
                    }), delete i.targets);
                }
            }
        });
    });
}
function IH(r1) {
    r1.scene.objects.traverse((t, e)=>{
        function n(i, s) {
            let o = new We, a = [];
            if (e.events.forEach((l, u, c)=>{
                if (l.type === "Audio" && l.trigger === s) {
                    let d;
                    a.push(u), l.interaction === "play" ? d = {
                        ...ra(l, "interaction", "audio", "delay", "volume", "loop"),
                        triggerAfter: "after" in l ? l.after : void 0,
                        toggle: "after" in l ? l.toggle : void 0,
                        type: "Audio"
                    } : (l.interaction === "pause" || l.interaction === "stop") && (d = {
                        ...ra(l, "interaction", "delay", "object", "playAudio"),
                        type: "Audio"
                    }), d && o.push({
                        fi: c,
                        id: u,
                        data: d
                    });
                }
            }), a.forEach((l)=>e.events.delete(l)), o.length) {
                let l = e.events.find((u)=>u.type === i)?.data;
                l ? "actions" in l && l.actions.insertBefore(null, o) : e.events.insertBefore(null, [
                    {
                        id: He.generateUUID(),
                        data: {
                            type: i,
                            actions: o
                        }
                    }
                ]);
            }
        }
        n("Start", "start"), n("MouseDown", "mouseDown"), n("MouseUp", "mouseUp"), n("KeyDown", "keyDown"), n("KeyUp", "keyUp");
    });
}
function IE(r1) {
    let t = r1.layers.find((e)=>e.type === "light")?.data;
    if (t?.category === "basic") {
        let e = Br.defaultData("light", "phong"), n = t;
        Object.assign(n, e), n.visible = !1;
    }
}
function OE(r1) {
    vu(r1, IE), xu(r1, IE);
}
function OH(r1) {
    r1.scene.objects.traverse((t, e)=>{
        e.type === "Mesh" && e.geometry.type === "SubdivGeometry" && (e.geometry.scaleBaked || (e.geometry.scaleBaked = [
            1,
            1,
            1
        ]));
    });
}
function RH(r1) {
    r1.scene.objects.traverse((t, e)=>{
        (e.type === "Empty" || e.type === "Mesh") && e.cloner && !e.cloner.randomnessObject && !e.cloner.toObject && !e.cloner.randomness && (e.cloner = {
            ...e.cloner,
            toObject: {
                object: "",
                spreadType: "random",
                scale: [
                    0,
                    0,
                    0
                ],
                rotation: [
                    0,
                    0,
                    0
                ],
                position: [
                    0,
                    0,
                    0
                ],
                axis: "x",
                seed: 0,
                count: 99,
                align: "normal"
            },
            randomness: !1,
            randomnessObject: {
                strength: 100,
                scale: [
                    0,
                    0,
                    0
                ],
                rotation: [
                    0,
                    0,
                    0
                ],
                position: [
                    0,
                    0,
                    0
                ],
                movement: 1,
                seed: 0,
                freqScale: 10,
                noiseType: "perlin"
            }
        });
    });
}
function LH(r1) {
    r1.scene.objects.traverse((t, e)=>{
        e.type === "Mesh" && e.geometry.type === "NonParametricGeometry" && !("material" in e) && !("materials" in e) && (e.material = or.defaultTwoLayerData("phong"));
    });
}
function NH(r1) {
    r1.scene.publish.orbitControls.autoZoom === void 0 && (r1.scene.publish.orbitControls.autoZoom = !1), r1.scene.objects.traverse((t, e)=>{
        (e.type === "OrthographicCamera" || e.type === "PerspectiveCamera") && (e.orthographic.autoZoom === void 0 && (e.orthographic.autoZoom = !1), e.orthographic.autoZoomFrustumSize === void 0 && (e.orthographic.autoZoomFrustumSize = 790));
    });
}
function BH(r1) {
    r1.scene.objects.traverse((t, e)=>{
        e.pathSnapping === void 0 && (e.pathSnapping = {
            pathId: null,
            slide: 0,
            offset: 0,
            orientation: "tangential"
        }), e.pathSnapping.offset === void 0 && (e.pathSnapping.offset = 0);
    });
}
function FH(r1) {
    r1.scene.publish.mouseEventTarget === void 0 && (r1.scene.publish.mouseEventTarget = "canvas"), r1.scene.publish.settings.web.hint === void 0 && (r1.scene.publish.settings.web.hint = !1);
}
function UH(r1) {
    let { video: t  } = r1.scene.publish.settings;
    t.format === "gif" && t.fps > 48 && (t.fps = 15);
}
function kH(r1) {
    r1.scene.objects.traverse((t, e)=>{
        e.events.forEach((n)=>{
            n.type === "GameControl" && (n.resetYPosition = Math.abs(n.resetYPosition - e.position[1]));
        });
    });
}
function zH(r1) {
    let t = r1.scene.environment.usePhysics;
    r1.scene.objects.traverse((e, n)=>{
        t && n.physics === null ? n.collision = !1 : n.collision = "visibility";
    });
}
function GH(r1) {
    r1.scene.objects.traverse((t, e)=>{
        e.events.forEach((n)=>{
            n.type === "GameControl" && (n.navmesh = yu.defaultDataThirdPerson.navmesh);
        });
    });
}
function VH(r1) {
    r1.scene.styles || (r1.scene.styles = gl.defaultData());
}
function RE(r1) {
    r1.layers.forEach((t)=>{
        t.type === "light" && t.category !== "toon" && t.occlusion === void 0 && (t.occlusion = !0);
    });
}
function HH(r1) {
    r1.scene.environment.ambientLight.occlusion === void 0 && (r1.scene.environment.ambientLight.occlusion = !1), r1.scene.environment.ambientLight.aoFullRes === void 0 && (r1.scene.environment.ambientLight.aoFullRes = !1), r1.scene.environment.ambientLight.radius === void 0 && (r1.scene.environment.ambientLight.radius = 256), r1.scene.environment.ambientLight.bias === void 0 && (r1.scene.environment.ambientLight.bias = .5), r1.scene.environment.ambientLight.aoColor === void 0 && (r1.scene.environment.ambientLight.aoColor = {
        r: .19607843137254902,
        g: .19607843137254902,
        b: .19607843137254902
    }), xu(r1, RE), vu(r1, RE);
}
var LE = 41;
function NE(r1) {
    let t = r1.schema ?? 0;
    t !== LE && (console.warn("updating from ", t, "to ", LE), t < 1 && (xu(r1, TE), vu(r1, TE), r1.schema = 1), t < 2 && (uH(r1), r1.schema = 2), t < 3 && (hH(r1), r1.schema = 3), t < 4 && (fH(r1), r1.schema = 4), t < 5 && (pH(r1), r1.schema = 5), t < 6 && (mH(r1), r1.schema = 6), t < 7 && (gH(r1), r1.schema = 7), t < 8 && (r1.schema = 8), t < 9 && (CE(r1), r1.schema = 9), t < 10 && (bH(r1), r1.schema = 10), t < 11 && (wH(r1), r1.schema = 11), t < 12 && (CE(r1), r1.schema = 12), t < 13 && (SH(r1), r1.schema = 13), t < 14 && (_H(r1), r1.schema = 14), t < 15 && (MH(r1), r1.schema = 15), t < 16 && (TH(r1), r1.schema = 16), t < 17 && (xu(r1, PE), vu(r1, PE), r1.schema = 17), t < 18 && (xu(r1, EE), vu(r1, EE), r1.schema = 18), t < 19 && (dH(r1), r1.schema = 19), t < 20 && (EH(r1), PH(r1), r1.schema = 20), t < 21 && (DH(r1), IH(r1), r1.schema = 21), t < 22 && (OE(r1), r1.schema = 22), t < 23 && (OH(r1), r1.schema = 23), t < 24 && (RH(r1), r1.schema = 24), (t < 25 || r1.shared.videos === void 0) && (AH(r1), t < 25 && (r1.schema = 25)), t < 26 && (yH(r1), r1.schema = 26), t < 27 && (vH(r1), r1.schema = 27), t < 28 && (OE(r1), r1.schema = 28), t < 29 && (xH(r1), r1.schema = 29), t < 30 && (LH(r1), r1.schema = 30), t < 31 && (NH(r1), r1.schema = 31), t < 33 && (BH(r1), r1.schema = 33), t < 34 && (FH(r1), r1.schema = 34), t < 35 && (UH(r1), r1.schema = 35), t < 36 && (kH(r1), r1.schema = 36), t < 37 && (zH(r1), r1.schema = 37), t < 38 && (xu(r1, DE), vu(r1, DE), r1.schema = 38), t < 39 && (GH(r1), r1.schema = 39), t < 40 && (VH(r1), r1.schema = 40), t < 41 && (HH(r1), r1.schema = 41));
}
function Xi(r1, t = !1) {
    let e = r1[0].index !== null, n = new Set(Object.keys(r1[0].attributes)), i = new Set(Object.keys(r1[0].morphAttributes)), s = {}, o = {}, a = r1[0].morphTargetsRelative, l = new Me, u = 0;
    for(let c = 0; c < r1.length; ++c){
        let d = r1[c], h = 0;
        if (e !== (d.index !== null)) return console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + c + ". All geometries must have compatible attributes; make sure index attribute exists among all geometries, or in none of them."), null;
        for(let f in d.attributes){
            if (!n.has(f)) return console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + c + '. All geometries must have compatible attributes; make sure "' + f + '" attribute exists among all geometries, or in none of them.'), null;
            s[f] === void 0 && (s[f] = []), s[f].push(d.attributes[f]), h++;
        }
        if (h !== n.size) return console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + c + ". Make sure all geometries have the same number of attributes."), null;
        if (a !== d.morphTargetsRelative) return console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + c + ". .morphTargetsRelative must be consistent throughout all geometries."), null;
        for(let f in d.morphAttributes){
            if (!i.has(f)) return console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + c + ".  .morphAttributes must be consistent throughout all geometries."), null;
            o[f] === void 0 && (o[f] = []), o[f].push(d.morphAttributes[f]);
        }
        if (t) {
            let f;
            if (e) f = d.index.count;
            else if (d.attributes.position !== void 0) f = d.attributes.position.count;
            else return console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + c + ". The geometry must have either an index or a position attribute"), null;
            l.addGroup(u, f, c), u += f;
        }
    }
    if (e) {
        let c = 0, d = [];
        for(let h = 0; h < r1.length; ++h){
            let f = r1[h].index;
            for(let m = 0; m < f.count; ++m)d.push(f.getX(m) + c);
            c += r1[h].attributes.position.count;
        }
        l.setIndex(d);
    }
    for(let c in s){
        let d = BE(s[c]);
        if (!d) return console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed while trying to merge the " + c + " attribute."), null;
        l.setAttribute(c, d);
    }
    for(let c in o){
        let d = o[c][0].length;
        if (d === 0) break;
        l.morphAttributes = l.morphAttributes || {}, l.morphAttributes[c] = [];
        for(let h = 0; h < d; ++h){
            let f = [];
            for(let p = 0; p < o[c].length; ++p)f.push(o[c][p][h]);
            let m = BE(f);
            if (!m) return console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed while trying to merge the " + c + " morphAttribute."), null;
            l.morphAttributes[c].push(m);
        }
    }
    return l;
}
function BE(r1) {
    let t, e, n, i = 0;
    for(let a = 0; a < r1.length; ++a){
        let l = r1[a];
        if (l.isInterleavedBufferAttribute) return console.error("THREE.BufferGeometryUtils: .mergeBufferAttributes() failed. InterleavedBufferAttributes are not supported."), null;
        if (t === void 0 && (t = l.array.constructor), t !== l.array.constructor) return console.error("THREE.BufferGeometryUtils: .mergeBufferAttributes() failed. BufferAttribute.array must be of consistent array types across matching attributes."), null;
        if (e === void 0 && (e = l.itemSize), e !== l.itemSize) return console.error("THREE.BufferGeometryUtils: .mergeBufferAttributes() failed. BufferAttribute.itemSize must be consistent across matching attributes."), null;
        if (n === void 0 && (n = l.normalized), n !== l.normalized) return console.error("THREE.BufferGeometryUtils: .mergeBufferAttributes() failed. BufferAttribute.normalized must be consistent across matching attributes."), null;
        i += l.array.length;
    }
    let s = new t(i), o = 0;
    for(let a = 0; a < r1.length; ++a)s.set(r1[a].array, o), o += r1[a].array.length;
    return new Be(s, e, n);
}
var FE = Math.pow(2, -24);
var yl = class {
    constructor(){}
};
function Si(r1, t, e) {
    return e.min.x = t[r1], e.min.y = t[r1 + 1], e.min.z = t[r1 + 2], e.max.x = t[r1 + 3], e.max.y = t[r1 + 4], e.max.z = t[r1 + 5], e;
}
function ib(r1) {
    let t = -1, e = -1 / 0;
    for(let n = 0; n < 3; n++){
        let i = r1[n + 3] - r1[n];
        i > e && (e = i, t = n);
    }
    return t;
}
function sb(r1, t) {
    t.set(r1);
}
function ob(r1, t, e) {
    let n, i;
    for(let s = 0; s < 3; s++){
        let o = s + 3;
        n = r1[s], i = t[s], e[s] = n < i ? n : i, n = r1[o], i = t[o], e[o] = n > i ? n : i;
    }
}
function Kh(r1, t, e) {
    for(let n = 0; n < 3; n++){
        let i = t[r1 + 2 * n], s = t[r1 + 2 * n + 1], o = i - s, a = i + s;
        o < e[n] && (e[n] = o), a > e[n + 3] && (e[n + 3] = a);
    }
}
function wu(r1) {
    let t = r1[3] - r1[0], e = r1[4] - r1[1], n = r1[5] - r1[2];
    return 2 * (t * e + e * n + n * t);
}
function qH(r1, t) {
    if (!r1.index) {
        let e = r1.attributes.position.count, n = t.useSharedArrayBuffer ? SharedArrayBuffer : ArrayBuffer, i;
        e > 65535 ? i = new Uint32Array(new n(4 * e)) : i = new Uint16Array(new n(2 * e)), r1.setIndex(new Be(i, 1));
        for(let s = 0; s < e; s++)i[s] = s;
    }
}
function XH(r1) {
    if (!r1.groups || !r1.groups.length) return [
        {
            offset: 0,
            count: r1.index.count / 3
        }
    ];
    let t = [], e = new Set;
    for (let i of r1.groups)e.add(i.start), e.add(i.start + i.count);
    let n = Array.from(e.values()).sort((i, s)=>i - s);
    for(let i = 0; i < n.length - 1; i++){
        let s = n[i], o = n[i + 1];
        t.push({
            offset: s / 3,
            count: (o - s) / 3
        });
    }
    return t;
}
function lb(r1, t, e, n, i = null) {
    let s = 1 / 0, o = 1 / 0, a = 1 / 0, l = -1 / 0, u = -1 / 0, c = -1 / 0, d = 1 / 0, h = 1 / 0, f = 1 / 0, m = -1 / 0, p = -1 / 0, g = -1 / 0, y = i !== null;
    for(let v = t * 6, x = (t + e) * 6; v < x; v += 6){
        let w = r1[v + 0], S = r1[v + 1], _ = w - S, M = w + S;
        _ < s && (s = _), M > l && (l = M), y && w < d && (d = w), y && w > m && (m = w);
        let b = r1[v + 2], T = r1[v + 3], E = b - T, P = b + T;
        E < o && (o = E), P > u && (u = P), y && b < h && (h = b), y && b > p && (p = b);
        let D = r1[v + 4], C = r1[v + 5], O = D - C, B = D + C;
        O < a && (a = O), B > c && (c = B), y && D < f && (f = D), y && D > g && (g = D);
    }
    n[0] = s, n[1] = o, n[2] = a, n[3] = l, n[4] = u, n[5] = c, y && (i[0] = d, i[1] = h, i[2] = f, i[3] = m, i[4] = p, i[5] = g);
}
function YH(r1, t, e, n) {
    let i = 1 / 0, s = 1 / 0, o = 1 / 0, a = -1 / 0, l = -1 / 0, u = -1 / 0;
    for(let c = t * 6, d = (t + e) * 6; c < d; c += 6){
        let h = r1[c + 0];
        h < i && (i = h), h > a && (a = h);
        let f = r1[c + 2];
        f < s && (s = f), f > l && (l = f);
        let m = r1[c + 4];
        m < o && (o = m), m > u && (u = m);
    }
    n[0] = i, n[1] = s, n[2] = o, n[3] = a, n[4] = l, n[5] = u;
}
function QH(r1, t, e, n, i) {
    let s = e, o = e + n - 1, a = i.pos, l = i.axis * 2;
    for(;;){
        for(; s <= o && t[s * 6 + l] < a;)s++;
        for(; s <= o && t[o * 6 + l] >= a;)o--;
        if (s < o) {
            for(let u = 0; u < 3; u++){
                let c = r1[s * 3 + u];
                r1[s * 3 + u] = r1[o * 3 + u], r1[o * 3 + u] = c;
                let d = t[s * 6 + u * 2 + 0];
                t[s * 6 + u * 2 + 0] = t[o * 6 + u * 2 + 0], t[o * 6 + u * 2 + 0] = d;
                let h = t[s * 6 + u * 2 + 1];
                t[s * 6 + u * 2 + 1] = t[o * 6 + u * 2 + 1], t[o * 6 + u * 2 + 1] = h;
            }
            s++, o--;
        } else return s;
    }
}
var bo = 32, KH = (r1, t)=>r1.candidate - t.candidate, ua = new Array(bo).fill().map(()=>({
        count: 0,
        bounds: new Float32Array(6),
        rightCacheBounds: new Float32Array(6),
        leftCacheBounds: new Float32Array(6),
        candidate: 0
    })), vg = new Float32Array(6);
function ZH(r1, t, e, n, i, s) {
    let o = -1, a = 0;
    if (s === 0) o = ib(t), o !== -1 && (a = (t[o] + t[o + 3]) / 2);
    else if (s === 1) o = ib(r1), o !== -1 && (a = JH(e, n, i, o));
    else if (s === 2) {
        let l = wu(r1), u = 1.25 * i, c = n * 6, d = (n + i) * 6;
        for(let h = 0; h < 3; h++){
            let f = t[h], g = (t[h + 3] - f) / bo;
            if (i < bo / 4) {
                let y = [
                    ...ua
                ];
                y.length = i;
                let v = 0;
                for(let w = c; w < d; w += 6, v++){
                    let S = y[v];
                    S.candidate = e[w + 2 * h], S.count = 0;
                    let { bounds: _ , leftCacheBounds: M , rightCacheBounds: b  } = S;
                    for(let T = 0; T < 3; T++)b[T] = 1 / 0, b[T + 3] = -1 / 0, M[T] = 1 / 0, M[T + 3] = -1 / 0, _[T] = 1 / 0, _[T + 3] = -1 / 0;
                    Kh(w, e, _);
                }
                y.sort(KH);
                let x = i;
                for(let w = 0; w < x; w++){
                    let S = y[w];
                    for(; w + 1 < x && y[w + 1].candidate === S.candidate;)y.splice(w + 1, 1), x--;
                }
                for(let w = c; w < d; w += 6){
                    let S = e[w + 2 * h];
                    for(let _ = 0; _ < x; _++){
                        let M = y[_];
                        S >= M.candidate ? Kh(w, e, M.rightCacheBounds) : (Kh(w, e, M.leftCacheBounds), M.count++);
                    }
                }
                for(let w = 0; w < x; w++){
                    let S = y[w], _ = S.count, M = i - S.count, b = S.leftCacheBounds, T = S.rightCacheBounds, E = 0;
                    _ !== 0 && (E = wu(b) / l);
                    let P = 0;
                    M !== 0 && (P = wu(T) / l);
                    let D = 1 + 1.25 * (E * _ + P * M);
                    D < u && (o = h, u = D, a = S.candidate);
                }
            } else {
                for(let x = 0; x < bo; x++){
                    let w = ua[x];
                    w.count = 0, w.candidate = f + g + x * g;
                    let S = w.bounds;
                    for(let _ = 0; _ < 3; _++)S[_] = 1 / 0, S[_ + 3] = -1 / 0;
                }
                for(let x = c; x < d; x += 6){
                    let _ = ~~((e[x + 2 * h] - f) / g);
                    _ >= bo && (_ = bo - 1);
                    let M = ua[_];
                    M.count++, Kh(x, e, M.bounds);
                }
                let y = ua[bo - 1];
                sb(y.bounds, y.rightCacheBounds);
                for(let x = bo - 2; x >= 0; x--){
                    let w = ua[x], S = ua[x + 1];
                    ob(w.bounds, S.rightCacheBounds, w.rightCacheBounds);
                }
                let v = 0;
                for(let x = 0; x < bo - 1; x++){
                    let w = ua[x], S = w.count, _ = w.bounds, b = ua[x + 1].rightCacheBounds;
                    S !== 0 && (v === 0 ? sb(_, vg) : ob(_, vg, vg)), v += S;
                    let T = 0, E = 0;
                    v !== 0 && (T = wu(vg) / l);
                    let P = i - v;
                    P !== 0 && (E = wu(b) / l);
                    let D = 1 + 1.25 * (T * v + E * P);
                    D < u && (o = h, u = D, a = w.candidate);
                }
            }
        }
    } else console.warn(`MeshBVH: Invalid build strategy value ${s} used.`);
    return {
        axis: o,
        pos: a
    };
}
function JH(r1, t, e, n) {
    let i = 0;
    for(let s = t, o = t + e; s < o; s++)i += r1[s * 6 + n * 2];
    return i / e;
}
function $H(r1, t) {
    let e = r1.attributes.position, n = e.array, i = r1.index.array, s = i.length / 3, o = new Float32Array(s * 6), a = e.offset || 0, l = 3;
    e.isInterleavedBufferAttribute && (l = e.data.stride);
    for(let u = 0; u < s; u++){
        let c = u * 3, d = u * 6, h = i[c + 0] * l + a, f = i[c + 1] * l + a, m = i[c + 2] * l + a;
        for(let p = 0; p < 3; p++){
            let g = n[h + p], y = n[f + p], v = n[m + p], x = g;
            y < x && (x = y), v < x && (x = v);
            let w = g;
            y > w && (w = y), v > w && (w = v);
            let S = (w - x) / 2, _ = p * 2;
            o[d + _ + 0] = x + S, o[d + _ + 1] = S + (Math.abs(x) + S) * FE, x < t[p] && (t[p] = x), w > t[p + 3] && (t[p + 3] = w);
        }
    }
    return o;
}
function e5(r1, t) {
    function e(y) {
        h && h(y / f);
    }
    function n(y, v, x, w = null, S = 0) {
        if (!m && S >= l && (m = !0, u && (console.warn(`MeshBVH: Max depth of ${l} reached when generating BVH. Consider increasing maxDepth.`), console.warn(r1))), x <= c || S >= l) return e(v + x), y.offset = v, y.count = x, y;
        let _ = ZH(y.boundingData, w, o, v, x, d);
        if (_.axis === -1) return e(v + x), y.offset = v, y.count = x, y;
        let M = QH(a, o, v, x, _);
        if (M === v || M === v + x) e(v + x), y.offset = v, y.count = x;
        else {
            y.splitAxis = _.axis;
            let b = new yl, T = v, E = M - v;
            y.left = b, b.boundingData = new Float32Array(6), lb(o, T, E, b.boundingData, s), n(b, T, E, s, S + 1);
            let P = new yl, D = M, C = x - E;
            y.right = P, P.boundingData = new Float32Array(6), lb(o, D, C, P.boundingData, s), n(P, D, C, s, S + 1);
        }
        return y;
    }
    qH(r1, t);
    let i = new Float32Array(6), s = new Float32Array(6), o = $H(r1, i), a = r1.index.array, l = t.maxDepth, u = t.verbose, c = t.maxLeafTris, d = t.strategy, h = t.onProgress, f = r1.index.count / 3, m = !1, p = [], g = XH(r1);
    if (g.length === 1) {
        let y = g[0], v = new yl;
        v.boundingData = i, YH(o, y.offset, y.count, s), n(v, y.offset, y.count, s), p.push(v);
    } else for (let y of g){
        let v = new yl;
        v.boundingData = new Float32Array(6), lb(o, y.offset, y.count, v.boundingData, s), n(v, y.offset, y.count, s), p.push(v);
    }
    return p;
}
function zE(r1, t) {
    let e = e5(r1, t), n, i, s, o = [], a = t.useSharedArrayBuffer ? SharedArrayBuffer : ArrayBuffer;
    for(let c = 0; c < e.length; c++){
        let d = e[c], h = l(d), f = new a(32 * h);
        n = new Float32Array(f), i = new Uint32Array(f), s = new Uint16Array(f), u(0, d), o.push(f);
    }
    return o;
    function l(c) {
        return c.count ? 1 : 1 + l(c.left) + l(c.right);
    }
    function u(c, d) {
        let h = c / 4, f = c / 2, m = !!d.count, p = d.boundingData;
        for(let g = 0; g < 6; g++)n[h + g] = p[g];
        if (m) {
            let g = d.offset, y = d.count;
            return i[h + 6] = g, s[f + 14] = y, s[f + 15] = 65535, c + 32;
        } else {
            let g = d.left, y = d.right, v = d.splitAxis, x;
            if (x = u(c + 32, g), x / 4 > Math.pow(2, 32)) throw new Error("MeshBVH: Cannot store child pointer greater than 32 bits.");
            return i[h + 6] = x / 4, x = u(x, y), i[h + 7] = v, x;
        }
    }
}
var Wr = class {
    constructor(){
        this.min = 1 / 0, this.max = -1 / 0;
    }
    setFromPointsField(t, e) {
        let n = 1 / 0, i = -1 / 0;
        for(let s = 0, o = t.length; s < o; s++){
            let l = t[s][e];
            n = l < n ? l : n, i = l > i ? l : i;
        }
        this.min = n, this.max = i;
    }
    setFromPoints(t, e) {
        let n = 1 / 0, i = -1 / 0;
        for(let s = 0, o = e.length; s < o; s++){
            let a = e[s], l = t.dot(a);
            n = l < n ? l : n, i = l > i ? l : i;
        }
        this.min = n, this.max = i;
    }
    isSeparated(t) {
        return this.min > t.max || t.min > this.max;
    }
};
Wr.prototype.setFromBox = function() {
    let r1 = new A;
    return function(e, n) {
        let i = n.min, s = n.max, o = 1 / 0, a = -1 / 0;
        for(let l = 0; l <= 1; l++)for(let u = 0; u <= 1; u++)for(let c = 0; c <= 1; c++){
            r1.x = i.x * l + s.x * (1 - l), r1.y = i.y * u + s.y * (1 - u), r1.z = i.z * c + s.z * (1 - c);
            let d = e.dot(r1);
            o = Math.min(d, o), a = Math.max(d, a);
        }
        this.min = o, this.max = a;
    };
}();
var Gie = function() {
    let r1 = new Wr;
    return function(e, n) {
        let i = e.points, s = e.satAxes, o = e.satBounds, a = n.points, l = n.satAxes, u = n.satBounds;
        for(let c = 0; c < 3; c++){
            let d = o[c], h = s[c];
            if (r1.setFromPoints(h, a), d.isSeparated(r1)) return !1;
        }
        for(let c = 0; c < 3; c++){
            let d = u[c], h = l[c];
            if (r1.setFromPoints(h, i), d.isSeparated(r1)) return !1;
        }
    };
}();
var t5 = function() {
    let r1 = new A, t = new A, e = new A;
    return function(i, s, o) {
        let a = i.start, l = r1, u = s.start, c = t;
        e.subVectors(a, u), r1.subVectors(i.end, s.start), t.subVectors(s.end, s.start);
        let d = e.dot(c), h = c.dot(l), f = c.dot(c), m = e.dot(l), g = l.dot(l) * f - h * h, y, v;
        g !== 0 ? y = (d * h - m * f) / g : y = 0, v = (d + y * h) / f, o.x = y, o.y = v;
    };
}(), Zh = function() {
    let r1 = new F, t = new A, e = new A;
    return function(i, s, o, a) {
        t5(i, s, r1);
        let l = r1.x, u = r1.y;
        if (l >= 0 && l <= 1 && u >= 0 && u <= 1) {
            i.at(l, o), s.at(u, a);
            return;
        } else if (l >= 0 && l <= 1) {
            u < 0 ? s.at(0, a) : s.at(1, a), i.closestPointToPoint(a, !0, o);
            return;
        } else if (u >= 0 && u <= 1) {
            l < 0 ? i.at(0, o) : i.at(1, o), s.closestPointToPoint(o, !0, a);
            return;
        } else {
            let c;
            l < 0 ? c = i.start : c = i.end;
            let d;
            u < 0 ? d = s.start : d = s.end;
            let h = t, f = e;
            if (i.closestPointToPoint(d, !0, t), s.closestPointToPoint(c, !0, e), h.distanceToSquared(d) <= f.distanceToSquared(c)) {
                o.copy(h), a.copy(d);
                return;
            } else {
                o.copy(c), a.copy(f);
                return;
            }
        }
    };
}(), GE = function() {
    let r1 = new A, t = new A, e = new yn, n = new Hn;
    return function(s, o) {
        let { radius: a , center: l  } = s, { a: u , b: c , c: d  } = o;
        if (n.start = u, n.end = c, n.closestPointToPoint(l, !0, r1).distanceTo(l) <= a || (n.start = u, n.end = d, n.closestPointToPoint(l, !0, r1).distanceTo(l) <= a) || (n.start = c, n.end = d, n.closestPointToPoint(l, !0, r1).distanceTo(l) <= a)) return !0;
        let p = o.getPlane(e);
        if (Math.abs(p.distanceToPoint(l)) <= a) {
            let y = p.projectPoint(l, t);
            if (o.containsPoint(y)) return !0;
        }
        return !1;
    };
}();
var n5 = 1e-15;
function Su(r1) {
    return Math.abs(r1) < n5;
}
var jr = class extends an {
    constructor(...t){
        super(...t), this.isExtendedTriangle = !0, this.satAxes = new Array(4).fill().map(()=>new A), this.satBounds = new Array(4).fill().map(()=>new Wr), this.points = [
            this.a,
            this.b,
            this.c
        ], this.sphere = new Rn, this.plane = new yn, this.needsUpdate = !0;
    }
    intersectsSphere(t) {
        return GE(t, this);
    }
    update() {
        let t = this.a, e = this.b, n = this.c, i = this.points, s = this.satAxes, o = this.satBounds, a = s[0], l = o[0];
        this.getNormal(a), l.setFromPoints(a, i);
        let u = s[1], c = o[1];
        u.subVectors(t, e), c.setFromPoints(u, i);
        let d = s[2], h = o[2];
        d.subVectors(e, n), h.setFromPoints(d, i);
        let f = s[3], m = o[3];
        f.subVectors(n, t), m.setFromPoints(f, i), this.sphere.setFromPoints(this.points), this.plane.setFromNormalAndCoplanarPoint(a, t), this.needsUpdate = !1;
    }
};
jr.prototype.closestPointToSegment = function() {
    let r1 = new A, t = new A, e = new Hn;
    return function(i, s = null, o = null) {
        let { start: a , end: l  } = i, u = this.points, c, d = 1 / 0;
        for(let h = 0; h < 3; h++){
            let f = (h + 1) % 3;
            e.start.copy(u[h]), e.end.copy(u[f]), Zh(e, i, r1, t), c = r1.distanceToSquared(t), c < d && (d = c, s && s.copy(r1), o && o.copy(t));
        }
        return this.closestPointToPoint(a, r1), c = a.distanceToSquared(r1), c < d && (d = c, s && s.copy(r1), o && o.copy(a)), this.closestPointToPoint(l, r1), c = l.distanceToSquared(r1), c < d && (d = c, s && s.copy(r1), o && o.copy(l)), Math.sqrt(d);
    };
}();
jr.prototype.intersectsTriangle = function() {
    let r1 = new jr, t = new Array(3), e = new Array(3), n = new Wr, i = new Wr, s = new A, o = new A, a = new A, l = new A, u = new Hn, c = new Hn, d = new Hn;
    return function(f, m = null) {
        this.needsUpdate && this.update(), f.isExtendedTriangle ? f.needsUpdate && f.update() : (r1.copy(f), r1.update(), f = r1);
        let p = this.plane, g = f.plane;
        if (Math.abs(p.normal.dot(g.normal)) > 1 - 1e-10) {
            let y = this.satBounds, v = this.satAxes;
            e[0] = f.a, e[1] = f.b, e[2] = f.c;
            for(let S = 0; S < 4; S++){
                let _ = y[S], M = v[S];
                if (n.setFromPoints(M, e), _.isSeparated(n)) return !1;
            }
            let x = f.satBounds, w = f.satAxes;
            t[0] = this.a, t[1] = this.b, t[2] = this.c;
            for(let S = 0; S < 4; S++){
                let _ = x[S], M = w[S];
                if (n.setFromPoints(M, t), _.isSeparated(n)) return !1;
            }
            for(let S = 0; S < 4; S++){
                let _ = v[S];
                for(let M = 0; M < 4; M++){
                    let b = w[M];
                    if (s.crossVectors(_, b), n.setFromPoints(s, t), i.setFromPoints(s, e), n.isSeparated(i)) return !1;
                }
            }
            return m && (console.warn("ExtendedTriangle.intersectsTriangle: Triangles are coplanar which does not support an output edge. Setting edge to 0, 0, 0."), m.start.set(0, 0, 0), m.end.set(0, 0, 0)), !0;
        } else {
            let y = this.points, v = !1, x = 0;
            for(let C = 0; C < 3; C++){
                let O = y[C], B = y[(C + 1) % 3];
                u.start.copy(O), u.end.copy(B), u.delta(o);
                let V = v ? c.start : c.end, Y = Su(g.distanceToPoint(O));
                if (Su(g.normal.dot(o)) && Y) {
                    c.copy(u), x = 2;
                    break;
                }
                if ((g.intersectLine(u, V) || Y) && !Su(V.distanceTo(B))) {
                    if (x++, v) break;
                    v = !0;
                }
            }
            if (x === 1 && this.containsPoint(c.start)) return m && (m.start.copy(c.start), m.end.copy(c.start)), !0;
            if (x !== 2) return !1;
            let w = f.points, S = !1, _ = 0;
            for(let C = 0; C < 3; C++){
                let O = w[C], B = w[(C + 1) % 3];
                u.start.copy(O), u.end.copy(B), u.delta(a);
                let V = S ? d.start : d.end, Y = Su(p.distanceToPoint(O));
                if (Su(p.normal.dot(a)) && Y) {
                    d.copy(u), _ = 2;
                    break;
                }
                if ((p.intersectLine(u, V) || Y) && !Su(V.distanceTo(B))) {
                    if (_++, S) break;
                    S = !0;
                }
            }
            if (_ === 1 && this.containsPoint(d.start)) return m && (m.start.copy(d.start), m.end.copy(d.start)), !0;
            if (_ !== 2) return !1;
            if (c.delta(o), d.delta(a), o.dot(a) < 0) {
                let C = d.start;
                d.start = d.end, d.end = C;
            }
            let M = c.start.dot(o), b = c.end.dot(o), T = d.start.dot(o), E = d.end.dot(o), P = b < T, D = M < E;
            return M !== E && T !== b && P === D ? !1 : (m && (l.subVectors(c.start, d.start), l.dot(o) > 0 ? m.start.copy(c.start) : m.start.copy(d.start), l.subVectors(c.end, d.end), l.dot(o) < 0 ? m.end.copy(c.end) : m.end.copy(d.end)), !0);
        }
    };
}();
jr.prototype.distanceToPoint = function() {
    let r1 = new A;
    return function(e) {
        return this.closestPointToPoint(e, r1), e.distanceTo(r1);
    };
}();
jr.prototype.distanceToTriangle = function() {
    let r1 = new A, t = new A, e = [
        "a",
        "b",
        "c"
    ], n = new Hn, i = new Hn;
    return function(o, a = null, l = null) {
        let u = a || l ? n : null;
        if (this.intersectsTriangle(o, u)) return (a || l) && (a && u.getCenter(a), l && u.getCenter(l)), 0;
        let c = 1 / 0;
        for(let d = 0; d < 3; d++){
            let h, f = e[d], m = o[f];
            this.closestPointToPoint(m, r1), h = m.distanceToSquared(r1), h < c && (c = h, a && a.copy(r1), l && l.copy(m));
            let p = this[f];
            o.closestPointToPoint(p, r1), h = p.distanceToSquared(r1), h < c && (c = h, a && a.copy(p), l && l.copy(r1));
        }
        for(let d = 0; d < 3; d++){
            let h = e[d], f = e[(d + 1) % 3];
            n.set(this[h], this[f]);
            for(let m = 0; m < 3; m++){
                let p = e[m], g = e[(m + 1) % 3];
                i.set(o[p], o[g]), Zh(n, i, r1, t);
                let y = r1.distanceToSquared(t);
                y < c && (c = y, a && a.copy(r1), l && l.copy(t));
            }
        }
        return Math.sqrt(c);
    };
}();
var qr = class extends Mt {
    constructor(...t){
        super(...t), this.isOrientedBox = !0, this.matrix = new ae, this.invMatrix = new ae, this.points = new Array(8).fill().map(()=>new A), this.satAxes = new Array(3).fill().map(()=>new A), this.satBounds = new Array(3).fill().map(()=>new Wr), this.alignedSatBounds = new Array(3).fill().map(()=>new Wr), this.needsUpdate = !1;
    }
    set(t, e, n) {
        super.set(t, e), this.matrix.copy(n), this.needsUpdate = !0;
    }
    copy(t) {
        super.copy(t), this.matrix.copy(t.matrix), this.needsUpdate = !0;
    }
};
qr.prototype.update = function() {
    return function() {
        let t = this.matrix, e = this.min, n = this.max, i = this.points;
        for(let u = 0; u <= 1; u++)for(let c = 0; c <= 1; c++)for(let d = 0; d <= 1; d++){
            let h = 1 * u | 2 * c | 4 * d, f = i[h];
            f.x = u ? n.x : e.x, f.y = c ? n.y : e.y, f.z = d ? n.z : e.z, f.applyMatrix4(t);
        }
        let s = this.satBounds, o = this.satAxes, a = i[0];
        for(let u = 0; u < 3; u++){
            let c = o[u], d = s[u], h = 1 << u, f = i[h];
            c.subVectors(a, f), d.setFromPoints(c, i);
        }
        let l = this.alignedSatBounds;
        l[0].setFromPointsField(i, "x"), l[1].setFromPointsField(i, "y"), l[2].setFromPointsField(i, "z"), this.invMatrix.copy(this.matrix).invert(), this.needsUpdate = !1;
    };
}();
qr.prototype.intersectsBox = function() {
    let r1 = new Wr;
    return function(e) {
        this.needsUpdate && this.update();
        let n = e.min, i = e.max, s = this.satBounds, o = this.satAxes, a = this.alignedSatBounds;
        if (r1.min = n.x, r1.max = i.x, a[0].isSeparated(r1) || (r1.min = n.y, r1.max = i.y, a[1].isSeparated(r1)) || (r1.min = n.z, r1.max = i.z, a[2].isSeparated(r1))) return !1;
        for(let l = 0; l < 3; l++){
            let u = o[l], c = s[l];
            if (r1.setFromBox(u, e), c.isSeparated(r1)) return !1;
        }
        return !0;
    };
}();
qr.prototype.intersectsTriangle = function() {
    let r1 = new jr, t = new Array(3), e = new Wr, n = new Wr, i = new A;
    return function(o) {
        this.needsUpdate && this.update(), o.isExtendedTriangle ? o.needsUpdate && o.update() : (r1.copy(o), r1.update(), o = r1);
        let a = this.satBounds, l = this.satAxes;
        t[0] = o.a, t[1] = o.b, t[2] = o.c;
        for(let h = 0; h < 3; h++){
            let f = a[h], m = l[h];
            if (e.setFromPoints(m, t), f.isSeparated(e)) return !1;
        }
        let u = o.satBounds, c = o.satAxes, d = this.points;
        for(let h = 0; h < 3; h++){
            let f = u[h], m = c[h];
            if (e.setFromPoints(m, d), f.isSeparated(e)) return !1;
        }
        for(let h = 0; h < 3; h++){
            let f = l[h];
            for(let m = 0; m < 4; m++){
                let p = c[m];
                if (i.crossVectors(f, p), e.setFromPoints(i, t), n.setFromPoints(i, d), e.isSeparated(n)) return !1;
            }
        }
        return !0;
    };
}();
qr.prototype.closestPointToPoint = function() {
    return function(t, e) {
        return this.needsUpdate && this.update(), e.copy(t).applyMatrix4(this.invMatrix).clamp(this.min, this.max).applyMatrix4(this.matrix), e;
    };
}();
qr.prototype.distanceToPoint = function() {
    let r1 = new A;
    return function(e) {
        return this.closestPointToPoint(e, r1), e.distanceTo(r1);
    };
}();
qr.prototype.distanceToBox = function() {
    let r1 = [
        "x",
        "y",
        "z"
    ], t = new Array(12).fill().map(()=>new Hn), e = new Array(12).fill().map(()=>new Hn), n = new A, i = new A;
    return function(o, a = 0, l = null, u = null) {
        if (this.needsUpdate && this.update(), this.intersectsBox(o)) return (l || u) && (o.getCenter(i), this.closestPointToPoint(i, n), o.closestPointToPoint(n, i), l && l.copy(n), u && u.copy(i)), 0;
        let c = a * a, d = o.min, h = o.max, f = this.points, m = 1 / 0;
        for(let g = 0; g < 8; g++){
            let y = f[g];
            i.copy(y).clamp(d, h);
            let v = y.distanceToSquared(i);
            if (v < m && (m = v, l && l.copy(y), u && u.copy(i), v < c)) return Math.sqrt(v);
        }
        let p = 0;
        for(let g = 0; g < 3; g++)for(let y = 0; y <= 1; y++)for(let v = 0; v <= 1; v++){
            let x = (g + 1) % 3, w = (g + 2) % 3, S = y << x | v << w, _ = 1 << g | y << x | v << w, M = f[S], b = f[_];
            t[p].set(M, b);
            let E = r1[g], P = r1[x], D = r1[w], C = e[p], O = C.start, B = C.end;
            O[E] = d[E], O[P] = y ? d[P] : h[P], O[D] = v ? d[D] : h[P], B[E] = h[E], B[P] = y ? d[P] : h[P], B[D] = v ? d[D] : h[P], p++;
        }
        for(let g = 0; g <= 1; g++)for(let y = 0; y <= 1; y++)for(let v = 0; v <= 1; v++){
            i.x = g ? h.x : d.x, i.y = y ? h.y : d.y, i.z = v ? h.z : d.z, this.closestPointToPoint(i, n);
            let x = i.distanceToSquared(n);
            if (x < m && (m = x, l && l.copy(n), u && u.copy(i), x < c)) return Math.sqrt(x);
        }
        for(let g = 0; g < 12; g++){
            let y = t[g];
            for(let v = 0; v < 12; v++){
                let x = e[v];
                Zh(y, x, n, i);
                let w = n.distanceToSquared(i);
                if (w < m && (m = w, l && l.copy(n), u && u.copy(i), w < c)) return Math.sqrt(w);
            }
        }
        return Math.sqrt(m);
    };
}();
var bg = new A, wg = new A, Sg = new A, VE = new F, HE = new F, WE = new F, jE = new A;
function r5(r1, t, e, n, i, s) {
    let o;
    return s === On ? o = r1.intersectTriangle(n, e, t, !0, i) : o = r1.intersectTriangle(t, e, n, s !== Ir, i), o === null ? null : {
        distance: r1.origin.distanceTo(i),
        point: i.clone()
    };
}
function i5(r1, t, e, n, i, s, o) {
    bg.fromBufferAttribute(t, n), wg.fromBufferAttribute(t, i), Sg.fromBufferAttribute(t, s);
    let a = r5(r1, bg, wg, Sg, jE, o);
    if (a) {
        e && (VE.fromBufferAttribute(e, n), HE.fromBufferAttribute(e, i), WE.fromBufferAttribute(e, s), a.uv = an.getUV(jE, bg, wg, Sg, VE, HE, WE, new F));
        let l = {
            a: n,
            b: i,
            c: s,
            normal: new A,
            materialIndex: 0
        };
        an.getNormal(bg, wg, Sg, l.normal), a.face = l, a.faceIndex = n;
    }
    return a;
}
function ub(r1, t, e, n, i) {
    let s = n * 3, o = r1.index.getX(s), a = r1.index.getX(s + 1), l = r1.index.getX(s + 2), u = i5(e, r1.attributes.position, r1.attributes.uv, o, a, l, t);
    return u ? (u.faceIndex = n, i && i.push(u), u) : null;
}
function qE(r1, t, e, n, i, s) {
    for(let o = n, a = n + i; o < a; o++)ub(r1, t, e, o, s);
}
function XE(r1, t, e, n, i) {
    let s = 1 / 0, o = null;
    for(let a = n, l = n + i; a < l; a++){
        let u = ub(r1, t, e, a);
        u && u.distance < s && (o = u, s = u.distance);
    }
    return o;
}
function db(r1, t, e) {
    return r1 === null || (r1.point.applyMatrix4(t.matrixWorld), r1.distance = r1.point.distanceTo(e.ray.origin), r1.object = t, r1.distance < e.near || r1.distance > e.far) ? null : r1;
}
function Ai(r1, t, e, n) {
    let i = r1.a, s = r1.b, o = r1.c, a = t, l = t + 1, u = t + 2;
    e && (a = e.getX(t), l = e.getX(t + 1), u = e.getX(t + 2)), i.x = n.getX(a), i.y = n.getY(a), i.z = n.getZ(a), s.x = n.getX(l), s.y = n.getY(l), s.z = n.getZ(l), o.x = n.getX(u), o.y = n.getY(u), o.z = n.getZ(u);
}
function hb(r1, t, e, n, i, s, o) {
    let a = e.index, l = e.attributes.position;
    for(let u = r1, c = t + r1; u < c; u++)if (Ai(o, u * 3, a, l), o.needsUpdate = !0, n(o, u, i, s)) return !0;
    return !1;
}
var Au = class {
    constructor(t){
        this._getNewPrimitive = t, this._primitives = [];
    }
    getPrimitive() {
        let t = this._primitives;
        return t.length === 0 ? this._getNewPrimitive() : t.pop();
    }
    releasePrimitive(t) {
        this._primitives.push(t);
    }
};
function wo(r1, t) {
    return t[r1 + 15] === 65535;
}
function vl(r1, t) {
    return t[r1 + 6];
}
function _u(r1, t) {
    return t[r1 + 14];
}
function Mu(r1) {
    return r1 + 8;
}
function Tu(r1, t) {
    return t[r1 + 6];
}
function YE(r1, t) {
    return t[r1 + 7];
}
var Eu = new Mt, _g = new A, o5 = [
    "x",
    "y",
    "z"
];
function Mg(r1, t, e, n, i) {
    let s = r1 * 2, o = Cu, a = da, l = ha;
    if (wo(s, a)) {
        let c = vl(r1, l), d = _u(s, a);
        qE(t, e, n, c, d, i);
    } else {
        let c = Mu(r1);
        Eg(c, o, n, _g) && Mg(c, t, e, n, i);
        let d = Tu(r1, l);
        Eg(d, o, n, _g) && Mg(d, t, e, n, i);
    }
}
function Tg(r1, t, e, n) {
    let i = r1 * 2, s = Cu, o = da, a = ha;
    if (wo(i, o)) {
        let u = vl(r1, a), c = _u(i, o);
        return XE(t, e, n, u, c);
    } else {
        let u = YE(r1, a), c = o5[u], h = n.direction[c] >= 0, f, m;
        h ? (f = Mu(r1), m = Tu(r1, a)) : (f = Tu(r1, a), m = Mu(r1));
        let g = Eg(f, s, n, _g) ? Tg(f, t, e, n) : null;
        if (g) {
            let x = g.point[c];
            if (h ? x <= s[m + u] : x >= s[m + u + 3]) return g;
        }
        let v = Eg(m, s, n, _g) ? Tg(m, t, e, n) : null;
        return g && v ? g.distance <= v.distance ? g : v : g || v || null;
    }
}
var QE = function() {
    let r1, t, e = [], n = new Au(()=>new Mt);
    return function(...o) {
        r1 = n.getPrimitive(), t = n.getPrimitive(), e.push(r1, t);
        let a = i(...o);
        n.releasePrimitive(r1), n.releasePrimitive(t), e.pop(), e.pop();
        let l = e.length;
        return l > 0 && (t = e[l - 1], r1 = e[l - 2]), a;
    };
    function i(s, o, a, l, u = null, c = 0, d = 0) {
        function h(x) {
            let w = x * 2, S = da, _ = ha;
            for(; !wo(w, S);)x = Mu(x), w = x * 2;
            return vl(x, _);
        }
        function f(x) {
            let w = x * 2, S = da, _ = ha;
            for(; !wo(w, S);)x = Tu(x, _), w = x * 2;
            return vl(x, _) + _u(w, S);
        }
        let m = s * 2, p = Cu, g = da, y = ha;
        if (wo(m, g)) {
            let x = vl(s, y), w = _u(m, g);
            return Si(s, p, r1), l(x, w, !1, d, c + s, r1);
        } else {
            let x = Mu(s), w = Tu(s, y), S = x, _ = w, M, b, T, E;
            if (u && (T = r1, E = t, Si(S, p, T), Si(_, p, E), M = u(T), b = u(E), b < M)) {
                S = w, _ = x;
                let Y = M;
                M = b, b = Y, T = E;
            }
            T || (T = r1, Si(S, p, T));
            let P = wo(S * 2, g), D = a(T, P, M, d + 1, c + S), C;
            if (D === 2) {
                let Y = h(S), q = f(S) - Y;
                C = l(Y, q, !0, d + 1, c + S, T);
            } else C = D && i(S, o, a, l, u, c, d + 1);
            if (C) return !0;
            E = t, Si(_, p, E);
            let O = wo(_ * 2, g), B = a(E, O, b, d + 1, c + _), V;
            if (B === 2) {
                let Y = h(_), q = f(_) - Y;
                V = l(Y, q, !0, d + 1, c + _, E);
            } else V = B && i(_, o, a, l, u, c, d + 1);
            return !!V;
        }
    }
}(), KE = function() {
    let r1 = new jr, t = new jr, e = new ae, n = new qr, i = new qr;
    return function s(o, a, l, u, c = null) {
        let d = o * 2, h = Cu, f = da, m = ha;
        if (c === null && (l.boundingBox || l.computeBoundingBox(), n.set(l.boundingBox.min, l.boundingBox.max, u), c = n), wo(d, f)) {
            let g = a, y = g.index, v = g.attributes.position, x = l.index, w = l.attributes.position, S = vl(o, m), _ = _u(d, f);
            if (e.copy(u).invert(), l.boundsTree) return Si(o, h, i), i.matrix.copy(e), i.needsUpdate = !0, l.boundsTree.shapecast({
                intersectsBounds: (b)=>i.intersectsBox(b),
                intersectsTriangle: (b)=>{
                    b.a.applyMatrix4(u), b.b.applyMatrix4(u), b.c.applyMatrix4(u), b.needsUpdate = !0;
                    for(let T = S * 3, E = (_ + S) * 3; T < E; T += 3)if (Ai(t, T, y, v), t.needsUpdate = !0, b.intersectsTriangle(t)) return !0;
                    return !1;
                }
            });
            for(let M = S * 3, b = _ + S * 3; M < b; M += 3){
                Ai(r1, M, y, v), r1.a.applyMatrix4(e), r1.b.applyMatrix4(e), r1.c.applyMatrix4(e), r1.needsUpdate = !0;
                for(let T = 0, E = x.count; T < E; T += 3)if (Ai(t, T, x, w), t.needsUpdate = !0, r1.intersectsTriangle(t)) return !0;
            }
        } else {
            let g = o + 8, y = m[o + 6];
            return Si(g, h, Eu), !!(c.intersectsBox(Eu) && s(g, a, l, u, c) || (Si(y, h, Eu), c.intersectsBox(Eu) && s(y, a, l, u, c)));
        }
    };
}();
function Eg(r1, t, e, n) {
    return Si(r1, t, Eu), e.intersectBox(Eu, n);
}
var fb = [], Ag, Cu, da, ha;
function Pu(r1) {
    Ag && fb.push(Ag), Ag = r1, Cu = new Float32Array(r1), da = new Uint16Array(r1), ha = new Uint32Array(r1);
}
function Jh() {
    Ag = null, Cu = null, da = null, ha = null, fb.length && Pu(fb.pop());
}
var pb = Symbol("skip tree generation"), mb = new Mt, gb = new Mt, Du = new ae, xl = new qr, $h = new qr, ef = new A, Cg = new A, a5 = new A, l5 = new A, c5 = new A, ZE = new Mt, Ts = new Au(()=>new jr), un = class {
    static serialize(t, e = {}) {
        if (e.isBufferGeometry) return console.warn("MeshBVH.serialize: The arguments for the function have changed. See documentation for new signature."), un.serialize(arguments[0], {
            cloneBuffers: arguments[2] === void 0 ? !0 : arguments[2]
        });
        e = {
            cloneBuffers: !0,
            ...e
        };
        let n = t.geometry, i = t._roots, s = n.getIndex(), o;
        return e.cloneBuffers ? o = {
            roots: i.map((a)=>a.slice()),
            index: s.array.slice()
        } : o = {
            roots: i,
            index: s.array
        }, o;
    }
    static deserialize(t, e, n = {}) {
        if (typeof n == "boolean") return console.warn("MeshBVH.deserialize: The arguments for the function have changed. See documentation for new signature."), un.deserialize(arguments[0], arguments[1], {
            setIndex: arguments[2] === void 0 ? !0 : arguments[2]
        });
        n = {
            setIndex: !0,
            ...n
        };
        let { index: i , roots: s  } = t, o = new un(e, {
            ...n,
            [pb]: !0
        });
        if (o._roots = s, n.setIndex) {
            let a = e.getIndex();
            if (a === null) {
                let l = new Be(t.index, 1, !1);
                e.setIndex(l);
            } else a.array !== i && (a.array.set(i), a.needsUpdate = !0);
        }
        return o;
    }
    constructor(t, e = {}){
        if (t.isBufferGeometry) {
            if (t.index && t.index.isInterleavedBufferAttribute) throw new Error("MeshBVH: InterleavedBufferAttribute is not supported for the index attribute.");
        } else throw new Error("MeshBVH: Only BufferGeometries are supported.");
        if (e = Object.assign({
            strategy: 0,
            maxDepth: 40,
            maxLeafTris: 10,
            verbose: !0,
            useSharedArrayBuffer: !1,
            setBoundingBox: !0,
            onProgress: null,
            [pb]: !1
        }, e), e.useSharedArrayBuffer && typeof SharedArrayBuffer > "u") throw new Error("MeshBVH: SharedArrayBuffer is not available.");
        this._roots = null, e[pb] || (this._roots = zE(t, e), !t.boundingBox && e.setBoundingBox && (t.boundingBox = this.getBoundingBox(new Mt))), this.geometry = t;
    }
    refit(t = null) {
        t && Array.isArray(t) && (t = new Set(t));
        let e = this.geometry, n = e.index.array, i = e.attributes.position, s = i.array, o = i.offset || 0, a = 3;
        i.isInterleavedBufferAttribute && (a = i.data.stride);
        let l, u, c, d, h = 0, f = this._roots;
        for(let p = 0, g = f.length; p < g; p++)l = f[p], u = new Uint32Array(l), c = new Uint16Array(l), d = new Float32Array(l), m(0, h), h += l.byteLength;
        function m(p, g, y = !1) {
            let v = p * 2;
            if (c[v + 15] === 65535) {
                let w = u[p + 6], S = c[v + 14], _ = 1 / 0, M = 1 / 0, b = 1 / 0, T = -1 / 0, E = -1 / 0, P = -1 / 0;
                for(let D = 3 * w, C = 3 * (w + S); D < C; D++){
                    let O = n[D] * a + o, B = s[O + 0], V = s[O + 1], Y = s[O + 2];
                    B < _ && (_ = B), B > T && (T = B), V < M && (M = V), V > E && (E = V), Y < b && (b = Y), Y > P && (P = Y);
                }
                return d[p + 0] !== _ || d[p + 1] !== M || d[p + 2] !== b || d[p + 3] !== T || d[p + 4] !== E || d[p + 5] !== P ? (d[p + 0] = _, d[p + 1] = M, d[p + 2] = b, d[p + 3] = T, d[p + 4] = E, d[p + 5] = P, !0) : !1;
            } else {
                let w = p + 8, S = u[p + 6], _ = w + g, M = S + g, b = y, T = !1, E = !1;
                t ? b || (T = t.has(_), E = t.has(M), b = !T && !E) : (T = !0, E = !0);
                let P = b || T, D = b || E, C = !1;
                P && (C = m(w, g, b));
                let O = !1;
                D && (O = m(S, g, b));
                let B = C || O;
                if (B) for(let V = 0; V < 3; V++){
                    let Y = w + V, W = S + V, q = d[Y], j = d[Y + 3], X = d[W], L = d[W + 3];
                    d[p + V] = q < X ? q : X, d[p + V + 3] = j > L ? j : L;
                }
                return B;
            }
        }
    }
    traverse(t, e = 0) {
        let n = this._roots[e], i = new Uint32Array(n), s = new Uint16Array(n);
        o(0);
        function o(a, l = 0) {
            let u = a * 2, c = s[u + 15] === 65535;
            if (c) {
                let d = i[a + 6], h = s[u + 14];
                t(l, c, new Float32Array(n, a * 4, 6), d, h);
            } else {
                let d = a + 8, h = i[a + 6], f = i[a + 7];
                t(l, c, new Float32Array(n, a * 4, 6), f) || (o(d, l + 1), o(h, l + 1));
            }
        }
    }
    raycast(t, e = si) {
        let n = this._roots, i = this.geometry, s = [], o = e.isMaterial, a = Array.isArray(e), l = i.groups, u = o ? e.side : e;
        for(let c = 0, d = n.length; c < d; c++){
            let h = a ? e[l[c].materialIndex].side : u, f = s.length;
            if (Pu(n[c]), Mg(0, i, h, t, s), Jh(), a) {
                let m = l[c].materialIndex;
                for(let p = f, g = s.length; p < g; p++)s[p].face.materialIndex = m;
            }
        }
        return s;
    }
    raycastFirst(t, e = si) {
        let n = this._roots, i = this.geometry, s = e.isMaterial, o = Array.isArray(e), a = null, l = i.groups, u = s ? e.side : e;
        for(let c = 0, d = n.length; c < d; c++){
            let h = o ? e[l[c].materialIndex].side : u;
            Pu(n[c]);
            let f = Tg(0, i, h, t);
            Jh(), f != null && (a == null || f.distance < a.distance) && (a = f, o && (f.face.materialIndex = l[c].materialIndex));
        }
        return a;
    }
    intersectsGeometry(t, e) {
        let n = this.geometry, i = !1;
        for (let s of this._roots)if (Pu(s), i = KE(0, n, t, e), Jh(), i) break;
        return i;
    }
    shapecast(t, e, n) {
        let i = this.geometry;
        if (t instanceof Function) {
            if (e) {
                let h = e;
                e = (f, m, p, g)=>{
                    let y = m * 3;
                    return h(f, y, y + 1, y + 2, p, g);
                };
            }
            t = {
                boundsTraverseOrder: n,
                intersectsBounds: t,
                intersectsTriangle: e,
                intersectsRange: null
            }, console.warn("MeshBVH: Shapecast function signature has changed and now takes an object of callbacks as a second argument. See docs for new signature.");
        }
        let s = Ts.getPrimitive(), { boundsTraverseOrder: o , intersectsBounds: a , intersectsRange: l , intersectsTriangle: u  } = t;
        if (l && u) {
            let h = l;
            l = (f, m, p, g, y)=>h(f, m, p, g, y) ? !0 : hb(f, m, i, u, p, g, s);
        } else l || (u ? l = (h, f, m, p)=>hb(h, f, i, u, m, p, s) : l = (h, f, m)=>m);
        let c = !1, d = 0;
        for (let h of this._roots){
            if (Pu(h), c = QE(0, i, a, l, o, d), Jh(), c) break;
            d += h.byteLength;
        }
        return Ts.releasePrimitive(s), c;
    }
    bvhcast(t, e, n) {
        let { intersectsRanges: i , intersectsTriangles: s  } = n, o = this.geometry.index, a = this.geometry.attributes.position, l = t.geometry.index, u = t.geometry.attributes.position;
        Du.copy(e).invert();
        let c = Ts.getPrimitive(), d = Ts.getPrimitive();
        if (s) {
            let f = function(m, p, g, y, v, x, w, S) {
                for(let _ = g, M = g + y; _ < M; _++){
                    Ai(d, _ * 3, l, u), d.a.applyMatrix4(e), d.b.applyMatrix4(e), d.c.applyMatrix4(e), d.needsUpdate = !0;
                    for(let b = m, T = m + p; b < T; b++)if (Ai(c, b * 3, o, a), c.needsUpdate = !0, s(c, d, b, _, v, x, w, S)) return !0;
                }
                return !1;
            };
            if (i) {
                let m = i;
                i = function(p, g, y, v, x, w, S, _) {
                    return m(p, g, y, v, x, w, S, _) ? !0 : f(p, g, y, v, x, w, S, _);
                };
            } else i = f;
        }
        t.getBoundingBox(gb), gb.applyMatrix4(e);
        let h = this.shapecast({
            intersectsBounds: (f)=>gb.intersectsBox(f),
            intersectsRange: (f, m, p, g, y, v)=>(mb.copy(v), mb.applyMatrix4(Du), t.shapecast({
                    intersectsBounds: (x)=>mb.intersectsBox(x),
                    intersectsRange: (x, w, S, _, M)=>i(f, m, x, w, g, y, _, M)
                }))
        });
        return Ts.releasePrimitive(c), Ts.releasePrimitive(d), h;
    }
    intersectsBox(t, e) {
        return xl.set(t.min, t.max, e), xl.needsUpdate = !0, this.shapecast({
            intersectsBounds: (n)=>xl.intersectsBox(n),
            intersectsTriangle: (n)=>xl.intersectsTriangle(n)
        });
    }
    intersectsSphere(t) {
        return this.shapecast({
            intersectsBounds: (e)=>t.intersectsBox(e),
            intersectsTriangle: (e)=>e.intersectsSphere(t)
        });
    }
    closestPointToGeometry(t, e, n = {}, i = {}, s = 0, o = 1 / 0) {
        t.boundingBox || t.computeBoundingBox(), xl.set(t.boundingBox.min, t.boundingBox.max, e), xl.needsUpdate = !0;
        let a = this.geometry, l = a.attributes.position, u = a.index, c = t.attributes.position, d = t.index, h = Ts.getPrimitive(), f = Ts.getPrimitive(), m = Cg, p = a5, g = null, y = null;
        i && (g = l5, y = c5);
        let v = 1 / 0, x = null, w = null;
        return Du.copy(e).invert(), $h.matrix.copy(Du), this.shapecast({
            boundsTraverseOrder: (S)=>xl.distanceToBox(S),
            intersectsBounds: (S, _, M)=>M < v && M < o ? (_ && ($h.min.copy(S.min), $h.max.copy(S.max), $h.needsUpdate = !0), !0) : !1,
            intersectsRange: (S, _)=>{
                if (t.boundsTree) return t.boundsTree.shapecast({
                    boundsTraverseOrder: (M)=>$h.distanceToBox(M),
                    intersectsBounds: (M, b, T)=>T < v && T < o,
                    intersectsRange: (M, b)=>{
                        for(let T = M * 3, E = (M + b) * 3; T < E; T += 3){
                            Ai(f, T, d, c), f.a.applyMatrix4(e), f.b.applyMatrix4(e), f.c.applyMatrix4(e), f.needsUpdate = !0;
                            for(let P = S * 3, D = (S + _) * 3; P < D; P += 3){
                                Ai(h, P, u, l), h.needsUpdate = !0;
                                let C = h.distanceToTriangle(f, m, g);
                                if (C < v && (p.copy(m), y && y.copy(g), v = C, x = P / 3, w = T / 3), C < s) return !0;
                            }
                        }
                    }
                });
                {
                    let M = d ? d.count : c.count;
                    for(let b = 0, T = M; b < T; b += 3){
                        Ai(f, b, d, c), f.a.applyMatrix4(e), f.b.applyMatrix4(e), f.c.applyMatrix4(e), f.needsUpdate = !0;
                        for(let E = S * 3, P = (S + _) * 3; E < P; E += 3){
                            Ai(h, E, u, l), h.needsUpdate = !0;
                            let D = h.distanceToTriangle(f, m, g);
                            if (D < v && (p.copy(m), y && y.copy(g), v = D, x = E / 3, w = b / 3), D < s) return !0;
                        }
                    }
                }
            }
        }), Ts.releasePrimitive(h), Ts.releasePrimitive(f), v === 1 / 0 ? null : (n.point ? n.point.copy(p) : n.point = p.clone(), n.distance = v, n.faceIndex = x, i && (i.point ? i.point.copy(y) : i.point = y.clone(), i.point.applyMatrix4(Du), p.applyMatrix4(Du), i.distance = p.sub(i.point).length(), i.faceIndex = w), n);
    }
    closestPointToPoint(t, e = {}, n = 0, i = 1 / 0) {
        let s = n * n, o = i * i, a = 1 / 0, l = null;
        if (this.shapecast({
            boundsTraverseOrder: (c)=>(ef.copy(t).clamp(c.min, c.max), ef.distanceToSquared(t)),
            intersectsBounds: (c, d, h)=>h < a && h < o,
            intersectsTriangle: (c, d)=>{
                c.closestPointToPoint(t, ef);
                let h = t.distanceToSquared(ef);
                return h < a && (Cg.copy(ef), a = h, l = d), h < s;
            }
        }), a === 1 / 0) return null;
        let u = Math.sqrt(a);
        return e.point ? e.point.copy(Cg) : e.point = Cg.clone(), e.distance = u, e.faceIndex = l, e;
    }
    getBoundingBox(t) {
        return t.makeEmpty(), this._roots.forEach((n)=>{
            Si(0, new Float32Array(n), ZE), t.union(ZE);
        }), t;
    }
}, JE = un.prototype.raycast;
un.prototype.raycast = function(...r1) {
    if (r1[0].isMesh) {
        console.warn('MeshBVH: The function signature and results frame for "raycast" has changed. See docs for new signature.');
        let [t, e, n, i] = r1;
        return JE.call(this, n, t.material).forEach((o)=>{
            o = db(o, t, e), o && i.push(o);
        }), i;
    } else return JE.apply(this, r1);
};
var $E = un.prototype.raycastFirst;
un.prototype.raycastFirst = function(...r1) {
    if (r1[0].isMesh) {
        console.warn('MeshBVH: The function signature and results frame for "raycastFirst" has changed. See docs for new signature.');
        let [t, e, n] = r1;
        return db($E.call(this, n, t.material), t, e);
    } else return $E.apply(this, r1);
};
var eC = un.prototype.closestPointToPoint;
un.prototype.closestPointToPoint = function(...r1) {
    if (r1[0].isMesh) {
        console.warn('MeshBVH: The function signature and results frame for "closestPointToPoint" has changed. See docs for new signature.'), r1.unshift();
        let t = r1[1], e = {};
        return r1[1] = e, eC.apply(this, r1), t && t.copy(e.point), e.distance;
    } else return eC.apply(this, r1);
};
var tC = un.prototype.closestPointToGeometry;
un.prototype.closestPointToGeometry = function(...r1) {
    let t = r1[2], e = r1[3];
    if (t && t.isVector3 || e && e.isVector3) {
        console.warn('MeshBVH: The function signature and results frame for "closestPointToGeometry" has changed. See docs for new signature.');
        let n = {}, i = {}, s = r1[1];
        return r1[2] = n, r1[3] = i, tC.apply(this, r1), t && t.copy(n.point), e && e.copy(i.point).applyMatrix4(s), n.distance;
    } else return tC.apply(this, r1);
};
var nC = un.prototype.refit;
un.prototype.refit = function(...r1) {
    let t = r1[0], e = r1[1];
    if (e && (e instanceof Set || Array.isArray(e))) {
        console.warn('MeshBVH: The function signature for "refit" has changed. See docs for new signature.');
        let n = new Set;
        e.forEach((i)=>n.add(i)), t && t.forEach((i)=>n.add(i)), nC.call(this, n);
    } else nC.apply(this, r1);
};
[
    "intersectsGeometry",
    "shapecast",
    "intersectsBox",
    "intersectsSphere"
].forEach((r1)=>{
    let t = un.prototype[r1];
    un.prototype[r1] = function(...e) {
        return (e[0] === null || e[0].isMesh) && (e.shift(), console.warn(`MeshBVH: The function signature for "${r1}" has changed and no longer takes Mesh. See docs for new signature.`)), t.apply(this, e);
    };
});
var bd = Jd(iC());
var u5 = .5 * (Math.sqrt(3) - 1), tf = (3 - Math.sqrt(3)) / 6, d5 = 1 / 3, Es = 1 / 6, Nse = (Math.sqrt(5) - 1) / 4, Bse = (5 - Math.sqrt(5)) / 20, nf = (r1)=>Math.floor(r1) | 0, sC = new Float64Array([
    1,
    1,
    -1,
    1,
    1,
    -1,
    -1,
    -1,
    1,
    0,
    -1,
    0,
    1,
    0,
    -1,
    0,
    0,
    1,
    0,
    -1,
    0,
    1,
    0,
    -1
]), vb = new Float64Array([
    1,
    1,
    0,
    -1,
    1,
    0,
    1,
    -1,
    0,
    -1,
    -1,
    0,
    1,
    0,
    1,
    -1,
    0,
    1,
    1,
    0,
    -1,
    -1,
    0,
    -1,
    0,
    1,
    1,
    0,
    -1,
    1,
    0,
    1,
    -1,
    0,
    -1,
    -1
]);
function Pg(r1 = Math.random) {
    let t = aC(r1), e = new Float64Array(t).map((i)=>sC[i % 12 * 2]), n = new Float64Array(t).map((i)=>sC[i % 12 * 2 + 1]);
    return function(s, o) {
        let a = 0, l = 0, u = 0, c = (s + o) * u5, d = nf(s + c), h = nf(o + c), f = (d + h) * tf, m = d - f, p = h - f, g = s - m, y = o - p, v, x;
        g > y ? (v = 1, x = 0) : (v = 0, x = 1);
        let w = g - v + tf, S = y - x + tf, _ = g - 1 + 2 * tf, M = y - 1 + 2 * tf, b = d & 255, T = h & 255, E = .5 - g * g - y * y;
        if (E >= 0) {
            let C = b + t[T], O = e[C], B = n[C];
            E *= E, a = E * E * (O * g + B * y);
        }
        let P = .5 - w * w - S * S;
        if (P >= 0) {
            let C = b + v + t[T + x], O = e[C], B = n[C];
            P *= P, l = P * P * (O * w + B * S);
        }
        let D = .5 - _ * _ - M * M;
        if (D >= 0) {
            let C = b + 1 + t[T + 1], O = e[C], B = n[C];
            D *= D, u = D * D * (O * _ + B * M);
        }
        return 70 * (a + l + u);
    };
}
function oC(r1 = Math.random) {
    let t = aC(r1), e = new Float64Array(t).map((s)=>vb[s % 12 * 3]), n = new Float64Array(t).map((s)=>vb[s % 12 * 3 + 1]), i = new Float64Array(t).map((s)=>vb[s % 12 * 3 + 2]);
    return function(o, a, l) {
        let u, c, d, h, f = (o + a + l) * d5, m = nf(o + f), p = nf(a + f), g = nf(l + f), y = (m + p + g) * Es, v = m - y, x = p - y, w = g - y, S = o - v, _ = a - x, M = l - w, b, T, E, P, D, C;
        S >= _ ? _ >= M ? (b = 1, T = 0, E = 0, P = 1, D = 1, C = 0) : S >= M ? (b = 1, T = 0, E = 0, P = 1, D = 0, C = 1) : (b = 0, T = 0, E = 1, P = 1, D = 0, C = 1) : _ < M ? (b = 0, T = 0, E = 1, P = 0, D = 1, C = 1) : S < M ? (b = 0, T = 1, E = 0, P = 0, D = 1, C = 1) : (b = 0, T = 1, E = 0, P = 1, D = 1, C = 0);
        let O = S - b + Es, B = _ - T + Es, V = M - E + Es, Y = S - P + 2 * Es, W = _ - D + 2 * Es, q = M - C + 2 * Es, j = S - 1 + 3 * Es, X = _ - 1 + 3 * Es, L = M - 1 + 3 * Es, U = m & 255, G = p & 255, H = g & 255, z = .6 - S * S - _ * _ - M * M;
        if (z < 0) u = 0;
        else {
            let k = U + t[G + t[H]];
            z *= z, u = z * z * (e[k] * S + n[k] * _ + i[k] * M);
        }
        let re = .6 - O * O - B * B - V * V;
        if (re < 0) c = 0;
        else {
            let k = U + b + t[G + T + t[H + E]];
            re *= re, c = re * re * (e[k] * O + n[k] * B + i[k] * V);
        }
        let K = .6 - Y * Y - W * W - q * q;
        if (K < 0) d = 0;
        else {
            let k = U + P + t[G + D + t[H + C]];
            K *= K, d = K * K * (e[k] * Y + n[k] * W + i[k] * q);
        }
        let Z = .6 - j * j - X * X - L * L;
        if (Z < 0) h = 0;
        else {
            let k = U + 1 + t[G + 1 + t[H + 1]];
            Z *= Z, h = Z * Z * (e[k] * j + n[k] * X + i[k] * L);
        }
        return 32 * (u + c + d + h);
    };
}
function aC(r1) {
    let e = new Uint8Array(512);
    for(let n = 0; n < 256; n++)e[n] = n;
    for(let n = 0; n < 255; n++){
        let i = n + ~~(r1() * (256 - n)), s = e[n];
        e[n] = e[i], e[i] = s;
    }
    for(let n = 256; n < 512; n++)e[n] = e[n - 256];
    return e;
}
var Yi = new an, Dg = class {
    constructor(t){
        this.weightAttribute = null;
        let e = t.geometry;
        if (!e.isBufferGeometry || e.attributes.position.itemSize !== 3) throw new Error("THREE.MeshSurfaceSampler: Requires BufferGeometry triangle mesh.");
        e.index && (e = e.toNonIndexed()), this.geometry = e, this.randomFunction = Math.random, this.positionAttribute = this.geometry.getAttribute("position"), this.distribution = null;
    }
    build() {
        let t = this.positionAttribute, e = new Float32Array(t.count / 3);
        for(let i = 0; i < t.count; i += 3){
            let s = 1;
            Yi.a.fromBufferAttribute(t, i), Yi.b.fromBufferAttribute(t, i + 1), Yi.c.fromBufferAttribute(t, i + 2), s *= Yi.getArea(), e[i / 3] = s;
        }
        this.distribution = new Float32Array(t.count / 3);
        let n = 0;
        for(let i = 0; i < e.length; i++)n += e[i], this.distribution[i] = n;
        return this;
    }
    setRandomGenerator(t) {
        return this.randomFunction = t, this;
    }
    sample(t, e) {
        if (this.distribution) {
            let n = this.distribution[this.distribution.length - 1], i = this.binarySearch(this.randomFunction() * n);
            return this.sampleFace(i, t, e);
        }
    }
    binarySearch(t) {
        if (!this.distribution) return 0;
        let e = this.distribution, n = 0, i = e.length - 1, s = -1;
        for(; n <= i;){
            let o = Math.ceil((n + i) / 2);
            if (o === 0 || e[o - 1] <= t && e[o] > t) {
                s = o;
                break;
            } else t < e[o] ? i = o - 1 : n = o + 1;
        }
        return s;
    }
    sampleFace(t, e, n) {
        let i = this.randomFunction(), s = this.randomFunction();
        return i + s > 1 && (i = 1 - i, s = 1 - s), Yi.a.fromBufferAttribute(this.positionAttribute, t * 3), Yi.b.fromBufferAttribute(this.positionAttribute, t * 3 + 1), Yi.c.fromBufferAttribute(this.positionAttribute, t * 3 + 2), e.set(0, 0, 0).addScaledVector(Yi.a, i).addScaledVector(Yi.b, s).addScaledVector(Yi.c, 1 - (i + s)), Yi.getNormal(n), this;
    }
};
var cC = Jd(xb()), h5 = new ae, f5 = new ae, p5 = new ae, rf;
((t)=>{
    function r1(e) {
        return e && e.__isSPEObject;
    }
    t.is = r1;
})(rf || (rf = {}));
var Iu = (r1)=>class extends r1 {
        constructor(){
            super(...arguments);
            this.previousModelViewMatrix = new ae;
            this.copyPreviousMatrix = !0;
            this.hiddenMatrix = new ae;
            this.matrixWorldRigid = new ae;
            this.shearScale = new ae;
            this.shearScaleInv = new ae;
        }
        get __isSPEObject() {
            return !0;
        }
        isDescendantOf(n) {
            n instanceof pt && (n = n.uuid);
            let i = this;
            for(; i.parent;){
                if (i.parent.uuid === n) return !0;
                i = i.parent;
            }
            return !1;
        }
        updateMatrixWorld(n) {
            this.matrixAutoUpdate && this.updateMatrix(), (this.matrixWorldNeedsUpdate || n) && (this.parent === null ? this.matrixWorld.multiplyMatrices(this.hiddenMatrix, this.matrix) : (this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.hiddenMatrix), this.matrixWorld.multiplyMatrices(this.matrixWorld, this.matrix)), this.matrixWorldNeedsUpdate = !1, n = !0);
            for (let i of this.children)i.updateMatrixWorld(n);
        }
        updateWorldMatrix(n, i) {
            let s = this.parent;
            if (n && s !== null && s.updateWorldMatrix(!0, !1), this.matrixAutoUpdate && this.updateMatrix(), this.parent === null ? this.matrixWorld.multiplyMatrices(this.hiddenMatrix, this.matrix) : (this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.hiddenMatrix), this.matrixWorld.multiplyMatrices(this.matrixWorld, this.matrix)), i) for (let o of this.children)o.updateWorldMatrix(!1, !0);
        }
        traverseObject(n, i = 0) {
            if (n(this, i) !== !0) for (let o of this.children)rf.is(o) && o.traverseObject(n, i + 1);
        }
        updateMatrixWorldSVD() {
            let n = this.matrixWorld.elements, i = [
                [
                    n[0],
                    n[4],
                    n[8]
                ],
                [
                    n[1],
                    n[5],
                    n[9]
                ],
                [
                    n[2],
                    n[6],
                    n[10]
                ]
            ], { u: s , v: o , q: a  } = (0, cC.SVD)(i), l = h5.set(s[0][0], s[0][1], s[0][2], 0, s[1][0], s[1][1], s[1][2], 0, s[2][0], s[2][1], s[2][2], 0, 0, 0, 0, 1), u = f5.set(o[0][0], o[0][1], o[0][2], 0, o[1][0], o[1][1], o[1][2], 0, o[2][0], o[2][1], o[2][2], 0, 0, 0, 0, 1), c = p5.copy(u).transpose();
            this.shearScale.makeScale(a[0], a[1], a[2]).multiply(c).premultiply(u), this.shearScaleInv.copy(this.shearScale).invert(), this.matrixWorldRigid.multiplyMatrices(l, c).copyPosition(this.matrixWorld), a.every((d)=>Math.abs(a[0] - d) < .01) ? this.hasNonUniformScale = !1 : this.hasNonUniformScale = !0;
        }
        attach(n, i) {
            this.updateWorldMatrix(!0, !1);
            let s = new ae().copy(this.matrixWorld).invert();
            return n.parent !== null && (n.parent.updateWorldMatrix(!0, !1), s.multiply(n.parent.matrixWorld)), "hiddenMatrix" in n && n.hiddenMatrix instanceof ae ? n.hiddenMatrix.premultiply(s) : n.applyMatrix4(s), n.updateWorldMatrix(!1, !1), this.add(n), i !== void 0 && (this.children.pop(), this.children.splice(i, 0, n)), this;
        }
        copy(n, i = !1) {
            return super.copy(n, i), this.hasNonUniformScale = n.hasNonUniformScale, this;
        }
        onAfterRender(n, i, s, o, a, l) {
            this.copyPreviousMatrix && this.previousModelViewMatrix.copy(this.modelViewMatrix);
        }
    };
var bb = class extends Iu(pt) {
}, m5 = (r1)=>r1.type === "Mesh", dn = class extends bb {
    constructor(e){
        super();
        this.object = e;
        this.matrixAutoUpdate = !1, this.hasNonUniformScale = e.hasNonUniformScale;
    }
    raycast(e, n) {}
    expand() {
        let e = 0, n = this.object.entityChildren(e);
        for(; n;){
            let i = this.children[e];
            i?.object !== n && (i && this.remove(i), i = new dn(n), this.add(i), this.children.splice(e, 0, this.children.pop()), i.matrixWorldNeedsUpdate = !0, i.matrixAutoUpdate = !1, i.matrix = n.matrix, i.hiddenMatrix = n.hiddenMatrix), i.expand(), e += 1, n = this.object.entityChildren(e);
        }
        for(; this.children.length > e;)this.remove(this.children[e]);
    }
    get visible() {
        return this.playModeVisible !== void 0 ? this.playModeVisible : this.object.visible || this.object.dataPatched.visible && this.object.dataPatched.cloner?.hideBase === !0;
    }
    set visible(e) {}
    get castShadow() {
        return this.object.castShadow;
    }
    set castShadow(e) {}
    get receiveShadow() {
        return this.object.receiveShadow;
    }
    set receiveShadow(e) {}
    get isMesh() {
        return m5(this.object);
    }
    get isLight() {
        return this.object.isLight;
    }
    get layers() {
        return this.object.layers;
    }
    set layers(e) {}
    get isCamera() {
        return !1;
    }
    get geometry() {
        if (this.object.geometry) return this.object.geometry;
    }
    get material() {
        if (this.object.material) return this.object.material;
    }
};
var bl = new A, wl = new A, Ou = new ae, dC = [
    new A(-1, 1, 1),
    new A(-1, -1, 1),
    new A(1, -1, 1),
    new A(1, 1, 1),
    new A(-1, 1, -1),
    new A(-1, -1, -1),
    new A(1, -1, -1),
    new A(1, 1, -1)
], g5 = [
    [
        0,
        3
    ],
    [
        1,
        2
    ],
    [
        5,
        6
    ],
    [
        4,
        7
    ],
    [
        0,
        1
    ],
    [
        3,
        2
    ],
    [
        7,
        6
    ],
    [
        4,
        5
    ],
    [
        0,
        4
    ],
    [
        1,
        5
    ],
    [
        2,
        6
    ],
    [
        3,
        7
    ]
], y5 = [
    [
        0,
        2
    ],
    [
        7,
        5
    ],
    [
        4,
        1
    ],
    [
        3,
        6
    ],
    [
        4,
        3
    ],
    [
        1,
        6
    ]
], uC = (r1, t, e)=>{
    r1.updateEntityBoxSize(bl, wl), Ou.copy(t).multiply(r1.matrixWorld), wl.x === 0 && wl.y === 0 && wl.z === 0 ? e.push(new A(bl.x, bl.y, bl.z).applyMatrix4(Ou)) : dC.forEach((n)=>{
        e.push(n.clone().multiply(wl).add(bl).applyMatrix4(Ou));
    });
}, sf = class extends Mt {
    constructor(){
        super(...arguments);
        this.matrix = new ae;
        this.vertices = [];
        this.faces = [];
        this.edges = [];
        this.centerEdges = [];
    }
    copy(e) {
        return super.copy(e), this.matrix.copy(e.matrix), this.vertices = e.vertices.map((n)=>n.clone()), this.faces = e.faces.map((n)=>n.clone()), this.edges = e.edges.map((n)=>n.clone()), this.centerEdges = e.centerEdges.map((n)=>n.clone()), this;
    }
    setFromObjectSize(e, n = !1) {
        e.updateWorldMatrix(!1, n), this.makeEmpty(), this.matrix.copy(e.matrixWorld);
        let i = new ae().copy(e.matrixWorld).invert();
        return this.expandByObjectSize(e, i, n);
    }
    expandByObjectSize(e, n, i = !1) {
        let s = [];
        return i === !0 ? e.traverseEntity((o)=>{
            if (o.visible || o.cloner && o.data.visible) {
                if (!("geometry" in o)) {
                    s.push(new A);
                    return;
                }
                uC(o, n, s);
            }
        }) : uC(e, n, s), this.setFromPoints(s);
    }
    getCenter(e) {
        return e = super.getCenter(e), e.applyMatrix4(this.matrix), e;
    }
    getPositionToCenter(e) {
        return e = super.getCenter(e), e.applyMatrix4(Ou.copy(this.matrix).setPosition(0, 0, 0)), e;
    }
    computeVertices() {
        this.getSize(wl).multiplyScalar(.5), this.getCenter(bl), Ou.copy(this.matrix).setPosition(bl), this.vertices = dC.map((e)=>e.clone().multiply(wl).applyMatrix4(Ou));
    }
    computeEdges() {
        this.vertices.length > 0 && this.computeVertices(), this.edges = g5.map(([e, n])=>new Hn(this.vertices[e], this.vertices[n])), this.centerEdges = this.edges.map((e)=>e.getCenter(new A));
    }
    computeFaces() {
        this.vertices.length > 0 && this.computeVertices(), this.faces = y5.map(([e, n])=>this.vertices[e].clone().add(this.vertices[n]).multiplyScalar(.5));
    }
};
var Qi = {
    Cloner: ()=>{},
    changeEntityProptotype: ()=>{},
    createEntity: ()=>{}
};
var Sb = class extends bh {
    constructor(){
        super();
    }
    getPoints(t = 12) {
        let e = [], n, i = this.getCurveLengths(), o = i[i.length - 1] / i.length;
        for(let a = 0, l = this.curves; a < l.length; a++){
            let u = l[a], c = a === 0 ? i[a] : i[a] - i[a - 1], d = Math.ceil(t * c / o), h = u.getPoints(d);
            for(let f = 0; f < h.length; f++){
                let m = h[f];
                n && n.equals(m) || (e.push(m), n = m);
            }
        }
        return this.autoClose && e.length > 1 && !e[e.length - 1].equals(e[0]) && e.push(e[0]), e;
    }
};
var Ab = .001;
function _b(r1, t, e) {
    return t.clone().sub(r1).cross(t.clone().sub(e)).length() <= Ab;
}
function wb(r1, t) {
    let e = new A(...r1.position), n = new A(...r1.controlNext.position), i = new A(...t.controlPrevious.position), s = new A(...t.position);
    return _b(e, n, s) && _b(e, i, s);
}
function Og(r1) {
    let t = r1.points.map((c)=>new A(...c.data.position)), e = [
        r1.points[0]
    ], n = new A(...e[0].data.position);
    for(let c = 0; c < r1.points.length - 1; c++)_b(n, t[c], t[c + 1]) || (e.push(r1.points[c]), n = t[c]);
    e.push(r1.points[r1.points.length - 1]);
    let i = r1.isClosed, s = e.length - (i ? 0 : 1), o = e.length, a = [];
    for(let c = 0; c < o; c++){
        let d = e[c].data, h = new A(...d.position), f = new A(...d.controlPrevious.position), m = new A(...d.controlNext.position), p = {
            position: h,
            baseRoundness: d.roundness,
            controlPrevious: f,
            controlNext: m
        };
        if (d.roundness === 0 || !r1.isClosed && (c === 0 || c === o - 1)) {
            a[c] = {
                ...p,
                removedLength: 0
            };
            continue;
        }
        let g = i && c == 0 ? o - 1 : c - 1, y = i && c == o - 1 ? 0 : c + 1, v = e[g].data, x = e[y].data, w = new A(...v.position), S = new A(...x.position), _ = w.clone().sub(h).normalize(), M = S.clone().sub(h).normalize();
        Object.assign(p, {
            prevDir: _,
            nextDir: M
        });
        let b = wb(v, d), T = wb(d, x);
        if (!b || !T) a[c] = {
            ...p,
            removedLength: 0
        };
        else {
            let E = _.clone().add(M).normalize(), P = E.clone().cross(_).length() / _.dot(E);
            a[c] = {
                ...p,
                tan: P,
                removedLength: d.roundness / P
            };
        }
    }
    for(let c = 0; c < s; c++){
        let d = c, h = i && c === o - 1 ? 0 : c + 1, f = a[d], m = a[h];
        if (f.removedLength !== 0 || m.removedLength !== 0) {
            let p = f.position.distanceTo(m.position);
            f.removedLength = Math.min(f.removedLength, p / 2), m.removedLength = Math.min(m.removedLength, p / 2);
        }
    }
    let l = [];
    for(let c = 0; c < s; c++){
        let d = c, h = i && c === o - 1 ? 0 : c + 1, f = a[d], m = a[h], p = null;
        if (!wb(e[d].data, e[h].data)) f.position.distanceTo(m.position) > Ab && (p = new Qa(f.position, f.controlNext, m.controlPrevious, m.position));
        else {
            let g = f.position.clone(), y = m.position.clone();
            (f.removedLength !== 0 || m.removedLength !== 0) && (f.nextDir && g.add(f.nextDir.clone().setLength(f.removedLength)), m.prevDir && y.add(m.prevDir.clone().setLength(m.removedLength))), g.distanceTo(y) > Ab && (p = new Qa(g, g.clone().lerp(y, .3), y.clone().lerp(g, .3), y));
        }
        l[2 * c + 1] = p;
    }
    for(let c = 0; c < o; c++){
        let d = a[c];
        if (d.removedLength === 0) {
            l[2 * c] = null;
            continue;
        }
        let h = d.position, f = d.prevDir.clone().multiplyScalar(d.removedLength).add(h), m = d.nextDir.clone().multiplyScalar(d.removedLength).add(h), p = d.tan * d.removedLength, g = d.prevDir.clone().add(d.nextDir).normalize(), y = f.clone().lerp(m, .5), v = f.distanceTo(m) / 2, x = g.clone().multiplyScalar(Math.sqrt(Math.pow(p, 2) - Math.pow(v, 2))).add(y), w = g.clone().multiplyScalar(-p).add(x), S = h.distanceTo(w) / h.distanceTo(y), _ = d.prevDir.clone().multiplyScalar(S * h.distanceTo(f)).add(h), M = _.clone().lerp(w, 2), b = f.clone().lerp(_, 4 / 3), T = m.clone().lerp(M, 4 / 3);
        l[2 * c] = new Qa(f, b, T, m);
    }
    let u = new Sb;
    return l.forEach((c)=>{
        c && u.add(c);
    }), u;
}
var St;
((t)=>{
    function r1(e) {
        return e && e.__isEntity;
    }
    t.is = r1;
})(St || (St = {}));
var So = (r1)=>St.is(r1), v5 = {
    type: "completeState",
    isfromEntity: !0
}, Rg = (r1)=>class extends Iu(r1) {
        constructor(){
            super(...arguments);
            this.raycastLock = !1;
            this.scaleLock = !1;
            this.disposed = !1;
            this.stateSelection = null;
            this.instances = [];
            this.prevState = null;
            this.currentState = null;
            this.reversibleToState = null;
            this.currentTransitionEvent = null;
            this.previousAction = null;
            this._singleBBox = new sf;
            this._recursiveBBox = new sf;
            this.singleBBoxNeedsUpdate = !0;
            this.recursiveBBoxNeedsUpdate = !0;
            this._needApplyPathSnapping = !0;
            this.attachedPaths = new Set;
        }
        get __isEntity() {
            return !0;
        }
        entityChildren(n) {
            let i = this.children[n];
            if (St.is(i)) return i;
        }
        get isConcreteEntity() {
            return typeof this.identity == "string";
        }
        get isVirtualEntity() {
            return typeof this.identity != "string";
        }
        get isInstanceRoot() {
            return this.isConcreteEntity && this.data.type === "Instance";
        }
        nearestInstanceSelfOrParent() {
            let n = this;
            for(; n.data.type !== "Instance";){
                let i = n.parent;
                if (St.is(i)) n = i;
                else return;
            }
            return n;
        }
        forInstancesRec(n) {
            this.instances.forEach((i)=>{
                i.disposed || n(i), i.forInstancesRec(n);
            });
        }
        super_Entity(n, i) {
            typeof n == "string" && (this.uuid = n), this.identity = n, this.data = i, this.matrixAutoUpdate = !1, this.dataPatched = this.data;
        }
        changeSelectedState(n, i, s = !1) {
            if (!(this.data.states.length === 0 && !s)) {
                for (let o of this.data.states)vo.toOps(this.data, o.data).forEach((l)=>{
                    let u = Vm.replaceProps(l, this.data);
                    this.dataPatched = this.data, this.updateByPatchedOp(u, this.data, i);
                });
                if (n !== null) {
                    let o = this.data.states.data(n);
                    o && (this.dataPatched = vo.patch(this.data, o), vo.toOps(this.data, o).forEach((l)=>{
                        this.updateByPatchedOp(l, this.dataPatched, i);
                    }));
                }
                s && this.updateTransformState(this.dataPatched), this.stateSelection = n, this.updatePathSnapping(this.dataPatched.pathSnapping);
            }
        }
        get singleBBox() {
            return this.singleBBoxNeedsUpdate && (this.singleBBoxNeedsUpdate = !1, this._singleBBox.setFromObjectSize(this, !1), this._singleBBox.computeVertices(), this._singleBBox.computeEdges(), this._singleBBox.computeFaces()), this._singleBBox;
        }
        get recursiveBBox() {
            return this.recursiveBBoxNeedsUpdate && (this.recursiveBBoxNeedsUpdate = !1, this._recursiveBBox.setFromObjectSize(this, !0), this._recursiveBBox.computeVertices(), this._recursiveBBox.computeEdges(), this._recursiveBBox.computeFaces()), this._recursiveBBox;
        }
        updateEntityBoxSize(n, i) {
            n.setScalar(0), i.setScalar(0);
        }
        resetBBoxNeedsUpdateSelf() {
            this.singleBBoxNeedsUpdate = !0, this.recursiveBBoxNeedsUpdate = !0;
        }
        resetBBoxNeedsUpdate() {
            this.resetBBoxNeedsUpdateSelf(), this.traverseAncestors((n)=>{
                So(n) && n.resetBBoxNeedsUpdateSelf();
            }), this.traverseEntity((n)=>{
                n.resetBBoxNeedsUpdateSelf();
            });
        }
        find(n) {
            let i;
            return this.traverseEntity((s)=>{
                s.uuid === n && (i = s);
            }), i;
        }
        traverseSortNextHelper() {
            let n = this.parent;
            if (n) {
                let i = n.children, s = i.indexOf(this) + 1;
                if (St.is(i[s])) return i[s];
                if (St.is(n)) return n.traverseSortNextHelper();
            }
        }
        sortNext() {
            let n = this.children;
            return this.children.length > 0 && St.is(this.children[0]) ? n[0] : this.traverseSortNextHelper();
        }
        goUp(n) {
            let i = this;
            for(; n > 0 && i !== null;)i = i.parent, n -= 1;
            return i;
        }
        hasAnccestorOrSelf(n) {
            return this === n || this.hasAnccestor(n);
        }
        hasAnccestor(n) {
            let i = this.parent;
            for(; i;){
                if (n === i) return !0;
                i = i.parent;
            }
            return !1;
        }
        countToAccestor(n) {
            let i = 0, s = this;
            for(; s !== n;){
                if (s === null) return -1;
                s = s.parent, i += 1;
            }
            return i;
        }
        forEachEntity(n) {
            for (let i of this.children)So(i) && n(i);
        }
        traverseEntityAncestors(n) {
            this.traverseAncestors((i)=>{
                St.is(i) && n(i);
            });
        }
        traverseEntity(n, i = 0) {
            if (n(this, i) !== !0) for (let o of this.children)So(o) && o.traverseEntity(n, i + 1);
        }
        traverseVisibleEntity(n) {
            n(this);
            for (let i of this.children)So(i) && i.visible && i.traverseVisibleEntity(n);
        }
        updateMatrix() {
            super.updateMatrix(), this.cloner && this.cloner.onObjUpdateMatrix(), this.dispatchEvent({
                type: "updateMatrix"
            });
        }
        copy(n, i = !1) {
            return super.copy(n, i), this.dataPatched = n.dataPatched, this.raycastLock = n.raycastLock, this.scaleLock = n.scaleLock, this.hiddenMatrix.copy(n.hiddenMatrix), this;
        }
        hasEntityChild() {
            return this.children.some((n)=>So(n));
        }
        isAncestorOf(n) {
            if (this.uuid === n) return !1;
            let i = !1;
            return this.traverseEntity((s)=>{
                s.uuid === n && (i = !0);
            }), i;
        }
        toObjectTransformState(n = []) {
            this.updateWorldMatrix(!0, !1);
            let i = {
                position: this.position.toArray(),
                rotation: [
                    this.rotation.x,
                    this.rotation.y,
                    this.rotation.z
                ],
                scale: this.scale.toArray(),
                hiddenMatrix: this.hiddenMatrix.toArray()
            };
            return $c(i, n);
        }
        updateTransformState(n) {
            let i = !1;
            return n.position && (this.position.fromArray(n.position), i = !0), n.rotation && (this.rotation.fromArray(n.rotation), i = !0), n.scale && (i = !0, this.scale.fromArray(n.scale)), n.hiddenMatrix !== void 0 && (i = !0, this.hiddenMatrix.fromArray(n.hiddenMatrix ?? aa.identity)), i && (this.updateMatrix(), this.resetBBoxNeedsUpdate(), this.invalidateClonerTransform(this), this.traverseEntityAncestors((s)=>{
                s.invalidateClonerTransform(this);
            })), n.position && n.rotation && n.scale && n.hiddenMatrix !== void 0 && this.updateWorldMatrix(!1, !0), i;
        }
        dispose() {
            this.disposed = !0, this.cloner && (this.cloner.removeFromParent(), this.cloner = void 0);
        }
        disposeChildrenRecursively() {
            for (let n of this.children)St.is(n) && n.disposeRecursively();
        }
        disposeRecursively() {
            this.dispose(), this.children.forEach((n)=>{
                St.is(n) && n.disposeRecursively();
            });
        }
        toState(n = []) {
            let i = {
                name: this.name,
                visible: this.visible,
                raycastLock: this.raycastLock,
                ...this.toObjectTransformState(n)
            };
            return $c(i, n);
        }
        updateByOp(n, i, s, o) {
            let a = this.data;
            this.data = i;
            let l = n, u = Wi(n.path, [
                "states",
                "*"
            ]);
            if (u !== null) {
                if (n.type === 0) {
                    let [c] = u;
                    if (this?.stateSelection === c) {
                        let d = {
                            ...n.props
                        };
                        if (Object.values(n.props).some((h)=>h === void 0)) {
                            let h = this.data;
                            if (h !== void 0) {
                                let f = Lr.zoom(h, n.path.slice(2));
                                if (f) for(let m in n.props)n.props[m] === void 0 && m in f && (d[m] = f[m]);
                            }
                        }
                        l = {
                            ...n,
                            props: d,
                            path: n.path.slice(2)
                        };
                    }
                }
            } else if (n.type === 0) {
                let c = this.stateSelection ? this.data.states.data(this.stateSelection) : void 0;
                if (c !== void 0) {
                    if (n.props.name !== void 0 && c.name) {
                        let { name: h , ...f } = c;
                        c = f;
                    }
                    if (n.props.material !== void 0 && "material" in c) {
                        let { material: h , ...f } = c;
                        c = f;
                    }
                    let d = Lr.removeOverridden(n.path, n.props, c);
                    l = {
                        ...n,
                        props: d
                    };
                }
            }
            if (this.updateByPatchedOpBase(l, vo.patch(this.data, this.stateSelection ? this.data.states.data(this.stateSelection) : void 0), s), Wi(n.path, [
                "overrides"
            ])) {
                let c = [], d = [
                    ...n.path
                ];
                for(c.push(d[1]), d.splice(0, 2); d.length > 0 && d[0] === "descendants";)c.push(d[1]), d.splice(0, 2);
                if (c[c.length - 1] === void 0) {
                    if (n.type === 0) for (let h of Object.keys(n.props)){
                        c[c.length - 1] = h;
                        let f = s.scene.findInstance([
                            this.uuid,
                            ...c
                        ]);
                        f && (f.overrideData = n.props[h], f.updateState(po.apply(f.component.data, f.overrideData), s));
                    }
                } else {
                    let h = s.scene.findInstance([
                        this.uuid,
                        ...c
                    ]);
                    if (h) {
                        let f = Lr.zoom(h.component.data, d);
                        if (n = {
                            ...n,
                            path: d
                        }, n.type === 0) {
                            let m = n.props;
                            if (f) for (let [p, g] of Object.entries(n.props))g === void 0 && (m === n.props && (m = {
                                ...n.props
                            }), m[p] = f[p]);
                            n = {
                                ...n,
                                props: m
                            };
                        }
                        h.overrideData = pu.resolve(i.overrides, c), h.updateByOp(n, gr.applySimple(h.data, n), s, !1);
                    }
                }
            } else if (this.instances.length > 0) {
                let c;
                if (n.path.length === 0 && n.type === 0) {
                    let d;
                    for (let h of ca.rootOverrideProps)h in n.props && (d === void 0 && (d = {}), d[h] = n.props[h]);
                    d && (c = {
                        ...n,
                        props: d
                    });
                } else for (let d of ca.rootOverrideProps)if (Wi(n.path, [
                    d
                ])) {
                    c = n;
                    break;
                }
                c !== void 0 && this.instances.forEach((d)=>{
                    if (d.isInstanceRoot) {
                        let h = po.filterOp(d.overrideData, c);
                        h && d.updateByOp(h, gr.applySimple(d.data, h), s, !0);
                    }
                }), this.instances.forEach((d)=>{
                    if (!d.isInstanceRoot) {
                        let h = po.filterOp(d.overrideData, n);
                        if (h) {
                            let f;
                            a === d.data && n === h ? f = i : f = gr.applySimple(d.data, h), d.updateByOp(h, f, s, !0);
                        }
                    }
                });
            }
        }
        updateByPatchedOpBase(n, i, s) {
            if (this.dataPatched = i, n.path.length === 0 && n.type === 0) n.props.type !== void 0 && !ji.is(n.props.type) && Qi.changeEntityProptotype(this, i, s);
            else if (n.path.length === 1 && n.path[0] === "geometry" && n.type === 0 && "type" in n.props) {
                Qi.changeEntityProptotype(this, i, s);
                for (let o of this.children)St.is(o) && o.updateVisible();
            }
            this.updateByPatchedOp(n, i, s);
        }
        updateByPatchedOp(n, i, s) {
            if (n.path.length === 0 && n.type === 0 && this.updateState(n.props, s), Wi(n.path, [
                "pathSnapping"
            ]) !== null && this.updatePathSnapping(i.pathSnapping), Wi(n.path, [
                "cloner"
            ]) !== null) {
                let o = gr.drop(n, 1);
                o.path.length === 0 && o.type === 0 && o.props.disabled === !0 ? this.setFromClonerState(null, s) : this.cloner ? this.cloner.updateState(i.cloner, s.scene) : (this.setFromClonerState(i.cloner, s), this.expandCloner(s.scene)), this.updateVisible();
            }
        }
        updatePathSnapping(n) {
            this._updatedPathSnapping = n, this._needApplyPathSnapping = !0;
        }
        get updatedPathSnapping() {
            return this._updatedPathSnapping;
        }
        applyPathSnapping(n) {
            let i = this._updatedPathSnapping?.pathId ?? this.dataPatched.pathSnapping.pathId, s = this._updatedPathSnapping?.slide ?? this.dataPatched.pathSnapping.slide ?? 0, o = this._updatedPathSnapping?.offset ?? this.dataPatched.pathSnapping.offset, a = this._updatedPathSnapping?.orientation ?? this.dataPatched.pathSnapping.orientation;
            if (i === null) return;
            let l = n.find(i);
            if (!l || this._needApplyPathSnapping === !1) return;
            this._needApplyPathSnapping = !1;
            let u = l.data, c = Og(u.geometry.path), d = (s + o) % 1;
            s + o === 1 && d === 0 && (d = 1);
            let h = c.getPointAt(d), f = this.parent ? this.parent?.matrixWorld : new ae;
            l.updateMatrixWorld();
            let m = new ae().multiplyMatrices(f.clone().invert(), l.matrixWorld);
            h.applyMatrix4(m);
            let p = {
                position: h.toArray(),
                rotation: u.rotation
            };
            if (a === "tangential") {
                let g = new ae().extractRotation(l.matrixWorld), y = c.getTangentAt(d).applyMatrix4(g).add(h), v = new ae().lookAt(h, y, new A(0, 1, 0)), x = new Wt().setFromRotationMatrix(v);
                p = {
                    ...p,
                    rotation: [
                        x.x,
                        x.y,
                        x.z
                    ]
                };
            }
            this.updateTransformState(p), this.traverseEntity((g)=>{
                g._cameraType && g.dispatchEvent(v5);
            });
        }
        updateVisible() {
            this.visible = this.dataPatched.visible && (!this.dataPatched.cloner || (this.dataPatched.cloner.disabled ?? !1) || this.dataPatched.cloner?.hideBase !== !0);
        }
        updateState_Entity(n, i) {
            n.name !== void 0 && (this.name = n.name), n.raycastLock !== void 0 && (this.raycastLock = n.raycastLock), n.visible !== void 0 && (this.updateVisible(), this.resetBBoxNeedsUpdate()), "cloner" in n && n.cloner !== void 0 && (this.setFromClonerState(n.cloner, i), this.updateVisible()), this.updateTransformState(n);
        }
        get attachedSurfaceCloners() {
            return this.children.filter((n)=>n instanceof Qi.Cloner && n.parameters.type === "toObject");
        }
        setFromClonerState(n, i) {
            this.disposed || (n === null || n.disabled ? (this.cloner && this.cloner.removeFromParent(), this.cloner = void 0) : this.cloner === void 0 ? (this.cloner = new Qi.Cloner(this, n), i.scene.addPendingExpandCloner(this)) : this.cloner.updateState(n, i.scene));
        }
        expandCloner(n) {
            !this.disposed && this.cloner && this.cloner.expandClones(n);
        }
        invalidateClonerTransform(n) {
            this.cloner && this.cloner.invalidateTransform(n);
        }
    };
var Lg = class {
    static create(r1) {
        return this.build(this.normalizeInputs(r1));
    }
    static normalizeInputs(r1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            radialSegments: 64,
            heightSegments: 1,
            openEnded: !1,
            thetaStart: 0,
            thetaLength: 360,
            cornerRadius: 8,
            cornerSegments: 8,
            hollow: 0
        }, r1.parameters), n = e.width / 2, i = e.radiusTop ?? n, s = e.radiusBottom ?? n;
        return i === s ? (i = n, s = n) : i > s ? (i = n, s = s * n / i) : (i = i * n / s, s = n), {
            parameters: Object.assign(e, {
                width: Math.abs(e.width),
                height: Math.abs(e.height ?? e.width),
                depth: Math.abs(e.depth ?? e.width),
                radiusTop: i,
                radiusBottom: s
            })
        };
    }
    static build(r1) {
        let { width: t , depth: e , height: n , radialSegments: i , heightSegments: s , openEnded: o , thetaStart: a , thetaLength: l , radiusTop: u , radiusBottom: c , cornerRadius: d , cornerSegments: h , hollow: f  } = r1.parameters, m;
        return d || f ? m = new of(u, c, n, i, s, o, a, l * Math.PI / 180, d, d, h, f) : m = new Za(u, c, n, i, s, o, a, l * Math.PI / 180), m.scale(1, 1, e / t), Object.assign(m, {
            userData: {
                ...r1,
                type: "CylinderGeometry"
            }
        });
    }
};
function fa(r1, t, e) {
    e.x = r1.x * t.x, e.y = r1.y, e.z = r1.x * t.y;
}
function hC(r1) {
    return new F(r1.y, -r1.x);
}
var of = class extends Me {
    constructor(t, e, n, i, s, o, a, l, u, c, d, h, f = !1){
        super(), this.type = "RoundedCylinderBufferGeometry", t = t !== void 0 ? t : 1, e = e !== void 0 ? e : 1, n = n || 1, i = Math.floor(i) || 8, s = Math.floor(s) || 1, o = o !== void 0 ? o : !1, a = a !== void 0 ? a : 0, l = l !== void 0 ? l : Math.PI * 2, o && (u = 0, c = 0);
        let m = [], p = [], g = [], y = [], v = 0, x = n / 2, w = new A, S = new A;
        f && t == 0 && (t = u), f && e == 0 && (e = c);
        let _ = new F(t, x), M = new F(e, -x), b = null, T = null, E = null, P = null, D = _.clone().sub(M), C = 0, O = 0, B = 0;
        h > 0 && (C = Math.min(t, e) * (1 - h), O = t - C, B = e - C);
        let V = _.clone();
        V.x -= C;
        let Y = Math.PI - D.angle(), W = D.angle(), q = Math.tan(W / 2), j = Math.tan(Y / 2), X = q + j, L = h ? X : j, U = h ? X : q;
        if (u = Math.min(u, (t - O) / L, D.length() / X), c = Math.min(c, (e - B) / U, D.length() / X), u > 0) {
            let Z = u / q;
            b = _.clone().sub(new F(Z, u)), h && (E = b.clone(), E.x -= C - X * u), _.sub(D.clone().setLength(Z));
        }
        if (c > 0) {
            let Z = c / j;
            T = M.clone().sub(new F(Z, -c)), M.add(D.clone().setLength(Z)), h && (P = T.clone(), P.x -= C - X * c, V.sub(D.clone().setLength(Z)));
        }
        D = _.clone().sub(M);
        let G = D.length() < .5, H = [];
        for(let Z = 0; Z <= i; Z++){
            let k = [], he = Z / i, fe = he * l + a, ce = new F(Math.sin(fe), Math.cos(fe));
            P && T ? (z(k, he, ce, Y, c, P, -1, !0), z(k, he, ce, W, c, T, -1, !1)) : T ? (re(k, ce, T.x, 0, -1), z(k, he, ce, W, c, T, -1, !1)) : o || re(k, ce, e, B, -1);
            let ye = hC(D).normalize();
            if (fa(ye, ce, w), !G) for(let Se = 0; Se <= s; Se++){
                let ve = Se / s, Te = D.clone().multiplyScalar(ve).add(M);
                fa(Te, ce, S), p.push(S.x, S.y, S.z), g.push(w.x, w.y, w.z), y.push(he, .5 + S.y / n), k.push(v++);
            }
            if (E && b ? (z(k, he, ce, Y, u, b, 1, !1), z(k, he, ce, W, u, E, 1, !0)) : b ? (z(k, he, ce, Y, u, b, 1, !1), re(k, ce, b.x, 0, 1)) : o || re(k, ce, t, O, 1), h && !G) {
                let Se = hC(D).multiplyScalar(-1).normalize();
                fa(Se, ce, w);
                for(let ve = 0; ve <= s; ve++){
                    let Te = ve / s, Ee = D.clone().multiplyScalar(-Te).add(V);
                    fa(Ee, ce, S), p.push(S.x, S.y, S.z), g.push(w.x, w.y, w.z), y.push(he, .5 + S.y / n), k.push(v++);
                }
            }
            h && !o && k.push(k[0]), H.push(k);
        }
        for(let Z = 0; Z < H.length - 1; Z++)for(let k = 0; k < H[0].length - 1; k++){
            if (o && h && k == s) continue;
            let he = H[Z][k], fe = H[Z + 1][k], ce = H[Z + 1][k + 1], ye = H[Z][k + 1], Se = p[ce * 3 + 0], ve = p[ce * 3 + 2];
            m.push(he, fe, ye), (Se != 0 || ve != 0) && m.push(fe, ce, ye);
        }
        l < Math.PI * 2 && (K(-1, H[0], a), K(1, H[H.length - 1], a + l)), this.setIndex(m), this.setAttribute("position", new Ae(p, 3)), this.setAttribute("normal", new Ae(g, 3)), this.setAttribute("uv", new Ae(y, 2));
        function z(Z, k, he, fe, ce, ye, Se, ve) {
            for(let Te = 0; Te < d + 1; Te++){
                let Ee = Te / d, we = Se < 0 ? Ee : 1 - Ee;
                ve && (we -= 1), we *= fe;
                let Ge = new F(Math.sin(we), Math.cos(we) * Se), gt = Ge.clone().multiplyScalar(ce).add(ye);
                fa(gt, he, S), p.push(S.x, S.y, S.z), fa(Ge, he, w), g.push(w.x, w.y, w.z), y.push(k, .5 + S.y / n), Z.push(v++);
            }
        }
        function re(Z, k, he, fe, ce) {
            let ye = new A, Se = new F, ve = [
                he,
                fe
            ];
            ce < 0 && ve.reverse();
            for (let Te of ve)Se.set(Te, x * ce), fa(Se, k, ye), p.push(ye.x, ye.y, ye.z), g.push(0, ce, 0), y.push(.5, .5), Z.push(v++);
        }
        function K(Z, k, he) {
            let fe = new F(Math.sin(he), Math.cos(he)), ce = new F(-Math.cos(he), Math.sin(he)), ye = new A, Se = Z < 0 ? (Ee, we, Ge)=>m.push(Ee, we, Ge) : (Ee, we, Ge)=>m.push(Ee, Ge, we), ve = new F((t + e + O + B) / 4, 0);
            fa(ve, fe, ye), p.push(ye.x, ye.y, ye.z), g.push(ce.x, 0, ce.y), y.push(.5, .5);
            let Te = v++;
            for (let Ee of k){
                let we = p.slice(Ee * 3, Ee * 3 + 3);
                p.push(...we), g.push(ce.x, 0, ce.y);
                let Ge = y.slice(Ee * 2, Ee * 2 + 2);
                y.push(...Ge), v++;
            }
            for(let Ee = Te + 1; Ee < v - 1; Ee++)Se(Te, Ee, Ee + 1);
            Se(Te, v - 1, Te + 1);
        }
    }
};
var fC = class {
    static create(r1) {
        return this.build(this.normalizeInputs(r1));
    }
    static normalizeInputs(r1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            radialSegments: 32,
            heightSegments: 8,
            openEnded: !1,
            thetaStart: 0,
            thetaLength: 360,
            cornerRadiusTop: 8,
            cornerRadiusBottom: 8,
            cornerSegments: 8
        }, r1.parameters);
        return {
            parameters: Object.assign(e, {
                width: Math.abs(e.width),
                height: Math.abs(e.height ?? e.width),
                depth: Math.abs(e.depth ?? e.width)
            })
        };
    }
    static build(r1) {
        let { width: t , depth: e , height: n , radialSegments: i , heightSegments: s , openEnded: o , thetaStart: a , thetaLength: l , cornerRadiusTop: u , cornerRadiusBottom: c , cornerSegments: d  } = r1.parameters, h;
        return u > 0 || c > 0 || l < 360 ? h = new of(0, t / 2, n, i, s, o, a, l * Math.PI / 180, u, c, d, 0, !0) : h = new hc(t / 2, n, i, s, o), h.scale(1, 1, e / t), Object.assign(h, {
            userData: {
                ...r1,
                type: "ConeGeometry"
            }
        });
    }
};
var pC = class {
    static create(r1) {
        return this.build(this.normalizeInputs(r1));
    }
    static normalizeInputs(r1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            widthSegments: 1,
            heightSegments: 1,
            depthSegments: 1,
            cornerRadius: 8,
            cornerSegments: 8
        }, r1.parameters);
        return {
            parameters: Object.assign(e, {
                width: Math.abs(e.width),
                height: Math.abs(e.height ?? e.width),
                depth: Math.abs(e.depth ?? e.width)
            })
        };
    }
    static build(r1) {
        let { width: t , height: e , depth: n , widthSegments: i , heightSegments: s , depthSegments: o , cornerRadius: a , cornerSegments: l  } = r1.parameters, u;
        return a == 0 ? u = new er(t, e, n, i, s, o) : u = new Tb(t, e, n, i, s, o, a, l), Object.assign(u, {
            userData: {
                ...r1,
                type: "CubeGeometry"
            }
        });
    }
}, Mb = Math.PI / 2, Tb = class extends Me {
    constructor(t = 1, e = 1, n = 1, i = 1, s = 1, o = 1, a = 0, l = 4){
        super(), this.type = "BoxGeometry";
        let u = this;
        i = Math.floor(i), s = Math.floor(s), o = Math.floor(o), l = Math.floor(l), a = Math.min(a, t / 2, e / 2, n / 2);
        let c = [], d = [], h = [], f = [], m = 0, p = 0;
        g("z", "y", "x", -1, -1, n, e, t, o, s, 0), g("z", "y", "x", 1, -1, n, e, -t, o, s, 1), g("x", "z", "y", 1, 1, t, n, e, i, o, 2), g("x", "z", "y", 1, -1, t, n, -e, i, o, 3), g("x", "y", "z", 1, -1, t, e, n, i, s, 4), g("x", "y", "z", -1, -1, t, e, -n, i, s, 5), a > 0 && (y("z", "y", "x", -1, -1, 1, n, e, t, o, 0), y("z", "y", "x", 1, -1, -1, n, e, t, o, 1), y("z", "y", "x", -1, 1, -1, n, e, t, o, 1), y("z", "y", "x", 1, 1, 1, n, e, t, o, 0), y("x", "y", "z", -1, -1, -1, t, e, n, i, 0), y("x", "y", "z", 1, -1, 1, t, e, n, i, 1), y("x", "y", "z", -1, 1, 1, t, e, n, i, 0), y("x", "y", "z", 1, 1, -1, t, e, n, i, 1), y("y", "x", "z", -1, -1, 1, e, t, n, s, 0), y("y", "x", "z", 1, -1, -1, e, t, n, s, 1), y("y", "x", "z", 1, 1, 1, e, t, n, s, 1), y("y", "x", "z", -1, 1, -1, e, t, n, s, 0), v(1, 1, 1), v(-1, 1, 1), v(1, -1, 1), v(-1, -1, 1), v(1, 1, -1), v(-1, 1, -1), v(1, -1, -1), v(-1, -1, -1)), this.setIndex(c), this.setAttribute("position", new Ae(d, 3)), this.setAttribute("normal", new Ae(h, 3)), this.setAttribute("uv", new Ae(f, 2));
        function g(x, w, S, _, M, b, T, E, P, D, C) {
            let O = (b - 2 * a) / P, B = (T - 2 * a) / D, V = b / 2 - a, Y = T / 2 - a, W = E / 2, q = P + 1, j = D + 1, X = 0, L = 0, U = new A;
            for(let G = 0; G < j; G++){
                let H = G * B - Y;
                for(let z = 0; z < q; z++){
                    let re = z * O - V;
                    U[x] = re * _, U[w] = H * M, U[S] = W, d.push(U.x, U.y, U.z), U[x] = 0, U[w] = 0, U[S] = E > 0 ? 1 : -1, h.push(U.x, U.y, U.z), f.push(z / P), f.push(1 - G / D), X += 1;
                }
            }
            for(let G = 0; G < D; G++)for(let H = 0; H < P; H++){
                let z = m + H + q * G, re = m + H + q * (G + 1), K = m + (H + 1) + q * (G + 1), Z = m + (H + 1) + q * G;
                c.push(z, re, Z), c.push(re, K, Z), L += 6;
            }
            u.addGroup(p, L, C), p += L, m += X;
        }
        function y(x, w, S, _, M, b, T, E, P, D, C) {
            let O = (T - 2 * a) / D, B = T / 2 - a, V = E / 2 - a, Y = P / 2, W = D + 1, q = 0, j = 0, X = new A, L = new A;
            for(let U = 0; U < l + 1; U++){
                let G = U / l * Mb, H = Math.sin(G) * a, z = (1 - Math.cos(G)) * a, re = Math.sin(G), K = Math.cos(G);
                X[w] = (V + H) * M, X[S] = (Y - z) * b, L[x] = 0, L[w] = re * Math.sign(X[w]), L[S] = K * Math.sign(X[S]);
                for(let Z = 0; Z < W; Z++){
                    let k = Z * O - B;
                    X[x] = k * _, d.push(X.x, X.y, X.z), h.push(L.x, L.y, L.z), f.push(Z / D), f.push(0), q += 1;
                }
            }
            for(let U = 0; U < l; U++)for(let G = 0; G < D; G++){
                let H = m + G + W * U, z = m + G + W * (U + 1), re = m + (G + 1) + W * (U + 1), K = m + (G + 1) + W * U;
                c.push(H, z, K), c.push(z, re, K), j += 6;
            }
            u.addGroup(p, j, C), p += j, m += q;
        }
        function v(x, w, S) {
            let _ = new A, M = new A(t / 2, e / 2, n / 2);
            M.subScalar(a);
            let b = [], T = x * w * S > 0 ? (P, D, C)=>c.push(P, D, C) : (P, D, C)=>c.push(P, C, D);
            for(let P = 0; P <= l; P++){
                let D = [], C = Mb * (1 - P / l), O = Math.cos(C), B = Math.sin(C), V = 0;
                for(let Y = 0; Y <= P; Y++){
                    let W = Math.cos(V), q = Math.sin(V);
                    _.x = O * W, _.y = B, _.z = O * q;
                    let j = M.clone().addScaledVector(_, a);
                    d.push(x * j.x, w * j.y, S * j.z), h.push(x * _.x, w * _.y, S * _.z), f.push(0, 0), D.push(m++), V += Mb / P;
                }
                b.push(D);
            }
            let E = b.length - 1;
            for(let P = 0; P < E; P++){
                let D = b[P], C = b[P + 1], O = D.length - 1;
                T(D[0], C[1], C[0]);
                for(let B = 1; B <= O; B++)T(D[B - 1], D[B], C[B]), T(D[B], C[B + 1], C[B]);
            }
        }
    }
};
var pa = class extends Me {
    constructor(t = [], e = [], n = "", i = 1, s = .2, o = 4){
        super(), this.type = "PolyhedronGeometryRound";
        let a = [], l = [], u = [];
        c(), d(), this.setAttribute("position", new Ae(a, 3)), this.setAttribute("normal", new Ae(u, 3)), this.setAttribute("uv", new Ae(l, 2));
        return;
        function c() {
            s = Math.min(1 - 1e-5, s), s == 0 && (o = 0);
            let f = {
                IcosahedronGeometry: 5,
                DodecahedronGeometry: 3,
                HexahedronGeometry: 3,
                OctahedronGeometry: 4,
                TetrahedronGeometry: 3
            }[n], m = new A, p = m.clone(), g = new an, y = s * i, v = i - y, x = o + 1, w = new A, S = (q, j)=>w.subVectors(q, j).normalize(), _ = (q, j)=>Array(q).fill(void 0).map(j), M = _(t.length / 3, (q, j)=>new A().fromArray(t, j * 3).setLength(i)), b = [], T = 1e6;
            for(let q = 0; q < M.length; q++){
                let j = M[q], X = [], L, U, G, H = 1e10, z = -1;
                for(; (z = e.indexOf(q, z + 1)) != -1;){
                    let k = z - z % 3;
                    L = e[k + (z + 1) % 3], U = e[k + (z + 2) % 3], G = j.distanceToSquared(M[L]), H = Math.min(H, G), X.push([
                        L,
                        U,
                        G
                    ]);
                }
                H += 1e-6;
                let re = [], K = 0, Z = X.length;
                for(let k = 0; k < Z; k++){
                    [L, U, G] = X[K];
                    let he = b[L]?.includes(q) == !0;
                    G <= H && re.push(L + +he * T), K = X.findIndex((fe)=>fe[0] == U);
                }
                b.push(re);
            }
            let E = [];
            {
                let q = 0, j = 0, X, L, U = f == 3;
                for(let G = 0; G <= o; G++){
                    X = G * (G + 1) / 2, L = (G + 1) * (G + 2) / 2;
                    for(let H = 0; H < o - G; H++)[q, j] = [
                        X + H + G + 2,
                        L + H + G + 3
                    ], E.push(X, L, ...U ? [
                        j,
                        X
                    ] : [
                        q,
                        L
                    ], j, q), [X, L] = [
                        q,
                        j
                    ];
                    E.push(X, L, X + o + 2);
                }
            }
            let P = m.clone(), D = m.clone(), C = m.clone(), O = m.clone(), B = m.clone(), V = [], Y = _(M.length, ()=>_(f, ()=>m.clone()));
            for(let q = 0; q < M.length; q++){
                m.copy(M[q]).normalize(), P.copy(m).multiplyScalar(v);
                let j = b[q];
                for(let re = 0; re < j.length; re++){
                    let K = j[re], Z = j[(re + 1) % f];
                    g.setFromPointsAndIndices(M, q, K % T, Z % T), g.b.sub(g.a).setLength(1e10).add(g.a), g.c.sub(g.a).setLength(1e10).add(g.a), g.closestPointToPoint(P, Y[q][re]);
                }
                let X = [], L = [], U = [], G = new A;
                o == 0 && [
                    ...Y[q]
                ].reduce((re, K)=>re.add(K), G).multiplyScalar(1 / f);
                for(let re = 0; re < f; re++){
                    let K = [], Z = (re - 1 + f) % f, k = Y[q][Z], he = Y[q][re];
                    m.copy(k).sub(P), p.copy(he).sub(P);
                    let fe = P.angleTo(m), ce = m.angleTo(p), ye = Math.cos(fe) * y;
                    o == 0 ? D.copy(G) : D.copy(P).setLength(v + ye), L.push(ye);
                    let Se = [
                        D,
                        k,
                        he
                    ];
                    for(let ve = 0; ve < 2; ve++){
                        let Te = Se[ve], Ee = Se[ve + 1];
                        O.subVectors(Te, P), B.subVectors(Ee, P), C.crossVectors(O, B).normalize();
                        for(let we = 0; we < x; we++){
                            let Ge = [
                                fe,
                                ce
                            ][ve] * we / x;
                            m.copy(O).applyAxisAngle(C, Ge).add(P), X.push(m.clone()), ve && (S(m, P), K.push([
                                we == 0 ? Te : m.clone(),
                                w.clone()
                            ]));
                        }
                        ve && (S(Ee, P), K.push([
                            Ee,
                            w.clone()
                        ]));
                    }
                    U.push(K);
                }
                V.push(U);
                let H = 2 * x, z = 2;
                for(let re = 0; re < f; re++){
                    let K = H * re, Z = H * ((re + 1) % f), k = [
                        X[K]
                    ];
                    for(let fe = 1; fe < x; fe++){
                        O = X[K + fe], B = X[Z + fe], k.push(O);
                        for(let ce = 1, ye = fe - z + 1; ce <= ye; ce++)m.lerpVectors(O, B, ce / (ye + 1)), m.sub(P).setLength(L[re]).add(P), k.push(m.clone());
                        k.push(B);
                    }
                    for(let fe = 0; fe < x; fe++)k.push(X[fe + x + K]);
                    k.push(X[Z + x]);
                    let he = E.map((fe)=>k[fe]);
                    a.push(...he.map((fe)=>[
                            fe.x,
                            fe.y,
                            fe.z
                        ]).flat()), u.push(...he.map((fe)=>(S(fe, P), [
                            w.x,
                            w.y,
                            w.z
                        ])).flat());
                }
            }
            let W = [];
            for(let q = 0; q < b.length; q++)for(let j = 0; j < f; j++){
                let X = b[q][j];
                if (X < T) {
                    let L = b[X].findIndex((H)=>H % T == q), U = V[q][j], G = V[X][L];
                    for(let H = 0; H < x; H++){
                        let z = U[H], re = G[x - H], K = U[H + 1], Z = G[x - (H + 1)];
                        [
                            z,
                            re,
                            K,
                            K,
                            re,
                            Z
                        ].forEach((k)=>{
                            a.push(k[0].x, k[0].y, k[0].z), u.push(k[1].x, k[1].y, k[1].z);
                        });
                    }
                    W.push(U[0][0], G[x][0], U[x][0], G[0][0]);
                }
            }
            for(; W.length;){
                let q, j, X, L;
                [q, j] = W.splice(0, 2);
                let U = [
                    q
                ];
                for(; q != j;)U.push(j), X = W.indexOf(j), L = X % 2, j = W.splice(X - L, 2)[1 - L];
                w.subVectors(U[0], U[1]).cross(m.subVectors(U[0], U[2])).normalize();
                let G = w.dot(U[0]) < 0;
                G && w.negate();
                for(let H = 1; H <= U.length - 2; H++)[
                    U[H + +G],
                    U[H + 1 - +G],
                    U[0]
                ].forEach((z)=>{
                    a.push(z.x, z.y, z.z), u.push(w.x, w.y, w.z);
                });
            }
        }
        function d() {
            let h = new A;
            for(let M = 0; M < a.length; M += 3){
                h.x = a[M + 0], h.y = a[M + 1], h.z = a[M + 2];
                let b = S(h) / 2 / Math.PI + .5, T = _(h) / Math.PI + .5;
                l.push(b, 1 - T);
            }
            let f = new A, m = new A, p = new A, g = new A, y = new F, v = new F, x = new F, w = (M, b, T, E)=>{
                E < 0 && M.x === 1 && (l[b] = M.x - 1), T.x === 0 && T.z === 0 && (l[b] = E / 2 / Math.PI + .5);
            };
            for(let M = 0, b = 0; M < a.length; M += 9, b += 6){
                f.set(a[M + 0], a[M + 1], a[M + 2]), m.set(a[M + 3], a[M + 4], a[M + 5]), p.set(a[M + 6], a[M + 7], a[M + 8]), y.set(l[b + 0], l[b + 1]), v.set(l[b + 2], l[b + 3]), x.set(l[b + 4], l[b + 5]), g.copy(f).add(m).add(p).divideScalar(3);
                let T = S(g);
                w(y, b + 0, f, T), w(v, b + 2, m, T), w(x, b + 4, p, T);
            }
            for(let M = 0; M < l.length; M += 6){
                let b = l[M + 0], T = l[M + 2], E = l[M + 4], P = Math.max(b, T, E), D = Math.min(b, T, E);
                P > .9 && D < .1 && (b < .2 && (l[M + 0] += 1), T < .2 && (l[M + 2] += 1), E < .2 && (l[M + 4] += 1));
            }
            function S(M) {
                return Math.atan2(M.z, -M.x);
            }
            function _(M) {
                return Math.atan2(-M.y, Math.sqrt(M.x * M.x + M.z * M.z));
            }
        }
    }
    static fromJSON(t) {
        return new pa(t.vertices, t.indices, t.radius, t.corner, t.cornerSides);
    }
};
var mC = class {
    static create(r1) {
        return this.build(this.normalizeInputs(r1));
    }
    static normalizeInputs(r1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            detail: 0,
            corner: 0,
            cornerSides: 4
        }, r1.parameters);
        return {
            parameters: Object.assign(e, {
                width: Math.abs(e.width),
                height: Math.abs(e.height ?? e.width),
                depth: Math.abs(e.depth ?? e.width)
            })
        };
    }
    static build(r1) {
        let { width: t , height: e , depth: n , detail: i , corner: s , cornerSides: o  } = r1.parameters, a = i === 0 && s !== 0 ? new af(t * .5, s, o) : new pc(t * .5, i);
        return a.scale(1, e / t, n / t), Object.assign(a, {
            userData: {
                ...r1,
                type: "DodecahedronGeometry"
            }
        });
    }
}, af = class extends pa {
    constructor(t = 1, e = .2, n = 4){
        let i = (1 + Math.sqrt(5)) / 2, s = 1 / i, o = [
            -1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            1,
            1,
            1,
            0,
            -s,
            -i,
            0,
            -s,
            i,
            0,
            s,
            -i,
            0,
            s,
            i,
            -s,
            -i,
            0,
            -s,
            i,
            0,
            s,
            -i,
            0,
            s,
            i,
            0,
            -i,
            0,
            -s,
            i,
            0,
            -s,
            -i,
            0,
            s,
            i,
            0,
            s
        ], a = [
            3,
            11,
            7,
            3,
            7,
            15,
            3,
            15,
            13,
            7,
            19,
            17,
            7,
            17,
            6,
            7,
            6,
            15,
            17,
            4,
            8,
            17,
            8,
            10,
            17,
            10,
            6,
            8,
            0,
            16,
            8,
            16,
            2,
            8,
            2,
            10,
            0,
            12,
            1,
            0,
            1,
            18,
            0,
            18,
            16,
            6,
            10,
            2,
            6,
            2,
            13,
            6,
            13,
            15,
            2,
            16,
            18,
            2,
            18,
            3,
            2,
            3,
            13,
            18,
            1,
            9,
            18,
            9,
            11,
            18,
            11,
            3,
            4,
            14,
            12,
            4,
            12,
            0,
            4,
            0,
            8,
            11,
            9,
            5,
            11,
            5,
            19,
            11,
            19,
            7,
            19,
            5,
            14,
            19,
            14,
            4,
            19,
            4,
            17,
            1,
            12,
            14,
            1,
            14,
            5,
            1,
            5,
            9
        ], l = "DodecahedronGeometry";
        super(o, a, l, t, e, n), this.type = l;
    }
    static fromJSON(t) {
        return new af(t.radius, t.corner, t.cornerSides);
    }
};
var lf = 1e-12, Ru = class {
    constructor(t){
        this.position = new F;
        this.startPosition = new F;
        this.uuid = He.generateUUID();
        this.position = t.clone();
    }
    start() {
        this.reset();
    }
    reset() {
        this.startPosition.copy(this.position);
    }
    applyOffset(t) {
        this.position.copy(this.startPosition).add(t);
    }
    copy(t) {
        return this.position.copy(t.position), this.startPosition.copy(t.startPosition), this;
    }
    clone() {
        return new Ru(this.position).copy(this);
    }
    toJSON() {
        return [
            this.position.x,
            this.position.y
        ];
    }
}, Lu = class extends Ru {
    constructor(e){
        super(e.position);
        this.parent = e;
    }
    copy(e) {
        return super.copy(e), this;
    }
    clone() {
        return new Lu(this.parent).copy(this);
    }
}, Ki = class extends Ru {
    constructor(e, n){
        super(n);
        this.controls = [];
        this.roundness = 0;
        this.areControlsDirectionsMirrored = !0;
        this.uuid = e, this.controls.push(new Lu(this), new Lu(this));
    }
    static create(e, n) {
        let i = new Ki(e, new F(...n.position));
        return i.controls[0].position.set(...n.controlPrevious.position), i.controls[1].position.set(...n.controlNext.position), i.roundness = n.roundness, i.areControlsDirectionsMirrored = n.areControlsDirectionsMirrored, i;
    }
    getOppositeControl(e) {
        let n = this.controls.indexOf(e);
        return n === 0 ? this.controls[1] : n === 1 ? this.controls[0] : null;
    }
    applyOffsetToControls(e, n = 1) {
        for(let i = 0, s = this.controls.length; i < s; i++){
            let o = this.controls[i];
            this.position.distanceTo(o.position) <= n ? o.position.copy(this.position) : o.applyOffset(e);
        }
    }
    controlsMoved() {
        return !(this.position.equals(this.controls[0].position) && this.position.equals(this.controls[1].position));
    }
    copy(e) {
        return super.copy(e), this.controls[0].copy(e.controls[0]), this.controls[1].copy(e.controls[1]), this.roundness = e.roundness, this.uuid = e.uuid, this;
    }
    clone() {
        return new Ki(this.uuid, this.position).copy(this);
    }
    toJSON() {
        return super.toJSON().concat(this.controls[0].toJSON(), this.controls[1].toJSON(), [
            this.roundness
        ]);
    }
    computeTangents() {
        let e = this.curveBefore?.getTangentAt(1), n = this.curveAfter?.getTangentAt(0);
        return [
            e,
            n
        ];
    }
    computeNormals(e = new F, n = new F) {
        let [i, s] = this.computeTangents();
        return i && s && (gC(i, e), gC(s, n)), [
            e,
            n
        ];
    }
    computeTangent(e = new F) {
        let [n, i] = this.computeTangents();
        return n && i && e.copy(n).add(i).normalize(), e;
    }
    computeNormal(e = new F) {
        let [n, i] = this.computeNormals();
        return e.copy(n).add(i).normalize(), e;
    }
};
function gC(r1, t = new F) {
    let e = r1.length();
    return t.set(-r1.y / e, r1.x / e);
}
var Cb = (r1)=>r1, Nu = new F, Ng = new F, x5 = new F, b5 = new F, w5 = new F, S5 = new F, vC = new A, xC = new A;
function bC(r1) {
    let t = new F;
    t.addVectors(r1.v0, Nu.subVectors(r1.v1, r1.v0).multiplyScalar(2 / 3));
    let e = new F;
    return e.addVectors(r1.v2, Ng.subVectors(r1.v1, r1.v2).multiplyScalar(2 / 3)), new Sr(r1.v0, t, e, r1.v2);
}
function cf(r1, t, e = Number.EPSILON) {
    return Math.abs(r1 - t) < e;
}
function A5(r1, t, e = Number.EPSILON) {
    return r1.distanceTo(t) < e;
}
function _5(r1, t, e = Number.EPSILON) {
    return r1.distanceTo(t) < e;
}
function Pb(r1, t, e) {
    let n = Math.sqrt(Math.pow(t.x - r1.x, 2) + Math.pow(t.y - r1.y, 2)), i = Math.sqrt(Math.pow(t.x - e.x, 2) + Math.pow(t.y - e.y, 2)), s = Math.sqrt(Math.pow(e.x - r1.x, 2) + Math.pow(e.y - r1.y, 2));
    return Math.acos((i * i + n * n - s * s) / (2 * i * n));
}
function wC(r1, t, e) {
    return yC(r1, t) && yC(t, e) && Eb(r1.position, t.position, e.position);
}
function Eb(r1, t, e) {
    return Nu.copy(t).sub(r1).cross(Ng.copy(e).sub(r1)) === 0;
}
function SC(r1, t, e, n, i) {
    let s = Math.sqrt(Math.pow(t.x - r1.x, 2) + Math.pow(t.y - r1.y, 2)), o = (r1.y + t.y) / 2, a = (r1.x + t.x) / 2, l = Math.sqrt(Math.pow(e, 2) - Math.pow(s / 2, 2)) * (r1.y - t.y) / s, u = Math.sqrt(Math.pow(e, 2) - Math.pow(s / 2, 2)) * (t.x - r1.x) / s;
    return n.set(a + l, o + u), i.set(a - l, o - u), [
        n,
        i
    ];
}
function AC(r1, t, e) {
    let n = r1.distanceTo(e), i = t.distanceTo(e);
    return n < i ? t : r1;
}
function _C(r1, t, e, n, i, s) {
    let o = t.x - r1.x, a = t.y - r1.y, l = e.x - r1.x, u = e.y - r1.y, c = Math.sqrt((o + l) * (o + l) + (a + u) * (a + u)), d;
    return Pb(t, r1, e) > Math.PI && (c *= -1), cf(u, a) ? d = (a + u) * (n / c - .5) * 8 / 3 / (o - l) : d = (o + l) * (n / c - .5) * 8 / 3 / (u - a), i.set(t.x - d * a, t.y + d * o), s.set(e.x + d * u, e.y - d * l), [
        i,
        s
    ];
}
function Db(r1, t) {
    return r1.position.equals(r1.controls[1].position) && t.position.equals(t.controls[0].position);
}
function yC(r1, t) {
    return Eb(r1.position, r1.controls[1].position, t.position) && Eb(r1.position, t.controls[0].position, t.position);
}
function MC(r1, t, e, n, i = .5) {
    let s = Nu.subVectors(t, r1).multiplyScalar(i).add(r1), o = Ng.subVectors(e, t).multiplyScalar(i).add(t), a = x5.subVectors(n, e).multiplyScalar(i).add(e), l = s, u = b5.subVectors(o, s).multiplyScalar(i).add(s), c = w5.subVectors(a, o).multiplyScalar(i).add(o), d = a, h = S5.subVectors(c, u).multiplyScalar(i).add(u);
    return [
        r1.x,
        r1.y,
        l.x,
        l.y,
        u.x,
        u.y,
        h.x,
        h.y,
        c.x,
        c.y,
        d.x,
        d.y,
        n.x,
        n.y
    ];
}
function TC(r1, t, e = 12, n = !0) {
    let i = xC.set(0, 0, 0), s, o = 0, a = [];
    for(let l = 0; l < t.length; l++){
        let u = Cb(t[l]), c = Nu, d = ma(u, e);
        a.push(d);
        for(let h = 0; h <= d; h++)if (u instanceof Sr || u instanceof ai || u instanceof Ar) {
            if (u.getPoint(h / d, c), i.set(c.x, c.y, 0), s !== void 0 && _5(s, i)) continue;
            s === void 0 && (s = vC), s.copy(i), r1.setXYZ(o, i.x, i.y, i.z), o++;
        }
    }
    return n && o > 1 && !(r1.getX(o - 1) === r1.getX(0) && r1.getY(o - 1) === r1.getY(0) && r1.getZ(o - 1) === r1.getZ(0)) && (r1.setXYZ(o, r1.getX(0), r1.getY(0), r1.getZ(0)), o++), r1;
}
function EC(r1, t, e, n = 12, i = !0) {
    let s = xC.set(0, 0, 0), o = 0, a = [];
    for(let l = 0; l < t.length; l++){
        if (e[l] === !1) continue;
        let u, c = Cb(t[l]), d = Nu, h = ma(c, n);
        a.push(h);
        for(let f = 0; f <= h; f++)if (c instanceof Sr || c instanceof ai || c instanceof Ar) {
            if (c.getPoint(f / h, d), s.set(d.x, d.y, 0), u?.equals(s)) continue;
            u === void 0 ? u = vC : (r1.setXYZ(o, u.x, u.y, u.z), o++, r1.setXYZ(o, s.x, s.y, s.z), o++), u.copy(s);
        }
    }
    return i && o > 1 && !(r1.getX(o - 1) === r1.getX(0) && r1.getY(o - 1) === r1.getY(0) && r1.getZ(o - 1) === r1.getZ(0)) && (r1.setXYZ(o, r1.getX(0), r1.getY(0), r1.getZ(0)), o++), a;
}
function Ib(r1, t = 12, e = !1) {
    let n = [];
    for(let i = 0, s = r1.length; i < s; i++){
        let o = r1[i], a = 0;
        if (e && o.roundedCurveCorner !== void 0) {
            let l = ma(o.roundedCurveCorner, t) * .5;
            i > 0 && (n[i - 1] += l), a += l;
        }
        o.curveAfter !== void 0 && (a += ma(o.curveAfter, t)), n.push(a);
    }
    return r1.length > 0 && e && r1[0].roundedCurveCorner !== void 0 && (n[r1.length - 1] += ma(r1[0].roundedCurveCorner, t) * .5), n;
}
function ma(r1, t = 12) {
    return r1 && r1 instanceof Ya ? t * 2 : r1 && (r1 instanceof Ar || r1 instanceof xh) ? 1 : r1 && r1 instanceof uc ? t * r1.points.length : t;
}
function CC(r1, t, e = 12, n = !0) {
    let i, s = 0;
    for(let o = 0; o < t.length; o++){
        let a = Cb(t[o]), l = ma(a, e), u = Nu;
        for(let c = 0; c <= l; c++)if (a instanceof Sr || a instanceof ai || a instanceof Ar) {
            if (a.getPoint(c / l, u), i !== void 0 && A5(i, u, lf)) continue;
            i === void 0 && (i = Ng), i.copy(u), r1.push(u.x, u.y), s++;
        }
    }
    return cf(r1[0], r1[r1.length - 2], lf) && cf(r1[1], r1[r1.length - 1], lf) && (r1.pop(), r1.pop()), n && s > 1 && !(cf(r1[s - 1], r1[1], lf) && cf(r1[s - 2], r1[0], lf)) && (r1.push(r1[0], r1[1]), s++), r1;
}
var Ob = new F, M5 = new F, T5 = new F, E5 = new F, C5 = new F, P5 = new F, Tt = class extends oo {
    constructor(e = 100, n = 100){
        super();
        this.points = [];
        this.shapeHoles = [];
        this.plane = new yn(new A(0, 0, -1));
        this.subdivision = 0;
        this.controlSnapDistance = 4;
        this.pointIDs = 0;
        this.isMesh2D = !1;
        this._roundness = 0;
        this.isClosed = !1;
        this.useCubicForRoundedCorners = !0;
        this.uuid = He.generateUUID();
        this.needsUpdate = !1;
        this.roundedCurves = [];
        this._width = e, this._height = n;
    }
    static createFromState(e, n, i) {
        let s = new Tt;
        return s.isClosed = e.isClosed, s.points = e.points.map((o)=>Ki.create(o.id, o.data)), typeof e.roundness == "number" && (s.roundness = e.roundness), s.shapeHoles = e.shapeHoles.map((o)=>Tt.createFromState(o)), n !== void 0 && i !== void 0 && s.applySize(n, i), s.update(), s;
    }
    get width() {
        return this._width;
    }
    get height() {
        return this._height;
    }
    get roundness() {
        return this._roundness;
    }
    set roundness(e) {
        if (this._roundness !== e) {
            this._roundness = e;
            for(let n = 0, i = this.points.length; n < i; n++)this.points[n].roundness = e;
            this.needsUpdate = !0;
        }
    }
    getPointsIndexesByIds(e) {
        return e.map((n)=>this.getPointIndexById(n)).filter((n)=>n >= 0);
    }
    getPointIndexById(e) {
        let n = this.points.length, i = this.points.findIndex((s)=>s.uuid === e);
        if (i < 0) {
            let s = n;
            for(let o = 0, a = this.shapeHoles.length; o < a; o++){
                let l = this.shapeHoles[o], u = l.points.length, c = l.getPointIndexById(e);
                if (c < 0) s += u;
                else return c + s;
            }
        }
        return i;
    }
    getLineIndexById(e) {
        return this.getPointIndexById(e);
    }
    getBezierPoint(e) {
        if (e <= this.points.length - 1) return this.points[e];
        if (this.shapeHoles.length > 0) {
            let n = this.points.length;
            for(let i = 0, s = this.shapeHoles.length; i < s; i++){
                let o = this.shapeHoles[i], a = e - n;
                if (a <= o.points.length - 1) return o.points[a];
                n += o.points.length;
            }
        }
        throw new Error("This shape does not have a point for this index: " + e);
    }
    getBezierPointIndex(e) {
        let n = this.points.indexOf(e);
        if (n >= 0) return n;
        if (n = this.points.length, this.shapeHoles.length > 0) for(let i = 0, s = this.shapeHoles.length; i < s; i++){
            let o = this.shapeHoles[i], a = o.points.indexOf(e);
            if (a >= 0) return n + a;
            n += o.points.length;
        }
        return -1;
    }
    getAllPoints() {
        let e = [].concat(...this.shapeHoles.map((n)=>n.points));
        return [
            ...this.points,
            ...e
        ];
    }
    applySize(e, n) {
        e === 0 && (e = .001), n === 0 && (n = .001), this._width = e, this._height = n;
    }
    applyScale(e, n) {
        let i = Ob.set(e, n);
        for(let s = 0, o = this.points.length; s < o; s++){
            let a = this.points[s];
            a.position.multiply(i), a.controls[0].position.multiply(i), a.controls[1].position.multiply(i);
        }
        for(let s = 0, o = this.shapeHoles.length; s < o; s++)this.shapeHoles[s].applyScale(e, n);
        this._update();
    }
    createPoint(e, n = 0, i = He.generateUUID()) {
        let s;
        e instanceof F ? s = e : s = new F(e, n);
        let o = new Ki(i, s);
        return o.roundness = this.roundness, o;
    }
    addPoint(e) {
        this.points.push(e), this.needsUpdate = !0;
    }
    addPointAt(e, n) {
        this.points.splice(n, 0, e), this.needsUpdate = !0;
    }
    getPointByUuid(e) {
        for(let n = 0, i = this.points.length; n < i; n++){
            let s = this.points[n];
            if (s.uuid === e) return s;
        }
        for(let n = 0, i = this.shapeHoles.length; n < i; n++){
            let o = this.shapeHoles[n].getPointByUuid(e);
            if (o) return o;
        }
    }
    getFirstPoint() {
        return this.points[0];
    }
    getLastPoint() {
        return this.points[this.points.length - 1];
    }
    removePoint(e) {
        let n = this.points.indexOf(e);
        n >= 0 && this.points.splice(n, 1), this.needsUpdate = !0;
    }
    removePointById(e) {
        let n = this.points.find((i)=>i.uuid === e);
        n && this.removePoint(n);
    }
    update() {
        for(let e = 0, n = this.shapeHoles.length; e < n; e++)this.shapeHoles[e].update();
        this._update();
    }
    extractShapePointsToBuffer(e, n = 12, i = !1) {
        this.subdivision = n, this.curveDivisions === void 0 && this.computeCurveDivisions(n);
        let s = i ? this.roundedCurveDivisions : this.curveDivisions;
        return TC(e, i ? this.roundedCurves : this.curves, n, this.autoClose), s.reduce((o, a)=>o + a, 0) + 1;
    }
    computeCurveDivisions(e = 12) {
        return this.curveDivisions = Ib(this.points, e, !1), this.roundedCurveDivisions = Ib(this.points, e, !0), this.curveDivisions;
    }
    extractFilteredShapePointsToBuffer(e, n, i = 12) {
        return EC(e, this.curves, n, i, this.autoClose).reduce((o, a)=>o + a, 0) * 2;
    }
    extractShapePointsToFlatArray(e, n = 12) {
        return this.subdivision = n, this.curveDivisions === void 0 && this.computeCurveDivisions(n), CC(e, this.roundedCurves, n, this.autoClose);
    }
    getCurveIndexFromVertexId(e, n = !1) {
        let i = 0;
        this.curveDivisions === void 0 && this.computeCurveDivisions(this.subdivision);
        let s = n ? this.roundedCurveDivisions : this.curveDivisions, o = 0;
        n && this.points[0].roundedCurveCorner !== void 0 && (o = ma(this.points[0].roundedCurveCorner, this.subdivision) * .5);
        let a = e - o;
        a < 0 && (a += s.reduce((l, u)=>l + u, 0));
        for(let l = 0, u = s.length; l < u; l++){
            let c = s[l];
            if (a < i + c) return [
                l,
                (a - i + 1) / c
            ];
            i += c;
        }
        return [
            0,
            1
        ];
    }
    getCurveT(e, n, i) {
        let s = this.points[e], o = this.points[e >= this.points.length - 1 ? 0 : e + 1], a = this.curveDivisions, l = a[e];
        if (Db(s, o)) {
            let d = s.position.distanceTo(o.position);
            return s.position.distanceTo(Ob.set(i.x, i.y)) / d;
        }
        let u = 0;
        for(let d = 0; d < e; d++)u += a[d];
        return (n - u) / l;
    }
    dispose() {}
    _applyCurveForPoint(e, n) {
        Db(n, e) ? this.lineTo(e.position.x, e.position.y) : this.bezierCurveTo(n.controls[1].position.x, n.controls[1].position.y, e.controls[0].position.x, e.controls[0].position.y, e.position.x, e.position.y);
        let i = this.curves[this.curves.length - 1];
        e.curveBefore = i, n.curveAfter = i;
        let s = i.clone();
        e.roundedCurveBefore = s, n.roundedCurveAfter = s, e.roundedCurveCorner = void 0, this.roundedCurves.push(s);
    }
    _update() {
        if (this.curves = [], this.roundedCurves = [], !this.points.length) return;
        for(let n = 0, i = this.points.length; n < i; n++){
            let s = this.points[n];
            if (n === 0) this.moveTo(s.position.x, s.position.y);
            else {
                let o = this.points[n - 1];
                this._applyCurveForPoint(s, o);
            }
        }
        let e = this.getLastPoint();
        if (e?.curveAfter && (e.curveAfter = void 0), this.isClosed) {
            let n = this.points[0], i = this.points[this.points.length - 1];
            this._applyCurveForPoint(n, i);
        }
        if (this.points.length > 2) {
            let n = 0;
            for(let i = 0, s = this.points.length; i < s; i++){
                let o = this.points[i], a = this.points[i - 1] ?? this.points[this.points.length - 1], l = this.points[i + 1] ?? this.points[0], u = o.roundness, c = a && l && wC(a, o, l);
                if (!o.controlsMoved() && u > 0 && !c) {
                    let d = o.curveBefore, h = o.curveAfter;
                    if (d === void 0 || h === void 0) continue;
                    let f = o.roundedCurveBefore, m = o.roundedCurveAfter, p = d.getLength(), g = h.getLength(), y = Math.min(u, p * .499), v = Math.min(u, g * .499), x = Math.min(y, v), w = 1 - x / p, S = x / g, _ = d.getPointAt(w, Ob), M = h.getPointAt(S, M5);
                    this._subSplitCurve(d, f, w, _, void 0), this._subSplitCurve(h, m, S, void 0, M);
                    let b;
                    if (this.useCubicForRoundedCorners) {
                        let T = Pb(_, o.position, M) / 2, E = Math.tan(T) * _.distanceTo(o.position), [P, D] = SC(_, M, E, T5, E5), C = AC(P, D, o.position), [O, B] = _C(C, _, M, E, C5, P5);
                        b = new Sr(_.clone(), O.clone(), B.clone(), M.clone());
                    } else b = new ai(_.clone(), o.position.clone(), M.clone());
                    o.roundedCurveCorner = b, this.roundedCurves.splice(i + n, 0, b), n++;
                }
            }
        }
    }
    _subSplitCurve(e, n, i, s, o) {
        if (e instanceof Ar) s !== void 0 && n.v2.copy(s), o !== void 0 && n.v1.copy(o);
        else {
            let a = e, l = n, u = a.getUtoTmapping(i, 0), c = MC(a.v0, a.v1, a.v2, a.v3, u);
            return s !== void 0 && (l.v0.set(c[0], c[1]), l.v1.set(c[2], c[3]), l.v2.set(c[4], c[5]), l.v3.set(c[6], c[7])), o !== void 0 && (l.v0.set(c[6], c[7]), l.v1.set(c[8], c[9]), l.v2.set(c[10], c[11]), l.v3.set(c[12], c[13])), l;
        }
        return n;
    }
    clone() {
        let e = new Tt(this._width, this._height);
        return e.points = this.points.map((n)=>n.clone()), e.isClosed = this.isClosed, e.roundness = this.roundness, e.isMesh2D = this.isMesh2D, e.shapeHoles = this.shapeHoles.map((n)=>n.clone()), e;
    }
    toJSON() {
        return {
            points: this.points.reduce((e, n)=>e.concat(n.toJSON()), []),
            shapeHoles: this.shapeHoles.map((e)=>e.toJSON()),
            isClosed: this.isClosed,
            roundness: this.roundness
        };
    }
    fromJSON(e) {
        this.points = [], this.pointIDs = 0;
        let n = e.points.length / 7;
        for(let i = 0; i < n; i++){
            let s = i * 7, o = e.points[s + 0], a = e.points[s + 1], l = e.points[s + 2], u = e.points[s + 3], c = e.points[s + 4], d = e.points[s + 5], h = e.points[s + 6], f = new Ki(He.generateUUID(), new F(o, a));
            f.controls[0].position.set(l, u), f.controls[1].position.set(c, d), f.roundness = h, this.points.push(f);
        }
        return this.shapeHoles = e.shapeHoles?.length ? e.shapeHoles.map((i)=>{
            let s = new Tt;
            return s.fromJSON(i), s;
        }) : [], this.isClosed = e.isClosed, this._roundness = e.roundness, this._update(), this;
    }
    fromShape(e) {
        let n = (s, o)=>{
            o instanceof Sr && o.v3.equals(s.position) && s.controls[0].position.copy(o.v2);
        }, i = (s)=>{
            let o = [], a, l;
            for(a = 0, l = s.length; a < l; a++)s[a] instanceof ai && (s[a] = bC(s[a]));
            for(a = 0, l = s.length; a < l; a++){
                let d = s[a], h = a > 0 ? s[a - 1] : null, f;
                d instanceof Sr ? (f = this.createPoint(d.v0), f.controls[1].position.copy(d.v1)) : d instanceof Ar && (f = this.createPoint(d.v1)), f !== void 0 && (h !== null && n(f, h), o.push(f));
            }
            let u = s[s.length - 1], c = !1;
            return u instanceof Sr ? u.v3.equals(o[0].position) && (o[0].controls[0].position.copy(u.v2), c = !0) : u instanceof Ar && u.v2.equals(o[0].position) && (c = !0), this.isClosed = c, o;
        };
        return this.points = i(e.curves), e instanceof oo && (this.shapeHoles = e.holes.map((s)=>{
            let o = new Tt;
            return o.fromShape(s), o;
        })), this.update(), this;
    }
    updatePoint(e, n) {
        let i = this.getPointByUuid(e);
        i && (n.position !== void 0 && i.position.fromArray(n.position), n.roundness !== void 0 && (i.roundness = n.roundness), n.areControlsDirectionsMirrored !== void 0 && (i.areControlsDirectionsMirrored = n.areControlsDirectionsMirrored), this.needsUpdate = !0);
    }
    updatePreviousControl(e, n) {
        let s = this.getPointByUuid(e)?.controls[0];
        s && (n.position && s.position.fromArray(n.position), this.needsUpdate = !0);
    }
    updateNextControl(e, n) {
        let s = this.getPointByUuid(e)?.controls[1];
        s && (n.position && s.position.fromArray(n.position), this.needsUpdate = !0);
    }
};
var Lb = Math.PI * 2;
function Rb({ x: r1 , y: t  }, e, n, i, s) {
    return {
        x: r1 * e + i,
        y: t * n + s
    };
}
function D5(r1, t) {
    let e = t === 1.5707963267948966 ? .551915024494 : t === -1.5707963267948966 ? -0.551915024494 : 1.3333333333333333 * Math.tan(t / 4), n = Math.cos(r1), i = Math.sin(r1), s = Math.cos(r1 + t), o = Math.sin(r1 + t);
    return [
        {
            x: n - i * e,
            y: i + n * e
        },
        {
            x: s + o * e,
            y: o - s * e
        },
        {
            x: s,
            y: o
        }
    ];
}
function PC(r1, t, e, n) {
    let i = r1 * n - t * e < 0 ? -1 : 1, s = Math.min(1, Math.max(-1, r1 * e + t * n));
    return i * Math.acos(s);
}
function I5(r1, t, e, n, i, s, o, a, l, u) {
    let c = Math.pow(i, 2), d = Math.pow(s, 2), h = Math.pow(o, 2), f = Math.pow(a, 2), m = c * d - c * f - d * h;
    m < 0 && (m = 0), m /= c * f + d * h, m = Math.sqrt(m) * (l === u ? -1 : 1);
    let p = m * i / s * a, g = m * -s / i * o, y = p + (r1 + e) / 2, v = g + (t + n) / 2, x = (o - p) / i, w = (a - g) / s, S = (-o - p) / i, _ = (-a - g) / s, M = PC(1, 0, x, w), b = PC(x, w, S, _);
    return !u && b > 0 && (b -= Lb), u && b < 0 && (b += Lb), {
        centerx: y,
        centery: v,
        ang1: M,
        ang2: b
    };
}
function DC({ px: r1 , py: t , cx: e , cy: n , rx: i , ry: s , largeArcFlag: o , sweepFlag: a  }) {
    let l = [];
    if (i === 0 || s === 0) return [];
    let u = (r1 - e) / 2, c = (t - n) / 2;
    if (u === 0 && c === 0) return [];
    i = Math.abs(i), s = Math.abs(s);
    let d = Math.pow(u, 2) / Math.pow(i, 2) + Math.pow(c, 2) / Math.pow(s, 2);
    d > 1 && (i *= Math.sqrt(d), s *= Math.sqrt(d));
    let h = I5(r1, t, e, n, i, s, u, c, o, a), { ang1: f , ang2: m  } = h, { centerx: p , centery: g  } = h, y = Math.abs(m) / (Lb / 4);
    Math.abs(1 - y) < 1e-7 && (y = 1);
    let v = Math.max(Math.ceil(y), 1);
    m /= v;
    for(let x = 0; x < v; x++)l.push(D5(f, m)), f += m;
    return l.map((x)=>{
        let { x: w , y: S  } = Rb(x[0], i, s, p, g), { x: _ , y: M  } = Rb(x[1], i, s, p, g), { x: b , y: T  } = Rb(x[2], i, s, p, g);
        return {
            x1: w,
            y1: S,
            x2: _,
            y2: M,
            x: b,
            y: T
        };
    });
}
var mt;
(function(r1) {
    r1[r1.ODD = 0] = "ODD", r1[r1.NONZERO = 1] = "NONZERO", r1[r1.POSITIVE = 2] = "POSITIVE", r1[r1.NEGATIVE = 3] = "NEGATIVE", r1[r1.ABS_GEQ_TWO = 4] = "ABS_GEQ_TWO";
})(mt || (mt = {}));
var sn;
(function(r1) {
    r1[r1.POLYGONS = 0] = "POLYGONS", r1[r1.CONNECTED_POLYGONS = 1] = "CONNECTED_POLYGONS", r1[r1.BOUNDARY_CONTOURS = 2] = "BOUNDARY_CONTOURS";
})(sn || (sn = {}));
function $e(r1, t) {
    if (!r1) throw t || "Assertion Failed!";
}
var je = function() {
    function r1() {}
    return r1.vertEq = function(t, e) {
        return t.s === e.s && t.t === e.t;
    }, r1.vertLeq = function(t, e) {
        return t.s < e.s || t.s === e.s && t.t <= e.t;
    }, r1.transLeq = function(t, e) {
        return t.t < e.t || t.t === e.t && t.s <= e.s;
    }, r1.edgeGoesLeft = function(t) {
        return r1.vertLeq(t.Dst, t.Org);
    }, r1.edgeGoesRight = function(t) {
        return r1.vertLeq(t.Org, t.Dst);
    }, r1.vertL1dist = function(t, e) {
        return Math.abs(t.s - e.s) + Math.abs(t.t - e.t);
    }, r1.edgeEval = function(t, e, n) {
        $e(r1.vertLeq(t, e) && r1.vertLeq(e, n));
        var i = e.s - t.s, s = n.s - e.s;
        return i + s > 0 ? i < s ? e.t - t.t + (t.t - n.t) * (i / (i + s)) : e.t - n.t + (n.t - t.t) * (s / (i + s)) : 0;
    }, r1.edgeSign = function(t, e, n) {
        $e(r1.vertLeq(t, e) && r1.vertLeq(e, n));
        var i = e.s - t.s, s = n.s - e.s;
        return i + s > 0 ? (e.t - n.t) * i + (e.t - t.t) * s : 0;
    }, r1.transEval = function(t, e, n) {
        $e(r1.transLeq(t, e) && r1.transLeq(e, n));
        var i = e.t - t.t, s = n.t - e.t;
        return i + s > 0 ? i < s ? e.s - t.s + (t.s - n.s) * (i / (i + s)) : e.s - n.s + (n.s - t.s) * (s / (i + s)) : 0;
    }, r1.transSign = function(t, e, n) {
        $e(r1.transLeq(t, e) && r1.transLeq(e, n));
        var i = e.t - t.t, s = n.t - e.t;
        return i + s > 0 ? (e.s - n.s) * i + (e.s - t.s) * s : 0;
    }, r1.vertCCW = function(t, e, n) {
        return t.s * (e.t - n.t) + e.s * (n.t - t.t) + n.s * (t.t - e.t) >= 0;
    }, r1.interpolate = function(t, e, n, i) {
        return t = t < 0 ? 0 : t, n = n < 0 ? 0 : n, t <= n ? n === 0 ? (e + i) / 2 : e + (i - e) * (t / (t + n)) : i + (e - i) * (n / (t + n));
    }, r1.intersect = function(t, e, n, i, s) {
        var o, a, l;
        r1.vertLeq(t, e) || (l = t, t = e, e = l), r1.vertLeq(n, i) || (l = n, n = i, i = l), r1.vertLeq(t, n) || (l = t, t = n, n = l, l = e, e = i, i = l), r1.vertLeq(n, e) ? r1.vertLeq(e, i) ? (o = r1.edgeEval(t, n, e), a = r1.edgeEval(n, e, i), o + a < 0 && (o = -o, a = -a), s.s = r1.interpolate(o, n.s, a, e.s)) : (o = r1.edgeSign(t, n, e), a = -r1.edgeSign(t, i, e), o + a < 0 && (o = -o, a = -a), s.s = r1.interpolate(o, n.s, a, i.s)) : s.s = (n.s + e.s) / 2, r1.transLeq(t, e) || (l = t, t = e, e = l), r1.transLeq(n, i) || (l = n, n = i, i = l), r1.transLeq(t, n) || (l = t, t = n, n = l, l = e, e = i, i = l), r1.transLeq(n, e) ? r1.transLeq(e, i) ? (o = r1.transEval(t, n, e), a = r1.transEval(n, e, i), o + a < 0 && (o = -o, a = -a), s.t = r1.interpolate(o, n.t, a, e.t)) : (o = r1.transSign(t, n, e), a = -r1.transSign(t, i, e), o + a < 0 && (o = -o, a = -a), s.t = r1.interpolate(o, n.t, a, i.t)) : s.t = (n.t + e.t) / 2;
    }, r1;
}(), uf = function() {
    function r1() {
        this.next = null, this.prev = null, this.anEdge = null, this.trail = null, this.n = 0, this.marked = !1, this.inside = !1;
    }
    return r1;
}(), Bg = function() {
    function r1(t) {
        this.side = t, this.next = null, this.Org = null, this.Sym = null, this.Onext = null, this.Lnext = null, this.Lface = null, this.activeRegion = null, this.winding = 0;
    }
    return Object.defineProperty(r1.prototype, "Rface", {
        get: function() {
            return this.Sym.Lface;
        },
        set: function(t) {
            this.Sym.Lface = t;
        },
        enumerable: !0,
        configurable: !0
    }), Object.defineProperty(r1.prototype, "Dst", {
        get: function() {
            return this.Sym.Org;
        },
        set: function(t) {
            this.Sym.Org = t;
        },
        enumerable: !0,
        configurable: !0
    }), Object.defineProperty(r1.prototype, "Oprev", {
        get: function() {
            return this.Sym.Lnext;
        },
        set: function(t) {
            this.Sym.Lnext = t;
        },
        enumerable: !0,
        configurable: !0
    }), Object.defineProperty(r1.prototype, "Lprev", {
        get: function() {
            return this.Onext.Sym;
        },
        set: function(t) {
            this.Onext.Sym = t;
        },
        enumerable: !0,
        configurable: !0
    }), Object.defineProperty(r1.prototype, "Dprev", {
        get: function() {
            return this.Lnext.Sym;
        },
        set: function(t) {
            this.Lnext.Sym = t;
        },
        enumerable: !0,
        configurable: !0
    }), Object.defineProperty(r1.prototype, "Rprev", {
        get: function() {
            return this.Sym.Onext;
        },
        set: function(t) {
            this.Sym.Onext = t;
        },
        enumerable: !0,
        configurable: !0
    }), Object.defineProperty(r1.prototype, "Dnext", {
        get: function() {
            return this.Sym.Onext.Sym;
        },
        set: function(t) {
            this.Sym.Onext.Sym = t;
        },
        enumerable: !0,
        configurable: !0
    }), Object.defineProperty(r1.prototype, "Rnext", {
        get: function() {
            return this.Sym.Lnext.Sym;
        },
        set: function(t) {
            this.Sym.Lnext.Sym = t;
        },
        enumerable: !0,
        configurable: !0
    }), r1;
}(), Bu = function() {
    function r1() {
        this.next = null, this.prev = null, this.anEdge = null, this.coords = [
            0,
            0,
            0
        ], this.s = 0, this.t = 0, this.pqHandle = 0, this.n = 0, this.idx = 0;
    }
    return r1;
}(), IC = function() {
    function r1() {
        var t = new Bu, e = new uf, n = new Bg(0), i = new Bg(1);
        t.next = t.prev = t, t.anEdge = null, e.next = e.prev = e, n.next = n, n.Sym = i, i.next = i, i.Sym = n, this.vHead = t, this.fHead = e, this.eHead = n, this.eHeadSym = i;
    }
    return r1.prototype.makeEdge_ = function(t) {
        var e = new Bg(0), n = new Bg(1);
        t.Sym.side < t.side && (t = t.Sym);
        var i = t.Sym.next;
        return n.next = i, i.Sym.next = e, e.next = t, t.Sym.next = n, e.Sym = n, e.Onext = e, e.Lnext = n, e.Org = null, e.Lface = null, e.winding = 0, e.activeRegion = null, n.Sym = e, n.Onext = n, n.Lnext = e, n.Org = null, n.Lface = null, n.winding = 0, n.activeRegion = null, e;
    }, r1.prototype.splice_ = function(t, e) {
        var n = t.Onext, i = e.Onext;
        n.Sym.Lnext = e, i.Sym.Lnext = t, t.Onext = i, e.Onext = n;
    }, r1.prototype.makeVertex_ = function(t, e, n) {
        var i = t;
        $e(i, "Vertex can't be null!");
        var s = n.prev;
        i.prev = s, s.next = i, i.next = n, n.prev = i, i.anEdge = e;
        var o = e;
        do o.Org = i, o = o.Onext;
        while (o !== e);
    }, r1.prototype.makeFace_ = function(t, e, n) {
        var i = t;
        $e(i, "Face can't be null");
        var s = n.prev;
        i.prev = s, s.next = i, i.next = n, n.prev = i, i.anEdge = e, i.trail = null, i.marked = !1, i.inside = n.inside;
        var o = e;
        do o.Lface = i, o = o.Lnext;
        while (o !== e);
    }, r1.prototype.killEdge_ = function(t) {
        t.Sym.side < t.side && (t = t.Sym);
        var e = t.next, n = t.Sym.next;
        e.Sym.next = n, n.Sym.next = e;
    }, r1.prototype.killVertex_ = function(t, e) {
        var n = t.anEdge, i = n;
        do i.Org = e, i = i.Onext;
        while (i !== n);
        var s = t.prev, o = t.next;
        o.prev = s, s.next = o;
    }, r1.prototype.killFace_ = function(t, e) {
        var n = t.anEdge, i = n;
        do i.Lface = e, i = i.Lnext;
        while (i !== n);
        var s = t.prev, o = t.next;
        o.prev = s, s.next = o;
    }, r1.prototype.makeEdge = function() {
        var t = new Bu, e = new Bu, n = new uf, i = this.makeEdge_(this.eHead);
        return this.makeVertex_(t, i, this.vHead), this.makeVertex_(e, i.Sym, this.vHead), this.makeFace_(n, i, this.fHead), i;
    }, r1.prototype.splice = function(t, e) {
        var n = !1, i = !1;
        if (t !== e) {
            if (e.Org !== t.Org && (i = !0, this.killVertex_(e.Org, t.Org)), e.Lface !== t.Lface && (n = !0, this.killFace_(e.Lface, t.Lface)), this.splice_(e, t), !i) {
                var s = new Bu;
                this.makeVertex_(s, e, t.Org), t.Org.anEdge = t;
            }
            if (!n) {
                var o = new uf;
                this.makeFace_(o, e, t.Lface), t.Lface.anEdge = t;
            }
        }
    }, r1.prototype.delete = function(t) {
        var e = t.Sym, n = !1;
        if (t.Lface !== t.Rface && (n = !0, this.killFace_(t.Lface, t.Rface)), t.Onext === t) this.killVertex_(t.Org, null);
        else if (t.Rface.anEdge = t.Oprev, t.Org.anEdge = t.Onext, this.splice_(t, t.Oprev), !n) {
            var i = new uf;
            this.makeFace_(i, t, t.Lface);
        }
        e.Onext === e ? (this.killVertex_(e.Org, null), this.killFace_(e.Lface, null)) : (t.Lface.anEdge = e.Oprev, e.Org.anEdge = e.Onext, this.splice_(e, e.Oprev)), this.killEdge_(t);
    }, r1.prototype.addEdgeVertex = function(t) {
        var e = this.makeEdge_(t), n = e.Sym;
        this.splice_(e, t.Lnext), e.Org = t.Dst;
        var i = new Bu;
        return this.makeVertex_(i, n, e.Org), e.Lface = n.Lface = t.Lface, e;
    }, r1.prototype.splitEdge = function(t) {
        var e = this.addEdgeVertex(t), n = e.Sym;
        return this.splice_(t.Sym, t.Sym.Oprev), this.splice_(t.Sym, n), t.Dst = n.Org, n.Dst.anEdge = n.Sym, n.Rface = t.Rface, n.winding = t.winding, n.Sym.winding = t.Sym.winding, n.idx = t.idx, n.Sym.idx = t.Sym.idx, n;
    }, r1.prototype.connect = function(t, e) {
        var n = !1, i = this.makeEdge_(t), s = i.Sym;
        if (e.Lface !== t.Lface && (n = !0, this.killFace_(e.Lface, t.Lface)), this.splice_(i, t.Lnext), this.splice_(s, e), i.Org = t.Dst, s.Org = e.Org, i.Lface = s.Lface = t.Lface, t.Lface.anEdge = s, !n) {
            var o = new uf;
            this.makeFace_(o, i, t.Lface);
        }
        return i;
    }, r1.prototype.zapFace = function(t) {
        var e = t.anEdge, n, i, s, o, a;
        i = e.Lnext;
        do n = i, i = n.Lnext, n.Lface = null, n.Rface === null && (n.Onext === n ? this.killVertex_(n.Org, null) : (n.Org.anEdge = n.Onext, this.splice_(n, n.Oprev)), s = n.Sym, s.Onext === s ? this.killVertex_(s.Org, null) : (s.Org.anEdge = s.Onext, this.splice_(s, s.Oprev)), this.killEdge_(n));
        while (n != e);
        o = t.prev, a = t.next, a.prev = o, o.next = a;
    }, r1.prototype.countFaceVerts_ = function(t) {
        var e = t.anEdge, n = 0;
        do n++, e = e.Lnext;
        while (e !== t.anEdge);
        return n;
    }, r1.prototype.mergeConvexFaces = function(t) {
        var e, n, i, s, o, a, l;
        for(e = this.fHead.next; e !== this.fHead; e = e.next)if (!!e.inside) for(n = e.anEdge, o = n.Org; i = n.Lnext, s = n.Sym, s && s.Lface && s.Lface.inside && (a = this.countFaceVerts_(e), l = this.countFaceVerts_(s.Lface), a + l - 2 <= t && je.vertCCW(n.Lprev.Org, n.Org, s.Lnext.Lnext.Org) && je.vertCCW(s.Lprev.Org, s.Org, n.Lnext.Lnext.Org) && (i = s.Lnext, this.delete(s), n = null, s = null)), !(n && n.Lnext.Org === o);)n = i;
        return !0;
    }, r1.prototype.check = function() {
        var t = this.fHead, e = this.vHead, n = this.eHead, i, s, o, a, l, u;
        for(s = t, s = t; (i = s.next) !== t; s = i){
            $e(i.prev === s), l = i.anEdge;
            do $e(l.Sym !== l), $e(l.Sym.Sym === l), $e(l.Lnext.Onext.Sym === l), $e(l.Onext.Sym.Lnext === l), $e(l.Lface === i), l = l.Lnext;
            while (l !== i.anEdge);
        }
        for($e(i.prev === s && i.anEdge === null), a = e, a = e; (o = a.next) !== e; a = o){
            $e(o.prev === a), l = o.anEdge;
            do $e(l.Sym !== l), $e(l.Sym.Sym === l), $e(l.Lnext.Onext.Sym === l), $e(l.Onext.Sym.Lnext === l), $e(l.Org === o), l = l.Onext;
            while (l !== o.anEdge);
        }
        for($e(o.prev === a && o.anEdge === null), u = n, u = n; (l = u.next) !== n; u = l)$e(l.Sym.next === u.Sym), $e(l.Sym !== l), $e(l.Sym.Sym === l), $e(l.Org !== null), $e(l.Dst !== null), $e(l.Lnext.Onext.Sym === l), $e(l.Onext.Sym.Lnext === l);
        $e(l.Sym.next === u.Sym && l.Sym === this.eHeadSym && l.Sym.Sym === l && l.Org === null && l.Dst === null && l.Lface === null && l.Rface === null);
    }, r1;
}(), OC = function() {
    function r1() {
        this.handle = null;
    }
    return r1;
}(), RC = function() {
    function r1() {
        this.key = null, this.node = 0;
    }
    return r1;
}(), O5 = function() {
    function r1(t, e) {
        this.leq = e, this.max = 0, this.nodes = [], this.handles = [], this.initialized = !1, this.freeList = 0, this.size = 0, this.max = t, this.nodes = [], this.handles = [];
        for(var n = 0; n < t + 1; n++)this.nodes[n] = new OC, this.handles[n] = new RC;
        this.initialized = !1, this.nodes[1].handle = 1, this.handles[1].key = null;
    }
    return r1.prototype.floatDown_ = function(t) {
        var e = this.nodes, n = this.handles, i, s, o;
        for(i = e[t].handle;;){
            if (o = t << 1, o < this.size && this.leq(n[e[o + 1].handle].key, n[e[o].handle].key) && ++o, $e(o <= this.max), s = e[o].handle, o > this.size || this.leq(n[i].key, n[s].key)) {
                e[t].handle = i, n[i].node = t;
                break;
            }
            e[t].handle = s, n[s].node = t, t = o;
        }
    }, r1.prototype.floatUp_ = function(t) {
        var e = this.nodes, n = this.handles, i, s, o;
        for(i = e[t].handle;;){
            if (o = t >> 1, s = e[o].handle, o === 0 || this.leq(n[s].key, n[i].key)) {
                e[t].handle = i, n[i].node = t;
                break;
            }
            e[t].handle = s, n[s].node = t, t = o;
        }
    }, r1.prototype.init = function() {
        for(var t = this.size; t >= 1; --t)this.floatDown_(t);
        this.initialized = !0;
    }, r1.prototype.min = function() {
        return this.handles[this.nodes[1].handle].key;
    }, r1.prototype.insert = function(t) {
        var e, n;
        if (e = ++this.size, e * 2 > this.max) {
            this.max *= 2;
            var i, s;
            for(s = this.nodes.length, this.nodes.length = this.max + 1, i = s; i < this.nodes.length; i++)this.nodes[i] = new OC;
            for(s = this.handles.length, this.handles.length = this.max + 1, i = s; i < this.handles.length; i++)this.handles[i] = new RC;
        }
        return this.freeList === 0 ? n = e : (n = this.freeList, this.freeList = this.handles[n].node), this.nodes[e].handle = n, this.handles[n].node = e, this.handles[n].key = t, this.initialized && this.floatUp_(e), n;
    }, r1.prototype.extractMin = function() {
        var t = this.nodes, e = this.handles, n = t[1].handle, i = e[n].key;
        return this.size > 0 && (t[1].handle = t[this.size].handle, e[t[1].handle].node = 1, e[n].key = null, e[n].node = this.freeList, this.freeList = n, --this.size, this.size > 0 && this.floatDown_(1)), i;
    }, r1.prototype.delete = function(t) {
        var e = this.nodes, n = this.handles, i;
        $e(t >= 1 && t <= this.max && n[t].key !== null), i = n[t].node, e[i].handle = e[this.size].handle, n[e[i].handle].node = i, --this.size, i <= this.size && (i <= 1 || this.leq(n[e[i >> 1].handle].key, n[e[i].handle].key) ? this.floatDown_(i) : this.floatUp_(i)), n[t].key = null, n[t].node = this.freeList, this.freeList = t;
    }, r1;
}(), Nb = function() {
    function r1() {
        this.eUp = null, this.nodeUp = null, this.windingNumber = 0, this.inside = !1, this.sentinel = !1, this.dirty = !1, this.fixUpperEdge = !1;
    }
    return r1;
}(), LC = function() {
    function r1() {
        this.key = null, this.next = null, this.prev = null;
    }
    return r1;
}(), R5 = function() {
    function r1(t, e) {
        this.frame = t, this.leq = e, this.head = new LC, this.head.next = this.head, this.head.prev = this.head;
    }
    return r1.prototype.min = function() {
        return this.head.next;
    }, r1.prototype.max = function() {
        return this.head.prev;
    }, r1.prototype.insert = function(t) {
        return this.insertBefore(this.head, t);
    }, r1.prototype.search = function(t) {
        var e = this.head;
        do e = e.next;
        while (e.key !== null && !this.leq(this.frame, t, e.key));
        return e;
    }, r1.prototype.insertBefore = function(t, e) {
        do t = t.prev;
        while (t.key !== null && !this.leq(this.frame, t.key, e));
        var n = new LC;
        return n.key = e, n.next = t.next, t.next.prev = n, n.prev = t, t.next = n, n;
    }, r1.prototype.delete = function(t) {
        t.next.prev = t.prev, t.prev.next = t.next;
    }, r1;
}(), L5 = function() {
    function r1() {}
    return r1.regionBelow = function(t) {
        return t.nodeUp.prev.key;
    }, r1.regionAbove = function(t) {
        return t.nodeUp.next.key;
    }, r1.debugEvent = function(t) {}, r1.addWinding = function(t, e) {
        t.winding += e.winding, t.Sym.winding += e.Sym.winding;
    }, r1.edgeLeq = function(t, e, n) {
        var i = t.event, s = e.eUp, o = n.eUp;
        if (s.Dst === i) return o.Dst === i ? je.vertLeq(s.Org, o.Org) ? je.edgeSign(o.Dst, s.Org, o.Org) <= 0 : je.edgeSign(s.Dst, o.Org, s.Org) >= 0 : je.edgeSign(o.Dst, i, o.Org) <= 0;
        if (o.Dst === i) return je.edgeSign(s.Dst, i, s.Org) >= 0;
        var a = je.edgeEval(s.Dst, i, s.Org), l = je.edgeEval(o.Dst, i, o.Org);
        return a >= l;
    }, r1.deleteRegion = function(t, e) {
        e.fixUpperEdge && $e(e.eUp.winding === 0), e.eUp.activeRegion = null, t.dict.delete(e.nodeUp);
    }, r1.fixUpperEdge = function(t, e, n) {
        $e(e.fixUpperEdge), t.mesh.delete(e.eUp), e.fixUpperEdge = !1, e.eUp = n, n.activeRegion = e;
    }, r1.topLeftRegion = function(t, e) {
        var n = e.eUp.Org, i;
        do e = r1.regionAbove(e);
        while (e.eUp.Org === n);
        if (e.fixUpperEdge) {
            if (i = t.mesh.connect(r1.regionBelow(e).eUp.Sym, e.eUp.Lnext), i === null) return null;
            r1.fixUpperEdge(t, e, i), e = r1.regionAbove(e);
        }
        return e;
    }, r1.topRightRegion = function(t) {
        var e = t.eUp.Dst;
        do t = r1.regionAbove(t);
        while (t.eUp.Dst === e);
        return t;
    }, r1.addRegionBelow = function(t, e, n) {
        var i = new Nb;
        return i.eUp = n, i.nodeUp = t.dict.insertBefore(e.nodeUp, i), i.fixUpperEdge = !1, i.sentinel = !1, i.dirty = !1, n.activeRegion = i, i;
    }, r1.isWindingInside = function(t, e) {
        switch(t.windingRule){
            case mt.ODD:
                return (e & 1) !== 0;
            case mt.NONZERO:
                return e !== 0;
            case mt.POSITIVE:
                return e > 0;
            case mt.NEGATIVE:
                return e < 0;
            case mt.ABS_GEQ_TWO:
                return e >= 2 || e <= -2;
        }
        throw new Error("Invalid winding rulle");
    }, r1.computeWinding = function(t, e) {
        e.windingNumber = r1.regionAbove(e).windingNumber + e.eUp.winding, e.inside = r1.isWindingInside(t, e.windingNumber);
    }, r1.finishRegion = function(t, e) {
        var n = e.eUp, i = n.Lface;
        i.inside = e.inside, i.anEdge = n, r1.deleteRegion(t, e);
    }, r1.finishLeftRegions = function(t, e, n) {
        for(var i, s = null, o = e, a = e.eUp; o !== n;){
            if (o.fixUpperEdge = !1, s = r1.regionBelow(o), i = s.eUp, i.Org != a.Org) {
                if (!s.fixUpperEdge) {
                    r1.finishRegion(t, o);
                    break;
                }
                i = t.mesh.connect(a.Lprev, i.Sym), r1.fixUpperEdge(t, s, i);
            }
            a.Onext !== i && (t.mesh.splice(i.Oprev, i), t.mesh.splice(a, i)), r1.finishRegion(t, o), a = s.eUp, o = s;
        }
        return a;
    }, r1.addRightEdges = function(t, e, n, i, s, o) {
        var a, l, u, c, d = !0;
        u = n;
        do $e(je.vertLeq(u.Org, u.Dst)), r1.addRegionBelow(t, e, u.Sym), u = u.Onext;
        while (u !== i);
        for(s === null && (s = r1.regionBelow(e).eUp.Rprev), l = e, c = s; a = r1.regionBelow(l), u = a.eUp.Sym, u.Org === c.Org;)u.Onext !== c && (t.mesh.splice(u.Oprev, u), t.mesh.splice(c.Oprev, u)), a.windingNumber = l.windingNumber - u.winding, a.inside = r1.isWindingInside(t, a.windingNumber), l.dirty = !0, !d && r1.checkForRightSplice(t, l) && (r1.addWinding(u, c), r1.deleteRegion(t, l), t.mesh.delete(c)), d = !1, l = a, c = u;
        l.dirty = !0, $e(l.windingNumber - u.winding === a.windingNumber), o && r1.walkDirtyRegions(t, l);
    }, r1.spliceMergeVertices = function(t, e, n) {
        t.mesh.splice(e, n);
    }, r1.vertexWeights = function(t, e, n) {
        var i = je.vertL1dist(e, t), s = je.vertL1dist(n, t), o = .5 * s / (i + s), a = .5 * i / (i + s);
        t.coords[0] += o * e.coords[0] + a * n.coords[0], t.coords[1] += o * e.coords[1] + a * n.coords[1], t.coords[2] += o * e.coords[2] + a * n.coords[2];
    }, r1.getIntersectData = function(t, e, n, i, s, o) {
        e.coords[0] = e.coords[1] = e.coords[2] = 0, e.idx = -1, r1.vertexWeights(e, n, i), r1.vertexWeights(e, s, o);
    }, r1.checkForRightSplice = function(t, e) {
        var n = r1.regionBelow(e), i = e.eUp, s = n.eUp;
        if (je.vertLeq(i.Org, s.Org)) {
            if (je.edgeSign(s.Dst, i.Org, s.Org) > 0) return !1;
            je.vertEq(i.Org, s.Org) ? i.Org !== s.Org && (t.pq.delete(i.Org.pqHandle), r1.spliceMergeVertices(t, s.Oprev, i)) : (t.mesh.splitEdge(s.Sym), t.mesh.splice(i, s.Oprev), e.dirty = n.dirty = !0);
        } else {
            if (je.edgeSign(i.Dst, s.Org, i.Org) < 0) return !1;
            r1.regionAbove(e).dirty = e.dirty = !0, t.mesh.splitEdge(i.Sym), t.mesh.splice(s.Oprev, i);
        }
        return !0;
    }, r1.checkForLeftSplice = function(t, e) {
        var n = r1.regionBelow(e), i = e.eUp, s = n.eUp, o;
        if ($e(!je.vertEq(i.Dst, s.Dst)), je.vertLeq(i.Dst, s.Dst)) {
            if (je.edgeSign(i.Dst, s.Dst, i.Org) < 0) return !1;
            r1.regionAbove(e).dirty = e.dirty = !0, o = t.mesh.splitEdge(i), t.mesh.splice(s.Sym, o), o.Lface.inside = e.inside;
        } else {
            if (je.edgeSign(s.Dst, i.Dst, s.Org) > 0) return !1;
            e.dirty = n.dirty = !0, o = t.mesh.splitEdge(s), t.mesh.splice(i.Lnext, s.Sym), o.Rface.inside = e.inside;
        }
        return !0;
    }, r1.checkForIntersect = function(t, e) {
        var n = r1.regionBelow(e), i = e.eUp, s = n.eUp, o = i.Org, a = s.Org, l = i.Dst, u = s.Dst, c, d, h = new Bu, f, m;
        if ($e(!je.vertEq(u, l)), $e(je.edgeSign(l, t.event, o) <= 0), $e(je.edgeSign(u, t.event, a) >= 0), $e(o !== t.event && a !== t.event), $e(!e.fixUpperEdge && !n.fixUpperEdge), o === a || (c = Math.min(o.t, l.t), d = Math.max(a.t, u.t), c > d)) return !1;
        if (je.vertLeq(o, a)) {
            if (je.edgeSign(u, o, a) > 0) return !1;
        } else if (je.edgeSign(l, a, o) < 0) return !1;
        return r1.debugEvent(t), je.intersect(l, o, u, a, h), $e(Math.min(o.t, l.t) <= h.t), $e(h.t <= Math.max(a.t, u.t)), $e(Math.min(u.s, l.s) <= h.s), $e(h.s <= Math.max(a.s, o.s)), je.vertLeq(h, t.event) && (h.s = t.event.s, h.t = t.event.t), f = je.vertLeq(o, a) ? o : a, je.vertLeq(f, h) && (h.s = f.s, h.t = f.t), je.vertEq(h, o) || je.vertEq(h, a) ? (r1.checkForRightSplice(t, e), !1) : !je.vertEq(l, t.event) && je.edgeSign(l, t.event, h) >= 0 || !je.vertEq(u, t.event) && je.edgeSign(u, t.event, h) <= 0 ? u === t.event ? (t.mesh.splitEdge(i.Sym), t.mesh.splice(s.Sym, i), e = r1.topLeftRegion(t, e), i = r1.regionBelow(e).eUp, r1.finishLeftRegions(t, r1.regionBelow(e), n), r1.addRightEdges(t, e, i.Oprev, i, i, !0), !0) : l === t.event ? (t.mesh.splitEdge(s.Sym), t.mesh.splice(i.Lnext, s.Oprev), n = e, e = r1.topRightRegion(e), m = r1.regionBelow(e).eUp.Rprev, n.eUp = s.Oprev, s = r1.finishLeftRegions(t, n, null), r1.addRightEdges(t, e, s.Onext, i.Rprev, m, !0), !0) : (je.edgeSign(l, t.event, h) >= 0 && (r1.regionAbove(e).dirty = e.dirty = !0, t.mesh.splitEdge(i.Sym), i.Org.s = t.event.s, i.Org.t = t.event.t), je.edgeSign(u, t.event, h) <= 0 && (e.dirty = n.dirty = !0, t.mesh.splitEdge(s.Sym), s.Org.s = t.event.s, s.Org.t = t.event.t), !1) : (t.mesh.splitEdge(i.Sym), t.mesh.splitEdge(s.Sym), t.mesh.splice(s.Oprev, i), i.Org.s = h.s, i.Org.t = h.t, i.Org.pqHandle = t.pq.insert(i.Org), r1.getIntersectData(t, i.Org, o, l, a, u), r1.regionAbove(e).dirty = e.dirty = n.dirty = !0, !1);
    }, r1.walkDirtyRegions = function(t, e) {
        for(var n = r1.regionBelow(e), i, s;;){
            for(; n.dirty;)e = n, n = r1.regionBelow(n);
            if (!e.dirty && (n = e, e = r1.regionAbove(e), e === null || !e.dirty)) return;
            if (e.dirty = !1, i = e.eUp, s = n.eUp, i.Dst !== s.Dst && r1.checkForLeftSplice(t, e) && (n.fixUpperEdge ? (r1.deleteRegion(t, n), t.mesh.delete(s), n = r1.regionBelow(e), s = n.eUp) : e.fixUpperEdge && (r1.deleteRegion(t, e), t.mesh.delete(i), e = r1.regionAbove(n), i = e.eUp)), i.Org !== s.Org) {
                if (i.Dst !== s.Dst && !e.fixUpperEdge && !n.fixUpperEdge && (i.Dst === t.event || s.Dst === t.event)) {
                    if (r1.checkForIntersect(t, e)) return;
                } else r1.checkForRightSplice(t, e);
            }
            i.Org === s.Org && i.Dst === s.Dst && (r1.addWinding(s, i), r1.deleteRegion(t, e), t.mesh.delete(i), e = r1.regionAbove(n));
        }
    }, r1.connectRightVertex = function(t, e, n) {
        var i, s = n.Onext, o = r1.regionBelow(e), a = e.eUp, l = o.eUp, u = !1;
        if (a.Dst !== l.Dst && r1.checkForIntersect(t, e), je.vertEq(a.Org, t.event) && (t.mesh.splice(s.Oprev, a), e = r1.topLeftRegion(t, e), s = r1.regionBelow(e).eUp, r1.finishLeftRegions(t, r1.regionBelow(e), o), u = !0), je.vertEq(l.Org, t.event) && (t.mesh.splice(n, l.Oprev), n = r1.finishLeftRegions(t, o, null), u = !0), u) {
            r1.addRightEdges(t, e, n.Onext, s, s, !0);
            return;
        }
        je.vertLeq(l.Org, a.Org) ? i = l.Oprev : i = a, i = t.mesh.connect(n.Lprev, i), r1.addRightEdges(t, e, i, i.Onext, i.Onext, !1), i.Sym.activeRegion.fixUpperEdge = !0, r1.walkDirtyRegions(t, e);
    }, r1.connectLeftDegenerate = function(t, e, n) {
        var i, s, o, a, l;
        if (i = e.eUp, je.vertEq(i.Org, n)) {
            $e(!1), r1.spliceMergeVertices(t, i, n.anEdge);
            return;
        }
        if (!je.vertEq(i.Dst, n)) {
            t.mesh.splitEdge(i.Sym), e.fixUpperEdge && (t.mesh.delete(i.Onext), e.fixUpperEdge = !1), t.mesh.splice(n.anEdge, i), r1.sweepEvent(t, n);
            return;
        }
        $e(!1), e = r1.topRightRegion(e), l = r1.regionBelow(e), o = l.eUp.Sym, s = a = o.Onext, l.fixUpperEdge && ($e(s !== o), r1.deleteRegion(t, l), t.mesh.delete(o), o = s.Oprev), t.mesh.splice(n.anEdge, o), je.edgeGoesLeft(s) || (s = null), r1.addRightEdges(t, e, o.Onext, a, s, !0);
    }, r1.connectLeftVertex = function(t, e) {
        var n, i, s, o, a, l, u = new Nb;
        if (u.eUp = e.anEdge.Sym, n = t.dict.search(u).key, i = r1.regionBelow(n), !!i) {
            if (o = n.eUp, a = i.eUp, je.edgeSign(o.Dst, e, o.Org) === 0) {
                r1.connectLeftDegenerate(t, n, e);
                return;
            }
            if (s = je.vertLeq(a.Dst, o.Dst) ? n : i, n.inside || s.fixUpperEdge) {
                if (s === n) l = t.mesh.connect(e.anEdge.Sym, o.Lnext);
                else {
                    var c = t.mesh.connect(a.Dnext, e.anEdge);
                    l = c.Sym;
                }
                s.fixUpperEdge ? r1.fixUpperEdge(t, s, l) : r1.computeWinding(t, r1.addRegionBelow(t, n, l)), r1.sweepEvent(t, e);
            } else r1.addRightEdges(t, n, e.anEdge, e.anEdge, null, !0);
        }
    }, r1.sweepEvent = function(t, e) {
        t.event = e, r1.debugEvent(t);
        for(var n = e.anEdge; n.activeRegion === null;)if (n = n.Onext, n === e.anEdge) {
            r1.connectLeftVertex(t, e);
            return;
        }
        var i = r1.topLeftRegion(t, n.activeRegion);
        $e(i !== null);
        var s = r1.regionBelow(i), o = s.eUp, a = r1.finishLeftRegions(t, s, null);
        a.Onext === o ? r1.connectRightVertex(t, i, a) : r1.addRightEdges(t, i, a.Onext, o, o, !0);
    }, r1.addSentinel = function(t, e, n, i) {
        var s = new Nb, o = t.mesh.makeEdge();
        o.Org.s = n, o.Org.t = i, o.Dst.s = e, o.Dst.t = i, t.event = o.Dst, s.eUp = o, s.windingNumber = 0, s.inside = !1, s.fixUpperEdge = !1, s.sentinel = !0, s.dirty = !1, s.nodeUp = t.dict.insert(s);
    }, r1.initEdgeDict = function(t) {
        t.dict = new R5(t, r1.edgeLeq);
        var e = t.bmax[0] - t.bmin[0], n = t.bmax[1] - t.bmin[1], i = t.bmin[0] - e, s = t.bmax[0] + e, o = t.bmin[1] - n, a = t.bmax[1] + n;
        r1.addSentinel(t, i, s, o), r1.addSentinel(t, i, s, a);
    }, r1.doneEdgeDict = function(t) {
        for(var e, n = 0; (e = t.dict.min().key) !== null;)e.sentinel || ($e(e.fixUpperEdge), $e(++n === 1)), $e(e.windingNumber === 0), r1.deleteRegion(t, e);
    }, r1.removeDegenerateEdges = function(t) {
        var e, n, i, s = t.mesh.eHead;
        for(e = s.next; e !== s; e = n)n = e.next, i = e.Lnext, je.vertEq(e.Org, e.Dst) && e.Lnext.Lnext !== e && (r1.spliceMergeVertices(t, i, e), t.mesh.delete(e), e = i, i = e.Lnext), i.Lnext === e && (i !== e && ((i === n || i === n.Sym) && (n = n.next), t.mesh.delete(i)), (e === n || e === n.Sym) && (n = n.next), t.mesh.delete(e));
    }, r1.initPriorityQ = function(t) {
        var e, n, i, s = 0;
        for(i = t.mesh.vHead, n = i.next; n !== i; n = n.next)s++;
        for(s += 8, e = t.pq = new O5(s, je.vertLeq), i = t.mesh.vHead, n = i.next; n !== i; n = n.next)n.pqHandle = e.insert(n);
        return n !== i ? !1 : (e.init(), !0);
    }, r1.donePriorityQ = function(t) {
        t.pq = null;
    }, r1.removeDegenerateFaces = function(t, e) {
        var n, i, s;
        for(n = e.fHead.next; n !== e.fHead; n = i)i = n.next, s = n.anEdge, $e(s.Lnext !== s), s.Lnext.Lnext === s && (r1.addWinding(s.Onext, s), t.mesh.delete(s));
        return !0;
    }, r1.computeInterior = function(t, e) {
        e === void 0 && (e = !0);
        var n, i;
        if (r1.removeDegenerateEdges(t), !r1.initPriorityQ(t)) return !1;
        for(r1.initEdgeDict(t); (n = t.pq.extractMin()) !== null;){
            for(; i = t.pq.min(), !(i === null || !je.vertEq(i, n));)i = t.pq.extractMin(), r1.spliceMergeVertices(t, n.anEdge, i.anEdge);
            r1.sweepEvent(t, n);
        }
        return t.event = t.dict.min().key.eUp.Org, r1.debugEvent(t), r1.doneEdgeDict(t), r1.donePriorityQ(t), r1.removeDegenerateFaces(t, t.mesh) ? (e && t.mesh.check(), !0) : !1;
    }, r1;
}(), N5 = function() {
    function r1() {
        this.mesh = new IC, this.normal = [
            0,
            0,
            0
        ], this.sUnit = [
            0,
            0,
            0
        ], this.tUnit = [
            0,
            0,
            0
        ], this.bmin = [
            0,
            0
        ], this.bmax = [
            0,
            0
        ], this.windingRule = mt.ODD, this.dict = null, this.pq = null, this.event = null, this.vertexIndexCounter = 0, this.vertices = [], this.vertexIndices = [], this.vertexCount = 0, this.elements = [], this.elementCount = 0;
    }
    return r1.prototype.dot_ = function(t, e) {
        return t[0] * e[0] + t[1] * e[1] + t[2] * e[2];
    }, r1.prototype.normalize_ = function(t) {
        var e = t[0] * t[0] + t[1] * t[1] + t[2] * t[2];
        if (!e) throw "Zero-size vector!";
        e = Math.sqrt(e), t[0] /= e, t[1] /= e, t[2] /= e;
    }, r1.prototype.longAxis_ = function(t) {
        var e = 0;
        return Math.abs(t[1]) > Math.abs(t[0]) && (e = 1), Math.abs(t[2]) > Math.abs(t[e]) && (e = 2), e;
    }, r1.prototype.computeNormal_ = function(t) {
        var e, n, i, s, o, a, l = [
            0,
            0,
            0
        ], u = [
            0,
            0,
            0
        ], c = [
            0,
            0,
            0
        ], d = [
            0,
            0,
            0
        ], h = [
            0,
            0,
            0
        ], f = [
            null,
            null,
            null
        ], m = [
            null,
            null,
            null
        ], p = this.mesh.vHead;
        e = p.next;
        for(var g = 0; g < 3; ++g)s = e.coords[g], u[g] = s, m[g] = e, l[g] = s, f[g] = e;
        for(e = p.next; e !== p; e = e.next)for(var y = 0; y < 3; ++y)s = e.coords[y], s < u[y] && (u[y] = s, m[y] = e), s > l[y] && (l[y] = s, f[y] = e);
        var v = 0;
        if (l[1] - u[1] > l[0] - u[0] && (v = 1), l[2] - u[2] > l[v] - u[v] && (v = 2), u[v] >= l[v]) {
            t[0] = 0, t[1] = 0, t[2] = 1;
            return;
        }
        for(a = 0, n = m[v], i = f[v], c[0] = n.coords[0] - i.coords[0], c[1] = n.coords[1] - i.coords[1], c[2] = n.coords[2] - i.coords[2], e = p.next; e !== p; e = e.next)d[0] = e.coords[0] - i.coords[0], d[1] = e.coords[1] - i.coords[1], d[2] = e.coords[2] - i.coords[2], h[0] = c[1] * d[2] - c[2] * d[1], h[1] = c[2] * d[0] - c[0] * d[2], h[2] = c[0] * d[1] - c[1] * d[0], o = h[0] * h[0] + h[1] * h[1] + h[2] * h[2], o > a && (a = o, t[0] = h[0], t[1] = h[1], t[2] = h[2]);
        a <= 0 && (t[0] = t[1] = t[2] = 0, t[this.longAxis_(c)] = 1);
    }, r1.prototype.checkOrientation_ = function() {
        for(var t = this.mesh.fHead, e, n = this.mesh.vHead, i, s = 0, o = t.next; o !== t; o = o.next)if (i = o.anEdge, !(i.winding <= 0)) do s += (i.Org.s - i.Dst.s) * (i.Org.t + i.Dst.t), i = i.Lnext;
        while (i !== o.anEdge);
        if (s < 0) {
            for(e = n.next; e !== n; e = e.next)e.t = -e.t;
            this.tUnit[0] = -this.tUnit[0], this.tUnit[1] = -this.tUnit[1], this.tUnit[2] = -this.tUnit[2];
        }
    }, r1.prototype.projectPolygon_ = function() {
        var t = this.mesh.vHead, e = [
            0,
            0,
            0
        ], n, i, s = !1;
        e[0] = this.normal[0], e[1] = this.normal[1], e[2] = this.normal[2], !e[0] && !e[1] && !e[2] && (this.computeNormal_(e), s = !0), n = this.sUnit, i = this.tUnit;
        var o = this.longAxis_(e);
        n[o] = 0, n[(o + 1) % 3] = 1, n[(o + 2) % 3] = 0, i[o] = 0, i[(o + 1) % 3] = 0, i[(o + 2) % 3] = e[o] > 0 ? 1 : -1;
        for(var a = t.next; a !== t; a = a.next)a.s = this.dot_(a.coords, n), a.t = this.dot_(a.coords, i);
        s && this.checkOrientation_();
        for(var l = !0, u = t.next; u !== t; u = u.next)l ? (this.bmin[0] = this.bmax[0] = u.s, this.bmin[1] = this.bmax[1] = u.t, l = !1) : (u.s < this.bmin[0] && (this.bmin[0] = u.s), u.s > this.bmax[0] && (this.bmax[0] = u.s), u.t < this.bmin[1] && (this.bmin[1] = u.t), u.t > this.bmax[1] && (this.bmax[1] = u.t));
    }, r1.prototype.addWinding_ = function(t, e) {
        t.winding += e.winding, t.Sym.winding += e.Sym.winding;
    }, r1.prototype.tessellateMonoRegion_ = function(t, e) {
        var n, i;
        if (n = e.anEdge, !(n.Lnext !== n && n.Lnext.Lnext !== n)) throw "Mono region invalid";
        for(; je.vertLeq(n.Dst, n.Org); n = n.Lprev);
        for(; je.vertLeq(n.Org, n.Dst); n = n.Lnext);
        i = n.Lprev;
        for(var s = void 0; n.Lnext !== i;)if (je.vertLeq(n.Dst, i.Org)) {
            for(; i.Lnext !== n && (je.edgeGoesLeft(i.Lnext) || je.edgeSign(i.Org, i.Dst, i.Lnext.Dst) <= 0);)s = t.connect(i.Lnext, i), i = s.Sym;
            i = i.Lprev;
        } else {
            for(; i.Lnext !== n && (je.edgeGoesRight(n.Lprev) || je.edgeSign(n.Dst, n.Org, n.Lprev.Org) >= 0);)s = t.connect(n, n.Lprev), n = s.Sym;
            n = n.Lnext;
        }
        if (i.Lnext === n) throw "Mono region invalid";
        for(; i.Lnext.Lnext !== n;)s = t.connect(i.Lnext, i), i = s.Sym;
        return !0;
    }, r1.prototype.tessellateInterior_ = function(t) {
        for(var e, n = t.fHead.next; n !== t.fHead; n = e)if (e = n.next, n.inside && !this.tessellateMonoRegion_(t, n)) return !1;
        return !0;
    }, r1.prototype.discardExterior_ = function(t) {
        for(var e, n = t.fHead.next; n !== t.fHead; n = e)e = n.next, n.inside || t.zapFace(n);
    }, r1.prototype.setWindingNumber_ = function(t, e, n) {
        for(var i, s = t.eHead.next; s !== t.eHead; s = i)i = s.next, s.Rface.inside !== s.Lface.inside ? s.winding = s.Lface.inside ? e : -e : n ? t.delete(s) : s.winding = 0;
    }, r1.prototype.getNeighbourFace_ = function(t) {
        return !t.Rface || !t.Rface.inside ? -1 : t.Rface.n;
    }, r1.prototype.outputPolymesh_ = function(t, e, n, i) {
        var s, o = 0, a = 0, l;
        n > 3 && t.mergeConvexFaces(n);
        for(var u = t.vHead.next; u !== t.vHead; u = u.next)u.n = -1;
        for(var c = t.fHead.next; c !== t.fHead; c = c.next)if (c.n = -1, !!c.inside) {
            s = c.anEdge, l = 0;
            do {
                var u = s.Org;
                u.n === -1 && (u.n = a, a++), l++, s = s.Lnext;
            }while (s !== c.anEdge);
            if (l > n) throw "Face vertex greater that support polygon";
            c.n = o, ++o;
        }
        this.elementCount = o, e === sn.CONNECTED_POLYGONS && (o *= 2), this.elements = [], this.elements.length = o * n, this.vertexCount = a, this.vertices = [], this.vertices.length = a * i, this.vertexIndices = [], this.vertexIndices.length = a;
        for(var u = t.vHead.next; u !== t.vHead; u = u.next)if (u.n !== -1) {
            var d = u.n * i;
            this.vertices[d + 0] = u.coords[0], this.vertices[d + 1] = u.coords[1], i > 2 && (this.vertices[d + 2] = u.coords[2]), this.vertexIndices[u.n] = u.idx;
        }
        for(var h = 0, c = t.fHead.next; c !== t.fHead; c = c.next)if (!!c.inside) {
            s = c.anEdge, l = 0;
            do {
                var u = s.Org;
                this.elements[h++] = u.n, l++, s = s.Lnext;
            }while (s !== c.anEdge);
            for(var f = l; f < n; ++f)this.elements[h++] = -1;
            if (e === sn.CONNECTED_POLYGONS) {
                s = c.anEdge;
                do this.elements[h++] = this.getNeighbourFace_(s), s = s.Lnext;
                while (s !== c.anEdge);
                for(var m = l; m < n; ++m)this.elements[h++] = -1;
            }
        }
    }, r1.prototype.outputContours_ = function(t, e) {
        var n, i, s = 0, o = 0;
        this.vertexCount = 0, this.elementCount = 0;
        for(var a = t.fHead.next; a !== t.fHead; a = a.next)if (!!a.inside) {
            i = n = a.anEdge;
            do this.vertexCount++, n = n.Lnext;
            while (n !== i);
            this.elementCount++;
        }
        this.elements = [], this.elements.length = this.elementCount * 2, this.vertices = [], this.vertices.length = this.vertexCount * e, this.vertexIndices = [], this.vertexIndices.length = this.vertexCount;
        var l = 0, u = 0, c = 0;
        s = 0;
        for(var a = t.fHead.next; a !== t.fHead; a = a.next)if (!!a.inside) {
            o = 0, i = n = a.anEdge;
            do this.vertices[l++] = n.Org.coords[0], this.vertices[l++] = n.Org.coords[1], e > 2 && (this.vertices[l++] = n.Org.coords[2]), this.vertexIndices[u++] = this.vertexIdCallback ? this.vertexIdCallback(n) : n.Org.idx, o++, n = n.Lnext;
            while (n !== i);
            this.elements[c++] = s, this.elements[c++] = o, s += o;
        }
    }, r1.prototype.addContour = function(t, e) {
        this.mesh === null && (this.mesh = new IC), t < 2 && (t = 2), t > 3 && (t = 3);
        for(var n = null, i = 0; i < e.length; i += t)n === null ? (n = this.mesh.makeEdge(), this.mesh.splice(n, n.Sym)) : (this.mesh.splitEdge(n), n = n.Lnext), n.Org.coords[0] = e[i + 0], n.Org.coords[1] = e[i + 1], t > 2 ? n.Org.coords[2] = e[i + 2] : n.Org.coords[2] = 0, n.Org.idx = this.vertexIndexCounter++, this.edgeCreateCallback && this.edgeCreateCallback(n), n.winding = 1, n.Sym.winding = -1;
    }, r1.prototype.tesselate = function(t, e, n, i, s, o) {
        if (t === void 0 && (t = mt.ODD), e === void 0 && (e = sn.POLYGONS), o === void 0 && (o = !0), this.vertices = [], this.elements = [], this.vertexIndices = [], this.vertexIndexCounter = 0, s && (this.normal[0] = s[0], this.normal[1] = s[1], this.normal[2] = s[2]), this.windingRule = t, i < 2 && (i = 2), i > 3 && (i = 3), !this.mesh) return !1;
        this.projectPolygon_(), L5.computeInterior(this, o);
        var a = this.mesh;
        return e === sn.BOUNDARY_CONTOURS ? this.setWindingNumber_(a, 1, !0) : this.tessellateInterior_(a), o && a.check(), e === sn.BOUNDARY_CONTOURS ? this.outputContours_(a, i) : this.outputPolymesh_(a, e, n, i), !0;
    }, r1;
}();
function Zi(r1) {
    var t = r1.windingRule, e = t === void 0 ? mt.ODD : t, n = r1.elementType, i = n === void 0 ? sn.POLYGONS : n, s = r1.polySize, o = s === void 0 ? 3 : s, a = r1.vertexSize, l = a === void 0 ? 2 : a, u = r1.normal, c = u === void 0 ? [
        0,
        0,
        1
    ] : u, d = r1.contours, h = d === void 0 ? [] : d, f = r1.strict, m = f === void 0 ? !0 : f, p = r1.debug, g = p === void 0 ? !1 : p;
    if (!h && m) throw new Error("Contours can't be empty");
    if (!!h) {
        var y = new N5;
        r1.edgeCreateCallback && (y.edgeCreateCallback = r1.edgeCreateCallback), r1.vertexIdCallback && (y.vertexIdCallback = r1.vertexIdCallback);
        for(var v = 0; v < h.length; v++)y.addContour(l || 2, h[v]);
        return y.tesselate(e, i, o, l, c, m), {
            vertices: y.vertices,
            vertexIndices: y.vertexIndices,
            vertexCount: y.vertexCount,
            elements: y.elements,
            elementCount: y.elementCount,
            mesh: g ? y.mesh : void 0
        };
    }
}
var cae = mt.ODD, uae = mt.NONZERO, dae = mt.POSITIVE, hae = mt.NEGATIVE, fae = mt.ABS_GEQ_TWO, pae = sn.POLYGONS, mae = sn.CONNECTED_POLYGONS, gae = sn.BOUNDARY_CONTOURS;
var Fg = class {
    constructor(t = 256, e = !1){
        this.capacity = t, this.size = 0, this.debug = e, this.debug && console.log(`allocating with cap ${t}`);
        let n = t * Fg.eSize;
        this.buffer = new ArrayBuffer(n);
        let i = Float32Array.BYTES_PER_ELEMENT, s = 0;
        this.positions = new Float32Array(this.buffer, s * i, 3 * t), s += 3 * t, this.normals = new Float32Array(this.buffer, s * i, 3 * t), s += 3 * t, this.uvs = new Float32Array(this.buffer, s * i, 2 * t);
    }
    realloc(t, e = !1) {
        if (t < this.size) throw Error("cannot shrink buffer");
        if (t <= this.capacity && !e) return;
        this.debug && console.log(`resizing from ${this.capacity} \u2192 ${t}`);
        let n = t * Fg.eSize, i = new ArrayBuffer(n), s = Float32Array.BYTES_PER_ELEMENT, o = 0, a = new Float32Array(i, o * s, 3 * t);
        o += 3 * t;
        let l = new Float32Array(i, o * s, 3 * t);
        o += 3 * t;
        let u = new Float32Array(i, o * s, 2 * t);
        a.set(this.positions.slice(0, this.size * 3)), l.set(this.normals.slice(0, this.size * 3)), u.set(this.uvs.slice(0, this.size * 2)), this.buffer = i, this.positions = a, this.normals = l, this.uvs = u, this.capacity = t;
    }
    get(t = 1) {
        let e = this.size + t;
        if (e > this.capacity) {
            let i = this.capacity;
            for(; e > i;)i *= 2;
            this.realloc(i);
        }
        let n = this.size;
        return this.size = e, n;
    }
    reserve(t) {
        let e = this.size + t;
        e > this.capacity && this.realloc(e);
    }
    shrink() {
        this.debug && console.log(`shrinking ${this.capacity} \u2192 ${this.size}`), this.realloc(this.size, !0);
    }
}, df = Fg;
df.eSize = 8 * Float32Array.BYTES_PER_ELEMENT;
var hf = {
    vertices: [
        160,
        160,
        -160,
        160,
        -160,
        -160,
        160,
        -160
    ],
    vertexIndices: [
        1,
        0,
        3,
        2
    ],
    vertexCount: 4,
    elements: [
        0,
        4
    ],
    elementCount: 1,
    mesh: void 0
}, Fb = {
    vertices: [],
    vertexIndices: [],
    vertexCount: 0,
    elements: [],
    elementCount: 0,
    mesh: void 0
}, Ub = {
    vertices: [
        -160,
        160,
        160,
        -160,
        160,
        160,
        -160,
        -160
    ],
    vertexIndices: [
        1,
        3,
        0,
        2
    ],
    vertexCount: 4,
    elements: [
        0,
        1,
        2,
        1,
        0,
        3
    ],
    elementCount: 2,
    mesh: void 0
}, Bb = (r1, t)=>([e, n])=>(n < e && (n += t), (r1 >= e ? r1 : r1 + t) <= n), Fu = class extends Me {
    constructor(e, n, i = 0, s = 12, o = 3, a = mt.ODD){
        super();
        this.type = "ShapeGeometry";
        this.vertexCache = {};
        this._shape = e, this._depth = n, this._bevel = i, this._curveSegments = s, this._bevelSegmentsInput = o, i <= 0 ? (this._bevelSize = 0, this._bevelSegments = 0) : (this._bevelSize = Math.min(i, n / 2 - 1e-12), this._bevelSegments = Math.floor(o));
        let l = this._shape.extractShapePointsToFlatArray([], s), u = this._shape.shapeHoles.map((M)=>{
            let b = M.extractShapePointsToFlatArray([], s), T = [];
            for(let E = b.length - 1; E >= 1; E -= 2){
                let P = b[E - 1], D = b[E - 0];
                T.push(P, D);
            }
            return T;
        }), c;
        try {
            c = Zi({
                windingRule: a,
                elementType: sn.BOUNDARY_CONTOURS,
                vertexSize: 2,
                strict: !0,
                contours: [
                    l
                ]
            });
        } catch  {
            c = hf;
        }
        let d;
        try {
            d = Zi({
                windingRule: mt.ODD,
                elementType: sn.BOUNDARY_CONTOURS,
                vertexSize: 2,
                strict: !0,
                contours: [
                    ...u
                ]
            });
        } catch  {
            d = Fb;
        }
        if (!c) throw new Error("error generating geometry");
        let h = c.elementCount;
        if (d) {
            c.elementCount += d.elementCount;
            for(let M = 0; M < d.elements.length; M++){
                let b = d.elements[M], T = M % 2 === 0 ? c.vertexCount : 0;
                c.elements.push(b + T);
            }
            for(let M = 0; M < d.vertexIndices.length; M++){
                let b = d.vertexIndices[M], T = c.vertexCount;
                c.vertexIndices.push(b + T);
            }
            for(let M = 0; M < d.vertices.length; M++){
                let b = d.vertices[M];
                c.vertices.push(b);
            }
        }
        let f = 1 / 0, m = -1 / 0, p = 1 / 0, g = -1 / 0;
        for(let M = 0, b = c.vertexCount; M < b; M++){
            let T = M * 2, E = c.vertices[T + 0], P = c.vertices[T + 1];
            E < f && (f = E), E > m && (m = E), P < p && (p = P), P > g && (g = P);
        }
        this._minX = f, this._minY = p, this._width = m - f, this._height = g - p, this._buffer = new df(this._computeBufferEstimatedSize(c));
        let y = [], v = [];
        for(let M = c.elementCount - 1; M >= 0; M--){
            let b = M >= h, T = M * 2, E = c.elements[T + 0], P = c.elements[T + 1], D = E + P, C = {
                start: E,
                count: P,
                normals: [],
                continuous: [],
                concave: []
            }, O = E, B = D - 1, V = E + 1, Y = this._shape.roundedCurves.length;
            do {
                let X = O - E, L = c.vertices[B * 2 + 0], U = c.vertices[B * 2 + 1], G = c.vertices[O * 2 + 0], H = c.vertices[O * 2 + 1], z = c.vertices[V * 2 + 0], re = c.vertices[V * 2 + 1], K = G - L, Z = H - U, k = Math.sqrt(K * K + Z * Z);
                K /= k, Z /= k;
                let he = G - z, fe = H - re, ce = Math.sqrt(he * he + fe * fe);
                he /= ce, fe /= ce, C.normals[X * 2 + 0] = -fe, C.normals[X * 2 + 1] = he, C.concave[X] = K * fe - Z * he > 0;
                let ye = c.vertexIndices[O];
                if (Array.isArray(ye)) C.continuous[X] = !1;
                else {
                    let [Se, ve] = this._shape.getCurveIndexFromVertexId(ye - 1, !0);
                    if (ve > 0 && ve < 1) C.continuous[X] = !0;
                    else {
                        let Te = ve === 1 ? Se + 1 : Se - 1;
                        Te = (Te + Y) % Y;
                        let Ee = ve === 1 ? 0 : 1, we = this._shape.roundedCurves[Se].getTangent(ve), Ge = this._shape.roundedCurves[Te].getTangent(Ee);
                        C.continuous[X] = we.dot(Ge) > .95;
                    }
                }
                b && (C.normals[X * 2 + 0] *= -1, C.normals[X * 2 + 1] *= -1), [B, O, V] = [
                    O,
                    V,
                    V + 1
                ], V >= D && (V -= P);
            }while (V !== E + 1);
            let W = [];
            W.push({
                bevelI: 0,
                angle: 0,
                size: 0,
                boundary: {
                    vertices: c.vertices.slice(E * 2, D * 2),
                    vertexCount: P,
                    vertexIndices: new Array(P).fill(!0).map((X, L)=>[
                            L,
                            L
                        ]),
                    elements: [
                        0,
                        P
                    ],
                    elementCount: 1,
                    mesh: null
                },
                reverseMap: [],
                insetPoints: c.vertices.slice(E * 2, D * 2)
            });
            for(let X = 1; X <= this._bevelSegments; X++){
                let L = X / this._bevelSegments * Math.PI / 2, U = (1 - Math.cos(L)) * this._bevelSize, G = [], H = [], z = [], re = [], K = 0;
                for(let k = 0; k < P; k++){
                    let he = k * 2, fe = (k - 1 + P) % P * 2, ce = c.vertices[C.start * 2 + he + 0], ye = c.vertices[C.start * 2 + he + 1], Se = -C.normals[fe + 0] * U, ve = -C.normals[fe + 1] * U, Te = -C.normals[he + 0] * U, Ee = -C.normals[he + 1] * U;
                    if (C.concave[k] || !C.concave[k] && b) {
                        let we = Math.atan2(ve, Se), Ge = Math.atan2(Ee, Te);
                        Ge > we && (Ge -= Math.PI * 2);
                        let gt = Ge - we;
                        if (C.continuous[k] || b) {
                            let R = we + gt / 2, I = Math.cos(R) * U, ee = Math.sin(R) * U;
                            G[2 * K + 0] = ce + I * (b ? -1 : 1), G[2 * K + 1] = ye + ee * (b ? -1 : 1), re[K] = k, K++;
                        } else {
                            let R = Math.max(1, Math.floor(s / 4 * Math.abs(gt) / Math.PI));
                            for(let I = 0; I <= R; I++){
                                let ee = we + gt * (I / R), pe = Math.cos(ee) * U, xe = Math.sin(ee) * U;
                                G[2 * K + 0] = ce + pe, G[2 * K + 1] = ye + xe, re[K] = k, K++;
                            }
                        }
                    } else G[2 * K + 0] = ce + Se, G[2 * K + 1] = ye + ve, re[K] = k, H[k] = K, K++, G[2 * K + 0] = ce, G[2 * K + 1] = ye, re[K] = k, K++, G[2 * K + 0] = ce + Te, G[2 * K + 1] = ye + Ee, re[K] = k, z[k] = K, K++;
                }
                let Z = Zi({
                    windingRule: mt.POSITIVE,
                    elementType: sn.BOUNDARY_CONTOURS,
                    vertexSize: 2,
                    strict: !0,
                    contours: [
                        G
                    ],
                    edgeCreateCallback: (k)=>{
                        let fe = k.Org.idx, ce = re[fe], ye = re[(fe + 1) % re.length];
                        k.idx = [
                            ce,
                            ye
                        ], k.Sym.idx = [
                            ye,
                            ce
                        ];
                    },
                    vertexIdCallback: (k)=>{
                        let he = k.Lprev.idx;
                        return [
                            he ? he[1] : 0,
                            k.idx ? k.idx[0] : 0
                        ];
                    }
                });
                if (!Z) throw console.log("Error"), new Error(`error generating bevel geometry for ${X}'th loop`);
                if (!Z.vertexCount) break;
                for(let k = 0; k < Z.vertexIndices.length; k++){
                    let [he, fe] = Z.vertexIndices[k];
                    if (he === fe) continue;
                    let ce = fe;
                    fe < he && (ce += P);
                    for(let ye = he; ye < ce; ye++){
                        let Se = ye % P, ve = (ye + 1) % P;
                        if (!C.continuous[Se] || !C.continuous[ve]) {
                            Z.vertexIndices[k] = [
                                he,
                                Se
                            ], Z.vertexIndices.splice(k + 1, 0, [
                                ve,
                                fe
                            ]), Z.vertices.splice((k + 1) * 2, 0, Z.vertices[k * 2], Z.vertices[k * 2 + 1]);
                            break;
                        }
                    }
                }
                W.push({
                    bevelI: X,
                    angle: L,
                    size: U,
                    boundary: Z,
                    reverseMap: re,
                    insetPoints: G
                });
            }
            let q = (X, L, U)=>{
                let G = 0, H = X.boundary.vertexIndices.length;
                for(; G < H && U(X.boundary.vertexIndices[L]);)L = (L + 1) % H, G++;
                return G;
            }, j = y.length;
            for(let X = 1; X < W.length; X++){
                let L = W[X - 1], U = W[X], G = L.boundary.vertexIndices.length, H = U.boundary.vertexIndices.length;
                if (!G || !H) break;
                let z = C.concave.length, re = 0, K = Bb(re, P);
                for(; !L.boundary.vertexIndices.filter(K).length || !U.boundary.vertexIndices.filter(K).length;)re++, K = Bb(re, P);
                let Z = L.boundary.vertexIndices.findIndex(K), k = U.boundary.vertexIndices.findIndex(K);
                do Z = (Z + 1) % G;
                while (K(L.boundary.vertexIndices[Z]));
                do k = (k + 1) % H;
                while (K(U.boundary.vertexIndices[k]));
                re = (re + 1) % P;
                let he = re, fe = this._buildBevelVert(C, L, (Z - 1 + G) % G), ce = this._buildBevelVert(C, U, (k - 1 + H) % H), ye = fe, Se = ce, ve, Te, Ee = !1;
                do {
                    K = Bb(re, P);
                    let we = q(L, Z, K), Ge = q(U, k, K), gt = Ee;
                    if (Ee = !1, we && !Ge) {
                        for(let R = 0; R < we; R++)ve = this._buildBevelVert(C, L, (Z + R) % G, R / (we - 1)), y.push(ye.topN, ve.topP, Se.topN), y.push(ve.bottomP, ye.bottomN, Se.bottomN), ye = ve;
                        Ee = !0;
                    } else if (!we && Ge) for(let R = 0; R < Ge; R++)Te = this._buildBevelVert(C, U, (k + R) % H, R / (Ge - 1)), y.push(Se.topN, ye.topP, Te.topP), y.push(ye.bottomP, Se.bottomN, Te.bottomP), Se = Te;
                    else if (we && Ge) {
                        if (ve = this._buildBevelVert(C, L, Z, 0), Te = this._buildBevelVert(C, U, k, 0), gt ? (y.push(ye.topN, Te.topP, Se.topN), y.push(ye.topN, ve.topP, Te.topP), y.push(Te.bottomP, ye.bottomN, Se.bottomN), y.push(Te.bottomP, ve.bottomP, ye.bottomN)) : (y.push(Se.topN, ye.topN, ve.topP), y.push(Se.topN, ve.topP, Te.topP), y.push(ve.bottomP, ye.bottomN, Se.bottomN), y.push(ve.bottomP, Se.bottomN, Te.bottomP)), ye = ve, Se = Te, we === Ge) for(let R = 1; R < we; R++)ve = this._buildBevelVert(C, L, (Z + R) % G, R / (we - 1)), Te = this._buildBevelVert(C, U, (k + R) % H, R / (Ge - 1)), y.push(ye.topN, ve.topP, Se.topN), y.push(Se.topN, ve.topP, Te.topP), y.push(ve.bottomP, ye.bottomN, Se.bottomN), y.push(ve.bottomP, Se.bottomN, Te.bottomP), ye = ve, Se = Te;
                        else if (we > Ge) {
                            let R = we / Ge, I = 0;
                            for(let ee = 1; ee < we; ee++)ve = this._buildBevelVert(C, L, (Z + ee) % G, ee / (we - 1)), y.push(ye.topN, ve.topP, Se.topN), y.push(ve.bottomP, ye.bottomN, Se.bottomN), ye = ve, ee > (I + 1) * R && (I++, Te = this._buildBevelVert(C, U, (k + I) % H, I / (Ge - 1)), y.push(Se.topN, ve.topP, Te.topP), y.push(ve.bottomP, Se.bottomN, Te.bottomP), Se = Te);
                        } else {
                            let R = Ge / we, I = 0;
                            for(let ee = 1; ee < Ge; ee++)Te = this._buildBevelVert(C, U, (k + ee) % H, ee / (Ge - 1)), y.push(Se.topN, ve.topP, Te.topP), y.push(ve.bottomP, Se.bottomN, Te.bottomP), Se = Te, ee > (I + 1) * R && (I++, ve = this._buildBevelVert(C, L, (Z + I) % G, I / (we - 1)), y.push(ye.topN, ve.topP, Se.topN), y.push(ve.bottomP, ye.bottomN, Se.bottomN), ye = ve);
                        }
                    }
                    Z = (Z + we) % G, k = (k + Ge) % H, re = (re + 1) % z;
                }while (re !== he);
            }
            if (this._buildWall(W, C, y), b) {
                let X = [];
                for(let L = y.length - 1; L >= j + 2; L -= 3){
                    let U = y[L - 2], G = y[L - 1], H = y[L - 0];
                    X.push(H, G, U);
                }
                y.splice(j, y.length - j, ...X);
            }
            if (b) {
                let X = [];
                for(let L = W[W.length - 1].boundary.vertices.length - 1; L >= 1; L -= 2){
                    let U = W[W.length - 1].boundary.vertices[L - 1], G = W[W.length - 1].boundary.vertices[L - 0];
                    X.push(U, G);
                }
                v.push(X);
            }
            if (!b) {
                let X = W[W.length - 1], L;
                try {
                    L = Zi({
                        windingRule: W.length > 1 ? mt.POSITIVE : mt.ODD,
                        elementType: sn.POLYGONS,
                        vertexSize: 2,
                        strict: !0,
                        contours: [
                            X.insetPoints,
                            ...v
                        ]
                    });
                } catch  {
                    L = Ub;
                }
                if (!L) throw new Error("Error generating geometry for surface");
                u.length === 0 && Object.assign(this, {
                    capStartIndex: y.length
                });
                for(let U = 0; U < L.elementCount * 3; U += 3){
                    let G = this._buildSurfaceVert(L, L.elements[U + 0]), H = this._buildSurfaceVert(L, L.elements[U + 1]), z = this._buildSurfaceVert(L, L.elements[U + 2]);
                    y.push(G.top, H.top, z.top), y.push(z.bottom, H.bottom, G.bottom);
                }
            }
            this.vertexCache = {};
        }
        this._buffer.shrink();
        let x = new Be(Uint32Array.from(y), 1), w = new Be(this._buffer.positions, 3), S = new Be(this._buffer.normals, 3), _ = new Be(this._buffer.uvs, 2);
        w.needsUpdate = !0, S.needsUpdate = !0, _.needsUpdate = !0, x.needsUpdate = !0, this.setAttribute("position", w), this.setAttribute("normal", S), this.setAttribute("uv", _), this.setIndex(x);
    }
    _computeBufferEstimatedSize(e) {
        return e.vertexCount * 2 * (2 + this._bevelSegments);
    }
    _buildWall(e, n, i) {
        let s = e[0];
        for(let o = 0, a = s.boundary.vertexCount; o < a; o++){
            let l = this._buildBevelVert(n, s, o), u = this._buildBevelVert(n, s, (o + 1) % a);
            i.push(u.topP, l.topN, l.bottomN), i.push(u.topP, l.bottomN, u.bottomP);
        }
    }
    _buildSurfaceVert(e, n) {
        let i = n.toString();
        if (i in this.vertexCache) return this.vertexCache[i];
        let s = e.vertices[n * 2 + 0], o = e.vertices[n * 2 + 1], a = (s - this._minX) / this._width, l = (o - this._minY) / this._height, u = this._buffer.get(2), c = u * 3, d = u * 2, h = {
            top: u + 0,
            bottom: u + 1
        };
        return this._buffer.positions[c + 0] = s, this._buffer.positions[c + 1] = o, this._buffer.positions[c + 2] = this._depth, this._buffer.normals[c + 0] = 0, this._buffer.normals[c + 1] = 0, this._buffer.normals[c + 2] = 1, this._buffer.uvs[d + 0] = a, this._buffer.uvs[d + 1] = l, this._buffer.positions[c + 3] = s, this._buffer.positions[c + 4] = o, this._buffer.positions[c + 5] = 0, this._buffer.normals[c + 3] = 0, this._buffer.normals[c + 4] = 0, this._buffer.normals[c + 5] = -1, this._buffer.uvs[d + 2] = a, this._buffer.uvs[d + 3] = l, this.vertexCache[i] = h, h;
    }
    _buildBevelVert(e, n, i, s = 1) {
        let o = `${n.bevelI}:${i}`;
        if (o in this.vertexCache) return this.vertexCache[o];
        let [a, l] = n.boundary.vertexIndices[i], u, c, d, h;
        a !== l ? (c = a, u = l, h = !1, d = e.continuous[c] && e.continuous[u]) : (u = a, c = (u - 1 + e.count) % e.count, h = e.concave[u] && n.bevelI > 0, d = e.continuous[u] || h);
        let f = Math.cos(n.angle), m = Math.sin(n.angle), p = i * 2, g = u * 2, y = c * 2, v = n.boundary.vertices[p + 0], x = n.boundary.vertices[p + 1], w = (1 - m) * this._bevelSize, S = (v - this._minX) / this._width, _ = (x - this._minY) / this._height, M = e.normals[g + 0], b = e.normals[g + 1], T = e.normals[y + 0], E = e.normals[y + 1];
        if (h) {
            let B = T - M, V = E - b;
            M = M + B * (1 - s), b = b + V * (1 - s);
            let Y = Math.sqrt(M * M + b * b);
            M /= Y, b /= Y;
        }
        let P = this._buffer.get(d ? 2 : 4), D = P * 3, C = P * 2, O = {
            i: i,
            fi: u,
            topP: P + 0,
            topN: P + 0,
            bottomP: P + 1,
            bottomN: P + 1
        };
        return this._buffer.positions[D + 0] = v, this._buffer.positions[D + 1] = x, this._buffer.positions[D + 2] = this._depth - w, this._buffer.normals[D + 0] = M * f, this._buffer.normals[D + 1] = b * f, this._buffer.normals[D + 2] = m, this._buffer.uvs[C + 0] = S, this._buffer.uvs[C + 1] = _, this._buffer.positions[D + 3] = v, this._buffer.positions[D + 4] = x, this._buffer.positions[D + 5] = w, this._buffer.normals[D + 3] = M * f, this._buffer.normals[D + 4] = b * f, this._buffer.normals[D + 5] = -m, this._buffer.uvs[C + 2] = _, this._buffer.uvs[C + 3] = S, d || (P += 2, D += 6, C += 4, O.topP = P + 0, O.bottomP = P + 1, this._buffer.positions[D + 0] = v, this._buffer.positions[D + 1] = x, this._buffer.positions[D + 2] = this._depth - w, this._buffer.normals[D + 0] = T * f, this._buffer.normals[D + 1] = E * f, this._buffer.normals[D + 2] = m, this._buffer.uvs[C + 0] = S, this._buffer.uvs[C + 1] = _, this._buffer.positions[D + 3] = v, this._buffer.positions[D + 4] = x, this._buffer.positions[D + 5] = w, this._buffer.normals[D + 3] = T * f, this._buffer.normals[D + 4] = E * f, this._buffer.normals[D + 5] = -m, this._buffer.uvs[C + 2] = _, this._buffer.uvs[C + 3] = S), this.vertexCache[o] = O, O;
    }
    clone() {
        let e = new Fu(this._shape, this._depth, this._bevel, this._curveSegments, this._bevelSegmentsInput);
        return e.userData = fo(this.userData), e;
    }
};
var Uu = class extends Me {
    constructor(e, n = 12, i = {}){
        super();
        this.type = "ShapeGeometry";
        this.windingRule = mt.ODD;
        this.elementType = sn.POLYGONS;
        this.polySize = 3;
        this.vertexSize = 2;
        this.strict = !0;
        this._shape = e, this._curveSegments = n, this._triangulationOptions = Object.assign({
            windingRule: mt.ODD,
            elementType: sn.POLYGONS,
            polySize: 3,
            vertexSize: 2,
            strict: !0
        }, i);
        let s = this._shape.extractShapePointsToFlatArray([], this._curveSegments), o = this._shape.shapeHoles.map((m)=>m.extractShapePointsToFlatArray([], this._curveSegments)), a, l = !0, u = !0, c, d;
        for(let m = 0, p = s.length / 2; m < p; m++){
            let g = m * 2, y = s[g + 0], v = s[g + 1];
            if (c !== void 0 && y !== c && (l = !1), d !== void 0 && v !== d && (u = !1), c = y, d = v, !l && !u) break;
        }
        if (!l && !u) try {
            a = Zi({
                contours: [
                    s,
                    ...o
                ],
                windingRule: this._triangulationOptions.windingRule,
                elementType: this._triangulationOptions.elementType,
                polySize: this._triangulationOptions.polySize,
                vertexSize: this._triangulationOptions.vertexSize,
                strict: this._triangulationOptions.strict
            });
        } catch  {
            a = hf;
        }
        let h = a?.vertexCount ?? 1, f = a?.elementCount ?? 1;
        if (this._positionAttribute = new Be(new Float32Array(h * 3), 3), this._normalAttribute = new Be(new Float32Array(h * 3), 3), this._uvAttribute = new Be(new Float32Array(h * 2), 2), this._indexAttribute = new Be(new Uint32Array(f * 3), 1), a) {
            let m = 1 / 0, p = -1 / 0, g = 1 / 0, y = -1 / 0;
            for(let w = 0, S = h; w < S; w++){
                let _ = w * 2, M = a.vertices[_ + 0], b = a.vertices[_ + 1];
                M < m && (m = M), M > p && (p = M), b < g && (g = b), b > y && (y = b);
            }
            let v = p - m, x = y - g;
            for(let w = 0, S = h; w < S; w++){
                let _ = w * 2, M = a.vertices[_ + 0], b = a.vertices[_ + 1], T = (M - m) / v, E = (b - g) / x;
                this._positionAttribute.setXYZ(w, M, b, 0), this._normalAttribute.setXYZ(w, 0, 0, 1), this._uvAttribute.setXY(w, T, E);
            }
            for(let w = 0, S = f; w < S; w++){
                let _ = w * 3, M = a.elements[_ + 0], b = a.elements[_ + 1], T = a.elements[_ + 2];
                this._indexAttribute.setX(_ + 0, M), this._indexAttribute.setX(_ + 1, b), this._indexAttribute.setX(_ + 2, T);
            }
        }
        this.setAttribute("position", this._positionAttribute), this.setAttribute("normal", this._normalAttribute), this.setAttribute("uv", this._uvAttribute), this.setIndex(this._indexAttribute), this.setDrawRange(0, (a?.elementCount ?? 1) * 3);
    }
    clone() {
        let e = new Uu(this._shape, this._curveSegments);
        return e.userData = fo(this.userData), e;
    }
};
var ku = class extends Fu {
    constructor(e, n, i = 0, s = 12, o = 3, a = mt.ODD){
        super(e, n, i, s, o, a);
        this.type = "ShapeGeometry";
    }
    _computeBufferEstimatedSize(e) {
        return e.vertexCount * 2 * (2 + this._bevelSegments);
    }
    _buildWall(e, n, i) {
        let s = e[0];
        for(let o = 0, a = s.boundary.vertexCount; o < a; o++){
            let l = this._buildBevelVert(n, s, o), u = this._buildBevelVert(n, s, (o + 1) % a);
            i.push(u.topP, l.topN, l.bottomN), i.push(u.topP, l.bottomN, u.bottomP);
        }
    }
    clone() {
        let e = new ku(this._shape, this._depth, this._bevel, this._curveSegments, this._bevelSegmentsInput);
        return e.userData = fo(this.userData), e;
    }
};
var Xr = class {
    static create(r1) {
        return this.build(this.normalizeInputs(r1));
    }
    static normalizeInputs(r1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            subdivisions: 40,
            roundness: 0,
            extrudeBevelSize: 0,
            extrudeBevelSegments: 3,
            windingRule: mt.ODD
        }, r1.parameters), n = Math.abs(e.width), i = Math.abs(e.height ?? e.width), s = Math.abs(e.depth ?? 0), o = r1.shape ?? t?.shape, a = o?.roundness ?? e.roundness;
        o !== void 0 && (o instanceof Tt ? (o.width !== n || o.height !== i) && o.applySize(n, i) : o = new Tt(n, i).fromJSON(o), r1.parameters?.roundness !== void 0 && r1.parameters?.roundness > 0 && o.update());
        let l = o ?? new Tt(n, i);
        return {
            parameters: Object.assign(e, {
                width: n,
                height: i,
                depth: s,
                roundness: a
            }),
            shape: l
        };
    }
    static build(r1) {
        let { depth: t , extrudeBevelSize: e , extrudeBevelSegments: n , subdivisions: i , roundness: s , windingRule: o  } = r1.parameters;
        r1.shape.roundness = s;
        let a;
        return t <= 0 ? a = new Uu(r1.shape, i, {
            windingRule: o
        }) : a = new ku(r1.shape, t, e, i, n, o), Object.assign(a, {
            userData: {
                ...r1,
                type: "VectorGeometry"
            }
        });
    }
};
var BC = Math.PI * 2, Gu = class {
    static create(r1) {
        return this.build(this.normalizeInputs(r1));
    }
    static normalizeInputs(r1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            depth: 0,
            spikes: 64,
            angle: 360,
            innerRadius: 0,
            extrudeBevelSize: 0,
            extrudeBevelSegments: 1
        }, r1.parameters);
        return {
            shape: r1.shape && r1.shape instanceof Tt ? r1.shape : new Tt,
            parameters: Object.assign(e, {
                width: Math.abs(e.width),
                height: Math.abs(e.height ?? e.width),
                depth: Math.abs(e.depth ?? 0)
            })
        };
    }
    static build(r1) {
        let { width: t , height: e , spikes: n , angle: i , innerRadius: s , depth: o , extrudeBevelSize: a , extrudeBevelSegments: l  } = r1.parameters, u = r1.shape, c = t * .5, d = e * .5, h = B5(u, c, d, i * Math.PI / 180, n, s);
        u.isClosed = !0, u.update();
        let f = Xr.create({
            shape: u,
            parameters: {
                subdivisions: h,
                depth: o,
                extrudeBevelSize: a,
                extrudeBevelSegments: l
            }
        });
        return Object.assign(f, {
            userData: {
                ...r1,
                type: "EllipseGeometry"
            }
        });
    }
};
function B5(r1, t, e, n, i, s) {
    if (n >= BC) return i > 30 || i % 4 === 0 ? (U5(r1, t, e, s), Math.round(i / 4)) : NC(r1, n, i, t, e, s);
    n = Math.max(n, .001);
    let o = {
        x: 0,
        y: e
    }, a = n + Math.PI * .5, l = {
        x: Math.cos(a) * t,
        y: Math.sin(a) * e
    }, u = DC({
        px: o.x,
        py: o.y,
        cx: l.x,
        cy: l.y,
        rx: t,
        ry: e,
        largeArcFlag: n > Math.PI,
        sweepFlag: !0
    });
    return i > 30 || i % u.length === 0 ? F5(r1, o.x, o.y, u, i, t, e, s) : NC(r1, n, i, t, e, s);
}
function F5(r1, t, e, n, i, s, o, a) {
    let l = Math.round(i / n.length);
    r1.addPoint(zu(t, e));
    for(let u = 0, c = n.length; u < c; u++){
        let d = n[u], h = r1.points[u], f = zu(d.x, d.y);
        h.controls[1].position.set(d.x1, d.y1), f.controls[0].position.set(d.x2, d.y2), r1.addPoint(f);
    }
    return a > 0 ? FC(r1, s, o, a) : r1.addPoint(zu(0, 0)), l;
}
function NC(r1, t, e, n, i, s) {
    let o = -t / e;
    for(let a = 0; a <= e; a++){
        let l = o * a, u = Math.sin(l) * n, c = Math.cos(l) * i;
        r1.addPoint(zu(u, c));
    }
    return t < BC ? s > 0 ? FC(r1, n, i, s) : r1.addPoint(zu(0, 0)) : (r1.removePoint(r1.points[r1.points.length - 1]), s > 0 && UC(r1, n, i, s)), 1;
}
function U5(r1, t, e, n = 0, i = 0, s = 0) {
    let o = .5522847498, a = t * o, l = e * o;
    r1.addPoint(Ug(i - t, s, i - t, s - l, i - t, s + l)), r1.addPoint(Ug(i, s + e, i - a, s + e, i + a, s + e)), r1.addPoint(Ug(i + t, s, i + t, s + l, i + t, s - l)), r1.addPoint(Ug(i, s - e, i + a, s - e, i - a, s - e)), n > 0 && UC(r1, t, e, n);
}
function zu(r1, t) {
    return new Ki(He.generateUUID(), new F(r1, t));
}
function Ug(r1, t, e, n, i, s) {
    let o = zu(r1, t);
    return o.controls[0].position.set(e, n), o.controls[1].position.set(i, s), o;
}
function FC(r1, t, e, n) {
    kC(r1, t, e, n).forEach((s)=>r1.addPoint(s));
}
function UC(r1, t, e, n) {
    let i = kC(r1, t, e, n), s = new Tt;
    i.forEach((o)=>s.addPoint(o)), s.isClosed = !0, r1.shapeHoles.push(s);
}
function kC(r1, t, e, n) {
    let i = n * t / 100, s = i * (Math.abs(e) / Math.abs(t)), o = new F(i / t, s / e), a = r1.points.map((l)=>{
        let u = l.clone();
        return u.uuid = He.generateUUID(), u;
    }).reverse();
    return a.forEach((l)=>{
        l.position.multiply(o);
        let u = l.controls[0].position.clone().multiply(o), c = l.controls[1].position.clone().multiply(o);
        l.controls[0].position.copy(c), l.controls[1].position.copy(u);
    }), a;
}
var zC = class {
    static create(r1) {
        return this.build(this.normalizeInputs(r1));
    }
    static normalizeInputs(r1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            revolutions: 2,
            segments: 40,
            pathRadius: 10,
            pathType: 0,
            pathSegments: 30,
            cornerRadius: 30,
            cornerSegments: 4
        }, r1.parameters), n = Math.abs(e.width), i = Math.abs(e.height ?? n), s = Math.abs(e.depth ?? n), o = Math.abs(Math.min(n, s)) / 2;
        return {
            parameters: Object.assign(e, {
                width: n,
                height: i,
                depth: s,
                radius: o,
                segments: Math.round(e.segments),
                pathSegments: Math.round(e.pathSegments),
                cornerSegments: Math.round(e.cornerSegments)
            })
        };
    }
    static build(r1) {
        let { width: t , height: e , depth: n , radius: i , revolutions: s , segments: o , pathRadius: a , pathType: l , pathSegments: u , cornerRadius: c , cornerSegments: d  } = r1.parameters, h = new ff(!1, t, e, n, i, s, o, a, l, u, c, d);
        return Object.assign(h, {
            userData: {
                ...r1,
                type: "HelixGeometry"
            }
        });
    }
}, kb = new ys([
    0,
    0,
    0
], 1), ff = class extends Me {
    constructor(t = !0, e = 1, n = 1, i = 1, s = 1, o = 1, a = 1, l = 1, u = 1, c = 1, d = 1, h = 1){
        if (super(), o === 0) return;
        let f = t && o === 1;
        f && (h = 0), d > 100 && (d = 100), d === 0 && (h = 0);
        let m = ()=>new A, p = new A, g = m(), y = m(), v = m(), x, w, S, _, M, b, T, E, P = m(), D = m(), C = m(), O = m(), B = m(), V = m(), Y = m(), W = m(), q = n - 2 * l + .001, j = q / o, X = Math.ceil(a * o), L = X + 1, U = q / X, G = -q / 2, H = c + 1, z = 2 * Math.PI / c, re = Math.PI / 2 / h, K = .01, Z = Math.min((1 - d / 100) * l, l - K), k = l - Z, he = 0, fe = 2, ce = h * fe + fe, ye = H * ce / fe, Se = ye + H * L, ve = H * (L + ce), [Te, Ee, we] = [
            3,
            3,
            2
        ].map((Re)=>Array(ve * Re).fill(0)), Ge = [], gt = s - l;
        function R(Re, De) {
            let Ue = Math.PI / 2;
            b = De * U, E = 2 * Math.PI * (b % j) / j + Ue, b += G, T = Math.sin(E) * gt, M = Math.cos(E) * gt, t ? Re.set(M, T, b) : Re.set(M, b, T);
        }
        R(p, -0.0000000001), R(g, 0), P.copy(p), R(p, 1);
        let I = p.distanceTo(g), ee = f ? 0 : k + Z, pe = I * X + 2 * ee, xe = Z, Ce = pe - ee;
        for(let Re = 0; Re <= X; Re++){
            R(y, Re), W.subVectors(y, P).normalize(), P.copy(y), V.copy(y).setComponent(+t + 1, 0).normalize(), Y.crossVectors(W, V).normalize();
            let De = Re === 0, Ue = Re === X, Xe = De ? 3 * Math.PI / 2 : re, yt = De ? xe : Ce, zt = De ? H : Se, Tn = De ? 0 : ve - H, Q = W.clone().multiplyScalar(De ? -k : k).add(y), se = W.clone().multiplyScalar(De ? -1 : 1).normalize();
            for(let ge = 0; ge < H; ge++){
                let Le = ge * z;
                if (D.addVectors(p.copy(V).multiplyScalar(l * Math.cos(Le)), g.copy(Y).multiplyScalar(l * Math.sin(Le))), C.copy(D).normalize(), De || Ue) {
                    f || (he = Tn + ge, [
                        0,
                        1,
                        2
                    ].forEach((Oe)=>{
                        Te[he * 3 + Oe] = Q.getComponent(Oe), Ee[he * 3 + Oe] = se.getComponent(Oe);
                    }), we[he * 2] = +Ue, we[he * 2 + 1] = ge / c), g.copy(C).multiplyScalar(Z), v.addVectors(y, g);
                    for(let Oe = 0; Oe < h; Oe++){
                        let vt = Oe * re + Xe;
                        O.addVectors(p.copy(W).multiplyScalar(k * Math.sin(vt)), g.copy(C).multiplyScalar(k * Math.cos(vt))), B.copy(O).normalize(), g.addVectors(v, O), O.normalize(), he = zt + Oe * H + ge, [
                            0,
                            1,
                            2
                        ].forEach((pn)=>{
                            Te[he * 3 + pn] = g.getComponent(pn), Ee[he * 3 + pn] = B.getComponent(pn);
                        });
                        let En = +De + Math.sin(vt);
                        we[he * 2] = (yt + k * En) / pe, we[he * 2 + 1] = ge / c;
                    }
                }
                g.addVectors(y, D), he = ye + Re * H + ge, [
                    0,
                    1,
                    2
                ].forEach((Oe)=>{
                    Te[he * 3 + Oe] = g.getComponent(Oe), Ee[he * 3 + Oe] = C.getComponent(Oe);
                }), we[he * 2] = (ee + Re * I) / pe, we[he * 2 + 1] = ge / c;
            }
        }
        let Ve = L + 2 * h + fe, Pe = 1, [de, qe] = [
            +f,
            Ve - 1
        ];
        for(let Re = de; Re <= qe - 1; Re++){
            let De = f && Re === qe - 1;
            for(let Ue = 0; Ue < H - 1; Ue++)x = Re * H + Ue, w = x + 1, S = (De ? Ue : x) + H, _ = (De ? Ue + 1 : w) + H, Re === 0 ? Ge.push(w, _, S) : Re === Ve - 2 ? Ge.push(x, w, S) : Ge.push(x, w, S, w, _, S);
        }
        this.setIndex(Ge), this.setAttribute("position", new Ae(Te, 3)), this.setAttribute("normal", new Ae(Ee, 3)), this.setAttribute("uv", new Ae(we, 2));
    }
    getClosedTorusIndicesForBooleanOrSubdiv() {
        let t = this.userData.parameters, e = Math.ceil(t.tubularSegments), n = t.radialSegments + 1, i = Array.from(this.getIndex().array), s, o, a, l, u = 6 * (e - 1) * t.radialSegments, c = e, d = c === e;
        for(let h = 0; h < t.radialSegments; h++)s = c * n + h, o = s + 1, a = (d ? h : s) + n, l = (d ? h + 1 : o) + n, i[u++] = s, i[u++] = o, i[u++] = a, i[u++] = o, i[u++] = l, i[u++] = a;
        return i.length = u, kb.array = i, kb.count = i.length, kb;
    }
};
var GC = class {
    static create(r1) {
        return this.build(this.normalizeInputs(r1));
    }
    static normalizeInputs(r1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            detail: 0,
            corner: 0,
            cornerSides: 4
        }, r1.parameters);
        return {
            parameters: Object.assign(e, {
                width: Math.abs(e.width),
                height: Math.abs(e.height ?? e.width),
                depth: Math.abs(e.depth ?? e.width)
            })
        };
    }
    static build(r1) {
        let { width: t , height: e , depth: n , detail: i , corner: s , cornerSides: o  } = r1.parameters, a = i === 0 && s !== 0 ? new pf(t * .5, s, o) : new gc(t * .5, i);
        return a.scale(1, e / t, n / t), Object.assign(a, {
            userData: {
                ...r1,
                type: "IcosahedronGeometry"
            }
        });
    }
}, pf = class extends pa {
    constructor(t = 1, e = .2, n = 4){
        let i = (1 + Math.sqrt(5)) / 2, s = [
            -1,
            i,
            0,
            1,
            i,
            0,
            -1,
            -i,
            0,
            1,
            -i,
            0,
            0,
            -1,
            i,
            0,
            1,
            i,
            0,
            -1,
            -i,
            0,
            1,
            -i,
            i,
            0,
            -1,
            i,
            0,
            1,
            -i,
            0,
            -1,
            -i,
            0,
            1
        ], o = [
            0,
            11,
            5,
            0,
            5,
            1,
            0,
            1,
            7,
            0,
            7,
            10,
            0,
            10,
            11,
            1,
            5,
            9,
            5,
            11,
            4,
            11,
            10,
            2,
            10,
            7,
            6,
            7,
            1,
            8,
            3,
            9,
            4,
            3,
            4,
            2,
            3,
            2,
            6,
            3,
            6,
            8,
            3,
            8,
            9,
            4,
            9,
            5,
            2,
            4,
            11,
            6,
            2,
            10,
            8,
            6,
            7,
            9,
            8,
            1
        ], a = "IcosahedronGeometry";
        super(s, o, a, t, e, n), this.type = a;
    }
    static fromJSON(t) {
        return new pf(t.radius, t.corner, t.cornerSides);
    }
};
var VC = class {
    static create(r1) {
        return this.build(this.normalizeInputs(r1));
    }
    static normalizeInputs(r1, t) {
        (r1.parameters?.points ?? []).forEach((n)=>{
            Array.isArray(n) && (n.x = n[0], n.y = n[1]);
        });
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            segments: 64,
            verticalSegments: 64,
            points: [
                {
                    x: 0,
                    y: -50,
                    id: 0
                },
                {
                    x: 50,
                    y: -50,
                    id: 1
                },
                {
                    x: 50,
                    y: 50,
                    id: 2
                },
                {
                    x: 0,
                    y: 50,
                    id: 3
                }
            ]
        }, r1.parameters);
        return {
            parameters: Object.assign(e, {
                width: Math.abs(e.width),
                height: Math.abs(e.height ?? e.width),
                depth: Math.abs(e.depth ?? e.width)
            })
        };
    }
    static build(r1) {
        let { points: t , segments: e , verticalSegments: n  } = r1.parameters, i = new oo;
        i.moveTo(t[0].x, t[0].y), i.bezierCurveTo(t[1].x, t[1].y, t[2].x, t[2].y, t[3].x, t[3].y);
        let s = new dc(i.extractPoints(n).shape, e);
        return s.rotateZ(Math.PI), Object.assign(s, {
            userData: {
                ...r1,
                type: "LatheGeometry"
            }
        });
    }
};
var Cs = new ae, zb = new pt, kg = new A, ga = class extends Ht {
    constructor(){
        super(), this.uuid = He.generateUUID(), this.name = "", this.type = "Geometry", this.vertices = [], this.colors = [], this.faces = [], this.faceVertexUvs = [
            []
        ], this.morphTargets = [], this.morphNormals = [], this.skinWeights = [], this.skinIndices = [], this.lineDistances = [], this.boundingBox = null, this.boundingSphere = null, this.elementsNeedUpdate = !1, this.verticesNeedUpdate = !1, this.uvsNeedUpdate = !1, this.normalsNeedUpdate = !1, this.colorsNeedUpdate = !1, this.lineDistancesNeedUpdate = !1, this.groupsNeedUpdate = !1;
    }
    applyMatrix4(t) {
        let e = new Kt().getNormalMatrix(t);
        for(let n = 0, i = this.vertices.length; n < i; n++)this.vertices[n].applyMatrix4(t);
        for(let n = 0, i = this.faces.length; n < i; n++){
            let s = this.faces[n];
            s.normal.applyMatrix3(e).normalize();
            for(let o = 0, a = s.vertexNormals.length; o < a; o++)s.vertexNormals[o].applyMatrix3(e).normalize();
        }
        return this.boundingBox !== null && this.computeBoundingBox(), this.boundingSphere !== null && this.computeBoundingSphere(), this.verticesNeedUpdate = !0, this.normalsNeedUpdate = !0, this;
    }
    rotateX(t) {
        return Cs.makeRotationX(t), this.applyMatrix4(Cs), this;
    }
    rotateY(t) {
        return Cs.makeRotationY(t), this.applyMatrix4(Cs), this;
    }
    rotateZ(t) {
        return Cs.makeRotationZ(t), this.applyMatrix4(Cs), this;
    }
    translate(t, e, n) {
        return Cs.makeTranslation(t, e, n), this.applyMatrix4(Cs), this;
    }
    scale(t, e, n) {
        return Cs.makeScale(t, e, n), this.applyMatrix4(Cs), this;
    }
    lookAt(t) {
        return zb.lookAt(t), zb.updateMatrix(), this.applyMatrix4(zb.matrix), this;
    }
    fromBufferGeometry(t) {
        let e = this, n = t.index !== null ? t.index : void 0, i = t.attributes;
        if (i.position === void 0) return console.error("THREE.Geometry.fromBufferGeometry(): Position attribute required for conversion."), this;
        let s = i.position, o = i.normal, a = i.color, l = i.uv, u = i.uv2;
        u !== void 0 && (this.faceVertexUvs[1] = []);
        for(let h = 0; h < s.count; h++)e.vertices.push(new A().fromBufferAttribute(s, h)), a !== void 0 && e.colors.push(new Ne().fromBufferAttribute(a, h));
        function c(h, f, m, p) {
            let g = a === void 0 ? [] : [
                e.colors[h].clone(),
                e.colors[f].clone(),
                e.colors[m].clone()
            ], y = o === void 0 ? [] : [
                new A().fromBufferAttribute(o, h),
                new A().fromBufferAttribute(o, f),
                new A().fromBufferAttribute(o, m)
            ], v = new Vu(h, f, m, y, g, p);
            e.faces.push(v), l !== void 0 && e.faceVertexUvs[0].push([
                new F().fromBufferAttribute(l, h),
                new F().fromBufferAttribute(l, f),
                new F().fromBufferAttribute(l, m)
            ]), u !== void 0 && e.faceVertexUvs[1].push([
                new F().fromBufferAttribute(u, h),
                new F().fromBufferAttribute(u, f),
                new F().fromBufferAttribute(u, m)
            ]);
        }
        let d = t.groups;
        if (d.length > 0) for(let h = 0; h < d.length; h++){
            let f = d[h], m = f.start, p = f.count;
            for(let g = m, y = m + p; g < y; g += 3)n !== void 0 ? c(n.getX(g), n.getX(g + 1), n.getX(g + 2), f.materialIndex) : c(g, g + 1, g + 2, f.materialIndex);
        }
        else if (n !== void 0) for(let h = 0; h < n.count; h += 3)c(n.getX(h), n.getX(h + 1), n.getX(h + 2));
        else for(let h = 0; h < s.count; h += 3)c(h, h + 1, h + 2);
        return this.computeFaceNormals(), t.boundingBox !== null && (this.boundingBox = t.boundingBox.clone()), t.boundingSphere !== null && (this.boundingSphere = t.boundingSphere.clone()), this;
    }
    center() {
        return this.computeBoundingBox(), this.boundingBox.getCenter(kg).negate(), this.translate(kg.x, kg.y, kg.z), this;
    }
    normalize() {
        this.computeBoundingSphere();
        let t = this.boundingSphere.center, e = this.boundingSphere.radius, n = e === 0 ? 1 : 1 / e, i = new ae;
        return i.set(n, 0, 0, -n * t.x, 0, n, 0, -n * t.y, 0, 0, n, -n * t.z, 0, 0, 0, 1), this.applyMatrix4(i), this;
    }
    computeFaceNormals() {
        let t = new A, e = new A;
        for(let n = 0, i = this.faces.length; n < i; n++){
            let s = this.faces[n], o = this.vertices[s.a], a = this.vertices[s.b], l = this.vertices[s.c];
            t.subVectors(l, a), e.subVectors(o, a), t.cross(e), t.normalize(), s.normal.copy(t);
        }
    }
    computeVertexNormals(t = !0) {
        let e = new Array(this.vertices.length);
        for(let n = 0, i = this.vertices.length; n < i; n++)e[n] = new A;
        if (t) {
            let n = new A, i = new A;
            for(let s = 0, o = this.faces.length; s < o; s++){
                let a = this.faces[s], l = this.vertices[a.a], u = this.vertices[a.b], c = this.vertices[a.c];
                n.subVectors(c, u), i.subVectors(l, u), n.cross(i), e[a.a].add(n), e[a.b].add(n), e[a.c].add(n);
            }
        } else {
            this.computeFaceNormals();
            for(let n = 0, i = this.faces.length; n < i; n++){
                let s = this.faces[n];
                e[s.a].add(s.normal), e[s.b].add(s.normal), e[s.c].add(s.normal);
            }
        }
        for(let n = 0, i = this.vertices.length; n < i; n++)e[n].normalize();
        for(let n = 0, i = this.faces.length; n < i; n++){
            let s = this.faces[n], o = s.vertexNormals;
            o.length === 3 ? (o[0].copy(e[s.a]), o[1].copy(e[s.b]), o[2].copy(e[s.c])) : (o[0] = e[s.a].clone(), o[1] = e[s.b].clone(), o[2] = e[s.c].clone());
        }
        this.faces.length > 0 && (this.normalsNeedUpdate = !0);
    }
    computeFlatVertexNormals() {
        this.computeFaceNormals();
        for(let t = 0, e = this.faces.length; t < e; t++){
            let n = this.faces[t], i = n.vertexNormals;
            i.length === 3 ? (i[0].copy(n.normal), i[1].copy(n.normal), i[2].copy(n.normal)) : (i[0] = n.normal.clone(), i[1] = n.normal.clone(), i[2] = n.normal.clone());
        }
        this.faces.length > 0 && (this.normalsNeedUpdate = !0);
    }
    computeMorphNormals() {
        for(let e = 0, n = this.faces.length; e < n; e++){
            let i = this.faces[e];
            i.__originalFaceNormal ? i.__originalFaceNormal.copy(i.normal) : i.__originalFaceNormal = i.normal.clone(), i.__originalVertexNormals || (i.__originalVertexNormals = []);
            for(let s = 0, o = i.vertexNormals.length; s < o; s++)i.__originalVertexNormals[s] ? i.__originalVertexNormals[s].copy(i.vertexNormals[s]) : i.__originalVertexNormals[s] = i.vertexNormals[s].clone();
        }
        let t = new ga;
        t.faces = this.faces;
        for(let e = 0, n = this.morphTargets.length; e < n; e++){
            if (!this.morphNormals[e]) {
                this.morphNormals[e] = {}, this.morphNormals[e].faceNormals = [], this.morphNormals[e].vertexNormals = [];
                let s = this.morphNormals[e].faceNormals, o = this.morphNormals[e].vertexNormals;
                for(let a = 0, l = this.faces.length; a < l; a++){
                    let u = new A, c = {
                        a: new A,
                        b: new A,
                        c: new A
                    };
                    s.push(u), o.push(c);
                }
            }
            let i = this.morphNormals[e];
            t.vertices = this.morphTargets[e].vertices, t.computeFaceNormals(), t.computeVertexNormals();
            for(let s = 0, o = this.faces.length; s < o; s++){
                let a = this.faces[s], l = i.faceNormals[s], u = i.vertexNormals[s];
                l.copy(a.normal), u.a.copy(a.vertexNormals[0]), u.b.copy(a.vertexNormals[1]), u.c.copy(a.vertexNormals[2]);
            }
        }
        for(let e = 0, n = this.faces.length; e < n; e++){
            let i = this.faces[e];
            i.normal = i.__originalFaceNormal, i.vertexNormals = i.__originalVertexNormals;
        }
    }
    computeBoundingBox() {
        this.boundingBox === null && (this.boundingBox = new Mt), this.boundingBox.setFromPoints(this.vertices);
    }
    computeBoundingSphere() {
        this.boundingSphere === null && (this.boundingSphere = new Rn), this.boundingSphere.setFromPoints(this.vertices);
    }
    merge(t, e, n = 0) {
        if (!(t && t.isGeometry)) {
            console.error("THREE.Geometry.merge(): geometry not an instance of THREE.Geometry.", t);
            return;
        }
        let i, s = this.vertices.length, o = this.vertices, a = t.vertices, l = this.faces, u = t.faces, c = this.colors, d = t.colors;
        e !== void 0 && (i = new Kt().getNormalMatrix(e));
        for(let h = 0, f = a.length; h < f; h++){
            let p = a[h].clone();
            e !== void 0 && p.applyMatrix4(e), o.push(p);
        }
        for(let h = 0, f = d.length; h < f; h++)c.push(d[h].clone());
        for(let h = 0, f = u.length; h < f; h++){
            let m = u[h], p, g, y = m.vertexNormals, v = m.vertexColors, x = new Vu(m.a + s, m.b + s, m.c + s);
            x.normal.copy(m.normal), i !== void 0 && x.normal.applyMatrix3(i).normalize();
            for(let w = 0, S = y.length; w < S; w++)p = y[w].clone(), i !== void 0 && p.applyMatrix3(i).normalize(), x.vertexNormals.push(p);
            x.color.copy(m.color);
            for(let w = 0, S = v.length; w < S; w++)g = v[w], x.vertexColors.push(g.clone());
            x.materialIndex = m.materialIndex + n, l.push(x);
        }
        for(let h = 0, f = t.faceVertexUvs.length; h < f; h++){
            let m = t.faceVertexUvs[h];
            this.faceVertexUvs[h] === void 0 && (this.faceVertexUvs[h] = []);
            for(let p = 0, g = m.length; p < g; p++){
                let y = m[p], v = [];
                for(let x = 0, w = y.length; x < w; x++)v.push(y[x].clone());
                this.faceVertexUvs[h].push(v);
            }
        }
    }
    mergeMesh(t) {
        if (!(t && t.isMesh)) {
            console.error("THREE.Geometry.mergeMesh(): mesh not an instance of THREE.Mesh.", t);
            return;
        }
        t.matrixAutoUpdate && t.updateMatrix(), this.merge(t.geometry, t.matrix);
    }
    mergeVertices(t = 4) {
        let e = {}, n = [], i = [], s = Math.pow(10, t);
        for(let l = 0, u = this.vertices.length; l < u; l++){
            let c = this.vertices[l], d = Math.round(c.x * s) + "_" + Math.round(c.y * s) + "_" + Math.round(c.z * s);
            e[d] === void 0 ? (e[d] = l, n.push(this.vertices[l]), i[l] = n.length - 1) : i[l] = i[e[d]];
        }
        let o = [];
        for(let l = 0, u = this.faces.length; l < u; l++){
            let c = this.faces[l];
            c.a = i[c.a], c.b = i[c.b], c.c = i[c.c];
            let d = [
                c.a,
                c.b,
                c.c
            ];
            for(let h = 0; h < 3; h++)if (d[h] === d[(h + 1) % 3]) {
                o.push(l);
                break;
            }
        }
        for(let l = o.length - 1; l >= 0; l--){
            let u = o[l];
            this.faces.splice(u, 1);
            for(let c = 0, d = this.faceVertexUvs.length; c < d; c++)this.faceVertexUvs[c].splice(u, 1);
        }
        let a = this.vertices.length - n.length;
        return this.vertices = n, a;
    }
    setFromPoints(t) {
        this.vertices = [];
        for(let e = 0, n = t.length; e < n; e++){
            let i = t[e];
            this.vertices.push(new A(i.x, i.y, i.z || 0));
        }
        return this;
    }
    sortFacesByMaterialIndex() {
        let t = this.faces, e = t.length;
        for(let l = 0; l < e; l++)t[l]._id = l;
        function n(l, u) {
            return l.materialIndex - u.materialIndex;
        }
        t.sort(n);
        let i = this.faceVertexUvs[0], s = this.faceVertexUvs[1], o, a;
        i && i.length === e && (o = []), s && s.length === e && (a = []);
        for(let l = 0; l < e; l++){
            let u = t[l]._id;
            o && o.push(i[u]), a && a.push(s[u]);
        }
        o && (this.faceVertexUvs[0] = o), a && (this.faceVertexUvs[1] = a);
    }
    toJSON() {
        let t = {
            metadata: {
                version: 4.5,
                type: "Geometry",
                generator: "Geometry.toJSON"
            }
        };
        if (t.uuid = this.uuid, t.type = this.type, this.name !== "" && (t.name = this.name), this.parameters !== void 0) {
            let m = this.parameters;
            for(let p in m)m[p] !== void 0 && (t[p] = m[p]);
            return t;
        }
        let e = [];
        for(let m = 0; m < this.vertices.length; m++){
            let p = this.vertices[m];
            e.push(p.x, p.y, p.z);
        }
        let n = [], i = [], s = {}, o = [], a = {}, l = [], u = {};
        for(let m = 0; m < this.faces.length; m++){
            let p = this.faces[m], g = !0, y = !1, v = this.faceVertexUvs[0][m] !== void 0, x = p.normal.length() > 0, w = p.vertexNormals.length > 0, S = p.color.r !== 1 || p.color.g !== 1 || p.color.b !== 1, _ = p.vertexColors.length > 0, M = 0;
            if (M = c(M, 0, 0), M = c(M, 1, g), M = c(M, 2, y), M = c(M, 3, v), M = c(M, 4, x), M = c(M, 5, w), M = c(M, 6, S), M = c(M, 7, _), n.push(M), n.push(p.a, p.b, p.c), n.push(p.materialIndex), v) {
                let b = this.faceVertexUvs[0][m];
                n.push(f(b[0]), f(b[1]), f(b[2]));
            }
            if (x && n.push(d(p.normal)), w) {
                let b = p.vertexNormals;
                n.push(d(b[0]), d(b[1]), d(b[2]));
            }
            if (S && n.push(h(p.color)), _) {
                let b = p.vertexColors;
                n.push(h(b[0]), h(b[1]), h(b[2]));
            }
        }
        function c(m, p, g) {
            return g ? m | 1 << p : m & ~(1 << p);
        }
        function d(m) {
            let p = m.x.toString() + m.y.toString() + m.z.toString();
            return s[p] !== void 0 || (s[p] = i.length / 3, i.push(m.x, m.y, m.z)), s[p];
        }
        function h(m) {
            let p = m.r.toString() + m.g.toString() + m.b.toString();
            return a[p] !== void 0 || (a[p] = o.length, o.push(m.getHex())), a[p];
        }
        function f(m) {
            let p = m.x.toString() + m.y.toString();
            return u[p] !== void 0 || (u[p] = l.length / 2, l.push(m.x, m.y)), u[p];
        }
        return t.data = {}, t.data.vertices = e, t.data.normals = i, o.length > 0 && (t.data.colors = o), l.length > 0 && (t.data.uvs = [
            l
        ]), t.data.faces = n, t;
    }
    clone() {
        return new ga().copy(this);
    }
    copy(t) {
        this.vertices = [], this.colors = [], this.faces = [], this.faceVertexUvs = [
            []
        ], this.morphTargets = [], this.morphNormals = [], this.skinWeights = [], this.skinIndices = [], this.lineDistances = [], this.boundingBox = null, this.boundingSphere = null, this.name = t.name;
        let e = t.vertices;
        for(let h = 0, f = e.length; h < f; h++)this.vertices.push(e[h].clone());
        let n = t.colors;
        for(let h = 0, f = n.length; h < f; h++)this.colors.push(n[h].clone());
        let i = t.faces;
        for(let h = 0, f = i.length; h < f; h++)this.faces.push(i[h].clone());
        for(let h = 0, f = t.faceVertexUvs.length; h < f; h++){
            let m = t.faceVertexUvs[h];
            this.faceVertexUvs[h] === void 0 && (this.faceVertexUvs[h] = []);
            for(let p = 0, g = m.length; p < g; p++){
                let y = m[p], v = [];
                for(let x = 0, w = y.length; x < w; x++){
                    let S = y[x];
                    v.push(S.clone());
                }
                this.faceVertexUvs[h].push(v);
            }
        }
        let s = t.morphTargets;
        for(let h = 0, f = s.length; h < f; h++){
            let m = {};
            if (m.name = s[h].name, s[h].vertices !== void 0) {
                m.vertices = [];
                for(let p = 0, g = s[h].vertices.length; p < g; p++)m.vertices.push(s[h].vertices[p].clone());
            }
            if (s[h].normals !== void 0) {
                m.normals = [];
                for(let p = 0, g = s[h].normals.length; p < g; p++)m.normals.push(s[h].normals[p].clone());
            }
            this.morphTargets.push(m);
        }
        let o = t.morphNormals;
        for(let h = 0, f = o.length; h < f; h++){
            let m = {};
            if (o[h].vertexNormals !== void 0) {
                m.vertexNormals = [];
                for(let p = 0, g = o[h].vertexNormals.length; p < g; p++){
                    let y = o[h].vertexNormals[p], v = {};
                    v.a = y.a.clone(), v.b = y.b.clone(), v.c = y.c.clone(), m.vertexNormals.push(v);
                }
            }
            if (o[h].faceNormals !== void 0) {
                m.faceNormals = [];
                for(let p = 0, g = o[h].faceNormals.length; p < g; p++)m.faceNormals.push(o[h].faceNormals[p].clone());
            }
            this.morphNormals.push(m);
        }
        let a = t.skinWeights;
        for(let h = 0, f = a.length; h < f; h++)this.skinWeights.push(a[h].clone());
        let l = t.skinIndices;
        for(let h = 0, f = l.length; h < f; h++)this.skinIndices.push(l[h].clone());
        let u = t.lineDistances;
        for(let h = 0, f = u.length; h < f; h++)this.lineDistances.push(u[h]);
        let c = t.boundingBox;
        c !== null && (this.boundingBox = c.clone());
        let d = t.boundingSphere;
        return d !== null && (this.boundingSphere = d.clone()), this.elementsNeedUpdate = t.elementsNeedUpdate, this.verticesNeedUpdate = t.verticesNeedUpdate, this.uvsNeedUpdate = t.uvsNeedUpdate, this.normalsNeedUpdate = t.normalsNeedUpdate, this.colorsNeedUpdate = t.colorsNeedUpdate, this.lineDistancesNeedUpdate = t.lineDistancesNeedUpdate, this.groupsNeedUpdate = t.groupsNeedUpdate, this;
    }
    toBufferGeometry() {
        let t = new Gb().fromGeometry(this), e = new Me, n = new Float32Array(t.vertices.length * 3);
        if (e.setAttribute("position", zg.call(new Be(n, 3), t.vertices)), t.normals.length > 0) {
            let i = new Float32Array(t.normals.length * 3);
            e.setAttribute("normal", zg.call(new Be(i, 3), t.normals));
        }
        if (t.colors.length > 0) {
            let i = new Float32Array(t.colors.length * 3);
            e.setAttribute("color", HC.call(new Be(i, 3), t.colors));
        }
        if (t.uvs.length > 0) {
            let i = new Float32Array(t.uvs.length * 2);
            e.setAttribute("uv", WC.call(new Be(i, 2), t.uvs));
        }
        if (t.uvs2.length > 0) {
            let i = new Float32Array(t.uvs2.length * 2);
            e.setAttribute("uv2", WC.call(new Be(i, 2), t.uvs2));
        }
        e.groups = t.groups;
        for(let i in t.morphTargets){
            let s = [], o = t.morphTargets[i];
            for(let a = 0, l = o.length; a < l; a++){
                let u = o[a], c = new Ae(u.data.length * 3, 3);
                c.name = u.name, s.push(zg.call(c, u.data));
            }
            e.morphAttributes[i] = s;
        }
        if (t.skinIndices.length > 0) {
            let i = new Ae(t.skinIndices.length * 4, 4);
            e.setAttribute("skinIndex", jC.call(i, t.skinIndices));
        }
        if (t.skinWeights.length > 0) {
            let i = new Ae(t.skinWeights.length * 4, 4);
            e.setAttribute("skinWeight", jC.call(i, t.skinWeights));
        }
        return t.boundingSphere !== null && (e.boundingSphere = t.boundingSphere.clone()), t.boundingBox !== null && (e.boundingBox = t.boundingBox.clone()), e;
    }
    computeTangents() {
        console.error("THREE.Geometry: .computeTangents() has been removed.");
    }
    computeLineDistances() {
        console.error("THREE.Geometry: .computeLineDistances() has been removed. Use THREE.Line.computeLineDistances() instead.");
    }
    applyMatrix(t) {
        return console.warn("THREE.Geometry: .applyMatrix() has been renamed to .applyMatrix4()."), this.applyMatrix4(t);
    }
    dispose() {
        this.dispatchEvent({
            type: "dispose"
        });
    }
    static createBufferGeometryFromObject(t) {
        let e = new Me, n = t.geometry;
        if (t.isPoints || t.isLine) {
            let i = new Ae(n.vertices.length * 3, 3), s = new Ae(n.colors.length * 3, 3);
            if (e.setAttribute("position", zg.call(i, n.vertices)), e.setAttribute("color", HC.call(s, n.colors)), n.lineDistances && n.lineDistances.length === n.vertices.length) {
                let o = new Ae(n.lineDistances.length, 1);
                e.setAttribute("lineDistance", k5.call(o, n.lineDistances));
            }
            n.boundingSphere !== null && (e.boundingSphere = n.boundingSphere.clone()), n.boundingBox !== null && (e.boundingBox = n.boundingBox.clone());
        } else t.isMesh && (e = n.toBufferGeometry());
        return e;
    }
};
ga.prototype.isGeometry = !0;
var Gb = class {
    constructor(){
        this.vertices = [], this.normals = [], this.colors = [], this.uvs = [], this.uvs2 = [], this.groups = [], this.morphTargets = {}, this.skinWeights = [], this.skinIndices = [], this.boundingBox = null, this.boundingSphere = null, this.verticesNeedUpdate = !1, this.normalsNeedUpdate = !1, this.colorsNeedUpdate = !1, this.uvsNeedUpdate = !1, this.groupsNeedUpdate = !1;
    }
    computeGroups(t) {
        let e = [], n, i, s, o = t.faces;
        for(i = 0; i < o.length; i++){
            let a = o[i];
            a.materialIndex !== s && (s = a.materialIndex, n !== void 0 && (n.count = i * 3 - n.start, e.push(n)), n = {
                start: i * 3,
                materialIndex: s
            });
        }
        n !== void 0 && (n.count = i * 3 - n.start, e.push(n)), this.groups = e;
    }
    fromGeometry(t) {
        let e = t.faces, n = t.vertices, i = t.faceVertexUvs, s = i[0] && i[0].length > 0, o = i[1] && i[1].length > 0, a = t.morphTargets, l = a.length, u;
        if (l > 0) {
            u = [];
            for(let y = 0; y < l; y++)u[y] = {
                name: a[y].name,
                data: []
            };
            this.morphTargets.position = u;
        }
        let c = t.morphNormals, d = c.length, h;
        if (d > 0) {
            h = [];
            for(let y = 0; y < d; y++)h[y] = {
                name: c[y].name,
                data: []
            };
            this.morphTargets.normal = h;
        }
        let f = t.skinIndices, m = t.skinWeights, p = f.length === n.length, g = m.length === n.length;
        n.length > 0 && e.length === 0 && console.error("THREE.DirectGeometry: Faceless geometries are not supported.");
        for(let y = 0; y < e.length; y++){
            let v = e[y];
            this.vertices.push(n[v.a], n[v.b], n[v.c]);
            let x = v.vertexNormals;
            if (x.length === 3) this.normals.push(x[0], x[1], x[2]);
            else {
                let S = v.normal;
                this.normals.push(S, S, S);
            }
            let w = v.vertexColors;
            if (w.length === 3) this.colors.push(w[0], w[1], w[2]);
            else {
                let S = v.color;
                this.colors.push(S, S, S);
            }
            if (s === !0) {
                let S = i[0][y];
                S !== void 0 ? this.uvs.push(S[0], S[1], S[2]) : (console.warn("THREE.DirectGeometry.fromGeometry(): Undefined vertexUv ", y), this.uvs.push(new F, new F, new F));
            }
            if (o === !0) {
                let S = i[1][y];
                S !== void 0 ? this.uvs2.push(S[0], S[1], S[2]) : (console.warn("THREE.DirectGeometry.fromGeometry(): Undefined vertexUv2 ", y), this.uvs2.push(new F, new F, new F));
            }
            for(let S = 0; S < l; S++){
                let _ = a[S].vertices;
                u[S].data.push(_[v.a], _[v.b], _[v.c]);
            }
            for(let S = 0; S < d; S++){
                let _ = c[S].vertexNormals[y];
                h[S].data.push(_.a, _.b, _.c);
            }
            p && this.skinIndices.push(f[v.a], f[v.b], f[v.c]), g && this.skinWeights.push(m[v.a], m[v.b], m[v.c]);
        }
        return this.computeGroups(t), this.verticesNeedUpdate = t.verticesNeedUpdate, this.normalsNeedUpdate = t.normalsNeedUpdate, this.colorsNeedUpdate = t.colorsNeedUpdate, this.uvsNeedUpdate = t.uvsNeedUpdate, this.groupsNeedUpdate = t.groupsNeedUpdate, t.boundingSphere !== null && (this.boundingSphere = t.boundingSphere.clone()), t.boundingBox !== null && (this.boundingBox = t.boundingBox.clone()), this;
    }
}, Vu = class {
    constructor(t, e, n, i, s, o = 0){
        this.a = t, this.b = e, this.c = n, this.normal = i && i.isVector3 ? i : new A, this.vertexNormals = Array.isArray(i) ? i : [], this.color = s && s.isColor ? s : new Ne, this.vertexColors = Array.isArray(s) ? s : [], this.materialIndex = o;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(t) {
        this.a = t.a, this.b = t.b, this.c = t.c, this.normal.copy(t.normal), this.color.copy(t.color), this.materialIndex = t.materialIndex;
        for(let e = 0, n = t.vertexNormals.length; e < n; e++)this.vertexNormals[e] = t.vertexNormals[e].clone();
        for(let e = 0, n = t.vertexColors.length; e < n; e++)this.vertexColors[e] = t.vertexColors[e].clone();
        return this;
    }
};
function k5(r1) {
    return this.array.set(r1), this;
}
function HC(r1) {
    let t = this.array, e = 0;
    for(let n = 0, i = r1.length; n < i; n++){
        let s = r1[n];
        s === void 0 && (console.warn("THREE.BufferAttribute.copyColorsArray(): color is undefined", n), s = new Ne), t[e++] = s.r, t[e++] = s.g, t[e++] = s.b;
    }
    return this;
}
function WC(r1) {
    let t = this.array, e = 0;
    for(let n = 0, i = r1.length; n < i; n++){
        let s = r1[n];
        s === void 0 && (console.warn("THREE.BufferAttribute.copyVector2sArray(): vector is undefined", n), s = new F), t[e++] = s.x, t[e++] = s.y;
    }
    return this;
}
function zg(r1) {
    let t = this.array, e = 0;
    for(let n = 0, i = r1.length; n < i; n++){
        let s = r1[n];
        s === void 0 && (console.warn("THREE.BufferAttribute.copyVector3sArray(): vector is undefined", n), s = new A), t[e++] = s.x, t[e++] = s.y, t[e++] = s.z;
    }
    return this;
}
function jC(r1) {
    let t = this.array, e = 0;
    for(let n = 0, i = r1.length; n < i; n++){
        let s = r1[n];
        s === void 0 && (console.warn("THREE.BufferAttribute.copyVector4sArray(): vector is undefined", n), s = new Ze), t[e++] = s.x, t[e++] = s.y, t[e++] = s.z, t[e++] = s.w;
    }
    return this;
}
var z5 = [
    "a",
    "b",
    "c"
];
function G5(r1, t) {
    switch(t){
        case "c":
            return r1.c;
        case "b":
            return r1.b;
        case "a":
        default:
            return r1.a;
    }
}
function Vb(r1, t, e) {
    let n = Math.min(r1, t), i = Math.max(r1, t), s = n + "_" + i;
    return e.get(s);
}
function Hb(r1, t, e, n, i, s) {
    let o = Math.min(r1, t), a = Math.max(r1, t), l = o + "_" + a, u;
    if (n.has(l)) u = n.get(l);
    else {
        let c = e[o], d = e[a];
        u = {
            a: c,
            b: d,
            newEdge: null,
            faces: []
        }, n.set(l, u);
    }
    u.faces.push(i), s[r1].edges.push(u), s[t].edges.push(u);
}
function V5(r1, t, e, n) {
    let i, s, o;
    for(i = 0, s = r1.length; i < s; i++)e[i] = {
        edges: []
    };
    for(i = 0, s = t.length; i < s; i++)o = t[i], Hb(o.a, o.b, r1, n, o, e), Hb(o.b, o.c, r1, n, o, e), Hb(o.c, o.a, r1, n, o, e);
}
function Gg(r1, t, e, n, i) {
    r1.push(new Vu(t, e, n, void 0, void 0, i));
}
function Hu(r1, t) {
    return Math.abs(t - r1) / 2 + Math.min(r1, t);
}
function Vg(r1, t, e, n) {
    r1.push([
        t.clone(),
        e.clone(),
        n.clone()
    ]);
}
var Hg = class {
    constructor(t = 1){
        this.subdivisions = t;
    }
    modify(t) {
        t instanceof Me ? t = new ga().fromBufferGeometry(t) : t = t.clone(), t.mergeVertices();
        let e = this.subdivisions;
        for(; e-- > 0;)this._smooth(t);
        return t.computeFaceNormals(), t.computeVertexNormals(), t;
    }
    _smooth(t) {
        let e = new A, n, i, s, o, a, l = t.vertices, u = t.faces, c = t.faceVertexUvs[0], d = c !== void 0 && c.length > 0, h = [], f = new Map;
        V5(l, u, h, f);
        let m = [], p, g, y, v, x, w, S;
        for (let K of Array.from(f.keys())){
            for(g = f.get(K), y = new A, x = 3 / 8, w = 1 / 8, S = g.faces.length, S != 2 && (x = .5, w = 0, S), y.addVectors(g.a, g.b).multiplyScalar(x), e.set(0, 0, 0), o = 0; o < S; o++){
                for(v = g.faces[o], a = 0; a < 3 && (p = l[G5(v, z5[a])], !(p !== g.a && p !== g.b)); a++);
                p && e.add(p);
            }
            e.multiplyScalar(w), y.add(e), g.newEdge = m.length, m.push(y);
        }
        let _, M, b, T, E, P, D, C = [];
        for(i = 0, s = l.length; i < s; i++){
            for(P = l[i], E = h[i].edges, n = E.length, n == 3 ? _ = 3 / 16 : n > 3 && (_ = 3 / (8 * n)), M = 1 - n * Number(_), b = _, n <= 2 && (n == 2 ? (M = 3 / 4, b = 1 / 8) : n == 1 || n), D = P.clone().multiplyScalar(M), e.set(0, 0, 0), o = 0; o < n; o++)T = E[o], p = T.a !== P ? T.a : T.b, e.add(p);
            e.multiplyScalar(Number(b)), D.add(e), C.push(D);
        }
        let O = C.concat(m), B = C.length, V, Y, W, q = [], j = [], X, L, U, G, H = new F, z = new F, re = new F;
        for(i = 0, s = u.length; i < s; i++)v = u[i], V = Number(Vb(v.a, v.b, f).newEdge) + B, Y = Number(Vb(v.b, v.c, f).newEdge) + B, W = Number(Vb(v.c, v.a, f).newEdge) + B, Gg(q, V, Y, W, v.materialIndex), Gg(q, v.a, V, W, v.materialIndex), Gg(q, v.b, Y, V, v.materialIndex), Gg(q, v.c, W, Y, v.materialIndex), d && (X = c[i], L = X[0], U = X[1], G = X[2], H.set(Hu(L.x, U.x), Hu(L.y, U.y)), z.set(Hu(U.x, G.x), Hu(U.y, G.y)), re.set(Hu(L.x, G.x), Hu(L.y, G.y)), Vg(j, H, z, re), Vg(j, L, H, re), Vg(j, U, z, H), Vg(j, G, re, z));
        t.vertices = O, t.faces = q, d && (t.faceVertexUvs[0] = j);
    }
};
var qn = new A, qC = class {
    static create(r1) {
        return this.build(this.normalizeInputs(r1));
    }
    static normalizeInputs(r1, t) {
        let e = r1.geometry ?? t?.geometry ?? new Me().copy(new er(100, 100, 100)), n;
        t === void 0 ? (e.computeBoundingBox(), e.boundingBox.getSize(qn), n = {
            width: qn.x,
            height: qn.y,
            depth: qn.z,
            subdivisions: 0
        }) : n = t.parameters;
        let i = {
            ...n,
            ...r1.parameters
        };
        return {
            parameters: {
                width: Math.abs(i.width),
                height: Math.abs(i.height),
                depth: Math.abs(i.depth),
                subdivisions: Math.abs(i.subdivisions)
            },
            geometry: e
        };
    }
    static build(r1) {
        let { width: t , height: e , depth: n , subdivisions: i  } = r1.parameters, s = r1.geometry ?? new Me().copy(new er(100, 100, 100)), o = s.userData.parameters;
        o === void 0 ? (s.computeBoundingBox(), s.boundingBox.getSize(qn)) : qn.set(o.width, o.height, o.depth), (t !== qn.x || e !== qn.y || n !== qn.z) && s.scale(qn.x === 0 ? 1 : t / qn.x, qn.y === 0 ? 1 : e / qn.y, qn.z === 0 ? 1 : n / qn.z);
        let a = s.originalGeometry;
        try {
            i > 0 ? (a === void 0 || o?.subdivisions !== i) && (a === void 0 && (a = s), s = new Hg(i).modify(a).toBufferGeometry()) : (a !== void 0 && (s = a), a = void 0, s.getAttribute("normal") === void 0 && s.computeVertexNormals());
        } catch  {
            a !== void 0 && (s = a), a = void 0, s.getAttribute("normal") === void 0 && s.computeVertexNormals();
        }
        return a !== void 0 && Object.assign(s, {
            originalGeometry: a
        }), delete r1.geometry, Object.assign(s, {
            userData: {
                ...r1,
                type: "NonParametricGeometry"
            }
        });
    }
    static loadFromUrl(r1, t, e) {
        new wc(e).load(r1, (i)=>{
            let s = this.normalizeInputs({
                geometry: i
            });
            i.boundingBox.getSize(qn);
            let o = 100 / qn.x;
            Object.assign(s.parameters, {
                width: 100,
                height: qn.y * o,
                depth: qn.z * o
            }), t(this.build(s));
        });
    }
};
var Wg = class {
    static create(r1) {
        return this.build(this.normalizeInputs(r1));
    }
    static normalizeInputs(r1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            depth: 0,
            spikes: 5,
            cornerRadius: 0,
            extrudeBevelSize: 0,
            extrudeBevelSegments: 3
        }, r1.parameters);
        return {
            shape: r1.shape && r1.shape instanceof Tt ? r1.shape : new Tt,
            parameters: Object.assign(e, {
                width: Math.abs(e.width),
                height: Math.abs(e.height ?? e.width),
                depth: Math.abs(e.depth ?? 0)
            })
        };
    }
    static build(r1) {
        let { width: t , height: e , spikes: n , cornerRadius: i , depth: s , extrudeBevelSize: o , extrudeBevelSegments: a  } = r1.parameters, l = r1.shape, u = t * .5, c = e * .5, d = 0, h = 0, f = 2 * Math.PI / n;
        for(let p = 0; p < n; p++){
            let g = f * p, y = d + Math.sin(g) * u, v = h + Math.cos(g) * c;
            l.addPoint(l.createPoint(y, v));
        }
        l.isClosed = !0;
        for(let p = 0, g = l.points.length; p < g; p++)l.points[p].roundness = i;
        l.roundness = i, l.update();
        let m = Xr.create({
            shape: l,
            parameters: {
                roundness: i,
                depth: s,
                extrudeBevelSize: o,
                extrudeBevelSegments: a
            }
        });
        return Object.assign(m, {
            userData: {
                ...r1,
                type: "PolygonGeometry"
            }
        });
    }
};
var XC = class {
    static create(r1) {
        return this.build(this.normalizeInputs(r1));
    }
    static normalizeInputs(r1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            radialSegments: 4,
            heightSegments: 1,
            cornerRadius: 0,
            cornerSegments: 8,
            openEnded: !1
        }, r1.parameters);
        return {
            parameters: Object.assign(e, {
                width: Math.abs(e.width),
                height: Math.abs(e.height ?? e.width),
                depth: Math.abs(e.depth ?? e.width)
            })
        };
    }
    static build(r1) {
        let { width: t , height: e , depth: n , radialSegments: i , heightSegments: s , openEnded: o , cornerRadius: a , cornerSegments: l  } = r1.parameters, u = new jb(t * .5, e, i, s, o, a, l);
        return u.scale(1, 1, n / t), Object.assign(u, {
            userData: {
                ...r1,
                type: "PyramidGeometry"
            }
        });
    }
};
function mf(r1, t, e) {
    e.x = r1.x * t.x, e.y = r1.y, e.z = r1.x * t.y;
}
function Wb(r1, t, e, n, i, s) {
    let o = t.clone().sub(r1), a = e.clone().sub(r1), l = o.angleTo(a);
    if (o.normalize(), a.normalize(), n === i) {
        let u = o.add(a).normalize();
        s.copy(r1).addScaledVector(u, n / Math.sin(l / 2));
    } else {
        let u = o.angleTo(a);
        s.copy(r1), s.addScaledVector(o, i / Math.sin(u)), s.addScaledVector(a, n / Math.sin(u));
    }
}
function H5(r1, t, e) {
    let n = r1.clone().sub(t), i = e.clone().sub(t);
    return n.projectOnVector(i), n.add(t);
}
var jb = class extends Me {
    constructor(t = .5, e = 1, n = 4, i = 1, s = !1, o = 0, a = 4){
        super(), n = Math.floor(Math.max(3, n)), i = Math.floor(i), a = Math.floor(a);
        let l = [], u = [], c = [], d = [], h = 0, f = e / 2, m = Math.PI / n, p = t * Math.cos(Math.PI / n), g = 2 * Math.PI / n, y = (n - 2) * Math.PI / n, v = Math.PI - y, x = new A(0, -f, 0), w = new A(0, f, 0), S = new F(t, -f), _ = new F(p, -f), M = new F(0, w.y).sub(_), b = new F(0, w.y).sub(S), T = new F(M.y, -M.x).normalize(), E = new F(b.y, -b.x).normalize(), D = t * Math.cos(Math.PI / n) * Math.tan((Math.PI - M.angle()) / 2) - 1e-8;
        o = Math.min(o, D);
        let C;
        {
            let j = new A(T.x, T.y, 0), X = new A(Math.cos(g) * j.x, j.y, Math.sin(g) * j.x);
            C = j.angleTo(X);
        }
        let O = o / Math.tan((Math.PI - M.angle()) / 2), B = o / Math.tan((Math.PI - C) / 2), V = new A;
        if (!s) {
            u.push(x.x, x.y, x.z), c.push(0, -1, 0), d.push(0, 0);
            let j = h++, X = [], L = S.clone(), U = O / Math.cos(Math.PI / n);
            L.x -= U;
            for(let G = 0; G < n; G++){
                let H = G / n * Math.PI * 2 + m, z = new F(Math.sin(H), Math.cos(H));
                mf(L, z, V), u.push(V.x, V.y, V.z), c.push(0, -1, 0), d.push(0, 0), X.push(h++);
            }
            for(let G = 0; G < X.length; G++)l.push(X[G], j, X[(G + 1) % X.length]);
        }
        let Y = [];
        {
            let j = new A, X = new A, L = new A, U = new A, G = new A, H = new A;
            for(let z = 0; z < n; z++){
                let re = z / n * Math.PI * 2 + m, K = (z + .5) / n * Math.PI * 2 + m, Z = (z + 1) / n * Math.PI * 2 + m, k = new F(Math.sin(re), Math.cos(re)), he = new F(Math.sin(K), Math.cos(K)), fe = new F(Math.sin(Z), Math.cos(Z));
                mf(S, k, X), mf(S, fe, L), mf(T, he, j), Wb(w, X, L, B, B, U), u.push(U.x, U.y, U.z), Wb(X, w, L, B, O, G), u.push(G.x, G.y, G.z), Wb(L, X, w, O, B, H), u.push(H.x, H.y, H.z), c.push(j.x, j.y, j.z), c.push(j.x, j.y, j.z), c.push(j.x, j.y, j.z), d.push(0, 0), d.push(0, 0), d.push(0, 0);
                let ce = h++, ye = h++, Se = h++;
                if (l.push(ce, ye, Se), o > 0) {
                    {
                        let Ee = X.clone().add(L).multiplyScalar(.5), we = w.clone().sub(Ee).normalize(), gt = x.clone().sub(Ee).normalize().add(we).normalize().multiplyScalar(-1), R = H.clone().sub(G);
                        W(Ee, R, gt, M.angle());
                    }
                    let ve, Te;
                    {
                        let Ee = new A;
                        mf(E, fe, Ee);
                        let we = H.clone().add(U).multiplyScalar(.5);
                        we = H5(we, L, w);
                        let Ge = H.clone().sub(U);
                        [ve, Te] = W(we, Ge, Ee, C, U.y);
                    }
                    {
                        let Ee = ve, we = Ee.clone().setY(0).normalize(), Ge = new A(0, -1, 0), gt = we.clone().cross(Ge);
                        q(Ee, we, Ge, gt);
                    }
                    Y.concat(Te);
                    {
                        let Ee = M.angle(), we = Math.PI - Ee, Ge = w.clone();
                        Ge.y -= o / Math.sin(Ee - Math.PI / 2);
                        let gt = new A, R = [];
                        for(let ee = 0; ee < a; ee++){
                            let pe = [], xe = Math.PI / 2 - we * ee / a, Ce = Math.cos(xe), Ve = Math.sin(xe), Pe = K;
                            for(let de = 0; de <= ee; de++){
                                let qe = Math.cos(Pe), Re = Math.sin(Pe);
                                j.x = Ce * Re, j.y = Ve, j.z = Ce * qe, gt.copy(Ge).addScaledVector(j, o), u.push(gt.x, gt.y, gt.z), c.push(j.x, j.y, j.z), d.push(0, 0), pe.push(h++), Pe += Math.PI * 2 / ee / n;
                            }
                            R.push(pe);
                        }
                        Te.reverse(), R.push(Te);
                        let I = R.length - 1;
                        for(let ee = 0; ee < I; ee++){
                            let pe = R[ee], xe = R[ee + 1], Ce = pe.length - 1;
                            l.push(xe[1], pe[0], xe[0]);
                            for(let Ve = 1; Ve <= Ce; Ve++)l.push(pe[Ve], pe[Ve - 1], xe[Ve]), l.push(xe[Ve + 1], pe[Ve], xe[Ve]);
                        }
                    }
                }
            }
        }
        this.setIndex(l), this.setAttribute("position", new Ae(u, 3)), this.setAttribute("normal", new Ae(c, 3)), this.setAttribute("uv", new Ae(d, 2));
        function W(j, X, L, U, G) {
            let H = -U / 2, z = (Math.PI - U) / 2, re = X.clone().normalize().cross(L);
            j.addScaledVector(L, -o / Math.sin(z));
            let K = new A, Z = new A, k = 1, he = h, fe = [];
            for(let ce = 0; ce <= a; ce++){
                let ye = H + ce / a * U;
                Z.set(0, 0, 0), Z.addScaledVector(re, Math.sin(ye)), Z.addScaledVector(L, Math.cos(ye));
                for(let Se = 0; Se <= k; Se++){
                    let ve = Se / k - .5;
                    if (K.copy(j), K.addScaledVector(X, ve), K.addScaledVector(Z, o), G != null) {
                        let Te = Math.max(0, K.y - G);
                        K.addScaledVector(X, -Te / X.y);
                    }
                    u.push(K.x, K.y, K.z), c.push(Z.x, Z.y, Z.z), d.push(0, 0), Se === 0 && fe.push(h), h++;
                }
            }
            for(let ce = 0; ce < a; ce++)for(let ye = 0; ye < k; ye++){
                let Se = he + ye + (k + 1) * ce, ve = Se + (k + 1), Te = ve + 1, Ee = Se + 1;
                l.push(Se, ve, Ee), l.push(ve, Te, Ee);
            }
            return [
                j.clone().addScaledVector(X, .5),
                fe
            ];
        }
        function q(j, X, L, U) {
            let G = Math.PI / 2, H = b.angle() - G, z = [], re = new A, K = new A;
            for(let k = 0; k <= a; k++){
                let he = [], fe = k / a;
                for(let ce = 0; ce <= k; ce++){
                    let Se = ((k ? ce / k : 0) - .5) * v, ve = Math.cos(Se), Te = Math.sin(Se), Ee = Math.atan(Math.tan(H) * ve), we = (G + Ee) * fe, Ge = Math.cos(we), gt = Math.sin(we);
                    re.set(0, 0, 0), re.addScaledVector(X, gt * ve), re.addScaledVector(L, Ge), re.addScaledVector(U, gt * Te), K.copy(j).addScaledVector(re, o), u.push(K.x, K.y, K.z), c.push(re.x, re.y, re.z), d.push(0, 0), he.push(h++);
                }
                z.push(he);
            }
            let Z = z.length - 1;
            for(let k = 0; k < Z; k++){
                let he = z[k], fe = z[k + 1], ce = he.length - 1;
                l.push(he[0], fe[1], fe[0]);
                for(let ye = 1; ye <= ce; ye++)l.push(he[ye - 1], he[ye], fe[ye]), l.push(he[ye], fe[ye + 1], fe[ye]);
            }
        }
    }
};
var jg = class {
    static create(r1) {
        return this.build(this.normalizeInputs(r1));
    }
    static normalizeInputs(r1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            depth: 0,
            cornerRadius: [
                0,
                0,
                0,
                0
            ],
            cornerType: 1,
            extrudeBevelSize: 0,
            extrudeBevelSegments: 1
        }, r1.parameters), n = Object.assign(t?.ui ?? {
            enabledIndieCorners: !1
        }, r1.ui);
        return {
            shape: r1.shape && r1.shape instanceof Tt ? r1.shape : new Tt,
            parameters: Object.assign(e, {
                width: Math.abs(e.width),
                height: Math.abs(e.height ?? e.width),
                depth: Math.abs(e.depth ?? 0)
            }),
            ui: n
        };
    }
    static build(r1) {
        let t = r1.shape, { width: e , height: n , cornerRadius: i , cornerType: s , depth: o , extrudeBevelSize: a , extrudeBevelSegments: l  } = r1.parameters, u = {
            x: e * .5,
            y: n * .5
        }, c = {
            x: -u.x,
            y: -u.y
        }, d = {
            x: u.x,
            y: u.y
        };
        function h(w, S, _) {
            return S > e && _ > n ? Math.min(w * e / S, w * n / _) : S > e ? w * e / S : _ > n ? w * n / _ : w;
        }
        let f = [];
        f[0] = i[0] === 0 ? 0 : h(i[0], i[0] + i[3], i[0] + i[1]), f[1] = i[1] === 0 ? 0 : h(i[1], i[1] + i[2], i[1] + i[0]), f[2] = i[2] === 0 ? 0 : h(i[2], i[2] + i[1], i[2] + i[3]), f[3] = i[3] === 0 ? 0 : h(i[3], i[3] + i[0], i[3] + i[2]);
        let m = c.x, p = d.x, g = d.y, y = c.y;
        t.addPoint(t.createPoint(m, g)), t.addPoint(t.createPoint(p, g)), t.addPoint(t.createPoint(p, y)), t.addPoint(t.createPoint(m, y)), t.isClosed = !0;
        let v = !0;
        for(let w = 0, S = t.points.length; w < S; w++)t.points[w].roundness = f[w], w > 0 && f[w] !== f[w - 1] && (v = !1);
        v && (t.roundness = f[0]), t.useCubicForRoundedCorners = s !== 1, t.update();
        let x = Xr.create({
            shape: t,
            parameters: {
                depth: o,
                extrudeBevelSize: a,
                extrudeBevelSegments: l
            }
        });
        return Object.assign(x, {
            userData: {
                ...r1,
                type: "RectangleGeometry"
            }
        });
    }
};
var YC = class {
    static create(r1) {
        return this.build(this.normalizeInputs(r1));
    }
    static normalizeInputs(r1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            widthSegments: 64,
            heightSegments: 64,
            phiStart: 0,
            phiLength: 2 * Math.PI,
            thetaStart: 0,
            thetaLength: Math.PI
        }, r1.parameters);
        return {
            parameters: Object.assign(e, {
                width: Math.abs(e.width),
                height: Math.abs(e.height ?? e.width),
                depth: Math.abs(e.depth ?? e.width)
            })
        };
    }
    static build(r1) {
        let { width: t = 100 , height: e = t , depth: n = t , widthSegments: i = 64 , heightSegments: s = 64 , phiStart: o , phiLength: a , thetaStart: l , thetaLength: u  } = r1.parameters, c = new $a(.5 * t, i, s, o, a, l, u);
        return c.scale(1, e / t, n / t), Object.assign(c, {
            userData: {
                ...r1,
                type: "SphereGeometry"
            }
        });
    }
};
var QC = class {
    static create(r1) {
        return this.build(this.normalizeInputs(r1));
    }
    static normalizeInputs(r1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            depth: 0,
            widthSegments: 8,
            heightSegments: 8
        }, r1.parameters);
        return {
            parameters: Object.assign(e, {
                width: Math.abs(e.width),
                height: Math.abs(e.height ?? e.width),
                depth: 0
            })
        };
    }
    static build(r1) {
        let { width: t = 100 , height: e = t , widthSegments: n = 8 , heightSegments: i = 8  } = r1.parameters, s = new so(t, e, n, i);
        return s.scale(1, 1, 1), Object.assign(s, {
            userData: {
                ...r1,
                type: "PlaneGeometry"
            }
        });
    }
};
var KC = class {
    static create(r1) {
        return this.build(this.normalizeInputs(r1));
    }
    static normalizeInputs(r1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            angle: 90,
            cornerRadius: 24,
            cornerSegments: 8
        }, r1.parameters);
        return {
            parameters: Object.assign(e, {
                width: Math.abs(e.width),
                height: Math.abs(e.height ?? e.width),
                depth: Math.abs(e.depth ?? e.width)
            })
        };
    }
    static build(r1) {
        let { width: t , height: e , depth: n , angle: i , cornerRadius: s , cornerSegments: o  } = r1.parameters, a = new qb(t, e, n, i, s, o);
        return Object.assign(a, {
            userData: {
                ...r1,
                type: "BackdropGeometry"
            }
        });
    }
}, qb = class extends Me {
    constructor(t = 1, e = 1, n = 1, i = 90, s = 10, o = 24){
        super(), this.type = "BackdropGeometry";
        let a = [], l = [], u = [], c = .001;
        s == 0 && (o = 1), o = Math.max(1, Math.floor(o)), s = Math.min(s, 100), i = Math.min(180 - c, i), i *= Math.PI / 180;
        let d = [], h = Math.PI / 2, f = (K = 0, Z = 0, k = 0)=>new A(K, Z, k), m = f(), p = f(), [g, y, v] = [
            e / 2,
            t / 2,
            n / 2
        ], x = -y, w = +y, [S, _, M] = [
            f(x, -g, +v),
            f(x, -g, -v),
            f(x, +g, -v)
        ], b = (K, Z = !1)=>Math.sin(K - Math.PI / (1 + +Z)), T = (K, Z = !1)=>Math.cos(K - Math.PI / (1 + +Z));
        M.y = Math.sin(i) * e - g;
        let E = Math.cos(i) * e - v, P = S.z - c;
        i <= h ? (M.z = Math.min(E, P), M.z == P && (M.y -= (E - P) / Math.tan(h - i))) : _.z = Math.min(_.z - E - v, S.z - c), m.subVectors(S, _), p.subVectors(M, _);
        let D = Math.min(m.length(), p.length()) * s / 100, C = D * Math.tan(i / 2), O = D / Math.cos(i / 2), B = m.clone().normalize().add(p.normalize()).setLength(O).add(_);
        m.set(0, b(i, !0), T(i, !0)), d.push([
            M,
            m.clone()
        ]);
        let V = (Math.PI - i) / o;
        for(let K = 0; K <= o; K++){
            let Z = h + i + K * V;
            m.set(0, Math.sin(Z) * C, Math.cos(Z) * C), m.add(B), p.set(0, b(Z), T(Z)), d.push([
                m.clone(),
                p.clone()
            ]);
        }
        d.push([
            S,
            f(0, 1, 0)
        ]);
        let Y = Math.sin(V / 2) * C * 2, W = d.length - 1, q = d[0][0].distanceTo(d[1][0]), j = d[W - 1][0].distanceTo(d[W][0]), X = q + Y * o + j;
        d[0].push(1);
        for(let K = 0; K <= o; K++)d[K + 1].push(1 - (q + K * Y) / X);
        d[W].push(0);
        let [L, U, G] = d[0], H, z, re;
        for(let K = 1; K < d.length; K++)[H, z, re] = d[K], a.push(x, L.y, L.z, x, H.y, H.z, w, L.y, L.z, w, L.y, L.z, x, H.y, H.z, w, H.y, H.z), l.push(0, U.y, U.z, 0, z.y, z.z, 0, U.y, U.z, 0, U.y, U.z, 0, z.y, z.z, 0, z.y, z.z), u.push(0, G, 0, re, 1, G, 1, G, 0, re, 1, re), [L, U, G] = [
            H,
            z,
            re
        ];
        this.setAttribute("position", new Ae(a, 3)), this.setAttribute("normal", new Ae(l, 3)), this.setAttribute("uv", new Ae(u, 2));
    }
};
var qg = class {
    static create(r1) {
        return this.build(this.normalizeInputs(r1));
    }
    static normalizeInputs(r1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            depth: 0,
            innerRadiusPercent: 38.19,
            spikes: 5,
            cornerRadius: 0,
            angle: 360,
            extrudeBevelSize: 0,
            extrudeBevelSegments: 1
        }, r1.parameters);
        return {
            shape: r1.shape && r1.shape instanceof Tt ? r1.shape : new Tt,
            parameters: Object.assign(e, {
                width: Math.abs(e.width),
                height: Math.abs(e.height ?? e.width),
                depth: Math.abs(e.depth ?? 0)
            })
        };
    }
    static build(r1) {
        let { width: t , height: e , innerRadiusPercent: n , spikes: i , cornerRadius: s , angle: o , depth: a , extrudeBevelSize: l , extrudeBevelSegments: u  } = r1.parameters, c = r1.shape, d = t * .5, h = e * .5, f = 0, m = 0, p = o * Math.PI / 360 / i, g = Math.PI / 2 * -3, y = d * n / 100, v = h * n / 100;
        if (i === 3 && n === 50) {
            p = 2 * Math.PI / i;
            for(let w = 0; w < i; w++){
                let S = p * w, _ = f + Math.sin(S) * d, M = m + Math.cos(S) * h;
                c.addPoint(c.createPoint(_, M));
            }
        } else for(let w = 0; w < i; w++){
            let S = f + Math.cos(g) * d, _ = m + Math.sin(g) * h;
            c.addPoint(c.createPoint(S, _)), g += p, S = f + Math.cos(g) * y, _ = m + Math.sin(g) * v, c.addPoint(c.createPoint(S, _)), g += p;
        }
        c.isClosed = !0;
        for(let w = 0, S = c.points.length; w < S; w++)c.points[w].roundness = s;
        c.roundness = s, c.update();
        let x = Xr.create({
            shape: c,
            parameters: {
                roundness: s,
                depth: a,
                extrudeBevelSize: l,
                extrudeBevelSegments: u
            }
        });
        return Object.assign(x, {
            userData: {
                ...r1,
                type: "StarGeometry"
            }
        });
    }
};
var ZC = class {
    static create(r1) {
        return this.build(this.normalizeInputs(r1));
    }
    static normalizeInputs(r1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            depth: 0
        }, r1.parameters);
        return {
            parameters: Object.assign(e, {
                width: Math.abs(e.width),
                height: Math.abs(e.height ?? e.width),
                depth: Math.abs(e.depth ?? 0)
            })
        };
    }
    static build(r1) {
        let { width: t , height: e  } = r1.parameters, n = new so(t, e);
        return Object.assign(n, {
            userData: {
                ...r1,
                type: "TextFrameGeometry"
            }
        });
    }
};
var JC = class {
    static create(r1) {
        return this.build(this.normalizeInputs(r1));
    }
    static normalizeInputs(r1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            radialSegments: 32,
            tubularSegments: 64,
            arc: Math.PI * 2,
            cornerRadius: 30,
            cornerSegments: 8
        }, r1.parameters), n = Math.abs(e.width), i = Math.abs(e.height ?? e.width), s = Math.round(Math.abs(e.depth ?? e.width * .25));
        return {
            parameters: Object.assign(e, {
                width: n,
                height: i,
                depth: s
            })
        };
    }
    static build(r1) {
        let { width: t , height: e , depth: n , radialSegments: i , tubularSegments: s , arc: o , cornerRadius: a , cornerSegments: l  } = r1.parameters, u = W5(t, e, n, t * .5, o, s, 0, 0, i, a, l);
        return u.scale(1, e / t, 1), Object.assign(u, {
            userData: {
                ...r1,
                type: "TorusGeometry"
            }
        });
    }
};
function W5(r1, t, e, n, i, s, o, a, l, u, c) {
    return [t, e] = [
        e,
        t
    ], o = t / 2, i /= 2 * Math.PI, i == 1 && (u = 0), new ff(!0, r1, t, e, n, i, s, o, a, l, u, c);
}
var $C = class {
    static create(r1) {
        return this.build(this.normalizeInputs(r1));
    }
    static normalizeInputs(r1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            tubularSegments: 64,
            radialSegments: 32,
            p: 2,
            q: 3
        }, r1.parameters);
        return {
            parameters: Object.assign(e, {
                width: Math.abs(e.width),
                height: Math.abs(e.height ?? e.width),
                depth: Math.abs(e.depth ?? e.width),
                tube: e.tube ?? e.width * .125
            })
        };
    }
    static build(r1) {
        let { width: t , tube: e , tubularSegments: n , radialSegments: i , p: s , q: o  } = r1.parameters, a = t * .5;
        a !== e && (a -= e);
        let l = new yc(a, e, n, i, s, o);
        return Object.assign(l, {
            userData: {
                ...r1,
                type: "TorusKnotGeometry"
            }
        });
    }
};
var eP = class {
    static create(r1) {
        return this.build(this.normalizeInputs(r1));
    }
    static normalizeInputs(r1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            depth: 0,
            spikes: 5,
            cornerRadius: 0,
            extrudeBevelSize: 0,
            extrudeBevelSegments: 1,
            isRect: !1
        }, r1.parameters);
        return {
            shape: r1.shape && r1.shape instanceof Tt ? r1.shape : new Tt,
            parameters: Object.assign(e, {
                width: Math.abs(e.width),
                height: Math.abs(e.height ?? e.width * (e.isRect ? 1 : Math.sqrt(3) / 2)),
                depth: Math.abs(e.depth ?? 0)
            })
        };
    }
    static build(r1) {
        let { width: t = 100 , height: e , cornerRadius: n , depth: i , extrudeBevelSize: s , extrudeBevelSegments: o , isRect: a  } = r1.parameters, l = r1.shape, u = t * .5, c = e * .5;
        a ? (l.addPoint(l.createPoint(-u, c)), l.addPoint(l.createPoint(u, -c)), l.addPoint(l.createPoint(-u, -c))) : (l.addPoint(l.createPoint(0, c)), l.addPoint(l.createPoint(u, -c)), l.addPoint(l.createPoint(-u, -c))), l.isClosed = !0;
        for(let h = 0, f = l.points.length; h < f; h++)l.points[h].roundness = n;
        l.roundness = n, l.update();
        let d = Xr.create({
            shape: l,
            parameters: {
                roundness: n,
                depth: i,
                extrudeBevelSize: s,
                extrudeBevelSegments: o
            }
        });
        return Object.assign(d, {
            userData: {
                ...r1,
                type: "TriangleGeometry"
            }
        });
    }
};
function tP(r1, t) {
    let e = 2 * Math.PI;
    return (r1 % e + e) % e === (t % e + e) % e;
}
function j5(r1, t, e) {
    let n = [
        new A,
        new A,
        new A
    ], i = [
        new A,
        new A,
        new A
    ];
    return r1.extractBasis(n[0], n[1], n[2]), t.extractBasis(i[0], i[1], i[2]), n.forEach((s, o)=>{
        let a = i[o], l = He.lerp(s.length(), a.length(), e);
        s.lerp(a, e).setLength(l);
    }), new ae().makeBasis(n[0], n[1], n[2]);
}
var nP = class {
    static create(r1) {
        return this.build(this.normalizeInputs(r1));
    }
    static normalizeInputs(r1, t) {
        let e = Object.assign({}, t?.parameters ?? {
            width: 100,
            height: 100,
            depth: 1,
            subdivisions: 12,
            roundness: 0,
            extrudeBevelSize: 0,
            extrudeBevelSegments: 3
        }, r1.parameters), n = Math.abs(e.width), i = Math.abs(e.height ?? e.width), s = Math.abs(e.depth ?? 0), o = t?.shapeData ?? Gu.create({
            parameters: Jx
        }).userData.shape;
        return {
            path: r1.path ?? du.defaultData(),
            parameters: Object.assign(e, {
                width: n,
                height: i,
                depth: s,
                extrusion: {
                    ...fg,
                    ...e.extrusion
                }
            }),
            shapeData: o
        };
    }
    static build(r1) {
        if (r1.path.points.length >= 2) {
            let e = new Xb(r1);
            return Object.assign(e, {
                userData: {
                    ...r1,
                    type: "PathGeometry"
                }
            });
        } else return Object.assign(new Me, {
            userData: {
                ...r1,
                type: "PathGeometry"
            }
        });
    }
}, Xb = class extends Me {
    constructor(e){
        super();
        this.type = "PathExtrusionGeometry", this.inputs = e, this.build();
    }
    _isGeometryClosed() {
        return this.inputs.path.isClosed && this.inputs.parameters.extrusion.depth === 1;
    }
    _isOpenEnded() {
        let e = this.inputs.parameters.extrusion;
        return !(this.inputs.path.isClosed && e.depth === 1) || !tP(e.twist, 0) || e.startScale !== e.endScale;
    }
    build() {
        let e = this._extractPathPoints();
        if (e.length < 2) return;
        let n = this._computeBasisMatrices(e), { depth: i , offset: s  } = this.inputs.parameters.extrusion, o = this.inputs.path.isClosed ? e.length : e.length - 1, a = Math.floor(s * o), l = this.inputs.path.isClosed ? Math.ceil((i + s) * o) : Math.ceil(Math.min(1, i + s) * o), u = Math.min(Math.max(2, l - a + 1), o + 2), c = [], d = [];
        for(let D = 0; D < u; D++){
            let C = this.inputs.path.isClosed ? (D + a) % e.length : Math.min(D + a, e.length - 1);
            c.push(e[C].clone()), d.push(n[C].clone());
        }
        let h = (D, C, O)=>{
            c[D] = c[D].clone().lerp(c[C], O), d[D] = j5(d[D], d[C], O);
        }, f = 0, m = s * o % 1;
        (!this.inputs.path.isClosed || i <= 1) && (m || s === 0) && (f = m, h(0, 1, f));
        let p = 0, g = (s + i) * o % 1;
        if ((this.inputs.path.isClosed && i <= 1 || !this.inputs.path.isClosed && s + i < 1) && g && (p = g, h(c.length - 1, c.length - 2, 1 - p)), i === 0) {
            let D = c.length - 1;
            c[D].copy(c[0]), d[D].copy(d[0]);
        }
        this._applyPathModifiers(d, f, p);
        let { regions: y , infos: v , vertices: x  } = this._computeShapePoints(5), w = 0, S = 0;
        v.sort((D, C)=>D.start - C.start), v.forEach((D)=>{
            D.verticesStart = w, D.verticesCount = D.continuous.reduce((C, O, B)=>C + (B === 0 || !O ? 2 : 1), 0), S += D.verticesCount, w = S;
        });
        let _ = S * u, M, b = 0;
        if (this._isOpenEnded()) {
            try {
                M = Zi({
                    windingRule: mt.ODD,
                    elementType: sn.POLYGONS,
                    polySize: 3,
                    vertexSize: 2,
                    strict: !0,
                    contours: y
                });
            } catch  {
                M = Ub;
            }
            b = M.vertexCount;
        }
        let T = _ + 2 * b, E = {
            positions: new Float32Array(T * 3),
            normals: new Float32Array(T * 3),
            uvs: new Float32Array(T * 2)
        }, P = [];
        v.forEach((D)=>{
            this._extrudeRegion(D, x, d, c, E, P, this._isGeometryClosed() && !this._isOpenEnded());
        }), M && (this._closeEnd(M, _, P, E, d[0], c[0], !1), this._closeEnd(M, _ + b, P, E, d[d.length - 1], c[c.length - 1], !0)), this.setAttribute("position", new Be(E.positions, 3)), this.setAttribute("normal", new Be(E.normals, 3)), this.setAttribute("uv", new Be(E.uvs, 2)), this.setIndex(P);
    }
    _extractPathPoints() {
        let n = Og(this.inputs.path).getPoints(this.inputs.path.subdivisions);
        if (n.length < 2) return [];
        let i = [
            n[0]
        ];
        return n.forEach((o)=>{
            i[i.length - 1].distanceToSquared(o) > .001 && i.push(o);
        }), this.inputs.path.isClosed && i[i.length - 1].distanceTo(i[0]) < .001 && i.pop(), i;
    }
    _computeBasisMatrices(e) {
        let n = [], i = e.length, s = this.inputs.path.isClosed, o = new A, a = new A, l = new A, u = new A, c = new A(0, 1, 0);
        for(let g = 0; g < i; g++){
            let y = e[g], v;
            g === 0 ? v = s ? e[e.length - 2] : y.clone().multiplyScalar(2).sub(e[1]) : v = e[g - 1];
            let x;
            g === i - 1 ? x = s ? e[1] : y.clone().multiplyScalar(2).sub(e[g - 1]) : x = e[g + 1];
            let w = y.clone().sub(v).normalize(), S = x.clone().sub(y).normalize(), _ = w.clone().add(S).normalize();
            l.copy(_), g === 0 && (_.equals(c) || _.clone().negate().equals(c)) && c.set(0, 0, 1);
            let M = c.clone().cross(_).normalize(), b = _.clone().cross(M).normalize();
            c.copy(b), u.copy(M), g === 0 && (o.copy(b), a.copy(_));
            let T = new ae().makeBasis(M, b, _);
            n.push(T);
        }
        let d = s ? a : l, h = s ? o : new A(0, 1, 0), f = d.clone().cross(u).normalize(), m = Math.acos(h.dot(f));
        if (isNaN(m)) return n;
        let p = h.clone().cross(f);
        d.dot(p) > 0 && (m *= -1);
        for(let g = 1; g < n.length; g++){
            let y = new ae().makeRotationZ(m * g / n.length);
            n[g].multiply(y);
        }
        return n;
    }
    _applyPathModifiers(e, n, i) {
        let s = e.length, { angle: o , twist: a , startScale: l , endScale: u  } = this.inputs.parameters.extrusion, c = new ae, d = new ae;
        return e.forEach((h, f)=>{
            let m = f === 0 ? 0 : f === s - 1 ? 1 : (f - n) / (s - (i === 0 ? 0 : 1) - (n + (1 - i)));
            c.makeRotationZ(He.lerp(o, o + a, m));
            let p = He.lerp(l, u, m);
            d.makeScale(p, p, p), h.multiply(c).multiply(d);
        }), e;
    }
    _computeShapePoints(e = 12, n = mt.ODD) {
        let i = this.inputs.shapeData, s = i.extractShapePointsToFlatArray([], e), o = i.shapeHoles.map((p)=>{
            let g = p.extractShapePointsToFlatArray([], e), y = [];
            for(let v = g.length - 1; v >= 1; v -= 2){
                let x = g[v - 1], w = g[v - 0];
                y.push(x, w);
            }
            return y;
        }), a;
        try {
            a = Zi({
                windingRule: n,
                elementType: sn.BOUNDARY_CONTOURS,
                vertexSize: 2,
                strict: !0,
                contours: [
                    s
                ]
            });
        } catch  {
            a = hf;
        }
        let l;
        try {
            l = Zi({
                windingRule: mt.ODD,
                elementType: sn.BOUNDARY_CONTOURS,
                vertexSize: 2,
                strict: !0,
                contours: [
                    ...o
                ]
            });
        } catch  {
            l = Fb;
        }
        if (!a) throw new Error("error generating geometry");
        let u = a.elementCount;
        if (l) {
            a.elementCount += l.elementCount;
            for(let p = 0; p < l.elements.length; p++){
                let g = l.elements[p], y = p % 2 === 0 ? a.vertexCount : 0;
                a.elements.push(g + y);
            }
            for(let p = 0; p < l.vertexIndices.length; p++){
                let g = l.vertexIndices[p], y = a.vertexCount;
                a.vertexIndices.push(g + y);
            }
            for(let p = 0; p < l.vertices.length; p++){
                let g = l.vertices[p];
                a.vertices.push(g);
            }
        }
        let c = 1 / 0, d = -1 / 0, h = 1 / 0, f = -1 / 0;
        for(let p = 0, g = a.vertexCount; p < g; p++){
            let y = p * 2, v = a.vertices[y + 0], x = a.vertices[y + 1];
            v < c && (c = v), v > d && (d = v), x < h && (h = x), x > f && (f = x);
        }
        let m = [];
        for(let p = a.elementCount - 1; p >= 0; p--){
            let g = p >= u, y = p * 2, v = a.elements[y + 0], x = a.elements[y + 1], w = v + x, S = {
                start: v,
                count: x,
                normals: [],
                isHole: g,
                continuous: [],
                verticesStart: 0,
                verticesCount: 0
            };
            m.push(S);
            let _ = v, M = w - 1, b = v + 1, T = i.roundedCurves.length;
            do {
                let E = _ - v, P = a.vertices[M * 2 + 0], D = a.vertices[M * 2 + 1], C = a.vertices[_ * 2 + 0], O = a.vertices[_ * 2 + 1], B = a.vertices[b * 2 + 0], V = a.vertices[b * 2 + 1], Y = C - P, W = O - D, q = Math.sqrt(Y * Y + W * W);
                Y /= q, W /= q;
                let j = C - B, X = O - V, L = Math.sqrt(j * j + X * X);
                j /= L, X /= L, S.normals[E * 2 + 0] = -X, S.normals[E * 2 + 1] = j;
                let U = a.vertexIndices[_];
                if (Array.isArray(U)) S.continuous[E] = !1;
                else {
                    let [G, H] = i.getCurveIndexFromVertexId(U - 1, !0);
                    if (H > 0 && H < 1) S.continuous[E] = !0;
                    else {
                        let z = H === 1 ? G + 1 : G - 1;
                        z = (z + T) % T;
                        let re = H === 1 ? 0 : 1, K = i.roundedCurves[G].getTangent(H), Z = i.roundedCurves[z].getTangent(re);
                        S.continuous[E] = K.dot(Z) > .95;
                    }
                }
                g && (S.normals[E * 2 + 0] *= -1, S.normals[E * 2 + 1] *= -1), [M, _, b] = [
                    _,
                    b,
                    b + 1
                ], b >= w && (b -= x);
            }while (b !== v + 1);
        }
        return {
            regions: [
                s,
                ...o
            ],
            infos: m,
            vertices: a.vertices
        };
    }
    _insertVertex(e, n, i, s, o) {
        let a = n * 2, l = n * 3;
        e.positions[l + 0] = i.x, e.positions[l + 1] = i.y, e.positions[l + 2] = i.z, e.normals[l + 0] = s.x, e.normals[l + 1] = s.y, e.normals[l + 2] = s.z, e.uvs[a + 0] = o.x, e.uvs[a + 1] = o.y;
    }
    _extrudeRegion(e, n, i, s, o, a, l) {
        let u = new A, c = new A, d = new A, h = new A, f = new F;
        i.forEach((p, g)=>{
            let y = s[g], v = e.verticesStart * i.length + e.verticesCount * g;
            for(let x = 0; x < e.count; x++){
                let w = (e.start + x) * 2;
                if (u.set(n[w + 0], n[w + 1], 0), d.copy(u).applyMatrix4(p).add(y), e.continuous[x]) h.set(e.normals[x * 2 + 0], e.normals[x * 2 + 1], 0);
                else {
                    let S = x == 0 ? (e.start + e.count - 1) * 2 : w - 2;
                    c.set(n[S + 0], n[S + 1], 0), h.copy(u).sub(c), h.set(-h.y, h.x, 0), e.isHole || h.negate();
                }
                if (h.applyMatrix4(p).normalize(), f.set(x === 0 ? 1 : x / e.count, g / (i.length - 1)), this._insertVertex(o, v, d, h, f), v++, !e.continuous[x] || x === 0) {
                    if (x === 0) h.set(e.normals[x * 2 + 0], e.normals[x * 2 + 1], 0), f.set(0, g / (i.length - 1));
                    else {
                        let S = x === e.count - 1 ? e.start * 2 : w + 2;
                        c.set(n[S + 0], n[S + 1], 0), h.copy(c).sub(u), h.set(-h.y, h.x, 0), e.isHole || h.negate();
                    }
                    h.applyMatrix4(p).normalize(), this._insertVertex(o, v, d, h, f), v++;
                }
            }
        });
        let m = i.length - 1;
        for(let p = 0; p < m; p++){
            let g = e.verticesStart * i.length + e.verticesCount * p, y = e.verticesStart * i.length + e.verticesCount * (p + 1), v = 0;
            for(let x = 0; x < e.count; x++){
                (!e.continuous[x] || x === 0) && v++;
                let w = x === e.count - 1 ? 0 : v + 1, S = g + v, _ = g + w, M = y + w, b = y + v;
                e.isHole ? a.push(S, M, _, S, b, M) : a.push(S, _, M, S, M, b), v++;
            }
        }
    }
    _closeEnd(e, n, i, s, o, a, l) {
        let u = e.vertexCount, c = new A(0, 0, l ? -1 : 1).applyMatrix4(o), d = new A, h = new F;
        for(let m = 0; m < u; m++){
            let p = 2 * m;
            d.set(e.vertices[p + 0], e.vertices[p + 1], 0).applyMatrix4(o).add(a), this._insertVertex(s, n + m, d, c, h);
        }
        let f = e.elements;
        for(let m = 0; m < e.elementCount; m++){
            let p = 3 * m, g = f[p + 0] + n, y = f[p + (l ? 1 : 2)] + n, v = f[p + (l ? 2 : 1)] + n;
            i.push(g, y, v);
        }
    }
};
function rP() {
    let r1 = new Me;
    return r1.setAttribute("position", new Be(new Float32Array([]), 3)), r1.setIndex(new Be(new Uint16Array([]), 1)), r1;
}
var q5 = rP().attributes, X5 = 12, Y5 = 1, Wu = class extends Me {
    constructor(e, n){
        super();
        this.charWidths = [];
        this.charCoords = [];
        this.wrappedText = [];
        this.isLowResolution = !1;
        this.vectorShapes = [];
        Object.assign(this.attributes, q5), this.userData = {
            parameters: e,
            type: "TextGeometry"
        };
        let i = n.getFont(e.font);
        i?.isLoaded ? (this.font = i, this.update(e)) : this.updateFont(e.font, n).then(()=>{
            this.update(e), n?.requestRender();
        });
    }
    async updateFont(e, n) {
        let i = n.getFont(e);
        i && (this.font = i, await i.loadingPromise);
    }
    update(e) {
        let n = this.font;
        if (this.userData = {
            parameters: e,
            type: "TextGeometry"
        }, !n?.isLoaded) {
            console.warn("Cannot update text because its font is not loaded");
            return;
        }
        let { width: i , height: s , depth: o , extrudeBevelSize: a , extrudeBevelSegments: l , text: u , textTransform: c  } = e, d = c === 2 ? u.toUpperCase() : c === 3 ? u.toLowerCase() : u, h = Q5(e, n, d), { shapes: f , charWidths: m , charCoords: p  } = n.generateShapes(h, e), g = i * .5, y = s * .5, v = f.map((S)=>new Tt().fromShape(S));
        this.vectorShapes = v;
        let x = v.map((S)=>Xr.create({
                shape: S,
                parameters: {
                    depth: o,
                    extrudeBevelSegments: l,
                    extrudeBevelSize: a,
                    windingRule: o <= 0 ? mt.NONZERO : mt.ODD,
                    subdivisions: this.isLowResolution && o > 0 ? Y5 : X5
                }
            })), w = x.length ? Xi(x) : rP();
        w.translate(-g, y, 0), this.dispose(), this.wrappedText = h, this.charCoords = p, this.charWidths = m, this.deleteAttribute("extrudeNormal"), Object.entries(w.attributes).forEach(([S, _])=>{
            this.setAttribute(S, _);
        }), this.setIndex(w.index), this.computeBoundingSphere();
    }
    clone() {
        let e = Hi(new Me, Wu.prototype);
        return e.copy(this), console.log("CloneGeometry", this, e), e;
    }
    copy(e) {
        return Object.entries(e.attributes).forEach(([n, i])=>{
            this.setAttribute(n, i);
        }), this.setIndex(e.index), this.userData = {
            parameters: {
                ...e.userData.parameters
            },
            type: "TextGeometry"
        }, this;
    }
    async setText(e) {
        this.font && await this.font.loadingPromise, await this.update({
            ...this.userData.parameters,
            text: e
        });
    }
    get text() {
        return this.userData.parameters.text ?? "";
    }
};
function Q5(r1, t, e) {
    e = e ?? r1.text;
    let n = [
        ""
    ], i = "";
    for (let s of e)i += s, s === " " || s === `
` ? (n[n.length - 1] += i, i = "", s === `
` && n.push("")) : t.getTextWidth(n[n.length - 1] + i, r1) > r1.width && (n[n.length - 1].length && n.push(""), t.getTextWidth(n[n.length - 1] + i, r1) > r1.width && (i.length === 1 ? (n[n.length - 1] += i, i = "") : (n[n.length - 1] += i.slice(0, -1), i = i[i.length - 1], n.push(""))));
    return n[n.length - 1] += i, n;
}
var sP, ju = new Promise((r1)=>{
    sP = r1;
}), iP = !1;

async function oP() {
    if (iP) return;
    let t = "https://unpkg.com/@splinetool/modelling-wasm@0.9.369/build", [e, n] = await Promise.all([
        (parcelRequire("hmY9C")),
        fetch(`${t}/process.wasm`).then((o)=>o.arrayBuffer())
    ]), i = e.default, s = await i({
        wasmBinary: n
    });
    sP(s), iP = !0;
}
function Sl(r1, t, e) {
    let n = {
        parameters: r1,
        type: r1.type
    };
    if (r1.type === "PathGeometry") n.path = r1.path;
    else if (r1.type === "VectorGeometry") {
        let s = Tt.createFromState(r1.shape, r1.width, r1.height);
        n.shape = s;
    } else if (r1.type === "NonParametricGeometry") r1.data.groups && r1.data.groups.forEach((s)=>s.materialIndex = Math.max(s.materialIndex ?? 0, 0)), n.geometry = new wc().parse(r1);
    else {
        if (r1.type === "SubdivGeometry") return new xn(r1, e);
        if (r1.type === "TextGeometry") return new Wu(r1, t);
    }
    let i;
    try {
        i = Yb(n);
    } catch (s) {
        console.error(s);
    }
    if (!i) {
        let s = Tt.createFromState(uu.defaultData(), 100, 100);
        n.shape = s, i = Yb(n);
    }
    return i;
}
var K5 = new ae;
function gf(r1, t, e, n) {
    let i = r1.position.array, s = r1.normal.array, o = K5.makeScale(t, e, n).invert().elements, a, l, u;
    for(var c = 0, d = i.length; c < d; c += 3)i[c] *= t, i[c + 1] *= e, i[c + 2] *= n, a = s[c], l = s[c + 1], u = s[c + 2], s[c] = o[0] * a + o[4] * l + o[8] * u, s[c + 1] = o[1] * a + o[5] * l + o[9] * u, s[c + 2] = o[2] * a + o[6] * l + o[10] * u;
    r1.position.needsUpdate = !0, r1.normal.needsUpdate = !0;
}
var Xg = new Mt, qu = new A, Ke;
ju.then((r1)=>{
    Ke = r1;
});
var aP = new Float32Array([
    10,
    10,
    0,
    -10,
    10,
    0,
    -10,
    -10,
    0,
    10,
    -10,
    0
]), lP = new Uint32Array([
    0,
    1,
    2,
    3
]), cP = new Uint8Array([
    4
]), xn = class extends Me {
    constructor(e, n){
        super();
        this.data = e;
        this.flatShading = n;
        this.subdivPointer = 0;
        this.rebuild(), this.freeSubdivPointer();
    }
    mutateDirectlyScaleBaked(e, n) {
        this.freeSubdivPointer();
        let i = this.data.scaleBaked, s = _s.div(n, i);
        this.subdividedGeometry && gf(this.subdividedGeometry.attributes, ...s), this.originalGeometry && gf(this.originalGeometry.attributes, ...s), this.data = e;
        let o = this.userData.parameters;
        this.userData.parameters = {
            width: o.width * s[0],
            height: o.height * s[1],
            depth: o.depth * s[2]
        }, this.originalGeometry.boundingSphere.center.multiply(qu.fromArray(s));
        let a = qu.set(o.width, o.height, o.depth).length();
        this.originalGeometry.boundingSphere.radius = a / 2;
    }
    ensureSubdivPointer() {
        return this.subdivPointer === 0 && this.rebuild(), this.subdivPointer;
    }
    rebuild() {
        let e, n, i;
        try {
            ({ originalGeometry: e , subdividedGeometry: n , subdivPointer: i  } = xn.build(this.data, void 0, !this.flatShading, void 0));
        } catch  {
            e = new er(100, 100, 100), i = 0;
        }
        this.subdivPointer = i, this.originalGeometry = e, this.subdividedGeometry = n ?? void 0;
        let s = this.subdividedGeometry ?? this.originalGeometry;
        Object.assign(this, s), this.calcBoundingBox();
    }
    freeSubdivPointer() {
        this.subdivPointer && (xn.freeSubdivPointer(this.subdivPointer), this.subdivPointer = 0);
    }
    dispose() {
        super.dispose(), this.freeSubdivPointer();
    }
    calcBoundingBox() {
        let e = this.originalGeometry;
        e.boundingSphere === null && (e.boundingSphere = new Rn, this.subdividedGeometry && (this.subdividedGeometry.boundingSphere = e.boundingSphere));
        let n = e.attributes.position, i = e.boundingSphere.center;
        Xg.setFromBufferAttribute(n), Xg.getCenter(i), e.boundingSphere.radius = i.distanceTo(Xg.max), isNaN(e.boundingSphere.radius) && console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this), Xg.getSize(qu);
        let s = {
            width: qu.x,
            height: qu.y,
            depth: qu.z
        };
        return this.userData.parameters = s, s;
    }
    static build(e, n, i, s) {
        let o, a, l, u = e?.phongAngle ?? 35;
        i === !1 && (u = -1), n && (Ke.free_bvh(n), Ke.free_subdivision_surface(n));
        try {
            o = xn.allocate(e, s);
        } catch (c) {
            console.error(c, e), o = xn.allocate({
                positionWASM: aP,
                indexWASM: lP,
                verticesPerFaceWASM: cP
            }, s);
        }
        if (Ke.set_destination_refinement_level(o, 0), a = xn.buildLevel(o, !0, u), e.subdivisions > 0) try {
            Ke.set_destination_refinement_level(o, e.subdivisions), l = xn.buildLevel(o, !1, u);
        } catch  {
            try {
                Ke.set_destination_refinement_level(o, e.subdivisions - 1), l = xn.buildLevel(o, !1, u);
            } catch  {
                l = null;
            }
        }
        else l = null;
        return {
            subdivPointer: o,
            originalGeometry: a,
            subdividedGeometry: l
        };
    }
    static primitiveToQuads(e, n, i) {
        e.widthSegments > 16 && (e.widthSegments = 16), e.heightSegments > 16 && (e.heightSegments = 16), e.depthSegments > 16 && (e.depthSegments = 16), e.radialSegments > 16 && (e.radialSegments = 16), e.type === "DodecahedronGeometry" && (e.detail = 0);
        let s = e.shape !== void 0 ? n.geometry : Sl(e, i, !1), o;
        e.type === "TorusGeometry" && e.arc === Math.PI * 2 ? o = s.getClosedTorusIndicesForBooleanOrSubdiv() : o = s.getIndex();
        let a, l, u, c;
        ({ positions: a , triIndices: c  } = Al(s.getAttribute("position"), o));
        let d;
        if (e.type === "CylinderGeometry" && e.cornerRadius === 0 && e.hollow === 0 && e.openEnded === !1) {
            let h = e.radialSegments * e.heightSegments * 6, f = h + e.radialSegments * 3;
            d = [
                h,
                f
            ];
        }
        return { indices: l , verticesPerFace: u  } = Jb(a, c, s, d), {
            positions: a,
            indices: l,
            verticesPerFace: u
        };
    }
    static allocate(e, n) {
        let i, s, o, a = [], l = [];
        e.positionWASM && e.positionWASM.length > 0 ? (i = e.positionWASM, s = e.indexWASM, o = e.verticesPerFaceWASM) : (i = aP, s = lP, o = cP);
        let u = i.length, c = s.length, d = o.length, h = i.length + a.length + l.length, f = s.length + o.length, m = h * Float32Array.BYTES_PER_ELEMENT + f * Uint32Array.BYTES_PER_ELEMENT, p = h * Float32Array.BYTES_PER_ELEMENT, g = f * Uint32Array.BYTES_PER_ELEMENT, y = Ke._malloc(m), v = new Float32Array(Ke.HEAPF32.buffer, y, h), x = new Uint32Array(Ke.HEAPU32.buffer, y + p, f);
        v.set(i, 0), v.set(a, i.length), v.set(l, i.length + a.length), x.set(s, 0), x.set(o, s.length);
        let w;
        e?.scaleBaked?.some((_)=>_ !== 1) && (w = new ae().makeScale(...e.scaleBaked)), n && (w ? w.premultiply(n) : w = n);
        let S = w ? Ke.alloc_subdivision_surface2(y, u, y + p, c, y + p + s.length * Uint32Array.BYTES_PER_ELEMENT, d, w.elements) : Ke.alloc_subdivision_surface(y, u, y + p, c, y + p + s.length * Uint32Array.BYTES_PER_ELEMENT, d);
        return Ke._free(y), S;
    }
    static buildLevel(e, n, i, s, o) {
        let a = o ? Ke.get_mesh_data2(e, n ? Ke.Level.CONTROL : Ke.Level.REFINED, i, o.elements) : Ke.get_mesh_data(e, n ? Ke.Level.CONTROL : Ke.Level.REFINED, i), l = 8, u = Ke.HEAPU32.subarray(a >> 2, (a >> 2) + l), c = u.subarray(4, 8), d = 0, h = Ke.HEAPU32[u[d] >> 2], f = Ke.HEAPF32.subarray(h >> 2, (h >> 2) + c[d]);
        d++;
        let m = Ke.HEAPU32[u[d] >> 2], p = Ke.HEAPF32.subarray(m >> 2, (m >> 2) + c[d]);
        d++;
        let g = Ke.HEAPU32[u[d] >> 2], y = Ke.HEAPU32.subarray(g >> 2, (g >> 2) + c[d]);
        d++;
        let v = Ke.HEAPU32[u[d] >> 2], x = Ke.HEAPU32.subarray(v >> 2, (v >> 2) + c[d]);
        if (d++, s === void 0) {
            let w = new Me;
            if (w.setIndex(new ys(x, 1)), w.setAttribute("position", new Ae(f, 3)), w.setAttribute("normal", new Ae(p, 3)), n) {
                w.setAttribute("faceMap", new ys(y, 1));
                let S = new Float32Array(p.length / 3 * 4).fill(0);
                w.setAttribute("color", new Be(S, 4));
            }
            return Ke.free_mesh_data(a), w.userData.type = "SubdivGeometry", w;
        }
        s.getAttribute("position").copyArray(f), s.getAttribute("normal").copyArray(p), s.attributes.position.needsUpdate = !0, s.attributes.normal.needsUpdate = !0, Ke.free_mesh_data(a);
    }
    static freeSubdivPointer(e) {
        Ke.free_bvh(e), Ke.free_subdivision_surface(e);
    }
    static buildControlCageWireframe(e, n, i) {
        let s = Ke.get_wireframe_data_for_base_level(e), o = 4, a = Ke.HEAPU32.subarray(s >> 2, (s >> 2) + o), l = a.subarray(2, 4), u = 0, c = Ke.HEAPU32[a[u] >> 2], d = Ke.HEAPF32.subarray(c >> 2, (c >> 2) + l[u]);
        u++;
        let h = Ke.HEAPU32[a[u] >> 2], f = Ke.HEAPU32.subarray(h >> 2, (h >> 2) + l[u]);
        if (n === void 0) {
            let m = new Me;
            m.setAttribute("position", new Ae(d, 3));
            let p = new Float32Array(d.length);
            for(let g = 0, y = d.length; g < y;)p[g++] = i.r, p[g++] = i.g, p[g++] = i.b;
            return m.setAttribute("color", new Be(p, 3)), m.setIndex(new ys(f, 1)), Ke.free_wireframe_data_for_base_level(s), m;
        }
        n.getAttribute("position").copyArray(d), n.attributes.position.needsUpdate = !0, Ke.free_wireframe_data_for_base_level(s);
    }
    static updateCollabMesh(e, n, i) {
        let s = n === 0;
        s || Ke.set_destination_refinement_level(e, n);
        let o = i ? Ke.get_topological_data2(e, s ? Ke.Level.CONTROL : Ke.Level.REFINED, i.elements) : Ke.get_topological_data(e, s ? Ke.Level.CONTROL : Ke.Level.REFINED), a = 6, l = Ke.HEAPU32.subarray(o >> 2, (o >> 2) + a), u = l.subarray(3, 6), c = 0, d = Ke.HEAPU32[l[c] >> 2], h = new Float32Array(Ke.HEAPF32.subarray(d >> 2, (d >> 2) + u[c]));
        c++;
        let f = Ke.HEAPU32[l[c] >> 2], m = new Uint32Array(Ke.HEAPU32.subarray(f >> 2, (f >> 2) + u[c]));
        c++;
        let p = Ke.HEAPU32[l[c] >> 2], g = new Uint8Array(Ke.HEAPU32.subarray(p >> 2, (p >> 2) + u[c]));
        return Ke.free_topological_data(o), {
            positions: h,
            indices: m,
            verticesPerFace: g
        };
    }
};
var uP = [
    "getX",
    "getY",
    "getZ"
];
function Al(r1, t) {
    let e = {}, n = t ? t.count : r1.count, i = 0, s = [], o = [], a = 1e4;
    for(let u = 0; u < n; u++){
        let c = t ? t.getX(u) : u, d = "";
        for(let h = 0; h < 3; h++)d += `${~~(r1[uP[h]](c) * a)},`;
        if (d in e) s.push(e[d]);
        else {
            for(let h = 0; h < 3; h++)o.push(r1[uP[h]](c));
            e[d] = i, s.push(i), i++;
        }
    }
    let l = [];
    for(let u = 0; u < s.length; u += 3)s[u] === s[u + 1] || s[u] === s[u + 2] || s[u + 1] === s[u + 2] || l.push(s[u], s[u + 1], s[u + 2]);
    return {
        positions: o,
        triIndices: l
    };
}
var Yg = new A, Qb = new A, Kb = new A, Zb = new A;
function Jb(r1, t, e, n) {
    let i = [], s = [];
    if (e.userData.shape !== void 0 && e.userData.parameters.depth === 0 && e.userData.shape.shapeHoles.length === 0) {
        let o = e.userData.shape.extractShapePointsToFlatArray([]), a = e.userData.parameters.spikes;
        if (e.userData.type === "EllipseGeometry" && a <= 24 && a % 4 === 0 && e.userData.parameters.angle >= 360) {
            let c = o.length / 2 / a;
            o = o.filter((d, h)=>Math.floor(h / 2) % c === 0);
        }
        let l = 0;
        for(let c = 0; c < o.length; c += 2)l += (o[c] - o[(c === 0 ? o.length : c) - 2]) * (o[c + 1] + o[(c === 0 ? o.length : c) - 1]);
        r1.length = 0;
        let u = 0;
        if (l < 0) for(let c = 0; c < o.length; c += 2)r1.push(o[c], o[c + 1], 0), i.push(u++);
        else for(let c = o.length - 2; c >= 0; c -= 2)r1.push(o[c], o[c + 1], 0), i.push(u++);
        return s.push(u), {
            indices: i,
            verticesPerFace: s
        };
    }
    for(let o = 0, a = e.capStartIndex ?? t.length; o < a;)if (t[o + 1] === t[o + 3] && t[o + 2] === t[o + 5] || t[o + 0] === t[o + 3] && t[o + 2] === t[o + 4]) {
        Yg.set(r1[t[o] * 3], r1[t[o] * 3 + 1], r1[t[o] * 3 + 2]), Qb.set(r1[t[o + 1] * 3], r1[t[o + 1] * 3 + 1], r1[t[o + 1] * 3 + 2]), Kb.set(r1[t[o + 4] * 3], r1[t[o + 4] * 3 + 1], r1[t[o + 4] * 3 + 2]), Zb.set(r1[t[o + 5] * 3], r1[t[o + 5] * 3 + 1], r1[t[o + 5] * 3 + 2]), Qb.sub(Yg).normalize(), Kb.sub(Yg).normalize(), Zb.sub(Yg).normalize();
        let l = Qb.cross(Kb).dot(Zb);
        Math.abs(l) > .005 || n && n.some((u, c)=>c % 2 === 1 ? !1 : o >= n[c] && o < n[c + 1]) ? (i.push(t[o], t[o + 1], t[o + 2]), s.push(3), o += 3) : (i.push(t[o], t[o + 1], t[o + 4], t[o + 5]), s.push(4), o += 6);
    } else i.push(t[o], t[o + 1], t[o + 2]), s.push(3), o += 3;
    if (e.capStartIndex !== void 0) {
        let o = [], a = [], l = 0, u = new Float32Array([
            e.userData.parameters.depth
        ])[0];
        for(let c = 0, d = 0; c < r1.length; c += 3, d++)r1[c + 2] === 0 && (o.push(d), l++), r1[c + 2] === u && a.push(d);
        if (e.userData.parameters.extrudeBevelSize === 0) {
            let c = a[0];
            a[0] = a[1], a[1] = c;
        }
        o.reverse(), i.push(...o, ...a), s.push(l, l);
    }
    return {
        indices: i,
        verticesPerFace: s
    };
}
var Ji = {};
VI(Ji, {
    calcBoolean: ()=>$5,
    calcBooleanTopological: ()=>J5,
    freeMeshSet: ()=>nW,
    getMeshSet: ()=>eW,
    transformMeshSet: ()=>tW
});
var hP, fP = new Promise((r1)=>{
    hP = r1;
}), dP = !1;

async function pP() {
    if (dP) return;
    let t = "https://unpkg.com/@splinetool/boolean-wasm@0.9.369/build", [e, n] = await Promise.all([
        (parcelRequire("av1EJ")),
        fetch(`${t}/boolean.wasm`).then((o)=>o.arrayBuffer())
    ]), i = e.default, s = await i({
        wasmBinary: n
    });
    hP(s), dP = !0;
}
var ut, Xu;
fP.then((r1)=>ut = r1);
function Z5(r1, t, e) {
    let n, i;
    r1.userData.parameters.type === "TorusGeometry" && r1.userData.parameters.arc === Math.PI * 2 ? i = r1.getClosedTorusIndicesForBooleanOrSubdiv() : i = r1.getIndex();
    let { positions: s , triIndices: o  } = Al(r1.getAttribute("position"), i), a;
    if (t && e) {
        let { indices: l , verticesPerFace: u  } = Jb(s, o, r1);
        a = u.length, n = [];
        for(let c = 0, d = 0; c < a; c++){
            n.push(u[c]);
            for(let h = 0; h < u[c]; h++)n.push(l[d++]);
        }
    } else {
        let l = o.length;
        n = Array(l + l / 3), a = 0;
        for(let u = 0, c = 0; c < n.length;)n[c++] = 3, a++, n[c++] = o[u++], n[c++] = o[u++], n[c++] = o[u++];
    }
    return {
        positions: s,
        faceIndices: n,
        nFaces: a
    };
}
function mP(r1) {
    let t = r1.length, e = t * Uint32Array.BYTES_PER_ELEMENT, n = t * Float32Array.BYTES_PER_ELEMENT, i = Number.isInteger(r1[0]) ? e : n, s = ut._malloc(i);
    return (Number.isInteger(r1[0]) ? new Uint32Array(ut.HEAPU32.buffer, s, t) : new Float32Array(ut.HEAPF32.buffer, s, t)).set(r1, 0), s;
}
function gP(r1) {
    switch(r1){
        case 0:
            return ut.OP.UNION;
        case 1:
            return ut.OP.INTERSECTION;
        case 2:
            return ut.OP.A_MINUS_B;
        case 3:
            return ut.OP.B_MINUS_A;
        case 4:
            return ut.OP.SYMMETRIC_DIFFERENCE;
        case 5:
            return ut.OP.ALL;
        default:
            throw new Error("Unknown boolean operation " + r1);
    }
}
function J5(r1, t) {
    Xu === void 0 && (Xu = ut.init_csg());
    let e = mP(r1), n = ut.csg_calc_topological(Xu, e, r1.length, gP(t));
    ut._free(e);
    let i = 6, s = ut.HEAPU32.subarray(n >> 2, (n >> 2) + i), o = s.subarray(3, 6), a = 0, l = ut.HEAPU32[s[a] >> 2], u = new Float32Array(ut.HEAPF32.subarray(l >> 2, (l >> 2) + o[a]));
    a++;
    let c = ut.HEAPU32[s[a] >> 2], d = new Uint32Array(ut.HEAPU32.subarray(c >> 2, (c >> 2) + o[a]));
    a++;
    let h = ut.HEAPU32[s[a] >> 2], f = new Uint8Array(ut.HEAPU32.subarray(h >> 2, (h >> 2) + o[a]));
    return ut.free_mesh_data(n), {
        positions: u,
        indices: d,
        verticesPerFace: f
    };
}
function $5(r1, t, e, n) {
    Xu === void 0 && (Xu = ut.init_csg());
    let i = mP(r1), s = ut.csg_calc(Xu, i, r1.length, n, gP(t));
    ut._free(i);
    let o = 5, a = ut.HEAPU32.subarray(s >> 2, (s >> 2) + o), l = a.subarray(2, 5), u = 0, c = ut.HEAPU32[a[u] >> 2], d = ut.HEAPF32.subarray(c >> 2, (c >> 2) + l[u]);
    u++;
    let h = ut.HEAPU32[a[u] >> 2], f = ut.HEAPF32.subarray(h >> 2, (h >> 2) + l[u]);
    u++;
    let m = l[u];
    e.setAttribute("position", new Ae(d, 3)), e.setAttribute("normal", new Ae(f, 3));
    let p = ut.HEAPF32.subarray((s >> 2) + 5, (s >> 2) + 5 + 6);
    return e.boundingSphere === null && (e.boundingSphere = new Rn), e.boundingSphere.center.set(p[0], p[1], p[2]), e.boundingSphere.radius = (p[3] ** 2 + p[4] ** 2 + p[5] ** 2) ** .5, e.userData.parameters = {
        width: p[3] * 2,
        height: p[4] * 2,
        depth: p[5] * 2
    }, ut.free_mesh_data(s), m;
}
function eW(r1, t, e) {
    if (ut === void 0) return -1;
    let n, i, s;
    if (t && r1.userData.positions !== void 0) {
        let g = r1.userData;
        s = g.verticesPerFace.length, n = g.positions, i = Array(g.verticesPerFace.reduce((y, v)=>y + v, 0) + s);
        for(let y = 0, v = 0, x = 0; y < g.verticesPerFace.length; y++){
            i[x++] = g.verticesPerFace[y];
            for(let w = 0; w < g.verticesPerFace[y]; w++)i[x++] = g.indices[v++];
        }
    } else ({ positions: n , faceIndices: i , nFaces: s  } = Z5(r1, t, e));
    let o = n.length, a = i.length, l = n.length, u = i.length, c = l * Float32Array.BYTES_PER_ELEMENT + u * Uint32Array.BYTES_PER_ELEMENT, d = l * Float32Array.BYTES_PER_ELEMENT, h = u * Uint32Array.BYTES_PER_ELEMENT, f = ut._malloc(c), m = new Float32Array(ut.HEAPF32.buffer, f, l), p = new Uint32Array(ut.HEAPU32.buffer, f + d, u);
    return m.set(n, 0), p.set(i, 0), ut.get_csg_mesh(f, o, f + d, a, s);
}
function tW(r1, t) {
    ut.transform_csg_mesh(r1, t.elements);
}
function nW(r1) {
    ut.free_csg_mesh(r1);
}
var rW = {
    ConeGeometry: fC,
    CubeGeometry: pC,
    CylinderGeometry: Lg,
    DodecahedronGeometry: mC,
    EllipseGeometry: Gu,
    HelixGeometry: zC,
    IcosahedronGeometry: GC,
    LatheGeometry: VC,
    NonParametricGeometry: qC,
    PolygonGeometry: Wg,
    PyramidGeometry: XC,
    RectangleGeometry: jg,
    SphereGeometry: YC,
    PlaneGeometry: QC,
    BackdropGeometry: KC,
    StarGeometry: qg,
    TextFrameGeometry: ZC,
    TorusGeometry: JC,
    TorusKnotGeometry: $C,
    TriangleGeometry: eP,
    PathGeometry: nP,
    VectorGeometry: Xr
}, Yb = (r1)=>rW[r1.type].create(r1);
function yf(r1) {
    return r1 !== null && "booleanOp" in r1;
}
var Yu = class extends Rg(In) {
    constructor(){
        super(...arguments);
        this.booleanMeshSetAddress = -1;
        this.booleanWasTransformed = !1;
        this.booleanMatrixInvOld = new ae;
    }
    updateVisible() {
        super.updateVisible(), this.visible = !yf(this.parent) && this.visible, yf(this.parent) && this.parent.invalidateDownstreamBooleanData();
    }
    freeBooleanPointer() {
        this.booleanMeshSetAddress !== -1 && (Ji.freeMeshSet(this.booleanMeshSetAddress), this.booleanMeshSetAddress = -1);
    }
    invalidateDownstreamBooleanData(e = !1) {
        return e ? this.booleanWasTransformed = !0 : this.freeBooleanPointer(), yf(this.parent) ? this.parent.invalidateDownstreamBooleanData() : this;
    }
    invalidateUpstreamBooleanData() {
        this.freeBooleanPointer();
        for (let e of this.children)e instanceof Yu && (e.freeBooleanPointer(), yf(e) && e.invalidateUpstreamBooleanData());
    }
    updateTransformState(e) {
        let n = super.updateTransformState(e);
        return n && yf(this.parent) && this.invalidateDownstreamBooleanData(!0), n;
    }
};
var Qg = new Mt;
function vf(r1, t = 0, e = r1.count, n, i) {
    let s = 1 / 0, o = 1 / 0, a = 1 / 0, l = -1 / 0, u = -1 / 0, c = -1 / 0;
    for(let d = t; d < e; d++){
        let h = r1.getX(d), f = r1.getY(d), m = r1.getZ(d);
        h < s && (s = h), f < o && (o = f), m < a && (a = m), h > l && (l = h), f > u && (u = f), m > c && (c = m);
    }
    Qg.min.set(s, o, a), Qg.max.set(l, u, c), Qg.getCenter(n), Qg.getSize(i).multiplyScalar(.5);
}
var iW = new Me, sW = new Ui, kt = class extends Yu {
    constructor(t, e){
        super(iW, sW), this.super_Entity(t, e);
    }
    updateState(t, e) {
        this.updateState_Entity(t, e);
    }
    updateEntityBoxSize(t, e) {
        let n = this.geometry.getAttribute("position");
        n !== void 0 ? vf(n, this.geometry.drawRange.start, this.geometry.drawRange.count < 1 / 0 ? this.geometry.drawRange.count : n.count, t, e) : super.updateEntityBoxSize(t, e);
    }
};
var xf = class {
    constructor(t){
        t = t ?? {}, this.name = t.name, this.type = t.type, this.node = t.node, this.size = t.size, this.needsUpdate = t.needsUpdate;
    }
    get value() {
        return this.node.value;
    }
    set value(t) {
        this.node.value = t;
    }
};
var ar = class {
    constructor(t){
        this.hashProperties = void 0;
        this.isNode = !0;
        this.shortcuts = {};
        this.uuid = He.generateUUID(), this.type = t, this.name = "";
    }
    analyze(t, e) {
        e = e ?? {}, t.analyzing = !0, this.build(t.addFlow(e.slot, e.cache, e.context), "v4"), t.clearVertexNodeCode(), t.clearFragmentNodeCode(), t.removeFlow(), t.analyzing = !1;
    }
    analyzeAndFlow(t, e, n) {
        return n = n ?? {}, this.analyze(t, n), this.flow(t, e, n);
    }
    flow(t, e, n) {
        n = n ?? {}, t.addFlow(n.slot, n.cache, n.context);
        let i = {
            result: this.build(t, e),
            code: t.clearNodeCode(),
            extra: t.context.extra
        };
        return t.removeFlow(), i;
    }
    build(t, e, n) {
        e = e ?? this.getType(t, e);
        let i = t.getNodeData(n ?? this);
        return t.analyzing && this.appendDepsNode(t, i, e), t.nodes.indexOf(this) === -1 && t.nodes.push(this), this.updateFrame !== void 0 && t.updaters.indexOf(this) === -1 && t.updaters.push(this), this.generate(t, e, n);
    }
    updateFrame(t) {}
    generateReadonly(t, e, n, i, s, o) {
        return "";
    }
    generate(t, e, n, i, s) {
        return "";
    }
    parse(t, e, n, i) {}
    appendDepsNode(t, e, n) {
        e.deps = (e.deps || 0) + 1;
        let i = t.getTypeLength(n);
        (i > (e.outputMax || 0) || this.getType(t, n)) && (e.outputMax = i, e.output = n);
    }
    setName(t) {
        this.name = t;
    }
    getName() {
        return this.name;
    }
    getType(t, e) {
        return e === "sampler2D" || e === "samplerCube" ? e : this.type;
    }
    getHash() {
        let t = "{", e, n;
        for(e in this)n = this[e], n instanceof ar && (t += '"' + e + '":' + n.getHash() + ",");
        if (this.hashProperties) for(let i = 0; i < this.hashProperties.length; i++)e = this.hashProperties[i], n = this[e], t += '"' + e + '":"' + String(n) + '",';
        return t += '"id":"' + this.uuid + '"}', t;
    }
};
var $b = class {
    constructor(){
        this.nodes = {};
        this.keywords = {};
    }
    add(t) {
        this.nodes[t.name] = t;
    }
    addKeyword(t, e, n) {
        n = n !== void 0 ? n : !0, this.keywords[t] = {
            callback: e,
            cache: n
        };
    }
    remove(t) {
        delete this.nodes[t.name];
    }
    removeKeyword(t) {
        delete this.keywords[t];
    }
    get(t) {
        return this.nodes[t];
    }
    getKeyword(t, e) {
        return this.keywords[t].callback(e);
    }
    getKeywordData(t) {
        return this.keywords[t];
    }
    contains(t) {
        return this.nodes[t] !== void 0;
    }
    containsKeyword(t) {
        return this.keywords[t] !== void 0;
    }
}, Xn = new $b;
var ze = class extends ar {
    constructor(e, n){
        super(e);
        this.scope = "";
        n = n ?? {}, this.shared = n.shared !== void 0 ? n.shared : !0, this.unique = n.unique !== void 0 ? n.unique : !1;
    }
    build(e, n, i, s) {
        if (n = n ?? this.getType(e), this.getShared(e, n)) {
            let o = this.getUnique(e, n);
            o && this.uuid === void 0 && (this.uuid = He.generateUUID()), i = e.getUUID(i ?? this.getUUID(), !o);
            let a = e.getNodeData(i), l = a.output || this.getType(e);
            if (e.analyzing) return (a.deps || 0) > 0 || this.getLabel() ? (this.appendDepsNode(e, a, n), this.generate(e, n, i)) : super.build(e, n, i);
            if (o) return a.name = a.name || super.build(e, n, i), a.name;
            if (!this.getLabel() && (!this.getShared(e, l) || e.context.ignoreCache || a.deps === 1)) return super.build(e, n, i);
            i = this.getUUID(!1);
            let u = this.getTemp(e, i);
            if (u) return e.format(u, l, n);
            {
                u = super.generate(e, n, i, a.output, s);
                let c = this.generate(e, l, i);
                return e.addNodeCode(u + " = " + c + ";"), e.format(u, l, n);
            }
        }
        return super.build(e, n, i);
    }
    getShared(e, n) {
        return n !== "sampler2D" && n !== "samplerCube" && this.shared;
    }
    getUnique(e, n) {
        return this.unique;
    }
    setLabel(e) {
        return this.label = e, this;
    }
    getLabel() {
        return this.label;
    }
    getUUID(e) {
        let n = this.uuid;
        return typeof this.scope == "string" && (n = this.scope + "-" + n), n;
    }
    getTemp(e, n) {
        n = n || this.uuid;
        let i = e.getVars()[n];
        return i ? i.name : void 0;
    }
    generate(e, n, i, s, o) {
        return this.getShared(e, n) || console.error("TempNode is not shared"), i = i ?? this.uuid, e.getTempVar(i, s ?? this.getType(e), o, this.getLabel()).name;
    }
};
var Nt = class extends ze {
    constructor(e, n){
        n = n ?? {}, n.shared = n.shared !== void 0 ? n.shared : !1;
        super(e, n);
        this.readonly = !1;
    }
    setReadonly(e) {
        return this.readonly = e, this.hashProperties = this.readonly ? [
            "value"
        ] : void 0, this;
    }
    getReadonly() {
        return this.readonly;
    }
    generate(e, n, i, s, o, a) {
        i = e.getUUID(i ?? this.getUUID()), s = s ?? this.getType(e);
        let l = e.getNodeData(i);
        return this.getReadonly() && this.generateReadonly !== void 0 ? this.generateReadonly(e, n, i, s, o, a) : e.isShader("vertex") ? (l.vertex || (l.vertex = e.createVertexUniform(s, this, o, a, this.getLabel())), e.format(l.vertex.name, s, n)) : (l.fragment || (l.fragment = e.createFragmentUniform(s, this, o, a, this.getLabel())), e.format(l.fragment.name, s, n));
    }
};
var hn = class extends Nt {
    constructor(e = 0, n){
        super("v2");
        this.nodeType = "Vector2";
        this.value = e instanceof F ? e : new F(e, n);
    }
    get x() {
        return this.value.x;
    }
    set x(e) {
        this.value.x = e;
    }
    get y() {
        return this.value.y;
    }
    set y(e) {
        this.value.y = e;
    }
    generateReadonly(e, n, i, s, o, a) {
        return e.format("vec2(" + this.value.x + ", " + this.value.y + ")", s, n);
    }
};
var yr = class extends Nt {
    constructor(e = 0, n, i){
        super("v3");
        this.nodeType = "Vector3";
        this.value = e instanceof A ? e : new A(e, n, i);
    }
    get x() {
        return this.value.x;
    }
    set x(e) {
        this.value.x = e;
    }
    get y() {
        return this.value.y;
    }
    set y(e) {
        this.value.y = e;
    }
    get z() {
        return this.value.z;
    }
    set z(e) {
        this.value.z = e;
    }
    generateReadonly(e, n, i, s, o, a) {
        return e.format("vec3(" + this.value.x + ", " + this.value.y + ", " + this.value.z + ")", s, n);
    }
};
var $t = class extends Ne {
    constructor(e, n, i, s){
        super(e, n, i);
        this.isColorA = !0;
        this.a = s;
    }
    setRGBA(e, n, i, s) {
        super.setRGB(e, n, i), this.a = s;
    }
    copy(e) {
        return super.copy(e), this.a = "a" in e ? e.a : 1, this;
    }
    clone() {
        return new this.constructor(this.r, this.g, this.b, this.a);
    }
    setStyle(e, n = "srgb") {
        let i;
        if (e === "transparent") return this.setRGBA(0, 0, 0, 0), this;
        if (i = /^((?:rgb|hsl)a?)\(([^)]*)\)/.exec(e)) {
            let s, o = i[1], a = i[2];
            switch(o){
                case "rgb":
                case "rgba":
                    if (s = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(a)) return this.a = o === "rgba" ? parseFloat(s[4]) : 1, super.setStyle(e, n);
                    break;
                case "hsl":
                case "hsla":
                    if (s = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)%\s*,\s*(\d*\.?\d+)%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(a)) return this.a = o === "hsla" ? parseFloat(s[4]) : 1, super.setStyle(e, n);
                    break;
            }
        }
        return super.setStyle(e, n);
    }
    get x() {
        return this.r;
    }
    get y() {
        return this.g;
    }
    get z() {
        return this.b;
    }
    get w() {
        return this.a;
    }
    set x(e) {
        this.r = e;
    }
    set y(e) {
        this.g = e;
    }
    set z(e) {
        this.b = e;
    }
    set w(e) {
        this.a = e;
    }
};
var Yr = class extends Nt {
    constructor(e){
        super("v4");
        this.nodeType = "Vector4";
        this.value = e instanceof $t ? e : new $t(e.r, e.g, e.b, e.a);
    }
    generateReadonly(e, n, i, s, o, a) {
        return e.format("vec4(" + this.value.r + ", " + this.value.g + ", " + this.value.b + ", " + this.value.a + ")", s, n);
    }
};
var oW = /^\s*([a-z_0-9]+)\s([a-z_0-9]+)\s*\((.*?)\)/i, yP = /[a-z_0-9]+/gi, me = class extends ze {
    constructor(e, n, i, s, o){
        super(o);
        this.src = "";
        this.nodeType = "Function";
        this.useKeywords = !0;
        this.includes = [];
        this.extensions = {};
        this.keywords = {};
        this.isMethod = o === void 0, this.isInterface = !1, this.parse(e, n, i, s);
    }
    getShared(e, n) {
        return !this.isMethod;
    }
    getType(e) {
        return e.getTypeByFormat(this.type);
    }
    getInputByName(e) {
        if (this.inputs) {
            let n = this.inputs.length;
            for(; n--;)if (this.inputs[n].name === e) return this.inputs[n];
        }
    }
    getIncludeByName(e) {
        if (this.includes) {
            let n = this.includes.length;
            for(; n--;)if (this.includes[n].name === e) return this.includes[n];
        }
    }
    generate(e, n, i, s, o) {
        let a, l = 0, u = this.src;
        if (this.includes) for(let d = 0; d < this.includes.length; d++)e.include(this.includes[d], this);
        for(let d in this.extensions)e.extensions[d] = !0;
        let c = [];
        for(; a = yP.exec(this.src);)c.push(a);
        for(let d = 0; d < c.length; d++){
            let h = c[d], f = h[0], m = this.isMethod ? !this.getInputByName(f) : !0, p = f;
            if (this.keywords[f] || this.useKeywords && m && Xn.containsKeyword(f)) {
                let g = this.keywords[f];
                if (!g) {
                    let y = Xn.getKeywordData(f);
                    y.cache && (g = e.keywords[f]), g = g || Xn.getKeyword(f, e), y.cache && (e.keywords[f] = g);
                }
                p = g.build(e);
            }
            f !== p && u[h.index + l - 1] !== "." && (u = u.substring(0, h.index + l) + p + u.substring(h.index + f.length + l), l += p.length - f.length), this.getIncludeByName(p) === void 0 && Xn.contains(p) && e.include(Xn.get(p));
        }
        return n === "source" ? u : this.isMethod ? (this.isInterface || e.include(this, void 0, u), this.name) : e.format("( " + u + " )", this.getType(e), n);
    }
    parse(e, n, i, s) {
        if (this.src = e || "", this.includes = n ?? [], this.extensions = i ?? {}, this.keywords = s ?? {}, this.isMethod) {
            let o = oW.exec(this.src);
            if (this.inputs = [], o && o.length == 4) {
                this.type = o[1], this.name = o[2];
                let a = o[3].match(yP);
                if (a) {
                    let l = 0;
                    for(; l < a.length;){
                        let u = a[l++], c;
                        u === "in" || u === "out" || u === "inout" ? c = a[l++] : (c = u, u = "");
                        let d = a[l++];
                        this.inputs.push({
                            name: d,
                            type: c,
                            qualifier: u
                        });
                    }
                }
                this.isInterface = this.src.indexOf("{") === -1;
            } else this.type = "", this.name = "";
        }
    }
};
var aW = /^([a-z_0-9]+)\s([a-z_0-9]+)\s?\=?\s?(.*?)(\;|$)/i, ew = class extends ze {
    constructor(e = "", n){
        super();
        this.src = "";
        this.useDefine = !1;
        this.nodeType = "Const";
        this.parse(e || ew.PI, void 0, void 0, void 0, n);
    }
    getType(e) {
        return e.getTypeByFormat(this.type);
    }
    parse(e, n, i, s, o) {
        this.src = e || "";
        let a, l, u = "", c = aW.exec(e);
        this.useDefine = o ?? this.src.charAt(0) === "#", c && c.length > 1 ? (l = c[1], a = c[2], u = c[3]) : (a = this.src, l = "f"), this.name = a, this.type = l, this.value = u;
    }
    build(e, n) {
        if (n === "source") {
            if (this.value) return this.useDefine ? "#define " + this.name + " " + this.value : "const " + this.type + " " + this.name + " = " + this.value + ";";
            if (this.useDefine) return this.src;
        }
        return e.include(this), e.format(this.name, this.getType(e), n);
    }
    generate(e, n, i, s, o) {
        return e.format(this.name, this.getType(e), n);
    }
}, At = ew;
At.PI = "PI", At.PI2 = "PI2", At.RECIPROCAL_PI = "RECIPROCAL_PI", At.RECIPROCAL_PI2 = "RECIPROCAL_PI2", At.LOG2 = "LOG2", At.EPSILON = "EPSILON";
var lW = new RegExp(`^structs*([a-z_0-9]+)s*{s*((.|
)*?)}`, "gim"), cW = new RegExp("s*(w*?)s*(w*?)(=|;)", "gim"), Qu = class extends ze {
    constructor(e = ""){
        super();
        this.inputs = [];
        this.src = "";
        this.nodeType = "Struct";
        this.parse(e);
    }
    getType(e) {
        return e.getTypeByFormat(this.name);
    }
    getInputByName(e) {
        let n = this.inputs.length;
        for(; n--;)if (this.inputs[n].name === e) return this.inputs[n];
    }
    generate(e, n, i, s, o) {
        return n === "source" ? this.src + ";" : e.format("( " + this.src + " )", this.getType(e), n);
    }
    parse(e = "") {
        this.src = e, this.inputs = [];
        let n = lW.exec(e);
        if (n) {
            let i = n[2], s;
            for(; s = cW.exec(i);)this.inputs.push({
                type: s[1],
                name: s[2]
            });
            this.name = n[1];
        } else this.name = "";
        this.type = this.name;
    }
};
var Ku = class extends ze {
    constructor(e){
        super("v2", {
            shared: !1
        });
        this.nodeType = "UV";
        this.index = e ?? 0;
    }
    generate(e, n) {
        e.requires.uv[this.index] = !0;
        let i = this.index > 0 ? this.index + 1 : "", s = e.isShader("vertex") ? "uv" + i : "vUv" + i;
        return e.format(s, this.getType(e), n);
    }
};
Xn.addKeyword("uv", function() {
    return new Ku;
});
Xn.addKeyword("uv2", function() {
    return new Ku(1);
});
var _l = class extends ze {
    constructor(e, n){
        super("v4");
        this.nodeType = "ColorSpace";
        this.input = e, this.method = n ?? _l.LINEAR_TO_LINEAR, this.hashProperties = [
            "method"
        ];
    }
    static getEncodingComponents(e) {
        switch(e){
            case oi:
                return [
                    "Linear"
                ];
            case Ye:
                return [
                    "sRGB"
                ];
            default:
                return [];
        }
    }
    generate(e, n) {
        let i = this.input.build(e, "v4"), s = this.getType(e), o = _l.Nodes[this.method], a = e.include(o);
        if (a === _l.LINEAR_TO_LINEAR) return e.format(i, s, n);
        if (o.inputs?.length === 2) {
            let l = this.factor.build(e, "f");
            return e.format(a + "( " + i + ", " + l + " )", s, n);
        } else return e.format(a + "( " + i + " )", s, n);
    }
    fromEncoding(e) {
        let n = _l.getEncodingComponents(e);
        this.method = "LinearTo" + n[0], this.factor = n[1];
    }
    fromDecoding(e) {
        let n = _l.getEncodingComponents(e);
        this.method = n[0] + "ToLinear", this.factor = n[1];
    }
}, Ur = _l;
Ur.Nodes = {
    LinearToLinear: new me([
        "vec4 LinearToLinear( in vec4 value ) {",
        "	return value;",
        "}"
    ].join(`
`)),
    sRGBToLinear: new me([
        "vec4 sRGBToLinear( in vec4 value ) {",
        "	return vec4( mix( pow( value.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), value.rgb * 0.0773993808, vec3( lessThanEqual( value.rgb, vec3( 0.04045 ) ) ) ), value.w );",
        "}"
    ].join(`
`)),
    LinearTosRGB: new me([
        "vec4 LinearTosRGB( in vec4 value ) {",
        "	return vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.w );",
        "}"
    ].join(`
`))
}, Ur.LINEAR_TO_LINEAR = "LinearToLinear", Ur.SRGB_TO_LINEAR = "sRGBToLinear", Ur.LINEAR_TO_SRGB = "LinearTosRGB";
var Et = class extends me {
    constructor(e = "", n, i, s, o){
        super(e, o, s, i, n);
        this.nodeType = "Expression";
    }
};
var kr = class extends Nt {
    constructor(e = new Vt, n, i, s){
        super("v4", {
            shared: !0
        });
        this.nodeType = "Texture";
        this.value = e, this.uv = n ?? new Ku, this.bias = i, this.project = s !== void 0 ? s : !1;
    }
    getTexture(e, n) {
        return super.generate(e, n, this.value.uuid, "t");
    }
    generate(e, n) {
        if (n === "sampler2D") return this.getTexture(e, n);
        let i = this.getTexture(e, n), s = this.uv.build(e, this.project ? "v4" : "v2"), o = this.bias ? this.bias.build(e, "f") : void 0;
        o === void 0 && e.context.bias && (o = e.context.bias.setTexture(this).build(e, "f"));
        let a, l;
        this.project ? a = "texture2DProj" : a = o ? "tex2DBias" : "tex2D", o ? l = a + "( " + i + ", " + s + ", " + o + " )" : l = a + "( " + i + ", " + s + " )";
        let u = {
            include: e.isShader("vertex"),
            ignoreCache: !0
        }, c = this.getType(e);
        return e.addContext(u), this.colorSpace = this.colorSpace ?? new Ur(new Et("", c)), this.colorSpace.fromDecoding(e.getTextureEncodingFromMap(this.value)), this.colorSpace.input.parse(l), l = this.colorSpace.build(e, c), e.removeContext(), e.format(l, c, n);
    }
};
var _e = class extends Nt {
    constructor(e){
        super("f");
        this.nodeType = "Float";
        this.value = e ?? 0;
    }
    generateReadonly(e, n, i, s, o, a) {
        return e.format(this.value + (this.value % 1 ? "" : ".0"), s, n);
    }
};
var bf = class extends ze {
    constructor(e, n){
        super();
        this.inputs = [];
        this.nodeType = "FunctionCall";
        this.value = e, this.inputs = n ?? [];
    }
    getFunction() {
        return this.value;
    }
    getType(e) {
        return this.value.getType(e);
    }
    generate(e, n, i, s, o) {
        s = this.getType(e);
        let a = this.value, l = a.build(e, n) + "( ", u = [];
        if (a.inputs) {
            for(let c = 0; c < a.inputs.length; c++){
                let d = a.inputs[c], h = this.inputs[c] || this.inputs[d.name];
                u.push(h.build(e, e.getTypeByFormat(d.type)));
            }
            l += u.join(", ") + " )";
        }
        return e.format(l, s, n);
    }
};
var tw = class extends ze {
    constructor(e, n, i = tw.ADD){
        super();
        this.nodeType = "Operator";
        this.type = e.type, this.a = e, this.b = n, this.op = i;
    }
    getType(e) {
        let n = this.a.getType(e), i = this.b.getType(e);
        return e.isTypeMatrix(n) ? "v4" : e.getTypeLength(i) > e.getTypeLength(n) ? i : n;
    }
    generate(e, n) {
        let i = this.getType(e);
        this.type = i;
        let s = this.a.build(e, i), o = this.b.build(e, i);
        return e.format("( " + s + " " + this.op + " " + o + " )", i, n);
    }
}, lr = tw;
lr.ADD = "+", lr.SUB = "-", lr.MUL = "*", lr.DIV = "/";
var Bt = class extends ze {
    constructor(e, n = Bt.ABS, i, s){
        super();
        this.nodeType = "Math";
        this.a = e, typeof n != "string" ? this.b = n : s = n, typeof i != "string" ? this.c = i : s = i, this.method = s, this.hashProperties = [
            "method"
        ];
    }
    getNumInputs(e) {
        switch(this.method){
            case Bt.MIX:
            case Bt.CLAMP:
            case Bt.REFRACT:
            case Bt.SMOOTHSTEP:
            case Bt.FACEFORWARD:
                return 3;
            case Bt.MIN:
            case Bt.MAX:
            case Bt.MOD:
            case Bt.STEP:
            case Bt.REFLECT:
            case Bt.DISTANCE:
            case Bt.DOT:
            case Bt.CROSS:
            case Bt.POW:
                return 2;
            default:
                return 1;
        }
    }
    getInputType(e) {
        let n = e.getTypeLength(this.a.getType(e)), i = this.b ? e.getTypeLength(this.b.getType(e)) : 0, s = this.c ? e.getTypeLength(this.c.getType(e)) : 0;
        return n > i && n > s ? this.a.getType(e) : i > s ? this.b.getType(e) : this.c.getType(e);
    }
    getType(e) {
        switch(this.method){
            case Bt.LENGTH:
            case Bt.DISTANCE:
            case Bt.DOT:
                return "f";
            case Bt.CROSS:
                return "v3";
        }
        return this.getInputType(e);
    }
    generate(e, n) {
        let i, s, o, a = this.a ? e.getTypeLength(this.a.getType(e)) : 0, l = this.b ? e.getTypeLength(this.b.getType(e)) : 0, u = this.c ? e.getTypeLength(this.c.getType(e)) : 0, c = this.getInputType(e), d = this.getType(e);
        switch(this.type = d, this.method){
            case Bt.NEGATE:
                return e.format("( -" + this.a.build(e, c) + " )", c, n);
            case Bt.INVERT:
                return e.format("( 1.0 - " + this.a.build(e, c) + " )", c, n);
            case Bt.CROSS:
                i = this.a.build(e, "v3"), s = this.b.build(e, "v3");
                break;
            case Bt.STEP:
                i = this.a.build(e, a === 1 ? "f" : c), s = this.b.build(e, c);
                break;
            case Bt.MIN:
            case Bt.MAX:
            case Bt.MOD:
                i = this.a.build(e, c), s = this.b.build(e, l === 1 ? "f" : c);
                break;
            case Bt.REFRACT:
                i = this.a.build(e, c), s = this.b.build(e, c), o = this.c.build(e, "f");
                break;
            case Bt.MIX:
                i = this.a.build(e, c), s = this.b.build(e, c), o = this.c.build(e, u === 1 ? "f" : c);
                break;
            default:
                i = this.a.build(e, c), this.b && (s = this.b.build(e, c)), this.c && (o = this.c.build(e, c));
                break;
        }
        let h = [];
        h.push(i), s && h.push(s), o && h.push(o);
        let f = this.getNumInputs(e);
        if (h.length !== f) throw Error(`Arguments not match used in "${this.method}". Require ${f}, currently ${h.length}.`);
        return e.format(this.method + "( " + h.join(", ") + " )", d, n);
    }
}, nt = Bt;
nt.RAD = "radians", nt.DEG = "degrees", nt.EXP = "exp", nt.EXP2 = "exp2", nt.LOG = "log", nt.LOG2 = "log2", nt.SQRT = "sqrt", nt.INV_SQRT = "inversesqrt", nt.FLOOR = "floor", nt.CEIL = "ceil", nt.NORMALIZE = "normalize", nt.FRACT = "fract", nt.SATURATE = "saturate", nt.SIN = "sin", nt.COS = "cos", nt.TAN = "tan", nt.ASIN = "asin", nt.ACOS = "acos", nt.ARCTAN = "atan", nt.ABS = "abs", nt.SIGN = "sign", nt.LENGTH = "length", nt.NEGATE = "negate", nt.INVERT = "invert", nt.MIN = "min", nt.MAX = "max", nt.MOD = "mod", nt.STEP = "step", nt.REFLECT = "reflect", nt.DISTANCE = "distance", nt.DOT = "dot", nt.CROSS = "cross", nt.POW = "pow", nt.MIX = "mix", nt.CLAMP = "clamp", nt.REFRACT = "refract", nt.SMOOTHSTEP = "smoothstep", nt.FACEFORWARD = "faceforward";
var Zu = class extends ze {
    constructor(e, n, i){
        super("v4");
        this.nodeType = "TextureCubeUV";
        this.value = e, this.uv = n, this.bias = i;
    }
    bilinearCubeUV(e, n, i, s) {
        let o = new bf(Zu.Nodes.bilinearCubeUV, [
            n,
            i,
            s
        ]);
        this.colorSpaceTL = this.colorSpaceTL ?? new Ur(new Et("", "v4")), this.colorSpaceTL.fromDecoding(e.getTextureEncodingFromMap(this.value.value)), this.colorSpaceTL.input.parse(o.build(e) + ".tl"), this.colorSpaceTR = this.colorSpaceTR ?? new Ur(new Et("", "v4")), this.colorSpaceTR.fromDecoding(e.getTextureEncodingFromMap(this.value.value)), this.colorSpaceTR.input.parse(o.build(e) + ".tr"), this.colorSpaceBL = this.colorSpaceBL ?? new Ur(new Et("", "v4")), this.colorSpaceBL.fromDecoding(e.getTextureEncodingFromMap(this.value.value)), this.colorSpaceBL.input.parse(o.build(e) + ".bl"), this.colorSpaceBR = this.colorSpaceBR ?? new Ur(new Et("", "v4")), this.colorSpaceBR.fromDecoding(e.getTextureEncodingFromMap(this.value.value)), this.colorSpaceBR.input.parse(o.build(e) + ".br");
        let a = {
            include: e.isShader("vertex"),
            ignoreCache: !0
        };
        e.addContext(a), this.colorSpaceTLExp = new Et(this.colorSpaceTL.build(e, "v4"), "v4"), this.colorSpaceTRExp = new Et(this.colorSpaceTR.build(e, "v4"), "v4"), this.colorSpaceBLExp = new Et(this.colorSpaceBL.build(e, "v4"), "v4"), this.colorSpaceBRExp = new Et(this.colorSpaceBR.build(e, "v4"), "v4"), e.removeContext();
        let l = new Et("mix( mix( cubeUV_TL, cubeUV_TR, cubeUV.f.x ), mix( cubeUV_BL, cubeUV_BR, cubeUV.f.x ), cubeUV.f.y )", "v4");
        return l.keywords.cubeUV_TL = this.colorSpaceTLExp, l.keywords.cubeUV_TR = this.colorSpaceTRExp, l.keywords.cubeUV_BL = this.colorSpaceBLExp, l.keywords.cubeUV_BR = this.colorSpaceBRExp, l.keywords.cubeUV = o, l;
    }
    generate(e, n) {
        if (e.isShader("fragment")) {
            let i = this.uv, s = this.bias || e.context.roughness, o = new bf(Zu.Nodes.roughnessToMip, [
                s
            ]), a = new nt(o, Zu.Nodes.m0, Zu.Nodes.cubeUV_maxMipLevel, nt.CLAMP), l = new nt(a, nt.FLOOR), u = new nt(a, nt.FRACT), c = this.bilinearCubeUV(e, this.value, i, l), d = this.bilinearCubeUV(e, this.value, i, new lr(l, new _e(1).setReadonly(!0), lr.ADD)), h = new nt(c, d, u, nt.MIX);
            return e.format(h.build(e), "v4", n);
        } else return console.warn("TextureCubeUVNode is not compatible with " + e.shader + " shader."), e.format("vec4( 0.0 )", this.getType(e), n);
    }
}, Ju = Zu;
Ju.Nodes = function() {
    let e = new Qu(`struct TextureCubeUVData {
			vec4 tl;
			vec4 tr;
			vec4 br;
			vec4 bl;
			vec2 f;
		}`), n = new At("float cubeUV_maxMipLevel 8.0", !0), i = new At("float cubeUV_minMipLevel 4.0", !0), s = new At("float cubeUV_maxTileSize 256.0", !0), o = new At("float cubeUV_minTileSize 16.0", !0), a = new me(`float getFace(vec3 direction) {
				vec3 absDirection = abs(direction);
				float face = -1.0;
				if (absDirection.x > absDirection.z) {
					if (absDirection.x > absDirection.y)
						face = direction.x > 0.0 ? 0.0 : 3.0;
					else
						face = direction.y > 0.0 ? 1.0 : 4.0;
				} else {
					if (absDirection.z > absDirection.y)
						face = direction.z > 0.0 ? 2.0 : 5.0;
					else
						face = direction.y > 0.0 ? 1.0 : 4.0;
				}
				return face;
		}`);
    a.useKeywords = !1;
    let l = new me(`vec2 getUV(vec3 direction, float face) {
				vec2 uv;
				if (face == 0.0) {
					uv = vec2(direction.z, direction.y) / abs(direction.x); // pos x
				} else if (face == 1.0) {
					uv = vec2(-direction.x, -direction.z) / abs(direction.y); // pos y
				} else if (face == 2.0) {
					uv = vec2(-direction.x, direction.y) / abs(direction.z); // pos z
				} else if (face == 3.0) {
					uv = vec2(-direction.z, direction.y) / abs(direction.x); // neg x
				} else if (face == 4.0) {
					uv = vec2(-direction.x, direction.z) / abs(direction.y); // neg y
				} else {
					uv = vec2(direction.x, direction.y) / abs(direction.z); // neg z
				}
				return 0.5 * (uv + 1.0);
		}`);
    l.useKeywords = !1;
    let u = new me(`TextureCubeUVData bilinearCubeUV(sampler2D envMap, vec3 direction, float mipInt) {
			float face = getFace(direction);
			float filterInt = max(cubeUV_minMipLevel - mipInt, 0.0);
			mipInt = max(mipInt, cubeUV_minMipLevel);
			float faceSize = exp2(mipInt);
			float texelSize = 1.0 / (3.0 * cubeUV_maxTileSize);
			vec2 uv = getUV(direction, face) * (faceSize - 1.0);
			vec2 f = fract(uv);
			uv += 0.5 - f;
			if (face > 2.0) {
				uv.y += faceSize;
				face -= 3.0;
			}
			uv.x += face * faceSize;
			if(mipInt < cubeUV_maxMipLevel){
				uv.y += 2.0 * cubeUV_maxTileSize;
			}
			uv.y += filterInt * 2.0 * cubeUV_minTileSize;
			uv.x += 3.0 * max(0.0, cubeUV_maxTileSize - 2.0 * faceSize);
			uv *= texelSize;
			vec4 tl = texture2D(envMap, uv);
			uv.x += texelSize;
			vec4 tr = texture2D(envMap, uv);
			uv.y += texelSize;
			vec4 br = texture2D(envMap, uv);
			uv.x -= texelSize;
			vec4 bl = texture2D(envMap, uv);
			return TextureCubeUVData( tl, tr, br, bl, f );
		}`, [
        e,
        a,
        l,
        n,
        i,
        s,
        o
    ]);
    u.useKeywords = !1;
    let c = new At("float r0 1.0", !0), d = new At("float v0 0.339", !0), h = new At("float m0 -2.0", !0), f = new At("float r1 0.8", !0), m = new At("float v1 0.276", !0), p = new At("float m1 -1.0", !0), g = new At("float r4 0.4", !0), y = new At("float v4 0.046", !0), v = new At("float m4 2.0", !0), x = new At("float r5 0.305", !0), w = new At("float v5 0.016", !0), S = new At("float m5 3.0", !0), _ = new At("float r6 0.21", !0), M = new At("float v6 0.0038", !0), b = new At("float m6 4.0", !0), T = [
        c,
        d,
        h,
        f,
        m,
        p,
        g,
        y,
        v,
        x,
        w,
        S,
        _,
        M,
        b
    ], E = new me(`float roughnessToMip(float roughness) {
			float mip = 0.0;
			if (roughness >= r1) {
				mip = (r0 - roughness) * (m1 - m0) / (r0 - r1) + m0;
			} else if (roughness >= r4) {
				mip = (r1 - roughness) * (m4 - m1) / (r1 - r4) + m1;
			} else if (roughness >= r5) {
				mip = (r4 - roughness) * (m5 - m4) / (r4 - r5) + m4;
			} else if (roughness >= r6) {
				mip = (r5 - roughness) * (m6 - m5) / (r5 - r6) + m5;
			} else {
				mip = -2.0 * log2(1.16 * roughness);// 1.16 = 1.79^0.25
			}
			return mip;
		}`, T);
    return {
        bilinearCubeUV: u,
        roughnessToMip: E,
        m0: h,
        cubeUV_maxMipLevel: n
    };
}();
var Ml = class extends ze {
    constructor(e){
        super("v3");
        this.nodeType = "Normal";
        this.scope = e ?? Ml.VIEW;
    }
    getShared() {
        return this.scope === Ml.WORLD;
    }
    build(e, n, i, s) {
        let o = e.context[this.scope + "Normal"];
        return o ? o.build(e, n, i, s) : super.build(e, n, i);
    }
    generate(e, n, i, s, o) {
        let a;
        switch(this.scope){
            case Ml.VIEW:
                e.isShader("vertex") ? a = "transformedNormal" : a = "geometryNormal";
                break;
            case Ml.LOCAL:
                e.isShader("vertex") ? a = "objectNormal" : (e.requires.normal = !0, a = "vObjectNormal");
                break;
            case Ml.WORLD:
                e.isShader("vertex") ? a = "inverseTransformDirection( transformedNormal, viewMatrix ).xyz" : (e.requires.worldNormal = !0, a = "vWNormal");
                break;
        }
        return e.format(a, this.getType(e), n);
    }
}, cr = Ml;
cr.LOCAL = "local", cr.WORLD = "world", cr.VIEW = "view", cr.NORMAL = "normal";
Xn.addKeyword("viewNormal", function() {
    return new cr(cr.VIEW);
});
Xn.addKeyword("localNormal", function() {
    return new cr(cr.NORMAL);
});
Xn.addKeyword("worldNormal", function() {
    return new cr(cr.WORLD);
});
var Ps = class extends ze {
    constructor(e){
        super("v3");
        this.nodeType = "Position";
        this.scope = e ?? Ps.LOCAL;
    }
    getType() {
        switch(this.scope){
            case Ps.PROJECTION:
                return "v4";
        }
        return this.type;
    }
    getShader() {
        switch(this.scope){
            case Ps.LOCAL:
            case Ps.WORLD:
                return !1;
        }
        return !0;
    }
    generate(e, n, i, s, o) {
        let a;
        switch(this.scope){
            case Ps.LOCAL:
                e.isShader("vertex") ? a = "transformed" : (e.requires.position = !0, a = "vPosition");
                break;
            case Ps.WORLD:
                if (e.isShader("vertex")) return "( modelMatrix * vec4( transformed, 1.0 ) ).xyz";
                e.requires.worldPosition = !0, a = "vWPosition";
                break;
            case Ps.VIEW:
                a = e.isShader("vertex") ? "-mvPosition.xyz" : "vViewPosition";
                break;
            case Ps.PROJECTION:
                a = e.isShader("vertex") ? "( projectionMatrix * modelViewMatrix * vec4( position, 1.0 ) )" : "vec4( 0.0 )";
                break;
        }
        return e.format(a, this.getType(), n);
    }
}, Qr = Ps;
Qr.LOCAL = "local", Qr.WORLD = "world", Qr.VIEW = "view", Qr.PROJECTION = "projection";
Xn.addKeyword("position", function() {
    return new Qr;
});
Xn.addKeyword("worldPosition", function() {
    return new Qr(Qr.WORLD);
});
Xn.addKeyword("viewPosition", function() {
    return new Qr(Qr.VIEW);
});
var $i = class extends ze {
    constructor(e){
        super("v3");
        this.nodeType = "Reflect";
        this.scope = e ?? $i.CUBE;
    }
    getUnique(e) {
        return !e.context.viewNormal;
    }
    getType() {
        switch(this.scope){
            case $i.SPHERE:
                return "v2";
        }
        return this.type;
    }
    generate(e, n) {
        let i = this.getUnique(e);
        if (e.isShader("fragment")) {
            let s;
            switch(this.scope){
                case $i.VECTOR:
                    {
                        let o = new cr(cr.VIEW), a = e.context.roughness, l = o.build(e, "v3"), u = new Qr(Qr.VIEW).build(e, "v3"), c = a ? a.build(e, "f") : void 0, d = `reflect( -normalize( ${u} ), ${l} )`;
                        c && (d = `normalize( mix( ${d}, ${l}, ${c} * ${c} ) )`);
                        let h = `inverseTransformDirection( ${d}, viewMatrix )`;
                        i ? (e.addNodeCode(`vec3 reflectVec = ${h};`), s = "reflectVec") : s = h;
                        break;
                    }
                case $i.CUBE:
                    {
                        let o = new $i($i.VECTOR).build(e, "v3"), a = "vec3( -" + o + ".x, " + o + ".yz )";
                        i ? (e.addNodeCode(`vec3 reflectCubeVec = ${a};`), s = "reflectCubeVec") : s = a;
                        break;
                    }
                case $i.SPHERE:
                    {
                        let a = "normalize( ( viewMatrix * vec4( " + new $i($i.VECTOR).build(e, "v3") + ", 0.0 ) ).xyz + vec3( 0.0, 0.0, 1.0 ) ).xy * 0.5 + 0.5";
                        i ? (e.addNodeCode(`vec2 reflectSphereVec = ${a};`), s = "reflectSphereVec") : s = a;
                        break;
                    }
            }
            return e.format(s, this.getType(), n);
        } else return console.warn("ReflectNode is not compatible with " + e.shader + " shader."), e.format("vec3( 0.0 )", this.type, n);
    }
}, Ds = $i;
Ds.CUBE = "cube", Ds.SPHERE = "sphere", Ds.VECTOR = "vector";
var Kg = class extends ze {
    constructor(e = new kr, n, i){
        super("v4");
        this.nodeType = "TextureCube";
        this.value = e, this.radianceNode = new Ju(this.value, n ?? new Ds(Ds.VECTOR), i), this.irradianceNode = new Ju(this.value, new cr(cr.WORLD), new _e(1).setReadonly(!0));
    }
    generate(e, n) {
        return e.isShader("fragment") ? (e.require("irradiance"), e.context.bias && e.context.bias.setTexture(this.value), (e.slot === "irradiance" ? this.irradianceNode : this.radianceNode).build(e, n)) : (console.warn("TextureCubeNode is not compatible with " + e.shader + " shader."), e.format("vec4( 0.0 )", this.getType(e), n));
    }
};
var Zg = class extends Nt {
    constructor(e = new lc, n, i){
        super("v4", {
            shared: !0
        });
        this.nodeType = "CubeTexture";
        this.value = e, this.uv = n ?? new Ds, this.bias = i;
    }
    getTexture(e, n) {
        return super.generate(e, n, this.value.uuid, "tc");
    }
    generate(e, n) {
        if (n === "samplerCube") return this.getTexture(e, n);
        let i = this.getTexture(e, n), s = this.uv?.build(e, "v3"), o = this.bias ? this.bias.build(e, "f") : void 0;
        o === void 0 && e.context.bias && (o = e.context.bias.setTexture(this).build(e, "f"));
        let a;
        o ? a = "texCubeBias( " + i + ", " + s + ", " + o + " )" : a = "texCube( " + i + ", " + s + " )";
        let l = {
            include: e.isShader("vertex"),
            ignoreCache: !0
        }, u = this.getType(e);
        return e.addContext(l), this.colorSpace = this.colorSpace ?? new Ur(new Et("", u)), this.colorSpace.fromDecoding(e.getTextureEncodingFromMap(this.value)), this.colorSpace.input.parse(a), a = this.colorSpace.build(e, u), e.removeContext(), e.format(a, u, n);
    }
};
var vP = `
uniform int frameIndex;
uniform vec2 resolution;
uniform mat4 previousModelViewMatrix;
uniform mat4 previousProjectionMatrix;

varying vec4 vCurrentPosition;
varying vec4 vPreviousPosition;
`, xP = `
layout(location = 1) out vec4 gVelocity;

uniform int frameIndex;
uniform vec2 resolution;

varying vec4 vCurrentPosition;
varying vec4 vPreviousPosition;

const vec2 haltonSequence[16] = vec2[16](
vec2( 0.000000,-0.333334),
vec2(-0.500000, 0.333334),
vec2( 0.500000,-0.777778),
vec2(-0.750000,-0.111112),
vec2( 0.250000, 0.555556),
vec2(-0.250000,-0.555556),
vec2( 0.750000, 0.111112),
vec2(-0.875000, 0.777778),
vec2(0.125000, -0.925926),
vec2(-0.375000, -0.259260),
vec2(0.625000, 0.407408),
vec2(-0.625000, -0.703704),
vec2(0.375000, -0.037038),
vec2(-0.125000, 0.629630),
vec2(0.875000, -0.481482),
vec2(-0.937500, 0.185186));

vec2 vogelDiskSample(int sampleIndex, int sampleCount, float angle) {
  const float goldenAngle = 2.399963f; // radians
  float r = sqrt(float(sampleIndex) + 0.5f) / sqrt(float(sampleCount));
  float theta = float(sampleIndex) * goldenAngle + angle;
  float sine = sin(theta);
  float cosine = cos(theta);
  return vec2(cosine, sine) * r;
}

// Derived from the interleaved gradient function from Jimenez 2014 http:goo.gl/eomGso
float getNoiseInterleavedGradient(vec2 screenPos) {
    vec3 magic = vec3(0.06711056f, 0.00583715f, 52.9829189f);
    return fract(magic.z * fract(dot(screenPos, magic.xy)));
}

`, bP = `
// TODO: This could be generated CPU side and passed to the shader every frame
const vec2 haltonSequence[16] = vec2[16](
vec2( 0.000000,-0.333334),
vec2(-0.500000, 0.333334),
vec2( 0.500000,-0.777778),
vec2(-0.750000,-0.111112),
vec2( 0.250000, 0.555556),
vec2(-0.250000,-0.555556),
vec2( 0.750000, 0.111112),
vec2(-0.875000, 0.777778),
vec2(0.125000, -0.925926),
vec2(-0.375000, -0.259260),
vec2(0.625000, 0.407408),
vec2(-0.625000, -0.703704),
vec2(0.375000, -0.037038),
vec2(-0.125000, 0.629630),
vec2(0.875000, -0.481482),
vec2(-0.937500, 0.185186));

// TODO: Pass correct view size
vec2 offset = haltonSequence[frameIndex];
offset.x /= resolution.x;
offset.y /= resolution.y;

vec4 currentPosition = gl_Position;
vec4 currentPositionJittered = currentPosition + (vec4(offset.x, offset.y, 0.0, 0.0) * currentPosition.w);

// We want to calculate the velocity with unjittered positions
// so that things that are not moving get a velocity = 0
vCurrentPosition = currentPosition;
vPreviousPosition = previousProjectionMatrix * previousModelViewMatrix * vec4(transformed, 1.0);
#ifdef OUTLINE_COMPENSATION
vPreviousPosition.xy += OUTLINE_COMPENSATION;
#endif
gl_Position = currentPositionJittered;

`, wP = `
vec2 oldPos = vPreviousPosition.xy;
    oldPos /= vPreviousPosition.w;
    oldPos.xy = (oldPos.xy+1.)/2.0;

vec2 newPos = vCurrentPosition.xy;
    newPos /= vCurrentPosition.w;
    newPos.xy = (newPos.xy+1.)/2.0;

vec2 velocity = (newPos - oldPos);

// NOTE: We use the blue channel to avoid temporal reprojection
// with incorrect velocity if the fragment is transparent.
gVelocity = vec4(velocity, gl_FragColor.a < 1.0 ? 0.0 : 1.0, 1.);
`;
var SP = [
    "x",
    "y",
    "z",
    "w"
], uW = [
    "float",
    "vec2",
    "vec3",
    "vec4"
], dW = {
    float: "f",
    vec2: "v2",
    vec3: "v3",
    vec4: "v4",
    mat4: "v4",
    int: "i",
    bool: "b",
    "float[]": "f[]",
    "vec4[]": "v4[]"
}, hW = {
    t: "sampler2D",
    tc: "samplerCube",
    b: "bool",
    i: "int",
    f: "float",
    c: "vec3",
    v2: "vec2",
    v3: "vec3",
    v4: "vec4",
    m3: "mat3",
    m4: "mat4",
    "f[]": "float[]",
    "v4[]": "vec4[]"
}, Jg = class {
    constructor(){
        this.includes = {
            consts: {},
            functions: {},
            structs: {}
        };
        this.cache = "";
        this.slot = "";
        this.shader = "";
        this.context = {};
        this.needsJitter = !0;
        this.getIncludesCode = function() {
            function t(e, n) {
                return e.deps.length - n.deps.length;
            }
            return function(n, i) {
                let s = this.getIncludes(n, i);
                if (!s) return "";
                let o = "";
                s = s.sort(t);
                for(let a = 0; a < s.length; a++)s[a].src && (o += s[a].src + `
`);
                return o;
            };
        }();
        this.slots = [], this.caches = [], this.contexts = [], this.keywords = {}, this.nodeData = {}, this.fragmentVariables = {}, this.fragmentParsVariables = {}, this.vertexParsVariables = {}, this.requires = {
            uv: [],
            color: [],
            transparent: !1,
            irradiance: !1,
            position: !1,
            worldPosition: !1,
            normal: !1,
            worldNormal: !1,
            vWorldViewDir: !1,
            modelMatrix: !1,
            viewMatrix: !1,
            projectionMatrix: !1
        }, this.includes = {
            consts: [],
            functions: [],
            structs: []
        }, this.attributes = {}, this.prefixCode = [
            "#ifdef TEXTURE_LOD_EXT",
            "	#define texCube(a, b) textureCube(a, b)",
            "	#define texCubeBias(a, b, c) textureCubeLodEXT(a, b, c)",
            "	#define tex2D(a, b) texture2D(a, b)",
            "	#define tex2DBias(a, b, c) texture2DLodEXT(a, b, c)",
            "#else",
            "	#define texCube(a, b) textureCube(a, b)",
            "	#define texCubeBias(a, b, c) textureCube(a, b, c)",
            "	#define tex2D(a, b) texture2D(a, b)",
            "	#define tex2DBias(a, b, c) texture2D(a, b, c)",
            "#endif",
            `
			// NOTE: Include Spline's blending modes. This could be part of BlendNode
			#define SPE_BLENDING_NORMAL 0
			#define SPE_BLENDING_MULTIPLY 1
			#define SPE_BLENDING_SCREEN 2
			#define SPE_BLENDING_OVERLAY 3

			vec3 spe_normalBlend( vec3 a, vec3 b, float alpha ) {
				return mix( a, b, alpha );
			}

			vec3 spe_multiplyBlend( vec3 a, vec3 b, float alpha ) {
				return mix( a, a * b, alpha );
			}

			vec3 spe_screenBlend( vec3 a, vec3 b, float alpha ) {
				vec3 tmp = 1.0 - ( 1.0 - a ) * ( 1.0 - b );
				return mix( a, tmp, alpha );
			}

			vec3 spe_overlayBlend( vec3 a, vec3 b, float alpha ) {
				vec3 tmp = mix( 1. - 2. * (1. - a) * (1. - b), 2. * a * b, step( a, vec3(.5) ) );
				return clamp( mix( a, tmp, alpha ), 0.0, 1.0 );
			}

			vec3 spe_blend( vec3 a, vec3 b, float alpha, int mode ) {
				if ( mode == SPE_BLENDING_NORMAL ) return spe_normalBlend( a, b, alpha );
				else if ( mode == SPE_BLENDING_MULTIPLY ) return spe_multiplyBlend( a, b, alpha );
				else if ( mode == SPE_BLENDING_SCREEN ) return spe_screenBlend( a, b, alpha );
				else if ( mode == SPE_BLENDING_OVERLAY ) return spe_overlayBlend( a, b, alpha );
				return vec3( 1.0 );
			}
			`,
            "#include <packing>",
            "#include <common>"
        ].join(`
`), this.parsCode = {
            vertex: [
                "float neighbor_offset = 0.0001;",
                ""
            ].join(`
`),
            fragment: [
                "float accumAlpha = 0.0;",
                `void accumulateAlpha(float alpha) {
					accumAlpha += (1.0 - accumAlpha) * alpha;
				}`,
                ""
            ].join(`
`)
        }, this.code = {
            vertex: "",
            fragment: ""
        }, this.nodeCode = {
            vertex: "",
            fragment: ""
        }, this.resultCode = {
            vertex: "",
            fragment: ""
        }, this.finalCode = {
            vertex: "",
            fragment: ""
        }, this.inputs = {
            uniforms: {
                list: [],
                vertex: [],
                fragment: []
            },
            arrayUniforms: {
                list: [],
                vertex: [],
                fragment: []
            },
            vars: {
                varying: [],
                vertex: [],
                fragment: []
            }
        }, this.defines = {}, this.uniforms = {}, this.extensions = {
            derivatives: !1,
            fragDepth: !1,
            drawBuffers: !1,
            shaderTextureLOD: !1
        }, this.updaters = [], this.nodes = [], this.analyzing = !1;
    }
    build(t, e) {
        this.addVertexParsCode(vP), this.addFragmentParsCode(xP), this.buildShader("vertex", t), this.buildShader("fragment", e);
        for(let n = 0; n < this.requires.uv.length; n++)if (this.requires.uv[n]) {
            let i = n > 0 ? n + 1 : "";
            this.addVaryCode("varying vec2 vUv" + i + ";"), n > 0 && this.addVertexParsCode("attribute vec2 uv" + i + ";"), this.addVertexFinalCode("vUv" + i + " = uv" + i + ";");
        }
        return this.requires.color[0] && (this.addVaryCode("varying vec4 vColor;"), this.addVertexParsCode("attribute vec4 color;"), this.addVertexFinalCode("vColor = color;")), this.requires.color[1] && (this.addVaryCode("varying vec4 vColor2;"), this.addVertexParsCode("attribute vec4 color2;"), this.addVertexFinalCode("vColor2 = color2;")), this.requires.position && (this.addVaryCode("varying vec3 vPosition;"), this.addVertexFinalCode("vPosition = transformed;")), this.requires.worldPosition, this.requires.normal && (this.addVaryCode("varying vec3 vObjectNormal;"), this.addVertexFinalCode("vObjectNormal = normal;")), this.requires.modelMatrix && this.addFragmentParsCode("uniform mat4 modelMatrix;"), this.requires.viewMatrix && this.addFragmentParsCode("uniform mat4 viewMatrix;"), this.requires.projectionMatrix && this.addFragmentParsCode("uniform mat4 projectionMatrix;"), this.requires.worldNormal && (this.addVaryCode("varying vec3 vWNormal;"), this.addVertexFinalCode("vWNormal = inverseTransformDirection( transformedNormal, viewMatrix ).xyz;")), this.requires.vWorldViewDir && (this.addVaryCode("varying vec3 vWorldViewDir;"), this.addVertexFinalCode("vWorldViewDir = isPerspectiveMatrix( projectionMatrix ) ?  ( (modelMatrix * vec4(position, 1.0)).xyz - cameraPosition ) : vec3( -viewMatrix[0][2], -viewMatrix[1][2], -viewMatrix[2][2] );")), this.needsJitter && (this.addVertexFinalCode(bP), this.addFragmentFinalCode(wP)), this;
    }
    buildShader(t, e) {
        this.resultCode[t] = e.build(this.setShader(t), "v4");
    }
    setMaterial(t, e) {
        return this.defines = {}, this;
    }
    addFlow(t, e, n) {
        return this.addSlot(t).addCache(e).addContext(n);
    }
    removeFlow() {
        return this.removeSlot().removeCache().removeContext();
    }
    addCache(t) {
        return this.cache = t ?? "", this.caches.push(this.cache), this;
    }
    removeCache() {
        return this.caches.pop(), this.cache = this.caches[this.caches.length - 1] || "", this;
    }
    addContext(t) {
        return this.context = Object.assign({}, this.context, t), this.context.extra = this.context.extra || {}, this.contexts.push(this.context), this;
    }
    removeContext() {
        return this.contexts.pop(), this.context = this.contexts[this.contexts.length - 1] || {}, this;
    }
    addSlot(t) {
        return this.slot = t || "", this.slots.push(this.slot), this;
    }
    removeSlot() {
        return this.slots.pop(), this.slot = this.slots[this.slots.length - 1] || "", this;
    }
    addFragmentVariable(t, e) {
        this.fragmentVariables[t] === void 0 && (this.addFragmentCode(`${e} ${t};`), this.fragmentVariables[t] = "");
    }
    addFragmentParsVariable(t, e) {
        this.fragmentParsVariables[t] === void 0 && (this.addFragmentParsCode(`${e} ${t};`), this.fragmentParsVariables[t] = "");
    }
    addVertexParsVariable(t, e) {
        this.vertexParsVariables[t] === void 0 && (this.addVertexParsCode(`${e} ${t};`), this.vertexParsVariables[t] = "");
    }
    addVertexCode(t) {
        this.addCode(t, "vertex");
    }
    addFragmentCode(t) {
        this.addCode(t, "fragment");
    }
    addCode(t, e) {
        this.code[e ?? this.shader] += t + `
`;
    }
    addVertexNodeCode(t) {
        this.addNodeCode(t, "vertex");
    }
    addFragmentNodeCode(t) {
        this.addNodeCode(t, "fragment");
    }
    addNodeCode(t, e) {
        this.nodeCode[e ?? this.shader] += t + `
`;
    }
    clearNodeCode(t) {
        t = t ?? this.shader;
        let e = this.nodeCode[t];
        return this.nodeCode[t] = "", e;
    }
    clearVertexNodeCode() {
        return this.clearNodeCode("vertex");
    }
    clearFragmentNodeCode() {
        return this.clearNodeCode("fragment");
    }
    addVertexFinalCode(t) {
        this.addFinalCode(t, "vertex");
    }
    addFragmentFinalCode(t) {
        this.addFinalCode(t, "fragment");
    }
    addFinalCode(t, e) {
        this.finalCode[e ?? this.shader] += t + `
`;
    }
    addVertexParsCode(t) {
        this.addParsCode(t, "vertex");
    }
    addFragmentParsCode(t) {
        this.addParsCode(t, "fragment");
    }
    addParsCode(t, e) {
        this.parsCode[e ?? this.shader] += t + `
`;
    }
    addVaryCode(t) {
        this.addVertexParsCode(t), this.addFragmentParsCode(t);
    }
    isCache(t) {
        return this.caches.indexOf(t) !== -1;
    }
    isSlot(t) {
        return this.slots.indexOf(t) !== -1;
    }
    define(t, e) {
        this.defines[t] = e === void 0 ? 1 : e;
    }
    require(t) {
        this.requires[t] = !0;
    }
    isDefined(t) {
        return this.defines[t] !== void 0;
    }
    getVar(t, e, n, i = "varying", s = "V", o = "") {
        let a = this.getVars(i), l = a[t];
        if (!l) {
            let u = a.length;
            l = {
                name: n || "node" + s + u + (o ? "_" + o : ""),
                type: e
            }, a.push(l), a[t] = l;
        }
        return l;
    }
    getTempVar(t, e, n, i) {
        return this.getVar(t, e, n, this.shader, "T", i);
    }
    getAttribute(t, e) {
        if (!this.attributes[t]) {
            let n = this.getVar(t, e);
            this.addVertexParsCode("attribute " + e + " " + t + ";"), this.addVertexFinalCode(n.name + " = " + t + ";"), this.attributes[t] = {
                varying: n,
                name: t,
                type: e
            };
        }
        return this.attributes[t];
    }
    getCode(t) {
        return [
            this.prefixCode,
            this.parsCode[t],
            this.getVarListCode(this.getVars("varying"), "varying"),
            this.getVarListCode(this.inputs.uniforms[t], "uniform"),
            this.getVarListCode(this.inputs.arrayUniforms[t], "uniform"),
            this.getIncludesCode("consts", t),
            this.getIncludesCode("structs", t),
            this.getIncludesCode("functions", t),
            "void main() {",
            this.getVarListCode(this.getVars(t)),
            this.code[t],
            this.resultCode[t],
            this.finalCode[t],
            "}"
        ].join(`
`);
    }
    getVarListCode(t, e) {
        e = e ?? "";
        let n = "";
        for(let i = 0, s = t.length; i < s; ++i){
            let o = t[i], a = o.type, l = o.name, u = o.size, c = this.getFormatByType(a);
            if (c === void 0) throw new Error("Node pars " + c + " not found.");
            c.includes("[]") ? n += e + " " + c.substring(0, c.length - 2) + " " + l + `[${u}];
` : n += e + " " + c + " " + l + `;
`;
        }
        return n;
    }
    getVars(t) {
        return this.inputs.vars[t ?? this.shader];
    }
    getNodeData(t) {
        let e = t instanceof ar ? t.uuid : t;
        return this.nodeData[e] = this.nodeData[e] || {};
    }
    createUniform(t, e, n, i, s, o) {
        if (e.includes("[]")) {
            let a = this.inputs.arrayUniforms, l = a.list.length, u = new xf({
                type: e,
                size: n.size,
                name: i || "nodeUA" + l + (o ? "_" + o : ""),
                node: n,
                needsUpdate: s
            });
            return a.list.push(u), a[t].push(u), a[t][u.name] = u, this.uniforms[u.name] = u, u;
        } else {
            let a = this.inputs.uniforms, l = a.list.length, u = new xf({
                type: e,
                name: i || "nodeU" + l + (o ? "_" + o : ""),
                node: n,
                needsUpdate: s
            });
            return a.list.push(u), a[t].push(u), a[t][u.name] = u, this.uniforms[u.name] = u, u;
        }
    }
    createVertexUniform(t, e, n, i, s) {
        return this.createUniform("vertex", t, e, n, i, s);
    }
    createFragmentUniform(t, e, n, i, s) {
        return this.createUniform("fragment", t, e, n, i, s);
    }
    include(t, e, n) {
        let i;
        if (t = typeof t == "string" ? Xn.get(t) : t, this.context.include === !1) return t.name;
        t instanceof me ? i = this.includes.functions : t instanceof At ? i = this.includes.consts : t instanceof Qu && (i = this.includes.structs);
        let s = i[this.shader] = i[this.shader] || [];
        if (t) {
            let o = s[t.name];
            if (o || (o = s[t.name] = {
                node: t,
                deps: []
            }, s.push(o), o.src = t.build(this, "source")), t instanceof me && e && s[e.name] && s[e.name].deps.indexOf(t) === -1 && (s[e.name].deps.push(t), t.includes?.length)) {
                let a = 0;
                do this.include(t.includes[a++], e);
                while (a < t.includes.length);
            }
            return n && (o.src = n), t.name;
        } else throw new Error("Include not found.");
    }
    colorToVectorProperties(t) {
        return t.replace("r", "x").replace("g", "y").replace("b", "z").replace("a", "w");
    }
    colorToVector(t) {
        return t.replace(/c/g, "v3");
    }
    getIncludes(t, e) {
        return this.includes[t][e || this.shader];
    }
    getConstructorFromLength(t) {
        return uW[t - 1];
    }
    isTypeMatrix(t) {
        return /^m/.test(t);
    }
    getTypeLength(t) {
        return t === "f" ? 1 : parseInt(this.colorToVector(t).substr(1));
    }
    getTypeFromLength(t) {
        return t === 1 ? "f" : "v" + t;
    }
    findNode(...t) {
        for(let e = 0; e < arguments.length; e++){
            let n = t[e];
            if (n?.isNode) return n;
        }
    }
    resolve(...t) {
        for(let e = 0; e < arguments.length; e++){
            let n = t[e];
            if (n !== void 0) {
                if (n.isNode) return n;
                if (n.isTexture) switch(n.mapping){
                    case Vo:
                    case Ho:
                        return new Zg(n);
                    case Ac:
                        return new Kg(new kr(n));
                    default:
                        return new kr(n);
                }
                else {
                    if (n.isVector2) return new hn(n);
                    if (n.isVector3) return new yr(n);
                    if (n.isVector4) return new Yr(n);
                }
            }
        }
    }
    format(t, e, n) {
        switch(this.colorToVector(n + " <- " + e)){
            case "f <- v2":
                return t + ".x";
            case "f <- v3":
                return t + ".x";
            case "f <- v4":
                return t + ".x";
            case "f <- i":
            case "f <- b":
                return "float( " + t + " )";
            case "v2 <- f":
                return "vec2( " + t + " )";
            case "v2 <- v3":
                return t + ".xy";
            case "v2 <- v4":
                return t + ".xy";
            case "v2 <- i":
            case "v2 <- b":
                return "vec2( float( " + t + " ) )";
            case "v3 <- f":
                return "vec3( " + t + " )";
            case "v3 <- v2":
                return "vec3( " + t + ", 0.0 )";
            case "v3 <- v4":
                return t + ".xyz";
            case "v3 <- i":
            case "v3 <- b":
                return "vec2( float( " + t + " ) )";
            case "v4 <- f":
                return "vec4( " + t + " )";
            case "v4 <- v2":
                return "vec4( " + t + ", 0.0, 1.0 )";
            case "v4 <- v3":
                return "vec4( " + t + ", 1.0 )";
            case "v4 <- i":
            case "v4 <- b":
                return "vec4( float( " + t + " ) )";
            case "i <- f":
            case "i <- b":
                return "int( " + t + " )";
            case "i <- v2":
                return "int( " + t + ".x )";
            case "i <- v3":
                return "int( " + t + ".x )";
            case "i <- v4":
                return "int( " + t + ".x )";
            case "b <- f":
                return "( " + t + " != 0.0 )";
            case "b <- v2":
                return "( " + t + " != vec2( 0.0 ) )";
            case "b <- v3":
                return "( " + t + " != vec3( 0.0 ) )";
            case "b <- v4":
                return "( " + t + " != vec4( 0.0 ) )";
            case "b <- i":
                return "( " + t + " != 0 )";
        }
        return t;
    }
    getTypeByFormat(t) {
        return dW[t] || t;
    }
    getFormatByType(t) {
        return hW[t] || t;
    }
    getUUID(t, e) {
        return e = e !== void 0 ? e : !0, e && this.cache && (t = this.cache + "-" + t), t;
    }
    getElementByIndex(t) {
        return SP[t];
    }
    getIndexByElement(t) {
        return SP.indexOf(t);
    }
    isShader(t) {
        return this.shader === t;
    }
    setShader(t) {
        return this.shader = t, this;
    }
    mergeDefines(t) {
        for(let e in t)this.defines[e] = t[e];
        return this.defines;
    }
    mergeUniform(t) {
        for(let e in t)this.uniforms[e] = t[e];
        return this.uniforms;
    }
    getTextureEncodingFromMap(t) {
        let e;
        return t ? t.isTexture && (e = t.encoding) : e = oi, e === oi && this.context.gamma && (e = Ye), e;
    }
};
var It = class extends Nt {
    constructor(e = 0, n, i, s){
        super("c");
        this.nodeType = "Color";
        this.value = e instanceof $t ? e : new $t(e || 0, n, i, s);
    }
    setRGBA(e) {
        this.value.setRGBA(e.r, e.g, e.b, e.a);
    }
    generate(e, n, i, s, o, a) {
        i = e.getUUID(i ?? this.getUUID()), s = s ?? this.getType(e);
        let l = e.getNodeData(i), u = this.getReadonly() && this.generateReadonly !== void 0;
        if (this.alpha) {
            let c = this.alpha.build(e, "f");
            e.addFragmentNodeCode(`accumAlpha += ( 1.0 - accumAlpha ) * ${c};`);
        }
        return u ? this.generateReadonly(e, n, i, s, o, a) : e.isShader("vertex") ? (l.vertex || (l.vertex = e.createVertexUniform(s, this, o, a, this.getLabel())), e.format(l.vertex.name, s, n)) : (l.fragment || (l.fragment = e.createFragmentUniform(s, this, o, a, this.getLabel())), e.format(l.fragment.name, s, n));
    }
    generateReadonly(e, n, i, s, o, a) {
        return e.format("vec3(" + this.value.r + ", " + this.value.g + ", " + this.value.b + ")", s, n);
    }
};
var dt = class extends Nt {
    constructor(e){
        super("i");
        this.nodeType = "Int";
        this.value = Math.floor(e ?? 0);
    }
    generateReadonly(e, n, i, s, o, a) {
        return e.format(this.value.toString(), s, n);
    }
};
var fn = class extends Nt {
    constructor(e){
        super("b");
        this.nodeType = "Bool";
        this.value = e ?? !1;
    }
    generateReadonly(e, n, i, s) {
        return e.format(this.value ? "true" : "false", s, n);
    }
};
var es = class extends Nt {
    constructor(e = 1, n){
        super("f[]");
        this.nodeType = "FloatArray";
        this.size = e, this.value = Array.isArray(n) ? n : typeof n == "number" ? new Array(e).fill(n) : new Array(e).fill(0);
    }
};
var ya = class extends Nt {
};
var $g = class extends ya {
    constructor(e){
        super("v3");
        this.image = e;
        this._value = new A;
    }
    get value() {
        return this._value.x = this.image.isVideo ? this.image.img.videoWidth ?? 0 : this.image.img.width, this._value.y = this.image.isVideo ? this.image.img.videoHeight ?? 0 : this.image.img.height, this._value;
    }
};
var Tl = class extends ya {
    constructor(e, n){
        super("t");
        this.image = e;
        this.wrap = n;
    }
    get value() {
        return this.image.getTexture(this.wrap);
    }
};
var $u = class extends Nt {
    constructor(e){
        super("m3");
        this.nodeType = "Matrix3";
        this.value = e ?? new Kt;
    }
    generateReadonly(e, n, i, s, o, a) {
        return e.format("mat3(" + this.value.elements.join(", ") + ")", s, n);
    }
    get elements() {
        return this.value.elements;
    }
    set elements(e) {
        this.value.fromArray(e);
    }
};
var vr = class extends Nt {
    constructor(e){
        super("m4");
        this.nodeType = "Matrix4";
        this.value = e ?? new ae;
    }
    generateReadonly(e, n, i, s, o, a) {
        return e.format("mat4(" + this.value.elements.join(", ") + ")", s, n);
    }
    get elements() {
        return this.value.elements;
    }
    set elements(e) {
        this.value.fromArray(e);
    }
};
function AP(r1, t, e) {
    r1.setUvTransform(e[0], e[1], t[0], t[1], 0, 0, 0);
}
var ey = class extends $u {
    constructor(e, n){
        super(new Kt);
        this.repeat = e;
        this.offset = n;
        AP(this.value, e, n);
    }
    updateMatrix() {
        AP(this.value, this.repeat, this.offset);
    }
};
var ts = class extends Nt {
    constructor(e = 1, n){
        super("v4[]");
        this.nodeType = "Vector4Array";
        this.size = e, this.value = Array.isArray(n) ? n : n instanceof Ze ? new Array(e).fill(n) : new Array(e).fill(new Ze(0));
    }
};
var ed = class extends ze {
    constructor(e, n, i, s){
        super("v3");
        this.nodeType = "Blend";
        this.a = e, this.b = n, this.alpha = i, this.mode = s;
    }
    generate(e, n) {
        if (e.isShader("fragment")) {
            let i = [];
            return i.push(this.a.build(e, "c")), i.push(this.b.build(e, "c")), i.push(this.alpha.build(e, "f")), i.push(this.mode.build(e, "i")), e.format("spe_blend(" + i.join(",") + ")", this.getType(e), n);
        } else return console.warn("BlendNode is not compatible with " + e.shader + " shader."), e.format("vec3( 0.0 )", this.getType(e), n);
    }
};
var nw = class extends ze {
    constructor(e, n){
        super("v3");
        this.nodeType = "CustomColor";
        this.color = e, this.alpha = n, this.calpha = `g${this.uuid.toString().replace(/-/g, "")}_calpha`;
    }
    generate(e, n) {
        if (e.isShader("fragment")) {
            let i = e.include(nw.Nodes.customColor);
            e.addFragmentVariable(this.calpha, "float");
            let s = [];
            return s.push(this.color.build(e, "v3")), s.push(this.mask ? `luminance(${this.mask.build(e, "v3")})` : "1.0"), s.push(this.alpha.build(e, "f")), s.push(this.calpha), e.format(i + "(" + s.join(",") + ")", this.getType(e), n);
        } else return console.warn("CustomColorNode is not compatible with " + e.shader + " shader."), e.format("vec3( 0.0 )", this.getType(e), n);
    }
}, El = nw;
El.Nodes = function() {
    return {
        customColor: new me(`vec3 customColor(vec3 color, float mask, float alpha, out float calpha) {
				float lalpha = alpha * mask;
				calpha =  lalpha / clamp(lalpha + accumAlpha, 0.00001, 1.0);
				accumAlpha += (1.0 - accumAlpha) * lalpha;

				return color;
			}`)
    };
}();
var rw = class extends ze {
    constructor(e, n){
        super("v3");
        this.nodeType = "CustomNormal";
        this.cnormal = e, this.alpha = n, this.calpha = `g${this.uuid.toString().replace(/-/g, "")}_calpha`;
    }
    generate(e, n) {
        if (e.isShader("fragment")) {
            let i = e.include(rw.Nodes.customNormal);
            e.addFragmentVariable(this.calpha, "float");
            let s = [];
            return s.push(this.cnormal.build(e, "v3")), s.push("normal"), s.push(this.mask ? `luminance(${this.mask.flow(e, "v3").result})` : "1.0"), s.push(this.alpha.build(e, "f")), s.push(this.calpha), e.format(i + "(" + s.join(",") + ")", this.getType(e), n);
        } else return console.warn("CustomNormalNode is not compatible with " + e.shader + " shader."), e.format("vec3( 0.0 )", this.getType(e), n);
    }
}, td = rw;
td.Nodes = function() {
    return {
        customNormal: new me(`vec3 customNormal(vec3 cnormal, vec3 norm, float mask, float alpha, out float calpha) {
				vec3 normal = packNormalToRGB( norm ).rgb;
				normal *= step( vec3(0.5), cnormal );

				float lalpha = alpha * mask;
				calpha =  lalpha / clamp( lalpha + accumAlpha, 0.00001, 1.0 );
				accumAlpha += ( 1.0 - accumAlpha ) * lalpha;

				return normal;
			}`)
    };
}();
var nd = class extends ze {
    constructor(e, n, i, s, o, a, l, u, c, d, h, f){
        super("v3");
        this.nodeType = "CustomTexture";
        this.firstTime = !0, this.texture = e, this.textureSize = n, this.crop = i, this.projection = s, this.axis = o, this.side = a, this.size = l, this.blending = u, this.mat = c, this.alpha = d, this.mode = h, this.isMask = f, this.calpha = `g${this.uuid.toString().replace(/-/g, "")}_calpha`;
    }
    generate(e, n) {
        e.require("position"), e.require("normal"), e.require("uv"), e.requires.uv = [
            !0
        ], e.extensions.shaderTextureLOD = !0, e.extensions.derivatives = !0;
        let i = `g${this.uuid.toString().replace(/-/g, "")}`, s;
        switch(this.projection.value){
            case 3:
                s = e.include(nd.Nodes.cylindrical);
                break;
            case 2:
                s = e.include(nd.Nodes.spherical);
                break;
            case 1:
                let a = [
                    "vec3(1.0, 0.0, 0.0)",
                    "vec3(0.0, 1.0, 0.0)",
                    "vec3(0.0, 0.0, 1.0)"
                ][this.axis.value], l = new me(`
		vec3 ${i}_planarTexture(vec3 normal, sampler2D tex, vec2 textureSize, float crop, mat3 mat, vec2 size, float blending, bool isMask, float mask, float alpha, int mode, out float calpha) {

				vec2 uvs = ( mat * vec3( (${i}_vCustomUv * 2. - 1.) / (size * .5), 1. ) / 2. + 0.5 ).xy;

				vec4 tmp = texture2D( tex, uvs );

				vec3 col = tmp.rgb;
				float lalpha = alpha * tmp.a;
				${this.side.value === 2 ? "" : `lalpha *= step(0.0, ${this.side.value === 1 ? "-1.0 * " : ""}dot(vObjectNormal, mat * ${a}));`}

				if ( crop > 0.5 ) {
					if ( uvs.x < 0.0 || uvs.x > 1.0 || uvs.y < 0.0 || uvs.y > 1.0 )  {
						lalpha = 0.0;
					}
				}
				
				lalpha *= mask;

				calpha =  lalpha / clamp( lalpha + accumAlpha, 0.00001, 1.0 );
				accumAlpha += (1.0 - accumAlpha) * lalpha * (1.0 - float(isMask));

				return col;
			}`);
                s = e.include(l);
                break;
            case 4:
                s = e.include(nd.Nodes.triplanar);
                break;
            default:
                s = e.include(nd.Nodes.uv);
                break;
        }
        if (this.projection.value === 1 && this.firstTime) {
            e.addVertexParsCode(`varying vec2 ${i}_vCustomUv;`), e.addFragmentParsCode(`varying vec2 ${i}_vCustomUv;`);
            let a = [
                "zy",
                "xz",
                "xy"
            ][this.axis.value];
            e.addVertexFinalCode(`${i}_vCustomUv = (1. + (transformed.${a})) / 2.;`);
        }
        e.addFragmentVariable(this.calpha, "float");
        let o = [];
        return o.push("normal"), o.push(this.texture.generate(e, "t")), o.push(this.textureSize.build(e, "v2")), o.push(this.crop.build(e, "f")), o.push(this.mat.build(e, "mat3")), o.push(this.size.build(e, "v2")), o.push(this.blending.build(e, "f")), o.push(this.isMask.build(e, "b")), o.push(this.mask ? `luminance(${this.mask.flow(e, "v3").result})` : "1.0"), o.push(this.alpha.build(e, "f")), o.push(this.mode.build(e, "i")), o.push(this.calpha), this.firstTime = !this.firstTime, e.format(s + "(" + o.join(",") + ")", this.getType(e), n);
    }
}, rd = nd;
rd.Nodes = function() {
    let e = new me(`
vec3 cylindricalTexture(vec3 normal, sampler2D tex, vec2 textureSize, float crop, mat3 mat, vec2 size, float blending, bool isMask, float mask, float alpha, int mode, out float calpha) {
                vec3 posN = normalize(position);
                float u = 0.5 + atan(posN.z, posN.x) / (2.*3.1415);
                float scaledHeight = position.y / (size.y * 0.5);
                float v =  (scaledHeight / 2.) + .5;

                vec2 calculatedUv = vec2(u,v);
				vec2 uvs = ( mat * vec3( calculatedUv * 2. - 1., 1. ) / 2. + 0.5 ).xy;

                vec2 df = fwidth(uvs);
               	if(df.x > 0.5) df.x = 0.;

				#ifdef GL_EXT_shader_texture_lod
                vec4 tmp = texture2DLodEXT(tex, uvs, log2(max(df.x, df.y)*min(textureSize.x, textureSize.y)));
				#else
                vec4 tmp = textureLod(tex, uvs, log2(max(df.x, df.y)*min(textureSize.x, textureSize.y)));
				#endif

				vec3 col = tmp.rgb;
				float lalpha = alpha * tmp.a;
				if ( crop > 0.5 ) {
					if ( uvs.x < 0.0 || uvs.x > 1.0 || uvs.y < 0.0 || uvs.y > 1.0 )  {
						lalpha = 0.0;
					}
				}

				lalpha *= mask;
				
				calpha =  lalpha / clamp( lalpha + accumAlpha, 0.00001, 1.0 );
				accumAlpha += (1.0 - accumAlpha) * lalpha * (1.0 - float(isMask));

				return col;
			}
`), n = new me(`
vec3 sphericalTexture(vec3 normal, sampler2D tex, vec2 textureSize, float crop, mat3 mat, vec2 size, float blending, bool isMask, float mask, float alpha, int mode, out float calpha) {
                vec3 posN = normalize(vPosition);
                float u = 0.5 + atan(posN.z, posN.x) / (2.*3.1415);
                float v = 0.5 + asin(posN.y) / 3.1415;

                vec2 calculatedUv = vec2(u,v);
				vec2 uvs = ( mat * vec3( calculatedUv * 2. - 1., 1. ) / 2. + 0.5 ).xy;

                vec2 df = fwidth(uvs);
               	if(df.x > 0.5) df.x = 0.;
				#ifdef GL_EXT_shader_texture_lod
                vec4 tmp = texture2DLodEXT(tex, uvs, log2(max(df.x, df.y)*min(textureSize.x, textureSize.y)));
				#else
                vec4 tmp = textureLod(tex, uvs, log2(max(df.x, df.y)*min(textureSize.x, textureSize.y)));
				#endif

				vec3 col = tmp.rgb;
				float lalpha = alpha * tmp.a;
				if ( crop > 0.5 ) {
					if ( uvs.x < 0.0 || uvs.x > 1.0 || uvs.y < 0.0 || uvs.y > 1.0 )  {
						lalpha = 0.0;
					}
				}

				lalpha *= mask;

				calpha =  lalpha / clamp( lalpha + accumAlpha, 0.00001, 1.0 );
				accumAlpha += (1.0 - accumAlpha) * lalpha * (1.0 - float(isMask));

				return col;
			}
`), i = new me(`vec3 uvTexture(vec3 normal, sampler2D tex, vec2 textureSize, float crop, mat3 mat, vec2 size, float blending, bool isMask, float mask, float alpha, int mode, out float calpha) {

				vec2 uvs = ( mat * vec3( vUv * 2. - 1., 1. ) / 2. + 0.5 ).xy;
				vec4 tmp = texture2D( tex, uvs );

				vec3 col = tmp.rgb;

				float lalpha = alpha * tmp.a;
				if ( crop > 0.5 ) {
					if ( uvs.x < 0.0 || uvs.x > 1.0 || uvs.y < 0.0 || uvs.y > 1.0 )  {
						lalpha = 0.0;
					}
				}
				
				lalpha *= mask;

				calpha =  lalpha / clamp( lalpha + accumAlpha, 0.00001, 1.0 );
				accumAlpha += (1.0 - accumAlpha) * lalpha * (1.0 - float(isMask));

				return col;
			}`), s = new me(`vec3 triplanarTexture(vec3 normal, sampler2D tex, vec2 textureSize, float crop, mat3 mat, vec2 size, float blending, bool isMask, float mask, float alpha, int mode, out float calpha) {
				vec3 p = position;
				vec2 uv0 = (1.0 + p.xy) / 2.0;     
				vec2 uv1 = (1.0 + p.zy) / 2.0;		
				vec2 uv2 = (1.0 + p.xz) / 2.0;		
	
				uv0 = (mat * vec3((uv0 * 2.0 - 1.0) / (size * 0.5), 1.0) / 2.0 + 0.5).xy;
				uv1 = (mat * vec3((uv1 * 2.0 - 1.0) / (size * 0.5), 1.0) / 2.0 + 0.5).xy;
				uv2 = (mat * vec3((uv2 * 2.0 - 1.0) / (size * 0.5), 1.0) / 2.0 + 0.5).xy;

				// Range from 3 to 128 seems to be good
				float exponent = (1.0 - blending) * 125.0 + 3.0;

				vec3 n = vObjectNormal;
				vec3 weights = abs(normalize(n));
				weights = pow(weights, vec3(exponent));
				weights /= dot(weights, vec3(1.0));

				// Derivatives for LOD
				vec2 df0 = fwidth(uv0);
				vec2 df1 = fwidth(uv1);
				vec2 df2 = fwidth(uv2);
				if (df0.x > 0.5) df0.x = 0.0;
				if (df1.x > 0.5) df1.x = 0.0;
				if (df2.x > 0.5) df2.x = 0.0;

				#ifdef GL_EXT_shader_texture_lod
                	vec4 tmp = 
						texture2DLodEXT(tex, uv0, log2(max(df0.x, df0.y)*min(textureSize.x, textureSize.y))) * weights.z + 
						texture2DLodEXT(tex, uv1, log2(max(df1.x, df1.y)*min(textureSize.x, textureSize.y))) * weights.x + 
						texture2DLodEXT(tex, uv2, log2(max(df2.x, df2.y)*min(textureSize.x, textureSize.y))) * weights.y;
				#else
                	vec4 tmp = 
						textureLod(tex, uv0, log2(max(df0.x, df0.y)*min(textureSize.x, textureSize.y))) * weights.z + 
						textureLod(tex, uv1, log2(max(df1.x, df1.y)*min(textureSize.x, textureSize.y))) * weights.x + 
						textureLod(tex, uv2, log2(max(df2.x, df2.y)*min(textureSize.x, textureSize.y))) * weights.y;
				#endif

				vec3 col = tmp.rgb;
				float lalpha = alpha * tmp.a;

				// Apply cropping across all 3 planes
				if ( crop > 0.5 ) {
					if ( uv0.x < 0.0 || uv0.x > 1.0 || uv0.y < 0.0 || uv0.y > 1.0 )  {
						lalpha = 0.0;
					}
					if ( uv1.x < 0.0 || uv1.x > 1.0 || uv1.y < 0.0 || uv1.y > 1.0 )  {
						lalpha = 0.0;
					}
					if ( uv2.x < 0.0 || uv2.x > 1.0 || uv2.y < 0.0 || uv2.y > 1.0 )  {
						lalpha = 0.0;
					}
				}

				lalpha *= mask;
				calpha =  lalpha / clamp(lalpha + accumAlpha, 0.00001, 1.0);
				accumAlpha += (1.0 - accumAlpha) * lalpha * (1.0 - float(isMask));

				return col;//n * 0.5 + 0.5;
			}			
			`);
    return {
        cylindrical: e,
        spherical: n,
        uv: i,
        triplanar: s
    };
}();
var id = class extends ze {
    constructor(e, n, i, s, o, a, l, u, c, d, h, f){
        super("v3");
        this.nodeType = "Depth";
        this.gradientType = e, this.smooth = n, this.near = i, this.far = s, this.isVector = o, this.isWorldSpace = a, this.origin = l, this.direction = u, this.colors = c, this.steps = d, this.isMask = f, this.alpha = h, this.calpha = `g${this.uuid.toString().replace(/-/g, "")}_calpha`;
    }
    generate(e, n) {
        let i = `g${this.uuid.toString().replace(/-/g, "")}`, s = new me(`vec3 ${i}_sdepth(float near, float far, vec3 origin, vec3 direction, vec4 colors[${i}_MAX_COLORS], float steps[${i}_MAX_COLORS], bool isMask, float mask, float alpha, out float calpha) {
               vec4 color = colors[0];
               #ifdef ${i}_IS_VECTOR
                   #ifdef ${i}_LINEAR
                       #ifdef ${i}_WORLDSPACE
                       float depth = vectorLinearWorldSpaceDepth(direction, origin, near, far);
                       #else
                       float depth = vectorLinearObjectSpaceDepth(direction, origin, near, far);
                       #endif
                   #else
                       #ifdef ${i}_WORLDSPACE
                           float depth = vectorSphericalWorldSpaceDepth(origin, near, far);
                       #else
                           float depth = vectorSphericalObjectSpaceDepth(origin, near, far);
                       #endif
                   #endif
               #else
                   float dist = length(vWPosition - cameraPosition);
			       float depth = ( dist - near ) / ( far - near );
               #endif


              float p;
              #ifdef ${i}_SMOOTH
				for ( int i = 1; i < ${i}_MAX_COLORS; i++ ) {
						p = clamp( ( depth - steps[i-1] ) / ( steps[i] - steps[i-1] ), 0.0, 1.0 );
						color = mix(color, colors[i], smoothstep(0.0, 1.0, p));
					}
              #else
                for ( int i = 1; i < ${i}_MAX_COLORS; i++ ) {
                   p = clamp(( depth - steps[i - 1] ) / ( steps[i] - steps[i - 1] ), 0.0, 1.0);
                   color = mix(color, colors[i], p);
                 }
              #endif

               float lalpha = alpha * color.a * mask;
               calpha = mix(lalpha / clamp(lalpha + accumAlpha, 0.00001, 1.0), lalpha, float(isMask));
			   accumAlpha += (1.0 - accumAlpha) * lalpha * (1.0 - float(isMask));
			   
               return color.rgb;
			}`, [
            id.Nodes.vectorLinearWorldSpaceDepth,
            id.Nodes.vectorLinearObjectSpaceDepth,
            id.Nodes.vectorSphericalObjectSpaceDepth,
            id.Nodes.vectorSphericalWorldSpaceDepth
        ]);
        if (e.isShader("fragment")) {
            e.define(`${i}_MAX_COLORS`, this.colors.value.length), this.smooth.value && e.define(`${i}_SMOOTH`), this.isVector.value > .5 && e.define(`${i}_IS_VECTOR`), this.gradientType.value === 0 && e.define(`${i}_LINEAR`), this.isWorldSpace.value > .5 && e.define(`${i}_WORLDSPACE`), e.require("worldPosition"), e.addFragmentVariable(this.calpha, "float");
            let o = e.include(s), a = [];
            return a.push(this.near.build(e, "f")), a.push(this.far.build(e, "f")), a.push(this.origin.build(e, "v3")), a.push(this.direction.build(e, "v3")), a.push(this.colors.build(e, "v4[]")), a.push(this.steps.build(e, "f[]")), a.push(this.isMask.build(e, "b")), a.push(this.mask ? `luminance(${this.mask.flow(e, "v3").result})` : "1.0"), a.push(this.alpha.build(e, "f")), a.push(this.calpha), e.format(o + "(" + a.join(",") + ")", this.getType(e), n);
        } else return console.warn("DepthNode is not compatible with " + e.shader + " shader."), e.format("vec3( 0.0 )", this.getType(e), n);
    }
}, sd = id;
sd.Nodes = function() {
    let e = new me(`float vectorLinearWorldSpaceDepth(vec3 direction, vec3 origin, float near, float far) {
               vec3 n = normalize(direction);
               float dist = (n.x*(vWPosition.x - origin.x) + n.y*(vWPosition.y - origin.y) + n.z*(vWPosition.z - origin.z));
               return ( dist - near ) / ( far - near );
            }`), n = new me(`float vectorLinearObjectSpaceDepth(vec3 direction, vec3 origin, float near, float far) {
               vec3 n = normalize(direction);
               float dist = (n.x*(position.x - origin.x) + n.y*(position.y - origin.y) + n.z*(position.z - origin.z));
               return ( dist - near ) / ( far - near );
            }`), i = new me(`float vectorSphericalWorldSpaceDepth(vec3 origin, float near, float far) {
               float dist = length(vWPosition - origin);
               return ( dist - near ) / ( far - near );
            }`), s = new me(`float vectorSphericalObjectSpaceDepth(vec3 origin, float near, float far) {
               float dist = length(position - origin);
               return ( dist - near ) / ( far - near );
            }`);
    return {
        vectorLinearWorldSpaceDepth: e,
        vectorLinearObjectSpaceDepth: n,
        vectorSphericalWorldSpaceDepth: i,
        vectorSphericalObjectSpaceDepth: s
    };
}();
var wf = class extends ze {
    constructor(e, n, i, s, o, a, l, u){
        super("v3");
        this.nodeType = "Fresnel";
        this.color = e, this.bias = n, this.scale = i, this.intensity = s, this.factor = o, this.isMask = u, this.alpha = a, this.mode = l, this.calpha = `g${this.uuid.toString().replace(/-/g, "")}_calpha`;
    }
    generate(e, n) {
        if (e.require("vWorldViewDir"), e.require("worldNormal"), e.isShader("fragment")) {
            e.addFragmentVariable(this.calpha, "float");
            let i = new me(`vec3 fresnel(vec3 color, float bias, float scale, float intensity, float factor, bool isMask, float mask, float alpha, int mode, out float calpha) {
					float fresnel = bias + scale * pow( abs( factor + dot( normalize( vWorldViewDir ), normalize( vWNormal ) ) ), intensity );

					float lalpha = clamp(fresnel, 0.0, 1.0) * alpha * mask;
					calpha = mix(lalpha / clamp(lalpha + accumAlpha, 0.00001, 1.0), lalpha, float(isMask));
					accumAlpha += (1.0 - accumAlpha) * lalpha * (1.0 - float(isMask));

					return color;
				}`), s = e.include(i), o = [];
            return o.push(this.color.build(e, "c")), o.push(this.bias.build(e, "f")), o.push(this.scale.build(e, "f")), o.push(this.intensity.build(e, "f")), o.push(this.factor.build(e, "f")), o.push(this.isMask.build(e, "b")), o.push(this.mask ? `luminance(${this.mask.flow(e, "v3").result})` : "1.0"), o.push(this.alpha.build(e, "f")), o.push(this.mode.build(e, "i")), o.push(this.calpha), e.format(s + "(" + o.join(",") + ")", this.getType(e), n);
        } else return console.warn("FresnelNode is not compatible with " + e.shader + " shader."), e.format("vec3( 0.0 )", this.getType(e), n);
    }
};
var iw = class extends ze {
    constructor(e, n, i, s, o, a, l, u, c){
        super("v3");
        this.nodeType = "Gradient";
        this.gradientType = e, this.smooth = n, this.colors = i, this.steps = s, this.offset = o, this.morph = a, this.angle = l, this.isMask = c, this.alpha = u, this.calpha = `g${this.uuid.toString().replace(/-/g, "")}_calpha`;
    }
    generate(e, n) {
        if (e.isShader("fragment")) {
            e.define("GRAD_MAX", 10), e.require("uv"), e.requires.uv = [
                !0
            ], e.addFragmentVariable(this.calpha, "float");
            let i = e.include(iw.Nodes.gradient), s = [];
            return s.push(this.gradientType.build(e, "i")), s.push(this.smooth.build(e, "b")), s.push(this.colors.build(e, "v4[]")), s.push(this.steps.build(e, "f[]")), s.push(this.offset.build(e, "v2")), s.push(this.morph.build(e, "v2")), s.push(this.angle.build(e, "f")), s.push(this.isMask.build(e, "b")), s.push(this.mask ? `luminance(${this.mask.flow(e, "v3").result})` : "1.0"), s.push(this.alpha.build(e, "f")), s.push(this.calpha), e.format(i + "(" + s.join(",") + ")", this.getType(e), n);
        } else return console.warn("GradientNode is not compatible with " + e.shader + " shader."), e.format("vec3( 0.0 )", this.getType(e), n);
    }
}, od = iw;
od.Nodes = function() {
    return {
        gradient: new me(`vec3 gradient(int gradientType, bool smoothed, vec4 colors[GRAD_MAX], float steps[GRAD_MAX], vec2 offset, vec2 morph, float angle, bool isMask, float mask, float alpha, out float calpha) {
				vec4 color = colors[0];
				vec2 m = morph / vUv.xy;
				vec2 rot = vec2( 0.5 + m.x, m.y );
				vec2 dt = vec2(
					cos( angle ) * rot.x - sin( angle ) * rot.y,
					sin( angle ) * rot.x + cos( angle ) * rot.y
				);
				vec2 pt = ( vUv - 0.5 + offset ) / 2.0 + dt / 2.0;
				float t = dot( pt, dt ) / dot( dt, dt );
				if ( gradientType == 1 ) {
					t = distance (
						( vUv + morph ) * 3.0,
						( vUv + offset ) + 1.0
					) + angle;
				} else if ( gradientType == 2 ) {
					float polar = atan(
						vUv.x + morph.x - 0.5 + offset.x,
						vUv.y + morph.y - 0.5 + offset.y
					) * -1.0;
					t = fract( ( angle / PI / -2.0 ) + 0.5 * ( polar / PI ) );
				}

				float p;
				if (smoothed) {
					for ( int i = 1; i < GRAD_MAX; i++ ) {
						p = clamp( ( t - steps[i-1] ) / ( steps[i] - steps[i-1] ), 0.0, 1.0 );
						color = mix(color, colors[i], smoothstep(0.0, 1.0, p));
					}

				} else {
					for ( int i = 1; i < GRAD_MAX; i++ ) {
						p = clamp( ( t - steps[i-1] ) / ( steps[i] - steps[i-1] ), 0.0, 1.0 );
						color = mix(color, colors[i], p);
					}
				}

				float lalpha = alpha * color.a * mask;
				calpha = mix(lalpha / clamp(lalpha + accumAlpha, 0.00001, 1.0), lalpha, float(isMask));
				accumAlpha += (1.0 - accumAlpha) * lalpha * (1.0 - float(isMask));
				
				return color.xyz;
			}`)
    };
}();
var sw = class extends ze {
    constructor(e, n, i, s){
        super("v3");
        this.nodeType = "Matcap";
        this.texture = e, this.isMask = s, this.alpha = n, this.mode = i, this.calpha = `g${this.uuid.toString().replace(/-/g, "")}_calpha`;
    }
    generate(e, n) {
        if (e.isShader("fragment")) {
            e.addFragmentVariable(this.calpha, "float");
            let i = e.include(sw.Nodes.matcap);
            e.require("normal"), e.requires.normal = !0;
            let s = [];
            return s.push(this.texture.generate(e, "t")), s.push("normal"), s.push(this.isMask.build(e, "b")), s.push(this.mask ? `luminance(${this.mask.flow(e, "v3").result})` : "1.0"), s.push(this.alpha.build(e, "f")), s.push(this.mode.build(e, "i")), s.push(this.calpha), e.format(i + "(" + s.join(",") + ")", this.getType(e), n);
        } else return console.warn("MatcapNode is not compatible with " + e.shader + " shader."), e.format("vec3( 0.0 )", this.getType(e), n);
    }
}, ad = sw;
ad.Nodes = function() {
    return {
        matcap: new me(`vec3 matcap(sampler2D matcapTex, vec3 normal, bool isMask, float mask, float alpha, int mode, out float calpha) {
					vec3 viewDir = normalize( vViewPosition );
					vec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );
					vec3 y = cross( viewDir, x );
					vec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5; // 0.495 to remove artifacts caused by undersized matcap disks
					vec4 matcapColor = texture2D( matcapTex, uv );

					float lalpha = alpha * mask;
					calpha = mix(lalpha / clamp(lalpha + accumAlpha, 0.00001, 1.0), lalpha, float(isMask));
					accumAlpha += (1.0 - accumAlpha) * lalpha * (1.0 - float(isMask));
					
					return matcapColor.rgb;
            	}`)
    };
}();
var Sf = ((o)=>(o.SIMPLEX = "simplex3d", o.SIMPLEX_FRACTAL = "simplex3dFractal", o.ASHIMA = "simplexAshima", o.FBM = "fbm", o.PERLIN = "perlin", o.VORONOI = "voronoi", o))(Sf || {}), ur = function() {
    let t = new me(`vec3 random3(vec3 c) {
			float j = 4096.0*sin(dot(c,vec3(17.0, 59.4, 15.0)));
			vec3 r;
			r.z = fract(512.0*j);
			j *= .125;
			r.x = fract(512.0*j);
			j *= .125;
			r.y = fract(512.0*j);
			return r-0.5;
		}`), e = new me(`float simplex3d(vec3 p) {
			 vec3 s = floor(p + dot(p, vec3(F3)));
			 vec3 x = p - s + dot(s, vec3(G3));
			 
			 vec3 e = step(vec3(0.0), x - x.yzx);
			 vec3 i1 = e*(1.0 - e.zxy);
			 vec3 i2 = 1.0 - e.zxy*(1.0 - e);
				
			 vec3 x1 = x - i1 + G3;
			 vec3 x2 = x - i2 + 2.0*G3;
			 vec3 x3 = x - 1.0 + 3.0*G3;
			 
			 vec4 w, d;
			 
			 w.x = dot(x, x);
			 w.y = dot(x1, x1);
			 w.z = dot(x2, x2);
			 w.w = dot(x3, x3);
			 
			 w = max(0.6 - w, 0.0);
			 
			 d.x = dot(random3(s), x);
			 d.y = dot(random3(s + i1), x1);
			 d.z = dot(random3(s + i2), x2);
			 d.w = dot(random3(s + 1.0), x3);
			 
			 w *= w;
			 w *= w;
			 d *= w;
			 
			 return dot(d, vec4(52.0));
		}`, [
        t
    ]);
    e.keywords.F3 = new At("float F3 0.3333333"), e.keywords.G3 = new At("float G3 0.1666667");
    let n = new me(`float simplex3dFractal(vec3 m) {
			mat3 rot1 = mat3(-0.37, 0.36, 0.85,-0.14,-0.93, 0.34,0.92, 0.01,0.4);
			mat3 rot2 = mat3(-0.55,-0.39, 0.74, 0.33,-0.91,-0.24,0.77, 0.12,0.63);
			mat3 rot3 = mat3(-0.71, 0.52,-0.47,-0.08,-0.72,-0.68,-0.7,-0.45,0.56);
			return 0.5333333 * simplex3d(m * rot1)
				 + 0.2666667 * simplex3d(2.0 * m * rot2)
				 + 0.1333333 * simplex3d(4.0 * m * rot3)
				 + 0.0666667 * simplex3d(8.0 * m);
		}`, [
        e
    ]), i = new me("vec4 permute(vec4 x){return mod(((x*34.0)+1.0)*x, 289.0);}"), s = new me("vec4 taylorInvSqrt(vec4 r){return 1.79284291400159 - 0.85373472095314 * r;}"), o = new me(`float simplexAshima(vec3 v) {
		  const vec2  C = vec2(1.0/6.0, 1.0/3.0) ;
		  const vec4  D = vec4(0.0, 0.5, 1.0, 2.0);
		  vec3 i  = floor(v + dot(v, C.yyy) );
		  vec3 x0 =   v - i + dot(i, C.xxx) ;
		  vec3 g = step(x0.yzx, x0.xyz);
		  vec3 l = 1.0 - g;
		  vec3 i1 = min( g.xyz, l.zxy );
		  vec3 i2 = max( g.xyz, l.zxy );
		  vec3 x1 = x0 - i1 + 1.0 * C.xxx;
		  vec3 x2 = x0 - i2 + 2.0 * C.xxx;
		  vec3 x3 = x0 - 1. + 3.0 * C.xxx;
		  i = mod(i, 289.0 ); 
		  vec4 p = permute( permute( permute( 
					 i.z + vec4(0.0, i1.z, i2.z, 1.0 ))
				   + i.y + vec4(0.0, i1.y, i2.y, 1.0 )) 
				   + i.x + vec4(0.0, i1.x, i2.x, 1.0 ));
		  float n_ = 1.0/7.0; // N=7
		  vec3  ns = n_ * D.wyz - D.xzx;
		  vec4 j = p - 49.0 * floor(p * ns.z *ns.z);  //  mod(p,N*N)
		  vec4 x_ = floor(j * ns.z);
		  vec4 y_ = floor(j - 7.0 * x_ );    // mod(j,N)
		  vec4 x = x_ *ns.x + ns.yyyy;
		  vec4 y = y_ *ns.x + ns.yyyy;
		  vec4 h = 1.0 - abs(x) - abs(y);
		  vec4 b0 = vec4( x.xy, y.xy );
		  vec4 b1 = vec4( x.zw, y.zw );
		  vec4 s0 = floor(b0)*2.0 + 1.0;
		  vec4 s1 = floor(b1)*2.0 + 1.0;
		  vec4 sh = -step(h, vec4(0.0));
		  vec4 a0 = b0.xzyw + s0.xzyw*sh.xxyy ;
		  vec4 a1 = b1.xzyw + s1.xzyw*sh.zzww ;
		  vec3 p0 = vec3(a0.xy,h.x);
		  vec3 p1 = vec3(a0.zw,h.y);
		  vec3 p2 = vec3(a1.xy,h.z);
		  vec3 p3 = vec3(a1.zw,h.w);
		  vec4 norm = taylorInvSqrt(vec4(dot(p0,p0), dot(p1,p1), dot(p2, p2), dot(p3,p3)));
		  p0 *= norm.x;
		  p1 *= norm.y;
		  p2 *= norm.z;
		  p3 *= norm.w;
		  vec4 m = max(0.6 - vec4(dot(x0,x0), dot(x1,x1), dot(x2,x2), dot(x3,x3)), 0.0);
		  m = m * m;
		  return 42.0 * dot( m*m, vec4( dot(p0,x0), dot(p1,x1), 
										dot(p2,x2), dot(p3,x3) ) );
		}`, [
        i,
        s
    ]), a = new me("vec4 mod289(vec4 x){return x - floor(x * (1.0 / 289.0)) * 289.0;}"), l = new me("vec4 perm(vec4 x){return mod289(((x * 34.0) + 1.0) * x);}", [
        a
    ]), u = new me(`float noise(vec3 p){
			vec3 a = floor(p);
			vec3 d = p - a;
			d = d * d * (3.0 - 2.0 * d);
			vec4 b = a.xxyy + vec4(0.0, 1.0, 0.0, 1.0);
			vec4 k1 = perm(b.xyxy);
			vec4 k2 = perm(k1.xyxy + b.zzww);
			vec4 c = k2 + a.zzzz;
			vec4 k3 = perm(c);
			vec4 k4 = perm(c + 1.0);
			vec4 o1 = fract(k3 * (1.0 / 41.0));
			vec4 o2 = fract(k4 * (1.0 / 41.0));
			vec4 o3 = o2 * d.z + o1 * (1.0 - d.z);
			vec2 o4 = o3.yw * d.x + o3.xz * (1.0 - d.x);
			return o4.y * d.y + o4.x * (1.0 - d.y);
		}`, [
        l
    ]), c = new me(`float fbm(vec3 x) {
			float v = 0.0;
			float a = 0.5;
			vec3 shift = vec3(100);
			for (int i = 0; i < NUM_OCTAVES; ++i) {
				v += a * noise(x);
				x = x * 2.0 + shift;
				a *= 0.5;
			}
			return v;
		}`, [
        u
    ]);
    c.keywords.NUM_OCTAVES = new At(`int NUM_OCTAVES ${5}`);
    let d = new me("vec3 fade(vec3 t) {return t*t*t*(t*(t*6.0-15.0)+10.0);}"), h = new me(`float perlin(vec3 P){
		  vec3 Pi0 = floor(P);
		  vec3 Pi1 = Pi0 + vec3(1.0);
		  Pi0 = mod(Pi0, 289.0);
		  Pi1 = mod(Pi1, 289.0);
		  vec3 Pf0 = fract(P);
		  vec3 Pf1 = Pf0 - vec3(1.0);
		  vec4 ix = vec4(Pi0.x, Pi1.x, Pi0.x, Pi1.x);
		  vec4 iy = vec4(Pi0.yy, Pi1.yy);
		  vec4 iz0 = Pi0.zzzz;
		  vec4 iz1 = Pi1.zzzz;
		  vec4 ixy = permute(permute(ix) + iy);
		  vec4 ixy0 = permute(ixy + iz0);
		  vec4 ixy1 = permute(ixy + iz1);
		  vec4 gx0 = ixy0 / 7.0;
		  vec4 gy0 = fract(floor(gx0) / 7.0) - 0.5;
		  gx0 = fract(gx0);
		  vec4 gz0 = vec4(0.5) - abs(gx0) - abs(gy0);
		  vec4 sz0 = step(gz0, vec4(0.0));
		  gx0 -= sz0 * (step(0.0, gx0) - 0.5);
		  gy0 -= sz0 * (step(0.0, gy0) - 0.5);
		  vec4 gx1 = ixy1 / 7.0;
		  vec4 gy1 = fract(floor(gx1) / 7.0) - 0.5;
		  gx1 = fract(gx1);
		  vec4 gz1 = vec4(0.5) - abs(gx1) - abs(gy1);
		  vec4 sz1 = step(gz1, vec4(0.0));
		  gx1 -= sz1 * (step(0.0, gx1) - 0.5);
		  gy1 -= sz1 * (step(0.0, gy1) - 0.5);
		  vec3 g000 = vec3(gx0.x,gy0.x,gz0.x);
		  vec3 g100 = vec3(gx0.y,gy0.y,gz0.y);
		  vec3 g010 = vec3(gx0.z,gy0.z,gz0.z);
		  vec3 g110 = vec3(gx0.w,gy0.w,gz0.w);
		  vec3 g001 = vec3(gx1.x,gy1.x,gz1.x);
		  vec3 g101 = vec3(gx1.y,gy1.y,gz1.y);
		  vec3 g011 = vec3(gx1.z,gy1.z,gz1.z);
		  vec3 g111 = vec3(gx1.w,gy1.w,gz1.w);
		  vec4 norm0 = taylorInvSqrt(vec4(dot(g000, g000), dot(g010, g010), dot(g100, g100), dot(g110, g110)));
		  g000 *= norm0.x;
		  g010 *= norm0.y;
		  g100 *= norm0.z;
		  g110 *= norm0.w;
		  vec4 norm1 = taylorInvSqrt(vec4(dot(g001, g001), dot(g011, g011), dot(g101, g101), dot(g111, g111)));
		  g001 *= norm1.x;
		  g011 *= norm1.y;
		  g101 *= norm1.z;
		  g111 *= norm1.w;
		  float n000 = dot(g000, Pf0);
		  float n100 = dot(g100, vec3(Pf1.x, Pf0.yz));
		  float n010 = dot(g010, vec3(Pf0.x, Pf1.y, Pf0.z));
		  float n110 = dot(g110, vec3(Pf1.xy, Pf0.z));
		  float n001 = dot(g001, vec3(Pf0.xy, Pf1.z));
		  float n101 = dot(g101, vec3(Pf1.x, Pf0.y, Pf1.z));
		  float n011 = dot(g011, vec3(Pf0.x, Pf1.yz));
		  float n111 = dot(g111, Pf1);
		  vec3 fade_xyz = fade(Pf0);
		  vec4 n_z = mix(vec4(n000, n100, n010, n110), vec4(n001, n101, n011, n111), fade_xyz.z);
		  vec2 n_yz = mix(n_z.xy, n_z.zw, fade_xyz.y);
		  float n_xyz = mix(n_yz.x, n_yz.y, fade_xyz.x); 
		  return 2.2 * n_xyz;
		}`, [
        i,
        s,
        d
    ]), f = new me(`float hashwithoutsine13(vec3 p3)
		{
			p3  = fract(p3 * .1031);
			p3 += dot(p3, p3.yzx + 33.33);
			return fract((p3.x + p3.y) * p3.z);
		}`), m = new me(`vec3 hashwithoutsine33(vec3 p3)
		{
			p3 = fract(p3 * vec3(.1031, .1030, .0973));
			p3 += dot(p3, p3.yxz+33.33);
			return fract((p3.xxy + p3.yxx)*p3.zyx);
		}`), p = new me(`float metric(in vec3 p)
		{
			// L2 
			return length(p);

			// Chebyshev 
			// vec3 a = abs(p);
			// return max(a.x, max(a.y, a.z));
		}`), g = new me(`float smin( float a, float b, float k )
		{
			float h = smoothstep(0.0, 1.0, 0.5 + 0.5 * (b - a) / k);
			float correction = k * h * (1.0 - h);
			return mix(b, a, h) - correction;
		}`), y = new me(`float smax( float a, float b, float k )
		{
			float h = smoothstep(1.0, 0.0, 0.5 + 0.5 * (a - b) / k);
			float correction = k * h * (1.0 - h);
			return mix(a, b, h) + correction;
		}`), v = new me(`float remap(float value, float input_min, float input_max, float output_min, float output_max) {
			// Compute width of each interval
			float input_width = input_max - input_min;
			float output_width = output_max - output_min;
		
			// Convert input range into a 0-1 range 
			float scaled = (value - input_min) / input_width;
		
			// Convert the 0-1 range into a value in output range
			return output_min + (scaled * output_width);
		}`), x = new me(`float voronoi(in vec3 x, in int style, in float smoothness, in float seed, in int quality) 
		{
			// Integer and fractional parts of this point's coordinates
			ivec3 p = ivec3(floor(x));
			vec3 f = fract(x);

			// Different variables that we will use to construct noise:
			//
			// f1: distance to the closest feature point
			// f2: distance to the second closest feature point
			// e: distance to the closest edge (cell boundary)
			//
			// We also compute "smooth" versions of all of the above quantites, essentially
			// replacing "hard" minimums with "smooth" minimums (described by IQ)
			float f1_smooth = 8.0;
			float f1 = 8.0;
			float f2_smooth = 8.0;
			float f2 = 8.0;
			float e_smooth = 8.0;
			float e = 8.0;

			// Variables stored from closest cell
			ivec3 mb;
			vec3 mr; 

			int steps = quality;
			
			for (int x = -steps; x <= steps; x++) 
			for (int y = -steps; y <= steps; y++)
			for (int z = -steps; z <= steps; z++)
			{
				ivec3 b = ivec3(x, y, z);
				vec3 r = vec3(b) + hashwithoutsine33(vec3(p + b) + seed) - f;
				float d = length(r);
				
				f1_smooth = smin(d, f1_smooth, smoothness);

				// Store un-smoothed distances too 
				if (d < f1) 
				{
					f2 = f1;
					f1 = d;

					mb = ivec3(x, y, z);
					mr = r;
				} 
				else if (d < f2) 
				{
					f2 = d;
				}
			}	
			
			float id = hashwithoutsine13(vec3(p + mb) + seed);

			// Second pass for edge distance  
			for (int x = -steps; x <= steps; x++) 
			for (int y = -steps; y <= steps; y++)
			for (int z = -steps; z <= steps; z++)
			{
				// Start search at the cell that contains the closest point to "x" (found in 1st pass)
				ivec3 b = mb + ivec3(x, y, z);
				vec3 r = vec3(b) + hashwithoutsine33(vec3(p + b) + seed) - f;
				float d1 = dot(0.5 * (mr + r), (r - mr)); 				// IQ normalizes "r - mr" but that breaks things for the smooth version?
				float d2 = dot(0.5 * (mr + r), normalize(r - mr));

				e_smooth = smin(d1, e_smooth, smoothness);

				e = min(e, d2);

				// Also compute a smooth version of F2 in this pass
				{
					ivec3 b = ivec3(x, y, z);
					if (b != mb) 
					{
						vec3 r = vec3(b) + hashwithoutsine33(vec3(p + b) + seed) - f;
						float d = length(r);

						f2_smooth = smin(d, f2_smooth, smoothness);
					}
				}
			}

			// Different visualization modes 
			if (style == 0) 
			{
				return f1_smooth;
			}
			if (style == 1) 
			{
				return f2_smooth;
			}
			if (style == 2) 
			{
				return f2_smooth - f1_smooth;
				
				// "Pebbles" also cool
				//return step(0.2, f2_smooth - f1_smooth);
			}
			if (style == 3) 
			{
				// This one is really good for rock / stone effects
				float a = f1; 
				float b = f2;
				float k = 3.0;
				float h = max(k - abs(a - b), 0.0) / k;
				float final = min(a, b) - h * h * k * (1.0 / 4.0);
				return final;
			}
			if (style == 4) 
			{
				// Some random adjustments to make this style stand out more 
				return exp(5.0 * e_smooth);
			}
			if (style == 5) 
			{
				return pow(f1_smooth, 3.0);
			}
			if (style == 6) 
			{				
				const float eps = 0.0125;

				// Thicker lines as the user increases the smoothness slider
				float thickness = smoothness * 0.25 + eps;

				// Blurrier lines as the user increases the smoothness slider
				float blur = pow(smoothness, 3.0) * 0.25 + eps;

				return smoothstep(
					thickness - thickness * blur, 
					thickness + thickness * blur, 
					e
				);
			}
			if (style == 7) 
			{
				return hashwithoutsine13(vec3(p + mb) + seed);
			}
		}
	`, [
        f,
        m,
        p,
        g,
        y,
        v
    ]);
    return {
        simplex: e,
        simplexFractal: n,
        simplexAshima: o,
        fbm: c,
        perlin: h,
        voronoi: x
    };
}();
var ld = class extends ze {
    constructor(e, n, i, s, o, a, l, u, c, d, h, f, m, p, g, y, v, x, w){
        super("v3");
        this.nodeType = "Noise";
        this.scale = e, this.size = n, this.move = i, this.fA = s, this.fB = o, this.distortion = a, this.colorA = l, this.colorB = u, this.colorC = c, this.colorD = d, this.noiseType = f, this.voronoiStyle = p, this.highCut = g, this.lowCut = y, this.smoothness = v, this.seed = x, this.quality = w, this.isMask = m, this.alpha = h, this.calpha = `g${this.uuid.toString().replace(/-/g, "")}_calpha`;
    }
    generate(e, n, i, s, o) {
        e.require("uv"), e.requires.uv = [
            !0
        ], e.addFragmentVariable(this.calpha, "float");
        let a = Object.values(Sf)[this.noiseType.value], l = a == "voronoi" ? `
		float v = ${a}(st + move, voronoiStyle, smoothness, seed, quality);

		// Apply clipping to colors
		v = remap(v, lowCut, highCut, 0.0, 1.0);
		v = smax(v, 0.0, smoothness * 0.25);
		v = smin(v, 1.0, smoothness * 0.25);

		// Note that the voronoi mode only uses colors "A" and "C" from the UI 
		vec4 color = mix(colorA, colorC, v); 
		` : `
		vec3 q = vec3(${a}(st),
					   ${a}(st + vec3(1.0)),
					   ${a}(st + vec3(1.0)));
		vec3 r = vec3(${a}(st + vec3(distortion, 1.0) * q + vec3(fA, 1.0) + move),
					  ${a}(st + vec3(distortion, 1.0) * q + vec3(fB, 1.0) + move), 
					  ${a}(st * q));
		float f = ${a}(st + r);
		vec4 color;
		color = mix(colorA, colorB, clamp((f * f) * 4.0, 0.0, 1.0));
		color = mix(color, colorC, clamp(length(q), 0.0, 1.0));
		color = mix(color, colorD, clamp(length(r.x), 0.0, 1.0));
		`, u = new me(`vec3 ${a}customNoise(float scale, vec3 size, float move, vec2 fA, vec2 fB, vec2 distortion, vec4 colorA, vec4 colorB, vec4 colorC, vec4 colorD, int voronoiStyle, float highCut, float lowCut, float smoothness, float seed, int quality, bool isMask, float mask, float alpha, out float calpha) 
			{
                // Prevent scale of zero 
				scale = max(abs(scale), 0.001);

				vec3 st = position / size;
				st /= scale;

				${l}

				float lalpha = alpha * color.a * mask;
				calpha = mix(lalpha / clamp(lalpha + accumAlpha, 0.00001, 1.0), lalpha, float(isMask));
				accumAlpha += (1.0 - accumAlpha) * lalpha * (1.0 - float(isMask));

				return clamp(color, 0.0, 1.0).rgb;
			}`, [
            ur.simplex,
            ur.simplexFractal,
            ur.simplexAshima,
            ur.fbm,
            ur.perlin,
            ur.voronoi
        ]), c = e.include(u), d = [];
        return d.push(this.scale.build(e, "f")), d.push(this.size.build(e, "v3")), d.push(this.move.build(e, "f")), d.push(this.fA.build(e, "v2")), d.push(this.fB.build(e, "v2")), d.push(this.distortion.build(e, "v2")), d.push(this.colorA.build(e, "v4")), d.push(this.colorB.build(e, "v4")), d.push(this.colorC.build(e, "v4")), d.push(this.colorD.build(e, "v4")), d.push(this.voronoiStyle.build(e, "i")), d.push(this.highCut.build(e, "f")), d.push(this.lowCut.build(e, "f")), d.push(this.smoothness.build(e, "f")), d.push(this.seed.build(e, "f")), d.push(this.quality.build(e, "i")), d.push(this.isMask.build(e, "b")), d.push(this.mask ? `luminance(${this.mask.flow(e, "v3").result})` : "1.0"), d.push(this.alpha.build(e, "f")), d.push(this.calpha), e.format(c + "(" + d.join(",") + ")", this.getType(e), n);
    }
};
ld.numOctaves = 5;
var ow = class extends ze {
    constructor(e, n, i, s, o, a, l, u, c, d, h, f, m, p, g, y){
        super("v3");
        this.nodeType = "Outline";
        this.firstTime = !0, this.outlineColor = e, this.contourColor = n, this.outlineWidth = i, this.contourWidth = s, this.contourThreshold = o, this.outlineThreshold = a, this.contourFrequency = l, this.outlineSmoothing = u, this.contourDirection = c, this.positionalLines = d, this.compensation = h, this.resolution = f, this.normalMap = m, this.depthMap = p, this.pixelRatio = g, this.alpha = y, this.calpha = `g${this.uuid.toString().replace(/-/g, "")}_calpha`;
    }
    generate(e, n) {
        let i = `g${this.uuid.toString().replace(/-/g, "")}`;
        if (e.require("vWorldViewDir"), e.require("worldNormal"), e.extensions.derivatives = !0, this.compensation.value && e.define("OUTLINE_COMPENSATION", `${i}_offset`), this.firstTime) {
            let s = this.outlineWidth.build(e, "f"), o = this.resolution.build(e, "v2"), a = this.compensation.build(e, "b"), l = this.pixelRatio.build(e, "f");
            e.addVertexParsVariable("randomColor", "attribute vec3"), e.addVertexParsVariable("extrudeNormal", "attribute vec3"), e.addVertexParsVariable(s, "uniform float"), e.addVertexParsVariable(o, "uniform vec2"), e.addVertexParsVariable(a, "uniform bool"), e.addVertexParsVariable(l, "uniform float"), e.addVertexParsVariable("vID", "flat out float"), e.addFragmentParsVariable("vID", "flat in float"), e.addVertexFinalCode(`
                vID = randomColor.r;
                vec2 ${i}_offset = vec2(0.0);
                if (${a}) {
                    vec4 ${i}_clipPosition = projectionMatrix * (modelViewMatrix * vec4(position, 1.0));
                    // NOTE: For certain shapes, like spheres, we get incorrect extrusion when the
                    // normals face the camera directly. So we hackily fix this by offsetting the normal
                    // by a tiny amount.
                    vec3 ${i}_clipNormal = mat3(projectionMatrix) * (mat3(modelViewMatrix) * extrudeNormal) + 0.0000001;
                    ${i}_offset = normalize(${i}_clipNormal.xy) / ${o} * (${s} / 2.0) * ${i}_clipPosition.w * 2.0 * ${l};
                    ${i}_clipPosition.xy += ${i}_offset;
                    // TODO(MAX): To handle multiple outline layers, we only want to extrude
                    // if this offset is the biggest of all the potential offsets
                    gl_Position = ${i}_clipPosition;
                }
            `);
        }
        if (e.isShader("fragment")) {
            e.require("uv"), e.requires.uv = [
                !0
            ], e.addFragmentVariable(this.calpha, "float");
            let s = e.include(ow.Nodes.outline), o = [];
            return o.push(this.outlineColor.build(e, "c")), o.push(this.contourColor.build(e, "c")), o.push(this.outlineWidth.build(e, "f")), o.push(this.contourWidth.build(e, "f")), o.push(this.contourThreshold.build(e, "f")), o.push(this.outlineThreshold.build(e, "f")), o.push(this.contourFrequency.build(e, "f")), o.push(this.outlineSmoothing.build(e, "f")), o.push(this.contourDirection.build(e, "v3")), o.push(this.positionalLines.build(e, "b")), o.push(this.resolution.build(e, "v2")), o.push(this.normalMap.getTexture(e, "t")), o.push(this.depthMap.getTexture(e, "t")), o.push(this.pixelRatio.build(e, "f")), o.push(this.compensation.build(e, "b")), o.push(this.mask ? `luminance(${this.mask.flow(e, "v3").result})` : "1.0"), o.push(this.alpha.build(e, "f")), o.push(this.calpha), this.firstTime = !this.firstTime, e.format(s + "(" + o.join(",") + ")", this.getType(e), n);
        } else return console.warn("OutlineNode is not compatible with " + e.shader + " shader."), "";
    }
}, cd = ow;
cd.Nodes = function() {
    let e = new me(`
float sobelSample(sampler2D t, sampler2D d, vec2 uv, vec2 resolution, float outlineWidth, float pixelRatio)
{
    vec2 halton = haltonSequence[frameIndex];
    float temporalOffset = getNoiseInterleavedGradient(gl_FragCoord.xy + halton);
    float temporalAngle  = temporalOffset * PI2;

    vec2 texelSize = (vec2(1.0) / resolution);
    vec2 offsetSize = texelSize * outlineWidth * pixelRatio;

    vec2 uvSamples[9];
    vec4 normalSamples[9];

	uvSamples[0] = uv + vec2( -offsetSize.x, -offsetSize.y) + (vogelDiskSample(0, 9, temporalAngle) * texelSize);
	uvSamples[1] = uv + vec2(0.0, -offsetSize.y) + (vogelDiskSample(1, 9, temporalAngle) * texelSize);
	uvSamples[2] = uv + vec2(  offsetSize.x, -offsetSize.y) + (vogelDiskSample(2, 9, temporalAngle) * texelSize);
	uvSamples[3] = uv + vec2( -offsetSize.x, 0.0) + (vogelDiskSample(3, 9, temporalAngle) * texelSize);
	uvSamples[4] = uv;
	uvSamples[5] = uv + vec2(  offsetSize.x, 0.0) + (vogelDiskSample(5, 9, temporalAngle) * texelSize);
	uvSamples[6] = uv + vec2( -offsetSize.x, offsetSize.y) + (vogelDiskSample(6, 9, temporalAngle) * texelSize);
	uvSamples[7] = uv + vec2(0.0, offsetSize.y) + (vogelDiskSample(7, 9, temporalAngle) * texelSize);
	uvSamples[8] = uv + vec2(  offsetSize.x, offsetSize.y) + (vogelDiskSample(8, 9, temporalAngle) * texelSize);


    normalSamples[0] = texture2D(t, uvSamples[0]);
    normalSamples[1] = texture2D(t, uvSamples[1]);
    normalSamples[2] = texture2D(t, uvSamples[2]);
    normalSamples[3] = texture2D(t, uvSamples[3]);
    normalSamples[4] = texture2D(t, uvSamples[4]);
    normalSamples[5] = texture2D(t, uvSamples[5]);
    normalSamples[6] = texture2D(t, uvSamples[6]);
    normalSamples[7] = texture2D(t, uvSamples[7]);
    normalSamples[8] = texture2D(t, uvSamples[8]);

    float depthBias = 0.0001;
    // TODO(MAX): Can we somehow reduce the number of conditionals here with MATH?!
    if (normalSamples[0].a != vID && normalSamples[0].a != 0.0) {
        float depthAtSample = texture2D(d, uvSamples[0]).r + depthBias;
        if (gl_FragCoord.z > depthAtSample) {
           return 0.0;
        }
    }

    if (normalSamples[1].a != vID && normalSamples[1].a != 0.0) {
        float depthAtSample = texture2D(d, uvSamples[1]).r + depthBias;
        if (gl_FragCoord.z > depthAtSample) {
           return 0.0;
        }
    }

    if (normalSamples[2].a != vID && normalSamples[2].a != 0.0) {
        float depthAtSample = texture2D(d, uvSamples[2]).r + depthBias;
        if (gl_FragCoord.z > depthAtSample) {
           return 0.0;
        }
    }

    if (normalSamples[3].a != vID && normalSamples[3].a != 0.0) {
        float depthAtSample = texture2D(d, uvSamples[3]).r + depthBias;
        if (gl_FragCoord.z > depthAtSample) {
           return 0.0;
        }
    }


    if (normalSamples[4].a != vID && normalSamples[4].a != 0.0) {
        float depthAtSample = texture2D(d, uvSamples[4]).r + depthBias;
        if (gl_FragCoord.z > depthAtSample) {
           return 0.0;
        }
    }

    if (normalSamples[5].a != vID && normalSamples[5].a != 0.0) {
        float depthAtSample = texture2D(d, uvSamples[5]).r + depthBias;
        if (gl_FragCoord.z > depthAtSample) {
           return 0.0;
        }
    }

    if (normalSamples[6].a != vID && normalSamples[6].a != 0.0) {
        float depthAtSample = texture2D(d, uvSamples[6]).r + depthBias;
        if (gl_FragCoord.z > depthAtSample) {
           return 0.0;
        }
    }

    if (normalSamples[7].a != vID && normalSamples[7].a != 0.0) {
        float depthAtSample = texture2D(d, uvSamples[7]).r + depthBias;
        if (gl_FragCoord.z > depthAtSample) {
           return 0.0;
        }
    }

    if (normalSamples[8].a != vID && normalSamples[8].a != 0.0) {
        float depthAtSample = texture2D(d, uvSamples[8]).r + depthBias;
        if (gl_FragCoord.z > depthAtSample) {
           return 0.0;
        }
    }

    vec3 sobel_edge_h = normalSamples[2].rgb + (2.0*normalSamples[5].rgb) + normalSamples[8].rgb - (normalSamples[0].rgb + (2.0*normalSamples[3].rgb) + normalSamples[6].rgb);
  	vec3 sobel_edge_v = normalSamples[0].rgb + (2.0*normalSamples[1].rgb) + normalSamples[2].rgb - (normalSamples[6].rgb + (2.0*normalSamples[7].rgb) + normalSamples[8].rgb);

    float edgeNormal = sqrt(dot(sobel_edge_h, sobel_edge_h) + dot(sobel_edge_v, sobel_edge_v));
    return edgeNormal;
}
`);
    return {
        outline: new me(`vec3 outline(vec3 outlineColor, vec3 contourColor, float outlineWidth, float contourWidth, float outlineThreshold, float contourThreshold, float outlineSmoothing, float contourFrequency, vec3 contourDirection, bool positionalLines, vec2 resolution, sampler2D normalMap, sampler2D depthMap, float pixelRatio, bool compensation, float mask, float alpha, out float calpha) {
                vec3 result = outlineColor;
                float resultAlpha = 0.0;

                vec3 N = normalize(vWNormal);
                vec2 nuv = (gl_FragCoord.xy / resolution);
                float sobelSample = compensation ? sobelSample(normalMap, depthMap, nuv, resolution, outlineWidth / 2., pixelRatio) : sobelSample(normalMap, depthMap, nuv, resolution, outlineWidth, pixelRatio);
                resultAlpha = smoothstep(outlineThreshold - outlineSmoothing, outlineThreshold + outlineSmoothing, sobelSample);

                //resultAlpha = 1.0;
                //result = vec3(sobelSample);

                float t = 1.0 - contourThreshold;
                if(positionalLines) {
                    vec3 NDir = position * contourDirection;
                    float NT = NDir.x + NDir.y + NDir.z;
                    float f  = fract(NT * contourFrequency * 0.01);
                    float df = fwidth(NT * contourFrequency);

                    float g = smoothstep(df * (contourWidth * 0.01), df * (contourWidth * 0.01 * 2.0), f);
                    if (g < 1.0 && resultAlpha == 0.0) {
                        result = contourColor;
                        resultAlpha = 1.0;
                    }
                 }
                 else {
                    vec3 NDir = N * contourDirection;
                    float NT = NDir.x + NDir.y + NDir.z;
                    float df = fwidth(NT * contourThreshold);
                    float f = sin(NT * 1.0 * contourFrequency);
                    float g = smoothstep(0.0, df * contourWidth, 1.0 - f);

                    if (df > (t * 0.5) && g < 1.0 && resultAlpha == 0.0) {
                        result = contourColor;
                        resultAlpha = 1.0 - g;
                    }
                 }

                 float lalpha = alpha * resultAlpha * mask;
                 calpha =  lalpha / clamp( lalpha + accumAlpha, 0.00001, 1.0 );
                 accumAlpha += ( 1.0 - accumAlpha ) * lalpha;
				 
                 return result;
             }`, [
            e
        ])
    };
}();
var Is = class extends ze {
    constructor(e, n, i, s, o, a, l, u, c, d, h, f, m, p, g, y, v, x){
        super("v3");
        this.nodeType = "Pattern";
        this.style = e, this.projection = n, this.axis = i, this.blending = s, this.offset = o, this.colorA = a, this.colorB = l, this.frequency = u, this.size = c, this.variation = d, this.smoothness = h, this.zigzag = f, this.rotation = m, this.vertical = p, this.horizontal = g, this.sides = y, this.isMask = x, this.alpha = v, this.calpha = `g${this.uuid.toString().replace(/-/g, "")}_calpha`;
    }
    generate(e, n) {
        if (e.isShader("fragment")) {
            e.require("position"), e.require("uv"), e.requires.uv = [
                !0
            ], e.require("normal"), e.requires.normal = !0, e.addFragmentVariable(this.calpha, "float");
            let i;
            switch(this.style.value){
                case 0:
                    i = "circle";
                    break;
                case 1:
                    i = "ring";
                    break;
                case 2:
                    i = "polygon";
                    break;
                case 3:
                    i = "xcross";
                    break;
                case 4:
                    i = "diamond";
                    break;
                case 5:
                    i = "checkerboard";
                    break;
                case 6:
                    i = "line";
                    break;
                case 7:
                    i = "wave";
                    break;
                default:
                    i = "circle";
                    break;
            }
            let s = `g${this.uuid.toString().replace(/-/g, "")}`, o = new me(`float hashwithoutsine12(vec2 p)
				{
					vec3 p3 = fract(vec3(p.xyx) * .1031);
					p3 += dot(p3, p3.yzx + 33.33);
					return fract((p3.x + p3.y) * p3.z);
				}`), a = new me(`vec2 rotate_uv(in vec2 uv, float a, bool repeat) 
				{
					const float mid = 0.5;
					float radians = a * (PI / 180.0);
					vec2 rotated = vec2(
						cos(radians) * (uv.x - mid) + sin(radians) * (uv.y - mid) + mid,
						cos(radians) * (uv.y - mid) - sin(radians) * (uv.x - mid) + mid
					);
					return repeat ? fract(rotated): rotated;
				}`), l = "";
            if (this.projection.value === 4) {
                let h = this.style.value === 2 ? `${i}(uv0, frequency, size, variation, smoothness_remapped, zigzag, rotation, sides)` : `${i}(uv0, frequency, size, variation, smoothness_remapped, zigzag, rotation)`, f = this.style.value === 2 ? `${i}(uv1, frequency, size, variation, smoothness_remapped, zigzag, rotation, sides)` : `${i}(uv1, frequency, size, variation, smoothness_remapped, zigzag, rotation)`, m = this.style.value === 2 ? `${i}(uv2, frequency, size, variation, smoothness_remapped, zigzag, rotation, sides)` : `${i}(uv2, frequency, size, variation, smoothness_remapped, zigzag, rotation)`;
                l = `
				vec3 p = position;
				float factor = 0.0125;
				vec2 uv0 = fract(p.xy * factor);
				vec2 uv1 = fract(p.zy * factor);
				vec2 uv2 = fract(p.xz * factor);
				
				uv0 = rotate_uv(uv0 + offset, rotation, true);
				uv1 = rotate_uv(uv1 + offset, rotation, true);
				uv2 = rotate_uv(uv2 + offset, rotation, true);
	
				float d0 = ${h};
				float d1 = ${f};
				float d2 = ${m};
				
				// Range from 3 to 128 seems to be good
				float exponent = (1.0 - blending) * 125.0 + 3.0;

				vec3 n = vObjectNormal;
				vec3 weights = abs(normalize(n));
				weights = pow(weights, vec3(exponent));
				weights /= dot(weights, vec3(1.0));
				d0 *= weights.z;
				d1 *= weights.x;
				d2 *= weights.y;
				float draw = d0 + d1 + d2;
	
				vec2 custom_uv = uv0 * weights.z + uv1 * weights.x + uv2 * weights.y;
				`;
            } else {
                let h = this.style.value === 2 ? `${i}(custom_uv, frequency, size, variation, smoothness_remapped, zigzag, rotation, sides)` : `${i}(custom_uv, frequency, size, variation, smoothness_remapped, zigzag, rotation)`, f = "";
                this.axis.value === 0 ? f = `float radius = length(p);
					float theta = atan(p.y, p.z);
					float phi = acos(p.x / radius);` : this.axis.value === 1 ? f = `float radius = length(p);
					float theta = atan(p.x, p.z);
					float phi = acos(p.y / radius);` : (this.axis.value, f = `float radius = length(p);
					float theta = atan(p.y, p.x);
					float phi = acos(p.z / radius);`);
                let m = "";
                switch(this.projection.value){
                    case 0:
                        m = "custom_uv = vUv.st;";
                        break;
                    case 1:
                        break;
                    case 2:
                        m = `
							vec3 p = position;
							${f}
							custom_uv = vec2(theta, phi);
							custom_uv /= PI;
							`;
                        break;
                    case 3:
                        break;
                    default:
                        break;
                }
                l = `
				vec2 custom_uv;
				${m}
	
				custom_uv += offset;
				custom_uv = fract(custom_uv);
				custom_uv = rotate_uv(custom_uv, rotation, true);
	
				float draw = ${h};
				`;
            }
            let u = new me(`vec3 ${s}_pattern(vec3 normal, float blending, int style, vec2 offset, vec4 colorA, vec4 colorB, vec2 frequency, float size, float variation, float smoothness, float zigzag, float rotation, vec2 vertical, vec2 horizontal, int sides, bool isMask, float mask, float alpha, out float calpha) {
					const float TWO_PI = PI * 2.0;
					float smoothness_remapped = pow(smoothness, 5.0);	

					${l}

					// Construct final output color
					vec4 color = mix(colorA, colorB, draw);
					color.a = clamp(color.a, 0.0, 1.0);

					// Apply cuts
					color.a *= 
						step(vertical.x, custom_uv.y) * 
						step(custom_uv.y, vertical.y);
					color.a *= 
						step(horizontal.x, abs(custom_uv.x)) * 
						step(abs(custom_uv.x), horizontal.y);

					// Accumulate alpha 
					float lalpha = alpha * clamp(color.a, 0.0, 1.0) * mask;
					calpha = mix(lalpha / clamp(lalpha + accumAlpha, 0.00001, 1.0), lalpha, float(isMask));
					accumAlpha += (1.0 - accumAlpha) * lalpha * (1.0 - float(isMask));

					return clamp(color, 0.0, 1.0).rgb;
				}`, [
                a,
                o,
                Is.DrawFunctions.circle,
                Is.DrawFunctions.ring,
                Is.DrawFunctions.polygon,
                Is.DrawFunctions.cross,
                Is.DrawFunctions.diamond,
                Is.DrawFunctions.checkerboard,
                Is.DrawFunctions.line,
                Is.DrawFunctions.wave
            ]), c = e.include(u), d = [];
            return d.push("normal"), d.push(this.blending.build(e, "f")), d.push(this.style.build(e, "i")), d.push(this.offset.build(e, "v2")), d.push(this.colorA.build(e, "v4")), d.push(this.colorB.build(e, "v4")), d.push(this.frequency.build(e, "v2")), d.push(this.size.build(e, "f")), d.push(this.variation.build(e, "f")), d.push(this.smoothness.build(e, "f")), d.push(this.zigzag.build(e, "f")), d.push(this.rotation.build(e, "f")), d.push(this.vertical.build(e, "v2")), d.push(this.horizontal.build(e, "v2")), d.push(this.sides.build(e, "i")), d.push(this.isMask.build(e, "b")), d.push(this.mask ? `luminance(${this.mask.flow(e, "v3").result})` : "1.0"), d.push(this.alpha.build(e, "f")), d.push(this.calpha), e.format(c + "(" + d.join(",") + ")", this.getType(e), n);
        } else return console.warn("PatterNode is not compatible with " + e.shader + " shader."), e.format("vec3(0.0)", this.getType(e), n);
    }
}, ud = Is;
ud.DrawFunctions = function() {
    let e = new me(`float hashwithoutsine12(vec2 p) {
				vec3 p3 = fract(vec3(p.xyx) * 0.1031);
				p3 += dot(p3, p3.yzx + 33.33);
				return fract((p3.x + p3.y) * p3.z);
			}`), n = new me(`vec2 tile_and_center(in vec2 uv, in vec2 frequency, in float variation, in float zigzag, in float rotation) {
                // Create tiles in UV-space
                uv *= frequency;

                // Integer coords
                vec2 i = floor(uv);

                // Offset every other row based on zigzag param, then compute fractional coords
                float row_offset = mod(i.y, 2.0);
                uv.x += row_offset * zigzag;
                vec2 f = fract(uv);

				// Rotate the tile itself:
				// const float mid = 0.5;
				// f = vec2(
				// 	cos(rotation) * (f.x - mid) + sin(rotation) * (f.y - mid) + mid,
				// 	cos(rotation) * (f.y - mid) - sin(rotation) * (f.x - mid) + mid
				// );
				// f = fract(f);

                f = f * 2.0 - 1.0;

				// Recompute integer coords after shifting - then, random value per tile 
				i = floor(uv);
				float rand = (hashwithoutsine12(i) * 5.0 + 1.0);
				float jitter = mix(1.0, rand, variation);
				f *= jitter;

                return f;
            }`, [
        e
    ]), i = new me(`float circle(in vec2 uv, in vec2 frequency, in float size, in float variation, in float smoothness, in float zigzag, in float rotation) {
                vec2 f = tile_and_center(uv, frequency, variation, zigzag, rotation);
                return smoothstep(
                    -smoothness, 
                     smoothness, 
                     length(f) - size
                );
            }`, [
        n
    ]), s = new me(`float ring(in vec2 uv, in vec2 frequency, in float size, in float variation, in float smoothness, in float zigzag, in float rotation) {
                vec2 f = tile_and_center(uv, frequency, variation, zigzag, rotation);

				float d = length(f);
                const float inner_width = 0.5;

                float outer = smoothstep(-smoothness, smoothness, d - size);
                float inner = smoothstep(-smoothness, smoothness, d - size * inner_width);
				return outer + (1.0 - inner);   
            }`, [
        n
    ]), o = new me(`float sdf_ngon(in vec2 p, in float r, in int n) {
                float an = (PI * 2.0) / float(n);
                float he = r * tan(0.5 * an);
                
                // Rotate to first sector
                p = -p.yx; 
                float bn = an * floor((atan(p.y, p.x) + 0.5 * an) / an);
                vec2  cs = vec2(cos(bn), sin(bn));
                p = mat2(cs.x, -cs.y, cs.y, cs.x)*p;
            
                // Side of polygon
                return length(p - vec2(r, clamp(p.y, -he, he))) * sign(p.x - r);
            }
            
            float polygon(in vec2 uv, in vec2 frequency, in float size, in float variation, in float smoothness, in float zigzag, in float rotation, in int sides) {
                vec2 f = tile_and_center(uv, frequency, variation, zigzag, rotation);
                return smoothstep(-smoothness, smoothness, sdf_ngon(f, size, sides));
            }`, [
        n
    ]), a = new me(`float sdf_cross(in vec2 p, in vec2 b, float r ) {
                p = abs(p); 
				p = (p.y > p.x) ? p.yx : p.xy;
                vec2  q = p - b;
                float k = max(q.y, q.x);
                vec2  w = (k > 0.0) ? q : vec2(b.y - p.x, -k);
                return sign(k) * length(max(w, 0.0)) + r;
            }
            
            // Avoid namespace conflicts 
            float xcross(in vec2 uv, in vec2 frequency, in float size, in float variation, in float smoothness, in float zigzag, in float rotation) {
                vec2 f = tile_and_center(uv, frequency, variation, zigzag, rotation);
                return smoothstep(-smoothness, smoothness, sdf_cross(f, vec2(size, size * 0.25), smoothness));
            }`, [
        n
    ]), l = new me(`float ndot(vec2 a, vec2 b) { 
                return a.x*b.x - a.y*b.y; 
            }
            
            float sdf_diamond(in vec2 p, in vec2 b) {
                p = abs(p);
                float h = clamp(ndot(b - 2.0 * p, b) / dot(b, b), -1.0, 1.0);
                float d = length(p - 0.5 * b * vec2(1.0 - h, 1.0 + h));
                return d * sign(p.x * b.y + p.y * b.x - b.x * b.y);
            }

            float diamond(in vec2 uv, in vec2 frequency, in float size, in float variation, in float smoothness, in float zigzag, in float rotation) {
                vec2 f = tile_and_center(uv, frequency, variation, zigzag, rotation);
	            return smoothstep(-smoothness, smoothness, sdf_diamond(f, vec2(size)));
            }`, [
        n
    ]), u = new me(`float checkerboard(in vec2 uv, in vec2 frequency, in float size, in float variation, in float smoothness, in float zigzag, in float rotation) {
                uv *= frequency;
                vec2 i = floor(uv);

                float offset = mod(i.y, 2.0);

                uv.x += offset + zigzag * offset;
                float x = floor(uv.x);
                
                return mod(x, 2.0);
            }`), c = new me(`float line(in vec2 uv, in vec2 frequency, in float size, in float variation, in float smoothness, in float zigzag, in float rotation) {
                vec2 f = tile_and_center(uv, frequency, 0.0, zigzag, rotation);
				
				// Different approach for variation param here
				float row = floor(uv * frequency).y;
				float rand = hashwithoutsine12(vec2(row));
				float s = mix(size, size * rand, variation);

				return smoothstep(
					s - smoothness, 
					s + smoothness, 
					abs(f.y)
				);
            }`, [
        n
    ]), d = new me(`// Uses bisection 
            float udf_cos(in vec2 p, in float a, in float b, in float c, in float d) {
                // Convert all data to a primitive cosine wave
                p = c * (p - vec2(d, a));
                
                const float TWO_PI = PI * 2.0;

                // Reduce to principal half cycle
                p.x = mod(p.x, TWO_PI); 
                if (p.x > PI) {
                    p.x = TWO_PI - p.x;
                }
            
                // Find zero of derivative (minimize distance)
                float xa = 0.0;
                float xb = TWO_PI;

                // 24 bit precision
                for (int i = 0; i < 24; i++) {
                    float x = 0.5 * (xa + xb);
                    float y = x - p.x + b * c * sin(x) * (p.y - b * c * cos(x));
                    if (y < 0.0) xa = x; 
                    else xb = x;
                }
                float x = 0.5 * (xa + xb);
                
                // Compute distance    
                vec2 q = vec2(x, b * c * cos(x));
                return length(p - q) / c;
            }

            float wave(in vec2 uv, in vec2 frequency, in float size, in float variation, in float smoothness, in float zigzag, in float rotation) {
                float repeat = frequency.x;
                uv *= repeat;
                vec2 i = floor(uv);
                float row_offset = mod(i.y, 2.0);
                uv.x += row_offset * zigzag;
                vec2 f = vec2(uv.x, fract(uv.y));

                // Generalized cosine: y(x) = a + b * cos(cx + d)
                const float amplitude = 0.125;
                float wave_frequency = frequency.y * 0.1;
                float distance_estimate = udf_cos(f, 0.50, amplitude, wave_frequency * (2.0 * PI), 0.0);

				// Different approach for variation param here
				float rand = hashwithoutsine12(vec2(i.y));
				float s = mix(size, size * rand, variation);

                return smoothstep(-smoothness, smoothness, distance_estimate - s * 0.5);
            }`);
    return {
        tileAndCenter: n,
        circle: i,
        ring: s,
        polygon: o,
        cross: a,
        diamond: l,
        checkerboard: u,
        line: c,
        wave: d
    };
}();
var aw = class extends ze {
    constructor(e, n, i, s, o, a, l, u){
        super("v3");
        this.nodeType = "Rainbow";
        this.filmThickness = e, this.movement = n, this.wavelengths = i, this.noiseStrength = s, this.noiseScale = o, this.offset = a, this.isMask = u, this.alpha = l, this.calpha = `g${this.uuid.toString().replace(/-/g, "")}_calpha`;
    }
    generate(e, n) {
        if (e.require("vWorldViewDir"), e.require("worldNormal"), e.isShader("fragment")) {
            e.require("uv"), e.requires.uv = [
                !0
            ], e.addFragmentVariable(this.calpha, "float");
            let i = e.include(aw.Nodes.rainbow), s = [];
            return s.push(this.filmThickness.build(e, "f")), s.push(this.movement.build(e, "f")), s.push(this.wavelengths.build(e, "v3")), s.push(this.noiseStrength.build(e, "f")), s.push(this.noiseScale.build(e, "f")), s.push(this.offset.build(e, "v3")), s.push(this.isMask.build(e, "b")), s.push(this.mask ? `luminance(${this.mask.flow(e, "v3").result})` : "1.0"), s.push(this.alpha.build(e, "f")), s.push(this.calpha), e.format(i + "(" + s.join(",") + ")", this.getType(e), n);
        } else return console.warn("RainbowNode is not compatible with " + e.shader + " shader."), e.format("vec3( 0.0 )", this.getType(e), n);
    }
}, dd = aw;
dd.Nodes = function() {
    let e = new me(`vec3 attenuation(vec3 wavelengths, float filmThickness, float movement, float noiseStrength, float noiseScale, vec3 offset) {
                 vec3 st = position / noiseScale;
				 vec3 q = vec3(simplex3d(st),
							  simplex3d(st + vec3(1.0)),
							  simplex3d(st + vec3(1.0)));

				 vec3 r = vec3(simplex3d(st + vec3(1.4, 1.3, 1.0) * q + vec3(1.7, 9.2, 1.0)),
							  simplex3d(st + vec3(2.0, 1.2, 1.0) * q + vec3(8.3, 2.8, 1.0)),
							  simplex3d(st * q));

                 float noise = simplex3d(st + r);

                 return .5 + .5 * cos((((filmThickness + (noise * noiseStrength)) / (vec3(wavelengths.r * 1.0, wavelengths.g * 0.8, wavelengths.b * 0.6) + 1.0)) * dot(normalize(vWorldViewDir + (offset * -0.001)), normalize(vWNormal))) + movement);
             }`, [
        ur.simplex
    ]);
    return {
        rainbow: new me(`vec3 rainbow(float filmThickness, float movement, vec3 wavelengths, float noiseStrength, float noiseScale, vec3 offset, bool isMask, float mask, float alpha, out float calpha) {
				vec3 res = clamp(attenuation(wavelengths, filmThickness, movement, noiseStrength, noiseScale, offset), 0.0, 2.0);

				float rainbowContribution = clamp(res.r + res.g + res.b, 0.0, 1.0);

				float lalpha = alpha * rainbowContribution * mask;
				calpha = mix(lalpha / clamp(lalpha + accumAlpha, 0.00001, 1.0), lalpha, float(isMask));
				accumAlpha += (1.0 - accumAlpha) * lalpha * (1.0 - float(isMask));

				return res;
             }`, [
            e
        ])
    };
}();
var lw = class extends ze {
    constructor(e, n, i, s, o, a, l, u, c, d){
        super("v3");
        this.nodeType = "Toon";
        this.positioning = e, this.colors = n, this.steps = i, this.source = s, this.isWorldSpace = o, this.noiseStrength = a, this.noiseScale = l, this.shadowColor = u, this.offset = c, this.alpha = d, this.calpha = `g${this.uuid.toString().replace(/-/g, "")}_calpha`;
    }
    generate(e, n) {
        if (e.require("worldNormal"), e.require("worldPosition"), e.isShader("fragment")) {
            e.define("COLORS_MAX", 10), e.addFragmentVariable(this.calpha, "float");
            let i = e.include(lw.Nodes.toon), s = [];
            return s.push(this.positioning.build(e, "i")), s.push(this.colors.build(e, "v4[]")), s.push(this.steps.build(e, "f[]")), s.push(this.source.build(e, "v3")), s.push(this.isWorldSpace.build(e, "b")), s.push(this.noiseStrength.build(e, "f")), s.push(this.noiseScale.build(e, "f")), s.push(this.shadowColor.build(e, "v4")), s.push(this.offset.build(e, "v3")), s.push(this.mask ? `luminance(${this.mask.flow(e, "v3").result})` : "1.0"), s.push(this.alpha.build(e, "f")), s.push(this.calpha), e.format(i + "(" + s.join(",") + ")", this.getType(e), n);
        } else return console.warn("ToonNode is not compatible with " + e.shader + " shader."), e.format("vec3( 0.0 )", this.getType(e), n);
    }
}, hd = lw;
hd.Nodes = function() {
    let e = new me(`float rand(float n) {
				return fract(sin(n) * 43758.5453123);
			}`), n = new me(`float hash1(float p) { 
				p = fract(p * 0.011); 
				p *= p + 7.5; 
				p *= p + p; 
				return fract(p); 
			}`), i = new me(`float valueNoise(vec3 x) {
				const vec3 step = vec3(110, 241, 171);
			
				vec3 i = floor(x);
				vec3 f = fract(x);
			 
				// For performance, compute the base input to a 1D hash from the integer part of the argument and the 
				// incremental change to the 1D based on the 3D -> 1D wrapping
				float n = dot(i, step);
			
				vec3 u = f * f * (3.0 - 2.0 * f);
				return mix(mix(mix( hash1(n + dot(step, vec3(0, 0, 0))), hash1(n + dot(step, vec3(1, 0, 0))), u.x),
							   mix( hash1(n + dot(step, vec3(0, 1, 0))), hash1(n + dot(step, vec3(1, 1, 0))), u.x), u.y),
						   mix(mix( hash1(n + dot(step, vec3(0, 0, 1))), hash1(n + dot(step, vec3(1, 0, 1))), u.x),
							   mix( hash1(n + dot(step, vec3(0, 1, 1))), hash1(n + dot(step, vec3(1, 1, 1))), u.x), u.y), u.z);
			}`, [
        n
    ]), s = new me(`vec3 hash3(vec3 x) {
				x = vec3(dot(x,vec3(127.1, 311.7, 74.7)),
						 dot(x,vec3(269.5, 183.3, 246.1)),
						 dot(x,vec3(113.5, 271.9, 124.6)));
			
				return fract(sin(x)*43758.5453123);
			}`), o = new me(`vec3 voronoiNoise(in vec3 x)
			{
				vec3 p = floor(x);
				vec3 f = fract(x);

				float id = 0.0;
				vec2 res = vec2(100.0);

				for(int k=-1; k<=1; k++)
				for(int j=-1; j<=1; j++)
				for(int i=-1; i<=1; i++)
				{
					vec3 b = vec3(float(i), float(j), float(k));

					// Comment out the "+ hash(p + b);" part below to get "square" cells
					vec3 r = vec3(b) - f + hash3(p + b);
					float d = dot(r, r);

					if (d < res.x)
					{
						id = dot(p + b, vec3(1.0, 57.0, 113.0));
						res = vec2(d, res.x);			
					}
					else if (d < res.y)
					{
						res.y = d;
					}
				}

				return vec3(sqrt(res), abs(id));
			}
			`, [
        s
    ]);
    return {
        toon: new me(`vec3 toon(int positioning, vec4 colors[COLORS_MAX], float steps[COLORS_MAX], vec3 source, bool isWorldSpace, float noiseStrength, float noiseScale, vec4 shadowColor, vec3 offset, float mask, float alpha, out float calpha) {
				float t = 0.0;
				float shadow = 1.0;

				if (positioning == 0) {

					// Can't do this mode if lighting is "none"
					#if (defined(PHONG) || defined(LAMBERT) || defined(STANDARD))

						// Algorithm from Chapter 10 of Graphics Shaders
						const vec3 weights = vec3(0.2125, 0.7154, 0.0721);
						vec3 lpos;
						vec3 l;
						float dproduct;

						#if (NUM_POINT_LIGHTS > 0)

							#if defined(USE_SHADOWMAP) && (NUM_POINT_LIGHT_SHADOWS > 0)
								PointLightShadow pointLightShadow;
							#endif 

							#pragma unroll_loop_start
							for (int i = 0; i < NUM_POINT_LIGHTS; i++) {
								// Light positions are in view-space for some reason?
								lpos = (inverse(viewMatrix) * vec4(pointLights[UNROLLED_LOOP_INDEX].position, 1.0)).xyz;
								l = normalize(lpos - worldPosition);
								
								dproduct = dot(l, normalize(worldNormal)) * 0.5 + 0.5;
								
								// TODO: we want to use "intensity" but it isn't available in the shader code
								//dproduct += dot(pointLights[UNROLLED_LOOP_INDEX].color, weights);

								t = max(t, dproduct);

								// Accumulate shadow contribution
								#if defined(USE_SHADOWMAP) && (UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS)
									pointLightShadow = pointLightShadows[UNROLLED_LOOP_INDEX];
									shadow *= getPointShadow( 
											pointShadowMap[UNROLLED_LOOP_INDEX], 
											pointLightShadow.shadowMapSize, 
											pointLightShadow.shadowBias, 
											pointLightShadow.shadowRadius,
											vPointShadowCoord[UNROLLED_LOOP_INDEX], 
											pointLightShadow.shadowCameraNear, 
											pointLightShadow.shadowCameraFar);
								#endif
							}
							#pragma unroll_loop_end

						#endif

						#if NUM_DIR_LIGHTS > 0 
							
							#if defined(USE_SHADOWMAP) && (NUM_DIR_LIGHT_SHADOWS > 0)
								DirectionalLightShadow directionalLightShadow;
							#endif 

							#pragma unroll_loop_start
							for (int i = 0; i < NUM_DIR_LIGHTS; i++) {
								// Use the direction vector for directional lights instead
								l = (inverse(viewMatrix) * vec4(directionalLights[UNROLLED_LOOP_INDEX].direction, 0.0)).xyz;
		
								dproduct = dot(l, normalize(worldNormal)) * 0.5 + 0.5;
								t = max(t, dproduct);

								// Accumulate shadow contribution
								#if defined(USE_SHADOWMAP) && (UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS)
									directionalLightShadow = directionalLightShadows[UNROLLED_LOOP_INDEX];
									shadow *= getShadow( 
										UNROLLED_LOOP_INDEX,
										directionalShadowMap[UNROLLED_LOOP_INDEX], 
										directionalLightShadow.shadowMapSize, 
										directionalLightShadow.shadowBias, 
										directionalLightShadow.shadowRadius, 
										vDirectionalShadowCoord[UNROLLED_LOOP_INDEX]);
								#endif
							}
							#pragma unroll_loop_end

						#endif

						#if NUM_SPOT_LIGHTS > 0 
							
							#if defined(USE_SHADOWMAP) && (NUM_SPOT_LIGHT_SHADOWS > 0)
								SpotLightShadow spotLightShadow;
							#endif 

							#pragma unroll_loop_start
							for (int i = 0; i < NUM_SPOT_LIGHTS; i++) {
								lpos = (inverse(viewMatrix) * vec4(spotLights[UNROLLED_LOOP_INDEX].position, 1.0)).xyz;
								l = normalize(lpos - worldPosition);
								
								dproduct = dot(l, normalize(worldNormal)) * 0.5 + 0.5;
								t = max(t, dproduct);

								// Accumulate shadow contribution
								#if defined(USE_SHADOWMAP) && (UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS)
									spotLightShadow = spotLightShadows[UNROLLED_LOOP_INDEX];
									shadow *= getShadow(
										UNROLLED_LOOP_INDEX,
										spotShadowMap[UNROLLED_LOOP_INDEX], 
										spotLightShadow.shadowMapSize, 
										spotLightShadow.shadowBias, 
										spotLightShadow.shadowRadius, 
										vSpotLightCoord[UNROLLED_LOOP_INDEX]);
								#endif
							}
							#pragma unroll_loop_end

						#endif

						t = clamp(t, 0.0, 1.0);
				
					#endif

				} else if (positioning == 1) {
					
					vec3 origin = mix(position, worldPosition, float(isWorldSpace));
					vec3 direction = normalize(source - origin);
					t = dot(direction, normalize(worldNormal)) * 0.5 + 0.5;	

				} else {

					vec3 origin = worldPosition;
					vec3 source = cameraPosition - offset;
					vec3 direction = normalize(source - origin);
					t = dot(direction, normalize(worldNormal)) * 0.5 + 0.5;	
					
				}

				if (noiseStrength > 0.0) {
					// Distort with noise
					vec3 st = position / noiseScale;
					
					// Voronoi "smooth" noise
					float noise = 1.0 - voronoiNoise(st).x;

					// Voronoi cellular noise
					//float noise = 1.0 - rand(voronoiNoise(st).z);

					// Position warp noise
					// vec3 offset = vec3(
					// 	simplex3d(st),
					// 	simplex3d(st + vec3(111.1, 143.89, 217.19)),
					// 	simplex3d(st + vec3(171.1, 247.89, 117.23))
					// );
					// st += offset;
					// float noise = valueNoise(st);

					t += noise * noiseStrength;
				}

				t = clamp(t, 0.0, 1.0);

				// Compute ramp color
				float p;
				vec4 color = colors[0];
				for (int i = 1; i < COLORS_MAX; i++) {
					p = clamp((t - steps[i-1]) / (steps[i] - steps[i-1]), 0.0, 1.0);
					color = mix(color, colors[i], smoothstep(0.0, 1.0, p));
				}

				// Incorporate custom shadow color
				if (positioning == 0) {

					vec3 blendedShadow = mix(color.rgb, shadowColor.rgb, shadowColor.a);
					color.rgb = mix(blendedShadow, color.rgb, shadow);
				
				}

				// Accumulate alpha as usual
				float lalpha = alpha * color.a * mask;
				calpha =  lalpha / clamp(lalpha + accumAlpha, 0.00001, 1.0);
				accumAlpha += (1.0 - accumAlpha) * lalpha;

				return color.xyz;

            }`, [
            ur.simplex,
            e,
            i,
            o
        ])
    };
}();
var cw = class extends ze {
    constructor(e, n, i, s, o, a, l, u){
        super("v3");
        this.nodeType = "Transmission";
        this.thickness = e, this.ior = n, this.roughness = i, this.transmissionSamplerSize = s, this.transmissionSamplerMap = o, this.transmissionDepthMap = a, this.aspectRatio = l, this.alpha = u, this.calpha = `g${this.uuid.toString().replace(/-/g, "")}_calpha`;
    }
    generate(e, n) {
        if (e.extensions.shaderTextureLOD = !0, e.extensions.derivatives = !0, e.isShader("fragment")) {
            e.define("NUM_SAMPLES", 6), e.define("BLUR_SLOD", Math.pow(2, Fe.transmissionLod.value)), e.require("worldPosition"), e.requires.worldNormal = !0, e.requires.modelMatrix = !0, e.requires.projectionMatrix = !0, e.addFragmentVariable(this.calpha, "float");
            let i = e.include(cw.Nodes.transmission), s = [];
            return s.push(this.thickness.build(e, "f")), s.push(this.ior.build(e, "f")), s.push(this.roughness.build(e, "f")), s.push(this.transmissionSamplerSize.build(e, "v2")), s.push(this.transmissionSamplerMap.getTexture(e, "t")), s.push(this.transmissionDepthMap.getTexture(e, "t")), s.push(this.aspectRatio.build(e, "v2")), s.push("normal"), s.push(this.mask ? `luminance(${this.mask.flow(e, "v3").result})` : "1.0"), s.push(this.alpha.build(e, "f")), s.push(this.calpha), e.format(i + "(" + s.join(",") + ")", this.getType(e), n);
        } else return console.warn("TransmissionNode is not compatible with " + e.shader + " shader."), e.format("vec3( 0.0 )", this.getType(e), n);
    }
}, fd = cw;
fd.Nodes = function() {
    let e = new me(`
            vec3 blur(sampler2D sp, vec2 U, vec2 scale, float lod, sampler2D dm, vec2 unrefractedU, vec2 aspectRatio) {
                // Slightly modified version of this:
                // https://www.shadertoy.com/view/ltScRG

				// Special case for blur == 0.0
				if (lod == 0.0) {
					#ifdef TEXTURE_LOD_EXT
					return texture2DLodEXT( sp, U, 0.0).rgb;
					#else
					return textureLod( sp, U, 0.0).rgb;
					#endif
				}
				
				vec2 texelSize = vec2(1.0) / resolution;
                vec2 halton = haltonSequence[frameIndex];
                float temporalOffset = getNoiseInterleavedGradient(gl_FragCoord.xy + halton);
                float temporalAngle  = temporalOffset * PI2;
				vec3 res = vec3(0.0);
                vec2 uv = vec2(0.0);
                vec2 offset = vec2(0.0);
                vec2 vogelSample = vec2(0.0);
                for (int i = 0; i < NUM_SAMPLES; i++) {
                    vogelSample =  vogelDiskSample(i, NUM_SAMPLES, temporalAngle) * texelSize;
                    offset = vogelSample * scale * (lod * 10.0); // TODO: used to be hardcoded to 20
                    uv = U + offset;
                    float opaqueDepth = unpackRGBAToDepth(textureLod(dm, uv, lod));
                    if (opaqueDepth != 0.0 && opaqueDepth < gl_FragCoord.z) {
                        uv = unrefractedU;
                        lod = lod > 4.0 ? lod : lod / 2.0;
                    }
                    res += textureLod(sp, uv, lod).rgb;
                }
                return res / float(NUM_SAMPLES);

            }`), n = new me(`
            vec3 getVolumeTransmissionRay( vec3 n, vec3 v, float thickness, float ior, mat4 modelMatrix ) {
		        // Direction of refracted light.
		        vec3 refractionVector = refract( -v,  n, 1.0 / ior );
		        // Compute rotation-independant scaling of the model matrix.
		        vec3 modelScale;
		        modelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );
		        modelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );
		        modelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );
		        // The thickness is specified in local space.
		        return normalize( refractionVector ) * thickness * modelScale;
	        }`), i = new me(`
float applyIorToRoughness( float roughness, float ior ) {
		// Scale roughness with IOR so that an IOR of 1.0 results in no microfacet refraction and
		// an IOR of 1.5 results in the default amount of microfacet refraction.
		return roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );
	} `), s = new me(`
vec3 getTransmissionSample( vec2 fragCoord, float roughness, float ior, vec2 transmissionSamplerSize, sampler2D transmissionSamplerMap, sampler2D transmissionDepthMap, vec2 unrefractedCoords, vec2 aspectRatio) {
		float framebufferLod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );
        float lod = applyIorToRoughness(roughness, ior);

        return blur(transmissionSamplerMap, fragCoord, vec2(lod), min(framebufferLod / 5.5, 8.5), transmissionDepthMap, unrefractedCoords, aspectRatio);
	}`, [
        i,
        e
    ]), o = new me(`
vec3 getIBLVolumeRefraction( vec3 n, vec3 v, float roughness, vec3 position, mat4 modelMatrix, mat4 viewMatrix, mat4 projMatrix, float ior, float thickness, vec2 transmissionSamplerSize, sampler2D transmissionSamplerMap, sampler2D transmissionDepthMap, vec2 aspectRatio ) {
        vec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );
        vec3 refractedRayExit = position + transmissionRay;

        // Project refracted vector on the framebuffer, while mapping to normalized device coordinates.
        vec4 ndcPos = projMatrix * viewMatrix *  vec4( refractedRayExit, 1.0 );
        vec2 refractionCoords = ndcPos.xy / ndcPos.w;
        refractionCoords += 1.0;
        refractionCoords /= 2.0;

        vec4 ndcPosUnrefracted = projMatrix * viewMatrix * vec4(position, 1.0 );
        vec2 unrefractedCoords = ndcPosUnrefracted.xy / ndcPosUnrefracted.w;
        unrefractedCoords += 1.0;
        unrefractedCoords /= 2.0;

        // Sample framebuffer to get pixel the refracted ray hits.
        return getTransmissionSample( refractionCoords, roughness, ior, transmissionSamplerSize, transmissionSamplerMap, transmissionDepthMap, unrefractedCoords, aspectRatio );
    }`, [
        s,
        n
    ]);
    return {
        transmission: new me(`
            vec3 transmission(float thickness, float ior, float roughness, vec2 transmissionSamplerSize, sampler2D transmissionSamplerMap, sampler2D transmissionDepthMap, vec2 aspectRatio, vec3 normal, float mask, float alpha, out float calpha) {
                vec3 v = vec3(0.);
                if (isOrthographic) {
                    v = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );
                } else {
                    v = normalize(vWPosition - cameraPosition);
                }
                vec3 transmission = getIBLVolumeRefraction(vWNormal, -v, roughness,  vWPosition, modelMatrix, viewMatrix, projectionMatrix, ior, thickness, transmissionSamplerSize, transmissionSamplerMap, transmissionDepthMap, aspectRatio );
                
				float lalpha = alpha * mask;
				calpha =  lalpha / clamp( lalpha + accumAlpha, 0.00001, 1.0 );
				accumAlpha += ( 1.0 - accumAlpha ) * alpha;

				return transmission;
            }`, [
            o
        ])
    };
}();
var uw = ((e)=>(e.NOISE = "noise", e.MAP = "map", e))(uw || {}), dw = class extends ze {
    constructor(e, n, i, s, o, a, l, u, c, d, h){
        super("v3");
        this.displacementTypeIndex = new dt(0);
        this.nodeType = "VertexDisplacement";
        this.intensity = e, this.movementOrTexture = n, Object.values(uw)[this.displacementTypeIndex.value] === "map" && (this.mat = new $u(this.movementOrTexture.value.matrix)), this.cropOrOffset = i, this.scale = d, this.noiseFunctionIndex = h, this.voronoiStyle = s, this.smoothness = o, this.seed = a, this.highCut = l, this.lowCut = u, this.quality = c;
    }
    generate(e, n) {
        if (e.isShader("vertex")) {
            e.define("USE_LAYER_DISPLACE");
            let i, s = [];
            switch(s.push("displaced_position"), s.push("displaced_normal"), Object.values(uw)[this.displacementTypeIndex.value]){
                case "map":
                    i = e.include(dw.Nodes.map), s.push(this.movementOrTexture.getTexture(e, "t")), s.push("uv"), s.push(this.cropOrOffset.build(e, "f")), this.mat && s.push(this.mat.build(e, "mat3"));
                    break;
                case "noise":
                    {
                        let a = Object.values(Sf)[this.noiseFunctionIndex.value], l = new me(`vec3 orthogonal(vec3 v) {
							return normalize(abs(v.x) > abs(v.z) ? vec3(-v.y, v.x, 0.0) : vec3(0.0, -v.z, v.y));
						}`), u = a == "voronoi" ? `
					float v = ${a}((p + offset) * scale * 0.001 + neighbour_offset + (movement * 0.1), voronoiStyle, smoothness, seed, quality);
					v = remap(v, lowCut, highCut, 0.0, 1.0);
					v = smax(v, 0.0, smoothness * 0.25);
					v = smin(v, 1.0, smoothness * 0.25);

					return p + n * v * intensity;
					` : `
					return p + n * ${a}((p + offset) * scale * 0.001 + neighbour_offset + (movement * 0.1)) * intensity;
					`, c = new me(`vec3 distorted(vec3 p, vec3 n, float scale, float intensity, vec3 offset, float neighbour_offset, float movement, int voronoiStyle, float smoothness, float seed, float highCut, float lowCut, int quality) {
							${u}
						}`, [
                            ur.simplex,
                            ur.simplexFractal,
                            ur.simplexAshima,
                            ur.fbm,
                            ur.perlin,
                            ur.voronoi
                        ]), d = new me(`vec3 vertexDisplacementNoise(vec3 position, vec3 normal, float scale, vec3 offset, float movement, int voronoiStyle, float smoothness, float seed, float highCut, float lowCut, int quality, float intensity, out vec3 displaced_normal) {
							vec3 displaced_position = distorted(position, normal, scale, intensity, offset, neighbor_offset, movement, voronoiStyle, smoothness, seed, highCut, lowCut, quality);
							vec3 tangent1 = orthogonal(normal);
							vec3 tangent2 = normalize(cross(normal, tangent1));

                            // TODO(Max): The distance to the neighbors was originally scaled by 0.1.
                            // This caused some small oval/circular visual artifacts in the lighting.
                            // For now, simply using neighbors further away betters the problem,
                            // but we should figure out the underlying cause when we have some time.
                            // Maybe its related to how we calculate the tangent and bitangent?
							vec3 nearby1 = position + tangent1;
							vec3 nearby2 = position + tangent2;
							vec3 distorted1 = distorted(nearby1, normal, scale, intensity, offset, neighbor_offset, movement, voronoiStyle, smoothness, seed, highCut, lowCut, quality);
							vec3 distorted2 = distorted(nearby2, normal, scale, intensity, offset, neighbor_offset, movement, voronoiStyle, smoothness, seed, highCut, lowCut, quality);
							displaced_normal = normalize(cross(distorted1 - displaced_position, distorted2 - displaced_position));
							return displaced_position;
						}`, [
                            c,
                            l
                        ]);
                        i = e.include(d), s.push(this.scale.build(e, "f")), s.push(this.cropOrOffset.build(e, "v3")), s.push(this.movementOrTexture.build(e, "f")), s.push(this.voronoiStyle.build(e, "i")), s.push(this.smoothness.build(e, "f")), s.push(this.seed.build(e, "f")), s.push(this.highCut.build(e, "f")), s.push(this.lowCut.build(e, "f")), s.push(this.quality.build(e, "i"));
                        break;
                    }
            }
            return s.push(this.intensity.build(e, "f")), s.push("displaced_normal"), e.format(i + "(" + s.join(",") + ")", this.getType(e), n);
        } else return console.warn("VertexDisplacementNode is not compatible with " + e.shader + " shader."), e.format("vec3( 0.0 )", this.getType(e), n);
    }
}, pd = dw;
pd.Nodes = function() {
    let e = new me(`vec3 orthogonal(vec3 v) {
				return normalize(abs(v.x) > abs(v.z) ? vec3(-v.y, v.x, 0.0) : vec3(0.0, -v.z, v.y));
			}`), n = new me(`float displacementMapTexture(sampler2D tex, float crop, vec2 uv, mat3 mat, vec2 offset) {
				vec2 uvs = (mat * vec3(uv * 2.0 - 1.0, 1.0) / 2.0 + 0.5).xy + offset;
				vec4 tmp = texture2D(tex, uvs);
				vec3 col = tmp.rgb;
				if (crop > 0.5) {
					if ( uvs.x < 0.0 || uvs.x > 1.0 || uvs.y < 0.0 || uvs.y > 1.0 )  {
						return 0.0;
					}
				}
				return col.r;
			}`);
    return {
        map: new me(`vec3 vertexDisplacementMap(vec3 position, vec3 normal, sampler2D tex, vec2 uv, float crop, mat3 mat, float intensity, out vec3 displaced_normal) {
				vec3 displaced_position = position + normal * displacementMapTexture(tex, crop, uv, mat, vec2(0.0)) * intensity;
				vec3 tangent1 = normalize(orthogonal(normal));
				vec3 tangent2 = normalize(cross(normal, tangent1));
				vec3 nearby1 = position + tangent1 * 0.1;
				vec3 nearby2 = position + tangent2 * 0.1;
				vec3 distorted1 = nearby1 + normal * displacementMapTexture(tex, crop, uv, mat, vec2(neighbor_offset)) * intensity;
				vec3 distorted2 = nearby2 + normal * displacementMapTexture(tex, crop, uv, mat, vec2(neighbor_offset)) * intensity;
				displaced_normal = normalize(cross(distorted1 - displaced_position, distorted2 - displaced_position));
				return displaced_position;
			}`, [
            e,
            n
        ])
    };
}();
var Fe = {
    normalRenderTarget: new kr,
    normalRenderTargetDepth: new kr,
    transmissionRenderTarget: new kr,
    transmissionSize: new hn(2048, 2048),
    transmissionRenderTargetDepth: new kr,
    aoRenderTarget: new kr,
    aoEnabled: new fn,
    pixelRatioNode: new _e(1),
    resolution: new hn,
    penumbraSize: new es(5, .5),
    frameIndex: new dt(0),
    transmissionLod: new dt(2)
};
for (let r1 of Object.values(Fe))r1.isRenderGlobal = !0;
var Cl = class extends ar {
    constructor(){
        super("basic");
        this.nodeType = "Basic";
        this.color = new It(5526619), this.shadingAlpha = new _e(1), this.shadingBlend = new dt(0), this.previousModelViewMatrix = new vr, this.previouseProjectionMatrix = new vr;
    }
    get category() {
        return "phong";
    }
    generate(e) {
        let n;
        if (e.isShader("vertex")) {
            let i = this.position ? this.position.analyzeAndFlow(e, "v3", {
                cache: "position"
            }) : void 0;
            e.mergeUniform({
                frameIndex: Fe.frameIndex
            }), e.mergeUniform({
                resolution: Fe.resolution
            }), e.mergeUniform({
                previousModelViewMatrix: this.previousModelViewMatrix
            }), e.mergeUniform({
                previousProjectionMatrix: this.previouseProjectionMatrix
            }), e.mergeUniform(Gi.merge([
                be.fog
            ])), e.addParsCode([
                "varying vec3 vViewPosition;",
                "varying vec3 vWPosition;",
                "#include <fog_pars_vertex>",
                "#include <normal_pars_vertex>"
            ].join(`
`));
            let s = [
                "#include <beginnormal_vertex>",
                `
				#if !defined( USE_LAYER_DISPLACE )
					#include <defaultnormal_vertex>
				#endif

				vec3 displaced_position = position;
				vec3 displaced_normal = normal;

				#if defined( USE_LAYER_DISPLACE )
					vec3 transformed;
					vec3 transformedNormal;
				#endif
				`,
                "#include <normal_vertex>",
                `
				#if !defined( USE_LAYER_DISPLACE )
					#include <begin_vertex>
				#endif /* !USE_LAYER_DISPLACE */
				`
            ];
            i && s.push(i.code, i.result ? "displaced_position = " + i.result + ";" : ""), s.push("transformed = displaced_position;", "transformedNormal = normalMatrix * displaced_normal;", "#ifndef FLAT_SHADED", "	vNormal = transformedNormal;", "#endif"), s.push("#include <project_vertex>", "#include <fog_vertex>", "#include <clipping_planes_vertex>", "	vViewPosition = - mvPosition.xyz;", "#include <worldpos_vertex>"), s.push("vWPosition = ( modelMatrix * vec4( transformed, 1.0 ) ).xyz;"), n = s.join(`
`);
        } else {
            this.color === void 0 && (this.color = new It(5526619)), this.color.analyze(e, {
                slot: "color"
            }), this.alpha && this.alpha.analyze(e), this.afterColor && this.afterColor.analyze(e, {
                slot: "afterColor"
            });
            let i = this.color.flow(e, "c", {
                slot: "color"
            }), s = this.alpha ? this.alpha.flow(e, "f") : void 0, o = this.afterColor ? this.afterColor.flow(e, "c", {
                slot: "afterColor"
            }) : void 0;
            e.requires.transparent = s !== void 0, e.addParsCode([
                "varying vec3 vWPosition;",
                "#include <fog_pars_fragment>",
                "#include <dithering_pars_fragment>",
                "varying vec3 vViewPosition;",
                "#include <normal_pars_fragment>"
            ].join(`
`));
            let a = [
                "#include <normal_fragment_begin>",
                i.code
            ];
            s && a.push(s.code, "#ifdef ALPHATEST", " if ( " + s.result + " <= ALPHATEST ) discard;", "#endif"), o ? a.push(o.code, `vec3 outgoingLight = ${i.result};`, `vec3 finalColor = spe_blend(outgoingLight, ${o.result}, 1.0, SPE_BLENDING_NORMAL);`) : a.push(`vec3 finalColor = ${i.result};`);
            let l = "1.0";
            this.mask && (this.mask.analyze(e), l = `luminance(${this.mask.flow(e, "v3").result})`), s ? a.push(`gl_FragColor = vec4( finalColor, accumAlpha * ${s.result} * ${l} );`) : a.push("gl_FragColor = vec4(" + i.result + ", 1.0 );"), a.push("#include <fog_fragment>", "#include <dithering_fragment>"), n = a.join(`
`);
        }
        return n;
    }
};
var Af = class extends ar {
    constructor(){
        super("lambert");
        this.nodeType = "Lambert";
        this.color = new It(5526619), this.emissive = new It(0), this.emissiveIntensity = new _e(1), this.previousModelViewMatrix = new vr, this.previouseProjectionMatrix = new vr, this.shadingAlpha = new _e(1), this.shadingBlend = new dt(0), this.occlusion = new fn(!0);
    }
    get category() {
        return "lambert";
    }
    build(e) {
        let n;
        if (e.define("LAMBERT"), e.requires.lights = !0, e.extensions.derivatives = !0, e.isShader("vertex")) {
            let i = this.position ? this.position.analyzeAndFlow(e, "v3", {
                cache: "position"
            }) : void 0;
            e.mergeUniform({
                frameIndex: Fe.frameIndex
            }), e.mergeUniform({
                resolution: Fe.resolution
            }), e.mergeUniform({
                previousModelViewMatrix: this.previousModelViewMatrix
            }), e.mergeUniform({
                previousProjectionMatrix: this.previouseProjectionMatrix
            }), e.mergeUniform(Gi.merge([
                be.fog,
                be.lights
            ])), e.addParsCode([
                "varying vec3 vViewPosition;",
                "varying vec3 vWPosition;",
                "varying vec3 vLightFront;",
                "varying vec3 vIndirectFront;",
                "#ifndef DOUBLE_SIDED",
                "   #define DOUBLE_SIDED",
                "#endif",
                "#ifdef DOUBLE_SIDED",
                "	varying vec3 vLightBack;",
                "	varying vec3 vIndirectBack;",
                "#endif",
                "#include <bsdfs>",
                "#include <lights_pars_begin>",
                "#include <color_pars_vertex>",
                "#include <fog_pars_vertex>",
                "#include <normal_pars_vertex>",
                "#include <shadowmap_pars_vertex>",
                "#include <clipping_planes_pars_vertex>"
            ].join(`
`));
            let s = [
                "#include <beginnormal_vertex>",
                `
				#ifndef USE_LAYER_DISPLACE
					#include <defaultnormal_vertex>
				#endif

				vec3 displaced_position = position;
				vec3 displaced_normal = normal;

				#ifdef USE_LAYER_DISPLACE
					vec3 transformed;
					vec3 transformedNormal;
				#endif
				`,
                "#include <normal_vertex>",
                `
				#ifndef USE_LAYER_DISPLACE
					#include <begin_vertex>
				#endif
				`
            ];
            i && s.push(i.code, i.result ? "displaced_position = " + i.result + ";" : ""), s.push("transformed = displaced_position;", "transformedNormal = normalMatrix * displaced_normal;", "#ifndef FLAT_SHADED", "    vNormal = transformedNormal;", "#endif"), s.push("	#include <project_vertex>", "	#include <clipping_planes_vertex>", "	vViewPosition = - mvPosition.xyz;", "	#include <worldpos_vertex>", `
					vec3 diffuse = vec3( 1.0 );
					GeometricContext geometry;
					geometry.position = mvPosition.xyz;
					geometry.normal = normalize( transformedNormal );
					geometry.viewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( -mvPosition.xyz );
					GeometricContext backGeometry;
					backGeometry.position = geometry.position;
					backGeometry.normal = -geometry.normal;
					backGeometry.viewDir = geometry.viewDir;
					vLightFront = vec3( 0.0 );
					vIndirectFront = vec3( 0.0 );
					#ifdef DOUBLE_SIDED
						vLightBack = vec3( 0.0 );
						vIndirectBack = vec3( 0.0 );
					#endif
					IncidentLight directLight;
					float dotNL;
					vec3 directLightColor_Diffuse;
					vIndirectFront += getAmbientLightIrradiance( ambientLightColor );
					vIndirectFront += getLightProbeIrradiance( lightProbe, geometry.normal );
					#ifdef DOUBLE_SIDED
						vIndirectBack += getAmbientLightIrradiance( ambientLightColor );
						vIndirectBack += getLightProbeIrradiance( lightProbe, backGeometry.normal );
					#endif
					#if NUM_POINT_LIGHTS > 0
						#pragma unroll_loop_start
						for ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {
							getPointLightInfo( pointLights[ i ], geometry, directLight );
							dotNL = dot( geometry.normal, directLight.direction );
							directLightColor_Diffuse = directLight.color;
							vLightFront += saturate( dotNL ) * directLightColor_Diffuse;
							#ifdef DOUBLE_SIDED
								vLightBack += saturate( -dotNL ) * directLightColor_Diffuse;
							#endif
						}
						#pragma unroll_loop_end
					#endif
					#if NUM_SPOT_LIGHTS > 0
						#pragma unroll_loop_start
						for ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {
							getSpotLightInfo( spotLights[ i ], geometry, directLight );
							dotNL = dot( geometry.normal, directLight.direction );
							directLightColor_Diffuse = directLight.color;
							vLightFront += saturate( dotNL ) * directLightColor_Diffuse;
							#ifdef DOUBLE_SIDED
								vLightBack += saturate( -dotNL ) * directLightColor_Diffuse;
							#endif
						}
						#pragma unroll_loop_end
					#endif
					#if NUM_DIR_LIGHTS > 0
						#pragma unroll_loop_start
						for ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {
							getDirectionalLightInfo( directionalLights[ i ], geometry, directLight );
							dotNL = dot( geometry.normal, directLight.direction );
							directLightColor_Diffuse = directLight.color;
							vLightFront += saturate( dotNL ) * directLightColor_Diffuse;
							#ifdef DOUBLE_SIDED
								vLightBack += saturate( -dotNL ) * directLightColor_Diffuse;
							#endif
						}
						#pragma unroll_loop_end
					#endif
					#if NUM_HEMI_LIGHTS > 0
						#pragma unroll_loop_start
						for ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {
							vIndirectFront += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry.normal );
							#ifdef DOUBLE_SIDED
								vIndirectBack += getHemisphereLightIrradiance( hemisphereLights[ i ], backGeometry.normal );
							#endif
						}
						#pragma unroll_loop_end
					#endif
				`, "	#include <shadowmap_vertex>", "	#include <fog_vertex>"), s.push("vWPosition = ( modelMatrix * vec4( transformed, 1.0 ) ).xyz;"), n = s.join(`
`);
        } else {
            e.mergeUniform({
                penumbraSize: Fe.penumbraSize
            }), e.mergeUniform({
                frameIndex: Fe.frameIndex
            }), e.mergeUniform({
                aoMap: Fe.aoRenderTarget
            }), e.mergeUniform({
                aoEnabled: Fe.aoEnabled
            }), this.color === void 0 && (this.color = new It(5526619)), this.color.analyze(e, {
                slot: "color"
            }), this.shadingAlpha.analyze(e), this.shadingBlend.analyze(e), this.afterColor && this.afterColor.analyze(e, {
                slot: "afterColor"
            }), this.alpha && this.alpha.analyze(e);
            let i = this.color.flow(e, "c", {
                slot: "color"
            }), s = this.emissive.flow(e, "c", {
                slot: "emissive"
            }), o = this.emissiveIntensity.flow(e, "f", {
                slot: "emissive"
            }), a = this.occlusion.flow(e, "b", {
                slot: "occlusion"
            }), l = this.shadingAlpha.flow(e, "f"), u = this.shadingBlend.flow(e, "i"), c = this.afterColor ? this.afterColor.flow(e, "c", {
                slot: "afterColor"
            }) : void 0, d = this.alpha ? this.alpha.flow(e, "f") : void 0;
            e.requires.transparent = d !== void 0, e.addParsCode([
                `uniform float penumbraSize[${5}];`,
                "uniform sampler2D aoMap;",
                "uniform bool aoEnabled;",
                "varying vec3 vViewPosition;",
                "varying vec3 vWPosition;",
                "varying vec3 vLightFront;",
                "varying vec3 vIndirectFront;",
                "#ifndef DOUBLE_SIDED",
                "   #define DOUBLE_SIDED",
                "#endif",
                "#include <normal_pars_fragment>",
                "#ifdef DOUBLE_SIDED",
                "	varying vec3 vLightBack;",
                "	varying vec3 vIndirectBack;",
                "#endif",
                "#include <bsdfs>",
                "#include <lights_pars_begin>",
                "#include <fog_pars_fragment>",
                "#include <shadowmap_pars_fragment>",
                "#include <shadowmask_pars_fragment>",
                "#include <clipping_planes_pars_fragment>",
                "#include <dithering_pars_fragment>"
            ].join(`
`));
            let h = [
                "#include <normal_fragment_begin>",
                `
				// NOTE: gl_FrontFacing alternative using face normal estimation.
				vec3 viewdx = dFdx(vViewPosition);
				vec3 viewdy = dFdy(vViewPosition);
				vec3 faceNormal = normalize(cross(viewdx, viewdy));
				bool isFrontFacing = (dot(normal, faceNormal) >= 0.0);
				`,
                "#include <clipping_planes_fragment>"
            ];
            h.push(i.code, "vec3 diffuseColor = " + i.result + ";", "ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );"), d && h.push(d.code, "#ifdef ALPHATEST", "if ( " + d.result + " <= ALPHATEST ) discard;", "#endif"), h.push("#ifdef DOUBLE_SIDED", "	reflectedLight.indirectDiffuse += ( isFrontFacing ) ? vIndirectFront : vIndirectBack;", "#else", "	reflectedLight.indirectDiffuse += vIndirectFront;", "#endif", "#include <lightmap_fragment>", "reflectedLight.indirectDiffuse *= BRDF_Lambert( diffuseColor.rgb );", "#ifdef DOUBLE_SIDED", "	reflectedLight.directDiffuse = ( isFrontFacing ) ? vLightFront : vLightBack;", "#else", "	reflectedLight.directDiffuse = vLightFront;", "#endif", "reflectedLight.directDiffuse *= BRDF_Lambert( diffuseColor.rgb ) * getShadowMask();"), s && h.push(s.code, "reflectedLight.directDiffuse += " + s.result + " * " + o.result + ";"), h.push("vec3 ao = aoEnabled && " + a.result + " ? tex2D(aoMap, gl_FragCoord.xy / resolution).rgb : vec3(1.0);", "vec3 outgoingLight = (reflectedLight.directDiffuse + reflectedLight.indirectDiffuse) ;");
            let f = "1.0";
            this.mask && (this.mask.analyze(e), f = `luminance(${this.mask.flow(e, "v3").result})`), h.push(`
				if (outgoingLight != diffuseColor) {
					float lightAccu = clamp( length( reflectedLight.directSpecular + reflectedLight.indirectSpecular ), 0.0, 1.0 );
					accumAlpha += ( 1.0 - accumAlpha ) * ${l.result} * ${f} * lightAccu;
					outgoingLight = spe_blend( diffuseColor, outgoingLight, ${l.result} * ${f}, ${u.result} );

					outgoingLight *= ao;
				}
				`), c && h.push(c.code, `outgoingLight = spe_blend(outgoingLight, ${c.result}, 1.0, SPE_BLENDING_NORMAL);`), d ? h.push(`gl_FragColor = vec4( outgoingLight, accumAlpha * ${d.result} );`) : h.push("gl_FragColor = vec4( outgoingLight, 1.0 );"), h.push("#include <encodings_fragment>", "#include <fog_fragment>", "#include <dithering_fragment>"), n = h.join(`
`);
        }
        return n;
    }
};
var _f = class extends ar {
    constructor(){
        super("phong");
        this.nodeType = "Phong";
        this.color = new It(5526619), this.specular = new It(1118481), this.shininess = new _e(30), this.previousModelViewMatrix = new vr, this.previouseProjectionMatrix = new vr, this.shadingAlpha = new _e(1), this.shadingBlend = new dt(0), this.occlusion = new fn(!0);
    }
    get category() {
        return "phong";
    }
    build(e) {
        let n;
        if (e.define("PHONG"), e.requires.lights = !0, e.extensions.derivatives = !0, e.isShader("vertex")) {
            let i = this.position ? this.position.analyzeAndFlow(e, "v3", {
                cache: "position"
            }) : void 0;
            e.mergeUniform({
                frameIndex: Fe.frameIndex
            }), e.mergeUniform({
                resolution: Fe.resolution
            }), e.mergeUniform({
                previousModelViewMatrix: this.previousModelViewMatrix
            }), e.mergeUniform({
                previousProjectionMatrix: this.previouseProjectionMatrix
            }), e.mergeUniform(Gi.merge([
                be.fog,
                be.lights
            ])), e.addParsCode([
                "varying vec3 vViewPosition;",
                "varying vec3 vWPosition;",
                "#include <fog_pars_vertex>",
                "#include <normal_pars_vertex>",
                "#include <shadowmap_pars_vertex>",
                "#include <clipping_planes_pars_vertex>"
            ].join(`
`));
            let s = [
                "#include <beginnormal_vertex>",
                `
				#ifndef USE_LAYER_DISPLACE
					#include <defaultnormal_vertex>
				#endif


				vec3 displaced_position = position;
				vec3 displaced_normal = normal;

				#ifdef USE_LAYER_DISPLACE
					vec3 transformed;
					vec3 transformedNormal;
				#endif
				`,
                "#include <normal_vertex>",
                `
				#ifndef USE_LAYER_DISPLACE
					#include <begin_vertex>
				#endif
				`
            ];
            i && s.push(i.code, i.result ? "displaced_position = " + i.result + ";" : ""), s.push("transformed = displaced_position;", "transformedNormal = normalMatrix * displaced_normal;", "#ifndef FLAT_SHADED", "    vNormal = transformedNormal;", "#endif"), s.push("	#include <project_vertex>", "	#include <clipping_planes_vertex>", "	vViewPosition = - mvPosition.xyz;", "	#include <worldpos_vertex>", "	#include <shadowmap_vertex>", "	#include <fog_vertex>"), s.push("vWPosition = ( modelMatrix * vec4( transformed, 1.0 ) ).xyz;"), n = s.join(`
`);
        } else {
            e.mergeUniform({
                penumbraSize: Fe.penumbraSize
            }), e.mergeUniform({
                frameIndex: Fe.frameIndex
            }), e.mergeUniform({
                aoMap: Fe.aoRenderTarget
            }), e.mergeUniform({
                aoEnabled: Fe.aoEnabled
            }), this.color === void 0 && (this.color = new It(5526619)), this.color.analyze(e, {
                slot: "color"
            }), this.specular.analyze(e), this.shininess.analyze(e);
            let i = this.occlusion.flow(e, "b", {
                slot: "occlusion"
            });
            this.shadingAlpha.analyze(e), this.shadingBlend.analyze(e), this.afterColor && this.afterColor.analyze(e, {
                slot: "afterColor"
            }), this.alpha && this.alpha.analyze(e);
            let s = this.color.flow(e, "c", {
                slot: "color"
            }), o = this.specular.flow(e, "c"), a = this.shininess.flow(e, "f"), l = this.shadingAlpha.flow(e, "f"), u = this.shadingBlend.flow(e, "i"), c = this.afterColor ? this.afterColor.flow(e, "c", {
                slot: "afterColor"
            }) : void 0, d = this.alpha ? this.alpha.flow(e, "f") : void 0;
            e.requires.transparent = d !== void 0, e.addParsCode([
                "varying vec3 vWPosition;",
                "uniform vec3 emissive;",
                `uniform float penumbraSize[${5}];`,
                "uniform sampler2D aoMap;",
                "uniform bool aoEnabled;",
                "#include <normal_pars_fragment>",
                "#include <fog_pars_fragment>",
                "#include <bsdfs>",
                "#include <lights_pars_begin>",
                "#include <lights_phong_pars_fragment>",
                "#include <shadowmap_pars_fragment>",
                "#include <dithering_pars_fragment>"
            ].join(`
`));
            let h = [
                "#include <normal_fragment_begin>",
                `
				// NOTE: gl_FrontFacing alternative using face normal estimation.
				vec3 viewdx = dFdx(vViewPosition);
				vec3 viewdy = dFdy(vViewPosition);
				vec3 faceNormal = normalize(cross(viewdx,viewdy));
				if (dot(normal, faceNormal) < 0.0) {
					normal *= -1.0;
				}
				`,
                "	BlinnPhongMaterial material;"
            ];
            h.push(s.code, "	vec3 diffuseColor = " + s.result + ";", "	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );", "	vec3 totalEmissiveRadiance = emissive;", o.code, "	vec3 specular = " + o.result + ";", a.code, "	float shininess = max( 0.0001, " + a.result + " );", "	float specularStrength = 1.0;"), d && h.push(d.code, "#ifdef ALPHATEST", "if ( " + d.result + " <= ALPHATEST ) discard;", "#endif"), h.push("material.diffuseColor = diffuseColor;"), h.push("material.specularColor = specular;", "material.specularShininess = shininess;", "material.specularStrength = specularStrength;", "#include <lights_fragment_begin>", "#include <lights_fragment_end>"), h.push("vec3 ao = aoEnabled && " + i.result + " ? tex2D(aoMap, gl_FragCoord.xy / resolution).rgb : vec3(1.0);", "vec3 outgoingLight = ((reflectedLight.directDiffuse + reflectedLight.indirectDiffuse)) + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;");
            let f = "1.0";
            this.mask && (this.mask.analyze(e), f = `luminance(${this.mask.flow(e, "v3").result})`), h.push(`
				if (outgoingLight != diffuseColor) {
					float lightAccu = clamp( length( reflectedLight.directSpecular + reflectedLight.indirectSpecular ), 0.0, 1.0 );
					accumAlpha += ( 1.0 - accumAlpha ) * ${l.result} * ${f} * lightAccu;
					outgoingLight = spe_blend( diffuseColor, outgoingLight, ${l.result} * ${f}, ${u.result} );
					
					outgoingLight *= ao;
				}
				`), c && h.push(c.code, `outgoingLight = spe_blend(outgoingLight, ${c.result}, 1.0, SPE_BLENDING_NORMAL);`), d ? h.push(`gl_FragColor = vec4( outgoingLight, accumAlpha * ${d.result} );`) : h.push("gl_FragColor = vec4( outgoingLight, 1.0 );"), h.push("#include <encodings_fragment>", "#include <fog_fragment>", "#include <dithering_fragment>"), n = h.join(`
`);
        }
        return n;
    }
};
var Mf = class extends ar {
    constructor(){
        super("standard");
        this.nodeType = "Standard";
        this.color = new It(5526619), this.roughness = new _e(.3), this.metalness = new _e(0), this.reflectivity = new _e(.5), this.previousModelViewMatrix = new vr, this.previouseProjectionMatrix = new vr, this.shadingAlpha = new _e(1), this.shadingBlend = new dt(0), this.occlusion = new fn(!0);
    }
    get category() {
        return "physical";
    }
    build(e) {
        let n;
        if (e.define("STANDARD"), e.requires.lights = !0, e.extensions.derivatives = !0, e.extensions.shaderTextureLOD = !0, e.isShader("vertex")) {
            let i = this.position ? this.position.analyzeAndFlow(e, "v3", {
                cache: "position"
            }) : void 0;
            e.mergeUniform({
                frameIndex: Fe.frameIndex
            }), e.mergeUniform({
                resolution: Fe.resolution
            }), e.mergeUniform({
                previousModelViewMatrix: this.previousModelViewMatrix
            }), e.mergeUniform({
                previousProjectionMatrix: this.previouseProjectionMatrix
            }), e.mergeUniform(Gi.merge([
                be.fog,
                be.lights
            ])), be.LTC_1 && (e.uniforms.ltc_1 = {
                value: void 0
            }, e.uniforms.ltc_2 = {
                value: void 0
            }), e.addParsCode([
                "varying vec3 vViewPosition;",
                "varying vec3 vWPosition;",
                "#include <fog_pars_vertex>",
                "#include <normal_pars_vertex>",
                "#include <shadowmap_pars_vertex>",
                "#include <clipping_planes_pars_vertex>"
            ].join(`
`));
            let s = [
                "#include <beginnormal_vertex>",
                `
				#if !defined( USE_LAYER_DISPLACE )
					#include <defaultnormal_vertex>
				#endif

				vec3 displaced_position = position;
				vec3 displaced_normal = normal;

				#if defined( USE_LAYER_DISPLACE )
					vec3 transformed;
					vec3 transformedNormal;
				#endif
				`,
                "#include <normal_vertex>",
                `
				#if !defined( USE_LAYER_DISPLACE )
					#include <begin_vertex>
				#endif /* !USE_LAYER_DISPLACE */
				`
            ];
            i && s.push(i.code, i.result ? "displaced_position = " + i.result + ";" : ""), s.push("transformed = displaced_position;", "transformedNormal = normalMatrix * displaced_normal;", "#ifndef FLAT_SHADED", "    vNormal = transformedNormal;", "#endif"), s.push("#include <project_vertex>", "#include <fog_vertex>", "#include <clipping_planes_vertex>", "	vViewPosition = - mvPosition.xyz;", "#include <worldpos_vertex>", "#include <shadowmap_vertex>"), s.push("vWPosition = ( modelMatrix * vec4( transformed, 1.0 ) ).xyz;"), n = s.join(`
`);
        } else {
            e.mergeUniform({
                penumbraSize: Fe.penumbraSize
            }), e.mergeUniform({
                frameIndex: Fe.frameIndex
            }), e.mergeUniform({
                aoMap: Fe.aoRenderTarget
            }), e.mergeUniform({
                aoEnabled: Fe.aoEnabled
            });
            let i = {
                gamma: !0
            };
            this.color === void 0 && (this.color = new It(5526619)), this.color.analyze(e, {
                slot: "color",
                context: i
            }), this.roughness.analyze(e), this.metalness.analyze(e);
            let s = this.occlusion.flow(e, "b", {
                slot: "occlusion"
            });
            this.shadingAlpha.analyze(e), this.shadingBlend.analyze(e), this.afterColor && this.afterColor.analyze(e, {
                slot: "afterColor"
            }), this.alpha && this.alpha.analyze(e), this.reflectivity && this.reflectivity.analyze(e);
            let o = this.color.flow(e, "c", {
                slot: "color",
                context: i
            }), a = this.roughness.flow(e, "f"), l = this.metalness.flow(e, "f"), u = this.shadingAlpha.flow(e, "f"), c = this.shadingBlend.flow(e, "i"), d = this.afterColor ? this.afterColor.flow(e, "c", {
                slot: "afterColor"
            }) : void 0, h = this.alpha ? this.alpha.flow(e, "f") : void 0, f = this.reflectivity ? this.reflectivity.flow(e, "f") : void 0;
            e.requires.transparent = h !== void 0, e.addParsCode([
                "varying vec3 vViewPosition;",
                "varying vec3 vWPosition;",
                `uniform float penumbraSize[${5}];`,
                "uniform sampler2D aoMap;",
                "uniform bool aoEnabled;",
                "#include <normal_pars_fragment>",
                "#include <dithering_pars_fragment>",
                "#include <fog_pars_fragment>",
                "#include <bsdfs>",
                "#include <lights_pars_begin>",
                "#include <lights_physical_pars_fragment>",
                "#include <shadowmap_pars_fragment>"
            ].join(`
`));
            let m = [
                "#include <clipping_planes_fragment>",
                "	#include <normal_fragment_begin>",
                `
				// NOTE: gl_FrontFacing alternative using face normal estimation.
				vec3 viewdx = dFdx(vViewPosition);
				vec3 viewdy = dFdy(vViewPosition);
				vec3 faceNormal = normalize(cross(viewdx,viewdy));
				if (dot(normal, faceNormal) < 0.0) {
					normal *= -1.0;
				}
				`,
                "	PhysicalMaterial material;",
                "	material.diffuseColor = vec3( 1.0 );"
            ];
            m.push(o.code, "	vec3 diffuseColor = " + o.result + ";", "	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );", a.code, "	float roughnessFactor = " + a.result + ";", l.code, "	float metalnessFactor = " + l.result + ";"), h && m.push(h.code, "#ifdef ALPHATEST", "	if ( " + h.result + " <= ALPHATEST ) discard;", "#endif"), m.push("vec3 dxy = max( abs( dFdx( geometryNormal ) ), abs( dFdy( geometryNormal ) ) );", "float geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );"), m.push("material.diffuseColor = diffuseColor * ( 1.0 - metalnessFactor );", "material.roughness = max( roughnessFactor, 0.0525 );", "material.roughness += geometryRoughness;", "material.roughness = min( material.roughness, 1.0 );", "material.roughness = clamp( roughnessFactor, 0.04, 1.0 );"), f ? m.push(f.code, "material.specularColor = mix( vec3( 0.16 * pow2( " + f.result + " ) ), diffuseColor, metalnessFactor );") : m.push("material.specularColor = mix( vec3( 0.04 ), diffuseColor, metalnessFactor );"), m.push("#include <lights_fragment_begin>"), m.push("#include <lights_fragment_end>"), m.push("vec3 ao = aoEnabled && " + s.result + " ? tex2D(aoMap, gl_FragCoord.xy / resolution).rgb : vec3(1.0);", "vec3 outgoingLight = ((reflectedLight.directDiffuse + reflectedLight.indirectDiffuse)) + reflectedLight.directSpecular + reflectedLight.indirectSpecular;");
            let p = "1.0";
            this.mask && (this.mask.analyze(e), p = `luminance(${this.mask.flow(e, "v3").result})`), m.push(`
				if (outgoingLight != diffuseColor) {
					float lightAccu = clamp( length( reflectedLight.directSpecular + reflectedLight.indirectSpecular ), 0.0, 1.0 );
					accumAlpha += ( 1.0 - accumAlpha ) * ${u.result} * ${p} * lightAccu;
					outgoingLight = spe_blend( diffuseColor, outgoingLight, ${u.result} * ${p}, ${c.result} );
					
					outgoingLight *= ao;
				}
				`), d && m.push(d.code, `outgoingLight = spe_blend(outgoingLight, ${d.result}, 1.0, SPE_BLENDING_NORMAL);`), h ? m.push(`gl_FragColor = vec4( outgoingLight, accumAlpha * ${h.result} );`) : m.push("gl_FragColor = vec4( outgoingLight, 1.0 );"), m.push("#include <encodings_fragment>", "#include <fog_fragment>", "#include <dithering_fragment>"), n = m.join(`
`);
        }
        return n;
    }
};
var Tf = class extends ar {
    constructor(){
        super("toon");
        this.nodeType = "Toon";
        this.color = new It(5526619), this.specular = new It(1118481), this.shininess = new _e(30), this.previousModelViewMatrix = new vr, this.previouseProjectionMatrix = new vr, this.shadingAlpha = new _e(1), this.shadingBlend = new dt(0);
    }
    get category() {
        return "toon";
    }
    build(e) {
        let n;
        if (e.define("TOON"), e.requires.lights = !0, e.extensions.derivatives = !0, e.isShader("vertex")) {
            let i = this.position ? this.position.analyzeAndFlow(e, "v3", {
                cache: "position"
            }) : void 0;
            e.mergeUniform({
                frameIndex: Fe.frameIndex
            }), e.mergeUniform({
                resolution: Fe.resolution
            }), e.mergeUniform({
                previousModelViewMatrix: this.previousModelViewMatrix
            }), e.mergeUniform({
                previousProjectionMatrix: this.previouseProjectionMatrix
            }), e.mergeUniform(Gi.merge([
                be.fog,
                be.lights
            ])), e.addParsCode([
                "varying vec3 vViewPosition;",
                "varying vec3 vWPosition;",
                "#include <fog_pars_vertex>",
                "#include <normal_pars_vertex>",
                "#include <shadowmap_pars_vertex>",
                "#include <clipping_planes_pars_vertex>"
            ].join(`
`));
            let s = [
                "#include <beginnormal_vertex>",
                `
				#ifndef USE_LAYER_DISPLACE
					#include <defaultnormal_vertex>
				#endif

				vec3 displaced_position = position;
				vec3 displaced_normal = normal;

				#ifdef USE_LAYER_DISPLACE
					vec3 transformed;
					vec3 transformedNormal;
				#endif
				`,
                "#include <normal_vertex>",
                `
				#ifndef USE_LAYER_DISPLACE
					#include <begin_vertex>
				#endif
				`
            ];
            i && s.push(i.code, i.result ? "displaced_position = " + i.result + ";" : ""), s.push("transformed = displaced_position;", "transformedNormal = normalMatrix * displaced_normal;", "#ifndef FLAT_SHADED", "    vNormal = transformedNormal;", "#endif"), s.push("	#include <project_vertex>", "	#include <fog_vertex>", "	#include <clipping_planes_vertex>", "	vViewPosition = - mvPosition.xyz;", "	#include <worldpos_vertex>", "	#include <shadowmap_vertex>", "	#include <fog_vertex>"), s.push("vWPosition = ( modelMatrix * vec4( transformed, 1.0 ) ).xyz;"), n = s.join(`
`);
        } else {
            e.mergeUniform({
                penumbraSize: Fe.penumbraSize
            }), e.mergeUniform({
                frameIndex: Fe.frameIndex
            }), e.mergeUniform({
                aoMap: Fe.aoRenderTarget
            }), e.mergeUniform({
                aoEnabled: Fe.aoEnabled
            }), this.color === void 0 && (this.color = new It(5526619)), this.color.analyze(e, {
                slot: "color"
            }), this.specular.analyze(e), this.shininess.analyze(e), this.shadingAlpha.analyze(e), this.shadingBlend.analyze(e), this.afterColor && this.afterColor.analyze(e, {
                slot: "afterColor"
            }), this.alpha && this.alpha.analyze(e);
            let i = this.color.flow(e, "c", {
                slot: "color"
            }), s = this.specular.flow(e, "c"), o = this.shininess.flow(e, "f"), a = this.shadingAlpha.flow(e, "f"), l = this.shadingBlend.flow(e, "i"), u = this.afterColor ? this.afterColor.flow(e, "c", {
                slot: "afterColor"
            }) : void 0, c = this.alpha ? this.alpha.flow(e, "f") : void 0;
            e.requires.transparent = c !== void 0, e.addParsCode([
                `uniform float penumbraSize[${5}];`,
                "uniform sampler2D aoMap;",
                "uniform bool aoEnabled;",
                "varying vec3 vWPosition;",
                "#include <normal_pars_fragment>",
                "#include <gradientmap_pars_fragment>",
                "#include <fog_pars_fragment>",
                "#include <bsdfs>",
                "#include <lights_pars_begin>",
                "#include <dithering_pars_fragment>",
                `
					varying vec3 vViewPosition;
					struct ToonMaterial {
						vec3	diffuseColor;
						vec3	specularColor;
						float	specularShininess;
						float	specularStrength;
					};
					void RE_Direct_Toon( const in IncidentLight directLight, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {
						vec3 irradiance = getGradientIrradiance( geometry.normal, directLight.direction ) * directLight.color;
			
						reflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
						reflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometry.viewDir, geometry.normal, material.specularColor, material.specularShininess ) * material.specularStrength;
					}
					void RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {
						reflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );
					}
					#define RE_Direct				RE_Direct_Toon
					#define RE_IndirectDiffuse		RE_IndirectDiffuse_Toon
					#define Material_LightProbeLOD( material )	(0)
					`,
                "#include <shadowmap_pars_fragment>",
                "#include <bumpmap_pars_fragment>",
                "#include <normalmap_pars_fragment>"
            ].join(`
`));
            let d = [
                "#include <normal_fragment_begin>",
                `
				// NOTE: gl_FrontFacing alternative using face normal estimation.
				vec3 viewdx = dFdx(vViewPosition);
				vec3 viewdy = dFdy(vViewPosition);
				vec3 faceNormal = normalize(cross(viewdx,viewdy));
				if (dot(normal, faceNormal) < 0.0) {
					normal *= -1.0;
				}
				`,
                "	ToonMaterial material;"
            ];
            d.push(i.code, "	vec3 diffuseColor = " + i.result + ";", "	ReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );", s.code, "	vec3 specular = " + s.result + ";", o.code, "	float shininess = max( 0.0001, " + o.result + " );", "	float specularStrength = 1.0;"), c && d.push(c.code, "#ifdef ALPHATEST", "if ( " + c.result + " <= ALPHATEST ) discard;", "#endif"), d.push("material.diffuseColor = diffuseColor;"), d.push("material.specularColor = specular;", "material.specularShininess = shininess;", "material.specularStrength = specularStrength;", "#include <lights_fragment_begin>", "#include <lights_fragment_end>"), d.push("vec3 ao = aoEnabled ? tex2D(aoMap, gl_FragCoord.xy / resolution).rgb : vec3(1.0);", "vec3 outgoingLight = ((reflectedLight.directDiffuse + reflectedLight.indirectDiffuse) * ao) + reflectedLight.directSpecular;");
            let h = "1.0";
            this.mask && (this.mask.analyze(e), h = `luminance(${this.mask.flow(e, "v3").result})`), d.push(`
				if (outgoingLight != diffuseColor) {
					float lightAccu = clamp( length( reflectedLight.directSpecular + reflectedLight.indirectSpecular ), 0.0, 1.0 );
					accumAlpha += ( 1.0 - accumAlpha ) * ${a.result} * ${h} * lightAccu;
					outgoingLight = spe_blend( diffuseColor, outgoingLight, ${a.result} * ${h}, ${l.result} );
				}
				`), u && d.push(u.code, `outgoingLight = spe_blend(outgoingLight, ${u.result}, 1.0, SPE_BLENDING_NORMAL);`), c ? d.push(`gl_FragColor = vec4( outgoingLight, accumAlpha * ${c.result} );`) : d.push("gl_FragColor = vec4( outgoingLight, 1.0 );"), d.push("#include <encodings_fragment>", "#include <fog_fragment>", "#include <dithering_fragment>"), n = d.join(`
`);
        }
        return n;
    }
};
var ty = class {
    constructor(t = 10000){
        this.timeout = t;
        this.cache = new Map;
        this.head = {
            data: null,
            time: 0,
            src: null,
            next: null,
            prev: null
        };
        this.tail = {
            data: null,
            time: 1 / 0,
            src: null,
            next: null,
            prev: null
        };
        this.hasClean = !1;
        this.head.next = this.tail, this.tail.prev = this.head;
    }
    log(...t) {}
    remove(t) {
        let e = this.cache.get(t);
        e && (this.dispose(t, e.data), this.cache.delete(t), e.prev.next = e.next, e.next.prev = e.prev);
    }
    scheduleCleanup() {
        this.hasClean || (this.log("scheduled cleanup"), this.hasClean = !0, setTimeout(()=>{
            this.hasClean = !1, this.log("cleaning");
            let t = Date.now(), e = this.head.next;
            for(; e.time < t - this.timeout;)this.dispose(e.src, e.data), this.cache.delete(e.src), e = e.next, e.prev = this.head, this.head.next = e;
            this.head.next !== this.tail ? this.scheduleCleanup() : this.log("no more cleanup");
        }, this.timeout + 1e3));
    }
    has(t) {
        return this.cache.get(t)?.data;
    }
    load(t) {
        let e = Date.now(), n = this.cache.get(t);
        return n === void 0 ? (n = {
            data: this.create(t),
            src: t,
            time: e,
            next: null,
            prev: null
        }, this.cache.set(t, n)) : (n.time = e, n.prev.next = n.next, n.next.prev = n.prev), n.prev = this.tail.prev, n.next = this.tail, this.tail.prev.next = n, this.tail.prev = n, this.scheduleCleanup(), n.data;
    }
};
var fw = class extends ty {
    create(t) {
        return URL.createObjectURL(new Blob([
            t
        ]));
    }
    dispose(t, e) {
        URL.revokeObjectURL(e);
    }
}, hw;
function _P(r1) {
    return typeof r1 == "string" ? r1 : (hw || (hw = new fw), hw.load(r1));
}
var ny = class {
    constructor(t, e){
        this.data = t;
        this.cache = e;
        this.refCount = 0;
    }
    deref() {
        this.refCount;
        this.refCount -= 1, this.refCount === 0 && (this.cache.remove(this), this.dispose());
    }
    dispose() {
        this.refCount;
    }
}, ry = class {
    constructor(){
        this.cache = new Map;
    }
    remove(t) {
        this.cache.delete(t.data);
    }
    load(t) {
        let e = this.cache.get(t);
        return e === void 0 && (e = this.create(t), this.cache.set(t, e)), e.refCount += 1, e;
    }
};
var md = class extends ny {
    constructor(e, n){
        super(e, n.imageHolderCache);
        this.data = e;
        this.shared = n;
        this.loaded = !1;
        this.isVideo = !1;
        this.isVideo = e.type === "video", this.updateSrc(e.data);
    }
    async updateSrc(e) {
        if (typeof document > "u") return;
        this.disposeTextures(), this.loaded = !1;
        let n = ()=>{
            this.loaded = !0;
            let s = [
                1e3,
                1001,
                1002
            ];
            for (let o of s){
                let a = this[o];
                a && (a.image = this.img, a.needsUpdate = !0);
            }
            this.shared.requestRender();
        };
        if (this.isVideo) {
            if (this.img = document.createElement("video"), this.img.preload = "auto", this.img.playsInline = !0, this.img.currentTime = .01, typeof e != "string") {
                var i = new FileReader;
                i.readAsDataURL(new Blob([
                    e
                ], {
                    type: "video/mp4"
                }));
                let s;
                await new Promise((o)=>{
                    i.onloadend = (a)=>{
                        s = a.target?.result, o(null);
                    };
                }), this.img.src = s;
            } else this.img.src = e;
            this.img.onloadeddata = ()=>{
                n();
            };
        } else this.img = new Image, this.img.src = _P(e), this.img.onload = n;
    }
    getTexture(e) {
        let n = this[e];
        if (n) return n;
        {
            let i;
            return this.isVideo ? i = new qp(this.img, void 0, e, e) : i = new Vt(this.img, void 0, e, e), this.loaded && (i.needsUpdate = !0), this[e] = i, i;
        }
    }
    disposeTextures() {
        this[1e3]?.dispose(), this[1e3] = void 0, this[1001]?.dispose(), this[1001] = void 0, this[1002]?.dispose(), this[1002] = void 0;
    }
    dispose() {
        super.dispose(), this.disposeTextures();
    }
};
var _i = class extends md {
};
function dr(r1, t) {
    return t.color(r1);
}
function MP(r1, t) {
    switch(r1.type){
        case "fresnel":
            return mW(r1, t);
        case "gradient":
            return gW(r1);
        case "depth":
            return yW(r1);
        case "normal":
            return vW(r1);
        case "noise":
            return xW(r1, t);
        case "rainbow":
            return bW(r1);
        case "toon":
            return wW(r1, t);
        case "outline":
            return SW(r1, t);
        case "transmission":
            return AW(r1, t);
        case "color":
            return pW(r1, t);
        case "pattern":
            return _W(r1, t);
    }
}
function fW(r1) {
    return {
        type: r1.type
    };
}
function ns(r1) {
    let { alpha: t , mode: e , isMask: n  } = r1;
    return {
        ...fW(r1),
        alpha: t,
        mode: e,
        isMask: n
    };
}
function pW(r1, t) {
    return {
        ...ns(r1),
        color: dr(r1.color, t)
    };
}
function mW(r1, t) {
    let { bias: e , scale: n , intensity: i , factor: s , color: o , isMask: a  } = r1;
    return {
        ...ns(r1),
        color: dr(o, t),
        bias: e,
        scale: n,
        intensity: i,
        factor: s
    };
}
function gW(r1) {
    let { gradientType: t , smooth: e , colors: n , steps: i , angle: s , offset: o , morph: a  } = r1;
    return {
        ...ns(r1),
        gradientType: t,
        smooth: e,
        colors: n.map((l)=>new Ze(l[0], l[1], l[2], l[3])),
        num: n.length,
        steps: i,
        offset: new F(...o),
        morph: new F(...a),
        angle: s
    };
}
function yW(r1) {
    let { gradientType: t , near: e , far: n , isVector: i , isWorldSpace: s , origin: o , direction: a , colors: l , steps: u , smooth: c  } = r1;
    return {
        ...ns(r1),
        gradientType: t,
        near: e,
        far: n,
        isVector: i,
        isWorldSpace: s,
        origin: new A(...o),
        direction: a ? new A(...a) : new A(1, 0, 0),
        colors: l.map((d)=>d !== void 0 ? new Ze(d[0], d[1], d[2], d[3]) : new Ze(0, 0, 0, 0)),
        steps: u.slice(0, l.length),
        smooth: c
    };
}
function vW(r1) {
    let { cnormal: t  } = r1;
    return {
        ...ns(r1),
        cnormal: new A(t[0], t[1], t[2])
    };
}
function xW(r1, t) {
    return {
        ...ns(r1),
        scale: r1.scale,
        move: r1.move,
        fA: new F(...r1.fA),
        fB: new F(...r1.fB),
        size: new A(...r1.size),
        distortion: new F(...r1.distortion),
        colorA: dr(r1.colorA, t),
        colorB: dr(r1.colorB, t),
        colorC: dr(r1.colorC, t),
        colorD: dr(r1.colorD, t),
        noiseType: r1.noiseType,
        voronoiStyle: r1.voronoiStyle,
        highCut: r1.highCut,
        lowCut: r1.lowCut,
        smoothness: r1.smoothness,
        seed: r1.seed,
        quality: r1.quality
    };
}
function bW(r1) {
    return {
        ...ns(r1),
        filmThickness: r1.filmThickness,
        movement: r1.movement,
        wavelengths: new A(...r1.wavelengths),
        noiseStrength: r1.noiseStrength,
        noiseScale: r1.noiseScale,
        offset: new A(...r1.offset)
    };
}
function wW(r1, t) {
    return {
        ...ns(r1),
        positioning: r1.positioning,
        colors: r1.colors.map((e)=>new Ze(e[0], e[1], e[2], e[3])),
        num: r1.colors.length,
        steps: r1.steps,
        source: new A(...r1.source),
        isWorldSpace: r1.isWorldSpace,
        noiseStrength: r1.noiseStrength,
        noiseScale: r1.noiseScale,
        shadowColor: dr(r1.shadowColor, t),
        offset: new A(...r1.offset)
    };
}
function SW(r1, t) {
    return {
        ...ns(r1),
        outlineColor: dr(r1.outlineColor, t),
        contourColor: dr(r1.contourColor, t),
        outlineWidth: r1.outlineWidth,
        contourWidth: r1.contourWidth,
        outlineThreshold: r1.outlineThreshold,
        contourThreshold: r1.contourThreshold,
        outlineSmoothing: r1.outlineSmoothing,
        contourFrequency: r1.contourFrequency,
        contourDirection: new A(...r1.contourDirection),
        positionalLines: r1.positionalLines,
        compensation: r1.compensation
    };
}
function AW(r1, t) {
    return {
        ...ns(r1),
        thickness: r1.thickness,
        ior: r1.ior,
        roughness: r1.roughness
    };
}
function _W(r1, t) {
    return {
        ...ns(r1),
        style: r1.style,
        projection: r1.projection,
        axis: r1.axis,
        blending: r1.blending,
        offset: new F(...r1.offset),
        colorA: dr(r1.colorA, t),
        colorB: dr(r1.colorB, t),
        frequency: new F(...r1.frequency),
        size: r1.size,
        variation: r1.variation,
        smoothness: r1.smoothness,
        zigzag: r1.zigzag,
        rotation: r1.rotation,
        vertical: new F(...r1.vertical),
        horizontal: new F(...r1.horizontal),
        sides: r1.sides
    };
}
var va = class extends $t {
};
var pw = {
    noise: [
        "noiseType"
    ],
    texture: [
        "projection",
        "axis",
        "side"
    ],
    video: [
        "projection",
        "axis",
        "side"
    ],
    displace: [
        "noiseType"
    ],
    depth: [
        "smooth",
        "isWorldSpace",
        "gradientType",
        "isVector"
    ],
    pattern: [
        "style",
        "projection",
        "axis"
    ]
}, mw = {
    depth: [
        "colors"
    ]
};
function MW(r1, t, e) {
    if (t === "isMask") return !0;
    let n = pw[r1.type], i = mw[r1.type];
    if (i !== void 0) {
        let s = r1.color;
        if (i.includes(t)) {
            let o = s[t]?.value?.length;
            if (o !== void 0 && o !== e.length) return !0;
        }
    }
    return n !== void 0 ? n.includes(t) : !1;
}
function gw(r1, t, e) {
    let n = e.uniforms[`f${e.id}_texture`];
    if (!n) return !1;
    let i = !1, s = r1;
    if ("image" in s) {
        let o = s.image, a = t.image(o), l = n;
        l.image instanceof _i || l.image.deref(), l.image = a;
    }
    if ("video" in s) {
        let o = s.video, a = t.video(o), l = n;
        l.image instanceof _i || l.image.deref(), l.image = a;
    }
    if ("wrapping" in s) {
        let o = n;
        o.wrap = s.wrapping;
    }
    if ("repeat" in s || "offset" in s) {
        let o = "mat", a = e.uniforms[`f${e.id}_${o}`];
        "repeat" in s && (a.repeat = s.repeat), "offset" in s && (a.offset = s.offset), a.updateMatrix();
    }
    return i;
}
function TP(r1, t, e, n) {
    let i = !1;
    for (let [s, o] of Object.entries(r1)){
        if (!s || o === void 0) continue;
        if (yw(s, e, n)) {
            s === "visible" && e.type === "light" && (i = !0);
            continue;
        }
        e.visible = n.visible;
        let a = e.uniforms[`f${e.id}_${s}`];
        if (!!a && !(a instanceof ya)) switch(i = i || MW(e, s, o), a.constructor){
            case It:
                if (typeof o == "string") {
                    let l = t.getColor(o);
                    l && (a.value = l);
                    break;
                } else {
                    let l = o;
                    a.value instanceof va ? a.value = new $t(l.r, l.g, l.b, l.a) : a.setRGBA(l);
                    break;
                }
            case Yr:
                if (typeof o == "string") {
                    let l = t.getColor(o);
                    l && (a.value = l);
                    break;
                } else {
                    let l = o;
                    a.value instanceof va ? a.value = new $t(l.r, l.g, l.b, l.a) : a.value.setRGBA(l.r, l.g, l.b, l.a);
                    break;
                }
            case hn:
                {
                    let l = o;
                    a.value.setX(l[0]), a.value.setY(l[1]);
                    break;
                }
            case yr:
                {
                    let l = o;
                    a.value.setX(l[0]), a.value.setY(l[1]), a.value.setZ(l[2]);
                    break;
                }
            case kr:
                gw(o, t, e);
                break;
            case ts:
                a.value = o.map((l)=>new Ze(...l));
                break;
            default:
                a.value = o;
                break;
        }
    }
    return i;
}
var Os = class {
    constructor(t, e, n, i){
        this.id = t;
        this.uuid = e;
        this.data = n;
        this.uniforms = {};
        for(let s in i)this.uniforms[`f${this.id}_${s}`] = i[s];
        for(let s in n)yw(s, this, n);
    }
    get type() {
        return this.data.type;
    }
    static create(t, e, n, i) {
        if (n.type === "light") return Ti.createLigherLayer(t, e, n, i);
        if (n.type === "texture" || n.type === "video") {
            let s = n.type === "texture" ? i.image(n.texture.image) : i.video(n.texture.video), o = new Tl(s, n.texture.wrapping), a = new $g(s), l = new ey(n.texture.repeat, n.texture.offset), u = new _e(n.crop ? 1 : 0), c = new dt(n.projection ?? 0), d = new dt([
                "x",
                "y",
                "z"
            ].indexOf(n.axis) ?? 0), h = new dt(n.side ?? 0), f = new hn(n.size ? new F(n.size[0], n.size[1]) : new F(100, 100)), m = new _e(n.blending ?? 0), p = new _e(n.alpha ?? 1), g = new dt(n.mode ?? 0), y = new fn(n.isMask ?? !1), v = new rd(o, a, u, c, d, h, f, m, l, p, g, y), x = new Et(v.calpha, "f");
            return new en(t, e, n, {
                texture: o,
                textureSize: a,
                crop: u,
                projection: c,
                axis: d,
                side: h,
                size: f,
                blending: m,
                mat: l,
                alpha: p,
                mode: g,
                isMask: y
            }, v, g, x, y);
        } else if (n.type === "matcap") {
            let s = i.image(n.texture.image), o = new Tl(s, n.texture.wrapping), a = new _e(n.alpha ?? 1), l = new dt(n.mode ?? 0), u = new fn(n.isMask ?? !1), c = new ad(o, a, l, u), d = new Et(c.calpha, "f");
            return new en(t, e, n, {
                texture: o,
                alpha: a,
                mode: l,
                isMask: u
            }, c, l, d, u);
        } else if (n.type === "displace") {
            if (n.displacementType === "noise") {
                let s = new yr(new A(...n.offset)), o = new _e(n.scale ?? 10), a = new _e(n.intensity ?? 8), l = new _e(n.movement ?? 1), u = new dt(n.noiseType ?? 0), c = new dt(n.voronoiStyle ?? 0), d = new _e(n.smoothness ?? .5), h = new _e(n.seed ?? 0), f = new _e(n.highCut ?? 1), m = new _e(n.lowCut ?? 0), p = new dt(n.quality ?? 1), g = new pd(a, l, s, c, d, h, f, m, p, o, u);
                return new Ef(t, e, n, {
                    offset: s,
                    scale: o,
                    intensity: a,
                    movement: l,
                    noiseType: u,
                    voronoiStyle: c,
                    smoothness: d,
                    seed: h,
                    highCut: f,
                    lowCut: m,
                    quality: p
                }, g);
            } else throw new Error;
        } else return CW(t, e, n, i);
    }
    updateByOp(t, e, n) {
        let i = t;
        if (i.path[0] === void 0) {
            if (i.type === 0) return "type" in i.props || "category" in i.props || "visible" in i.props ? (n.scene?.markNeedsUpdateRendererDirty(), !0) : TP(i.props, n.shared, this, e);
        } else if (i.path[0] === "texture") return "texture" in e || "video" in e ? gw(i.props, n.shared, this) : !0;
        return !1;
    }
    dispose() {
        if (TW(this)) {
            let t = this.uniforms[`f${this.id}_texture`];
            if (!t) return !1;
            let e = t;
            e.image instanceof _i || e.image.deref();
        }
    }
    hasValueByKey(t) {
        return this.uniforms[t] !== void 0;
    }
    hasValue(t) {
        return this.hasValueByKey(`f${this.id}_${t}`);
    }
    setValue(t, e) {
        let n = `f${this.id}_${t}`;
        this.hasValueByKey(n) && e !== void 0 && (this.uniforms[n].value = e);
    }
    getNode(t) {
        let e = `f${this.id}_${t}`;
        if (this.hasValueByKey(e)) return this.uniforms[e];
    }
    getValue(t) {
        let e = `f${this.id}_${t}`;
        if (this.hasValueByKey(e)) return this.uniforms[e].value;
    }
    getName(t) {
        let n = /f\d+_(.*)/.exec(t);
        if (n && n.length > 1) return n[1];
        console.log(`Layer.getName: error ${t}`);
    }
    getNames() {
        let t = [];
        for(let e in this.uniforms){
            let n = this.getName(e);
            n && t.push(n);
        }
        return t;
    }
}, en = class extends Os {
    constructor(e, n, i, s, o, a, l, u){
        super(e, n, i, s);
        this.params = s;
        this.color = o;
        this.mode = a;
        this.alpha = l;
        this.isMask = u;
    }
}, Ef = class extends Os {
    constructor(e, n, i, s, o){
        super(e, n, i, s);
        this.position = o;
    }
}, Ti = class extends Os {
    constructor(e, n, i, s, o){
        super(e, n, i, o);
        this.node = s;
    }
    static createLigherLayer(e, n, i, s) {
        let o, a = new _e(i.alpha), l = new dt(i.mode), u;
        if (!i.visible) o = new Cl, u = {};
        else if (i.category === "lambert") {
            o = new Af;
            let c = new It(s.color(i.emissive) ?? 0), d = new fn(i.occlusion ?? !0);
            u = {
                emissive: c,
                occlusion: d
            }, o.emissive = c, o.occlusion = d;
        } else if (i.category === "toon") {
            o = new Tf;
            let c = new _e(i.shininess ?? 30), d = new It(s.color(i.specular) ?? 1118481);
            u = {
                shininess: c,
                specular: d
            }, o.shininess = c, o.specular = d;
        } else if (i.category === "physical") {
            o = new Mf;
            let c = new _e(i.roughness ?? .3), d = new _e(i.metalness ?? 0), h = new _e(i.reflectivity ?? .5), f = new fn(i.occlusion ?? !0);
            u = {
                roughness: c,
                metalness: d,
                reflectivity: h,
                occlusion: f
            }, o.roughness = c, o.metalness = d, o.reflectivity = h, o.occlusion = f;
        } else {
            o = new _f;
            let c = new _e(i.shininess ?? 30), d = new It(i.specular !== void 0 ? s.color(i.specular) ?? 1118481 : 1118481), h = new fn(i.occlusion ?? !0);
            u = {
                shininess: c,
                specular: d,
                occlusion: h
            }, o.shininess = c, o.specular = d, o.occlusion = h;
        }
        return o.alpha = new _e(1), o.shadingAlpha = a, o.shadingBlend = l, u.alpha = o.shadingAlpha, u.mode = o.shadingBlend, new Ti(e, n, i, o, u);
    }
    get category() {
        return this.node.category;
    }
};
function TW(r1) {
    let t = r1 instanceof Os ? r1.type : r1;
    return t === "texture" || t === "video" || t === "displace_map" || t === "matcap";
}
function Mi(r1) {
    return {
        alpha: new _e(r1.alpha ?? 1),
        mode: new dt(r1.mode ?? 0),
        isMask: new fn(r1.isMask ?? !1)
    };
}
function EW(r1, t, e, n) {
    switch(r1.type){
        case "color":
            {
                let i = new It(n.color ?? 5526619), s = Mi(n), o = new El(i, s.alpha), a = new Et(o.calpha, "f");
                return new en(t, e, r1, {
                    color: i,
                    ...s
                }, o, s.mode, a, s.isMask);
            }
        case "fresnel":
            {
                let i = new It(n.color ?? 16777215), s = new _e(n.bias ?? .1), o = new _e(n.scale ?? 1), a = new _e(n.intensity ?? 2), l = new _e(n.factor ?? 1), u = Mi(n), c = new wf(i, s, o, a, l, u.alpha, u.mode, u.isMask), d = new Et(c.calpha, "f");
                return new en(t, e, r1, {
                    color: i,
                    bias: s,
                    scale: o,
                    intensity: a,
                    factor: l,
                    ...u
                }, c, u.mode, d, u.isMask);
            }
        case "rainbow":
            {
                let i = new _e(n.filmThickness ?? 30), s = new _e(n.movement ?? 0), o = new yr(n.wavelengths ?? new A(0, 0, 0)), a = new _e(n.noiseStrength ?? 0), l = new _e(n.noiseScale ?? 1), u = new yr(n.offset ?? new A(0, 0, 0)), c = Mi(n), d = new dd(i, s, o, a, l, u, c.alpha, c.isMask), h = new Et(d.calpha, "f");
                return new en(t, e, r1, {
                    filmThickness: i,
                    movement: s,
                    wavelengths: o,
                    noiseStrength: a,
                    noiseScale: l,
                    offset: u,
                    ...c
                }, d, c.mode, h, c.isMask);
            }
        case "transmission":
            {
                let i = new _e(n.thickness ?? 10), s = new _e(n.ior ?? 1.5), o = new _e(n.roughness ?? .5), a = Fe.transmissionSize, l = Fe.transmissionRenderTarget, u = Fe.transmissionRenderTargetDepth, c = window.innerWidth, d = window.innerHeight, h = c >= d ? new hn(d / c, 1) : new hn(1, c / d), f = Mi(n), m = new fd(i, s, o, a, l, u, h, f.alpha), p = new Et(m.calpha, "f");
                return new en(t, e, r1, {
                    thickness: i,
                    ior: s,
                    roughness: o,
                    aspectRatio: h,
                    ...f
                }, m, f.mode, p, f.isMask);
            }
        case "toon":
            {
                let i = new dt(n.positioning ?? 0), s;
                n.colors ? s = new ts(n.colors.length, n.colors) : (s = new ts(10, new Ze(0, 0, 0, 1)), s.value[1] = new Ze(1, 1, 1, 1));
                let o;
                n.steps ? o = new es(n.steps.length, n.steps) : (o = new es(10, 1), o.value[0] = 0);
                let a = new yr(n.source ?? new A(0, 0, 0)), l = new fn(n.isWorldSpace ?? !0), u = new _e(n.noiseStrength ?? 0), c = new _e(n.noiseScale ?? 1), d = new Yr(n.shadowColor), h = new yr(n.offset ?? new A(0, 0, 0)), f = Mi(n), m = new hd(i, s, o, a, l, u, c, d, h, f.alpha), p = new Et(m.calpha, "f");
                return new en(t, e, r1, {
                    positioning: i,
                    colors: s,
                    steps: o,
                    source: a,
                    isWorldSpace: l,
                    noiseStrength: u,
                    noiseScale: c,
                    shadowColor: d,
                    offset: h,
                    ...f
                }, m, f.mode, p, f.isMask);
            }
        case "outline":
            {
                let i = new It(n.outlineColor ?? 16777215), s = new It(n.contourColor ?? 16777215), o = new _e(n.outlineWidth ?? .1), a = new _e(n.contourWidth ?? .1), l = new _e(n.outlineThreshold ?? .1), u = new _e(n.contourThreshold ?? .1), c = new _e(n.outlineSmoothing ?? .1), d = new _e(n.contourFrequency ?? .1), h = new yr(n.contourDirection ?? new A(0, 1, 0)), f = new fn(n.positionalLines ?? !1), m = new fn(n.compensation ?? !0), p = Fe.normalRenderTarget, g = Fe.normalRenderTargetDepth, y = Fe.pixelRatioNode, v = Fe.resolution, x = Mi(n), w = new cd(i, s, o, a, l, u, c, d, h, f, m, v, p, g, y, x.alpha), S = new Et(w.calpha, "f");
                return new en(t, e, r1, {
                    outlineColor: i,
                    contourColor: s,
                    outlineWidth: o,
                    contourWidth: a,
                    outlineThreshold: l,
                    contourThreshold: u,
                    outlineSmoothing: c,
                    contourFrequency: d,
                    contourDirection: h,
                    positionalLines: f,
                    compensation: m,
                    ...x
                }, w, x.mode, S, x.isMask);
            }
        case "depth":
            {
                let i = new dt(n.gradientType ?? 0), s = new fn(n.smooth ?? !1), o = new _e(n.near ?? 50), a = new _e(n.far ?? 200), l = new _e(n.isVector ?? 1), u = new _e(n.isWorldSpace ?? 0), c = new yr(n.origin ?? new A), d = new yr(n.direction ?? new A), h;
                n.colors ? h = new ts(n.colors.length, n.colors) : (h = new ts(2, new Ze(0, 0, 0, 1)), h.value[1] = new Ze(1, 1, 1, 1));
                let f;
                n.steps ? f = new es(n.steps.length, n.steps) : (f = new es(2, 1), f.value[0] = 0);
                let m = Mi(n), p = new sd(i, s, o, a, l, u, c, d, h, f, m.alpha, m.isMask), g = new Et(p.calpha, "f");
                return new en(t, e, r1, {
                    gradientType: i,
                    smooth: s,
                    near: o,
                    far: a,
                    isVector: l,
                    isWorldSpace: u,
                    origin: c,
                    direction: d,
                    colors: h,
                    steps: f,
                    ...m
                }, p, m.mode, g, m.isMask);
            }
        case "noise":
            {
                let i = new _e(n.scale ?? 1), s = new yr(n.size ?? new A(100, 100, 100)), o = new _e(n.move ?? 1), a = new hn(n.fA ?? new F(1.7, 9.2)), l = new hn(n.fB ?? new F(8.3, 2.8)), u = new hn(n.distortion ?? new F(1, 1)), c = new Yr(n.colorA), d = new Yr(n.colorB), h = new Yr(n.colorC), f = new Yr(n.colorD), m = new dt(n.noiseType ?? 0), p = new dt(n.voronoiStyle ?? 0), g = new _e(n.highCut ?? 1), y = new _e(n.lowCut ?? 0), v = new _e(n.smoothness ?? .5), x = new _e(n.seed ?? .5), w = new dt(n.quality ?? 1), S = Mi(n), _ = new ld(i, s, o, a, l, u, c, d, h, f, S.alpha, m, S.isMask, p, g, y, v, x, w), M = new Et(_.calpha, "f");
                return new en(t, e, r1, {
                    scale: i,
                    size: s,
                    move: o,
                    fA: a,
                    fB: l,
                    distortion: u,
                    colorA: c,
                    colorB: d,
                    colorC: h,
                    colorD: f,
                    noiseType: m,
                    ...S,
                    voronoiStyle: p,
                    highCut: g,
                    lowCut: y,
                    smoothness: v,
                    seed: x,
                    quality: w
                }, _, S.mode, M, S.isMask);
            }
        case "normal":
            {
                let i = new yr(n.cnormal ?? new A(1, 1, 1)), s = Mi(n), o = new td(i, s.alpha), a = new Et(o.calpha, "f");
                return new en(t, e, r1, {
                    cnormal: i,
                    ...s
                }, o, s.mode, a, s.isMask);
            }
        case "gradient":
            {
                let i = new dt(n.gradientType ?? 0), s = new fn(n.smooth ?? !1), o;
                n.colors ? o = new ts(n.colors.length, n.colors) : (o = new ts(10, new Ze(0, 0, 0, 1)), o.value[1] = new Ze(1, 1, 1, 1));
                let a;
                n.steps ? a = new es(n.steps.length, n.steps) : (a = new es(10, 1), a.value[0] = 0);
                let l = new hn(n.offset ?? new F(0, 0)), u = new hn(n.morph ?? new F(0, 0)), c = new _e(n.angle ?? 0), d = Mi(n), h = new od(i, s, o, a, l, u, c, d.alpha, d.isMask), f = new Et(h.calpha, "f");
                return new en(t, e, r1, {
                    gradientType: i,
                    smooth: s,
                    colors: o,
                    steps: a,
                    offset: l,
                    morph: u,
                    angle: c,
                    ...d
                }, h, d.mode, f, d.isMask);
            }
        case "pattern":
            {
                let i = new dt(n.style ?? 0), s = new dt(n.projection ?? 0), o = new dt([
                    "x",
                    "y",
                    "z"
                ].indexOf(n.axis) ?? 0), a = new _e(n.blending ?? 0), l = new hn(n.offset ?? new F(0, 0)), u = new Yr(n.colorA), c = new Yr(n.colorB), d = new hn(n.frequency ?? new F(10, 10)), h = new _e(n.size ?? .5), f = new _e(n.variation ?? 0), m = new _e(n.smoothness ?? .5), p = new _e(n.zigzag ?? 0), g = new _e(n.rotation ?? 0), y = new hn(n.vertical ?? new F(0, 1)), v = new hn(n.horizontal ?? new F(0, 1)), x = new dt(n.sides ?? 6), w = Mi(n), S = new ud(i, s, o, a, l, u, c, d, h, f, m, p, g, y, v, x, w.alpha, w.isMask), _ = new Et(S.calpha, "f");
                return new en(t, e, r1, {
                    style: i,
                    projection: s,
                    axis: o,
                    blending: a,
                    offset: l,
                    colorA: u,
                    colorB: c,
                    frequency: d,
                    size: h,
                    variation: f,
                    smoothness: m,
                    zigzag: p,
                    rotation: g,
                    vertical: y,
                    horizontal: v,
                    sides: x,
                    ...w
                }, S, w.mode, _, w.isMask);
            }
        default:
            {
                let i = new It(1, 0, 0, 1), s = Mi(n), o = new El(i, s.alpha), a = new Et(o.calpha, "f");
                return new en(t, e, r1, {
                    color: i,
                    ...s
                }, o, s.mode, a, s.isMask);
            }
    }
}
function CW(r1, t, e, n) {
    let i = MP(e, n);
    return EW(e, r1, t, i);
}
function yw(r1, t, e) {
    if (e.type === "displace" && (r1 === "intensity" || r1 === "visible")) {
        let n = t.uniforms[`f${t.id}_intensity`];
        return n ? (n.value = e.intensity * (e.visible ? 1 : 0), n) : void 0;
    }
    if (e.type !== "displace" && (r1 === "alpha" || r1 === "visible")) {
        let n = t.uniforms[`f${t.id}_alpha`];
        if (!n) return;
        if (n.value = e.alpha * (e.visible ? 1 : 0), e.type === "outline" && r1 === "visible") {
            let i = t.uniforms[`f${t.id}_compensation`];
            i && (i.value = e.compensation && e.visible);
        }
        return n;
    }
}
function Cf(r1, t) {
    let e = 0;
    for (let n of r1.layers){
        if (n.data.type !== "displace" && n.data.isMask) return !0;
        if (n.data.type !== "displace" && "alpha" in n.data && n.data.type !== "light" && n.data.type !== "fresnel" && n.data.type !== "texture" && n.data.type !== "matcap" && n.data.type !== "rainbow" && n.data.type !== "outline" && n.data.type !== "pattern") {
            let i = n.data.visible ? n.data.alpha : 0;
            if (i === 1 && n.data.type === "depth" || n.data.type === "gradient") {
                for (let s of n.data.colors)if (s[3] < 1) {
                    i = s[3];
                    break;
                }
            } else if (i === 1 && n.data.type === "noise") {
                let s = t.color(n.data.colorA).a, o = t.color(n.data.colorB).a, a = t.color(n.data.colorC).a, l = t.color(n.data.colorD).a, u = Math.min(s, Math.min(o, Math.min(a, l)));
                u < 1 && (i = u);
            }
            e += (1 - e) * i;
        }
    }
    return e < 1;
}
var Kr = class extends ot {
    constructor(){
        super(void 0);
        this.flatShading = !1;
        this.needsJitter = !0;
        this.cacheKey = "";
        this.fog = !0, this.dithering = !0, this.vertexColors = !0, this.transparent = !0;
    }
    customProgramCacheKey() {
        return this.cacheKey;
    }
}, iy = class extends Kr {
    constructor(e, n, i, s){
        super();
        this.flatShading = e;
        this.side = n;
        this.wireframe = i;
        this.root = s;
    }
    updateAfterBuild() {
        let e = this.root;
        this.lights = e.lights, this.vertexShader = e.vertexShader, this.fragmentShader = e.fragmentShader, this.defines = e.defines, this.uniforms = e.uniforms, this.extensions = e.extensions, this.transparent = e.transparent, this.cacheKey = e.customProgramCacheKey() + "flat" + this.flatShading + this.side;
    }
    onBeforeCompile(e, n) {
        this.root.onBeforeCompile(e);
    }
    get data() {
        return this.root.data;
    }
    get category() {
        return this.root.category;
    }
    get hasAO() {
        return this.root.hasAO;
    }
    getFlavor(e, n, i) {
        return this.root.getFlavor(e, n, i);
    }
    get layers() {
        return this.root.layers;
    }
    get fragment() {
        return this.root.fragment;
    }
    getLayersOfType(e) {
        return this.root.getLayersOfType(e);
    }
    getLayerByUuid(e) {
        return this.root.getLayerByUuid(e);
    }
    updateByOp(e, n, i) {
        this.root.updateByOp(e, n, i);
    }
    nodeMaterialDispose() {
        this.root.nodeMaterialDispose();
    }
}, Pl = class extends Kr {
    constructor(e, n){
        super();
        this.data = e;
        this.layerIdGen = 0;
        this.flavors = [];
        this.masks = {};
        this.type = "NodeMaterial";
        this.updaters = [], this.reset0(e, n);
    }
    get nodeMaterial() {
        return this;
    }
    getFlavor(e, n, i) {
        let s = i ? 6 : (e ? 3 : 0) + n;
        if (s === 0) return this;
        this.flavors === void 0 && (this.flavors = []), s -= 1;
        let o = this.flavors[s];
        return o === void 0 && (o = new iy(e, n, i, this), this.flavors[s] = o, o.flatShading = e, o.side = n, o.updateAfterBuild()), o;
    }
    get fragment() {
        return this.lightLayer.node;
    }
    get category() {
        return this.lightLayer.category;
    }
    get hasAO() {
        return this.lightLayer.getNode("occlusion")?.value ?? !1;
    }
    reset(e, n) {
        this.data !== e && this.reset0(e, n);
    }
    reset0(e, n) {
        this.data = e;
        let i = e.layers ?? or.defaultTwoLayerData("phong").layers;
        this.layers = i.map((s)=>Os.create(this.layerIdGen++, s.id, s.data, n.shared)), this.layers.reverse(), this.name = e.name ?? "Untitled Material", this.onUpdate(), this.transparent = Cf(e, n.shared);
    }
    getLayersOfType(e) {
        return this.layers.filter((n)=>n.type === e);
    }
    getLayerByUuid(e) {
        return this.layers.find((n)=>n.uuid === e);
    }
    onUpdate() {
        this.cacheKey = this.computeCacheKey(), this.lightLayer = this.layers.find((e)=>e instanceof Ti), this.lightLayer === void 0 && (this.lightLayer = new Ti(0, "", {
            ...Br.defaultData("light", "phong"),
            visible: !1
        }, new Cl, {})), this.dispose();
        for (let e of this.flavors)e && e.dispose();
        this.applyMasks(), this.blendColors(), this.blendAfterColors(), this.blendPositions();
    }
    updateByOp(e, n, i) {
        if (n !== void 0 ? this.data = n : n = this.data, this.transparent = Cf(n, i.shared), e.path[0] === "layers") {
            this.data = n;
            let s = i.shared, o = e.path[1];
            if (o === void 0) {
                if (this.layers.reverse(), e.type === 4) {
                    let a = Os.create(this.layerIdGen++, e.id, e.data, i.shared);
                    this.layers.splice(e.localIndex, 0, a), i.scene?.markNeedsUpdateRendererDirty();
                } else if (e.type === 5) this.layers.splice(e.localIndex, 1)[0].dispose(), i.scene?.markNeedsUpdateRendererDirty();
                else if (e.type === 6) {
                    let a = this.layers.findIndex((u)=>u.uuid === e.id), l = this.layers[a];
                    this.layers.splice(a, 1), this.layers.splice(e.localIndex, 0, l), i.scene?.markNeedsUpdateRendererDirty();
                }
                this.layers.reverse(), this.onUpdate();
            } else {
                e.type === 0 && e.props.occlusion !== void 0 && i.scene?.markNeedsUpdateRendererDirty();
                let a = this.layers.find((l)=>l.uuid === o);
                if (a) {
                    let l = n.layers.data(o);
                    if (a.updateByOp({
                        ...e,
                        path: e.path.slice(2)
                    }, l, i)) {
                        let c = Os.create(this.layerIdGen++, o, l, s);
                        this.layers.splice(this.layers.findIndex((d)=>d.uuid === o), 1, c), this.onUpdate();
                    }
                }
            }
        } else this.reset(n, i);
    }
    applyMasks() {
        for(let e = 0; e < this.layers.length; ++e){
            let n = this.layers[e];
            n instanceof en ? n.color.mask = void 0 : n instanceof Ti && (n.node.mask = void 0);
        }
        for(let e = 0; e < this.layers.length; ++e){
            let n = this.layers[e];
            if (n instanceof en && n.isMask.value && n.data.visible && e > 0) {
                let i = e - 1, s = this.layers[i];
                s instanceof Ti ? s.node.mask = new lr(n.color, n.alpha, lr.MUL) : s instanceof en && (s.isMask.value || (s.color.mask = new lr(n.color, n.alpha, lr.MUL)));
            }
        }
    }
    blendColors() {
        let e = this.layers.findIndex((i)=>i instanceof en), n = this.layers.findIndex((i)=>i instanceof Ti);
        if (e !== -1 && e < n) {
            let i = this.layers[e].color;
            for(let s = e + 1; s < n; ++s){
                let o = this.layers[s];
                if (o instanceof en) {
                    if (o.isMask.value) continue;
                    i = new ed(i, o.color, o.alpha, o.mode);
                }
            }
            this.fragment.color = i;
        } else this.fragment.color = void 0;
    }
    blendAfterColors() {
        let e = new Et("outgoingLight", "f"), n = this.layers.findIndex((i)=>i instanceof Ti);
        if (this.layers.length > n + 1) {
            for(let i = n + 1; i < this.layers.length; ++i){
                let s = this.layers[i];
                if (s instanceof en) {
                    if (s.isMask.value) continue;
                    e = new ed(e, s.color, s.alpha, s.mode);
                }
            }
            this.fragment.afterColor = e;
        } else this.fragment.afterColor = void 0;
    }
    blendPositions() {
        let e = this.layers.filter((n)=>n instanceof Ef);
        if (e.length > 0) {
            let n = e[0].position;
            for(let i = 1; i < e.length; ++i)e[i] && (n = new lr(n, e[i].position, lr.ADD), n = new lr(n, new _e(.5).setReadonly(!0), lr.MUL));
            this.fragment.position = n;
        } else this.fragment.position = void 0;
    }
    getDefines() {
        return this.defines;
    }
    getUniforms() {
        return this.uniforms;
    }
    getVertexShader() {
        return this.vertexShader;
    }
    getFragmentShader() {
        return this.fragmentShader;
    }
    onBeforeCompile(e) {
        this.build(), e.defines = this.defines, e.uniforms = this.uniforms, e.vertexShader = this.vertexShader, e.fragmentShader = this.fragmentShader, e.extensionDerivatives = this.extensions.derivatives === !0, e.extensionFragDepth = this.extensions.fragDepth === !0, e.extensionDrawBuffers = this.extensions.drawBuffers === !0, e.extensionShaderTextureLOD = this.extensions.shaderTextureLOD === !0;
    }
    clampUniformsForPreview(e, n) {
        let i = (s, o, a)=>Math.min(Math.max(s, o), a);
        for (let s of this.layers)if (s.type === "displace") {
            let o = i(s.uniforms[`f${s.id}_intensity`].value, e, n);
            s.uniforms[`f${s.id}_intensity`].value = o;
        }
    }
    computeCacheKey() {
        let e = "[";
        for (let { data: n  } of this.data.layers)if (n.type === "light") e += `"${n.visible ? n.category.toUpperCase() : "Basic"}"`;
        else {
            let i = (pw[n.type] ?? []).map((a)=>n[a]), s = (mw[n.type] ?? []).map((a)=>n[a]?.length ?? 0), o = [
                ...i,
                ...s
            ];
            o.length ? e += `["${n.type}", "${o.join('","')}"],` : e += `"${n.type}",`;
        }
        return e = e.slice(0, -1) + "]", e;
    }
    updateFrame(e) {
        for(let n = 0; n < this.updaters.length; ++n)e.updateNode(this.updaters[n]);
    }
    build() {
        let e = new Jg;
        e.needsJitter = this.needsJitter, this.lights = this.lightLayer.data.visible, e.build(this.fragment, this.fragment), this.vertexShader = e.getCode("vertex"), this.fragmentShader = e.getCode("fragment"), this.defines = e.defines, this.uniforms = e.uniforms, this.extensions = e.extensions, this.updaters = e.updaters;
        for (let n of this.flavors)n && n.updateAfterBuild();
        return this;
    }
    nodeMaterialDispose() {
        this.layers.forEach((e)=>e.dispose()), super.dispose();
        for (let e of this.flavors)e && e.dispose();
    }
    assetsLoaded() {
        for (let e of this.layers)if (e instanceof en) {
            let n = e.params.texture;
            if (n instanceof Tl && !n.image.loaded) return !1;
        }
        return !0;
    }
    getHash() {
        let e = "{";
        return e += '"fragment":' + this.fragment.getHash(), e += "}", e;
    }
};
Object.defineProperties(Kr.prototype, {
    properties: {
        get: function() {
            return this.fragment.properties;
        }
    }
});
var Dl = class extends Pl {
};
var DP = Jd(EP());
var CP = new Map;
function PP(r1) {
    if (typeof r1 == "string") return r1;
    let t = CP.get(r1);
    return t || (t = {
        url: URL.createObjectURL(new Blob([
            r1
        ]))
    }, CP.set(r1, t)), t.url;
}
var Ao = class {
    constructor({ src: t , volume: e , delay: n , loop: i  }){
        this._volume = 1;
        this.delay = 0;
        this._loop = 1;
        this.loopsRemaining = 0;
        this._status = "stopped";
        this.onEnd = ()=>{
            this.loopsRemaining === 1 / 0 ? this.replay() : this.loopsRemaining > 1 ? (this.replay(), this.loopsRemaining--) : (this._status = "stopped", this.loopsRemaining = this._loop);
        };
        let s;
        typeof t == "string" ? s = {
            src: t
        } : s = {
            src: PP(t),
            format: "wav"
        }, this.sound = new DP.Howl(s), this.sound.on("end", this.onEnd), this.src = t, e !== void 0 && (this.volume = e), n !== void 0 && (this.delay = n), i !== void 0 && (this.loop = i);
    }
    get status() {
        return this._status;
    }
    get volume() {
        return this._volume;
    }
    set volume(t) {
        this._volume = t, this.sound.volume(t);
    }
    get loop() {
        return this._loop;
    }
    set loop(t) {
        this._loop = t, this.loopsRemaining = t;
    }
    replay() {
        this.clearDelay(), this.delayTimerId = window.setTimeout(()=>{
            this.sound.play(), this.clearDelay();
        }, this.delay);
    }
    fade(t, e = 1e3) {
        t ? (this.sound.volume(this._volume), this.clearFade(), this.fadeTimerId = window.setTimeout(()=>{
            this.sound.fade(this._volume, 0, e), this.clearFade();
        }, t)) : this.sound.fade(this._volume, 0, e);
    }
    on(t, e, n) {
        this.sound.on(t, e, n);
    }
    off(t, e, n) {
        this.sound.off(t, e, n);
    }
    play() {
        this._status === "playing" || this.sound.playing() || (this._status === "paused" ? (this.sound.seek() === 0 ? this.replay() : this.sound.play(), this._status = "playing") : this._status === "stopped" && (this.replay(), this._status = "playing"));
    }
    pause() {
        this._status === "playing" && (this.sound.pause(), this.clearFade(), this.clearDelay(), this._status = "paused");
    }
    stop() {
        this.sound.stop(), this.loopsRemaining = this._loop, this.clearFade(), this.clearDelay(), this._status = "stopped";
    }
    clearFade() {
        this.fadeTimerId && (clearTimeout(this.fadeTimerId), delete this.fadeTimerId);
    }
    clearDelay() {
        this.delayTimerId && (clearTimeout(this.delayTimerId), delete this.delayTimerId);
    }
    dispose(t = !1) {
        this.off(), this.stop(), this.clearFade(), this.clearDelay();
    }
};
var oy = class {
    constructor(){
        this.type = "ShapePath";
        this.color = new Ne;
        this.subPaths = [];
        this.currentPath = null;
    }
    moveTo(t, e) {
        return this.currentPath = new Ka, this.subPaths.push(this.currentPath), this.currentPath.moveTo(t, e), this;
    }
    lineTo(t, e) {
        return this.currentPath?.lineTo(t, e), this;
    }
    quadraticCurveTo(t, e, n, i) {
        return this.currentPath?.quadraticCurveTo(t, e, n, i), this;
    }
    bezierCurveTo(t, e, n, i, s, o) {
        return this.currentPath?.bezierCurveTo(t, e, n, i, s, o), this;
    }
    splineThru(t) {
        return this.currentPath?.splineThru(t), this;
    }
    toShapes() {
        let e = {
            ORIGIN: 0,
            DESTINATION: 1,
            BETWEEN: 2,
            LEFT: 3,
            RIGHT: 4,
            BEHIND: 5,
            BEYOND: 6
        }, n = {
            loc: e.ORIGIN,
            t: 0
        };
        function i(p, g, y, v) {
            let x = p.x, w = g.x, S = y.x, _ = v.x, M = p.y, b = g.y, T = y.y, E = v.y, P = (_ - S) * (M - T) - (E - T) * (x - S), D = (w - x) * (M - T) - (b - M) * (x - S), C = (E - T) * (w - x) - (_ - S) * (b - M), O = P / C, B = D / C;
            if (C === 0 && P !== 0 || O <= 0 || O >= 1 || B < 0 || B > 1) return null;
            if (P === 0 && C === 0) {
                for(let V = 0; V < 2; V++)if (s(V === 0 ? y : v, p, g), n.loc === e.ORIGIN) {
                    let Y = V === 0 ? y : v;
                    return {
                        x: Y.x,
                        y: Y.y,
                        t: n.t
                    };
                } else if (n.loc === e.BETWEEN) {
                    let Y = +(x + n.t * (w - x)).toPrecision(10), W = +(M + n.t * (b - M)).toPrecision(10);
                    return {
                        x: Y,
                        y: W,
                        t: n.t
                    };
                }
                return null;
            } else {
                for(let W = 0; W < 2; W++)if (s(W === 0 ? y : v, p, g), n.loc === e.ORIGIN) {
                    let q = W === 0 ? y : v;
                    return {
                        x: q.x,
                        y: q.y,
                        t: n.t
                    };
                }
                let V = +(x + O * (w - x)).toPrecision(10), Y = +(M + O * (b - M)).toPrecision(10);
                return {
                    x: V,
                    y: Y,
                    t: O
                };
            }
        }
        function s(p, g, y) {
            let v = y.x - g.x, x = y.y - g.y, w = p.x - g.x, S = p.y - g.y, _ = v * S - w * x;
            if (p.x === g.x && p.y === g.y) {
                n.loc = e.ORIGIN, n.t = 0;
                return;
            }
            if (p.x === y.x && p.y === y.y) {
                n.loc = e.DESTINATION, n.t = 1;
                return;
            }
            if (_ < -Number.EPSILON) {
                n.loc = e.LEFT;
                return;
            }
            if (_ > Number.EPSILON) {
                n.loc = e.RIGHT;
                return;
            }
            if (v * w < 0 || x * S < 0) {
                n.loc = e.BEHIND;
                return;
            }
            if (Math.sqrt(v * v + x * x) < Math.sqrt(w * w + S * S)) {
                n.loc = e.BEYOND;
                return;
            }
            let M;
            v !== 0 ? M = w / v : M = S / x, n.loc = e.BETWEEN, n.t = M;
        }
        function o(p, g) {
            let y = [], v = [];
            for(let x = 1; x < p.length; x++){
                let w = p[x - 1], S = p[x];
                for(let _ = 1; _ < g.length; _++){
                    let M = g[_ - 1], b = g[_], T = i(w, S, M, b);
                    T !== null && y.find((E)=>E.t <= T.t + Number.EPSILON && E.t >= T.t - Number.EPSILON) === void 0 && (y.push(T), v.push(new F(T.x, T.y)));
                }
            }
            return v;
        }
        function a(p, g, y) {
            let v = new F;
            g.getCenter(v);
            let x = [];
            return y.forEach((w)=>{
                w.boundingBox.containsPoint(v) && o(p, w.points).forEach((_)=>{
                    x.push({
                        identifier: w.identifier,
                        isCW: w.isCW,
                        point: _
                    });
                });
            }), x.sort((w, S)=>w.point.x - S.point.x), x;
        }
        function l(p, g, y, v, x) {
            (x == null || x === "") && (x = "nonzero");
            let w = new F;
            p.boundingBox.getCenter(w);
            let S = [
                new F(y, w.y),
                new F(v, w.y)
            ], _ = a(S, p.boundingBox, g);
            _.sort((D, C)=>D.point.x - C.point.x);
            let M = [], b = [];
            _.forEach((D)=>{
                D.identifier === p.identifier ? M.push(D) : b.push(D);
            });
            let T = M[0].point.x, E = [], P = 0;
            for(; P < b.length && b[P].point.x < T;)E.length > 0 && E[E.length - 1] === b[P].identifier ? E.pop() : E.push(b[P].identifier), P++;
            if (E.push(p.identifier), x === "evenodd") {
                let D = E.length % 2 === 0, C = E[E.length - 2];
                return {
                    identifier: p.identifier,
                    isHole: D,
                    for: C
                };
            } else if (x === "nonzero") {
                let D = !0, C = null, O = null;
                for(let B = 0; B < E.length; B++){
                    let V = E[B];
                    g[V] && (D ? (O = g[V].isCW, D = !1, C = V) : O !== g[V].isCW && (O = g[V].isCW, D = !0));
                }
                return {
                    identifier: p.identifier,
                    isHole: D,
                    for: C
                };
            } else console.warn('fill-rule: "' + x + '" is currently not implemented.');
        }
        let u = 0, c = 999999999, d = -999999999, h = [];
        this.subPaths.forEach((p)=>{
            let g = p.getPoints(), y = -999999999, v = 999999999, x = -999999999, w = 999999999;
            for(let S = 0; S < g.length; S++){
                let _ = g[S];
                _.y > y && (y = _.y), _.y < v && (v = _.y), _.x > x && (x = _.x), _.x < w && (w = _.x);
            }
            d <= x && (d = x + 1), c >= w && (c = w - 1), g.length && h.push({
                curves: p.curves,
                points: g,
                isCW: mc.isClockWise(g),
                identifier: u++,
                boundingBox: new Jp(new F(w, v), new F(x, y))
            });
        });
        let f = h.map((p)=>l(p, h, c, d, this.userData?.style.fillRule)), m = [];
        return h.forEach((p)=>{
            let g = f[p.identifier];
            if (g && !g.isHole) {
                let y = new oo;
                y.curves = p.curves, f.filter((x)=>x?.isHole && x.for === p.identifier).forEach((x)=>{
                    if (x) {
                        let w = h[x.identifier], S = new Ka;
                        S.curves = w.curves, y.holes.push(S);
                    }
                }), m.push(y);
            }
        }), m;
    }
};
var OP, vw = new Promise((r1)=>{
    OP = r1;
}), IP = !1;

async function RP() {
    if (IP) return;
    let r1 = await (parcelRequire("i8OU0"));
    OP(r1), IP = !0;
}
var Pf = class {
    async load(t, e, n = ()=>{}) {
        let { load: i  } = await vw;
        i(t, (s, o)=>{
            s || !o ? n(s ?? "Something went wrong") : e(o);
        });
    }
    async parse(t) {
        let { parse: e , Bidi: n  } = await vw;
        try {
            let i = e(t), s = new n, o = (a)=>i.charToGlyphIndex(a.char);
            return s.registerModifier("glyphIndex", null, o), s.applyFeatures(i, i.defaultRenderOptions.features), {
                font: i,
                bidi: s
            };
        } catch (i) {
            console.error(i);
        }
    }
};
async function PW(r1) {
    return await (await fetch(r1)).arrayBuffer();
}
var DW = new Pf;
async function xw(r1) {
    let t, e, n = !1;
    if (r1.url ? (t = await PW(r1.url), e = r1.url, n = r1.url.startsWith("/")) : r1.data && (t = r1.data.buffer), t) {
        let i = await DW.parse(t);
        if (i) return {
            font: i.font,
            url: e,
            intercepted: n,
            arr: t,
            bidi: i.bidi
        };
    }
}
function IW(r1, t) {
    return t.state.glyphIndex === r1 || t.state.fina === r1 || t.state.medi === r1 || t.state.init === r1;
}
var ay = class {
    constructor(t){
        this._arrayBuffer = new ArrayBuffer(1);
        this._isLoaded = !1;
        this._intercepted = !1;
        this._isUserFont = t.isUserFont ?? !1, this._loadingPromise = xw(t).then((e)=>{
            e && (this._arrayBuffer = e.arr, this._url = e.url, this.font = e.font, this._intercepted = e.intercepted, this._isLoaded = !0, this._bidi = e.bidi);
        });
    }
    update(t) {
        this._isLoaded = !1, this._isUserFont = t.isUserFont ?? !1, this._loadingPromise = xw(t).then((e)=>{
            e && (this._arrayBuffer = e.arr, this._url = e.url, this.font = e.font, this._intercepted = e.intercepted, this._isLoaded = !0, this._bidi = e.bidi);
        });
    }
    get url() {
        return this._url;
    }
    get intercepted() {
        return this._intercepted;
    }
    get isLoaded() {
        return this._isLoaded;
    }
    get loadingPromise() {
        return this._loadingPromise;
    }
    reverseLigaturesTable(t, e, n) {
        if (!this._bidi) return [];
        let i = this._bidi;
        i.getTextGlyphs(e);
        let s = i.tokenizer.tokens, o = [], a = 0, l = n.length === s.length;
        for(let u = 0; u < n.length; u++){
            let c = n[u].index, d = String.fromCharCode(n[u].unicode), h = s[a];
            if (IW(c, h) || l) o.push({
                char: d,
                index: c,
                replacements: [
                    h.state.glyphIndex
                ],
                replacementChars: [
                    h.char
                ]
            }), a++;
            else {
                let f = h.char, m = "", p = [
                    h.state.glyphIndex
                ], g = [], y = !1;
                for(; !y;)a++, m = e.charAt(a), f += m, p.push(t.charToGlyphIndex(m)), g = t.stringToGlyphs(f), g.length === 1 && g[0].index === c && (y = !0), a > e.length && (y = !0);
                o.push({
                    char: d,
                    index: c,
                    replacements: p,
                    replacementChars: Array.from(f)
                }), a++;
            }
        }
        return o;
    }
    generateShapes(t, e) {
        if (!this._isLoaded) return;
        let n = this.font, i = e.fontSize / this.unitsPerEm, s = e.fontSize * e.lineHeight, o = t.map((v)=>this.getTextWidth(v, e)), a = e.width, l = this.getCharWidth(`
`, e), u = e.horizontalAlign === 1 ? l : 0, c = this.computeSpaceWidthForLine(t, 0, e), d = this.getLineInitialOffsetX(o[0], a, e.horizontalAlign, t[0], l), h = this.getLineInitialOffsetY(s, t.length, e.height, i, e.verticalAlign), f = [], m = t.map((v)=>[]), p = t.map((v)=>[]), g;
        for(let v = 0; v < t.length; v++){
            let x = t[v], w = {
                features: {
                    liga: !0
                }
            }, S = [];
            try {
                S = n.stringToGlyphs(x, w);
            } catch (M) {
                console.warn(M);
            }
            d = this.getLineInitialOffsetX(o[v], a, e.horizontalAlign, x, l);
            let _ = [];
            try {
                _ = this.reverseLigaturesTable(n, x, S);
            } catch (M) {
                console.warn(M);
            }
            c = this.computeSpaceWidthForLine(t, v, e);
            for(let M = 0; M < S.length; M++){
                let b = S[M], T = b.index === 0 ? `
` : b.unicode ? String.fromCharCode(b.unicode) : void 0, E = _[M], P = 0, D = 0;
                M === 0 && e.horizontalAlign === 2 && b.leftSideBearing !== void 0 && (D = -b.leftSideBearing * i), g && (P = n.getKerningValue(b, g) * i), d += D + P;
                let C = 0;
                if (T === `
`) C = u;
                else if (T === " ") C = c;
                else {
                    let O = this.createPath(b, i, d, h, e);
                    O && (C = O.offsetX - (P + D), f.push(O.path));
                }
                if (E.replacements.length === 1) p[v].push([
                    d,
                    h
                ]), m[v].push(C);
                else {
                    let O = E.replacements.map((W)=>(n.glyphs.get(W).advanceWidth ?? 0) * i), B = O.reduce((W, q)=>W += q, 0), V = O.map((W)=>W / B), Y = d;
                    for(let W = 0; W < V.length; W++){
                        let q = C * V[W];
                        p[v].push([
                            Y,
                            h
                        ]), m[v].push(q), Y += q;
                    }
                }
                d += C, g = b;
            }
            h -= s;
        }
        let y = [];
        for(let v = 0, x = f.length; v < x; v++)y.push(...f[v].toShapes());
        return {
            shapes: y,
            charWidths: m,
            lineWidths: o,
            charCoords: p
        };
    }
    get isUserFont() {
        return this._isUserFont;
    }
    get arrayBuffer() {
        return this._arrayBuffer;
    }
    get ascender() {
        return this.font?.ascender ?? 0;
    }
    get descender() {
        return this.font?.descender ?? 0;
    }
    get familyName() {
        return this.font?.names.fontFamily ?? "";
    }
    get subfamilyName() {
        return this.font?.names.fontSubfamily ?? "";
    }
    get unitsPerEm() {
        return this.font?.unitsPerEm ?? 1;
    }
    getLineInitialOffsetX(t, e, n, i, s) {
        return (n === 3 || n === 2) && i.indexOf(`
`) >= 0 && (t -= s), n === 3 ? e * .5 - t * .5 : n === 2 ? e - t : 0;
    }
    getLineInitialOffsetY(t, e, n, i, s) {
        let o = e * t, a = Math.abs(this.ascender - this.descender) * i, l = t - a, u = -this.ascender * i - l / 2;
        return s === 3 ? -(n - o - u) : s === 2 ? -(n * .5 - o * .5 - u) : u;
    }
    createPath(t, e, n, i, s) {
        let o = t.getPath(n, -i, s.fontSize, {
            kerning: !1,
            letterSpacing: s.letterSpacing
        });
        if (!o) {
            console.error('THREE.Font: character "' + t + '" does not exists in font family ' + this.familyName + ".");
            return;
        }
        let a = new oy, l = (t.advanceWidth ?? 1) * e;
        if (t) for (let u of o.commands){
            let c = a.currentPath?.currentPoint;
            if (!(c && u.type !== "Z" && c.x === u.x && -c.y === u.y)) switch(u.type){
                case "M":
                    a.moveTo(u.x, -u.y);
                    break;
                case "L":
                    a.lineTo(u.x, -u.y);
                    break;
                case "Q":
                    a.quadraticCurveTo(u.x1, -u.y1, u.x, -u.y);
                    break;
                case "C":
                    a.bezierCurveTo(u.x1, -u.y1, u.x2, -u.y2, u.x, -u.y);
                    break;
            }
        }
        return a.subPaths.forEach((u)=>{
            let c = OW(u.curves);
            c !== void 0 && u.currentPoint.distanceTo(c) > 0 && u.lineTo(c.x, c.y);
        }), {
            offsetX: l + s.fontSize * s.letterSpacing,
            path: a
        };
    }
    getCharWidth(t, e) {
        return this.font?.getAdvanceWidth(t, e.fontSize, {
            kerning: !0,
            letterSpacing: e.letterSpacing
        }) ?? 0;
    }
    getTextWidth(t, e) {
        return this.font?.getAdvanceWidth(t, e.fontSize, {
            kerning: !0,
            letterSpacing: e.letterSpacing
        }) ?? 0;
    }
    computeSpaceWidthForLine(t, e, n) {
        let i = this.getCharWidth(" ", n), s = t[e];
        if (s) {
            let o = this.countSpaces(s.trimEnd());
            if (n.horizontalAlign === 4 && e < t.length - 1 && o) {
                let a = n.width, l = this.getTextWidth(s, n);
                return (a - (l - o * i)) / o;
            }
        }
        return i;
    }
    countSpaces(t) {
        return (t.match(/ /g) || []).length;
    }
};
function OW(r1) {
    if (r1.length) {
        let t = r1[0];
        if (t instanceof Ar) return t.v1;
        if (t instanceof Sr || t instanceof ai) return t.v0;
    }
}
var bw = class {
    constructor(){
        this.objects = new Map;
        this.unreachable = new Set;
    }
    getCached(t) {
        return this.objects.get(t);
    }
    get size() {
        return this.objects.size;
    }
    get(t, e) {
        let n = this.objects.get(t);
        return n === void 0 ? (n = this.createObject(t, e), this.objects.set(t, n)) : n.isShared = !0, n;
    }
    mutateIfUnique(t, e) {
        let n = this.objects.get(t);
        if (n && n.isShared !== !0) return this.objects.delete(t), this.objects.set(e, n), n;
    }
    startGc() {
        this.unreachable = new Set(this.objects.keys());
    }
    markAsReachable(t, e) {
        let n = this.objects.get(t);
        e === n && this.unreachable.delete(t);
    }
    endGc() {
        this.unreachable.forEach((t)=>{
            this.disposeObject(this.objects.get(t)), this.objects.delete(t);
        }), this.unreachable.clear();
    }
    dispose() {
        this.objects.forEach((t)=>{
            this.disposeObject(t);
        }), this.objects.clear();
    }
}, Df = class extends bw {
    constructor(e){
        super();
        this.flatShading = e;
    }
    disposeObject(e) {
        e.dispose();
    }
    createObject(e, n) {
        let i = Sl(e, n, this.flatShading);
        return i.computeBoundingSphere(), i;
    }
};
var LP = {
    find (r1) {},
    markNeedsUpdateRendererDirty: function() {},
    markGeometryCacheDirty: function() {},
    addPendingExpandCloner: function(r1) {},
    addPendingUpdateCloner (r1) {},
    addPendingCommand (r1) {}
};
var ww = class extends ry {
    constructor(e){
        super();
        this.shared = e;
    }
    create(e) {
        return new md(e, this.shared);
    }
}, Il = class {
    constructor(t, e = {}){
        this.geometryCache = new Df(!0);
        this.geometryCache2 = new Df(!1);
        this.imageHolderCache = new ww(this);
        this.thisContext = {
            scene: LP,
            shared: this
        };
        this.deletedMaterial = new Dl(or.defaultTwoLayerData("phong"), this.thisContext);
        this.deletedImage = new _i(gu.emptyImage, this);
        this.deletedVideo = new _i(cu.defaultVideo, this);
        this.materials = {};
        this.images = {};
        this.videos = {};
        this.colors = {};
        this.audios = {};
        this.fonts = {};
        this.penumbraSize = [];
        this.requestRender = ()=>{
            this._requestRender && this._requestRender();
        };
        if (e.images) for (let [n, i] of Object.entries(e.images))this.addImage(n, i);
        if (e.videos) for (let [n, i] of Object.entries(e.videos))this.addVideo(n, i);
        if (e.audios) for (let [n, i] of Object.entries(e.audios))this.addAudio(n, i.data);
        this.reset(t);
    }
    setRequestRender(t) {
        this._requestRender = t;
    }
    reset(t) {
        for (let [e, n] of Object.entries(t.images))this.addImage(e, n);
        for (let [e, n] of Object.entries(t.videos))this.addVideo(e, n);
        for (let [e, n] of Object.entries(t.colors))this.addColor(e, n);
        for (let [e, n] of Object.entries(t.materials))this.addMaterial(e, new Dl(n, this.thisContext));
        for (let [e, n] of Object.entries(t.audios))this.addAudio(e, n.data);
        for (let [e, n] of Object.entries(t.fonts))this.addFont(e, n);
        this.penumbraSize = t.penumbraSize;
    }
    addMaterial(t, e) {
        e.uuid = t, this.materials[t] ? (this.materials[t].reset(e.data, this.thisContext), e.dispose()) : this.materials[t] = e;
    }
    deleteMaterial(t) {
        this.materials[t] && (this.materials[t].nodeMaterialDispose(), delete this.materials[t]);
    }
    getMaterial(t) {
        let e = this.materials[t];
        return e;
    }
    getMaterialOrDeletedPlaceholder(t) {
        return this.materials[t] ?? this.deletedMaterial;
    }
    material(t) {
        return typeof t == "string" ? this.getMaterialOrDeletedPlaceholder(t) : new Pl(t, this.thisContext);
    }
    getMaterials() {
        return this.materials;
    }
    addImage(t, e) {
        return this.images[t] ? (this.onColorOrImageUpdate && this.onColorOrImageUpdate(), this.images[t].updateSrc(e.data), !0) : (this.images[t] = new _i(e, this), !1);
    }
    deleteImage(t) {
        let e = this.images[t];
        e && (e.dispose(), delete this.images[t]);
    }
    getDefaultImage() {
        return this.images.image_0;
    }
    getImage(t) {
        return this.images[t] ?? this.deletedImage;
    }
    image(t) {
        return typeof t == "string" ? this.getImage(t) : this.imageHolderCache.load(t);
    }
    addVideo(t, e) {
        return this.videos[t] ? (this.videos[t].updateSrc(e.data), !0) : (this.videos[t] = new _i(e, this), !1);
    }
    deleteVideo(t) {
        let e = this.videos[t];
        e && (e.dispose(), delete this.videos[t]);
    }
    getVideo(t) {
        return this.videos[t] ?? this.deletedVideo;
    }
    video(t) {
        return typeof t == "string" ? this.getVideo(t) : this.imageHolderCache.load(t);
    }
    addColor(t, e) {
        return this.colors[t] ? (this.onColorOrImageUpdate && this.onColorOrImageUpdate(), "a" in e ? this.colors[t].setRGBA(e.r, e.g, e.b, e.a) : this.colors[t].setRGBA(e.r, e.g, e.b, 1), !0) : ("a" in e ? this.colors[t] = new va(e.r, e.g, e.b, e.a) : this.colors[t] = new va(e.r, e.g, e.b, 1), !1);
    }
    updateColor(t, e) {
        if (this.colors[t]) {
            this.onColorOrImageUpdate && this.onColorOrImageUpdate();
            let n = this.colors[t];
            return this.colors[t].r = e.r ?? n.r, this.colors[t].g = e.g ?? n.g, this.colors[t].b = e.b ?? n.b, this.colors[t].a = e.a ?? n.a, !0;
        }
        return !1;
    }
    deleteColor(t) {
        this.colors[t] && delete this.colors[t];
    }
    getColor(t) {
        return this.colors[t];
    }
    color(t) {
        let e;
        if (typeof t == "string") {
            let n = this.getColor(t);
            n ? e = n : (console.warn("Tried to create color layer params with a color key that does not exist in the assets manager"), e = new $t(0, 0, 0, 0));
        } else return "a" in t ? new $t(t.r, t.g, t.b, t.a) : new $t(t.r, t.g, t.b, 1);
        return e;
    }
    addAudio(t, e) {
        this.audios[t] = e;
    }
    getAudio(t) {
        let e = this.audios[t];
        if (e instanceof Ao) return e;
        {
            let n = new Ao({
                src: e
            });
            return this.audios[t] = n, n;
        }
    }
    deleteAudio(t) {
        let e = this.audios[t];
        e && (e instanceof Ao && e.dispose(), delete this.audios[t]);
    }
    addFont(t, e) {
        this.fonts[t] = new ay(e), this.fonts[t].loadingPromise.then(()=>this.requestRender());
    }
    getFont(t) {
        return this.fonts[t];
    }
    deleteFont(t) {
        this.fonts[t] && delete this.fonts[t];
    }
    dispose() {
        Object.keys(this.materials).forEach((e)=>this.deleteMaterial(e)), this._requestRender = void 0, Object.values(this.audios).forEach((e)=>{
            e instanceof Ao && e.dispose();
        }), this.audios = {}, this.geometryCache.dispose(), this.geometryCache2.dispose();
    }
}, Vve = new Il(yg.emptyData());
var Rs = class extends kt {
    updateByPatchedOp(e, n, i) {
        if (super.updateByPatchedOp(e, n, i), zT(e.path, [
            "materials"
        ]) !== null && e.type === 0 && Array.isArray(this.material)) for (let [s, o] of Object.entries(e.props)){
            let a = i.shared.material(o);
            this.material[Number(s)] = a;
        }
        else if (Wi(e.path, [
            "material"
        ]) && this.material instanceof Kr) "material" in n && typeof n.material != "string" && this.material.updateByOp(gr.drop(e, 1), n.material, i);
        else if (Wi(e.path, [
            "materials",
            "*"
        ]) && Array.isArray(this.material)) {
            let s = e.path[1];
            if ("materials" in n && s < this.material.length) {
                let o = n.materials[s];
                typeof o != "string" && this.material[s].updateByOp(gr.drop(e, 2), o, i);
            }
        }
    }
    get needsAO() {
        return this.material !== void 0 ? (Array.isArray(this.material) ? this.material[0] : this.material).hasAO : !1;
    }
    updateState(e, n) {
        super.updateState(e, n), e.castShadow !== void 0 && (this.castShadow = e.castShadow), e.receiveShadow !== void 0 && (this.receiveShadow = e.receiveShadow);
        let i = this.dataPatched;
        if (e.geometry?.type !== "NonParametricGeometry" && "material" in e && e.material !== void 0 && (this.disposeMaterial(), this.material = n.shared.material(e.material).getFlavor(i.flatShading, i.side, i.wireframe), n.scene?.markNeedsUpdateRendererDirty()), e.geometry?.type === "NonParametricGeometry" && ("materials" in e && e.materials !== void 0 ? (this.disposeMaterial(), this.material = e.materials.map((s)=>n.shared.material(s).getFlavor(i.flatShading, i.side, i.wireframe)), n.scene?.markNeedsUpdateRendererDirty()) : "material" in e && e.material !== void 0 && (this.disposeMaterial(), this.material = [
            n.shared.material(e.material).getFlavor(i.flatShading, i.side, i.wireframe)
        ], n.scene?.markNeedsUpdateRendererDirty())), e.flatShading !== void 0 || e.wireframe !== void 0 || e.side !== void 0) {
            if (Array.isArray(this.material)) for(let s = 0; s < this.material.length; s++)this.material[s] = this.material[s].getFlavor(i.flatShading, i.side, i.wireframe);
            else this.material = this.material.getFlavor(i.flatShading, i.side, i.wireframe);
        }
    }
    disposeMaterial() {
        this.material && Lm(this.material).forEach((e)=>{
            e instanceof Kr && (e instanceof Dl || e.nodeMaterialDispose());
        });
    }
    dispose() {
        this.disposeMaterial(), super.dispose();
    }
};
var tn = class extends Rs {
    constructor(e, n, i){
        super(e, n);
        this.data = n;
        this.localGeometry = void 0;
    }
    chooseGeoemtryCache(e) {
        return e.geometryCache;
    }
    markGeometryAsReachable(e) {
        this.geometryCreateDeleyed instanceof Me && this.chooseGeoemtryCache(e).markAsReachable(this.dataPatched.geometry, this.geometryCreateDeleyed);
    }
    get geometry() {
        if (this.localGeometry !== void 0) return this.localGeometry;
        if (this.geometryCreateDeleyed instanceof Il) {
            let e = this.geometryCreateDeleyed, n = this.chooseGeoemtryCache(e);
            this.geometryCreateDeleyed = n.get(this.dataPatched.geometry, e);
        }
        return this.geometryCreateDeleyed;
    }
    set geometry(e) {
        this.localGeometry = e;
    }
    get is2DAndNoDepth() {
        let e = this.dataPatched.geometry;
        return Xh.is2DParametricMesh(e.type) && e.depth === 0;
    }
    get is2DType() {
        return Xh.is2DParametricMesh(this.geometry.userData.type);
    }
    get isNonParametric() {
        return this.geometry.userData.type === "NonParametricGeometry";
    }
    updateByPatchedOp(e, n, i) {
        super.updateByPatchedOp(e, n, i), Wi(e.path, [
            "geometry"
        ]) && this.updateByPatchedOpGeometry(gr.drop(e, 1), n.geometry, i);
    }
    removeInteractionGeometry() {
        this.localGeometry?.dispose(), this.localGeometry = void 0;
    }
    updateGeometryInteractions(e, n) {
        this.invalidateDownstreamBooleanData();
        let i = this.data.geometry.type;
        if (i === "NonParametricGeometry" || i === "SubdivGeometry") {
            let s = e;
            if (this.localGeometry === void 0) {
                let c = {
                    ...this.data.geometry,
                    ...s
                };
                this.localGeometry = Sl(c, n, this.data.flatShading);
            }
            let o, a, l;
            s.scaleBaked ? [o, a, l] = s.scaleBaked : { width: o , height: a , depth: l  } = s;
            let u = this.localGeometry.userData;
            u.sxPrev !== void 0 && gf(this.localGeometry.attributes, o / u.sxPrev, a / u.syPrev, l / u.szPrev), u.sxPrev = o, u.syPrev = a, u.szPrev = l;
        } else {
            let s = {
                ...this.data.geometry,
                ...e
            };
            this.localGeometry?.dispose(), this.localGeometry = Sl(s, n, this.data.flatShading);
        }
    }
    refreshAttachedCloners(e) {
        for (let n of this.attachedSurfaceCloners)e.scene.addPendingUpdateCloner(n.object);
    }
    refreshAttachedPaths(e) {
        for (let n of this.attachedPaths)e.scene.addPendingCommand(()=>n.updateShape());
    }
    createGeometryDelayed(e) {
        this.geometryCreateDeleyed = e.shared, this.refreshAttachedCloners(e), this.refreshAttachedPaths(e);
    }
    updateByPatchedOpGeometry(e, n, i) {
        let s = !1;
        e.type === 0 && e.path.length === 0 && al([
            "scaleBaked"
        ], Object.keys(e.props)) && this.geometryCreateDeleyed instanceof xn && this.chooseGeoemtryCache(i.shared).mutateIfUnique(this.geometryCreateDeleyed.data, n) === this.geometryCreateDeleyed && (s = !0, this.geometryCreateDeleyed.mutateDirectlyScaleBaked(n, e.props.scaleBaked), this.refreshAttachedCloners(i), this.refreshAttachedPaths(i)), s || (i.scene?.markGeometryCacheDirty(), this.createGeometryDelayed(i)), this.resetBBoxNeedsUpdate(), this.invalidateDownstreamBooleanData();
    }
    updateGeometryOnStateUpdate(e, n) {
        this.createGeometryDelayed(n);
    }
    updateState(e, n) {
        e.geometry !== void 0 && this.updateGeometryOnStateUpdate(e.geometry, n), super.updateState(e, n);
    }
    updateGeometryGroupsIfNeeded() {
        Array.isArray(this.material) && this.geometry.groups.length === 0 && this.geometry.addGroup(0, Math.max(this.geometry.getIndex()?.count ?? 0, this.geometry.getAttribute("position").count), 0);
    }
    updateEntityBoxSize(e, n) {
        let i = this.geometry.userData.parameters;
        this.is2DType ? e.set(0, 0, i.depth * .5) : this.isNonParametric ? (e.setScalar(0), this.geometry.boundingSphere && e.copy(this.geometry.boundingSphere.center), n.set(i.width, i.height, i.depth ?? 0).multiplyScalar(.5)) : e.setScalar(0), n.set(i.width, i.height, i.depth ?? 0).multiplyScalar(.5);
    }
};
function RW(r1) {
    if (r1.geometry.attributes.extrudeNormal || !r1.geometry.attributes.position || !r1.geometry.attributes.normal) return;
    let t = new Map, e = r1.geometry.attributes, n = e.position.array, i = e.normal.array, s = new Float32Array(n.length);
    for(let o = 0; o < n.length; o += 3){
        let a = `${n[o]}_${n[o + 1]}_${n[o + 2]}`, l = new A(i[o], i[o + 1], i[o + 2]);
        t.has(a) ? t.get(a)?.normals.push(l) : t.set(a, {
            normals: [
                l
            ],
            result: new A
        });
    }
    t.forEach((o, a)=>{
        for (let l of o.normals)o.result.add(l);
        o.result.divideScalar(o.normals.length);
    });
    for(let o = 0; o < n.length; o += 3){
        let a = `${n[o]}_${n[o + 1]}_${n[o + 2]}`, l = t.get(a)?.result;
        l && (s[o] = l.x, s[o + 1] = l.y, s[o + 2] = l.z);
    }
    r1.geometry.setAttribute("extrudeNormal", new Ae(s, 3));
}
function LW(r1) {
    if (r1.geometry.attributes.extrudeNormals || !r1.geometry.attributes.position) return;
    let e = r1.geometry.attributes.position.array, n = new Float32Array(e.length), i = new A;
    for(let s = 0; s < e.length; s += 3)i.set(e[s], e[s + 1], e[s + 2]).normalize(), n[s] = i.x, n[s + 1] = i.y, n[s + 2] = i.z;
    r1.geometry.setAttribute("extrudeNormal", new Ae(n, 3));
}
function gd(r1) {
    if (Array.isArray(r1.material)) {
        for (let t of r1.material)if (t.getLayersOfType("outline").length === 0) return;
    } else if (!(r1.material instanceof Kr) || r1.material.getLayersOfType("outline").length === 0) return;
    r1 instanceof tn && r1.is2DAndNoDepth ? LW(r1) : RW(r1);
}
function yd(r1) {
    if (!r1.geometry.attributes.position) return;
    let e = r1.geometry.attributes.position.array, n = new Float32Array(e.length), i = parseInt(r1.uuid.replace(/\D/g, "")), s = [
        He.seededRandom(i),
        He.seededRandom(i + 1e4),
        He.seededRandom(i + 2e4)
    ];
    for(let o = 0; o < e.length; o++)n[o] = s[o % 3];
    r1.geometry.setAttribute("randomColor", new Be(n, 3));
}
var NW;
ju.then((r1)=>{
    NW = r1;
});
var Ls = new Mt, If = new A;
function NP(r1) {
    let t = !1;
    return r1.scene.objects.traverse((e, n)=>{
        n.type === "Mesh" && n.geometry.type === "SubdivGeometry" && (t = !0);
    }), t;
}
var rs = class extends tn {
    constructor(e, n, i){
        super(e, n, i);
        this.data = n;
        this.hiddenMatrixOld = new ae;
        this.smoothShading = !0;
        this.skipReactionUpdate = !1;
    }
    chooseGeoemtryCache(e) {
        return this.dataPatched.flatShading ? e.geometryCache : e.geometryCache2;
    }
    get subdivPointerNew() {
        return this.localGeometry !== void 0 ? this.subdivPointer : this.geometry.ensureSubdivPointer();
    }
    get originalGeometryNew() {
        return this.localGeometry !== void 0 ? this.originalGeometry : this.geometry.originalGeometry;
    }
    get phongAngle() {
        return this.data.geometry.phongAngle ?? 45;
    }
    updateEntityBoxSize(e, n) {
        let i = this.geometry.userData.parameters;
        e.copy(this.originalGeometryNew.boundingSphere.center), n.set(i.width, i.height, i.depth ?? 0).multiplyScalar(.5);
    }
    createGeometryByControls(e) {
        if (this.skipReactionUpdate === !0) return;
        let n = this.localGeometry?.uuid, { originalGeometry: i , subdividedGeometry: s , subdivPointer: o  } = xn.build(e, this.subdivPointer, this.smoothShading, this.hasNonUniformScale ? this.shearScale : void 0);
        this.subdivPointer = o, i !== void 0 && (this.originalGeometry?.dispose(), this.originalGeometry = i), s !== void 0 && (this.subdividedGeometry?.dispose(), this.subdividedGeometry = s ?? void 0), this.localGeometry = this.subdividedGeometry ?? this.originalGeometry, gd(this), yd(this), this.calcBoundingBox(), n && (this.localGeometry.uuid = n);
    }
    updateState(e, n) {
        if (super.updateState(e, n), e.flatShading !== void 0) {
            let i = this.material;
            this.material = i.getFlavor(!1, i.side, i.wireframe), this.smoothShading = !e.flatShading, this.createGeometryDelayed(n);
        }
    }
    updateMesh(e = !1) {
        xn.buildLevel(this.subdivPointer, !0, this.smoothShading ? this.phongAngle : -1, this.originalGeometry, e && this.hasNonUniformScale ? this.shearScaleInv : void 0), this.subdividedGeometry && xn.buildLevel(this.subdivPointer, !1, this.smoothShading ? this.phongAngle : -1, this.subdividedGeometry, e && this.hasNonUniformScale ? this.shearScaleInv : void 0);
    }
    updateTopology() {
        this.originalGeometry.dispose(), this.originalGeometry = xn.buildLevel(this.subdivPointer, !0, this.smoothShading ? this.phongAngle : -1), this.subdividedGeometry && (this.subdividedGeometry.dispose(), this.subdividedGeometry = xn.buildLevel(this.subdivPointer, !1, this.smoothShading ? this.phongAngle : -1)), this.localGeometry = this.subdividedGeometry ?? this.originalGeometry;
    }
    raycast(e, n) {
        let i = this.localGeometry;
        this.localGeometry = this.originalGeometryNew, kt.prototype.raycast.call(this, e, n), this.localGeometry = i;
    }
    activateSVDCompensation() {
        !this.hasNonUniformScale || (this.matrix.copy(this.matrixWorldRigid), this.hiddenMatrixOld.copy(this.hiddenMatrix), this.hiddenMatrix.copy(this.parent.matrixWorld).invert());
    }
    deactivateSVDCompensation() {
        !this.hasNonUniformScale || (this.updateMatrix(), this.hasNonUniformScale = void 0, this.hiddenMatrix.copy(this.hiddenMatrixOld));
    }
    calcBoundingBox() {
        let e = this.originalGeometry;
        e.boundingSphere === null && (e.boundingSphere = new Rn, this.subdividedGeometry && (this.subdividedGeometry.boundingSphere = e.boundingSphere));
        let n = e.attributes.position, i = e.boundingSphere.center;
        Ls.setFromBufferAttribute(n), Ls.getCenter(i), e.boundingSphere.radius = i.distanceTo(Ls.max), isNaN(e.boundingSphere.radius) && console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this), Ls.getSize(If), this.hasNonUniformScale && If.divide(this.scale);
        let s = {
            width: If.x,
            height: If.y,
            depth: If.z
        };
        return this.geometry.userData.parameters = s, s;
    }
    updateBoundingSphere(e) {
        let n = this.originalGeometry;
        Ls.min.set(e[0], e[2], e[4]), Ls.max.set(e[1], e[3], e[5]), this.hasNonUniformScale && (Ls.min.applyMatrix4(this.shearScaleInv), Ls.max.applyMatrix4(this.shearScaleInv)), n.boundingSphere === null && (n.boundingSphere = new Rn);
        let i = n.boundingSphere.center;
        Ls.getCenter(i), n.boundingSphere.radius = i.distanceTo(Ls.max);
    }
    freeSubdivPointer() {
        this.subdivPointer && (xn.freeSubdivPointer(this.subdivPointer), this.subdivPointer = 0), this.localGeometry = void 0, this.originalGeometry?.dispose(), this.subdividedGeometry?.dispose();
    }
    dispose() {
        super.dispose(), this.freeSubdivPointer();
    }
    updateByPatchedOpGeometry(e, n, i) {
        super.updateByPatchedOpGeometry(e, n, i), this.localGeometry && this.createGeometryByControls(n);
    }
};
var BP = -1, BW = 1, FP = {
    x: [
        1,
        0,
        0
    ],
    "-x": [
        -1,
        0,
        0
    ],
    y: [
        0,
        1,
        0
    ],
    "-y": [
        0,
        -1,
        0
    ],
    z: [
        0,
        0,
        1
    ],
    "-z": [
        0,
        0,
        -1
    ]
}, UP = {
    polygon_center: 0,
    edge: 1,
    vertex: 2
}, Of = (r1, t)=>(e, n)=>!t || e === 0 || r1 === 0 ? 0 : r1 * n / 100, rt = (r1, t)=>{
    let e = Math.abs(t), n = e * -1;
    return (r1 - BP) * (e - n) / (BW - BP) + n;
};
function kP(r1) {
    let t = [], e = {};
    for(var n = 0, i = r1.length; n < i; n++){
        var s = JSON.stringify(r1[n].pos.map((o)=>Math.round(o * 1e4) / 1e4));
        e[s] || (t.push(r1[n]), e[s] = !0);
    }
    return t;
}
var FW = new A, ly = new A, UW = new A, kW = new A;
function vd(r1, t) {
    let e = UW.fromArray(r1), n = kW.fromArray(t);
    ly.copy(n).sub(e);
    let i = ly.length();
    return ly.normalize().multiplyScalar(i * .5), FW.copy(e).add(ly).toArray();
}
var Ei = new an, cy = new A, uy = new A, Ol = new A;
function zP(r1) {
    let t = [];
    for(let e = 0; e <= r1.index.count; e++)if (cy.fromArray(r1.index.array, e * 3), Ei.setFromAttributeAndIndices(r1.attributes.position, cy.x, cy.y, cy.z), Ei.getNormal(uy), Ei.getMidpoint(Ol), !(isNaN(Ol.x) || isNaN(Ol.y) || isNaN(Ol.z))) {
        let { a: n , b: i , c: s  } = Ei, o = n.toArray(), a = i.toArray(), l = s.toArray(), u = n.distanceTo(i), c = i.distanceTo(s), d = s.distanceTo(n), h = vd(o, a), f = vd(a, l), m = vd(l, o), p = [
            u,
            c,
            d
        ], g = Math.max(...p), y = p.filter((w)=>Math.round(w) === Math.round(g)).length > 1, v = [], x = Ei.getMidpoint(Ol).toArray();
        g === u && !y && (v = [
            f,
            m,
            m
        ], x = h), g === c && !y && (v = [
            h,
            m,
            m
        ], x = f), g === d && !y && (v = [
            h,
            f,
            f
        ], x = m), y && (v = [
            h,
            f,
            m
        ]), t.push({
            vertices: [
                o,
                a,
                l
            ],
            faceCenters: v,
            midpoint: x,
            norm: Ei.getNormal(uy).toArray()
        });
    }
    return t;
}
function GP(r1) {
    let t = [], { position: e  } = r1.attributes;
    for(let n = 0; n < e.count; n++){
        Ei.setFromAttributeAndIndices(e, n * 3, n * 3 + 1, n * 3 + 2), Ei.getNormal(uy), Ei.getMidpoint(Ol);
        let i = Ei.a.toArray(), s = Ei.b.toArray(), o = Ei.c.toArray();
        t.push({
            vertices: [
                i,
                s,
                o
            ],
            faceCenters: [
                vd(i, s),
                vd(s, o),
                vd(o, i)
            ],
            midpoint: Ol.toArray(),
            norm: uy.toArray()
        });
    }
    return t;
}
var zW = 4, GW = .5, Sw = (r1)=>.5 * (1 - Math.cos(r1 * Math.PI)), Aw = class {
    constructor(){
        this.perlin = new Array(4096);
    }
    noise(t, e = 0, n = 0) {
        if (this.perlin == null) {
            this.perlin = new Array(4096);
            for(let y = 0; y < 4096; y++)this.perlin[y] = Math.random();
        }
        t < 0 && (t = -t), e < 0 && (e = -e), n < 0 && (n = -n);
        let i = Math.floor(t), s = Math.floor(e), o = Math.floor(n), a = t - i, l = e - s, u = n - o, c, d, h = 0, f = .5, m, p, g;
        for(let y = 0; y < zW; y++){
            let v = i + (s << 4) + (o << 8);
            c = Sw(a), d = Sw(l), m = this.perlin[v & 4095], m += c * (this.perlin[v + 1 & 4095] - m), p = this.perlin[v + 16 & 4095], p += c * (this.perlin[v + 16 + 1 & 4095] - p), m += d * (p - m), v += 256, p = this.perlin[v & 4095], p += c * (this.perlin[v + 1 & 4095] - p), g = this.perlin[v + 16 & 4095], g += c * (this.perlin[v + 16 + 1 & 4095] - g), p += d * (g - p), m += Sw(u) * (p - m), h += m * f, f *= GW, i <<= 1, a *= 2, s <<= 1, l *= 2, o <<= 1, u *= 2, a >= 1 && (i++, a--), l >= 1 && (s++, l--), u >= 1 && (o++, u--);
        }
        return h;
    }
    noiseSeed(t) {
        let e = (()=>{
            let o, a;
            return {
                setSeed (l) {
                    a = o = (l ?? Math.random() * 4294967296) >>> 0;
                },
                getSeed () {
                    return o;
                },
                rand () {
                    return a = (1664525 * a + 1013904223) % 4294967296, a / 4294967296;
                }
            };
        })();
        e.setSeed(t), this.perlin = new Array(4096);
        for(let n = 0; n < 4096; n++)this.perlin[n] = e.rand();
    }
}, VP = Aw;
var HP = new A, WP = new ae, jP = new Fi;
function _w(r1) {
    let t = !1;
    return r1.scene.objects.traverse((e, n)=>{
        n.type === "Mesh" && n.geometry.type === "TextGeometry" && (t = !0);
    }), t;
}
var xd = class extends tn {
    constructor(e, n, i){
        super(e, n, i);
        this.data = n;
    }
    get textGeometry() {
        return this.geometry;
    }
    get charWidths() {
        return this.textGeometry.charWidths;
    }
    get charCoords() {
        return this.textGeometry.charCoords;
    }
    get wrappedText() {
        return this.textGeometry.wrappedText;
    }
    get font() {
        return this.textGeometry.font;
    }
    get initialOffsetY() {
        let e = this.dataPatched;
        return this.font?.getLineInitialOffsetY(this.lineHeight, this.wrappedText.length, e.geometry.height, this.fontScale, e.geometry.verticalAlign) ?? 0;
    }
    get fontScale() {
        let e = this.dataPatched;
        return this.font ? e.geometry.fontSize / this.font.unitsPerEm : 1;
    }
    get AD() {
        return Math.abs(this.ascender - this.descender);
    }
    get ascender() {
        return (this.font?.ascender ?? 1) * this.fontScale;
    }
    get descender() {
        return (this.font?.descender ?? 1) * this.fontScale;
    }
    get lineHeight() {
        let e = this.dataPatched;
        return e.geometry.fontSize * e.geometry.lineHeight;
    }
    raycast(e, n) {
        let { matrixWorld: i  } = this;
        if (!(isNaN(e.ray.origin.x) || this.scale.x === 0 || this.scale.y === 0 || this.scale.z === 0) && (WP.copy(i).invert(), jP.copy(e.ray).applyMatrix4(WP), jP.intersectBox(this.singleBBox, HP))) {
            let s = HP.applyMatrix4(i), o = e.ray.origin.distanceTo(s);
            n.push({
                distance: o,
                point: s.clone(),
                object: this
            });
        }
    }
};
var zr = 1e-4, Ns, YP, QP, KP, qP = new A, XP = new A;
ju.then((r1)=>{
    Ns = r1, YP = [
        Ns.get_face_center,
        Ns.get_edge_midpoint,
        Ns.get_vertex_position
    ], QP = [
        Ns.get_face_normal,
        Ns.get_edge_normal,
        Ns.get_vertex_normal
    ], KP = [
        Ns.face_count,
        Ns.edge_count,
        Ns.vertex_count
    ];
});
var VW = new ae, HW = new ae, xa = new A, Rl = new A, Rf = new A, Mw = new A, WW = new A, jW = new A;
var _o = new VP, hr = class extends Iu(pt) {
    constructor(e, n){
        super();
        this.parameters = n;
        this.objectForSample = void 0;
        this._pendingMediaLoad = !1;
        this.object = e;
    }
    resetOnMove() {
        this.removeFromParent(), this.parent = null;
    }
    expandClones(e) {
        if (this.parent === null) this.updateState(this.parameters, e);
        else for (let n of this.children)n instanceof dn && n.expand();
    }
    invalidateTransform(e) {
        this.matrixWorldNeedsUpdate = !0, this.traverse((n)=>{
            n instanceof dn && n.object === e && (n.matrixWorldNeedsUpdate = !0);
        });
    }
    onObjUpdateMatrix() {
        this.parameters.type !== "toObject" && (this.matrixWorldNeedsUpdate = !0);
    }
    update() {
        switch(this._updateCount(), this.parameters.type){
            case "radial":
                this._updateRadial(this.parameters);
                break;
            case "linear":
                this._updateLinear(this.parameters);
                break;
            case "grid":
                this._updateGrid(this.parameters);
                break;
            case "toObject":
                this._updateToObject(this.parameters);
        }
        for (let e of this.children)e.updateMatrix(), e.hasNonUniformScale && (e.updateMatrixWorld(), e.updateMatrixWorldSVD());
    }
    _updateCount(e) {
        let n;
        if (e !== void 0 ? n = e : n = this.parameters.type === "grid" ? Math.round(this.parameters.grid.count[0]) * Math.round(this.parameters.grid.count[1]) * Math.round(this.parameters.grid.count[2]) : this.parameters.count, this.parameters.type === "toObject" && !this.parameters.toObject.object && (n = 0), this.parameters.type === "toObject" && this.objectForSample) {
            for(let s = 0, o = this.children.length; s < o; ++s)this.remove(this.children[0]);
            let i = this.children;
            if (i.length === n) return;
            if (i.length < n) for(let s = 0, o = n - i.length; s < o; ++s){
                let a = new dn(this.object);
                a.expand(), this.add(a);
            }
            else for(let s = 0, o = i.length - n; s < o; ++s)this.remove(i[s]);
        } else {
            if (this.children.length === n) return;
            if (this.children.length < n) for(let i = 0, s = n - this.children.length; i < s; ++i){
                let o = new dn(this.object);
                o.expand(), this.add(o);
            }
            else for(let i = 0, s = this.children.length - n; i < s; ++i)this.remove(this.children[0]);
        }
    }
    _updateRadial(e) {
        let n = e.radial, i = n.start * He.DEG2RAD, s = n.end * He.DEG2RAD, o = i - s, a = new Wt(n.rotation[0], n.rotation[1], n.rotation[2]), l;
        switch(n.axis){
            case "z":
                l = new A(0, 0, 1);
                break;
            case "y":
                l = new A(0, 1, 0);
                break;
            default:
            case "x":
                l = new A(1, 0, 0);
                break;
        }
        let u = e.randomnessObject ?? Ms.defaultData([
            1,
            1,
            1
        ]).randomnessObject, c = u.noiseType === "perlin";
        _o.noiseSeed(u.seed);
        let d = Pg((0, bd.default)(u.seed)), h = Of(u.strength, this.parameters.randomness);
        for (let [f, m] of this.children.entries()){
            let p = f * (u.freqScale / 10) + u.movement, g = c ? _o.noise(p) : d(p, p);
            m.scale.x = n.scale[0] + h(f, rt(g, u.scale[0])) || zr, m.scale.y = n.scale[1] + h(f, rt(g, u.scale[1])) || zr, m.scale.z = n.scale[2] + h(f, rt(g, u.scale[2])) || zr, m.position.setScalar(0);
            let y = o / e.count * f - i;
            switch(n.axis){
                case "x":
                    m.rotation.set(0, y, 0);
                    break;
                case "y":
                    m.rotation.set(0, 0, y);
                    break;
                case "z":
                    m.rotation.set(y, 0, 0);
                    break;
            }
            m.translateOnAxis(l, n.radius), m.position.x += n.position[0] + h(f, rt(g, u.position[0])), m.position.y += n.position[1] + h(f, rt(g, u.position[1])), m.position.z += n.position[2] + h(f, rt(g, u.position[2]));
            let v = h(f, rt(g, u.rotation[0])), x = h(f, rt(g, u.rotation[1])), w = h(f, rt(g, u.rotation[2]));
            n.alignment === !0 ? (m.rotation.x += a.x + v, m.rotation.y += a.y + x, m.rotation.z += a.z + w) : m.rotation.set(a.x + v, a.y + x, a.z + w);
        }
    }
    _updateLinear(e) {
        if (e.type !== "linear") throw new Error;
        let n = e.linear, i = new Wt(n.rotation[0], n.rotation[1], n.rotation[2]), s = e.randomnessObject ?? Ms.defaultData([
            1,
            1,
            1
        ]).randomnessObject, o = s.noiseType === "perlin";
        _o.noiseSeed(s.seed);
        let a = Pg((0, bd.default)(s.seed)), l = Of(s.strength, this.parameters.randomness);
        for (let [u, c] of this.children.entries()){
            let d = u * (s.freqScale / 10) + s.movement, h = o ? _o.noise(d) : a(d, d), f = l(u, rt(h, s.rotation[0])), m = l(u, rt(h, s.rotation[1])), p = l(u, rt(h, s.rotation[2]));
            c.scale.x = 1 + (n.scale[0] - 1) * u + l(u, rt(h, s.scale[0])) || zr, c.scale.y = 1 + (n.scale[1] - 1) * u + l(u, rt(h, s.scale[1])) || zr, c.scale.z = 1 + (n.scale[2] - 1) * u + l(u, rt(h, s.scale[2])) || zr, c.rotation.x = i.x * u + f, c.rotation.y = i.y * u + m, c.rotation.z = i.z * u + p, c.position.x = n.position[0] * u + l(u, rt(h, s.position[0])), c.position.y = n.position[1] * u + l(u, rt(h, s.position[1])), c.position.z = n.position[2] * u + l(u, rt(h, s.position[2]));
        }
    }
    _updateGrid(e) {
        let n = 0, i = e.grid, s = e.randomnessObject ?? Ms.defaultData([
            1,
            1,
            1
        ]).randomnessObject, o = Of(s.strength, this.parameters.randomness), a = s.noiseType === "perlin";
        _o.noiseSeed(s.seed);
        let l = oC((0, bd.default)(s.seed));
        if (i.useCenter === !0) {
            let u = {
                x: i.count[0] % 2 === 0 ? 2 : 1,
                y: i.count[1] % 2 === 0 ? 2 : 1,
                z: i.count[2] % 2 === 0 ? 2 : 1
            }, c = new A(i.size[0] * (i.count[0] - u.x) * .5, i.size[1] * (i.count[1] - u.y) * .5, i.size[2] * (i.count[2] - u.z) * .5);
            for(let d = 0; d < i.count[0]; d++)for(let h = 0; h < i.count[1]; h++)for(let f = 0; f < i.count[2]; f++){
                let m = [
                    (d + 1) * (s.freqScale / 10) + s.movement,
                    (h + 1) * (s.freqScale / 10) + s.movement,
                    (f + 1) * (s.freqScale / 10) + s.movement
                ], p = a ? _o.noise(...m) : l(...m), g = this.children[n++];
                g.scale.x = 1 + o(n, rt(p, s.scale[0])) || zr, g.scale.y = 1 + o(n, rt(p, s.scale[1])) || zr, g.scale.z = 1 + o(n, rt(p, s.scale[2])) || zr;
                let y = o(n, rt(p, s.rotation[0])), v = o(n, rt(p, s.rotation[1])), x = o(n, rt(p, s.rotation[2]));
                g.rotation.set(y, v, x), g.position.x = i.size[0] * d - c.x + o(n, rt(p, s.position[0])), g.position.y = i.size[1] * h - c.y + o(n, rt(p, s.position[1])), g.position.z = i.size[2] * f - c.z + o(n, rt(p, s.position[2]));
            }
        } else for(let u = 0; u < i.count[0]; u++)for(let c = 0; c < i.count[1]; c++)for(let d = 0; d < i.count[2]; d++){
            let h = [
                (u + 1) * (s.freqScale / 10) + s.movement,
                (c + 1) * (s.freqScale / 10) + s.movement,
                (d + 1) * (s.freqScale / 10) + s.movement
            ], f = a ? _o.noise(...h) : l(...h), m = this.children[n++];
            m.scale.x = 1 + o(n, rt(f, s.scale[0])) || zr, m.scale.y = 1 + o(n, rt(f, s.scale[1])) || zr, m.scale.z = 1 + o(n, rt(f, s.scale[2])) || zr;
            let p = o(n, rt(f, s.rotation[0])), g = o(n, rt(f, s.rotation[1])), y = o(n, rt(f, s.rotation[2]));
            m.rotation.set(p, g, y), m.position.x = i.size[0] * u + o(n, rt(f, s.position[0])), m.position.y = -i.size[1] * c + o(n, rt(f, s.position[1])), m.position.z = -i.size[2] * d + o(n, rt(f, s.position[2]));
        }
    }
    _updateToObject(e) {
        if (e.type !== "toObject") throw new Error;
        let { toObject: n  } = e, i = new Wt(n.rotation[0], n.rotation[1], n.rotation[2]), s = e.randomnessObject ?? Ms.defaultData([
            1,
            1,
            1
        ]).randomnessObject, o = s.noiseType === "perlin";
        _o.noiseSeed(s.seed);
        let a = Pg((0, bd.default)(s.seed)), l = Of(s.strength, this.parameters.randomness);
        if (!n.object) {
            for (let [, y] of this.children.entries())y.position.set(0, 0, 0), y.scale.setScalar(1), y.rotation.set(0, 0, 0);
            this.objectForSample = void 0;
            return;
        }
        if (!this.objectForSample) return;
        if (this.objectForSample instanceof xd) {
            if (!this.objectForSample.font?.isLoaded || this.objectForSample.geometry.attributes.position === void 0) {
                this._pendingMediaLoad = !0;
                return;
            } else this._pendingMediaLoad = !1;
        }
        if (this.objectForSample.geometry === void 0 && this.objectForSample.isAncestorOf(this.object.uuid)) {
            console.warn(`Oh no! The object "${this.object.name}" (${this.object.uuid}) seem to be a child/descendant of the object it's being cloned to. Please re-parent it so that they are siblings instead.`);
            return;
        }
        let u = this.getSubdivData(), c = [], d = (y)=>{
            let v = y.length, x = y.map((_)=>_[0]).reduce((_, M)=>_ + M, 0), w = y.map((_)=>_[1]).reduce((_, M)=>_ + M, 0), S = y.map((_)=>_[2]).reduce((_, M)=>_ + M, 0);
            return [
                x / v,
                w / v,
                S / v
            ];
        }, h = (y)=>Math.round(y * 1e6) / 1e6;
        u.forEach((y)=>{
            let v = u.filter((x)=>h(y.pos[0]) === h(x.pos[0]) && h(y.pos[1]) === h(x.pos[1]) && h(y.pos[2]) === h(x.pos[2]));
            v.length > 1 ? c.push({
                pos: y.pos,
                norm: d(v.map((x)=>x.norm))
            }) : c.push(y);
        });
        let f = kP(c);
        if (u.length > 0) {
            let y = Math.round(f.length * n.count / 100);
            this._updateCount(y);
        }
        this.objectForSample.updateMatrixWorld();
        let m = new Dg(this.objectForSample).build(), p = FP[n.axis], g = this.children;
        m.setRandomGenerator((0, bd.default)(this.object.uuid + n.seed));
        for (let [y, v] of g.entries()){
            let x = y * (s.freqScale / 10) + s.movement, w = o ? _o.noise(x) : a(x, x), S = l(y, rt(w, s.rotation[0])), _ = l(y, rt(w, s.rotation[1])), M = l(y, rt(w, s.rotation[2]));
            n.spreadType === "random" ? m.sample(Rf, Mw) : (f.length && (Rf.fromArray(f[y].pos), Mw.fromArray(f[y].norm)), this.objectForSample instanceof rs && Rf.applyMatrix4(VW.copy(this.objectForSample.matrixWorld).invert())), Rf.applyMatrix4(this.object.hiddenMatrix.clone().invert()), v.position.copy(Rf), xa.fromArray(p);
            let b = n.align === "normal" ? Mw : this.object.getWorldDirection(jW), T = Rl.fromArray(n.position);
            Rl.x += Rl.x + l(y, rt(w, s.position[0])), Rl.y += Rl.y + l(y, rt(w, s.position[1])), Rl.z += Rl.z + l(y, rt(w, s.position[2]));
            let E = Math.acos(b.dot(xa)), P = WW.crossVectors(xa, b).normalize(), D = HW.makeRotationAxis(P, E), C = b.clone().cross(this.object.up).normalize(), O = C.clone().cross(b).normalize(), B = new ae().makeBasis(C, b, O), V = new A(xa.y, xa.z, xa.x).normalize(), Y = V.clone().cross(xa).normalize(), W = new ae().makeBasis(V, xa, Y).invert(), q = new ae().multiplyMatrices(B, W);
            v.rotation.setFromRotationMatrix(q), T.applyMatrix4(D), v.position.add(T), v.rotation.x = v.rotation.x + i.x + S, v.rotation.y = v.rotation.y + i.y + _, v.rotation.z = v.rotation.z + i.z + M, v.scale.setScalar(1), v.scale.x = v.scale.x + n.scale[0] + l(y, rt(w, s.scale[0])) || zr, v.scale.y = v.scale.y + n.scale[1] + l(y, rt(w, s.scale[1])) || zr, v.scale.z = v.scale.z + n.scale[2] + l(y, rt(w, s.scale[2])) || zr, v.scale.multiply(this.object.scale), v.hiddenMatrix = this.object.hiddenMatrix;
        }
    }
    getSubdivData() {
        if (!this.objectForSample) return [];
        let e = this.parameters.toObject.spreadType;
        if (e === "random") return [];
        if (this.objectForSample instanceof rs) {
            let n = this.objectForSample, i = UP[e], s = KP[i], o = YP[i], a = QP[i], l = [], u = s(n.subdivPointerNew);
            for(let c = 0; c <= u - 1; c++){
                let d = o(n.subdivPointerNew, c), h = a(n.subdivPointerNew, c);
                qP.fromArray(d).applyMatrix4(n.matrixWorld), XP.fromArray(h), l.push({
                    pos: qP.toArray(),
                    norm: XP.toArray()
                });
            }
            return l;
        } else return (this.objectForSample.geometry.index ? zP(this.objectForSample.geometry) : GP(this.objectForSample.geometry)).map((i, s)=>e === "polygon_center" ? {
                pos: i.midpoint,
                norm: i.norm
            } : e === "vertex" ? [
                {
                    pos: i.vertices[0],
                    norm: i.norm
                },
                {
                    pos: i.vertices[1],
                    norm: i.norm
                },
                {
                    pos: i.vertices[2],
                    norm: i.norm
                }
            ] : e === "edge" ? [
                {
                    pos: i.faceCenters[0],
                    norm: i.norm
                },
                {
                    pos: i.faceCenters[1],
                    norm: i.norm
                },
                {
                    pos: i.faceCenters[2],
                    norm: i.norm
                }
            ] : []).flat();
    }
    updateState(e, n) {
        if (this.parameters = fo(e), this.parameters.type !== "toObject") (this.parent === null || this.parent !== this.object) && (this.removeFromParent(), this.object.parent?.add(this), this.matrix = this.object.matrix, this.hiddenMatrix = this.object.hiddenMatrix, this.matrixWorldNeedsUpdate = !0, this.matrixAutoUpdate = !1);
        else if (this.parent === null || this.parent.uuid !== this.parameters.toObject.object) {
            this.removeFromParent();
            let i = n.find(this.parameters.toObject.object);
            i instanceof kt ? this.objectForSample = i : this.objectForSample = void 0, this.matrix = new ae, this.hiddenMatrix = new ae, this.matrixWorldNeedsUpdate = !0, this.matrixAutoUpdate = !1, i && i.add(this);
        }
        this.update();
    }
    get pendingMediaLoad() {
        return this._pendingMediaLoad;
    }
};
var Bs = (r1)=>{
    var t;
    return t = class extends r1 {
    }, t.geometryHelper = new er(30, 30, 30), t;
};
var dy = new Fi, Tw = new Rn, ZP = new ae, Fs = (r1, t, e, n, i = !1)=>{
    let s = t, o = r1.matrixWorld;
    if (s.boundingSphere === null && s.computeBoundingSphere(), Tw.copy(s.boundingSphere), Tw.applyMatrix4(o), e.ray.intersectsSphere(Tw) === !1 || (ZP.copy(o).invert(), dy.copy(e.ray).applyMatrix4(ZP), s.boundingBox !== null && dy.intersectsBox(s.boundingBox) === !1)) return;
    let a, l, u, c, d = s.index, h = s.attributes.position, f = s.drawRange, m, p;
    if (i === !1) {
        let y = Math.max(0, f.start), v = Math.min(d.count, f.start + f.count);
        for(m = y, p = v; m < p; m += 3)if (l = d.getX(m), u = d.getX(m + 1), c = d.getX(m + 2), a = g(r1, e, dy, h, l, u, c), a) {
            a.faceIndex = Math.floor(m / 3), n.push(a);
            return;
        }
    } else {
        let v = s.attributes.position, x = new A, w = new A, S = new A, _ = new A, M = 2, T = 1 / ((r1.scale.x + r1.scale.y + r1.scale.z) / 3), E = T * T, P = Math.max(0, f.start), D = Math.min(v.count, f.start + f.count);
        for(let C = P, O = D - 1; C < O; C += M){
            if (x.fromBufferAttribute(v, C), w.fromBufferAttribute(v, C + 1), dy.distanceSqToSegment(x, w, _, S) > E) continue;
            _.applyMatrix4(r1.matrixWorld);
            let V = e.ray.origin.distanceTo(_);
            V < e.near || V > e.far || n.push({
                distance: V,
                point: S.clone().applyMatrix4(r1.matrixWorld),
                object: r1
            });
        }
    }
    function g(y, v, x, w, S, _, M) {
        let b = new A, T = new A, E = new A, P = new A, D = new A;
        if (b.fromBufferAttribute(w, S), T.fromBufferAttribute(w, _), E.fromBufferAttribute(w, M), x.intersectTriangle(b, T, E, !1, P) === null) return null;
        D.copy(P), D.applyMatrix4(y.matrixWorld);
        let O = v.ray.origin.distanceTo(D);
        return O < v.near || O > v.far ? null : {
            faceIndex: 1,
            distance: O,
            point: D.clone(),
            object: y
        };
    }
};
var hy = new A, Ci = new ki, Ew = class extends qo {
    constructor(e){
        let n = new Me, i = new vi({
            color: 16777215,
            vertexColors: !0,
            toneMapped: !1
        }), s = [], o = [], a = {}, l = new Ne(15711266), u = new Ne(15711266), c = new Ne(2857471);
        d("n1", "n2", l), d("n2", "n4", l), d("n4", "n3", l), d("n3", "n1", l), d("f1", "f2", l), d("f2", "f4", l), d("f4", "f3", l), d("f3", "f1", l), d("n1", "f1", l), d("n2", "f2", l), d("n3", "f3", l), d("n4", "f4", l), d("p", "n1", u), d("p", "n2", u), d("p", "n3", u), d("p", "n4", u), d("u1", "u2", c), d("u2", "u3", c), d("u3", "u1", c);
        function d(f, m, p) {
            h(f, p), h(m, p);
        }
        function h(f, m) {
            s.push(0, 0, 0), o.push(m.r, m.g, m.b), a[f] === void 0 && (a[f] = []), a[f].push(s.length / 3 - 1);
        }
        n.setAttribute("position", new Ae(s, 3)), n.setAttribute("color", new Ae(o, 3));
        super(n, i);
        this.type = "CameraHelper", this.camera = e, this.camera.updateProjectionMatrix && this.camera.updateProjectionMatrix(), this.matrix = e.matrixWorld, this.matrixAutoUpdate = !1, this.pointMap = a, this.update();
    }
    update() {
        let e = this.geometry, n = this.pointMap, i = !0;
        Ci.projectionMatrixInverse.elements = [
            .5112609807824982,
            -0,
            -0,
            -0,
            -0,
            .41421356237309503,
            -0,
            -0,
            -0,
            -0,
            -0,
            -0.099999,
            -0,
            -0,
            -1.0000000000000002,
            .100001
        ];
        let s = 1, o = 1, a = i ? .8 : 1e-4;
        is("n1", n, e, Ci, -s, -o, a), is("n2", n, e, Ci, s, -o, a), is("n3", n, e, Ci, -s, o, a), is("n4", n, e, Ci, s, o, a);
        let l = a;
        is("f1", n, e, Ci, -s, -o, l), is("f2", n, e, Ci, s, -o, l), is("f3", n, e, Ci, -s, o, l), is("f4", n, e, Ci, s, o, l);
        let u = l, c = .5;
        is("u1", n, e, Ci, s * .7 * c, o * 1.1, u), is("u2", n, e, Ci, -s * .7 * c, o * 1.1, u), is("u3", n, e, Ci, 0, o * (1.1 + .9 * c), u), e.getAttribute("position").needsUpdate = !0;
    }
    dispose() {
        this.geometry.dispose(), this.material.dispose();
    }
};
function is(r1, t, e, n, i, s, o) {
    hy.set(i, s, o).unproject(n);
    let a = t[r1];
    if (a !== void 0) {
        let l = e.getAttribute("position");
        for(let u = 0, c = a.length; u < c; u++)l.setXYZ(a[u], hy.x, hy.y, hy.z);
    }
}
var fy = class extends Bs(Ew) {
    constructor(e){
        super(e);
        this.object = e;
        this.object = e, this.name = `CombinedCameraHelper: ${e.uuid}`;
    }
    updateMatrixWorld(e) {
        super.updateMatrixWorld(e), this.updateTarget();
    }
    updateTarget() {
        let e = this.object.getTarget();
        this.updateWorldMatrix(!0, !1), this.worldToLocal(e);
    }
    raycast(e, n) {
        Fs(this.object, this.geometry, e, n, !0);
    }
};
var py;
((t)=>t.is = (e)=>"objectHelper" in e)(py || (py = {}));
var ba = (r1, t)=>class extends Rg(r1) {
        constructor(){
            super(...arguments);
            this.objectHelper = new t(this);
            this.gizmos = {};
        }
        get geometryHelper() {
            return t.geometryHelper;
        }
        raycast(i, s) {
            this.objectHelper.raycast(i, s);
        }
        showGizmos() {
            for(let i in this.gizmos){
                let s = this.gizmos[i];
                s instanceof Qo && (s.visible = !0);
            }
        }
        updateEntityBoxSize(i, s) {
            this.objectHelper.visible && this.geometryHelper instanceof er ? (i.setScalar(0), s.set(this.geometryHelper.parameters.width, this.geometryHelper.parameters.height, this.geometryHelper.parameters.height).multiplyScalar(.5)) : super.updateEntityBoxSize(i, s);
        }
        hideGizmos() {
            for(let i in this.gizmos){
                let s = this.gizmos[i];
                s instanceof Qo && (s.visible = !1);
            }
        }
    };
var Cw = 790, wd = new A, Pw = new A, Dw = new Je, Iw = new A, Lf = new A, Ow = new A, Yt = class extends ba(ki, fy) {
    constructor(e = "", n = {
        ...fu.defaultData,
        name: ""
    }){
        super();
        this._cameraType = "OrthographicCamera";
        this.targetOffset = fl.DefaultTargetOffset;
        this.isUpVectorFlipped = !1;
        this.angleOffsetFromUp = 0;
        this.wasMovedByUser = !1;
        this.wasMovedBySwitchCameraAction = !1;
        this.super_Entity(e, n), this.previousProjectionMatrix = new ae, this.matrixAutoUpdate = !0, this.width = window.innerWidth, this.height = window.innerHeight;
        let i = this.width, s = this.height;
        if (n.orthographic.autoZoom) {
            let o = n.orthographic.autoZoomFrustumSize ?? Cw, a = i / s, l = i > s ? a : 1, u = i > s ? 1 : a;
            this.orthoCamera = new ja(-o * .5 * l, o * .5 * l, o * .5 * (1 / u), -o * .5 * (1 / u), -50000, 1e4);
        } else this.orthoCamera = new ja(i * -0.5, i * .5, s * .5, s * -0.5, -50000, 1e4);
        this.perspCamera = new gn(45, i / s, 50, 1e4), this.left = this.orthoCamera.left, this.right = this.orthoCamera.right, this.top = this.orthoCamera.top, this.bottom = this.orthoCamera.bottom, this.far = this.orthoCamera.far, this.view = this.orthoCamera.view, this.aspect = this.perspCamera.aspect, this.focus = this.perspCamera.focus, this.filmGauge = this.perspCamera.filmGauge, this.filmOffset = this.perspCamera.filmOffset, this.objectHelper.update();
    }
    get isPerspectiveCamera() {
        return this.cameraType === "PerspectiveCamera";
    }
    get isOrthographicCamera() {
        return !this.isPerspectiveCamera;
    }
    get cameraType() {
        return this._cameraType;
    }
    set fov(e) {
        this.perspCamera.fov = e;
    }
    get fov() {
        return this.perspCamera.fov;
    }
    setNear(e, n) {
        e === "PerspectiveCamera" ? this.perspCamera.near = n : this.orthoCamera.near = n;
    }
    setZoom(e, n) {
        n >= 0 && (e === "PerspectiveCamera" ? this.perspCamera.zoom = n : this.orthoCamera.zoom = n);
    }
    set cameraType(e) {
        e === "PerspectiveCamera" ? this.toPerspective() : e === "OrthographicCamera" && this.toOrthographic();
    }
    get near() {
        return this._cameraType === "PerspectiveCamera" ? this.perspCamera.near : this.orthoCamera.near;
    }
    set near(e) {
        this._cameraType === "PerspectiveCamera" ? this.perspCamera.near = e : this.orthoCamera.near = e;
    }
    get zoom() {
        return this._cameraType === "PerspectiveCamera" ? this.perspCamera.zoom : this.orthoCamera.zoom;
    }
    set zoom(e) {
        e >= 0 && (this._cameraType === "PerspectiveCamera" ? this.perspCamera.zoom = e : this.orthoCamera.zoom = e);
    }
    lookAt(e, n, i) {
        typeof e == "number" && (e = new A(e, n, i)), super.lookAt(e), this.getWorldPosition(wd), this.targetOffset = wd.distanceTo(e);
    }
    getTarget(e = new A) {
        return this.getWorldDirection(Pw), this.getWorldPosition(wd), Pw.multiplyScalar(this.targetOffset), e.copy(wd).add(Pw), e;
    }
    getDistanceToTarget() {
        let e = this.getTarget();
        return this.getWorldPosition(wd), wd.distanceTo(e);
    }
    updateUp() {
        this.getWorldQuaternion(Dw), Iw.set(0, 0, 1).applyQuaternion(Dw), Lf.copy(pt.DEFAULT_UP), this.isUpVectorFlipped && Lf.negate(), Lf.applyQuaternion(Dw), Ow.copy(pt.DEFAULT_UP).projectOnPlane(Iw), this.angleOffsetFromUp = Ow.angleTo(Lf), this.angleOffsetFromUp *= Ow.cross(Lf).dot(Iw) >= 0 ? 1 : -1;
    }
    updateTransformState(e) {
        let n = super.updateTransformState(e);
        return e.isUpVectorFlipped !== void 0 && (this.isUpVectorFlipped = e.isUpVectorFlipped), this.updateUp(), n;
    }
    getViewFrontToObject(e) {
        let n = e.getWorldPosition(new A), s = e.getWorldDirection(new A).multiplyScalar(this.targetOffset);
        return {
            position: n.clone().add(s),
            target: n
        };
    }
    getViewToObject(e) {
        let n = e.getWorldPosition(new A), s = this.getWorldDirection(new A).multiplyScalar(this.targetOffset);
        return {
            position: n.clone().sub(s),
            target: n
        };
    }
    setViewplaneSize(e, n) {
        if (this.aspect = e / n, this.data.type === "OrthographicCamera" && this.data.orthographic.autoZoom) {
            let i = this.data.orthographic.autoZoomFrustumSize ?? Cw, s = e > n ? this.aspect : 1, o = e > n ? 1 : this.aspect;
            this.left = -i * .5 * s, this.right = i * .5 * s, this.top = i * .5 * (1 / o), this.bottom = -i * .5 * (1 / o);
        } else this.left = -e * .5, this.right = e * .5, this.top = n * .5, this.bottom = -n * .5;
        this.updateProjectionMatrix();
    }
    toOrthographic() {
        this.orthoCamera.left = this.left, this.orthoCamera.right = this.right, this.orthoCamera.top = this.top, this.orthoCamera.bottom = this.bottom, this.orthoCamera.view = this.view, this.orthoCamera.far = this.far, this.orthoCamera.updateProjectionMatrix(), this.projectionMatrix = this.orthoCamera.projectionMatrix, this.projectionMatrixInverse = this.orthoCamera.projectionMatrixInverse, this._cameraType = "OrthographicCamera", this.objectHelper && this.objectHelper.update();
    }
    toPerspective() {
        this.perspCamera.aspect = this.aspect, this.perspCamera.fov = this.fov, this.perspCamera.view = this.view, this.perspCamera.far = this.far, this.perspCamera.updateProjectionMatrix(), this.projectionMatrix = this.perspCamera.projectionMatrix, this.projectionMatrixInverse = this.perspCamera.projectionMatrixInverse, this._cameraType = "PerspectiveCamera", this.objectHelper && this.objectHelper.update();
    }
    setFocalLength(e) {
        this.perspCamera.setFocalLength(e), this.toPerspective();
    }
    getFocalLength() {
        return this.perspCamera.getFocalLength();
    }
    getEffectiveFOV() {
        return this.perspCamera.getEffectiveFOV();
    }
    getFilmWidth() {
        return this.perspCamera.getFilmWidth();
    }
    getFilmHeight() {
        return this.perspCamera.getFilmHeight();
    }
    setViewOffset(e, n, i, s, o, a) {
        this._cameraType === "PerspectiveCamera" ? this.perspCamera.setViewOffset(e, n, i, s, o, a) : this.orthoCamera.setViewOffset(e, n, i, s, o, a);
    }
    clearViewOffset() {
        this._cameraType === "PerspectiveCamera" ? (this.perspCamera.clearViewOffset(), this.toPerspective()) : (this.orthoCamera.clearViewOffset(), this.toOrthographic());
    }
    copyHistory() {
        this.previousProjectionMatrix && this.previousProjectionMatrix.copy(this.projectionMatrix);
    }
    updateProjectionMatrix() {
        this._cameraType === "PerspectiveCamera" ? this.toPerspective() : this._cameraType === "OrthographicCamera" && this.toOrthographic();
    }
    updateMatrixWorld(e) {
        super.updateMatrixWorld(e), this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    updateWorldMatrix(e, n) {
        super.updateWorldMatrix(e, n), this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    copy(e, n) {
        return super.copy(e, n), this.parent = e.parent, this.orthoCamera.copy(e.orthoCamera), this.perspCamera.copy(e.perspCamera), this.left = e.left, this.right = e.right, this.top = e.top, this.bottom = e.bottom, this.far = e.far, this.view = e.view === null ? null : Object.assign({}, e.view), this._cameraType = e._cameraType, this.aspect = e.aspect, this.fov = e.fov, this.focus = e.focus, this.filmGauge = e.filmGauge, this.filmOffset = e.filmOffset, this.targetOffset = e.targetOffset, this.updateProjectionMatrix(), this;
    }
    toCameraState(e = []) {
        let n = {
            type: this.cameraType,
            far: this.far,
            orthographic: {
                near: this.orthoCamera.near,
                zoom: this.orthoCamera.zoom,
                autoZoom: !0,
                autoZoomFrustumSize: Cw
            },
            perspective: {
                near: this.perspCamera.near,
                fov: this.perspCamera.fov,
                zoom: this.perspCamera.zoom
            },
            up: this.up.toArray(),
            targetOffset: this.targetOffset,
            isUpVectorFlipped: this.isUpVectorFlipped
        };
        return $c(n, e);
    }
    updateCameraSubtype(e, n) {
        let i = e === "perspective" ? "PerspectiveCamera" : "OrthographicCamera";
        n.zoom !== void 0 && this.setZoom(i, n.zoom), n.near !== void 0 && this.setNear(i, n.near), n.fov !== void 0 && i === "PerspectiveCamera" && (this.fov = n.fov);
    }
    updateState(e, n) {
        this.updateCameraState(e, n);
    }
    updateCameraState(e, n) {
        this.updateState_Entity(e, n), e.far !== void 0 && (this.far = e.far), e.orthographic !== void 0 && this.updateCameraSubtype("orthographic", e.orthographic), e.perspective !== void 0 && this.updateCameraSubtype("perspective", e.perspective), e.type !== void 0 && (this.cameraType = e.type), e.up !== void 0 && this.up.fromArray(e.up), e.targetOffset !== void 0 && (this.targetOffset = e.targetOffset), e.isUpVectorFlipped !== void 0 && (this.isUpVectorFlipped = e.isUpVectorFlipped), this.updateProjectionMatrix();
    }
    updateByPatchedOp(e, n, i) {
        super.updateByPatchedOp(e, n, i), e.path.length === 1 && e.type === 0 && this.updateCameraSubtype(e.path[0], e.props);
    }
    toState(e) {
        return {
            ...super.toState(e),
            ...this.toCameraState(e),
            type: this.cameraType
        };
    }
};
var Sd = new ae, XW = new ae;
function Rw(r1) {
    let t = !1;
    return r1.scene.objects.traverse((e, n)=>{
        n.geometry?.type === "BooleanGeometry" && (t = !0);
    }), t;
}
var Pi = class extends Rs {
    constructor(e, n, i){
        super(e, n);
        this.data = n;
        this.meshSetAddresses = [];
        this.needsTransformForDownstream = !1;
        this.geometry = new Me;
        this.onAfterRender = (e, n, i, s, o, a)=>{
            super.onAfterRender(e, n, i, s, o, a), this.recomputeBoolean();
        };
        this.geometry.userData.parameters = {
            width: 0,
            height: 0,
            depth: 0
        };
    }
    get booleanOp() {
        return this.data.geometry.operation;
    }
    get phongAngle() {
        return this.data.geometry.phongAngle ?? 45;
    }
    get isLOD() {
        return this.recomputeBoolean(), !1;
    }
    updateByPatchedOp(e, n, i) {
        super.updateByPatchedOp(e, n, i), e.path.length === 1 && e.path[0] === "geometry" && e.type === 0 && e.props.operation !== void 0 && (this.freeBooleanPointer(), this.resetBBoxNeedsUpdate());
    }
    freeBooleanPointer() {
        super.freeBooleanPointer(), this.geometry.dispose();
    }
    recomputeBoolean(e, n = !0) {
        if (this.booleanMeshSetAddress !== -1 && !e) return;
        for(let s = 0; s < this.children.length; s++){
            let o = this.children[s];
            o instanceof Pi && o.recomputeBoolean(e === !0, n);
        }
        this.meshSetAddresses = [];
        for(let s = 0; s < this.children.length; s++){
            let o = this.children[s];
            if (o instanceof kt && o.dataPatched.visible === !0 && o.geometry.attributes.position?.count > 0 && o.geometry.drawRange.count > 0) {
                if (Sd.multiplyMatrices(o.hiddenMatrix, o.matrix), o.booleanMeshSetAddress === -1) {
                    if ((o.geometry.index ?? o.geometry.getAttribute("position")).count / 3 < 15e5 && (o.booleanMeshSetAddress = Ji.getMeshSet(o.geometry, e === !0, n)), o.booleanMeshSetAddress === -1) return;
                    Ji.transformMeshSet(o.booleanMeshSetAddress, Sd), o.booleanMatrixInvOld.copy(Sd).invert(), o.booleanWasTransformed = !1;
                } else o instanceof Pi && o.needsTransformForDownstream === !0 ? (Ji.transformMeshSet(o.booleanMeshSetAddress, Sd), o.needsTransformForDownstream = !1) : o.booleanWasTransformed === !0 && (Ji.transformMeshSet(o.booleanMeshSetAddress, XW.multiplyMatrices(Sd, o.booleanMatrixInvOld)), o.booleanMatrixInvOld.copy(Sd).invert(), o.booleanWasTransformed = !1);
                this.meshSetAddresses.push(o.booleanMeshSetAddress);
            }
        }
        if (this.meshSetAddresses.length === 0) {
            this.geometry.setAttribute("position", new Ae([], 0)), this.geometry.setDrawRange(0, 0);
            return;
        }
        if (e === !0) return Ji.calcBooleanTopological(this.meshSetAddresses, this.booleanOp);
        let i = this.geometry;
        i.dispose(), this.geometry = new Me, this.geometry.userData = i.userData, this.geometry.boundingSphere = i.boundingSphere;
        try {
            this.booleanMeshSetAddress = Ji.calcBoolean(this.meshSetAddresses, this.booleanOp, this.geometry, this.phongAngle);
        } catch (s) {
            this.booleanMeshSetAddress = 0, console.error(s);
        }
        this.booleanMatrixInvOld.copy(this.matrix).invert(), this.needsTransformForDownstream = !0, gd(this), yd(this);
    }
    dispose() {
        super.dispose(), this.geometry.dispose();
    }
};
var my;
((t)=>{
    function r1(e) {
        return St.is(e) && e instanceof Xo;
    }
    t.is = r1;
})(my || (my = {}));
var Ad = (r1, t)=>class extends ba(r1, t) {
        updateState_Light(n, i) {
            this.updateState_Entity(n, i), n.color !== void 0 && (this.color = i.shared.color(n.color)), n.intensity !== void 0 && (this.intensity = n.intensity), n.depth !== void 0 && (this.shadow.camera.far = n.depth, this.shadow.needsUpdate = !0), n.shadows !== void 0 && (this.castShadow = n.shadows);
        }
    };
var Zr = (r1)=>r1 instanceof kt, Gr = (r1)=>r1 !== null && r1 instanceof Pi, JP = (r1)=>r1 instanceof Yt, $P = (r1)=>my.is(r1), Lw = (r1)=>py.is(r1);
var wa = class extends Bs(nm) {
    constructor(e, n = 15){
        super(n);
        this.object = e;
        this.object.updateMatrixWorld(), this.name = `EmptyObjectHelper: ${e.uuid}`, this.matrix = e.matrixWorld, this.matrixAutoUpdate = !1;
    }
    raycast(e, n) {
        Fs(this.object, wa.geometryHelper, e, n);
    }
    update() {}
};
var Mo = class extends ba(ms, wa) {
    constructor(t, e){
        super(), this.super_Entity(t, e), this.objectHelper.update();
    }
    updateState(t, e) {
        this.updateState_Entity(t, e);
    }
};
var _d = class extends Bs(tm) {
    constructor(e, n = 15, i = 10066329){
        super(e, n, i);
        this.object = e;
        this.added = !1;
        this.name = `DirectionalLightHelper: ${e.uuid}`;
    }
    raycast(e, n) {
        Fs(this.object, _d.geometryHelper, e, n);
    }
};
var Md = class extends Bs(em) {
    constructor(e, n = 15, i = 6710886){
        super(e, n, i);
        this.object = e;
        this.name = `PointLightHelper: ${e.uuid}`;
    }
    raycast(e, n) {
        Fs(this.object, Md.geometryHelper, e, n);
    }
};
var gy = class extends Bs($p) {
    constructor(e, n = 6710886){
        super(e, n);
        this.object = e;
        this.name = `SpotLightHelper: ${e.uuid}`;
    }
    raycast(e, n) {
        Fs(this.object, gy.geometryHelper, e, n);
    }
    update() {
        if (this.object !== void 0) {
            let e = gy._vector, n = this.object.distance ? this.object.distance : 1e3, i = n * Math.tan(this.object.angle);
            this.cone.scale.set(i, i, n), e.setFromMatrixPosition(this.object.target.matrixWorld), this.cone.lookAt(e);
            let s = this.color !== void 0 ? this.color : this.light.color;
            if (this.cone.material instanceof Array) for(let o = 0, a = this.cone.material.length; o < a; o++)this.cone.material[o].color.set(s);
            else this.cone.material.color.set(s);
        }
    }
}, Nf = gy;
Nf._vector = new A;
function YW(r1, t) {
    r1.shadow.camera.right = t / 2, r1.shadow.camera.left = -t / 2, r1.shadow.camera.top = t / 2, r1.shadow.camera.bottom = -t / 2, r1.shadow.needsUpdate = !0;
}
var yy = class extends Ad(Kp, _d) {
    constructor(t, e, n){
        super(), this.super_Entity(t, e), this.castShadow = !0, this.shadow.mapSize.width = 2048, this.shadow.mapSize.height = 2048, this.shadow.normalBias = 1, this.layers.enable(3);
        let s = this.shadow.camera;
        s.top = 1250, s.bottom = -1250, s.right = 1250, s.left = -1250, s.near = -10000, s.far = 2500;
        let o = new Yo(this.shadow.camera);
        o.visible = !1, this.gizmos.shadowmap = o;
    }
    update() {
        this.shadow.camera.updateProjectionMatrix();
        for(let t in this.gizmos){
            let e = this.gizmos[t];
            e instanceof Yo && e.update();
        }
    }
    updateMatrixWorld(t) {
        super.updateMatrixWorld(t), this.objectHelper && this.objectHelper.update();
    }
    updateState(t, e) {
        this.updateState_Light(t, e);
        let n = t.depth !== void 0 && t.depth !== this.shadow.camera.far || t.size !== void 0 && t.size / 2 !== this.shadow.camera.right;
        t.size !== void 0 && YW(this, t.size), t.shadowRadius !== void 0 && (this.shadow.radius = t.shadowRadius), t.shadowResolution !== void 0 && (this.shadow.mapSize.set(t.shadowResolution, t.shadowResolution), this.shadow.map && (this.shadow.map.dispose(), this.shadow.map = null)), n && this.update();
    }
};
var vy = class extends Ad(Qp, Md) {
    constructor(t, e, n){
        super(), this.super_Entity(t, e), this.castShadow = !0, this.shadow.mapSize.width = 1024, this.shadow.mapSize.height = 1024, this.shadow.normalBias = 1, this.layers.enable(3);
        let s = this.shadow.camera;
        s.fov = 90, s.aspect = 1, s.near = 100, s.far = 2500;
        let o = new A(-s.far + this.position.x, -s.far + this.position.y, -s.far + this.position.z), a = new A(s.far + this.position.x, s.far + this.position.y, s.far + this.position.z), l = new Mt(o, a), u = new Qo(l, new Ne(16755200));
        u.visible = !1, this.gizmos.shadowmap = u, this.update();
    }
    update() {
        if (this.shadow && (this.shadow.camera.updateProjectionMatrix(), this.gizmos)) for(let t in this.gizmos){
            let e = this.gizmos[t];
            if (e instanceof Qo) {
                let n = this.shadow.camera, i = new A(-n.far + this.position.x, -n.far + this.position.y, -n.far + this.position.z), s = new A(n.far + this.position.x, n.far + this.position.y, n.far + this.position.z);
                e.box.set(i, s), e.updateMatrixWorld(!0);
            }
        }
    }
    updateMatrixWorld(t) {
        super.updateMatrixWorld(t), this.objectHelper && this.objectHelper.update();
    }
    updateState(t, e) {
        this.updateState_Light(t, e), t.distance !== void 0 && (this.distance = t.distance), t.decay !== void 0 && (this.decay = t.decay), t.shadowRadius !== void 0 && (this.shadow.radius = t.shadowRadius), t.shadowResolution !== void 0 && (this.shadow.mapSize.set(t.shadowResolution, t.shadowResolution), this.shadow.map && (this.shadow.map.dispose(), this.shadow.map = null));
    }
};
var e2 = new A, t2 = new A, n2 = new Je, xy = class extends Ad(Yp, Nf) {
    constructor(t, e, n){
        super(), this.super_Entity(t, e), this.castShadow = !0, this.shadow.mapSize.width = 1024, this.shadow.mapSize.height = 1024, this.shadow.normalBias = 1, this.layers.enable(3);
        let s = this.shadow.camera;
        s.fov = He.RAD2DEG * 2 * this.angle, s.aspect = 1, s.near = 100, s.far = 2500;
        let o = new Yo(this.shadow.camera);
        o.visible = !1, this.gizmos.shadowmap = o, this.update();
    }
    update() {
        this.shadow.camera.updateProjectionMatrix();
        for(let t in this.gizmos){
            let e = this.gizmos[t];
            e instanceof Yo && e.update();
        }
    }
    updateMatrixWorld(t) {
        super.updateMatrixWorld(t), t2.setFromMatrixPosition(this.matrixWorld), n2.setFromRotationMatrix(this.matrixWorld), e2.copy(this.up).applyQuaternion(n2).negate().multiplyScalar(this.distance), this.target.position.copy(t2).add(e2), this.target.updateMatrixWorld(), this.objectHelper && this.objectHelper.update();
    }
    updateState(t, e) {
        this.updateState_Light(t, e), t.distance !== void 0 && (this.distance = t.distance), t.decay !== void 0 && (this.decay = t.decay), t.angle !== void 0 && (this.angle = t.angle), t.penumbra !== void 0 && (this.penumbra = t.penumbra), t.shadowRadius !== void 0 && (this.shadow.radius = t.shadowRadius), t.shadowResolution !== void 0 && (this.shadow.mapSize.set(t.shadowResolution, t.shadowResolution), this.shadow.map && (this.shadow.map.dispose(), this.shadow.map = null));
    }
};
var by = class extends tn {
    get forceComputeSize() {
        return !0;
    }
    get shape() {
        return this.geometry.userData.shape;
    }
    updateEntityBoxSize(t, e) {
        let n = this.geometry.getAttribute("position");
        n !== void 0 ? vf(n, this.geometry.drawRange.start, this.geometry.drawRange.count < 1 / 0 ? this.geometry.drawRange.count : n.count, t, e) : super.updateEntityBoxSize(t, e);
    }
};
var Sa = class extends tn {
    constructor(e, n, i){
        super(e, n, i);
        this._shapeId = null;
        this._context = i;
    }
    updateState(e, n) {
        super.updateState(e, n), this.updateShape();
    }
    updateShape() {
        let e = this.data.geometry.extrusion.shape, n;
        if (e.type === "Custom") {
            let s = e.shapeId;
            if (s !== this._shapeId && this.detachShape(), s) {
                this._shapeId = s;
                let o = this._context.scene.find(s);
                o?.data && (o.attachedPaths.add(this), n = o.geometry.userData?.shape), n || this._context.scene.addPendingCommand(()=>this.updateShape());
            }
        } else {
            let s;
            switch(e.type){
                case "Rectangle":
                    s = jg;
                    break;
                case "Ellipse":
                    s = Gu;
                    break;
                case "Polygon":
                    s = Wg;
                    break;
                case "Star":
                    s = qg;
                    break;
                default:
                    throw new Error(`Unknown shape type: ${e.type}`);
            }
            n = s.create({
                parameters: e
            }).userData.shape;
        }
        let i = this.geometry;
        n && i.inputs && (i.inputs.shapeData = n, i.build(), this.attachedSurfaceCloners.forEach((s)=>s.update()));
    }
    detachShape() {
        this._shapeId !== null && this._context.scene.find(this._shapeId)?.attachedPaths.delete(this);
    }
    createGeometryDelayed(e) {
        this.geometryCreateDeleyed = e.shared, this.updateShape(), this.refreshAttachedPaths(e);
    }
    updateTransformState(e) {
        return super.updateTransformState(e);
    }
    updateGeometryInteractions(e, n) {
        super.updateGeometryInteractions(e, n), this.updateShape();
    }
    updateEntityBoxSize(e, n) {
        let i = this.geometry.getAttribute("position");
        i !== void 0 ? vf(i, this.geometry.drawRange.start, this.geometry.drawRange.count < 1 / 0 ? this.geometry.drawRange.count : i.count, e, n) : super.updateEntityBoxSize(e, n);
    }
};
var ss = class extends ba(ms, wa) {
    constructor(e, n, i){
        super();
        n.type === "Instance" && typeof e == "string" && (n = this.transformAssignData(n, i)), this.super_Entity(e, n), this.objectHelper.update();
    }
    get isComponentRoot() {
        return this.data.type === "Component" && typeof this.identity == "string";
    }
    get isInstanceRoot() {
        return this.data.type === "Instance" && typeof this.identity == "string";
    }
    transformAssignData(e, n) {
        let i = n.scene.data.objects.get(e.component);
        if (i) {
            let s, o;
            for (let a of ca.rootOverrideProps)e[a] === void 0 ? (s === void 0 && (s = {
                ...e
            }), s[a] = i.data[a]) : (o === void 0 && (o = {}), o[a] = e[a]);
            return this.overrideData = o, s ?? e;
        }
        return e;
    }
    updateByOp(e, n, i, s) {
        let o;
        if (this.isInstanceRoot && !s && (n = this.transformAssignData(n, i), e.type === 0 && e.path.length === 0 && this.component)) for (let a of ca.rootOverrideProps)a in e.props && e.props[a] === void 0 && (o === void 0 && (o = {
            ...e,
            props: {
                ...e.props
            }
        }), o.props[a] = this.component.data[a]);
        super.updateByOp(o ?? e, n, i, s);
    }
    updateState(e, n) {
        this.updateState_Entity(e, n);
    }
    expandInstanceChildren(e) {
        let n = this.data;
        if (this.component === void 0) {
            this.component = e.scene.find(n.component) ?? null;
            let i = !1;
            if (this.component !== this.oldComponent) {
                if (this.oldComponent) {
                    let s = 0;
                    for (let o of this.children)if (St.is(o)) e.scene.disposeAndUnregisterEntityRecursivelyIfNotReregistered(o), wy(o), s += 1;
                    else break;
                    this.children.splice(0, s);
                }
                i = !0;
            }
            this.component && i2(e, [
                this.uuid
            ], n.overrides, this, this.component, this.component, 0, i), this.oldComponent = this.component;
        }
    }
};
function wy(r1) {
    if (r1.component) {
        let t = r1.component.instances.indexOf(r1);
        t >= 0 && r1.component.instances.splice(t, 1);
        for (let e of r1.children)St.is(e) && wy(e);
    }
}
function r2(r1, t, e, n) {
    return r1.component === t && al(r1.identity, n) ? r1.overrideData === e ? 2 : 1 : 0;
}
function i2(r1, t, e, n, i, s, o, a) {
    if (o > 50) return !1;
    if (n.component !== i) {
        if (n.component) {
            let u = n.component.instances.indexOf(n);
            u >= 0 && n.component.instances.splice(u, 1);
        }
        i.instances.push(n), n.component = i;
    }
    i instanceof ss && i.isInstanceRoot && i.expandInstanceChildren(r1);
    let l = 0;
    for (let u of i.children)if (St.is(u)) {
        let c = [
            ...t,
            ...typeof u.identity == "string" ? [
                u.identity
            ] : u.identity
        ], d = pu.resolve(e, c, 1), h = null, f;
        if (!a) {
            let m = n.children[l];
            if (h = St.is(m) ? m : null, h !== null) {
                let p = r2(h, u, d, c);
                f = p >= 1 ? h.stateSelection : void 0, p !== 2 && (h = null);
            }
            if (h === null && (h = r1.scene.findInstance(c) ?? null, h !== null)) {
                let p = r2(h, u, d, c);
                if (f = p >= 1 ? h.stateSelection : void 0, p !== 2) h = null;
                else {
                    let g = h.parent.children.indexOf(h);
                    h.parent.children.splice(g, 1), n.children.splice(l, 0, h), h.parent === n ? g <= l && console.error("not possible") : (h.parent = n, h.matrixWorldNeedsUpdate = !0, h.resetBBoxNeedsUpdate(), h.updateVisible(), r1.pendingDeletes.delete(h));
                }
            }
        }
        if (h === null) {
            let m = d ? po.apply(u.data, d) : u.data;
            ji.is(m.type) && (m = {
                ...m,
                type: "Empty"
            }), h = Qi.createEntity(c, m, r1), h.overrideData = d, n.add(h), n.children.splice(n.children.length - 1, 1), n.children.splice(l, 0, h), h.updateState(h.data, r1), f && h.changeSelectedState(f, r1), r1.scene.registerInstanceAndSetUuid(h);
        }
        l += 1, i2(r1, t, e, h, u, s, o + 1, a);
    }
    if (!a) {
        let u = l;
        for(;;){
            let c = n.children[l];
            if (St.is(c)) r1.pendingDeletes.add(c);
            else break;
            l += 1;
        }
        n.children.splice(u, l - u);
    }
    return !0;
}
function QW(r1, t, e) {
    let n;
    return t.geometry.type === "TextGeometry" ? new xd(r1, t, e) : (t.geometry.type === "SubdivGeometry" ? n = new rs(r1, t, e) : t.geometry.type === "PathGeometry" ? n = new Sa(r1, t, e) : t.geometry.type === "VectorGeometry" ? n = new by(r1, t, e) : t.geometry.type === "BooleanGeometry" ? n = new Pi(r1, t, e) : n = new tn(r1, t, e), n);
}
function Sy(r1, t, e) {
    return t.type === "Mesh" ? QW(r1, t, e) : t.type === "Empty" ? new Mo(r1, t) : t.type === "PointLight" ? new vy(r1, t, e) : t.type === "SpotLight" ? new xy(r1, t, e) : t.type === "DirectionalLight" ? new yy(r1, t, e) : t.type === "Component" || t.type === "Instance" ? new ss(r1, t, e) : ji.is(t.type) ? new Yt(r1, t) : (console.error(t), new Mo(r1, t));
}
Qi.createEntity = Sy;
function KW(r1, t, e) {
    let n = Sy(r1.identity, t, e), i = r1.children, s = r1.attachedPaths, o = r1.parent, a = r1.component, l = r1.instances, u = r1.overrideData, c = r1.uuid, d = r1.stateSelection;
    r1.dispose();
    for (let h of Object.keys(r1))delete r1[h];
    Object.setPrototypeOf(r1, Object.getPrototypeOf(n));
    for (let h of Object.keys(n))r1[h] = n[h];
    r1.children = [
        ...r1.children,
        ...i
    ], r1.attachedPaths = s, r1.parent = o, r1.component = a, r1.instances = l, r1.uuid = c, r1.overrideData = u, r1.updateState(r1.data, e), d && r1.changeSelectedState(d, e), r1.resetBBoxNeedsUpdate();
}
Qi.changeEntityProptotype = KW;
Qi.Cloner = hr;
function s2(r1, t, e, n) {
    r1.updateByOp(t, e, n, !1);
}
function o2(r1, t) {
    let e = !1, n = t.getLayersOfType("transmission"), i = t.getLayersOfType("outline");
    return i.length > 0 && (r1.layers.set(8), n.length > 0 && r1.layers.enable(3), e = !0, yd(r1), gd(r1)), n.length === 0 && i.length === 0 && r1.layers.set(0), r1 instanceof Rs && r1.needsAO && r1.layers.enable(5), e;
}
function a2(r1, t) {
    if (!t.layers) return !1;
    let e = !1, n = t.getLayersOfType("transmission").filter((s)=>s.data.visible), i = t.getLayersOfType("outline").filter((s)=>s.data.visible);
    return n.length > 0 && (r1.layers.set(3), i.length > 0 && r1.layers.enable(8), e = !0), n.length === 0 && i.length === 0 && r1.layers.set(0), r1.needsAO && r1.layers.enable(5), e;
}
function c2(r1) {
    let t = !1;
    return r1.traverseEntity((e)=>{
        if (e instanceof Rs) {
            if (Array.isArray(e.material)) for(let n = 0; n < e.material.length; n++)o2(e, e.material[n]) && (t = !0);
            else o2(e, e.material) && (t = !0);
        }
    }), t;
}
function u2(r1) {
    let t = !1;
    return r1.traverseEntity((e)=>{
        if (e instanceof Rs) {
            if (Array.isArray(e.material)) for(let n = 0; n < e.material.length; n++)a2(e, e.material[n]) && (t = !0);
            else a2(e, e.material) && (t = !0);
        }
    }), t;
}
var ZW = new Sc, JW = new ae, $W = new Fi;
function Nw(r1, t, e, n = !1) {
    let i = r1.cloner;
    if (i) for (let s of i.children){
        let o = JW.copy(s.matrixWorld).invert(), a = $W.copy(t.ray).applyMatrix4(o), l = r1.matrixWorld;
        a.applyMatrix4(l);
        let u = ZW;
        u.set(a.origin, a.direction), u.near = t.near, u.far = t.far;
        let c = u.intersectObject(r1, !1);
        c.length > 0 && e.push({
            ...c[0],
            object: n ? s : r1
        });
    }
}
var ej = (r1)=>`

// PCSS implementation based on:
// https://www.gamedev.net/articles/programming/graphics/contact-hardening-soft-shadows-made-fast-r4906/
// NOTE: This number affects how big the shadow blur can
// possibly get. Bigger number == bigger blur, but less precise results

const float  gPenumbraFilterSize = 80.0;
const int   gPenumbraSamples = ${r1};
const int gShadowSamples = ${r1};
const float gShadowSamplesRpc = 1.0f / float(gShadowSamples);

#ifdef USE_SHADOWMAP
    #if NUM_DIR_LIGHT_SHADOWS > 0

        uniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];
        varying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];

        struct DirectionalLightShadow {
            float shadowBias;
            float shadowNormalBias;
            float shadowRadius;
            vec2 shadowMapSize;
        };

        uniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];

    #endif

    #if NUM_SPOT_LIGHT_SHADOWS > 0

        uniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];
        varying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_SHADOWS ];

        struct SpotLightShadow {
            float shadowBias;
            float shadowNormalBias;
            float shadowRadius;
            vec2 shadowMapSize;
        };

        uniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];

    #endif

    #if NUM_POINT_LIGHT_SHADOWS > 0

        uniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];
        varying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];

        struct PointLightShadow {
            float shadowBias;
            float shadowNormalBias;
            float shadowRadius;
            vec2 shadowMapSize;
            float shadowCameraNear;
            float shadowCameraFar;
        };

        uniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];

    #endif

    /*
    #if NUM_RECT_AREA_LIGHTS > 0

        // TODO (abelnation): create uniforms for area light shadows

    #endif
    */

float computePenumbra(int index, sampler2D shadowMap, float temporalAngle, float texelSize, vec2 uv, float compare, float texelScalar, float shadowRadius)
{
    float penumbra = 1.0;
    float blockerDepthAvg = 0.0;
    float blockerCount = 0.0;

    #pragma unroll_loop_start
    for(int i = 0; i < gPenumbraSamples; i ++)
    {
        vec2 offset = (vogelDiskSample(i, gShadowSamples, temporalAngle) * texelSize) * texelScalar;
        float depth = unpackRGBAToDepth( texture2D( shadowMap, uv + offset ) );

        if(depth < compare + 0.0001)
        {
            blockerDepthAvg += depth;
            blockerCount++;
        }
    }
    #pragma unroll_loop_end

    if (blockerCount > 0.0)
    {
        blockerDepthAvg /= blockerCount;

        // Compute penumbra
        penumbra = (compare - blockerDepthAvg) / (blockerDepthAvg);
        penumbra *= penumbra;
        penumbra *= 200.0 * penumbraSize[min(index, ${5} - 1)]; // Magic number that affects how quickly the penumbra grows

        return clamp(penumbra, 0.00, 1.0);
    }
    return 0.0;
}

float vogelShadow(int index, sampler2D shadowMap, vec2 uv, float texelSize, float compare, float shadowRadius)
{
    float shadow         = 0.0f;

    // NOTE: When using TAA, we should use screen space interleaved gradient noise
    vec2 halton = haltonSequence[frameIndex];
    float temporalOffset = getNoiseInterleavedGradient(gl_FragCoord.xy + halton);
    float temporalAngle  = temporalOffset * PI2;

    float texelScalar = (gPenumbraFilterSize) / (texelSize * 1024.);
    float penumbra = computePenumbra(index, shadowMap, temporalAngle, texelSize, uv, compare, texelScalar, shadowRadius);
    if (penumbra == -1.0) {
        return 1.0;
    }

    #pragma unroll_loop_start
    for (int i = 0; i < gShadowSamples; i++)
    {
        vec2 vogelSample =  vogelDiskSample(i, gShadowSamples, temporalAngle) * texelSize;
        // Overall blurring offset
        vec2 offset = vogelSample * (shadowRadius * 2.);

        // Penumbra offset
        offset += vogelSample * (penumbra * texelScalar);

        shadow += step( compare, unpackRGBAToDepth( texture2D( shadowMap, uv + offset ) ) );
    }
    #pragma unroll_loop_end

    return shadow * gShadowSamplesRpc;
}


    float texture2DCompare( sampler2D depths, vec2 uv, float compare ) {

        return step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );

    }

    vec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {

        return unpackRGBATo2Half( texture2D( shadow, uv ) );

    }

    float VSMShadow (sampler2D shadow, vec2 uv, float compare ){

        float occlusion = 1.0;

        vec2 distribution = texture2DDistribution( shadow, uv );

        float hard_shadow = step( compare , distribution.x ); // Hard Shadow

        if (hard_shadow != 1.0 ) {

            float distance = compare - distribution.x ;
            float variance = max( 0.00000, distribution.y * distribution.y );
            float softness_probability = variance / (variance + distance * distance ); // Chebeyshevs inequality
            softness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 ); // 0.3 reduces light bleed
            occlusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );

        }
        return occlusion;

    }

    float getShadow( int i, sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord ) {

        float shadow = 1.0;

        shadowCoord.xyz /= shadowCoord.w;
        shadowCoord.z += shadowBias;

        // if ( something && something ) breaks ATI OpenGL shader compiler
        // if ( all( something, something ) ) using this instead

        bvec4 inFrustumVec = bvec4 ( shadowCoord.x >= 0.0, shadowCoord.x <= 1.0, shadowCoord.y >= 0.0, shadowCoord.y <= 1.0 );
        bool inFrustum = all( inFrustumVec );

        bvec2 frustumTestVec = bvec2( inFrustum, shadowCoord.z <= 1.0 );

        bool frustumTest = all( frustumTestVec );

        if ( frustumTest ) {

        #if defined( SHADOWMAP_TYPE_PCF )

            vec2 texelSize = vec2( 1.0 ) / shadowMapSize;
            return vogelShadow(i, shadowMap, shadowCoord.xy, texelSize.x, shadowCoord.z, shadowRadius );

        #elif defined( SHADOWMAP_TYPE_PCF_SOFT )

            vec2 texelSize = vec2( 1.0 ) / shadowMapSize;
            float dx = texelSize.x;
            float dy = texelSize.y;

            vec2 uv = shadowCoord.xy;
            vec2 f = fract( uv * shadowMapSize + 0.5 );
            uv -= f * texelSize;

            shadow = (
                texture2DCompare( shadowMap, uv, shadowCoord.z ) +
                texture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +
                texture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +
                texture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +
                mix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ),
                     texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),
                     f.x ) +
                mix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ),
                     texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),
                     f.x ) +
                mix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ),
                     texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),
                     f.y ) +
                mix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ),
                     texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),
                     f.y ) +
                mix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ),
                          texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),
                          f.x ),
                     mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ),
                          texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),
                          f.x ),
                     f.y )
            ) * ( 1.0 / 9.0 );

        #elif defined( SHADOWMAP_TYPE_VSM )

            shadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );

        #else // no percentage-closer filtering:

            shadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );

        #endif

        }

        return shadow;

    }

    // cubeToUV() maps a 3D direction vector suitable for cube texture mapping to a 2D
    // vector suitable for 2D texture mapping. This code uses the following layout for the
    // 2D texture:
    //
    // xzXZ
    //  y Y
    //
    // Y - Positive y direction
    // y - Negative y direction
    // X - Positive x direction
    // x - Negative x direction
    // Z - Positive z direction
    // z - Negative z direction
    //
    // Source and test bed:
    // https://gist.github.com/tschw/da10c43c467ce8afd0c4

    vec2 cubeToUV( vec3 v, float texelSizeY ) {

        // Number of texels to avoid at the edge of each square

        vec3 absV = abs( v );

        // Intersect unit cube

        float scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );
        absV *= scaleToCube;

        // Apply scale to avoid seams

        // two texels less per square (one texel will do for NEAREST)
        v *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );

        // Unwrap

        // space: -1 ... 1 range for each square
        //
        // #X##         dim    := ( 4 , 2 )
        //  # #         center := ( 1 , 1 )

        vec2 planar = v.xy;

        float almostATexel = 1.5 * texelSizeY;
        float almostOne = 1.0 - almostATexel;

        if ( absV.z >= almostOne ) {

            if ( v.z > 0.0 )
                planar.x = 4.0 - v.x;

        } else if ( absV.x >= almostOne ) {

            float signX = sign( v.x );
            planar.x = v.z * signX + 2.0 * signX;

        } else if ( absV.y >= almostOne ) {

            float signY = sign( v.y );
            planar.x = v.x + 2.0 * signY + 2.0;
            planar.y = v.z * signY - 2.0;

        }

        // Transform to UV space

        // scale := 0.5 / dim
        // translate := ( center + 0.5 ) / dim
        return vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );

    }

    float getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {

        float shadow = 1.0;
        vec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );

        // for point lights, the uniform @vShadowCoord is re-purposed to hold
        // the vector from the light to the world-space position of the fragment.
        vec3 lightToPosition = shadowCoord.xyz;

        // dp = normalized distance from light to fragment position
        float compare = ( length( lightToPosition ) - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear ); // need to clamp?
        compare += shadowBias;

        // bd3D = base direction 3D
        vec3 bd3D = normalize( lightToPosition );

        vec2 halton = haltonSequence[frameIndex];
        float temporalOffset = getNoiseInterleavedGradient(gl_FragCoord.xy + halton);
        float temporalAngle  = temporalOffset * PI2;

        #if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_VSM )
            for (int i = 0; i < gShadowSamples; i++) {
                vec2 vogelSample = vogelDiskSample(i, gShadowSamples, temporalAngle) * texelSize;

                // Overall blurring offset
                vec3 offset = vec3(vogelSample.x, vogelSample.y, -vogelSample.x) * (shadowRadius + 5.);

                // NOTE: Removed for now
                // Penumbra offset
                //offset += vec3(vogelSample.x, vogelSample.y, vogelSample.y)  * (penumbra * gPenumbraFilterSize);

                shadow += texture2DCompare( shadowMap, cubeToUV( bd3D + offset, texelSize.y ), compare );

            }
            return shadow * gShadowSamplesRpc;

        #elif defined( SHADOWMAP_TYPE_PCF_SOFT )
            for (int i = 0; i < 16; i++) {
                vec2 vogelSample = vogelDiskSample(i, gShadowSamples, temporalAngle) * texelSize;

                // Overall blurring offset
                vec3 offset = vec3(vogelSample.x, vogelSample.y, -vogelSample.x) * (shadowRadius + 5.);

                shadow += texture2DCompare( shadowMap, cubeToUV( bd3D + offset, texelSize.y ), compare );

            }
            return shadow * (1.0 / 16.0);
        #else // no percentage-closer filtering

            return texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), compare );

        #endif

    }

#endif
`, tj = it.lights_fragment_begin, nj = it.shadowmask_pars_fragment, d2 = !1, rj = (r1)=>{
    switch(r1){
        case "low":
            return 8;
        case "medium":
            return 16;
        case "high":
            return 32;
        default:
            return 16;
    }
}, h2 = (r1 = "medium")=>{
    if (d2) return;
    d2 = !0;
    let t = rj(r1);
    it.shadowmap_pars_fragment = ej(t);
    let e = tj.slice();
    e = e.replace("getShadow( spotShadowMap[ i ]", `getShadow( UNROLLED_LOOP_INDEX + ${3}, spotShadowMap[ i ]`), e = e.replace("getShadow( directionalShadowMap[ i ]", "getShadow( UNROLLED_LOOP_INDEX, directionalShadowMap[ i ]"), it.lights_fragment_begin = e;
    let n = nj.slice();
    n = n.replaceAll("getShadow(", "getShadow( UNROLLED_LOOP_INDEX, "), it.shadowmask_pars_fragment = n;
};
var ij = `
attribute vec3 randomColor;
varying vec3 vNormal;
flat out vec3 vColor;

void main()
{
vNormal = normal;
vColor = randomColor;
gl_Position = projectionMatrix * (modelViewMatrix * vec4(position, 1.0));
}
`, sj = `
uniform float depthContrast;
varying vec3 vNormal;
flat in vec3 vColor;
void main()
{
vec3 normal = (normalize(vNormal)).rgb;

float contrastDepth = (gl_FragCoord.z - 0.5) * depthContrast + 0.5;

vec3 resultColor = mix(mix(vColor, normal, 0.2), vec3(contrastDepth), 0.4);
gl_FragColor = vec4(resultColor, vColor.r);
}
`, Ay = new ot({
    vertexShader: ij,
    fragmentShader: sj,
    uniforms: {
        depthContrast: {
            value: 1
        }
    }
});
var _y = class {
    constructor(){
        this._constraints = new Map;
    }
    setConstraint(t, e) {
        e === null ? this._constraints.delete(t) : this._constraints.set(t, e);
    }
    removeDependencies(t) {
        this._constraints.delete(t);
    }
    applyConstraints(t) {
        let e = new Set;
        this._constraints.forEach((n, i)=>{
            let s = [
                i,
                n
            ], o = n;
            for(; this._constraints.has(o);)o = this._constraints.get(o), e.has(o) || s.push(o);
            for(let a = s.length - 2; a >= 0; a--)if (!e.has(s[a])) {
                let l = t.find(s[a]);
                l ? l.applyPathSnapping(t) : console.warn(`missing entity ${s[a]}`), e.add(s[a]);
            }
        });
    }
    findDependency(t, e) {
        let n = t;
        for(; this._constraints.has(n);)if (n = this._constraints.get(n), n === e) return !0;
        return !1;
    }
};
var My = new Ui;
My.wireframe = !0;
var f2 = new A, Bw = class extends Or {
    constructor(e, n){
        super();
        this.data = e;
        this.backupFog = new cc(16777215, .1, 2e3);
        this.fogUseBGColor = !1;
        this.enableHelpers = !1;
        this.wireframeState = !1;
        this.needsTransmissionDirty = !0;
        this.needsNormalDirty = !0;
        this._needsTransmission = !1;
        this._needsNormal = !1;
        this.occlusion = !1;
        this.aoFullRes = !1;
        this.radius = 128;
        this.bias = .5;
        this.aoColor = {
            r: 0,
            g: 0,
            b: 0
        };
        this.geometryCacheChanged = !1;
        this.bgColor = new $t(1, 1, 1, 1);
        this.entityByUuid = {};
        this.entityIdentityToEntity = {};
        this.toExpandCloner = new Set;
        this.toUpdateCloner = new Set;
        this.pendingCommands = [];
        this.pathConstraints = new _y;
        this.needsRecomputeInstances = !1;
        this.ambientLight = new Xp(13882323, 8553090, .75), this.ambientLight.name = "Default Ambient Light", this.ambientLight.layers.enable(3), this.personalCamera = this.createPersonalCamera(), this.activeCamera = this.personalCamera, this.postprocessing = e.postprocessing, this.init(e, n), this.matrixAutoUpdate = !1;
    }
    markGeometryCacheDirty() {
        this.geometryCacheChanged = !0;
    }
    markNeedsUpdateRendererDirty() {
        this.needsTransmissionDirty = !0, this.needsNormalDirty = !0;
    }
    needsTransmission() {
        return this.needsTransmissionDirty && (this._needsTransmission = u2(this), this.needsTransmissionDirty = !1), this._needsTransmission;
    }
    needsNormal() {
        return this.needsNormalDirty && (this._needsNormal = c2(this), this.needsNormalDirty = !1), this._needsNormal;
    }
    registerInstanceAndSetUuid(e) {
        let n = e.identity.join("-"), i = this.entityIdentityToEntity[n];
        i && (e.uuid = i.uuid), this.entityIdentityToEntity[n] = e, this.entityByUuid[e.uuid] = e;
    }
    findInstance(e) {
        return this.entityIdentityToEntity[e.join("-")];
    }
    getWithSortKey(e) {
        let n = this.find(e);
        if (n === void 0) return;
        let i = [], s = n;
        for(; s !== this;){
            let o = s;
            s = s.parent;
            let a = s.children.indexOf(o);
            i.splice(0, 0, a);
        }
        return {
            entity: n,
            sortKey: i
        };
    }
    getAllSorted(e) {
        let n = [];
        for (let i of e){
            let s = this.getWithSortKey(i.id);
            s !== void 0 && n.push(s);
        }
        return n.sort((i, s)=>yT(i.sortKey, s.sortKey)), n.map((i)=>i.entity);
    }
    nonExistOrDescendantOf(e, n) {
        let i = this.find(e);
        if (i === void 0) return !0;
        for(; i;){
            if (i.uuid === n) return !0;
            i = i.parent;
        }
        return !1;
    }
    find(e) {
        if (e === "" || e === void 0) return;
        let n = this.entityByUuid[e];
        return n === void 0 ? this.getObjectByProperty("uuid", e) : n;
    }
    debugEnsureEntity(e) {
        let n = this.find(e);
        if (n) {
            if (Array.isArray(n.identity) && this.findInstance(n.identity) === void 0) {
                console.error("not found instance");
                debugger;
            }
        } else {
            console.error("not found");
            debugger;
        }
    }
    addPendingExpandCloner(e) {
        this.toExpandCloner.add(e);
    }
    addPendingUpdateCloner(e) {
        this.toUpdateCloner.add(e);
    }
    markToExpandCloner(e) {
        this.toExpandCloner.add(e), e.traverseEntityAncestors((n)=>{
            this.toExpandCloner.add(n);
        });
    }
    doPendingExpandCloner() {
        this.toExpandCloner.forEach((e)=>{
            e.expandCloner(this);
        }), this.toExpandCloner.clear();
    }
    doPendingUpdateCloner() {
        this.toUpdateCloner.forEach((e)=>{
            e.cloner?.update();
        }), this.toUpdateCloner.clear();
    }
    doPendingUpdates() {
        this.doPendingExpandCloner(), this.doPendingUpdateCloner(), this.applyPendingCommands();
    }
    addPendingCommand(e) {
        this.pendingCommands.push(e);
    }
    applyPendingCommands() {
        this.pendingCommands.forEach((e)=>e()), this.pendingCommands.length = 0;
    }
    updateTreeByOp(e, n) {
        if (e.path.length === 0 && e.type === 7) {
            let i = e.parent === null ? this : this.find(e.parent);
            if (i === void 0) throw new Error("unexpected");
            let s = this.createObject(e.id, e.data, e.children, i, e.localIndex, n);
            s.updateVisible(), s.resetBBoxNeedsUpdate(), Zr(s) && Gr(s.parent) && (s.invalidateUpstreamBooleanData(), s.parent.invalidateDownstreamBooleanData().recomputeBoolean()), this.markNeedsRecomputeInstancesForAncessors(i), this.markNeedsRecomputeInstancesForChildren(s), this.markToExpandCloner(s);
        } else if (e.path.length === 0 && e.type === 8) {
            let i = this.find(e.id);
            if (i === void 0) throw new Error("unexpected");
            this.markToExpandCloner(i), i.resetBBoxNeedsUpdate(), this.unregisterObject(i);
            let s = i.parent;
            this.markNeedsRecomputeInstancesForAncessors(s), this.markNeedsRecomputeInstancesForChildren(i), i.parent.remove(i), Gr(i.parent) && (i.parent.invalidateUpstreamBooleanData(), i.parent.invalidateDownstreamBooleanData().recomputeBoolean()), Zr(i) && (i.freeBooleanPointer(), s instanceof Pi && s.invalidateDownstreamBooleanData().recomputeBoolean()), i instanceof Sa && i.detachShape(), this.disposeAndUnregisterEntityRecursivelyIfNotReregistered(i), this.pathConstraints.removeDependencies(i.uuid);
        } else if (e.path.length === 0 && e.type === 9) {
            let i = this.find(e.id);
            if (i === void 0) throw new Error("unexpected");
            this.markNeedsRecomputeInstancesForChildren(i);
            let s = i.parent;
            this.markNeedsRecomputeInstancesForAncessors(s), i.cloner?.resetOnMove(), this.markToExpandCloner(i);
            let o = e.parent === null ? this : this.find(e.parent);
            if (o === void 0) throw new Error("unexpected");
            o.add(i), this.markNeedsRecomputeInstancesForAncessors(o), this.markToExpandCloner(i), i.invalidateClonerTransform(i), i.updateVisible(), i.resetBBoxNeedsUpdate();
            let a = e.localIndex;
            o.children.splice(a, 0, o.children.pop()), Zr(i) && (i.invalidateUpstreamBooleanData(), Gr(i.parent) ? i.parent.invalidateDownstreamBooleanData().recomputeBoolean() : s instanceof Pi && s.invalidateDownstreamBooleanData().recomputeBoolean());
        }
        this.markNeedsUpdateRendererDirty(), this.markGeometryCacheDirty();
    }
    updateEntityByOp(e, n, i, s) {
        if (n.type === 0) {
            if (("overrides" in n.props || "component" in n.props) && this.markNeedsRecomputeInstances(), n.path.includes("overrides") && "states" in n.props) {
                let { rest: a  } = n.props;
                n = {
                    ...n,
                    props: a
                }, this.markNeedsRecomputeInstances();
            }
            n.path[0] === "pathSnapping" && n.props.pathId !== void 0 && this.pathConstraints.setConstraint(e, n.props.pathId);
        }
        let o = this.find(e);
        if (o) try {
            s2(o, n, i, {
                scene: this,
                shared: s
            }), o instanceof tn && o.updateGeometryGroupsIfNeeded();
        } catch (a) {
            console.error(a);
        }
    }
    get enableFog() {
        return this.fog !== null;
    }
    set enableFog(e) {
        this.fog = e === !0 ? this.backupFog : null;
    }
    init(e, n) {
        if (this.createChildrenObjects(e.objects, this, n), this.personalCamera.removeFromParent(), this.add(this.personalCamera), this.ambientLight.removeFromParent(), this.add(this.ambientLight), this.setBackgroundColor(dr(e.backgroundColor, n)), this.updateFog(e.fog, n), this.updateAmbientLight(e.environment.ambientLight, n), this.activeCamera = this.personalCamera, e.publish.playCamera !== null) {
            let i = this.find(e.publish.playCamera);
            i instanceof Yt && this.switchActiveCamera(i);
        }
        this.expandInstances(n, !0), this.traverseEntity((i)=>{
            Gr(i) && i.recomputeBoolean(), i instanceof Yt && i.updateUp();
        }), this.doPendingExpandCloner(), this.applyPendingCommands();
    }
    markNeedsRecomputeInstances() {
        this.needsRecomputeInstances = !0;
    }
    markNeedsRecomputeInstancesForChildren(e) {
        e.traverseEntity((n)=>{
            (n.data.type === "Component" || n.data.type === "Instance") && this.markNeedsRecomputeInstances();
        });
    }
    markNeedsRecomputeInstancesForAncessors(e) {
        St.is(e) && (e.data.type === "Component" && this.markNeedsRecomputeInstances(), e.traverseAncestors((n)=>{
            St.is(n) && n.data.type === "Component" && this.markNeedsRecomputeInstances();
        }));
    }
    relativeizeInner(e, n, i, s, o, a, l) {
        e && e !== s.uuid && s.find(e) && o.forInstancesRec((c)=>{
            c.isInstanceRoot || (c.data = au(c.data, (d)=>{
                let h = d.events.data(l.id), f = c.goUp(a);
                if (f) {
                    let m = [
                        ...Lm(f.identity),
                        e
                    ].join("-"), p = this.entityIdentityToEntity[m];
                    if (p) {
                        let g = p.uuid;
                        Lr.zoom(h, n)[i] = g;
                    } else console.warn("cannot find instance");
                }
            }).data);
        });
    }
    rewriteEventsBeforeGoToPlayMode() {
        this.traverseEntity((e)=>{
            if (e instanceof ss && typeof e.identity == "string" && e.data.type === "Component") return e.traverseEntity((n, i)=>{
                n.data.events.forEach((s)=>{
                    s.data.type === "GameControl" ? n.forInstancesRec((o)=>{
                        o.isInstanceRoot || (o.data = au(o.data, (a)=>{
                            a.events.delete(s.id);
                        }).data);
                    }) : s.data.type === "Conditional" ? (s.data.condition.type === "Distance" ? (this.relativeizeInner(s.data.condition.fromObject, [
                        "condition"
                    ], "fromObject", e, n, i, s), this.relativeizeInner(s.data.condition.toObject, [
                        "condition"
                    ], "toObject", e, n, i, s)) : s.data.condition.type === "State" ? this.relativeizeInner(s.data.condition.object, [
                        "condition"
                    ], "object", e, n, i, s) : s.data.condition.type === "Comparison" && (s.data.condition.lOperand.type === "Property" && this.relativeizeInner(s.data.condition.lOperand.value[0], [
                        "condition",
                        "lOperand",
                        "value"
                    ], 0, e, n, i, s), s.data.condition.rOperand.type === "Property" && this.relativeizeInner(s.data.condition.rOperand.value[0], [
                        "condition",
                        "rOperand",
                        "value"
                    ], 0, e, n, i, s)), s.data.inActions.forEach((o)=>{
                        o.data.type === "Transition" && this.relativeizeInner(o.data.object, [
                            "inActions",
                            o.id
                        ], "object", e, n, i, s);
                    }), s.data.outActions.forEach((o)=>{
                        o.data.type === "Transition" && this.relativeizeInner(o.data.object, [
                            "outActions",
                            o.id
                        ], "object", e, n, i, s);
                    })) : "actions" in s.data && s.data.actions.forEach((o)=>{
                        o.data.type === "Transition" && this.relativeizeInner(o.data.object, [
                            "actions",
                            o.id
                        ], "object", e, n, i, s);
                    });
                });
            }), !0;
        });
    }
    expandInstances(e, n) {
        let i = new Set;
        this.traverseEntity((s)=>{
            if (s instanceof ss && s.isInstanceRoot) return s.expandInstanceChildren({
                scene: this,
                shared: e,
                pendingDeletes: i
            }), n || s.resetBBoxNeedsUpdate(), !0;
        });
        for (let s of i)this.disposeAndUnregisterEntityRecursivelyIfNotReregistered(s), wy(s);
    }
    recomputeInstances(e) {
        this.needsRecomputeInstances && (this.needsRecomputeInstances = !1, this.traverseEntity((n)=>{
            n instanceof ss && n.isInstanceRoot && (n.component = void 0);
        }), this.expandInstances(e, !1));
    }
    disposeAndUnregisterEntityRecursivelyIfNotReregistered(e) {
        e.traverseEntity((n)=>{
            let i = typeof n.identity == "string" ? n.identity : n.identity.join("-");
            this.entityIdentityToEntity[i] === n && (delete this.entityByUuid[n.uuid], delete this.entityIdentityToEntity[i]), n.dispose();
        });
    }
    clearScene() {
        for (let e of this.children)St.is(e) && e.disposeRecursively();
        this.children.length = 0;
    }
    resetAfterClear(e, n) {
        this.init(e, n);
    }
    createPersonalCamera() {
        let e = new Yt(Bw.PERSONAL_CAMERA_ID, {
            ...fu.defaultData,
            name: "Personal Camera"
        });
        return e.objectHelper.visible = !1, this.registerObjectCreatedInLegacy(e), e;
    }
    raycast(e) {
        let n = [], i = (s)=>{
            for (let o of s.children){
                let a = o.cloner;
                St.is(o) && !o.raycastLock && (o.visible || a?.object.data.visible) && ((Zr(o) || Lw(o) && this.enableHelpers && o.objectHelper.visible) && (e.intersectObject(o, !1, n), Nw(o, e, n)), i(o));
            }
        };
        return i(this), n;
    }
    raycastWithClones(e) {
        let n = [], i = (s)=>{
            for (let o of s.children){
                let a = o.cloner;
                St.is(o) && (o.visible || a?.object.data.visible) && ((Zr(o) || Lw(o) && this.enableHelpers && o.objectHelper.visible) && (e.intersectObject(o, !1, n), Nw(o, e, n, !0)), i(o));
            }
        };
        return i(this), n;
    }
    forEachEntity(e) {
        for (let n of this.children)St.is(n) && e(n);
    }
    traverseEntity(e) {
        for (let n of this.children)St.is(n) && n.traverseEntity(e);
    }
    traverseObject(e) {
        for (let n of this.children)rf.is(n) && n.traverseObject(e);
    }
    traverseVisibleEntity(e) {
        for (let n of this.children)St.is(n) && n.visible && n.traverseVisibleEntity(e);
    }
    updateFog(e, n) {
        this.enableFog = e.enabled, this.fogUseBGColor = e.useBackgroundColor, e.useBackgroundColor ? this.backupFog.color.set(this.bgColor) : this.backupFog.color = dr(e.color, n), this.backupFog.near = e.near, this.backupFog.far = e.far;
    }
    dispose() {
        this.clearScene();
    }
    updateAmbientLight(e, n) {
        e.color !== void 0 && (this.ambientLight.color = dr(e.color, n)), e.intensity !== void 0 && (this.ambientLight.intensity = e.intensity), e.groundColor !== void 0 && (this.ambientLight.groundColor = dr(e.groundColor, n)), e.enabled !== void 0 && (this.ambientLight.visible = e.enabled), e.occlusion !== void 0 && (this.occlusion = e.occlusion), e.aoFullRes !== void 0 && (this.aoFullRes = e.aoFullRes), e.radius !== void 0 && (this.radius = e.radius), e.bias !== void 0 && (this.bias = e.bias), e.aoColor !== void 0 && (this.aoColor = dr(e.aoColor, n));
    }
    switchActiveCamera(e) {
        this.activeCamera !== this.personalCamera && (this.activeCamera.objectHelper.visible = !0), this.activeCamera = e, e.objectHelper.visible = !1;
    }
    setBackgroundColor(e) {
        this.bgColor = e, this.fogUseBGColor === !0 && (this.backupFog.color = e);
    }
    createChildrenObjects(e, n, i) {
        let s = 0;
        for (let o of e)this.createObject(o.id, o.data, o.children, n, s, i), s += 1;
    }
    registerObjectCreatedInLegacy(e) {
        this.entityByUuid[e.uuid] = e;
    }
    unregisterObject(e) {
        delete this.entityByUuid[e.uuid];
        for (let n of e.children)this.unregisterObject(n);
    }
    createObject(e, n, i, s, o, a) {
        let l = {
            scene: this,
            shared: a
        }, u = Sy(e, n, l);
        return u && (this.entityByUuid[e] = u, s.add(u), s.children.splice(o, 0, s.children.pop()), i.length > 0 && (u.isInstanceRoot ? console.error("instance should not have children!") : this.createChildrenObjects(i, u, a)), u.updateState(n, l), u instanceof tn && u.updateGeometryGroupsIfNeeded(), u.updateVisible(), u.cloner && this.toExpandCloner.add(u), n.pathSnapping?.pathId && this.pathConstraints.setConstraint(e, n.pathSnapping.pathId)), u;
    }
    getCenter(e) {
        let n = [];
        for(let s = 0, o = e.length; s < o; ++s){
            let { id: a , recursive: l  } = e[s], u = this.find(a), c = l ? u.recursiveBBox : u.singleBBox;
            n.push(...c.vertices);
        }
        let i = new Mt;
        return i.setFromPoints(n), i.getCenter(f2), f2;
    }
    copyMatrixWorld(e, n) {
        if (e === null) {
            n.identity();
            return;
        }
        let i = this.find(e);
        i ? n.copy(i.matrixWorld) : n.identity();
    }
    copyParentMatrixWorld(e, n) {
        if (e === null) {
            n.identity();
            return;
        }
        let i = this.find(e)?.parent;
        i ? n.copy(i.matrixWorld) : n.identity();
    }
    traverseMaterial(e) {
        this.traverseEntity((n)=>{
            if (n instanceof kt) {
                if (Array.isArray(n.material)) for(let i = 0; i < n.material.length; i++)n.material[i] instanceof Kr && e(n.material[i]);
                else n.material instanceof Kr && e(n.material);
            }
        });
    }
    updateCanvasSize(e, n) {
        this.activeCamera.setViewplaneSize(e, n);
        let i, s;
        e >= n ? (i = n / e, s = 1) : (i = 1, s = e / n), this.traverseMaterial((o)=>{
            o.getLayersOfType("transmission").forEach((l)=>{
                l.uniforms[`f${l.id}_aspectRatio`].value.x = i, l.uniforms[`f${l.id}_aspectRatio`].value.y = s;
            });
        });
    }
}, bn = Bw;
bn.PERSONAL_CAMERA_ID = "f23858d0-4a3b-4bd8-8173-66ed0af7f6fb-personalCamera", bn.PERSONAL_CAMERA_EXPORT_ID = "f23858d0-4a3b-4bd8-8173-66ed0af7f6fb-personalCameraExport";
var Bf = (r1, t)=>{
    let e = t.x - r1.x, n = t.y - r1.y;
    return Math.sqrt(e * e + n * n);
}, p2 = (r1, t)=>{
    let e = t.x - r1.x, n = t.y - r1.y;
    return oj(Math.atan2(n, e));
}, m2 = (r1, t, e)=>{
    let n = {
        x: 0,
        y: 0
    };
    return e = Ty(e), n.x = r1.x - t * Math.cos(e), n.y = r1.y - t * Math.sin(e), n;
}, Ty = (r1)=>r1 * (Math.PI / 180), oj = (r1)=>r1 * (180 / Math.PI), g2 = (r1)=>isNaN(r1.buttons) ? r1.pressure !== 0 : r1.buttons !== 0, Fw = new Map, Uw = (r1)=>{
    Fw.has(r1) && clearTimeout(Fw.get(r1)), Fw.set(r1, setTimeout(r1, 100));
}, Td = (r1, t, e)=>{
    let n = t.split(/[ ,]+/g), i;
    for(let s = 0; s < n.length; s += 1)i = n[s], r1.addEventListener ? r1.addEventListener(i, e, !1) : r1.attachEvent && r1.attachEvent(i, e);
}, kw = (r1, t, e)=>{
    let n = t.split(/[ ,]+/g), i;
    for(let s = 0; s < n.length; s += 1)i = n[s], r1.removeEventListener ? r1.removeEventListener(i, e) : r1.detachEvent && r1.detachEvent(i, e);
};
var Ey = (r1)=>(r1.preventDefault(), r1.type.match(/^touch/) ? r1.changedTouches : r1), zw = ()=>{
    if (typeof window > "u") return;
    let r1 = window.pageXOffset !== void 0 ? window.pageXOffset : (document.documentElement || document.body.parentNode || document.body).scrollLeft, t = window.pageYOffset !== void 0 ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
    return {
        x: r1,
        y: t
    };
}, Cy = (r1, t)=>{
    t.top || t.right || t.bottom || t.left ? (r1.style.top = t.top, r1.style.right = t.right, r1.style.bottom = t.bottom, r1.style.left = t.left) : (r1.style.left = t.x + "px", r1.style.top = t.y + "px");
}, Py = (r1, t, e)=>{
    let n = v2(r1);
    for(let i in n)if (n.hasOwnProperty(i)) {
        if (typeof t == "string") n[i] = t + " " + e;
        else {
            let s = "";
            for(let o = 0, a = t.length; o < a; o += 1)s += t[o] + " " + e + ", ";
            n[i] = s.slice(0, -2);
        }
    }
    return n;
}, y2 = (r1, t)=>{
    let e = v2(r1);
    for(let n in e)e.hasOwnProperty(n) && (e[n] = t);
    return e;
}, v2 = (r1)=>{
    let t = {};
    return t[r1] = "", [
        "webkit",
        "Moz",
        "o"
    ].forEach(function(n) {
        t[n + r1.charAt(0).toUpperCase() + r1.slice(1)] = "";
    }), t;
}, Dy = (r1, t)=>{
    for(let e in t)t.hasOwnProperty(e) && (r1[e] = t[e]);
    return r1;
}, x2 = (r1, t)=>{
    let e = {};
    for(let n in r1)r1.hasOwnProperty(n) && t.hasOwnProperty(n) ? e[n] = t[n] : r1.hasOwnProperty(n) && (e[n] = r1[n]);
    return e;
}, Ff = (r1, t)=>{
    if (r1.length) for(let e = 0, n = r1.length; e < n; e += 1)t(r1[e]);
    else t(r1);
}, b2 = (r1, t, e)=>({
        x: Math.min(Math.max(r1.x, t.x - e), t.x + e),
        y: Math.min(Math.max(r1.y, t.y - e), t.y + e)
    });
typeof window < "u" && (w2 = "ontouchstart" in window, S2 = !!window.PointerEvent, A2 = !!window.MSPointerEvent);
var w2, S2, A2, Uf = {
    touch: {
        start: "touchstart",
        move: "touchmove",
        end: "touchend, touchcancel"
    },
    mouse: {
        start: "mousedown",
        move: "mousemove",
        end: "mouseup"
    },
    pointer: {
        start: "pointerdown",
        move: "pointermove",
        end: "pointerup, pointercancel"
    },
    MSPointer: {
        start: "MSPointerDown",
        move: "MSPointerMove",
        end: "MSPointerUp"
    }
}, Ed, kf = {};
S2 ? Ed = Uf.pointer : A2 ? Ed = Uf.MSPointer : w2 ? (Ed = Uf.touch, kf = Uf.mouse) : Ed = Uf.mouse;
function Nl() {}
Nl.prototype.on = function(r1, t) {
    var e = this, n = r1.split(/[ ,]+/g), i;
    e._handlers_ = e._handlers_ || {};
    for(var s = 0; s < n.length; s += 1)i = n[s], e._handlers_[i] = e._handlers_[i] || [], e._handlers_[i].push(t);
    return e;
};
Nl.prototype.off = function(r1, t) {
    var e = this;
    return e._handlers_ = e._handlers_ || {}, r1 === void 0 ? e._handlers_ = {} : t === void 0 ? e._handlers_[r1] = null : e._handlers_[r1] && e._handlers_[r1].indexOf(t) >= 0 && e._handlers_[r1].splice(e._handlers_[r1].indexOf(t), 1), e;
};
Nl.prototype.trigger = function(r1, t) {
    var e = this, n = r1.split(/[ ,]+/g), i;
    e._handlers_ = e._handlers_ || {};
    for(var s = 0; s < n.length; s += 1)i = n[s], e._handlers_[i] && e._handlers_[i].length && e._handlers_[i].forEach(function(o) {
        o.call(e, {
            type: i,
            target: e
        }, t);
    });
};
Nl.prototype.config = function(r1) {
    var t = this;
    t.options = t.defaults || {}, r1 && (t.options = x2(t.options, r1));
};
Nl.prototype.bindEvt = function(r1, t) {
    var e = this;
    return e._domHandlers_ = e._domHandlers_ || {}, e._domHandlers_[t] = function() {
        typeof e["on" + t] == "function" ? e["on" + t].apply(e, arguments) : console.warn('[WARNING] : Missing "on' + t + '" handler.');
    }, Td(r1, Ed[t], e._domHandlers_[t]), kf[t] && Td(r1, kf[t], e._domHandlers_[t]), e;
};
Nl.prototype.unbindEvt = function(r1, t) {
    var e = this;
    return e._domHandlers_ = e._domHandlers_ || {}, kw(r1, Ed[t], e._domHandlers_[t]), kf[t] && kw(r1, kf[t], e._domHandlers_[t]), delete e._domHandlers_[t], this;
};
var Cd = Nl;
function Yn(r1, t) {
    return this.identifier = t.identifier, this.position = t.position, this.frontPosition = t.frontPosition, this.collection = r1, this.defaults = {
        size: 100,
        threshold: .1,
        color: "white",
        fadeTime: 250,
        dataOnly: !1,
        restJoystick: !0,
        restOpacity: 1,
        mode: "dynamic",
        zone: document.body,
        lockX: !1,
        lockY: !1,
        shape: "circle"
    }, this.config(t), this.options.mode === "dynamic" && (this.options.restOpacity = 0), this.id = Yn.id, Yn.id += 1, this.buildEl().stylize(), this.instance = {
        el: this.ui.el,
        on: this.on.bind(this),
        off: this.off.bind(this),
        show: this.show.bind(this),
        hide: this.hide.bind(this),
        add: this.addToDom.bind(this),
        remove: this.removeFromDom.bind(this),
        destroy: this.destroy.bind(this),
        setPosition: this.setPosition.bind(this),
        resetDirection: this.resetDirection.bind(this),
        computeDirection: this.computeDirection.bind(this),
        trigger: this.trigger.bind(this),
        position: this.position,
        frontPosition: this.frontPosition,
        ui: this.ui,
        identifier: this.identifier,
        id: this.id,
        options: this.options
    }, this.instance;
}
Yn.prototype = new Cd;
Yn.constructor = Yn;
Yn.id = 0;
Yn.prototype.buildEl = function(r1) {
    return this.ui = {}, this.options.dataOnly ? this : (this.ui.el = document.createElement("div"), this.ui.back = document.createElement("div"), this.ui.front = document.createElement("div"), this.ui.el.className = "nipple collection_" + this.collection.id, this.ui.back.className = "back", this.ui.front.className = "front", this.ui.el.setAttribute("id", "nipple_" + this.collection.id + "_" + this.id), this.ui.el.appendChild(this.ui.back), this.ui.el.appendChild(this.ui.front), this);
};
Yn.prototype.stylize = function() {
    if (this.options.dataOnly) return this;
    var r1 = this.options.fadeTime + "ms", t = y2("borderRadius", "50%"), e = Py("transition", "opacity", r1), n = {};
    return n.el = {
        position: "absolute",
        opacity: this.options.restOpacity,
        display: "block",
        zIndex: 999
    }, n.back = {
        position: "absolute",
        display: "block",
        width: this.options.size + "px",
        height: this.options.size + "px",
        marginLeft: -this.options.size / 2 + "px",
        marginTop: -this.options.size / 2 + "px",
        background: "rgba(255, 255, 255, .4)",
        border: "solid 2px rgba(0, 0, 0, .1)"
    }, n.front = {
        width: this.options.size / 2 + "px",
        height: this.options.size / 2 + "px",
        position: "absolute",
        display: "block",
        marginLeft: -this.options.size / 4 + "px",
        marginTop: -this.options.size / 4 + "px",
        background: "rgba(255, 255, 255, .8)",
        border: "solid 2px rgba(0, 0, 0, .1)"
    }, Dy(n.el, e), this.options.shape === "circle" && Dy(n.back, t), Dy(n.front, t), this.applyStyles(n), this;
};
Yn.prototype.applyStyles = function(r1) {
    for(var t in this.ui)if (this.ui.hasOwnProperty(t)) for(var e in r1[t])this.ui[t].style[e] = r1[t][e];
    return this;
};
Yn.prototype.addToDom = function() {
    return this.options.dataOnly || document.body.contains(this.ui.el) ? this : (this.options.zone.appendChild(this.ui.el), this);
};
Yn.prototype.removeFromDom = function() {
    return this.options.dataOnly || !document.body.contains(this.ui.el) ? this : (this.options.zone.removeChild(this.ui.el), this);
};
Yn.prototype.destroy = function() {
    clearTimeout(this.removeTimeout), clearTimeout(this.showTimeout), clearTimeout(this.restTimeout), this.trigger("destroyed", this.instance), this.removeFromDom(), this.off();
};
Yn.prototype.show = function(r1) {
    var t = this;
    return t.options.dataOnly || (clearTimeout(t.removeTimeout), clearTimeout(t.showTimeout), clearTimeout(t.restTimeout), t.addToDom(), t.restCallback(), setTimeout(function() {
        t.ui.el.style.opacity = 1;
    }, 0), t.showTimeout = setTimeout(function() {
        t.trigger("shown", t.instance), typeof r1 == "function" && r1.call(this);
    }, t.options.fadeTime)), t;
};
Yn.prototype.hide = function(r1) {
    var t = this;
    if (t.options.dataOnly) return t;
    if (t.ui.el.style.opacity = t.options.restOpacity, clearTimeout(t.removeTimeout), clearTimeout(t.showTimeout), clearTimeout(t.restTimeout), t.removeTimeout = setTimeout(function() {
        var e = t.options.mode === "dynamic" ? "none" : "block";
        t.ui.el.style.display = e, typeof r1 == "function" && r1.call(t), t.trigger("hidden", t.instance);
    }, t.options.fadeTime), t.options.restJoystick) {
        let e = t.options.restJoystick, n = {};
        n.x = e === !0 || e.x !== !1 ? 0 : t.instance.frontPosition.x, n.y = e === !0 || e.y !== !1 ? 0 : t.instance.frontPosition.y, t.setPosition(r1, n);
    }
    return t;
};
Yn.prototype.setPosition = function(r1, t) {
    var e = this;
    e.frontPosition = {
        x: t.x,
        y: t.y
    };
    var n = e.options.fadeTime + "ms", i = {};
    i.front = Py("transition", [
        "top",
        "left"
    ], n);
    var s = {
        front: {}
    };
    s.front = {
        left: e.frontPosition.x + "px",
        top: e.frontPosition.y + "px"
    }, e.applyStyles(i), e.applyStyles(s), e.restTimeout = setTimeout(function() {
        typeof r1 == "function" && r1.call(e), e.restCallback();
    }, e.options.fadeTime);
};
Yn.prototype.restCallback = function() {
    var r1 = this, t = {};
    t.front = Py("transition", "none", ""), r1.applyStyles(t), r1.trigger("rested", r1.instance);
};
Yn.prototype.resetDirection = function() {
    this.direction = {
        x: !1,
        y: !1,
        angle: !1
    };
};
Yn.prototype.computeDirection = function(r1) {
    var t = r1.angle.radian, e = Math.PI / 4, n = Math.PI / 2, i, s, o;
    if (t > e && t < e * 3 && !r1.lockX ? i = "up" : t > -e && t <= e && !r1.lockY ? i = "left" : t > -e * 3 && t <= -e && !r1.lockX ? i = "down" : r1.lockY || (i = "right"), r1.lockY || (t > -n && t < n ? s = "left" : s = "right"), r1.lockX || (t > 0 ? o = "up" : o = "down"), r1.force > this.options.threshold) {
        var a = {}, l;
        for(l in this.direction)this.direction.hasOwnProperty(l) && (a[l] = this.direction[l]);
        var u = {};
        this.direction = {
            x: s,
            y: o,
            angle: i
        }, r1.direction = this.direction;
        for(l in a)a[l] === this.direction[l] && (u[l] = !0);
        if (u.x && u.y && u.angle) return r1;
        (!u.x || !u.y) && this.trigger("plain", r1), u.x || this.trigger("plain:" + s, r1), u.y || this.trigger("plain:" + o, r1), u.angle || this.trigger("dir dir:" + i, r1);
    } else this.resetDirection();
    return r1;
};
var _2 = Yn;
function wn(r1, t) {
    var e = this;
    e.nipples = [], e.idles = [], e.actives = [], e.ids = [], e.pressureIntervals = {}, e.manager = r1, e.id = wn.id, wn.id += 1, e.defaults = {
        zone: document.body,
        multitouch: !1,
        maxNumberOfNipples: 10,
        mode: "dynamic",
        position: {
            top: 0,
            left: 0
        },
        catchDistance: 200,
        size: 100,
        threshold: .1,
        color: "white",
        fadeTime: 250,
        dataOnly: !1,
        restJoystick: !0,
        restOpacity: 1,
        lockX: !1,
        lockY: !1,
        shape: "circle",
        dynamicPage: !1,
        follow: !1
    }, e.config(t), (e.options.mode === "static" || e.options.mode === "semi") && (e.options.multitouch = !1), e.options.multitouch || (e.options.maxNumberOfNipples = 1);
    let n = getComputedStyle(e.options.zone.parentElement);
    return n && n.display === "flex" && (e.parentIsFlex = !0), e.updateBox(), e.prepareNipples(), e.bindings(), e.begin(), e.nipples;
}
wn.prototype = new Cd;
wn.constructor = wn;
wn.id = 0;
wn.prototype.prepareNipples = function() {
    var r1 = this, t = r1.nipples;
    t.on = r1.on.bind(r1), t.off = r1.off.bind(r1), t.options = r1.options, t.destroy = r1.destroy.bind(r1), t.ids = r1.ids, t.id = r1.id, t.processOnMove = r1.processOnMove.bind(r1), t.processOnEnd = r1.processOnEnd.bind(r1), t.get = function(e) {
        if (e === void 0) return t[0];
        for(var n = 0, i = t.length; n < i; n += 1)if (t[n].identifier === e) return t[n];
        return !1;
    };
};
wn.prototype.bindings = function() {
    var r1 = this;
    r1.bindEvt(r1.options.zone, "start"), r1.options.zone.style.touchAction = "none", r1.options.zone.style.msTouchAction = "none";
};
wn.prototype.begin = function() {
    var r1 = this, t = r1.options;
    if (t.mode === "static") {
        var e = r1.createNipple(t.position, r1.manager.getIdentifier());
        e.add(), r1.idles.push(e);
    }
};
wn.prototype.createNipple = function(r1, t) {
    var e = this, n = e.manager.scroll, i = {}, s = e.options, o = {
        x: e.parentIsFlex ? n.x : n.x + e.box.left,
        y: e.parentIsFlex ? n.y : n.y + e.box.top
    };
    if (r1.x && r1.y) i = {
        x: r1.x - o.x,
        y: r1.y - o.y
    };
    else if (r1.top || r1.right || r1.bottom || r1.left) {
        var a = document.createElement("DIV");
        a.style.display = "hidden", a.style.top = r1.top, a.style.right = r1.right, a.style.bottom = r1.bottom, a.style.left = r1.left, a.style.position = "absolute", s.zone.appendChild(a);
        var l = a.getBoundingClientRect();
        s.zone.removeChild(a), i = r1, r1 = {
            x: l.left + n.x,
            y: l.top + n.y
        };
    }
    var u = new _2(e, {
        color: s.color,
        size: s.size,
        threshold: s.threshold,
        fadeTime: s.fadeTime,
        dataOnly: s.dataOnly,
        restJoystick: s.restJoystick,
        restOpacity: s.restOpacity,
        mode: s.mode,
        identifier: t,
        position: r1,
        zone: s.zone,
        frontPosition: {
            x: 0,
            y: 0
        },
        shape: s.shape
    });
    return s.dataOnly || (Cy(u.ui.el, i), Cy(u.ui.front, u.frontPosition)), e.nipples.push(u), e.trigger("added " + u.identifier + ":added", u), e.manager.trigger("added " + u.identifier + ":added", u), e.bindNipple(u), u;
};
wn.prototype.updateBox = function() {
    var r1 = this;
    r1.box = r1.options.zone.getBoundingClientRect();
};
wn.prototype.bindNipple = function(r1) {
    var t = this, e, n = function(i, s) {
        e = i.type + " " + s.id + ":" + i.type, t.trigger(e, s);
    };
    r1.on("destroyed", t.onDestroyed.bind(t)), r1.on("shown hidden rested dir plain", n), r1.on("dir:up dir:right dir:down dir:left", n), r1.on("plain:up plain:right plain:down plain:left", n);
};
wn.prototype.pressureFn = function(r1, t, e) {
    var n = this, i = 0;
    clearInterval(n.pressureIntervals[e]), n.pressureIntervals[e] = setInterval((function() {
        var s = r1.force || r1.pressure || r1.webkitForce || 0;
        s !== i && (t.trigger("pressure", s), n.trigger("pressure " + t.identifier + ":pressure", s), i = s);
    }).bind(n), 100);
};
wn.prototype.onstart = function(r1) {
    var t = this, e = t.options, n = r1;
    r1 = Ey(r1), t.updateBox();
    var i = function(s) {
        t.actives.length < e.maxNumberOfNipples ? t.processOnStart(s) : n.type.match(/^touch/) && (Object.keys(t.manager.ids).forEach(function(o) {
            if (Object.values(n.touches).findIndex(function(l) {
                return l.identifier === o;
            }) < 0) {
                var a = [
                    r1[0]
                ];
                a.identifier = o, t.processOnEnd(a);
            }
        }), t.actives.length < e.maxNumberOfNipples && t.processOnStart(s));
    };
    return Ff(r1, i), t.manager.bindDocument(), !1;
};
wn.prototype.processOnStart = function(r1) {
    var t = this, e = t.options, n, i = t.manager.getIdentifier(r1), s = r1.force || r1.pressure || r1.webkitForce || 0, o = {
        x: r1.pageX,
        y: r1.pageY
    }, a = t.getOrCreate(i, o);
    a.identifier !== i && t.manager.removeIdentifier(a.identifier), a.identifier = i;
    var l = function(c) {
        c.trigger("start", c), t.trigger("start " + c.id + ":start", c), c.show(), s > 0 && t.pressureFn(r1, c, c.identifier), t.processOnMove(r1);
    };
    if ((n = t.idles.indexOf(a)) >= 0 && t.idles.splice(n, 1), t.actives.push(a), t.ids.push(a.identifier), e.mode !== "semi") l(a);
    else {
        var u = Bf(o, a.position);
        if (u <= e.catchDistance) l(a);
        else {
            a.destroy(), t.processOnStart(r1);
            return;
        }
    }
    return a;
};
wn.prototype.getOrCreate = function(r1, t) {
    var e = this, n = e.options, i;
    return /(semi|static)/.test(n.mode) ? (i = e.idles[0], i ? (e.idles.splice(0, 1), i) : n.mode === "semi" ? e.createNipple(t, r1) : (console.warn("Coudln't find the needed nipple."), !1)) : (i = e.createNipple(t, r1), i);
};
wn.prototype.processOnMove = function(r1) {
    var t = this, e = t.options, n = t.manager.getIdentifier(r1), i = t.nipples.get(n), s = t.manager.scroll;
    if (!g2(r1)) {
        this.processOnEnd(r1);
        return;
    }
    if (!i) {
        console.error("Found zombie joystick with ID " + n), t.manager.removeIdentifier(n);
        return;
    }
    if (e.dynamicPage) {
        var o = i.el.getBoundingClientRect();
        i.position = {
            x: s.x + o.left,
            y: s.y + o.top
        };
    }
    i.identifier = n;
    var a = i.options.size / 2, l = {
        x: r1.pageX,
        y: r1.pageY
    };
    e.lockX && (l.y = i.position.y), e.lockY && (l.x = i.position.x);
    var u = Bf(l, i.position), c = p2(l, i.position), d = Ty(c), h = u / a, f = {
        distance: u,
        position: l
    }, m, p;
    if (i.options.shape === "circle" ? (m = Math.min(u, a), p = m2(i.position, m, c)) : (p = b2(l, i.position, a), m = Bf(p, i.position)), e.follow) {
        if (u > a) {
            let x = l.x - p.x, w = l.y - p.y;
            i.position.x += x, i.position.y += w, i.el.style.top = i.position.y - (t.box.top + s.y) + "px", i.el.style.left = i.position.x - (t.box.left + s.x) + "px", u = Bf(l, i.position);
        }
    } else l = p, u = m;
    var g = l.x - i.position.x, y = l.y - i.position.y;
    i.frontPosition = {
        x: g,
        y: y
    }, e.dataOnly || Cy(i.ui.front, i.frontPosition);
    var v = {
        identifier: i.identifier,
        position: l,
        force: h,
        pressure: r1.force || r1.pressure || r1.webkitForce || 0,
        distance: u,
        angle: {
            radian: d,
            degree: c
        },
        vector: {
            x: g / a,
            y: -y / a
        },
        raw: f,
        instance: i,
        lockX: e.lockX,
        lockY: e.lockY
    };
    v = i.computeDirection(v), v.angle = {
        radian: Ty(180 - c),
        degree: 180 - c
    }, i.trigger("move", v), t.trigger("move " + i.id + ":move", v);
};
wn.prototype.processOnEnd = function(r1) {
    var t = this, e = t.options, n = t.manager.getIdentifier(r1), i = t.nipples.get(n), s = t.manager.removeIdentifier(i.identifier);
    !i || (e.dataOnly || i.hide(function() {
        e.mode === "dynamic" && (i.trigger("removed", i), t.trigger("removed " + i.id + ":removed", i), t.manager.trigger("removed " + i.id + ":removed", i), i.destroy());
    }), clearInterval(t.pressureIntervals[i.identifier]), i.resetDirection(), i.trigger("end", i), t.trigger("end " + i.id + ":end", i), t.ids.indexOf(i.identifier) >= 0 && t.ids.splice(t.ids.indexOf(i.identifier), 1), t.actives.indexOf(i) >= 0 && t.actives.splice(t.actives.indexOf(i), 1), /(semi|static)/.test(e.mode) ? t.idles.push(i) : t.nipples.indexOf(i) >= 0 && t.nipples.splice(t.nipples.indexOf(i), 1), t.manager.unbindDocument(), /(semi|static)/.test(e.mode) && (t.manager.ids[s.id] = s.identifier));
};
wn.prototype.onDestroyed = function(r1, t) {
    var e = this;
    e.nipples.indexOf(t) >= 0 && e.nipples.splice(e.nipples.indexOf(t), 1), e.actives.indexOf(t) >= 0 && e.actives.splice(e.actives.indexOf(t), 1), e.idles.indexOf(t) >= 0 && e.idles.splice(e.idles.indexOf(t), 1), e.ids.indexOf(t.identifier) >= 0 && e.ids.splice(e.ids.indexOf(t.identifier), 1), e.manager.removeIdentifier(t.identifier), e.manager.unbindDocument();
};
wn.prototype.destroy = function() {
    var r1 = this;
    r1.unbindEvt(r1.options.zone, "start"), r1.nipples.forEach(function(e) {
        e.destroy();
    });
    for(var t in r1.pressureIntervals)r1.pressureIntervals.hasOwnProperty(t) && clearInterval(r1.pressureIntervals[t]);
    r1.trigger("destroyed", r1.nipples), r1.manager.unbindDocument(), r1.off();
};
var M2 = wn;
function fr(r1) {
    var t = this;
    t.ids = {}, t.index = 0, t.collections = [], t.scroll = zw(), t.config(r1), t.prepareCollections();
    var e = function() {
        var i;
        t.collections.forEach(function(s) {
            s.forEach(function(o) {
                i = o.el.getBoundingClientRect(), o.position = {
                    x: t.scroll.x + i.left,
                    y: t.scroll.y + i.top
                };
            });
        });
    };
    if (typeof window > "u") return t.collections;
    Td(window, "resize", function() {
        Uw(e);
    });
    var n = function() {
        t.scroll = zw();
    };
    return Td(window, "scroll", function() {
        Uw(n);
    }), t.collections;
}
fr.prototype = new Cd;
fr.constructor = fr;
fr.prototype.prepareCollections = function() {
    var r1 = this;
    r1.collections.create = r1.create.bind(r1), r1.collections.on = r1.on.bind(r1), r1.collections.off = r1.off.bind(r1), r1.collections.destroy = r1.destroy.bind(r1), r1.collections.get = function(t) {
        var e;
        return r1.collections.every(function(n) {
            return e = n.get(t), !e;
        }), e;
    };
};
fr.prototype.create = function(r1) {
    return this.createCollection(r1);
};
fr.prototype.createCollection = function(r1) {
    var t = this, e = new M2(t, r1);
    return t.bindCollection(e), t.collections.push(e), e;
};
fr.prototype.bindCollection = function(r1) {
    var t = this, e, n = function(i, s) {
        e = i.type + " " + s.id + ":" + i.type, t.trigger(e, s);
    };
    r1.on("destroyed", t.onDestroyed.bind(t)), r1.on("shown hidden rested dir plain", n), r1.on("dir:up dir:right dir:down dir:left", n), r1.on("plain:up plain:right plain:down plain:left", n);
};
fr.prototype.bindDocument = function() {
    var r1 = this;
    r1.binded || (r1.bindEvt(document, "move").bindEvt(document, "end"), r1.binded = !0);
};
fr.prototype.unbindDocument = function(r1) {
    var t = this;
    (!Object.keys(t.ids).length || r1 === !0) && (t.unbindEvt(document, "move").unbindEvt(document, "end"), t.binded = !1);
};
fr.prototype.getIdentifier = function(r1) {
    var t;
    return r1 ? (t = r1.identifier === void 0 ? r1.pointerId : r1.identifier, t === void 0 && (t = this.latest || 0)) : t = this.index, this.ids[t] === void 0 && (this.ids[t] = this.index, this.index += 1), this.latest = t, this.ids[t];
};
fr.prototype.removeIdentifier = function(r1) {
    var t = {};
    for(var e in this.ids)if (this.ids[e] === r1) {
        t.id = e, t.identifier = this.ids[e], delete this.ids[e];
        break;
    }
    return t;
};
fr.prototype.onmove = function(r1) {
    var t = this;
    return t.onAny("move", r1), !1;
};
fr.prototype.onend = function(r1) {
    var t = this;
    return t.onAny("end", r1), !1;
};
fr.prototype.oncancel = function(r1) {
    var t = this;
    return t.onAny("end", r1), !1;
};
fr.prototype.onAny = function(r1, t) {
    var e = this, n, i = "processOn" + r1.charAt(0).toUpperCase() + r1.slice(1);
    t = Ey(t);
    var s = function(a, l, u) {
        u.ids.indexOf(l) >= 0 && (u[i](a), a._found_ = !0);
    }, o = function(a) {
        n = e.getIdentifier(a), Ff(e.collections, s.bind(null, a, n)), a._found_ || e.removeIdentifier(n);
    };
    return Ff(t, o), !1;
};
fr.prototype.destroy = function() {
    var r1 = this;
    r1.unbindDocument(!0), r1.ids = {}, r1.index = 0, r1.collections.forEach(function(t) {
        t.destroy();
    }), r1.off();
};
fr.prototype.onDestroyed = function(r1, t) {
    var e = this;
    if (e.collections.indexOf(t) < 0) return !1;
    e.collections.splice(e.collections.indexOf(t), 1);
};
var T2 = fr;
var E2 = new T2, C2 = {
    create: function(r1) {
        return E2.create(r1);
    },
    factory: E2
};
var P2 = Jd(xb());
function os(r1, t) {
    let e = new Me;
    if (!r1.getAttribute("position")) return e.setAttribute("position", new Ae([], 3)), e.setIndex([]), e;
    let { positions: n , triIndices: i  } = Al(r1.getAttribute("position"), r1.getIndex());
    return e.setAttribute("position", new Ae(n, 3)), e.setIndex(i), t && e.applyMatrix4(t), e;
}
var aj = new ae, lj = new ae, Us = [
    [
        0,
        0,
        0
    ],
    [
        0,
        0,
        0
    ],
    [
        0,
        0,
        0
    ]
];
function Gw(r1) {
    let t = r1.elements;
    Us[0][0] = t[0], Us[0][1] = t[4], Us[0][2] = t[8], Us[1][0] = t[1], Us[1][1] = t[5], Us[1][2] = t[9], Us[2][0] = t[2], Us[2][1] = t[6], Us[2][2] = t[10];
    let { u: e , v: n  } = (0, P2.SVD)(Us), i = aj.set(e[0][0], e[0][1], e[0][2], 0, e[1][0], e[1][1], e[1][2], 0, e[2][0], e[2][1], e[2][2], 0, 0, 0, 0, 1), s = lj.set(n[0][0], n[0][1], n[0][2], 0, n[1][0], n[1][1], n[1][2], 0, n[2][0], n[2][1], n[2][2], 0, 0, 0, 0, 1);
    return i.multiply(s.transpose());
}
var Oy = class extends Sc {
    constructor(){
        super(), this.layers.enable(3), this.layers.enable(8);
    }
    setFromCamera(t, e) {
        e.isOrthographicCamera ? (this.ray.origin.set(t.x, t.y, -1).unproject(e), this.ray.direction.set(0, 0, -1).transformDirection(e.matrixWorld), this.camera = e) : e.isPerspectiveCamera ? (this.ray.origin.set(t.x, t.y, -1).unproject(e), this.ray.direction.set(t.x, t.y, .5).unproject(e).sub(this.ray.origin).normalize(), this.camera = e) : console.error("Raycaster: Unsupported camera type.");
    }
    intersectVisibleObjects(t, e = !0, n = []) {
        return t.forEach((i)=>{
            i.visible && this.intersectObject(i, e, n);
        }), n;
    }
    createRaycastLineHelper() {
        let t = new vi({
            color: 65280,
            linewidth: 10
        }), e = new A(this.ray.origin.x, this.ray.origin.y, this.ray.origin.z), n = new A(this.ray.direction.x, this.ray.direction.y, this.ray.direction.z), i = this.camera.far - this.camera.near, s = new A().addVectors(e, n.multiplyScalar(i)), o = new Me;
        return o.setFromPoints([
            e,
            s
        ]), new Xa(o, t);
    }
};
var D2 = (r1)=>r1 instanceof Mo || r1 instanceof ss;
function cj(r1, t) {
    return r1.distance - t.distance;
}
function I2(r1, t, e) {
    if (!(!So(t) || !t.visible)) {
        Zr(t) && t.raycast(r1, e);
        for (let n of t.children)I2(r1, n, e);
    }
}
function zf(r1, t, e) {
    if (!e.some((i)=>Pd(r1, i) !== void 0)) return [];
    let n = [];
    return t.children.forEach((i)=>I2(r1, i, n)), n.sort(cj), n;
}
function Gf(r1) {
    let t = [];
    if (r1.length) {
        let e = r1[0].object;
        So(e) && t.push(e);
        let n = e.parent;
        for(; n;)D2(n) && t.push(n), n = n.parent;
    }
    return t;
}
function Pd(r1, t) {
    if (Zr(t)) {
        if (t.visible) {
            let e = [];
            return t.raycast(r1, e), e.length ? e[0] : void 0;
        }
    } else if (D2(t)) return O2(r1, t);
}
function O2(r1, t) {
    if (!(!So(t) || !t.visible)) {
        if (Zr(t)) {
            let e = [];
            if (t.raycast(r1, e), e.length) return e[0];
        }
        for (let e of t.children){
            let n = O2(r1, e);
            if (n) return n;
        }
    }
}
function uj(r1, t, e) {
    return {
        x: (r1 - (e.left + window.scrollX)) / e.width * 2 - 1,
        y: -((t - (e.top + window.scrollY)) / e.height) * 2 + 1
    };
}
var Ry = class {
    constructor(t, e, n, i, s, o, a){
        this.scene = e;
        this.camera = n;
        this.sharedAssets = i;
        this.stopRaycast = s;
        this.requestRender = o;
        this.isExport = a;
        this.raycaster = new Oy;
        this.raycasterNeedsUpdate = !0;
        this._useWindowEvents = !1;
        this.renderer = t, this._useWindowEvents = e.data.publish.mouseEventTarget === "window", this.domElement = t.domElement, this.eventElement = this._useWindowEvents ? window : t.domElement;
    }
    set useWindowEvents(t) {
        this._useWindowEvents = t, this.eventElement = t ? window : this.renderer.domElement;
    }
    get useWindowEvents() {
        return this._useWindowEvents;
    }
    updateRaycaster(t) {
        if (!this.raycasterNeedsUpdate) return;
        this.raycasterNeedsUpdate = !1;
        let { pageX: e , pageY: n  } = t.touches !== void 0 && t.touches.length > 0 ? t.touches[0] : t, i = this.domElement.getBoundingClientRect();
        this.raycaster.setFromCamera(uj(e, n, i), this.camera);
    }
};
var Vw = ((a)=>(a[a.keydown = 0] = "keydown", a[a.keyup = 1] = "keyup", a[a.pointerdown = 2] = "pointerdown", a[a.pointerup = 3] = "pointerup", a[a.pointermove = 4] = "pointermove", a[a.wheel = 5] = "wheel", a[a.scroll = 6] = "scroll", a))(Vw || {}), Bn = class {
    constructor(t){
        this.eventContext = t;
        this.domEventsNeeded = new Set;
        this.hasVideoAction = !1;
    }
    connect() {}
    disconnect() {}
};
var R2 = new Map, Vf = new Map, To = class {
    constructor(t, e, n, i){
        this.data = e;
        let { audio: s , volume: o , delay: a , loop: l  } = e;
        if (!s) throw new Error("Missing property");
        let u = typeof s == "string" ? i.getAudio(s).src : s.data;
        this.audioPlayer = new Ao({
            src: u,
            volume: o,
            delay: a,
            loop: l
        }), Vf.has(n.uuid) ? Vf.get(n.uuid).push(this) : Vf.set(n.uuid, [
            this
        ]), R2.set(t, this);
    }
    playByToggle() {
        this.data.toggle === "stop" ? this.audioPlayer.status === "playing" ? this.audioPlayer.stop() : (this.audioPlayer.stop(), this.audioPlayer.play()) : this.data.toggle === "pause" ? this.audioPlayer.status === "playing" ? this.audioPlayer.pause() : this.audioPlayer.play() : (this.audioPlayer.stop(), this.audioPlayer.play());
    }
    dispose() {
        this.audioPlayer.stop();
    }
}, Dd = class {
    constructor(t){
        this.data = t;
    }
    dispatch() {
        this.data.playAudio ? this.pauseAudio(this.data.playAudio) : this.data.object ? this.pauseAllAudiosFromObject(this.data.object) : this.pauseAllAudios();
    }
    pauseAudio(t) {
        let e = R2.get(t);
        !e || (this.data.delay > 0 ? (this.disposeDelay(), this.timeoutId = window.setTimeout(()=>{
            e.audioPlayer[this.data.interaction](), this.disposeDelay();
        }, this.data.delay)) : e.audioPlayer[this.data.interaction]());
    }
    pauseAllAudiosFromObject(t) {
        let e = Vf.get(t);
        !e?.length || (this.data.delay > 0 ? (this.disposeDelay(), this.timeoutId = window.setTimeout(()=>{
            e.forEach((n)=>n.audioPlayer[this.data.interaction]()), this.disposeDelay();
        }, this.data.delay)) : e.forEach((n)=>n.audioPlayer[this.data.interaction]()));
    }
    pauseAllAudios() {
        let t = [
            ...Vf.values()
        ];
        !t.length || (this.data.delay > 0 ? (this.disposeDelay(), this.timeoutId = window.setTimeout(()=>{
            t.forEach((e)=>{
                e.forEach((n)=>{
                    n.audioPlayer[this.data.interaction]();
                });
            }), this.disposeDelay();
        }, this.data.delay)) : t.forEach((e)=>{
            e.forEach((n)=>{
                n.audioPlayer[this.data.interaction]();
            });
        }));
    }
    disposeDelay() {
        clearTimeout(this.timeoutId), delete this.timeoutId;
    }
    dispose() {
        clearTimeout(this.timeoutId), delete this.timeoutId;
    }
}, Eo = class {
    constructor(t, e, n, i){
        this.data = e;
        if (e.interaction === "play") this.interaction = new To(t, e, n, i);
        else if (e.interaction === "pause" || e.interaction === "stop") this.interaction = new Dd(e);
        else throw new Error("Missing property");
    }
    dispatchBasic() {
        this.interaction instanceof To ? this.interaction.playByToggle() : this.interaction.dispatch();
    }
    dispatchConditional() {
        this.interaction instanceof To ? this.interaction.audioPlayer.play() : this.interaction.dispatch();
    }
    dispatchGameControl(t) {
        this.interaction instanceof To && (t === "start" ? this.interaction.audioPlayer.play() : this.interaction.audioPlayer.stop());
    }
    dispose() {
        this.interaction.dispose();
    }
};
function L2(r1, t) {
    let e = r1.material.layers.find((n)=>n.uuid === t);
    if (!!e) return e.color.texture.image.img instanceof HTMLVideoElement ? e.color.texture.image.img : void 0;
}
var N2 = new Map, Hf = new Map, Aa = class {
    constructor(t, e, n){
        this.data = e;
        this.delay = 0;
        this.status = "stopped";
        let { layerId: i , loop: s , volume: o , delay: a  } = e;
        if (this.object = n, i === void 0) throw new Error("Missing property");
        let l = L2(n, i);
        l && (this.videoElement = l, this.videoElement.loop = s === 1 / 0, this.videoElement.autoplay = !0, o !== void 0 && (this.videoElement.volume = o)), a !== void 0 && (this.delay = a), Hf.has(n.uuid) ? Hf.get(n.uuid).push(this) : Hf.set(n.uuid, [
            this
        ]), N2.set(t, this), this.pause();
    }
    mute() {
        !this.videoElement || (this.videoElement.muted = !0);
    }
    unMute() {
        !this.videoElement || (this.videoElement.muted = !1);
    }
    play(t) {
        if (!this.videoElement) return;
        let e = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        t ? (this.mute(), this.delay += 150) : e ? (this.mute(), window.setTimeout(()=>{
            this.unMute();
        }, 100)) : this.unMute(), this.delayTimerId = window.setTimeout(()=>{
            if (!this.videoElement) return;
            let n = this.videoElement.play();
            n !== void 0 && n.then((i)=>{}).catch((i)=>{
                this.play();
            }), this.clearDelay();
        }, this.delay), this.status = "playing";
    }
    clearDelay() {
        this.delayTimerId && (clearTimeout(this.delayTimerId), delete this.delayTimerId);
    }
    pause() {
        !this.videoElement || (this.videoElement.pause(), this.status = "paused");
    }
    stop() {
        !this.videoElement || (this.videoElement.pause(), this.videoElement.currentTime = 0, this.status = "stopped", this.clearDelay());
    }
    playByToggle() {
        this.data.toggle === "stop" ? this.status === "playing" ? this.stop() : (this.stop(), this.play()) : this.data.toggle === "pause" ? this.status === "playing" ? this.pause() : this.play() : (this.stop(), this.play());
    }
    dispose() {
        !this.videoElement || (this.stop(), this.videoElement.muted = !0);
    }
}, Id = class {
    constructor(t){
        this.data = t;
    }
    dispatch() {
        this.data.playVideo ? this.pauseVideo(this.data.playVideo) : this.data.object ? this.pauseAllVideosFromObject(this.data.object) : this.pauseAllVideos();
    }
    pauseVideo(t) {
        let e = N2.get(t);
        !e || (this.data.delay > 0 ? (this.disposeDelay(), this.timeoutId = window.setTimeout(()=>{
            e[this.data.interaction](), this.disposeDelay();
        }, this.data.delay)) : e[this.data.interaction]());
    }
    pauseAllVideosFromObject(t) {
        let e = Hf.get(t);
        !e?.length || (this.data.delay > 0 ? (this.disposeDelay(), this.timeoutId = window.setTimeout(()=>{
            e.forEach((n)=>n[this.data.interaction]()), this.disposeDelay();
        }, this.data.delay)) : e.forEach((n)=>n[this.data.interaction]()));
    }
    pauseAllVideos() {
        let t = [
            ...Hf.values()
        ];
        !t.length || (this.data.delay > 0 ? (this.disposeDelay(), this.timeoutId = window.setTimeout(()=>{
            t.forEach((e)=>{
                e.forEach((n)=>{
                    n[this.data.interaction]();
                });
            }), this.disposeDelay();
        }, this.data.delay)) : t.forEach((e)=>{
            e.forEach((n)=>{
                n[this.data.interaction]();
            });
        }));
    }
    disposeDelay() {
        clearTimeout(this.timeoutId), delete this.timeoutId;
    }
    dispose() {
        clearTimeout(this.timeoutId), delete this.timeoutId;
    }
}, Bl = class {
    constructor(t, e, n){
        this.data = e;
        if (e.interaction === "play") this.interaction = new Aa(t, e, n);
        else if (e.interaction === "pause" || e.interaction === "stop") this.interaction = new Id(e);
        else throw new Error("Missing property");
    }
    dispatchBasic() {
        this.interaction instanceof Aa ? this.interaction.playByToggle() : this.interaction.dispatch();
    }
    dispatchConditional() {
        this.interaction instanceof Aa ? this.interaction.play() : this.interaction.dispatch();
    }
    dispose() {
        this.interaction.dispose();
    }
};
var dj = "text/plain", hj = "us-ascii", B2 = (r1, t)=>t.some((e)=>e instanceof RegExp ? e.test(r1) : e === r1), fj = (r1, { stripHash: t  })=>{
    let e = /^data:(?<type>[^,]*?),(?<data>[^#]*?)(?:#(?<hash>.*))?$/.exec(r1);
    if (!e) throw new Error(`Invalid URL: ${r1}`);
    let { type: n , data: i , hash: s  } = e.groups, o = n.split(";");
    s = t ? "" : s;
    let a = !1;
    o[o.length - 1] === "base64" && (o.pop(), a = !0);
    let l = (o.shift() || "").toLowerCase(), c = [
        ...o.map((d)=>{
            let [h, f = ""] = d.split("=").map((m)=>m.trim());
            return h === "charset" && (f = f.toLowerCase(), f === hj) ? "" : `${h}${f ? `=${f}` : ""}`;
        }).filter(Boolean)
    ];
    return a && c.push("base64"), (c.length > 0 || l && l !== dj) && c.unshift(l), `data:${c.join(";")},${a ? i.trim() : i}${s ? `#${s}` : ""}`;
};
function Hw(r1, t) {
    if (t = {
        defaultProtocol: "http:",
        normalizeProtocol: !0,
        forceHttp: !1,
        forceHttps: !1,
        stripAuthentication: !0,
        stripHash: !1,
        stripTextFragment: !0,
        stripWWW: !0,
        removeQueryParameters: [
            /^utm_\w+/i
        ],
        removeTrailingSlash: !0,
        removeSingleSlash: !0,
        removeDirectoryIndex: !1,
        sortQueryParameters: !0,
        ...t
    }, r1 = r1.trim(), /^data:/i.test(r1)) return fj(r1, t);
    if (/^view-source:/i.test(r1)) throw new Error("`view-source:` is not supported as it is a non-standard protocol");
    let e = r1.startsWith("//");
    !e && /^\.*\//.test(r1) || (r1 = r1.replace(/^(?!(?:\w+:)?\/\/)|^\/\//, t.defaultProtocol));
    let i = new URL(r1);
    if (t.forceHttp && t.forceHttps) throw new Error("The `forceHttp` and `forceHttps` options cannot be used together");
    if (t.forceHttp && i.protocol === "https:" && (i.protocol = "http:"), t.forceHttps && i.protocol === "http:" && (i.protocol = "https:"), t.stripAuthentication && (i.username = "", i.password = ""), t.stripHash ? i.hash = "" : t.stripTextFragment && (i.hash = i.hash.replace(/#?:~:text.*?$/i, "")), i.pathname) {
        let o = /\b[a-z][a-z\d+\-.]{1,50}:\/\//g, a = 0, l = "";
        for(;;){
            let c = o.exec(i.pathname);
            if (!c) break;
            let d = c[0], h = c.index, f = i.pathname.slice(a, h);
            l += f.replace(/\/{2,}/g, "/"), l += d, a = h + d.length;
        }
        let u = i.pathname.slice(a, i.pathname.length);
        l += u.replace(/\/{2,}/g, "/"), i.pathname = l;
    }
    if (i.pathname) try {
        i.pathname = decodeURI(i.pathname);
    } catch  {}
    if (t.removeDirectoryIndex === !0 && (t.removeDirectoryIndex = [
        /^index\.[a-z]+$/
    ]), Array.isArray(t.removeDirectoryIndex) && t.removeDirectoryIndex.length > 0) {
        let o = i.pathname.split("/"), a = o[o.length - 1];
        B2(a, t.removeDirectoryIndex) && (o = o.slice(0, -1), i.pathname = o.slice(1).join("/") + "/");
    }
    if (i.hostname && (i.hostname = i.hostname.replace(/\.$/, ""), t.stripWWW && /^www\.(?!www\.)[a-z\-\d]{1,63}\.[a-z.\-\d]{2,63}$/.test(i.hostname) && (i.hostname = i.hostname.replace(/^www\./, ""))), Array.isArray(t.removeQueryParameters)) for (let o of [
        ...i.searchParams.keys()
    ])B2(o, t.removeQueryParameters) && i.searchParams.delete(o);
    if (t.removeQueryParameters === !0 && (i.search = ""), t.sortQueryParameters) {
        i.searchParams.sort();
        try {
            i.search = decodeURIComponent(i.search);
        } catch  {}
    }
    t.removeTrailingSlash && (i.pathname = i.pathname.replace(/\/$/, ""));
    let s = r1;
    return r1 = i.toString(), !t.removeSingleSlash && i.pathname === "/" && !s.endsWith("/") && i.hash === "" && (r1 = r1.replace(/\/$/, "")), (t.removeTrailingSlash || i.pathname === "/") && i.hash === "" && t.removeSingleSlash && (r1 = r1.replace(/\/$/, "")), e && !t.normalizeProtocol && (r1 = r1.replace(/^http:\/\//, "//")), t.stripProtocol && (r1 = r1.replace(/^(?:https?:)?\/\//, "")), r1;
}
var Ly = class {
    constructor({ url: t , context: e  }, n){
        this.managers = n;
        if (!t) throw new Error("Missing property");
        this.url = t.startsWith("mailto:") ? t : Hw(t, {
            removeTrailingSlash: !1,
            removeSingleSlash: !1
        }), this.context = e ?? "tab";
    }
    dispatch() {
        Rm ? window.location.assign(this.url) : (this.context === "tab" ? window.open(this.url, "_blank") : this.context === "window" ? window.open(this.url, "_blank", `width=${window.innerWidth}, height=${window.innerHeight}`) : window.open(this.url, "_parent"), this.managers.controlsManager.orbitControls?.onPointerUp(ke[0]), xT());
    }
};
var Wf = class {
    constructor(t, e, n){
        this.data = t;
        this.managers = n;
        this.timeoutIdQueue = [];
        this.dispatchInner = ()=>{
            this.objects.forEach(this.destroyCallback);
        };
        this.destroyCallback = (t)=>{
            this.timeoutIdQueue.shift();
            let e = this.scene.find(t);
            if (e === void 0) return;
            let n = this.controlsManager.sharedGameControlGlobals.rapierWorld, i = n ? e.dataPatched.physics?.fusedBody : !0;
            if (e.cloner) {
                for (let s of e.cloner.children)i ? (s.playModeVisible = !1, s.rigidBody && e.dataPatched.physics?.rigidBody === "positioned" && (n.removeRigidBody(s.rigidBody), s.rigidBody = void 0), s.boundsTree && (s.boundsTree = void 0)) : this.clone === void 0 || this.clone === s ? (s.playModeVisible = !1, s.rigidBody && (n.removeRigidBody(s.rigidBody), s.rigidBody = void 0)) : s.playModeVisible === void 0 && (s.playModeVisible = !0);
                (i || this.clone === void 0 || this.clone === !1) && (e.visible = !1, e.rigidBody && (n.removeRigidBody(e.rigidBody), e.rigidBody = void 0), e.boundsTree && (e.boundsTree = void 0));
            } else e.rigidBody && (n.removeRigidBody(e.rigidBody), e.rigidBody = void 0), e.boundsTree && (e.boundsTree = void 0), e.visible = !1;
            n === void 0 ? this.controlsManager.sharedGameControlGlobals.entitiesWithTransformAnim = this.controlsManager.sharedGameControlGlobals.entitiesWithTransformAnim.filter((s)=>s.boundsTree !== void 0) : this.controlsManager.sharedGameControlGlobals.entitiesWithTransformAnim = this.controlsManager.sharedGameControlGlobals.entitiesWithTransformAnim.filter((s)=>s.rigidBody !== void 0), this.managers.eventManager.requestRender();
        };
        this.objects = [
            ...t.objects
        ], this.scene = e, this.controlsManager = n.controlsManager;
    }
    dispatch(t) {
        this.clone = t, this.data.delay ? this.timeoutIdQueue.push(window.setTimeout(this.dispatchInner, this.data.delay * 1e3)) : this.dispatchInner();
    }
    dispatchFromStart() {
        this.timeoutIdQueue.push(window.setTimeout(this.dispatchInner, this.data.delay * 1e3));
    }
    dispose() {
        this.timeoutIdQueue.forEach((t)=>window.clearTimeout(t));
    }
};
var F2 = (()=>{
    let r1, t, e, n;
    function i(a) {
        !r1 && !U2() && t?.sharedGameControlGlobals.createdObjects.length > 0 && (r1 = requestAnimationFrame(s)), a && (t = a, n = a.requestRender);
    }
    function s(a) {
        let l = e ? a - e : 0, u = t.sharedGameControlGlobals.createdObjects, c = t.sharedGameControlGlobals.nCreatedPerAction, d = u.length, h = 0;
        for(; h < d;){
            let f = u[h];
            f.userData.createdTime === void 0 && (f.userData.createdTime = a), f.userData.lifetime === void 0 && f.userData.quantity === void 0 || f.userData.lifetime && a - f.userData.createdTime < f.userData.lifetime || f.userData.quantity && c[f.userData.actionId] <= f.userData.quantity ? (f.userData.velocity && (f.position.addScaledVector(f.userData.velocity, l / 1e3), f.updateMatrix(), n()), h++) : (c[f.userData.actionId] > f.userData.quantity && c[f.userData.actionId]--, u.splice(h, 1), f.removeFromParent(), t.sharedGameControlGlobals.rapierWorld && f.rigidBody ? t.sharedGameControlGlobals.rapierWorld.removeRigidBody(f.rigidBody) : (f.boundsTree = void 0, t.sharedGameControlGlobals.entitiesWithTransformAnim = t.sharedGameControlGlobals.entitiesWithTransformAnim.filter((m)=>m.boundsTree !== void 0)), d--, n());
        }
        r1 = h > 0 ? requestAnimationFrame(s) : void 0, e = h > 0 ? a : void 0;
    }
    function o() {
        U2() ? r1 && (cancelAnimationFrame(r1), e = void 0) : i();
    }
    return typeof document < "u" && document.addEventListener("visibilitychange", o), i;
})();
function U2() {
    return !!document && document.hidden;
}
var k2 = new Je, pj = new A, mj = new A, Co = class {
    constructor(t, e, n){
        this.data = t;
        this.scene = e;
        this.controlsManager = n;
        this.intervalId = null;
        this.timeoutIdQueue = [];
        this.uniqueId = He.generateUUID();
        this.dispatch = ()=>{
            this.data.delay ? this.timeoutIdQueue.push(window.setTimeout(this.dispatchInner, this.data.delay * 1e3)) : this.dispatchInner();
        };
        this.dispatchFromStart = ()=>{
            this.timeoutIdQueue.push(window.setTimeout(this.dispatchInner, this.data.delay * 1e3));
        };
        this.dispatchThrottled = wx(this.dispatch, 1e3 / this.data.creationSpeed);
        this.dispatchStart = ()=>{
            this.intervalId === null && (this.intervalId = window.setInterval(this.dispatch, 1e3 / this.data.creationSpeed));
        };
        this.dispatchStop = ()=>{
            this.intervalId !== null && (window.clearInterval(this.intervalId), this.intervalId = null);
        };
        this.dispatchInner = ()=>{
            if (this.timeoutIdQueue.shift(), this.object === void 0) return;
            let t = new dn(this.object);
            if (t.playModeVisible = !0, t.expand(), this.data.coordinateSystem !== "world") {
                let n = this.data.coordinateSystem;
                n === bn.PERSONAL_CAMERA_ID && this.scene.find(bn.PERSONAL_CAMERA_EXPORT_ID) && (n = bn.PERSONAL_CAMERA_EXPORT_ID);
                let i = this.scene.find(n);
                i && (i.updateMatrixWorldSVD(), t.hiddenMatrix.setPosition(0, 0, 0), t.hiddenMatrix.premultiply(i.matrixWorldRigid), t.updateMatrixWorld());
            }
            t.position.fromArray(this.data.position), t.rotation.fromArray(this.data.rotation), t.updateMatrix(), this.scene.add(t);
            let e = this.controlsManager.sharedGameControlGlobals;
            e.createdObjects.push(t), e.nCreatedPerAction[this.uniqueId] === void 0 ? e.nCreatedPerAction[this.uniqueId] = 1 : e.nCreatedPerAction[this.uniqueId]++, t.updateWorldMatrix(!0, !0), t.traverseObject(this.traverseObjectCB), F2(), this.controlsManager.requestRender();
        };
        this.traverseObjectCB = (t)=>{
            t.hasNonUniformScale && t.updateMatrixWorldSVD();
            let e;
            if (this.controlsManager.sharedGameControlGlobals.rapierWorld) {
                if (t instanceof hr) {
                    if (t.objectForSample) {
                        if (t.objectForSample.dataPatched.physics.fusedBody) return;
                        e = t.object;
                    } else return t.object.dataPatched.physics.fusedBody === !0 && t.object.dataPatched.physics.rigidBody === "dynamic" ? !0 : void 0;
                } else if (t instanceof dn) e = t.object;
                else if (e = t, e.dataPatched.cloner?.hideBase) return !0;
            } else {
                if (t instanceof hr) return;
                t instanceof dn ? e = t.object : e = t;
            }
            this.data.destroy === "Time" ? t.userData.lifetime = this.data.lifetime * 1e3 : this.data.destroy === "Quantity" && (t.userData.quantity = this.data.destroyAfterQuantity, t.userData.actionId = this.uniqueId), t.matrixWorld.decompose(pj, k2, mj);
            let n = new A().fromArray(this.data.velocity).applyQuaternion(k2), i = e.dataPatched;
            if (!(i.collision === "visibility" ? !i.visible : !i.collision) && (this.controlsManager.sharedGameControlGlobals.rapierWorld ? (this.controlsManager.addRigidBody(t, e, {
                fromCreate: !0,
                dynamic: this.data.dynamic
            }), this.data.destroy === "Collision" && (t.rigidBody?.collider(0).setActiveEvents(1), t.userData.hasCollisionDestroy = !0), this.data.velocity.some((s)=>s !== 0) && this.data.dynamic && t.rigidBody?.setLinvel(n.divideScalar(this.controlsManager.pixelsPerMeter), !0)) : ("geometry" in t.object && this.controlsManager.addBoundsTree(t), this.data.velocity.some((s)=>s !== 0) && this.data.dynamic && (t.userData.velocity = n)), e.dataPatched.physics?.fusedBody === !0)) return !0;
        };
        this.scene = e, this.object = this.scene.find(this.data.object), F2(n);
    }
    dispose() {
        this.intervalId !== null && (window.clearInterval(this.intervalId), this.intervalId = null), this.timeoutIdQueue.forEach((t)=>window.clearTimeout(t)), this.dispatchThrottled.cancel(), this.scene.remove(...this.controlsManager.sharedGameControlGlobals.createdObjects), this.controlsManager.sharedGameControlGlobals.createdObjects = [];
    }
};
var Ny = class {
    constructor(t, e, n, i){
        this.scene = e, this.sharedAssets = n, this.sceneData = t, this.managers = i;
    }
    dispatch() {
        By(this.sceneData, this.scene, this.sharedAssets, !0), this.managers.eventManager?.reset(), this.managers.controlsManager?.gameControls.forEach((e)=>e.reset(!0));
        let t;
        this.sceneData.publish.playCamera ? t = this.scene.find(this.sceneData.publish.playCamera) : (t = this.scene.find(bn.PERSONAL_CAMERA_ID), t || (t = this.scene.find(bn.PERSONAL_CAMERA_EXPORT_ID))), this.scene.switchActiveCamera(t), this.managers.controlsManager.requestRender();
    }
};
var j2 = {
    update: null,
    begin: null,
    loopBegin: null,
    changeBegin: null,
    change: null,
    changeComplete: null,
    timelineChangeComplete: null,
    loopComplete: null,
    complete: null,
    loop: 1,
    direction: "normal",
    autoplay: !0,
    timelineOffset: 0,
    rewind: !0
}, Xw = {
    duration: 1e3,
    delay: 0,
    endDelay: 0,
    startOnceDelay: 0,
    pingPongDelayCorrection: 0,
    pingPongEndDelayCorrection: 0,
    easing: "easeOutElastic(1, .5)",
    round: 0
}, gj = [
    "translateX",
    "translateY",
    "translateZ",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "scale",
    "scaleX",
    "scaleY",
    "scaleZ",
    "skew",
    "skewX",
    "skewY",
    "perspective",
    "matrix",
    "matrix3d"
], Uy = {
    CSS: {},
    springs: {}
};
function as(r1, t, e) {
    return Math.min(Math.max(r1, t), e);
}
function jf(r1, t) {
    return r1.indexOf(t) > -1;
}
function Ww(r1, t) {
    return r1.apply(null, t);
}
var et = {
    arr: function(r1) {
        return Array.isArray(r1);
    },
    obj: function(r1) {
        return jf(Object.prototype.toString.call(r1), "Object");
    },
    pth: function(r1) {
        return et.obj(r1) && r1.hasOwnProperty("totalLength");
    },
    svg: function(r1) {
        return r1 instanceof SVGElement;
    },
    inp: function(r1) {
        return r1 instanceof HTMLInputElement;
    },
    dom: function(r1) {
        return !("isNode" in r1) && (r1.nodeType || et.svg(r1));
    },
    str: function(r1) {
        return typeof r1 == "string";
    },
    fnc: function(r1) {
        return typeof r1 == "function";
    },
    und: function(r1) {
        return typeof r1 > "u";
    },
    hex: function(r1) {
        return /(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(r1);
    },
    rgb: function(r1) {
        return /^rgb/.test(r1);
    },
    hsl: function(r1) {
        return /^hsl/.test(r1);
    },
    col: function(r1) {
        return et.hex(r1) || et.rgb(r1) || et.hsl(r1);
    },
    key: function(r1) {
        return !j2.hasOwnProperty(r1) && !Xw.hasOwnProperty(r1) && r1 !== "targets" && r1 !== "keyframes";
    }
};
function q2(r1) {
    var t = /\(([^)]+)\)/.exec(r1);
    return t ? t[1].split(",").map(function(e) {
        return parseFloat(e);
    }) : [];
}
function X2(r1, t) {
    var e = q2(r1), n = as(et.und(e[0]) ? 1 : e[0], .1, 100), i = as(et.und(e[1]) ? 100 : e[1], .1, 100), s = as(et.und(e[2]) ? 10 : e[2], .1, 100), o = as(et.und(e[3]) ? 0 : e[3], .1, 100), a = Math.sqrt(i / n), l = s / (2 * Math.sqrt(i * n)), u = l < 1 ? a * Math.sqrt(1 - l * l) : 0, c = 1, d = l < 1 ? (l * a + -o) / u : -o + a;
    function h(m) {
        var p = t ? t * m / 1e3 : m;
        return l < 1 ? p = Math.exp(-p * l * a) * (c * Math.cos(u * p) + d * Math.sin(u * p)) : p = (c + d * p) * Math.exp(-p * a), m === 0 || m === 1 ? m : 1 - p;
    }
    function f() {
        var m = Uy.springs[r1];
        if (m) return m;
        for(var p = 1 / 6, g = 0, y = 0;;)if (g += p, h(g) === 1) {
            if (y++, y >= 16) break;
        } else y = 0;
        var v = g * p * 1e3;
        return Uy.springs[r1] = v, v;
    }
    return t ? h : f;
}
function yj(r1) {
    return r1 === void 0 && (r1 = 10), function(t) {
        return Math.ceil(as(t, 1e-6, 1) * r1) * (1 / r1);
    };
}
var vj = function() {
    var r1 = 11, t = 1 / (r1 - 1);
    function e(c, d) {
        return 1 - 3 * d + 3 * c;
    }
    function n(c, d) {
        return 3 * d - 6 * c;
    }
    function i(c) {
        return 3 * c;
    }
    function s(c, d, h) {
        return ((e(d, h) * c + n(d, h)) * c + i(d)) * c;
    }
    function o(c, d, h) {
        return 3 * e(d, h) * c * c + 2 * n(d, h) * c + i(d);
    }
    function a(c, d, h, f, m) {
        var p, g, y = 0;
        do g = d + (h - d) / 2, p = s(g, f, m) - c, p > 0 ? h = g : d = g;
        while (Math.abs(p) > 1e-7 && ++y < 10);
        return g;
    }
    function l(c, d, h, f) {
        for(var m = 0; m < 4; ++m){
            var p = o(d, h, f);
            if (p === 0) return d;
            var g = s(d, h, f) - c;
            d -= g / p;
        }
        return d;
    }
    function u(c, d, h, f) {
        if (!(0 <= c && c <= 1 && 0 <= h && h <= 1)) return;
        var m = new Float32Array(r1);
        if (c !== d || h !== f) for(var p = 0; p < r1; ++p)m[p] = s(p * t, c, h);
        function g(y) {
            for(var v = 0, x = 1, w = r1 - 1; x !== w && m[x] <= y; ++x)v += t;
            --x;
            var S = (y - m[x]) / (m[x + 1] - m[x]), _ = v + S * t, M = o(_, c, h);
            return M >= .001 ? l(y, _, c, h) : M === 0 ? _ : a(y, v, v + t, c, h);
        }
        return function(y) {
            return c === d && h === f || y === 0 || y === 1 ? y : s(g(y), d, f);
        };
    }
    return u;
}(), Y2 = function() {
    var r1 = {
        linear: function() {
            return function(n) {
                return n;
            };
        }
    }, t = {
        Sine: function() {
            return function(n) {
                return 1 - Math.cos(n * Math.PI / 2);
            };
        },
        Circ: function() {
            return function(n) {
                return 1 - Math.sqrt(1 - n * n);
            };
        },
        Back: function() {
            return function(n) {
                return n * n * (3 * n - 2);
            };
        },
        Bounce: function() {
            return function(n) {
                for(var i, s = 4; n < ((i = Math.pow(2, --s)) - 1) / 11;);
                return 1 / Math.pow(4, 3 - s) - 7.5625 * Math.pow((i * 3 - 2) / 22 - n, 2);
            };
        },
        Elastic: function(n, i) {
            n === void 0 && (n = 1), i === void 0 && (i = .5);
            var s = as(n, 1, 10), o = as(i, .1, 2);
            return function(a) {
                return a === 0 || a === 1 ? a : -s * Math.pow(2, 10 * (a - 1)) * Math.sin((a - 1 - o / (Math.PI * 2) * Math.asin(1 / s)) * (Math.PI * 2) / o);
            };
        }
    }, e = [
        "Quad",
        "Cubic",
        "Quart",
        "Quint",
        "Expo"
    ];
    return e.forEach(function(n, i) {
        t[n] = function() {
            return function(s) {
                return Math.pow(s, i + 2);
            };
        };
    }), Object.keys(t).forEach(function(n) {
        var i = t[n];
        r1["easeIn" + n] = i, r1["easeOut" + n] = function(s, o) {
            return function(a) {
                return 1 - i(s, o)(1 - a);
            };
        }, r1["easeInOut" + n] = function(s, o) {
            return function(a) {
                return a < .5 ? i(s, o)(a * 2) / 2 : 1 - i(s, o)(a * -2 + 2) / 2;
            };
        };
    }), r1;
}();
function Yw(r1, t) {
    if (et.fnc(r1)) return r1;
    var e = r1.split("(")[0], n = Y2[e], i = q2(r1);
    switch(e){
        case "spring":
            return X2(r1, t);
        case "cubicBezier":
            return Ww(vj, i);
        case "steps":
            return Ww(yj, i);
        default:
            return Ww(n, i);
    }
}
function Q2(r1) {
    try {
        var t = document.querySelectorAll(r1);
        return t;
    } catch  {
        return;
    }
}
function ky(r1, t) {
    for(var e = r1.length, n = arguments.length >= 2 ? arguments[1] : void 0, i = [], s = 0; s < e; s++)if (s in r1) {
        var o = r1[s];
        t.call(n, o, s, r1) && i.push(o);
    }
    return i;
}
function zy(r1) {
    return r1.reduce(function(t, e) {
        return t.concat(et.arr(e) ? zy(e) : e);
    }, []);
}
function z2(r1) {
    return et.arr(r1) ? r1 : (et.str(r1) && (r1 = Q2(r1) || r1), r1 instanceof NodeList || r1 instanceof HTMLCollection ? [].slice.call(r1) : [
        r1
    ]);
}
function Qw(r1, t) {
    return r1.some(function(e) {
        return e === t;
    });
}
function Kw(r1) {
    var t = {};
    for(var e in r1)t[e] = r1[e];
    return t;
}
function jw(r1, t) {
    var e = Kw(r1);
    for(var n in r1)e[n] = t.hasOwnProperty(n) ? t[n] : r1[n];
    return e;
}
function Gy(r1, t) {
    var e = Kw(r1);
    for(var n in t)e[n] = et.und(r1[n]) ? t[n] : r1[n];
    return e;
}
function xj(r1) {
    var t = /rgb\((\d+,\s*[\d]+,\s*[\d]+)\)/g.exec(r1);
    return t ? "rgba(" + t[1] + ",1)" : r1;
}
function bj(r1) {
    var t = /^#?([a-f\d])([a-f\d])([a-f\d])$/i, e = r1.replace(t, function(a, l, u, c) {
        return l + l + u + u + c + c;
    }), n = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(e), i = parseInt(n[1], 16), s = parseInt(n[2], 16), o = parseInt(n[3], 16);
    return "rgba(" + i + "," + s + "," + o + ",1)";
}
function wj(r1) {
    var t = /hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(r1) || /hsla\((\d+),\s*([\d.]+)%,\s*([\d.]+)%,\s*([\d.]+)\)/g.exec(r1), e = parseInt(t[1], 10) / 360, n = parseInt(t[2], 10) / 100, i = parseInt(t[3], 10) / 100, s = t[4] || 1;
    function o(h, f, m) {
        return m < 0 && (m += 1), m > 1 && (m -= 1), m < 1 / 6 ? h + (f - h) * 6 * m : m < 0.5 ? f : m < 2 / 3 ? h + (f - h) * (2 / 3 - m) * 6 : h;
    }
    var a, l, u;
    if (n == 0) a = l = u = i;
    else {
        var c = i < .5 ? i * (1 + n) : i + n - i * n, d = 2 * i - c;
        a = o(d, c, e + 1 / 3), l = o(d, c, e), u = o(d, c, e - 1 / 3);
    }
    return "rgba(" + a * 255 + "," + l * 255 + "," + u * 255 + "," + s + ")";
}
function Sj(r1) {
    if (et.rgb(r1)) return xj(r1);
    if (et.hex(r1)) return bj(r1);
    if (et.hsl(r1)) return wj(r1);
}
function Po(r1) {
    var t = /[+-]?\d*\.?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?(%|px|pt|em|rem|in|cm|mm|ex|ch|pc|vw|vh|vmin|vmax|deg|rad|turn)?$/.exec(r1);
    if (t) return t[1];
}
function Aj(r1) {
    if (jf(r1, "translate") || r1 === "perspective") return "px";
    if (jf(r1, "rotate") || jf(r1, "skew")) return "deg";
}
function qw(r1, t) {
    return et.fnc(r1) ? r1(t.target, t.id, t.total) : r1;
}
function ks(r1, t) {
    return r1.getAttribute(t);
}
function Zw(r1, t, e) {
    var n = Po(t);
    if (Qw([
        e,
        "deg",
        "rad",
        "turn"
    ], n)) return t;
    var i = Uy.CSS[t + e];
    if (!et.und(i)) return i;
    var s = 100, o = document.createElement(r1.tagName), a = r1.parentNode && r1.parentNode !== document ? r1.parentNode : document.body;
    a.appendChild(o), o.style.position = "absolute", o.style.width = s + e;
    var l = s / o.offsetWidth;
    a.removeChild(o);
    var u = l * parseFloat(t);
    return Uy.CSS[t + e] = u, u;
}
function K2(r1, t, e) {
    if (t in r1.style) {
        var n = t.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase(), i = r1.style[t] || getComputedStyle(r1).getPropertyValue(n) || "0";
        return e ? Zw(r1, i, e) : i;
    }
}
function Jw(r1, t) {
    if (et.dom(r1) && !et.inp(r1) && (ks(r1, t) || et.svg(r1) && r1[t])) return "attribute";
    if (et.dom(r1) && Qw(gj, t)) return "transform";
    if (et.dom(r1) && t !== "transform" && K2(r1, t)) return "css";
    if (r1[t] != null) return "object";
}
function Z2(r1) {
    if (!!et.dom(r1)) {
        for(var t = r1.style.transform || "", e = /(\w+)\(([^)]*)\)/g, n = new Map, i; i = e.exec(t);)n.set(i[1], i[2]);
        return n;
    }
}
function _j(r1, t, e, n) {
    var i = jf(t, "scale") ? 1 : 0 + Aj(t), s = Z2(r1).get(t) || i;
    return e && (e.transforms.list.set(t, s), e.transforms.last = t), n ? Zw(r1, s, n) : s;
}
function $w(r1, t, e, n) {
    switch(Jw(r1, t)){
        case "transform":
            return _j(r1, t, n, e);
        case "css":
            return K2(r1, t, e);
        case "attribute":
            return ks(r1, t);
        default:
            return r1[t] || 0;
    }
}
function eS(r1, t) {
    var e = /^(\*=|\+=|-=)/.exec(r1);
    if (!e) return r1;
    var n = Po(r1) || 0, i = parseFloat(t), s = parseFloat(r1.replace(e[0], ""));
    switch(e[0][0]){
        case "+":
            return i + s + n;
        case "-":
            return i - s + n;
        case "*":
            return i * s + n;
    }
}
function J2(r1, t) {
    if (et.col(r1)) return Sj(r1);
    if (/\s/g.test(r1)) return r1;
    var e = Po(r1), n = e ? r1.substr(0, r1.length - e.length) : r1;
    return t ? n + t : n;
}
function tS(r1, t) {
    return Math.sqrt(Math.pow(t.x - r1.x, 2) + Math.pow(t.y - r1.y, 2));
}
function Mj(r1) {
    return Math.PI * 2 * ks(r1, "r");
}
function Tj(r1) {
    return ks(r1, "width") * 2 + ks(r1, "height") * 2;
}
function Ej(r1) {
    return tS({
        x: ks(r1, "x1"),
        y: ks(r1, "y1")
    }, {
        x: ks(r1, "x2"),
        y: ks(r1, "y2")
    });
}
function $2(r1) {
    for(var t = r1.points, e = 0, n, i = 0; i < t.numberOfItems; i++){
        var s = t.getItem(i);
        i > 0 && (e += tS(n, s)), n = s;
    }
    return e;
}
function Cj(r1) {
    var t = r1.points;
    return $2(r1) + tS(t.getItem(t.numberOfItems - 1), t.getItem(0));
}
function eD(r1) {
    if (r1.getTotalLength) return r1.getTotalLength();
    switch(r1.tagName.toLowerCase()){
        case "circle":
            return Mj(r1);
        case "rect":
            return Tj(r1);
        case "line":
            return Ej(r1);
        case "polyline":
            return $2(r1);
        case "polygon":
            return Cj(r1);
    }
}
function Pj(r1) {
    var t = eD(r1);
    return r1.setAttribute("stroke-dasharray", t), t;
}
function Dj(r1) {
    for(var t = r1.parentNode; et.svg(t) && et.svg(t.parentNode);)t = t.parentNode;
    return t;
}
function tD(r1, t) {
    var e = t || {}, n = e.el || Dj(r1), i = n.getBoundingClientRect(), s = ks(n, "viewBox"), o = i.width, a = i.height, l = e.viewBox || (s ? s.split(" ") : [
        0,
        0,
        o,
        a
    ]);
    return {
        el: n,
        viewBox: l,
        x: l[0] / 1,
        y: l[1] / 1,
        w: o / l[2],
        h: a / l[3]
    };
}
function Ij(r1, t) {
    var e = et.str(r1) ? Q2(r1)[0] : r1, n = t || 100;
    return function(i) {
        return {
            property: i,
            el: e,
            svg: tD(e),
            totalLength: eD(e) * (n / 100)
        };
    };
}
function Oj(r1, t) {
    function e(a) {
        a === void 0 && (a = 0);
        var l = t + a >= 1 ? t + a : 0;
        return r1.el.getPointAtLength(l);
    }
    var n = tD(r1.el, r1.svg), i = e(), s = e(-1), o = e(1);
    switch(r1.property){
        case "x":
            return (i.x - n.x) * n.w;
        case "y":
            return (i.y - n.y) * n.h;
        case "angle":
            return Math.atan2(o.y - s.y, o.x - s.x) * 180 / Math.PI;
    }
}
function G2(r1, t) {
    var e = /[+-]?\d*\.?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?/g, n = J2(et.pth(r1) ? r1.totalLength : r1, t) + "";
    return {
        original: n,
        numbers: n.match(e) ? n.match(e).map(Number) : [
            0
        ],
        strings: et.str(r1) || t ? n.split(e) : []
    };
}
function nD(r1) {
    var t = r1 ? zy(et.arr(r1) ? r1.map(z2) : z2(r1)) : [];
    return ky(t, function(e, n, i) {
        return i.indexOf(e) === n;
    });
}
function rD(r1) {
    var t = nD(r1);
    return t.map(function(e, n) {
        return {
            target: e,
            id: n,
            total: t.length,
            transforms: {
                list: Z2(e)
            }
        };
    });
}
function Rj(r1, t) {
    var e = Kw(t);
    if (/^spring/.test(e.easing) && (e.duration = X2(e.easing)), et.arr(r1)) {
        var n = r1.length, i = n === 2 && !et.obj(r1[0]);
        i ? r1 = {
            value: r1
        } : et.fnc(t.duration) || (e.duration = t.duration / n);
    }
    var s = et.arr(r1) ? r1 : [
        r1
    ];
    return s.map(function(o, a) {
        var l = et.obj(o) && !et.pth(o) ? o : {
            value: o
        };
        return et.und(l.delay) && (l.delay = a ? 0 : t.delay), et.und(l.endDelay) && (l.endDelay = a === s.length - 1 ? t.endDelay : 0), l;
    }).map(function(o) {
        return Gy(o, e);
    });
}
function Lj(r1) {
    for(var t = ky(zy(r1.map(function(s) {
        return Object.keys(s);
    })), function(s) {
        return et.key(s);
    }).reduce(function(s, o) {
        return s.indexOf(o) < 0 && s.push(o), s;
    }, []), e = {}, n = function(s) {
        var o = t[s];
        e[o] = r1.map(function(a) {
            var l = {};
            for(var u in a)et.key(u) ? u == o && (l.value = a[u]) : l[u] = a[u];
            return l;
        });
    }, i = 0; i < t.length; i++)n(i);
    return e;
}
function Nj(r1, t) {
    var e = [], n = t.keyframes;
    n && (t = Gy(Lj(n), t));
    for(var i in t)et.key(i) && e.push({
        name: i,
        tweens: Rj(t[i], r1)
    });
    return e;
}
function Bj(r1, t) {
    var e = {};
    for(var n in r1){
        var i = qw(r1[n], t);
        et.arr(i) && (i = i.map(function(s) {
            return qw(s, t);
        }), i.length === 1 && (i = i[0])), e[n] = i;
    }
    return e.duration = parseFloat(e.duration), e.delay = parseFloat(e.delay), e;
}
function Fj(r1, t) {
    var e;
    return r1.tweens.map(function(n) {
        var i = Bj(n, t), s = i.value, o = et.arr(s) ? s[1] : s, a = Po(o), l = $w(t.target, r1.name, a, t), u = e ? e.to.original : l, c = et.arr(s) ? s[0] : u, d = Po(c) || Po(l), h = a || d;
        return et.und(o) && (o = u), i.from = G2(c, h), i.to = G2(eS(o, c), h), i.start = e ? e.end : 0, i.end = i.start + i.delay + i.duration + i.endDelay, i.easing = Yw(i.easing, i.duration), i.isPath = et.pth(s), i.isColor = et.col(i.from.original), i.isColor && (i.round = 1), e = i, i;
    });
}
var iD = {
    css: function(r1, t, e) {
        return r1.style[t] = e;
    },
    attribute: function(r1, t, e) {
        return r1.setAttribute(t, e);
    },
    object: function(r1, t, e) {
        return r1[t] = e;
    },
    transform: function(r1, t, e, n, i) {
        if (n.list.set(t, e), t === n.last || i) {
            var s = "";
            n.list.forEach(function(o, a) {
                s += a + "(" + o + ") ";
            }), r1.style.transform = s;
        }
    }
};
function sD(r1, t) {
    var e = rD(r1);
    e.forEach(function(n) {
        for(var i in t){
            var s = qw(t[i], n), o = n.target, a = Po(s), l = $w(o, i, a, n), u = a || Po(l), c = eS(J2(s, u), l), d = Jw(o, i);
            iD[d](o, i, c, n.transforms, !0);
        }
    });
}
function Uj(r1, t) {
    var e = Jw(r1.target, t.name);
    if (e) {
        var n = Fj(t, r1), i = n[n.length - 1];
        return {
            type: e,
            property: t.name,
            animatable: r1,
            tweens: n,
            duration: i.end,
            delay: n[0].delay,
            endDelay: i.endDelay
        };
    }
}
function kj(r1, t) {
    return ky(zy(r1.map(function(e) {
        return t.map(function(n) {
            return Uj(e, n);
        });
    })), function(e) {
        return !et.und(e);
    });
}
function oD(r1, t) {
    var e = r1.length, n = function(s) {
        return s.timelineOffset ? s.timelineOffset : 0;
    }, i = {};
    return i.duration = e ? Math.max.apply(Math, r1.map(function(s) {
        let o = s.startOnceDelay ?? 0, a = s.pingPongDelayCorrection ?? 0, l = s.pingPongEndDelayCorrection ?? 0;
        return n(s) + o + a + l + s.duration * (s.loop ?? 1);
    })) : t.duration, i.delay = e ? Math.min.apply(Math, r1.map(function(s) {
        let o = s.startOnceDelay ?? 0, a = s.pingPongDelayCorrection ?? 0;
        return n(s) + o + a + s.delay;
    })) : t.delay, i.endDelay = e ? i.duration - Math.max.apply(Math, r1.map(function(s) {
        let o = s.startOnceDelay ?? 0, a = s.pingPongDelayCorrection ?? 0, l = s.pingPongEndDelayCorrection ?? 0;
        return n(s) + o + a + s.duration * (s.loop ?? 1) - s.endDelay - l;
    })) : t.endDelay, i;
}
var V2 = 0;
function zj(r1) {
    var t = jw(j2, r1), e = jw(Xw, r1), n = Nj(e, r1), i = rD(r1.targets), s = kj(i, n), o = oD(s, e), a = V2;
    return V2++, Gy(t, {
        id: a,
        children: [],
        animatables: i,
        animations: s,
        duration: o.duration,
        delay: o.delay,
        endDelay: o.endDelay,
        startOnceDelay: e.startOnceDelay,
        pingPongDelayCorrection: e.pingPongDelayCorrection,
        pingPongEndDelayCorrection: e.pingPongEndDelayCorrection
    });
}
var Di = [], H2 = [], Fy, Gj = function() {
    function r1() {
        Fy = requestAnimationFrame(t);
    }
    function t(e) {
        var n = Di.length;
        if (n) {
            for(var i = 0; i < n;){
                var s = Di[i];
                s.paused ? (Di.splice(i, 1), n -= 1) : (s.tick(e), i++);
            }
            r1();
        } else Fy = cancelAnimationFrame(Fy);
    }
    return r1;
}();
function Vj(r1) {
    document.hidden ? (Di.forEach(function(t) {
        return t.pause(r1.timeStamp);
    }), H2 = Di.slice(0), Sn.running = Di = []) : H2.forEach(function(t) {
        return t.play(r1.timeStamp);
    });
}
typeof document < "u" && document.addEventListener("visibilitychange", Vj);
function Sn(r1) {
    r1 === void 0 && (r1 = {});
    var t = 0, e = 0, n = 0, i, s, o = 0, a = null;
    function l(M) {
        var b = window.Promise && new Promise(function(T) {
            return a = T;
        });
        return M.finished = b, b;
    }
    var u = zj(r1), c = l(u);
    function d() {
        var M = u.direction;
        M !== "alternate" && (u.direction = M !== "normal" ? "normal" : "reverse"), u.reversed = !u.reversed, s.forEach(function(b) {
            (b.loop === 1 || b.loop % 2 === 0) && (b.reversed = u.reversed);
        });
    }
    function h() {
        u.direction = "normal", u.reversed = !1, s.forEach(function(M) {
            return M.reversed = !1;
        });
    }
    function f(M) {
        return u.reversed ? u.duration - M : M;
    }
    function m() {
        t = 0, e = f(u.currentTime) * (1 / Sn.speed);
    }
    function p(M, b) {
        b && (u.reversed ? b.seek(b.duration * b.loop - (M - b.timelineOffset - b.pingPongDelayCorrection)) : b.seek(M - b.timelineOffset - b.startOnceDelay - b.pingPongDelayCorrection));
    }
    function g(M) {
        if (u.reversed) for(var T = o; T--;)p(M, s[T]);
        else for(var b = 0; b < o; b++)p(M, s[b]);
    }
    function y(M) {
        var b = 0, T = u.animations, E = T.length;
        for(u.direction !== "alternate" && u.parent?.direction === "alternate" ? u.parent?.rewind === !1 && u.reversePlayback === !0 && u.rewind === !1 && (u.parent?.reversed && u.direction === "alternate" ? M = u.duration - u.delay + u.endDelay - M : M = u.duration + u.delay - u.endDelay - M) : S(!1, u.parent?.rewind, u.rewind, u.parent?.reversePlayback, u.reversePlayback) && (u.parent?.reversed && u.direction === "alternate" ? M = u.duration - u.delay + u.endDelay - M : M = u.duration + u.delay - u.endDelay - M); b < E;){
            var P = T[b], D = P.animatable, C = P.tweens, O = C.length - 1, B = C[O];
            O && (B = ky(C, function(k) {
                return M < k.end;
            })[0] || B);
            let Z;
            u.parent?.reversed && u.direction === "alternate" ? Z = as(M - B.start - B.endDelay, 0, B.duration) / B.duration : Z = as(M - B.start - B.delay, 0, B.duration) / B.duration;
            for(var V = isNaN(Z) ? 1 : B.easing(Z), Y = B.to.strings, W = B.round, q = [], j = B.to.numbers.length, X = void 0, L = 0; L < j; L++){
                var U = void 0;
                let k, he;
                u.direction !== "alternate" ? u.parent?.rewind === !1 && u.reversePlayback === !0 && u.rewind === !1 ? (k = B.to.numbers[L], he = B.from.numbers[L] || 0) : (he = B.to.numbers[L], k = B.from.numbers[L] || 0) : S(!0, u.parent?.rewind, u.rewind, u.parent?.reversePlayback, u.reversePlayback) ? (k = B.to.numbers[L], he = B.from.numbers[L] || 0) : (he = B.to.numbers[L], k = B.from.numbers[L] || 0), B.isPath ? U = Oj(B.value, V * he) : U = k + V * (he - k), W && (B.isColor && L > 2 || (U = Math.round(U * W) / W)), q.push(U);
            }
            var G = Y.length;
            if (!G) X = q[0];
            else {
                X = Y[0];
                for(var H = 0; H < G; H++){
                    var z = Y[H], re = Y[H + 1], K = q[H];
                    isNaN(K) || (re ? X += K + re : X += K + " ");
                }
            }
            iD[P.type](D.target, P.property, X, D.transforms), P.currentValue = X, b++;
        }
    }
    function v(M) {
        u[M] && !u.passThrough && u[M](u);
    }
    function x() {
        u.remaining && u.remaining !== !0 && u.remaining--;
    }
    let w = {
        0: !1,
        1: !0,
        2: !1,
        3: !0,
        4: !1,
        5: !1,
        6: !1,
        7: !1,
        8: !1,
        9: !0,
        10: !0,
        11: !1,
        12: !1,
        13: !1,
        14: !0,
        15: !0,
        16: !1,
        17: !0,
        18: !0,
        19: !1,
        20: !1,
        21: !1,
        22: !0,
        23: !0,
        24: !1,
        25: !0,
        26: !1,
        27: !0,
        28: !1,
        29: !1,
        30: !1,
        31: !1
    };
    function S(M, b, T, E, P) {
        return w[M << 4 | b << 3 | T << 2 | E << 1 | P];
    }
    function _(M) {
        var b = u.duration;
        let T = u.delay, E = b - u.endDelay;
        u.parent?.reversed && u.direction === "alternate" && (T = u.endDelay, E = b - u.delay);
        var P = f(M);
        if (u.progress = as(P / b * 100, 0, 100), u.reversePlayback = P < u.currentTime, o && g(P), !u.began && u.currentTime >= 0 && (u.began = !0, v("begin")), !u.loopBegan && u.currentTime > 0 && (u.loopBegan = !0, v("loopBegin")), (u.reversed || P >= 0) && P <= T && u.currentTime !== 0 && (y(0), v("change")), (P >= E && u.currentTime !== b + u.pingPongDelayCorrection || !b) && (y(b), v("change")), P > T && P < E ? (u.changeBegan || (u.changeBegan = !0, u.changeCompleted = !1, v("changeBegin")), y(P), v("change")) : u.changeBegan ? (u.changeCompleted = !0, u.changeBegan = !1, v("change"), o && v("timelineChangeComplete")) : u.began && P > E && v("changeComplete"), u.currentTime = as(P, 0, b + u.pingPongDelayCorrection), u.began && v("update"), M >= b) {
            if (x(), !u.remaining) u.paused = !0, u.completed || (u.completed = !0, v("loopComplete"), v("complete"), !u.passThrough && "Promise" in window && (a(), c = l(u)));
            else {
                o ? t += u.duration / Sn.speed : t += u.duration;
                for (let D of s)D.setStartTime(0), D.remaining = D.loop;
                v("loopComplete"), u.loopBegan = !1, u.direction === "alternate" ? d() : o && h();
            }
        }
    }
    return u.reset = function() {
        var M = u.direction;
        u.passThrough = !1, u.currentTime = 0, u.progress = 0, u.paused = !0, u.began = !1, u.loopBegan = !1, u.changeBegan = !1, u.completed = !1, u.changeCompleted = !1, u.reversePlayback = !1, u.reversed = M === "reverse", u.remaining = u.loop, s = u.children, o = s.length;
        for(var b = o; b--;)u.children[b].reset();
        (u.reversed && u.loop !== !0 || M === "alternate" && u.loop === 1) && u.remaining++, y(u.reversed ? u.duration : 0);
    }, u.setStartTime = function(M) {
        t = M;
    }, u.set = function(M, b) {
        return sD(M, b), u;
    }, u.tick = function(M) {
        n = M, t || (t = n), _((n + (e - t)) * Sn.speed);
    }, u.seek = function(M) {
        _(M - t);
    }, u.pause = function(M) {
        u.paused = !0, o && (i = M ?? performance.now());
    }, u.play = function(M) {
        !u.paused || (u.completed && u.reset(), u.paused = !1, Di.push(u), o && i !== void 0 && (t += (M ?? performance.now()) - i), Fy || Gj());
    }, u.reverse = function() {
        d(), u.completed = !u.reversed, m();
    }, u.restart = function() {
        u.reset(), u.play();
    }, u.reset(), u.autoplay && u.play(), u;
}
function W2(r1, t) {
    for(var e = t.length; e--;)Qw(r1, t[e].animatable.target) && t.splice(e, 1);
}
function Hj(r1) {
    for(var t = nD(r1), e = Di.length; e--;){
        var n = Di[e], i = n.animations, s = n.children;
        W2(t, i);
        for(var o = s.length; o--;){
            var a = s[o], l = a.animations;
            W2(t, l), !l.length && !a.children.length && s.splice(o, 1);
        }
        !i.length && !s.length && n.pause();
    }
}
function Wj(r1, t) {
    t === void 0 && (t = {});
    var e = t.direction || "normal", n = t.easing ? Yw(t.easing) : null, i = t.grid, s = t.axis, o = t.from || 0, a = o === "first", l = o === "center", u = o === "last", c = et.arr(r1), d = parseFloat(c ? r1[0] : r1), h = c ? parseFloat(r1[1]) : 0, f = Po(c ? r1[1] : r1) || 0, m = t.start || 0 + (c ? d : 0), p = [], g = 0;
    return function(y, v, x) {
        if (a && (o = 0), l && (o = (x - 1) / 2), u && (o = x - 1), !p.length) {
            for(var w = 0; w < x; w++){
                if (!i) p.push(Math.abs(o - w));
                else {
                    var S = l ? (i[0] - 1) / 2 : o % i[0], _ = l ? (i[1] - 1) / 2 : Math.floor(o / i[0]), M = w % i[0], b = Math.floor(w / i[0]), T = S - M, E = _ - b, P = Math.sqrt(T * T + E * E);
                    s === "x" && (P = -T), s === "y" && (P = -E), p.push(P);
                }
                g = Math.max.apply(Math, p);
            }
            n && (p = p.map(function(C) {
                return n(C / g) * g;
            })), e === "reverse" && (p = p.map(function(C) {
                return s ? C < 0 ? C * -1 : -C : Math.abs(g - C);
            }));
        }
        var D = c ? (h - d) / g : d;
        return m + D * (Math.round(p[v] * 100) / 100) + f;
    };
}
function jj(r1) {
    r1 === void 0 && (r1 = {});
    var t = Sn(r1);
    return t.duration = 0, t.add = function(e, n) {
        var i = Di.indexOf(t), s = t.children;
        i > -1 && Di.splice(i, 1);
        function o(h) {
            h.passThrough = !0;
        }
        for(var a = 0; a < s.length; a++)o(s[a]);
        var l = Gy(e, jw(Xw, r1));
        l.targets = l.targets || r1.targets;
        var u = t.duration;
        l.autoplay = !1, l.timelineOffset = et.und(n) ? u : eS(n, u), o(t);
        var c = Sn(l);
        o(c), s.push(c), c.parent = t;
        var d = oD(s, r1);
        return t.delay = d.delay, t.endDelay = d.endDelay, t.duration = d.duration, c.loop === !0 && (t.duration = 1 / 0), t.seek(0), t.reset(), t.autoplay && t.play(), t;
    }, t;
}
Sn.version = "3.2.0";
Sn.speed = 1;
Sn.running = Di;
Sn.remove = Hj;
Sn.get = $w;
Sn.set = sD;
Sn.convertPx = Zw;
Sn.path = Ij;
Sn.setDashoffset = Pj;
Sn.stagger = Wj;
Sn.timeline = jj;
Sn.easing = Yw;
Sn.penner = Y2;
Sn.random = function(r1, t) {
    return Math.floor(Math.random() * (t - r1 + 1)) + r1;
};
var Vy = Sn;
var aD = new A, lD = new A, cD = new Je;
function uD(r1, t, e, n) {
    if (n === 0) return e.copy(r1);
    if (n === 1) return e.copy(t);
    let i = r1.w * t.w + r1.x * t.x + r1.y * t.y + r1.z * t.z;
    if (i >= 1) return e.copy(r1);
    let s = 1 - i * i;
    if (s <= Number.EPSILON) {
        let c = 1 - n;
        return e.w = c * r1.w + n * t.w, e.x = c * r1.x + n * t.x, e.y = c * r1.y + n * t.y, e.z = c * r1.z + n * t.z, e.normalize(), e;
    }
    let o = Math.sqrt(s), a = Math.atan2(o, i), l = Math.sin((1 - n) * a) / o, u = Math.sin(n * a) / o;
    return e.w = r1.w * l + t.w * u, e.x = r1.x * l + t.x * u, e.y = r1.y * l + t.y * u, e.z = r1.z * l + t.z * u, e;
}
function ls(r1, t, e, n, i) {
    let s = e[r1] ? e[r1] : void 0, o = n[r1];
    if (o == null) return;
    let a = s ?? t[r1], l = o;
    if (a !== l) return {
        update: (u)=>{
            let c = He.lerp(a, l, u);
            i ? t[r1] = Math.trunc(c) : t[r1] = c;
        },
        start: ()=>{
            t[r1] = a;
        },
        end: ()=>{
            t[r1] = l;
        }
    };
}
function nS(r1, t, e, n, i) {
    let s = e[r1] ? e[r1] : void 0, o = n[r1];
    if (!o) return;
    let a = t[r1], l = [
        ...s ?? a
    ], u = [
        ...o
    ];
    if (!(l.length !== u.length || al(l, u))) return {
        update: (c)=>{
            l.forEach((d, h)=>{
                let f = He.lerp(d, u[h], c);
                t[r1][h] = i ? Math.trunc(f) : f;
            });
        },
        start: ()=>{
            Object.assign(t[r1], l);
        },
        end: ()=>{
            Object.assign(t[r1], u);
        }
    };
}
function rS(r1, t, e, n) {
    let i = e[r1] ? e[r1] : void 0, s = n[r1];
    if (!s) return;
    let o = t[r1], a = i ? new A().fromArray(i) : o.clone(), l = new A().fromArray(s);
    if (!a.equals(l)) return {
        update: (u)=>{
            o.lerpVectors(a, l, u);
        },
        start: ()=>{
            o.copy(a);
        },
        end: ()=>{
            o.copy(l);
        }
    };
}
function dD(r1, t, e, n) {
    let i = e[r1] ? e[r1] : void 0, s = n[r1];
    if (!s) return;
    let o = t[r1], a = i ? new ae().fromArray(i) : o.clone(), l = new A, u = new Je, c = new A;
    a.decompose(l, u, c);
    let d = new ae().fromArray(s), h = new A, f = new Je, m = new A;
    if (d.decompose(h, f, m), !a.equals(d)) return {
        update: (p)=>{
            cD.slerpQuaternions(u, f, p), aD.lerpVectors(l, h, p), lD.lerpVectors(c, m, p), o.compose(aD, cD, lD);
        },
        start: ()=>{
            o.compose(l, u, c);
        },
        end: ()=>{
            o.compose(h, f, m);
        }
    };
}
function hD(r1, t, e, n, i) {
    let s = e[r1] ? e[r1] : void 0, o = n[r1];
    if (!o) return;
    let a = t[r1], l = s ? typeof s == "string" ? i.getColor(s).clone() : new Ne().setRGB(s.r, s.g, s.b) : a.clone(), u = typeof o == "string" ? i.getColor(o).clone() : new Ne().setRGB(o.r, o.g, o.b);
    if (l.equals(u)) return;
    let c = a.clone();
    return t[r1] = c, {
        update: (d)=>{
            c.lerpColors(l, u, d);
        },
        start: ()=>{
            c.copy(l);
        },
        end: ()=>{
            c.copy(u);
        }
    };
}
function zs(r1, t, e, n) {
    if (typeof t[r1] == "number") return ls(r1, t, e ?? {}, n);
    if (Array.isArray(t[r1])) return nS(r1, t, e ?? {}, n);
}
function fD(r1, t, e) {
    let n = [], i = r1.cameraType === "OrthographicCamera" ? t.orthographic?.zoom : t.perspective?.zoom, s = r1.cameraType === "OrthographicCamera" ? e.orthographic?.zoom : e.perspective?.zoom;
    if (s !== void 0) {
        let o = i ?? r1.zoom, a = s;
        o !== a && n.push({
            update: (l)=>{
                r1.zoom = He.lerp(o, a, l), r1.updateProjectionMatrix();
            },
            start: ()=>{
                r1.zoom = o, r1.updateProjectionMatrix();
            },
            end: ()=>{
                r1.zoom = a, r1.updateProjectionMatrix();
            }
        });
    }
    if (e.targetOffset !== void 0) {
        let o = ls("targetOffset", r1, t, e);
        o && n.push(o);
    }
    return n;
}
function qj(r1, t, e, n) {
    if (e.scaleBaked === void 0) return;
    let i = t.scaleBaked ?? r1.data.geometry.scaleBaked, s = e.scaleBaked;
    if (_s.isEqual(i, s)) return;
    let o = [];
    return o.push({
        update: (a)=>{
            r1.updateGeometryInteractions({
                scaleBaked: [
                    He.lerp(i[0], s[0], a),
                    He.lerp(i[1], s[1], a),
                    He.lerp(i[2], s[2], a)
                ]
            }, n), r1.invalidateDownstreamBooleanData();
        },
        start: ()=>{
            r1.updateGeometryInteractions({
                scaleBaked: i
            }, n), r1.invalidateDownstreamBooleanData();
        },
        end: ()=>{
            r1.updateGeometryInteractions({
                scaleBaked: s
            }, n), r1.invalidateDownstreamBooleanData();
        }
    }), o;
}
function Xj(r1, t, e) {
    if (!e.extrusion) return;
    let n = r1.extrusion, i = t.extrusion ?? {}, s = e.extrusion, o = [];
    return $x.forEach((a)=>{
        let l = zs(a, n, i, s);
        l && o.push(l);
    }), o;
}
function pD(r1, t, e, n) {
    let i = [];
    if (!("geometry" in e)) return i;
    let s = r1.geometry.userData.parameters, o = "geometry" in t ? t.geometry : {}, a = e.geometry;
    if (r1 instanceof rs) {
        let l = qj(r1, o, a, n);
        l && i.push(...l);
    } else {
        let l = {};
        if (Object.assign(l, ra(s, eb)), eb.forEach((u)=>{
            let c = zs(u, l, o, a);
            c && i.push(c);
        }), r1 instanceof Sa) {
            Object.assign(l, {
                extrusion: {
                    ...s.extrusion
                }
            });
            let u = Xj(l, o, a);
            u && i.push(...u);
        }
        i.length && i.push({
            update: (u)=>{
                r1.updateGeometryInteractions(l, n), r1.updateGeometryGroupsIfNeeded();
            },
            start: (u)=>{
                r1.updateGeometryInteractions(l, n), r1.updateGeometryGroupsIfNeeded();
            },
            end: (u)=>{
                r1.updateGeometryInteractions(l, n), r1.updateGeometryGroupsIfNeeded();
            }
        });
    }
    return i;
}
function mD(r1, t, e, n) {
    let i = [];
    if (e.intensity !== void 0) {
        let s = ls("intensity", r1, t, e);
        s && i.push(s);
    }
    if (e.color !== void 0) {
        let s = hD("color", r1, t, e, n);
        s && i.push(s);
    }
    return i;
}
function yD(r1, t, e, n) {
    let i = [];
    if (Array.isArray(r1.material)) {
        if (!("materials" in e && e.materials)) return i;
        let s = "materials" in t && t.materials ? t.materials : [], o = e.materials;
        r1.material.forEach((a, l)=>{
            if (!o[l]) return;
            let u = s[l] ?? {}, c = o[l];
            typeof u == "string" || typeof c == "string" || i.push(...gD(a, u, c, n));
        });
    } else {
        if (!("material" in e && e.material)) return i;
        let s = "material" in t && t.material ? t.material : {}, o = e.material;
        if (typeof s == "string" || typeof o == "string") return i;
        i.push(...gD(r1.material, s, o, n));
    }
    return i;
}
function gD(r1, t, e, n) {
    let i = [], s = Cf(e, n) || !!t.layers && Cf(t, n);
    i.push(n6(r1, s));
    for (let o of r1.layers){
        let a = t.layers?.data(o.uuid), l = e.layers.data(o.uuid);
        if (!l || !(o.visible ?? !0) || !(l.visible ?? !0)) continue;
        let u = o.getNames().filter((c)=>!dg.some((d)=>c.includes(d)));
        for (let c of u)try {
            let d = o.getValue(c), h;
            if (c === "colors") h = e6(o, a, l, c);
            else if (Array.isArray(d)) c === "steps" && (h = $j(o, a, l, c));
            else if (typeof d == "number") h = Yj(o, a, l, c);
            else {
                if (typeof d == "boolean") continue;
                d instanceof F ? h = Qj(o, a, l, c) : d instanceof A ? h = Kj(o, a, l, c) : d instanceof $t ? h = Jj(o, a, l, c, n) : d instanceof Ne ? h = Zj(o, a, l, c, n) : "isTexture" in d && (h = t6(o, a, l, c));
            }
            h && (Array.isArray(h) ? i.push(...h) : i.push(h));
        } catch (d) {
            console.error(`lerpMaterial: unexpected material layer for ${c}`, d);
        }
    }
    return i;
}
function Yj(r1, t, e, n) {
    if (!r1.hasValue(n) || !(n in e)) return;
    let i = t ? t[n] : r1.getValue(n), s = e[n];
    if (i !== s) return {
        update: (o)=>{
            r1.setValue(n, He.lerp(i, s, o));
        },
        start: ()=>{
            r1.setValue(n, i);
        },
        end: ()=>{
            r1.setValue(n, s);
        }
    };
}
function Qj(r1, t, e, n) {
    if (!r1.hasValue(n) || !(n in e)) return;
    let i = r1.getValue(n), s = t ? new F().fromArray(t[n]) : i.clone(), o = new F().fromArray(e[n]);
    if (!s.equals(o)) return {
        update: (a)=>{
            i.lerpVectors(s, o, a);
        },
        start: ()=>{
            i.copy(s);
        },
        end: ()=>{
            i.copy(o);
        }
    };
}
function Kj(r1, t, e, n) {
    if (!r1.hasValue(n) || !(n in e)) return;
    let i = r1.getValue(n), s = t ? new A().fromArray(t[n]) : i.clone(), o = new A().fromArray(e[n]);
    if (!s.equals(o)) return {
        update: (a)=>{
            i.lerpVectors(s, o, a);
        },
        start: ()=>{
            i.copy(s);
        },
        end: ()=>{
            i.copy(o);
        }
    };
}
function Zj(r1, t, e, n, i) {
    if (!r1.hasValue(n) || !(n in e)) return;
    let s = t ? t[n] : void 0, o = e[n], a = r1.getValue(n), l = s ? typeof s == "string" ? i.getColor(s).clone() : new Ne().setRGB(s.r, s.g, s.b) : a.clone(), u = typeof o == "string" ? i.getColor(o).clone() : new Ne().setRGB(o.r, o.g, o.b);
    if (l.equals(u)) return;
    let c = a.clone();
    return r1.setValue(n, c), {
        update: (d)=>{
            c.lerpColors(l, u, d);
        },
        start: ()=>{
            c.copy(l);
        },
        end: ()=>{
            c.copy(u);
        }
    };
}
function Jj(r1, t, e, n, i) {
    if (!r1.hasValue(n) || !(n in e)) return;
    let s = t ? t[n] : void 0, o = e[n], a = r1.getValue(n), l = s ? typeof s == "string" ? i.getColor(s).clone() : new Ne().setRGB(s.r, s.g, s.b) : a.clone(), u = typeof o == "string" ? i.getColor(o).clone() : new $t(o.r, o.g, o.b, o.a);
    if (l.equals(u)) return;
    let c = a.clone();
    return r1.setValue(n, c), {
        update: (d)=>{
            c.lerpColors(l, u, d);
        },
        start: ()=>{
            c.copy(l);
        },
        end: ()=>{
            c.copy(u);
        }
    };
}
function $j(r1, t, e, n = "steps") {
    if (!r1.hasValue(n) || !(n in e)) return;
    let i = [], s = r1.getValue(n), o = t ? t[n] : s, a = e[n];
    for(let l = 0; l < s.length; ++l){
        let u = o[l], c = a[l];
        u !== c && i.push({
            update: (d)=>{
                s[l] = He.lerp(u, c, d);
            },
            start: ()=>{
                s[l] = u;
            },
            end: ()=>{
                s[l] = c;
            }
        });
    }
    return i.length ? i : void 0;
}
function e6(r1, t, e, n = "colors") {
    if (!r1.hasValue(n) || !(n in e)) return;
    let i = [], s = r1.getValue(n), o = t ? t[n] : s.map((l)=>l.toArray()), a = e[n];
    for(let l = 0; l < s.length; ++l){
        let u = [
            ...o[l]
        ], c = [
            ...a[l]
        ];
        qh.isEqual(u, c) || i.push({
            update: (d)=>{
                s[l].fromArray(qh.lerp(u, c, d));
            },
            start: ()=>{
                s[l].fromArray(u);
            },
            end: ()=>{
                s[l].fromArray(c);
            }
        });
    }
    return i.length ? i : void 0;
}
function t6(r1, t, e, n = "texture") {
    if (!r1.hasValue(n) || !(n in e)) return;
    let i = r1.getNode("mat");
    if (!i) return;
    let s = t ? t[n] : i, o = e[n], a = [
        ...s.repeat
    ], l = [
        ...s.offset
    ], u = [
        ...o.repeat
    ], c = [
        ...o.offset
    ];
    if (!hl.isEqual(a, u) || !hl.isEqual(l, c)) return {
        update: (d)=>{
            i.repeat = hl.lerp(a, u, d), i.offset = hl.lerp(l, c, d), i.updateMatrix();
        },
        start: ()=>{
            i.repeat = [
                ...a
            ], i.offset = [
                ...l
            ], i.updateMatrix();
        },
        end: ()=>{
            i.repeat = [
                ...u
            ], i.offset = [
                ...c
            ], i.updateMatrix();
        }
    };
}
function n6(r1, t) {
    return {
        update: ()=>{
            r1.transparent = t;
        }
    };
}
var iS = new A, vD = new Wt;
function xD(r1, t, e, n) {
    let i = [], s, o, a, l, u, c, d = {
        slide: (t.pathSnapping ?? r1.updatedPathSnapping ?? r1.dataPatched.pathSnapping).slide,
        offset: (t.pathSnapping ?? r1.updatedPathSnapping ?? r1.dataPatched.pathSnapping).offset
    };
    if (u = ls("slide", d, t.pathSnapping ?? r1.updatedPathSnapping ?? r1.dataPatched.pathSnapping, e.pathSnapping ?? r1.dataPatched.pathSnapping), u && i.push(u), c = ls("offset", d, t.pathSnapping ?? r1.updatedPathSnapping ?? r1.dataPatched.pathSnapping, e.pathSnapping ?? r1.dataPatched.pathSnapping), c && i.push(c), !u && !c && (s = rS("position", r1, t, e), s && i.push(s), o = rS("scale", r1, t, e), o && i.push(o), a = r6(r1, t, e, n), a && i.push(a), l = dD("hiddenMatrix", r1, t, e), l && i.push(l)), s || o || a || l || u || c) {
        let h = ()=>{
            r1.updateMatrix(), r1.hasNonUniformScale && (r1.updateMatrixWorld(), r1.updateMatrixWorldSVD()), r1.parent?.matrixWorldFusedFalse && (r1.matrixWorld.multiplyMatrices(r1.parent.matrixWorldFusedFalse, r1.matrix), r1.matrixWorldNeedsUpdate = !1), Zr(r1) && Gr(r1.parent) && r1.invalidateDownstreamBooleanData(!0), r1.updatePathSnapping(Object.assign({}, t.pathSnapping, d));
        };
        i.push({
            update: h,
            start: h,
            end: h
        });
    }
    return i;
}
function r6(r1, t, e, n) {
    let i = t?.rotation ? t.rotation : void 0, s = e.rotation;
    if (!s) return;
    let o = i ? new A().fromArray(i) : new A().setFromEuler(r1.rotation), a = new A().fromArray(s);
    if (o.equals(a)) return;
    let l = iS.subVectors(a, o);
    if (n && l.toArray().every((u)=>Math.abs(u) < 2 * Math.PI)) {
        let u = new Je().setFromEuler(vD.setFromVector3(o)), c = new Je().setFromEuler(vD.setFromVector3(a));
        return {
            update: (d)=>{
                uD(u, c, r1.quaternion, d);
            },
            start: ()=>{
                r1.rotation.setFromVector3(o);
            },
            end: ()=>{
                r1.rotation.setFromVector3(a);
            }
        };
    } else return {
        update: (u)=>{
            iS.lerpVectors(o, a, u), r1.rotation.setFromVector3(iS);
        },
        start: ()=>{
            r1.rotation.setFromVector3(o);
        },
        end: ()=>{
            r1.rotation.setFromVector3(a);
        }
    };
}
function bD(r1, t, e) {
    let n = [];
    if (!("cloner" in e) || !r1.cloner) return n;
    let i = r1.cloner, s = "cloner" in t ? t.cloner : {}, o = e.cloner;
    Wx.forEach((h)=>{
        let f;
        h === "count" ? f = ls("count", i.parameters, s, o, !0) : f = zs(h, i.parameters, s ?? {}, o), f && n.push(f);
    });
    let a = i6(i, s, o);
    a?.length && n.push(...a);
    let l = s6(i, s, o);
    l?.length && n.push(...l);
    let u = o6(i, s, o);
    u?.length && n.push(...u);
    let c = a6(i, s, o);
    c?.length && n.push(...c);
    let d = l6(i, s, o);
    return d?.length && n.push(...d), n.length && n.push({
        update: ()=>{
            i.update();
        }
    }), n;
}
function i6(r1, t, e) {
    if (r1.parameters.type !== "radial") return;
    let n = t.radial, i = e.radial;
    if (!i) return;
    let s = r1.parameters.radial, o = [];
    return jx.forEach((a)=>{
        let l = zs(a, s, n ?? {}, i);
        l && o.push(l);
    }), o;
}
function s6(r1, t, e) {
    if (r1.parameters.type !== "linear") return;
    let n = t.linear, i = e.linear;
    if (!i) return;
    let s = [], o = r1.parameters.linear;
    return qx.forEach((a)=>{
        let l = zs(a, o, n ?? {}, i);
        l && s.push(l);
    }), s;
}
function o6(r1, t, e) {
    if (r1.parameters.type !== "grid") return;
    let n = t.grid, i = e.grid;
    if (!i) return;
    let s = [], o = r1.parameters.grid;
    return Xx.forEach((a)=>{
        let l;
        a === "count" ? l = nS(a, o, n ?? {}, i, !0) : l = zs(a, o, n ?? {}, i), l && s.push(l);
    }), s;
}
function a6(r1, t, e) {
    if (r1.parameters.type !== "toObject") return;
    let n = t.toObject, i = e.toObject;
    if (!i) return;
    let s = [], o = r1.parameters.toObject;
    return Yx.forEach((a)=>{
        let l;
        a === "count" ? l = ls(a, o, n ?? {}, i, !0) : l = zs(a, o, n ?? {}, i), l && s.push(l);
    }), s;
}
function l6(r1, t, e) {
    if (!r1.parameters.randomness) return;
    let n = t.randomnessObject, i = e.randomnessObject;
    if (!i) return;
    let s = [], o = r1.parameters.randomnessObject;
    return Qx.forEach((a)=>{
        let l = zs(a, o, n ?? {}, i);
        l && s.push(l);
    }), s;
}
function sS(r1, t, e, n, i) {
    let s = [];
    return r1.data.visible && s.push(...xD(r1, t, e, i)), r1.data.visible && s.push(...bD(r1, t, e)), Zr(r1) ? (r1 instanceof tn && r1.data.visible && s.push(...pD(r1, t, e, n)), r1.data.visible && s.push(...yD(r1, t, e, n))) : $P(r1) ? r1.data.visible && s.push(...mD(r1, t, e, n)) : JP(r1) && s.push(...fD(r1, t, e)), s.length ? {
        update: (o)=>{
            s.forEach((a)=>a.update(o));
        },
        start: (o)=>{
            s.forEach((a)=>a.start?.(o));
        },
        end: (o)=>{
            s.forEach((a)=>a.end?.(o));
        }
    } : void 0;
}
var wD = new A;
function By(r1, t, e, n = !1) {
    let i = [];
    t.traverseObject((s)=>{
        if (n && (s.rigidBody?.setTranslation(s.position0, !0), s.rigidBody?.setRotation(s.rotation0, !0), s.rigidBody?.setLinvel(wD, !0), s.rigidBody?.setAngvel(wD, !0)), !St.is(s)) return;
        let o = s.uuid, a = s.data;
        if (delete s.states, !a.states) return;
        let l = !1;
        i.some((u)=>r1.objects.isDescendantOf(o, u)) ? l = !0 : a.physics?.fusedBody === !0 && a.physics.rigidBody === "dynamic" && i.push(o), s.data = a, s.currentState = null, s.reversibleToState = null, s.currentTransitionEvent = null;
        for (let u of a.states)r1.environment.usePhysics === !0 && a.physics && (a.physics.rigidBody === "dynamic" || l) && (u.data.position !== void 0 || u.data.rotation !== void 0 || u.data.hiddenMatrix !== void 0) || (s.states || (s.states = {}), s.states[u.id] = vo.patch(a, u.data));
        u6(t, s, null, e, a.events.find((u)=>u.data.type === "Follow" || u.data.type === "LookAt") !== void 0), c6(t);
    });
}
function c6(r1) {
    r1.traverseEntity((t)=>{
        for (let e of t.data.events){
            let n = [];
            switch(e.data.type){
                case "Follow":
                case "MouseHover":
                case "Scroll":
                case "MouseDown":
                case "MouseUp":
                case "MousePress":
                case "KeyUp":
                case "KeyDown":
                case "KeyPress":
                case "Collision":
                    n.push(...e.data.actions);
                    break;
                case "GameControl":
                    for (let i of Object.values(e.data.gameActions))n.push(...i);
                    break;
                case "DragDrop":
                    n.push(...e.data.dragDropActions.drag, ...e.data.dragDropActions.drop);
                    break;
                case "Conditional":
                    n.push(...e.data.inActions, ...e.data.outActions);
                    break;
            }
            for (let i of n)i.data.type === "Create" && i.data.hideBase === "Yes" && (r1.find(i.data.object).visible = !1);
        }
    });
}
function u6(r1, t, e, n, i = !1) {
    if (t instanceof tn && t.removeInteractionGeometry(), t.changeSelectedState(e, {
        scene: r1,
        shared: n
    }, i), t instanceof tn && t.updateGeometryGroupsIfNeeded(), t instanceof Yt && t.updateCameraState(t.dataPatched, {
        scene: r1,
        shared: n
    }), t.cloner) for (let s of t.cloner.children)s.playModeVisible = void 0;
    t.updateVisible();
}
function oS(r1) {
    let t;
    if (r1.easing === 5) {
        let { control1: e , control2: n  } = r1;
        t = `cubicBezier(
			${e[0]}, ${e[1]}, ${n[0]}, ${n[1]}
		)`;
    } else if (r1.easing === 6) {
        let { mass: e , stiffness: n , damping: i , velocity: s  } = r1;
        t = `spring( ${e}, ${n}, ${i}, ${s} )`;
    } else {
        let e;
        switch(r1.easing){
            case 0:
                e = yo.linear;
                break;
            case 1:
                e = yo.ease;
                break;
            case 2:
                e = yo.easeIn;
                break;
            case 3:
                e = yo.easeOut;
                break;
            case 4:
                e = yo.easeInOut;
                break;
            default:
                e = yo.linear;
        }
        let [n, i, s, o] = e;
        t = `cubicBezier( ${n}, ${i}, ${s}, ${o} )`;
    }
    return {
        duration: r1.duration,
        easing: t
    };
}
function SD(r1) {
    let t = {
        delay: 0,
        loop: r1.repeat === -1 ? !0 : r1.repeat + 1
    };
    if (r1.repeat === 0) t.direction = "normal", t.rewind = !1;
    else switch(r1.direction){
        case "pingpong":
            t.direction = "alternate", t.rewind = !1;
            break;
        case "pingpong-rewind":
            t.direction = "alternate", t.rewind = !0;
            break;
        default:
            t.direction = "normal", t.rewind = !1;
            break;
    }
    switch(t.delay = 0, t.endDelay = 0, t.startOnceDelay = 0, t.pingPongDelayCorrection = 0, t.pingPongEndDelayCorrection = 0, r1.delayDirection){
        case "start-once":
            t.startOnceDelay = r1.delay;
            break;
        case "start":
            t.delay = r1.delay;
            break;
        case "end":
            t.endDelay = r1.delay;
            break;
        case "start-end":
        case void 0:
            t.delay = r1.delay, t.endDelay = r1.delay;
            break;
    }
    return t.direction === "alternate" && (t.delay /= 2, t.endDelay /= 2, r1.delayDirection === "start" ? (t.pingPongDelayCorrection = t.delay, typeof t.loop == "number" && t.loop % 2 === 0 && (t.pingPongEndDelayCorrection = t.delay)) : r1.delayDirection === "end" ? typeof t.loop == "number" && t.loop % 2 !== 0 && (t.pingPongEndDelayCorrection = t.endDelay) : r1.delayDirection === "start-end" && (t.pingPongDelayCorrection = t.delay, t.pingPongEndDelayCorrection = t.endDelay)), t;
}
var d6 = {
    type: "beginState"
}, h6 = {
    type: "completeState",
    isfromEntity: !1
}, Wy = class {
    constructor(t, e, n, i, s, o){
        this.object = t;
        this.data = i;
        this.sharedAssets = s;
        this.allowSlerp = o;
        this.targets = {
            t: 0
        };
        this.firstLoop = !0;
        this._changeBegan = !1;
        this._changeCompleted = !0;
        this.onChange = ()=>{
            this.callback && (this.callback.update(this.targets.t), this.object.dispatchEvent({
                type: "requestRender"
            })), this.targets.t === 0 || this.targets.t === 1 ? this._changeCompleted || (this._changeCompleted = !0, this._changeBegan = !1, this.onChangeComplete()) : (this._changeCompleted && (this._changeCompleted = !1), this._changeBegan || (this._changeBegan = !0, this.onChangeBegin()));
        };
        this.onChangeBegin = ()=>{
            this.object.reversibleToState = this.to.id;
            let t = this.targets.t > .5 ? this.from.id : this.to.id;
            this.object.prevState !== this.object.currentState && (this.object.prevState = this.object.currentState), this.object.currentState = t, this.object.dispatchEvent({
                type: "beginState",
                state: t
            }), this.object.traverseEntity((e)=>{
                e !== this.object && e instanceof Yt && e.dispatchEvent(d6);
            });
        };
        this.onChangeComplete = ()=>{
            this.firstLoop && (this.onFirstLoop(), this.firstLoop = !1), this.object.reversibleToState = this.to.id;
            let t = this.targets.t < .5 ? this.from.id : this.to.id;
            this.object.prevState !== this.object.currentState && (this.object.prevState = this.object.currentState), this.object.currentState = t, this.object.dispatchEvent({
                type: "completeState",
                state: t
            }), this.object.traverseEntity((e)=>{
                e !== this.object && e instanceof Yt && e.dispatchEvent(h6);
            });
        };
        this.onFirstLoop = ()=>{
            this.useCurrentState && (this.callback = sS(this.object, this.from.data, this.to.data, this.sharedAssets, this.allowSlerp));
        };
        if (e === void 0) {
            let a = Hy(this.object, this.object.currentState === n ? this.object.prevState : this.object.currentState);
            if (!a) throw new Error("Missing property");
            this.from = a;
        } else {
            let a = Hy(this.object, e);
            if (!a) throw new Error("Missing property");
            this.from = a;
        }
        if (n === void 0) throw new Error("Missing property");
        {
            let a = Hy(this.object, n);
            if (!a) throw new Error("Missing property");
            this.to = a;
        }
        this.useCurrentState = e === void 0 || n === void 0, this.params = {
            targets: this.targets,
            t: 1,
            autoplay: !1,
            ...SD(i),
            ...oS(i),
            change: this.onChange
        }, this.callback = sS(this.object, e === void 0 ? {} : this.from.data, n === void 0 ? {} : this.to.data, this.sharedAssets, this.allowSlerp);
    }
    get changeBegan() {
        return this._changeBegan;
    }
    get changeCompleted() {
        return this._changeCompleted;
    }
}, Do = class extends Ht {
    constructor(e, n, i){
        super();
        this.data = e;
        this.scene = n;
        this.sharedAssets = i;
        this.toggleIsForward = !1;
        this.timelineNeedsRebuild = !1;
        this.useToggle = !1;
        this.onTimelineChangeComplete = ()=>{
            this.data.tweens[0].data.direction !== "normal" && (this.toggleIsForward = !this.toggleIsForward), this.timelineNeedsRebuild !== !1 && (this.timeline?.pause(), this.buildTimeline({
                isForward: this.toggleIsForward,
                isRebuild: !0
            }), this.timeline.play());
        };
        if (!e.object) throw new Error("Missing property");
        let s = n.find(e.object);
        if (!s) throw new Error("Missing property");
        if (!s.states) throw new Error("Missing property");
        if (this.object = s, e.tweens.length < 2) throw new Error("Missing property");
        this.tweens = Array(this.data.tweens.length - 1), this.startOnceDelay = e.tweens[0].data.delayDirection === "start-once" ? e.tweens[0].data.delay : 0, this.init();
    }
    get playing() {
        return this.tweens.some((e)=>e.changeBegan) ?? !1;
    }
    init() {
        this.initialCurrentState = Hy(this.object, this.object.currentState).id, this.toggleIsForward = !1;
    }
    get currentState() {
        return this.useToggle ? this.initialCurrentState : this.object.currentState;
    }
    buildTimeline({ isForward: e = !0 , isRebuild: n = !1  } = {}) {
        try {
            let i = SD(this.data.tweens[0].data), s = i.loop;
            n && typeof i.loop == "number" && i.loop--, this.timeline?.pause(), this.timeline = Vy.timeline({
                autoplay: !1,
                ...i,
                ...s === !0 || s > 1 ? {
                    timelineChangeComplete: this.onTimelineChangeComplete
                } : {}
            });
            let o = this.tweens.findIndex((a)=>a?.changeBegan);
            if (this.timelineNeedsRebuild = o !== -1 && (s === !0 || s > 1), i.pingPongDelayCorrection && n === !1 && (this.timelineNeedsRebuild = !0), e) {
                let a = o === -1 ? 0 : o;
                for(let l = a; l < this.data.tweens.length - 1; l++){
                    let u = this.data.tweens[l], c = this.data.tweens[l + 1], d;
                    l === a && (this.object.wasMovedByUser === !0 || this.object.previousAction?.playing === !0) ? (d = void 0, this.object instanceof Yt && (this.object.wasMovedByUser = !1)) : d = u.data.state === void 0 ? this.currentState : u.data.state;
                    let h = new Wy(this.object, d, c.data.state === void 0 ? this.currentState : c.data.state, c.data, this.sharedAssets, this.data.allowSlerp ?? !1);
                    o !== -1 && l === a && Object.assign(h.params, {
                        startOnceDelay: 0
                    }), this.tweens[l] = h, this.timeline.add(h.params, this.timeline.duration + (l === a ? i.delay : 0) + (l === a && !n ? i.pingPongDelayCorrection : 0));
                }
                this.timeline.duration += i.endDelay;
            } else {
                let a = o === -1 ? this.data.tweens.length - 1 : o + 1;
                for(let l = a; l > 0; l--){
                    let u = this.data.tweens[l], c = this.data.tweens[l - 1], d;
                    l === a && (this.object.wasMovedByUser === !0 || this.object.previousAction?.playing === !0) ? (d = void 0, this.object instanceof Yt && (this.object.wasMovedByUser = !1)) : d = u.data.state === void 0 ? this.currentState : u.data.state;
                    let h = new Wy(this.object, d, c.data.state === void 0 ? this.currentState : c.data.state, u.data, this.sharedAssets, this.data.allowSlerp ?? !1);
                    o !== -1 && l === a && Object.assign(h.params, {
                        startOnceDelay: 0
                    }), this.tweens[l - 1] = h, this.timeline.add(h.params, this.timeline.duration + (l === a ? i.endDelay : 0));
                }
                this.timeline.duration += i.delay + (n ? 0 : i.pingPongDelayCorrection);
            }
        } catch (i) {
            i instanceof Error && console.error(i.message);
        }
        this.object.previousAction?.playing === !0 && this.object.previousAction.pause(), this.object.previousAction = this;
    }
    play() {
        if (this.playing) return !1;
        clearTimeout(this.timeoutId), this.timeoutId = window.setTimeout(()=>{
            try {
                this.buildTimeline(), this.timeline.play();
            } catch (e) {
                e instanceof Error && console.error(e.message);
            }
        }, this.startOnceDelay);
    }
    pause() {
        this.timeline?.pause(), clearTimeout(this.timeoutId), this.tweens = Array(this.data.tweens.length - 1), delete this.timeoutId;
    }
    stop() {
        this.pause();
        let e = this.data.tweens[0].data.state === void 0 ? this.initialCurrentState : this.data.tweens[0].data.state;
        this.object.changeSelectedState(e, {
            scene: this.scene,
            shared: this.sharedAssets
        }), this.object.currentState = e;
    }
    seek(e) {
        this.timeline === void 0 && this.buildTimeline(), this.timeline?.seek(e * this.timeline.duration);
    }
    toggle(e) {
        this.useToggle = !0, clearTimeout(this.timeoutId), this.toggleIsForward = e ?? !this.toggleIsForward, this.playing ? (this.timeline?.pause(), this.buildTimeline({
            isForward: this.toggleIsForward
        }), this.timeline.play()) : this.timeoutId = window.setTimeout(()=>{
            this.timeline?.pause(), this.buildTimeline({
                isForward: this.toggleIsForward
            }), this.timeline.play();
        }, this.startOnceDelay);
    }
    playFromCurrent() {
        this.toggle(!0);
    }
    reverseFromCurrent() {
        this.toggle(!1);
    }
    dispose() {
        this.pause();
    }
};
function Hy(r1, t) {
    let e, n;
    if (typeof t == "string" ? (e = t, n = r1.states?.[e]) : t === null && (e = null, n = r1.data), !(e === void 0 || n === void 0)) return {
        id: e,
        data: n
    };
}
var f6 = {
    type: "beginState"
}, AD = {
    type: "completeState",
    isfromEntity: !1
}, _D = {
    type: "requestRender"
}, qf = class extends Ht {
    constructor(e, n){
        super();
        this.data = e;
        this.scene = n;
        this.toggleIsForward = !1;
        this.useToggle = !1;
        this.posStart = new A;
        this.posEnd = new A;
        this.qStart = new Je;
        this.qEnd = new Je;
        this.zoomStart = 1;
        this.zoomEnd = 1;
        this.toCamera = n.find(e.targetCamera);
    }
    init() {}
    get playing() {
        return this.animation && this.animation.began && !this.animation.completed;
    }
    buildAnimation(e = !1) {
        if (!this.data.animate) return;
        let n = {
            t: 0
        };
        this.posStart.copy(this.scene.activeCamera.position), this.qStart.copy(this.scene.activeCamera.quaternion), this.zoomStart = this.scene.activeCamera.zoom, this.animation = Vy({
            targets: n,
            t: 1,
            ...oS(this.data),
            update: ()=>{
                n.t === 0 && (this.useToggle && !this.toggleIsForward ? (this.posEnd.copy(this.fromCamera.position), this.qEnd.copy(this.fromCamera.quaternion), this.zoomEnd = this.fromCamera.zoom, this.switchCamera(this.fromCamera)) : (this.posEnd.copy(this.toCamera.position), this.qEnd.copy(this.toCamera.quaternion), this.zoomEnd = this.toCamera.zoom, this.fromCamera = this.scene.activeCamera, this.switchCamera(this.toCamera)), this.scene.activeCamera.dispatchEvent(f6));
                let i = this.scene.activeCamera;
                i.position.lerpVectors(this.posStart, this.posEnd, n.t), i.quaternion.slerpQuaternions(this.qStart, this.qEnd, n.t), i.zoom = this.zoomStart + (this.zoomEnd - this.zoomStart) * n.t, i.wasMovedBySwitchCameraAction = !0, i.updateMatrix(), i.updateMatrixWorld(), i.updateProjectionMatrix(), i.dispatchEvent(_D), n.t === 1 && i.dispatchEvent(AD);
            }
        });
    }
    switchCamera(e) {
        this.scene.activeCamera.dispatchEvent({
            type: "cameraChange",
            camera: e
        }), this.scene.switchActiveCamera(e);
    }
    play() {
        this.playing || this.scene.activeCamera !== this.toCamera && (clearTimeout(this.timeoutId), this.timeoutId = window.setTimeout(()=>{
            delete this.timeoutId;
            try {
                this.data.animate ? (this.buildAnimation(), this.animation?.play()) : this.switchCamera(this.toCamera);
            } catch (e) {
                e instanceof Error && console.error(e.message);
            }
        }, this.data.delay * 1e3));
    }
    pause() {
        this.animation?.pause(), clearTimeout(this.timeoutId), delete this.timeoutId;
    }
    toggle(e) {
        this.useToggle = !0, clearTimeout(this.timeoutId), this.toggleIsForward = e ?? !this.toggleIsForward, this.playing ? (this.animation?.pause(), this.buildAnimation(!0), this.animation?.play()) : this.timeoutId = window.setTimeout(()=>{
            delete this.timeoutId, this.data.animate ? (this.animation?.pause(), this.buildAnimation(), this.animation?.play()) : (this.toggleIsForward ? (this.fromCamera = this.scene.activeCamera, this.switchCamera(this.toCamera)) : this.switchCamera(this.fromCamera), this.scene.activeCamera.dispatchEvent(AD), this.scene.activeCamera.dispatchEvent(_D));
        }, this.data.delay * 1e3);
    }
    playFromCurrent() {
        this.toggle(!0);
    }
    reverseFromCurrent() {
        this.toggle(!1);
    }
    dispose() {
        this.pause(), this.toggleIsForward = !1;
    }
};
function Qn(r1, t, e, n, i, s) {
    let o = {
        Audio: [],
        Video: [],
        Link: [],
        Destroy: [],
        Create: [],
        Reset: [],
        Transition: [],
        SwitchCamera: []
    };
    return t.forEach(({ id: a , data: l  })=>{
        try {
            l.type === "Audio" ? go[r1.type].includes("Audio") && o.Audio.push(new Eo(a, l, s, n)) : l.type === "Video" ? go[r1.type].includes("Video") && o.Video.push(new Bl(a, l, s)) : l.type === "Link" ? go[r1.type].includes("Link") && o.Link.push(new Ly(l, i)) : l.type === "Create" ? go[r1.type].includes("Create") && o.Create.push(new Co(l, e, i.controlsManager)) : l.type === "Destroy" ? go[r1.type].includes("Destroy") && o.Destroy.push(new Wf(l, e, i)) : l.type === "Reset" ? go[r1.type].includes("Reset") && o.Reset.push(new Ny(e.data, e, n, i)) : l.type === "Transition" ? go[r1.type].includes("Transition") && o.Transition.push(new Do(l, e, n)) : l.type === "SwitchCamera" && go[r1.type].includes("SwitchCamera") && o.SwitchCamera.push(new qf(l, e));
        } catch (u) {}
    }), o;
}
function An(r1) {
    Object.values(r1).forEach((t)=>{
        t.forEach((e)=>{
            (e instanceof Eo || e instanceof Bl || e instanceof Do || e instanceof Co || e instanceof Wf || e instanceof qf) && e.dispose();
        });
    });
}
var aS = [
    [
        "start",
        "Start"
    ],
    [
        "keyDown",
        "KeyDown"
    ],
    [
        "keyUp",
        "KeyUp"
    ],
    [
        "mouseDown",
        "MouseDown"
    ],
    [
        "mouseUp",
        "MouseUp"
    ],
    [
        "mouseHover",
        "MouseHover"
    ],
    [
        "collision",
        "Collision"
    ],
    [
        "lookAt",
        "LookAt"
    ],
    [
        "follow",
        "Follow"
    ],
    [
        "scroll",
        "Scroll"
    ]
], MD = (r1)=>aS.find(([t, e])=>e === r1)?.[0], Gs = (r1)=>aS.find(([t])=>t === r1)?.[1], p6 = (r1, t)=>{
    let e = MD(r1);
    if (e) {
        let n = new CustomEvent(e, {
            bubbles: !0
        });
        return Object.defineProperty(n, "target", {
            writable: !1,
            value: t
        }), n;
    }
}, jy = class extends Bn {
    constructor(e){
        super(e);
        this.objectsPerEvents = new Map;
        this.splineEvents = {};
        this.onBeginEvent = (e)=>{
            if (!e.eventName || !e.target || e.eventName === "Scroll") return;
            let n = this.splineEvents[MD(e.eventName)]?.[e.target.uuid];
            if (!n) return;
            e.eventName === "Scroll" && e.deltaY !== void 0 && Object.assign(n, {
                deltaY: e.deltaY
            });
            let { domElement: i  } = this.eventContext;
            i.dispatchEvent(n);
        };
        let { scene: n  } = this.eventContext;
        n.traverseEntity((i)=>{
            if (!!i.data?.events.length) {
                for (let [s, o] of aS)if (i.data.events.some((a)=>a.data.type === o && !a.data.disabled)) {
                    this.objectsPerEvents.has(s) ? this.objectsPerEvents.get(s)?.push(i) : this.objectsPerEvents.set(s, [
                        i
                    ]);
                    let a = {
                        id: i.uuid,
                        name: i.name
                    }, l = p6(o, a), u = this.splineEvents[s];
                    u ? u[i.uuid] = l : this.splineEvents[s] = {
                        [i.uuid]: l
                    };
                }
            }
        });
    }
    connect() {
        this.objectsPerEvents.forEach((e)=>{
            e.forEach((n)=>{
                n.addEventListener("beginEvent", this.onBeginEvent);
            });
        });
    }
    disconnect() {
        this.objectsPerEvents.forEach((e)=>{
            e.forEach((n)=>{
                n.removeEventListener("beginEvent", this.onBeginEvent);
            });
        });
    }
};
var lS = class {
    constructor(t, e, n, i, s, o){
        this.id = t;
        this.data = e;
        this.object = n;
        this.entered = !1;
        if (this.useToggle = e.toggle, (e.type === "KeyDown" || e.type === "KeyUp" || e.type === "KeyPress") && !e.key) throw new Error("Missing property");
        this.actions = Qn(e, e.actions, i, s, o, n);
    }
    disconnect() {
        An(this.actions);
    }
    dispatchHeld(t) {
        this.actions.Create.forEach((e)=>{
            t && e.dispatchThrottled.cancel(), e.dispatchThrottled();
        });
    }
    dispatch(t = !1) {
        let e = new Set;
        this.actions.Transition.forEach((n)=>{
            n.object.currentTransitionEvent !== this ? (n.object.currentTransitionEvent = this, n.init()) : this.useToggle === !1 && e.add(n);
        }), this.useToggle ? (this.actions.Transition.forEach((n)=>{
            n.toggle();
        }), this.actions.SwitchCamera.forEach((n)=>{
            n.toggle();
        })) : this.data.type === "MousePress" || this.data.type === "KeyPress" ? this.entered || (this.entered = !0, this.actions.Transition.forEach((n)=>n.playFromCurrent()), this.actions.SwitchCamera.forEach((n)=>n.playFromCurrent()), this.actions.Create.forEach((n)=>n.dispatchStart())) : (this.actions.Transition.some((s)=>s.playing) || this.actions.Transition.forEach((s)=>{
            e.has(s) === !1 && s.play();
        }), this.actions.SwitchCamera.some((s)=>s.playing) || this.actions.SwitchCamera.forEach((s)=>{
            s.play();
        })), this.actions.Link.forEach((n)=>{
            n.dispatch();
        }), t === !1 && this.actions.Create.forEach((n)=>{
            n.dispatch();
        }), this.actions.Destroy.forEach((n)=>{
            n.dispatch();
        }), this.actions.Reset.forEach((n)=>{
            n.dispatch();
        }), this.actions.Audio.forEach((n)=>{
            n.dispatchBasic();
        }), this.actions.Video.forEach((n)=>{
            n.dispatchBasic();
        });
    }
    dispatchRelease() {
        this.entered && (this.entered = !1, this.actions.Transition.forEach((t)=>t.reverseFromCurrent()), this.actions.SwitchCamera.forEach((t)=>t.reverseFromCurrent()), this.actions.Create.forEach((t)=>t.dispatchStop()));
    }
    dispatchUserEvent(t) {
        this.actions.Transition.forEach((e)=>{
            e.object.currentTransitionEvent !== this && (e.object.currentTransitionEvent = this, e.init());
        }), t ? (this.actions.Transition.forEach((e)=>e.reverseFromCurrent()), this.actions.SwitchCamera.forEach((e)=>e.reverseFromCurrent())) : (this.actions.Transition.forEach((e)=>e.playFromCurrent()), this.actions.SwitchCamera.forEach((e)=>e.playFromCurrent())), this.actions.Link.forEach((e)=>{
            e.dispatch();
        }), this.actions.Create.forEach((e)=>{
            e.dispatch();
        }), this.actions.Destroy.forEach((e)=>{
            e.dispatch();
        }), this.actions.Reset.forEach((e)=>{
            e.dispatch();
        }), this.actions.Audio.forEach((e)=>{
            e.dispatchBasic();
        }), this.actions.Video.forEach((e)=>{
            e.dispatchBasic();
        });
    }
}, qy = class extends Bn {
    constructor(e, n){
        super(e);
        this.objectsPerTypes = {
            MouseDown: [],
            MouseUp: [],
            MousePress: [],
            KeyDown: [],
            KeyUp: [],
            KeyPress: []
        };
        this.canvasMouseEvents = [];
        this.windowMouseEvents = [];
        this.eventsPerObjects = {
            MouseDown: {},
            MouseUp: {},
            MousePress: {},
            KeyDown: {},
            KeyUp: {},
            KeyPress: {}
        };
        this.heldKeys = {};
        this.heldKeysPress = {};
        this._prevObjects = [];
        this.onWindowMouseDown = (e)=>{
            e.target === this.eventContext.domElement && this.canvasMouseEvents.forEach((n)=>{
                (n.data.type === "MouseDown" || n.data.type === "MousePress") && n.dispatch();
            }), this.windowMouseEvents.forEach((n)=>{
                (n.data.type === "MouseDown" || n.data.type === "MousePress") && n.dispatch();
            });
        };
        this.onWindowMouseUp = (e)=>{
            e.target === this.eventContext.domElement && this.canvasMouseEvents.forEach((n)=>{
                n.data.type === "MouseUp" ? n.dispatch() : n.data.type === "MousePress" && n.dispatchRelease();
            }), this.windowMouseEvents.forEach((n)=>{
                n.data.type === "MouseUp" ? n.dispatch() : n.data.type === "MousePress" && n.dispatchRelease();
            });
        };
        this.onMouseDown = (e)=>{
            ke.length > 1 || (this.eventContext.updateRaycaster(e), this.handleMouseEvent("MouseDown"));
        };
        this.onMouseUp = (e)=>{
            ke.length > 1 || (this.eventContext.updateRaycaster(e), this.handleMouseEvent("MouseUp"));
        };
        this.onMousePressDown = (e)=>{
            ke.length > 1 || (this.eventContext.updateRaycaster(e), this.handleMousePressEvent());
        };
        this.onMousePressRelease = (e)=>{
            ke.length > 1 || (this.eventContext.updateRaycaster(e), this.handleMousePressEvent(!0));
        };
        this.onKeyDown = (e)=>{
            this.heldKeys[e.key] || (this.handleKeyEvent(e, "KeyDown"), this.handleKeyEventHeld(e, "KeyDown", !0)), this.heldKeys[e.key] = !0;
        };
        this.onKeyUp = (e)=>{
            this.handleKeyEvent(e, "KeyUp"), this.handleKeyEventHeld(e, "KeyUp", !0);
        };
        this.onKeyPressDown = (e)=>{
            this.heldKeysPress[e.key] ? this.handleKeyEventHeld(e, "KeyPress") : (this.handleKeyEvent(e, "KeyPress"), this.handleKeyEventHeld(e, "KeyPress", !0)), this.heldKeysPress[e.key] = !0;
        };
        this.onKeyPressUp = (e)=>{
            this.handleKeyEvent(e, "KeyPress", !0);
        };
        this.releaseHeldKey = (e)=>{
            delete this.heldKeys[e.key];
        };
        this.releaseHeldKeyPress = (e)=>{
            delete this.heldKeysPress[e.key];
        };
        this._onUserEvent = ({ eventName: e , target: n , reverse: i  })=>{
            if (!e || !n) return;
            let s = Gs(e);
            s && (s === "MouseDown" || s === "MouseUp" || s === "MousePress" ? (n.dispatchEvent({
                type: "beginEvent",
                eventName: s
            }), this.eventsPerObjects[s]?.[n.uuid]?.forEach((o)=>{
                o.dispatchUserEvent(i);
            })) : (s === "KeyDown" || s === "KeyUp" || s === "KeyPress") && (n.dispatchEvent({
                type: "beginEvent",
                eventName: s
            }), this.eventsPerObjects[s]?.[n.uuid]?.forEach((o)=>{
                o.dispatchUserEvent();
            })));
        };
        let { scene: i , sharedAssets: s  } = this.eventContext;
        i.traverseEntity((o)=>{
            if (!o.data?.events.length) return;
            let a = [
                "MouseDown",
                "MouseUp",
                "MousePress",
                "KeyDown",
                "KeyUp",
                "KeyPress"
            ];
            for (let l of a){
                let u = this.eventsPerObjects[l];
                o.data.events.filter(({ data: c  })=>c.type === l && c.disabled !== !0).forEach(({ id: c , data: d  })=>{
                    try {
                        let h = new lS(c, d, o, i, s, n);
                        h.actions.Video.length && (this.hasVideoAction = !0), (d.type === "MouseDown" || d.type === "MouseUp" || d.type === "MousePress") && (d.mode === "Canvas" || d.mode === "Window") ? d.mode === "Canvas" && this.canvasMouseEvents.push(h) : u[o.uuid] ? u[o.uuid].push(h) : u[o.uuid] = [
                            h
                        ];
                    } catch (h) {}
                }), u[o.uuid]?.length && this.objectsPerTypes[l].push(o);
            }
        });
    }
    connect() {
        let { domElement: e  } = this.eventContext;
        this.heldKeys = {}, this.heldKeysPress = {}, this.domEventsNeeded.clear(), typeof window < "u" && (window.addEventListener("pointerdown", this.onWindowMouseDown, {
            capture: !0
        }), window.addEventListener("pointerup", this.onWindowMouseUp, {
            capture: !0
        })), this.objectsPerTypes.MouseDown?.length && (this.domEventsNeeded.add("pointerdown"), e.addEventListener("pointerdown", this.onMouseDown)), this.objectsPerTypes.MouseUp?.length && (this.domEventsNeeded.add("pointerup"), e.addEventListener("pointerup", this.onMouseUp)), this.objectsPerTypes.MousePress?.length && (this.domEventsNeeded.add("pointerdown"), e.addEventListener("pointerdown", this.onMousePressDown), this.domEventsNeeded.add("pointerup"), e.addEventListener("pointerup", this.onMousePressRelease)), this.objectsPerTypes.KeyDown?.length && (this.domEventsNeeded.add("keydown"), document.addEventListener("keydown", this.onKeyDown), document.addEventListener("keyup", this.releaseHeldKey)), this.objectsPerTypes.KeyUp?.length && (this.domEventsNeeded.add("keyup"), document.addEventListener("keyup", this.onKeyUp)), this.objectsPerTypes.KeyPress?.length && (this.domEventsNeeded.add("keydown"), document.addEventListener("keydown", this.onKeyPressDown), document.addEventListener("keyup", this.releaseHeldKeyPress), this.domEventsNeeded.add("keyup"), document.addEventListener("keyup", this.onKeyPressUp)), Object.entries(this.objectsPerTypes).forEach(([n, i])=>{
            i.forEach((s)=>{
                s.addEventListener("userEvent", this._onUserEvent);
            });
        });
    }
    disconnect() {
        let { domElement: e  } = this.eventContext;
        this.domEventsNeeded.clear(), this.heldKeys = {}, this.heldKeysPress = {}, typeof window < "u" && (window.removeEventListener("pointerdown", this.onWindowMouseDown, {
            capture: !0
        }), window.removeEventListener("pointerup", this.onWindowMouseUp, {
            capture: !0
        })), e.removeEventListener("pointerdown", this.onMouseDown), e.removeEventListener("pointerdown", this.onMousePressDown), e.removeEventListener("pointerup", this.onMouseUp), e.removeEventListener("pointerup", this.onMousePressRelease), document.removeEventListener("keydown", this.onKeyDown), document.removeEventListener("keyup", this.onKeyUp), document.removeEventListener("keydown", this.onKeyPressDown), document.removeEventListener("keyup", this.onKeyPressUp), document.removeEventListener("keyup", this.releaseHeldKey), Object.values(this.eventsPerObjects).forEach((n)=>{
            Object.values(n).forEach((i)=>{
                i.forEach((s)=>{
                    s.disconnect();
                });
            });
        }), this.canvasMouseEvents.forEach((n)=>{
            n.disconnect();
        }), Object.entries(this.objectsPerTypes).forEach(([n, i])=>{
            i.forEach((s)=>{
                s.removeEventListener("userEvent", this._onUserEvent);
            });
        });
    }
    handleMouseEvent(e) {
        let { stopRaycast: n , raycaster: i , scene: s  } = this.eventContext, o = this.objectsPerTypes[e];
        if (!!o.length) {
            if (n) {
                let a = zf(i, s, o);
                Gf(a).forEach((l)=>{
                    this.eventsPerObjects[e][l.uuid] && this.handleObjectMouseEventDispatch(l, e);
                });
            } else o.forEach((a)=>{
                Pd(i, a) && this.handleObjectMouseEventDispatch(a, e);
            });
        }
    }
    handleMousePressEvent(e = !1) {
        let n = "MousePress", i = this.objectsPerTypes[n], s = [];
        if (!!i.length) {
            if (!e) {
                let { stopRaycast: o , raycaster: a , scene: l  } = this.eventContext;
                if (o) {
                    let u = zf(a, l, i);
                    s = Gf(u);
                } else i.forEach((u)=>{
                    Pd(a, u) && s.push(u);
                });
            }
            this._prevObjects.length && this._prevObjects.forEach((o)=>{
                s.includes(o) || this.handleObjectMouseEventDispatchRelease(o, n);
            }), s.length && s.forEach((o)=>{
                this.handleObjectMouseEventDispatch(o, n);
            }), this._prevObjects = s;
        }
    }
    handleObjectMouseEventDispatch(e, n) {
        e.dispatchEvent({
            type: "beginEvent",
            eventName: n
        }), this.eventsPerObjects[n]?.[e.uuid]?.forEach((i)=>{
            i.dispatch();
        });
    }
    handleObjectMouseEventDispatchRelease(e, n) {
        e.dispatchEvent({
            type: "beginEvent",
            eventName: n
        }), this.eventsPerObjects[n]?.[e.uuid]?.forEach((i)=>{
            i.dispatchRelease();
        });
    }
    handleKeyEvent(e, n, i = !1) {
        this.objectsPerTypes[n].forEach((s)=>{
            let o = this.eventsPerObjects[n][s.uuid];
            o.some(({ data: a  })=>"key" in a && a.key === e.key) && s.dispatchEvent({
                type: "beginEvent",
                eventName: n
            }), o.forEach((a)=>{
                "key" in a.data && a.data.key === e.key && (i ? a.dispatchRelease() : a.dispatch(!0));
            });
        });
    }
    handleKeyEventHeld(e, n, i = !1) {
        this.objectsPerTypes[n].forEach((s)=>{
            this.eventsPerObjects[n][s.uuid].forEach((a)=>{
                "key" in a.data && a.data.key === e.key && a.dispatchHeld(i);
            });
        });
    }
};
var m6 = new A, g6 = new A;
var Xy = class {
    constructor(t, e, n, i, s){
        this.actionsIn = Qn(t, t.inActions, n, i, s, e), this.actionsOut = Qn(t, t.outActions, n, i, s, e);
    }
    disconnect() {
        An(this.actionsIn), An(this.actionsOut);
    }
};
var cS = class extends Xy {
    constructor(e, n, i, s, o, a){
        super(n, i, s, o, a);
        this.id = e;
        this.data = n;
        this.object = i;
        this.stage = "out";
        this.objects = [];
        this.onUpdateMatrix = ()=>{
            let e = m6.setFromMatrixPosition(this.objects[0].matrixWorld), n = g6.setFromMatrixPosition(this.objects[1].matrixWorld), i = e.distanceTo(n) <= this.distance ? "in" : "out";
            if (this.stage !== i) {
                let s = i === "in" ? this.actionsIn : this.actionsOut;
                s.Audio.forEach((o)=>o.dispatchConditional()), s.Video.forEach((o)=>o.dispatchConditional()), s.Create.forEach((o)=>o.dispatch()), s.Destroy.forEach((o)=>o.dispatch()), s.Transition.forEach((o)=>{
                    o.object.currentTransitionEvent !== this && (o.object.currentTransitionEvent = this), o.init();
                }), s.Transition.forEach((o)=>o.play()), s.SwitchCamera.forEach((o)=>o.play()), this.stage = i;
            }
        };
        let { distance: l , fromObject: u , toObject: c  } = n.condition;
        this.distance = l;
        for (let d of [
            u,
            c
        ]){
            if (!d) throw new Error("Missing property");
            let h = s.find(d);
            if (!h) throw new Error("Missing property");
            this.objects.push(h);
        }
    }
    connect() {
        this.objects.forEach((e)=>{
            e.addEventListener("updateMatrix", this.onUpdateMatrix);
        }), this.onUpdateMatrix();
    }
    disconnect() {
        super.disconnect(), this.stage = "out", this.objects.forEach((e)=>{
            e.removeEventListener("updateMatrix", this.onUpdateMatrix);
        });
    }
}, uS = class extends Xy {
    constructor(e, n, i, s, o, a){
        super(n, i, s, o, a);
        this.id = e;
        this.data = n;
        this.object = i;
        this.onBegin = ({ target: e , state: n  })=>{
            this.toState !== n && (this.actionsOut.Audio.forEach((i)=>i.dispatchConditional()), this.actionsOut.Video.forEach((i)=>i.dispatchConditional()), this.actionsOut.Create.forEach((i)=>i.dispatch()), this.actionsOut.Destroy.forEach((i)=>i.dispatch()), this.actionsIn.Transition.forEach((i)=>i.pause()), this.object.currentTransitionEvent = this, this.actionsOut.Transition.forEach((i)=>i.play()), this.actionsIn.SwitchCamera.forEach((i)=>i.pause()), this.actionsOut.SwitchCamera.forEach((i)=>i.play()));
        };
        this.onComplete = ({ target: e , state: n  })=>{
            this.toState === n && (this.actionsIn.Audio.forEach((i)=>i.dispatchConditional()), this.actionsIn.Video.forEach((i)=>i.dispatchConditional()), this.actionsIn.Create.forEach((i)=>i.dispatch()), this.actionsIn.Destroy.forEach((i)=>i.dispatch()), this.actionsOut.Transition.forEach((i)=>i.pause()), this.object.currentTransitionEvent = this, this.actionsIn.Transition.forEach((i)=>i.play()), this.actionsOut.SwitchCamera.forEach((i)=>i.pause()), this.actionsIn.SwitchCamera.forEach((i)=>i.play()));
        };
        let { condition: l  } = n;
        if (!l.object) throw new Error("Missing property");
        let u = s.find(l.object);
        if (!u) throw new Error("Missing property");
        if (this.toObject = u, l.state && !this.toObject.states?.[l.state]) throw new Error("Missing property");
        this.toState = l.state;
    }
    connect() {
        (this.actionsOut.Audio.length || this.actionsOut.Video.length || this.actionsOut.Create.length || this.actionsOut.Destroy.length || this.actionsOut.Transition.length || this.actionsOut.SwitchCamera.length) && this.toObject.addEventListener("beginState", this.onBegin), (this.actionsIn.Audio.length || this.actionsIn.Video.length || this.actionsOut.Create.length || this.actionsIn.Destroy.length || this.actionsIn.Transition.length || this.actionsIn.SwitchCamera.length) && this.toObject.addEventListener("completeState", this.onComplete);
    }
    disconnect() {
        super.disconnect(), (this.actionsOut.Audio.length || this.actionsOut.Video.length || this.actionsOut.Create.length || this.actionsOut.Destroy.length || this.actionsOut.Transition.length || this.actionsOut.SwitchCamera.length) && this.toObject.removeEventListener("beginState", this.onBegin), (this.actionsIn.Audio.length || this.actionsIn.Video.length || this.actionsOut.Create.length || this.actionsIn.Destroy.length || this.actionsIn.Transition.length || this.actionsIn.SwitchCamera.length) && this.toObject.removeEventListener("completeState", this.onComplete);
    }
}, Yy = class extends Bn {
    constructor(e, n){
        super(e);
        this.eventsPerConditions = {
            Comparison: [],
            Distance: [],
            State: []
        };
        this.hasVideoAction = !1;
        let { scene: i , sharedAssets: s  } = this.eventContext;
        i.traverseEntity((o)=>{
            if (!!o.data?.events.length) {
                for (let { id: a , data: l  } of o.data.events)if (!l.disabled && l.type === "Conditional") try {
                    let u;
                    l.condition.type === "Comparison" || (l.condition.type === "Distance" ? u = new cS(a, l, o, i, s, n) : l.condition.type === "State" && (u = new uS(a, l, o, i, s, n))), u && (this.eventsPerConditions[l.condition.type].push(u), (u.actionsIn.Video.length || u.actionsOut.Video.length) && (this.hasVideoAction = !0));
                } catch (u) {}
            }
        });
    }
    connect() {
        super.connect(), Object.values(this.eventsPerConditions).forEach((e)=>e.forEach((n)=>n.connect()));
    }
    disconnect() {
        super.disconnect(), Object.values(this.eventsPerConditions).forEach((e)=>e.forEach((n)=>n.disconnect()));
    }
};
var Xf = new A, _a = new A, Fl = new A, TD = new yn, y6 = .01, Ot = new A, Kn = new A, ED = new A, Ul = new Je, dS = new Wt, v6 = new ae, hS = new Kt, Od = new A, Vs = new A, Rd = .2;
function fS(r1, t) {
    !t || (t[0] < t[1] && (r1.x = Math.min(Math.max(r1.x, t[0]), t[1])), t[2] < t[3] && (r1.y = Math.min(Math.max(r1.y, t[2]), t[3])), t[4] < t[5] && (r1.z = Math.min(Math.max(r1.z, t[4]), t[5])));
}
var x6 = function() {
    let r1 = new ae;
    return (t, e, n)=>{
        let i = t.obj;
        r1.copy(i.hiddenMatrix), i.parent !== null && r1.premultiply(i.parent.matrixWorld), r1.invert(), i.position.copy(e), t.reference === "global" && fS(i.position, t.limits), i.position.applyMatrix4(r1), t.reference === "parent" ? fS(i.position, t.limits) : t.reference === "local" && (Ul.copy(t.quat0).invert(), i.position.sub(t.position0), i.position.applyQuaternion(Ul), fS(i.position, t.limits), Ul.invert(), i.position.applyQuaternion(Ul), i.position.add(t.position0)), r1.multiply(n ?? i.matrixWorld).decompose(Ot, i.quaternion, Kn), i.updateMatrix(), i.hasNonUniformScale && (i.updateMatrixWorld(), i.updateMatrixWorldSVD()), i instanceof kt && Gr(i.parent) && i.invalidateDownstreamBooleanData(!0);
    };
}(), pS = class {
    constructor(t, e, n, i, s, o){
        this.object = t;
        this.data = e;
        this.dropDestIds = [];
        this.activeIdx = null;
        this.wasDragEventTriggered = !1;
        this.resetDampingFactor = this.data.resetSpeed === 0 ? 1 : 8 / this.data.resetSpeed + 1, this.snapDampingFactor = this.data.snapSpeed === 0 ? 1 : 8 / this.data.snapSpeed + 1, this.actionsDrag = Qn(e, e.dragDropActions.drag, n, i, s, this.object), this.actionsDrop = Qn(e, e.dragDropActions.drop, n, i, s, this.object);
        let a = [];
        this.data.objects.forEach((l)=>{
            let u = n.find(l);
            !u || u.dataPatched.visible !== !1 && (a.push(u), o[u.uuid] && o[u.uuid].forEach((c)=>{
                let d = n.find(c);
                !d || d.dataPatched.visible !== !1 && a.push(d);
            }));
        }), this.data.dropDestinations.forEach((l)=>{
            let u = n.find(l);
            !u || u.dataPatched.visible !== !1 && (this.dropDestIds.push(u.uuid), o[u.uuid] && o[u.uuid].forEach((c)=>{
                let d = n.find(c);
                !d || d.dataPatched.visible !== !1 && this.dropDestIds.push(d.uuid);
            }));
        }), this.dragItems = a.map((l)=>(this.data.planeMode === "locked" && (l.userData.lockedPlane = !0), l.userData.worldPosition0 = new A().setFromMatrixPosition(l.matrixWorld), {
                obj: l,
                fromPosition: new A().setFromMatrixPosition(l.matrixWorld),
                pointStart: new A,
                pointEnd: new A,
                paused: !0,
                currentDampingFactor: this.data.dampingFactor,
                reset: !1,
                position0: new A().copy(l.position),
                quat0: new Je().copy(l.quaternion),
                snapped: !1,
                orientationMatrix: new ae,
                limits: this.data.limits,
                reference: this.data.referenceFrame
            }));
    }
    get activeDragItem() {
        return this.activeIdx !== null ? this.dragItems[this.activeIdx] : null;
    }
    dispose() {
        An(this.actionsDrag), An(this.actionsDrop), this.dragItems.forEach((t)=>{
            t.fromPosition.copy(t.obj.userData.worldPosition0), t.pointStart.copy(t.fromPosition), t.pointEnd.copy(t.pointStart), t.obj.recursiveBBoxNeedsUpdate = !0, t.obj.userData.lockedPlane = void 0, t.obj.position.copy(t.position0), t.obj.quaternion.copy(t.quat0), t.obj.updateMatrix();
        });
    }
}, Qy = class extends Bn {
    constructor(e, n){
        super(e);
        this.managers = n;
        this.events = [];
        this.lastDropDestination = null;
        this.dragTimeout = null;
        this.onPointerDown = (e)=>{
            if (ke.length > 1) return;
            this.eventContext.updateRaycaster(e);
            let { raycaster: n , scene: i  } = this.eventContext, s = i.raycastWithClones(n);
            if (this.lastDropDestination = null, s.length === 0) {
                this.activeEvent = null;
                return;
            }
            for (let o of this.events){
                let a = 0;
                for (let { obj: l , pointEnd: u , pointStart: c  } of o.dragItems){
                    if (l === s[0].object || l === s[0].object.object || St.is(l) && l.isAncestorOf(s[0].object.uuid)) {
                        if (o.activeIdx = a, o.activeDragItem.reset = !1, o.activeDragItem.currentDampingFactor = o.data.dampingFactor, o.activeDragItem.snapped = !1, o.data.cursor === "hand" && this.setCursor("grabbing"), this.managers.controlsManager.usePhysics) {
                            o.activeDragItem.obj.rigidBody && o.activeDragItem.obj.rigidBody.setBodyType(2, !0);
                            let d = o.activeDragItem.obj;
                            l.hasNonUniformScale && l.updateMatrixWorldSVD(), (d.hasNonUniformScale ? d.matrixWorldRigid : d.matrixWorld).decompose(Ot, Ul, Kn), dS.setFromQuaternion(Ul), d.prevR === void 0 ? (d.prevR = dS.clone(), d.prevT = Ot.clone()) : (d.prevR.copy(dS), d.prevT.copy(Ot)), this.managers.controlsManager.sharedGameControlGlobals.entitiesWithTransformAnim.push(o.activeDragItem.obj);
                        }
                        this.calcPlaneIntersectPos(l, c, o.data.plane, o.data.referenceFrame), u.copy(c), (this.managers.controlsManager.usePhysics && l.dataPatched.physics?.rigidBody === "dynamic" || o.data.drop === !1 || o.data.resetOnSnapFail === !1) && o.activeDragItem.fromPosition.setFromMatrixPosition(o.activeDragItem.obj.matrixWorld), this.activeEvent = o, this.managers.controlsManager.orbitControls && (this.managers.controlsManager.orbitControls.enabled = !1);
                        return;
                    }
                    a++;
                }
            }
            this.activeEvent = null;
        };
        this.onPointerMove = (e)=>{
            if (ke.length > 1) return;
            this.eventContext.updateRaycaster(e);
            let { raycaster: n , scene: i  } = this.eventContext, s = i.raycastWithClones(n);
            if (ke.length === 0) {
                let o = !1;
                for (let a of this.events){
                    for (let { obj: l  } of a.dragItems)if (l === s[0]?.object || l === s[0]?.object?.object || St.is(l) && l.isAncestorOf(s[0]?.object.uuid)) {
                        switch(o = !0, a.data.cursor){
                            case "hand":
                                this.setCursor("grab");
                                break;
                            case "move":
                                this.setCursor("move");
                                break;
                            default:
                                break;
                        }
                        break;
                    }
                    if (o) break;
                }
                o || this.setCursor("default");
                return;
            }
            if (this.activeEvent && this.activeEvent.activeDragItem) {
                let o = this.activeEvent.activeDragItem;
                o.snapped = !1;
                let a;
                if (this.activeEvent.data.drop && (a = s.filter((l)=>o.obj !== l.object && !o.obj.isAncestorOf(l.object.uuid) && !(l.object instanceof Mo) && (this.activeEvent.data.dropOn === "all" || this.activeEvent.dropDestIds.some((u)=>u === l.object.uuid || i.find(u).isAncestorOf(l.object.uuid))))[0]), a) {
                    let l = ED.copy(a.face.normal).applyMatrix3(hS.getNormalMatrix(a.object.matrixWorld));
                    if (this.activeEvent.data.snapTo === "center") o.fromPosition.setFromMatrixPosition(a.object.matrixWorld);
                    else if (this.activeEvent.data.snapTo === "surface") {
                        if (o.fromPosition.copy(a.point), this.activeEvent.data.snapSurfaceMode === "bbox") {
                            Ot.copy(l).applyMatrix3(hS.setFromMatrix4(o.obj.matrixWorld).transpose());
                            let u = o.obj;
                            Ot.x > Rd ? Kn.x = -u.recursiveBBox.min.x : Ot.x < -Rd && (Kn.x = -u.recursiveBBox.max.x), Ot.y > Rd ? Kn.y = -u.recursiveBBox.min.y : Ot.y < -Rd && (Kn.y = -u.recursiveBBox.max.y), Ot.z > Rd ? Kn.z = -u.recursiveBBox.min.z : Ot.z < -Rd && (Kn.z = -u.recursiveBBox.max.z), Kn.applyMatrix3(hS.invert());
                        } else Kn.copy(l).multiplyScalar(this.activeEvent.data.snapSurfaceOffset);
                        o.fromPosition.add(Kn);
                    }
                    this.activeEvent.data.autoOrient && (Ot.set(0, 1, 0).cross(l), Ot.length() < 1e-4 && Ot.set(-1, 0, 0).cross(l), Kn.crossVectors(ED, Ot), o.orientationMatrix.makeBasis(Ot, Kn, l)), o.pointStart.copy(o.fromPosition), o.pointEnd.copy(o.pointStart), o.currentDampingFactor = this.activeEvent.snapDampingFactor, o.snapped = !0, this.lastDropDestination !== a.object && (this.lastDropDestination = a.object, this.activeEvent.actionsDrop.Transition.forEach((u)=>{
                        u.play();
                    }), this.activeEvent.actionsDrop.Audio.forEach((u)=>{
                        u.dispatchGameControl("start");
                    }), this.activeEvent.actionsDrop.Create.forEach((u)=>{
                        u.dispatchThrottled();
                    }));
                } else o.orientationMatrix.makeRotationFromQuaternion(o.quat0), this.lastDropDestination = null, o.currentDampingFactor = this.activeEvent.data.dampingFactor, this.calcPlaneIntersectPos(o.obj, o.pointEnd, this.activeEvent.data.plane, this.activeEvent.data.referenceFrame), this.activeEvent.actionsDrop.Transition.forEach((l)=>{
                    l.stop(), l.object.currentState !== null && l.object.changeSelectedState(null, {
                        scene: this.eventContext.scene,
                        shared: this.eventContext.sharedAssets
                    });
                }), this.activeEvent.actionsDrop.Audio.forEach((l)=>{
                    l.dispatchGameControl("stop");
                });
                this.activeEvent.actionsDrag.Create.forEach((l)=>{
                    l.dispatchThrottled();
                }), this.activeEvent.wasDragEventTriggered === !1 && (this.activeEvent.wasDragEventTriggered = !0, this.activeEvent.actionsDrag.Transition.forEach((l)=>{
                    l.play();
                }), this.activeEvent.actionsDrag.Audio.forEach((l)=>{
                    l.dispatchGameControl("start");
                })), this.dragTimeout && window.clearTimeout(this.dragTimeout), this.dragTimeout = window.setTimeout(()=>{
                    !this.activeEvent || (this.activeEvent.wasDragEventTriggered = !1, this.activeEvent.actionsDrag.Audio.forEach((l)=>{
                        l.dispatchGameControl("stop");
                    }), this.activeEvent.actionsDrag.Transition.forEach((l)=>{
                        l.stop(), l.object.currentState !== null && l.object.changeSelectedState(null, {
                            scene: this.eventContext.scene,
                            shared: this.eventContext.sharedAssets
                        });
                    }));
                }, 500), this.updateDragItem(o), o.obj.dispatchEvent({
                    type: "requestRender"
                });
            }
        };
        this.onPointerUp = (e)=>{
            if (this.activeEvent && this.activeEvent.activeDragItem) {
                this.activeEvent.data.cursor === "hand" && this.setCursor("grab");
                let n = this.activeEvent.activeDragItem.obj.dataPatched.physics?.rigidBody === "dynamic";
                this.activeEvent.activeDragItem.snapped === !1 && this.activeEvent.data.drop && this.activeEvent.data.resetOnSnapFail && (this.managers.controlsManager.usePhysics === !1 || !n) && (this.activeEvent.activeDragItem.reset = this.activeEvent.data.resetOnSnapFail, this.activeEvent.activeDragItem.paused = !1, this.activeEvent.activeDragItem.currentDampingFactor = this.activeEvent.resetDampingFactor), this.managers.controlsManager.usePhysics && n && (this.managers.controlsManager.sharedGameControlGlobals.entitiesWithTransformAnim.pop(), this.activeEvent.activeDragItem.obj.rigidBody.setBodyType(0, !0), this.activeEvent.activeDragItem.paused = !0), this.activeEvent.wasDragEventTriggered === !0 && (this.activeEvent.wasDragEventTriggered = !1, this.activeEvent.actionsDrag.Transition.forEach((i)=>{
                    i.stop(), i.object.currentState !== null && i.object.changeSelectedState(null, {
                        scene: this.eventContext.scene,
                        shared: this.eventContext.sharedAssets
                    });
                }), this.activeEvent.actionsDrag.Audio.forEach((i)=>{
                    i.dispatchGameControl("stop");
                })), this.managers.controlsManager.orbitControls && (this.managers.controlsManager.orbitControls.enabled = !0);
            }
        };
        let i = {};
        e.scene.traverseEntity((s)=>{
            s.component && (i[s.component.uuid] ? i[s.component.uuid].push(s.uuid) : i[s.component.uuid] = [
                s.uuid
            ]);
        }), e.scene.traverseEntity((s)=>{
            s.data?.events.filter((o)=>o.data.type === "DragDrop" && !o.data.disabled).forEach((o)=>{
                this.events.push(new pS(s, o.data, e.scene, e.sharedAssets, n, i));
            });
        });
    }
    connect() {
        if (!this.events.length) return;
        this.domEventsNeeded.clear(), this.domEventsNeeded.add("pointerdown");
        let e = this.eventContext.domElement;
        e.addEventListener("pointerdown", this.onPointerDown), e.addEventListener("pointermove", this.onPointerMove), e.addEventListener("pointerup", this.onPointerUp), this.domEventsNeeded.add("pointermove");
    }
    disconnect() {
        if (!this.events.length) return;
        this.domEventsNeeded.clear();
        let e = this.eventContext.domElement;
        e.removeEventListener("pointerdown", this.onPointerDown), e.removeEventListener("pointermove", this.onPointerMove), e.removeEventListener("pointerup", this.onPointerUp), this.events.forEach((n)=>n.dispose());
    }
    setCursor(e) {
        this.eventContext.domElement.style.cursor = e;
    }
    onAnimationFrameDamping() {
        for (let e of this.events)for (let n of e.dragItems)n.paused || this.updateDragItem(n, !0);
    }
    calcPlaneIntersectPos(e, n, i, s) {
        let { camera: o , raycaster: a  } = this.eventContext;
        o.getWorldDirection(_a), _a.negate();
        let l = Ul.identity();
        switch(s === "parent" ? v6.multiplyMatrices(e.parent.matrixWorld, e.hiddenMatrix).decompose(Ot, l, Kn) : s === "local" && e.matrixWorld.decompose(Ot, l, Kn), i){
            case "x":
                Ot.set(1, 0, 0).applyQuaternion(l), Od.copy(_a).cross(Ot), Vs.copy(Ot).cross(Od);
                break;
            case "y":
                Ot.set(0, 1, 0).applyQuaternion(l), Od.copy(_a).cross(Ot), Vs.copy(Ot).cross(Od);
                break;
            case "z":
                Ot.set(0, 0, 1).applyQuaternion(l), Od.copy(_a).cross(Ot), Vs.copy(Ot).cross(Od);
                break;
            case "xy":
                Vs.set(0, 0, 1).applyQuaternion(l);
                break;
            case "yz":
                Vs.set(1, 0, 0).applyQuaternion(l);
                break;
            case "xz":
                Vs.set(0, 1, 0).applyQuaternion(l);
                break;
            case "adaptive":
                _a.angleTo(Kn.set(0, 1, 0)) > Math.PI / 6 ? (Ot.crossVectors(Kn.set(0, 1, 0), _a), Vs.crossVectors(Ot, Kn)) : Vs.set(0, 1, 0);
                break;
            default:
                Vs.copy(_a);
                break;
        }
        Fl.setFromMatrixPosition(e.matrixWorld);
        let u = e.userData.lockedPlane ? e.userData.worldPosition0 : Fl;
        if (TD.setFromNormalAndCoplanarPoint(Vs, u), !!a.ray.intersectPlane(TD, n) && (i === "x" || i === "y" || i === "z")) {
            let c = Kn.subVectors(n, u).dot(Ot);
            n.copy(u).addScaledVector(Ot, c);
        }
    }
    updateDragItem(e, n = !1) {
        Fl.setFromMatrixPosition(e.obj.matrixWorld), e.reset === "current" ? Xf.subVectors(e.fromPosition, Fl).divideScalar(e.currentDampingFactor) : e.reset === "original" ? (Xf.subVectors(e.obj.userData.worldPosition0, Fl).divideScalar(e.currentDampingFactor), e.fromPosition.copy(e.obj.userData.worldPosition0), e.pointStart.copy(e.fromPosition), e.pointEnd.copy(e.pointStart)) : Xf.subVectors(e.pointEnd, e.pointStart).add(e.fromPosition).sub(Fl).divideScalar(e.currentDampingFactor), e.paused = e.currentDampingFactor > 1 ? Xf.length() < y6 : !0, (this.activeEvent && this.activeEvent.data.dampingFactor === 1 || n) && x6(e, Xf.add(Fl), this.activeEvent?.data.drop && this.activeEvent?.data.autoOrient ? e.orientationMatrix : null), e.obj.dispatchEvent({
            type: "beginEvent",
            eventName: "DragDrop"
        }), this.managers.eventManager.requestRender();
    }
};
var Ld = new A, mS = new A, Io = new A, Oo = new A, CD = new yn, b6 = .01, w6 = {
    type: "requestRender"
}, S6 = function() {
    let r1 = new A, t = new A;
    return (e, n, i)=>i > 0 ? (r1.subVectors(e, n), r1.length() <= i ? e : t.copy(n).add(r1.normalize().multiplyScalar(i))) : n;
}(), PD = function() {
    let r1 = new ae;
    return (t, e)=>{
        t.position.copy(e), t.parent !== null && (r1.copy(t.parent.matrixWorld).invert(), t.position.applyMatrix4(r1)), r1.copy(t.hiddenMatrix).invert(), t.position.applyMatrix4(r1), t.updateMatrix(), t.hasNonUniformScale && (t.updateMatrixWorld(), t.updateMatrixWorldSVD()), t instanceof kt && Gr(t.parent) && t.invalidateDownstreamBooleanData(!0);
    };
}(), gS = class {
    constructor(t, e, n, i, s){
        this.data = t;
        this.object = e;
        this.paused = !1;
        this.currentDampingFactor = 1;
        this.snapComplete = !1;
        this.isReset = !1;
        this.worldPosition0 = new A;
        this.timeoutId = null;
        this.delayFinished = !0;
        this.wasOutside = !1;
        this.data = {
            ...ig.defaultData,
            ...t,
            ...t.resetOnPointerLeave === void 0 && {
                resetOnPointerLeave: !1
            }
        }, t.target === void 0 || t.target === "cursor" || (t.target === "personal camera" ? this.target = n.find(bn.PERSONAL_CAMERA_ID) : this.target = n.find(t.target)), this.data.dampingFactor && (this.currentDampingFactor = this.data.dampingFactor), this.resetDampingFactor = 80 / this.data.resetSpeed + 1, this.object.getWorldPosition(this.worldPosition0), this.actions = Qn(t, t.actions, n, i, s, e);
    }
}, Ky = class extends Bn {
    constructor(e, n){
        super(e);
        this.events = [];
        this.pairOfEventListeners = [];
        this.onMouseMove = (e)=>{
            if (!(ke.length > 1)) {
                this.eventContext.updateRaycaster(e);
                for (let n of this.events)n.target === void 0 && this.updateSingleEvent(n);
            }
        };
        this.onMouseEnter = (e)=>{
            for (let n of this.events)n.target === void 0 && (n.isReset = !1, n.currentDampingFactor = n.data.dampingFactor);
        };
        this.onMouseLeave = (e)=>{
            for (let n of this.events)n.target === void 0 && (n.data.resetOnPointerLeave && (n.isReset = !0, n.currentDampingFactor = n.resetDampingFactor), this.updateSingleEvent(n));
        };
        this.onTargetChange = (e)=>()=>{
                this.updateSingleEvent(e);
            };
        let { scene: i  } = this.eventContext;
        i.traverseEntity((s)=>{
            let o = s.data?.events.find((a)=>a.data.type === "Follow" && !a.data.disabled);
            o && (!i.data.environment.usePhysics || s.dataPatched.physics?.rigidBody !== "dynamic") && this.events.push(new gS(o.data, s, i, e.sharedAssets, n));
        });
    }
    connect() {
        if (!this.events.length) return;
        let { domElement: e , eventElement: n  } = this.eventContext;
        this.domEventsNeeded.clear(), jn && (this.domEventsNeeded.add("pointerdown"), e.addEventListener("pointerdown", this.onMouseMove)), this.domEventsNeeded.add("pointermove"), n.addEventListener("pointermove", this.onMouseMove), this.eventContext.useWindowEvents || (e.addEventListener("pointerenter", this.onMouseEnter), e.addEventListener("pointerleave", this.onMouseLeave));
        for (let i of this.events)if (i.target !== void 0) {
            let s = i.target, o = this.onTargetChange(i);
            this.pairOfEventListeners.push([
                s,
                o
            ]), s.addEventListener("requestRender", o);
        }
    }
    disconnect() {
        if (!this.events.length) return;
        let { domElement: e , eventElement: n  } = this.eventContext;
        this.domEventsNeeded.clear(), jn && e.removeEventListener("pointerdown", this.onMouseMove), n.removeEventListener("pointermove", this.onMouseMove), e.removeEventListener("pointerenter", this.onMouseEnter), e.removeEventListener("pointerleave", this.onMouseLeave);
        for (let [i, s] of this.pairOfEventListeners)i.removeEventListener("requestRender", s);
        for (let i of this.events)i.paused = !0, i.isReset = !1, An(i.actions);
    }
    onAnimationFrameDamping() {
        for (let e of this.events)e.paused || this.updateSingleEvent(e, !0);
    }
    updateSingleEvent(e, n = !1) {
        this.events.forEach((l)=>{
            l.actions.Create.forEach((u)=>{
                u.dispatchThrottled();
            });
        });
        let { plane: i , limitDistance: s , limitDistanceEnabled: o  } = e.data;
        if (e.object.getWorldPosition(Io), e.isReset) Oo.copy(e.worldPosition0);
        else if (e.target) e.target.getWorldPosition(Oo);
        else {
            let { camera: l , raycaster: u  } = this.eventContext;
            if (i === "custom" ? (l.getWorldDirection(mS), mS.negate(), Ld.copy(mS)) : i === "xy" ? Ld.set(0, 0, 1) : i === "xz" ? Ld.set(0, 1, 0) : i === "yz" && Ld.set(1, 0, 0), CD.setFromNormalAndCoplanarPoint(Ld, Io), !u.ray.intersectPlane(CD, Oo)) return;
        }
        if (!e.isReset) {
            if (Oo.distanceTo(e.worldPosition0) > s && o && e.target) {
                if (e.snapComplete = !1, e.data.snapDelay && (e.delayFinished = !1, typeof window < "u" && e.timeoutId !== null && (window.clearTimeout(e.timeoutId), e.timeoutId = null)), e.wasOutside = !0, e.data.resetAfterDistanceLimit) Oo.copy(e.worldPosition0), e.currentDampingFactor = e.resetDampingFactor;
                else return;
            } else if (e.wasOutside && (e.data.snapDelay && typeof window < "u" && (e.timeoutId = window.setTimeout(()=>{
                e.delayFinished = !0, e.paused = !1, this.updateSingleEvent(e);
            }, e.data.snapDelay * 1e3)), e.currentDampingFactor = e.data.dampingFactor, e.wasOutside = !1), e.delayFinished === !1) return;
        }
        e.data.enabledTranslation[0] === !1 && (Oo.x = Io.x), e.data.enabledTranslation[1] === !1 && (Oo.y = Io.y), e.data.enabledTranslation[2] === !1 && (Oo.z = Io.z);
        let a = S6(Io, Oo, e.wasOutside ? 0 : e.data.maxDelta);
        if (e.currentDampingFactor > 1) {
            let l = Ld.subVectors(a, Io).divideScalar(e.currentDampingFactor);
            Io.add(l), n && PD(e.object, Io), e.paused = l.length() < b6;
        } else PD(e.object, a), e.paused = !0;
        e.object?.dispatchEvent({
            type: "beginEvent",
            eventName: "Follow"
        }), e.object.dispatchEvent(w6);
    }
};
var Yf = new A, Zy = new A, Qf = new ae, Nd = new Je, Ma = new Je, Kf = new A, Zf = new A, kl = new A, Ro = new A, yS = new yn, A6 = 1e-6, _6 = {
    type: "requestRender"
}, M6 = {
    type: "changeRotation"
}, ID = function() {
    let r1 = new ae;
    return function(e, n) {
        e.parent !== null ? r1.multiplyMatrices(e.parent.matrixWorld, e.hiddenMatrix) : r1.copy(e.hiddenMatrix), n.premultiply(Gw(r1).invert()), e.rotation.setFromRotationMatrix(n), e.updateMatrix(), e instanceof kt && Gr(e.parent) && e.invalidateDownstreamBooleanData(!0);
    };
}(), vS = class {
    constructor(t, e, n){
        this.object = e;
        this.paused = !1;
        this.currentDampingFactor = 1;
        this.isReset = !1;
        this.worldQuaternion0 = new Je;
        this.timeoutId = null;
        this.delayFinished = !0;
        this.wasOutside = !1;
        this.data = {
            ...sg.defaultData,
            ...t,
            ...t.resetOnPointerLeave === void 0 && {
                resetOnPointerLeave: !1
            }
        }, t.target === void 0 || t.target === "cursor" || (t.target === "personal camera" ? this.target = n.find(bn.PERSONAL_CAMERA_ID) : this.target = n.find(t.target)), this.data.dampingFactor && (this.currentDampingFactor = this.data.dampingFactor), this.object.getWorldQuaternion(this.worldQuaternion0), this.resetDampingFactor = 80 / this.data.resetSpeed + 1;
    }
}, Jy = class extends Bn {
    constructor(e){
        super(e);
        this.events = [];
        this.pairOfEventListeners = [];
        this.pairOfUserEventListeners = [];
        this.onMouseMove = (e)=>{
            if (!(ke.length > 1)) {
                this._lastMouseEvent = e, this.eventContext.updateRaycaster(e);
                for (let n of this.events)n.target === void 0 && this.updateSingleEvent(n);
            }
        };
        this.onMouseEnter = (e)=>{
            for (let n of this.events)n.target === void 0 && (n.isReset = !1, n.currentDampingFactor = n.data.dampingFactor);
        };
        this.onMouseLeave = (e)=>{
            for (let n of this.events)n.target === void 0 && (n.data.resetOnPointerLeave && (n.isReset = !0, n.currentDampingFactor = n.resetDampingFactor), this.updateSingleEvent(n));
        };
        this.onScroll = (e)=>{
            if (this._lastMouseEvent) {
                let n = new PointerEvent("pointermove", {
                    clientX: this._lastMouseEvent.clientX,
                    clientY: this._lastMouseEvent.clientY,
                    bubbles: !0,
                    cancelable: !0,
                    view: window
                });
                this.eventContext.eventElement.dispatchEvent(n);
            }
        };
        this.onTargetChange = (e)=>()=>{
                this.updateSingleEvent(e);
            };
        this.createUserEventListener = (e)=>({ eventName: n , target: i  })=>{
                if (!n || !i) return;
                let s = Gs(n);
                s && s === "LookAt" && this.updateSingleEvent(e);
            };
        let { scene: n  } = this.eventContext;
        n.traverseEntity((i)=>{
            let s = i.data?.events.find((o)=>o.data.type === "LookAt" && !o.data.disabled);
            s && (!n.data.environment.usePhysics || i.dataPatched.physics?.rigidBody !== "dynamic") && this.events.push(new vS(s.data, i, n));
        });
    }
    connect() {
        if (!this.events.length) return;
        let { domElement: e , eventElement: n  } = this.eventContext;
        this.domEventsNeeded.clear(), jn && (this.domEventsNeeded.add("pointerdown"), e.addEventListener("pointerdown", this.onMouseMove)), this.domEventsNeeded.add("pointermove"), n.addEventListener("pointermove", this.onMouseMove), this.eventContext.useWindowEvents ? n.addEventListener("scroll", this.onScroll) : (e.addEventListener("pointerenter", this.onMouseEnter), e.addEventListener("pointerleave", this.onMouseLeave));
        for (let i of this.events){
            if (i.target !== void 0) {
                let a = this.onTargetChange(i), l = i.target;
                this.pairOfEventListeners.push([
                    l,
                    a
                ]), l.addEventListener("requestRender", a);
            }
            let s = this.createUserEventListener(i), o = i.object;
            this.pairOfUserEventListeners.push([
                o,
                s
            ]), o.addEventListener("userEvent", s);
        }
    }
    disconnect() {
        if (!this.events.length) return;
        let { domElement: e , eventElement: n  } = this.eventContext;
        this.domEventsNeeded.clear(), jn && e.removeEventListener("pointerdown", this.onMouseMove), n.removeEventListener("pointermove", this.onMouseMove), e.removeEventListener("pointerenter", this.onMouseEnter), e.removeEventListener("pointerleave", this.onMouseLeave), n.removeEventListener("scroll", this.onScroll);
        for (let [i, s] of this.pairOfEventListeners)i.removeEventListener("requestRender", s);
        for (let [i, s] of this.pairOfUserEventListeners)i.removeEventListener("userEvent", s);
        for (let i of this.events)i.paused = !0, i.isReset = !1;
    }
    onAnimationFrameDamping() {
        for (let e of this.events)e.paused || this.updateSingleEvent(e);
    }
    updateSingleEvent(e) {
        let { tilt: n , axis: i , distance: s , plane: o , limitDistance: a , enabledRotation: l , limitDistanceEnabled: u  } = e.data, { camera: c , raycaster: d  } = this.eventContext, { object: h , target: f  } = e;
        if (h.getWorldPosition(Kf), !e.isReset) {
            if (e.target) e.target.getWorldPosition(Zf);
            else {
                if (o === "custom" ? (c.getWorldDirection(Zy), Zy.negate(), yS.setFromNormalAndCoplanarPoint(Zy, Kf)) : (o === "xy" ? Yf.set(0, 0, 1) : o === "xz" ? Yf.set(0, 1, 0) : o === "yz" && Yf.set(1, 0, 0), yS.setFromNormalAndCoplanarPoint(Yf, Kf)), !d.ray.intersectPlane(yS, Zf)) return;
                s > 0 && (o === "custom" || o === void 0) && Zf.addScaledVector(Zy, s);
            }
        }
        if (e.isReset || (f ? n === "target" ? kl.copy(f.up).applyMatrix4(Qf.extractRotation(f.matrixWorld)).normalize() : l.some((m)=>m === !1) ? (i === "x" ? (Ro.set(0, 0, 1), l[2] === !1 && Ro.set(0, 1, 0)) : i === "y" ? (Ro.set(1, 0, 0), l[0] === !1 && Ro.set(0, 0, 1)) : (Ro.set(0, 1, 0), l[1] === !1 && Ro.set(1, 0, 0)), kl.copy(Ro).applyQuaternion(e.worldQuaternion0).normalize()) : kl.set(0, 1, 0) : o === "custom" ? kl.set(0, 1, 0) : kl.copy(Yf)), e.isReset) Ma.copy(e.worldQuaternion0);
        else if (Kf.distanceTo(Zf) > a && u && f) {
            if (e.data.snapDelay && (e.delayFinished = !1, typeof window < "u" && e.timeoutId !== null && (window.clearTimeout(e.timeoutId), e.timeoutId = null)), e.wasOutside = !0, e.data.resetAfterDistanceLimit) Ma.copy(e.worldQuaternion0), e.currentDampingFactor = e.resetDampingFactor;
            else return;
        } else {
            if (e.wasOutside && (e.data.snapDelay && typeof window < "u" && (e.timeoutId = window.setTimeout(()=>{
                e.delayFinished = !0, e.paused = !1, this.updateSingleEvent(e);
            }, e.data.snapDelay * 1e3)), e.currentDampingFactor = e.data.dampingFactor, e.wasOutside = !1), e.delayFinished === !1) return;
            T6(Qf, Zf, Kf, kl, i, Ro), Ma.setFromRotationMatrix(Qf), Nd.setFromUnitVectors(Ro.applyQuaternion(Ma), kl), l.some((m)=>m === !1) && n !== "target" && Ma.premultiply(Nd).normalize();
        }
        e.currentDampingFactor > 1 ? (h.updateWorldMatrix(!0, !1), Nd.setFromRotationMatrix(Gw(h.matrixWorld)), Nd.slerp(Ma, 1 / e.currentDampingFactor), ID(h, Qf.makeRotationFromQuaternion(Nd)), e.paused = 8 * (1 - Nd.dot(Ma)) < A6) : (ID(h, Qf.makeRotationFromQuaternion(Ma)), e.paused = !0), e.object?.dispatchEvent({
            type: "beginEvent",
            eventName: "LookAt"
        }), h.dispatchEvent(_6), h.dispatchEvent(M6);
    }
}, Ii = new A, Zn = new A, _n = new A;
function T6(r1, t, e, n, i, s) {
    let o = r1.elements;
    _n.subVectors(t, e), _n.lengthSq() === 0 && (_n.z = 1), _n.normalize(), Zn.crossVectors(n, _n), Zn.lengthSq() === 0 && (Math.abs(n.z) === 1 ? _n.x += 1e-4 : _n.z += 1e-4, _n.normalize(), Zn.crossVectors(n, _n)), Zn.normalize(), Ii.crossVectors(_n, Zn), i === "x" ? s.z === 1 ? [Zn, Ii, _n] = [
        _n,
        Zn,
        Ii
    ] : (Zn.negate(), [Zn, _n] = [
        _n,
        Zn
    ]) : i === "y" ? s.x === 1 ? [Zn, Ii, _n] = [
        Ii,
        _n,
        Zn
    ] : (Zn.negate(), [Ii, _n] = [
        _n,
        Ii
    ]) : s.x === 1 && (Zn.negate(), [Zn, Ii] = [
        Ii,
        Zn
    ]), o[0] = Zn.x, o[4] = Ii.x, o[8] = _n.x, o[1] = Zn.y, o[5] = Ii.y, o[9] = _n.y, o[2] = Zn.z, o[6] = Ii.z, o[10] = _n.z;
}
var xS = class {
    constructor(t, e, n, i, s, o){
        this.id = t;
        this.data = e;
        this.object = n;
        this.entered = !1;
        this.actions = Qn(e, e.actions, i, s, o, n);
    }
    disconnect() {
        An(this.actions);
    }
    dispatchEnter() {
        this.actions.Transition.forEach((t)=>{
            t.object.currentTransitionEvent !== this && (t.object.currentTransitionEvent = this, t.init());
        }), this.entered || (this.entered = !0, this.actions.Transition.forEach((t)=>t.playFromCurrent()), this.actions.Create.forEach((t)=>t.dispatch()), this.actions.Destroy.forEach((t)=>t.dispatch()), this.actions.SwitchCamera.forEach((t)=>t.playFromCurrent()));
    }
    dispatchLeave() {
        this.actions.Transition.forEach((t)=>{
            t.object.currentTransitionEvent !== this && (t.object.currentTransitionEvent = this, t.init());
        }), this.entered && (this.entered = !1, this.actions.Transition.forEach((t)=>t.reverseFromCurrent()), this.actions.SwitchCamera.forEach((t)=>t.reverseFromCurrent()));
    }
    dispatchUserEvent(t) {
        this.actions.Transition.forEach((e)=>{
            e.object.currentTransitionEvent !== this && (e.object.currentTransitionEvent = this, e.init());
        }), t ? (this.actions.Transition.forEach((e)=>e.reverseFromCurrent()), this.actions.SwitchCamera.forEach((e)=>e.reverseFromCurrent())) : (this.actions.Transition.forEach((e)=>e.playFromCurrent()), this.actions.Create.forEach((e)=>e.dispatch()), this.actions.Destroy.forEach((e)=>e.dispatch()), this.actions.SwitchCamera.forEach((e)=>e.playFromCurrent()));
    }
}, $y = class extends Bn {
    constructor(e, n){
        super(e);
        this.eventsPerObjects = {};
        this.objects = [];
        this._prevObjects = [];
        this.onMouseDown = (e)=>{
            ke.length > 1 || (this.eventContext.updateRaycaster(e), this.handleMouseHoverEvent());
        };
        this.onMouseUp = (e)=>{
            ke.length > 1 || this.handleMouseHoverEvent(!0);
        };
        this.onMouseMove = (e)=>{
            ke.length > 1 || (this.eventContext.updateRaycaster(e), this.handleMouseHoverEvent());
        };
        this.onUserEvent = ({ eventName: e , target: n , reverse: i  })=>{
            if (!e || !n) return;
            let s = Gs(e);
            s && s === "MouseHover" && (n.dispatchEvent({
                type: "beginEvent",
                eventName: "MouseHover"
            }), this.eventsPerObjects[n.uuid]?.forEach((o)=>o.dispatchUserEvent(i)));
        };
        let { scene: i , sharedAssets: s  } = this.eventContext;
        i.traverseEntity((o)=>{
            if (!(!o.visible || !o.data?.events.length)) {
                for (let { id: a , data: l  } of o.data.events)if (!l.disabled && l.type === "MouseHover") try {
                    let u = new xS(a, l, o, i, s, n);
                    this.eventsPerObjects[o.uuid] ? this.eventsPerObjects[o.uuid].push(u) : this.eventsPerObjects[o.uuid] = [
                        u
                    ];
                } catch (u) {}
                this.eventsPerObjects[o.uuid]?.length && this.objects.push(o);
            }
        });
    }
    connect() {
        if (!this.objects.length) return;
        let { domElement: e  } = this.eventContext;
        this.domEventsNeeded.clear(), jn && (this.domEventsNeeded.add("pointerdown"), e.addEventListener("pointerdown", this.onMouseDown), this.domEventsNeeded.add("pointerup"), e.addEventListener("pointerup", this.onMouseUp)), this.domEventsNeeded.add("pointermove"), e.addEventListener("pointermove", this.onMouseMove), this.objects.forEach((n)=>{
            n.addEventListener("userEvent", this.onUserEvent);
        });
    }
    disconnect() {
        if (!this.objects.length) return;
        let { domElement: e  } = this.eventContext;
        this.domEventsNeeded.clear(), jn && (e.removeEventListener("pointerdown", this.onMouseDown), e.removeEventListener("pointerup", this.onMouseUp)), e.removeEventListener("pointermove", this.onMouseMove), Object.values(this.eventsPerObjects).forEach((n)=>{
            n.forEach((i)=>{
                i.disconnect();
            });
        }), this.objects.forEach((n)=>{
            n.removeEventListener("userEvent", this.onUserEvent);
        });
    }
    handleMouseHoverEvent(e = !1) {
        let n = [];
        if (!e) {
            let { stopRaycast: i , raycaster: s , scene: o  } = this.eventContext;
            if (i) {
                let a = zf(s, o, this.objects);
                n = Gf(a);
            } else this.objects.forEach((a)=>{
                Pd(s, a) && n.push(a);
            });
        }
        this._prevObjects.length && this._prevObjects.forEach((i)=>{
            n.includes(i) || (i.dispatchEvent({
                type: "beginEvent",
                eventName: "MouseHover"
            }), this.eventsPerObjects[i.uuid]?.forEach((s)=>s.dispatchLeave()));
        }), n.length && n.forEach((i)=>{
            i.dispatchEvent({
                type: "beginEvent",
                eventName: "MouseHover"
            }), this.eventsPerObjects[i.uuid]?.forEach((s)=>s.dispatchEnter());
        }), this._prevObjects = n;
    }
};
var bS = class {
    constructor(t, e, n, i, s, o){
        this.id = t;
        this.data = e;
        this.object = n;
        this.scrollCounter = 0;
        this.actions = Qn(e, e.actions, i, s, o, n);
    }
    connect() {
        this.scrollCounter = 0;
    }
    disconnect() {
        An(this.actions);
    }
    dispatch(t) {
        this.actions.Transition.forEach((i)=>{
            i.object.currentTransitionEvent !== this && (i.object.currentTransitionEvent = this, i.init());
        });
        let e = t > 0 ? 1 : -1;
        this.scrollCounter += e, this.scrollCounter = Math.min(Math.max(this.scrollCounter, 0), this.data.steps);
        let n = this.scrollCounter / this.data.steps;
        this.actions.Transition.forEach((i)=>i.seek(n)), this.actions.Create.forEach((i)=>i.dispatchThrottled());
    }
    dispatchUserEvent(t) {
        this.actions.Transition.forEach((e)=>{
            e.object.currentTransitionEvent !== this && (e.object.currentTransitionEvent = this, e.init());
        }), t ? this.actions.Transition.forEach((e)=>e.reverseFromCurrent()) : this.actions.Transition.forEach((e)=>{
            e.playFromCurrent();
        }), this.actions.Create.forEach((e)=>e.dispatchThrottled());
    }
}, wS = class {
    constructor(t, e, n, i, s, o, a){
        this.id = t;
        this.data = e;
        this.object = n;
        this.domElement = o;
        this.managers = a;
        this.scrollStart = 0;
        this.scrollEnd = 0;
        this.actions = Qn(e, e.actions, i, s, a, n);
    }
    computeScrollBounds() {
        let t = this.domElement.getBoundingClientRect(), e = document.body, n = document.documentElement, i = window.pageYOffset || n.scrollTop || e.scrollTop, s = n.clientTop || e.clientTop || 0, o = Math.round(t.top + i - s);
        if (this.data.startFrom === "enter") {
            let a = window.innerHeight, l = t.height, u = this.data.enterAnchor, c = u === "top" ? a : u === "bottom" ? a - l : a - l * .5;
            this.scrollStart = o - c;
        } else this.scrollStart = 0;
        this.scrollStart += this.data.startOffset ?? 0, this.scrollEnd = this.scrollStart + (this.data.endAfter ?? 400), this.dispatch({
            x: window.scrollX,
            y: window.scrollY
        });
    }
    connect() {
        this.computeScrollBounds();
    }
    disconnect() {
        An(this.actions);
    }
    handleResize() {
        this.computeScrollBounds();
    }
    dispatch({ x: t , y: e  }) {
        this.actions.Transition.forEach((s)=>{
            s.object.currentTransitionEvent !== this && (s.object.currentTransitionEvent = this, s.init());
        });
        let n = this.scrollEnd - this.scrollStart, i = Math.min(1, Math.max(0, (e - this.scrollStart) / n));
        this.actions.Transition.forEach((s)=>s.seek(i)), this.actions.Create.forEach((s)=>s.dispatchThrottled());
    }
    dispatchUserEvent(t) {
        this.actions.Transition.forEach((e)=>{
            e.object.currentTransitionEvent !== this && (e.object.currentTransitionEvent = this, e.init());
        }), t ? this.actions.Transition.forEach((e)=>e.reverseFromCurrent()) : this.actions.Transition.forEach((e)=>{
            e.playFromCurrent();
        }), this.actions.Create.forEach((e)=>e.dispatchThrottled());
    }
}, ev = class extends Bn {
    constructor(e, n){
        super(e);
        this.wheelEventsPerObject = new Map;
        this.scrollEventsPerObject = new Map;
        this.isInview = !0;
        this.handleResize = ()=>{
            [
                ...this.scrollEventsPerObject.entries()
            ].forEach(([e, n])=>{
                n.forEach((i)=>i.handleResize());
            });
        };
        this.onScroll = (e)=>{
            if (!this.isInview) return;
            let n = {
                y: window.scrollY,
                x: window.scrollX
            };
            [
                ...this.scrollEventsPerObject.entries()
            ].forEach(([i, s])=>{
                i.dispatchEvent({
                    type: "beginEvent",
                    eventName: "Scroll",
                    scroll: n
                }), s.forEach((o)=>o.dispatch(n));
            });
        };
        this.onWheel = (e)=>{
            !this.isInview || e.ctrlKey || [
                ...this.wheelEventsPerObject.entries()
            ].forEach(([n, i])=>{
                n.dispatchEvent({
                    type: "beginEvent",
                    eventName: "Scroll",
                    deltaY: e.deltaY
                }), i.forEach((s)=>s.dispatch(e.deltaY));
            });
        };
        this.onUserEvent = ({ eventName: e , target: n , reverse: i  })=>{
            if (!e || !n) return;
            let s = Gs(e);
            s && s === "Scroll" && (n.dispatchEvent({
                type: "beginEvent",
                eventName: "Scroll"
            }), this.wheelEventsPerObject.get(n)?.forEach((o)=>{
                o.dispatchUserEvent(i);
            }));
        };
        let { scene: i , sharedAssets: s , domElement: o , isExport: a  } = this.eventContext;
        i.traverseEntity((l)=>{
            if (!!l.data?.events.length) {
                for (let { id: u , data: c  } of l.data.events)if (!c.disabled && c.type === "Scroll") {
                    if (c.trigger === "load" || !a) {
                        let d = new bS(u, c, l, i, s, n);
                        this.wheelEventsPerObject.has(l) ? this.wheelEventsPerObject.get(l)?.push(d) : this.wheelEventsPerObject.set(l, [
                            d
                        ]);
                    } else {
                        let d = new wS(u, c, l, i, s, o, n);
                        this.scrollEventsPerObject.has(l) ? this.scrollEventsPerObject.get(l)?.push(d) : this.scrollEventsPerObject.set(l, [
                            d
                        ]);
                    }
                }
            }
        }), this.intersectionObserver = new IntersectionObserver((l)=>{
            let u = l[0];
            u && (this.isInview = u.isIntersecting);
        }, {
            root: null
        });
    }
    connect() {
        this.intersectionObserver.observe(this.eventContext.domElement), [
            ...this.wheelEventsPerObject.entries()
        ].forEach(([e, n])=>{
            n.forEach((i)=>i.connect()), e.addEventListener("userEvent", this.onUserEvent);
        }), [
            ...this.scrollEventsPerObject.entries()
        ].forEach(([e, n])=>{
            n.forEach((i)=>i.connect()), e.addEventListener("userEvent", this.onUserEvent);
        }), [
            ...this.wheelEventsPerObject.values()
        ].some((e)=>e.length) && (this.domEventsNeeded.add("wheel"), window.addEventListener("wheel", this.onWheel)), [
            ...this.scrollEventsPerObject.values()
        ].some((e)=>e.length) && (this.domEventsNeeded.add("scroll"), window.addEventListener("scroll", this.onScroll), window.addEventListener("resize", this.handleResize));
    }
    disconnect() {
        window.removeEventListener("wheel", this.onWheel), window.removeEventListener("scroll", this.onScroll), window.removeEventListener("resize", this.handleResize), this.intersectionObserver.unobserve(this.eventContext.domElement), this.domEventsNeeded.clear(), [
            ...this.wheelEventsPerObject.entries()
        ].forEach(([e, n])=>{
            n.forEach((i)=>i.disconnect()), e.removeEventListener("userEvent", this.onUserEvent);
        }), [
            ...this.scrollEventsPerObject.entries()
        ].forEach(([e, n])=>{
            n.forEach((i)=>i.disconnect()), e.removeEventListener("userEvent", this.onUserEvent);
        });
    }
};
var SS = class {
    constructor(t, e, n, i, s, o){
        this.id = t;
        this.data = e;
        this.object = n;
        this.actions = Qn(e, e.actions, i, s, o, n);
    }
    disconnect() {
        An(this.actions);
    }
    dispatch() {
        this.actions.Transition.forEach((t)=>{
            t.play();
        }), this.actions.SwitchCamera.forEach((t)=>{
            t.play();
        }), this.actions.Create.forEach((t)=>{
            t.dispatchFromStart();
        }), this.actions.Destroy.forEach((t)=>{
            t.dispatchFromStart();
        });
    }
    dispatchAfter(t) {
        this.actions.Audio.forEach((e)=>{
            (e.interaction.data.triggerAfter ?? "any") === t && (e.interaction instanceof To ? e.interaction.audioPlayer.play() : e.interaction instanceof Dd && e.interaction.dispatch());
        }), this.actions.Video.forEach((e)=>{
            let n = e.interaction.data.triggerAfter ?? "autoplay";
            n === t && (e.interaction instanceof Aa ? e.interaction.play(n === "autoplay") : e.interaction instanceof Id && e.interaction.dispatch());
        });
    }
    dispatchUserEvent(t) {
        this.actions.Transition.forEach((e)=>{
            e.object.currentTransitionEvent !== this && (e.object.currentTransitionEvent = this, e.init());
        }), t ? (this.actions.Transition.forEach((e)=>e.reverseFromCurrent()), this.actions.SwitchCamera.forEach((e)=>e.reverseFromCurrent())) : (this.actions.Transition.forEach((e)=>e.playFromCurrent()), this.actions.SwitchCamera.forEach((e)=>e.playFromCurrent())), this.actions.Create.forEach((e)=>{
            e.dispatch();
        }), this.actions.Destroy.forEach((e)=>{
            e.dispatch();
        }), this.actions.Audio.forEach((e)=>{
            e.interaction instanceof To ? e.interaction.audioPlayer.play() : e.interaction instanceof Dd && e.interaction.dispatch();
        }), this.actions.Video.forEach((e)=>{
            e.interaction instanceof Aa ? e.interaction.play() : e.interaction instanceof Id && e.interaction.dispatch();
        });
    }
}, tv = class extends Bn {
    constructor(e, n){
        super(e);
        this.eventsPerObject = new Map;
        this.eventsAfterPerObject = new Map;
        this.onMouseDown = ()=>{
            [
                ...this.eventsAfterPerObject.entries()
            ].forEach(([e, n])=>{
                e.dispatchEvent({
                    type: "beginEvent",
                    eventName: "Start"
                }), n.forEach((i)=>{
                    i.dispatchAfter("mouseDown");
                });
            });
        };
        this.onKeyDown = ()=>{
            [
                ...this.eventsAfterPerObject.entries()
            ].forEach(([e, n])=>{
                e.dispatchEvent({
                    type: "beginEvent",
                    eventName: "Start"
                }), n.forEach((i)=>{
                    i.dispatchAfter("keyDown");
                });
            });
        };
        this.onAny = ()=>{
            let { domElement: e , isExport: n  } = this.eventContext;
            (n ? document : e).removeEventListener("pointerdown", this.onAny), document.removeEventListener("keydown", this.onAny), [
                ...this.eventsAfterPerObject.entries()
            ].forEach(([s, o])=>{
                s.dispatchEvent({
                    type: "beginEvent",
                    eventName: "Start"
                }), o.forEach((a)=>{
                    a.dispatchAfter("any");
                });
            });
        };
        this.onPlay = ()=>{
            [
                ...this.eventsAfterPerObject.entries()
            ].forEach(([e, n])=>{
                e.dispatchEvent({
                    type: "beginEvent",
                    eventName: "Start"
                }), n.forEach((i)=>{
                    i.dispatchAfter("autoplay");
                });
            });
        };
        this.onUserEvent = ({ eventName: e , target: n , reverse: i  })=>{
            if (!e || !n) return;
            let s = Gs(e);
            s && s === "Start" && (n.dispatchEvent({
                type: "beginEvent",
                eventName: "Start"
            }), this.eventsPerObject.get(n)?.forEach((o)=>{
                o.dispatchUserEvent(i);
            }), this.eventsAfterPerObject.get(n)?.forEach((o)=>{
                o.dispatchUserEvent(i);
            }));
        };
        let { scene: i , sharedAssets: s  } = this.eventContext;
        i.traverseEntity((o)=>{
            if (!!o.data?.events.length) for (let { id: a , data: l  } of o.data.events){
                if (l.disabled || l.type !== "Start") continue;
                let u = new SS(a, l, o, i, s, n);
                (u.actions.Transition.length || u.actions.SwitchCamera.length || u.actions.Create.length || u.actions.Destroy.length) && (this.eventsPerObject.has(o) ? this.eventsPerObject.get(o)?.push(u) : this.eventsPerObject.set(o, [
                    u
                ])), u.actions.Audio.length && (this.eventsAfterPerObject.has(o) ? this.eventsAfterPerObject.get(o)?.push(u) : this.eventsAfterPerObject.set(o, [
                    u
                ])), u.actions.Video.length && (this.hasVideoAction = !0, this.eventsAfterPerObject.has(o) ? this.eventsAfterPerObject.get(o)?.push(u) : this.eventsAfterPerObject.set(o, [
                    u
                ]));
            }
        });
    }
    connect() {
        if ([
            ...this.eventsAfterPerObject.values()
        ].some((e)=>e.length)) {
            let { domElement: e , isExport: n  } = this.eventContext, i = n ? document : e;
            i.addEventListener("pointerdown", this.onMouseDown, {
                once: !0
            }), document.addEventListener("keydown", this.onKeyDown, {
                once: !0
            }), i.addEventListener("pointerdown", this.onAny), document.addEventListener("keydown", this.onAny), [
                ...this.eventsAfterPerObject.entries()
            ].forEach(([s, o])=>{
                s.addEventListener("userEvent", this.onUserEvent);
            }), this.onPlay();
        }
        [
            ...this.eventsPerObject.entries()
        ].forEach(([e, n])=>{
            e.dispatchEvent({
                type: "beginEvent",
                eventName: "Start"
            }), n.forEach((i)=>i.dispatch()), e.addEventListener("userEvent", this.onUserEvent);
        });
    }
    disconnect() {
        if ([
            ...this.eventsAfterPerObject.values()
        ].some((e)=>e.length)) {
            let { domElement: e , isExport: n  } = this.eventContext, i = n ? document : e;
            i.removeEventListener("pointerdown", this.onMouseDown), document.removeEventListener("keydown", this.onKeyDown), i.removeEventListener("pointerdown", this.onAny), document.removeEventListener("keydown", this.onAny), [
                ...this.eventsAfterPerObject.entries()
            ].forEach(([s, o])=>{
                s.removeEventListener("userEvent", this.onUserEvent), o.forEach((a)=>a.disconnect());
            });
        }
        [
            ...this.eventsPerObject.entries()
        ].forEach(([e, n])=>{
            e.removeEventListener("userEvent", this.onUserEvent), n.forEach((i)=>i.disconnect());
        });
    }
};
var nv = class {
    constructor(t, e, n, i, s, o){
        this.id = t;
        this.data = e;
        this.object = n;
        this.disabled = !0;
        this.actions = Qn(e, e.actions, i, s, o, n), this.target = e.target, this.useToggle = e.toggle;
    }
    disconnect() {
        An(this.actions);
    }
    dispatch(t) {
        this.disabled || (this.actions.Transition.forEach((e)=>{
            e.object.currentTransitionEvent !== this && (e.object.currentTransitionEvent = this, e.init());
        }), this.object.dispatchEvent({
            type: "beginEvent",
            eventName: "Collision"
        }), this.useToggle ? this.actions.Transition.forEach((e)=>{
            e.toggle();
        }) : this.actions.Transition.forEach((e)=>{
            e.play();
        }), this.actions.Link.forEach((e)=>{
            e.dispatch();
        }), this.actions.Reset.forEach((e)=>{
            e.dispatch();
        }), this.actions.Create.forEach((e)=>{
            e.dispatch();
        }), this.actions.Destroy.forEach((e)=>{
            e.dispatch(t ?? !1);
        }), this.actions.Audio.forEach((e)=>{
            e.dispatchBasic();
        }), this.actions.Video.forEach((e)=>{
            e.dispatchBasic();
        }));
    }
};
var RD = "https://unpkg.com/@splinetool/runtime@0.9.369/build/", E6 = "https://unpkg.com/@splinetool/navmesh-wasm@0.9.369/build/", C6 = `
(async function() {
	const [wasmImport, wasmBinary] = await Promise.all([
		import('${RD}' + 'navmesh.js'),
		fetch('${E6}' + 'navmesh.wasm').then((res) => res.arrayBuffer()),
	]);
	const wasmModule = wasmImport.default;
	self.module = await wasmModule({ wasmBinary });
	postMessage('ready');
})();
`, P6 = `
(async function() {
	const [wasmImport, wasmBinary] = await Promise.all([
		import(self.location.origin + '/_libraries/navmesh.js'),
		fetch(self.location.origin + '/_libraries/navmesh.wasm').then((res) => res.arrayBuffer()),
	]);
	const wasmModule = wasmImport.default;
	self.module = await wasmModule({ wasmBinary });
	postMessage('ready');
})();
`, D6 = `

onmessage = function(messageEvent) {
	const meshData = messageEvent.data;
	const positions = meshData[0];
	const offset = meshData[1];
	const indices = meshData[2];
	const indicesLength = meshData[3];
	const parameters = meshData[4];

	const module = self.module;
	const rc = new module.rcConfig();
	rc.cs = parameters.cs;
	rc.ch = parameters.ch;
	rc.borderSize = parameters.borderSize ? parameters.borderSize : 0;
	rc.tileSize = parameters.tileSize ? parameters.tileSize : 0;
	rc.walkableSlopeAngle = parameters.walkableSlopeAngle;
	rc.walkableHeight = parameters.walkableHeight;
	rc.walkableClimb = parameters.walkableClimb;
	rc.walkableRadius = parameters.walkableRadius;
	rc.maxEdgeLen = parameters.maxEdgeLen;
	rc.maxSimplificationError = parameters.maxSimplificationError;
	rc.minRegionArea = parameters.minRegionArea;
	rc.mergeRegionArea = parameters.mergeRegionArea;
	rc.maxVertsPerPoly = parameters.maxVertsPerPoly;
	rc.detailSampleDist = parameters.detailSampleDist;
	rc.detailSampleMaxError = parameters.detailSampleMaxError;

	if (!self.navMesh) {
		self.navMesh = new module.NavMesh();
	}
	self.navMesh.build(positions, offset, indices, indicesLength, rc);

	const navmeshData = navMesh.getNavmeshData();
	const arrView = new Uint8Array(module.HEAPU8.buffer, navmeshData.dataPointer, navmeshData.size);
	const ret = new Uint8Array(navmeshData.size);
	ret.set(arrView);
	navMesh.freeNavmeshData(navmeshData);

	postMessage(ret);
}
`, OD = .001, I6 = {
    cs: 6,
    ch: 2,
    walkableSlopeAngle: 90,
    walkableHeight: 20,
    walkableClimb: 5,
    walkableRadius: 0,
    maxEdgeLen: 12,
    maxSimplificationError: 1.3,
    minRegionArea: 8,
    mergeRegionArea: 20,
    maxVertsPerPoly: 6,
    detailSampleDist: 6,
    detailSampleMaxError: 1
}, LD, ht, xr;
TT.then((r1)=>{
    LD = r1, ht = new r1.Vec3, xr = new r1.Vec3;
});
var O6 = new A, rv = class {
    constructor(t = !1, e = !1){
        this.usePhysics = t;
        this.isExport = e;
        this.onPointerDown = (t)=>{
            if (ke.length !== 1) return;
            let { raycaster: e , scene: n  } = this.eventContext;
            this.eventContext.updateRaycaster(t);
            let i = n.raycastWithClones(e);
            if (i.length !== 0) {
                for (let s of this.gameControls){
                    let o = O6.copy(s.colliderWorldPosition);
                    o.y -= s.colliderHeight / 2, s.path = this.computePath(o, i[0].point);
                }
                this.eventContext.requestRender();
            }
        };
        this.traverseWithPhysics = (t, e)=>(n)=>{
                let i;
                if (n instanceof hr) {
                    if (n.objectForSample) {
                        if (n.objectForSample.dataPatched.physics.fusedBody) return;
                        i = n.object;
                    } else return n.object.dataPatched.physics.fusedBody === !0 && n.object.dataPatched.physics.rigidBody === "dynamic" ? !0 : void 0;
                } else if (n instanceof dn) i = n.object;
                else if (i = n, i.dataPatched.cloner?.disabled === !1 && i.dataPatched.cloner?.hideBase && i.dataPatched.physics?.fusedBody !== !0) return !0;
                if (e && !i.userData.navmesh) return;
                let s = i.dataPatched;
                if (!s.visible && s.collision !== !0) return !0;
                n.updateMatrixWorldSVD();
                let o = Jf(s), a = i.userData.hasDestroy, l = i.userData.hasDrag, u = !1, c = !1;
                for (let d of s.events)d.data.disabled !== !0 && (d.data.type === "GameControl" ? u = !0 : d.data.type === "Follow" && (c = !0));
                if (u || o || c || a || l) return !0;
                if (this.usePhysics && s.physics?.rigidBody === "dynamic") {
                    if (this.usePhysics && s.physics?.fusedBody) return !0;
                } else if ("geometry" in n && t.push(os(n.geometry, n.matrixWorld)), this.usePhysics && s.physics?.fusedBody) return n.traverseObject((d, h)=>{
                    if (h === 0) return;
                    let f;
                    if (d instanceof hr) {
                        if (d.objectForSample) {
                            if (d.objectForSample.dataPatched.physics.fusedBody) return;
                            f = d.object;
                        } else return d.object.dataPatched.physics.fusedBody === !0 && d.object.dataPatched.physics.rigidBody === "dynamic" ? !0 : void 0;
                    } else if (d instanceof dn) f = d.object;
                    else if (f = d, d.dataPatched.cloner?.hideBase) return !0;
                    let m = f.dataPatched;
                    if (!m.visible && m.collision !== !0) return !0;
                    "geometry" in d && t.push(os(d.geometry, d.matrixWorld));
                }), !0;
            };
        this.traverseNoPhysics = (t, e)=>(n)=>{
                let i;
                if (n instanceof hr) return;
                n instanceof dn ? i = n.object : i = n;
                let s = i.dataPatched;
                if (s.collision === "visibility" ? !s.visible : !s.collision) return !0;
                if (e && !i.userData.navmesh) return;
                let o = n.geometry, a = i.userData.hasDestroy === !0, l = i.userData.hasDrag === !0;
                if (Jf(s) || a || l || i.dataPatched.events.some((u)=>u.data.disabled !== !0 && u.data.type === "GameControl")) return !0;
                o && t.push(os(o, n.matrixWorld));
            };
        this.navmeshWasm = LD, this.navMesh = new this.navmeshWasm.NavMesh, this._workerURL = URL.createObjectURL(new Blob([
            (e ? C6 : P6) + D6
        ])), this._worker = new Worker(this._workerURL);
    }
    init(t, e, n) {
        this.gameControls = e, this.eventContext = n, this.resolution = t.ch, this.setDefaultQueryExtent(new A().setScalar(t.ch * t.walkableRadius * 1.2)), this._worker.onmessage = ()=>{
            this.createNavMesh(n.scene, t, (i)=>{
                this.buildFromNavmeshData(i.data);
            });
        }, this.eventContext.renderer.domElement.addEventListener("pointerdown", this.onPointerDown);
    }
    createNavMesh(t, e, n) {
        e.objects.forEach((u)=>{
            let c = t.find(u);
            c.traverseEntity((d)=>{
                d.userData.navmesh = !0;
            }), c.cloner?.traverseObject((d)=>{
                d.userData.navmesh = !0;
            });
        });
        let i = [], s = (this.usePhysics ? this.traverseWithPhysics : this.traverseNoPhysics)(i, e.zones === "custom");
        if (t.traverseObject(s), e.objects.forEach((u)=>{
            let c = t.find(u);
            c.traverseEntity((d)=>{
                d.userData.navmesh = void 0;
            }), c.cloner?.traverseObject((d)=>{
                d.userData.navmesh = void 0;
            });
        }), i.length === 0) return !1;
        let o = Xi(i), { positions: a , triIndices: l  } = Al(o.getAttribute("position"), o.getIndex());
        return this._worker.postMessage([
            a,
            a.length / 3,
            l,
            l.length,
            {
                ...I6,
                ...e
            }
        ]), this._worker.onmessage = n, !0;
    }
    createDebugNavGeometry() {
        let t, e, n = this.navMesh.getDebugNavMesh(), i = n.getTriangleCount(), s = new Uint32Array(i * 3), o = new Float32Array(i * 9);
        for(t = 0; t < i * 3; t++)s[t] = t;
        for(t = 0; t < i; t++)for(e = 0; e < 3; e++){
            let l = n.getTriangle(t).getPoint(e);
            o[t * 9 + e * 3 + 0] = l.x, o[t * 9 + e * 3 + 1] = l.y, o[t * 9 + e * 3 + 2] = l.z;
        }
        let a = new Me;
        return a.setIndex(new Be(s, 1)), a.setAttribute("position", new Be(o, 3)), a;
    }
    getClosestPoint(t) {
        return ht.x = t.x, ht.y = t.y, ht.z = t.z, this.navMesh.getClosestPoint(ht);
    }
    getClosestPointToRef(t, e) {
        ht.x = t.x, ht.y = t.y, ht.z = t.z;
        let n = this.navMesh.getClosestPoint(ht);
        e.set(n.x, n.y, n.z);
    }
    getRandomPointAround(t, e) {
        return ht.x = t.x, ht.y = t.y, ht.z = t.z, this.navMesh.getRandomPointAround(ht, e);
    }
    getRandomPointAroundToRef(t, e, n) {
        ht.x = t.x, ht.y = t.y, ht.z = t.z;
        let i = this.navMesh.getRandomPointAround(ht, e);
        n.set(i.x, i.y, i.z);
    }
    moveAlong(t, e) {
        return ht.x = t.x, ht.y = t.y, ht.z = t.z, xr.x = e.x, xr.y = e.y, xr.z = e.z, this.navMesh.moveAlong(ht, xr);
    }
    moveAlongToRef(t, e, n) {
        return ht.x = t.x, ht.y = t.y, ht.z = t.z, xr.x = e.x, xr.y = e.y, xr.z = e.z, this.navMesh.moveAlong(ht, xr);
    }
    computePath(t, e) {
        let n = this.getClosestPoint(e);
        xr.x = n.x, xr.y = n.y, xr.z = n.z, this.getClosestPoint(t);
        let i = this.navMesh.computePath(ht, xr), s = i.getPointCount(), o = [];
        for(let a = 0; a < s; a++){
            let l = i.getPoint(a);
            o.push(new A(l.x, l.y, l.z));
        }
        return o;
    }
    createCrowd(t, e) {
        return new AS(this, t, e);
    }
    setDefaultQueryExtent(t) {
        ht.x = t.x, ht.y = t.y, ht.z = t.z, this.navMesh.setDefaultQueryExtent(ht);
    }
    getDefaultQueryExtent() {
        return this.navMesh.getDefaultQueryExtent();
    }
    buildFromNavmeshData(t) {
        let e = t.length * t.BYTES_PER_ELEMENT, n = this.navmeshWasm._malloc(e), i = new Uint8Array(this.navmeshWasm.HEAPU8.buffer, n, e);
        i.set(t);
        let s = new this.navmeshWasm.NavmeshData;
        s.dataPointer = i.byteOffset, s.size = t.length, this.navMesh.buildFromNavmeshData(s), this.navmeshWasm._free(i.byteOffset);
    }
    getNavmeshData() {
        let t = this.navMesh.getNavmeshData(), e = new Uint8Array(this.navmeshWasm.HEAPU8.buffer, t.dataPointer, t.size), n = new Uint8Array(t.size);
        return n.set(e), this.navMesh.freeNavmeshData(t), n;
    }
    getDefaultQueryExtentToRef(t) {
        let e = this.navMesh.getDefaultQueryExtent();
        t.set(e.x, e.y, e.z);
    }
    dispose() {
        this.navMesh.destroy(), this._worker.terminate(), URL.revokeObjectURL(this._workerURL), this.eventContext?.renderer.domElement.removeEventListener("pointerdown", this.onPointerDown);
    }
    addCylinderObstacle(t, e, n) {
        return ht.x = t.x, ht.y = t.y, ht.z = t.z, this.navMesh.addCylinderObstacle(ht, e, n);
    }
    addBoxObstacle(t, e, n) {
        return ht.x = t.x, ht.y = t.y, ht.z = t.z, xr.x = e.x, xr.y = e.y, xr.z = e.z, this.navMesh.addBoxObstacle(ht, xr, n);
    }
    removeObstacle(t) {
        this.navMesh.removeObstacle(t);
    }
    isSupported() {
        return this.navmeshWasm !== void 0;
    }
}, AS = class {
    constructor(t, e, n){
        this.navmeshWasmWrapper = t;
        this.transforms = [];
        this.agents = new Array;
        this.reachRadii = new Array;
        this._agentDestinationArmed = new Array;
        this._agentDestination = new Array;
        this.crowd = new this.navmeshWasmWrapper.navmeshWasm.Crowd(e, n, this.navmeshWasmWrapper.navMesh.getNavMesh());
    }
    onReachTarget(t, e) {}
    addAgent(t, e, n) {
        let i = new this.navmeshWasmWrapper.navmeshWasm.dtCrowdAgentParams;
        i.radius = e.radius, i.height = e.height, i.maxAcceleration = e.maxAcceleration, i.maxSpeed = e.maxSpeed, i.collisionQueryRange = e.collisionQueryRange, i.pathOptimizationRange = e.pathOptimizationRange, i.separationWeight = e.separationWeight, i.updateFlags = 7, i.obstacleAvoidanceType = 0, i.queryFilterType = 0, i.userData = 0;
        let s = this.crowd.addAgent(new this.navmeshWasmWrapper.navmeshWasm.Vec3(t.x, t.y, t.z), i);
        return this.transforms.push(n), this.agents.push(s), this.reachRadii.push(e.reachRadius ? e.reachRadius : e.radius), this._agentDestinationArmed.push(!1), this._agentDestination.push(new A(0, 0, 0)), s;
    }
    getAgentPosition(t) {
        return this.crowd.getAgentPosition(t);
    }
    getAgentPositionToRef(t, e) {
        let n = this.crowd.getAgentPosition(t);
        e.set(n.x, n.y, n.z);
    }
    getAgentVelocity(t) {
        return this.crowd.getAgentVelocity(t);
    }
    getAgentVelocityToRef(t, e) {
        let n = this.crowd.getAgentVelocity(t);
        e.set(n.x, n.y, n.z);
    }
    getAgentNextTargetPath(t) {
        return this.crowd.getAgentNextTargetPath(t);
    }
    getAgentNextTargetPathToRef(t, e) {
        let n = this.crowd.getAgentNextTargetPath(t);
        e.set(n.x, n.y, n.z);
    }
    getAgentState(t) {
        return this.crowd.getAgentState(t);
    }
    overOffmeshConnection(t) {
        return this.crowd.overOffmeshConnection(t);
    }
    agentGoto(t, e) {
        this.crowd.agentGoto(t, new this.navmeshWasmWrapper.navmeshWasm.Vec3(e.x, e.y, e.z));
        let n = this.agents.indexOf(t);
        n > -1 && (this._agentDestinationArmed[n] = !0, this._agentDestination[n].set(e.x, e.y, e.z));
    }
    agentTeleport(t, e) {
        this.crowd.agentTeleport(t, new this.navmeshWasmWrapper.navmeshWasm.Vec3(e.x, e.y, e.z));
    }
    updateAgentParameters(t, e) {
        let n = this.crowd.getAgentParameters(t);
        e.radius !== void 0 && (n.radius = e.radius), e.height !== void 0 && (n.height = e.height), e.maxAcceleration !== void 0 && (n.maxAcceleration = e.maxAcceleration), e.maxSpeed !== void 0 && (n.maxSpeed = e.maxSpeed), e.collisionQueryRange !== void 0 && (n.collisionQueryRange = e.collisionQueryRange), e.pathOptimizationRange !== void 0 && (n.pathOptimizationRange = e.pathOptimizationRange), e.separationWeight !== void 0 && (n.separationWeight = e.separationWeight), this.crowd.setAgentParameters(t, n);
    }
    removeAgent(t) {
        this.crowd.removeAgent(t);
        let e = this.agents.indexOf(t);
        e > -1 && (this.agents.splice(e, 1), this.transforms.splice(e, 1), this.reachRadii.splice(e, 1), this._agentDestinationArmed.splice(e, 1), this._agentDestination.splice(e, 1));
    }
    getAgents() {
        return this.agents;
    }
    update(t) {
        if (this.navmeshWasmWrapper.navMesh.update(), t <= OD) return;
        let e = 1 / 60, n = 10;
        if (e <= OD) this.crowd.update(t);
        else {
            let i = Math.floor(t / e);
            n && i > n && (i = n), i < 1 && (i = 1);
            let s = t / i;
            for(let o = 0; o < i; o++)this.crowd.update(s);
        }
        for(let i = 0; i < this.agents.length; i++){
            let s = this.agents[i], o = this.getAgentPosition(s);
            if (this.transforms[i].copy(o), this._agentDestinationArmed[i]) {
                let a = o.x - this._agentDestination[i].x, l = o.z - this._agentDestination[i].z, u = this.reachRadii[i], c = this._agentDestination[i].y - this.reachRadii[i], d = this._agentDestination[i].y + this.reachRadii[i], h = a * a + l * l;
                o.y > c && o.y < d && h < u * u && (this.onReachTarget(s, this._agentDestination[i]), this._agentDestinationArmed[i] = !1);
            }
        }
    }
    setDefaultQueryExtent(t) {
        let e = new this.navmeshWasmWrapper.navmeshWasm.Vec3(t.x, t.y, t.z);
        this.crowd.setDefaultQueryExtent(e);
    }
    getDefaultQueryExtent() {
        return this.crowd.getDefaultQueryExtent();
    }
    getDefaultQueryExtentToRef(t) {
        let e = this.crowd.getDefaultQueryExtent();
        t.set(e.x, e.y, e.z);
    }
    getCorners(t) {
        let e, n = this.crowd.getCorners(t), i = n.getPointCount(), s = [];
        for(e = 0; e < i; e++){
            let o = n.getPoint(e);
            s.push(new A(o.x, o.y, o.z));
        }
        return s;
    }
    dispose() {
        this.crowd.destroy();
    }
};
function _S(r1) {
    let t = !1, e = r1.scene.publish.gameControlObject;
    return e && r1.scene.objects.data(e)?.events?.forEach((n)=>{
        n.data.type === "GameControl" && n.data.navmesh.enabled && (t = !0);
    }), t;
}
var nn;
DT.then((r1)=>nn = r1);
var Fn = new A, cs = new Je, Ta = new A, MS = new Wt(0, 0, 0, "YXZ"), R6 = {
    type: "updateMatrix"
}, TS = {
    type: "beginEvent",
    eventName: "Collision"
};
function ND(r1) {
    if (r1.scene.environment.usePhysics) return !0;
    let t = !1;
    return r1.scene.objects.traverse((e, n)=>{
        for (let i of n.events)if (i.data.disabled !== !0 && i.data.type === "GameControl" && i.data.collisionEnabled) {
            t = !0;
            break;
        }
    }), t;
}
var Jf = (r1)=>r1.states.some((t)=>t.data.position !== void 0 || t.data.rotation !== void 0 || t.data.hiddenMatrix !== void 0 || t.data.cloner !== void 0 || t.data.pathSnapping !== void 0), iv = class {
    constructor(t, e){
        this.collab = t;
        this.eventContext = e;
        this.orbitControlsNeedsUpdate = !0;
        this.gameControls = [];
        this.gameControlStates = [];
        this.joysticks = [];
        this.joystickToGameControls = [];
        this.sharedGameControlGlobals = {
            entitiesWithTransformAnim: [],
            eventsPerObjects: {},
            colliderToEntity: {},
            gamePads: [],
            createdObjects: [],
            nCreatedPerAction: {}
        };
        this.eventManager = void 0;
        this.needsCollisionDetection = !1;
        this.initializationCounter = -1;
        this.rigidBodyToMesh = new Map;
        this.nActiveRigidBodies = 0;
        this.collisionEvents = [];
        this.isExport = !1;
        this.processRigidBody = (t)=>{
            if (t.bodyType() !== nn.RigidBodyType.Dynamic) return;
            t.isSleeping() || this.nActiveRigidBodies++;
            let [e, n, i] = this.rigidBodyToMesh.get(t.handle);
            if (Fn.copy(t.translation()).multiplyScalar(this.pixelsPerMeter), cs.copy(t.rotation()), e.matrixWorld.compose(Fn, cs, n), e.hasNonUniformScale && e.matrixWorld.multiply(e.shearScale), e.dispatchEvent(R6), i) {
                let s = e.cloner;
                if (s && s.objectForSample === void 0) {
                    s.matrixWorld.copy(e.matrixWorld);
                    for (let o of s.children)o.updateMatrixWorld(!0);
                }
                for (let o of e.children)o.updateMatrixWorld(!0);
            }
        };
        this.handleCollisionEvents = (t, e, n)=>{
            if (n !== !1) {
                for(let i = this.sharedGameControlGlobals.createdObjects.length - 1; i >= 0; i--){
                    let s = this.sharedGameControlGlobals.createdObjects[i];
                    if (s.userData.hasCollisionDestroy && (s.rigidBody?.collider(0).handle === t || s.rigidBody?.collider(0).handle === e)) {
                        this.sharedGameControlGlobals.createdObjects.splice(i, 1), s.removeFromParent(), requestAnimationFrame(()=>this.sharedGameControlGlobals.rapierWorld?.removeRigidBody(s.rigidBody));
                        break;
                    }
                }
                if (this.gameControls.some((i)=>i.object === this.sharedGameControlGlobals.colliderToEntity[t])) {
                    let i = this.sharedGameControlGlobals.colliderToEntity[e], s = this.sharedGameControlGlobals.eventsPerObjects[i.uuid];
                    if (s === void 0) return;
                    for (let o of s)o.data.target === "character" && this.dispatchCollisionEvent(o, i, e);
                } else if (this.gameControls.some((i)=>i.object === this.sharedGameControlGlobals.colliderToEntity[e])) {
                    let i = this.sharedGameControlGlobals.colliderToEntity[t], s = this.sharedGameControlGlobals.eventsPerObjects[i.uuid];
                    if (s === void 0) return;
                    for (let o of s)o.data.target === "character" && this.dispatchCollisionEvent(o, i, t);
                } else {
                    let i = this.sharedGameControlGlobals.colliderToEntity[t], s = this.sharedGameControlGlobals.eventsPerObjects[i.uuid];
                    if (s !== void 0) for (let l of s)l.data.target === "scene" && this.dispatchCollisionEvent(l, i, t);
                    let o = this.sharedGameControlGlobals.colliderToEntity[e], a = this.sharedGameControlGlobals.eventsPerObjects[o?.uuid];
                    if (a !== void 0) for (let l of a)l.data.target === "scene" && this.dispatchCollisionEvent(l, o, e);
                }
            }
        };
        this.isExport = e.isExport, this.sharedAssets = e.sharedAssets, this.scene = e.scene, this.renderer = e.renderer, this.requestRender = e.requestRender, this.domElement = this.renderer.domElement, this.usePhysics = this.collab.scene.environment.usePhysics ?? Fr.defaultData.usePhysics, this.pixelsPerMeter = this.collab.scene.environment.pixelsPerMeter ?? Fr.defaultData.pixelsPerMeter, this.gravity = this.collab.scene.environment.gravity ?? Fr.defaultData.gravity;
    }
    attachVRControllers(t) {
        t.forEach((e)=>{
            e.addEventListener("connected", (n)=>{
                "gamepad" in n.data && "axes" in n.data.gamepad && this.sharedGameControlGlobals.gamePads.push(n.data.gamepad);
            });
        });
    }
    markIsDestroyTarget() {
        this.scene.traverseVisibleEntity((t)=>{
            let e = t.dataPatched;
            for (let n of e.events){
                if (n.data.disabled === !0) continue;
                let i = n.data.actions?.find((s)=>s.data.type === "Destroy")?.data;
                if (i) for (let s of i.objects){
                    let o = this.scene.find(s);
                    o && (o.userData.hasDestroy = !0);
                }
            }
        });
    }
    markIsDragObject() {
        this.scene.traverseVisibleEntity((t)=>{
            let e = t.dataPatched;
            for (let n of e.events)if (!(n.data.disabled === !0 || n.data.type !== "DragDrop")) for (let i of n.data.objects){
                let s = this.scene.find(i);
                s && (s.userData.hasDrag = !0);
            }
        });
    }
    initBVH() {
        let t = [];
        if (this.scene.traverseObject((e)=>{
            let n;
            if (e instanceof hr) return;
            e instanceof dn ? n = e.object : n = e;
            let i = n.dataPatched;
            if (i.collision === "visibility" ? !i.visible : !i.collision) return !0;
            let s = e.geometry, o = n.userData.hasDestroy === !0, a = n.userData.hasDrag === !0;
            if (Jf(i) || o || a || n.dataPatched.events.some((l)=>l.data.disabled !== !0 && l.data.type === "GameControl")) return e.updateMatrixWorldSVD(), this.addBoundsTree(e), !0;
            s && t.push(os(s, e.matrixWorld));
        }), t.length > 0) {
            let e = Xi(t, !1);
            this.sharedGameControlGlobals.staticMeshBVH = new un(e);
        }
    }
    addRigidBody(t, e, n) {
        let i = [], s = "geometry" in t ? t.geometry : void 0, o = e.dataPatched;
        if (s?.getAttribute("position") !== void 0 && i.push(os(s, t.shearScale)), o.physics.fusedBody) {
            let a = this.gatherChildrenGeom(t, i);
            t.traverseObject(a), t.children.forEach((u)=>u.updateMatrixWorld(!0));
            let l = t.cloner;
            l && l.objectForSample === void 0 && o.physics.rigidBody === "dynamic" && (l.traverseObject(a), l.children.forEach((u)=>u.updateMatrixWorld(!0)));
        }
        if (i.length > 0) {
            let a, l = !n.fromCreate && o.physics.rigidBody === "dynamic" || n.fromCreate && n.dynamic;
            l ? (a = nn.RigidBodyDesc.dynamic(), a.setLinearDamping(o.physics.damping).setAdditionalMass(1e-9).setGravityScale(o.physics.gravityScale).enabledRotations(...o.physics.enabledRotation).enabledTranslations(...o.physics.enabledTranslation)) : (n.hasTransformAnim || n.hasFollow || n.hasDrag) && !n.fromCreate ? (a = nn.RigidBodyDesc.kinematicPositionBased(), this.sharedGameControlGlobals.entitiesWithTransformAnim.push(t)) : a = nn.RigidBodyDesc.fixed();
            let u = Xi(i);
            (t.hasNonUniformScale ? t.matrixWorldRigid : t.matrixWorld).decompose(Fn, cs, Ta), t.position0 = Fn.clone().divideScalar(this.pixelsPerMeter), t.rotation0 = cs.clone(), Fn.divideScalar(this.pixelsPerMeter), a.setTranslation(Fn.x, Fn.y, Fn.z).setRotation(cs), s ? u?.scale(1 / this.pixelsPerMeter, 1 / this.pixelsPerMeter, 1 / this.pixelsPerMeter) : u?.scale(Ta.x / this.pixelsPerMeter, Ta.y / this.pixelsPerMeter, Ta.z / this.pixelsPerMeter);
            let c = this.sharedGameControlGlobals.rapierWorld.createRigidBody(a);
            l && this.rigidBodyToMesh.set(c.handle, [
                t,
                Ta.clone(),
                o.physics.fusedBody
            ]);
            let d = !(o.geometry === void 0 || o.geometry.type === "SubdivGeometry" || o.geometry.type === "NonParametricGeometry" || o.geometry.type === "BooleanGeometry" || o.geometry.type === "VectorGeometry" || o.geometry.type === "StarGeometry" || o.geometry.type === "RectangleGeometry" || o.geometry.type === "EllipseGeometry" || o.geometry.type === "TriangleGeometry" || o.geometry.type === "TorusGeometry" || o.geometry.type === "HelixGeometry");
            try {
                this.addCollider(c, o.physics, u, n.fromCreate ? void 0 : e, d);
            } catch  {
                try {
                    this.addCollider(c, o.physics, u, n.fromCreate ? void 0 : e, !1);
                } catch (f) {
                    console.error(f);
                }
            }
            t.rigidBody = c;
        }
    }
    addBoundsTree(t) {
        let e = [];
        if ("geometry" in t && t.geometry.getAttribute("position") !== void 0 && e.push(os(t.geometry, t.shearScale)), t.traverseObject(this.gatherChildrenGeom(t, e)), t.children.forEach((n)=>n.updateMatrixWorld(!0)), e.length > 0) {
            let n = Xi(e, !1);
            t.boundsTree = new un(n), this.sharedGameControlGlobals.entitiesWithTransformAnim.push(t);
        }
    }
    addCollider(t, e, n, i, s = !0) {
        if (n?.getAttribute("position").count === 0 || n?.getIndex()?.count === 0) return;
        let o;
        n && (e.colliderType === "trimesh" ? o = nn.ColliderDesc.trimesh(n.getAttribute("position").array, n.getIndex().array) : o = nn.ColliderDesc.convexMesh(n.getAttribute("position").array, s ? n.getIndex().array : void 0)), o.setFrictionCombineRule(nn.CoefficientCombineRule.Average).setRestitutionCombineRule(nn.CoefficientCombineRule.Average).setDensity(e.density).setFriction(e.friction).setRestitution(e.restitution);
        let a = this.sharedGameControlGlobals.rapierWorld.createCollider(o, t);
        i && (this.sharedGameControlGlobals.colliderToEntity[a.handle] = i, this.sharedGameControlGlobals.eventsPerObjects[i.uuid]?.some((l)=>l.target === "scene") && a.setActiveEvents(nn.ActiveEvents.COLLISION_EVENTS));
    }
    gatherChildrenGeom(t, e) {
        return (n, i)=>{
            if (i === 0) return;
            let s;
            if (n instanceof hr) {
                if (n.objectForSample) {
                    if (n.objectForSample.dataPatched.physics.fusedBody) return;
                    s = n.object;
                } else return n.object.dataPatched.physics.fusedBody === !0 && n.object.dataPatched.physics.rigidBody === "dynamic" ? !0 : void 0;
            } else if (n instanceof dn) s = n.object;
            else if (s = n, s.dataPatched.cloner?.hideBase) return !0;
            let o = s.dataPatched;
            if (o.collision === "visibility" ? !o.visible : !o.collision) return !0;
            i === 1 ? t.hasNonUniformScale ? n.matrixWorld.multiplyMatrices(t.shearScale, n.hiddenMatrix) : n.matrixWorld.copy(n.hiddenMatrix) : n.matrixWorld.multiplyMatrices(n.parent.matrixWorld, n.hiddenMatrix), n.matrixWorld.multiply(n.matrix);
            let a = n.geometry;
            a?.getAttribute("position") !== void 0 && e.push(os(a, n.matrixWorld));
        };
    }
    activate(t) {
        this.eventManager = t;
        let e;
        this.collab.scene.publish.playCamera === null ? e = bn.PERSONAL_CAMERA_ID : e = this.collab.scene.publish.playCamera;
        let n = this.scene.find(e), i = !1, s, o = 5, a = 8, l = 9, u = "drag";
        if (this.collab.scene.objects.data(this.collab.scene.publish.gameControlObject ?? "")?.events.forEach((h)=>{
            h.data.disabled !== !0 && h.data.type === "GameControl" && (s = h.data.keyAssignments, o = h.data.joystickPosLoc, a = h.data.joystickRotLoc, l = h.data.jumpTouchButtonLoc, u = h.data.rotByTouch);
        }), this.scene.traverseEntity((h)=>{
            h.dataPatched.events.forEach((f)=>{
                if (f.data.disabled || f.data.type !== "GameControl") return;
                let m = h;
                for(; (m = m.parent)?.parent !== null;)if (m.dataPatched.physics?.fusedBody) return;
                f.data.collisionEnabled && (this.needsCollisionDetection = !0), this.gameControlStates.push([
                    h,
                    f.data
                ]);
            });
        }), this.gameControlStates.forEach(([h, f])=>{
            i = i || f.camera === n.uuid || h.uuid === n.uuid;
            let m = new $f(h, this.renderer.domElement, {
                ...f,
                keyAssignments: s
            }, this.collab.scene.environment, this, h.uuid !== n.uuid && f.camera === n.uuid, n, this.scene, this.sharedAssets);
            this.gameControls.push(m), jn && f.touchControl && (this.joystickToGameControls[o] !== void 0 ? this.joystickToGameControls[o].push([
                m,
                "pos"
            ]) : this.joystickToGameControls[o] = [
                [
                    m,
                    "pos"
                ]
            ], f.moveMode === "walk" && (this.joystickToGameControls[l] !== void 0 ? this.joystickToGameControls[l].push([
                m,
                "jmp"
            ]) : this.joystickToGameControls[l] = [
                [
                    m,
                    "jmp"
                ]
            ]), u === "joystick" && (this.joystickToGameControls[a] !== void 0 ? this.joystickToGameControls[a].push([
                m,
                "rot"
            ]) : this.joystickToGameControls[a] = [
                [
                    m,
                    "rot"
                ]
            ]));
        }), this.collab.scene.objects.data(this.collab.scene.publish.gameControlObject ?? "")?.events.forEach((h)=>{
            if (h.data.disabled !== !0 && h.data.type === "GameControl" && h.data.navmesh.enabled && !this.navigationMeshWrapper) {
                this.navigationMeshWrapper = new rv(this.usePhysics, this.isExport);
                let f;
                h.data.collider.type === "sphere" ? f = h.data.collider.radius * 2 : f = h.data.collider.height, f = Math.floor(f / h.data.navmesh.ch - 1), this.navigationMeshWrapper.init({
                    ...h.data.navmesh,
                    walkableHeight: f
                }, this.gameControls, this.eventContext);
            }
        }), i === !1) {
            let { enableRotate: h , enablePan: f , enableZoom: m , autoRotate: p , hoverRotatePanMode: g  } = this.collab.scene.publish.orbitControls;
            (h || f || m || p || g !== 0) && (this.orbitControls = new Bd(n, this.renderer.domElement, {
                isExport: this.isExport,
                isPlayMode: !0
            }), this.orbitControls.addEventListener("change", this.requestRender), this.orbitControls.addEventListener("end", this.requestRender), this.orbitControls.addEventListener("start", this.requestRender), this.orbitControls.fromJSON(this.collab.scene.publish.orbitControls, this.collab.scene.publish.mouseEventTarget), this.orbitControls.useKeyEvents = !1, this.orbitControls.addEventListenersToCamera(), this.orbitControls.connect(), this.orbitControls.update());
        }
        let c = this.renderer.domElement.width / this.renderer.getPixelRatio(), d = this.renderer.domElement.height / this.renderer.getPixelRatio();
        this.joystickToGameControls.forEach((h, f)=>{
            let m = document.body.appendChild(document.createElement("div")), [p, g, y] = (this.collab.scene.publish.joystickSizeAndXYOffset ?? xo.defaultData.joystickSizeAndXYOffset)[f], v = (c - 5 * p) / 4 + p, x = {}, w = h.some((b)=>b[1] === "jmp"), S = w ? 0 : p;
            f < 10 ? (f < 5 ? x.top = S / 2 : x.bottom = S / 2, x.left = S / 2 + f % 5 * v) : f === 10 ? (x.left = S / 2, x.top = d / 2) : (x.right = S / 2, x.top = d / 2), x.top ? x.top -= g[1] : x.bottom += g[1], x.left ? x.left += g[0] : x.right -= g[0];
            for(let b in x)x[b] += "px";
            if (w) {
                let b = m.appendChild(document.createElement("div"));
                Object.assign(b.style, x, {
                    position: "absolute",
                    width: p + "px",
                    height: p + "px",
                    backgroundColor: `rgba(255,255,255,${y === "show" ? .4 : 0})`,
                    zIndex: "9999",
                    borderRadius: p + "px",
                    border: y === "show" ? "solid 2px rgba(0, 0, 0, .1)" : "none",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    touchAction: "none"
                });
                let T = p / 16 * 6.4;
                y === "show" && (b.innerHTML = `
						<svg width="${T}" height="${p * .4}" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M2 10L8 4L14 10" stroke="black" stroke-opacity="40%" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
						</svg>
					`), b.addEventListener("pointerdown", ()=>{
                    h.forEach((E)=>{
                        E[0].movementState.jump = 1;
                    }), this.requestRender();
                }), b.addEventListener("touchend", (E)=>E.preventDefault()), this.joysticks[f] = [
                    void 0,
                    m
                ];
                return;
            }
            let _ = {
                zone: m,
                mode: "static",
                position: x,
                size: p
            };
            y === "hide" && (_.restOpacity = 0);
            let M = C2.create(_);
            M.on("move", (b, T)=>{
                h.forEach((E)=>{
                    let P = E[0];
                    E[1] === "pos" ? T.force < .2 ? P.moveForce = 0 : (P.movementState.movePosZ = Math.sin(-T.angle.radian), P.movementState.movePosX = Math.cos(-T.angle.radian), T.force < .3 ? P.moveForce = (T.force - .2) / .1 : P.moveForce = 1) : T.force < .2 ? P.rotForce = 0 : (P.movementState.rotPosX = T.vector.y, P.movementState.rotPosY = -T.vector.x, T.force < .3 ? P.rotForce = (T.force - .2) / .1 : P.rotForce = 1);
                }), this.requestRender();
            }), M.on("end", (b, T)=>{
                h.forEach((E)=>{
                    let P = E[0];
                    E[1] === "pos" ? (P.movementState.movePosZ = 0, P.movementState.movePosX = 0, P.moveForce = 1) : (P.movementState.rotPosX = 0, P.movementState.rotPosY = 0, P.rotForce = 1);
                });
            }), this.joysticks[f] = [
                M,
                m
            ];
        }), this.markIsDestroyTarget(), this.markIsDragObject(), this.usePhysics && (this.gameControlStates.length === 0 || this.needsCollisionDetection) && this.initPhysics(), this.usePhysics === !1 && this.needsCollisionDetection && this.initBVH(), this.initializationCounter++, window.setTimeout(()=>this.collisionEvents.forEach((h)=>h.disabled = !1), 80);
    }
    initPhysics() {
        this.sharedGameControlGlobals.rapierWorld = new nn.World(new nn.Vector3(0, this.gravity, 0)), this.events = new nn.EventQueue(!0);
        let t = [];
        if (this.scene.traverseObject((o)=>{
            let a;
            if (o instanceof hr) {
                if (o.objectForSample) {
                    if (o.objectForSample.dataPatched.physics.fusedBody) return;
                    a = o.object;
                } else return o.object.dataPatched.physics.fusedBody === !0 && o.object.dataPatched.physics.rigidBody === "dynamic" ? !0 : void 0;
            } else if (o instanceof dn) a = o.object;
            else if (a = o, a.dataPatched.cloner?.disabled === !1 && a.dataPatched.cloner?.hideBase && a.dataPatched.physics?.fusedBody !== !0) return !0;
            let l = a.dataPatched;
            if (!l.physics || (l.collision === "visibility" ? !l.visible : !l.collision)) return !0;
            o.updateMatrixWorldSVD();
            let u = Jf(l), c, d = !1, h = a.userData.hasDestroy, f = a.userData.hasDrag, m = !1;
            for (let g of l.events)if (g.data.disabled !== !0) {
                if (g.data.type === "GameControl") c = g.data;
                else if (g.data.type === "Collision") {
                    d = !0;
                    let y = new nv(g.id, g.data, a, this.scene, this.sharedAssets, {
                        controlsManager: this,
                        eventManager: this.eventManager
                    });
                    this.collisionEvents.push(y), this.sharedGameControlGlobals.eventsPerObjects[a.uuid] && this.sharedGameControlGlobals.eventsPerObjects[a.uuid].every((v)=>v.id !== g.id) ? this.sharedGameControlGlobals.eventsPerObjects[a.uuid].push(y) : this.sharedGameControlGlobals.eventsPerObjects[a.uuid] = [
                        y
                    ];
                } else if (g.data.type === "Follow") {
                    m = !0;
                    let y = g.data.target;
                    o.traverseVisible((v)=>{
                        v.userData.isFollowingObj = y;
                    });
                }
            }
            l.physics.rigidBody === "dynamic" && l.physics.fusedBody === !1 && (o.matrixWorldFusedFalse = o.matrixWorld.clone());
            let p = o.geometry;
            if (c !== void 0) {
                let g = nn.RigidBodyDesc.kinematicPositionBased();
                (o.hasNonUniformScale ? o.matrixWorldRigid : o.matrixWorld).decompose(Fn, cs, Ta), o.position0 = Fn.clone().divideScalar(this.pixelsPerMeter), o.rotation0 = cs.clone(), Fn.divideScalar(this.pixelsPerMeter), g.setTranslation(Fn.x, Fn.y, Fn.z).setRotation(cs);
                let y = this.sharedGameControlGlobals.rapierWorld.createRigidBody(g);
                o.rigidBody = y;
                let v;
                c.collider.type === "sphere" ? v = nn.ColliderDesc.ball(c.collider.radius / this.pixelsPerMeter) : c.collider.type === "capsule" ? v = nn.ColliderDesc.capsule((c.collider.height / 2 - c.collider.radius) / this.pixelsPerMeter, c.collider.radius / this.pixelsPerMeter) : v = nn.ColliderDesc.cuboid(c.collider.width / this.pixelsPerMeter / 2, c.collider.height / this.pixelsPerMeter / 2, c.collider.depth / this.pixelsPerMeter / 2), v.setFrictionCombineRule(nn.CoefficientCombineRule.Average).setRestitutionCombineRule(nn.CoefficientCombineRule.Average).setDensity(l.physics.density).setFriction(l.physics.friction).setRestitution(l.physics.restitution);
                let x = this.sharedGameControlGlobals.rapierWorld.createCollider(v, y);
                this.sharedGameControlGlobals.colliderToEntity[x.handle] = a, Fn.fromArray(c.collider.position).multiply(Ta.setFromMatrixScale(a.matrixWorld)).divideScalar(this.pixelsPerMeter), x.setTranslationWrtParent(Fn);
                let w = new Je().setFromEuler(new Wt().setFromVector3(new A().fromArray(c.collider.rotation)));
                x.setRotationWrtParent(w), x.setActiveEvents(nn.ActiveEvents.COLLISION_EVENTS);
            } else l.physics.rigidBody === "dynamic" || u || m || h || f || d ? this.addRigidBody(o, a, {
                hasFollow: m,
                hasTransformAnim: u,
                hasDrag: f
            }) : (p && t.push(os(p, o.matrixWorld)), l.physics.fusedBody && o.traverseObject((g, y)=>{
                if (y === 0) return;
                let v;
                if (g instanceof hr) {
                    if (g.objectForSample) {
                        if (g.objectForSample.dataPatched.physics.fusedBody) return;
                        v = g.object;
                    } else return g.object.dataPatched.physics.fusedBody === !0 && g.object.dataPatched.physics.rigidBody === "dynamic" ? !0 : void 0;
                } else if (g instanceof dn) v = g.object;
                else if (v = g, v.dataPatched.cloner?.hideBase) return !0;
                let x = v.dataPatched;
                if (x.collision === "visibility" ? !x.visible : !x.collision) return !0;
                let w = g.geometry;
                w?.getAttribute("position") !== void 0 && t.push(os(w, g.matrixWorld));
            }));
            if (l.physics?.fusedBody === !0 || c) return !0;
        }), t.length === 0) return;
        let e = Xi(t);
        e.scale(1 / this.pixelsPerMeter, 1 / this.pixelsPerMeter, 1 / this.pixelsPerMeter);
        let n = nn.RigidBodyDesc.fixed(), i = this.sharedGameControlGlobals.rapierWorld.createRigidBody(n), s = nn.ColliderDesc.trimesh(e.getAttribute("position").array, e.getIndex().array).setFrictionCombineRule(nn.CoefficientCombineRule.Multiply).setRestitutionCombineRule(nn.CoefficientCombineRule.Multiply).setFriction(1).setRestitution(1);
        this.sharedGameControlGlobals.rapierWorld.createCollider(s, i);
    }
    updatePositions() {
        return this.nActiveRigidBodies = 0, this.sharedGameControlGlobals.rapierWorld.forEachRigidBody(this.processRigidBody), this.nActiveRigidBodies > 0;
    }
    rebuildBVH() {
        this.usePhysics ? (this.sharedGameControlGlobals.rapierWorld?.free(), this.initPhysics()) : (this.sharedGameControlGlobals.staticMeshBVH = void 0, this.initBVH());
    }
    disconnectCollisionEvents() {
        this.collisionEvents.forEach((t)=>t.disconnect());
    }
    deactivate() {
        this.scene.traverse((t)=>{
            let e = t;
            e.matrixWorldFusedFalse && (e.matrixWorldFusedFalse = void 0), e.rigidBody && (e.rigidBody = void 0), e.position0 && (e.position0 = void 0), e.rotation0 && (e.rotation0 = void 0);
        }), this.sharedGameControlGlobals.rapierWorld?.free(), this.sharedGameControlGlobals.rapierWorld = void 0, this.sharedGameControlGlobals.staticMeshBVH = void 0, this.sharedGameControlGlobals.entitiesWithTransformAnim = [], this.disconnectCollisionEvents(), this.gameControls.forEach((t)=>{
            t.reset(), t.dispose();
        }), this.gameControls = [], this.joysticks.forEach(([t, e])=>{
            t?.destroy(), e.remove();
        }), this.joystickToGameControls = [], this.joysticks = [], this.orbitControls && (this.orbitControls.dispose(), this.orbitControls = void 0), this.navigationMeshWrapper?.dispose();
        for (let t of Object.values(this.sharedGameControlGlobals.eventsPerObjects))t.forEach((e)=>e.disconnect());
        this.sharedGameControlGlobals.eventsPerObjects = {}, this.scene.updateMatrixWorld(!0);
    }
    update(t, e, n) {
        let i = !0;
        if (this.orbitControls !== void 0 && this.orbitControls.needsUpdate && (i = !this.orbitControls.update()), this.initializationCounter >= 0 && this.initializationCounter < 2) this.initializationCounter++, i = !1;
        else if (this.initializationCounter === 2) for (let s of this.gameControls)i = !s.update(t, e, n) && i;
        if (this.usePhysics) {
            for (let s of this.sharedGameControlGlobals.entitiesWithTransformAnim){
                (s.hasNonUniformScale ? s.matrixWorldRigid : s.matrixWorld).decompose(Fn, cs, Ta), MS.setFromQuaternion(cs);
                let o = s;
                o.prevR === void 0 ? (o.prevR = MS.clone(), o.prevT = Fn.clone()) : (o.prevR.copy(MS), o.prevT.copy(Fn)), s.rigidBody.setNextKinematicTranslation(Fn.divideScalar(this.pixelsPerMeter)), s.rigidBody.setNextKinematicRotation(cs);
            }
            this.sharedGameControlGlobals.rapierWorld.step(this.events), this.events?.drainCollisionEvents(this.handleCollisionEvents), i = !this.updatePositions() && i;
        }
        return i;
    }
    dispatchCollisionEvent(t, e, n) {
        let i = this.sharedGameControlGlobals.rapierWorld?.getCollider(n)._parent, s;
        if (e.cloner) {
            for (let o of e.cloner.children)if (o.rigidBody === i) {
                s = o;
                break;
            }
        }
        t.dispatch(s), e.dispatchEvent(TS);
    }
    updateUseWindowEvents(t) {
        this.orbitControls?.updateUseWindowEvents(t);
    }
};
var uEe = new A, BD = new A, FD = new A, L6 = new A, Jr = new A, $r = new A, Ea = new A, ES = new ae, UD = new ae, N6 = new ae, dEe = new ae, us = new Je, Lo = new Je, Hs = new Wt(0, 0, 0, "YXZ"), B6 = new A(1, 0, 0), ds = new A(0, 1, 0), F6 = new A(0, 0, 1), kD = new A(1, 1, 1), U6 = 1, k6 = .025, z6 = 16e-6, zD = 12, G6 = 20, Tr = new Hn, Oi = new Mt, V6 = {
    type: "requestRender"
}, GD = Math.PI / 6, sv = class extends Ht {
    constructor(e, n, i, s, o, a, l, u, c){
        super();
        this.object = e;
        this.domElement = n;
        this.controlsManager = o;
        this.cameraFollow = a;
        this.camera = l;
        this.scene = u;
        this.sharedAssets = c;
        this.enableDamping = !0;
        this.position0 = new A;
        this.rotation0 = new Wt(0, 0, 0, "XYZ");
        this.scale0 = new A;
        this.hiddenMatrix0 = new ae;
        this.target0 = new A;
        this.zoom0 = 1;
        this.rotForce = 1;
        this.moveForce = 1;
        this.euler0 = new Wt(0, 0, 0, "YXZ");
        this.position0Cam = new A;
        this.quat0Cam = new Je;
        this.scale0Cam = new A;
        this.hiddenMatrix0Cam = new ae;
        this.threshEndTranslate = .01;
        this.threshEndRotate = 1e-8;
        this.threshEndRotVel = .005;
        this.collider = {
            type: "capsule",
            radius: 40,
            segment: new Hn(new A(0, -40, 0), new A(0, 40, 0)),
            matrix: new ae,
            position: new A,
            rotation: new Je
        };
        this.euler = new Wt(0, 0, 0, "YXZ");
        this.eulerDelta = new A;
        this.lastPosition = new A;
        this.lastCameraQuaternion = new Je;
        this.lastCameraPosition = new A;
        this.PI_2 = Math.PI / 2;
        this.prevMouse = new F;
        this.velocityTarget = new A;
        this.velocity = new A;
        this.directionXZ = new A;
        this.rotVelocityStick = new A;
        this.rotVelocityTarget = new A;
        this.rotVelocity = new A;
        this.rotDirection = new A;
        this.nonColliderRotOffset = new ae;
        this.nonColliderPosOffset = new ae;
        this.firstPointerId = -1;
        this.rot = new A;
        this.path = [];
        this.movementState = {
            moveNegZ: 0,
            movePosZ: 0,
            moveNegX: 0,
            movePosX: 0,
            moveNegY: 0,
            movePosY: 0,
            rotPosX: 0,
            rotNegX: 0,
            rotPosY: 0,
            rotNegY: 0,
            jump: 0
        };
        this.vrEulerYOffset = 0;
        this.onObject = !1;
        this.actionState = {};
        this.keyAssignments = [
            [
                "moveNegZ",
                "W"
            ],
            [
                "moveNegX",
                "A"
            ],
            [
                "movePosZ",
                "S"
            ],
            [
                "movePosX",
                "D"
            ],
            [
                "rotPosX",
                "ArrowUp"
            ],
            [
                "rotPosY",
                "ArrowLeft"
            ],
            [
                "rotNegX",
                "ArrowDown"
            ],
            [
                "rotNegY",
                "ArrowRight"
            ],
            [
                "jump",
                " "
            ]
        ];
        this.collisionEnabled = !0;
        this.offsetMatrix = new ae;
        this.objectToTarget = new A;
        this.objectToTarget0 = new A;
        this.objectToCamXZ = new A;
        this.objectToCamXZ0 = new A;
        this.targetToCamera = new A;
        this.targetToCamera0 = new A;
        this.cameraPolarAxis0 = new A;
        this.targetPos = new A;
        this.targetQuat = new Je;
        this.lerpFactorPos = new A().setScalar(.3);
        this.lerpFactorPosStart = .3;
        this.lerpFactorPosEnd = .3;
        this.lerpFactorRotStart = .3;
        this.lerpFactorRotEnd = .3;
        this.lerpFactorPosCamera = .3;
        this.lerpFactorRotCamera = .3;
        this.objXZQuat = new Je;
        this.objXZQuatInv = new Je;
        this.objXZRotMat = new ae;
        this.isFirstPerson = !1;
        this.actions = {};
        this.didHit = !1;
        this.groundVelocity = new A;
        this.pushedVelocity = new A;
        this.groundYRotation = 0;
        this.objectRealQuat = new Je;
        this.colliderWorldQuat = new Je;
        this.groundNormal = new A;
        this.groundTilt = new Je;
        this.groundTiltInv = new Je;
        this.lastHitObj = null;
        this.isFirstFrame = !0;
        this.rotationAccumWhenOrientWithCamera = 0;
        this.navMeshPathDest = null;
        this.onPointerDown = (e)=>{
            e.target !== this.domElement || this.firstPointerId !== -1 || (this.firstPointerId = e.pointerId, this.domElement.ownerDocument.addEventListener("pointermove", this.onPointerMove), this.domElement.ownerDocument.addEventListener("pointerup", this.onPointerUp), this.rotBy !== "keys" && !jn && (!Sx || Ax >= 15.5) && this.domElement.requestPointerLock(), this.prevMouse.set(e.clientX, e.clientY));
        };
        this.onPointerUp = (e)=>{
            this.firstPointerId = -1, this.domElement.ownerDocument.removeEventListener("pointermove", this.onPointerMove), this.domElement.ownerDocument.removeEventListener("pointerup", this.onPointerUp), e.pointerType === "mouse" && this.domElement.ownerDocument.exitPointerLock();
        };
        this.onPointerMove = (e)=>{
            if (e.pointerId !== this.firstPointerId) return;
            let n = e.clientX - this.prevMouse.x, i = e.clientY - this.prevMouse.y;
            this.prevMouse.set(e.clientX, e.clientY), e.pointerType === "mouse" && this.rotBy !== "keys" && (Sx && Ax < 15.5 && !jn ? (this.eulerDelta.y = -n * this.mouseOrbitSensitivity, this.eulerDelta.x = -i * this.mouseOrbitSensitivity) : (this.eulerDelta.y = -e.movementX * this.mouseOrbitSensitivity, this.eulerDelta.x = -e.movementY * this.mouseOrbitSensitivity)), e.pointerType !== "mouse" && this.rotByTouch === "drag" && (this.eulerDelta.y = -n * this.mouseOrbitSensitivity * 5, this.eulerDelta.x = -i * this.mouseOrbitSensitivity * 5), this.controlsManager.requestRender();
        };
        this.onPointerlockChange = (e)=>{
            this.domElement.ownerDocument.pointerLockElement === this.domElement ? sv.isLocked = !0 : sv.isLocked = !1;
        };
        this.onPointerlockError = ()=>{
            console.error("SPE.GameControls: Unable to use Pointer Lock API");
        };
        this.onKeyDown = (e)=>{
            !(e.target instanceof HTMLInputElement) && (e.code === "ArrowLeft" || e.code === "ArrowUp" || e.code === "ArrowRight" || e.code === "ArrowDown" || e.code === "Space") && e.preventDefault();
            for (let n of this.keyAssignments)if (e.key.toUpperCase() === n[1] || e.key === n[1]) {
                this.movementState[n[0]] = 1;
                break;
            }
            this.controlsManager.requestRender();
        };
        this.onKeyUp = (e)=>{
            for (let n of this.keyAssignments)if (e.key.toUpperCase() === n[1] || e.key === n[1] || e.code.slice(3, e.code.length).toUpperCase() === n[1]) {
                this.movementState[n[0]] = 0;
                break;
            }
        };
        this.copyVRGamePadValues = (e, n)=>{
            for(let i = 2; i < 4; i++){
                let s = e.axes[i];
                n === 0 ? i === 2 ? this.movementState.movePosX = s : this.movementState.movePosZ = s : (e.buttons[3].pressed ? this.movementState.jump = 1 : this.movementState.jump = 0, i === 2 ? (Math.abs(this.movementState.rotPosY) < .3 && Math.abs(s) >= .3 && (this.vrEulerYOffset += s < 0 ? 1 : -1), this.movementState.rotPosY = s) : this.moveMode === "fly" && (this.movementState.moveNegY = s));
            }
        };
        this.sharedGameControlGlobals = o.sharedGameControlGlobals, e === l && (this.isFirstPerson = !0), this.position0.copy(this.object.position), this.rotation0.copy(this.object.rotation), this.scale0.copy(this.object.scale), this.hiddenMatrix0.copy(this.object.hiddenMatrix), this.object.parent ? this.object.hiddenMatrix.copy(this.object.parent.matrixWorld).invert() : this.object.hiddenMatrix.identity(), this.object.matrix.copy(this.object.matrixWorld), this.object.matrix.decompose(this.object.position, this.object.quaternion, this.object.scale), this.object.rotation.reorder("YXZ"), this.euler0.copy(this.object.rotation);
        let d = this.object.rotation.y;
        if (this.objectRealQuat.copy(this.object.quaternion), this.object.rotation.y = 0, this.objXZQuat.copy(this.object.quaternion), this.objXZQuatInv.copy(this.objXZQuat).invert(), this.objXZRotMat.makeRotationFromQuaternion(this.object.quaternion), this.object.rotation.set(0, d, 0), this.rot.setFromEuler(this.object.rotation), this.object.matrixAutoUpdate = !1, (this.isFirstPerson || this.cameraFollow === !0) && (this.target0.copy(this.camera.getTarget()), this.zoom0 = this.camera.zoom), this.cameraFollow === !0) {
            this.position0Cam.copy(this.camera.position), this.quat0Cam.copy(this.camera.quaternion), this.scale0Cam.copy(this.camera.scale), this.hiddenMatrix0Cam.copy(this.camera.hiddenMatrix), this.camera.parent ? (this.camera.hiddenMatrix.copy(this.camera?.parent.matrixWorld), this.camera.matrix.copy(this.camera.matrixWorld)) : this.camera.hiddenMatrix.identity(), this.camera.matrix.copy(this.camera.matrixWorld), this.camera.matrix.decompose(this.camera.position, this.camera.quaternion, this.camera.scale), this.camera.matrixAutoUpdate = !1, this.offsetMatrix.copy(this.object.matrix).invert().multiply(this.camera.matrix);
            let y = new A(0, 0, -1).applyQuaternion(this.camera.quaternion), v = new A().subVectors(this.object.position, this.camera.position);
            this.objectToCamXZ.copy(v), this.objectToCamXZ.y = 0, this.objectToCamXZ0.copy(this.objectToCamXZ);
            let x, w;
            Math.abs(y.y) < 1e-6 ? (v.y = 0, y.y = 0, w = v.projectOnVector(y)) : v.y / y.y > 0 ? w = y.multiplyScalar(v.y / y.y) : w = y.multiplyScalar(v.length()), this.targetToCamera0.copy(w).negate(), x = this.camera.position.clone().add(w), this.objectToTarget0.subVectors(x, this.object.position);
            let S = new Wt().setFromQuaternion(this.camera.quaternion, "YXZ");
            this.cameraPolarOffset = -S.x, S.x = 0, S.z = 0, S.y -= Math.PI / 2, this.cameraPolarAxis0.set(0, 0, -1).applyEuler(S);
        }
        if (this.object instanceof Yt && (this.object.matrixAutoUpdate = !1), this.euler.setFromQuaternion(this.object.quaternion, "YXZ"), this.connect(), this.rotByTouch = i.rotByTouch ?? "joystick", this.rotBy = i.rotBy ?? "keys", this.rotationMode = i.rotationMode ?? "normal", this.moveMode = i.moveMode ?? "walk", this.collisionEnabled = i.collisionEnabled, this.speedTranslate = (i.speedTranslate ?? 250) * U6, this.speedOrbit = (i.speedRotate ?? 100) * k6, this.mouseOrbitSensitivity = (i.speedRotate ?? 100) * z6, this.keyAssignments = i.keyAssignments.map((y)=>{
            let v = [
                y[0],
                y[1]
            ];
            return v[1] === "▲" ? v[1] = "ArrowUp" : v[1] === "◀" ? v[1] = "ArrowLeft" : v[1] === "▼" ? v[1] = "ArrowDown" : v[1] === "▶" ? v[1] = "ArrowRight" : v[1] === "⇧" ? v[1] = "Shift" : v[1] === "↵" ? v[1] = "Enter" : v[1] === "Space" ? v[1] = " " : v[1] === "⌘" ? v[1] = "Meta" : v[1] === "Ctrl" ? v[1] = "Control" : v[1] === "Esc" && (v[1] = "Escape"), v;
        }), i.rotBy === "mouse") {
            let y;
            y = this.keyAssignments.findIndex((v)=>v[0] === "rotNegX"), y !== -1 && (this.keyAssignments[y][1] = ""), y = this.keyAssignments.findIndex((v)=>v[0] === "rotPosX"), y !== -1 && (this.keyAssignments[y][1] = ""), y = this.keyAssignments.findIndex((v)=>v[0] === "rotPosY"), y !== -1 && (this.keyAssignments[y][1] = ""), y = this.keyAssignments.findIndex((v)=>v[0] === "rotNegY"), y !== -1 && (this.keyAssignments[y][1] = "");
        }
        this.lerpFactorPosStart = 1 - .02 ** (1 / ((i.delayPos[0] ?? .3) * 60)), this.lerpFactorPosEnd = 1 - .02 ** (1 / ((i.delayPos[1] ?? .3) * 60)), this.lerpFactorPos.setScalar(this.lerpFactorPosStart), this.lerpFactorRotStart = 1 - .02 ** (1 / ((i.delayRot[0] ?? .3) * 60)), this.lerpFactorRotEnd = 1 - .02 ** (1 / ((i.delayRot[1] ?? .3) * 60)), this.lerpFactorPosCamera = 1 - .02 ** (1 / ((i.delayPosCamera ?? .3) * 60)), this.lerpFactorRotCamera = 1 - .02 ** (1 / ((i.delayRotCamera ?? .3) * 60)), this.gravity = (s.gravity ?? Fr.defaultData.gravity) * zD, this.pixelsPerMeter = s.pixelsPerMeter ?? Fr.defaultData.pixelsPerMeter, this.usePhysics = s.usePhysics ?? Fr.defaultData.usePhysics, this.jumpPower = i.jumpPower * G6, this.resetYPosition = this.object.position.y + Math.abs(i.resetYPosition) * (this.gravity > 0 ? 1 : -1), this.alignToGround = i.alignToGround ?? !1, this.orientMode = i.autoOrientMove ? i.orientMode : "none", this.orientWith = i.orientWith ?? yu.defaultDataThirdPerson.orientWith;
        let h = s.skinWidthRelative ?? Fr.defaultData.skinWidthRelative, f = s.stepThreshRelative ?? Fr.defaultData.stepThreshRelative;
        this.slopeThresh = (s.slopeThresh ?? Fr.defaultData.slopeThresh) * Math.PI / 180, i.collider.type === "capsule" ? (this.collider.radius = i.collider.radius, this.collider.segment.start.y = i.collider.height / 2 - i.collider.radius, this.collider.segment.end.y = -this.collider.segment.start.y, this.offset = i.collider.height * h / this.pixelsPerMeter, this.stepThresh = i.collider.height * f / this.pixelsPerMeter, this.colliderHeight = i.collider.height) : i.collider.type === "sphere" ? (this.collider.radius = i.collider.radius, this.collider.segment.start.y = 0, this.collider.segment.end.y = 0, this.offset = 2 * i.collider.radius * h / this.pixelsPerMeter, this.stepThresh = 2 * i.collider.radius * f / this.pixelsPerMeter, this.colliderHeight = i.collider.radius * 2) : (this.offset = i.collider.height * h / this.pixelsPerMeter, this.stepThresh = i.collider.height * f / this.pixelsPerMeter, this.colliderHeight = i.collider.height), this.collider.type = i.collider.type;
        let m = new A().fromArray(i.collider.position), p = new Je().setFromEuler(new Wt().fromArray([
            ...i.collider.rotation,
            "XYZ"
        ]));
        this.collider.position.copy(m).multiply(this.object.scale), this.collider.rotation.copy(p), this.collider.matrix.compose(m, p, kD), i.cameraXAxis !== void 0 && (this.cameraXAxis = i.cameraXAxis, this.cameraYAxis = i.cameraYAxis, this.minPolarAngle = i.cameraRotXLimits[0], this.maxPolarAngle = i.cameraRotXLimits[1], this.minAzimuthAngleRel = i.cameraRotYLimits[0], this.maxAzimuthAngleRel = i.cameraRotYLimits[1]), i.gameActions !== void 0 && Object.entries(i.gameActions).forEach(([y, v], x)=>{
            v.forEach(({ id: w , data: S  })=>{
                try {
                    this.actions[y] === void 0 && (this.actions[y] = []), S.type === "Transition" ? this.actions[y].push(new Do(S, u, c)) : S.type === "Audio" ? this.actions[y].push(new Eo(w, S, e, c)) : S.type === "Video" ? this.actions[y].push(new Bl(w, S, e)) : S.type === "Create" && this.actions[y].push(new Co(S, u, this.controlsManager));
                } catch  {}
            });
        }), this.dispatchStopEvent("move"), this.dispatchStopEvent("jump"), this.dispatchStartEvent("idle");
        let g = i.navmesh.destinationHelperRadius * 2;
        g > 0 && (this.navMeshPathDest = new In(Lg.create({
            parameters: {
                width: g,
                height: g / 10,
                hollow: .7
            }
        }), new Ui({
            color: Nn.toHex(i.navmesh.destinationHelperColor),
            transparent: !0,
            opacity: i.navmesh.destinationHelperColor.a
        })), this.navMeshPathDest.material.userData.opacity0 = i.navmesh.destinationHelperColor.a);
    }
    reset(e = !1) {
        if (this.object.rotation.copy(this.rotation0), this.object.position.copy(this.position0), this.object.scale.copy(this.scale0), this.object.hiddenMatrix.copy(this.hiddenMatrix0), e === !0) {
            this.object.updateMatrix(), this.object.updateMatrixWorld(), this.object.matrix.copy(this.object.matrixWorld), this.object.matrix.decompose(this.object.position, this.object.quaternion, this.object.scale), this.object.parent ? this.object.hiddenMatrix.copy(this.object.parent.matrixWorld).invert() : this.object.hiddenMatrix.identity(), this.object.rotation.reorder("YXZ");
            let n = this.object.rotation.y;
            this.object.rotation.y = 0, this.objXZQuat.copy(this.object.quaternion), this.objXZQuatInv.copy(this.objXZQuat).invert(), this.objXZRotMat.makeRotationFromQuaternion(this.object.quaternion), this.object.rotation.set(0, n, 0), this.rot.setFromEuler(this.object.rotation), this.euler.setFromQuaternion(this.object.quaternion, "YXZ"), this.velocityTarget.set(0, 0, 0), this.velocity.set(0, 0, 0);
        }
        e === !1 && (this.object instanceof Yt ? this.object.matrixAutoUpdate = !0 : this.object.updateMatrix()), this.cameraFollow === !0 && (this.camera.quaternion.copy(this.quat0Cam), this.camera.position.copy(this.position0Cam), this.camera.scale.copy(this.scale0Cam), this.camera.hiddenMatrix.copy(this.hiddenMatrix0Cam), this.camera.matrixAutoUpdate = !0), this.controlsManager.requestRender();
    }
    connect() {
        this.domElement.ownerDocument.addEventListener("pointerdown", this.onPointerDown), this.domElement.ownerDocument.addEventListener("keydown", this.onKeyDown), this.domElement.ownerDocument.addEventListener("keyup", this.onKeyUp), this.domElement.ownerDocument.addEventListener("pointerlockchange", this.onPointerlockChange), this.domElement.ownerDocument.addEventListener("pointerlockerror", this.onPointerlockError);
    }
    disconnect() {
        this.domElement.ownerDocument.removeEventListener("pointerdown", this.onPointerDown), this.domElement.ownerDocument.removeEventListener("keydown", this.onKeyDown), this.domElement.ownerDocument.removeEventListener("keyup", this.onKeyUp), this.domElement.ownerDocument.removeEventListener("pointerlockchange", this.onPointerlockChange), this.domElement.ownerDocument.removeEventListener("pointerlockerror", this.onPointerlockError);
    }
    dispose() {
        this.disconnect(), this.disposeActions(), this.navMeshPathDest?.parent && this.scene.remove(this.navMeshPathDest);
    }
    disposeActions() {
        this.dispatchStopEvent("idle"), this.dispatchStopEvent("move"), this.dispatchStopEvent("jump"), An(this.actions);
    }
    dispatchStartEvent(e) {
        this.actions[e] !== void 0 && (this.actionState[e] || (this.actionState[e] = !0, this.actions[e].forEach((n)=>{
            n instanceof Do ? n.play() : n instanceof Co ? n.dispatchStart() : n instanceof Eo && n.dispatchGameControl("start");
        })));
    }
    dispatchStopEvent(e) {
        this.actions[e] !== void 0 && (!this.actionState[e] || (this.actionState[e] = !1, this.actions[e].forEach((n)=>{
            n instanceof Do ? (n.stop(), n.object.currentState !== null && n.object.changeSelectedState(null, {
                scene: this.scene,
                shared: this.sharedAssets
            })) : n instanceof Co ? n.dispatchStop() : n instanceof Eo && n.dispatchGameControl("stop");
        })));
    }
    get colliderWorldPosition() {
        return Jr.copy(this.collider.position).applyQuaternion(this.objectRealQuat).add(this.object.position);
    }
    update(e, n, i) {
        if (this.gravity < 0 ? this.object.position.y < this.resetYPosition : this.object.position.y > this.resetYPosition) return this.reset(!0), !0;
        this.sharedGameControlGlobals.gamePads.forEach(this.copyVRGamePadValues);
        let s = (this.isFirstFrame ? 16.6 : e) / 1e3;
        this.isFirstFrame && (this.isFirstFrame = !1);
        let o = s * 60, a = !1;
        if (this.usePhysics && this.collisionEnabled) {
            let u = $r.set(0, (this.velocity.y === 0 ? this.pixelsPerMeter * Math.max(Math.abs(this.gravity) / (10 * zD), 1) * (this.gravity > 0 ? 1 : -1) : this.velocity.y) * s, 0).divideScalar(this.pixelsPerMeter), c = this.sharedGameControlGlobals.rapierWorld.castShape(this.colliderWorldPosition.divideScalar(this.pixelsPerMeter), this.colliderWorldQuat, u, this.object.rigidBody?.collider(0).shape, 1, !1, void 0, void 0, void 0, this.object.rigidBody);
            if (c) {
                this.onObject = !0, this.groundNormal.set(c.normal2.x, c.normal2.y, c.normal2.z).applyQuaternion(this.colliderWorldQuat).negate(), this.alignToGround && this.groundTiltAdjustment(this.groundNormal), Math.acos(this.groundNormal.y) < this.slopeThresh && (a = !0), c.collider.parent()?.bodyType() === 0 && Math.acos(this.groundNormal.y) * (180 / Math.PI) > 45 && (this.onObject = !1);
                let d = c.collider.parent();
                this.groundYRotation = 0, this.groundVelocity.set(0, 0, 0);
                for (let h of this.sharedGameControlGlobals.entitiesWithTransformAnim)if (h.rigidBody === d && h.userData.isFollowingObj !== this.object.uuid) {
                    (h.hasNonUniformScale ? h.matrixWorldRigid : h.matrixWorld).decompose(Jr, Lo, $r), this.groundVelocity.subVectors(Jr, h.prevT), this.object.getWorldPosition($r).add(this.collider.position).sub(h.position), this.groundYRotation = Hs.setFromQuaternion(Lo).y - h.prevR.y, Ea.copy($r).applyAxisAngle(ds, this.groundYRotation), this.groundVelocity.add(Ea.sub($r)).divideScalar(s);
                    break;
                }
            } else this.onObject = !1;
        }
        if (this.moveMode === "walk" && this.collisionEnabled && (this.movementState.jump === 1 && this.onObject && (this.velocityTarget.y = this.jumpPower, this.movementState.jump = 0, this.dispatchStopEvent("idle"), this.dispatchStopEvent("move"), this.dispatchStopEvent("jump"), this.dispatchStartEvent("jump"), this.onObject = !1), this.onObject ? this.velocityTarget.y /= 2 : this.velocityTarget.y += this.gravity * o), this.moveMode === "fly" && (this.velocityTarget.y = (this.movementState.movePosY - this.movementState.moveNegY) * this.speedTranslate), this.directionXZ.z = this.movementState.movePosZ - this.movementState.moveNegZ, this.directionXZ.x = this.movementState.movePosX - this.movementState.moveNegX, this.directionXZ.manhattanLength() > 0 && (this.path = []), this.navMeshPathDest) {
            let u = this.navMeshPathDest.material;
            if (this.moveMode === "walk" && this.path.length > 1) {
                this.navMeshPathDest.position.copy(this.path[this.path.length - 1]), this.navMeshPathDest.parent || this.scene.add(this.navMeshPathDest);
                let c = Jr.subVectors(this.path[1], this.object.position), d = $r.subVectors(this.path[1], this.path[0]);
                c.dot(d) < 0 ? this.path.shift() : (this.directionXZ.x = d.x, this.directionXZ.z = d.z), u.opacity = u.userData.opacity0;
            } else u.opacity -= .05 * u.userData.opacity0, this.navMeshPathDest.material.opacity <= 0 && this.navMeshPathDest.parent && this.scene.remove(this.navMeshPathDest);
        }
        this.directionXZ.normalize(), this.velocityTarget.z = this.directionXZ.z * this.speedTranslate * this.moveForce, this.velocityTarget.x = this.directionXZ.x * this.speedTranslate * this.moveForce, (this.moveMode === "walk" ? this.velocityTarget.x + this.velocityTarget.z === 0 : this.velocityTarget.manhattanLength() === 0) ? this.lerpFactorPos.setScalar(this.lerpFactorPosEnd) : this.lerpFactorPos.setScalar(this.lerpFactorPosStart), this.moveMode === "walk" && (this.lerpFactorPos.y = 1), this.didHit === !1 && this.pushedVelocity.manhattanLength() === 0 || this.usePhysics === !1 ? (this.velocity.x += (this.velocityTarget.x - this.velocity.x) * (1 - (1 - this.lerpFactorPos.x) ** o), this.velocity.y += (this.velocityTarget.y - this.velocity.y) * (1 - (1 - this.lerpFactorPos.y) ** o), this.velocity.z += (this.velocityTarget.z - this.velocity.z) * (1 - (1 - this.lerpFactorPos.z) ** o)) : this.velocity.copy(this.velocityTarget), (this.moveMode === "walk" ? this.velocity.x ** 2 + this.velocity.z ** 2 < this.speedTranslate : this.velocity.lengthSq() < this.speedTranslate) ? (this.dispatchStopEvent("move"), this.onObject && (this.dispatchStopEvent("jump"), this.dispatchStartEvent("idle"))) : (this.dispatchStopEvent("idle"), this.onObject && (this.dispatchStopEvent("jump"), this.dispatchStartEvent("move")));
        let l = L6.copy(this.velocity);
        if (this.orientMode !== "none" && this.isFirstPerson === !1) {
            let u = $r.copy(l);
            u.y = 0, l.set(0, l.y, u.length() * -1);
        }
        if (this.directionXZ.manhattanLength() > 0 && this.orientMode !== "none") {
            if (this.orientWith === "camera" && this.path.length <= 1) {
                let u = Jr;
                this.camera.getWorldDirection(u);
                let c = Ea.copy(ds).multiplyScalar(u.dot(ds));
                u.sub(c);
                let d = $r.copy(this.directionXZ);
                d.x *= -1, this.rot.y = u.angleTo(d) * (u.cross(d).y > 0 ? -1 : 1) + this.rotationAccumWhenOrientWithCamera;
            } else this.rot.y = (this.path.length > 1 ? 0 : this.euler.y) + Math.atan2(-this.directionXZ.z, this.directionXZ.x) - Math.PI / 2;
        }
        if (Hs.setFromVector3(this.rot), this.moveMode === "walk" && (Hs.x = 0), l.applyEuler(Hs), a && (Lo.setFromUnitVectors(ds, this.groundNormal), l.applyQuaternion(Lo)), i) {
            let u = Hs.set(0, this.vrEulerYOffset * GD, 0);
            i.applyEuler(u), l.x += i.x, l.z += i.z, this.nonColliderPosOffset.elements[13] += i.y * s;
        }
        if (this.usePhysics === !0) {
            let u = $r;
            this.pushedVelocity.set(0, 0, 0);
            for (let c of this.sharedGameControlGlobals.entitiesWithTransformAnim){
                let d = Ea.setFromMatrixPosition(c.matrixWorld).sub(c.prevT).divideScalar(s).divideScalar(this.pixelsPerMeter), h = c.rigidBody.collider(0).castCollider(d, this.object.rigidBody.collider(0), Jr.copy(l).divideScalar(this.pixelsPerMeter), s, !1);
                if (d.multiplyScalar(this.pixelsPerMeter), h !== null) {
                    this.pushedVelocity.copy(d), u.copy(h.normal1).applyQuaternion(c.quaternion);
                    break;
                }
            }
            if (this.pushedVelocity.manhattanLength() !== 0) {
                let c = u.dot(l);
                c < 0 && l.addScaledVector(u, -c), l.add(this.pushedVelocity);
            } else l.add(this.groundVelocity);
        }
        if (this.rotDirection.y = Number(this.movementState.rotPosY) - Number(this.movementState.rotNegY), this.rotDirection.x = Number(this.movementState.rotPosX) - Number(this.movementState.rotNegX), this.rotDirection.normalize(), this.rotationMode === "normal" && (this.movementState.rotPosX || this.movementState.rotNegX) || this.rotationMode === "steer" && (this.movementState.rotPosX || this.movementState.rotNegX) && (this.movementState.movePosZ || this.movementState.moveNegZ || this.moveMode === "walk") ? this.rotVelocityStick.x = -this.rotDirection.x * this.speedOrbit * this.rotForce : this.rotVelocityStick.x = 0, this.rotationMode === "normal" && (this.movementState.rotPosY || this.movementState.rotNegY) || this.rotationMode === "steer" && (this.movementState.rotPosY || this.movementState.rotNegY) && (this.movementState.movePosZ || this.movementState.moveNegZ) ? this.rotVelocityStick.y = -this.rotDirection.y * this.speedOrbit * this.rotForce : this.rotVelocityStick.y = 0, this.rotVelocityTarget.subVectors(this.eulerDelta.divideScalar(s), this.rotVelocityStick), this.rotVelocityTarget.manhattanLength() === 0 ? this.rotVelocity.lerp(this.rotVelocityTarget, 1 - (1 - this.lerpFactorRotEnd) ** o) : this.rotVelocity.lerp(this.rotVelocityTarget, 1 - (1 - this.lerpFactorRotStart) ** o), this.euler.x += this.rotVelocity.x * s, this.euler.y += this.rotVelocity.y * s + this.groundYRotation, this.rotVelocityTarget.y === 0 && this.directionXZ.manhattanLength() === 0 ? this.rotationAccumWhenOrientWithCamera = 0 : (this.cameraFollow === !1 || this.cameraYAxis === "Locked") && (this.rotationAccumWhenOrientWithCamera += this.rotVelocity.y * s), this.isFirstPerson === !1 && this.orientMode !== "none" && this.directionXZ.manhattanLength() > 0) {
            if (this.orientMode === "radial") {
                this.objectToCamXZ.copy(this.objectToCamXZ0).applyAxisAngle(ds, this.euler.y - this.euler0.y);
                let u = $r.copy(this.objectToCamXZ).normalize(), c = Ea.copy(l).multiplyScalar(s);
                c.y = 0;
                let d = c.sub(Jr.copy(u).multiplyScalar(c.dot(u))).cross(u).y;
                this.euler.y -= Math.atan2(d, this.objectToCamXZ.length());
            }
        } else this.rot.y += this.rotVelocity.y * s + this.groundYRotation, this.rotVelocityTarget.y !== 0 && (this.cameraFollow === !1 || this.cameraYAxis === "Locked") && (this.euler.y = this.rot.y);
        if (this.cameraFollow === !0 && (this.moveMode === "walk" ? this.cameraXAxis === "Limit" ? this.euler.x = He.clamp(this.euler.x, -this.maxPolarAngle + this.cameraPolarOffset + 1e-6, -this.minPolarAngle + this.cameraPolarOffset - 1e-6) : this.euler.x = He.clamp(this.euler.x, -this.PI_2 + this.cameraPolarOffset, this.PI_2 + this.cameraPolarOffset) : this.cameraXAxis === "Limit" && (this.euler.x = He.clamp(this.euler.x, -this.PI_2, this.PI_2))), this.moveMode === "fly" ? this.rot.x = this.euler.x : this.isFirstPerson && (n ? (Hs.copy(n), Hs.y = 0) : (Hs.copy(this.euler), Hs.y = 0), this.nonColliderRotOffset.makeRotationFromEuler(Hs)), n && (this.moveMode === "walk" ? (this.rot.y = n.y, this.rot.x = 0, this.rot.z = 0) : this.rot.setFromEuler(n), this.rot.y += this.vrEulerYOffset * GD), us.setFromAxisAngle(B6, this.rot.x), Lo.setFromAxisAngle(ds, this.rot.y), Lo.multiply(us), us.setFromAxisAngle(F6, this.rot.z), Lo.multiply(us), this.object.quaternion.copy(Lo), this.objectRealQuat.multiplyQuaternions(this.object.quaternion, this.objXZQuat), this.objectRealQuat.multiply(this.objXZQuat), this.colliderWorldQuat.copy(this.objectRealQuat).multiply(this.collider.rotation), this.collisionEnabled) {
            if (this.usePhysics) {
                let u = $r.copy(l).multiplyScalar(s / this.pixelsPerMeter), c = null;
                this.didHit = !1;
                let d = new A;
                for(let h = 0; h < 5; h++){
                    let f = u.length(), m = Ea.copy(u).normalize();
                    if (c = this.sharedGameControlGlobals.rapierWorld.castShape(this.colliderWorldPosition.divideScalar(this.pixelsPerMeter).add(d), this.colliderWorldQuat, m, this.object.rigidBody?.collider(0).shape, f, !1, 8, void 0, void 0, this.object.rigidBody), c !== null) {
                        this.didHit = !0;
                        let p = this.sharedGameControlGlobals.colliderToEntity[c.collider.handle];
                        if (p !== this.lastHitObj && h === 0) {
                            this.lastHitObj = p;
                            let x = this.sharedGameControlGlobals.eventsPerObjects[p?.uuid];
                            if (x) {
                                for (let w of x)if (w.data.target === "character") {
                                    let S = this.sharedGameControlGlobals.rapierWorld?.getCollider(c.collider.handle)._parent, _;
                                    if (p.cloner) {
                                        for (let M of p.cloner.children)if (M.rigidBody === S) {
                                            _ = M;
                                            break;
                                        }
                                    }
                                    w.dispatch(_), p.dispatchEvent(TS);
                                }
                            }
                        }
                        let g = BD.set(c.normal2.x, c.normal2.y, c.normal2.z).applyQuaternion(this.colliderWorldQuat), y = FD.copy(m).multiplyScalar(c.toi).dot(g), v = c.toi;
                        if (v === 0 && (this.object.position.y += this.offset * this.pixelsPerMeter), y > this.offset && (v = c.toi * (y - this.offset) / y, d.addScaledVector(m, v)), u.copy(m).multiplyScalar(f - v), Math.acos(-g.y) > this.slopeThresh) {
                            let x = this.colliderWorldPosition.divideScalar(this.pixelsPerMeter).add(d), w = Ea.copy(c.witness2).applyQuaternion(this.colliderWorldQuat);
                            w.y = 0;
                            let S = x.add(w);
                            S.y += this.stepThresh;
                            let _ = this.sharedGameControlGlobals.rapierWorld.castShape(S, this.colliderWorldQuat, u, this.object.rigidBody?.collider(0).shape, 1, !1, 8, void 0, void 0, this.object.rigidBody);
                            _ !== null && _.toi === 0 && (g.y = 0, g.normalize());
                        }
                        u.addScaledVector(g, -u.dot(g));
                    } else {
                        h === 0 && this.directionXZ.manhattanLength() !== 0 && (this.lastHitObj = null), d.add(u);
                        break;
                    }
                }
                this.object.position.addScaledVector(d, this.pixelsPerMeter), this.object.rigidBody?.setTranslation(Jr.copy(this.object.position).divideScalar(this.pixelsPerMeter), !0), this.object.rigidBody?.setRotation(us.copy(this.object.quaternion).premultiply(this.groundTilt).multiply(this.objXZQuat), !0);
            } else {
                let u = this.onObject ? 1 : 5, c = l.multiplyScalar(s / u);
                for(let d = 0; d < u; d++)this.object.position.add(c), this.collisionAdjustment(s / u);
            }
        } else this.object.position.addScaledVector(l, s);
        if (this.moveMode === "walk" && this.onObject && (this.velocityTarget.y = 0, this.velocity.y = 0), this.object.quaternion.premultiply(this.groundTilt).multiply(this.objXZQuat), this.object.updateMatrix(), this.object.matrix.multiply(this.nonColliderPosOffset).multiply(this.nonColliderRotOffset), this.object.quaternion.premultiply(this.groundTiltInv).multiply(this.objXZQuatInv), this.cameraFollow === !0) {
            this.updateFollowArms();
            let u = this.objectToTarget.add(this.object.position), c = this.targetToCamera.add(u);
            ES.lookAt(c, u, ds).setPosition(c), ES.decompose(this.targetPos, this.targetQuat, Jr), this.camera.quaternion.slerp(this.targetQuat, 1 - (1 - this.lerpFactorRotCamera) ** o), this.camera.position.lerp(this.targetPos, 1 - (1 - this.lerpFactorPosCamera) ** o), this.camera.updateMatrix(), this.camera.updateMatrixWorld(), this.cameraYAxis === "Limit" && this.orientMode === "cartesian" && (this.euler.y = He.clamp(this.euler.y, this.minAzimuthAngleRel, this.maxAzimuthAngleRel)), this.euler.x = He.clamp(this.euler.x, -this.PI_2 + (this.cameraPolarOffset < 0 ? this.cameraPolarOffset : 0), this.PI_2 + (this.cameraPolarOffset > 0 ? this.cameraPolarOffset : 0));
        }
        return this.eulerDelta.set(0, 0, 0), this.path.length < 2 && this.lastPosition.distanceToSquared(this.object.position) < this.threshEndTranslate && Math.abs(this.rotVelocity.x) < this.threshEndRotVel && Math.abs(this.rotVelocity.y) < this.threshEndRotVel && (this.camera === void 0 || this.isFirstPerson || this.lastCameraPosition.distanceToSquared(this.camera.position) < this.threshEndTranslate && 8 * (1 - this.lastCameraQuaternion.dot(this.camera.quaternion)) < this.threshEndRotate) && (this.moveMode === "fly" || this.onObject === !0 || this.collisionEnabled === !1) && this.navMeshPathDest?.material?.opacity < -0.04 * this.navMeshPathDest?.material?.userData.opacity0 ? !1 : (this.camera && (this.lastCameraPosition.copy(this.camera.position), this.lastCameraQuaternion.copy(this.camera.quaternion)), this.lastPosition.copy(this.object.position), this.object.dispatchEvent(V6), !0);
    }
    updateFollowArms() {
        this.objectToTarget.copy(this.objectToTarget0), this.targetToCamera.copy(this.targetToCamera0);
        let e = us.setFromAxisAngle(ds, this.cameraYAxis === "Limit" && this.orientMode !== "radial" ? He.clamp(this.euler.y - this.euler0.y, this.minAzimuthAngleRel, this.maxAzimuthAngleRel) : this.euler.y - this.euler0.y);
        (this.cameraYAxis !== "Locked" || this.orientMode === "radial") && this.objectToTarget.applyQuaternion(e);
        let n;
        this.cameraXAxis === "Limit" ? n = He.clamp(this.euler.x, -this.maxPolarAngle + this.cameraPolarOffset + 1e-6, -this.minPolarAngle + this.cameraPolarOffset - 1e-6) : n = He.clamp(this.euler.x, -this.PI_2 + this.cameraPolarOffset + 1e-6, this.PI_2 + this.cameraPolarOffset - 1e-6);
        let i = Jr.copy(this.cameraPolarAxis0);
        (this.cameraYAxis !== "Locked" || this.orientMode === "radial") && i.applyQuaternion(e);
        let s = Lo.setFromAxisAngle(i, n);
        this.cameraYAxis !== "Locked" && this.targetToCamera.applyQuaternion(e), this.cameraXAxis !== "Locked" && this.targetToCamera.applyQuaternion(s);
    }
    groundTiltAdjustment(e) {
        ds.angleTo(e) * 180 / Math.PI < 15 || ds.angleTo(e) * 180 / Math.PI > 85 ? us.identity() : us.setFromUnitVectors(ds, e), this.groundTilt.slerp(us, .06), this.groundTiltInv.copy(this.groundTilt).invert();
    }
    collisionAdjustment(e) {
        let n = FD.set(0, 0, 0);
        this.object.updateMatrix();
        let i = ES.multiplyMatrices(this.object.matrix, this.objXZRotMat).multiply(this.collider.matrix).decompose(Jr, us, $r).compose(Jr, us, kD);
        this.sharedGameControlGlobals.entitiesWithTransformAnim.forEach((o)=>{
            if (o === this.object || o.isDescendantOf(this.object)) return;
            Oi.makeEmpty(), o.updateMatrixWorldSVD();
            let a = o.matrixWorldRigid, l = UD.copy(a).invert(), u = N6.copy(UD).multiply(i);
            Tr.copy(this.collider.segment), Tr.start.applyMatrix4(u), Tr.end.applyMatrix4(u);
            let c = BD.copy(this.object.position).applyMatrix4(l);
            Oi.expandByPoint(Tr.start), Oi.expandByPoint(Tr.end), Oi.min.addScalar(-this.collider.radius), Oi.max.addScalar(this.collider.radius), o.boundsTree.shapecast({
                intersectsBounds: (d)=>d.intersectsBox(Oi),
                intersectsTriangle: (d)=>{
                    let h = Jr, f = $r, m = d.closestPointToSegment(Tr, h, f);
                    if (m < this.collider.radius) {
                        let p = this.collider.radius - m, g = f.sub(h).normalize(), y = Ea.copy(c);
                        y.addScaledVector(g, p);
                        let v = y.applyMatrix4(a).sub(this.object.position);
                        n.add(v), Tr.start.addScaledVector(g, p), Tr.end.addScaledVector(g, p);
                    }
                }
            });
        }), Oi.makeEmpty(), Tr.copy(this.collider.segment), Tr.start.applyMatrix4(i), Tr.end.applyMatrix4(i), Oi.expandByPoint(Tr.start), Oi.expandByPoint(Tr.end), Oi.min.addScalar(-this.collider.radius), Oi.max.addScalar(this.collider.radius), this.sharedGameControlGlobals.staticMeshBVH?.shapecast({
            intersectsBounds: (o)=>o.intersectsBox(Oi),
            intersectsTriangle: (o)=>{
                let a = Jr, l = $r, u = o.closestPointToSegment(Tr, a, l);
                if (u < this.collider.radius) {
                    let c = this.collider.radius - u, d = l.sub(a).normalize();
                    this.alignToGround && this.groundTiltAdjustment(d), n.addScaledVector(d, c), Tr.start.addScaledVector(d, c), Tr.end.addScaledVector(d, c);
                }
            }
        }), this.onObject = Math.abs(n.y) > Math.abs(e * this.velocity.y * .25), this.onObject && this.dispatchStopEvent("jump");
        let s = Math.max(0, n.length() - 1e-5);
        n.normalize().multiplyScalar(s), this.object.position.add(n);
    }
}, $f = sv;
$f.isLocked = !1;
var H6 = {
    type: "change"
}, VD = {
    type: "changeZoom"
}, W6 = {
    type: "changePan"
}, Fd = {
    type: "start"
}, Ud = {
    type: "end",
    changed: !0
}, j6 = {
    type: "end",
    changed: !1
}, CS = new Je, HD = new F, q6 = 2 * Math.PI, X6 = 1e-8, Y6 = .01, PS = new A, ov = new F, DS = new A, av = new Je, WD = new ae;
var Q6 = {
    type: "requestRender"
}, Bd = class extends Ht {
    constructor(e, n, i = {
        isPlayMode: !1,
        isExport: !1
    }){
        super();
        this.object = e;
        this.domElement = n;
        this.options = i;
        this.enabled = !0;
        this.useKeyEvents = !0;
        this.enableDamping = !1;
        this.enableZoom = !0;
        this.enableRotate = !0;
        this.enablePan = !0;
        this.autoRotate = !1;
        this.rotationLimitsMode = 0;
        this.panLimitsMode = 0;
        this.rotationSoftLimit = 2;
        this.panSoftLimit = 2;
        this.hoverRotatePanMode = 0;
        this.zoomLimitsEnabled = !1;
        this.mouseButtons = [
            0,
            5
        ];
        this.mouseButtonsPlay = [
            3,
            4,
            5
        ];
        this.touches = [
            null,
            li.DOLLY_ROTATE,
            li.PAN
        ];
        this.offset = new A;
        this.eye = new A;
        this.lastPosition = new A;
        this.lastQuaternion = new Je;
        this.current = new F;
        this.overShoot = new F;
        this.overRatio = new F;
        this.spherical = new Eh;
        this.sphericalDelta = new Eh;
        this.panOffset = new A;
        this.panLeftV = new A;
        this.panUpV = new A;
        this.panV = new A;
        this.rotateStart = new F;
        this.rotateEnd = new F;
        this.rotateDelta = new F;
        this.panStart = new F;
        this.panEnd = new F;
        this.panDelta = new F;
        this.dollyStart = new F;
        this.dollyEnd = new F;
        this.dollyDelta = new F;
        this.rotationRangeFactor = new F;
        this.panRangeFactor = new F;
        this.state = -1;
        this.zoomChanged = !1;
        this.isPointerDown = !1;
        this.isThetaFlipped = !1;
        this.prevScale = 0;
        this.scale = 1;
        this.gesture = !1;
        this.timer = -1;
        this.timerHover = -1;
        this.minDistance = 0;
        this.maxDistance = 1 / 0;
        this.minZoom = 0;
        this.maxZoom = 1 / 0;
        this.minPhi = 0;
        this.maxPhi = Math.PI;
        this.minTheta = -1 / 0;
        this.maxTheta = 1 / 0;
        this.minH = 0;
        this.maxH = Math.PI;
        this.minV = -1 / 0;
        this.maxV = 1 / 0;
        this.autoRotateClockwise = !0;
        this.isPanOverShoot = !1;
        this.isRotateOverShoot = !1;
        this.resetHoverEffectOnPointerLeave = !1;
        this.hasChange = !1;
        this.useWindowEvents = !1;
        this.isTouchZoom = !0;
        this.autoRotateSpeed = 2;
        this.dampingFactor = .125;
        this.zoomSpeed = 2;
        this.rotateSpeed = 1;
        this.panSpeed = 1;
        this.hoverRotatePanStrength = .1;
        this.thetaIsFree = !1;
        this.phiIsFree = !1;
        this.needsUpdate = !0;
        this.onCameraChange = (e)=>{
            this.object.removeEventListener("beginState", this.onBeginState), this.object.removeEventListener("completeState", this.onCompleteState), this.object.removeEventListener("cameraChange", this.onCameraChange), this.object = e.camera, this.object.addEventListener("beginState", this.onBeginState), this.object.addEventListener("completeState", this.onCompleteState), this.object.addEventListener("cameraChange", this.onCameraChange);
        };
        this.update = ()=>{
            this.object.updateWorldMatrix(!0, !1), this.object.matrixWorld.decompose(DS, av, PS), this.offset.copy(DS).sub(this.target), this.spherical.setFromVector3(this.offset), this.object.isUpVectorFlipped && (this.spherical.phi *= -1, this.spherical.theta -= Math.PI), this.autoRotate && this.state === -1 && this.rotateLeft((this.autoRotateClockwise === !0 ? 1 : -1) * this.getAutoRotationAngle()), this.rotationLimitsMode !== 0 && this.applyLimits(this.sphericalDelta, this.rotationLimitsMode, this.rotationSoftLimit, this.maxTheta, this.minTheta, this.maxPhi, this.minPhi, this.rotationRangeFactor), this.rotationLimitsMode !== 2 && (this.spherical.phi += this.sphericalDelta.phi), (this.rotationLimitsMode !== 1 || this.autoRotate === !0) && (this.spherical.theta += this.sphericalDelta.theta), this.spherical.radius *= this.scale, this.zoomLimitsEnabled && (this.spherical.radius = Math.max(this.minDistance, Math.min(this.maxDistance, this.spherical.radius))), this.panLimitsMode !== 0 && (this.target.applyQuaternion(CS.copy(av).invert()), this.panOffset.applyQuaternion(CS), this.applyLimits(this.panOffset, this.panLimitsMode, this.panSoftLimit, this.maxH, this.minH, this.maxV, this.minV, this.panRangeFactor), this.target.applyQuaternion(av), this.panOffset.applyQuaternion(av)), this.panLimitsMode === 2 && (this.panOffset.y = 0), this.panLimitsMode === 1 && (this.panOffset.x = 0), this.state === -1 && !this.gesture ? (this.panOffset.multiplyScalar(1 - this.dampingFactor), this.target.add(this.panOffset)) : (this.target.add(this.panOffset), this.panOffset.set(0, 0, 0)), this.offset.setFromSpherical(this.spherical), DS.copy(this.target).add(this.offset), this.object.position.copy(this.target).add(this.offset), this.object.parent && (WD.copy(this.object.parent.matrixWorld).invert(), this.object.position.applyMatrix4(WD));
            let e = this.spherical.phi % q6;
            return this.eye.copy(this.offset).normalize(), this.object.up.copy(pt.DEFAULT_UP).applyAxisAngle(this.eye, this.object.angleOffsetFromUp), e > 0 && e > Math.PI || e < 0 && e > -Math.PI ? (this.object.up.negate(), this.object.lookAt(this.target), this.object.isUpVectorFlipped = !0) : (this.object.lookAt(this.target), this.object.isUpVectorFlipped = !1), this.state === -1 || this.enableDamping === !0 ? (this.sphericalDelta.theta *= 1 - this.dampingFactor, this.sphericalDelta.phi *= 1 - this.dampingFactor) : this.sphericalDelta.set(0, 0, 0), this.scale = 1, this.zoomChanged || this.lastPosition.distanceToSquared(this.object.position) > Y6 || 8 * (1 - this.lastQuaternion.dot(this.object.quaternion)) > X6 ? (this.dispatchEvent(H6), this.object.dispatchEvent(Q6), this.lastPosition.copy(this.object.position), this.lastQuaternion.copy(this.object.quaternion), this.zoomChanged = !1, !0) : (this.isPanOverShoot = !1, this.isRotateOverShoot = !1, this.object.wasMovedBySwitchCameraAction = !1, this.sphericalDelta.set(0, 0, 0), this.panOffset.set(0, 0, 0), !1);
        };
        this.onPointerDown = (e)=>{
            this.enabled !== !1 && (e.pointerType === "touch" || e.pointerType === "pen" && jn ? this.onPointerDownTouch(e) : this.onPointerDownMouse(e), this.state !== -1 && (this.isPointerDown = !0, this.dispatchEvent(Fd), this.domElement.addEventListener("pointermove", this.onPointerMove), this.domElement.addEventListener("pointerup", this.onPointerUp), e.stopPropagation(), e.pointerType === "touch" || e.pointerType === "pen" && jn || this.domElement.setPointerCapture(e.pointerId)));
        };
        this.onPointerLeave = (e)=>{
            this.resetHoverEffectOnPointerLeave && !this.useWindowEvents ? (this.hoverRotatePanMode === 1 ? (this.sphericalDelta.theta = -this.spherical.theta, this.sphericalDelta.phi = -this.spherical.phi, PS.subVectors(this.position0, this.target0), this.spherical.setFromVector3(PS), this.sphericalDelta.theta += this.spherical.theta, this.sphericalDelta.phi += this.spherical.phi, this.sphericalDelta.theta /= 8, this.sphericalDelta.phi /= 8) : this.hoverRotatePanMode === 2 && this.panOffset.subVectors(this.target0, this.target).divideScalar(8), this.update()) : this.pointerLeaveEvent = e;
        };
        this.onPointerEnter = (e)=>{
            this.resetHoverEffectOnPointerLeave || this.pointerLeaveEvent === void 0 ? ov.set(e.clientX - this.domElement.clientWidth / 2, e.clientY - this.domElement.clientHeight / 2) : ov.set(e.clientX - this.pointerLeaveEvent.clientX, e.clientY - this.pointerLeaveEvent.clientY), this.hoverRotatePanMode === 1 ? (this.rotateDelta.copy(ov).multiplyScalar(this.rotateSpeed * this.hoverRotatePanStrength).rotateAround(HD, -this.object.angleOffsetFromUp), this.rotateLeft(2 * Math.PI * this.rotateDelta.x / this.domElement.clientHeight), this.rotateUp(2 * Math.PI * this.rotateDelta.y / this.domElement.clientHeight), this.rotateStart.set(e.clientX, e.clientY)) : this.hoverRotatePanMode === 2 && (this.panDelta.copy(ov).multiplyScalar(this.panSpeed * this.hoverRotatePanStrength), this.pan(this.panDelta.x, this.panDelta.y), this.panStart.set(e.clientX, e.clientY)), this.update();
        };
        this.onPointerMove = (e)=>{
            this.enabled !== !1 && (e.pointerType === "touch" || e.pointerType === "pen" && jn ? this.onPointerMoveTouch(e) : this.onPointerMoveMouse(e), e.stopPropagation());
        };
        this.onPointerUp = (e)=>{
            this.isPointerDown = !1, ke.length === 0 && (this.domElement.removeEventListener("pointermove", this.onPointerMove), this.domElement.removeEventListener("pointerup", this.onPointerUp)), ke.length > 1 && e.preventDefault(), this.hasChange ? this.dispatchEvent(Ud) : this.dispatchEvent(j6), this.state = -1, e && (e.stopPropagation(), e.pointerType === "touch" || e.pointerType === "pen" && jn || this.domElement.releasePointerCapture(e.pointerId));
        };
        this.onPointerDownMouse = (e)=>{
            let n;
            switch(this.useKeyEvents ? n = this.mouseButtons[e.button] : n = this.mouseButtonsPlay[e.button], n){
                case 0:
                    if (e.altKey === !0 && !e.shiftKey && !Fh(e)) {
                        if (this.enableRotate === !1) return;
                        this.handleMouseDownRotate(e), this.state = 0;
                    } else if (this.key === " ") {
                        if (this.enablePan === !1) return;
                        this.handleMouseDownPan(e), this.state = 2;
                    }
                    break;
                case 4:
                    if (this.enablePan === !1) return;
                    this.handleMouseDownPan(e), this.state = 2;
                    break;
                case 3:
                    if (Fh(e) || e.shiftKey) {
                        if (this.enablePan === !1) return;
                        this.handleMouseDownPan(e), this.state = 2;
                    } else {
                        if (this.enableRotate === !1) return;
                        this.handleMouseDownRotate(e), this.state = 0;
                    }
                    break;
                case 5:
                    if (Fh(e) || e.shiftKey) {
                        if (this.enableRotate === !1) return;
                        this.handleMouseDownRotate(e), this.state = 0;
                    } else {
                        if (this.enablePan === !1) return;
                        this.handleMouseDownPan(e), this.state = 2;
                    }
                    break;
                default:
                    this.state = -1;
            }
        };
        this.onPointerMoveMouse = (e)=>{
            switch(this.state){
                case 0:
                    if (this.enableRotate === !1) return;
                    this.handleMouseMoveRotate(e);
                    break;
                case 1:
                    if (this.enableZoom === !1) return;
                    this.handleMouseMoveDolly(e);
                    break;
                case 2:
                    if (this.enablePan === !1) return;
                    this.handleMouseMovePan(e);
                    break;
            }
            this.object.wasMovedByUser = !0;
        };
        this.onPointerDownTouch = (e)=>{
            switch(ke.length > 1 && e.preventDefault(), this.touches[ke.length - 1]){
                case li.ROTATE:
                    if (this.enableRotate === !1) {
                        this.state = -1;
                        return;
                    }
                    this.handleTouchStartRotate(), this.state = 3;
                    break;
                case li.PAN:
                    if (this.enablePan === !1) {
                        this.state = -1;
                        return;
                    }
                    this.handleTouchStartPan(), this.state = 4;
                    break;
                case li.DOLLY_PAN:
                    if (this.enableZoom === !1 && this.enablePan === !1) return;
                    this.handleTouchStartDollyPan(), this.state = 5;
                    break;
                case li.DOLLY_ROTATE:
                    if (this.enableZoom === !1 && this.enableRotate === !1) return;
                    this.handleTouchStartDollyRotate(), this.state = 6;
                    break;
                default:
                    this.state = -1;
            }
        };
        this.onPointerMoveTouch = (e)=>{
            switch(ke.length > 1 && e.preventDefault(), this.state){
                case 3:
                    if (this.enableRotate === !1) return;
                    this.handleTouchMoveRotate(e), this.update();
                    break;
                case 4:
                    if (this.enablePan === !1) return;
                    this.handleTouchMovePan(e), this.update();
                    break;
                case 5:
                    if (this.enableZoom === !1 && this.enablePan === !1) return;
                    this.handleTouchMoveDollyPan(e), this.update();
                    break;
                case 6:
                    if (this.enableZoom === !1 && this.enableRotate === !1) return;
                    this.handleTouchMoveDollyRotate(e), this.update();
                    break;
                default:
                    this.state = -1;
            }
            this.object.wasMovedByUser = !0;
        };
        this.dispatchEndDebounced = ol(()=>this.dispatchEvent(Ud), 33);
        this.onMouseWheel = (e)=>{
            this.enabled === !1 || this.enableZoom === !1 && this.enablePan === !1 || (this.options.isExport === !1 && this.domElement.clientHeight === document.body.clientHeight && this.domElement.clientWidth === document.body.clientWidth && e.preventDefault(), this.dispatchEvent(Fd), this.handleMouseWheel(e), this.dispatchEndDebounced(), this.object.wasMovedByUser = !0);
        };
        this.onGesture = (e)=>{
            if (e.preventDefault(), this.enabled !== !1 && !Rm) {
                if (e.type === "gesturechange") {
                    if (this.enableZoom === !1 || this.isTouchZoom === !1) return;
                    this.dispatchEvent(Fd), e.scale > this.prevScale ? this.dollyIn(this.getZoomScale()) : e.scale < this.prevScale && this.dollyOut(this.getZoomScale()), this.prevScale = e.scale, this.update(), this.object.wasMovedByUser = !0;
                } else this.dispatchEvent(Ud);
            }
        };
        this.onContextMenu = (e)=>{
            e.preventDefault();
        };
        this.onTouchEnd = (e)=>{
            e.preventDefault();
        };
        this.onKeyDown = (e)=>{
            this.enabled !== !1 && (this.key = e.key, e.key === " " && this.dispatchEvent(Fd));
        };
        this.onKeyUp = (e)=>{
            this.enabled !== !1 && (this.key = void 0, this.state !== -1 && e.key === "Alt" && this.onPointerUp(ke[0]), e.key === " " && this.dispatchEvent(Ud));
        };
        this.onPointerHover = (e)=>{
            e.pointerType !== "mouse" || this.enabled === !1 || this.state !== -1 || this.hoverRotatePanMode === 2 && this.isPanOverShoot || this.hoverRotatePanMode === 1 && this.isRotateOverShoot || (this.isPointerDown = !0, this.hoverRotatePanMode === 2 ? this.handleMouseMovePan(e, this.hoverRotatePanStrength) : this.hoverRotatePanMode === 1 && this.handleMouseMoveRotate(e, this.hoverRotatePanStrength));
        };
        this.onBeginState = ()=>{
            this.enabled = !1, this.needsUpdate = !1;
        };
        this.onCompleteState = (e)=>{
            e.isfromEntity && this.options.isPlayMode || (this.enabled = !0, this.needsUpdate = !0, this.object.updateUp(), this.object.getTarget(this.target));
        };
        this.target = this.object.getTarget(), this.target0 = this.target.clone(), this.position0 = this.object.position.clone(), this.zoom0 = this.object.zoom, this.quat0 = this.object.quaternion.clone(), this.isUpVectorFlipped0 = this.object.isUpVectorFlipped, this.offset.copy(this.object.position).sub(this.target), this.spherical.setFromVector3(this.offset), this.object.isUpVectorFlipped && (this.spherical.phi *= -1, this.spherical.theta -= Math.PI), this.addEventListenersToCamera();
    }
    dispatchEvent(e) {
        e.type === "start" ? this.hasChange = !1 : this.hasChange = !0, super.dispatchEvent(e);
    }
    addEventListenersToCamera() {
        this.object.addEventListener("beginState", this.onBeginState), this.object.addEventListener("completeState", this.onCompleteState), this.object.addEventListener("cameraChange", this.onCameraChange);
    }
    removeEventListenersFromCamera() {
        this.object.removeEventListener("beginState", this.onBeginState), this.object.removeEventListener("completeState", this.onCompleteState), this.object.removeEventListener("cameraChange", this.onCameraChange);
    }
    updateUseWindowEvents(e) {
        if (window.removeEventListener("pointermove", this.onPointerHover), this.domElement.removeEventListener("pointermove", this.onPointerHover), this.useWindowEvents = e, this.hoverRotatePanMode !== 0 && (this.useWindowEvents ? window.addEventListener("pointermove", this.onPointerHover) : this.domElement.addEventListener("pointermove", this.onPointerHover)), this.domElement.removeEventListener("pointerleave", this.onPointerLeave), this.domElement.removeEventListener("pointerenter", this.onPointerEnter), window.removeEventListener("pointerleave", this.onPointerLeave), window.removeEventListener("pointerenter", this.onPointerEnter), this.hoverRotatePanMode !== 0 && !this.useWindowEvents) {
            let n = this.useWindowEvents ? window : this.domElement;
            n.addEventListener("pointerleave", this.onPointerLeave), n.addEventListener("pointerenter", this.onPointerEnter);
        }
    }
    fromJSON(e, n) {
        this.setEnableDampingSpeed(e.enableDamping), this.enablePan = e.enablePan, this.enableZoom = e.enableZoom, this.enableRotate = e.enableRotate, this.rotationLimitsMode = e.rotationLimitsMode, this.thetaIsFree = e.rotationHorizontalOffset.min === e.rotationHorizontalOffset.max && e.rotationHorizontalOffset.min === Math.PI, this.phiIsFree = e.rotationVerticalOffset.min === e.rotationVerticalOffset.max && e.rotationVerticalOffset.min === Math.PI, this.panLimitsMode = e.panLimitsMode, this.panSoftLimit = e.panSoftLimit, this.rotationSoftLimit = e.rotationSoftLimit, this.hoverRotatePanMode = e.hoverRotatePanMode, this.useWindowEvents = n === "window", this.hoverRotatePanMode !== 0 && (this.useWindowEvents ? window.addEventListener("pointermove", this.onPointerHover) : this.domElement.addEventListener("pointermove", this.onPointerHover));
        let i = e.hoverRotatePanStrength / 100;
        this.hoverRotatePanStrength = i ** 2, this.zoomLimitsEnabled = e.zoomLimitsEnabled, this.minZoom = e.zoomLimits.min, this.maxZoom = Math.max(e.zoomLimits.min, e.zoomLimits.max), this.minDistance = 1e3 / e.zoomLimits.max, this.maxDistance = Math.max(this.minDistance, 1e3 / e.zoomLimits.min), this.autoRotate = e.autoRotate, this.autoRotateSpeed = e.autoRotateSpeed, this.autoRotateClockwise = e.autoRotateClockwise;
        let s = this.object.getTarget().applyQuaternion(CS.copy(this.object.quaternion).invert());
        this.minV = -e.panVerticalOffset.min + s.y, this.maxV = e.panVerticalOffset.max + s.y, this.minH = -e.panHorizontalOffset.min + s.x, this.maxH = e.panHorizontalOffset.max + s.x, this.panRangeFactor.set(this.maxH - this.minH, this.maxV - this.minV).divideScalar(2), this.rotationRangeFactor.setScalar(Math.PI).divideScalar(4), this.minPhi = Ws(this.spherical.phi - e.rotationVerticalOffset.min), this.maxPhi = Ws(this.spherical.phi + e.rotationVerticalOffset.max), this.minTheta = Ws(Ws(this.spherical.theta) - e.rotationHorizontalOffset.min), this.maxTheta = Ws(Ws(this.spherical.theta) + e.rotationHorizontalOffset.max), this.isThetaFlipped = this.minTheta > this.maxTheta, e.orbitTouches === 1 && (this.touches[0] = li.ROTATE), e.panTouches === 1 && (this.touches[0] = li.PAN), e.orbitTouches === 2 && (this.touches[1] = li.DOLLY_ROTATE), e.panTouches === 2 && (this.touches[1] = li.DOLLY_PAN), e.orbitTouches === 3 && (this.touches[2] = li.ROTATE), e.panTouches === 3 && (this.touches[2] = li.PAN), this.isTouchZoom = e.isTouchZoom, this.resetHoverEffectOnPointerLeave = e.resetHoverEffectOnPointerLeave ?? !1;
    }
    connect() {
        if (this.domElement.addEventListener("contextmenu", this.onContextMenu), this.domElement.addEventListener("pointerdown", this.onPointerDown), this.domElement.addEventListener("wheel", this.onMouseWheel), window.addEventListener("keydown", this.onKeyDown, !1), window.addEventListener("keyup", this.onKeyUp, !1), this.domElement.addEventListener("gesturestart", this.onGesture), this.domElement.addEventListener("gesturechange", this.onGesture), this.domElement.addEventListener("gestureend", this.onGesture), this.domElement.addEventListener("touchend", this.onTouchEnd), this.hoverRotatePanMode !== 0 && !this.useWindowEvents) {
            let e = this.useWindowEvents ? window : this.domElement;
            e.addEventListener("pointerleave", this.onPointerLeave), e.addEventListener("pointerenter", this.onPointerEnter);
        }
        this.pointerLeaveEvent = void 0;
    }
    dispose() {
        this.removeEventListenersFromCamera(), this.domElement.removeEventListener("contextmenu", this.onContextMenu), this.domElement.removeEventListener("pointerdown", this.onPointerDown), this.domElement.removeEventListener("wheel", this.onMouseWheel), window.removeEventListener("keydown", this.onKeyDown, !1), window.removeEventListener("keyup", this.onKeyUp, !1), this.domElement.removeEventListener("pointermove", this.onPointerHover), window.removeEventListener("pointermove", this.onPointerHover), this.domElement.removeEventListener("gesturestart", this.onGesture), this.domElement.removeEventListener("gesturechange", this.onGesture), this.domElement.removeEventListener("gestureend", this.onGesture), this.domElement.removeEventListener("touchend", this.onTouchEnd), this.domElement.removeEventListener("pointerleave", this.onPointerLeave), this.domElement.removeEventListener("pointerenter", this.onPointerEnter), window.removeEventListener("pointerleave", this.onPointerLeave), window.removeEventListener("pointerenter", this.onPointerEnter), this.domElement.removeEventListener("pointermove", this.onPointerMove), this.domElement.removeEventListener("pointerup", this.onPointerUp);
    }
    applyLimits(e, n, i, s, o, a, l, u) {
        this.overShoot.set(0, 0);
        let c, d, h;
        e instanceof A ? (c = e.x, d = e.y, this.current.set(this.target.x, this.target.y), h = !0) : (c = e.theta, d = e.phi, this.current.set(Ws(this.spherical.theta), Ws(this.spherical.phi)), h = !1), i === 0 && (this.current.x += c, this.current.y += d), (n === 3 || n === 2) && (!h && this.isThetaFlipped ? this.current.x > s && this.current.x < 0 ? this.overShoot.x = s - this.current.x : this.current.x < o && this.current.x > 0 && (this.overShoot.x = o - this.current.x) : this.current.x > s ? this.overShoot.x = s - this.current.x : this.current.x < o && (this.overShoot.x = o - this.current.x)), (n === 3 || n === 1) && (this.current.y > a ? this.overShoot.y = a - this.current.y : this.current.y < l && (this.overShoot.y = l - this.current.y)), h || (this.overShoot.x = Ws(this.overShoot.x), this.overShoot.y = Ws(this.overShoot.y)), i !== 0 ? (this.overRatio.copy(this.overShoot).divide(u), this.overRatio.x = Math.min(Math.abs(this.overRatio.x), 1), this.overRatio.y = Math.min(Math.abs(this.overRatio.y), 1), i === 1 && (this.overRatio.x = jD(Math.abs(this.overRatio.x)), this.overRatio.y = jD(Math.abs(this.overRatio.y))), this.isPointerDown || i === 1 ? i === 2 && (this.overRatio.x > .9 && !this.thetaIsFree || this.overRatio.y > .9 && !this.phiIsFree) ? this.isPointerDown = !1 : (c * this.overShoot.x < 0 && !this.thetaIsFree && (c *= 1 - this.overRatio.x), d * this.overShoot.y < 0 && !this.phiIsFree && (d *= 1 - this.overRatio.y)) : i === 2 && (!h && (this.overRatio.x > .002 && !this.thetaIsFree || this.overRatio.y > .002 && !this.phiIsFree) || h && (Math.abs(this.overShoot.x) > 2 || Math.abs(this.overShoot.y) > 2) ? (this.thetaIsFree || (c = this.overShoot.x * .05), this.phiIsFree || (d = this.overShoot.y * .05), h ? this.isPanOverShoot = !0 : this.isRotateOverShoot = !0) : h ? this.isPanOverShoot = !1 : this.isRotateOverShoot = !1)) : (c += this.overShoot.x, d += this.overShoot.y), e instanceof A ? (e.x = c, e.y = d) : (this.thetaIsFree || (e.theta = c), this.phiIsFree || (e.phi = d));
    }
    setEnableDampingSpeed(e) {
        this.enableDamping = e, this.rotateSpeed = e === !0 ? .2 : 1;
    }
    stopDamping() {
        this.sphericalDelta.theta = 0, this.sphericalDelta.phi = 0;
    }
    getAutoRotationAngle() {
        return 2 * Math.PI / 60 / 60 * this.autoRotateSpeed;
    }
    getZoomScale() {
        return Math.pow(.95, this.zoomSpeed);
    }
    rotateLeft(e) {
        this.sphericalDelta.theta -= e;
    }
    rotateUp(e) {
        this.sphericalDelta.phi -= e;
    }
    panLeft(e, n) {
        this.panLeftV.setFromMatrixColumn(n, 0), this.panLeftV.multiplyScalar(-e), this.panOffset.add(this.panLeftV);
    }
    panUp(e, n) {
        this.panUpV.setFromMatrixColumn(n, 1), this.panUpV.multiplyScalar(e), this.panOffset.add(this.panUpV);
    }
    pan(e, n) {
        let i = this.domElement;
        if (i && this.object.isPerspectiveCamera) {
            let s = this.object.position;
            this.panV.copy(s).sub(this.target);
            let o = this.panV.length();
            o *= Math.tan(this.object.fov / 2 * Math.PI / 180), this.panLeft(2 * e * o / i.clientHeight, this.object.matrixWorld), this.panUp(2 * n * o / i.clientHeight, this.object.matrixWorld);
        } else i && this.object.isOrthographicCamera && (this.panLeft(e * (this.object.right - this.object.left) / this.object.zoom / i.clientWidth, this.object.matrixWorld), this.panUp(n * (this.object.top - this.object.bottom) / this.object.zoom / i.clientHeight, this.object.matrixWorld));
        this.dispatchEvent(W6);
    }
    dollyOut(e) {
        this.object.isPerspectiveCamera ? this.scale /= e : this.object.isOrthographicCamera && (this.object.zoom *= e, this.zoomLimitsEnabled && (this.object.zoom = Math.max(this.minZoom, Math.min(this.maxZoom, this.object.zoom))), this.object.updateProjectionMatrix(), this.zoomChanged = !0), this.dispatchEvent(VD);
    }
    dollyIn(e) {
        this.object.isPerspectiveCamera ? this.scale *= e : this.object.isOrthographicCamera && (this.object.zoom /= e, this.zoomLimitsEnabled && (this.object.zoom = Math.max(this.minZoom, Math.min(this.maxZoom, this.object.zoom))), this.object.updateProjectionMatrix(), this.zoomChanged = !0), this.dispatchEvent(VD);
    }
    zoomOut(e = this.getZoomScale()) {
        this.dispatchEvent(Fd), this.dollyOut(e), this.dispatchEvent(Ud);
    }
    zoomIn(e = this.getZoomScale()) {
        this.dispatchEvent(Fd), this.dollyIn(e), this.dispatchEvent(Ud);
    }
    handleMouseDownRotate(e) {
        this.rotateStart.set(e.clientX, e.clientY);
    }
    handleMouseDownDolly(e) {
        this.dollyStart.set(e.clientX, e.clientY);
    }
    handleMouseDownPan(e) {
        this.panStart.set(e.clientX, e.clientY);
    }
    handleMouseMoveRotate(e, n = 1) {
        e.movementX !== void 0 ? this.rotateDelta.set(e.movementX, e.movementY) : (this.rotateEnd.set(e.clientX, e.clientY), this.rotateDelta.subVectors(this.rotateEnd, this.rotateStart), this.rotateStart.copy(this.rotateEnd)), this.rotateDelta.multiplyScalar(this.rotateSpeed * n).rotateAround(HD, -this.object.angleOffsetFromUp);
        let i = this.domElement, s = this.useWindowEvents ? window.innerHeight : i.clientHeight, o = 2 * Math.PI * this.rotateDelta.x / s, a = 2 * Math.PI * this.rotateDelta.y / s;
        this.rotateLeft(o), this.rotateUp(a), this.update();
    }
    handleMouseMoveDolly(e) {
        this.dollyEnd.set(e.clientX, e.clientY), this.dollyDelta.subVectors(this.dollyEnd, this.dollyStart), this.dollyDelta.y > 0 ? this.dollyOut(this.getZoomScale()) : this.dollyDelta.y < 0 && this.dollyIn(this.getZoomScale()), this.dollyStart.copy(this.dollyEnd), this.update();
    }
    handleMouseMovePan(e, n = 1) {
        e.movementX !== void 0 ? this.panDelta.set(e.movementX, e.movementY) : (this.panEnd.set(e.clientX, e.clientY), this.panDelta.subVectors(this.panEnd, this.panStart), this.panStart.copy(this.panEnd)), this.panDelta.multiplyScalar(this.panSpeed * n), this.pan(this.panDelta.x, this.panDelta.y), this.update();
    }
    handleMouseWheel(e) {
        if (gT === !1 && Fh(e) === !1 && K6(e) === !0) {
            if (this.enablePan === !1) return;
            this.gesture ? (this.panDelta.set(-e.deltaX, -e.deltaY).multiplyScalar(this.panSpeed), this.panDelta.x = Math.min(Math.abs(this.panDelta.x), 100) * (this.panDelta.x < 0 ? -1 : 1), this.panDelta.y = Math.min(Math.abs(this.panDelta.y), 100) * (this.panDelta.y < 0 ? -1 : 1), e.altKey ? this.pan(0, this.panDelta.y) : e.shiftKey ? this.pan(this.panDelta.x, 0) : this.pan(this.panDelta.x, this.panDelta.y), this.update()) : (this.gesture = !0, this.isPointerDown = !0), window.clearTimeout(this.timer), this.timer = window.setTimeout(()=>{
                this.gesture = !1, this.isPointerDown = !1;
            }, 30);
        } else {
            if (this.enableZoom === !1) return;
            e.deltaY === 0 ? e.deltaX < 0 ? this.dollyIn(this.getZoomScale()) : e.deltaX > 0 && this.dollyOut(this.getZoomScale()) : e.deltaY < 0 ? this.dollyIn(this.getZoomScale()) : e.deltaY > 0 && this.dollyOut(this.getZoomScale()), this.update(), this.gesture = !1, this.isPointerDown = !1;
        }
    }
    handleTouchStartRotate() {
        if (ke.length === 2) {
            let e = .5 * (ke[0].pageX + ke[1].pageX), n = .5 * (ke[0].pageY + ke[1].pageY);
            this.rotateStart.set(e, n);
        } else this.rotateStart.set(ke[0].pageX, ke[0].pageY);
    }
    handleTouchStartPan() {
        if (ke.length === 2) {
            let e = .5 * (ke[0].pageX + ke[1].pageX), n = .5 * (ke[0].pageY + ke[1].pageY);
            this.panStart.set(e, n);
        } else this.panStart.set(ke[0].pageX, ke[0].pageY);
    }
    handleTouchStartDolly() {
        let e = ke[0].pageX - ke[1].pageX, n = ke[0].pageY - ke[1].pageY, i = Math.sqrt(e * e + n * n);
        this.dollyStart.set(0, i);
    }
    handleTouchStartDollyPan() {
        this.enableZoom && this.isTouchZoom === !0 && this.handleTouchStartDolly(), this.enablePan && this.handleTouchStartPan();
    }
    handleTouchStartDollyRotate() {
        this.enableZoom && this.isTouchZoom === !0 && this.handleTouchStartDolly(), this.enableRotate && this.handleTouchStartRotate();
    }
    handleTouchMoveRotate(e) {
        if (ke.length === 2) {
            let i = Um(e), s = .5 * (e.pageX + i.x), o = .5 * (e.pageY + i.y);
            this.rotateEnd.set(s, o);
        } else {
            if (e.pointerId !== ke[0].pointerId) return;
            this.rotateEnd.set(e.pageX, e.pageY);
        }
        this.rotateDelta.subVectors(this.rotateEnd, this.rotateStart).multiplyScalar(this.rotateSpeed);
        let n = this.domElement;
        n && (this.rotateLeft(2 * Math.PI * this.rotateDelta.x / n.clientHeight), this.rotateUp(2 * Math.PI * this.rotateDelta.y / n.clientHeight)), this.rotateStart.copy(this.rotateEnd);
    }
    handleTouchMovePan(e) {
        if (ke.length === 2) {
            let n = Um(e), i = .5 * (e.pageX + n.x), s = .5 * (e.pageY + n.y);
            this.panEnd.set(i, s);
        } else {
            if (e.pointerId !== ke[0].pointerId) return;
            this.panEnd.set(e.pageX, e.pageY);
        }
        this.panDelta.subVectors(this.panEnd, this.panStart).multiplyScalar(this.panSpeed), this.pan(this.panDelta.x, this.panDelta.y), this.panStart.copy(this.panEnd);
    }
    handleTouchMoveDolly(e) {
        let n = Um(e), i = e.pageX - n.x, s = e.pageY - n.y, o = Math.sqrt(i * i + s * s);
        this.dollyEnd.set(0, o), this.dollyDelta.set(0, Math.pow(this.dollyEnd.y / this.dollyStart.y, this.zoomSpeed)), this.dollyOut(this.dollyDelta.y), this.dollyStart.copy(this.dollyEnd);
    }
    handleTouchMoveDollyPan(e) {
        this.enableZoom && this.isTouchZoom === !0 && this.handleTouchMoveDolly(e), this.enablePan && this.handleTouchMovePan(e);
    }
    handleTouchMoveDollyRotate(e) {
        this.enableZoom && this.isTouchZoom === !0 && this.handleTouchMoveDolly(e), this.enableRotate && this.handleTouchMoveRotate(e);
    }
};
function Ws(r1) {
    let t = Math.PI * 2;
    for(; r1 <= -Math.PI;)r1 += t;
    for(; r1 > Math.PI;)r1 -= t;
    return r1;
}
function jD(r1) {
    return 1 - Math.pow(1 - r1, 4);
}
function K6(r1) {
    return r1.wheelDeltaY === 0 || r1.deltaY === 0 ? ll && r1.shiftKey && Math.abs(r1.wheelDeltaX) >= 120 ? !1 : r1.wheelDeltaX ? r1.wheelDeltaX === -3 * r1.deltaX : r1.deltaMode === 0 : r1.wheelDeltaY ? r1.wheelDeltaY === -3 * r1.deltaY : r1.deltaMode === 0;
}
var IS = new WeakMap, lv = class extends xc {
    constructor(t){
        super(t), this.decoderPath = "", this.decoderConfig = {}, this.decoderBinary = null, this.decoderPending = null, this.workerLimit = 4, this.workerPool = [], this.workerNextTaskID = 1, this.workerSourceURL = "", this.defaultAttributeIDs = {
            position: "POSITION",
            normal: "NORMAL",
            color: "COLOR",
            uv: "TEX_COORD"
        }, this.defaultAttributeTypes = {
            position: "Float32Array",
            normal: "Float32Array",
            color: "Float32Array",
            uv: "Float32Array"
        };
    }
    setDecoderPath(t) {
        return this.decoderPath = t, this;
    }
    setDecoderConfig(t) {
        return this.decoderConfig = t, this;
    }
    setWorkerLimit(t) {
        return this.workerLimit = t, this;
    }
    load(t, e, n, i) {
        let s = new bc(this.manager);
        s.setPath(this.path), s.setResponseType("arraybuffer"), s.setRequestHeader(this.requestHeader), s.setWithCredentials(this.withCredentials), s.load(t, (o)=>{
            this.decodeDracoFile(o, e).catch(i);
        }, n, i);
    }
    decodeDracoFile(t, e, n, i) {
        let s = {
            attributeIDs: n || this.defaultAttributeIDs,
            attributeTypes: i || this.defaultAttributeTypes,
            useUniqueIDs: !!n
        };
        return this.decodeGeometry(t, s).then(e);
    }
    decodeGeometry(t, e) {
        let n = JSON.stringify(e);
        if (IS.has(t)) {
            let l = IS.get(t);
            if (l.key === n) return l.promise;
            if (t.byteLength === 0) throw new Error("THREE.DRACOLoader: Unable to re-decode a buffer with different settings. Buffer has already been transferred.");
        }
        let i, s = this.workerNextTaskID++, o = t.byteLength, a = this._getWorker(s, o).then((l)=>(i = l, new Promise((u, c)=>{
                i._callbacks[s] = {
                    resolve: u,
                    reject: c
                }, i.postMessage({
                    type: "decode",
                    id: s,
                    taskConfig: e,
                    buffer: t
                }, [
                    t
                ]);
            }))).then((l)=>this._createGeometry(l.geometry));
        return a.catch(()=>!0).then(()=>{
            i && s && this._releaseTask(i, s);
        }), IS.set(t, {
            key: n,
            promise: a
        }), a;
    }
    _createGeometry(t) {
        let e = new Me;
        t.index && e.setIndex(new Be(t.index.array, 1));
        for(let n = 0; n < t.attributes.length; n++){
            let i = t.attributes[n], s = i.name, o = i.array, a = i.itemSize;
            e.setAttribute(s, new Be(o, a));
        }
        return e;
    }
    _loadLibrary(t, e) {
        let n = new bc(this.manager);
        return n.setPath(this.decoderPath), n.setResponseType(e), n.setWithCredentials(this.withCredentials), new Promise((i, s)=>{
            n.load(t, i, void 0, s);
        });
    }
    preload() {
        return this._initDecoder(), this;
    }
    _initDecoder() {
        if (this.decoderPending) return this.decoderPending;
        let t = typeof WebAssembly != "object" || this.decoderConfig.type === "js", e = [];
        return t ? e.push(this._loadLibrary("draco_decoder.js", "text")) : (e.push(this._loadLibrary("draco_wasm_wrapper.js", "text")), e.push(this._loadLibrary("draco_decoder.wasm", "arraybuffer"))), this.decoderPending = Promise.all(e).then((n)=>{
            let i = n[0];
            t || (this.decoderConfig.wasmBinary = n[1]);
            let s = Z6.toString(), o = [
                "/* draco decoder */",
                i,
                "",
                "/* worker */",
                s.substring(s.indexOf("{") + 1, s.lastIndexOf("}"))
            ].join(`
`);
            this.workerSourceURL = URL.createObjectURL(new Blob([
                o
            ]));
        }), this.decoderPending;
    }
    _getWorker(t, e) {
        return this._initDecoder().then(()=>{
            if (this.workerPool.length < this.workerLimit) {
                let i = new Worker(this.workerSourceURL);
                i._callbacks = {}, i._taskCosts = {}, i._taskLoad = 0, i.postMessage({
                    type: "init",
                    decoderConfig: this.decoderConfig
                }), i.onmessage = function(s) {
                    let o = s.data;
                    switch(o.type){
                        case "decode":
                            i._callbacks[o.id].resolve(o);
                            break;
                        case "error":
                            i._callbacks[o.id].reject(o);
                            break;
                        default:
                            console.error('THREE.DRACOLoader: Unexpected message, "' + o.type + '"');
                    }
                }, this.workerPool.push(i);
            } else this.workerPool.sort(function(i, s) {
                return i._taskLoad > s._taskLoad ? -1 : 1;
            });
            let n = this.workerPool[this.workerPool.length - 1];
            return n._taskCosts[t] = e, n._taskLoad += e, n;
        });
    }
    _releaseTask(t, e) {
        t._taskLoad -= t._taskCosts[e], delete t._callbacks[e], delete t._taskCosts[e];
    }
    debug() {
        console.log("Task load: ", this.workerPool.map((t)=>t._taskLoad));
    }
    dispose() {
        for(let t = 0; t < this.workerPool.length; ++t)this.workerPool[t].terminate();
        return this.workerPool.length = 0, this.workerSourceURL !== "" && URL.revokeObjectURL(this.workerSourceURL), this;
    }
};
function Z6() {
    let r1, t;
    onmessage = function(o) {
        let a = o.data;
        switch(a.type){
            case "init":
                r1 = a.decoderConfig, t = new Promise(function(c) {
                    r1.onModuleLoaded = function(d) {
                        c({
                            draco: d
                        });
                    }, DracoDecoderModule(r1);
                });
                break;
            case "decode":
                let l = a.buffer, u = a.taskConfig;
                t.then((c)=>{
                    let d = c.draco, h = new d.Decoder, f = new d.DecoderBuffer;
                    f.Init(new Int8Array(l), l.byteLength);
                    try {
                        let m = e(d, h, f, u), p = m.attributes.map((g)=>g.array.buffer);
                        m.index && p.push(m.index.array.buffer), self.postMessage({
                            type: "decode",
                            id: a.id,
                            geometry: m
                        }, p);
                    } catch (m) {
                        console.error(m), self.postMessage({
                            type: "error",
                            id: a.id,
                            error: m.message
                        });
                    } finally{
                        d.destroy(f), d.destroy(h);
                    }
                });
                break;
        }
    };
    function e(o, a, l, u) {
        let c = u.attributeIDs, d = u.attributeTypes, h, f, m = a.GetEncodedGeometryType(l);
        if (m === o.TRIANGULAR_MESH) h = new o.Mesh, f = a.DecodeBufferToMesh(l, h);
        else if (m === o.POINT_CLOUD) h = new o.PointCloud, f = a.DecodeBufferToPointCloud(l, h);
        else throw new Error("THREE.DRACOLoader: Unexpected geometry type.");
        if (!f.ok() || h.ptr === 0) throw new Error("THREE.DRACOLoader: Decoding failed: " + f.error_msg());
        let p = {
            index: null,
            attributes: []
        };
        for(let g in c){
            let y = self[d[g]], v, x;
            if (u.useUniqueIDs) x = c[g], v = a.GetAttributeByUniqueId(h, x);
            else {
                if (x = a.GetAttributeId(h, o[c[g]]), x === -1) continue;
                v = a.GetAttribute(h, x);
            }
            p.attributes.push(i(o, a, h, g, y, v));
        }
        return m === o.TRIANGULAR_MESH && (p.index = n(o, a, h)), o.destroy(h), p;
    }
    function n(o, a, l) {
        let c = l.num_faces() * 3, d = c * 4, h = o._malloc(d);
        a.GetTrianglesUInt32Array(l, d, h);
        let f = new Uint32Array(o.HEAPF32.buffer, h, c).slice();
        return o._free(h), {
            array: f,
            itemSize: 1
        };
    }
    function i(o, a, l, u, c, d) {
        let h = d.num_components(), m = l.num_points() * h, p = m * c.BYTES_PER_ELEMENT, g = s(o, c), y = o._malloc(p);
        a.GetAttributeDataArrayForAllPoints(l, d, g, p, y);
        let v = new c(o.HEAPF32.buffer, y, m).slice();
        return o._free(y), {
            name: u,
            array: v,
            itemSize: h
        };
    }
    function s(o, a) {
        switch(a){
            case Float32Array:
                return o.DT_FLOAT32;
            case Int8Array:
                return o.DT_INT8;
            case Int16Array:
                return o.DT_INT16;
            case Int32Array:
                return o.DT_INT32;
            case Uint8Array:
                return o.DT_UINT8;
            case Uint16Array:
                return o.DT_UINT16;
            case Uint32Array:
                return o.DT_UINT32;
        }
    }
}
var Ca;
function J6() {
    return Ca || (Ca = new lv, Ca.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.2/").preload()), Ca.decoderPending;
}
async function $6(r1) {
    if (Ca) {
        let t = {
            attributeIDs: Ca.defaultAttributeIDs,
            attributeTypes: Ca.defaultAttributeTypes,
            useUniqueIDs: !1
        }, e;
        try {
            e = await Ca.decodeGeometry(new Int8Array(r1).buffer, t);
        } catch (n) {
            console.error(n);
        }
        if (e) return {
            index: e.index ? {
                array: e.index.array
            } : void 0,
            attributes: Object.entries(e.attributes).map(([n, i])=>({
                    name: n,
                    itemSize: i.itemSize,
                    array: i.array
                }))
        };
    }
    return null;
}
async function qD(r1, t) {
    let [e, n] = Dx(ng.deserialize(new Uint8Array(r1)));
    NE(e);
    let i = [];
    e.scene.objects.traverse((s, o)=>{
        o.type === "Mesh" && o.geometry.type === "NonParametricGeometry" && o.geometry.data.draco !== void 0 && i.push(o);
    }), i.length && await J6();
    for (let s of i){
        let o = await $6(ir(s.geometry.data.draco));
        if (o) {
            o.index && (s.geometry.data.index = {
                array: o.index.array,
                itemSize: 1,
                normalized: !1,
                type: "Uint32Array"
            });
            let a = {};
            o.attributes.forEach(({ name: l , array: u , itemSize: c  })=>{
                a[l] = {
                    array: u,
                    itemSize: c,
                    type: "Float32Array",
                    normalized: !1
                };
            }), s.geometry.data.attributes = a, s.geometry.data.draco = void 0;
        }
    }
    return t && t(e), n.result().data;
}
var XD = Object.keys(Vw).filter((r1)=>isNaN(Number(r1))), cv = class {
    constructor(t, e, n){
        this.controlsManager = e;
        this.eventContext = n;
        this.isEnable = !1;
        this._isPaused = !1;
        this.onResetRaycaster = ()=>{
            this.eventContext.raycasterNeedsUpdate = !0;
        };
        this.onTouchMovePreventScroll = (t)=>{
            (t.touches.length > 1 || this.preventTouchScroll) && t.preventDefault();
        };
        this.onMouseWheelPreventScroll = (t)=>{
            this.preventScroll && t.preventDefault();
        };
        this.stopRaycast = t.stopRaycast, this.preventScroll = t.preventScroll, this.preventTouchScroll = t.preventTouchScroll, this.hideCursor = t.hideCursor, this.requestRender = n.requestRender;
        let i = {
            controlsManager: e,
            eventManager: this
        };
        this.handlers = {
            Spline: new jy(this.eventContext),
            ["Conditional"]: new Yy(this.eventContext, i),
            ["Start"]: new tv(this.eventContext, i),
            Basic: new qy(this.eventContext, i),
            ["MouseHover"]: new $y(this.eventContext, i),
            ["Scroll"]: new ev(this.eventContext, i),
            ["Follow"]: new Ky(this.eventContext, i),
            ["DragDrop"]: new Qy(this.eventContext, i),
            ["LookAt"]: new Jy(this.eventContext)
        };
    }
    activate() {
        if (this.isPaused) return;
        let { scene: t , domElement: e , eventElement: n  } = this.eventContext;
        this.hideCursor && (e.style.cursor = "none"), this.isEnable = !0, t.traverseEntity((i)=>{
            i.addEventListener("requestRender", this.requestRender);
        }), Object.values(this.handlers).forEach((i)=>i.connect()), XD.forEach((i)=>{
            (Object.values(this.handlers).some((s)=>s.domEventsNeeded.has(i)) || i === "pointerdown" && this.controlsManager.navigationMeshWrapper) && (e.addEventListener(i, this.onResetRaycaster), n.addEventListener(i, this.onResetRaycaster));
        }), e.addEventListener("wheel", this.onMouseWheelPreventScroll), e.addEventListener("touchmove", this.onTouchMovePreventScroll);
    }
    deactivate() {
        let { scene: t , domElement: e  } = this.eventContext;
        this.isEnable = !1, e.style.cursor = "", Object.values(this.handlers).forEach((n)=>n.disconnect()), this.controlsManager.gameControls.forEach((n)=>{
            n.disposeActions();
        }), this.controlsManager.disconnectCollisionEvents(), t.traverseEntity((n)=>{
            n.removeEventListener("requestRender", this.requestRender);
        }), XD.forEach((n)=>{
            e.removeEventListener(n, this.onResetRaycaster);
        }), e.removeEventListener("touchmove", this.onTouchMovePreventScroll), e.removeEventListener("wheel", this.onMouseWheelPreventScroll);
    }
    get isPaused() {
        return this._isPaused;
    }
    pause() {
        this._isPaused = !0, this.deactivate();
    }
    resume() {
        this._isPaused = !1, this.activate();
    }
    reset() {
        this.deactivate(), this.activate();
    }
    updateUseWindowEvents(t) {
        let e = this.isEnable;
        e && this.deactivate(), this.eventContext.useWindowEvents = t, e && this.activate();
    }
};
var uv = class {
    constructor(t, e, n, i, s){
        this._aspect = 1;
        this._renderer = t, this._camera = e, this._frameSize = new F().copy(n), this._editorSize = new F().copy(i), this._aspect = e.aspect, this._fov = s ?? e.fov;
    }
    set frameSize(t) {
        this._frameSize.copy(t);
    }
    updateRenderer() {
        !this._renderer || this._renderer.setSize(this._frameSize.x, this._frameSize.y);
    }
    updateViewport() {
        if (!this._renderer || !this._camera || this._camera.cameraType !== "PerspectiveCamera") return;
        let t = this._frameSize.x, e = this._frameSize.y, n = this._editorSize.y;
        this._aspect = t / e, e <= n && (this._camera.zoom *= n / e), this._renderer.setViewport(0, 0, t, e);
    }
    updateCamera() {
        if (!!this._camera) {
            if (this._camera.cameraType === "PerspectiveCamera") {
                let t = this._frameSize.y, e = this._editorSize.y, n = this._fov;
                if (t > e) {
                    let i = e8(t, 1080, 2160, 1, 15) / 100;
                    n *= t / e, n *= 1 - i;
                }
                this._camera.aspect = this._aspect, this._camera.fov = n, this._camera.updateProjectionMatrix();
            } else this._camera.setViewplaneSize(this._frameSize.x, this._frameSize.y);
        }
    }
    setCamera(t) {
        this._camera = t, this._aspect = t.aspect, this._fov = t.fov;
    }
    revert() {
        let t = window.innerWidth, e = window.innerHeight;
        this._renderer && (this._renderer.setViewport(0, 0, t, e), this._renderer.setSize(t, e)), this._camera && (this._camera.aspect = t / e, this._camera.fov = this._fov, this._camera.setViewplaneSize(t, e), this._camera.updateProjectionMatrix());
    }
};
function e8(r1, t, e, n, i) {
    return (r1 - t) / (e - t) * (i - n) + n;
}
var eI = {
    RED: 0,
    GREEN: 1,
    BLUE: 2,
    ALPHA: 3
};
var ep = "varying vec2 vUv;void main(){vUv=position.xy*0.5+0.5;gl_Position=vec4(position.xy,1.0,1.0);}";
var t8 = `#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D inputBuffer;
#else
uniform lowp sampler2D inputBuffer;
#endif
uniform lowp sampler2D cocBuffer;uniform vec2 texelSize;uniform float scale;
#if PASS == 1
uniform vec4 kernel64[32];
#else
uniform vec4 kernel16[8];
#endif
varying vec2 vUv;void main(){
#ifdef FOREGROUND
vec2 CoCNearFar=texture2D(cocBuffer,vUv).rg;float CoC=CoCNearFar.r*scale;
#else
float CoC=texture2D(cocBuffer,vUv).g*scale;
#endif
if(CoC==0.0){gl_FragColor=texture2D(inputBuffer,vUv);}else{
#ifdef FOREGROUND
vec2 step=texelSize*max(CoC,CoCNearFar.g*scale);
#else
vec2 step=texelSize*CoC;
#endif
#if PASS == 1
vec4 acc=vec4(0.0);for(int i=0;i<32;++i){vec4 kernel=kernel64[i];vec2 uv=step*kernel.xy+vUv;acc+=texture2D(inputBuffer,uv);uv=step*kernel.zw+vUv;acc+=texture2D(inputBuffer,uv);}gl_FragColor=acc/64.0;
#else
vec4 maxValue=texture2D(inputBuffer,vUv);for(int i=0;i<8;++i){vec4 kernel=kernel16[i];vec2 uv=step*kernel.xy+vUv;maxValue=max(texture2D(inputBuffer,uv),maxValue);uv=step*kernel.zw+vUv;maxValue=max(texture2D(inputBuffer,uv),maxValue);}gl_FragColor=maxValue;
#endif
}}`, dv = class extends ot {
    constructor(r1 = !1, t = !1){
        super({
            name: "BokehMaterial",
            defines: {
                PASS: r1 ? "2" : "1"
            },
            uniforms: {
                kernel64: new ie(null),
                kernel16: new ie(null),
                inputBuffer: new ie(null),
                cocBuffer: new ie(null),
                texelSize: new ie(new F),
                scale: new ie(1)
            },
            blending: Dt,
            depthWrite: !1,
            depthTest: !1,
            fragmentShader: t8,
            vertexShader: ep
        }), this.toneMapped = !1, t && (this.defines.FOREGROUND = "1"), this.generateKernel();
    }
    set inputBuffer(r1) {
        this.uniforms.inputBuffer.value = r1;
    }
    setInputBuffer(r1) {
        this.uniforms.inputBuffer.value = r1;
    }
    set cocBuffer(r1) {
        this.uniforms.cocBuffer.value = r1;
    }
    setCoCBuffer(r1) {
        this.uniforms.cocBuffer.value = r1;
    }
    get scale() {
        return this.uniforms.scale.value;
    }
    set scale(r1) {
        this.uniforms.scale.value = r1;
    }
    getScale(r1) {
        return this.uniforms.scale.value = r1;
    }
    setScale(r1) {
        this.uniforms.scale.value = r1;
    }
    generateKernel() {
        let r1 = 2.39996323, t = new Float32Array(128), e = new Float32Array(32), n = 0, i = 0;
        for(let a = 0; a < 80; ++a){
            let l = a * r1, u = Math.sqrt(a) / Math.sqrt(80), c = u * Math.cos(l), d = u * Math.sin(l);
            a % 5 === 0 ? (e[i++] = c, e[i++] = d) : (t[n++] = c, t[n++] = d);
        }
        let s = [], o = [];
        for(let a = 0; a < 128;)s.push(new Ze(t[a++], t[a++], t[a++], t[a++]));
        for(let a = 0; a < 32;)o.push(new Ze(e[a++], e[a++], e[a++], e[a++]));
        this.uniforms.kernel64.value = s, this.uniforms.kernel16.value = o;
    }
    setTexelSize(r1, t) {
        this.uniforms.texelSize.value.set(r1, t);
    }
    setSize(r1, t) {
        this.uniforms.texelSize.value.set(1 / r1, 1 / t);
    }
};
function YD(r1, t, e) {
    return r1 * (t - e) - t;
}
function BS(r1, t, e) {
    return Math.min(Math.max((r1 + t) / (t - e), 0), 1);
}
var n8 = `#include <common>
#include <packing>
#ifdef GL_FRAGMENT_PRECISION_HIGH
uniform highp sampler2D depthBuffer;
#else
uniform mediump sampler2D depthBuffer;
#endif
uniform float focusDistance;uniform float focusRange;uniform float cameraNear;uniform float cameraFar;varying vec2 vUv;float readDepth(const in vec2 uv){
#if DEPTH_PACKING == 3201
return unpackRGBAToDepth(texture2D(depthBuffer,uv));
#else
return texture2D(depthBuffer,uv).r;
#endif
}void main(){float depth=readDepth(vUv);
#ifdef PERSPECTIVE_CAMERA
float viewZ=perspectiveDepthToViewZ(depth,cameraNear,cameraFar);float linearDepth=viewZToOrthographicDepth(viewZ,cameraNear,cameraFar);
#else
float linearDepth=depth;
#endif
float signedDistance=linearDepth-focusDistance;float magnitude=smoothstep(0.0,focusRange,abs(signedDistance));gl_FragColor.rg=magnitude*vec2(step(signedDistance,0.0),step(0.0,signedDistance));}`, r8 = class extends ot {
    constructor(r1){
        super({
            name: "CircleOfConfusionMaterial",
            defines: {
                DEPTH_PACKING: "0"
            },
            uniforms: {
                depthBuffer: new ie(null),
                focusDistance: new ie(0),
                focusRange: new ie(0),
                cameraNear: new ie(.3),
                cameraFar: new ie(1e3)
            },
            blending: Dt,
            depthWrite: !1,
            depthTest: !1,
            fragmentShader: n8,
            vertexShader: ep
        }), this.toneMapped = !1, this.uniforms.focalLength = this.uniforms.focusRange, this.adoptCameraSettings(r1);
    }
    get near() {
        return this.uniforms.cameraNear.value;
    }
    get far() {
        return this.uniforms.cameraFar.value;
    }
    set depthBuffer(r1) {
        this.uniforms.depthBuffer.value = r1;
    }
    set depthPacking(r1) {
        this.defines.DEPTH_PACKING = r1.toFixed(0), this.needsUpdate = !0;
    }
    setDepthBuffer(r1, t = tr) {
        this.depthBuffer = r1, this.depthPacking = t;
    }
    get focusDistance() {
        return this.uniforms.focusDistance.value;
    }
    set focusDistance(r1) {
        this.uniforms.focusDistance.value = r1;
    }
    get worldFocusDistance() {
        return -YD(this.focusDistance, this.near, this.far);
    }
    set worldFocusDistance(r1) {
        this.focusDistance = BS(-r1, this.near, this.far);
    }
    getFocusDistance(r1) {
        this.uniforms.focusDistance.value = r1;
    }
    setFocusDistance(r1) {
        this.uniforms.focusDistance.value = r1;
    }
    get focalLength() {
        return this.focusRange;
    }
    set focalLength(r1) {
        this.focusRange = r1;
    }
    get focusRange() {
        return this.uniforms.focusRange.value;
    }
    set focusRange(r1) {
        this.uniforms.focusRange.value = r1;
    }
    get worldFocusRange() {
        return -YD(this.focusRange, this.near, this.far);
    }
    set worldFocusRange(r1) {
        this.focusRange = BS(-r1, this.near, this.far);
    }
    getFocalLength(r1) {
        return this.focusRange;
    }
    setFocalLength(r1) {
        this.focusRange = r1;
    }
    adoptCameraSettings(r1) {
        r1 && (this.uniforms.cameraNear.value = r1.near, this.uniforms.cameraFar.value = r1.far, r1 instanceof gn ? this.defines.PERSPECTIVE_CAMERA = "1" : delete this.defines.PERSPECTIVE_CAMERA, this.needsUpdate = !0);
    }
}, i8 = `#include <common>
#include <dithering_pars_fragment>
#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D inputBuffer;
#else
uniform lowp sampler2D inputBuffer;
#endif
varying vec2 vUv0;varying vec2 vUv1;varying vec2 vUv2;varying vec2 vUv3;void main(){vec4 sum=texture2D(inputBuffer,vUv0);sum+=texture2D(inputBuffer,vUv1);sum+=texture2D(inputBuffer,vUv2);sum+=texture2D(inputBuffer,vUv3);gl_FragColor=sum*0.25;
#include <encodings_fragment>
#include <dithering_fragment>
}`, s8 = "uniform vec2 texelSize;uniform vec2 halfTexelSize;uniform float kernel;uniform float scale;varying vec2 vUv0;varying vec2 vUv1;varying vec2 vUv2;varying vec2 vUv3;void main(){vec2 uv=position.xy*0.5+0.5;vec2 dUv=(texelSize*vec2(kernel)+halfTexelSize)*scale;vUv0=vec2(uv.x-dUv.x,uv.y+dUv.y);vUv1=vec2(uv.x+dUv.x,uv.y+dUv.y);vUv2=vec2(uv.x+dUv.x,uv.y-dUv.y);vUv3=vec2(uv.x-dUv.x,uv.y-dUv.y);gl_Position=vec4(position.xy,1.0,1.0);}", QD = class extends ot {
    constructor(r1 = new F){
        super({
            name: "KawaseBlurMaterial",
            uniforms: {
                inputBuffer: new ie(null),
                texelSize: new ie(new F),
                halfTexelSize: new ie(new F),
                kernel: new ie(0),
                scale: new ie(1)
            },
            blending: Dt,
            depthWrite: !1,
            depthTest: !1,
            fragmentShader: i8,
            vertexShader: s8
        }), this.toneMapped = !1, this.setTexelSize(r1.x, r1.y);
    }
    set inputBuffer(r1) {
        this.uniforms.inputBuffer.value = r1;
    }
    setInputBuffer(r1) {
        this.inputBuffer = r1;
    }
    get scale() {
        return this.uniforms.scale.value;
    }
    set scale(r1) {
        this.uniforms.scale.value = r1;
    }
    getScale() {
        return this.uniforms.scale.value;
    }
    setScale(r1) {
        this.uniforms.scale.value = r1;
    }
    getKernel() {
        return null;
    }
    get kernel() {
        return this.uniforms.kernel.value;
    }
    set kernel(r1) {
        this.uniforms.kernel.value = r1;
    }
    setKernel(r1) {
        this.kernel = r1;
    }
    setTexelSize(r1, t) {
        this.uniforms.texelSize.value.set(r1, t), this.uniforms.halfTexelSize.value.set(r1, t).multiplyScalar(.5);
    }
    setSize(r1, t) {
        let e = this.uniforms;
        e.texelSize.value.set(1 / r1, 1 / t), e.halfTexelSize.value.copy(e.texelSize.value).multiplyScalar(.5);
    }
}, o8 = `#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D inputBuffer;
#else
uniform lowp sampler2D inputBuffer;
#endif
uniform float opacity;varying vec2 vUv;void main(){vec4 texel=texture2D(inputBuffer,vUv);gl_FragColor=opacity*texel;
#include <encodings_fragment>
}`, a8 = class extends ot {
    constructor(){
        super({
            name: "CopyMaterial",
            uniforms: {
                inputBuffer: new ie(null),
                opacity: new ie(1)
            },
            blending: Dt,
            depthWrite: !1,
            depthTest: !1,
            fragmentShader: o8,
            vertexShader: ep
        }), this.toneMapped = !1;
    }
    set inputBuffer(r1) {
        this.uniforms.inputBuffer.value = r1;
    }
    setInputBuffer(r1) {
        this.uniforms.inputBuffer.value = r1;
    }
    getOpacity(r1) {
        return this.uniforms.opacity.value;
    }
    setOpacity(r1) {
        this.uniforms.opacity.value = r1;
    }
};
var l8 = `varying vec2 vUv;varying vec2 vUv0;varying vec2 vUv1;
#if THREE_REVISION < 143
#define luminance(v) linearToRelativeLuminance(v)
#endif
#if EDGE_DETECTION_MODE != 0
varying vec2 vUv2;varying vec2 vUv3;varying vec2 vUv4;varying vec2 vUv5;
#endif
#if EDGE_DETECTION_MODE == 1
#include <common>
#endif
#if EDGE_DETECTION_MODE == 0 || PREDICATION_MODE == 1
#ifdef GL_FRAGMENT_PRECISION_HIGH
uniform highp sampler2D depthBuffer;
#else
uniform mediump sampler2D depthBuffer;
#endif
float readDepth(const in vec2 uv){
#if DEPTH_PACKING == 3201
return unpackRGBAToDepth(texture2D(depthBuffer,uv));
#else
return texture2D(depthBuffer,uv).r;
#endif
}vec3 gatherNeighbors(){float p=readDepth(vUv);float pLeft=readDepth(vUv0);float pTop=readDepth(vUv1);return vec3(p,pLeft,pTop);}
#elif PREDICATION_MODE == 2
uniform sampler2D predicationBuffer;vec3 gatherNeighbors(){float p=texture2D(predicationBuffer,vUv).r;float pLeft=texture2D(predicationBuffer,vUv0).r;float pTop=texture2D(predicationBuffer,vUv1).r;return vec3(p,pLeft,pTop);}
#endif
#if PREDICATION_MODE != 0
vec2 calculatePredicatedThreshold(){vec3 neighbours=gatherNeighbors();vec2 delta=abs(neighbours.xx-neighbours.yz);vec2 edges=step(PREDICATION_THRESHOLD,delta);return PREDICATION_SCALE*EDGE_THRESHOLD*(1.0-PREDICATION_STRENGTH*edges);}
#endif
#if EDGE_DETECTION_MODE != 0
uniform sampler2D inputBuffer;
#endif
void main(){
#if EDGE_DETECTION_MODE == 0
const vec2 threshold=vec2(DEPTH_THRESHOLD);
#elif PREDICATION_MODE != 0
vec2 threshold=calculatePredicatedThreshold();
#else
const vec2 threshold=vec2(EDGE_THRESHOLD);
#endif
#if EDGE_DETECTION_MODE == 0
vec3 neighbors=gatherNeighbors();vec2 delta=abs(neighbors.xx-vec2(neighbors.y,neighbors.z));vec2 edges=step(threshold,delta);if(dot(edges,vec2(1.0))==0.0){discard;}gl_FragColor=vec4(edges,0.0,1.0);
#elif EDGE_DETECTION_MODE == 1
float l=luminance(texture2D(inputBuffer,vUv).rgb);float lLeft=luminance(texture2D(inputBuffer,vUv0).rgb);float lTop=luminance(texture2D(inputBuffer,vUv1).rgb);vec4 delta;delta.xy=abs(l-vec2(lLeft,lTop));vec2 edges=step(threshold,delta.xy);if(dot(edges,vec2(1.0))==0.0){discard;}float lRight=luminance(texture2D(inputBuffer,vUv2).rgb);float lBottom=luminance(texture2D(inputBuffer,vUv3).rgb);delta.zw=abs(l-vec2(lRight,lBottom));vec2 maxDelta=max(delta.xy,delta.zw);float lLeftLeft=luminance(texture2D(inputBuffer,vUv4).rgb);float lTopTop=luminance(texture2D(inputBuffer,vUv5).rgb);delta.zw=abs(vec2(lLeft,lTop)-vec2(lLeftLeft,lTopTop));maxDelta=max(maxDelta.xy,delta.zw);float finalDelta=max(maxDelta.x,maxDelta.y);edges.xy*=step(finalDelta,LOCAL_CONTRAST_ADAPTATION_FACTOR*delta.xy);gl_FragColor=vec4(edges,0.0,1.0);
#elif EDGE_DETECTION_MODE == 2
vec4 delta;vec3 c=texture2D(inputBuffer,vUv).rgb;vec3 cLeft=texture2D(inputBuffer,vUv0).rgb;vec3 t=abs(c-cLeft);delta.x=max(max(t.r,t.g),t.b);vec3 cTop=texture2D(inputBuffer,vUv1).rgb;t=abs(c-cTop);delta.y=max(max(t.r,t.g),t.b);vec2 edges=step(threshold,delta.xy);if(dot(edges,vec2(1.0))==0.0){discard;}vec3 cRight=texture2D(inputBuffer,vUv2).rgb;t=abs(c-cRight);delta.z=max(max(t.r,t.g),t.b);vec3 cBottom=texture2D(inputBuffer,vUv3).rgb;t=abs(c-cBottom);delta.w=max(max(t.r,t.g),t.b);vec2 maxDelta=max(delta.xy,delta.zw);vec3 cLeftLeft=texture2D(inputBuffer,vUv4).rgb;t=abs(c-cLeftLeft);delta.z=max(max(t.r,t.g),t.b);vec3 cTopTop=texture2D(inputBuffer,vUv5).rgb;t=abs(c-cTopTop);delta.w=max(max(t.r,t.g),t.b);maxDelta=max(maxDelta.xy,delta.zw);float finalDelta=max(maxDelta.x,maxDelta.y);edges*=step(finalDelta,LOCAL_CONTRAST_ADAPTATION_FACTOR*delta.xy);gl_FragColor=vec4(edges,0.0,1.0);
#endif
}`, c8 = `uniform vec2 texelSize;varying vec2 vUv;varying vec2 vUv0;varying vec2 vUv1;
#if EDGE_DETECTION_MODE != 0
varying vec2 vUv2;varying vec2 vUv3;varying vec2 vUv4;varying vec2 vUv5;
#endif
void main(){vUv=position.xy*0.5+0.5;vUv0=vUv+texelSize*vec2(-1.0,0.0);vUv1=vUv+texelSize*vec2(0.0,-1.0);
#if EDGE_DETECTION_MODE != 0
vUv2=vUv+texelSize*vec2(1.0,0.0);vUv3=vUv+texelSize*vec2(0.0,1.0);vUv4=vUv+texelSize*vec2(-2.0,0.0);vUv5=vUv+texelSize*vec2(0.0,-2.0);
#endif
gl_Position=vec4(position.xy,1.0,1.0);}`, kd = {
    DEPTH: 0,
    LUMA: 1,
    COLOR: 2
}, u8 = {
    DISABLED: 0,
    DEPTH: 1,
    CUSTOM: 2
}, d8 = class extends ot {
    constructor(r1 = new F, t = kd.COLOR){
        super({
            name: "EdgeDetectionMaterial",
            defines: {
                THREE_REVISION: ao.replace(/\D+/g, ""),
                LOCAL_CONTRAST_ADAPTATION_FACTOR: "2.0",
                EDGE_THRESHOLD: "0.1",
                DEPTH_THRESHOLD: "0.01",
                PREDICATION_MODE: "0",
                PREDICATION_THRESHOLD: "0.01",
                PREDICATION_SCALE: "2.0",
                PREDICATION_STRENGTH: "1.0",
                DEPTH_PACKING: "0"
            },
            uniforms: {
                inputBuffer: new ie(null),
                depthBuffer: new ie(null),
                predicationBuffer: new ie(null),
                texelSize: new ie(r1)
            },
            blending: Dt,
            depthWrite: !1,
            depthTest: !1,
            fragmentShader: l8,
            vertexShader: c8
        }), this.toneMapped = !1, this.edgeDetectionMode = t;
    }
    set depthBuffer(r1) {
        this.uniforms.depthBuffer.value = r1;
    }
    set depthPacking(r1) {
        this.defines.DEPTH_PACKING = r1.toFixed(0), this.needsUpdate = !0;
    }
    setDepthBuffer(r1, t = tr) {
        this.depthBuffer = r1, this.depthPacking = t;
    }
    get edgeDetectionMode() {
        return Number(this.defines.EDGE_DETECTION_MODE);
    }
    set edgeDetectionMode(r1) {
        this.defines.EDGE_DETECTION_MODE = r1.toFixed(0), this.needsUpdate = !0;
    }
    getEdgeDetectionMode() {
        return this.edgeDetectionMode;
    }
    setEdgeDetectionMode(r1) {
        this.edgeDetectionMode = r1;
    }
    get localContrastAdaptationFactor() {
        return Number(this.defines.LOCAL_CONTRAST_ADAPTATION_FACTOR);
    }
    set localContrastAdaptationFactor(r1) {
        this.defines.LOCAL_CONTRAST_ADAPTATION_FACTOR = r1.toFixed("6"), this.needsUpdate = !0;
    }
    getLocalContrastAdaptationFactor() {
        return this.localContrastAdaptationFactor;
    }
    setLocalContrastAdaptationFactor(r1) {
        this.localContrastAdaptationFactor = r1;
    }
    get edgeDetectionThreshold() {
        return Number(this.defines.EDGE_THRESHOLD);
    }
    set edgeDetectionThreshold(r1) {
        this.defines.EDGE_THRESHOLD = r1.toFixed("6"), this.defines.DEPTH_THRESHOLD = (r1 * .1).toFixed("6"), this.needsUpdate = !0;
    }
    getEdgeDetectionThreshold() {
        return this.edgeDetectionThreshold;
    }
    setEdgeDetectionThreshold(r1) {
        this.edgeDetectionThreshold = r1;
    }
    get predicationMode() {
        return Number(this.defines.PREDICATION_MODE);
    }
    set predicationMode(r1) {
        this.defines.PREDICATION_MODE = r1.toFixed(0), this.needsUpdate = !0;
    }
    getPredicationMode() {
        return this.predicationMode;
    }
    setPredicationMode(r1) {
        this.predicationMode = r1;
    }
    set predicationBuffer(r1) {
        this.uniforms.predicationBuffer.value = r1;
    }
    setPredicationBuffer(r1) {
        this.uniforms.predicationBuffer.value = r1;
    }
    get predicationThreshold() {
        return Number(this.defines.PREDICATION_THRESHOLD);
    }
    set predicationThreshold(r1) {
        this.defines.PREDICATION_THRESHOLD = r1.toFixed("6"), this.needsUpdate = !0;
    }
    getPredicationThreshold() {
        return this.predicationThreshold;
    }
    setPredicationThreshold(r1) {
        this.predicationThreshold = r1;
    }
    get predicationScale() {
        return Number(this.defines.PREDICATION_SCALE);
    }
    set predicationScale(r1) {
        this.defines.PREDICATION_SCALE = r1.toFixed("6"), this.needsUpdate = !0;
    }
    getPredicationScale() {
        return this.predicationScale;
    }
    setPredicationScale(r1) {
        this.predicationScale = r1;
    }
    get predicationStrength() {
        return Number(this.defines.PREDICATION_STRENGTH);
    }
    set predicationStrength(r1) {
        this.defines.PREDICATION_STRENGTH = r1.toFixed("6"), this.needsUpdate = !0;
    }
    getPredicationStrength() {
        return this.predicationStrength;
    }
    setPredicationStrength(r1) {
        this.predicationStrength = r1;
    }
    setSize(r1, t) {
        this.uniforms.texelSize.value.set(1 / r1, 1 / t);
    }
}, h8 = `#include <common>
#include <packing>
#include <dithering_pars_fragment>
#define packFloatToRGBA(v) packDepthToRGBA(v)
#define unpackRGBAToFloat(v) unpackRGBAToDepth(v)
#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D inputBuffer;
#else
uniform lowp sampler2D inputBuffer;
#endif
#ifdef GL_FRAGMENT_PRECISION_HIGH
uniform highp sampler2D depthBuffer;
#else
uniform mediump sampler2D depthBuffer;
#endif
uniform vec2 resolution;uniform vec2 texelSize;uniform float cameraNear;uniform float cameraFar;uniform float aspect;uniform float time;varying vec2 vUv;
#if THREE_REVISION < 143
#define luminance(v) linearToRelativeLuminance(v)
#endif
#if THREE_REVISION >= 137
vec4 sRGBToLinear(const in vec4 value){return vec4(mix(pow(value.rgb*0.9478672986+vec3(0.0521327014),vec3(2.4)),value.rgb*0.0773993808,vec3(lessThanEqual(value.rgb,vec3(0.04045)))),value.a);}
#endif
float readDepth(const in vec2 uv){
#if DEPTH_PACKING == 3201
return unpackRGBAToDepth(texture2D(depthBuffer,uv));
#else
return texture2D(depthBuffer,uv).r;
#endif
}float getViewZ(const in float depth){
#ifdef PERSPECTIVE_CAMERA
return perspectiveDepthToViewZ(depth,cameraNear,cameraFar);
#else
return orthographicDepthToViewZ(depth,cameraNear,cameraFar);
#endif
}FRAGMENT_HEADvoid main(){FRAGMENT_MAIN_UVvec4 color0=texture2D(inputBuffer,UV);vec4 color1=vec4(0.0);FRAGMENT_MAIN_IMAGEgl_FragColor=color0;
#ifdef ENCODE_OUTPUT
#include <encodings_fragment>
#endif
#include <dithering_fragment>
}`, f8 = "uniform vec2 resolution;uniform vec2 texelSize;uniform float cameraNear;uniform float cameraFar;uniform float aspect;uniform float time;varying vec2 vUv;VERTEX_HEADvoid main(){vUv=position.xy*0.5+0.5;VERTEX_MAIN_SUPPORTgl_Position=vec4(position.xy,1.0,1.0);}", hs = {
    FRAGMENT_HEAD: "FRAGMENT_HEAD",
    FRAGMENT_MAIN_UV: "FRAGMENT_MAIN_UV",
    FRAGMENT_MAIN_IMAGE: "FRAGMENT_MAIN_IMAGE",
    VERTEX_HEAD: "VERTEX_HEAD",
    VERTEX_MAIN_SUPPORT: "VERTEX_MAIN_SUPPORT"
}, FS = class extends ot {
    constructor(r1, t, e, n, i = !1){
        super({
            name: "EffectMaterial",
            defines: {
                THREE_REVISION: ao.replace(/\D+/g, ""),
                DEPTH_PACKING: "0",
                ENCODE_OUTPUT: "1"
            },
            uniforms: {
                inputBuffer: new ie(null),
                depthBuffer: new ie(null),
                resolution: new ie(new F),
                texelSize: new ie(new F),
                cameraNear: new ie(.3),
                cameraFar: new ie(1e3),
                aspect: new ie(1),
                time: new ie(0)
            },
            blending: Dt,
            depthWrite: !1,
            depthTest: !1,
            dithering: i
        }), this.toneMapped = !1, r1 && this.setShaderParts(r1), t && this.setDefines(t), e && this.setUniforms(e), this.adoptCameraSettings(n);
    }
    set inputBuffer(r1) {
        this.uniforms.inputBuffer.value = r1;
    }
    setInputBuffer(r1) {
        this.uniforms.inputBuffer.value = r1;
    }
    get depthBuffer() {
        return this.uniforms.depthBuffer.value;
    }
    set depthBuffer(r1) {
        this.uniforms.depthBuffer.value = r1;
    }
    get depthPacking() {
        return Number(this.defines.DEPTH_PACKING);
    }
    set depthPacking(r1) {
        this.defines.DEPTH_PACKING = r1.toFixed(0), this.needsUpdate = !0;
    }
    setDepthBuffer(r1, t = tr) {
        this.depthBuffer = r1, this.depthPacking = t;
    }
    setShaderParts(r1) {
        return this.fragmentShader = h8.replace(hs.FRAGMENT_HEAD, r1.get(hs.FRAGMENT_HEAD)).replace(hs.FRAGMENT_MAIN_UV, r1.get(hs.FRAGMENT_MAIN_UV)).replace(hs.FRAGMENT_MAIN_IMAGE, r1.get(hs.FRAGMENT_MAIN_IMAGE)), this.vertexShader = f8.replace(hs.VERTEX_HEAD, r1.get(hs.VERTEX_HEAD)).replace(hs.VERTEX_MAIN_SUPPORT, r1.get(hs.VERTEX_MAIN_SUPPORT)), this.needsUpdate = !0, this;
    }
    setDefines(r1) {
        for (let t of r1.entries())this.defines[t[0]] = t[1];
        return this.needsUpdate = !0, this;
    }
    setUniforms(r1) {
        for (let t of r1.entries())this.uniforms[t[0]] = t[1];
        return this;
    }
    setExtensions(r1) {
        this.extensions = {};
        for (let t of r1)this.extensions[t] = !0;
        return this;
    }
    get encodeOutput() {
        return this.defines.ENCODE_OUTPUT !== void 0;
    }
    set encodeOutput(r1) {
        this.encodeOutput !== r1 && (r1 ? this.defines.ENCODE_OUTPUT = "1" : delete this.defines.ENCODE_OUTPUT, this.needsUpdate = !0);
    }
    isOutputEncodingEnabled(r1) {
        return this.encodeOutput;
    }
    setOutputEncodingEnabled(r1) {
        this.encodeOutput = r1;
    }
    get time() {
        return this.uniforms.time.value;
    }
    set time(r1) {
        this.uniforms.time.value = r1;
    }
    setDeltaTime(r1) {
        this.uniforms.time.value += r1;
    }
    adoptCameraSettings(r1) {
        r1 && (this.uniforms.cameraNear.value = r1.near, this.uniforms.cameraFar.value = r1.far, r1 instanceof gn ? this.defines.PERSPECTIVE_CAMERA = "1" : delete this.defines.PERSPECTIVE_CAMERA, this.needsUpdate = !0);
    }
    setSize(r1, t) {
        let e = this.uniforms;
        e.resolution.value.set(r1, t), e.texelSize.value.set(1 / r1, 1 / t), e.aspect.value = r1 / t;
    }
    static get Section() {
        return hs;
    }
};
var p8 = `#include <common>
#if THREE_REVISION < 143
#define luminance(v) linearToRelativeLuminance(v)
#endif
#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D inputBuffer;
#else
uniform lowp sampler2D inputBuffer;
#endif
#ifdef RANGE
uniform vec2 range;
#elif defined(THRESHOLD)
uniform float threshold;uniform float smoothing;
#endif
varying vec2 vUv;void main(){vec4 texel=texture2D(inputBuffer,vUv);float l=luminance(texel.rgb);
#ifdef RANGE
float low=step(range.x,l);float high=step(l,range.y);l*=low*high;
#elif defined(THRESHOLD)
l=smoothstep(threshold,threshold+smoothing,l);
#endif
#ifdef COLOR
gl_FragColor=vec4(texel.rgb*l,l);
#else
gl_FragColor=vec4(l);
#endif
}`, m8 = class extends ot {
    constructor(r1 = !1, t = null){
        super({
            name: "LuminanceMaterial",
            defines: {
                THREE_REVISION: ao.replace(/\D+/g, "")
            },
            uniforms: {
                inputBuffer: new ie(null),
                threshold: new ie(0),
                smoothing: new ie(1),
                range: new ie(null)
            },
            blending: Dt,
            depthWrite: !1,
            depthTest: !1,
            fragmentShader: p8,
            vertexShader: ep
        }), this.toneMapped = !1, this.colorOutput = r1, this.luminanceRange = t;
    }
    set inputBuffer(r1) {
        this.uniforms.inputBuffer.value = r1;
    }
    setInputBuffer(r1) {
        this.uniforms.inputBuffer.value = r1;
    }
    get threshold() {
        return this.uniforms.threshold.value;
    }
    set threshold(r1) {
        this.smoothing > 0 || r1 > 0 ? this.defines.THRESHOLD = "1" : delete this.defines.THRESHOLD, this.uniforms.threshold.value = r1;
    }
    getThreshold() {
        return this.threshold;
    }
    setThreshold(r1) {
        this.threshold = r1;
    }
    get smoothing() {
        return this.uniforms.smoothing.value;
    }
    set smoothing(r1) {
        this.threshold > 0 || r1 > 0 ? this.defines.THRESHOLD = "1" : delete this.defines.THRESHOLD, this.uniforms.smoothing.value = r1;
    }
    getSmoothingFactor() {
        return this.smoothing;
    }
    setSmoothingFactor(r1) {
        this.smoothing = r1;
    }
    get useThreshold() {
        return this.threshold > 0 || this.smoothing > 0;
    }
    set useThreshold(r1) {}
    get colorOutput() {
        return this.defines.COLOR !== void 0;
    }
    set colorOutput(r1) {
        r1 ? this.defines.COLOR = "1" : delete this.defines.COLOR, this.needsUpdate = !0;
    }
    isColorOutputEnabled(r1) {
        return this.colorOutput;
    }
    setColorOutputEnabled(r1) {
        this.colorOutput = r1;
    }
    get useRange() {
        return this.luminanceRange !== null;
    }
    set useRange(r1) {
        this.luminanceRange = null;
    }
    get luminanceRange() {
        return this.uniforms.range.value;
    }
    set luminanceRange(r1) {
        r1 !== null ? this.defines.RANGE = "1" : delete this.defines.RANGE, this.uniforms.range.value = r1, this.needsUpdate = !0;
    }
    getLuminanceRange() {
        return this.luminanceRange;
    }
    setLuminanceRange(r1) {
        this.luminanceRange = r1;
    }
}, g8 = `#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D inputBuffer;
#else
uniform lowp sampler2D inputBuffer;
#endif
#ifdef MASK_PRECISION_HIGH
uniform mediump sampler2D maskTexture;
#else
uniform lowp sampler2D maskTexture;
#endif
#if MASK_FUNCTION != 0
uniform float strength;
#endif
varying vec2 vUv;void main(){
#if COLOR_CHANNEL == 0
float mask=texture2D(maskTexture,vUv).r;
#elif COLOR_CHANNEL == 1
float mask=texture2D(maskTexture,vUv).g;
#elif COLOR_CHANNEL == 2
float mask=texture2D(maskTexture,vUv).b;
#else
float mask=texture2D(maskTexture,vUv).a;
#endif
#if MASK_FUNCTION == 0
#ifdef INVERTED
mask=step(mask,0.0);
#else
mask=1.0-step(mask,0.0);
#endif
#else
mask=clamp(mask*strength,0.0,1.0);
#ifdef INVERTED
mask=1.0-mask;
#endif
#endif
#if MASK_FUNCTION == 2
gl_FragColor=vec4(mask*texture2D(inputBuffer,vUv).rgb,mask);
#else
gl_FragColor=mask*texture2D(inputBuffer,vUv);
#endif
}`, tI = {
    DISCARD: 0,
    MULTIPLY: 1,
    MULTIPLY_RGB_SET_ALPHA: 2
}, y8 = class extends ot {
    constructor(r1 = null){
        super({
            name: "MaskMaterial",
            uniforms: {
                maskTexture: new ie(r1),
                inputBuffer: new ie(null),
                strength: new ie(1)
            },
            blending: Dt,
            depthWrite: !1,
            depthTest: !1,
            fragmentShader: g8,
            vertexShader: ep
        }), this.toneMapped = !1, this.setColorChannel(eI.RED), this.setMaskFunction(tI.DISCARD);
    }
    set inputBuffer(r1) {
        this.uniforms.inputBuffer.value = r1;
    }
    setInputBuffer(r1) {
        this.uniforms.inputBuffer.value = r1;
    }
    set maskTexture(r1) {
        this.uniforms.maskTexture.value = r1, delete this.defines.MASK_PRECISION_HIGH, r1.type !== qt && (this.defines.MASK_PRECISION_HIGH = "1"), this.needsUpdate = !0;
    }
    setMaskTexture(r1) {
        this.maskTexture = r1;
    }
    set colorChannel(r1) {
        this.defines.COLOR_CHANNEL = r1.toFixed(0), this.needsUpdate = !0;
    }
    setColorChannel(r1) {
        this.colorChannel = r1;
    }
    set maskFunction(r1) {
        this.defines.MASK_FUNCTION = r1.toFixed(0), this.needsUpdate = !0;
    }
    setMaskFunction(r1) {
        this.maskFunction = r1;
    }
    get inverted() {
        return this.defines.INVERTED !== void 0;
    }
    set inverted(r1) {
        this.inverted && !r1 ? delete this.defines.INVERTED : r1 && (this.defines.INVERTED = "1"), this.needsUpdate = !0;
    }
    isInverted() {
        return this.inverted;
    }
    setInverted(r1) {
        this.inverted = r1;
    }
    get strength() {
        return this.uniforms.strength.value;
    }
    set strength(r1) {
        this.uniforms.strength.value = r1;
    }
    getStrength() {
        return this.strength;
    }
    setStrength(r1) {
        this.strength = r1;
    }
};
var v8 = `#define sampleLevelZeroOffset(t, coord, offset) texture2D(t, coord + offset * texelSize)
#if __VERSION__ < 300
#define round(v) floor(v + 0.5)
#endif
#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D inputBuffer;
#else
uniform lowp sampler2D inputBuffer;
#endif
uniform lowp sampler2D areaTexture;uniform lowp sampler2D searchTexture;uniform vec2 texelSize;uniform vec2 resolution;varying vec2 vUv;varying vec4 vOffset[3];varying vec2 vPixCoord;void movec(const in bvec2 c,inout vec2 variable,const in vec2 value){if(c.x){variable.x=value.x;}if(c.y){variable.y=value.y;}}void movec(const in bvec4 c,inout vec4 variable,const in vec4 value){movec(c.xy,variable.xy,value.xy);movec(c.zw,variable.zw,value.zw);}vec2 decodeDiagBilinearAccess(in vec2 e){e.r=e.r*abs(5.0*e.r-5.0*0.75);return round(e);}vec4 decodeDiagBilinearAccess(in vec4 e){e.rb=e.rb*abs(5.0*e.rb-5.0*0.75);return round(e);}vec2 searchDiag1(const in vec2 texCoord,const in vec2 dir,out vec2 e){vec4 coord=vec4(texCoord,-1.0,1.0);vec3 t=vec3(texelSize,1.0);for(int i=0;i<MAX_SEARCH_STEPS_INT;++i){if(!(coord.z<float(MAX_SEARCH_STEPS_DIAG_INT-1)&&coord.w>0.9)){break;}coord.xyz=t*vec3(dir,1.0)+coord.xyz;e=texture2D(inputBuffer,coord.xy).rg;coord.w=dot(e,vec2(0.5));}return coord.zw;}vec2 searchDiag2(const in vec2 texCoord,const in vec2 dir,out vec2 e){vec4 coord=vec4(texCoord,-1.0,1.0);coord.x+=0.25*texelSize.x;vec3 t=vec3(texelSize,1.0);for(int i=0;i<MAX_SEARCH_STEPS_INT;++i){if(!(coord.z<float(MAX_SEARCH_STEPS_DIAG_INT-1)&&coord.w>0.9)){break;}coord.xyz=t*vec3(dir,1.0)+coord.xyz;e=texture2D(inputBuffer,coord.xy).rg;e=decodeDiagBilinearAccess(e);coord.w=dot(e,vec2(0.5));}return coord.zw;}vec2 areaDiag(const in vec2 dist,const in vec2 e,const in float offset){vec2 texCoord=vec2(AREATEX_MAX_DISTANCE_DIAG,AREATEX_MAX_DISTANCE_DIAG)*e+dist;texCoord=AREATEX_PIXEL_SIZE*texCoord+0.5*AREATEX_PIXEL_SIZE;texCoord.x+=0.5;texCoord.y+=AREATEX_SUBTEX_SIZE*offset;return texture2D(areaTexture,texCoord).rg;}vec2 calculateDiagWeights(const in vec2 texCoord,const in vec2 e,const in vec4 subsampleIndices){vec2 weights=vec2(0.0);vec4 d;vec2 end;if(e.r>0.0){d.xz=searchDiag1(texCoord,vec2(-1.0,1.0),end);d.x+=float(end.y>0.9);}else{d.xz=vec2(0.0);}d.yw=searchDiag1(texCoord,vec2(1.0,-1.0),end);if(d.x+d.y>2.0){vec4 coords=vec4(-d.x+0.25,d.x,d.y,-d.y-0.25)*texelSize.xyxy+texCoord.xyxy;vec4 c;c.xy=sampleLevelZeroOffset(inputBuffer,coords.xy,vec2(-1,0)).rg;c.zw=sampleLevelZeroOffset(inputBuffer,coords.zw,vec2(1,0)).rg;c.yxwz=decodeDiagBilinearAccess(c.xyzw);vec2 cc=vec2(2.0)*c.xz+c.yw;movec(bvec2(step(0.9,d.zw)),cc,vec2(0.0));weights+=areaDiag(d.xy,cc,subsampleIndices.z);}d.xz=searchDiag2(texCoord,vec2(-1.0,-1.0),end);if(sampleLevelZeroOffset(inputBuffer,texCoord,vec2(1,0)).r>0.0){d.yw=searchDiag2(texCoord,vec2(1.0),end);d.y+=float(end.y>0.9);}else{d.yw=vec2(0.0);}if(d.x+d.y>2.0){vec4 coords=vec4(-d.x,-d.x,d.y,d.y)*texelSize.xyxy+texCoord.xyxy;vec4 c;c.x=sampleLevelZeroOffset(inputBuffer,coords.xy,vec2(-1,0)).g;c.y=sampleLevelZeroOffset(inputBuffer,coords.xy,vec2(0,-1)).r;c.zw=sampleLevelZeroOffset(inputBuffer,coords.zw,vec2(1,0)).gr;vec2 cc=vec2(2.0)*c.xz+c.yw;movec(bvec2(step(0.9,d.zw)),cc,vec2(0.0));weights+=areaDiag(d.xy,cc,subsampleIndices.w).gr;}return weights;}float searchLength(const in vec2 e,const in float offset){vec2 scale=SEARCHTEX_SIZE*vec2(0.5,-1.0);vec2 bias=SEARCHTEX_SIZE*vec2(offset,1.0);scale+=vec2(-1.0,1.0);bias+=vec2(0.5,-0.5);scale*=1.0/SEARCHTEX_PACKED_SIZE;bias*=1.0/SEARCHTEX_PACKED_SIZE;return texture2D(searchTexture,scale*e+bias).r;}float searchXLeft(in vec2 texCoord,const in float end){vec2 e=vec2(0.0,1.0);for(int i=0;i<MAX_SEARCH_STEPS_INT;++i){if(!(texCoord.x>end&&e.g>0.8281&&e.r==0.0)){break;}e=texture2D(inputBuffer,texCoord).rg;texCoord=vec2(-2.0,0.0)*texelSize+texCoord;}float offset=-(255.0/127.0)*searchLength(e,0.0)+3.25;return texelSize.x*offset+texCoord.x;}float searchXRight(vec2 texCoord,const in float end){vec2 e=vec2(0.0,1.0);for(int i=0;i<MAX_SEARCH_STEPS_INT;++i){if(!(texCoord.x<end&&e.g>0.8281&&e.r==0.0)){break;}e=texture2D(inputBuffer,texCoord).rg;texCoord=vec2(2.0,0.0)*texelSize.xy+texCoord;}float offset=-(255.0/127.0)*searchLength(e,0.5)+3.25;return-texelSize.x*offset+texCoord.x;}float searchYUp(vec2 texCoord,const in float end){vec2 e=vec2(1.0,0.0);for(int i=0;i<MAX_SEARCH_STEPS_INT;++i){if(!(texCoord.y>end&&e.r>0.8281&&e.g==0.0)){break;}e=texture2D(inputBuffer,texCoord).rg;texCoord=-vec2(0.0,2.0)*texelSize.xy+texCoord;}float offset=-(255.0/127.0)*searchLength(e.gr,0.0)+3.25;return texelSize.y*offset+texCoord.y;}float searchYDown(vec2 texCoord,const in float end){vec2 e=vec2(1.0,0.0);for(int i=0;i<MAX_SEARCH_STEPS_INT;i++){if(!(texCoord.y<end&&e.r>0.8281&&e.g==0.0)){break;}e=texture2D(inputBuffer,texCoord).rg;texCoord=vec2(0.0,2.0)*texelSize.xy+texCoord;}float offset=-(255.0/127.0)*searchLength(e.gr,0.5)+3.25;return-texelSize.y*offset+texCoord.y;}vec2 area(const in vec2 dist,const in float e1,const in float e2,const in float offset){vec2 texCoord=vec2(AREATEX_MAX_DISTANCE)*round(4.0*vec2(e1,e2))+dist;texCoord=AREATEX_PIXEL_SIZE*texCoord+0.5*AREATEX_PIXEL_SIZE;texCoord.y=AREATEX_SUBTEX_SIZE*offset+texCoord.y;return texture2D(areaTexture,texCoord).rg;}void detectHorizontalCornerPattern(inout vec2 weights,const in vec4 texCoord,const in vec2 d){
#if !defined(DISABLE_CORNER_DETECTION)
vec2 leftRight=step(d.xy,d.yx);vec2 rounding=(1.0-CORNER_ROUNDING_NORM)*leftRight;rounding/=leftRight.x+leftRight.y;vec2 factor=vec2(1.0);factor.x-=rounding.x*sampleLevelZeroOffset(inputBuffer,texCoord.xy,vec2(0,1)).r;factor.x-=rounding.y*sampleLevelZeroOffset(inputBuffer,texCoord.zw,vec2(1,1)).r;factor.y-=rounding.x*sampleLevelZeroOffset(inputBuffer,texCoord.xy,vec2(0,-2)).r;factor.y-=rounding.y*sampleLevelZeroOffset(inputBuffer,texCoord.zw,vec2(1,-2)).r;weights*=clamp(factor,0.0,1.0);
#endif
}void detectVerticalCornerPattern(inout vec2 weights,const in vec4 texCoord,const in vec2 d){
#if !defined(DISABLE_CORNER_DETECTION)
vec2 leftRight=step(d.xy,d.yx);vec2 rounding=(1.0-CORNER_ROUNDING_NORM)*leftRight;rounding/=leftRight.x+leftRight.y;vec2 factor=vec2(1.0);factor.x-=rounding.x*sampleLevelZeroOffset(inputBuffer,texCoord.xy,vec2(1,0)).g;factor.x-=rounding.y*sampleLevelZeroOffset(inputBuffer,texCoord.zw,vec2(1,1)).g;factor.y-=rounding.x*sampleLevelZeroOffset(inputBuffer,texCoord.xy,vec2(-2,0)).g;factor.y-=rounding.y*sampleLevelZeroOffset(inputBuffer,texCoord.zw,vec2(-2,1)).g;weights*=clamp(factor,0.0,1.0);
#endif
}void main(){vec4 weights=vec4(0.0);vec4 subsampleIndices=vec4(0.0);vec2 e=texture2D(inputBuffer,vUv).rg;if(e.g>0.0){
#if !defined(DISABLE_DIAG_DETECTION)
weights.rg=calculateDiagWeights(vUv,e,subsampleIndices);if(weights.r==-weights.g){
#endif
vec2 d;vec3 coords;coords.x=searchXLeft(vOffset[0].xy,vOffset[2].x);coords.y=vOffset[1].y;d.x=coords.x;float e1=texture2D(inputBuffer,coords.xy).r;coords.z=searchXRight(vOffset[0].zw,vOffset[2].y);d.y=coords.z;d=round(resolution.xx*d+-vPixCoord.xx);vec2 sqrtD=sqrt(abs(d));float e2=sampleLevelZeroOffset(inputBuffer,coords.zy,vec2(1,0)).r;weights.rg=area(sqrtD,e1,e2,subsampleIndices.y);coords.y=vUv.y;detectHorizontalCornerPattern(weights.rg,coords.xyzy,d);
#if !defined(DISABLE_DIAG_DETECTION)
}else{e.r=0.0;}
#endif
}if(e.r>0.0){vec2 d;vec3 coords;coords.y=searchYUp(vOffset[1].xy,vOffset[2].z);coords.x=vOffset[0].x;d.x=coords.y;float e1=texture2D(inputBuffer,coords.xy).g;coords.z=searchYDown(vOffset[1].zw,vOffset[2].w);d.y=coords.z;d=round(resolution.yy*d-vPixCoord.yy);vec2 sqrtD=sqrt(abs(d));float e2=sampleLevelZeroOffset(inputBuffer,coords.xz,vec2(0,1)).g;weights.ba=area(sqrtD,e1,e2,subsampleIndices.x);coords.x=vUv.x;detectVerticalCornerPattern(weights.ba,coords.xyxz,d);}gl_FragColor=weights;}`, x8 = "uniform vec2 texelSize;uniform vec2 resolution;varying vec2 vUv;varying vec4 vOffset[3];varying vec2 vPixCoord;void main(){vUv=position.xy*0.5+0.5;vPixCoord=vUv*resolution;vOffset[0]=vUv.xyxy+texelSize.xyxy*vec4(-0.25,-0.125,1.25,-0.125);vOffset[1]=vUv.xyxy+texelSize.xyxy*vec4(-0.125,-0.25,-0.125,1.25);vOffset[2]=vec4(vOffset[0].xz,vOffset[1].yw)+vec4(-2.0,2.0,-2.0,2.0)*texelSize.xxyy*MAX_SEARCH_STEPS_FLOAT;gl_Position=vec4(position.xy,1.0,1.0);}", b8 = class extends ot {
    constructor(r1 = new F, t = new F){
        super({
            name: "SMAAWeightsMaterial",
            defines: {
                MAX_SEARCH_STEPS_INT: "16",
                MAX_SEARCH_STEPS_FLOAT: "16.0",
                MAX_SEARCH_STEPS_DIAG_INT: "8",
                MAX_SEARCH_STEPS_DIAG_FLOAT: "8.0",
                CORNER_ROUNDING: "25",
                CORNER_ROUNDING_NORM: "0.25",
                AREATEX_MAX_DISTANCE: "16.0",
                AREATEX_MAX_DISTANCE_DIAG: "20.0",
                AREATEX_PIXEL_SIZE: "(1.0 / vec2(160.0, 560.0))",
                AREATEX_SUBTEX_SIZE: "(1.0 / 7.0)",
                SEARCHTEX_SIZE: "vec2(66.0, 33.0)",
                SEARCHTEX_PACKED_SIZE: "vec2(64.0, 16.0)"
            },
            uniforms: {
                inputBuffer: new ie(null),
                searchTexture: new ie(null),
                areaTexture: new ie(null),
                resolution: new ie(t),
                texelSize: new ie(r1)
            },
            blending: Dt,
            depthWrite: !1,
            depthTest: !1,
            fragmentShader: v8,
            vertexShader: x8
        }), this.toneMapped = !1;
    }
    set inputBuffer(r1) {
        this.uniforms.inputBuffer.value = r1;
    }
    setInputBuffer(r1) {
        this.uniforms.inputBuffer.value = r1;
    }
    get searchTexture() {
        return this.uniforms.searchTexture.value;
    }
    set searchTexture(r1) {
        this.uniforms.searchTexture.value = r1;
    }
    get areaTexture() {
        return this.uniforms.areaTexture.value;
    }
    set areaTexture(r1) {
        this.uniforms.areaTexture.value = r1;
    }
    setLookupTextures(r1, t) {
        this.searchTexture = r1, this.areaTexture = t;
    }
    get orthogonalSearchSteps() {
        return Number(this.defines.MAX_SEARCH_STEPS_INT);
    }
    set orthogonalSearchSteps(r1) {
        let t = Math.min(Math.max(r1, 0), 112);
        this.defines.MAX_SEARCH_STEPS_INT = t.toFixed("0"), this.defines.MAX_SEARCH_STEPS_FLOAT = t.toFixed("1"), this.needsUpdate = !0;
    }
    setOrthogonalSearchSteps(r1) {
        this.orthogonalSearchSteps = r1;
    }
    get diagonalSearchSteps() {
        return Number(this.defines.MAX_SEARCH_STEPS_DIAG_INT);
    }
    set diagonalSearchSteps(r1) {
        let t = Math.min(Math.max(r1, 0), 20);
        this.defines.MAX_SEARCH_STEPS_DIAG_INT = t.toFixed("0"), this.defines.MAX_SEARCH_STEPS_DIAG_FLOAT = t.toFixed("1"), this.needsUpdate = !0;
    }
    setDiagonalSearchSteps(r1) {
        this.diagonalSearchSteps = r1;
    }
    get diagonalDetection() {
        return this.defines.DISABLE_DIAG_DETECTION === void 0;
    }
    set diagonalDetection(r1) {
        r1 ? delete this.defines.DISABLE_DIAG_DETECTION : this.defines.DISABLE_DIAG_DETECTION = "1", this.needsUpdate = !0;
    }
    isDiagonalDetectionEnabled() {
        return this.diagonalDetection;
    }
    setDiagonalDetectionEnabled(r1) {
        this.diagonalDetection = r1;
    }
    get cornerRounding() {
        return Number(this.defines.CORNER_ROUNDING);
    }
    set cornerRounding(r1) {
        let t = Math.min(Math.max(r1, 0), 100);
        this.defines.CORNER_ROUNDING = t.toFixed("4"), this.defines.CORNER_ROUNDING_NORM = (t / 100).toFixed("4"), this.needsUpdate = !0;
    }
    setCornerRounding(r1) {
        this.cornerRounding = r1;
    }
    get cornerDetection() {
        return this.defines.DISABLE_CORNER_DETECTION === void 0;
    }
    set cornerDetection(r1) {
        r1 ? delete this.defines.DISABLE_CORNER_DETECTION : this.defines.DISABLE_CORNER_DETECTION = "1", this.needsUpdate = !0;
    }
    isCornerRoundingEnabled() {
        return this.cornerDetection;
    }
    setCornerRoundingEnabled(r1) {
        this.cornerDetection = r1;
    }
    setSize(r1, t) {
        let e = this.uniforms;
        e.texelSize.value.set(1 / r1, 1 / t), e.resolution.value.set(r1, t);
    }
};
var w8 = new ki, Pa = null;
function S8() {
    if (Pa === null) {
        let r1 = new Float32Array([
            -1,
            -1,
            0,
            3,
            -1,
            0,
            -1,
            3,
            0
        ]), t = new Float32Array([
            0,
            0,
            2,
            0,
            0,
            2
        ]);
        Pa = new Me, Pa.setAttribute !== void 0 ? (Pa.setAttribute("position", new Be(r1, 3)), Pa.setAttribute("uv", new Be(t, 2))) : (Pa.addAttribute("position", new Be(r1, 3)), Pa.addAttribute("uv", new Be(t, 2)));
    }
    return Pa;
}
var Un = class {
    constructor(r1 = "Pass", t = new Or, e = w8){
        this.name = r1, this.renderer = null, this.scene = t, this.camera = e, this.screen = null, this.rtt = !0, this.needsSwap = !0, this.needsDepthTexture = !1, this.enabled = !0;
    }
    get renderToScreen() {
        return !this.rtt;
    }
    set renderToScreen(r1) {
        if (this.rtt === r1) {
            let t = this.getFullscreenMaterial();
            t !== null && (t.needsUpdate = !0), this.rtt = !r1;
        }
    }
    setRenderer(r1) {
        this.renderer = r1;
    }
    isEnabled() {
        return this.enabled;
    }
    setEnabled(r1) {
        this.enabled = r1;
    }
    get fullscreenMaterial() {
        return this.screen !== null ? this.screen.material : null;
    }
    set fullscreenMaterial(r1) {
        let t = this.screen;
        t !== null ? t.material = r1 : (t = new In(S8(), r1), t.frustumCulled = !1, this.scene === null && (this.scene = new Or), this.scene.add(t), this.screen = t);
    }
    getFullscreenMaterial() {
        return this.fullscreenMaterial;
    }
    setFullscreenMaterial(r1) {
        this.fullscreenMaterial = r1;
    }
    getDepthTexture() {
        return null;
    }
    setDepthTexture(r1, t = tr) {}
    render(r1, t, e, n, i) {
        throw new Error("Render method not implemented!");
    }
    setSize(r1, t) {}
    initialize(r1, t, e) {}
    dispose() {
        for (let r1 of Object.keys(this)){
            let t = this[r1];
            if (t !== null && typeof t.dispose == "function") {
                if (t instanceof Or || t === this.renderer) continue;
                this[r1].dispose();
            }
        }
    }
}, tp = class extends Un {
    constructor(r1, t = !0){
        super("CopyPass"), this.fullscreenMaterial = new a8, this.needsSwap = !1, this.renderTarget = r1, r1 === void 0 && (this.renderTarget = new st(1, 1, {
            minFilter: Qe,
            magFilter: Qe,
            stencilBuffer: !1,
            depthBuffer: !1
        }), this.renderTarget.texture.name = "CopyPass.Target"), this.autoResize = t;
    }
    get resize() {
        return this.autoResize;
    }
    set resize(r1) {
        this.autoResize = r1;
    }
    get texture() {
        return this.renderTarget.texture;
    }
    getTexture() {
        return this.renderTarget.texture;
    }
    setAutoResizeEnabled(r1) {
        this.autoResize = r1;
    }
    render(r1, t, e, n, i) {
        this.fullscreenMaterial.inputBuffer = t.texture, r1.setRenderTarget(this.renderToScreen ? null : this.renderTarget), r1.render(this.scene, this.camera);
    }
    setSize(r1, t) {
        this.autoResize && this.renderTarget.setSize(r1, t);
    }
    initialize(r1, t, e) {
        e !== void 0 && (this.renderTarget.texture.type = e, e !== qt ? this.fullscreenMaterial.defines.FRAMEBUFFER_PRECISION_HIGH = "1" : r1.outputEncoding === Ye && (this.renderTarget.texture.encoding = Ye));
    }
};
var nI = class extends Un {
    constructor(){
        super("ClearMaskPass", null, null), this.needsSwap = !1;
    }
    render(r1, t, e, n, i) {
        let s = r1.state.buffers.stencil;
        s.setLocked(!1), s.setTest(!1);
    }
}, OS = new Ne, US = class extends Un {
    constructor(r1 = !0, t = !0, e = !1){
        super("ClearPass", null, null), this.needsSwap = !1, this.color = r1, this.depth = t, this.stencil = e, this.overrideClearColor = null, this.overrideClearAlpha = -1;
    }
    setClearFlags(r1, t, e) {
        this.color = r1, this.depth = t, this.stencil = e;
    }
    getOverrideClearColor() {
        return this.overrideClearColor;
    }
    setOverrideClearColor(r1) {
        this.overrideClearColor = r1;
    }
    getOverrideClearAlpha() {
        return this.overrideClearAlpha;
    }
    setOverrideClearAlpha(r1) {
        this.overrideClearAlpha = r1;
    }
    render(r1, t, e, n, i) {
        let s = this.overrideClearColor, o = this.overrideClearAlpha, a = r1.getClearAlpha(), l = s !== null, u = o >= 0;
        l ? (OS.copy(r1.getClearColor(OS)), r1.setClearColor(s, u ? o : a)) : u && r1.setClearAlpha(o), r1.setRenderTarget(this.renderToScreen ? null : t), r1.clear(this.color, this.depth, this.stencil), l ? r1.setClearColor(OS, a) : u && r1.setClearAlpha(a);
    }
}, Da = -1, ei = class extends Ht {
    constructor(r1, t = Da, e = Da, n = 1){
        super(), this.resizable = r1, this.base = new F(1, 1), this.preferred = new F(t, e), this.target = this.preferred, this.s = n;
    }
    get width() {
        let { base: r1 , preferred: t , scale: e  } = this, n;
        return t.width !== Da ? n = t.width : t.height !== Da ? n = Math.round(t.height * (r1.width / Math.max(r1.height, 1))) : n = Math.round(r1.width * e), n;
    }
    set width(r1) {
        this.preferredWidth = r1;
    }
    get height() {
        let { base: r1 , preferred: t , scale: e  } = this, n;
        return t.height !== Da ? n = t.height : t.width !== Da ? n = Math.round(t.width / Math.max(r1.width / Math.max(r1.height, 1), 1)) : n = Math.round(r1.height * e), n;
    }
    set height(r1) {
        this.preferredHeight = r1;
    }
    getWidth() {
        return this.width;
    }
    getHeight() {
        return this.height;
    }
    get scale() {
        return this.s;
    }
    set scale(r1) {
        this.s !== r1 && (this.s = r1, this.preferred.setScalar(Da), this.dispatchEvent({
            type: "change"
        }), this.resizable.setSize(this.base.width, this.base.height));
    }
    getScale() {
        return this.scale;
    }
    setScale(r1) {
        this.scale = r1;
    }
    get baseWidth() {
        return this.base.width;
    }
    set baseWidth(r1) {
        this.base.width !== r1 && (this.base.width = r1, this.dispatchEvent({
            type: "change"
        }), this.resizable.setSize(this.base.width, this.base.height));
    }
    getBaseWidth() {
        return this.base.width;
    }
    setBaseWidth(r1) {
        this.base.width !== r1 && (this.base.width = r1, this.dispatchEvent({
            type: "change"
        }), this.resizable.setSize(this.base.width, this.base.height));
    }
    get baseHeight() {
        return this.base.height;
    }
    set baseHeight(r1) {
        this.base.height !== r1 && (this.base.height = r1, this.dispatchEvent({
            type: "change"
        }), this.resizable.setSize(this.base.width, this.base.height));
    }
    getBaseHeight() {
        return this.baseHeight;
    }
    setBaseHeight(r1) {
        this.baseHeight = r1;
    }
    setBaseSize(r1, t) {
        (this.base.width !== r1 || this.base.height !== t) && (this.base.set(r1, t), this.dispatchEvent({
            type: "change"
        }), this.resizable.setSize(this.base.width, this.base.height));
    }
    get preferredWidth() {
        return this.preferred.width;
    }
    set preferredWidth(r1) {
        this.preferred.width !== r1 && (this.preferred.width = r1, this.dispatchEvent({
            type: "change"
        }), this.resizable.setSize(this.base.width, this.base.height));
    }
    getPreferredWidth() {
        return this.preferredWidth;
    }
    setPreferredWidth(r1) {
        this.preferredWidth = r1;
    }
    get preferredHeight() {
        return this.preferred.height;
    }
    set preferredHeight(r1) {
        this.preferred.height !== r1 && (this.preferred.height = r1, this.dispatchEvent({
            type: "change"
        }), this.resizable.setSize(this.base.width, this.base.height));
    }
    getPreferredHeight() {
        return this.preferredHeight;
    }
    setPreferredHeight(r1) {
        this.preferredHeight = r1;
    }
    setPreferredSize(r1, t) {
        (this.preferred.width !== r1 || this.preferred.height !== t) && (this.preferred.set(r1, t), this.dispatchEvent({
            type: "change"
        }), this.resizable.setSize(this.base.width, this.base.height));
    }
    copy(r1) {
        this.base.set(r1.getBaseWidth(), r1.getBaseHeight()), this.preferred.set(r1.getPreferredWidth(), r1.getPreferredHeight()), this.dispatchEvent({
            type: "change"
        }), this.resizable.setSize(this.base.width, this.base.height);
    }
    static get AUTO_SIZE() {
        return Da;
    }
}, RS = !1, KD = class {
    constructor(r1 = null){
        this.originalMaterials = new Map, this.material = null, this.materials = null, this.materialsBackSide = null, this.materialsDoubleSide = null, this.materialsFlatShaded = null, this.materialsFlatShadedBackSide = null, this.materialsFlatShadedDoubleSide = null, this.setMaterial(r1), this.meshCount = 0, this.replaceMaterial = (t)=>{
            if (t.isMesh) {
                let e;
                if (t.material.flatShading) switch(t.material.side){
                    case Ir:
                        e = this.materialsFlatShadedDoubleSide;
                        break;
                    case On:
                        e = this.materialsFlatShadedBackSide;
                        break;
                    default:
                        e = this.materialsFlatShaded;
                        break;
                }
                else switch(t.material.side){
                    case Ir:
                        e = this.materialsDoubleSide;
                        break;
                    case On:
                        e = this.materialsBackSide;
                        break;
                    default:
                        e = this.materials;
                        break;
                }
                this.originalMaterials.set(t, t.material), t.isSkinnedMesh ? t.material = e[2] : t.isInstancedMesh ? t.material = e[1] : t.material = e[0], ++this.meshCount;
            }
        };
    }
    setMaterial(r1) {
        if (this.disposeMaterials(), this.material = r1, r1 !== null) {
            let t = this.materials = [
                r1.clone(),
                r1.clone(),
                r1.clone()
            ];
            for (let e of t)e.uniforms = Object.assign({}, r1.uniforms), e.side = si;
            t[2].skinning = !0, this.materialsBackSide = t.map((e)=>{
                let n = e.clone();
                return n.uniforms = Object.assign({}, r1.uniforms), n.side = On, n;
            }), this.materialsDoubleSide = t.map((e)=>{
                let n = e.clone();
                return n.uniforms = Object.assign({}, r1.uniforms), n.side = Ir, n;
            }), this.materialsFlatShaded = t.map((e)=>{
                let n = e.clone();
                return n.uniforms = Object.assign({}, r1.uniforms), n.flatShading = !0, n;
            }), this.materialsFlatShadedBackSide = t.map((e)=>{
                let n = e.clone();
                return n.uniforms = Object.assign({}, r1.uniforms), n.flatShading = !0, n.side = On, n;
            }), this.materialsFlatShadedDoubleSide = t.map((e)=>{
                let n = e.clone();
                return n.uniforms = Object.assign({}, r1.uniforms), n.flatShading = !0, n.side = Ir, n;
            });
        }
    }
    render(r1, t, e) {
        let n = r1.shadowMap.enabled;
        if (r1.shadowMap.enabled = !1, RS) {
            let i = this.originalMaterials;
            this.meshCount = 0, t.traverse(this.replaceMaterial), r1.render(t, e);
            for (let s of i)s[0].material = s[1];
            this.meshCount !== i.size && i.clear();
        } else {
            let i = t.overrideMaterial;
            t.overrideMaterial = this.material, r1.render(t, e), t.overrideMaterial = i;
        }
        r1.shadowMap.enabled = n;
    }
    disposeMaterials() {
        if (this.material !== null) {
            let r1 = this.materials.concat(this.materialsBackSide).concat(this.materialsDoubleSide).concat(this.materialsFlatShaded).concat(this.materialsFlatShadedBackSide).concat(this.materialsFlatShadedDoubleSide);
            for (let t of r1)t.dispose();
        }
    }
    dispose() {
        this.originalMaterials.clear(), this.disposeMaterials();
    }
    static get workaroundEnabled() {
        return RS;
    }
    static set workaroundEnabled(r1) {
        RS = r1;
    }
}, A8 = class extends Un {
    constructor(r1, t, e = null){
        super("RenderPass", r1, t), this.needsSwap = !1, this.clearPass = new US, this.overrideMaterialManager = e === null ? null : new KD(e), this.ignoreBackground = !1, this.skipShadowMapUpdate = !1, this.selection = null;
    }
    get renderToScreen() {
        return super.renderToScreen;
    }
    set renderToScreen(r1) {
        super.renderToScreen = r1, this.clearPass.renderToScreen = r1;
    }
    get overrideMaterial() {
        let r1 = this.overrideMaterialManager;
        return r1 !== null ? r1.material : null;
    }
    set overrideMaterial(r1) {
        let t = this.overrideMaterialManager;
        r1 !== null ? t !== null ? t.setMaterial(r1) : this.overrideMaterialManager = new KD(r1) : t !== null && (t.dispose(), this.overrideMaterialManager = null);
    }
    getOverrideMaterial() {
        return this.overrideMaterial;
    }
    setOverrideMaterial(r1) {
        this.overrideMaterial = r1;
    }
    get clear() {
        return this.clearPass.enabled;
    }
    set clear(r1) {
        this.clearPass.enabled = r1;
    }
    getSelection() {
        return this.selection;
    }
    setSelection(r1) {
        this.selection = r1;
    }
    isBackgroundDisabled() {
        return this.ignoreBackground;
    }
    setBackgroundDisabled(r1) {
        this.ignoreBackground = r1;
    }
    isShadowMapDisabled() {
        return this.skipShadowMapUpdate;
    }
    setShadowMapDisabled(r1) {
        this.skipShadowMapUpdate = r1;
    }
    getClearPass() {
        return this.clearPass;
    }
    render(r1, t, e, n, i) {
        let s = this.scene, o = this.camera, a = this.selection, l = o.layers.mask, u = s.background, c = r1.shadowMap.autoUpdate, d = this.renderToScreen ? null : t;
        a !== null && o.layers.set(a.getLayer()), this.skipShadowMapUpdate && (r1.shadowMap.autoUpdate = !1), (this.ignoreBackground || this.clearPass.overrideClearColor !== null) && (s.background = null), this.clearPass.enabled && this.clearPass.render(r1, t), r1.setRenderTarget(d), this.overrideMaterialManager !== null ? this.overrideMaterialManager.render(r1, s, o) : r1.render(s, o), o.layers.mask = l, s.background = u, r1.shadowMap.autoUpdate = c;
    }
}, kS = class extends Un {
    constructor(r1, t, { resolutionScale: e = 1 , width: n = ei.AUTO_SIZE , height: i = ei.AUTO_SIZE , renderTarget: s  } = {}){
        super("DepthPass"), this.needsSwap = !1, this.renderPass = new A8(r1, t, new vh({
            depthPacking: J0
        }));
        let o = this.renderPass;
        o.skipShadowMapUpdate = !0, o.ignoreBackground = !0;
        let a = o.getClearPass();
        a.overrideClearColor = new Ne(16777215), a.overrideClearAlpha = 1, this.renderTarget = s, this.renderTarget === void 0 && (this.renderTarget = new st(1, 1, {
            minFilter: _t,
            magFilter: _t,
            stencilBuffer: !1
        }), this.renderTarget.texture.name = "DepthPass.Target");
        let l = this.resolution = new ei(this, n, i, e);
        l.addEventListener("change", (u)=>this.setSize(l.baseWidth, l.baseHeight));
    }
    get texture() {
        return this.renderTarget.texture;
    }
    getTexture() {
        return this.renderTarget.texture;
    }
    getResolution() {
        return this.resolution;
    }
    getResolutionScale() {
        return this.resolution.scale;
    }
    setResolutionScale(r1) {
        this.resolution.scale = r1;
    }
    render(r1, t, e, n, i) {
        let s = this.renderToScreen ? null : this.renderTarget;
        this.renderPass.render(r1, s);
    }
    setSize(r1, t) {
        let e = this.resolution;
        e.setBaseSize(r1, t), this.renderTarget.setSize(e.width, e.height);
    }
};
var sCe = new Float32Array([
    255 / 256 / 256 ** 3,
    255 / 256 / 65536,
    255 / 256 / 256,
    255 / 256
]);
var lt = {
    SKIP: 0,
    ADD: 1,
    ALPHA: 2,
    AVERAGE: 3,
    COLOR_BURN: 4,
    COLOR_DODGE: 5,
    DARKEN: 6,
    DIFFERENCE: 7,
    EXCLUSION: 8,
    LIGHTEN: 9,
    MULTIPLY: 10,
    DIVIDE: 11,
    NEGATION: 12,
    NORMAL: 13,
    OVERLAY: 14,
    REFLECT: 15,
    SCREEN: 16,
    SOFT_LIGHT: 17,
    SUBTRACT: 18
}, _8 = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return min(x+y,1.0)*opacity+x*(1.0-opacity);}", M8 = "vec3 blend(const in vec3 x,const in vec3 y,const in float opacity){return y*opacity+x*(1.0-opacity);}vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){float a=min(y.a,opacity);return vec4(blend(x.rgb,y.rgb,a),max(x.a,a));}", T8 = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return(x+y)*0.5*opacity+x*(1.0-opacity);}", E8 = "float blend(const in float x,const in float y){return(y==0.0)?y:max(1.0-(1.0-x)/y,0.0);}vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){vec4 z=vec4(blend(x.r,y.r),blend(x.g,y.g),blend(x.b,y.b),blend(x.a,y.a));return z*opacity+x*(1.0-opacity);}", C8 = "float blend(const in float x,const in float y){return(y==1.0)?y:min(x/(1.0-y),1.0);}vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){vec4 z=vec4(blend(x.r,y.r),blend(x.g,y.g),blend(x.b,y.b),blend(x.a,y.a));return z*opacity+x*(1.0-opacity);}", P8 = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return min(x,y)*opacity+x*(1.0-opacity);}", D8 = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return abs(x-y)*opacity+x*(1.0-opacity);}", I8 = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return(x+y-2.0*x*y)*opacity+x*(1.0-opacity);}", O8 = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return max(x,y)*opacity+x*(1.0-opacity);}", R8 = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return x*y*opacity+x*(1.0-opacity);}", L8 = "float blend(const in float x,const in float y){return(y>0.0)?min(x/y,1.0):1.0;}vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){vec4 z=vec4(blend(x.r,y.r),blend(x.g,y.g),blend(x.b,y.b),blend(x.a,y.a));return z*opacity+x*(1.0-opacity);}", N8 = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return(1.0-abs(1.0-x-y))*opacity+x*(1.0-opacity);}", B8 = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return y*opacity+x*(1.0-opacity);}", F8 = "float blend(const in float x,const in float y){return(x<0.5)?(2.0*x*y):(1.0-2.0*(1.0-x)*(1.0-y));}vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){vec4 z=vec4(blend(x.r,y.r),blend(x.g,y.g),blend(x.b,y.b),blend(x.a,y.a));return z*opacity+x*(1.0-opacity);}", U8 = "float blend(const in float x,const in float y){return(y==1.0)?y:min(x*x/(1.0-y),1.0);}vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){vec4 z=vec4(blend(x.r,y.r),blend(x.g,y.g),blend(x.b,y.b),blend(x.a,y.a));return z*opacity+x*(1.0-opacity);}", k8 = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return(1.0-(1.0-x)*(1.0-y))*opacity+x*(1.0-opacity);}", z8 = "float blend(const in float x,const in float y){return(y<0.5)?(2.0*x*y+x*x*(1.0-2.0*y)):(sqrt(x)*(2.0*y-1.0)+2.0*x*(1.0-y));}vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){vec4 z=vec4(blend(x.r,y.r),blend(x.g,y.g),blend(x.b,y.b),blend(x.a,y.a));return z*opacity+x*(1.0-opacity);}", G8 = "vec4 blend(const in vec4 x,const in vec4 y,const in float opacity){return max(x+y-1.0,0.0)*opacity+x*(1.0-opacity);}", V8 = new Map([
    [
        lt.SKIP,
        null
    ],
    [
        lt.ADD,
        _8
    ],
    [
        lt.ALPHA,
        M8
    ],
    [
        lt.AVERAGE,
        T8
    ],
    [
        lt.COLOR_BURN,
        E8
    ],
    [
        lt.COLOR_DODGE,
        C8
    ],
    [
        lt.DARKEN,
        P8
    ],
    [
        lt.DIFFERENCE,
        D8
    ],
    [
        lt.EXCLUSION,
        I8
    ],
    [
        lt.LIGHTEN,
        O8
    ],
    [
        lt.MULTIPLY,
        R8
    ],
    [
        lt.DIVIDE,
        L8
    ],
    [
        lt.NEGATION,
        N8
    ],
    [
        lt.NORMAL,
        B8
    ],
    [
        lt.OVERLAY,
        F8
    ],
    [
        lt.REFLECT,
        U8
    ],
    [
        lt.SCREEN,
        k8
    ],
    [
        lt.SOFT_LIGHT,
        z8
    ],
    [
        lt.SUBTRACT,
        G8
    ]
]), H8 = class extends Ht {
    constructor(r1, t = 1){
        super(), this.f = r1, this.opacity = new ie(t);
    }
    getOpacity() {
        return this.opacity.value;
    }
    setOpacity(r1) {
        this.opacity.value = r1;
    }
    get blendFunction() {
        return this.f;
    }
    set blendFunction(r1) {
        this.f = r1, this.dispatchEvent({
            type: "change"
        });
    }
    getBlendFunction() {
        return this.blendFunction;
    }
    setBlendFunction(r1) {
        this.blendFunction = r1;
    }
    getShaderCode() {
        return V8.get(this.blendFunction);
    }
}, qs = {
    NONE: 0,
    DEPTH: 1,
    CONVOLUTION: 2
};
var Xs = class extends Ht {
    constructor(r1, t, { attributes: e = qs.NONE , blendFunction: n = lt.SCREEN , defines: i = new Map , uniforms: s = new Map , extensions: o = null , vertexShader: a = null  } = {}){
        super(), this.name = r1, this.renderer = null, this.attributes = e, this.fragmentShader = t, this.vertexShader = a, this.defines = i, this.uniforms = s, this.extensions = o, this.blendMode = new H8(n), this.blendMode.addEventListener("change", (l)=>this.setChanged());
    }
    getName() {
        return this.name;
    }
    setRenderer(r1) {
        this.renderer = r1;
    }
    getDefines() {
        return this.defines;
    }
    getUniforms() {
        return this.uniforms;
    }
    getExtensions() {
        return this.extensions;
    }
    getBlendMode() {
        return this.blendMode;
    }
    getAttributes() {
        return this.attributes;
    }
    setAttributes(r1) {
        this.attributes = r1, this.setChanged();
    }
    getFragmentShader() {
        return this.fragmentShader;
    }
    setFragmentShader(r1) {
        this.fragmentShader = r1, this.setChanged();
    }
    getVertexShader() {
        return this.vertexShader;
    }
    setVertexShader(r1) {
        this.vertexShader = r1, this.setChanged();
    }
    setChanged() {
        this.dispatchEvent({
            type: "change"
        });
    }
    setDepthTexture(r1, t = tr) {}
    update(r1, t, e) {}
    setSize(r1, t) {}
    initialize(r1, t, e) {}
    dispose() {
        for (let r1 of Object.keys(this)){
            let t = this[r1];
            if (t !== null && typeof t.dispose == "function") {
                if (t instanceof Or || t === this.renderer) continue;
                this[r1].dispose();
            }
        }
    }
};
function ZD(r1, t, e) {
    for (let n of t){
        let i = "$1" + r1 + n.charAt(0).toUpperCase() + n.slice(1), s = new RegExp("([^\\.])(\\b" + n + "\\b)", "g");
        for (let o of e.entries())o[1] !== null && e.set(o[0], o[1].replace(s, i));
    }
}
function W8(r1, t, e, n, i, s, o) {
    let a = new Map([
        [
            "fragment",
            t.getFragmentShader()
        ],
        [
            "vertex",
            t.getVertexShader()
        ]
    ]), l = a.get("fragment") !== void 0 && /mainImage/.test(a.get("fragment")), u = a.get("fragment") !== void 0 && /mainUv/.test(a.get("fragment")), c = [], d = [], h = !1, f = !1;
    if (a.get("fragment") === void 0) console.error("Missing fragment shader", t);
    else if (u && (o & qs.CONVOLUTION) !== 0) console.error("Effects that transform UV coordinates are incompatible with convolution effects", t);
    else if (!l && !u) console.error("The fragment shader contains neither a mainImage nor a mainUv function", t);
    else {
        let m = /(?:\w+\s+(\w+)\([\w\s,]*\)\s*{[^}]+})/g, p = FS.Section;
        if (u) {
            let y = `	${r1}MainUv(UV);
`;
            e.set(p.FRAGMENT_MAIN_UV, e.get(p.FRAGMENT_MAIN_UV) + y), h = !0;
        }
        if (a.get("vertex") !== null && /mainSupport/.test(a.get("vertex"))) {
            let y = `	${r1}MainSupport(`;
            y += /mainSupport *\([\w\s]*?uv\s*?\)/.test(a.get("vertex")) ? `vUv);
` : `);
`, e.set(p.VERTEX_MAIN_SUPPORT, e.get(p.VERTEX_MAIN_SUPPORT) + y), c = c.concat([
                ...a.get("vertex").matchAll(/(?:varying\s+\w+\s+(\w*))/g)
            ].map((v)=>v[1])), d = d.concat(c).concat([
                ...a.get("vertex").matchAll(m)
            ].map((v)=>v[1]));
        }
        d = d.concat([
            ...a.get("fragment").matchAll(m)
        ].map((y)=>y[1])), d = d.concat([
            ...t.defines.keys()
        ].map((y)=>y.replace(/\([\w\s,]*\)/g, ""))), d = d.concat([
            ...t.uniforms.keys()
        ]), t.uniforms.forEach((y, v)=>s.set(r1 + v.charAt(0).toUpperCase() + v.slice(1), y)), t.defines.forEach((y, v)=>i.set(r1 + v.charAt(0).toUpperCase() + v.slice(1), y)), ZD(r1, d, i), ZD(r1, d, a);
        let g = t.blendMode;
        if (n.set(g.blendFunction, g), l) {
            let y = /MainImage *\([\w\s,]*?depth[\w\s,]*?\)/, v = `${r1}MainImage(color0, UV, `;
            (o & qs.DEPTH) !== 0 && y.test(a.get("fragment")) && (v += "depth, ", f = !0), v += `color1);
	`;
            let x = r1 + "BlendOpacity";
            s.set(x, g.opacity), v += `color0 = blend${g.blendFunction}(color0, color1, ${x});

	`, e.set(p.FRAGMENT_MAIN_IMAGE, e.get(p.FRAGMENT_MAIN_IMAGE) + v), v = `uniform float ${x};

`, e.set(p.FRAGMENT_HEAD, e.get(p.FRAGMENT_HEAD) + v);
        }
        e.set(p.FRAGMENT_HEAD, e.get(p.FRAGMENT_HEAD) + a.get("fragment") + `
`), a.get("vertex") !== null && e.set(p.VERTEX_HEAD, e.get(p.VERTEX_HEAD) + a.get("vertex") + `
`);
    }
    return {
        varyings: c,
        transformedUv: h,
        readDepth: f
    };
}
var zl = class extends Un {
    constructor(r1, ...t){
        super("EffectPass"), this.fullscreenMaterial = new FS(null, null, null, r1), this.effects = t.sort((e, n)=>n.attributes - e.attributes), this.skipRendering = !1, this.uniformCount = 0, this.varyingCount = 0, this.minTime = 1, this.maxTime = Number.POSITIVE_INFINITY;
    }
    get encodeOutput() {
        return this.fullscreenMaterial.encodeOutput;
    }
    set encodeOutput(r1) {
        this.fullscreenMaterial.encodeOutput = r1;
    }
    get dithering() {
        return this.fullscreenMaterial.dithering;
    }
    set dithering(r1) {
        let t = this.fullscreenMaterial;
        t.dithering = r1, t.needsUpdate = !0;
    }
    verifyResources() {
        let r1 = this.renderer.capabilities, t = Math.min(r1.maxFragmentUniforms, r1.maxVertexUniforms);
        this.uniformCount > t && console.warn("The current rendering context doesn't support more than " + t + " uniforms, but " + this.uniformCount + " were defined"), t = r1.maxVaryings, this.varyingCount > t && console.warn("The current rendering context doesn't support more than " + t + " varyings, but " + this.varyingCount + " were defined");
    }
    updateMaterial() {
        let r1 = FS.Section, t = new Map([
            [
                r1.FRAGMENT_HEAD,
                ""
            ],
            [
                r1.FRAGMENT_MAIN_UV,
                ""
            ],
            [
                r1.FRAGMENT_MAIN_IMAGE,
                ""
            ],
            [
                r1.VERTEX_HEAD,
                ""
            ],
            [
                r1.VERTEX_MAIN_SUPPORT,
                ""
            ]
        ]), e = new Map, n = new Map, i = new Map, s = new Set, o = 0, a = 0, l = 0, u = !1, c = !1;
        for (let h of this.effects)if (h.blendMode.blendFunction === lt.SKIP) l |= h.getAttributes() & qs.DEPTH;
        else if ((l & h.getAttributes() & qs.CONVOLUTION) !== 0) console.error("Convolution effects cannot be merged", h);
        else {
            l |= h.getAttributes();
            let f = "e" + o++, m = W8(f, h, t, e, n, i, l);
            if (a += m.varyings.length, u = u || m.transformedUv, c = c || m.readDepth, h.extensions !== null) for (let p of h.extensions)s.add(p);
        }
        let d = /\bblend\b/g;
        for (let h of e.values()){
            let f = h.getShaderCode().replace(d, `blend${h.blendFunction}`);
            t.set(r1.FRAGMENT_HEAD, t.get(r1.FRAGMENT_HEAD) + f + `
`);
        }
        if ((l & qs.DEPTH) !== 0) {
            if (c) {
                let h = `float depth = readDepth(UV);

	`;
                t.set(r1.FRAGMENT_MAIN_IMAGE, h + t.get(r1.FRAGMENT_MAIN_IMAGE));
            }
            this.needsDepthTexture = this.getDepthTexture() === null;
        } else this.needsDepthTexture = !1;
        if (u) {
            let h = `vec2 transformedUv = vUv;
`;
            t.set(r1.FRAGMENT_MAIN_UV, h + t.get(r1.FRAGMENT_MAIN_UV)), n.set("UV", "transformedUv");
        } else n.set("UV", "vUv");
        t.forEach((h, f, m)=>m.set(f, h.trim().replace(/^#/, `
#`))), this.uniformCount = i.size, this.varyingCount = a, this.skipRendering = o === 0, this.needsSwap = !this.skipRendering, this.fullscreenMaterial.setShaderParts(t).setExtensions(s).setUniforms(i).setDefines(n);
    }
    recompile() {
        this.updateMaterial(), this.verifyResources();
    }
    getDepthTexture() {
        return this.fullscreenMaterial.depthBuffer;
    }
    setDepthTexture(r1, t = tr) {
        this.fullscreenMaterial.depthBuffer = r1, this.fullscreenMaterial.depthPacking = t;
        for (let e of this.effects)e.setDepthTexture(r1, t);
    }
    render(r1, t, e, n, i) {
        for (let s of this.effects)s.update(r1, t, n);
        if (!this.skipRendering || this.renderToScreen) {
            let s = this.fullscreenMaterial;
            s.inputBuffer = t.texture, s.time += n, r1.setRenderTarget(this.renderToScreen ? null : e), r1.render(this.scene, this.camera);
        }
    }
    setSize(r1, t) {
        this.fullscreenMaterial.setSize(r1, t);
        for (let e of this.effects)e.setSize(r1, t);
    }
    initialize(r1, t, e) {
        this.renderer = r1;
        for (let n of this.effects)n.initialize(r1, t, e), n.addEventListener("change", (i)=>this.handleEvent(i));
        this.updateMaterial(), this.verifyResources(), e !== void 0 && e !== qt && (this.fullscreenMaterial.defines.FRAMEBUFFER_PRECISION_HIGH = "1");
    }
    dispose() {
        super.dispose();
        for (let r1 of this.effects)r1.dispose();
    }
    handleEvent(r1) {
        switch(r1.type){
            case "change":
                this.recompile();
                break;
        }
    }
}, j8 = [
    new Float32Array([
        0,
        0
    ]),
    new Float32Array([
        0,
        1,
        1
    ]),
    new Float32Array([
        0,
        1,
        1,
        2
    ]),
    new Float32Array([
        0,
        1,
        2,
        2,
        3
    ]),
    new Float32Array([
        0,
        1,
        2,
        3,
        4,
        4,
        5
    ]),
    new Float32Array([
        0,
        1,
        2,
        3,
        4,
        5,
        7,
        8,
        9,
        10
    ])
], rI = class extends Un {
    constructor({ resolutionScale: r1 = .5 , width: t = ei.AUTO_SIZE , height: e = ei.AUTO_SIZE , kernelSize: n = zS.LARGE  } = {}){
        super("KawaseBlurPass"), this.renderTargetA = new st(1, 1, {
            minFilter: Qe,
            magFilter: Qe,
            stencilBuffer: !1,
            depthBuffer: !1
        }), this.renderTargetA.texture.name = "Blur.Target.A", this.renderTargetB = this.renderTargetA.clone(), this.renderTargetB.texture.name = "Blur.Target.B";
        let i = this.resolution = new ei(this, t, e, r1);
        i.addEventListener("change", (s)=>this.setSize(i.baseWidth, i.baseHeight)), this.blurMaterial = new QD, this.ditheredBlurMaterial = new QD, this.ditheredBlurMaterial.uniforms.scale = this.blurMaterial.uniforms.scale, this.ditheredBlurMaterial.dithering = !0, this.dithering = !1, this.kernelSize = n;
    }
    getResolution() {
        return this.resolution;
    }
    get width() {
        return this.resolution.width;
    }
    set width(r1) {
        this.resolution.preferredWidth = r1;
    }
    get height() {
        return this.resolution.height;
    }
    set height(r1) {
        this.resolution.preferredHeight = r1;
    }
    get scale() {
        return this.blurMaterial.scale;
    }
    set scale(r1) {
        this.blurMaterial.scale = r1;
    }
    getScale() {
        return this.blurMaterial.scale;
    }
    setScale(r1) {
        this.blurMaterial.scale = r1;
    }
    getKernelSize() {
        return this.kernelSize;
    }
    setKernelSize(r1) {
        this.kernelSize = r1;
    }
    getResolutionScale() {
        return this.resolution.scale;
    }
    setResolutionScale(r1) {
        this.resolution.scale = r1;
    }
    render(r1, t, e, n, i) {
        let s = this.scene, o = this.camera, a = this.renderTargetA, l = this.renderTargetB, u = j8[this.kernelSize], c = this.blurMaterial, d = t, h, f;
        for(this.fullscreenMaterial = c, h = 0, f = u.length - 1; h < f; ++h){
            let m = (h & 1) === 0 ? a : l;
            c.kernel = u[h], c.inputBuffer = d.texture, r1.setRenderTarget(m), r1.render(s, o), d = m;
        }
        this.dithering && (c = this.ditheredBlurMaterial, this.fullscreenMaterial = c), c.kernel = u[h], c.inputBuffer = d.texture, r1.setRenderTarget(this.renderToScreen ? null : e), r1.render(s, o);
    }
    setSize(r1, t) {
        let e = this.resolution;
        e.setBaseSize(r1, t);
        let n = e.width, i = e.height;
        this.renderTargetA.setSize(n, i), this.renderTargetB.setSize(n, i), this.blurMaterial.setSize(n, i), this.ditheredBlurMaterial.setSize(n, i);
    }
    initialize(r1, t, e) {
        e !== void 0 && (this.renderTargetA.texture.type = e, this.renderTargetB.texture.type = e, e !== qt ? (this.blurMaterial.defines.FRAMEBUFFER_PRECISION_HIGH = "1", this.ditheredBlurMaterial.defines.FRAMEBUFFER_PRECISION_HIGH = "1") : r1.outputEncoding === Ye && (this.renderTargetA.texture.encoding = Ye, this.renderTargetB.texture.encoding = Ye));
    }
    static get AUTO_SIZE() {
        return ei.AUTO_SIZE;
    }
};
var q8 = class extends Un {
    constructor({ width: r1 = ei.AUTO_SIZE , height: t = ei.AUTO_SIZE , renderTarget: e , luminanceRange: n , colorOutput: i  } = {}){
        super("LuminancePass"), this.fullscreenMaterial = new m8(i, n), this.needsSwap = !1, this.renderTarget = e, this.renderTarget === void 0 && (this.renderTarget = new st(1, 1, {
            minFilter: Qe,
            magFilter: Qe,
            stencilBuffer: !1,
            depthBuffer: !1
        }), this.renderTarget.texture.name = "LuminancePass.Target", this.renderTarget.texture.generateMipmaps = !1);
        let s = this.resolution = new ei(this, r1, t);
        s.addEventListener("change", (o)=>this.setSize(s.baseWidth, s.baseHeight));
    }
    get texture() {
        return this.renderTarget.texture;
    }
    getTexture() {
        return this.renderTarget.texture;
    }
    getResolution() {
        return this.resolution;
    }
    render(r1, t, e, n, i) {
        let s = this.fullscreenMaterial;
        s.inputBuffer = t.texture, r1.setRenderTarget(this.renderToScreen ? null : this.renderTarget), r1.render(this.scene, this.camera);
    }
    setSize(r1, t) {
        let e = this.resolution;
        e.setBaseSize(r1, t), this.renderTarget.setSize(e.width, e.height);
    }
    initialize(r1, t, e) {
        e !== void 0 && e !== qt && (this.fullscreenMaterial.defines.FRAMEBUFFER_PRECISION_HIGH = "1");
    }
}, iI = class extends Un {
    constructor(r1, t){
        super("MaskPass", r1, t), this.needsSwap = !1, this.clearPass = new US(!1, !1, !0), this.inverse = !1;
    }
    get inverted() {
        return this.inverse;
    }
    set inverted(r1) {
        this.inverse = r1;
    }
    get clear() {
        return this.clearPass.enabled;
    }
    set clear(r1) {
        this.clearPass.enabled = r1;
    }
    getClearPass() {
        return this.clearPass;
    }
    isInverted() {
        return this.inverted;
    }
    setInverted(r1) {
        this.inverted = r1;
    }
    render(r1, t, e, n, i) {
        let s = r1.getContext(), o = r1.state.buffers, a = this.scene, l = this.camera, u = this.clearPass, c = this.inverted ? 0 : 1, d = 1 - c;
        o.color.setMask(!1), o.depth.setMask(!1), o.color.setLocked(!0), o.depth.setLocked(!0), o.stencil.setTest(!0), o.stencil.setOp(s.REPLACE, s.REPLACE, s.REPLACE), o.stencil.setFunc(s.ALWAYS, c, 4294967295), o.stencil.setClear(d), o.stencil.setLocked(!0), this.clearPass.enabled && (this.renderToScreen ? u.render(r1, null) : (u.render(r1, t), u.render(r1, e))), this.renderToScreen ? (r1.setRenderTarget(null), r1.render(a, l)) : (r1.setRenderTarget(t), r1.render(a, l), r1.setRenderTarget(e), r1.render(a, l)), o.color.setLocked(!1), o.depth.setLocked(!1), o.stencil.setLocked(!1), o.stencil.setFunc(s.EQUAL, 1, 4294967295), o.stencil.setOp(s.KEEP, s.KEEP, s.KEEP), o.stencil.setLocked(!0);
    }
};
var js = class extends Un {
    constructor(r1, t = "inputBuffer"){
        super("ShaderPass"), this.fullscreenMaterial = r1, this.inputBufferUniform = null, this.setInput(t);
    }
    setInput(r1) {
        if (this.inputBufferUniform = null, this.fullscreenMaterial !== null) {
            let t = this.fullscreenMaterial.uniforms;
            t !== void 0 && t[r1] !== void 0 && (this.inputBufferUniform = t[r1]);
        }
    }
    render(r1, t, e, n, i) {
        this.inputBufferUniform !== null && t !== null && (this.inputBufferUniform.value = t.texture), r1.setRenderTarget(this.renderToScreen ? null : e), r1.render(this.scene, this.camera);
    }
    initialize(r1, t, e) {
        e !== void 0 && e !== qt && (this.fullscreenMaterial.defines.FRAMEBUFFER_PRECISION_HIGH = "1");
    }
}, LS = 0.001, X8 = 1e3, sI = class {
    constructor(){
        this.previousTime = 0, this.currentTime = 0, this.delta = 0, this.fixedDelta = 1e3 / 60, this.elapsed = 0, this.timescale = 1, this.fixedDeltaEnabled = !1, this.autoReset = !1;
    }
    setFixedDeltaEnabled(r1) {
        return this.fixedDeltaEnabled = r1, this;
    }
    isAutoResetEnabled(r1) {
        return this.autoReset;
    }
    setAutoResetEnabled(r1) {
        return typeof document < "u" && document.hidden !== void 0 && (r1 ? document.addEventListener("visibilitychange", this) : document.removeEventListener("visibilitychange", this), this.autoReset = r1), this;
    }
    getDelta() {
        return this.delta * LS;
    }
    getFixedDelta() {
        return this.fixedDelta * LS;
    }
    setFixedDelta(r1) {
        return this.fixedDelta = r1 * X8, this;
    }
    getElapsed() {
        return this.elapsed * LS;
    }
    getTimescale() {
        return this.timescale;
    }
    setTimescale(r1) {
        return this.timescale = r1, this;
    }
    update(r1) {
        return this.fixedDeltaEnabled ? this.delta = this.fixedDelta : (this.previousTime = this.currentTime, this.currentTime = r1 !== void 0 ? r1 : performance.now(), this.delta = this.currentTime - this.previousTime), this.delta *= this.timescale, this.elapsed += this.delta, this;
    }
    reset() {
        return this.delta = 0, this.elapsed = 0, this.currentTime = performance.now(), this;
    }
    handleEvent(r1) {
        document.hidden || (this.currentTime = performance.now());
    }
    dispose() {
        this.setAutoResetEnabled(!1);
    }
};
var zS = {
    VERY_SMALL: 0,
    SMALL: 1,
    MEDIUM: 2,
    LARGE: 3,
    VERY_LARGE: 4,
    HUGE: 5
};
var Y8 = `#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D map;
#else
uniform lowp sampler2D map;
#endif
uniform float intensity;void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){outputColor=clamp(texture2D(map,uv)*intensity,0.0,1.0);}`, oI = class extends Xs {
    constructor({ blendFunction: r1 = lt.SCREEN , luminanceThreshold: t = .9 , luminanceSmoothing: e = .025 , resolutionScale: n = .5 , intensity: i = 1 , width: s = ei.AUTO_SIZE , height: o = ei.AUTO_SIZE , kernelSize: a = zS.LARGE  } = {}){
        super("BloomEffect", Y8, {
            blendFunction: r1,
            uniforms: new Map([
                [
                    "map",
                    new ie(null)
                ],
                [
                    "intensity",
                    new ie(i)
                ]
            ])
        }), this.renderTarget = new st(1, 1, {
            minFilter: Qe,
            magFilter: Qe,
            stencilBuffer: !1,
            depthBuffer: !1
        }), this.renderTarget.texture.name = "Bloom.Target", this.renderTarget.texture.generateMipmaps = !1, this.uniforms.get("map").value = this.renderTarget.texture, this.luminancePass = new q8({
            renderTarget: this.renderTarget,
            colorOutput: !0
        }), this.luminanceMaterial.threshold = t, this.luminanceMaterial.smoothingFactor = e, this.blurPass = new rI({
            resolutionScale: n,
            width: s,
            height: o,
            kernelSize: a
        });
        let l = this.blurPass.getResolution();
        l.addEventListener("change", (u)=>this.setSize(l.baseWidth, l.baseHeight));
    }
    get texture() {
        return this.renderTarget.texture;
    }
    getTexture() {
        return this.renderTarget.texture;
    }
    get resolution() {
        return this.blurPass.resolution;
    }
    getResolution() {
        return this.blurPass.resolution;
    }
    getBlurPass() {
        return this.blurPass;
    }
    getLuminancePass() {
        return this.luminancePass;
    }
    get luminanceMaterial() {
        return this.luminancePass.fullscreenMaterial;
    }
    getLuminanceMaterial() {
        return this.luminancePass.fullscreenMaterial;
    }
    get width() {
        return this.resolution.width;
    }
    set width(r1) {
        this.resolution.preferredWidth = r1;
    }
    get height() {
        return this.resolution.height;
    }
    set height(r1) {
        this.resolution.preferredHeight = r1;
    }
    get dithering() {
        return this.blurPass.dithering;
    }
    set dithering(r1) {
        this.blurPass.dithering = r1;
    }
    get kernelSize() {
        return this.blurPass.kernelSize;
    }
    set kernelSize(r1) {
        this.blurPass.kernelSize = r1;
    }
    get distinction() {
        return console.warn(this.name, "distinction was removed"), 1;
    }
    set distinction(r1) {
        console.warn(this.name, "distinction was removed");
    }
    get intensity() {
        return this.uniforms.get("intensity").value;
    }
    set intensity(r1) {
        this.uniforms.get("intensity").value = r1;
    }
    getIntensity() {
        return this.intensity;
    }
    setIntensity(r1) {
        this.intensity = r1;
    }
    getResolutionScale() {
        return this.resolution.scale;
    }
    setResolutionScale(r1) {
        this.resolution.scale = r1;
    }
    update(r1, t, e) {
        let n = this.renderTarget;
        this.luminancePass.enabled ? (this.luminancePass.render(r1, t, n), this.blurPass.render(r1, n, n)) : this.blurPass.render(r1, t, n);
    }
    setSize(r1, t) {
        let e = this.resolution;
        e.setBaseSize(r1, t), this.renderTarget.setSize(e.width, e.height), this.luminancePass.resolution.copy(e);
    }
    initialize(r1, t, e) {
        this.blurPass.initialize(r1, t, e), e !== void 0 && (this.renderTarget.texture.type = e, r1.outputEncoding === Ye && (this.renderTarget.texture.encoding = Ye));
    }
};
var Q8 = "uniform float brightness;uniform float contrast;void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){vec3 color=inputColor.rgb+vec3(brightness-0.5);if(contrast>0.0){color/=vec3(1.0-contrast);}else{color*=vec3(1.0+contrast);}outputColor=vec4(min(color+vec3(0.5),1.0),inputColor.a);}", aI = class extends Xs {
    constructor({ blendFunction: r1 = lt.NORMAL , brightness: t = 0 , contrast: e = 0  } = {}){
        super("BrightnessContrastEffect", Q8, {
            blendFunction: r1,
            uniforms: new Map([
                [
                    "brightness",
                    new ie(t)
                ],
                [
                    "contrast",
                    new ie(e)
                ]
            ])
        });
    }
    get brightness() {
        return this.uniforms.get("brightness").value;
    }
    set brightness(r1) {
        this.uniforms.get("brightness").value = r1;
    }
    getBrightness(r1) {
        return this.brightness;
    }
    setBrightness(r1) {
        this.brightness = r1;
    }
    get contrast() {
        return this.uniforms.get("contrast").value;
    }
    set contrast(r1) {
        this.uniforms.get("contrast").value = r1;
    }
    getContrast(r1) {
        return this.contrast;
    }
    setContrast(r1) {
        this.contrast = r1;
    }
}, K8 = "void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){outputColor=vec4(vec3(average(inputColor.rgb)),inputColor.a);}", lI = class extends Xs {
    constructor(r1 = lt.NORMAL){
        super("ColorAverageEffect", K8, {
            blendFunction: r1
        });
    }
};
var Z8 = "varying vec2 vUvR;varying vec2 vUvB;void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){vec2 ra=texture2D(inputBuffer,vUvR).ra;vec2 ba=texture2D(inputBuffer,vUvB).ba;outputColor=vec4(ra.x,inputColor.g,ba.x,max(max(ra.y,ba.y),inputColor.a));}", J8 = "uniform vec2 offset;varying vec2 vUvR;varying vec2 vUvB;void mainSupport(const in vec2 uv){vec2 shift=offset*vec2(1.0,aspect);vUvR=uv+shift;vUvB=uv-shift;}", cI = class extends Xs {
    constructor({ blendFunction: r1 = lt.NORMAL , offset: t = new F(.001, 5e-4)  } = {}){
        super("ChromaticAberrationEffect", Z8, {
            vertexShader: J8,
            blendFunction: r1,
            attributes: qs.CONVOLUTION,
            uniforms: new Map([
                [
                    "offset",
                    new ie(t)
                ]
            ])
        });
    }
    get offset() {
        return this.uniforms.get("offset").value;
    }
    set offset(r1) {
        this.uniforms.get("offset").value = r1;
    }
    getOffset() {
        return this.offset;
    }
    setOffset(r1) {
        this.offset = r1;
    }
};
var $8 = `#ifdef FRAMEBUFFER_PRECISION_HIGH
uniform mediump sampler2D nearColorBuffer;uniform mediump sampler2D farColorBuffer;
#else
uniform lowp sampler2D nearColorBuffer;uniform lowp sampler2D farColorBuffer;
#endif
uniform lowp sampler2D nearCoCBuffer;uniform float scale;void mainImage(const in vec4 inputColor,const in vec2 uv,const in float depth,out vec4 outputColor){vec4 colorNear=texture2D(nearColorBuffer,uv);vec4 colorFar=texture2D(farColorBuffer,uv);float CoCNear=texture2D(nearCoCBuffer,uv).r;CoCNear=min(CoCNear*scale,1.0);vec4 result=inputColor*(1.0-colorFar.a)+colorFar;result=mix(result,colorNear,CoCNear);outputColor=result;}`, uI = class extends Xs {
    constructor(r1, { blendFunction: t = lt.NORMAL , worldFocusDistance: e , worldFocusRange: n , focusDistance: i = 0 , focalLength: s = .1 , focusRange: o = s , bokehScale: a = 1 , width: l = ei.AUTO_SIZE , height: u = ei.AUTO_SIZE  } = {}){
        super("DepthOfFieldEffect", $8, {
            blendFunction: t,
            attributes: qs.DEPTH,
            uniforms: new Map([
                [
                    "nearColorBuffer",
                    new ie(null)
                ],
                [
                    "farColorBuffer",
                    new ie(null)
                ],
                [
                    "nearCoCBuffer",
                    new ie(null)
                ],
                [
                    "scale",
                    new ie(1)
                ]
            ])
        }), this.camera = r1, this.renderTarget = new st(1, 1, {
            minFilter: Qe,
            magFilter: Qe,
            stencilBuffer: !1,
            depthBuffer: !1
        }), this.renderTarget.texture.name = "DoF.Intermediate", this.renderTarget.texture.generateMipmaps = !1, this.renderTargetMasked = this.renderTarget.clone(), this.renderTargetMasked.texture.name = "DoF.Masked.Far", this.renderTargetNear = this.renderTarget.clone(), this.renderTargetNear.texture.name = "DoF.Bokeh.Near", this.uniforms.get("nearColorBuffer").value = this.renderTargetNear.texture, this.renderTargetFar = this.renderTarget.clone(), this.renderTargetFar.texture.name = "DoF.Bokeh.Far", this.uniforms.get("farColorBuffer").value = this.renderTargetFar.texture, this.renderTargetCoC = this.renderTarget.clone(), this.renderTargetCoC.texture.name = "DoF.CoC", this.renderTargetCoCBlurred = this.renderTargetCoC.clone(), this.renderTargetCoCBlurred.texture.name = "DoF.CoC.Blurred", this.uniforms.get("nearCoCBuffer").value = this.renderTargetCoCBlurred.texture, this.cocPass = new js(new r8(r1));
        let c = this.cocMaterial;
        c.focusDistance = i, c.focusRange = o, e !== void 0 && (c.worldFocusDistance = e), n !== void 0 && (c.worldFocusRange = n), this.blurPass = new rI({
            kernelSize: zS.MEDIUM,
            width: l,
            height: u
        });
        let d = this.blurPass.getResolution();
        d.addEventListener("change", (f)=>this.setSize(d.getBaseWidth(), d.getBaseHeight())), this.maskPass = new js(new y8(this.renderTargetCoC.texture));
        let h = this.maskPass.fullscreenMaterial;
        h.maskFunction = tI.MULTIPLY, h.colorChannel = eI.GREEN, this.bokehNearBasePass = new js(new dv(!1, !0)), this.bokehNearBasePass.fullscreenMaterial.cocBuffer = this.renderTargetCoCBlurred.texture, this.bokehNearFillPass = new js(new dv(!0, !0)), this.bokehNearFillPass.fullscreenMaterial.cocBuffer = this.renderTargetCoCBlurred.texture, this.bokehFarBasePass = new js(new dv(!1, !1)), this.bokehFarBasePass.fullscreenMaterial.cocBuffer = this.renderTargetCoC.texture, this.bokehFarFillPass = new js(new dv(!0, !1)), this.bokehFarFillPass.fullscreenMaterial.cocBuffer = this.renderTargetCoC.texture, this.target = null, this.bokehScale = a;
    }
    get cocTexture() {
        return this.renderTargetCoC.texture;
    }
    get cocMaterial() {
        return this.cocPass.fullscreenMaterial;
    }
    get circleOfConfusionMaterial() {
        return this.cocMaterial;
    }
    getCircleOfConfusionMaterial() {
        return this.circleOfConfusionMaterial;
    }
    getBlurPass() {
        return this.blurPass;
    }
    get resolution() {
        return this.blurPass.getResolution();
    }
    getResolution() {
        return this.blurPass.getResolution();
    }
    get bokehScale() {
        return this.uniforms.get("scale").value;
    }
    set bokehScale(r1) {
        let t = [
            this.bokehNearBasePass,
            this.bokehNearFillPass,
            this.bokehFarBasePass,
            this.bokehFarFillPass
        ];
        for (let e of t)e.fullscreenMaterial.setScale(r1);
        this.maskPass.fullscreenMaterial.setStrength(r1), this.uniforms.get("scale").value = r1;
    }
    getBokehScale() {
        return this.bokehScale;
    }
    setBokehScale(r1) {
        this.bokehScale = r1;
    }
    getTarget() {
        return this.target;
    }
    setTarget(r1) {
        this.target = r1;
    }
    calculateFocusDistance(r1) {
        let t = this.camera, e = t.position.distanceTo(r1);
        return BS(-e, t.near, t.far);
    }
    setDepthTexture(r1, t = tr) {
        this.circleOfConfusionMaterial.depthBuffer = r1, this.circleOfConfusionMaterial.depthPacking = t;
    }
    update(r1, t, e) {
        let n = this.renderTarget, i = this.renderTargetCoC, s = this.renderTargetCoCBlurred, o = this.renderTargetMasked;
        if (this.target !== null) {
            let a = this.calculateFocusDistance(this.target);
            this.circleOfConfusionMaterial.focusDistance = a;
        }
        this.cocPass.render(r1, null, i), this.blurPass.render(r1, i, s), this.maskPass.render(r1, t, o), this.bokehFarBasePass.render(r1, o, n), this.bokehFarFillPass.render(r1, n, this.renderTargetFar), this.bokehNearBasePass.render(r1, t, n), this.bokehNearFillPass.render(r1, n, this.renderTargetNear);
    }
    setSize(r1, t) {
        let e = this.resolution;
        e.setBaseSize(r1, t);
        let n = e.width, i = e.height, s = [
            this.cocPass,
            this.blurPass,
            this.maskPass,
            this.bokehNearBasePass,
            this.bokehNearFillPass,
            this.bokehFarBasePass,
            this.bokehFarFillPass
        ];
        s.push(this.renderTargetCoC, this.renderTargetMasked), s.forEach((a)=>a.setSize(r1, t)), s = [
            this.renderTarget,
            this.renderTargetNear,
            this.renderTargetFar,
            this.renderTargetCoCBlurred
        ], s.forEach((a)=>a.setSize(n, i)), [
            this.bokehNearBasePass,
            this.bokehNearFillPass,
            this.bokehFarBasePass,
            this.bokehFarFillPass
        ].forEach((a)=>a.fullscreenMaterial.setSize(n, i));
    }
    initialize(r1, t, e) {
        [
            this.cocPass,
            this.maskPass,
            this.bokehNearBasePass,
            this.bokehNearFillPass,
            this.bokehFarBasePass,
            this.bokehFarFillPass
        ].forEach((i)=>i.initialize(r1, t, e)), this.blurPass.initialize(r1, t, qt), e !== void 0 && (this.renderTarget.texture.type = e, this.renderTargetNear.texture.type = e, this.renderTargetFar.texture.type = e, this.renderTargetMasked.texture.type = e, r1.outputEncoding === Ye && (this.renderTarget.texture.encoding = Ye, this.renderTargetNear.texture.encoding = Ye, this.renderTargetFar.texture.encoding = Ye, this.renderTargetMasked.texture.encoding = Ye));
    }
};
var yCe = new A, vCe = new ae;
var eq = "uniform vec3 hue;uniform float saturation;void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){vec3 color=vec3(dot(inputColor.rgb,hue.xyz),dot(inputColor.rgb,hue.zxy),dot(inputColor.rgb,hue.yzx));float average=(color.r+color.g+color.b)/3.0;vec3 diff=average-color;if(saturation>0.0){color+=diff*(1.0-1.0/(1.001-saturation));}else{color+=diff*-saturation;}outputColor=vec4(min(color,1.0),inputColor.a);}", dI = class extends Xs {
    constructor({ blendFunction: r1 = lt.NORMAL , hue: t = 0 , saturation: e = 0  } = {}){
        super("HueSaturationEffect", eq, {
            blendFunction: r1,
            uniforms: new Map([
                [
                    "hue",
                    new ie(new A)
                ],
                [
                    "saturation",
                    new ie(e)
                ]
            ])
        }), this.hue = t;
    }
    get saturation() {
        return this.uniforms.get("saturation").value;
    }
    set saturation(r1) {
        this.uniforms.get("saturation").value = r1;
    }
    getSaturation() {
        return this.saturation;
    }
    setSaturation(r1) {
        this.saturation = r1;
    }
    get hue() {
        let r1 = this.uniforms.get("hue").value;
        return Math.acos((r1.x * 3 - 1) / 2);
    }
    set hue(r1) {
        let t = Math.sin(r1), e = Math.cos(r1);
        this.uniforms.get("hue").value.set((2 * e + 1) / 3, (-Math.sqrt(3) * t - e + 1) / 3, (Math.sqrt(3) * t - e + 1) / 3);
    }
    getHue() {
        return this.hue;
    }
    setHue(r1) {
        this.hue = r1;
    }
};
var wCe = new Ne;
var tq = `void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){vec3 noise=vec3(rand(uv*time));
#ifdef PREMULTIPLY
outputColor=vec4(min(inputColor.rgb*noise,vec3(1.0)),inputColor.a);
#else
outputColor=vec4(noise,inputColor.a);
#endif
}`, hI = class extends Xs {
    constructor({ blendFunction: r1 = lt.SCREEN , premultiply: t = !1  } = {}){
        super("NoiseEffect", tq, {
            blendFunction: r1
        }), this.premultiply = t;
    }
    get premultiply() {
        return this.defines.has("PREMULTIPLY");
    }
    set premultiply(r1) {
        this.premultiply !== r1 && (r1 ? this.defines.set("PREMULTIPLY", "1") : this.defines.delete("PREMULTIPLY"), this.setChanged());
    }
    isPremultiplied() {
        return this.premultiply;
    }
    setPremultiplied(r1) {
        this.premultiply = r1;
    }
};
var nq = "uniform bool active;uniform vec2 d;void mainUv(inout vec2 uv){if(active){uv=vec2(d.x*(floor(uv.x/d.x)+0.5),d.y*(floor(uv.y/d.y)+0.5));}}", fI = class extends Xs {
    constructor(r1 = 30){
        super("PixelationEffect", nq, {
            uniforms: new Map([
                [
                    "active",
                    new ie(!1)
                ],
                [
                    "d",
                    new ie(new F)
                ]
            ])
        }), this.resolution = new F, this.d = 0, this.granularity = r1;
    }
    get granularity() {
        return this.d;
    }
    set granularity(r1) {
        let t = Math.floor(r1);
        t % 2 > 0 && (t += 1), this.d = t, this.uniforms.get("active").value = t > 0, this.setSize(this.resolution.width, this.resolution.height);
    }
    getGranularity() {
        return this.granularity;
    }
    setGranularity(r1) {
        this.granularity = r1;
    }
    setSize(r1, t) {
        this.resolution.set(r1, t), this.uniforms.get("d").value.setScalar(this.d).divide(this.resolution);
    }
};
var _Ce = Math.PI * .5, MCe = new A, TCe = new A;
var JD = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAAAQCAYAAACm53kpAAAAeElEQVRYR+2XSwqAMAxEJ168ePEqwRSKhIIiuHjJqiU0gWE+1CQdApcVAMUAuARaMGCX1MIL/Ow13++9lW2s3mW9MWvsnWc/2fvGygwPAN4E8QzAA4CXAB6AHjG4JTHYI1ey3pcx6FHnEfhLDOIBKAmUBK6/ANUDTlROXAHd9EC1AAAAAElFTkSuQmCC", $D = "data:image/png;base64,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", rq = "uniform sampler2D weightMap;varying vec2 vOffset0;varying vec2 vOffset1;void movec(const in bvec2 c,inout vec2 variable,const in vec2 value){if(c.x){variable.x=value.x;}if(c.y){variable.y=value.y;}}void movec(const in bvec4 c,inout vec4 variable,const in vec4 value){movec(c.xy,variable.xy,value.xy);movec(c.zw,variable.zw,value.zw);}void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){vec4 a;a.x=texture2D(weightMap,vOffset0).a;a.y=texture2D(weightMap,vOffset1).g;a.wz=texture2D(weightMap,uv).rb;vec4 color=inputColor;if(dot(a,vec4(1.0))>=1e-5){bool h=max(a.x,a.z)>max(a.y,a.w);vec4 blendingOffset=vec4(0.0,a.y,0.0,a.w);vec2 blendingWeight=a.yw;movec(bvec4(h),blendingOffset,vec4(a.x,0.0,a.z,0.0));movec(bvec2(h),blendingWeight,a.xz);blendingWeight/=dot(blendingWeight,vec2(1.0));vec4 blendingCoord=blendingOffset*vec4(texelSize,-texelSize)+uv.xyxy;color=blendingWeight.x*texture2D(inputBuffer,blendingCoord.xy);color+=blendingWeight.y*texture2D(inputBuffer,blendingCoord.zw);}outputColor=color;}", iq = "varying vec2 vOffset0;varying vec2 vOffset1;void mainSupport(const in vec2 uv){vOffset0=uv+texelSize*vec2(1.0,0.0);vOffset1=uv+texelSize*vec2(0.0,1.0);}", No = {
    LOW: 0,
    MEDIUM: 1,
    HIGH: 2,
    ULTRA: 3
}, fv = class extends Xs {
    constructor({ preset: r1 = No.MEDIUM , edgeDetectionMode: t = kd.COLOR , predicationMode: e = u8.DISABLED  } = {}){
        super("SMAAEffect", rq, {
            vertexShader: iq,
            blendFunction: lt.NORMAL,
            attributes: qs.CONVOLUTION | qs.DEPTH,
            uniforms: new Map([
                [
                    "weightMap",
                    new ie(null)
                ]
            ])
        });
        let n, i;
        arguments.length > 1 && (n = arguments[0], i = arguments[1], arguments.length > 2 && (r1 = arguments[2]), arguments.length > 3 && (t = arguments[3])), this.renderTargetEdges = new st(1, 1, {
            minFilter: Qe,
            stencilBuffer: !1,
            depthBuffer: !1
        }), this.renderTargetEdges.texture.name = "SMAA.Edges", this.renderTargetWeights = this.renderTargetEdges.clone(), this.renderTargetWeights.texture.name = "SMAA.Weights", this.uniforms.get("weightMap").value = this.renderTargetWeights.texture, this.clearPass = new US(!0, !1, !1), this.clearPass.overrideClearColor = new Ne(0), this.clearPass.overrideClearAlpha = 1, this.edgeDetectionPass = new js(new d8), this.edgeDetectionMaterial.edgeDetectionMode = t, this.edgeDetectionMaterial.predicationMode = e, this.weightsPass = new js(new b8);
        let s = new Mh;
        s.onLoad = ()=>{
            let o = new Vt(n);
            o.name = "SMAA.Search", o.magFilter = _t, o.minFilter = _t, o.generateMipmaps = !1, o.needsUpdate = !0, o.flipY = !0, this.weightsMaterial.searchTexture = o;
            let a = new Vt(i);
            a.name = "SMAA.Area", a.magFilter = Qe, a.minFilter = Qe, a.generateMipmaps = !1, a.needsUpdate = !0, a.flipY = !1, this.weightsMaterial.areaTexture = a, this.dispatchEvent({
                type: "load"
            });
        }, s.itemStart("search"), s.itemStart("area"), n !== void 0 && i !== void 0 ? (s.itemEnd("search"), s.itemEnd("area")) : typeof Image < "u" && (n = new Image, i = new Image, n.addEventListener("load", ()=>s.itemEnd("search")), i.addEventListener("load", ()=>s.itemEnd("area")), n.src = JD, i.src = $D), this.applyPreset(r1);
    }
    get edgesTexture() {
        return this.renderTargetEdges.texture;
    }
    getEdgesTexture() {
        return this.edgesTexture;
    }
    get weightsTexture() {
        return this.renderTargetWeights.texture;
    }
    getWeightsTexture() {
        return this.weightsTexture;
    }
    get edgeDetectionMaterial() {
        return this.edgeDetectionPass.fullscreenMaterial;
    }
    get colorEdgesMaterial() {
        return this.edgeDetectionMaterial;
    }
    getEdgeDetectionMaterial() {
        return this.edgeDetectionMaterial;
    }
    get weightsMaterial() {
        return this.weightsPass.fullscreenMaterial;
    }
    getWeightsMaterial() {
        return this.weightsMaterial;
    }
    setEdgeDetectionThreshold(r1) {
        this.edgeDetectionMaterial.edgeDetectionThreshold = r1;
    }
    setOrthogonalSearchSteps(r1) {
        this.weightsMaterial.orthogonalSearchSteps = r1;
    }
    applyPreset(r1) {
        let t = this.edgeDetectionMaterial, e = this.weightsMaterial;
        switch(r1){
            case No.LOW:
                t.edgeDetectionThreshold = .15, e.orthogonalSearchSteps = 4, e.diagonalDetection = !1, e.cornerDetection = !1;
                break;
            case No.MEDIUM:
                t.edgeDetectionThreshold = .1, e.orthogonalSearchSteps = 8, e.diagonalDetection = !1, e.cornerDetection = !1;
                break;
            case No.HIGH:
                t.edgeDetectionThreshold = .1, e.orthogonalSearchSteps = 16, e.diagonalSearchSteps = 8, e.cornerRounding = 25, e.diagonalDetection = !0, e.cornerDetection = !0;
                break;
            case No.ULTRA:
                t.edgeDetectionThreshold = .05, e.orthogonalSearchSteps = 32, e.diagonalSearchSteps = 16, e.cornerRounding = 25, e.diagonalDetection = !0, e.cornerDetection = !0;
                break;
        }
    }
    setDepthTexture(r1, t = tr) {
        this.edgeDetectionMaterial.depthBuffer = r1, this.edgeDetectionMaterial.depthPacking = t;
    }
    update(r1, t, e) {
        this.clearPass.render(r1, this.renderTargetEdges), this.edgeDetectionPass.render(r1, t, this.renderTargetEdges), this.weightsPass.render(r1, this.renderTargetEdges, this.renderTargetWeights);
    }
    setSize(r1, t) {
        this.edgeDetectionMaterial.setSize(r1, t), this.weightsMaterial.setSize(r1, t), this.renderTargetEdges.setSize(r1, t), this.renderTargetWeights.setSize(r1, t);
    }
    dispose() {
        let { searchTexture: r1 , areaTexture: t  } = this.weightsMaterial;
        r1 !== null && t !== null && (r1.dispose(), t.dispose()), super.dispose();
    }
    static get searchImageDataURL() {
        return JD;
    }
    static get areaImageDataURL() {
        return $D;
    }
};
var sq = `uniform float offset;uniform float darkness;void mainImage(const in vec4 inputColor,const in vec2 uv,out vec4 outputColor){const vec2 center=vec2(0.5);vec3 color=inputColor.rgb;
#if VIGNETTE_TECHNIQUE == 0
float d=distance(uv,center);color*=smoothstep(0.8,offset*0.799,d*(darkness+offset));
#else
vec2 coord=(uv-center)*vec2(offset);color=mix(color,vec3(1.0-darkness),dot(coord,coord));
#endif
outputColor=vec4(color,inputColor.a);}`, hv = {
    DEFAULT: 0,
    ESKIL: 1
}, pI = class extends Xs {
    constructor({ blendFunction: r1 = lt.NORMAL , technique: t = hv.DEFAULT , eskil: e = !1 , offset: n = .5 , darkness: i = .5  } = {}){
        super("VignetteEffect", sq, {
            blendFunction: r1,
            defines: new Map([
                [
                    "VIGNETTE_TECHNIQUE",
                    t.toFixed(0)
                ]
            ]),
            uniforms: new Map([
                [
                    "offset",
                    new ie(n)
                ],
                [
                    "darkness",
                    new ie(i)
                ]
            ])
        });
    }
    get technique() {
        return Number(this.defines.get("VIGNETTE_TECHNIQUE"));
    }
    set technique(r1) {
        this.technique !== r1 && (this.defines.set("VIGNETTE_TECHNIQUE", r1.toFixed(0)), this.setChanged());
    }
    get eskil() {
        return this.technique === hv.ESKIL;
    }
    set eskil(r1) {
        this.technique = r1 ? hv.ESKIL : hv.DEFAULT;
    }
    getTechnique() {
        return this.technique;
    }
    setTechnique(r1) {
        this.technique = r1;
    }
    get offset() {
        return this.uniforms.get("offset").value;
    }
    set offset(r1) {
        this.uniforms.get("offset").value = r1;
    }
    getOffset() {
        return this.offset;
    }
    setOffset(r1) {
        this.offset = r1;
    }
    get darkness() {
        return this.uniforms.get("darkness").value;
    }
    set darkness(r1) {
        this.uniforms.get("darkness").value = r1;
    }
    getDarkness() {
        return this.darkness;
    }
    setDarkness(r1) {
        this.darkness = r1;
    }
}, PCe = [
    new Float32Array(3),
    new Float32Array(3)
], DCe = [
    new Float32Array(3),
    new Float32Array(3),
    new Float32Array(3),
    new Float32Array(3)
], ICe = [
    [
        new Float32Array([
            0,
            0,
            0
        ]),
        new Float32Array([
            1,
            0,
            0
        ]),
        new Float32Array([
            1,
            1,
            0
        ]),
        new Float32Array([
            1,
            1,
            1
        ])
    ],
    [
        new Float32Array([
            0,
            0,
            0
        ]),
        new Float32Array([
            1,
            0,
            0
        ]),
        new Float32Array([
            1,
            0,
            1
        ]),
        new Float32Array([
            1,
            1,
            1
        ])
    ],
    [
        new Float32Array([
            0,
            0,
            0
        ]),
        new Float32Array([
            0,
            0,
            1
        ]),
        new Float32Array([
            1,
            0,
            1
        ]),
        new Float32Array([
            1,
            1,
            1
        ])
    ],
    [
        new Float32Array([
            0,
            0,
            0
        ]),
        new Float32Array([
            0,
            1,
            0
        ]),
        new Float32Array([
            1,
            1,
            0
        ]),
        new Float32Array([
            1,
            1,
            1
        ])
    ],
    [
        new Float32Array([
            0,
            0,
            0
        ]),
        new Float32Array([
            0,
            1,
            0
        ]),
        new Float32Array([
            0,
            1,
            1
        ]),
        new Float32Array([
            1,
            1,
            1
        ])
    ],
    [
        new Float32Array([
            0,
            0,
            0
        ]),
        new Float32Array([
            0,
            0,
            1
        ]),
        new Float32Array([
            0,
            1,
            1
        ]),
        new Float32Array([
            1,
            1,
            1
        ])
    ]
];
var OCe = [
    new Float32Array(2),
    new Float32Array(2)
];
var RCe = new Float32Array([
    0,
    -0.25,
    .25,
    -0.125,
    .125,
    -0.375,
    .375
]), LCe = [
    new Float32Array([
        0,
        0
    ]),
    new Float32Array([
        .25,
        -0.25
    ]),
    new Float32Array([
        -0.25,
        .25
    ]),
    new Float32Array([
        .125,
        -0.125
    ]),
    new Float32Array([
        -0.125,
        .125
    ])
], NCe = [
    new Uint8Array([
        0,
        0
    ]),
    new Uint8Array([
        3,
        0
    ]),
    new Uint8Array([
        0,
        3
    ]),
    new Uint8Array([
        3,
        3
    ]),
    new Uint8Array([
        1,
        0
    ]),
    new Uint8Array([
        4,
        0
    ]),
    new Uint8Array([
        1,
        3
    ]),
    new Uint8Array([
        4,
        3
    ]),
    new Uint8Array([
        0,
        1
    ]),
    new Uint8Array([
        3,
        1
    ]),
    new Uint8Array([
        0,
        4
    ]),
    new Uint8Array([
        3,
        4
    ]),
    new Uint8Array([
        1,
        1
    ]),
    new Uint8Array([
        4,
        1
    ]),
    new Uint8Array([
        1,
        4
    ]),
    new Uint8Array([
        4,
        4
    ])
], BCe = [
    new Uint8Array([
        0,
        0
    ]),
    new Uint8Array([
        1,
        0
    ]),
    new Uint8Array([
        0,
        2
    ]),
    new Uint8Array([
        1,
        2
    ]),
    new Uint8Array([
        2,
        0
    ]),
    new Uint8Array([
        3,
        0
    ]),
    new Uint8Array([
        2,
        2
    ]),
    new Uint8Array([
        3,
        2
    ]),
    new Uint8Array([
        0,
        1
    ]),
    new Uint8Array([
        1,
        1
    ]),
    new Uint8Array([
        0,
        3
    ]),
    new Uint8Array([
        1,
        3
    ]),
    new Uint8Array([
        2,
        1
    ]),
    new Uint8Array([
        3,
        1
    ]),
    new Uint8Array([
        2,
        3
    ]),
    new Uint8Array([
        3,
        3
    ])
];
var FCe = new Map([
    [
        Er(0, 0, 0, 0),
        new Float32Array([
            0,
            0,
            0,
            0
        ])
    ],
    [
        Er(0, 0, 0, 1),
        new Float32Array([
            0,
            0,
            0,
            1
        ])
    ],
    [
        Er(0, 0, 1, 0),
        new Float32Array([
            0,
            0,
            1,
            0
        ])
    ],
    [
        Er(0, 0, 1, 1),
        new Float32Array([
            0,
            0,
            1,
            1
        ])
    ],
    [
        Er(0, 1, 0, 0),
        new Float32Array([
            0,
            1,
            0,
            0
        ])
    ],
    [
        Er(0, 1, 0, 1),
        new Float32Array([
            0,
            1,
            0,
            1
        ])
    ],
    [
        Er(0, 1, 1, 0),
        new Float32Array([
            0,
            1,
            1,
            0
        ])
    ],
    [
        Er(0, 1, 1, 1),
        new Float32Array([
            0,
            1,
            1,
            1
        ])
    ],
    [
        Er(1, 0, 0, 0),
        new Float32Array([
            1,
            0,
            0,
            0
        ])
    ],
    [
        Er(1, 0, 0, 1),
        new Float32Array([
            1,
            0,
            0,
            1
        ])
    ],
    [
        Er(1, 0, 1, 0),
        new Float32Array([
            1,
            0,
            1,
            0
        ])
    ],
    [
        Er(1, 0, 1, 1),
        new Float32Array([
            1,
            0,
            1,
            1
        ])
    ],
    [
        Er(1, 1, 0, 0),
        new Float32Array([
            1,
            1,
            0,
            0
        ])
    ],
    [
        Er(1, 1, 0, 1),
        new Float32Array([
            1,
            1,
            0,
            1
        ])
    ],
    [
        Er(1, 1, 1, 0),
        new Float32Array([
            1,
            1,
            1,
            0
        ])
    ],
    [
        Er(1, 1, 1, 1),
        new Float32Array([
            1,
            1,
            1,
            1
        ])
    ]
]);
function NS(r1, t, e) {
    return r1 + (t - r1) * e;
}
function Er(r1, t, e, n) {
    let i = NS(r1, t, .75), s = NS(e, n, 0.75);
    return NS(i, s, 0.875);
}
var Mn = class {
    constructor(t, e){
        this.enabled = !1;
        this.effect = new t(e), Object.defineProperty(this, "opacity", {
            enumerable: !0,
            set (n) {
                this.effect.blendMode.opacity.value = n;
            },
            get () {
                return this.effect.blendMode.opacity.value;
            }
        }), Object.defineProperty(this, "blendFunction", {
            enumerable: !0,
            set (n) {
                this.effect.blendMode.setBlendFunction(Number(n));
            },
            get () {
                return this.effect.blendMode.blendFunction;
            }
        }), this.blendFunction = lt.NORMAL;
    }
};
var zd = class extends Mn {
    constructor(){
        super(oI), this.blendFunction = lt.SCREEN;
    }
    set intensity(t) {
        this.effect.intensity = t;
    }
    get intensity() {
        return this.effect.intensity;
    }
    set luminanceThreshold(t) {
        this.effect.luminanceMaterial.threshold = t;
    }
    get luminanceThreshold() {
        return this.effect.luminanceMaterial.threshold;
    }
    set luminanceSmoothing(t) {
        this.effect.luminanceMaterial.smoothing = t;
    }
    get luminanceSmoothing() {
        return this.effect.luminanceMaterial.smoothing;
    }
    set blurScale(t) {
        this.effect.blurPass.scale = t;
    }
    get blurScale() {
        return this.effect.blurPass.scale;
    }
    set kernelSize(t) {
        this.effect.blurPass.kernelSize = t;
    }
    get kernelSize() {
        return this.effect.blurPass.kernelSize;
    }
};
var Gd = class extends Mn {
    constructor(){
        super(aI);
    }
    set contrast(t) {
        this.effect.uniforms.get("contrast").value = t;
    }
    get contrast() {
        return this.effect.uniforms.get("contrast").value;
    }
    set brightness(t) {
        this.effect.uniforms.get("brightness").value = t;
    }
    get brightness() {
        return this.effect.uniforms.get("brightness").value;
    }
};
var Vd = class extends Mn {
    constructor(){
        super(cI), this.effect.offset = new F(.01, .01);
    }
    set offset(t) {
        this.effect.offset.set(t[0] / 1e3, t[1] / 1e3);
    }
    get offset() {
        return [
            this.effect.offset.x * 1e3,
            this.effect.offset.y * 1e3
        ];
    }
};
var Hd = class extends Mn {
    constructor(){
        super(lI);
    }
};
var Wd = class extends Mn {
    constructor(){
        super(dI);
        this._hue = 0;
    }
    set hue(e) {
        this._hue = e, this.effect.setHue(e);
    }
    get hue() {
        return this._hue;
    }
    set saturation(e) {
        this.effect.uniforms.get("saturation").value = e;
    }
    get saturation() {
        return this.effect.uniforms.get("saturation").value;
    }
};
var jd = class extends Mn {
    constructor(){
        super(hI), this.blendFunction = lt.OVERLAY;
    }
};
var qd = class extends Mn {
    constructor(){
        super(pI);
    }
    get eskil() {
        return this.effect.eskil;
    }
    set eskil(t) {
        this.effect.eskil = t;
    }
    get darkness() {
        return this.effect.uniforms.get("darkness").value;
    }
    set darkness(t) {
        this.effect.uniforms.get("darkness").value = t;
    }
    get offset() {
        return this.effect.uniforms.get("offset").value;
    }
    set offset(t) {
        this.effect.uniforms.get("offset").value = t;
    }
};
var Xd = class extends Mn {
    constructor(t){
        super(uI, t);
    }
    set focalLength(t) {
        this.effect.circleOfConfusionMaterial.uniforms.focalLength.value = t;
    }
    get focalLength() {
        return this.effect.circleOfConfusionMaterial.uniforms.focalLength.value;
    }
    set focusDistance(t) {
        this.effect.circleOfConfusionMaterial.uniforms.focusDistance.value = t;
    }
    get focusDistance() {
        return this.effect.circleOfConfusionMaterial.uniforms.focusDistance.value;
    }
    get bokehScale() {
        return this.effect.bokehScale;
    }
    set bokehScale(t) {
        this.effect.bokehScale = t;
    }
};
var Yd = class extends Mn {
    constructor(){
        super(fI);
    }
    get granularity() {
        return this.effect.getGranularity();
    }
    set granularity(t) {
        this.effect.setGranularity(t);
    }
};
var mI = `#define GLSLIFY 1
varying vec2 vUv;varying vec2 vTexCoords[9];uniform vec2 resolution;void main(){vUv=position.xy*0.5+0.5;vec2 texelSize=vec2(1.0)/resolution;vTexCoords[0]=vUv+vec2(-texelSize.x,-texelSize.y);vTexCoords[1]=vUv+vec2(0.0,-texelSize.y);vTexCoords[2]=vUv+vec2(texelSize.x,-texelSize.y);vTexCoords[3]=vUv+vec2(-texelSize.x,0.0);vTexCoords[4]=vUv+vec2(0.0,0.0);vTexCoords[5]=vUv+vec2(texelSize.x,0.0);vTexCoords[6]=vUv+vec2(-texelSize.x,texelSize.y);vTexCoords[7]=vUv+vec2(0.0,texelSize.y);vTexCoords[8]=vUv+vec2(texelSize.x,texelSize.y);gl_Position=vec4(position.xy,1.0,1.0);}`;
var gI = `#define GLSLIFY 1
varying vec2 vUv;varying vec2 vTexCoords[9];uniform sampler2D inputBuffer;uniform sampler2D historyBuffer;uniform sampler2D velocityBuffer;uniform sampler2D depthBuffer;uniform vec2 resolution;vec4 sampleTextureCatmullRom(sampler2D tex,vec2 uv,vec2 texSize){vec2 samplePos=uv*texSize;vec2 texPos1=floor(samplePos-0.5)+0.5;vec2 f=samplePos-texPos1;vec2 w0=f*(-0.5+f*(1.0-0.5*f));vec2 w1=1.0+f*f*(-2.5+1.5*f);vec2 w2=f*(0.5+f*(2.0-1.5*f));vec2 w3=f*f*(-0.5+0.5*f);vec2 w12=w1+w2;vec2 offset12=w2/(w1+w2);vec2 texPos0=texPos1-1.0;vec2 texPos3=texPos1+2.0;vec2 texPos12=texPos1+offset12;texPos0/=texSize;texPos3/=texSize;texPos12/=texSize;vec4 result=vec4(0.0);result+=texture2D(tex,vec2(texPos12.x,texPos0.y))*w12.x*w0.y;result+=texture2D(tex,vec2(texPos0.x,texPos12.y))*w0.x*w12.y;result+=texture2D(tex,vec2(texPos12.x,texPos12.y))*w12.x*w12.y;result+=texture2D(tex,vec2(texPos3.x,texPos12.y))*w3.x*w12.y;result+=texture2D(tex,vec2(texPos12.x,texPos3.y))*w12.x*w3.y;return result;}vec3 getDilatedVelocity(){float closestDepth=100.0;vec2 closestUVOffset=vec2(0.0);for(int i=0;i<9;i++){float neighborDepth=texture2D(depthBuffer,vTexCoords[i]).r;if(neighborDepth<closestDepth){closestUVOffset=vTexCoords[i];closestDepth=neighborDepth;}}return texture2D(velocityBuffer,closestUVOffset).rgb;}vec4 clipAabb(vec3 aabbMin,vec3 aabbMax,vec4 p,vec4 q){vec3 pClip=0.5*(aabbMax+aabbMin);vec3 eClip=0.5*(aabbMax-aabbMin)+0.00000001;vec4 vClip=q-vec4(pClip,p.w);vec3 vUnit=vClip.xyz/eClip;vec3 aUnit=abs(vUnit);float maUnit=max(aUnit.x,max(aUnit.y,aUnit.z));if(maUnit>1.0){return vec4(pClip,p.w)+vClip/maUnit;}else{return q;}}void main(){vec3 dilatedVelocity=getDilatedVelocity();vec2 velocity=dilatedVelocity.rg*(dilatedVelocity.b);vec2 previousPixelPos=vUv-velocity;vec4 currentColor=texture2D(inputBuffer,vUv);vec4 previousColor=sampleTextureCatmullRom(historyBuffer,previousPixelPos,resolution);vec4 ctl=texture2D(inputBuffer,vTexCoords[0]);vec4 ctc=texture2D(inputBuffer,vTexCoords[1]);vec4 ctr=texture2D(inputBuffer,vTexCoords[2]);vec4 cml=texture2D(inputBuffer,vTexCoords[3]);vec4 cmc=texture2D(inputBuffer,vTexCoords[4]);vec4 cmr=texture2D(inputBuffer,vTexCoords[5]);vec4 cbl=texture2D(inputBuffer,vTexCoords[6]);vec4 cbc=texture2D(inputBuffer,vTexCoords[7]);vec4 cbr=texture2D(inputBuffer,vTexCoords[8]);vec4 cmin=min(ctl,min(ctc,min(ctr,min(cml,min(cmc,min(cmr,min(cbl,min(cbc,cbr))))))));vec4 cmax=max(ctl,max(ctc,max(ctr,max(cml,max(cmc,max(cmr,max(cbl,max(cbc,cbr))))))));vec4 cavg=(ctl+ctc+ctr+cml+cmc+cmr+cbl+cbc+cbr)/9.0;vec4 cmin5=min(ctc,min(cml,min(cmc,min(cmr,cbc))));vec4 cmax5=max(ctc,max(cml,max(cmc,max(cmr,cbc))));vec4 cavg5=(ctc+cml+cmc+cmr+cbc)/5.0;cmin=0.5*(cmin+cmin5);cmax=0.5*(cmax+cmax5);cavg=0.5*(cavg+cavg5);vec4 previousColorClipped=clipAabb(cmin.xyz,cmax.xyz,clamp(cavg,cmin,cmax),previousColor);vec4 result=currentColor*0.1+previousColorClipped*0.9;gl_FragColor=result;}`;
var yI = `#define GLSLIFY 1
varying vec2 vUv;void main(){gl_Position=vec4(position.xy,1.0,1.0);vUv=position.xy*0.5+0.5;}`;
var vI = `#define GLSLIFY 1
layout(location=1)out vec4 gVelocity;varying vec2 vUv;uniform sampler2D inputBuffer;void main(){gl_FragColor=texture2D(inputBuffer,vUv);gVelocity=vec4(0.0);}`;
var Qd = class extends ot {
    constructor(){
        super({
            name: "PassthroughMaterial",
            uniforms: {
                inputBuffer: new ie(null)
            },
            blending: Dt,
            depthWrite: !1,
            depthTest: !1,
            vertexShader: yI,
            fragmentShader: vI
        });
    }
    set inputBuffer(t) {
        this.uniforms.inputBuffer.value = t;
    }
}, pv = class extends Un {
    constructor(){
        super("TAAResolvePass");
        this.MRTCompatible = !0;
        this.needsSwap = !1, this.passThroughMaterial = new Qd, this.resolutionVector = new F, this.resolveMaterial = new ot({
            name: "TAAResolveMaterial",
            uniforms: {
                inputBuffer: new ie(null),
                historyBuffer: new ie(null),
                velocityBuffer: new ie(null),
                depthBuffer: new ie(null),
                resolution: new ie(new F)
            },
            blending: Dt,
            depthWrite: !1,
            depthTest: !1,
            vertexShader: mI,
            fragmentShader: gI
        }), this.historyRenderTarget = new st(1024, 1024, {
            minFilter: Qe,
            stencilBuffer: !1,
            depthBuffer: !1
        }), this.historyRenderTarget.texture.name = "TAA.History", this.resultRenderTarget = new st(1024, 1024, {
            minFilter: _t,
            stencilBuffer: !1,
            depthBuffer: !1
        }), this.resultRenderTarget.texture.name = "TAA.Output";
    }
    setSize(e, n) {
        this.historyRenderTarget.setSize(e, n), this.resultRenderTarget.setSize(e, n);
    }
    render(e, n) {
        this.fullscreenMaterial = this.resolveMaterial, this.resolveMaterial.uniforms.inputBuffer.value = n.texture[0], this.resolveMaterial.uniforms.velocityBuffer.value = n.texture[1], this.resolveMaterial.uniforms.depthBuffer.value = n.depthTexture, this.resolveMaterial.uniforms.historyBuffer.value = this.historyRenderTarget.texture, this.resolveMaterial.uniforms.resolution.value.set(n.width, n.height), e.setRenderTarget(this.resultRenderTarget), e.render(this.scene, this.camera), this.fullscreenMaterial = this.passThroughMaterial, this.passThroughMaterial.inputBuffer = this.resultRenderTarget.texture, e.setRenderTarget(this.historyRenderTarget), e.render(this.scene, this.camera);
        let i = this.renderToScreen ? null : n;
        this.fullscreenMaterial = this.passThroughMaterial, this.passThroughMaterial.inputBuffer = this.resultRenderTarget.texture, e.setRenderTarget(i), e.render(this.scene, this.camera);
    }
    dispose() {
        this.resultRenderTarget.dispose(), this.historyRenderTarget.dispose(), this.resolveMaterial.dispose(), this.passThroughMaterial.dispose();
    }
};
var mv = class extends Un {
    constructor(e, n, i){
        super("TransmissionPass", void 0, n);
        this.MRTCompatible = !0;
        this.depthPass = new kS(e, n, {
            renderTarget: i.transmissionDepthTarget
        }), this.passThroughMaterial = new Qd, this.splineScene = e, this.needsSwap = !1;
    }
    updatePasses(e) {
        this.passThroughMaterial = new Qd, this.depthPass = new kS(this.splineScene, this.camera, {
            renderTarget: e.transmissionDepthTarget
        });
    }
    setCamera(e) {
        this.camera = e;
    }
    setScene(e) {
        this.splineScene = e;
    }
    render(e, n, i) {
        let s = this.camera.layers.mask, o = e;
        o.setRenderTarget(o.transmissionRenderTarget), this.fullscreenMaterial = this.passThroughMaterial, this.passThroughMaterial.inputBuffer = n.texture[0], o.clear(), o.render(this.scene, this.camera), this.camera.layers.disable(3), this.depthPass.render(e, n, i), o.shadowMap.needsUpdate = !1, o.shadowMap.autoUpdate = !1;
        let a = this.renderToScreen ? null : n;
        this.camera.layers.set(3), e.setRenderTarget(a), e.render(this.splineScene, this.camera), this.camera.layers.mask = s;
    }
};
var xI = new Or, dq = new ot({
    transparent: !0,
    vertexShader: `
        void main() {
            gl_Position = vec4(0.0);
        }
    `,
    fragmentShader: `
        layout(location = 1) out vec4 gVelocity;

        void main() {
            gl_FragColor = vec4(0.0);
			gVelocity = vec4(0.0);
        }
    `
}), Gl = class extends Un {
    constructor(e, n, i){
        super("OpaquePass", n ?? xI, i);
        this.MRTCompatible = !0;
        this.hasTransmissionPass = !1;
        this.clear = !0;
        this.clearColorOnly = !1;
        this.clearDepth = !1;
        this.needsSwap = !1, this.originalMaterials = new Map, this.MRTCompatible = e;
    }
    setCamera(e) {
        this.camera = e;
    }
    setScene(e) {
        this.scene = e ?? xI;
    }
    getScene() {
        return this.scene;
    }
    render(e, n) {
        this.camera.layers.enable(3), this.hasTransmissionPass && (this.originalMaterials.clear(), this.scene.traverse((s)=>{
            s.layers.isEnabled(3) && s instanceof kt && (this.originalMaterials.set(s.id, s.material), s.material = dq);
        }), e.shadowMap.needsUpdate = !0, e.shadowMap.autoUpdate = !0), this.camera.layers.enable(8);
        let i = this.renderToScreen ? null : n;
        e.setRenderTarget(i), this.clearColorOnly && e.clear(!0, !1, !0), this.clear && e.clear(), e.render(this.scene, this.camera), this.clearDepth && e.clear(!1, !0, !1), this.hasTransmissionPass && this.originalMaterials.forEach((s, o)=>{
            let a = this.scene.getObjectById(o);
            a && (a.material = s);
        });
    }
};
var gv = class {
    constructor(t, { depthBuffer: e = !0 , stencilBuffer: n = !1 , multisampling: i = 0 , frameBufferType: s = 0  } = {}){
        this.renderer = t;
        this.helperStartIndex = 0;
        this.copyPass = new tp;
        this.depthTexture = null;
        this.timer = new sI;
        this._width = 1;
        this._height = 1;
        this.passes = [];
        this.helperPasses = [];
        this.autoRenderToScreen = !0;
        this.inputBuffer = this.createBuffer(e, n, s, i, !0, "input buffer mrt"), this.inputBufferSingle = this.createBuffer(e, n, s, i, !1, " input buffer single"), this.inputBufferSingle.texture.dispose(), this.inputBufferSingle.depthTexture.dispose(), this.inputBufferSingle.texture = this.inputBuffer.texture[0], this.inputBufferSingle.depthTexture = this.inputBuffer.depthTexture, this.outputBuffer = this.inputBuffer.clone(), this.outputBuffer.name = "output buffer mrt", this.outputBufferSingle = this.createBuffer(e, n, s, i, !1, "output buffer single"), this.outputBufferSingle.texture.dispose(), this.outputBufferSingle.depthTexture.dispose(), this.outputBufferSingle.texture = this.outputBuffer.texture[0], this.outputBufferSingle.depthTexture = this.outputBuffer.depthTexture, this.setRenderer(t);
    }
    get multisampling() {
        return this.inputBuffer.samples || 0;
    }
    set multisampling(t) {
        let e = this.inputBuffer, n = this.multisampling;
        n > 0 && t > 0 ? (this.inputBuffer.samples = t, this.outputBuffer.samples = t, this.inputBuffer.dispose(), this.outputBuffer.dispose()) : n !== t && (this.inputBuffer.dispose(), this.outputBuffer.dispose(), console.log("creating new input buffer"), this.inputBuffer = this.createBuffer(e.depthBuffer, e.stencilBuffer, e.texture.type, t, !0, "new input buffer"), this.inputBuffer.depthTexture = this.depthTexture, this.outputBuffer = this.inputBuffer.clone());
    }
    getTimer() {
        return this.timer;
    }
    getRenderer() {
        return this.renderer;
    }
    setRenderer(t) {
        if (this.renderer = t, t !== null) {
            let e = t.getSize(new F), n = t.getContext().getContextAttributes()?.alpha ?? !1, i = this.inputBuffer.texture[0].type;
            i === qt && t.outputEncoding === Ye && (this.inputBuffer.texture[0].encoding = Ye, this.outputBuffer.texture[0].encoding = Ye, this.inputBuffer.dispose(), this.outputBuffer.dispose(), console.log("doing some kinda dispose??")), t.autoClear = !1, this.setSize(e.width, e.height, !1);
            for (let s of this.passes)s.initialize(t, n, i);
        }
    }
    replaceRenderer(t, e = !0) {
        let n = this.renderer, i = n.domElement.parentNode;
        return this.setRenderer(t), e && i !== null && (i.removeChild(n.domElement), i.appendChild(t.domElement)), n;
    }
    createDepthTexture() {
        let t = this.depthTexture = new yi(this._width, this._height);
        return this.inputBuffer.depthTexture = t, this.inputBuffer.dispose(), this.inputBuffer.stencilBuffer ? (t.format = Wo, t.type = Go) : t.type = no, t;
    }
    deleteDepthTexture() {
        if (this.depthTexture !== null) {
            this.depthTexture.dispose(), this.depthTexture = null, this.inputBuffer.depthTexture = null, this.inputBuffer.dispose();
            for (let t of this.passes)t.setDepthTexture(null);
        }
    }
    createBuffer(t, e, n, i, s, o) {
        let a = this.renderer, l = a === null ? new F : a.getDrawingBufferSize(new F), u = {
            minFilter: Qe,
            magFilter: Qe,
            wrapS: Gt,
            wrapT: Gt,
            stencilBuffer: e,
            depthBuffer: t
        }, c;
        return i > 0 ? (c = new st(l.width, l.height, u), c.samples = i) : (s ? (c = new Gp(l.width, l.height, 2, u), c.texture[1].type = Ha) : c = new st(l.width, l.height, u), c.depthTexture = new yi(2048, 2048), c.depthTexture.type = wr), n === qt && a !== null && a.outputEncoding === Ye && (Array.isArray(c.texture) ? c.texture.forEach((d)=>d.encoding = Ye) : c.texture.encoding = Ye), Array.isArray(c.texture) ? c.texture.forEach((d, h)=>{
            d.name = `EffectComposer.Buffer ${s} ${h}`, d.generateMipmaps = !1;
        }) : (c.texture.name = `EffectComposer.Buffer ${s}`, c.texture.generateMipmaps = !1), c.name = o, c;
    }
    addPass(t, e) {
        let n = this.passes, i = this.renderer, s = i.getDrawingBufferSize(new F), o = i.getContext().getContextAttributes()?.alpha ?? !1, a;
        if (t.MRTCompatible && (a = this.inputBuffer.texture[0].type), t.MRTCompatible || (a = this.inputBuffer.texture.type), t.setRenderer(i), t.setSize(s.width, s.height), t.initialize(i, o, a), this.autoRenderToScreen && (n.length > 0 && (n[n.length - 1].renderToScreen = !1), t.renderToScreen && (this.autoRenderToScreen = !1)), e !== void 0 ? n.splice(e, 0, t) : n.push(t), this.autoRenderToScreen && (n[n.length - 1].renderToScreen = !0), t.needsDepthTexture || this.depthTexture !== null) {
            if (this.depthTexture === null) {
                let l = this.createDepthTexture();
                for (t of n)t.setDepthTexture(l);
            } else t.setDepthTexture(this.depthTexture);
        }
    }
    setHelperStartIndex(t) {
        this.helperStartIndex = t;
    }
    removePass(t) {
        let e = this.passes, n = e.indexOf(t);
        if (n !== -1 && e.splice(n, 1).length > 0) {
            if (this.depthTexture !== null) {
                let o = (l, u)=>l || u.needsDepthTexture;
                e.reduce(o, !1) || (t.getDepthTexture() === this.depthTexture && t.setDepthTexture(null), this.deleteDepthTexture());
            }
            this.autoRenderToScreen && n === e.length && (t.renderToScreen = !1, e.length > 0 && (e[e.length - 1].renderToScreen = !0));
        }
    }
    removeAllPasses() {
        let t = this.passes;
        this.deleteDepthTexture(), t.length > 0 && (this.autoRenderToScreen && (t[t.length - 1].renderToScreen = !1), this.passes = []);
    }
    render(t) {
        let e = this.renderer, n = this.copyPass, i = this.inputBuffer, s = this.outputBuffer, o = this.inputBufferSingle, a = this.outputBufferSingle, l = !1, u, c, d, h;
        t === void 0 && (t = this.timer.update().getDelta());
        for (let f of this.passes)f.enabled && (f.MRTCompatible ? f.render(e, i, s, t, l) : f.render(e, o, a, t, l), f.needsSwap && (l && (n.renderToScreen = f.renderToScreen, u = e.getContext(), c = e.state.buffers.stencil, c.setFunc(u.NOTEQUAL, 1, 4294967295), n.render(e, i, s, t, l), c.setFunc(u.EQUAL, 1, 4294967295)), d = i, h = o, i = s, o = a, s = d, a = h), f instanceof iI ? l = !0 : f instanceof nI && (l = !1));
    }
    setSize(t, e, n) {
        let i = this.renderer;
        if (this._width = t, this._height = e, t === void 0 || e === void 0) {
            let o = i.getSize(new F);
            t = o.width, e = o.height;
        }
        i.setSize(t, e, n);
        let s = i.getDrawingBufferSize(new F);
        this.inputBuffer.setSize(s.width, s.height), this.outputBuffer.setSize(s.width, s.height), this.inputBufferSingle.setSize(s.width, s.height), this.outputBufferSingle.setSize(s.width, s.height);
        for (let o of this.passes)o.setSize(s.width, s.height);
    }
    reset() {
        let t = this.timer.isAutoResetEnabled();
        this.dispose(), this.autoRenderToScreen = !0, this.timer.setAutoResetEnabled(t);
    }
    dispose() {
        for (let t of this.passes)t.dispose();
        this.passes = [], this.inputBuffer !== null && this.inputBuffer.dispose(), this.outputBuffer !== null && this.outputBuffer.dispose(), this.inputBufferSingle !== null && this.inputBufferSingle.dispose(), this.outputBufferSingle !== null && this.outputBufferSingle.dispose(), this.deleteDepthTexture(), this.copyPass.dispose(), this.timer.dispose();
    }
};
var hq = new ot({
    name: "CombineMaterial",
    uniforms: {
        inputBufferA: new ie(null),
        inputBufferB: new ie(null)
    },
    blending: Dt,
    depthWrite: !1,
    depthTest: !1,
    vertexShader: `
varying vec2 vUv;
void main() {
    gl_Position = vec4(position.xy, 1.0, 1.0);
    vUv = position.xy * 0.5 + 0.5;
}
`,
    fragmentShader: `
    varying vec2 vUv;
    uniform sampler2D inputBufferA;
    uniform sampler2D inputBufferB;

    // TODO: Why do we need these when postpro of framemode is enabled???
    layout(location = 1) out vec4 gVelocity;

    void main() {
	vec4 resA = texture2D(inputBufferA, vUv);
	vec4 resB = texture2D(inputBufferB, vUv);
    float a = resA.a + resB.a * ( 1.0 - resA.a );

	vec4 res;
	res.rgb =  resA.rgb + (resB.rgb * (1.0 - resA.a));
	res.a = resA.a + resB.a * (1.0 - resA.a);
	gl_FragColor = res;
    gVelocity = vec4(0.0);
    }
`
}), yv = class extends Un {
    constructor(e){
        super("HelperPass", void 0, e);
        this.MRTCompatible = !1;
        this.fullscreenMaterial = hq, this.helperPass = new Gl(!1, void 0, this.camera), this.helperPass.hasTransmissionPass = !1, this.helperPass.clear = !1, this.helperPass.renderToScreen = !1, this.helperPassOnTop = new Gl(!1, void 0, this.camera), this.helperPassOnTop.hasTransmissionPass = !1, this.helperPassOnTop.clear = !1, this.helperPassOnTop.renderToScreen = !1;
        let n = new fv({
            preset: No.LOW,
            edgeDetectionMode: kd.COLOR
        });
        this.effectPass = new zl(this.camera, n), this.rt = new st(10, 10, {
            minFilter: Qe,
            magFilter: Qe,
            wrapS: Gt,
            wrapT: Gt,
            depthBuffer: !0
        });
    }
    setSize(e, n) {
        this.rt.setSize(e, n), this.effectPass.setSize(e, n);
    }
    set sceneHelpers(e) {
        this.helperPass.setScene(e);
    }
    get sceneHelpers() {
        return this.helperPass.getScene();
    }
    set sceneHelpersOnTop(e) {
        this.helperPassOnTop.setScene(e);
    }
    get sceneHelpersOnTop() {
        return this.helperPassOnTop.getScene();
    }
    setCamera(e) {
        this.helperPass.setCamera(e), this.helperPassOnTop.setCamera(e);
    }
    initialize(e, n, i) {
        super.initialize(e, n, i), this.effectPass.initialize(e, n, i);
    }
    dispose() {
        super.dispose(), this.rt.dispose(), this.effectPass.dispose();
    }
    render(e, n, i) {
        this.rt.depthTexture = n.depthTexture;
        let s = e.getClearAlpha();
        e.setClearAlpha(0), this.helperPass.clearDepth = !0, this.helperPass.clearColorOnly = !0, this.helperPass.render(e, this.rt), this.helperPassOnTop.render(e, this.rt), this.effectPass.renderToScreen = !1, this.effectPass.render(e, this.rt, i), this.fullscreenMaterial.uniforms.inputBufferA.value = i.texture, this.fullscreenMaterial.uniforms.inputBufferB.value = n.texture, e.setClearAlpha(s), e.setRenderTarget(null), e.clear(), e.render(this.scene, this.camera);
    }
};
var bI = `#define GLSLIFY 1
out vec3 n;void main(){vec4 view_space=viewMatrix*modelMatrix*vec4(position,1.0);gl_Position=projectionMatrix*view_space;n=mat3(viewMatrix*modelMatrix)*normal;n=normalize(n);}`;
var wI = `#define GLSLIFY 1
in vec3 n;void main(){gl_FragColor=vec4(n,1.0);}`;
var SI = `#define GLSLIFY 1
out vec2 v_uv;void main(){v_uv=uv;gl_Position=vec4(position.xy,1.0,1.0);}`;
var AI = `#define GLSLIFY 1
in vec2 v_uv;const float pi=3.14159265;const float num_steps=4.0;const float num_directions=4.0;uniform float near;uniform float far;uniform float fov;uniform vec4 proj_info;uniform bool is_ortho;uniform vec2 resolution;uniform float radius_of_influence;uniform float radius_in_screen_space;uniform float exponent;uniform vec3 ao_color;uniform float bias;uniform sampler2D texture_depth;uniform sampler2D texture_normals;uniform sampler2D texture_blue_noise;uniform sampler2D texture_blue_noise_in_disk;uniform sampler2D texture_color_pass;uniform int frame_index;uniform bool fog_enabled;uniform float fog_near;uniform float fog_far;vec3 uv_to_view_space(vec2 uv,float eye_z){return vec3((uv*proj_info.xy+proj_info.zw)*(is_ortho ? 1.0 : eye_z),eye_z);}float linearize_depth(float depth_sampled){float z=is_ortho ? depth_sampled : depth_sampled*2.0-1.0;return mix((2.0*near*far)/(far+near-z*(far-near)),near+z*(far-near),float(is_ortho));}vec3 get_view_position(vec2 uv_coords){float linear_depth=linearize_depth(texture(texture_depth,uv_coords).x);return uv_to_view_space(uv_coords,linear_depth);}vec3 min_difference(vec3 p,vec3 right,vec3 left){vec3 v1=right-p;vec3 v2=p-left;return(dot(v1,v1)<dot(v2,v2))? v1 : v2;}vec3 rebuild_normal(in vec2 uv,in vec3 p){vec2 one_over_resolution=1.0/resolution;vec3 r=get_view_position(uv+vec2(one_over_resolution.x,0));vec3 l=get_view_position(uv+vec2(-one_over_resolution.x,0));vec3 t=get_view_position(uv+vec2(0,one_over_resolution.y));vec3 b=get_view_position(uv+vec2(0,-one_over_resolution.y));return normalize(cross(min_difference(p,r,l),min_difference(p,t,b)));}float falloff(float distance_squared){float neg_inv_r2=-1.0/(radius_of_influence*radius_of_influence);return distance_squared*neg_inv_r2+1.0;}float ao_contribution(vec3 P,vec3 N,vec3 S){vec3 to_sample=S-P;float norm_squared=dot(to_sample,to_sample);float norm=sqrt(norm_squared);float cos_theta=dot(N,to_sample)/norm;return clamp(cos_theta-bias,0.0,1.0)*clamp(falloff(norm_squared),0.0,1.0);}float compute_ambient_occlusion(vec2 uv,float radius_in_screen_space,vec3 pc,vec3 view_space_n){vec2 one_over_resolution=1.0/resolution;ivec2 noise_uv=ivec2(int(mod(gl_FragCoord.x,128.0)),int(mod(gl_FragCoord.y,128.0)));float noise=texelFetch(texture_blue_noise,noise_uv,0).r;noise=fract(noise+0.61803398875*float(frame_index));float theta=noise*2.0*3.1415;float ct=cos(theta);float st=sin(theta);float step_size=radius_in_screen_space/(num_steps+1.0);const float angle_step=2.0*pi/num_directions;float contribution=0.0;for(int i=0;i<int(num_directions);++i){float current_pixel=step_size+1.0;for(int j=0;j<int(num_steps);++j){int index=i*int(num_steps)+j;vec2 blue_noise_sample=texelFetch(texture_blue_noise_in_disk,ivec2(index,0),0).rg;vec2 disk_point;disk_point.x=blue_noise_sample.x*ct-blue_noise_sample.y*st;disk_point.y=blue_noise_sample.x*st+blue_noise_sample.y*ct;vec2 sample_direction=disk_point;vec2 snapped_uv=round(current_pixel*sample_direction)*one_over_resolution+uv;vec3 ps=get_view_position(snapped_uv);current_pixel+=step_size;contribution+=ao_contribution(pc,view_space_n,ps);}}float mult=1.0/(1.0-bias);contribution*=mult/(num_directions*num_steps);return clamp(1.0-contribution*2.0,0.0,1.0);}
#define USE_GBUFFER_NORMALS
void main(){vec3 view_space_p=get_view_position(v_uv);
#ifdef USE_GBUFFER_NORMALS
vec3 view_space_n=texture(texture_normals,v_uv).rgb;view_space_n.z*=-1.0;
#else
vec3 view_space_n=-rebuild_normal(v_uv,view_space_p);
#endif
float radius_ss=radius_in_screen_space/(is_ortho ? 1.0 : view_space_p.z);float ao=compute_ambient_occlusion(v_uv,radius_ss,view_space_p,view_space_n);float final=pow(ao,exponent);if(view_space_p.z>=far){final=1.0;}vec3 color=mix(ao_color,vec3(1.0),final);if(fog_enabled){float fog_factor=smoothstep(fog_near,fog_far,view_space_p.z);color=mix(color,vec3(1.0),fog_factor);}gl_FragColor=vec4(color,1.0);}`;
var _I = `#define GLSLIFY 1
out vec2 v_uv;void main(){gl_Position=vec4(position.xy,1.0,1.0);v_uv=uv;}`;
var MI = `#define GLSLIFY 1
in vec2 v_uv;uniform sampler2D texture_ao_lrez;uniform sampler2D texture_depth_lrez;uniform sampler2D texture_depth_hrez;uniform float near;uniform float far;float linearize_depth(float depth_sampled){float z=depth_sampled*2.0-1.0;return(2.0*near*far)/(far+near-z*(far-near));}vec2 nearest_depth_filter(in vec2 uv){vec2 resolution=vec2(textureSize(texture_depth_lrez,0));vec2 texel_size=1.0/resolution;vec2 offset=uv-0.5*texel_size;float d_hrez=texture(texture_depth_hrez,uv).r;float a=abs(d_hrez-texture(texture_depth_lrez,offset).r);float b=abs(d_hrez-texture(texture_depth_lrez,offset+vec2(texel_size.x,0.0)).r);float c=abs(d_hrez-texture(texture_depth_lrez,offset+vec2(0.0,texel_size.y)).r);float d=abs(d_hrez-texture(texture_depth_lrez,offset+vec2(texel_size.x,texel_size.y)).r);float min_diff=min(a,min(b,min(c,d)));if(min_diff==a)return offset;if(min_diff==b)return offset+vec2(texel_size.x,0.0);if(min_diff==c)return offset+vec2(0.0,texel_size.y);if(min_diff==d)return offset+vec2(texel_size.x,texel_size.y);}void main(){
#ifdef DEBUG
float d_lrez=texture(texture_depth_lrez,v_uv).r;float d_hrez=texture(texture_depth_hrez,v_uv).r;float output_d=mix(linearize_depth(d_lrez)/far,linearize_depth(d_hrez)/far,step(0.5,v_uv.x));gl_FragColor=vec4(vec3(output_d),1.0);
#else
vec2 filtered_uv=nearest_depth_filter(v_uv);vec4 ao=texture(texture_ao_lrez,filtered_uv);gl_FragColor=vec4(ao.rgb,1.0);gl_FragColor=ao;
#endif
}`;
var Kd = [
    [
        .478712,
        .875764
    ],
    [
        -0.337956,
        -0.793959
    ],
    [
        -0.955259,
        -0.028164
    ],
    [
        .864527,
        .325689
    ],
    [
        .209342,
        -0.395657
    ],
    [
        -0.106779,
        .672585
    ],
    [
        .156213,
        .235113
    ],
    [
        -0.413644,
        -0.082856
    ],
    [
        -0.415667,
        .323909
    ],
    [
        .141896,
        -0.93998
    ],
    [
        .954932,
        -0.182516
    ],
    [
        -0.766184,
        .410799
    ],
    [
        -0.434912,
        -0.458845
    ],
    [
        .415242,
        -0.078724
    ],
    [
        .728335,
        -0.491777
    ],
    [
        -0.058086,
        -0.066401
    ],
    [
        .20299,
        .686837
    ],
    [
        -0.808362,
        -0.556402
    ],
    [
        .507386,
        -0.640839
    ],
    [
        -0.723494,
        -0.22924
    ],
    [
        .48974,
        .317826
    ],
    [
        -0.622663,
        .765301
    ],
    [
        -0.01064,
        .929347
    ],
    [
        .663146,
        .647618
    ],
    [
        -0.096674,
        -0.413835
    ],
    [
        .525945,
        -0.321063
    ],
    [
        -0.122533,
        .366019
    ],
    [
        .195235,
        -0.687983
    ],
    [
        -0.563203,
        .098748
    ],
    [
        .418563,
        .561335
    ],
    [
        -0.378595,
        .800367
    ],
    [
        .826922,
        .001024
    ],
    [
        -0.085372,
        -0.766651
    ],
    [
        -0.92192,
        .183673
    ],
    [
        -0.590008,
        -0.721799
    ],
    [
        .167751,
        -0.164393
    ],
    [
        .032961,
        -0.56253
    ],
    [
        .6329,
        -0.107059
    ],
    [
        -0.46408,
        .569669
    ],
    [
        -0.173676,
        -0.958758
    ],
    [
        -0.242648,
        -0.234303
    ],
    [
        -0.275362,
        .157163
    ],
    [
        .382295,
        -0.795131
    ],
    [
        .562955,
        .115562
    ],
    [
        .190586,
        .470121
    ],
    [
        .770764,
        -0.297576
    ],
    [
        .237281,
        .93105
    ],
    [
        -0.666642,
        -0.455871
    ],
    [
        -0.905649,
        -0.298379
    ],
    [
        .33952,
        .157829
    ],
    [
        .701438,
        -0.7041
    ],
    [
        -0.062758,
        .160346
    ],
    [
        -0.220674,
        .957141
    ],
    [
        .642692,
        .432706
    ],
    [
        -0.77339,
        -0.015272
    ],
    [
        -0.671467,
        .24688
    ],
    [
        .158051,
        .062859
    ],
    [
        .806009,
        .527232
    ],
    [
        -0.05762,
        -0.247071
    ],
    [
        .333436,
        -0.51671
    ],
    [
        -0.550658,
        -0.315773
    ],
    [
        -0.652078,
        .589846
    ],
    [
        .008818,
        .530556
    ],
    [
        -0.210004,
        .519896
    ]
];
var xq = new ot({
    vertexShader: bI,
    fragmentShader: wI
}), vv = new ot({
    vertexShader: _I,
    fragmentShader: MI,
    uniforms: {
        texture_ao_lrez: new ie(null),
        texture_depth_lrez: new ie(null),
        texture_depth_hrez: new ie(null),
        near: new ie(null),
        far: new ie(null)
    }
}), xv = class extends Un {
    constructor(e, n){
        super("AmbientOcclusionPass", void 0, n);
        this.fogEnabled = !1;
        this.fogNear = 1;
        this.fogFar = 1e3;
        this.frameIndex = 0;
        this._runHalfRes = !0;
        this._width = 1;
        this._height = 1;
        let i = 1024, s = 1024;
        this.gBuffer = new st(i, s, {
            type: wr,
            depthTexture: new yi(i, s),
            minFilter: Qe,
            magFilter: Qe
        }), this.depthBufferHighRes = new st(i, s, {
            depthTexture: new yi(i, s)
        }), this.aoBuffer = new st(i, s, {
            minFilter: Qe,
            magFilter: Qe
        }), this.splineScene = e, this.splineCamera = n;
        let o = new Float32Array(Kd.length * 2);
        for(let l = 0; l < Kd.length; l++){
            let u = l * 2;
            o[u + 0] = Kd[l][0], o[u + 1] = Kd[l][1];
        }
        this.blueNoiseInDiskTexture = new jo(o, Kd.length, 1, Z0, wr), this.blueNoiseInDiskTexture.wrapS = Bi, this.blueNoiseInDiskTexture.wrapT = Bi, this.blueNoiseInDiskTexture.needsUpdate = !0, this.hbaoMaterial = new ot({
            vertexShader: SI,
            fragmentShader: AI,
            uniforms: {
                near: new ie(null),
                far: new ie(null),
                fov: new ie(null),
                proj_info: new ie(new Ze),
                is_ortho: new ie(!1),
                resolution: new ie(new F),
                radius_of_influence: new ie(8),
                radius_in_screen_space: new ie(1),
                exponent: new ie(1),
                ao_color: new ie(new A),
                bias: new ie(.5),
                texture_depth: new ie(null),
                texture_normals: new ie(null),
                texture_blue_noise: new ie(null),
                texture_blue_noise_in_disk: new ie(this.blueNoiseInDiskTexture),
                frame_index: new ie(0),
                fog_enabled: new ie(!1),
                fog_near: new ie(1),
                fog_far: new ie(1e3)
            }
        }), this.radius = 128, this.aoColor = {
            r: 0,
            g: 0,
            b: 0
        }, this.bias = .5, this.hbaoMaterial.uniforms.texture_depth.value = this.gBuffer.depthTexture, this.hbaoMaterial.uniforms.texture_normals.value = this.gBuffer.texture, this.needsSwap = !0, this.aaBuffer = new st(i, s, {
            minFilter: Qe,
            magFilter: Qe,
            wrapS: Gt,
            wrapT: Gt,
            depthBuffer: !1,
            type: wr
        });
        let a = new fv({
            preset: No.ULTRA,
            edgeDetectionMode: kd.COLOR
        });
        this.effectPass = new zl(this.camera, a);
    }
    initialize(e, n, i) {
        super.initialize(e, n, i), this.effectPass.initialize(e, n, i);
    }
    setBlueNoiseTexture(e) {
        this.hbaoMaterial.uniforms.texture_blue_noise.value = e;
    }
    setSize(e, n) {
        this._width = e, this._height = n, this.depthBufferHighRes.setSize(e, n);
        let i = this._runHalfRes ? .5 : 1, s = e * i, o = n * i;
        this.gBuffer.setSize(s, o), this.aoBuffer.setSize(s, o), this.hbaoMaterial.uniforms.resolution.value.set(s, o), this.aaBuffer.setSize(s, o), this.effectPass.setSize(s, o);
    }
    get runHalfRes() {
        return this._runHalfRes;
    }
    set runHalfRes(e) {
        this._runHalfRes = e, this.setSize(this._width, this._height);
    }
    setCamera(e) {
        this.splineCamera = e;
    }
    setScene(e) {
        this.splineScene = e;
    }
    render(e, n, i) {
        this.splineScene.overrideMaterial = xq;
        let s = this.splineCamera.layers.mask;
        if (this.splineCamera.layers.set(5), e.setRenderTarget(this.gBuffer), e.clear(), e.render(this.splineScene, this.splineCamera), e.setRenderTarget(this.depthBufferHighRes), e.clear(), e.render(this.splineScene, this.splineCamera), this.splineScene.overrideMaterial = null, this.splineCamera.layers.mask = s, this.hbaoMaterial.uniforms.radius_of_influence.value = this.radius, this.hbaoMaterial.uniforms.ao_color.value.set(this.aoColor.r, this.aoColor.g, this.aoColor.b), this.hbaoMaterial.uniforms.bias.value = this.bias, this.hbaoMaterial.uniforms.fog_enabled.value = this.fogEnabled, this.hbaoMaterial.uniforms.fog_near.value = this.fogNear, this.hbaoMaterial.uniforms.fog_far.value = this.fogFar, this.hbaoMaterial.uniforms.frame_index.value = this.frameIndex, this.frameIndex++, this.splineCamera.isPerspectiveCamera) {
            this.hbaoMaterial.uniforms.near.value = this.splineCamera.perspCamera.near, this.hbaoMaterial.uniforms.far.value = this.splineCamera.perspCamera.far;
            let o = this.splineCamera.perspCamera.projectionMatrix.elements, a = 2 / o[0], l = 2 / o[5], u = -(1 - o[8]) / o[0], c = -(1 + o[9]) / o[5];
            this.hbaoMaterial.uniforms.proj_info.value.set(a, l, u, c);
            let h = this.splineCamera.perspCamera.fov * (Math.PI / 180), m = this.hbaoMaterial.uniforms.resolution.value.y / (Math.tan(h * .5) * 2), p = this.hbaoMaterial.uniforms.radius_of_influence.value * .5 * m;
            this.hbaoMaterial.uniforms.radius_in_screen_space.value = p, this.hbaoMaterial.uniforms.is_ortho.value = !1;
        } else {
            this.hbaoMaterial.uniforms.near.value = this.splineCamera.orthoCamera.near, this.hbaoMaterial.uniforms.far.value = this.splineCamera.orthoCamera.far;
            let o = this.splineCamera.orthoCamera.projectionMatrix.elements, a = 2 / o[0], l = 2 / o[5], u = -(1 + o[12]) / o[0], c = -(1 - o[13]) / o[5];
            this.hbaoMaterial.uniforms.proj_info.value.set(a, l, u, c);
            let h = .5 * (this.hbaoMaterial.uniforms.resolution.value.y / l), f = this.hbaoMaterial.uniforms.radius_of_influence.value * h;
            this.hbaoMaterial.uniforms.radius_in_screen_space.value = f, this.hbaoMaterial.uniforms.is_ortho.value = !0;
        }
        this.runHalfRes ? (this.fullscreenMaterial = this.hbaoMaterial, e.setRenderTarget(this.aoBuffer), e.clear(), e.render(this.scene, this.camera), this.fullscreenMaterial = vv, vv.uniforms.texture_ao_lrez.value = this.aoBuffer.texture, vv.uniforms.texture_depth_lrez.value = this.gBuffer.depthTexture, vv.uniforms.texture_depth_hrez.value = this.depthBufferHighRes.depthTexture, e.setRenderTarget(e.aoRenderTarget), e.clear(), e.render(this.scene, this.camera)) : (this.fullscreenMaterial = this.hbaoMaterial, e.setRenderTarget(this.aaBuffer), e.clear(), e.render(this.scene, this.camera), this.effectPass.renderToScreen = !1, this.effectPass.render(e, this.aaBuffer, e.aoRenderTarget));
    }
    dispose() {
        this.gBuffer.dispose(), this.depthBufferHighRes.dispose(), this.aoBuffer.dispose();
    }
};
var bq = `
varying vec2 vUv;
void main() {
    vUv = uv;
    gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
}`, wq = `
uniform sampler2D tInput;
uniform sampler2D tMap;
uniform vec2 resolution;
varying vec2 vUv;

uniform vec2 uResolution;
uniform vec2 uCoords;

// Draws a rectangle at center <st> with size <size>
float rectangle(vec2 st, vec2 size) {
    size = vec2(0.5) - size * 0.5;
    vec2 uv = vec2(step(size.x, st.x), step(size.y, st.y));
    uv *= vec2(step(size.x, 1.0 - st.x), step(size.y, 1.0 - st.y));

    return uv.x * uv.y;
}

uniform vec2 uSize;
uniform float uScale;
uniform float uDPR;
uniform float uCurrent;
uniform vec3 uSceneColor;

void main() {
    vec2 screenUv = gl_FragCoord.xy / uResolution.xy;
    screenUv *= 1.0 / uDPR;

    vec2 center = vec2(0.5, -0.5);
    vec2 outsideUv = screenUv;
    outsideUv += center;
    outsideUv -= uCoords.xy / uResolution.xy;
    outsideUv = (outsideUv - 0.5) + 0.5;
    outsideUv -= center;
    vec2 s = (uSize / uResolution) * uScale;
    float isOutside = 1.0 - rectangle(outsideUv, s);
    
    vec2 mid = vec2(0.5);
    vec2 insideUv = (screenUv - mid + s * mid) / s;
    vec4 background = texture2D(tInput, screenUv);
    vec4 image = texture2D(tMap, insideUv);
    gl_FragColor = mix(image, background, isOutside);
}
`, bv = class extends js {
    constructor(){
        super(new ot({
            vertexShader: bq,
            fragmentShader: wq,
            uniforms: {
                tInput: new ie(null),
                tMap: new ie(null),
                uResolution: new ie(new F),
                uSize: new ie(new F),
                uCoords: new ie(new F),
                uScale: new ie(1),
                uSceneColor: new ie(new Ne(16711680)),
                uDPR: new ie(1),
                uCurrent: new ie(0)
            }
        }), "tInput"), this.needsSwap = !0;
    }
    get uniforms() {
        return this.fullscreenMaterial.uniforms;
    }
    get texture() {
        return this.uniforms.tMap.value;
    }
    set texture(t) {
        this.uniforms.tMap.value = t;
    }
};
function TI(r1, t) {
    return t && t.enabled && r1.push(t.effect), r1;
}
var Sq = (r1)=>Object.values(lt).includes(r1) ? r1 : lt.NORMAL, np = class extends Ht {
    constructor(e){
        super();
        this.postprocessingState = pl.defaultData;
        this._scene = new Or;
        this._camera = new Yt;
        this.effects = new Map;
        this.blueNoiseTexture = new jo;
        this._renderToScreen = !0;
        this.clock = new Zp, this.renderer = e, this.debug = !1, this.effects.set("bloom", new zd), this.effects.set("chromaticAberration", new Vd), this.effects.set("vignette", new qd), this.effects.set("noise", new jd), this.effects.set("colorAverage", new Hd), this.effects.set("hueSaturation", new Wd), this.effects.set("brightnessContrast", new Gd), this.effects.set("depthOfField", new Xd), this.effects.set("pixelation", new Yd), this.effectComposer = new gv(this.renderer), this.effectComposer.autoRenderToScreen = !1, this.opaquePass = new Gl(!0, this.scene, this.camera), this.opaquePass.clear = !0, this.transmissionPass = new mv(this.scene, this.camera, this.renderer), this.aoPass = new xv(this.scene, this.camera), this.taaPass = new pv, this.taaPass.renderToScreen = !1, this.helperPass = new yv(this.camera), this.helperPass.renderToScreen = !1, this.overlayPass = new bv, this.overlayPass.enabled = !1, this._initCopyPass(), this._initPasses();
    }
    set overlayTexture(e) {
        e !== void 0 ? (this.overlayPass.texture = e, this.overlayPass.enabled = !0) : this.overlayPass.enabled = !1;
    }
    get overlayTexture() {
        return this.overlayPass.texture;
    }
    set sceneHelpers(e) {
        this.helperPass.sceneHelpers = e;
    }
    get sceneHelpers() {
        return this.helperPass.sceneHelpers;
    }
    set sceneHelpersOnTop(e) {
        this.helperPass.sceneHelpersOnTop = e;
    }
    get sceneHelpersOnTop() {
        return this.helperPass.sceneHelpersOnTop;
    }
    get scene() {
        return this._scene;
    }
    set scene(e) {
        this._scene = e, this.opaquePass.setScene(e), this.transmissionPass.setScene(e), this.aoPass.setScene(e);
    }
    get camera() {
        return this._camera;
    }
    set camera(e) {
        this._camera = e, this.opaquePass.setCamera(e), this.transmissionPass.setCamera(e), this.aoPass.setCamera(e), this.helperPass.setCamera(e);
    }
    updateRenderToScreen() {
        let e = !1;
        for(let n = this.effectComposer.passes.length - 1; n >= 0; n--){
            let i = this.effectComposer.passes[n];
            if (i.enabled === !0 && !e && this._renderToScreen) {
                i.renderToScreen = !0, e = !0;
                continue;
            }
            i.renderToScreen = !1;
        }
    }
    disableHelpers() {
        this.helperPass.enabled = !1, this.updateRenderToScreen();
    }
    enableHelpers() {
        this.helperPass.enabled = !0, this.updateRenderToScreen();
    }
    updateBlueNoiseTexture(e) {
        this.blueNoiseTexture = new jo(e, 128, 128), this.blueNoiseTexture.wrapS = Bi, this.blueNoiseTexture.wrapT = Bi, this.blueNoiseTexture.minFilter = _t, this.blueNoiseTexture.magFilter = _t, this.blueNoiseTexture.needsUpdate = !0;
    }
    setAmbientOcclusionParams(e, n, i, s, o, a, l, u) {
        this.aoPass.enabled = e, this.aoPass.radius = n, this.aoPass.bias = i, this.aoPass.aoColor = s, this.aoPass.fogEnabled = o, this.aoPass.fogNear = a, this.aoPass.fogFar = l, this.aoPass.runHalfRes !== !u && (this.aoPass.runHalfRes = !u);
    }
    setTransmissionPassEnabled(e) {
        this.transmissionPass.enabled = e, this.opaquePass.hasTransmissionPass = e;
    }
    _initPasses() {
        if (this.uvEffectPass?.dispose(), this.effectPass?.dispose(), this.effectComposer.removeAllPasses(), this.transmissionPass.updatePasses(this.renderer), this.effectComposer.addPass(this.aoPass), this.effectComposer.addPass(this.opaquePass), this.effectComposer.addPass(this.transmissionPass), this.effectComposer.addPass(this.taaPass), this.postprocessingState.enabled) {
            let e = [
                this.effects.get("pixelation")
            ].reduce(TI, []);
            e.length > 0 && (this.uvEffectPass = new zl(this.camera, ...e), this.uvEffectPass.renderToScreen = !1, this.effectComposer.addPass(this.uvEffectPass));
            let n = [
                this.effects.get("chromaticAberration"),
                this.effects.get("bloom"),
                this.effects.get("colorAverage"),
                this.effects.get("hueSaturation"),
                this.effects.get("brightnessContrast"),
                this.effects.get("vignette"),
                this.effects.get("noise")
            ].reduce(TI, []);
            n.length > 0 && (this.effectPass = new zl(this.camera, ...n), this.effectPass.renderToScreen = !1, this.effectComposer.addPass(this.effectPass));
        }
        this.effectComposer.addPass(this.overlayPass), this.effectComposer.addPass(this.helperPass);
    }
    _initCopyPass() {
        if (this._savePass) return;
        let e = new F;
        this.renderer.getDrawingBufferSize(e), this._rt = new st(e.x, e.y, {
            depthBuffer: !1,
            stencilBuffer: !1,
            wrapS: Bi,
            wrapT: Bi
        }), this._rt.samples = 0, this._savePass = new tp(this._rt, !1), this._savePass.renderToScreen = !1;
    }
    setCopyPass(e) {
        this._rt = e, this._savePass = new tp(this._rt, !1), this.renderToScreen = !1;
    }
    get renderToScreen() {
        return this._renderToScreen;
    }
    set renderToScreen(e) {
        if (this._renderToScreen === e) return;
        let n = this.effectComposer;
        !n || (e === !0 ? n.removePass(this._savePass) : n.addPass(this._savePass), this._renderToScreen = e, this.updateRenderToScreen());
    }
    get texture() {
        return this._rt && this._rt.texture;
    }
    get renderTarget() {
        return this._rt;
    }
    updatePostprocessing(e) {
        let { enabled: n , ...i } = e, s = !1;
        n !== this.postprocessingState.enabled && (s = !0);
        for (let o of Object.entries(i)){
            let a = o[1], l = this.effects.get(o[0]);
            if (l) {
                l.enabled !== a.enabled && (s = !0), l.enabled = a.enabled;
                for (let [u, c] of Object.entries(a))u === "blendFunction" ? l.blendFunction = Sq(c) : l[u] = c;
            }
        }
        this.postprocessingState = e, s && this._initPasses();
    }
    render() {
        this.effectComposer.render(this.clock.getDelta());
    }
    setScissor(e, n, i, s) {
        e instanceof Ze ? (this.effectComposer.inputBuffer.scissor.set(e.x, e.y, e.z, e.w), this.effectComposer.outputBuffer.scissor.set(e.x, e.y, e.z, e.w)) : (this.effectComposer.inputBuffer.scissor.set(e, n, i, s), this.effectComposer.outputBuffer.scissor.set(e, n, i, s));
        let o = this.renderer.getPixelRatio();
        this.effectComposer.inputBuffer.scissor.multiplyScalar(o), this.effectComposer.outputBuffer.scissor.multiplyScalar(o), this.renderer.setScissor(e, n, i, s);
    }
    setScissorTest(e) {
        this.effectComposer.inputBuffer.scissorTest = e, this.effectComposer.outputBuffer.scissorTest = e, this.renderer.setScissorTest(e);
    }
    setViewport(e, n, i, s) {
        e instanceof Ze ? (this.effectComposer.inputBuffer.viewport.copy(e), this.effectComposer.outputBuffer.viewport.copy(e)) : (this.effectComposer.inputBuffer.viewport.set(e, n, i, s), this.effectComposer.outputBuffer.viewport.set(e, n, i, s));
    }
    resize(e, n, i) {
        if (this.effectComposer.setSize(e, n, i), this._rt) {
            let s = this.renderer.getPixelRatio();
            this._rt.setSize(e * s, n * s);
        }
    }
    dispose() {
        this.uvEffectPass?.dispose(), this.effectPass?.dispose(), this.effectComposer.dispose();
    }
};
var EI = new Vt, wv = class extends tx {
    constructor(e){
        super(e);
        this._pixelRatio = this.getPixelRatio();
        this.viewportWidth = 1;
        this.viewportHeight = 1;
        this.resolution = new F;
        this.pipeline = new np(this);
        this.isXRCopyPassSet = !1;
        this.clear = (e = !0, n = !0, i = !0)=>{
            let s = this.getContext(), o = 0;
            e && (o |= s.COLOR_BUFFER_BIT), n && (o |= s.DEPTH_BUFFER_BIT), i && (o |= s.STENCIL_BUFFER_BIT), s.clear(o), s.clearBufferfv(s.COLOR, 1, [
                0,
                0,
                0,
                1
            ]);
        };
        this.overrideTransmission = e?.overrideTransmission, this.autoClear = !1;
        let n = this.setPixelRatio.bind(this), i = this.setSize.bind(this), s = this.getContext();
        if (s && "drawingBufferColorSpace" in s) try {
            s.drawingBufferColorSpace = "display-p3";
        } catch (o) {
            console.warn(o);
        }
        this.setPixelRatio = (o)=>{
            this._pixelRatio = o, n(o);
        }, this.setSize = (o, a, l = !0)=>{
            (this.viewportWidth !== o || this.viewportHeight !== a) && (this.viewportWidth = o, this.viewportHeight = a, i(o, a, l), this.normalRenderTarget?.setSize(o * this._pixelRatio, a * this._pixelRatio), this._resizeTransmission(o, a), this.transmissionDepthTarget?.setSize(o * this._pixelRatio / 2, a * this._pixelRatio / 2), this.pipeline.resize(o, a, l));
        }, this._superDispose = this.dispose, this.dispose = this._currentDispose;
    }
    createAORenderTarget() {
        this.aoRenderTarget === void 0 && (this.aoRenderTarget = new st(this.viewportWidth * this._pixelRatio, this.viewportHeight * this._pixelRatio, {
            generateMipmaps: !1,
            minFilter: Qe,
            magFilter: Qe,
            wrapS: Gt,
            wrapT: Gt,
            depthBuffer: !1
        }));
    }
    _resizeTransmission(e, n) {
        this.transmissionRenderTarget?.setSize(e * this._pixelRatio / (this.hdTransmission ? 1 : 2), n * this._pixelRatio / (this.hdTransmission ? 1 : 2)), this.aoRenderTarget?.setSize(e * this._pixelRatio / 1, n * this._pixelRatio / 1);
    }
    get hdTransmission() {
        return Fe.transmissionLod.value === 1;
    }
    set hdTransmission(e) {
        Fe.transmissionLod.value = e === !0 ? 1 : 2, this._resizeTransmission(this.viewportWidth, this.viewportHeight);
    }
    createTransmissionRenderTarget() {
        this.transmissionRenderTarget === void 0 && (this.transmissionRenderTarget = new st(this.viewportWidth * this._pixelRatio / (this.hdTransmission ? 1 : 2), this.viewportHeight * this._pixelRatio / (this.hdTransmission ? 1 : 2), {
            generateMipmaps: !0,
            minFilter: Va,
            magFilter: Qe,
            wrapS: Gt,
            wrapT: Gt,
            depthBuffer: !1
        }), this.transmissionDepthTarget = new st(this.viewportWidth * this._pixelRatio / 2, this.viewportHeight * this._pixelRatio / 2, {
            minFilter: _t,
            magFilter: _t,
            depthBuffer: !1
        }));
    }
    createNormalRenderTarget() {
        this.normalRenderTarget === void 0 && (this.normalRenderTarget = new st(this.viewportWidth * this._pixelRatio, this.viewportHeight * this._pixelRatio, {
            generateMipmaps: !1,
            minFilter: _t,
            magFilter: _t,
            type: wr,
            depthTexture: new yi(this.viewportWidth * this._pixelRatio, this.viewportHeight * this._pixelRatio)
        }));
    }
    renderNormal(e, n) {
        this.normalRenderTarget && (this.setClearColor(0), n.layers.enable(8), n.layers.disable(0), n.layers.disable(3), e.traverseEntity((i)=>{
            i.layers.isEnabled(8) && (i.copyPreviousMatrix = !1);
        }), this.setRenderTarget(this.normalRenderTarget), this.clear(), n instanceof Yt ? Ay.uniforms.depthContrast.value = (n.far - n.near) / 1e4 : Ay.uniforms.depthContrast.value = 1, e.overrideMaterial = Ay, this.render(e, n), this.setClearColor(e.bgColor, e.bgColor.a), this.setRenderTarget(null), e.overrideMaterial = e.wireframeState ? My : null, n.layers.enable(0), n.layers.enable(3), e.traverseEntity((i)=>{
            i.layers.isEnabled(8) && (i.copyPreviousMatrix = !0);
        }));
    }
    renderSplineScene(e, n, i, s, o) {
        this.xr.enabled && (this.isXRCopyPassSet === !1 && this.getRenderTarget() !== null && (this.pipeline.setCopyPass(this.getRenderTarget()), this.isXRCopyPassSet = !0), this.xr.updateCamera(n)), this.setClearColor(e.bgColor, e.bgColor.a), i.penumbraSize.forEach((l, u)=>{
            Fe.penumbraSize.value[u] = l;
        }), Fe.pixelRatioNode.value = this.getPixelRatio(), this.resolution.x !== 0 && this.resolution.y !== 0 ? Fe.resolution.value.set(this.resolution.x, this.resolution.y) : Fe.resolution.value.set(this.viewportWidth * this._pixelRatio, this.viewportHeight * this._pixelRatio), this.overrideNormal !== void 0 ? (Fe.normalRenderTarget.value = this.overrideNormal, Fe.normalRenderTargetDepth.value = EI) : e.needsNormal() && (this.createNormalRenderTarget(), Fe.normalRenderTarget.value = this.normalRenderTarget.texture, Fe.normalRenderTargetDepth.value = this.normalRenderTarget.depthTexture, this.renderNormal(e, n)), e.occlusion && (this.createAORenderTarget(), Fe.aoRenderTarget.value = this.aoRenderTarget.texture), Fe.aoEnabled.value = e.occlusion, this.pipeline.setAmbientOcclusionParams(e.occlusion, e.radius, e.bias, e.aoColor, e.enableFog, e.backupFog.near, e.backupFog.far, e.aoFullRes), this.pipeline.aoPass.setBlueNoiseTexture(this.pipeline.blueNoiseTexture);
        let a = !1;
        if (this.overrideTransmission !== void 0) Fe.transmissionRenderTarget.value = this.overrideTransmission, Fe.transmissionRenderTargetDepth.value = EI, this.pipeline.setTransmissionPassEnabled(!1);
        else {
            let l = e.needsTransmission();
            l && (this.transmissionRenderTarget === void 0 && (a = !0), this.createTransmissionRenderTarget(), Fe.transmissionRenderTarget.value = this.transmissionRenderTarget.texture, Fe.transmissionRenderTargetDepth.value = this.transmissionDepthTarget.texture), this.pipeline.setTransmissionPassEnabled(l);
        }
        n.layers.enable(3), n.layers.enable(8), this.pipeline.sceneHelpers = s, this.pipeline.sceneHelpersOnTop = o, this.pipeline.scene = e, this.pipeline.camera = n, a && this.pipeline.transmissionPass.updatePasses(this), this.pipeline.postprocessingState !== e.postprocessing && (this.pipeline.updatePostprocessing(e.postprocessing), !s && !o && this.pipeline.disableHelpers()), this.clearAlphaOverride !== void 0 && this.setClearAlpha(this.clearAlphaOverride), e.overrideMaterial = e.wireframeState ? My : null, this.pipeline.render(), Fe.frameIndex.value = (Fe.frameIndex.value + 1) % 16, n instanceof Yt && n.copyHistory();
    }
    _currentDispose() {
        this._superDispose(), this.pipeline.dispose(), this.aoRenderTarget?.dispose(), this.transmissionRenderTarget?.dispose(), this.transmissionDepthTarget?.dispose(), this.normalRenderTarget?.dispose(), this.normalRenderTarget?.depthTexture?.dispose();
    }
};
var Sv = class {
    get sharedAssets() {
        return this.shared;
    }
    constructor(t, e = {}){
        this.shared = new Il(t.shared, e), this.scene = new bn(t.scene, this.sharedAssets), this.scene.switchActiveCamera(this.scene.activeCamera);
    }
    reset(t, e) {
        this.scene.clearScene(), this.sharedAssets.reset(t.shared), this.scene.resetAfterClear(t.scene, this.sharedAssets);
    }
    dispose() {
        this.scene.dispose(), this.shared.dispose();
    }
    gc() {
        this.shared.geometryCache.startGc(), this.shared.geometryCache2.startGc(), this.scene.traverseEntity((t)=>{
            t instanceof tn && t.markGeometryAsReachable(this.shared);
        }), this.shared.geometryCache.endGc(), this.shared.geometryCache2.endGc();
    }
};
var Av = class {
    constructor({ x: t = 10 , y: e = 10  }){
        this._startTime = 0;
        let n = document.getElementById("spe-perfs");
        n ? this.element = n : (this.element = document.createElement("div"), document.body.appendChild(this.element), this.element.style.position = "absolute", this.element.style.zIndex = "10000", this.element.style.fontFamily = "monospace", this.element.style.background = "black", this.element.style.color = "white", this.element.style.padding = "10px", this.element.style.opacity = "0.5", this.element.style.fontSize = "11px", this.element.setAttribute("id", "spe-perfs")), this.element.style.left = `${t}px`, this.element.style.top = `${e}px`;
    }
    dispose() {
        this.element.parentElement?.removeChild(this.element);
    }
    start() {
        this._startTime = performance.now();
    }
    end() {
        let e = performance.now() - this._startTime;
        this.element.innerHTML = e.toFixed(3) + " ms";
    }
};
function Aq(r1) {
    let t;
    if (!!r1.index) for(let e = 0; e < r1.index.array.length; e += 3)t = r1.index.array[e], r1.index.array[e] = r1.index.array[e + 2], r1.index.array[e + 2] = t;
}
function rp(r1) {
    return r1 instanceof rs ? "SubdivObject" : r1.geometry.type === "NonParametricGeometry" ? "NonParametric" : "Mesh";
}
function _q(r1, t) {
    let e = {};
    return r1.traverseEntity((n)=>{
        if (!n.visible || !(n instanceof kt) || n.type !== "Mesh" || Array.isArray(n.material) || n.states && Object.keys(n.states).length) return;
        let i = n.parent;
        for(; i;){
            if (i instanceof kt && n.states && Object.keys(n.states).length) return;
            i = i.parent;
        }
        let s = n.material.uuid, o = t.shared.materials[s];
        if (o) {
            if (!or.isMergable(o)) return;
        } else {
            let u = t.scene.objects.get(n.uuid)?.data;
            if (u && "material" in u && typeof u.material != "string") {
                if (!or.isMergable(u.material)) return;
                s = or.getHash(u.material);
            }
        }
        e[s] || (e[s] = {});
        let l = e[s][rp(n)];
        if (l) {
            if (l.push(n), n.cloner) for (let u of n.cloner.children)l.push(u);
        } else if (e[s][rp(n)] = [
            n
        ], n.cloner) for (let u of n.cloner.children)e[s][rp(n)].push(u);
    }), e;
}
function Mq(r1) {
    let t = 0;
    return Object.values(r1).forEach((e)=>{
        Object.values(e).forEach((n)=>{
            let i = n.length;
            i > t && (t = i);
        });
    }), t;
}
function CI(r1, t) {
    let e = _q(t, r1), n = Mq(e), i = new Array(n), s = 0, o = new Array(n), a = 0, l = new Array(n), u = 0, c = new Array(n), d = 0;
    for (let [h, f] of Object.entries(e))for (let m of Object.values(f)){
        if (a = 0, u = 0, m.forEach((g)=>{
            g instanceof kt && (o[a++] = g.geometry.clone(), l[u++] = g);
        }), u < 2) continue;
        for(let g = 0; g < u; g++)l[g].updateWorldMatrix(!0, !1), o[g].applyMatrix4(l[g].matrixWorld), l[g].matrixWorld.determinant() < 0 && Aq(o[g]);
        let p = Xi(o.slice(0, a), !1);
        if (p) {
            let g;
            switch(h){
                case "SubdivObject":
                    console.warn("Turning subdiv object into mesh"), g = new In(p, l[0].material);
                    break;
                default:
                    g = new In(p, l[0].material);
                    break;
            }
            g.castShadow = l[0].castShadow, g.receiveShadow = l[0].receiveShadow, t.add(g);
            let y = (v)=>{
                d = 0;
                for (let x of v)x.children && y(x.children), x instanceof kt && (Array.isArray(x.material) || e[x.material.uuid] && e[x.material.uuid][rp(x)] && e[x.material.uuid][rp(x)].length > 1 || (c[d++] = x));
                for(let x = 0; x < d; x++)t.attach(c[x]);
            };
            for(let v = 0; v < u; v++){
                let x = l[v];
                y(x.children), i[s++] = x;
            }
        }
    }
    for(let h = 0; h < s; h++)i[h].removeFromParent();
}
var OI = Jd(DI(), 1);
var Tq = new F;
function Eq(r1) {
    let t = "The Spline Runtime only accepts .splinecode files that are generated from Spline export panel.";
    r1.endsWith(".spline") ? console.warn(t + " The .spline files are only meant to be used by the Editor.") : r1.endsWith(".splinecode") || console.warn(t);
}
var II = class {
    constructor(t, { renderOnDemand: e , renderMode: n = "auto"  } = {}){
        this._viewportMode = 1;
        this._viewportWidth = window.innerWidth;
        this._viewportHeight = window.innerHeight;
        this._proxyObjectCache = new Map;
        this._isPaused = !1;
        this._renderRequested = !1;
        this._skipRender = !1;
        this._lastTime = performance.now();
        this.time = performance.now();
        this.dt = 0;
        this.currentTAAFrame = 0;
        this.disposed = !1;
        this._requestRenderAutoMode = ()=>{
            this._skipRender = !1;
        };
        this.requestRender = ()=>{
            this._renderRequested = !0;
        };
        this.render = (t)=>{
            if (this.time = t, this.dt = this.time - this._lastTime, this._lastTime = this.time, this._perfs?.start(), !this._renderer) {
                this._perfs?.end();
                return;
            }
            if (!this._isPaused && (this.renderMode === "manual" && !this._renderRequested || this.renderMode === "auto" && this._skipRender)) {
                this._perfs?.end();
                return;
            }
            this._renderRequested = !1, this._skipRender = !0, this._controls && (this._skipRender = this._controls.update(this.dt)), this._eventManager && (this._eventManager.handlers.Start.hasVideoAction || this._eventManager.handlers.Basic.hasVideoAction || this._eventManager.handlers.Conditional.hasVideoAction) && (this._skipRender = !1), this._skipRender ? (this.currentTAAFrame++, this.currentTAAFrame < 32 ? this._skipRender = !1 : this.currentTAAFrame = 0) : this.currentTAAFrame = 0, this._scene && this._scene.activeCamera !== this._camera && (this._camera = this._scene.activeCamera), this._eventManager && (this._eventManager.isEnable || this._eventManager.activate(), this._eventManager.handlers.Follow.onAnimationFrameDamping(), this._eventManager.handlers.LookAt.onAnimationFrameDamping(), this._eventManager.handlers.DragDrop.onAnimationFrameDamping()), this._scene && this._camera && (this._scene.pathConstraints.applyConstraints(this._scene), this._renderer.renderSplineScene(this._scene, this._camera, this._sharedAssetsManager)), this.canvas.dispatchEvent(this._renderedEvent), this._perfs?.end();
        };
        this._resize = ()=>{
            !this._renderer || (this._viewportMode === 1 && this._frameView && (this._frameView.frameSize = Tq.set(this._viewportWidth, this._viewportHeight)), this._renderer.setSize(this._viewportWidth, this._viewportHeight, !1), this._camera && (this._frameView?.updateCamera(), this._camera.cameraType === "PerspectiveCamera" && (this._camera.aspect = this._viewportWidth / this._viewportHeight), this._camera.updateProjectionMatrix()), this._requestRenderAutoMode());
        };
        this._debouncedResize = ol(this._resize, 10);
        this.canvas = t, this.renderMode = e ? "auto" : n, this._renderedEvent = new CustomEvent("rendered", {
            bubbles: !0
        }), Object.defineProperty(this._renderedEvent, "target", {
            writable: !1,
            value: this
        }), window.location.search.includes("perfs") && (this._perfs = new Av({
            x: 10,
            y: 10
        })), ST(t);
    }
    async load(t, e) {
        Eq(t), this.disposed = !1;
        let i = await (await fetch(t, e)).arrayBuffer();
        await this.start(i);
    }
    async start(t, { interactive: e = !0  } = {}) {
        if (this.disposed) return;
        let n = await qD(t);
        this._data = n, n.version && (0, OI.default)(n.version, "0.9.369") > 0 && console.warn("Your .splinecode file is more recent than the library. Please upgrade @splinetool/runtime to the latest version."), await Promise.all([
            Rw(n) && pP(),
            NP(n) && oP(),
            n.scene.environment.usePhysics && IT(),
            _w(n) && RP(),
            _S(n) && ET()
        ].filter(Boolean)), this._eventManager?.deactivate(), this._controls?.deactivate(), this._scene?.dispose();
        let i = new Sv(n);
        if (this._scene = i.scene, this._sharedAssetsManager = i.sharedAssets, this._camera = this._scene.activeCamera, window.location.search.includes("merge-geometries")) {
            let o = performance.now();
            CI(n, i.scene);
            let a = performance.now();
            console.log("Merged geometries in ", a - o, " ms");
        }
        Rw(n) && this._scene.traverse((o)=>{
            Gr(o) && o.recomputeBoolean();
        }), this._sharedAssetsManager.setRequestRender(()=>{
            this._requestRenderAutoMode(), this._scene?.traverse((o)=>{
                o instanceof hr && o.pendingMediaLoad && o.update();
            });
        });
        let s = Object.keys(n.shared.fonts).map((o)=>this._sharedAssetsManager.getFont(o).loadingPromise);
        if (Promise.all(s).then(()=>{
            i.scene.markNeedsUpdateRendererDirty(), this._requestRenderAutoMode();
        }), _w(n) && ND(n) && await Promise.all(s), this._scene.rewriteEventsBeforeGoToPlayMode(), By(n.scene, this._scene, this._sharedAssetsManager), this._renderer || (this._renderer = new wv({
            canvas: this.canvas,
            antialias: !1,
            alpha: !0,
            stencil: !1,
            depth: !1,
            powerPreference: "high-performance"
        }), this._renderer.hdTransmission = n.scene.publish.hdTransmission === !0, this._renderer.setPixelRatio(window.devicePixelRatio), this._renderer.pipeline.addEventListener("smaaloaded", this._requestRenderAutoMode), this._renderer.shadowMap.enabled = !0, this._renderer.shadowMap.type = n.scene.environment.ambientLight.softShadows ? rm : K0, h2(n.scene.environment.ambientLight.softShadowQuality)), n.scene.environment.ambientLight.blueNoiseTextureData !== void 0 && this._renderer.pipeline.updateBlueNoiseTexture(n.scene.environment.ambientLight.blueNoiseTextureData), this._frameView) this._frameView.setCamera(this._camera);
        else {
            let o = Object.values(n.frames)[0];
            o.preset === "fullscreen" ? (this._viewportMode = 1, this.canvas.parentElement && (this._viewportWidth = this.canvas.parentElement.clientWidth || 300, this.canvas.style.width = "100%"), this.canvas.parentElement && (this._viewportHeight = this.canvas.parentElement.clientHeight || 150, this.canvas.style.height = "100%")) : (this._viewportMode = 2, this._viewportWidth = o.size[0], this._viewportHeight = o.size[1], this.canvas.style.width = `${this._viewportWidth}px`, this.canvas.style.height = `${this._viewportHeight}px`), this._renderer.setSize(this._viewportWidth, this._viewportHeight, !1), this._frameView = new uv(this._renderer, this._camera, new F(this._viewportWidth, this._viewportHeight), new F(window.innerWidth, window.innerHeight));
        }
        if (e) {
            let o = new Ry(this._renderer, this._scene, this._camera, this._sharedAssetsManager, n.scene.publish.stopRaycast, this._requestRenderAutoMode, !0);
            this._scene.updateMatrixWorld(!0), this._controls = new iv(n, o), this._eventManager = new cv(n.scene.publish, this._controls, o), this._controls.activate(this._eventManager);
        }
        this._resize(), this.dt === 0 && (this.render(performance.now()), this._renderer.setAnimationLoop(this.render)), this._resizeObserverTimeout = setTimeout(()=>{
            !this._resizeObserver && this.canvas.parentElement && (this._resizeObserver = new ResizeObserver(()=>{
                this._viewportWidth = this.canvas.clientWidth, this._viewportHeight = this.canvas.clientHeight, this._debouncedResize();
            }), this._resizeObserver.observe(this.canvas.parentElement));
        }, 300);
    }
    findObjectById(t) {
        let e = this._scene?.getObjectByProperty("uuid", t);
        return this._createProxyObject(e);
    }
    findObjectByName(t) {
        let e = this._scene?.getObjectByName(t);
        return this._createProxyObject(e);
    }
    getAllObjects() {
        let t = [];
        return this._scene?.traverseEntity((e)=>{
            if (e.uuid !== bn.PERSONAL_CAMERA_ID) {
                let n = this._createProxyObject(e);
                n && t.push(n);
            }
        }), t;
    }
    getSplineEvents() {
        return this._eventManager?.handlers.Spline.splineEvents;
    }
    emitEvent(t, e) {
        (this.findObjectById(e) || this.findObjectByName(e))?.emitEvent(t);
    }
    emitEventReverse(t, e) {
        (this.findObjectById(e) || this.findObjectByName(e))?.emitEventReverse(t);
    }
    addEventListener(t, e) {
        this.canvas.addEventListener(t, e);
    }
    removeEventListener(t, e) {
        this.canvas.removeEventListener(t, e);
    }
    setZoom(t) {
        this._controls?.orbitControls instanceof Bd && this._controls?.orbitControls.zoomOut(t);
    }
    get eventManager() {
        return this._eventManager;
    }
    get controls() {
        return this._controls;
    }
    setSize(t, e) {
        this._viewportWidth = t, this._viewportHeight = e, this._viewportMode = 2, this._resize();
    }
    setBackgroundColor(t) {
        let { r: e , g: n , b: i , a: s  } = {
            r: 0,
            g: 0,
            b: 0,
            a: 1
        }, o = new $t(e, n, i, s);
        try {
            o.setStyle(t);
        } catch  {
            console.error("This is not a valid css color", t);
        }
        this._scene?.setBackgroundColor(o), this._requestRenderAutoMode();
    }
    dispose() {
        this.disposed = !0, this._eventManager?.deactivate(), this._scene?.dispose(), this._sharedAssetsManager?.dispose(), this._proxyObjectCache.forEach((t)=>{
            px.unsubscribe(t);
        }), this._renderer?.setAnimationLoop(null), this._renderer?.dispose(), this._renderer = void 0, this._sharedAssetsManager?.dispose(), this._resizeObserver && (this._resizeObserver.disconnect(), this._resizeObserver = void 0), this._resizeObserverTimeout !== void 0 && clearTimeout(this._resizeObserverTimeout), this.canvas.style.width = "", this.canvas.style.height = "", this.canvas.removeAttribute("width"), this.canvas.removeAttribute("height"), this._frameView && (this._frameView = void 0), this._controls?.deactivate(), AT(this.canvas);
    }
    get isStopped() {
        return this._isPaused;
    }
    stop() {
        this._isPaused || (this._renderer?.setAnimationLoop(null), this._isPaused = !0, this._eventManager?.pause(), this._controls?.orbitControls && (this._controls.orbitControls.enabled = !1));
    }
    play() {
        !this._isPaused || (this._isPaused = !1, this._eventManager?.resume(), this._controls?.orbitControls && (this._controls.orbitControls.enabled = !0), this._renderer?.setAnimationLoop(this.render));
    }
    setGlobalEvents(t) {
        this._eventManager?.updateUseWindowEvents(t);
    }
    get data() {
        return this._data;
    }
    _createProxyObject(t) {
        if (t == null) return;
        if (this._proxyObjectCache.has(t.uuid)) return this._proxyObjectCache.get(t.uuid);
        let e = {
            name: t.name,
            uuid: t.uuid,
            visible: t.visible,
            intensity: t.intensity,
            position: t.position,
            rotation: t.rotation,
            scale: t.scale,
            emitEvent (i) {
                t.dispatchEvent({
                    type: "userEvent",
                    eventName: i
                });
            },
            emitEventReverse (i) {
                t.dispatchEvent({
                    type: "userEvent",
                    eventName: i,
                    reverse: !0
                });
            }
        }, n = px(e, (i, s)=>{
            typeof t[i] != "object" && Object.getOwnPropertyDescriptor(t, i)?.writable && (t[i] = s), this._requestRenderAutoMode(), t.updateMatrix();
        });
        return this._proxyObjectCache.set(t.uuid, n), n;
    }
};

});
parcelRequire.register("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});

parcelRequire.register("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
"use strict";

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case "ascii":
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case "base64":
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$51861dfc7ca9d588$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRequire.register("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
"use strict";
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup["-".charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup["_".charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRequire.register("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRequire.register("ghxkD", function(module, exports) {

module.exports = import("./" + (parcelRequire("27Lyk")).resolve("7ld7l")).then(()=>parcelRequire("gRaTy"));

});

parcelRequire.register("kB53x", function(module, exports) {

module.exports = import("./" + (parcelRequire("27Lyk")).resolve("cxrcT")).then(()=>parcelRequire("lxep3"));

});

parcelRequire.register("hmY9C", function(module, exports) {

module.exports = import("./" + (parcelRequire("27Lyk")).resolve("cM1YA")).then(()=>parcelRequire("1eBiX"));

});

parcelRequire.register("av1EJ", function(module, exports) {

module.exports = import("./" + (parcelRequire("27Lyk")).resolve("9WKx7")).then(()=>parcelRequire("Aa6gW"));

});

parcelRequire.register("i8OU0", function(module, exports) {

module.exports = import("./" + (parcelRequire("27Lyk")).resolve("dtqLr")).then(()=>parcelRequire("lq4np"));

});



var $6THZ6 = parcelRequire("6THZ6");
console.log(`%c
  ░▒▓█████▓░░░░░░░░░░░░░░░░░░░░░░░░░░░▒█▒▒█▒░░░░░░░░░░░░░░░░▓█████▓░░░░▒▓████▓▒░░░░░▓████▓▒░
  ▒█▓░░░░░▓█▒░░▒█▒░░░░░░░░░░░░░░░░░░░░▒█▒░░░░░░░░░░░░░░░░░░██░░░░░██░░▓█▓░░░░▒██░░▒█▓░░░░▒█▓
  ▒█▓░░░░░░░░▒██████░▓█░░░░░▓▓░░▒▓█▓▓▓▓█▒░█▒░░▒▓█▓█▓▒░░░░░░▒░░░░░░▓█▒▒██░░░░░░▓█▓░██░░▒▒▒░░░
  ░▒▓███▓▓▒░░░░▒█▒░░░██░░░░░██░▓█▒░░░░██▒▒█▒░██░░░░░██░░░░░░░░░░▒██▒░▓█▓░░░░░░▒██░███▓▒▒▓██░
  ░░░░░░░▒▓█▓░░▒█▒░░░██░░░░░██░█▓░░░░░▒█▒▒█▒▓█▒░░░░░▒█▓░░░░░░▒▓█▓▒░░░▒█▓░░░░░░▒█▓░██░░░░░░██
  ▓█▒░░░░░░██░░▒█▒░░░██░░░░░██░██░░░░░▓█▒▒█▒▒█▓░░░░░▒█▒░░░░▒██▒░░░░░░░██░░░░░░██░░▓█░░░░░░██
  ░▓█▓▓▒▒▓██▒░░░██▒▓░▒██▒▒▒▓██░░██▒▒▒▓██▒▒█▒░▒█▓▒▒▒▓█▒░░░░░██▓▓▓▓▓▓▓▒░░▓█▓▒▒▓██░░░░▓█▓▒▒▓██░  
`, "font-family:monospace; color: #695CFF;");
console.log(`%c
We build beatiful digital products
Get in touch: hello@studio206.dev
`, "font-family:monospace; color: #695CFF; font-weight: bold;");
if (null) null.accept();
const $2b6e161c9edcf319$var$canvas = document.getElementById("canvas3d");
const $2b6e161c9edcf319$var$app = new (0, $6THZ6.Application)($2b6e161c9edcf319$var$canvas);
$2b6e161c9edcf319$var$app.load("https://prod.spline.design/FiyK3Jqy9hBzjaiM/scene.splinecode").then(()=>{
    const width = window.innerWidth;
    width <= 600 && $2b6e161c9edcf319$var$app.setZoom(0.3);
    width > 600 && width <= 768 && $2b6e161c9edcf319$var$app.setZoom(0.5);
});


//# sourceMappingURL=index.0d41b794.js.map
